(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lGKbD", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $fca158e7bc793dc7$export$6503ec6e8aabbaf; }, function (v) { return $fca158e7bc793dc7$export$6503ec6e8aabbaf = v; });
var $fca158e7bc793dc7$export$6503ec6e8aabbaf;
var $fca158e7bc793dc7$export$f7ad0328861e2f03;
"use strict";
var $fca158e7bc793dc7$var$mapping = new Map();
function $fca158e7bc793dc7$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$fca158e7bc793dc7$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $fca158e7bc793dc7$var$resolve(id) {
    var resolved = $fca158e7bc793dc7$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$fca158e7bc793dc7$export$6503ec6e8aabbaf = $fca158e7bc793dc7$var$register;
$fca158e7bc793dc7$export$f7ad0328861e2f03 = $fca158e7bc793dc7$var$resolve;

});

parcelRegister("17QCl", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $0d1f42a1cefd465e$export$bdfd709ae4826697; }, function (v) { return $0d1f42a1cefd465e$export$bdfd709ae4826697 = v; });
var $0d1f42a1cefd465e$export$bdfd709ae4826697;
var $0d1f42a1cefd465e$export$c9e73fbda7da57b6;
var $0d1f42a1cefd465e$export$5a759dc7a1cfb72a;
"use strict";
var $0d1f42a1cefd465e$var$bundleURL = {};
function $0d1f42a1cefd465e$var$getBundleURLCached(id) {
    var value = $0d1f42a1cefd465e$var$bundleURL[id];
    if (!value) {
        value = $0d1f42a1cefd465e$var$getBundleURL();
        $0d1f42a1cefd465e$var$bundleURL[id] = value;
    }
    return value;
}
function $0d1f42a1cefd465e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $0d1f42a1cefd465e$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $0d1f42a1cefd465e$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $0d1f42a1cefd465e$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$0d1f42a1cefd465e$export$bdfd709ae4826697 = $0d1f42a1cefd465e$var$getBundleURLCached;
$0d1f42a1cefd465e$export$c9e73fbda7da57b6 = $0d1f42a1cefd465e$var$getBaseURL;
$0d1f42a1cefd465e$export$5a759dc7a1cfb72a = $0d1f42a1cefd465e$var$getOrigin;

});

parcelRegister("ccFxc", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8e26d2edf298385d$export$ffb0004e005737fa; }, function (v) { return $8e26d2edf298385d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $8e26d2edf298385d$export$34b9dba7ce09269b; }, function (v) { return $8e26d2edf298385d$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $8e26d2edf298385d$export$25062201e9e25d76; }, function (v) { return $8e26d2edf298385d$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8e26d2edf298385d$export$ffb0004e005737fa;
var $8e26d2edf298385d$export$34b9dba7ce09269b;
var $8e26d2edf298385d$export$25062201e9e25d76;
"use strict";
var $8e26d2edf298385d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8e26d2edf298385d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $8e26d2edf298385d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $8e26d2edf298385d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$8e26d2edf298385d$export$ffb0004e005737fa = $8e26d2edf298385d$var$REACT_FRAGMENT_TYPE;
$8e26d2edf298385d$export$34b9dba7ce09269b = $8e26d2edf298385d$var$jsxProd;
$8e26d2edf298385d$export$25062201e9e25d76 = $8e26d2edf298385d$var$jsxProd;

});

parcelRegister("1aGg9", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $0da7817f7132e823$export$dca3b0875bd9a954; }, function (v) { return $0da7817f7132e823$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $0da7817f7132e823$export$16fa2f45be04daa8; }, function (v) { return $0da7817f7132e823$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0da7817f7132e823$export$ffb0004e005737fa; }, function (v) { return $0da7817f7132e823$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $0da7817f7132e823$export$e2c29f18771995cb; }, function (v) { return $0da7817f7132e823$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $0da7817f7132e823$export$221d75b3f55bb0bd; }, function (v) { return $0da7817f7132e823$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0da7817f7132e823$export$5f8d39834fd61797; }, function (v) { return $0da7817f7132e823$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0da7817f7132e823$export$74bf444e3cd11ea5; }, function (v) { return $0da7817f7132e823$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $0da7817f7132e823$export$1ced07cd6b1985ce; }, function (v) { return $0da7817f7132e823$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $0da7817f7132e823$export$abd8e32b826d7ea7; }, function (v) { return $0da7817f7132e823$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $0da7817f7132e823$export$69a3209f1a06c04d; }, function (v) { return $0da7817f7132e823$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $0da7817f7132e823$export$e530037191fcd5d7; }, function (v) { return $0da7817f7132e823$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $0da7817f7132e823$export$fd42f52fd3ae1109; }, function (v) { return $0da7817f7132e823$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $0da7817f7132e823$export$c8a8987d4410bf2d; }, function (v) { return $0da7817f7132e823$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $0da7817f7132e823$export$7d1e3a5e95ceca43; }, function (v) { return $0da7817f7132e823$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $0da7817f7132e823$export$257a8862b851cb5b; }, function (v) { return $0da7817f7132e823$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $0da7817f7132e823$export$a8257692ac88316c; }, function (v) { return $0da7817f7132e823$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $0da7817f7132e823$export$488013bae63b21da; }, function (v) { return $0da7817f7132e823$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $0da7817f7132e823$export$7c73462e0d25e514; }, function (v) { return $0da7817f7132e823$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $0da7817f7132e823$export$7568632d0d33d16d; }, function (v) { return $0da7817f7132e823$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $0da7817f7132e823$export$f93f40ac0ca7e3a8; }, function (v) { return $0da7817f7132e823$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $0da7817f7132e823$export$1f96ae73734a86cc; }, function (v) { return $0da7817f7132e823$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $0da7817f7132e823$export$9a47ced3238df325; }, function (v) { return $0da7817f7132e823$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $0da7817f7132e823$export$35808ee640e87ca7; }, function (v) { return $0da7817f7132e823$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $0da7817f7132e823$export$fae74005e78b1a27; }, function (v) { return $0da7817f7132e823$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $0da7817f7132e823$export$dc8fbce3eb94dc1e; }, function (v) { return $0da7817f7132e823$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $0da7817f7132e823$export$6a7bc4e911dc01cf; }, function (v) { return $0da7817f7132e823$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $0da7817f7132e823$export$6d9c69b0de29b591; }, function (v) { return $0da7817f7132e823$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $0da7817f7132e823$export$f680877a34711e37; }, function (v) { return $0da7817f7132e823$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $0da7817f7132e823$export$d5a552a76deda3c2; }, function (v) { return $0da7817f7132e823$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $0da7817f7132e823$export$aaabe4eda9ed9969; }, function (v) { return $0da7817f7132e823$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $0da7817f7132e823$export$e5c5a5f917a5871c; }, function (v) { return $0da7817f7132e823$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $0da7817f7132e823$export$1538c33de8887b59; }, function (v) { return $0da7817f7132e823$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $0da7817f7132e823$export$fca7f784ae7a249a; }, function (v) { return $0da7817f7132e823$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $0da7817f7132e823$export$13e3392192263954; }, function (v) { return $0da7817f7132e823$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $0da7817f7132e823$export$b8f5890fc79d6aca; }, function (v) { return $0da7817f7132e823$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $0da7817f7132e823$export$60241385465d0a34; }, function (v) { return $0da7817f7132e823$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $0da7817f7132e823$export$306c0aa65ff9ec16; }, function (v) { return $0da7817f7132e823$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $0da7817f7132e823$export$7b286972b8d8ccbf; }, function (v) { return $0da7817f7132e823$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $0da7817f7132e823$export$83d89fbfd8236492; }, function (v) { return $0da7817f7132e823$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0da7817f7132e823$export$dca3b0875bd9a954;
var $0da7817f7132e823$export$16fa2f45be04daa8;
var $0da7817f7132e823$export$ffb0004e005737fa;
var $0da7817f7132e823$export$e2c29f18771995cb;
var $0da7817f7132e823$export$221d75b3f55bb0bd;
var $0da7817f7132e823$export$5f8d39834fd61797;
var $0da7817f7132e823$export$74bf444e3cd11ea5;
var $0da7817f7132e823$export$1ced07cd6b1985ce;
var $0da7817f7132e823$export$abd8e32b826d7ea7;
var $0da7817f7132e823$export$69a3209f1a06c04d;
var $0da7817f7132e823$export$e530037191fcd5d7;
var $0da7817f7132e823$export$fd42f52fd3ae1109;
var $0da7817f7132e823$export$c8a8987d4410bf2d;
var $0da7817f7132e823$export$7d1e3a5e95ceca43;
var $0da7817f7132e823$export$257a8862b851cb5b;
var $0da7817f7132e823$export$a8257692ac88316c;
var $0da7817f7132e823$export$488013bae63b21da;
var $0da7817f7132e823$export$7c73462e0d25e514;
var $0da7817f7132e823$export$7568632d0d33d16d;
var $0da7817f7132e823$export$f93f40ac0ca7e3a8;
var $0da7817f7132e823$export$1f96ae73734a86cc;
var $0da7817f7132e823$export$9a47ced3238df325;
var $0da7817f7132e823$export$35808ee640e87ca7;
var $0da7817f7132e823$export$fae74005e78b1a27;
var $0da7817f7132e823$export$dc8fbce3eb94dc1e;
var $0da7817f7132e823$export$6a7bc4e911dc01cf;
var $0da7817f7132e823$export$6d9c69b0de29b591;
var $0da7817f7132e823$export$f680877a34711e37;
var $0da7817f7132e823$export$d5a552a76deda3c2;
var $0da7817f7132e823$export$aaabe4eda9ed9969;
var $0da7817f7132e823$export$e5c5a5f917a5871c;
var $0da7817f7132e823$export$1538c33de8887b59;
var $0da7817f7132e823$export$fca7f784ae7a249a;
var $0da7817f7132e823$export$13e3392192263954;
var $0da7817f7132e823$export$b8f5890fc79d6aca;
var $0da7817f7132e823$export$60241385465d0a34;
var $0da7817f7132e823$export$306c0aa65ff9ec16;
var $0da7817f7132e823$export$7b286972b8d8ccbf;
var $0da7817f7132e823$export$83d89fbfd8236492;

var $a8i8g = parcelRequire("a8i8g");
"use strict";
var $0da7817f7132e823$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $0da7817f7132e823$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $0da7817f7132e823$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $0da7817f7132e823$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $0da7817f7132e823$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $0da7817f7132e823$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $0da7817f7132e823$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $0da7817f7132e823$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $0da7817f7132e823$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $0da7817f7132e823$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $0da7817f7132e823$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $0da7817f7132e823$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $0da7817f7132e823$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $0da7817f7132e823$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$0da7817f7132e823$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $0da7817f7132e823$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0da7817f7132e823$var$assign = Object.assign, $0da7817f7132e823$var$emptyObject = {};
function $0da7817f7132e823$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $0da7817f7132e823$var$emptyObject;
    this.updater = updater || $0da7817f7132e823$var$ReactNoopUpdateQueue;
}
$0da7817f7132e823$var$Component.prototype.isReactComponent = {};
$0da7817f7132e823$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$0da7817f7132e823$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $0da7817f7132e823$var$ComponentDummy() {}
$0da7817f7132e823$var$ComponentDummy.prototype = $0da7817f7132e823$var$Component.prototype;
function $0da7817f7132e823$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $0da7817f7132e823$var$emptyObject;
    this.updater = updater || $0da7817f7132e823$var$ReactNoopUpdateQueue;
}
var $0da7817f7132e823$var$pureComponentPrototype = $0da7817f7132e823$var$PureComponent.prototype = new $0da7817f7132e823$var$ComponentDummy();
$0da7817f7132e823$var$pureComponentPrototype.constructor = $0da7817f7132e823$var$PureComponent;
$0da7817f7132e823$var$assign($0da7817f7132e823$var$pureComponentPrototype, $0da7817f7132e823$var$Component.prototype);
$0da7817f7132e823$var$pureComponentPrototype.isPureReactComponent = !0;
var $0da7817f7132e823$var$isArrayImpl = Array.isArray, $0da7817f7132e823$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $0da7817f7132e823$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0da7817f7132e823$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $0da7817f7132e823$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $0da7817f7132e823$var$cloneAndReplaceKey(oldElement, newKey) {
    return $0da7817f7132e823$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $0da7817f7132e823$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $0da7817f7132e823$var$REACT_ELEMENT_TYPE;
}
function $0da7817f7132e823$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $0da7817f7132e823$var$userProvidedKeyEscapeRegex = /\/+/g;
function $0da7817f7132e823$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $0da7817f7132e823$var$escape("" + element.key) : index.toString(36);
}
function $0da7817f7132e823$var$noop$1() {}
function $0da7817f7132e823$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($0da7817f7132e823$var$noop$1, $0da7817f7132e823$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $0da7817f7132e823$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $0da7817f7132e823$var$REACT_ELEMENT_TYPE:
                case $0da7817f7132e823$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $0da7817f7132e823$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $0da7817f7132e823$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $0da7817f7132e823$var$getElementKey(children, 0) : nameSoFar, $0da7817f7132e823$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($0da7817f7132e823$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $0da7817f7132e823$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($0da7817f7132e823$var$isValidElement(callback) && (callback = $0da7817f7132e823$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($0da7817f7132e823$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($0da7817f7132e823$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $0da7817f7132e823$var$getElementKey(nameSoFar, i), invokeCallback += $0da7817f7132e823$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $0da7817f7132e823$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $0da7817f7132e823$var$getElementKey(nameSoFar, i++), invokeCallback += $0da7817f7132e823$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $0da7817f7132e823$var$mapIntoArray($0da7817f7132e823$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $0da7817f7132e823$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $0da7817f7132e823$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $0da7817f7132e823$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $0da7817f7132e823$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $a8i8g && "function" === typeof $a8i8g.emit) {
        $a8i8g.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $0da7817f7132e823$var$noop() {}
$0da7817f7132e823$export$dca3b0875bd9a954 = {
    map: $0da7817f7132e823$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $0da7817f7132e823$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $0da7817f7132e823$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $0da7817f7132e823$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$0da7817f7132e823$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$0da7817f7132e823$export$16fa2f45be04daa8 = $0da7817f7132e823$var$Component;
$0da7817f7132e823$export$ffb0004e005737fa = $0da7817f7132e823$var$REACT_FRAGMENT_TYPE;
$0da7817f7132e823$export$e2c29f18771995cb = $0da7817f7132e823$var$REACT_PROFILER_TYPE;
$0da7817f7132e823$export$221d75b3f55bb0bd = $0da7817f7132e823$var$PureComponent;
$0da7817f7132e823$export$5f8d39834fd61797 = $0da7817f7132e823$var$REACT_STRICT_MODE_TYPE;
$0da7817f7132e823$export$74bf444e3cd11ea5 = $0da7817f7132e823$var$REACT_SUSPENSE_TYPE;
$0da7817f7132e823$export$1ced07cd6b1985ce = $0da7817f7132e823$var$ReactSharedInternals;
$0da7817f7132e823$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $0da7817f7132e823$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$0da7817f7132e823$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$0da7817f7132e823$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $0da7817f7132e823$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$0da7817f7132e823$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $0da7817f7132e823$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$0da7817f7132e823$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $0da7817f7132e823$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $0da7817f7132e823$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$0da7817f7132e823$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$0da7817f7132e823$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $0da7817f7132e823$var$ReactElement(type, key, void 0, void 0, null, props);
};
$0da7817f7132e823$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0da7817f7132e823$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $0da7817f7132e823$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$0da7817f7132e823$export$a8257692ac88316c = $0da7817f7132e823$var$isValidElement;
$0da7817f7132e823$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $0da7817f7132e823$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $0da7817f7132e823$var$lazyInitializer
    };
};
$0da7817f7132e823$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $0da7817f7132e823$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$0da7817f7132e823$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $0da7817f7132e823$var$ReactSharedInternals.T, currentTransition = {};
    $0da7817f7132e823$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $0da7817f7132e823$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($0da7817f7132e823$var$noop, $0da7817f7132e823$var$reportGlobalError);
    } catch (error) {
        $0da7817f7132e823$var$reportGlobalError(error);
    } finally{
        $0da7817f7132e823$var$ReactSharedInternals.T = prevTransition;
    }
};
$0da7817f7132e823$export$f93f40ac0ca7e3a8 = function() {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useCacheRefresh();
};
$0da7817f7132e823$export$1f96ae73734a86cc = function(usable) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.use(usable);
};
$0da7817f7132e823$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$0da7817f7132e823$export$35808ee640e87ca7 = function(callback, deps) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$0da7817f7132e823$export$fae74005e78b1a27 = function(Context) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useContext(Context);
};
$0da7817f7132e823$export$dc8fbce3eb94dc1e = function() {};
$0da7817f7132e823$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$0da7817f7132e823$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $0da7817f7132e823$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$0da7817f7132e823$export$f680877a34711e37 = function() {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useId();
};
$0da7817f7132e823$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$0da7817f7132e823$export$aaabe4eda9ed9969 = function(create, deps) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$0da7817f7132e823$export$e5c5a5f917a5871c = function(create, deps) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$0da7817f7132e823$export$1538c33de8887b59 = function(create, deps) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useMemo(create, deps);
};
$0da7817f7132e823$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$0da7817f7132e823$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$0da7817f7132e823$export$b8f5890fc79d6aca = function(initialValue) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useRef(initialValue);
};
$0da7817f7132e823$export$60241385465d0a34 = function(initialState) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useState(initialState);
};
$0da7817f7132e823$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$0da7817f7132e823$export$7b286972b8d8ccbf = function() {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useTransition();
};
$0da7817f7132e823$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("a8i8g", function(module, exports) {
// shim for using process in browser
var $7608b7726638efe3$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $7608b7726638efe3$var$cachedSetTimeout;
var $7608b7726638efe3$var$cachedClearTimeout;
function $7608b7726638efe3$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $7608b7726638efe3$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $7608b7726638efe3$var$cachedSetTimeout = setTimeout;
        else $7608b7726638efe3$var$cachedSetTimeout = $7608b7726638efe3$var$defaultSetTimout;
    } catch (e) {
        $7608b7726638efe3$var$cachedSetTimeout = $7608b7726638efe3$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $7608b7726638efe3$var$cachedClearTimeout = clearTimeout;
        else $7608b7726638efe3$var$cachedClearTimeout = $7608b7726638efe3$var$defaultClearTimeout;
    } catch (e) {
        $7608b7726638efe3$var$cachedClearTimeout = $7608b7726638efe3$var$defaultClearTimeout;
    }
})();
function $7608b7726638efe3$var$runTimeout(fun) {
    if ($7608b7726638efe3$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($7608b7726638efe3$var$cachedSetTimeout === $7608b7726638efe3$var$defaultSetTimout || !$7608b7726638efe3$var$cachedSetTimeout) && setTimeout) {
        $7608b7726638efe3$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7608b7726638efe3$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $7608b7726638efe3$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $7608b7726638efe3$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $7608b7726638efe3$var$runClearTimeout(marker) {
    if ($7608b7726638efe3$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($7608b7726638efe3$var$cachedClearTimeout === $7608b7726638efe3$var$defaultClearTimeout || !$7608b7726638efe3$var$cachedClearTimeout) && clearTimeout) {
        $7608b7726638efe3$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7608b7726638efe3$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $7608b7726638efe3$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $7608b7726638efe3$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $7608b7726638efe3$var$queue = [];
var $7608b7726638efe3$var$draining = false;
var $7608b7726638efe3$var$currentQueue;
var $7608b7726638efe3$var$queueIndex = -1;
function $7608b7726638efe3$var$cleanUpNextTick() {
    if (!$7608b7726638efe3$var$draining || !$7608b7726638efe3$var$currentQueue) return;
    $7608b7726638efe3$var$draining = false;
    if ($7608b7726638efe3$var$currentQueue.length) $7608b7726638efe3$var$queue = $7608b7726638efe3$var$currentQueue.concat($7608b7726638efe3$var$queue);
    else $7608b7726638efe3$var$queueIndex = -1;
    if ($7608b7726638efe3$var$queue.length) $7608b7726638efe3$var$drainQueue();
}
function $7608b7726638efe3$var$drainQueue() {
    if ($7608b7726638efe3$var$draining) return;
    var timeout = $7608b7726638efe3$var$runTimeout($7608b7726638efe3$var$cleanUpNextTick);
    $7608b7726638efe3$var$draining = true;
    var len = $7608b7726638efe3$var$queue.length;
    while(len){
        $7608b7726638efe3$var$currentQueue = $7608b7726638efe3$var$queue;
        $7608b7726638efe3$var$queue = [];
        while(++$7608b7726638efe3$var$queueIndex < len)if ($7608b7726638efe3$var$currentQueue) $7608b7726638efe3$var$currentQueue[$7608b7726638efe3$var$queueIndex].run();
        $7608b7726638efe3$var$queueIndex = -1;
        len = $7608b7726638efe3$var$queue.length;
    }
    $7608b7726638efe3$var$currentQueue = null;
    $7608b7726638efe3$var$draining = false;
    $7608b7726638efe3$var$runClearTimeout(timeout);
}
$7608b7726638efe3$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $7608b7726638efe3$var$queue.push(new $7608b7726638efe3$var$Item(fun, args));
    if ($7608b7726638efe3$var$queue.length === 1 && !$7608b7726638efe3$var$draining) $7608b7726638efe3$var$runTimeout($7608b7726638efe3$var$drainQueue);
};
// v8 likes predictible objects
function $7608b7726638efe3$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$7608b7726638efe3$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$7608b7726638efe3$var$process.title = 'browser';
$7608b7726638efe3$var$process.browser = true;
$7608b7726638efe3$var$process.env = {};
$7608b7726638efe3$var$process.argv = [];
$7608b7726638efe3$var$process.version = ''; // empty string to avoid regexp issues
$7608b7726638efe3$var$process.versions = {};
function $7608b7726638efe3$var$noop() {}
$7608b7726638efe3$var$process.on = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.addListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.once = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.off = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.removeListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.removeAllListeners = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.emit = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.prependListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.prependOnceListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.listeners = function(name) {
    return [];
};
$7608b7726638efe3$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$7608b7726638efe3$var$process.cwd = function() {
    return '/';
};
$7608b7726638efe3$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$7608b7726638efe3$var$process.umask = function() {
    return 0;
};

});


parcelRegister("fxpQW", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $b4fdfdeec9399ede$export$882461b6382ed46c; }, function (v) { return $b4fdfdeec9399ede$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b4fdfdeec9399ede$export$757ceba2d55c277e; }, function (v) { return $b4fdfdeec9399ede$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $b4fdfdeec9399ede$export$83d89fbfd8236492; }, function (v) { return $b4fdfdeec9399ede$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b4fdfdeec9399ede$export$882461b6382ed46c;
var $b4fdfdeec9399ede$export$757ceba2d55c277e;
var $b4fdfdeec9399ede$export$83d89fbfd8236492;

var $a8i8g = parcelRequire("a8i8g");
"use strict";

var $1c9zD = parcelRequire("1c9zD");

var $6cds3 = parcelRequire("6cds3");

var $9nHRL = parcelRequire("9nHRL");
function $b4fdfdeec9399ede$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $b4fdfdeec9399ede$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $b4fdfdeec9399ede$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $b4fdfdeec9399ede$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $b4fdfdeec9399ede$var$assertIsMounted(fiber) {
    if ($b4fdfdeec9399ede$var$getNearestMountedFiber(fiber) !== fiber) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(188));
}
function $b4fdfdeec9399ede$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $b4fdfdeec9399ede$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $b4fdfdeec9399ede$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $b4fdfdeec9399ede$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $b4fdfdeec9399ede$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $b4fdfdeec9399ede$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $b4fdfdeec9399ede$var$assign = Object.assign, $b4fdfdeec9399ede$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $b4fdfdeec9399ede$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $b4fdfdeec9399ede$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $b4fdfdeec9399ede$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $b4fdfdeec9399ede$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $b4fdfdeec9399ede$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $b4fdfdeec9399ede$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $b4fdfdeec9399ede$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $b4fdfdeec9399ede$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $b4fdfdeec9399ede$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $b4fdfdeec9399ede$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $b4fdfdeec9399ede$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $b4fdfdeec9399ede$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $b4fdfdeec9399ede$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $b4fdfdeec9399ede$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $b4fdfdeec9399ede$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $b4fdfdeec9399ede$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $b4fdfdeec9399ede$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$b4fdfdeec9399ede$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $b4fdfdeec9399ede$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $b4fdfdeec9399ede$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $b4fdfdeec9399ede$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $b4fdfdeec9399ede$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $b4fdfdeec9399ede$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $b4fdfdeec9399ede$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $b4fdfdeec9399ede$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $b4fdfdeec9399ede$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $b4fdfdeec9399ede$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $b4fdfdeec9399ede$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $b4fdfdeec9399ede$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $b4fdfdeec9399ede$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $b4fdfdeec9399ede$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $b4fdfdeec9399ede$var$getComponentNameFromType(type.type) || "Memo";
        case $b4fdfdeec9399ede$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $b4fdfdeec9399ede$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $b4fdfdeec9399ede$var$isArrayImpl = Array.isArray, $b4fdfdeec9399ede$var$ReactSharedInternals = $6cds3.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b4fdfdeec9399ede$var$ReactDOMSharedInternals = $9nHRL.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b4fdfdeec9399ede$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $b4fdfdeec9399ede$var$valueStack = [], $b4fdfdeec9399ede$var$index = -1;
function $b4fdfdeec9399ede$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $b4fdfdeec9399ede$var$pop(cursor) {
    0 > $b4fdfdeec9399ede$var$index || (cursor.current = $b4fdfdeec9399ede$var$valueStack[$b4fdfdeec9399ede$var$index], $b4fdfdeec9399ede$var$valueStack[$b4fdfdeec9399ede$var$index] = null, $b4fdfdeec9399ede$var$index--);
}
function $b4fdfdeec9399ede$var$push(cursor, value) {
    $b4fdfdeec9399ede$var$index++;
    $b4fdfdeec9399ede$var$valueStack[$b4fdfdeec9399ede$var$index] = cursor.current;
    cursor.current = value;
}
var $b4fdfdeec9399ede$var$contextStackCursor = $b4fdfdeec9399ede$var$createCursor(null), $b4fdfdeec9399ede$var$contextFiberStackCursor = $b4fdfdeec9399ede$var$createCursor(null), $b4fdfdeec9399ede$var$rootInstanceStackCursor = $b4fdfdeec9399ede$var$createCursor(null), $b4fdfdeec9399ede$var$hostTransitionProviderCursor = $b4fdfdeec9399ede$var$createCursor(null);
function $b4fdfdeec9399ede$var$pushHostContainer(fiber, nextRootInstance) {
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$rootInstanceStackCursor, nextRootInstance);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$contextFiberStackCursor, fiber);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $b4fdfdeec9399ede$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $b4fdfdeec9399ede$var$getOwnHostContext(nextRootInstance), fiber = $b4fdfdeec9399ede$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$contextStackCursor);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$contextStackCursor, fiber);
}
function $b4fdfdeec9399ede$var$popHostContainer() {
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$contextStackCursor);
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$contextFiberStackCursor);
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$rootInstanceStackCursor);
}
function $b4fdfdeec9399ede$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$hostTransitionProviderCursor, fiber);
    var context = $b4fdfdeec9399ede$var$contextStackCursor.current;
    var JSCompiler_inline_result = $b4fdfdeec9399ede$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$contextFiberStackCursor, fiber), $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$contextStackCursor, JSCompiler_inline_result));
}
function $b4fdfdeec9399ede$var$popHostContext(fiber) {
    $b4fdfdeec9399ede$var$contextFiberStackCursor.current === fiber && ($b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$contextStackCursor), $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$contextFiberStackCursor));
    $b4fdfdeec9399ede$var$hostTransitionProviderCursor.current === fiber && ($b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$hostTransitionProviderCursor), $b4fdfdeec9399ede$var$HostTransitionContext._currentValue = $b4fdfdeec9399ede$var$sharedNotPendingObject);
}
var $b4fdfdeec9399ede$var$hasOwnProperty = Object.prototype.hasOwnProperty, $b4fdfdeec9399ede$var$scheduleCallback$3 = $1c9zD.unstable_scheduleCallback, $b4fdfdeec9399ede$var$cancelCallback$1 = $1c9zD.unstable_cancelCallback, $b4fdfdeec9399ede$var$shouldYield = $1c9zD.unstable_shouldYield, $b4fdfdeec9399ede$var$requestPaint = $1c9zD.unstable_requestPaint, $b4fdfdeec9399ede$var$now = $1c9zD.unstable_now, $b4fdfdeec9399ede$var$getCurrentPriorityLevel = $1c9zD.unstable_getCurrentPriorityLevel, $b4fdfdeec9399ede$var$ImmediatePriority = $1c9zD.unstable_ImmediatePriority, $b4fdfdeec9399ede$var$UserBlockingPriority = $1c9zD.unstable_UserBlockingPriority, $b4fdfdeec9399ede$var$NormalPriority$1 = $1c9zD.unstable_NormalPriority, $b4fdfdeec9399ede$var$LowPriority = $1c9zD.unstable_LowPriority, $b4fdfdeec9399ede$var$IdlePriority = $1c9zD.unstable_IdlePriority, $b4fdfdeec9399ede$var$log$1 = $1c9zD.log, $b4fdfdeec9399ede$var$unstable_setDisableYieldValue = $1c9zD.unstable_setDisableYieldValue, $b4fdfdeec9399ede$var$rendererID = null, $b4fdfdeec9399ede$var$injectedHook = null;
function $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $b4fdfdeec9399ede$var$log$1 && $b4fdfdeec9399ede$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($b4fdfdeec9399ede$var$injectedHook && "function" === typeof $b4fdfdeec9399ede$var$injectedHook.setStrictMode) try {
        $b4fdfdeec9399ede$var$injectedHook.setStrictMode($b4fdfdeec9399ede$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $b4fdfdeec9399ede$var$clz32 = Math.clz32 ? Math.clz32 : $b4fdfdeec9399ede$var$clz32Fallback, $b4fdfdeec9399ede$var$log = Math.log, $b4fdfdeec9399ede$var$LN2 = Math.LN2;
function $b4fdfdeec9399ede$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($b4fdfdeec9399ede$var$log(x) / $b4fdfdeec9399ede$var$LN2 | 0) | 0;
}
var $b4fdfdeec9399ede$var$nextTransitionLane = 256, $b4fdfdeec9399ede$var$nextRetryLane = 4194304;
function $b4fdfdeec9399ede$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $b4fdfdeec9399ede$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $b4fdfdeec9399ede$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $b4fdfdeec9399ede$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $b4fdfdeec9399ede$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $b4fdfdeec9399ede$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $b4fdfdeec9399ede$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $b4fdfdeec9399ede$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $b4fdfdeec9399ede$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $b4fdfdeec9399ede$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b4fdfdeec9399ede$var$claimNextTransitionLane() {
    var lane = $b4fdfdeec9399ede$var$nextTransitionLane;
    $b4fdfdeec9399ede$var$nextTransitionLane <<= 1;
    0 === ($b4fdfdeec9399ede$var$nextTransitionLane & 4194048) && ($b4fdfdeec9399ede$var$nextTransitionLane = 256);
    return lane;
}
function $b4fdfdeec9399ede$var$claimNextRetryLane() {
    var lane = $b4fdfdeec9399ede$var$nextRetryLane;
    $b4fdfdeec9399ede$var$nextRetryLane <<= 1;
    0 === ($b4fdfdeec9399ede$var$nextRetryLane & 62914560) && ($b4fdfdeec9399ede$var$nextRetryLane = 4194304);
    return lane;
}
function $b4fdfdeec9399ede$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $b4fdfdeec9399ede$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $b4fdfdeec9399ede$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $b4fdfdeec9399ede$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $b4fdfdeec9399ede$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $b4fdfdeec9399ede$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $b4fdfdeec9399ede$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $b4fdfdeec9399ede$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $b4fdfdeec9399ede$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $b4fdfdeec9399ede$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $b4fdfdeec9399ede$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $b4fdfdeec9399ede$var$resolveUpdatePriority() {
    var updatePriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $b4fdfdeec9399ede$var$getEventPriority(updatePriority.type);
}
function $b4fdfdeec9399ede$var$runWithPriority(priority, fn) {
    var previousPriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
    try {
        return $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $b4fdfdeec9399ede$var$randomKey = Math.random().toString(36).slice(2), $b4fdfdeec9399ede$var$internalInstanceKey = "__reactFiber$" + $b4fdfdeec9399ede$var$randomKey, $b4fdfdeec9399ede$var$internalPropsKey = "__reactProps$" + $b4fdfdeec9399ede$var$randomKey, $b4fdfdeec9399ede$var$internalContainerInstanceKey = "__reactContainer$" + $b4fdfdeec9399ede$var$randomKey, $b4fdfdeec9399ede$var$internalEventHandlersKey = "__reactEvents$" + $b4fdfdeec9399ede$var$randomKey, $b4fdfdeec9399ede$var$internalEventHandlerListenersKey = "__reactListeners$" + $b4fdfdeec9399ede$var$randomKey, $b4fdfdeec9399ede$var$internalEventHandlesSetKey = "__reactHandles$" + $b4fdfdeec9399ede$var$randomKey, $b4fdfdeec9399ede$var$internalRootNodeResourcesKey = "__reactResources$" + $b4fdfdeec9399ede$var$randomKey, $b4fdfdeec9399ede$var$internalHoistableMarker = "__reactMarker$" + $b4fdfdeec9399ede$var$randomKey;
function $b4fdfdeec9399ede$var$detachDeletedInstance(node) {
    delete node[$b4fdfdeec9399ede$var$internalInstanceKey];
    delete node[$b4fdfdeec9399ede$var$internalPropsKey];
    delete node[$b4fdfdeec9399ede$var$internalEventHandlersKey];
    delete node[$b4fdfdeec9399ede$var$internalEventHandlerListenersKey];
    delete node[$b4fdfdeec9399ede$var$internalEventHandlesSetKey];
}
function $b4fdfdeec9399ede$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$b4fdfdeec9399ede$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$b4fdfdeec9399ede$var$internalContainerInstanceKey] || parentNode[$b4fdfdeec9399ede$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $b4fdfdeec9399ede$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$b4fdfdeec9399ede$var$internalInstanceKey]) return parentNode;
                targetNode = $b4fdfdeec9399ede$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $b4fdfdeec9399ede$var$getInstanceFromNode(node) {
    if (node = node[$b4fdfdeec9399ede$var$internalInstanceKey] || node[$b4fdfdeec9399ede$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $b4fdfdeec9399ede$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(33));
}
function $b4fdfdeec9399ede$var$getResourcesFromRoot(root) {
    var resources = root[$b4fdfdeec9399ede$var$internalRootNodeResourcesKey];
    resources || (resources = root[$b4fdfdeec9399ede$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $b4fdfdeec9399ede$var$markNodeAsHoistable(node) {
    node[$b4fdfdeec9399ede$var$internalHoistableMarker] = !0;
}
var $b4fdfdeec9399ede$var$allNativeEvents = new Set(), $b4fdfdeec9399ede$var$registrationNameDependencies = {};
function $b4fdfdeec9399ede$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $b4fdfdeec9399ede$var$registerDirectEvent(registrationName, dependencies);
    $b4fdfdeec9399ede$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $b4fdfdeec9399ede$var$registerDirectEvent(registrationName, dependencies) {
    $b4fdfdeec9399ede$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$b4fdfdeec9399ede$var$allNativeEvents.add(dependencies[registrationName]);
}
var $b4fdfdeec9399ede$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $b4fdfdeec9399ede$var$illegalAttributeNameCache = {}, $b4fdfdeec9399ede$var$validatedAttributeNameCache = {};
function $b4fdfdeec9399ede$var$isAttributeNameSafe(attributeName) {
    if ($b4fdfdeec9399ede$var$hasOwnProperty.call($b4fdfdeec9399ede$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($b4fdfdeec9399ede$var$hasOwnProperty.call($b4fdfdeec9399ede$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($b4fdfdeec9399ede$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $b4fdfdeec9399ede$var$validatedAttributeNameCache[attributeName] = !0;
    $b4fdfdeec9399ede$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $b4fdfdeec9399ede$var$setValueForAttribute(node, name, value) {
    if ($b4fdfdeec9399ede$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $b4fdfdeec9399ede$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $b4fdfdeec9399ede$var$prefix, $b4fdfdeec9399ede$var$suffix;
function $b4fdfdeec9399ede$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $b4fdfdeec9399ede$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $b4fdfdeec9399ede$var$prefix = match && match[1] || "";
        $b4fdfdeec9399ede$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $b4fdfdeec9399ede$var$prefix + name + $b4fdfdeec9399ede$var$suffix;
}
var $b4fdfdeec9399ede$var$reentry = !1;
function $b4fdfdeec9399ede$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $b4fdfdeec9399ede$var$reentry) return "";
    $b4fdfdeec9399ede$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $b4fdfdeec9399ede$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $b4fdfdeec9399ede$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $b4fdfdeec9399ede$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $b4fdfdeec9399ede$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $b4fdfdeec9399ede$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $b4fdfdeec9399ede$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $b4fdfdeec9399ede$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $b4fdfdeec9399ede$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $b4fdfdeec9399ede$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $b4fdfdeec9399ede$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $b4fdfdeec9399ede$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $b4fdfdeec9399ede$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $b4fdfdeec9399ede$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $b4fdfdeec9399ede$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $b4fdfdeec9399ede$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $b4fdfdeec9399ede$var$trackValueOnNode(node) {
    var valueField = $b4fdfdeec9399ede$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $b4fdfdeec9399ede$var$track(node) {
    node._valueTracker || (node._valueTracker = $b4fdfdeec9399ede$var$trackValueOnNode(node));
}
function $b4fdfdeec9399ede$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $b4fdfdeec9399ede$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $b4fdfdeec9399ede$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $b4fdfdeec9399ede$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $b4fdfdeec9399ede$var$getToStringValue(value);
        } else element.value !== "" + $b4fdfdeec9399ede$var$getToStringValue(value) && (element.value = "" + $b4fdfdeec9399ede$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $b4fdfdeec9399ede$var$setDefaultValue(element, type, $b4fdfdeec9399ede$var$getToStringValue(value)) : null != defaultValue ? $b4fdfdeec9399ede$var$setDefaultValue(element, type, $b4fdfdeec9399ede$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $b4fdfdeec9399ede$var$getToStringValue(name) : element.removeAttribute("name");
}
function $b4fdfdeec9399ede$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $b4fdfdeec9399ede$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $b4fdfdeec9399ede$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $b4fdfdeec9399ede$var$setDefaultValue(node, type, value) {
    "number" === type && $b4fdfdeec9399ede$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $b4fdfdeec9399ede$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $b4fdfdeec9399ede$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $b4fdfdeec9399ede$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $b4fdfdeec9399ede$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $b4fdfdeec9399ede$var$getToStringValue(defaultValue) : "";
}
function $b4fdfdeec9399ede$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(92));
            if ($b4fdfdeec9399ede$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $b4fdfdeec9399ede$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $b4fdfdeec9399ede$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $b4fdfdeec9399ede$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $b4fdfdeec9399ede$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $b4fdfdeec9399ede$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $b4fdfdeec9399ede$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $b4fdfdeec9399ede$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $b4fdfdeec9399ede$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $b4fdfdeec9399ede$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b4fdfdeec9399ede$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $b4fdfdeec9399ede$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $b4fdfdeec9399ede$var$sanitizeURL(url) {
    return $b4fdfdeec9399ede$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $b4fdfdeec9399ede$var$currentReplayingEvent = null;
function $b4fdfdeec9399ede$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $b4fdfdeec9399ede$var$restoreTarget = null, $b4fdfdeec9399ede$var$restoreQueue = null;
function $b4fdfdeec9399ede$var$restoreStateOfTarget(target) {
    var internalInstance = $b4fdfdeec9399ede$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$b4fdfdeec9399ede$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $b4fdfdeec9399ede$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$b4fdfdeec9399ede$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(90));
                            $b4fdfdeec9399ede$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $b4fdfdeec9399ede$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $b4fdfdeec9399ede$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $b4fdfdeec9399ede$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $b4fdfdeec9399ede$var$isInsideEventHandler = !1;
function $b4fdfdeec9399ede$var$batchedUpdates$1(fn, a, b) {
    if ($b4fdfdeec9399ede$var$isInsideEventHandler) return fn(a, b);
    $b4fdfdeec9399ede$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($b4fdfdeec9399ede$var$isInsideEventHandler = !1, null !== $b4fdfdeec9399ede$var$restoreTarget || null !== $b4fdfdeec9399ede$var$restoreQueue) {
            if ($b4fdfdeec9399ede$var$flushSyncWork$1(), $b4fdfdeec9399ede$var$restoreTarget && (a = $b4fdfdeec9399ede$var$restoreTarget, fn = $b4fdfdeec9399ede$var$restoreQueue, $b4fdfdeec9399ede$var$restoreQueue = $b4fdfdeec9399ede$var$restoreTarget = null, $b4fdfdeec9399ede$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$b4fdfdeec9399ede$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $b4fdfdeec9399ede$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$b4fdfdeec9399ede$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $b4fdfdeec9399ede$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b4fdfdeec9399ede$var$passiveBrowserEventsSupported = !1;
if ($b4fdfdeec9399ede$var$canUseDOM) try {
    var $b4fdfdeec9399ede$var$options = {};
    Object.defineProperty($b4fdfdeec9399ede$var$options, "passive", {
        get: function() {
            $b4fdfdeec9399ede$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $b4fdfdeec9399ede$var$options, $b4fdfdeec9399ede$var$options);
    window.removeEventListener("test", $b4fdfdeec9399ede$var$options, $b4fdfdeec9399ede$var$options);
} catch (e) {
    $b4fdfdeec9399ede$var$passiveBrowserEventsSupported = !1;
}
var $b4fdfdeec9399ede$var$root = null, $b4fdfdeec9399ede$var$startText = null, $b4fdfdeec9399ede$var$fallbackText = null;
function $b4fdfdeec9399ede$var$getData() {
    if ($b4fdfdeec9399ede$var$fallbackText) return $b4fdfdeec9399ede$var$fallbackText;
    var start, startValue = $b4fdfdeec9399ede$var$startText, startLength = startValue.length, end, endValue = "value" in $b4fdfdeec9399ede$var$root ? $b4fdfdeec9399ede$var$root.value : $b4fdfdeec9399ede$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $b4fdfdeec9399ede$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $b4fdfdeec9399ede$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $b4fdfdeec9399ede$var$functionThatReturnsTrue() {
    return !0;
}
function $b4fdfdeec9399ede$var$functionThatReturnsFalse() {
    return !1;
}
function $b4fdfdeec9399ede$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $b4fdfdeec9399ede$var$functionThatReturnsTrue : $b4fdfdeec9399ede$var$functionThatReturnsFalse;
        this.isPropagationStopped = $b4fdfdeec9399ede$var$functionThatReturnsFalse;
        return this;
    }
    $b4fdfdeec9399ede$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $b4fdfdeec9399ede$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $b4fdfdeec9399ede$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $b4fdfdeec9399ede$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $b4fdfdeec9399ede$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b4fdfdeec9399ede$var$SyntheticEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$EventInterface), $b4fdfdeec9399ede$var$UIEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$EventInterface, {
    view: 0,
    detail: 0
}), $b4fdfdeec9399ede$var$SyntheticUIEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$UIEventInterface), $b4fdfdeec9399ede$var$lastMovementX, $b4fdfdeec9399ede$var$lastMovementY, $b4fdfdeec9399ede$var$lastMouseEvent, $b4fdfdeec9399ede$var$MouseEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b4fdfdeec9399ede$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $b4fdfdeec9399ede$var$lastMouseEvent && ($b4fdfdeec9399ede$var$lastMouseEvent && "mousemove" === event.type ? ($b4fdfdeec9399ede$var$lastMovementX = event.screenX - $b4fdfdeec9399ede$var$lastMouseEvent.screenX, $b4fdfdeec9399ede$var$lastMovementY = event.screenY - $b4fdfdeec9399ede$var$lastMouseEvent.screenY) : $b4fdfdeec9399ede$var$lastMovementY = $b4fdfdeec9399ede$var$lastMovementX = 0, $b4fdfdeec9399ede$var$lastMouseEvent = event);
        return $b4fdfdeec9399ede$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $b4fdfdeec9399ede$var$lastMovementY;
    }
}), $b4fdfdeec9399ede$var$SyntheticMouseEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$MouseEventInterface), $b4fdfdeec9399ede$var$DragEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$MouseEventInterface, {
    dataTransfer: 0
}), $b4fdfdeec9399ede$var$SyntheticDragEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$DragEventInterface), $b4fdfdeec9399ede$var$FocusEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$UIEventInterface, {
    relatedTarget: 0
}), $b4fdfdeec9399ede$var$SyntheticFocusEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$FocusEventInterface), $b4fdfdeec9399ede$var$AnimationEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b4fdfdeec9399ede$var$SyntheticAnimationEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$AnimationEventInterface), $b4fdfdeec9399ede$var$ClipboardEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $b4fdfdeec9399ede$var$SyntheticClipboardEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$ClipboardEventInterface), $b4fdfdeec9399ede$var$CompositionEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$EventInterface, {
    data: 0
}), $b4fdfdeec9399ede$var$SyntheticCompositionEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$CompositionEventInterface), $b4fdfdeec9399ede$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b4fdfdeec9399ede$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b4fdfdeec9399ede$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b4fdfdeec9399ede$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $b4fdfdeec9399ede$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $b4fdfdeec9399ede$var$getEventModifierState() {
    return $b4fdfdeec9399ede$var$modifierStateGetter;
}
var $b4fdfdeec9399ede$var$KeyboardEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $b4fdfdeec9399ede$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $b4fdfdeec9399ede$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $b4fdfdeec9399ede$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b4fdfdeec9399ede$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $b4fdfdeec9399ede$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $b4fdfdeec9399ede$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $b4fdfdeec9399ede$var$SyntheticKeyboardEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$KeyboardEventInterface), $b4fdfdeec9399ede$var$PointerEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b4fdfdeec9399ede$var$SyntheticPointerEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$PointerEventInterface), $b4fdfdeec9399ede$var$TouchEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b4fdfdeec9399ede$var$getEventModifierState
}), $b4fdfdeec9399ede$var$SyntheticTouchEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$TouchEventInterface), $b4fdfdeec9399ede$var$TransitionEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b4fdfdeec9399ede$var$SyntheticTransitionEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$TransitionEventInterface), $b4fdfdeec9399ede$var$WheelEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b4fdfdeec9399ede$var$SyntheticWheelEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$WheelEventInterface), $b4fdfdeec9399ede$var$ToggleEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $b4fdfdeec9399ede$var$SyntheticToggleEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$ToggleEventInterface), $b4fdfdeec9399ede$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $b4fdfdeec9399ede$var$canUseCompositionEvent = $b4fdfdeec9399ede$var$canUseDOM && "CompositionEvent" in window, $b4fdfdeec9399ede$var$documentMode = null;
$b4fdfdeec9399ede$var$canUseDOM && "documentMode" in document && ($b4fdfdeec9399ede$var$documentMode = document.documentMode);
var $b4fdfdeec9399ede$var$canUseTextInputEvent = $b4fdfdeec9399ede$var$canUseDOM && "TextEvent" in window && !$b4fdfdeec9399ede$var$documentMode, $b4fdfdeec9399ede$var$useFallbackCompositionData = $b4fdfdeec9399ede$var$canUseDOM && (!$b4fdfdeec9399ede$var$canUseCompositionEvent || $b4fdfdeec9399ede$var$documentMode && 8 < $b4fdfdeec9399ede$var$documentMode && 11 >= $b4fdfdeec9399ede$var$documentMode), $b4fdfdeec9399ede$var$SPACEBAR_CHAR = String.fromCharCode(32), $b4fdfdeec9399ede$var$hasSpaceKeypress = !1;
function $b4fdfdeec9399ede$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $b4fdfdeec9399ede$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b4fdfdeec9399ede$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $b4fdfdeec9399ede$var$isComposing = !1;
function $b4fdfdeec9399ede$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $b4fdfdeec9399ede$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $b4fdfdeec9399ede$var$hasSpaceKeypress = !0;
            return $b4fdfdeec9399ede$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $b4fdfdeec9399ede$var$SPACEBAR_CHAR && $b4fdfdeec9399ede$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $b4fdfdeec9399ede$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($b4fdfdeec9399ede$var$isComposing) return "compositionend" === domEventName || !$b4fdfdeec9399ede$var$canUseCompositionEvent && $b4fdfdeec9399ede$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $b4fdfdeec9399ede$var$getData(), $b4fdfdeec9399ede$var$fallbackText = $b4fdfdeec9399ede$var$startText = $b4fdfdeec9399ede$var$root = null, $b4fdfdeec9399ede$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $b4fdfdeec9399ede$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $b4fdfdeec9399ede$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b4fdfdeec9399ede$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$b4fdfdeec9399ede$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $b4fdfdeec9399ede$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $b4fdfdeec9399ede$var$restoreTarget ? $b4fdfdeec9399ede$var$restoreQueue ? $b4fdfdeec9399ede$var$restoreQueue.push(target) : $b4fdfdeec9399ede$var$restoreQueue = [
        target
    ] : $b4fdfdeec9399ede$var$restoreTarget = target;
    inst = $b4fdfdeec9399ede$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $b4fdfdeec9399ede$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $b4fdfdeec9399ede$var$activeElement$1 = null, $b4fdfdeec9399ede$var$activeElementInst$1 = null;
function $b4fdfdeec9399ede$var$runEventInBatch(dispatchQueue) {
    $b4fdfdeec9399ede$var$processDispatchQueue(dispatchQueue, 0);
}
function $b4fdfdeec9399ede$var$getInstIfValueChanged(targetInst) {
    var targetNode = $b4fdfdeec9399ede$var$getNodeFromInstance(targetInst);
    if ($b4fdfdeec9399ede$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $b4fdfdeec9399ede$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $b4fdfdeec9399ede$var$isInputEventSupported = !1;
if ($b4fdfdeec9399ede$var$canUseDOM) {
    var $b4fdfdeec9399ede$var$JSCompiler_inline_result$jscomp$282;
    if ($b4fdfdeec9399ede$var$canUseDOM) {
        var $b4fdfdeec9399ede$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$b4fdfdeec9399ede$var$isSupported$jscomp$inline_417) {
            var $b4fdfdeec9399ede$var$element$jscomp$inline_418 = document.createElement("div");
            $b4fdfdeec9399ede$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $b4fdfdeec9399ede$var$isSupported$jscomp$inline_417 = "function" === typeof $b4fdfdeec9399ede$var$element$jscomp$inline_418.oninput;
        }
        $b4fdfdeec9399ede$var$JSCompiler_inline_result$jscomp$282 = $b4fdfdeec9399ede$var$isSupported$jscomp$inline_417;
    } else $b4fdfdeec9399ede$var$JSCompiler_inline_result$jscomp$282 = !1;
    $b4fdfdeec9399ede$var$isInputEventSupported = $b4fdfdeec9399ede$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $b4fdfdeec9399ede$var$stopWatchingForValueChange() {
    $b4fdfdeec9399ede$var$activeElement$1 && ($b4fdfdeec9399ede$var$activeElement$1.detachEvent("onpropertychange", $b4fdfdeec9399ede$var$handlePropertyChange), $b4fdfdeec9399ede$var$activeElementInst$1 = $b4fdfdeec9399ede$var$activeElement$1 = null);
}
function $b4fdfdeec9399ede$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $b4fdfdeec9399ede$var$getInstIfValueChanged($b4fdfdeec9399ede$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $b4fdfdeec9399ede$var$createAndAccumulateChangeEvent(dispatchQueue, $b4fdfdeec9399ede$var$activeElementInst$1, nativeEvent, $b4fdfdeec9399ede$var$getEventTarget(nativeEvent));
        $b4fdfdeec9399ede$var$batchedUpdates$1($b4fdfdeec9399ede$var$runEventInBatch, dispatchQueue);
    }
}
function $b4fdfdeec9399ede$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($b4fdfdeec9399ede$var$stopWatchingForValueChange(), $b4fdfdeec9399ede$var$activeElement$1 = target, $b4fdfdeec9399ede$var$activeElementInst$1 = targetInst, $b4fdfdeec9399ede$var$activeElement$1.attachEvent("onpropertychange", $b4fdfdeec9399ede$var$handlePropertyChange)) : "focusout" === domEventName && $b4fdfdeec9399ede$var$stopWatchingForValueChange();
}
function $b4fdfdeec9399ede$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $b4fdfdeec9399ede$var$getInstIfValueChanged($b4fdfdeec9399ede$var$activeElementInst$1);
}
function $b4fdfdeec9399ede$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $b4fdfdeec9399ede$var$getInstIfValueChanged(targetInst);
}
function $b4fdfdeec9399ede$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $b4fdfdeec9399ede$var$getInstIfValueChanged(targetInst);
}
function $b4fdfdeec9399ede$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $b4fdfdeec9399ede$var$objectIs = "function" === typeof Object.is ? Object.is : $b4fdfdeec9399ede$var$is;
function $b4fdfdeec9399ede$var$shallowEqual(objA, objB) {
    if ($b4fdfdeec9399ede$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$b4fdfdeec9399ede$var$hasOwnProperty.call(objB, currentKey) || !$b4fdfdeec9399ede$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $b4fdfdeec9399ede$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $b4fdfdeec9399ede$var$getNodeForCharacterOffset(root, offset) {
    var node = $b4fdfdeec9399ede$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $b4fdfdeec9399ede$var$getLeafNode(node);
    }
}
function $b4fdfdeec9399ede$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $b4fdfdeec9399ede$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $b4fdfdeec9399ede$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $b4fdfdeec9399ede$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $b4fdfdeec9399ede$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $b4fdfdeec9399ede$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $b4fdfdeec9399ede$var$skipSelectionChangeEvent = $b4fdfdeec9399ede$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $b4fdfdeec9399ede$var$activeElement = null, $b4fdfdeec9399ede$var$activeElementInst = null, $b4fdfdeec9399ede$var$lastSelection = null, $b4fdfdeec9399ede$var$mouseDown = !1;
function $b4fdfdeec9399ede$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $b4fdfdeec9399ede$var$mouseDown || null == $b4fdfdeec9399ede$var$activeElement || $b4fdfdeec9399ede$var$activeElement !== $b4fdfdeec9399ede$var$getActiveElement(doc) || (doc = $b4fdfdeec9399ede$var$activeElement, "selectionStart" in doc && $b4fdfdeec9399ede$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $b4fdfdeec9399ede$var$lastSelection && $b4fdfdeec9399ede$var$shallowEqual($b4fdfdeec9399ede$var$lastSelection, doc) || ($b4fdfdeec9399ede$var$lastSelection = doc, doc = $b4fdfdeec9399ede$var$accumulateTwoPhaseListeners($b4fdfdeec9399ede$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $b4fdfdeec9399ede$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $b4fdfdeec9399ede$var$activeElement)));
}
function $b4fdfdeec9399ede$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $b4fdfdeec9399ede$var$vendorPrefixes = {
    animationend: $b4fdfdeec9399ede$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $b4fdfdeec9399ede$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $b4fdfdeec9399ede$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $b4fdfdeec9399ede$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $b4fdfdeec9399ede$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $b4fdfdeec9399ede$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $b4fdfdeec9399ede$var$makePrefixMap("Transition", "TransitionEnd")
}, $b4fdfdeec9399ede$var$prefixedEventNames = {}, $b4fdfdeec9399ede$var$style = {};
$b4fdfdeec9399ede$var$canUseDOM && ($b4fdfdeec9399ede$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $b4fdfdeec9399ede$var$vendorPrefixes.animationend.animation, delete $b4fdfdeec9399ede$var$vendorPrefixes.animationiteration.animation, delete $b4fdfdeec9399ede$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $b4fdfdeec9399ede$var$vendorPrefixes.transitionend.transition);
function $b4fdfdeec9399ede$var$getVendorPrefixedEventName(eventName) {
    if ($b4fdfdeec9399ede$var$prefixedEventNames[eventName]) return $b4fdfdeec9399ede$var$prefixedEventNames[eventName];
    if (!$b4fdfdeec9399ede$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $b4fdfdeec9399ede$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $b4fdfdeec9399ede$var$style) return $b4fdfdeec9399ede$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $b4fdfdeec9399ede$var$ANIMATION_END = $b4fdfdeec9399ede$var$getVendorPrefixedEventName("animationend"), $b4fdfdeec9399ede$var$ANIMATION_ITERATION = $b4fdfdeec9399ede$var$getVendorPrefixedEventName("animationiteration"), $b4fdfdeec9399ede$var$ANIMATION_START = $b4fdfdeec9399ede$var$getVendorPrefixedEventName("animationstart"), $b4fdfdeec9399ede$var$TRANSITION_RUN = $b4fdfdeec9399ede$var$getVendorPrefixedEventName("transitionrun"), $b4fdfdeec9399ede$var$TRANSITION_START = $b4fdfdeec9399ede$var$getVendorPrefixedEventName("transitionstart"), $b4fdfdeec9399ede$var$TRANSITION_CANCEL = $b4fdfdeec9399ede$var$getVendorPrefixedEventName("transitioncancel"), $b4fdfdeec9399ede$var$TRANSITION_END = $b4fdfdeec9399ede$var$getVendorPrefixedEventName("transitionend"), $b4fdfdeec9399ede$var$topLevelEventsToReactNames = new Map(), $b4fdfdeec9399ede$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$b4fdfdeec9399ede$var$simpleEventPluginEvents.push("scrollEnd");
function $b4fdfdeec9399ede$var$registerSimpleEvent(domEventName, reactName) {
    $b4fdfdeec9399ede$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $b4fdfdeec9399ede$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $b4fdfdeec9399ede$var$CapturedStacks = new WeakMap();
function $b4fdfdeec9399ede$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $b4fdfdeec9399ede$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $b4fdfdeec9399ede$var$getStackByFiberInDevAndProd(source)
        };
        $b4fdfdeec9399ede$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $b4fdfdeec9399ede$var$getStackByFiberInDevAndProd(source)
    };
}
var $b4fdfdeec9399ede$var$concurrentQueues = [], $b4fdfdeec9399ede$var$concurrentQueuesIndex = 0, $b4fdfdeec9399ede$var$concurrentlyUpdatedLanes = 0;
function $b4fdfdeec9399ede$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $b4fdfdeec9399ede$var$concurrentQueuesIndex, i = $b4fdfdeec9399ede$var$concurrentlyUpdatedLanes = $b4fdfdeec9399ede$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $b4fdfdeec9399ede$var$concurrentQueues[i];
        $b4fdfdeec9399ede$var$concurrentQueues[i++] = null;
        var queue = $b4fdfdeec9399ede$var$concurrentQueues[i];
        $b4fdfdeec9399ede$var$concurrentQueues[i++] = null;
        var update = $b4fdfdeec9399ede$var$concurrentQueues[i];
        $b4fdfdeec9399ede$var$concurrentQueues[i++] = null;
        var lane = $b4fdfdeec9399ede$var$concurrentQueues[i];
        $b4fdfdeec9399ede$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $b4fdfdeec9399ede$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $b4fdfdeec9399ede$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $b4fdfdeec9399ede$var$concurrentQueues[$b4fdfdeec9399ede$var$concurrentQueuesIndex++] = fiber;
    $b4fdfdeec9399ede$var$concurrentQueues[$b4fdfdeec9399ede$var$concurrentQueuesIndex++] = queue;
    $b4fdfdeec9399ede$var$concurrentQueues[$b4fdfdeec9399ede$var$concurrentQueuesIndex++] = update;
    $b4fdfdeec9399ede$var$concurrentQueues[$b4fdfdeec9399ede$var$concurrentQueuesIndex++] = lane;
    $b4fdfdeec9399ede$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $b4fdfdeec9399ede$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $b4fdfdeec9399ede$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $b4fdfdeec9399ede$var$getRootForUpdatedFiber(fiber);
}
function $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $b4fdfdeec9399ede$var$enqueueUpdate$1(fiber, null, null, lane);
    return $b4fdfdeec9399ede$var$getRootForUpdatedFiber(fiber);
}
function $b4fdfdeec9399ede$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $b4fdfdeec9399ede$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $b4fdfdeec9399ede$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $b4fdfdeec9399ede$var$nestedUpdateCount) throw $b4fdfdeec9399ede$var$nestedUpdateCount = 0, $b4fdfdeec9399ede$var$rootWithNestedUpdates = null, Error($b4fdfdeec9399ede$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $b4fdfdeec9399ede$var$emptyContextObject = {};
function $b4fdfdeec9399ede$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b4fdfdeec9399ede$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $b4fdfdeec9399ede$var$FiberNode(tag, pendingProps, key, mode);
}
function $b4fdfdeec9399ede$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $b4fdfdeec9399ede$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $b4fdfdeec9399ede$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $b4fdfdeec9399ede$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $b4fdfdeec9399ede$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $b4fdfdeec9399ede$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $b4fdfdeec9399ede$var$isHostHoistableType(type, pendingProps, $b4fdfdeec9399ede$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $b4fdfdeec9399ede$var$REACT_ACTIVITY_TYPE:
            return type = $b4fdfdeec9399ede$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $b4fdfdeec9399ede$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $b4fdfdeec9399ede$var$REACT_FRAGMENT_TYPE:
            return $b4fdfdeec9399ede$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $b4fdfdeec9399ede$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $b4fdfdeec9399ede$var$REACT_PROFILER_TYPE:
            return type = $b4fdfdeec9399ede$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $b4fdfdeec9399ede$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $b4fdfdeec9399ede$var$REACT_SUSPENSE_TYPE:
            return type = $b4fdfdeec9399ede$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $b4fdfdeec9399ede$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $b4fdfdeec9399ede$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $b4fdfdeec9399ede$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $b4fdfdeec9399ede$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $b4fdfdeec9399ede$var$REACT_PROVIDER_TYPE:
                case $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $b4fdfdeec9399ede$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $b4fdfdeec9399ede$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $b4fdfdeec9399ede$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $b4fdfdeec9399ede$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $b4fdfdeec9399ede$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $b4fdfdeec9399ede$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $b4fdfdeec9399ede$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $b4fdfdeec9399ede$var$createFiberFromText(content, mode, lanes) {
    content = $b4fdfdeec9399ede$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $b4fdfdeec9399ede$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $b4fdfdeec9399ede$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $b4fdfdeec9399ede$var$forkStack = [], $b4fdfdeec9399ede$var$forkStackIndex = 0, $b4fdfdeec9399ede$var$treeForkProvider = null, $b4fdfdeec9399ede$var$treeForkCount = 0, $b4fdfdeec9399ede$var$idStack = [], $b4fdfdeec9399ede$var$idStackIndex = 0, $b4fdfdeec9399ede$var$treeContextProvider = null, $b4fdfdeec9399ede$var$treeContextId = 1, $b4fdfdeec9399ede$var$treeContextOverflow = "";
function $b4fdfdeec9399ede$var$pushTreeFork(workInProgress, totalChildren) {
    $b4fdfdeec9399ede$var$forkStack[$b4fdfdeec9399ede$var$forkStackIndex++] = $b4fdfdeec9399ede$var$treeForkCount;
    $b4fdfdeec9399ede$var$forkStack[$b4fdfdeec9399ede$var$forkStackIndex++] = $b4fdfdeec9399ede$var$treeForkProvider;
    $b4fdfdeec9399ede$var$treeForkProvider = workInProgress;
    $b4fdfdeec9399ede$var$treeForkCount = totalChildren;
}
function $b4fdfdeec9399ede$var$pushTreeId(workInProgress, totalChildren, index) {
    $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex++] = $b4fdfdeec9399ede$var$treeContextId;
    $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex++] = $b4fdfdeec9399ede$var$treeContextOverflow;
    $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex++] = $b4fdfdeec9399ede$var$treeContextProvider;
    $b4fdfdeec9399ede$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $b4fdfdeec9399ede$var$treeContextId;
    workInProgress = $b4fdfdeec9399ede$var$treeContextOverflow;
    var baseLength = 32 - $b4fdfdeec9399ede$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $b4fdfdeec9399ede$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $b4fdfdeec9399ede$var$treeContextId = 1 << 32 - $b4fdfdeec9399ede$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $b4fdfdeec9399ede$var$treeContextOverflow = length + workInProgress;
    } else $b4fdfdeec9399ede$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $b4fdfdeec9399ede$var$treeContextOverflow = workInProgress;
}
function $b4fdfdeec9399ede$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($b4fdfdeec9399ede$var$pushTreeFork(workInProgress, 1), $b4fdfdeec9399ede$var$pushTreeId(workInProgress, 1, 0));
}
function $b4fdfdeec9399ede$var$popTreeContext(workInProgress) {
    for(; workInProgress === $b4fdfdeec9399ede$var$treeForkProvider;)$b4fdfdeec9399ede$var$treeForkProvider = $b4fdfdeec9399ede$var$forkStack[--$b4fdfdeec9399ede$var$forkStackIndex], $b4fdfdeec9399ede$var$forkStack[$b4fdfdeec9399ede$var$forkStackIndex] = null, $b4fdfdeec9399ede$var$treeForkCount = $b4fdfdeec9399ede$var$forkStack[--$b4fdfdeec9399ede$var$forkStackIndex], $b4fdfdeec9399ede$var$forkStack[$b4fdfdeec9399ede$var$forkStackIndex] = null;
    for(; workInProgress === $b4fdfdeec9399ede$var$treeContextProvider;)$b4fdfdeec9399ede$var$treeContextProvider = $b4fdfdeec9399ede$var$idStack[--$b4fdfdeec9399ede$var$idStackIndex], $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex] = null, $b4fdfdeec9399ede$var$treeContextOverflow = $b4fdfdeec9399ede$var$idStack[--$b4fdfdeec9399ede$var$idStackIndex], $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex] = null, $b4fdfdeec9399ede$var$treeContextId = $b4fdfdeec9399ede$var$idStack[--$b4fdfdeec9399ede$var$idStackIndex], $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex] = null;
}
var $b4fdfdeec9399ede$var$hydrationParentFiber = null, $b4fdfdeec9399ede$var$nextHydratableInstance = null, $b4fdfdeec9399ede$var$isHydrating = !1, $b4fdfdeec9399ede$var$hydrationErrors = null, $b4fdfdeec9399ede$var$rootOrSingletonContext = !1, $b4fdfdeec9399ede$var$HydrationMismatchException = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(519));
function $b4fdfdeec9399ede$var$throwOnHydrationMismatch(fiber) {
    var error = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(418, ""));
    $b4fdfdeec9399ede$var$queueHydrationError($b4fdfdeec9399ede$var$createCapturedValueAtFiber(error, fiber));
    throw $b4fdfdeec9399ede$var$HydrationMismatchException;
}
function $b4fdfdeec9399ede$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$b4fdfdeec9399ede$var$internalInstanceKey] = fiber;
    instance[$b4fdfdeec9399ede$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("cancel", instance);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $b4fdfdeec9399ede$var$mediaEventTypes.length; type++)$b4fdfdeec9399ede$var$listenToNonDelegatedEvent($b4fdfdeec9399ede$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("error", instance);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("invalid", instance);
            $b4fdfdeec9399ede$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $b4fdfdeec9399ede$var$track(instance);
            break;
        case "select":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("invalid", instance), $b4fdfdeec9399ede$var$initTextarea(instance, props.value, props.defaultValue, props.children), $b4fdfdeec9399ede$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $b4fdfdeec9399ede$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($b4fdfdeec9399ede$var$listenToNonDelegatedEvent("beforetoggle", instance), $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $b4fdfdeec9399ede$var$noop$1), instance = !0) : instance = !1;
    instance || $b4fdfdeec9399ede$var$throwOnHydrationMismatch(fiber);
}
function $b4fdfdeec9399ede$var$popToNextHostParent(fiber) {
    for($b4fdfdeec9399ede$var$hydrationParentFiber = fiber.return; $b4fdfdeec9399ede$var$hydrationParentFiber;)switch($b4fdfdeec9399ede$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $b4fdfdeec9399ede$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $b4fdfdeec9399ede$var$rootOrSingletonContext = !0;
            return;
        default:
            $b4fdfdeec9399ede$var$hydrationParentFiber = $b4fdfdeec9399ede$var$hydrationParentFiber.return;
    }
}
function $b4fdfdeec9399ede$var$popHydrationState(fiber) {
    if (fiber !== $b4fdfdeec9399ede$var$hydrationParentFiber) return !1;
    if (!$b4fdfdeec9399ede$var$isHydrating) return $b4fdfdeec9399ede$var$popToNextHostParent(fiber), $b4fdfdeec9399ede$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $b4fdfdeec9399ede$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $b4fdfdeec9399ede$var$nextHydratableInstance && $b4fdfdeec9399ede$var$throwOnHydrationMismatch(fiber);
    $b4fdfdeec9399ede$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $b4fdfdeec9399ede$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $b4fdfdeec9399ede$var$nextHydratableInstance, $b4fdfdeec9399ede$var$isSingletonScope(fiber.type) ? (fiber = $b4fdfdeec9399ede$var$previousHydratableOnEnteringScopedSingleton, $b4fdfdeec9399ede$var$previousHydratableOnEnteringScopedSingleton = null, $b4fdfdeec9399ede$var$nextHydratableInstance = fiber) : $b4fdfdeec9399ede$var$nextHydratableInstance = tag) : $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$hydrationParentFiber ? $b4fdfdeec9399ede$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $b4fdfdeec9399ede$var$resetHydrationState() {
    $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$hydrationParentFiber = null;
    $b4fdfdeec9399ede$var$isHydrating = !1;
}
function $b4fdfdeec9399ede$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $b4fdfdeec9399ede$var$hydrationErrors;
    null !== queuedErrors && (null === $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors ? $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors = queuedErrors : $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors.push.apply($b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors, queuedErrors), $b4fdfdeec9399ede$var$hydrationErrors = null);
    return queuedErrors;
}
function $b4fdfdeec9399ede$var$queueHydrationError(error) {
    null === $b4fdfdeec9399ede$var$hydrationErrors ? $b4fdfdeec9399ede$var$hydrationErrors = [
        error
    ] : $b4fdfdeec9399ede$var$hydrationErrors.push(error);
}
var $b4fdfdeec9399ede$var$valueCursor = $b4fdfdeec9399ede$var$createCursor(null), $b4fdfdeec9399ede$var$currentlyRenderingFiber$1 = null, $b4fdfdeec9399ede$var$lastContextDependency = null;
function $b4fdfdeec9399ede$var$pushProvider(providerFiber, context, nextValue) {
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $b4fdfdeec9399ede$var$popProvider(context) {
    context._currentValue = $b4fdfdeec9399ede$var$valueCursor.current;
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$valueCursor);
}
function $b4fdfdeec9399ede$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $b4fdfdeec9399ede$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $b4fdfdeec9399ede$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $b4fdfdeec9399ede$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $b4fdfdeec9399ede$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $b4fdfdeec9399ede$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $b4fdfdeec9399ede$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($b4fdfdeec9399ede$var$HostTransitionContext) : current = [
                $b4fdfdeec9399ede$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $b4fdfdeec9399ede$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $b4fdfdeec9399ede$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$b4fdfdeec9399ede$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $b4fdfdeec9399ede$var$prepareToReadContext(workInProgress) {
    $b4fdfdeec9399ede$var$currentlyRenderingFiber$1 = workInProgress;
    $b4fdfdeec9399ede$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $b4fdfdeec9399ede$var$readContext(context) {
    return $b4fdfdeec9399ede$var$readContextForConsumer($b4fdfdeec9399ede$var$currentlyRenderingFiber$1, context);
}
function $b4fdfdeec9399ede$var$readContextDuringReconciliation(consumer, context) {
    null === $b4fdfdeec9399ede$var$currentlyRenderingFiber$1 && $b4fdfdeec9399ede$var$prepareToReadContext(consumer);
    return $b4fdfdeec9399ede$var$readContextForConsumer(consumer, context);
}
function $b4fdfdeec9399ede$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $b4fdfdeec9399ede$var$lastContextDependency) {
        if (null === consumer) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(308));
        $b4fdfdeec9399ede$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $b4fdfdeec9399ede$var$lastContextDependency = $b4fdfdeec9399ede$var$lastContextDependency.next = context;
    return value;
}
var $b4fdfdeec9399ede$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $b4fdfdeec9399ede$var$scheduleCallback$2 = $1c9zD.unstable_scheduleCallback, $b4fdfdeec9399ede$var$NormalPriority = $1c9zD.unstable_NormalPriority, $b4fdfdeec9399ede$var$CacheContext = {
    $$typeof: $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $b4fdfdeec9399ede$var$createCache() {
    return {
        controller: new $b4fdfdeec9399ede$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $b4fdfdeec9399ede$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $b4fdfdeec9399ede$var$scheduleCallback$2($b4fdfdeec9399ede$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $b4fdfdeec9399ede$var$currentEntangledListeners = null, $b4fdfdeec9399ede$var$currentEntangledPendingCount = 0, $b4fdfdeec9399ede$var$currentEntangledLane = 0, $b4fdfdeec9399ede$var$currentEntangledActionThenable = null;
function $b4fdfdeec9399ede$var$entangleAsyncAction(transition, thenable) {
    if (null === $b4fdfdeec9399ede$var$currentEntangledListeners) {
        var entangledListeners = $b4fdfdeec9399ede$var$currentEntangledListeners = [];
        $b4fdfdeec9399ede$var$currentEntangledPendingCount = 0;
        $b4fdfdeec9399ede$var$currentEntangledLane = $b4fdfdeec9399ede$var$requestTransitionLane();
        $b4fdfdeec9399ede$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $b4fdfdeec9399ede$var$currentEntangledPendingCount++;
    thenable.then($b4fdfdeec9399ede$var$pingEngtangledActionScope, $b4fdfdeec9399ede$var$pingEngtangledActionScope);
    return thenable;
}
function $b4fdfdeec9399ede$var$pingEngtangledActionScope() {
    if (0 === --$b4fdfdeec9399ede$var$currentEntangledPendingCount && null !== $b4fdfdeec9399ede$var$currentEntangledListeners) {
        null !== $b4fdfdeec9399ede$var$currentEntangledActionThenable && ($b4fdfdeec9399ede$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $b4fdfdeec9399ede$var$currentEntangledListeners;
        $b4fdfdeec9399ede$var$currentEntangledListeners = null;
        $b4fdfdeec9399ede$var$currentEntangledLane = 0;
        $b4fdfdeec9399ede$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $b4fdfdeec9399ede$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $b4fdfdeec9399ede$var$prevOnStartTransitionFinish = $b4fdfdeec9399ede$var$ReactSharedInternals.S;
$b4fdfdeec9399ede$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $b4fdfdeec9399ede$var$entangleAsyncAction(transition, returnValue);
    null !== $b4fdfdeec9399ede$var$prevOnStartTransitionFinish && $b4fdfdeec9399ede$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $b4fdfdeec9399ede$var$resumedCache = $b4fdfdeec9399ede$var$createCursor(null);
function $b4fdfdeec9399ede$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $b4fdfdeec9399ede$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $b4fdfdeec9399ede$var$workInProgressRoot.pooledCache;
}
function $b4fdfdeec9399ede$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$resumedCache, $b4fdfdeec9399ede$var$resumedCache.current) : $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$resumedCache, prevCachePool.pool);
}
function $b4fdfdeec9399ede$var$getSuspendedCache() {
    var cacheFromPool = $b4fdfdeec9399ede$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $b4fdfdeec9399ede$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $b4fdfdeec9399ede$var$SuspenseException = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(460)), $b4fdfdeec9399ede$var$SuspenseyCommitException = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(474)), $b4fdfdeec9399ede$var$SuspenseActionException = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(542)), $b4fdfdeec9399ede$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $b4fdfdeec9399ede$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $b4fdfdeec9399ede$var$noop$3() {}
function $b4fdfdeec9399ede$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($b4fdfdeec9399ede$var$noop$3, $b4fdfdeec9399ede$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $b4fdfdeec9399ede$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($b4fdfdeec9399ede$var$noop$3, $b4fdfdeec9399ede$var$noop$3);
            else {
                thenableState = $b4fdfdeec9399ede$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $b4fdfdeec9399ede$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $b4fdfdeec9399ede$var$suspendedThenable = thenable;
            throw $b4fdfdeec9399ede$var$SuspenseException;
    }
}
var $b4fdfdeec9399ede$var$suspendedThenable = null;
function $b4fdfdeec9399ede$var$getSuspendedThenable() {
    if (null === $b4fdfdeec9399ede$var$suspendedThenable) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(459));
    var thenable = $b4fdfdeec9399ede$var$suspendedThenable;
    $b4fdfdeec9399ede$var$suspendedThenable = null;
    return thenable;
}
function $b4fdfdeec9399ede$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $b4fdfdeec9399ede$var$SuspenseException || rejectedReason === $b4fdfdeec9399ede$var$SuspenseActionException) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(483));
}
var $b4fdfdeec9399ede$var$hasForceUpdate = !1;
function $b4fdfdeec9399ede$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $b4fdfdeec9399ede$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $b4fdfdeec9399ede$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b4fdfdeec9399ede$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($b4fdfdeec9399ede$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $b4fdfdeec9399ede$var$getRootForUpdatedFiber(fiber);
        $b4fdfdeec9399ede$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $b4fdfdeec9399ede$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $b4fdfdeec9399ede$var$getRootForUpdatedFiber(fiber);
}
function $b4fdfdeec9399ede$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $b4fdfdeec9399ede$var$markRootEntangled(root, lane);
    }
}
function $b4fdfdeec9399ede$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $b4fdfdeec9399ede$var$didReadFromEntangledAsyncAction = !1;
function $b4fdfdeec9399ede$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($b4fdfdeec9399ede$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $b4fdfdeec9399ede$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $b4fdfdeec9399ede$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $b4fdfdeec9399ede$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $b4fdfdeec9399ede$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $b4fdfdeec9399ede$var$currentEntangledLane && ($b4fdfdeec9399ede$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $b4fdfdeec9399ede$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $b4fdfdeec9399ede$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $b4fdfdeec9399ede$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $b4fdfdeec9399ede$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$b4fdfdeec9399ede$var$callCallback(callbacks[updateQueue], context);
}
var $b4fdfdeec9399ede$var$currentTreeHiddenStackCursor = $b4fdfdeec9399ede$var$createCursor(null), $b4fdfdeec9399ede$var$prevEntangledRenderLanesCursor = $b4fdfdeec9399ede$var$createCursor(0);
function $b4fdfdeec9399ede$var$pushHiddenContext(fiber, context) {
    fiber = $b4fdfdeec9399ede$var$entangledRenderLanes;
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$prevEntangledRenderLanesCursor, fiber);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$currentTreeHiddenStackCursor, context);
    $b4fdfdeec9399ede$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $b4fdfdeec9399ede$var$reuseHiddenContextOnStack() {
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$prevEntangledRenderLanesCursor, $b4fdfdeec9399ede$var$entangledRenderLanes);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$currentTreeHiddenStackCursor, $b4fdfdeec9399ede$var$currentTreeHiddenStackCursor.current);
}
function $b4fdfdeec9399ede$var$popHiddenContext() {
    $b4fdfdeec9399ede$var$entangledRenderLanes = $b4fdfdeec9399ede$var$prevEntangledRenderLanesCursor.current;
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$currentTreeHiddenStackCursor);
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$prevEntangledRenderLanesCursor);
}
var $b4fdfdeec9399ede$var$renderLanes = 0, $b4fdfdeec9399ede$var$currentlyRenderingFiber = null, $b4fdfdeec9399ede$var$currentHook = null, $b4fdfdeec9399ede$var$workInProgressHook = null, $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdate = !1, $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $b4fdfdeec9399ede$var$localIdCounter = 0, $b4fdfdeec9399ede$var$thenableIndexCounter$1 = 0, $b4fdfdeec9399ede$var$thenableState$1 = null, $b4fdfdeec9399ede$var$globalClientIdCounter = 0;
function $b4fdfdeec9399ede$var$throwInvalidHookError() {
    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(321));
}
function $b4fdfdeec9399ede$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$b4fdfdeec9399ede$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $b4fdfdeec9399ede$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $b4fdfdeec9399ede$var$renderLanes = nextRenderLanes;
    $b4fdfdeec9399ede$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $b4fdfdeec9399ede$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $b4fdfdeec9399ede$var$HooksDispatcherOnMount : $b4fdfdeec9399ede$var$HooksDispatcherOnUpdate;
    $b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $b4fdfdeec9399ede$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $b4fdfdeec9399ede$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $b4fdfdeec9399ede$var$finishRenderingHooks(current) {
    $b4fdfdeec9399ede$var$ReactSharedInternals.H = $b4fdfdeec9399ede$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $b4fdfdeec9399ede$var$currentHook && null !== $b4fdfdeec9399ede$var$currentHook.next;
    $b4fdfdeec9399ede$var$renderLanes = 0;
    $b4fdfdeec9399ede$var$workInProgressHook = $b4fdfdeec9399ede$var$currentHook = $b4fdfdeec9399ede$var$currentlyRenderingFiber = null;
    $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdate = !1;
    $b4fdfdeec9399ede$var$thenableIndexCounter$1 = 0;
    $b4fdfdeec9399ede$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(300));
    null === current || $b4fdfdeec9399ede$var$didReceiveUpdate || (current = current.dependencies, null !== current && $b4fdfdeec9399ede$var$checkIfContextChanged(current) && ($b4fdfdeec9399ede$var$didReceiveUpdate = !0));
}
function $b4fdfdeec9399ede$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $b4fdfdeec9399ede$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdateDuringThisPass && ($b4fdfdeec9399ede$var$thenableState$1 = null);
        $b4fdfdeec9399ede$var$thenableIndexCounter$1 = 0;
        $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $b4fdfdeec9399ede$var$workInProgressHook = $b4fdfdeec9399ede$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $b4fdfdeec9399ede$var$ReactSharedInternals.H = $b4fdfdeec9399ede$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $b4fdfdeec9399ede$var$TransitionAwareHostComponent() {
    var dispatcher = $b4fdfdeec9399ede$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $b4fdfdeec9399ede$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $b4fdfdeec9399ede$var$currentHook ? $b4fdfdeec9399ede$var$currentHook.memoizedState : null) !== dispatcher && ($b4fdfdeec9399ede$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $b4fdfdeec9399ede$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $b4fdfdeec9399ede$var$localIdCounter;
    $b4fdfdeec9399ede$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $b4fdfdeec9399ede$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $b4fdfdeec9399ede$var$resetHooksOnUnwind(workInProgress) {
    if ($b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdate = !1;
    }
    $b4fdfdeec9399ede$var$renderLanes = 0;
    $b4fdfdeec9399ede$var$workInProgressHook = $b4fdfdeec9399ede$var$currentHook = $b4fdfdeec9399ede$var$currentlyRenderingFiber = null;
    $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $b4fdfdeec9399ede$var$thenableIndexCounter$1 = $b4fdfdeec9399ede$var$localIdCounter = 0;
    $b4fdfdeec9399ede$var$thenableState$1 = null;
}
function $b4fdfdeec9399ede$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b4fdfdeec9399ede$var$workInProgressHook ? $b4fdfdeec9399ede$var$currentlyRenderingFiber.memoizedState = $b4fdfdeec9399ede$var$workInProgressHook = hook : $b4fdfdeec9399ede$var$workInProgressHook = $b4fdfdeec9399ede$var$workInProgressHook.next = hook;
    return $b4fdfdeec9399ede$var$workInProgressHook;
}
function $b4fdfdeec9399ede$var$updateWorkInProgressHook() {
    if (null === $b4fdfdeec9399ede$var$currentHook) {
        var nextCurrentHook = $b4fdfdeec9399ede$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $b4fdfdeec9399ede$var$currentHook.next;
    var nextWorkInProgressHook = null === $b4fdfdeec9399ede$var$workInProgressHook ? $b4fdfdeec9399ede$var$currentlyRenderingFiber.memoizedState : $b4fdfdeec9399ede$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $b4fdfdeec9399ede$var$workInProgressHook = nextWorkInProgressHook, $b4fdfdeec9399ede$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $b4fdfdeec9399ede$var$currentlyRenderingFiber.alternate) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(467));
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(310));
        }
        $b4fdfdeec9399ede$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $b4fdfdeec9399ede$var$currentHook.memoizedState,
            baseState: $b4fdfdeec9399ede$var$currentHook.baseState,
            baseQueue: $b4fdfdeec9399ede$var$currentHook.baseQueue,
            queue: $b4fdfdeec9399ede$var$currentHook.queue,
            next: null
        };
        null === $b4fdfdeec9399ede$var$workInProgressHook ? $b4fdfdeec9399ede$var$currentlyRenderingFiber.memoizedState = $b4fdfdeec9399ede$var$workInProgressHook = nextCurrentHook : $b4fdfdeec9399ede$var$workInProgressHook = $b4fdfdeec9399ede$var$workInProgressHook.next = nextCurrentHook;
    }
    return $b4fdfdeec9399ede$var$workInProgressHook;
}
function $b4fdfdeec9399ede$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $b4fdfdeec9399ede$var$useThenable(thenable) {
    var index = $b4fdfdeec9399ede$var$thenableIndexCounter$1;
    $b4fdfdeec9399ede$var$thenableIndexCounter$1 += 1;
    null === $b4fdfdeec9399ede$var$thenableState$1 && ($b4fdfdeec9399ede$var$thenableState$1 = []);
    thenable = $b4fdfdeec9399ede$var$trackUsedThenable($b4fdfdeec9399ede$var$thenableState$1, thenable, index);
    index = $b4fdfdeec9399ede$var$currentlyRenderingFiber;
    null === (null === $b4fdfdeec9399ede$var$workInProgressHook ? index.memoizedState : $b4fdfdeec9399ede$var$workInProgressHook.next) && (index = index.alternate, $b4fdfdeec9399ede$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $b4fdfdeec9399ede$var$HooksDispatcherOnMount : $b4fdfdeec9399ede$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $b4fdfdeec9399ede$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $b4fdfdeec9399ede$var$useThenable(usable);
        if (usable.$$typeof === $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE) return $b4fdfdeec9399ede$var$readContext(usable);
    }
    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(438, String(usable)));
}
function $b4fdfdeec9399ede$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $b4fdfdeec9399ede$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $b4fdfdeec9399ede$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $b4fdfdeec9399ede$var$createFunctionComponentUpdateQueue(), $b4fdfdeec9399ede$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $b4fdfdeec9399ede$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $b4fdfdeec9399ede$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $b4fdfdeec9399ede$var$updateReducer(reducer) {
    var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    return $b4fdfdeec9399ede$var$updateReducerImpl(hook, $b4fdfdeec9399ede$var$currentHook, reducer);
}
function $b4fdfdeec9399ede$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($b4fdfdeec9399ede$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $b4fdfdeec9399ede$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($b4fdfdeec9399ede$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $b4fdfdeec9399ede$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $b4fdfdeec9399ede$var$currentlyRenderingFiber.lanes |= revertLane, $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $b4fdfdeec9399ede$var$currentlyRenderingFiber.lanes |= updateLane, $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$b4fdfdeec9399ede$var$objectIs(pendingQueue, hook.memoizedState) && ($b4fdfdeec9399ede$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $b4fdfdeec9399ede$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $b4fdfdeec9399ede$var$rerenderReducer(reducer) {
    var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $b4fdfdeec9399ede$var$objectIs(newState, hook.memoizedState) || ($b4fdfdeec9399ede$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $b4fdfdeec9399ede$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $b4fdfdeec9399ede$var$currentlyRenderingFiber, hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $b4fdfdeec9399ede$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$b4fdfdeec9399ede$var$objectIs(($b4fdfdeec9399ede$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $b4fdfdeec9399ede$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $b4fdfdeec9399ede$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $b4fdfdeec9399ede$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $b4fdfdeec9399ede$var$workInProgressHook && $b4fdfdeec9399ede$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $b4fdfdeec9399ede$var$pushSimpleEffect(9, $b4fdfdeec9399ede$var$createEffectInstance(), $b4fdfdeec9399ede$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $b4fdfdeec9399ede$var$workInProgressRoot) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($b4fdfdeec9399ede$var$renderLanes & 124) || $b4fdfdeec9399ede$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $b4fdfdeec9399ede$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $b4fdfdeec9399ede$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $b4fdfdeec9399ede$var$createFunctionComponentUpdateQueue(), $b4fdfdeec9399ede$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $b4fdfdeec9399ede$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $b4fdfdeec9399ede$var$checkIfSnapshotChanged(inst) && $b4fdfdeec9399ede$var$forceStoreRerender(fiber);
}
function $b4fdfdeec9399ede$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $b4fdfdeec9399ede$var$checkIfSnapshotChanged(inst) && $b4fdfdeec9399ede$var$forceStoreRerender(fiber);
    });
}
function $b4fdfdeec9399ede$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$b4fdfdeec9399ede$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $b4fdfdeec9399ede$var$forceStoreRerender(fiber) {
    var root = $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $b4fdfdeec9399ede$var$mountStateImpl(initialState) {
    var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b4fdfdeec9399ede$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $b4fdfdeec9399ede$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $b4fdfdeec9399ede$var$updateReducerImpl(hook, $b4fdfdeec9399ede$var$currentHook, "function" === typeof reducer ? reducer : $b4fdfdeec9399ede$var$basicStateReducer);
}
function $b4fdfdeec9399ede$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($b4fdfdeec9399ede$var$isRenderPhaseUpdate(fiber)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $b4fdfdeec9399ede$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $b4fdfdeec9399ede$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $b4fdfdeec9399ede$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $b4fdfdeec9399ede$var$ReactSharedInternals.T, currentTransition = {};
        $b4fdfdeec9399ede$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $b4fdfdeec9399ede$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $b4fdfdeec9399ede$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $b4fdfdeec9399ede$var$onActionError(actionQueue, node, error);
        } finally{
            $b4fdfdeec9399ede$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $b4fdfdeec9399ede$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $b4fdfdeec9399ede$var$onActionError(actionQueue, node, error$38);
    }
}
function $b4fdfdeec9399ede$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $b4fdfdeec9399ede$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $b4fdfdeec9399ede$var$onActionError(actionQueue, node, error);
    }) : $b4fdfdeec9399ede$var$onActionSuccess(actionQueue, node, returnValue);
}
function $b4fdfdeec9399ede$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $b4fdfdeec9399ede$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $b4fdfdeec9399ede$var$runActionStateAction(actionQueue, nextState)));
}
function $b4fdfdeec9399ede$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $b4fdfdeec9399ede$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $b4fdfdeec9399ede$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $b4fdfdeec9399ede$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $b4fdfdeec9399ede$var$mountActionState(action, initialStateProp) {
    if ($b4fdfdeec9399ede$var$isHydrating) {
        var ssrFormState = $b4fdfdeec9399ede$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $b4fdfdeec9399ede$var$currentlyRenderingFiber;
                if ($b4fdfdeec9399ede$var$isHydrating) {
                    if ($b4fdfdeec9399ede$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $b4fdfdeec9399ede$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $b4fdfdeec9399ede$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $b4fdfdeec9399ede$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $b4fdfdeec9399ede$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b4fdfdeec9399ede$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $b4fdfdeec9399ede$var$dispatchSetState.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $b4fdfdeec9399ede$var$mountStateImpl(!1);
    inRootOrSingleton = $b4fdfdeec9399ede$var$dispatchOptimisticSetState.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $b4fdfdeec9399ede$var$dispatchActionState.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $b4fdfdeec9399ede$var$updateActionState(action) {
    var stateHook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    return $b4fdfdeec9399ede$var$updateActionStateImpl(stateHook, $b4fdfdeec9399ede$var$currentHook, action);
}
function $b4fdfdeec9399ede$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $b4fdfdeec9399ede$var$updateReducerImpl(stateHook, currentStateHook, $b4fdfdeec9399ede$var$actionStateReducer)[0];
    stateHook = $b4fdfdeec9399ede$var$updateReducer($b4fdfdeec9399ede$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $b4fdfdeec9399ede$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $b4fdfdeec9399ede$var$SuspenseException) throw $b4fdfdeec9399ede$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($b4fdfdeec9399ede$var$currentlyRenderingFiber.flags |= 2048, $b4fdfdeec9399ede$var$pushSimpleEffect(9, $b4fdfdeec9399ede$var$createEffectInstance(), $b4fdfdeec9399ede$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $b4fdfdeec9399ede$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $b4fdfdeec9399ede$var$rerenderActionState(action) {
    var stateHook = $b4fdfdeec9399ede$var$updateWorkInProgressHook(), currentStateHook = $b4fdfdeec9399ede$var$currentHook;
    if (null !== currentStateHook) return $b4fdfdeec9399ede$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $b4fdfdeec9399ede$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $b4fdfdeec9399ede$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $b4fdfdeec9399ede$var$createFunctionComponentUpdateQueue(), $b4fdfdeec9399ede$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $b4fdfdeec9399ede$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $b4fdfdeec9399ede$var$updateRef() {
    return $b4fdfdeec9399ede$var$updateWorkInProgressHook().memoizedState;
}
function $b4fdfdeec9399ede$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $b4fdfdeec9399ede$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $b4fdfdeec9399ede$var$pushSimpleEffect(1 | hookFlags, $b4fdfdeec9399ede$var$createEffectInstance(), create, createDeps);
}
function $b4fdfdeec9399ede$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $b4fdfdeec9399ede$var$currentHook && null !== deps && $b4fdfdeec9399ede$var$areHookInputsEqual(deps, $b4fdfdeec9399ede$var$currentHook.memoizedState.deps) ? hook.memoizedState = $b4fdfdeec9399ede$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($b4fdfdeec9399ede$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $b4fdfdeec9399ede$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $b4fdfdeec9399ede$var$mountEffect(create, createDeps) {
    $b4fdfdeec9399ede$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $b4fdfdeec9399ede$var$updateEffect(create, createDeps) {
    $b4fdfdeec9399ede$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $b4fdfdeec9399ede$var$updateInsertionEffect(create, deps) {
    return $b4fdfdeec9399ede$var$updateEffectImpl(4, 2, create, deps);
}
function $b4fdfdeec9399ede$var$updateLayoutEffect(create, deps) {
    return $b4fdfdeec9399ede$var$updateEffectImpl(4, 4, create, deps);
}
function $b4fdfdeec9399ede$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $b4fdfdeec9399ede$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $b4fdfdeec9399ede$var$updateEffectImpl(4, 4, $b4fdfdeec9399ede$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $b4fdfdeec9399ede$var$mountDebugValue() {}
function $b4fdfdeec9399ede$var$updateCallback(callback, deps) {
    var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b4fdfdeec9399ede$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $b4fdfdeec9399ede$var$updateMemo(nextCreate, deps) {
    var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b4fdfdeec9399ede$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $b4fdfdeec9399ede$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($b4fdfdeec9399ede$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $b4fdfdeec9399ede$var$requestDeferredLane();
    $b4fdfdeec9399ede$var$currentlyRenderingFiber.lanes |= hook;
    $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $b4fdfdeec9399ede$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($b4fdfdeec9399ede$var$objectIs(value, prevValue)) return value;
    if (null !== $b4fdfdeec9399ede$var$currentTreeHiddenStackCursor.current) return hook = $b4fdfdeec9399ede$var$mountDeferredValueImpl(hook, value, initialValue), $b4fdfdeec9399ede$var$objectIs(hook, prevValue) || ($b4fdfdeec9399ede$var$didReceiveUpdate = !0), hook;
    if (0 === ($b4fdfdeec9399ede$var$renderLanes & 42)) return $b4fdfdeec9399ede$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $b4fdfdeec9399ede$var$requestDeferredLane();
    $b4fdfdeec9399ede$var$currentlyRenderingFiber.lanes |= hook;
    $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $b4fdfdeec9399ede$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
    $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $b4fdfdeec9399ede$var$ReactSharedInternals.T, currentTransition = {};
    $b4fdfdeec9399ede$var$ReactSharedInternals.T = currentTransition;
    $b4fdfdeec9399ede$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $b4fdfdeec9399ede$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $b4fdfdeec9399ede$var$chainThenableValue(returnValue, finishedState);
            $b4fdfdeec9399ede$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $b4fdfdeec9399ede$var$requestUpdateLane(fiber));
        } else $b4fdfdeec9399ede$var$dispatchSetStateInternal(fiber, queue, finishedState, $b4fdfdeec9399ede$var$requestUpdateLane(fiber));
    } catch (error) {
        $b4fdfdeec9399ede$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $b4fdfdeec9399ede$var$requestUpdateLane());
    } finally{
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = previousPriority, $b4fdfdeec9399ede$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b4fdfdeec9399ede$var$noop$2() {}
function $b4fdfdeec9399ede$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(476));
    var queue = $b4fdfdeec9399ede$var$ensureFormComponentIsStateful(formFiber).queue;
    $b4fdfdeec9399ede$var$startTransition(formFiber, queue, pendingState, $b4fdfdeec9399ede$var$sharedNotPendingObject, null === action ? $b4fdfdeec9399ede$var$noop$2 : function() {
        $b4fdfdeec9399ede$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $b4fdfdeec9399ede$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $b4fdfdeec9399ede$var$sharedNotPendingObject,
        baseState: $b4fdfdeec9399ede$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b4fdfdeec9399ede$var$basicStateReducer,
            lastRenderedState: $b4fdfdeec9399ede$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b4fdfdeec9399ede$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $b4fdfdeec9399ede$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $b4fdfdeec9399ede$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $b4fdfdeec9399ede$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $b4fdfdeec9399ede$var$requestUpdateLane());
}
function $b4fdfdeec9399ede$var$useHostTransitionStatus() {
    return $b4fdfdeec9399ede$var$readContext($b4fdfdeec9399ede$var$HostTransitionContext);
}
function $b4fdfdeec9399ede$var$updateId() {
    return $b4fdfdeec9399ede$var$updateWorkInProgressHook().memoizedState;
}
function $b4fdfdeec9399ede$var$updateRefresh() {
    return $b4fdfdeec9399ede$var$updateWorkInProgressHook().memoizedState;
}
function $b4fdfdeec9399ede$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $b4fdfdeec9399ede$var$requestUpdateLane();
                fiber = $b4fdfdeec9399ede$var$createUpdate(lane);
                var root$41 = $b4fdfdeec9399ede$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($b4fdfdeec9399ede$var$scheduleUpdateOnFiber(root$41, provider, lane), $b4fdfdeec9399ede$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $b4fdfdeec9399ede$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $b4fdfdeec9399ede$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $b4fdfdeec9399ede$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $b4fdfdeec9399ede$var$isRenderPhaseUpdate(fiber) ? $b4fdfdeec9399ede$var$enqueueRenderPhaseUpdate(queue, action) : (action = $b4fdfdeec9399ede$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($b4fdfdeec9399ede$var$scheduleUpdateOnFiber(action, fiber, lane), $b4fdfdeec9399ede$var$entangleTransitionUpdate(action, queue, lane)));
}
function $b4fdfdeec9399ede$var$dispatchSetState(fiber, queue, action) {
    var lane = $b4fdfdeec9399ede$var$requestUpdateLane();
    $b4fdfdeec9399ede$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $b4fdfdeec9399ede$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b4fdfdeec9399ede$var$isRenderPhaseUpdate(fiber)) $b4fdfdeec9399ede$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($b4fdfdeec9399ede$var$objectIs(eagerState, currentState)) return $b4fdfdeec9399ede$var$enqueueUpdate$1(fiber, queue, update, 0), null === $b4fdfdeec9399ede$var$workInProgressRoot && $b4fdfdeec9399ede$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $b4fdfdeec9399ede$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(action, fiber, lane), $b4fdfdeec9399ede$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $b4fdfdeec9399ede$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $b4fdfdeec9399ede$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b4fdfdeec9399ede$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $b4fdfdeec9399ede$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $b4fdfdeec9399ede$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $b4fdfdeec9399ede$var$currentlyRenderingFiber || null !== alternate && alternate === $b4fdfdeec9399ede$var$currentlyRenderingFiber;
}
function $b4fdfdeec9399ede$var$enqueueRenderPhaseUpdate(queue, update) {
    $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdateDuringThisPass = $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $b4fdfdeec9399ede$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $b4fdfdeec9399ede$var$markRootEntangled(root, lane);
    }
}
var $b4fdfdeec9399ede$var$ContextOnlyDispatcher = {
    readContext: $b4fdfdeec9399ede$var$readContext,
    use: $b4fdfdeec9399ede$var$use,
    useCallback: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useContext: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useEffect: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useImperativeHandle: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useLayoutEffect: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useInsertionEffect: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useMemo: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useReducer: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useRef: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useState: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useDebugValue: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useDeferredValue: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useTransition: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useSyncExternalStore: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useId: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useHostTransitionStatus: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useFormState: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useActionState: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useOptimistic: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useMemoCache: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useCacheRefresh: $b4fdfdeec9399ede$var$throwInvalidHookError
}, $b4fdfdeec9399ede$var$HooksDispatcherOnMount = {
    readContext: $b4fdfdeec9399ede$var$readContext,
    use: $b4fdfdeec9399ede$var$use,
    useCallback: function(callback, deps) {
        $b4fdfdeec9399ede$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $b4fdfdeec9399ede$var$readContext,
    useEffect: $b4fdfdeec9399ede$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $b4fdfdeec9399ede$var$mountEffectImpl(4194308, 4, $b4fdfdeec9399ede$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $b4fdfdeec9399ede$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $b4fdfdeec9399ede$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $b4fdfdeec9399ede$var$dispatchReducerAction.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $b4fdfdeec9399ede$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $b4fdfdeec9399ede$var$dispatchSetState.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $b4fdfdeec9399ede$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
        return $b4fdfdeec9399ede$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $b4fdfdeec9399ede$var$mountStateImpl(!1);
        stateHook = $b4fdfdeec9399ede$var$startTransition.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $b4fdfdeec9399ede$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $b4fdfdeec9399ede$var$currentlyRenderingFiber, hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
        if ($b4fdfdeec9399ede$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $b4fdfdeec9399ede$var$workInProgressRoot) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(349));
            0 !== ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 124) || $b4fdfdeec9399ede$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $b4fdfdeec9399ede$var$mountEffect($b4fdfdeec9399ede$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $b4fdfdeec9399ede$var$pushSimpleEffect(9, $b4fdfdeec9399ede$var$createEffectInstance(), $b4fdfdeec9399ede$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook(), identifierPrefix = $b4fdfdeec9399ede$var$workInProgressRoot.identifierPrefix;
        if ($b4fdfdeec9399ede$var$isHydrating) {
            var JSCompiler_inline_result = $b4fdfdeec9399ede$var$treeContextOverflow;
            var idWithLeadingBit = $b4fdfdeec9399ede$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $b4fdfdeec9399ede$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $b4fdfdeec9399ede$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $b4fdfdeec9399ede$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $b4fdfdeec9399ede$var$useHostTransitionStatus,
    useFormState: $b4fdfdeec9399ede$var$mountActionState,
    useActionState: $b4fdfdeec9399ede$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $b4fdfdeec9399ede$var$dispatchOptimisticSetState.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $b4fdfdeec9399ede$var$useMemoCache,
    useCacheRefresh: function() {
        return $b4fdfdeec9399ede$var$mountWorkInProgressHook().memoizedState = $b4fdfdeec9399ede$var$refreshCache.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber);
    }
}, $b4fdfdeec9399ede$var$HooksDispatcherOnUpdate = {
    readContext: $b4fdfdeec9399ede$var$readContext,
    use: $b4fdfdeec9399ede$var$use,
    useCallback: $b4fdfdeec9399ede$var$updateCallback,
    useContext: $b4fdfdeec9399ede$var$readContext,
    useEffect: $b4fdfdeec9399ede$var$updateEffect,
    useImperativeHandle: $b4fdfdeec9399ede$var$updateImperativeHandle,
    useInsertionEffect: $b4fdfdeec9399ede$var$updateInsertionEffect,
    useLayoutEffect: $b4fdfdeec9399ede$var$updateLayoutEffect,
    useMemo: $b4fdfdeec9399ede$var$updateMemo,
    useReducer: $b4fdfdeec9399ede$var$updateReducer,
    useRef: $b4fdfdeec9399ede$var$updateRef,
    useState: function() {
        return $b4fdfdeec9399ede$var$updateReducer($b4fdfdeec9399ede$var$basicStateReducer);
    },
    useDebugValue: $b4fdfdeec9399ede$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
        return $b4fdfdeec9399ede$var$updateDeferredValueImpl(hook, $b4fdfdeec9399ede$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b4fdfdeec9399ede$var$updateReducer($b4fdfdeec9399ede$var$basicStateReducer)[0], start = $b4fdfdeec9399ede$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b4fdfdeec9399ede$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b4fdfdeec9399ede$var$updateSyncExternalStore,
    useId: $b4fdfdeec9399ede$var$updateId,
    useHostTransitionStatus: $b4fdfdeec9399ede$var$useHostTransitionStatus,
    useFormState: $b4fdfdeec9399ede$var$updateActionState,
    useActionState: $b4fdfdeec9399ede$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
        return $b4fdfdeec9399ede$var$updateOptimisticImpl(hook, $b4fdfdeec9399ede$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $b4fdfdeec9399ede$var$useMemoCache,
    useCacheRefresh: $b4fdfdeec9399ede$var$updateRefresh
}, $b4fdfdeec9399ede$var$HooksDispatcherOnRerender = {
    readContext: $b4fdfdeec9399ede$var$readContext,
    use: $b4fdfdeec9399ede$var$use,
    useCallback: $b4fdfdeec9399ede$var$updateCallback,
    useContext: $b4fdfdeec9399ede$var$readContext,
    useEffect: $b4fdfdeec9399ede$var$updateEffect,
    useImperativeHandle: $b4fdfdeec9399ede$var$updateImperativeHandle,
    useInsertionEffect: $b4fdfdeec9399ede$var$updateInsertionEffect,
    useLayoutEffect: $b4fdfdeec9399ede$var$updateLayoutEffect,
    useMemo: $b4fdfdeec9399ede$var$updateMemo,
    useReducer: $b4fdfdeec9399ede$var$rerenderReducer,
    useRef: $b4fdfdeec9399ede$var$updateRef,
    useState: function() {
        return $b4fdfdeec9399ede$var$rerenderReducer($b4fdfdeec9399ede$var$basicStateReducer);
    },
    useDebugValue: $b4fdfdeec9399ede$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
        return null === $b4fdfdeec9399ede$var$currentHook ? $b4fdfdeec9399ede$var$mountDeferredValueImpl(hook, value, initialValue) : $b4fdfdeec9399ede$var$updateDeferredValueImpl(hook, $b4fdfdeec9399ede$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b4fdfdeec9399ede$var$rerenderReducer($b4fdfdeec9399ede$var$basicStateReducer)[0], start = $b4fdfdeec9399ede$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b4fdfdeec9399ede$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b4fdfdeec9399ede$var$updateSyncExternalStore,
    useId: $b4fdfdeec9399ede$var$updateId,
    useHostTransitionStatus: $b4fdfdeec9399ede$var$useHostTransitionStatus,
    useFormState: $b4fdfdeec9399ede$var$rerenderActionState,
    useActionState: $b4fdfdeec9399ede$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
        if (null !== $b4fdfdeec9399ede$var$currentHook) return $b4fdfdeec9399ede$var$updateOptimisticImpl(hook, $b4fdfdeec9399ede$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $b4fdfdeec9399ede$var$useMemoCache,
    useCacheRefresh: $b4fdfdeec9399ede$var$updateRefresh
}, $b4fdfdeec9399ede$var$thenableState = null, $b4fdfdeec9399ede$var$thenableIndexCounter = 0;
function $b4fdfdeec9399ede$var$unwrapThenable(thenable) {
    var index = $b4fdfdeec9399ede$var$thenableIndexCounter;
    $b4fdfdeec9399ede$var$thenableIndexCounter += 1;
    null === $b4fdfdeec9399ede$var$thenableState && ($b4fdfdeec9399ede$var$thenableState = []);
    return $b4fdfdeec9399ede$var$trackUsedThenable($b4fdfdeec9399ede$var$thenableState, thenable, index);
}
function $b4fdfdeec9399ede$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $b4fdfdeec9399ede$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $b4fdfdeec9399ede$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $b4fdfdeec9399ede$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $b4fdfdeec9399ede$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $b4fdfdeec9399ede$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $b4fdfdeec9399ede$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $b4fdfdeec9399ede$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $b4fdfdeec9399ede$var$REACT_LAZY_TYPE && $b4fdfdeec9399ede$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $b4fdfdeec9399ede$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $b4fdfdeec9399ede$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $b4fdfdeec9399ede$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $b4fdfdeec9399ede$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $b4fdfdeec9399ede$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $b4fdfdeec9399ede$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b4fdfdeec9399ede$var$REACT_ELEMENT_TYPE:
                    return lanes = $b4fdfdeec9399ede$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b4fdfdeec9399ede$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $b4fdfdeec9399ede$var$REACT_PORTAL_TYPE:
                    return newChild = $b4fdfdeec9399ede$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $b4fdfdeec9399ede$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($b4fdfdeec9399ede$var$isArrayImpl(newChild) || $b4fdfdeec9399ede$var$getIteratorFn(newChild)) return newChild = $b4fdfdeec9399ede$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $b4fdfdeec9399ede$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $b4fdfdeec9399ede$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b4fdfdeec9399ede$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b4fdfdeec9399ede$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $b4fdfdeec9399ede$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $b4fdfdeec9399ede$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($b4fdfdeec9399ede$var$isArrayImpl(newChild) || $b4fdfdeec9399ede$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $b4fdfdeec9399ede$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $b4fdfdeec9399ede$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b4fdfdeec9399ede$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b4fdfdeec9399ede$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $b4fdfdeec9399ede$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $b4fdfdeec9399ede$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($b4fdfdeec9399ede$var$isArrayImpl(newChild) || $b4fdfdeec9399ede$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $b4fdfdeec9399ede$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $b4fdfdeec9399ede$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b4fdfdeec9399ede$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $b4fdfdeec9399ede$var$isHydrating && $b4fdfdeec9399ede$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $b4fdfdeec9399ede$var$isHydrating && $b4fdfdeec9399ede$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b4fdfdeec9399ede$var$isHydrating && $b4fdfdeec9399ede$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $b4fdfdeec9399ede$var$isHydrating && $b4fdfdeec9399ede$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $b4fdfdeec9399ede$var$isHydrating && $b4fdfdeec9399ede$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b4fdfdeec9399ede$var$isHydrating && $b4fdfdeec9399ede$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $b4fdfdeec9399ede$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b4fdfdeec9399ede$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $b4fdfdeec9399ede$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $b4fdfdeec9399ede$var$REACT_LAZY_TYPE && $b4fdfdeec9399ede$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $b4fdfdeec9399ede$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $b4fdfdeec9399ede$var$REACT_FRAGMENT_TYPE ? (lanes = $b4fdfdeec9399ede$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $b4fdfdeec9399ede$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b4fdfdeec9399ede$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $b4fdfdeec9399ede$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $b4fdfdeec9399ede$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $b4fdfdeec9399ede$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($b4fdfdeec9399ede$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($b4fdfdeec9399ede$var$getIteratorFn(newChild)) {
                key = $b4fdfdeec9399ede$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b4fdfdeec9399ede$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b4fdfdeec9399ede$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b4fdfdeec9399ede$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $b4fdfdeec9399ede$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $b4fdfdeec9399ede$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $b4fdfdeec9399ede$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $b4fdfdeec9399ede$var$SuspenseException || x === $b4fdfdeec9399ede$var$SuspenseActionException) throw x;
            var fiber = $b4fdfdeec9399ede$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $b4fdfdeec9399ede$var$reconcileChildFibers = $b4fdfdeec9399ede$var$createChildReconciler(!0), $b4fdfdeec9399ede$var$mountChildFibers = $b4fdfdeec9399ede$var$createChildReconciler(!1), $b4fdfdeec9399ede$var$suspenseHandlerStackCursor = $b4fdfdeec9399ede$var$createCursor(null), $b4fdfdeec9399ede$var$shellBoundary = null;
function $b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, $b4fdfdeec9399ede$var$suspenseStackCursor.current & 1);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseHandlerStackCursor, handler);
    null === $b4fdfdeec9399ede$var$shellBoundary && (null === current || null !== $b4fdfdeec9399ede$var$currentTreeHiddenStackCursor.current ? $b4fdfdeec9399ede$var$shellBoundary = handler : null !== current.memoizedState && ($b4fdfdeec9399ede$var$shellBoundary = handler));
}
function $b4fdfdeec9399ede$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, $b4fdfdeec9399ede$var$suspenseStackCursor.current), $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseHandlerStackCursor, fiber), null === $b4fdfdeec9399ede$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($b4fdfdeec9399ede$var$shellBoundary = fiber);
        }
    } else $b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(fiber);
}
function $b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack() {
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, $b4fdfdeec9399ede$var$suspenseStackCursor.current);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseHandlerStackCursor, $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current);
}
function $b4fdfdeec9399ede$var$popSuspenseHandler(fiber) {
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$suspenseHandlerStackCursor);
    $b4fdfdeec9399ede$var$shellBoundary === fiber && ($b4fdfdeec9399ede$var$shellBoundary = null);
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$suspenseStackCursor);
}
var $b4fdfdeec9399ede$var$suspenseStackCursor = $b4fdfdeec9399ede$var$createCursor(0);
function $b4fdfdeec9399ede$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $b4fdfdeec9399ede$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $b4fdfdeec9399ede$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $b4fdfdeec9399ede$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $b4fdfdeec9399ede$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b4fdfdeec9399ede$var$requestUpdateLane(), update = $b4fdfdeec9399ede$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b4fdfdeec9399ede$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b4fdfdeec9399ede$var$scheduleUpdateOnFiber(payload, inst, lane), $b4fdfdeec9399ede$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b4fdfdeec9399ede$var$requestUpdateLane(), update = $b4fdfdeec9399ede$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b4fdfdeec9399ede$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b4fdfdeec9399ede$var$scheduleUpdateOnFiber(payload, inst, lane), $b4fdfdeec9399ede$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $b4fdfdeec9399ede$var$requestUpdateLane(), update = $b4fdfdeec9399ede$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $b4fdfdeec9399ede$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($b4fdfdeec9399ede$var$scheduleUpdateOnFiber(callback, inst, lane), $b4fdfdeec9399ede$var$entangleTransitions(callback, inst, lane));
    }
};
function $b4fdfdeec9399ede$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$b4fdfdeec9399ede$var$shallowEqual(oldProps, newProps) || !$b4fdfdeec9399ede$var$shallowEqual(oldState, newState) : !0;
}
function $b4fdfdeec9399ede$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $b4fdfdeec9399ede$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $b4fdfdeec9399ede$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $b4fdfdeec9399ede$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $b4fdfdeec9399ede$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $a8i8g && "function" === typeof $a8i8g.emit) {
        $a8i8g.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $b4fdfdeec9399ede$var$defaultOnUncaughtError(error) {
    $b4fdfdeec9399ede$var$reportGlobalError(error);
}
function $b4fdfdeec9399ede$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $b4fdfdeec9399ede$var$defaultOnRecoverableError(error) {
    $b4fdfdeec9399ede$var$reportGlobalError(error);
}
function $b4fdfdeec9399ede$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $b4fdfdeec9399ede$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $b4fdfdeec9399ede$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $b4fdfdeec9399ede$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $b4fdfdeec9399ede$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $b4fdfdeec9399ede$var$createClassErrorUpdate(lane) {
    lane = $b4fdfdeec9399ede$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $b4fdfdeec9399ede$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $b4fdfdeec9399ede$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $b4fdfdeec9399ede$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed ? $b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $b4fdfdeec9399ede$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $b4fdfdeec9399ede$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $b4fdfdeec9399ede$var$shellBoundary ? $b4fdfdeec9399ede$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $b4fdfdeec9399ede$var$workInProgressRootExitStatus && ($b4fdfdeec9399ede$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $b4fdfdeec9399ede$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $b4fdfdeec9399ede$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $b4fdfdeec9399ede$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $b4fdfdeec9399ede$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $b4fdfdeec9399ede$var$attachPingListener(root, value, rootRenderLanes);
        $b4fdfdeec9399ede$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($b4fdfdeec9399ede$var$isHydrating) return returnFiber = $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $b4fdfdeec9399ede$var$HydrationMismatchException && (root = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(422), {
        cause: value
    }), $b4fdfdeec9399ede$var$queueHydrationError($b4fdfdeec9399ede$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $b4fdfdeec9399ede$var$HydrationMismatchException && (returnFiber = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(423), {
        cause: value
    }), $b4fdfdeec9399ede$var$queueHydrationError($b4fdfdeec9399ede$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $b4fdfdeec9399ede$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $b4fdfdeec9399ede$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $b4fdfdeec9399ede$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $b4fdfdeec9399ede$var$workInProgressRootExitStatus && ($b4fdfdeec9399ede$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $b4fdfdeec9399ede$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $b4fdfdeec9399ede$var$workInProgressRootConcurrentErrors ? $b4fdfdeec9399ede$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $b4fdfdeec9399ede$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $b4fdfdeec9399ede$var$workInProgressRootExitStatus && ($b4fdfdeec9399ede$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $b4fdfdeec9399ede$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $b4fdfdeec9399ede$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $b4fdfdeec9399ede$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed || !$b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $b4fdfdeec9399ede$var$createClassErrorUpdate(rootRenderLanes), $b4fdfdeec9399ede$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $b4fdfdeec9399ede$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $b4fdfdeec9399ede$var$SelectiveHydrationException = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(461)), $b4fdfdeec9399ede$var$didReceiveUpdate = !1;
function $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $b4fdfdeec9399ede$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $b4fdfdeec9399ede$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $b4fdfdeec9399ede$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $b4fdfdeec9399ede$var$prepareToReadContext(workInProgress);
    nextProps = $b4fdfdeec9399ede$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $b4fdfdeec9399ede$var$checkDidRenderIdHook();
    if (null !== current && !$b4fdfdeec9399ede$var$didReceiveUpdate) return $b4fdfdeec9399ede$var$bailoutHooks(current, workInProgress, renderLanes), $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b4fdfdeec9399ede$var$isHydrating && key && $b4fdfdeec9399ede$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b4fdfdeec9399ede$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$b4fdfdeec9399ede$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $b4fdfdeec9399ede$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $b4fdfdeec9399ede$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$b4fdfdeec9399ede$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $b4fdfdeec9399ede$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $b4fdfdeec9399ede$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $b4fdfdeec9399ede$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($b4fdfdeec9399ede$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($b4fdfdeec9399ede$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $b4fdfdeec9399ede$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($b4fdfdeec9399ede$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $b4fdfdeec9399ede$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $b4fdfdeec9399ede$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $b4fdfdeec9399ede$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $b4fdfdeec9399ede$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $b4fdfdeec9399ede$var$pushHiddenContext(workInProgress, prevState) : $b4fdfdeec9399ede$var$reuseHiddenContextOnStack(), $b4fdfdeec9399ede$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $b4fdfdeec9399ede$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($b4fdfdeec9399ede$var$pushTransition(workInProgress, prevState.cachePool), $b4fdfdeec9399ede$var$pushHiddenContext(workInProgress, prevState), $b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $b4fdfdeec9399ede$var$pushTransition(workInProgress, null), $b4fdfdeec9399ede$var$reuseHiddenContextOnStack(), $b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(workInProgress));
    $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $b4fdfdeec9399ede$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $b4fdfdeec9399ede$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $b4fdfdeec9399ede$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $b4fdfdeec9399ede$var$pushTransition(workInProgress, null);
    $b4fdfdeec9399ede$var$reuseHiddenContextOnStack();
    $b4fdfdeec9399ede$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $b4fdfdeec9399ede$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $b4fdfdeec9399ede$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $b4fdfdeec9399ede$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b4fdfdeec9399ede$var$prepareToReadContext(workInProgress);
    Component = $b4fdfdeec9399ede$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $b4fdfdeec9399ede$var$checkDidRenderIdHook();
    if (null !== current && !$b4fdfdeec9399ede$var$didReceiveUpdate) return $b4fdfdeec9399ede$var$bailoutHooks(current, workInProgress, renderLanes), $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b4fdfdeec9399ede$var$isHydrating && nextProps && $b4fdfdeec9399ede$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $b4fdfdeec9399ede$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $b4fdfdeec9399ede$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $b4fdfdeec9399ede$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $b4fdfdeec9399ede$var$finishRenderingHooks(current);
    Component = $b4fdfdeec9399ede$var$checkDidRenderIdHook();
    if (null !== current && !$b4fdfdeec9399ede$var$didReceiveUpdate) return $b4fdfdeec9399ede$var$bailoutHooks(current, workInProgress, renderLanes), $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b4fdfdeec9399ede$var$isHydrating && Component && $b4fdfdeec9399ede$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b4fdfdeec9399ede$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b4fdfdeec9399ede$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $b4fdfdeec9399ede$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $b4fdfdeec9399ede$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $b4fdfdeec9399ede$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $b4fdfdeec9399ede$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $b4fdfdeec9399ede$var$readContext(contextType) : $b4fdfdeec9399ede$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($b4fdfdeec9399ede$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $b4fdfdeec9399ede$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $b4fdfdeec9399ede$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $b4fdfdeec9399ede$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $b4fdfdeec9399ede$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $b4fdfdeec9399ede$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $b4fdfdeec9399ede$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $b4fdfdeec9399ede$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $b4fdfdeec9399ede$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b4fdfdeec9399ede$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b4fdfdeec9399ede$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $b4fdfdeec9399ede$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($b4fdfdeec9399ede$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $b4fdfdeec9399ede$var$hasForceUpdate || $b4fdfdeec9399ede$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $b4fdfdeec9399ede$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $b4fdfdeec9399ede$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $b4fdfdeec9399ede$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $b4fdfdeec9399ede$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $b4fdfdeec9399ede$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $b4fdfdeec9399ede$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b4fdfdeec9399ede$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b4fdfdeec9399ede$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $b4fdfdeec9399ede$var$hasForceUpdate || null !== current && null !== current.dependencies && $b4fdfdeec9399ede$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($b4fdfdeec9399ede$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $b4fdfdeec9399ede$var$hasForceUpdate || $b4fdfdeec9399ede$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $b4fdfdeec9399ede$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $b4fdfdeec9399ede$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $b4fdfdeec9399ede$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $b4fdfdeec9399ede$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $b4fdfdeec9399ede$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $b4fdfdeec9399ede$var$resetHydrationState();
    workInProgress.flags |= 256;
    $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $b4fdfdeec9399ede$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $b4fdfdeec9399ede$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $b4fdfdeec9399ede$var$getSuspendedCache()
    };
}
function $b4fdfdeec9399ede$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $b4fdfdeec9399ede$var$workInProgressDeferredLane);
    return current;
}
function $b4fdfdeec9399ede$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($b4fdfdeec9399ede$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($b4fdfdeec9399ede$var$isHydrating) {
            showFallback ? $b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($b4fdfdeec9399ede$var$isHydrating) {
                var nextInstance = $b4fdfdeec9399ede$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $b4fdfdeec9399ede$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $b4fdfdeec9399ede$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $b4fdfdeec9399ede$var$treeContextProvider ? {
                            id: $b4fdfdeec9399ede$var$treeContextId,
                            overflow: $b4fdfdeec9399ede$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $b4fdfdeec9399ede$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $b4fdfdeec9399ede$var$hydrationParentFiber = workInProgress, $b4fdfdeec9399ede$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $b4fdfdeec9399ede$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $b4fdfdeec9399ede$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $b4fdfdeec9399ede$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $b4fdfdeec9399ede$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $b4fdfdeec9399ede$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $b4fdfdeec9399ede$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b4fdfdeec9399ede$var$SUSPENDED_MARKER, nextProps;
        $b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $b4fdfdeec9399ede$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $b4fdfdeec9399ede$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $b4fdfdeec9399ede$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $b4fdfdeec9399ede$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $b4fdfdeec9399ede$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $b4fdfdeec9399ede$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $b4fdfdeec9399ede$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b4fdfdeec9399ede$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress), $b4fdfdeec9399ede$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $b4fdfdeec9399ede$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $b4fdfdeec9399ede$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($b4fdfdeec9399ede$var$didReceiveUpdate || $b4fdfdeec9399ede$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $b4fdfdeec9399ede$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $b4fdfdeec9399ede$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $b4fdfdeec9399ede$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(current, nextProps), $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $b4fdfdeec9399ede$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $b4fdfdeec9399ede$var$renderDidSuspendDelayIfPossible();
            workInProgress = $b4fdfdeec9399ede$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$getNextHydratable(nextInstance.nextSibling), $b4fdfdeec9399ede$var$hydrationParentFiber = workInProgress, $b4fdfdeec9399ede$var$isHydrating = !0, $b4fdfdeec9399ede$var$hydrationErrors = null, $b4fdfdeec9399ede$var$rootOrSingletonContext = !1, null !== current && ($b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex++] = $b4fdfdeec9399ede$var$treeContextId, $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex++] = $b4fdfdeec9399ede$var$treeContextOverflow, $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex++] = $b4fdfdeec9399ede$var$treeContextProvider, $b4fdfdeec9399ede$var$treeContextId = current.id, $b4fdfdeec9399ede$var$treeContextOverflow = current.overflow, $b4fdfdeec9399ede$var$treeContextProvider = workInProgress), workInProgress = $b4fdfdeec9399ede$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $b4fdfdeec9399ede$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $b4fdfdeec9399ede$var$createWorkInProgress(digest, showFallback) : (showFallback = $b4fdfdeec9399ede$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $b4fdfdeec9399ede$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $b4fdfdeec9399ede$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $b4fdfdeec9399ede$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $b4fdfdeec9399ede$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b4fdfdeec9399ede$var$SUSPENDED_MARKER, nextProps;
    $b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $b4fdfdeec9399ede$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $b4fdfdeec9399ede$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $b4fdfdeec9399ede$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $b4fdfdeec9399ede$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $b4fdfdeec9399ede$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $b4fdfdeec9399ede$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $b4fdfdeec9399ede$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $b4fdfdeec9399ede$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $b4fdfdeec9399ede$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $b4fdfdeec9399ede$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $b4fdfdeec9399ede$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $b4fdfdeec9399ede$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $b4fdfdeec9399ede$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $b4fdfdeec9399ede$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $b4fdfdeec9399ede$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $b4fdfdeec9399ede$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $b4fdfdeec9399ede$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $b4fdfdeec9399ede$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $b4fdfdeec9399ede$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $b4fdfdeec9399ede$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($b4fdfdeec9399ede$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $b4fdfdeec9399ede$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $b4fdfdeec9399ede$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $b4fdfdeec9399ede$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $b4fdfdeec9399ede$var$checkIfContextChanged(current) ? !0 : !1;
}
function $b4fdfdeec9399ede$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $b4fdfdeec9399ede$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $b4fdfdeec9399ede$var$pushProvider(workInProgress, $b4fdfdeec9399ede$var$CacheContext, current.memoizedState.cache);
            $b4fdfdeec9399ede$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $b4fdfdeec9399ede$var$pushHostContext(workInProgress);
            break;
        case 4:
            $b4fdfdeec9399ede$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $b4fdfdeec9399ede$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $b4fdfdeec9399ede$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($b4fdfdeec9399ede$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $b4fdfdeec9399ede$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, $b4fdfdeec9399ede$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $b4fdfdeec9399ede$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $b4fdfdeec9399ede$var$pushProvider(workInProgress, $b4fdfdeec9399ede$var$CacheContext, current.memoizedState.cache);
    }
    return $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $b4fdfdeec9399ede$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $b4fdfdeec9399ede$var$didReceiveUpdate = !0;
        else {
            if (!$b4fdfdeec9399ede$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $b4fdfdeec9399ede$var$didReceiveUpdate = !1, $b4fdfdeec9399ede$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $b4fdfdeec9399ede$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $b4fdfdeec9399ede$var$didReceiveUpdate = !1, $b4fdfdeec9399ede$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $b4fdfdeec9399ede$var$pushTreeId(workInProgress, $b4fdfdeec9399ede$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $b4fdfdeec9399ede$var$shouldConstruct(lazyComponent) ? (current = $b4fdfdeec9399ede$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $b4fdfdeec9399ede$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $b4fdfdeec9399ede$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $b4fdfdeec9399ede$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $b4fdfdeec9399ede$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $b4fdfdeec9399ede$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $b4fdfdeec9399ede$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $b4fdfdeec9399ede$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $b4fdfdeec9399ede$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $b4fdfdeec9399ede$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $b4fdfdeec9399ede$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $b4fdfdeec9399ede$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $b4fdfdeec9399ede$var$cloneUpdateQueue(current, workInProgress);
                $b4fdfdeec9399ede$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $b4fdfdeec9399ede$var$pushProvider(workInProgress, $b4fdfdeec9399ede$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $b4fdfdeec9399ede$var$propagateContextChanges(workInProgress, [
                    $b4fdfdeec9399ede$var$CacheContext
                ], renderLanes, !0);
                $b4fdfdeec9399ede$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $b4fdfdeec9399ede$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $b4fdfdeec9399ede$var$createCapturedValueAtFiber(Error($b4fdfdeec9399ede$var$formatProdErrorMessage(424)), workInProgress);
                        $b4fdfdeec9399ede$var$queueHydrationError(init);
                        workInProgress = $b4fdfdeec9399ede$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$getNextHydratable(current.firstChild);
                        $b4fdfdeec9399ede$var$hydrationParentFiber = workInProgress;
                        $b4fdfdeec9399ede$var$isHydrating = !0;
                        $b4fdfdeec9399ede$var$hydrationErrors = null;
                        $b4fdfdeec9399ede$var$rootOrSingletonContext = !0;
                        renderLanes = $b4fdfdeec9399ede$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $b4fdfdeec9399ede$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $b4fdfdeec9399ede$var$markRef(current, workInProgress), null === current ? (renderLanes = $b4fdfdeec9399ede$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $b4fdfdeec9399ede$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $b4fdfdeec9399ede$var$getOwnerDocumentFromRootContainer($b4fdfdeec9399ede$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$b4fdfdeec9399ede$var$internalInstanceKey] = workInProgress, lazyComponent[$b4fdfdeec9399ede$var$internalPropsKey] = current, $b4fdfdeec9399ede$var$setInitialProperties(lazyComponent, renderLanes, current), $b4fdfdeec9399ede$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $b4fdfdeec9399ede$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $b4fdfdeec9399ede$var$pushHostContext(workInProgress), null === current && $b4fdfdeec9399ede$var$isHydrating && (lazyComponent = workInProgress.stateNode = $b4fdfdeec9399ede$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $b4fdfdeec9399ede$var$rootInstanceStackCursor.current), $b4fdfdeec9399ede$var$hydrationParentFiber = workInProgress, $b4fdfdeec9399ede$var$rootOrSingletonContext = !0, init = $b4fdfdeec9399ede$var$nextHydratableInstance, $b4fdfdeec9399ede$var$isSingletonScope(workInProgress.type) ? ($b4fdfdeec9399ede$var$previousHydratableOnEnteringScopedSingleton = init, $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$getNextHydratable(lazyComponent.firstChild)) : $b4fdfdeec9399ede$var$nextHydratableInstance = init), $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $b4fdfdeec9399ede$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $b4fdfdeec9399ede$var$isHydrating) {
                if (init = lazyComponent = $b4fdfdeec9399ede$var$nextHydratableInstance) lazyComponent = $b4fdfdeec9399ede$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $b4fdfdeec9399ede$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $b4fdfdeec9399ede$var$hydrationParentFiber = workInProgress, $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$getNextHydratable(lazyComponent.firstChild), $b4fdfdeec9399ede$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $b4fdfdeec9399ede$var$throwOnHydrationMismatch(workInProgress);
            }
            $b4fdfdeec9399ede$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $b4fdfdeec9399ede$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $b4fdfdeec9399ede$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $b4fdfdeec9399ede$var$renderWithHooks(current, workInProgress, $b4fdfdeec9399ede$var$TransitionAwareHostComponent, null, null, renderLanes), $b4fdfdeec9399ede$var$HostTransitionContext._currentValue = init);
            $b4fdfdeec9399ede$var$markRef(current, workInProgress);
            $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $b4fdfdeec9399ede$var$isHydrating) {
                if (current = renderLanes = $b4fdfdeec9399ede$var$nextHydratableInstance) renderLanes = $b4fdfdeec9399ede$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $b4fdfdeec9399ede$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $b4fdfdeec9399ede$var$hydrationParentFiber = workInProgress, $b4fdfdeec9399ede$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $b4fdfdeec9399ede$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $b4fdfdeec9399ede$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $b4fdfdeec9399ede$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $b4fdfdeec9399ede$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $b4fdfdeec9399ede$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $b4fdfdeec9399ede$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $b4fdfdeec9399ede$var$prepareToReadContext(workInProgress), init = $b4fdfdeec9399ede$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $b4fdfdeec9399ede$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $b4fdfdeec9399ede$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $b4fdfdeec9399ede$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $b4fdfdeec9399ede$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $b4fdfdeec9399ede$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $b4fdfdeec9399ede$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $b4fdfdeec9399ede$var$prepareToReadContext(workInProgress), lazyComponent = $b4fdfdeec9399ede$var$readContext($b4fdfdeec9399ede$var$CacheContext), null === current ? (init = $b4fdfdeec9399ede$var$peekCacheFromPool(), null === init && (init = $b4fdfdeec9399ede$var$workInProgressRoot, prevState = $b4fdfdeec9399ede$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $b4fdfdeec9399ede$var$initializeUpdateQueue(workInProgress), $b4fdfdeec9399ede$var$pushProvider(workInProgress, $b4fdfdeec9399ede$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($b4fdfdeec9399ede$var$cloneUpdateQueue(current, workInProgress), $b4fdfdeec9399ede$var$processUpdateQueue(workInProgress, null, null, renderLanes), $b4fdfdeec9399ede$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $b4fdfdeec9399ede$var$pushProvider(workInProgress, $b4fdfdeec9399ede$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $b4fdfdeec9399ede$var$pushProvider(workInProgress, $b4fdfdeec9399ede$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $b4fdfdeec9399ede$var$propagateContextChanges(workInProgress, [
                $b4fdfdeec9399ede$var$CacheContext
            ], renderLanes, !0))), $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b4fdfdeec9399ede$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $b4fdfdeec9399ede$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$b4fdfdeec9399ede$var$preloadResource(resource)) {
        resource = $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 4194048) === $b4fdfdeec9399ede$var$workInProgressRootRenderLanes ? null !== $b4fdfdeec9399ede$var$shellBoundary : ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 62914560) !== $b4fdfdeec9399ede$var$workInProgressRootRenderLanes && 0 === ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 536870912) || resource !== $b4fdfdeec9399ede$var$shellBoundary)) throw $b4fdfdeec9399ede$var$suspendedThenable = $b4fdfdeec9399ede$var$noopSuspenseyCommitThenable, $b4fdfdeec9399ede$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $b4fdfdeec9399ede$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $b4fdfdeec9399ede$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $b4fdfdeec9399ede$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $b4fdfdeec9399ede$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$b4fdfdeec9399ede$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $b4fdfdeec9399ede$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $b4fdfdeec9399ede$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $b4fdfdeec9399ede$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), null;
        case 1:
            return $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $b4fdfdeec9399ede$var$popProvider($b4fdfdeec9399ede$var$CacheContext);
            $b4fdfdeec9399ede$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $b4fdfdeec9399ede$var$popHydrationState(workInProgress) ? $b4fdfdeec9399ede$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $b4fdfdeec9399ede$var$upgradeHydrationErrorsToRecoverable());
            $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($b4fdfdeec9399ede$var$markUpdate(workInProgress), null !== renderLanes ? ($b4fdfdeec9399ede$var$bubbleProperties(workInProgress), $b4fdfdeec9399ede$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($b4fdfdeec9399ede$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($b4fdfdeec9399ede$var$markUpdate(workInProgress), $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), $b4fdfdeec9399ede$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($b4fdfdeec9399ede$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $b4fdfdeec9399ede$var$markUpdate(workInProgress), $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $b4fdfdeec9399ede$var$popHostContext(workInProgress);
            renderLanes = $b4fdfdeec9399ede$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b4fdfdeec9399ede$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(166));
                    $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $b4fdfdeec9399ede$var$contextStackCursor.current;
                $b4fdfdeec9399ede$var$popHydrationState(workInProgress) ? $b4fdfdeec9399ede$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $b4fdfdeec9399ede$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $b4fdfdeec9399ede$var$markUpdate(workInProgress));
            }
            $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $b4fdfdeec9399ede$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b4fdfdeec9399ede$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(166));
                    $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $b4fdfdeec9399ede$var$contextStackCursor.current;
                if ($b4fdfdeec9399ede$var$popHydrationState(workInProgress)) $b4fdfdeec9399ede$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $b4fdfdeec9399ede$var$getOwnerDocumentFromRootContainer($b4fdfdeec9399ede$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$b4fdfdeec9399ede$var$internalInstanceKey] = workInProgress;
                    current[$b4fdfdeec9399ede$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($b4fdfdeec9399ede$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $b4fdfdeec9399ede$var$markUpdate(workInProgress);
                }
            }
            $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b4fdfdeec9399ede$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(166));
                current = $b4fdfdeec9399ede$var$rootInstanceStackCursor.current;
                if ($b4fdfdeec9399ede$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $b4fdfdeec9399ede$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$b4fdfdeec9399ede$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $b4fdfdeec9399ede$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $b4fdfdeec9399ede$var$throwOnHydrationMismatch(workInProgress);
                } else current = $b4fdfdeec9399ede$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$b4fdfdeec9399ede$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $b4fdfdeec9399ede$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(317));
                        type[$b4fdfdeec9399ede$var$internalInstanceKey] = workInProgress;
                    } else $b4fdfdeec9399ede$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $b4fdfdeec9399ede$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress), workInProgress;
                    $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $b4fdfdeec9399ede$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $b4fdfdeec9399ede$var$popHostContainer(), null === current && $b4fdfdeec9399ede$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), null;
        case 10:
            return $b4fdfdeec9399ede$var$popProvider(workInProgress.type), $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), null;
        case 19:
            $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $b4fdfdeec9399ede$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $b4fdfdeec9399ede$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $b4fdfdeec9399ede$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $b4fdfdeec9399ede$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $b4fdfdeec9399ede$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$b4fdfdeec9399ede$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, $b4fdfdeec9399ede$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $b4fdfdeec9399ede$var$now() > $b4fdfdeec9399ede$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $b4fdfdeec9399ede$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $b4fdfdeec9399ede$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $b4fdfdeec9399ede$var$scheduleRetryEffect(workInProgress, current), $b4fdfdeec9399ede$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$b4fdfdeec9399ede$var$isHydrating) return $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), null;
                    } else 2 * $b4fdfdeec9399ede$var$now() - type.renderingStartTime > $b4fdfdeec9399ede$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $b4fdfdeec9399ede$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $b4fdfdeec9399ede$var$now(), workInProgress.sibling = null, current = $b4fdfdeec9399ede$var$suspenseStackCursor.current, $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress), $b4fdfdeec9399ede$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($b4fdfdeec9399ede$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $b4fdfdeec9399ede$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $b4fdfdeec9399ede$var$popProvider($b4fdfdeec9399ede$var$CacheContext), $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b4fdfdeec9399ede$var$unwindWork(current, workInProgress) {
    $b4fdfdeec9399ede$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $b4fdfdeec9399ede$var$popProvider($b4fdfdeec9399ede$var$CacheContext), $b4fdfdeec9399ede$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $b4fdfdeec9399ede$var$popHostContext(workInProgress), null;
        case 13:
            $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(340));
                $b4fdfdeec9399ede$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$suspenseStackCursor), null;
        case 4:
            return $b4fdfdeec9399ede$var$popHostContainer(), null;
        case 10:
            return $b4fdfdeec9399ede$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress), $b4fdfdeec9399ede$var$popHiddenContext(), null !== current && $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $b4fdfdeec9399ede$var$popProvider($b4fdfdeec9399ede$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $b4fdfdeec9399ede$var$unwindInterruptedWork(current, interruptedWork) {
    $b4fdfdeec9399ede$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $b4fdfdeec9399ede$var$popProvider($b4fdfdeec9399ede$var$CacheContext);
            $b4fdfdeec9399ede$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $b4fdfdeec9399ede$var$popHostContext(interruptedWork);
            break;
        case 4:
            $b4fdfdeec9399ede$var$popHostContainer();
            break;
        case 13:
            $b4fdfdeec9399ede$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$suspenseStackCursor);
            break;
        case 10:
            $b4fdfdeec9399ede$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $b4fdfdeec9399ede$var$popSuspenseHandler(interruptedWork);
            $b4fdfdeec9399ede$var$popHiddenContext();
            null !== current && $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$resumedCache);
            break;
        case 24:
            $b4fdfdeec9399ede$var$popProvider($b4fdfdeec9399ede$var$CacheContext);
    }
}
function $b4fdfdeec9399ede$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b4fdfdeec9399ede$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $b4fdfdeec9399ede$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b4fdfdeec9399ede$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $b4fdfdeec9399ede$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $b4fdfdeec9399ede$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $b4fdfdeec9399ede$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b4fdfdeec9399ede$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b4fdfdeec9399ede$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $b4fdfdeec9399ede$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $b4fdfdeec9399ede$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $b4fdfdeec9399ede$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b4fdfdeec9399ede$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $b4fdfdeec9399ede$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$b4fdfdeec9399ede$var$internalPropsKey] = newProps;
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b4fdfdeec9399ede$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $b4fdfdeec9399ede$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $b4fdfdeec9399ede$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $b4fdfdeec9399ede$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $b4fdfdeec9399ede$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $b4fdfdeec9399ede$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $b4fdfdeec9399ede$var$noop$1));
    else if (4 !== tag && (27 === tag && $b4fdfdeec9399ede$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($b4fdfdeec9399ede$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$b4fdfdeec9399ede$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $b4fdfdeec9399ede$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $b4fdfdeec9399ede$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($b4fdfdeec9399ede$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$b4fdfdeec9399ede$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $b4fdfdeec9399ede$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $b4fdfdeec9399ede$var$setInitialProperties(singleton, type, props);
        singleton[$b4fdfdeec9399ede$var$internalInstanceKey] = finishedWork;
        singleton[$b4fdfdeec9399ede$var$internalPropsKey] = props;
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden = !1, $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden = !1, $b4fdfdeec9399ede$var$needsFormReset = !1, $b4fdfdeec9399ede$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $b4fdfdeec9399ede$var$nextEffect = null;
function $b4fdfdeec9399ede$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $b4fdfdeec9399ede$var$eventsEnabled = $b4fdfdeec9399ede$var$_enabled;
    root = $b4fdfdeec9399ede$var$getActiveElementDeep(root);
    if ($b4fdfdeec9399ede$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $b4fdfdeec9399ede$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $b4fdfdeec9399ede$var$_enabled = !1;
    for($b4fdfdeec9399ede$var$nextEffect = firstChild; null !== $b4fdfdeec9399ede$var$nextEffect;)if (firstChild = $b4fdfdeec9399ede$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $b4fdfdeec9399ede$var$nextEffect = root;
    else for(; null !== $b4fdfdeec9399ede$var$nextEffect;){
        firstChild = $b4fdfdeec9399ede$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $b4fdfdeec9399ede$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $b4fdfdeec9399ede$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $b4fdfdeec9399ede$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $b4fdfdeec9399ede$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $b4fdfdeec9399ede$var$nextEffect = root;
            break;
        }
        $b4fdfdeec9399ede$var$nextEffect = firstChild.return;
    }
}
function $b4fdfdeec9399ede$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b4fdfdeec9399ede$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $b4fdfdeec9399ede$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $b4fdfdeec9399ede$var$commitClassCallbacks(finishedWork);
            flags & 512 && $b4fdfdeec9399ede$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $b4fdfdeec9399ede$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $b4fdfdeec9399ede$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $b4fdfdeec9399ede$var$commitHostMount(finishedWork);
            flags & 512 && $b4fdfdeec9399ede$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b4fdfdeec9399ede$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $b4fdfdeec9399ede$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $b4fdfdeec9399ede$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden;
                prevProps = $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden;
                $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden = flags;
                ($b4fdfdeec9399ede$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden = prevProps;
                $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $b4fdfdeec9399ede$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $b4fdfdeec9399ede$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $b4fdfdeec9399ede$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $b4fdfdeec9399ede$var$hostParent = null, $b4fdfdeec9399ede$var$hostParentIsContainer = !1;
function $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$b4fdfdeec9399ede$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $b4fdfdeec9399ede$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($b4fdfdeec9399ede$var$injectedHook && "function" === typeof $b4fdfdeec9399ede$var$injectedHook.onCommitFiberUnmount) try {
        $b4fdfdeec9399ede$var$injectedHook.onCommitFiberUnmount($b4fdfdeec9399ede$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || $b4fdfdeec9399ede$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || $b4fdfdeec9399ede$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $b4fdfdeec9399ede$var$hostParent, prevHostParentIsContainer = $b4fdfdeec9399ede$var$hostParentIsContainer;
            $b4fdfdeec9399ede$var$isSingletonScope(deletedFiber.type) && ($b4fdfdeec9399ede$var$hostParent = deletedFiber.stateNode, $b4fdfdeec9399ede$var$hostParentIsContainer = !1);
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b4fdfdeec9399ede$var$releaseSingletonInstance(deletedFiber.stateNode);
            $b4fdfdeec9399ede$var$hostParent = prevHostParent;
            $b4fdfdeec9399ede$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || $b4fdfdeec9399ede$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $b4fdfdeec9399ede$var$hostParent;
            prevHostParentIsContainer = $b4fdfdeec9399ede$var$hostParentIsContainer;
            $b4fdfdeec9399ede$var$hostParent = null;
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b4fdfdeec9399ede$var$hostParent = prevHostParent;
            $b4fdfdeec9399ede$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $b4fdfdeec9399ede$var$hostParent) {
                if ($b4fdfdeec9399ede$var$hostParentIsContainer) try {
                    (9 === $b4fdfdeec9399ede$var$hostParent.nodeType ? $b4fdfdeec9399ede$var$hostParent.body : "HTML" === $b4fdfdeec9399ede$var$hostParent.nodeName ? $b4fdfdeec9399ede$var$hostParent.ownerDocument.body : $b4fdfdeec9399ede$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $b4fdfdeec9399ede$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $b4fdfdeec9399ede$var$hostParent && ($b4fdfdeec9399ede$var$hostParentIsContainer ? (finishedRoot = $b4fdfdeec9399ede$var$hostParent, $b4fdfdeec9399ede$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $b4fdfdeec9399ede$var$retryIfBlockedOn(finishedRoot)) : $b4fdfdeec9399ede$var$clearSuspenseBoundary($b4fdfdeec9399ede$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $b4fdfdeec9399ede$var$hostParent;
            prevHostParentIsContainer = $b4fdfdeec9399ede$var$hostParentIsContainer;
            $b4fdfdeec9399ede$var$hostParent = deletedFiber.stateNode.containerInfo;
            $b4fdfdeec9399ede$var$hostParentIsContainer = !0;
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b4fdfdeec9399ede$var$hostParent = prevHostParent;
            $b4fdfdeec9399ede$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || $b4fdfdeec9399ede$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || $b4fdfdeec9399ede$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || ($b4fdfdeec9399ede$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $b4fdfdeec9399ede$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden = (prevHostParent = $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $b4fdfdeec9399ede$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $b4fdfdeec9399ede$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b4fdfdeec9399ede$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $b4fdfdeec9399ede$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $b4fdfdeec9399ede$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $b4fdfdeec9399ede$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $b4fdfdeec9399ede$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $b4fdfdeec9399ede$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($b4fdfdeec9399ede$var$isSingletonScope(parent.type)) {
                        $b4fdfdeec9399ede$var$hostParent = parent.stateNode;
                        $b4fdfdeec9399ede$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $b4fdfdeec9399ede$var$hostParent = parent.stateNode;
                    $b4fdfdeec9399ede$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $b4fdfdeec9399ede$var$hostParent = parent.stateNode.containerInfo;
                    $b4fdfdeec9399ede$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $b4fdfdeec9399ede$var$hostParent) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(160));
        $b4fdfdeec9399ede$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $b4fdfdeec9399ede$var$hostParent = null;
        $b4fdfdeec9399ede$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$b4fdfdeec9399ede$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $b4fdfdeec9399ede$var$currentHoistableRoot = null;
function $b4fdfdeec9399ede$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($b4fdfdeec9399ede$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $b4fdfdeec9399ede$var$commitHookEffectListMount(3, finishedWork), $b4fdfdeec9399ede$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || null === current || $b4fdfdeec9399ede$var$safelyDetachRef(current, current.return));
            flags & 64 && $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $b4fdfdeec9399ede$var$currentHoistableRoot;
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || null === current || $b4fdfdeec9399ede$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$b4fdfdeec9399ede$var$internalHoistableMarker] || currentResource[$b4fdfdeec9399ede$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $b4fdfdeec9399ede$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$b4fdfdeec9399ede$var$internalInstanceKey] = finishedWork;
                                        $b4fdfdeec9399ede$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $b4fdfdeec9399ede$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b4fdfdeec9399ede$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $b4fdfdeec9399ede$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b4fdfdeec9399ede$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$b4fdfdeec9399ede$var$internalInstanceKey] = finishedWork;
                                $b4fdfdeec9399ede$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $b4fdfdeec9399ede$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $b4fdfdeec9399ede$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $b4fdfdeec9399ede$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $b4fdfdeec9399ede$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $b4fdfdeec9399ede$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || null === current || $b4fdfdeec9399ede$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $b4fdfdeec9399ede$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || null === current || $b4fdfdeec9399ede$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $b4fdfdeec9399ede$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $b4fdfdeec9399ede$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($b4fdfdeec9399ede$var$needsFormReset = !0);
            break;
        case 6:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $b4fdfdeec9399ede$var$tagCaches = null;
            hoistableRoot = $b4fdfdeec9399ede$var$currentHoistableRoot;
            $b4fdfdeec9399ede$var$currentHoistableRoot = $b4fdfdeec9399ede$var$getHoistableRoot(root.containerInfo);
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$currentHoistableRoot = hoistableRoot;
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $b4fdfdeec9399ede$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $b4fdfdeec9399ede$var$needsFormReset && ($b4fdfdeec9399ede$var$needsFormReset = !1, $b4fdfdeec9399ede$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $b4fdfdeec9399ede$var$currentHoistableRoot;
            $b4fdfdeec9399ede$var$currentHoistableRoot = $b4fdfdeec9399ede$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            $b4fdfdeec9399ede$var$currentHoistableRoot = flags;
            break;
        case 12:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($b4fdfdeec9399ede$var$globalMostRecentFallbackTime = $b4fdfdeec9399ede$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b4fdfdeec9399ede$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden;
            $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden || $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $b4fdfdeec9399ede$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $b4fdfdeec9399ede$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $b4fdfdeec9399ede$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b4fdfdeec9399ede$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork), $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
    }
}
function $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($b4fdfdeec9399ede$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $b4fdfdeec9399ede$var$getHostSibling(finishedWork);
                    $b4fdfdeec9399ede$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($b4fdfdeec9399ede$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $b4fdfdeec9399ede$var$getHostSibling(finishedWork);
                    $b4fdfdeec9399ede$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $b4fdfdeec9399ede$var$getHostSibling(finishedWork);
                    $b4fdfdeec9399ede$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $b4fdfdeec9399ede$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $b4fdfdeec9399ede$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$b4fdfdeec9399ede$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $b4fdfdeec9399ede$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $b4fdfdeec9399ede$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $b4fdfdeec9399ede$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $b4fdfdeec9399ede$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $b4fdfdeec9399ede$var$safelyDetachRef(finishedWork, finishedWork.return);
                $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b4fdfdeec9399ede$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$b4fdfdeec9399ede$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $b4fdfdeec9399ede$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $b4fdfdeec9399ede$var$commitClassCallbacks(finishedWork);
                $b4fdfdeec9399ede$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $b4fdfdeec9399ede$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $b4fdfdeec9399ede$var$commitHostMount(finishedWork);
                $b4fdfdeec9399ede$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $b4fdfdeec9399ede$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b4fdfdeec9399ede$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b4fdfdeec9399ede$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $b4fdfdeec9399ede$var$releaseCache(previousCache));
}
function $b4fdfdeec9399ede$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $b4fdfdeec9399ede$var$releaseCache(current));
}
function $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b4fdfdeec9399ede$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $b4fdfdeec9399ede$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b4fdfdeec9399ede$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $b4fdfdeec9399ede$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $b4fdfdeec9399ede$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $b4fdfdeec9399ede$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $b4fdfdeec9399ede$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b4fdfdeec9399ede$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $b4fdfdeec9399ede$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b4fdfdeec9399ede$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $b4fdfdeec9399ede$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $b4fdfdeec9399ede$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $b4fdfdeec9399ede$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $b4fdfdeec9399ede$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $b4fdfdeec9399ede$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b4fdfdeec9399ede$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $b4fdfdeec9399ede$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b4fdfdeec9399ede$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b4fdfdeec9399ede$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $b4fdfdeec9399ede$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b4fdfdeec9399ede$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b4fdfdeec9399ede$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b4fdfdeec9399ede$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b4fdfdeec9399ede$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $b4fdfdeec9399ede$var$suspenseyCommitFlag = 8192;
function $b4fdfdeec9399ede$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $b4fdfdeec9399ede$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$b4fdfdeec9399ede$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $b4fdfdeec9399ede$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $b4fdfdeec9399ede$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $b4fdfdeec9399ede$var$suspenseyCommitFlag && null !== fiber.memoizedState && $b4fdfdeec9399ede$var$suspendResource($b4fdfdeec9399ede$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $b4fdfdeec9399ede$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $b4fdfdeec9399ede$var$currentHoistableRoot;
            $b4fdfdeec9399ede$var$currentHoistableRoot = $b4fdfdeec9399ede$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $b4fdfdeec9399ede$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $b4fdfdeec9399ede$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $b4fdfdeec9399ede$var$suspenseyCommitFlag, $b4fdfdeec9399ede$var$suspenseyCommitFlag = 16777216, $b4fdfdeec9399ede$var$recursivelyAccumulateSuspenseyCommit(fiber), $b4fdfdeec9399ede$var$suspenseyCommitFlag = previousHoistableRoot) : $b4fdfdeec9399ede$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $b4fdfdeec9399ede$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $b4fdfdeec9399ede$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $b4fdfdeec9399ede$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b4fdfdeec9399ede$var$nextEffect = childToDelete;
            $b4fdfdeec9399ede$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b4fdfdeec9399ede$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b4fdfdeec9399ede$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $b4fdfdeec9399ede$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $b4fdfdeec9399ede$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $b4fdfdeec9399ede$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $b4fdfdeec9399ede$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $b4fdfdeec9399ede$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b4fdfdeec9399ede$var$nextEffect = childToDelete;
            $b4fdfdeec9399ede$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b4fdfdeec9399ede$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $b4fdfdeec9399ede$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $b4fdfdeec9399ede$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $b4fdfdeec9399ede$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $b4fdfdeec9399ede$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b4fdfdeec9399ede$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $b4fdfdeec9399ede$var$nextEffect;){
        var fiber = $b4fdfdeec9399ede$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $b4fdfdeec9399ede$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $b4fdfdeec9399ede$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $b4fdfdeec9399ede$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $b4fdfdeec9399ede$var$nextEffect;){
            cache = $b4fdfdeec9399ede$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $b4fdfdeec9399ede$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $b4fdfdeec9399ede$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $b4fdfdeec9399ede$var$nextEffect = sibling;
                break a;
            }
            $b4fdfdeec9399ede$var$nextEffect = returnFiber;
        }
    }
}
var $b4fdfdeec9399ede$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $b4fdfdeec9399ede$var$readContext($b4fdfdeec9399ede$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $b4fdfdeec9399ede$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $b4fdfdeec9399ede$var$executionContext = 0, $b4fdfdeec9399ede$var$workInProgressRoot = null, $b4fdfdeec9399ede$var$workInProgress = null, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes = 0, $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0, $b4fdfdeec9399ede$var$workInProgressThrownValue = null, $b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings = !1, $b4fdfdeec9399ede$var$workInProgressRootIsPrerendering = !1, $b4fdfdeec9399ede$var$workInProgressRootDidAttachPingListener = !1, $b4fdfdeec9399ede$var$entangledRenderLanes = 0, $b4fdfdeec9399ede$var$workInProgressRootExitStatus = 0, $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes = 0, $b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes = 0, $b4fdfdeec9399ede$var$workInProgressRootPingedLanes = 0, $b4fdfdeec9399ede$var$workInProgressDeferredLane = 0, $b4fdfdeec9399ede$var$workInProgressSuspendedRetryLanes = 0, $b4fdfdeec9399ede$var$workInProgressRootConcurrentErrors = null, $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors = null, $b4fdfdeec9399ede$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $b4fdfdeec9399ede$var$globalMostRecentFallbackTime = 0, $b4fdfdeec9399ede$var$workInProgressRootRenderTargetTime = Infinity, $b4fdfdeec9399ede$var$workInProgressTransitions = null, $b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed = null, $b4fdfdeec9399ede$var$pendingEffectsStatus = 0, $b4fdfdeec9399ede$var$pendingEffectsRoot = null, $b4fdfdeec9399ede$var$pendingFinishedWork = null, $b4fdfdeec9399ede$var$pendingEffectsLanes = 0, $b4fdfdeec9399ede$var$pendingEffectsRemainingLanes = 0, $b4fdfdeec9399ede$var$pendingPassiveTransitions = null, $b4fdfdeec9399ede$var$pendingRecoverableErrors = null, $b4fdfdeec9399ede$var$nestedUpdateCount = 0, $b4fdfdeec9399ede$var$rootWithNestedUpdates = null;
function $b4fdfdeec9399ede$var$requestUpdateLane() {
    if (0 !== ($b4fdfdeec9399ede$var$executionContext & 2) && 0 !== $b4fdfdeec9399ede$var$workInProgressRootRenderLanes) return $b4fdfdeec9399ede$var$workInProgressRootRenderLanes & -$b4fdfdeec9399ede$var$workInProgressRootRenderLanes;
    if (null !== $b4fdfdeec9399ede$var$ReactSharedInternals.T) {
        var actionScopeLane = $b4fdfdeec9399ede$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $b4fdfdeec9399ede$var$requestTransitionLane();
    }
    return $b4fdfdeec9399ede$var$resolveUpdatePriority();
}
function $b4fdfdeec9399ede$var$requestDeferredLane() {
    0 === $b4fdfdeec9399ede$var$workInProgressDeferredLane && ($b4fdfdeec9399ede$var$workInProgressDeferredLane = 0 === ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 536870912) || $b4fdfdeec9399ede$var$isHydrating ? $b4fdfdeec9399ede$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $b4fdfdeec9399ede$var$workInProgressDeferredLane;
}
function $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $b4fdfdeec9399ede$var$workInProgressRoot && (2 === $b4fdfdeec9399ede$var$workInProgressSuspendedReason || 9 === $b4fdfdeec9399ede$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $b4fdfdeec9399ede$var$prepareFreshStack(root, 0), $b4fdfdeec9399ede$var$markRootSuspended(root, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes, $b4fdfdeec9399ede$var$workInProgressDeferredLane, !1);
    $b4fdfdeec9399ede$var$markRootUpdated$1(root, lane);
    if (0 === ($b4fdfdeec9399ede$var$executionContext & 2) || root !== $b4fdfdeec9399ede$var$workInProgressRoot) root === $b4fdfdeec9399ede$var$workInProgressRoot && (0 === ($b4fdfdeec9399ede$var$executionContext & 2) && ($b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $b4fdfdeec9399ede$var$workInProgressRootExitStatus && $b4fdfdeec9399ede$var$markRootSuspended(root, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes, $b4fdfdeec9399ede$var$workInProgressDeferredLane, !1)), $b4fdfdeec9399ede$var$ensureRootIsScheduled(root);
}
function $b4fdfdeec9399ede$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($b4fdfdeec9399ede$var$executionContext & 6)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $b4fdfdeec9399ede$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $b4fdfdeec9399ede$var$renderRootConcurrent(root$jscomp$0, lanes) : $b4fdfdeec9399ede$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $b4fdfdeec9399ede$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $b4fdfdeec9399ede$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$b4fdfdeec9399ede$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $b4fdfdeec9399ede$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $b4fdfdeec9399ede$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($b4fdfdeec9399ede$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $b4fdfdeec9399ede$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($b4fdfdeec9399ede$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors;
                            $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors ? $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors.push.apply($b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $b4fdfdeec9399ede$var$prepareFreshStack(root$jscomp$0, 0);
                $b4fdfdeec9399ede$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $b4fdfdeec9399ede$var$markRootSuspended(shouldTimeSlice, lanes, $b4fdfdeec9399ede$var$workInProgressDeferredLane, !$b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $b4fdfdeec9399ede$var$globalMostRecentFallbackTime + 300 - $b4fdfdeec9399ede$var$now(), 10 < exitStatus)) {
                    $b4fdfdeec9399ede$var$markRootSuspended(shouldTimeSlice, lanes, $b4fdfdeec9399ede$var$workInProgressDeferredLane, !$b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $b4fdfdeec9399ede$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $b4fdfdeec9399ede$var$scheduleTimeout($b4fdfdeec9399ede$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors, $b4fdfdeec9399ede$var$workInProgressTransitions, $b4fdfdeec9399ede$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b4fdfdeec9399ede$var$workInProgressDeferredLane, $b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes, $b4fdfdeec9399ede$var$workInProgressSuspendedRetryLanes, $b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $b4fdfdeec9399ede$var$commitRootWhenReady(shouldTimeSlice, forceSync, $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors, $b4fdfdeec9399ede$var$workInProgressTransitions, $b4fdfdeec9399ede$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b4fdfdeec9399ede$var$workInProgressDeferredLane, $b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes, $b4fdfdeec9399ede$var$workInProgressSuspendedRetryLanes, $b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $b4fdfdeec9399ede$var$ensureRootIsScheduled(root$jscomp$0);
}
function $b4fdfdeec9399ede$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($b4fdfdeec9399ede$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $b4fdfdeec9399ede$var$noop
        }, $b4fdfdeec9399ede$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $b4fdfdeec9399ede$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($b4fdfdeec9399ede$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $b4fdfdeec9399ede$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $b4fdfdeec9399ede$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $b4fdfdeec9399ede$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$b4fdfdeec9399ede$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $b4fdfdeec9399ede$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$b4fdfdeec9399ede$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $b4fdfdeec9399ede$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $b4fdfdeec9399ede$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $b4fdfdeec9399ede$var$flushSyncWork$1() {
    return 0 === ($b4fdfdeec9399ede$var$executionContext & 6) ? ($b4fdfdeec9399ede$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $b4fdfdeec9399ede$var$resetWorkInProgressStack() {
    if (null !== $b4fdfdeec9399ede$var$workInProgress) {
        if (0 === $b4fdfdeec9399ede$var$workInProgressSuspendedReason) var interruptedWork = $b4fdfdeec9399ede$var$workInProgress.return;
        else interruptedWork = $b4fdfdeec9399ede$var$workInProgress, $b4fdfdeec9399ede$var$lastContextDependency = $b4fdfdeec9399ede$var$currentlyRenderingFiber$1 = null, $b4fdfdeec9399ede$var$resetHooksOnUnwind(interruptedWork), $b4fdfdeec9399ede$var$thenableState = null, $b4fdfdeec9399ede$var$thenableIndexCounter = 0, interruptedWork = $b4fdfdeec9399ede$var$workInProgress;
        for(; null !== interruptedWork;)$b4fdfdeec9399ede$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $b4fdfdeec9399ede$var$workInProgress = null;
    }
}
function $b4fdfdeec9399ede$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $b4fdfdeec9399ede$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $b4fdfdeec9399ede$var$resetWorkInProgressStack();
    $b4fdfdeec9399ede$var$workInProgressRoot = root;
    $b4fdfdeec9399ede$var$workInProgress = timeoutHandle = $b4fdfdeec9399ede$var$createWorkInProgress(root.current, null);
    $b4fdfdeec9399ede$var$workInProgressRootRenderLanes = lanes;
    $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0;
    $b4fdfdeec9399ede$var$workInProgressThrownValue = null;
    $b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $b4fdfdeec9399ede$var$workInProgressRootIsPrerendering = $b4fdfdeec9399ede$var$checkIfRootIsPrerendering(root, lanes);
    $b4fdfdeec9399ede$var$workInProgressRootDidAttachPingListener = !1;
    $b4fdfdeec9399ede$var$workInProgressSuspendedRetryLanes = $b4fdfdeec9399ede$var$workInProgressDeferredLane = $b4fdfdeec9399ede$var$workInProgressRootPingedLanes = $b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes = $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes = $b4fdfdeec9399ede$var$workInProgressRootExitStatus = 0;
    $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors = $b4fdfdeec9399ede$var$workInProgressRootConcurrentErrors = null;
    $b4fdfdeec9399ede$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $b4fdfdeec9399ede$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $b4fdfdeec9399ede$var$entangledRenderLanes = lanes;
    $b4fdfdeec9399ede$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $b4fdfdeec9399ede$var$handleThrow(root, thrownValue) {
    $b4fdfdeec9399ede$var$currentlyRenderingFiber = null;
    $b4fdfdeec9399ede$var$ReactSharedInternals.H = $b4fdfdeec9399ede$var$ContextOnlyDispatcher;
    thrownValue === $b4fdfdeec9399ede$var$SuspenseException || thrownValue === $b4fdfdeec9399ede$var$SuspenseActionException ? (thrownValue = $b4fdfdeec9399ede$var$getSuspendedThenable(), $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 3) : thrownValue === $b4fdfdeec9399ede$var$SuspenseyCommitException ? (thrownValue = $b4fdfdeec9399ede$var$getSuspendedThenable(), $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 4) : $b4fdfdeec9399ede$var$workInProgressSuspendedReason = thrownValue === $b4fdfdeec9399ede$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $b4fdfdeec9399ede$var$workInProgressThrownValue = thrownValue;
    null === $b4fdfdeec9399ede$var$workInProgress && ($b4fdfdeec9399ede$var$workInProgressRootExitStatus = 1, $b4fdfdeec9399ede$var$logUncaughtError(root, $b4fdfdeec9399ede$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $b4fdfdeec9399ede$var$pushDispatcher() {
    var prevDispatcher = $b4fdfdeec9399ede$var$ReactSharedInternals.H;
    $b4fdfdeec9399ede$var$ReactSharedInternals.H = $b4fdfdeec9399ede$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $b4fdfdeec9399ede$var$ContextOnlyDispatcher : prevDispatcher;
}
function $b4fdfdeec9399ede$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $b4fdfdeec9399ede$var$ReactSharedInternals.A;
    $b4fdfdeec9399ede$var$ReactSharedInternals.A = $b4fdfdeec9399ede$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $b4fdfdeec9399ede$var$renderDidSuspendDelayIfPossible() {
    $b4fdfdeec9399ede$var$workInProgressRootExitStatus = 4;
    $b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings || ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 4194048) !== $b4fdfdeec9399ede$var$workInProgressRootRenderLanes && null !== $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current || ($b4fdfdeec9399ede$var$workInProgressRootIsPrerendering = !0);
    0 === ($b4fdfdeec9399ede$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $b4fdfdeec9399ede$var$workInProgressRoot || $b4fdfdeec9399ede$var$markRootSuspended($b4fdfdeec9399ede$var$workInProgressRoot, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes, $b4fdfdeec9399ede$var$workInProgressDeferredLane, !1);
}
function $b4fdfdeec9399ede$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $b4fdfdeec9399ede$var$executionContext;
    $b4fdfdeec9399ede$var$executionContext |= 2;
    var prevDispatcher = $b4fdfdeec9399ede$var$pushDispatcher(), prevAsyncDispatcher = $b4fdfdeec9399ede$var$pushAsyncDispatcher();
    if ($b4fdfdeec9399ede$var$workInProgressRoot !== root || $b4fdfdeec9399ede$var$workInProgressRootRenderLanes !== lanes) $b4fdfdeec9399ede$var$workInProgressTransitions = null, $b4fdfdeec9399ede$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $b4fdfdeec9399ede$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $b4fdfdeec9399ede$var$workInProgressSuspendedReason && null !== $b4fdfdeec9399ede$var$workInProgress) {
            var unitOfWork = $b4fdfdeec9399ede$var$workInProgress, thrownValue = $b4fdfdeec9399ede$var$workInProgressThrownValue;
            switch($b4fdfdeec9399ede$var$workInProgressSuspendedReason){
                case 8:
                    $b4fdfdeec9399ede$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $b4fdfdeec9399ede$var$workInProgressSuspendedReason;
                    $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0;
                    $b4fdfdeec9399ede$var$workInProgressThrownValue = null;
                    $b4fdfdeec9399ede$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $b4fdfdeec9399ede$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $b4fdfdeec9399ede$var$workInProgressSuspendedReason, $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0, $b4fdfdeec9399ede$var$workInProgressThrownValue = null, $b4fdfdeec9399ede$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $b4fdfdeec9399ede$var$workLoopSync();
        exitStatus = $b4fdfdeec9399ede$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $b4fdfdeec9399ede$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $b4fdfdeec9399ede$var$lastContextDependency = $b4fdfdeec9399ede$var$currentlyRenderingFiber$1 = null;
    $b4fdfdeec9399ede$var$executionContext = prevExecutionContext;
    $b4fdfdeec9399ede$var$ReactSharedInternals.H = prevDispatcher;
    $b4fdfdeec9399ede$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $b4fdfdeec9399ede$var$workInProgress && ($b4fdfdeec9399ede$var$workInProgressRoot = null, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes = 0, $b4fdfdeec9399ede$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $b4fdfdeec9399ede$var$workLoopSync() {
    for(; null !== $b4fdfdeec9399ede$var$workInProgress;)$b4fdfdeec9399ede$var$performUnitOfWork($b4fdfdeec9399ede$var$workInProgress);
}
function $b4fdfdeec9399ede$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $b4fdfdeec9399ede$var$executionContext;
    $b4fdfdeec9399ede$var$executionContext |= 2;
    var prevDispatcher = $b4fdfdeec9399ede$var$pushDispatcher(), prevAsyncDispatcher = $b4fdfdeec9399ede$var$pushAsyncDispatcher();
    $b4fdfdeec9399ede$var$workInProgressRoot !== root || $b4fdfdeec9399ede$var$workInProgressRootRenderLanes !== lanes ? ($b4fdfdeec9399ede$var$workInProgressTransitions = null, $b4fdfdeec9399ede$var$workInProgressRootRenderTargetTime = $b4fdfdeec9399ede$var$now() + 500, $b4fdfdeec9399ede$var$prepareFreshStack(root, lanes)) : $b4fdfdeec9399ede$var$workInProgressRootIsPrerendering = $b4fdfdeec9399ede$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $b4fdfdeec9399ede$var$workInProgressSuspendedReason && null !== $b4fdfdeec9399ede$var$workInProgress) {
            lanes = $b4fdfdeec9399ede$var$workInProgress;
            var thrownValue = $b4fdfdeec9399ede$var$workInProgressThrownValue;
            b: switch($b4fdfdeec9399ede$var$workInProgressSuspendedReason){
                case 1:
                    $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0;
                    $b4fdfdeec9399ede$var$workInProgressThrownValue = null;
                    $b4fdfdeec9399ede$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($b4fdfdeec9399ede$var$isThenableResolved(thrownValue)) {
                        $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0;
                        $b4fdfdeec9399ede$var$workInProgressThrownValue = null;
                        $b4fdfdeec9399ede$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $b4fdfdeec9399ede$var$workInProgressSuspendedReason && 9 !== $b4fdfdeec9399ede$var$workInProgressSuspendedReason || $b4fdfdeec9399ede$var$workInProgressRoot !== root || ($b4fdfdeec9399ede$var$workInProgressSuspendedReason = 7);
                        $b4fdfdeec9399ede$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $b4fdfdeec9399ede$var$isThenableResolved(thrownValue) ? ($b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0, $b4fdfdeec9399ede$var$workInProgressThrownValue = null, $b4fdfdeec9399ede$var$replaySuspendedUnitOfWork(lanes)) : ($b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0, $b4fdfdeec9399ede$var$workInProgressThrownValue = null, $b4fdfdeec9399ede$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($b4fdfdeec9399ede$var$workInProgress.tag){
                        case 26:
                            resource = $b4fdfdeec9399ede$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $b4fdfdeec9399ede$var$workInProgress;
                            if (resource ? $b4fdfdeec9399ede$var$preloadResource(resource) : 1) {
                                $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0;
                                $b4fdfdeec9399ede$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $b4fdfdeec9399ede$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($b4fdfdeec9399ede$var$workInProgress = returnFiber, $b4fdfdeec9399ede$var$completeUnitOfWork(returnFiber)) : $b4fdfdeec9399ede$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0;
                    $b4fdfdeec9399ede$var$workInProgressThrownValue = null;
                    $b4fdfdeec9399ede$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0;
                    $b4fdfdeec9399ede$var$workInProgressThrownValue = null;
                    $b4fdfdeec9399ede$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $b4fdfdeec9399ede$var$resetWorkInProgressStack();
                    $b4fdfdeec9399ede$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(462));
            }
        }
        $b4fdfdeec9399ede$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $b4fdfdeec9399ede$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $b4fdfdeec9399ede$var$lastContextDependency = $b4fdfdeec9399ede$var$currentlyRenderingFiber$1 = null;
    $b4fdfdeec9399ede$var$ReactSharedInternals.H = prevDispatcher;
    $b4fdfdeec9399ede$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $b4fdfdeec9399ede$var$executionContext = prevExecutionContext;
    if (null !== $b4fdfdeec9399ede$var$workInProgress) return 0;
    $b4fdfdeec9399ede$var$workInProgressRoot = null;
    $b4fdfdeec9399ede$var$workInProgressRootRenderLanes = 0;
    $b4fdfdeec9399ede$var$finishQueueingConcurrentUpdates();
    return $b4fdfdeec9399ede$var$workInProgressRootExitStatus;
}
function $b4fdfdeec9399ede$var$workLoopConcurrentByScheduler() {
    for(; null !== $b4fdfdeec9399ede$var$workInProgress && !$b4fdfdeec9399ede$var$shouldYield();)$b4fdfdeec9399ede$var$performUnitOfWork($b4fdfdeec9399ede$var$workInProgress);
}
function $b4fdfdeec9399ede$var$performUnitOfWork(unitOfWork) {
    var next = $b4fdfdeec9399ede$var$beginWork(unitOfWork.alternate, unitOfWork, $b4fdfdeec9399ede$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b4fdfdeec9399ede$var$completeUnitOfWork(unitOfWork) : $b4fdfdeec9399ede$var$workInProgress = next;
}
function $b4fdfdeec9399ede$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $b4fdfdeec9399ede$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $b4fdfdeec9399ede$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $b4fdfdeec9399ede$var$resetHooksOnUnwind(next);
        default:
            $b4fdfdeec9399ede$var$unwindInterruptedWork(current, next), next = $b4fdfdeec9399ede$var$workInProgress = $b4fdfdeec9399ede$var$resetWorkInProgress(next, $b4fdfdeec9399ede$var$entangledRenderLanes), next = $b4fdfdeec9399ede$var$beginWork(current, next, $b4fdfdeec9399ede$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b4fdfdeec9399ede$var$completeUnitOfWork(unitOfWork) : $b4fdfdeec9399ede$var$workInProgress = next;
}
function $b4fdfdeec9399ede$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $b4fdfdeec9399ede$var$lastContextDependency = $b4fdfdeec9399ede$var$currentlyRenderingFiber$1 = null;
    $b4fdfdeec9399ede$var$resetHooksOnUnwind(unitOfWork);
    $b4fdfdeec9399ede$var$thenableState = null;
    $b4fdfdeec9399ede$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($b4fdfdeec9399ede$var$throwException(root, returnFiber, unitOfWork, thrownValue, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes)) {
            $b4fdfdeec9399ede$var$workInProgressRootExitStatus = 1;
            $b4fdfdeec9399ede$var$logUncaughtError(root, $b4fdfdeec9399ede$var$createCapturedValueAtFiber(thrownValue, root.current));
            $b4fdfdeec9399ede$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $b4fdfdeec9399ede$var$workInProgress = returnFiber, error;
        $b4fdfdeec9399ede$var$workInProgressRootExitStatus = 1;
        $b4fdfdeec9399ede$var$logUncaughtError(root, $b4fdfdeec9399ede$var$createCapturedValueAtFiber(thrownValue, root.current));
        $b4fdfdeec9399ede$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($b4fdfdeec9399ede$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($b4fdfdeec9399ede$var$workInProgressRootIsPrerendering || 0 !== ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $b4fdfdeec9399ede$var$unwindUnitOfWork(unitOfWork, root);
    } else $b4fdfdeec9399ede$var$completeUnitOfWork(unitOfWork);
}
function $b4fdfdeec9399ede$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $b4fdfdeec9399ede$var$unwindUnitOfWork(completedWork, $b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $b4fdfdeec9399ede$var$completeWork(completedWork.alternate, completedWork, $b4fdfdeec9399ede$var$entangledRenderLanes);
        if (null !== next) {
            $b4fdfdeec9399ede$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $b4fdfdeec9399ede$var$workInProgress = completedWork;
            return;
        }
        $b4fdfdeec9399ede$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $b4fdfdeec9399ede$var$workInProgressRootExitStatus && ($b4fdfdeec9399ede$var$workInProgressRootExitStatus = 5);
}
function $b4fdfdeec9399ede$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $b4fdfdeec9399ede$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $b4fdfdeec9399ede$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $b4fdfdeec9399ede$var$workInProgress = unitOfWork;
            return;
        }
        $b4fdfdeec9399ede$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $b4fdfdeec9399ede$var$workInProgressRootExitStatus = 6;
    $b4fdfdeec9399ede$var$workInProgress = null;
}
function $b4fdfdeec9399ede$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $b4fdfdeec9399ede$var$flushPendingEffects();
    while (0 !== $b4fdfdeec9399ede$var$pendingEffectsStatus);
    if (0 !== ($b4fdfdeec9399ede$var$executionContext & 6)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $b4fdfdeec9399ede$var$concurrentlyUpdatedLanes;
        $b4fdfdeec9399ede$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $b4fdfdeec9399ede$var$workInProgressRoot && ($b4fdfdeec9399ede$var$workInProgress = $b4fdfdeec9399ede$var$workInProgressRoot = null, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes = 0);
        $b4fdfdeec9399ede$var$pendingFinishedWork = finishedWork;
        $b4fdfdeec9399ede$var$pendingEffectsRoot = root;
        $b4fdfdeec9399ede$var$pendingEffectsLanes = lanes;
        $b4fdfdeec9399ede$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $b4fdfdeec9399ede$var$pendingPassiveTransitions = transitions;
        $b4fdfdeec9399ede$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $b4fdfdeec9399ede$var$scheduleCallback$1($b4fdfdeec9399ede$var$NormalPriority$1, function() {
            $b4fdfdeec9399ede$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $b4fdfdeec9399ede$var$ReactSharedInternals.T;
            $b4fdfdeec9399ede$var$ReactSharedInternals.T = null;
            transitions = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
            $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $b4fdfdeec9399ede$var$executionContext;
            $b4fdfdeec9399ede$var$executionContext |= 4;
            try {
                $b4fdfdeec9399ede$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $b4fdfdeec9399ede$var$executionContext = spawnedLane, $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = transitions, $b4fdfdeec9399ede$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $b4fdfdeec9399ede$var$pendingEffectsStatus = 1;
        $b4fdfdeec9399ede$var$flushMutationEffects();
        $b4fdfdeec9399ede$var$flushLayoutEffects();
        $b4fdfdeec9399ede$var$flushSpawnedWork();
    }
}
function $b4fdfdeec9399ede$var$flushMutationEffects() {
    if (1 === $b4fdfdeec9399ede$var$pendingEffectsStatus) {
        $b4fdfdeec9399ede$var$pendingEffectsStatus = 0;
        var root = $b4fdfdeec9399ede$var$pendingEffectsRoot, finishedWork = $b4fdfdeec9399ede$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $b4fdfdeec9399ede$var$ReactSharedInternals.T;
            $b4fdfdeec9399ede$var$ReactSharedInternals.T = null;
            var previousPriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
            $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $b4fdfdeec9399ede$var$executionContext;
            $b4fdfdeec9399ede$var$executionContext |= 4;
            try {
                $b4fdfdeec9399ede$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $b4fdfdeec9399ede$var$selectionInformation, curFocusedElem = $b4fdfdeec9399ede$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $b4fdfdeec9399ede$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $b4fdfdeec9399ede$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $b4fdfdeec9399ede$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $b4fdfdeec9399ede$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $b4fdfdeec9399ede$var$_enabled = !!$b4fdfdeec9399ede$var$eventsEnabled;
                $b4fdfdeec9399ede$var$selectionInformation = $b4fdfdeec9399ede$var$eventsEnabled = null;
            } finally{
                $b4fdfdeec9399ede$var$executionContext = prevExecutionContext, $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = previousPriority, $b4fdfdeec9399ede$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $b4fdfdeec9399ede$var$pendingEffectsStatus = 2;
    }
}
function $b4fdfdeec9399ede$var$flushLayoutEffects() {
    if (2 === $b4fdfdeec9399ede$var$pendingEffectsStatus) {
        $b4fdfdeec9399ede$var$pendingEffectsStatus = 0;
        var root = $b4fdfdeec9399ede$var$pendingEffectsRoot, finishedWork = $b4fdfdeec9399ede$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $b4fdfdeec9399ede$var$ReactSharedInternals.T;
            $b4fdfdeec9399ede$var$ReactSharedInternals.T = null;
            var previousPriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
            $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $b4fdfdeec9399ede$var$executionContext;
            $b4fdfdeec9399ede$var$executionContext |= 4;
            try {
                $b4fdfdeec9399ede$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $b4fdfdeec9399ede$var$executionContext = prevExecutionContext, $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = previousPriority, $b4fdfdeec9399ede$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $b4fdfdeec9399ede$var$pendingEffectsStatus = 3;
    }
}
function $b4fdfdeec9399ede$var$flushSpawnedWork() {
    if (4 === $b4fdfdeec9399ede$var$pendingEffectsStatus || 3 === $b4fdfdeec9399ede$var$pendingEffectsStatus) {
        $b4fdfdeec9399ede$var$pendingEffectsStatus = 0;
        $b4fdfdeec9399ede$var$requestPaint();
        var root = $b4fdfdeec9399ede$var$pendingEffectsRoot, finishedWork = $b4fdfdeec9399ede$var$pendingFinishedWork, lanes = $b4fdfdeec9399ede$var$pendingEffectsLanes, recoverableErrors = $b4fdfdeec9399ede$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $b4fdfdeec9399ede$var$pendingEffectsStatus = 5 : ($b4fdfdeec9399ede$var$pendingEffectsStatus = 0, $b4fdfdeec9399ede$var$pendingFinishedWork = $b4fdfdeec9399ede$var$pendingEffectsRoot = null, $b4fdfdeec9399ede$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $b4fdfdeec9399ede$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($b4fdfdeec9399ede$var$injectedHook && "function" === typeof $b4fdfdeec9399ede$var$injectedHook.onCommitFiberRoot) try {
            $b4fdfdeec9399ede$var$injectedHook.onCommitFiberRoot($b4fdfdeec9399ede$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $b4fdfdeec9399ede$var$ReactSharedInternals.T;
            remainingLanes = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
            $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 2;
            $b4fdfdeec9399ede$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $b4fdfdeec9399ede$var$ReactSharedInternals.T = finishedWork, $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($b4fdfdeec9399ede$var$pendingEffectsLanes & 3) && $b4fdfdeec9399ede$var$flushPendingEffects();
        $b4fdfdeec9399ede$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $b4fdfdeec9399ede$var$rootWithNestedUpdates ? $b4fdfdeec9399ede$var$nestedUpdateCount++ : ($b4fdfdeec9399ede$var$nestedUpdateCount = 0, $b4fdfdeec9399ede$var$rootWithNestedUpdates = root) : $b4fdfdeec9399ede$var$nestedUpdateCount = 0;
        $b4fdfdeec9399ede$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $b4fdfdeec9399ede$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $b4fdfdeec9399ede$var$releaseCache(remainingLanes)));
}
function $b4fdfdeec9399ede$var$flushPendingEffects(wasDelayedCommit) {
    $b4fdfdeec9399ede$var$flushMutationEffects();
    $b4fdfdeec9399ede$var$flushLayoutEffects();
    $b4fdfdeec9399ede$var$flushSpawnedWork();
    return $b4fdfdeec9399ede$var$flushPassiveEffects(wasDelayedCommit);
}
function $b4fdfdeec9399ede$var$flushPassiveEffects() {
    if (5 !== $b4fdfdeec9399ede$var$pendingEffectsStatus) return !1;
    var root = $b4fdfdeec9399ede$var$pendingEffectsRoot, remainingLanes = $b4fdfdeec9399ede$var$pendingEffectsRemainingLanes;
    $b4fdfdeec9399ede$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $b4fdfdeec9399ede$var$lanesToEventPriority($b4fdfdeec9399ede$var$pendingEffectsLanes), prevTransition = $b4fdfdeec9399ede$var$ReactSharedInternals.T, previousPriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
    try {
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $b4fdfdeec9399ede$var$ReactSharedInternals.T = null;
        renderPriority = $b4fdfdeec9399ede$var$pendingPassiveTransitions;
        $b4fdfdeec9399ede$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $b4fdfdeec9399ede$var$pendingEffectsRoot, lanes = $b4fdfdeec9399ede$var$pendingEffectsLanes;
        $b4fdfdeec9399ede$var$pendingEffectsStatus = 0;
        $b4fdfdeec9399ede$var$pendingFinishedWork = $b4fdfdeec9399ede$var$pendingEffectsRoot = null;
        $b4fdfdeec9399ede$var$pendingEffectsLanes = 0;
        if (0 !== ($b4fdfdeec9399ede$var$executionContext & 6)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(331));
        var prevExecutionContext = $b4fdfdeec9399ede$var$executionContext;
        $b4fdfdeec9399ede$var$executionContext |= 4;
        $b4fdfdeec9399ede$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $b4fdfdeec9399ede$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $b4fdfdeec9399ede$var$executionContext = prevExecutionContext;
        $b4fdfdeec9399ede$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($b4fdfdeec9399ede$var$injectedHook && "function" === typeof $b4fdfdeec9399ede$var$injectedHook.onPostCommitFiberRoot) try {
            $b4fdfdeec9399ede$var$injectedHook.onPostCommitFiberRoot($b4fdfdeec9399ede$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = previousPriority, $b4fdfdeec9399ede$var$ReactSharedInternals.T = prevTransition, $b4fdfdeec9399ede$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $b4fdfdeec9399ede$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $b4fdfdeec9399ede$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $b4fdfdeec9399ede$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $b4fdfdeec9399ede$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($b4fdfdeec9399ede$var$markRootUpdated$1(rootFiber, 2), $b4fdfdeec9399ede$var$ensureRootIsScheduled(rootFiber));
}
function $b4fdfdeec9399ede$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $b4fdfdeec9399ede$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $b4fdfdeec9399ede$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed || !$b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $b4fdfdeec9399ede$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $b4fdfdeec9399ede$var$createClassErrorUpdate(2);
                instance = $b4fdfdeec9399ede$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($b4fdfdeec9399ede$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $b4fdfdeec9399ede$var$markRootUpdated$1(instance, 2), $b4fdfdeec9399ede$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $b4fdfdeec9399ede$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $b4fdfdeec9399ede$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($b4fdfdeec9399ede$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $b4fdfdeec9399ede$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $b4fdfdeec9399ede$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $b4fdfdeec9399ede$var$workInProgressRoot === root && ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $b4fdfdeec9399ede$var$workInProgressRootExitStatus || 3 === $b4fdfdeec9399ede$var$workInProgressRootExitStatus && ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 62914560) === $b4fdfdeec9399ede$var$workInProgressRootRenderLanes && 300 > $b4fdfdeec9399ede$var$now() - $b4fdfdeec9399ede$var$globalMostRecentFallbackTime ? 0 === ($b4fdfdeec9399ede$var$executionContext & 2) && $b4fdfdeec9399ede$var$prepareFreshStack(root, 0) : $b4fdfdeec9399ede$var$workInProgressRootPingedLanes |= pingedLanes, $b4fdfdeec9399ede$var$workInProgressSuspendedRetryLanes === $b4fdfdeec9399ede$var$workInProgressRootRenderLanes && ($b4fdfdeec9399ede$var$workInProgressSuspendedRetryLanes = 0));
    $b4fdfdeec9399ede$var$ensureRootIsScheduled(root);
}
function $b4fdfdeec9399ede$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $b4fdfdeec9399ede$var$claimNextRetryLane());
    boundaryFiber = $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($b4fdfdeec9399ede$var$markRootUpdated$1(boundaryFiber, retryLane), $b4fdfdeec9399ede$var$ensureRootIsScheduled(boundaryFiber));
}
function $b4fdfdeec9399ede$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $b4fdfdeec9399ede$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b4fdfdeec9399ede$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $b4fdfdeec9399ede$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b4fdfdeec9399ede$var$scheduleCallback$1(priorityLevel, callback) {
    return $b4fdfdeec9399ede$var$scheduleCallback$3(priorityLevel, callback);
}
var $b4fdfdeec9399ede$var$firstScheduledRoot = null, $b4fdfdeec9399ede$var$lastScheduledRoot = null, $b4fdfdeec9399ede$var$didScheduleMicrotask = !1, $b4fdfdeec9399ede$var$mightHavePendingSyncWork = !1, $b4fdfdeec9399ede$var$isFlushingWork = !1, $b4fdfdeec9399ede$var$currentEventTransitionLane = 0;
function $b4fdfdeec9399ede$var$ensureRootIsScheduled(root) {
    root !== $b4fdfdeec9399ede$var$lastScheduledRoot && null === root.next && (null === $b4fdfdeec9399ede$var$lastScheduledRoot ? $b4fdfdeec9399ede$var$firstScheduledRoot = $b4fdfdeec9399ede$var$lastScheduledRoot = root : $b4fdfdeec9399ede$var$lastScheduledRoot = $b4fdfdeec9399ede$var$lastScheduledRoot.next = root);
    $b4fdfdeec9399ede$var$mightHavePendingSyncWork = !0;
    $b4fdfdeec9399ede$var$didScheduleMicrotask || ($b4fdfdeec9399ede$var$didScheduleMicrotask = !0, $b4fdfdeec9399ede$var$scheduleImmediateRootScheduleTask());
}
function $b4fdfdeec9399ede$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$b4fdfdeec9399ede$var$isFlushingWork && $b4fdfdeec9399ede$var$mightHavePendingSyncWork) {
        $b4fdfdeec9399ede$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $b4fdfdeec9399ede$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $b4fdfdeec9399ede$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $b4fdfdeec9399ede$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $b4fdfdeec9399ede$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $b4fdfdeec9399ede$var$getNextLanes(root$174, root$174 === $b4fdfdeec9399ede$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $b4fdfdeec9399ede$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $b4fdfdeec9399ede$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $b4fdfdeec9399ede$var$isFlushingWork = !1;
    }
}
function $b4fdfdeec9399ede$var$processRootScheduleInImmediateTask() {
    $b4fdfdeec9399ede$var$processRootScheduleInMicrotask();
}
function $b4fdfdeec9399ede$var$processRootScheduleInMicrotask() {
    $b4fdfdeec9399ede$var$mightHavePendingSyncWork = $b4fdfdeec9399ede$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $b4fdfdeec9399ede$var$currentEventTransitionLane && ($b4fdfdeec9399ede$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $b4fdfdeec9399ede$var$currentEventTransitionLane), $b4fdfdeec9399ede$var$currentEventTransitionLane = 0);
    for(var currentTime = $b4fdfdeec9399ede$var$now(), prev = null, root = $b4fdfdeec9399ede$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $b4fdfdeec9399ede$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $b4fdfdeec9399ede$var$firstScheduledRoot = next : prev.next = next, null === next && ($b4fdfdeec9399ede$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $b4fdfdeec9399ede$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $b4fdfdeec9399ede$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $b4fdfdeec9399ede$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $b4fdfdeec9399ede$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $b4fdfdeec9399ede$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $b4fdfdeec9399ede$var$workInProgressRoot;
    suspendedLanes = $b4fdfdeec9399ede$var$workInProgressRootRenderLanes;
    suspendedLanes = $b4fdfdeec9399ede$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $b4fdfdeec9399ede$var$workInProgressSuspendedReason || 9 === $b4fdfdeec9399ede$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $b4fdfdeec9399ede$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $b4fdfdeec9399ede$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $b4fdfdeec9399ede$var$cancelCallback$1(pingedLanes);
        switch($b4fdfdeec9399ede$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $b4fdfdeec9399ede$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $b4fdfdeec9399ede$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $b4fdfdeec9399ede$var$IdlePriority;
                break;
            default:
                suspendedLanes = $b4fdfdeec9399ede$var$NormalPriority$1;
        }
        pingedLanes = $b4fdfdeec9399ede$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $b4fdfdeec9399ede$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $b4fdfdeec9399ede$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $b4fdfdeec9399ede$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $b4fdfdeec9399ede$var$pendingEffectsStatus && 5 !== $b4fdfdeec9399ede$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($b4fdfdeec9399ede$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $b4fdfdeec9399ede$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $b4fdfdeec9399ede$var$getNextLanes(root, root === $b4fdfdeec9399ede$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $b4fdfdeec9399ede$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $b4fdfdeec9399ede$var$scheduleTaskForRootDuringMicrotask(root, $b4fdfdeec9399ede$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $b4fdfdeec9399ede$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $b4fdfdeec9399ede$var$performSyncWorkOnRoot(root, lanes) {
    if ($b4fdfdeec9399ede$var$flushPendingEffects()) return null;
    $b4fdfdeec9399ede$var$performWorkOnRoot(root, lanes, !0);
}
function $b4fdfdeec9399ede$var$scheduleImmediateRootScheduleTask() {
    $b4fdfdeec9399ede$var$scheduleMicrotask(function() {
        0 !== ($b4fdfdeec9399ede$var$executionContext & 6) ? $b4fdfdeec9399ede$var$scheduleCallback$3($b4fdfdeec9399ede$var$ImmediatePriority, $b4fdfdeec9399ede$var$processRootScheduleInImmediateTask) : $b4fdfdeec9399ede$var$processRootScheduleInMicrotask();
    });
}
function $b4fdfdeec9399ede$var$requestTransitionLane() {
    0 === $b4fdfdeec9399ede$var$currentEventTransitionLane && ($b4fdfdeec9399ede$var$currentEventTransitionLane = $b4fdfdeec9399ede$var$claimNextTransitionLane());
    return $b4fdfdeec9399ede$var$currentEventTransitionLane;
}
function $b4fdfdeec9399ede$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $b4fdfdeec9399ede$var$sanitizeURL("" + actionProp);
}
function $b4fdfdeec9399ede$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $b4fdfdeec9399ede$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $b4fdfdeec9399ede$var$coerceFormActionProp((nativeEventTarget[$b4fdfdeec9399ede$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$b4fdfdeec9399ede$var$internalPropsKey] || null) ? $b4fdfdeec9399ede$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $b4fdfdeec9399ede$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $b4fdfdeec9399ede$var$currentEventTransitionLane) {
                                var formData = submitter ? $b4fdfdeec9399ede$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $b4fdfdeec9399ede$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $b4fdfdeec9399ede$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $b4fdfdeec9399ede$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $b4fdfdeec9399ede$var$i$jscomp$inline_1528 = 0; $b4fdfdeec9399ede$var$i$jscomp$inline_1528 < $b4fdfdeec9399ede$var$simpleEventPluginEvents.length; $b4fdfdeec9399ede$var$i$jscomp$inline_1528++){
    var $b4fdfdeec9399ede$var$eventName$jscomp$inline_1529 = $b4fdfdeec9399ede$var$simpleEventPluginEvents[$b4fdfdeec9399ede$var$i$jscomp$inline_1528], $b4fdfdeec9399ede$var$domEventName$jscomp$inline_1530 = $b4fdfdeec9399ede$var$eventName$jscomp$inline_1529.toLowerCase(), $b4fdfdeec9399ede$var$capitalizedEvent$jscomp$inline_1531 = $b4fdfdeec9399ede$var$eventName$jscomp$inline_1529[0].toUpperCase() + $b4fdfdeec9399ede$var$eventName$jscomp$inline_1529.slice(1);
    $b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$domEventName$jscomp$inline_1530, "on" + $b4fdfdeec9399ede$var$capitalizedEvent$jscomp$inline_1531);
}
$b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$ANIMATION_END, "onAnimationEnd");
$b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$ANIMATION_ITERATION, "onAnimationIteration");
$b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$ANIMATION_START, "onAnimationStart");
$b4fdfdeec9399ede$var$registerSimpleEvent("dblclick", "onDoubleClick");
$b4fdfdeec9399ede$var$registerSimpleEvent("focusin", "onFocus");
$b4fdfdeec9399ede$var$registerSimpleEvent("focusout", "onBlur");
$b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$TRANSITION_RUN, "onTransitionRun");
$b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$TRANSITION_START, "onTransitionStart");
$b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$TRANSITION_CANCEL, "onTransitionCancel");
$b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$TRANSITION_END, "onTransitionEnd");
$b4fdfdeec9399ede$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b4fdfdeec9399ede$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b4fdfdeec9399ede$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b4fdfdeec9399ede$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b4fdfdeec9399ede$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b4fdfdeec9399ede$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b4fdfdeec9399ede$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b4fdfdeec9399ede$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b4fdfdeec9399ede$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b4fdfdeec9399ede$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b4fdfdeec9399ede$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b4fdfdeec9399ede$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($b4fdfdeec9399ede$var$mediaEventTypes));
function $b4fdfdeec9399ede$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b4fdfdeec9399ede$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b4fdfdeec9399ede$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $b4fdfdeec9399ede$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$b4fdfdeec9399ede$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$b4fdfdeec9399ede$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($b4fdfdeec9399ede$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $b4fdfdeec9399ede$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $b4fdfdeec9399ede$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $b4fdfdeec9399ede$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $b4fdfdeec9399ede$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$b4fdfdeec9399ede$var$listeningMarker]) {
        rootContainerElement[$b4fdfdeec9399ede$var$listeningMarker] = !0;
        $b4fdfdeec9399ede$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($b4fdfdeec9399ede$var$nonDelegatedEvents.has(domEventName) || $b4fdfdeec9399ede$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $b4fdfdeec9399ede$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$b4fdfdeec9399ede$var$listeningMarker] || (ownerDocument[$b4fdfdeec9399ede$var$listeningMarker] = !0, $b4fdfdeec9399ede$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $b4fdfdeec9399ede$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($b4fdfdeec9399ede$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $b4fdfdeec9399ede$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $b4fdfdeec9399ede$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $b4fdfdeec9399ede$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$b4fdfdeec9399ede$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $b4fdfdeec9399ede$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $b4fdfdeec9399ede$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $b4fdfdeec9399ede$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $b4fdfdeec9399ede$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $b4fdfdeec9399ede$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $b4fdfdeec9399ede$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticTouchEvent;
                        break;
                    case $b4fdfdeec9399ede$var$ANIMATION_END:
                    case $b4fdfdeec9399ede$var$ANIMATION_ITERATION:
                    case $b4fdfdeec9399ede$var$ANIMATION_START:
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticAnimationEvent;
                        break;
                    case $b4fdfdeec9399ede$var$TRANSITION_END:
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $b4fdfdeec9399ede$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($b4fdfdeec9399ede$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $b4fdfdeec9399ede$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($b4fdfdeec9399ede$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$b4fdfdeec9399ede$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $b4fdfdeec9399ede$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $b4fdfdeec9399ede$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $b4fdfdeec9399ede$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $b4fdfdeec9399ede$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $b4fdfdeec9399ede$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $b4fdfdeec9399ede$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $b4fdfdeec9399ede$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $b4fdfdeec9399ede$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $b4fdfdeec9399ede$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $b4fdfdeec9399ede$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $b4fdfdeec9399ede$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $b4fdfdeec9399ede$var$getParent(inCapturePhase);
                                reactEventName = $b4fdfdeec9399ede$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $b4fdfdeec9399ede$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $b4fdfdeec9399ede$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $b4fdfdeec9399ede$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $b4fdfdeec9399ede$var$getTargetInstForChangeEvent;
                else if ($b4fdfdeec9399ede$var$isTextInputElement(reactName)) {
                    if ($b4fdfdeec9399ede$var$isInputEventSupported) getTargetInstFunc = $b4fdfdeec9399ede$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $b4fdfdeec9399ede$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $b4fdfdeec9399ede$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $b4fdfdeec9399ede$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $b4fdfdeec9399ede$var$getTargetInstForChangeEvent) : getTargetInstFunc = $b4fdfdeec9399ede$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $b4fdfdeec9399ede$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $b4fdfdeec9399ede$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $b4fdfdeec9399ede$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($b4fdfdeec9399ede$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $b4fdfdeec9399ede$var$activeElement = handleEventFunc, $b4fdfdeec9399ede$var$activeElementInst = targetInst, $b4fdfdeec9399ede$var$lastSelection = null;
                    break;
                case "focusout":
                    $b4fdfdeec9399ede$var$lastSelection = $b4fdfdeec9399ede$var$activeElementInst = $b4fdfdeec9399ede$var$activeElement = null;
                    break;
                case "mousedown":
                    $b4fdfdeec9399ede$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b4fdfdeec9399ede$var$mouseDown = !1;
                    $b4fdfdeec9399ede$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($b4fdfdeec9399ede$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $b4fdfdeec9399ede$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($b4fdfdeec9399ede$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $b4fdfdeec9399ede$var$isComposing ? $b4fdfdeec9399ede$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($b4fdfdeec9399ede$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($b4fdfdeec9399ede$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $b4fdfdeec9399ede$var$isComposing && (fallbackData = $b4fdfdeec9399ede$var$getData()) : ($b4fdfdeec9399ede$var$root = nativeEventTarget, $b4fdfdeec9399ede$var$startText = "value" in $b4fdfdeec9399ede$var$root ? $b4fdfdeec9399ede$var$root.value : $b4fdfdeec9399ede$var$root.textContent, $b4fdfdeec9399ede$var$isComposing = !0)), handleEventFunc = $b4fdfdeec9399ede$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $b4fdfdeec9399ede$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $b4fdfdeec9399ede$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $b4fdfdeec9399ede$var$canUseTextInputEvent ? $b4fdfdeec9399ede$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $b4fdfdeec9399ede$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $b4fdfdeec9399ede$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $b4fdfdeec9399ede$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $b4fdfdeec9399ede$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $b4fdfdeec9399ede$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $b4fdfdeec9399ede$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $b4fdfdeec9399ede$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $b4fdfdeec9399ede$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($b4fdfdeec9399ede$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $b4fdfdeec9399ede$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($b4fdfdeec9399ede$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $b4fdfdeec9399ede$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $b4fdfdeec9399ede$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $b4fdfdeec9399ede$var$getListener(target, registrationName), null != stateNode && listeners.unshift($b4fdfdeec9399ede$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $b4fdfdeec9399ede$var$getListener(target, registrationName), null != stateNode && listeners.push($b4fdfdeec9399ede$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $b4fdfdeec9399ede$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $b4fdfdeec9399ede$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $b4fdfdeec9399ede$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($b4fdfdeec9399ede$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($b4fdfdeec9399ede$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $b4fdfdeec9399ede$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $b4fdfdeec9399ede$var$normalizeMarkupForTextOrAttribute(clientText);
    return $b4fdfdeec9399ede$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $b4fdfdeec9399ede$var$noop$1() {}
function $b4fdfdeec9399ede$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $b4fdfdeec9399ede$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $b4fdfdeec9399ede$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $b4fdfdeec9399ede$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $b4fdfdeec9399ede$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $b4fdfdeec9399ede$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $b4fdfdeec9399ede$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $b4fdfdeec9399ede$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b4fdfdeec9399ede$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $b4fdfdeec9399ede$var$setProp(domElement, tag, "name", props.name, props, null), $b4fdfdeec9399ede$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $b4fdfdeec9399ede$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $b4fdfdeec9399ede$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($b4fdfdeec9399ede$var$setProp(domElement, tag, "encType", props.encType, props, null), $b4fdfdeec9399ede$var$setProp(domElement, tag, "method", props.method, props, null), $b4fdfdeec9399ede$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b4fdfdeec9399ede$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b4fdfdeec9399ede$var$noop$1);
            break;
        case "onScroll":
            null != value && $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $b4fdfdeec9399ede$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("toggle", domElement);
            $b4fdfdeec9399ede$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $b4fdfdeec9399ede$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $b4fdfdeec9399ede$var$aliases.get(key) || key, $b4fdfdeec9399ede$var$setValueForAttribute(domElement, key, value);
    }
}
function $b4fdfdeec9399ede$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $b4fdfdeec9399ede$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $b4fdfdeec9399ede$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $b4fdfdeec9399ede$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b4fdfdeec9399ede$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$b4fdfdeec9399ede$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$b4fdfdeec9399ede$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $b4fdfdeec9399ede$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $b4fdfdeec9399ede$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("error", domElement);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(137, tag));
                    default:
                        $b4fdfdeec9399ede$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $b4fdfdeec9399ede$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $b4fdfdeec9399ede$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $b4fdfdeec9399ede$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $b4fdfdeec9399ede$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $b4fdfdeec9399ede$var$track(domElement);
            return;
        case "select":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $b4fdfdeec9399ede$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $b4fdfdeec9399ede$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(91));
                    break;
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $b4fdfdeec9399ede$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $b4fdfdeec9399ede$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("toggle", domElement);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("cancel", domElement);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $b4fdfdeec9399ede$var$mediaEventTypes.length; hasSrc++)$b4fdfdeec9399ede$var$listenToNonDelegatedEvent($b4fdfdeec9399ede$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("error", domElement);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("error", domElement), $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(137, tag));
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($b4fdfdeec9399ede$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $b4fdfdeec9399ede$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $b4fdfdeec9399ede$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $b4fdfdeec9399ede$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $b4fdfdeec9399ede$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $b4fdfdeec9399ede$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $b4fdfdeec9399ede$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $b4fdfdeec9399ede$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $b4fdfdeec9399ede$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $b4fdfdeec9399ede$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $b4fdfdeec9399ede$var$updateOptions(domElement, !!lastProps, tag, !0) : $b4fdfdeec9399ede$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $b4fdfdeec9399ede$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $b4fdfdeec9399ede$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $b4fdfdeec9399ede$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($b4fdfdeec9399ede$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $b4fdfdeec9399ede$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $b4fdfdeec9399ede$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $b4fdfdeec9399ede$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $b4fdfdeec9399ede$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $b4fdfdeec9399ede$var$eventsEnabled = null, $b4fdfdeec9399ede$var$selectionInformation = null;
function $b4fdfdeec9399ede$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $b4fdfdeec9399ede$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $b4fdfdeec9399ede$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $b4fdfdeec9399ede$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $b4fdfdeec9399ede$var$currentPopstateTransitionEvent = null;
function $b4fdfdeec9399ede$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $b4fdfdeec9399ede$var$currentPopstateTransitionEvent) return !1;
        $b4fdfdeec9399ede$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $b4fdfdeec9399ede$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $b4fdfdeec9399ede$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $b4fdfdeec9399ede$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $b4fdfdeec9399ede$var$localPromise = "function" === typeof Promise ? Promise : void 0, $b4fdfdeec9399ede$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b4fdfdeec9399ede$var$localPromise ? function(callback) {
    return $b4fdfdeec9399ede$var$localPromise.resolve(null).then(callback).catch($b4fdfdeec9399ede$var$handleErrorInNextTick);
} : $b4fdfdeec9399ede$var$scheduleTimeout;
function $b4fdfdeec9399ede$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $b4fdfdeec9399ede$var$isSingletonScope(type) {
    return "head" === type;
}
function $b4fdfdeec9399ede$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $b4fdfdeec9399ede$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $b4fdfdeec9399ede$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $b4fdfdeec9399ede$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$b4fdfdeec9399ede$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $b4fdfdeec9399ede$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $b4fdfdeec9399ede$var$retryIfBlockedOn(suspenseInstance);
}
function $b4fdfdeec9399ede$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $b4fdfdeec9399ede$var$clearContainerSparingly(node);
                $b4fdfdeec9399ede$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $b4fdfdeec9399ede$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$b4fdfdeec9399ede$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $b4fdfdeec9399ede$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $b4fdfdeec9399ede$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $b4fdfdeec9399ede$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $b4fdfdeec9399ede$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $b4fdfdeec9399ede$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $b4fdfdeec9399ede$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $b4fdfdeec9399ede$var$previousHydratableOnEnteringScopedSingleton = null;
function $b4fdfdeec9399ede$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $b4fdfdeec9399ede$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $b4fdfdeec9399ede$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(451));
    }
}
function $b4fdfdeec9399ede$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $b4fdfdeec9399ede$var$detachDeletedInstance(instance);
}
var $b4fdfdeec9399ede$var$preloadPropsMap = new Map(), $b4fdfdeec9399ede$var$preconnectsSet = new Set();
function $b4fdfdeec9399ede$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $b4fdfdeec9399ede$var$previousDispatcher = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.d;
$b4fdfdeec9399ede$var$ReactDOMSharedInternals.d = {
    f: $b4fdfdeec9399ede$var$flushSyncWork,
    r: $b4fdfdeec9399ede$var$requestFormReset,
    D: $b4fdfdeec9399ede$var$prefetchDNS,
    C: $b4fdfdeec9399ede$var$preconnect,
    L: $b4fdfdeec9399ede$var$preload,
    m: $b4fdfdeec9399ede$var$preloadModule,
    X: $b4fdfdeec9399ede$var$preinitScript,
    S: $b4fdfdeec9399ede$var$preinitStyle,
    M: $b4fdfdeec9399ede$var$preinitModuleScript
};
function $b4fdfdeec9399ede$var$flushSyncWork() {
    var previousWasRendering = $b4fdfdeec9399ede$var$previousDispatcher.f(), wasRendering = $b4fdfdeec9399ede$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $b4fdfdeec9399ede$var$requestFormReset(form) {
    var formInst = $b4fdfdeec9399ede$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $b4fdfdeec9399ede$var$requestFormReset$1(formInst) : $b4fdfdeec9399ede$var$previousDispatcher.r(form);
}
var $b4fdfdeec9399ede$var$globalDocument = "undefined" === typeof document ? null : document;
function $b4fdfdeec9399ede$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $b4fdfdeec9399ede$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $b4fdfdeec9399ede$var$preconnectsSet.has(limitedEscapedHref) || ($b4fdfdeec9399ede$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $b4fdfdeec9399ede$var$setInitialProperties(href, "link", rel), $b4fdfdeec9399ede$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $b4fdfdeec9399ede$var$prefetchDNS(href) {
    $b4fdfdeec9399ede$var$previousDispatcher.D(href);
    $b4fdfdeec9399ede$var$preconnectAs("dns-prefetch", href, null);
}
function $b4fdfdeec9399ede$var$preconnect(href, crossOrigin) {
    $b4fdfdeec9399ede$var$previousDispatcher.C(href, crossOrigin);
    $b4fdfdeec9399ede$var$preconnectAs("preconnect", href, crossOrigin);
}
function $b4fdfdeec9399ede$var$preload(href, as, options) {
    $b4fdfdeec9399ede$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $b4fdfdeec9399ede$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $b4fdfdeec9399ede$var$getStyleKey(href);
                break;
            case "script":
                key = $b4fdfdeec9399ede$var$getScriptKey(href);
        }
        $b4fdfdeec9399ede$var$preloadPropsMap.has(key) || (href = $b4fdfdeec9399ede$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $b4fdfdeec9399ede$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($b4fdfdeec9399ede$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($b4fdfdeec9399ede$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $b4fdfdeec9399ede$var$setInitialProperties(as, "link", href), $b4fdfdeec9399ede$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $b4fdfdeec9399ede$var$preloadModule(href, options) {
    $b4fdfdeec9399ede$var$previousDispatcher.m(href, options);
    var ownerDocument = $b4fdfdeec9399ede$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $b4fdfdeec9399ede$var$getScriptKey(href);
        }
        if (!$b4fdfdeec9399ede$var$preloadPropsMap.has(key) && (href = $b4fdfdeec9399ede$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $b4fdfdeec9399ede$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($b4fdfdeec9399ede$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $b4fdfdeec9399ede$var$setInitialProperties(as, "link", href);
            $b4fdfdeec9399ede$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $b4fdfdeec9399ede$var$preinitStyle(href, precedence, options) {
    $b4fdfdeec9399ede$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $b4fdfdeec9399ede$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $b4fdfdeec9399ede$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $b4fdfdeec9399ede$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($b4fdfdeec9399ede$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $b4fdfdeec9399ede$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $b4fdfdeec9399ede$var$preloadPropsMap.get(key)) && $b4fdfdeec9399ede$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $b4fdfdeec9399ede$var$markNodeAsHoistable(link);
                $b4fdfdeec9399ede$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $b4fdfdeec9399ede$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $b4fdfdeec9399ede$var$preinitScript(src, options) {
    $b4fdfdeec9399ede$var$previousDispatcher.X(src, options);
    var ownerDocument = $b4fdfdeec9399ede$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b4fdfdeec9399ede$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b4fdfdeec9399ede$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b4fdfdeec9399ede$var$getScriptSelectorFromKey(key)), resource || (src = $b4fdfdeec9399ede$var$assign({
            src: src,
            async: !0
        }, options), (options = $b4fdfdeec9399ede$var$preloadPropsMap.get(key)) && $b4fdfdeec9399ede$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b4fdfdeec9399ede$var$markNodeAsHoistable(resource), $b4fdfdeec9399ede$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b4fdfdeec9399ede$var$preinitModuleScript(src, options) {
    $b4fdfdeec9399ede$var$previousDispatcher.M(src, options);
    var ownerDocument = $b4fdfdeec9399ede$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b4fdfdeec9399ede$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b4fdfdeec9399ede$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b4fdfdeec9399ede$var$getScriptSelectorFromKey(key)), resource || (src = $b4fdfdeec9399ede$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $b4fdfdeec9399ede$var$preloadPropsMap.get(key)) && $b4fdfdeec9399ede$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b4fdfdeec9399ede$var$markNodeAsHoistable(resource), $b4fdfdeec9399ede$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b4fdfdeec9399ede$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $b4fdfdeec9399ede$var$rootInstanceStackCursor.current) ? $b4fdfdeec9399ede$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $b4fdfdeec9399ede$var$getStyleKey(pendingProps.href), pendingProps = $b4fdfdeec9399ede$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $b4fdfdeec9399ede$var$getStyleKey(pendingProps.href);
                var styles$244 = $b4fdfdeec9399ede$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($b4fdfdeec9399ede$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $b4fdfdeec9399ede$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $b4fdfdeec9399ede$var$preloadPropsMap.set(type, pendingProps), styles$244 || $b4fdfdeec9399ede$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $b4fdfdeec9399ede$var$getScriptKey(pendingProps), pendingProps = $b4fdfdeec9399ede$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(444, type));
    }
}
function $b4fdfdeec9399ede$var$getStyleKey(href) {
    return 'href="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $b4fdfdeec9399ede$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $b4fdfdeec9399ede$var$stylesheetPropsFromRawProps(rawProps) {
    return $b4fdfdeec9399ede$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $b4fdfdeec9399ede$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $b4fdfdeec9399ede$var$setInitialProperties(key, "link", preloadProps), $b4fdfdeec9399ede$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $b4fdfdeec9399ede$var$getScriptKey(src) {
    return '[src="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $b4fdfdeec9399ede$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $b4fdfdeec9399ede$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $b4fdfdeec9399ede$var$markNodeAsHoistable(instance), instance;
            var styleProps = $b4fdfdeec9399ede$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $b4fdfdeec9399ede$var$markNodeAsHoistable(instance);
            $b4fdfdeec9399ede$var$setInitialProperties(instance, "style", styleProps);
            $b4fdfdeec9399ede$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $b4fdfdeec9399ede$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($b4fdfdeec9399ede$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $b4fdfdeec9399ede$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $b4fdfdeec9399ede$var$stylesheetPropsFromRawProps(props);
            (styleProps = $b4fdfdeec9399ede$var$preloadPropsMap.get(styleProps)) && $b4fdfdeec9399ede$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $b4fdfdeec9399ede$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b4fdfdeec9399ede$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $b4fdfdeec9399ede$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $b4fdfdeec9399ede$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($b4fdfdeec9399ede$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $b4fdfdeec9399ede$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $b4fdfdeec9399ede$var$preloadPropsMap.get(instance$250)) instance = $b4fdfdeec9399ede$var$assign({}, props), $b4fdfdeec9399ede$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $b4fdfdeec9399ede$var$markNodeAsHoistable(styleProps);
            $b4fdfdeec9399ede$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $b4fdfdeec9399ede$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $b4fdfdeec9399ede$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $b4fdfdeec9399ede$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $b4fdfdeec9399ede$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $b4fdfdeec9399ede$var$tagCaches = null;
function $b4fdfdeec9399ede$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $b4fdfdeec9399ede$var$tagCaches) {
        var cache = new Map();
        var caches = $b4fdfdeec9399ede$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $b4fdfdeec9399ede$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$b4fdfdeec9399ede$var$internalHoistableMarker] || node[$b4fdfdeec9399ede$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $b4fdfdeec9399ede$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $b4fdfdeec9399ede$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $b4fdfdeec9399ede$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $b4fdfdeec9399ede$var$suspendedState = null;
function $b4fdfdeec9399ede$var$noop() {}
function $b4fdfdeec9399ede$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $b4fdfdeec9399ede$var$suspendedState) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(475));
    var state = $b4fdfdeec9399ede$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $b4fdfdeec9399ede$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($b4fdfdeec9399ede$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $b4fdfdeec9399ede$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $b4fdfdeec9399ede$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $b4fdfdeec9399ede$var$stylesheetPropsFromRawProps(props);
            (key = $b4fdfdeec9399ede$var$preloadPropsMap.get(key)) && $b4fdfdeec9399ede$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $b4fdfdeec9399ede$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b4fdfdeec9399ede$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $b4fdfdeec9399ede$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $b4fdfdeec9399ede$var$waitForCommitToBeReady() {
    if (null === $b4fdfdeec9399ede$var$suspendedState) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(475));
    var state = $b4fdfdeec9399ede$var$suspendedState;
    state.stylesheets && 0 === state.count && $b4fdfdeec9399ede$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $b4fdfdeec9399ede$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $b4fdfdeec9399ede$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $b4fdfdeec9399ede$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $b4fdfdeec9399ede$var$precedencesByRoot = null;
function $b4fdfdeec9399ede$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $b4fdfdeec9399ede$var$precedencesByRoot = new Map(), resources.forEach($b4fdfdeec9399ede$var$insertStylesheetIntoRoot, state), $b4fdfdeec9399ede$var$precedencesByRoot = null, $b4fdfdeec9399ede$var$onUnsuspend.call(state));
}
function $b4fdfdeec9399ede$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $b4fdfdeec9399ede$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $b4fdfdeec9399ede$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $b4fdfdeec9399ede$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $b4fdfdeec9399ede$var$HostTransitionContext = {
    $$typeof: $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $b4fdfdeec9399ede$var$sharedNotPendingObject,
    _currentValue2: $b4fdfdeec9399ede$var$sharedNotPendingObject,
    _threadCount: 0
};
function $b4fdfdeec9399ede$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $b4fdfdeec9399ede$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b4fdfdeec9399ede$var$createLaneMap(0);
    this.hiddenUpdates = $b4fdfdeec9399ede$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $b4fdfdeec9399ede$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $b4fdfdeec9399ede$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $b4fdfdeec9399ede$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $b4fdfdeec9399ede$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $b4fdfdeec9399ede$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $b4fdfdeec9399ede$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $b4fdfdeec9399ede$var$emptyContextObject;
    parentComponent = $b4fdfdeec9399ede$var$emptyContextObject;
    return parentComponent;
}
function $b4fdfdeec9399ede$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $b4fdfdeec9399ede$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $b4fdfdeec9399ede$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $b4fdfdeec9399ede$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($b4fdfdeec9399ede$var$scheduleUpdateOnFiber(element, rootFiber, lane), $b4fdfdeec9399ede$var$entangleTransitions(element, rootFiber, lane));
}
function $b4fdfdeec9399ede$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $b4fdfdeec9399ede$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $b4fdfdeec9399ede$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $b4fdfdeec9399ede$var$markRetryLaneImpl(fiber, retryLane);
}
function $b4fdfdeec9399ede$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $b4fdfdeec9399ede$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $b4fdfdeec9399ede$var$_enabled = !0;
function $b4fdfdeec9399ede$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b4fdfdeec9399ede$var$ReactSharedInternals.T;
    $b4fdfdeec9399ede$var$ReactSharedInternals.T = null;
    var previousPriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
    try {
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 2, $b4fdfdeec9399ede$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = previousPriority, $b4fdfdeec9399ede$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b4fdfdeec9399ede$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b4fdfdeec9399ede$var$ReactSharedInternals.T;
    $b4fdfdeec9399ede$var$ReactSharedInternals.T = null;
    var previousPriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
    try {
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 8, $b4fdfdeec9399ede$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = previousPriority, $b4fdfdeec9399ede$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b4fdfdeec9399ede$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($b4fdfdeec9399ede$var$_enabled) {
        var blockedOn = $b4fdfdeec9399ede$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $b4fdfdeec9399ede$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b4fdfdeec9399ede$var$return_targetInst, targetContainer), $b4fdfdeec9399ede$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($b4fdfdeec9399ede$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($b4fdfdeec9399ede$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $b4fdfdeec9399ede$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $b4fdfdeec9399ede$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $b4fdfdeec9399ede$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $b4fdfdeec9399ede$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $b4fdfdeec9399ede$var$ensureRootIsScheduled(fiber);
                                0 === ($b4fdfdeec9399ede$var$executionContext & 6) && ($b4fdfdeec9399ede$var$workInProgressRootRenderTargetTime = $b4fdfdeec9399ede$var$now() + 500, $b4fdfdeec9399ede$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(root, fiber, 2), $b4fdfdeec9399ede$var$flushSyncWork$1(), $b4fdfdeec9399ede$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $b4fdfdeec9399ede$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $b4fdfdeec9399ede$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b4fdfdeec9399ede$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $b4fdfdeec9399ede$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $b4fdfdeec9399ede$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $b4fdfdeec9399ede$var$getEventTarget(nativeEvent);
    return $b4fdfdeec9399ede$var$findInstanceBlockingTarget(nativeEvent);
}
var $b4fdfdeec9399ede$var$return_targetInst = null;
function $b4fdfdeec9399ede$var$findInstanceBlockingTarget(targetNode) {
    $b4fdfdeec9399ede$var$return_targetInst = null;
    targetNode = $b4fdfdeec9399ede$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $b4fdfdeec9399ede$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $b4fdfdeec9399ede$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $b4fdfdeec9399ede$var$return_targetInst = targetNode;
    return null;
}
function $b4fdfdeec9399ede$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($b4fdfdeec9399ede$var$getCurrentPriorityLevel()){
                case $b4fdfdeec9399ede$var$ImmediatePriority:
                    return 2;
                case $b4fdfdeec9399ede$var$UserBlockingPriority:
                    return 8;
                case $b4fdfdeec9399ede$var$NormalPriority$1:
                case $b4fdfdeec9399ede$var$LowPriority:
                    return 32;
                case $b4fdfdeec9399ede$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $b4fdfdeec9399ede$var$hasScheduledReplayAttempt = !1, $b4fdfdeec9399ede$var$queuedFocus = null, $b4fdfdeec9399ede$var$queuedDrag = null, $b4fdfdeec9399ede$var$queuedMouse = null, $b4fdfdeec9399ede$var$queuedPointers = new Map(), $b4fdfdeec9399ede$var$queuedPointerCaptures = new Map(), $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets = [], $b4fdfdeec9399ede$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $b4fdfdeec9399ede$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $b4fdfdeec9399ede$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $b4fdfdeec9399ede$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $b4fdfdeec9399ede$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $b4fdfdeec9399ede$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b4fdfdeec9399ede$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $b4fdfdeec9399ede$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $b4fdfdeec9399ede$var$getInstanceFromNode(blockedOn), null !== blockedOn && $b4fdfdeec9399ede$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $b4fdfdeec9399ede$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $b4fdfdeec9399ede$var$queuedFocus = $b4fdfdeec9399ede$var$accumulateOrCreateContinuousQueuedReplayableEvent($b4fdfdeec9399ede$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $b4fdfdeec9399ede$var$queuedDrag = $b4fdfdeec9399ede$var$accumulateOrCreateContinuousQueuedReplayableEvent($b4fdfdeec9399ede$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $b4fdfdeec9399ede$var$queuedMouse = $b4fdfdeec9399ede$var$accumulateOrCreateContinuousQueuedReplayableEvent($b4fdfdeec9399ede$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $b4fdfdeec9399ede$var$queuedPointers.set(pointerId, $b4fdfdeec9399ede$var$accumulateOrCreateContinuousQueuedReplayableEvent($b4fdfdeec9399ede$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $b4fdfdeec9399ede$var$queuedPointerCaptures.set(pointerId, $b4fdfdeec9399ede$var$accumulateOrCreateContinuousQueuedReplayableEvent($b4fdfdeec9399ede$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $b4fdfdeec9399ede$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $b4fdfdeec9399ede$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $b4fdfdeec9399ede$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $b4fdfdeec9399ede$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $b4fdfdeec9399ede$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $b4fdfdeec9399ede$var$requestUpdateLane();
                            lane = $b4fdfdeec9399ede$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $b4fdfdeec9399ede$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $b4fdfdeec9399ede$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $b4fdfdeec9399ede$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $b4fdfdeec9399ede$var$currentReplayingEvent = null;
        } else return targetContainers = $b4fdfdeec9399ede$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $b4fdfdeec9399ede$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $b4fdfdeec9399ede$var$replayUnblockedEvents() {
    $b4fdfdeec9399ede$var$hasScheduledReplayAttempt = !1;
    null !== $b4fdfdeec9399ede$var$queuedFocus && $b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEvent($b4fdfdeec9399ede$var$queuedFocus) && ($b4fdfdeec9399ede$var$queuedFocus = null);
    null !== $b4fdfdeec9399ede$var$queuedDrag && $b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEvent($b4fdfdeec9399ede$var$queuedDrag) && ($b4fdfdeec9399ede$var$queuedDrag = null);
    null !== $b4fdfdeec9399ede$var$queuedMouse && $b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEvent($b4fdfdeec9399ede$var$queuedMouse) && ($b4fdfdeec9399ede$var$queuedMouse = null);
    $b4fdfdeec9399ede$var$queuedPointers.forEach($b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEventInMap);
    $b4fdfdeec9399ede$var$queuedPointerCaptures.forEach($b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEventInMap);
}
function $b4fdfdeec9399ede$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $b4fdfdeec9399ede$var$hasScheduledReplayAttempt || ($b4fdfdeec9399ede$var$hasScheduledReplayAttempt = !0, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, $b4fdfdeec9399ede$var$replayUnblockedEvents)));
}
var $b4fdfdeec9399ede$var$lastScheduledReplayQueue = null;
function $b4fdfdeec9399ede$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $b4fdfdeec9399ede$var$lastScheduledReplayQueue !== formReplayingQueue && ($b4fdfdeec9399ede$var$lastScheduledReplayQueue = formReplayingQueue, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, function() {
        $b4fdfdeec9399ede$var$lastScheduledReplayQueue === formReplayingQueue && ($b4fdfdeec9399ede$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $b4fdfdeec9399ede$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $b4fdfdeec9399ede$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $b4fdfdeec9399ede$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $b4fdfdeec9399ede$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $b4fdfdeec9399ede$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $b4fdfdeec9399ede$var$queuedFocus && $b4fdfdeec9399ede$var$scheduleCallbackIfUnblocked($b4fdfdeec9399ede$var$queuedFocus, unblocked);
    null !== $b4fdfdeec9399ede$var$queuedDrag && $b4fdfdeec9399ede$var$scheduleCallbackIfUnblocked($b4fdfdeec9399ede$var$queuedDrag, unblocked);
    null !== $b4fdfdeec9399ede$var$queuedMouse && $b4fdfdeec9399ede$var$scheduleCallbackIfUnblocked($b4fdfdeec9399ede$var$queuedMouse, unblocked);
    $b4fdfdeec9399ede$var$queuedPointers.forEach(unblock);
    $b4fdfdeec9399ede$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets.length && (i = $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$b4fdfdeec9399ede$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$b4fdfdeec9399ede$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $b4fdfdeec9399ede$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$b4fdfdeec9399ede$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $b4fdfdeec9399ede$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $b4fdfdeec9399ede$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $b4fdfdeec9399ede$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b4fdfdeec9399ede$var$ReactDOMHydrationRoot.prototype.render = $b4fdfdeec9399ede$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(409));
    var current = root.current, lane = $b4fdfdeec9399ede$var$requestUpdateLane();
    $b4fdfdeec9399ede$var$updateContainerImpl(current, lane, children, root, null, null);
};
$b4fdfdeec9399ede$var$ReactDOMHydrationRoot.prototype.unmount = $b4fdfdeec9399ede$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $b4fdfdeec9399ede$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $b4fdfdeec9399ede$var$flushSyncWork$1();
        container[$b4fdfdeec9399ede$var$internalContainerInstanceKey] = null;
    }
};
function $b4fdfdeec9399ede$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b4fdfdeec9399ede$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $b4fdfdeec9399ede$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets[i].priority; i++);
        $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $b4fdfdeec9399ede$var$attemptExplicitHydrationTarget(target);
    }
};
var $b4fdfdeec9399ede$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $6cds3.version;
if ("19.1.0" !== $b4fdfdeec9399ede$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(527, $b4fdfdeec9399ede$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
$b4fdfdeec9399ede$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $b4fdfdeec9399ede$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $b4fdfdeec9399ede$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $b4fdfdeec9399ede$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $b4fdfdeec9399ede$var$ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b4fdfdeec9399ede$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b4fdfdeec9399ede$var$hook$jscomp$inline_2257.isDisabled && $b4fdfdeec9399ede$var$hook$jscomp$inline_2257.supportsFiber) try {
        $b4fdfdeec9399ede$var$rendererID = $b4fdfdeec9399ede$var$hook$jscomp$inline_2257.inject($b4fdfdeec9399ede$var$internals$jscomp$inline_2256), $b4fdfdeec9399ede$var$injectedHook = $b4fdfdeec9399ede$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$b4fdfdeec9399ede$export$882461b6382ed46c = function(container, options) {
    if (!$b4fdfdeec9399ede$var$isValidContainer(container)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b4fdfdeec9399ede$var$defaultOnUncaughtError, onCaughtError = $b4fdfdeec9399ede$var$defaultOnCaughtError, onRecoverableError = $b4fdfdeec9399ede$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $b4fdfdeec9399ede$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$b4fdfdeec9399ede$var$internalContainerInstanceKey] = options.current;
    $b4fdfdeec9399ede$var$listenToAllSupportedEvents(container);
    return new $b4fdfdeec9399ede$var$ReactDOMRoot(options);
};
$b4fdfdeec9399ede$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$b4fdfdeec9399ede$var$isValidContainer(container)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b4fdfdeec9399ede$var$defaultOnUncaughtError, onCaughtError = $b4fdfdeec9399ede$var$defaultOnCaughtError, onRecoverableError = $b4fdfdeec9399ede$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $b4fdfdeec9399ede$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $b4fdfdeec9399ede$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $b4fdfdeec9399ede$var$requestUpdateLane();
    isStrictMode = $b4fdfdeec9399ede$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $b4fdfdeec9399ede$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $b4fdfdeec9399ede$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $b4fdfdeec9399ede$var$markRootUpdated$1(initialChildren, options);
    $b4fdfdeec9399ede$var$ensureRootIsScheduled(initialChildren);
    container[$b4fdfdeec9399ede$var$internalContainerInstanceKey] = initialChildren.current;
    $b4fdfdeec9399ede$var$listenToAllSupportedEvents(container);
    return new $b4fdfdeec9399ede$var$ReactDOMHydrationRoot(initialChildren);
};
$b4fdfdeec9399ede$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("1c9zD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("87gsC"));

});
parcelRegister("87gsC", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $5e8bbeeced84f587$export$c4744153514ff05d; }, function (v) { return $5e8bbeeced84f587$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $5e8bbeeced84f587$export$3e506c1ccc9cc1a7; }, function (v) { return $5e8bbeeced84f587$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $5e8bbeeced84f587$export$e26fe2ed2fa76875; }, function (v) { return $5e8bbeeced84f587$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $5e8bbeeced84f587$export$502329bbf4b505b1; }, function (v) { return $5e8bbeeced84f587$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $5e8bbeeced84f587$export$6e3807111c4874c4; }, function (v) { return $5e8bbeeced84f587$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $5e8bbeeced84f587$export$c27134553091fb3a; }, function (v) { return $5e8bbeeced84f587$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $5e8bbeeced84f587$export$33ee1acdc04fd2a2; }, function (v) { return $5e8bbeeced84f587$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $5e8bbeeced84f587$export$b00a404bbd5edef2; }, function (v) { return $5e8bbeeced84f587$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $5e8bbeeced84f587$export$d66a1c1c77bd778b; }, function (v) { return $5e8bbeeced84f587$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $5e8bbeeced84f587$export$d3dfb8e4810cb555; }, function (v) { return $5e8bbeeced84f587$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $5e8bbeeced84f587$export$72fdf0e06517287b; }, function (v) { return $5e8bbeeced84f587$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $5e8bbeeced84f587$export$816d2913ae6b83b1; }, function (v) { return $5e8bbeeced84f587$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $5e8bbeeced84f587$export$61bcfe829111a1d0; }, function (v) { return $5e8bbeeced84f587$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $5e8bbeeced84f587$export$7ee8c9beb337bc3f; }, function (v) { return $5e8bbeeced84f587$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $5e8bbeeced84f587$export$b5836b71941fa3ed; }, function (v) { return $5e8bbeeced84f587$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $5e8bbeeced84f587$export$cf845f2c119da08a; }, function (v) { return $5e8bbeeced84f587$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5e8bbeeced84f587$export$c4744153514ff05d;
var $5e8bbeeced84f587$export$3e506c1ccc9cc1a7;
var $5e8bbeeced84f587$export$e26fe2ed2fa76875;
var $5e8bbeeced84f587$export$502329bbf4b505b1;
var $5e8bbeeced84f587$export$6e3807111c4874c4;
var $5e8bbeeced84f587$export$c27134553091fb3a;
var $5e8bbeeced84f587$export$33ee1acdc04fd2a2;
var $5e8bbeeced84f587$export$b00a404bbd5edef2;
var $5e8bbeeced84f587$export$d66a1c1c77bd778b;
var $5e8bbeeced84f587$export$d3dfb8e4810cb555;
var $5e8bbeeced84f587$export$72fdf0e06517287b;
var $5e8bbeeced84f587$export$816d2913ae6b83b1;
var $5e8bbeeced84f587$export$61bcfe829111a1d0;
var $5e8bbeeced84f587$export$7ee8c9beb337bc3f;
var $5e8bbeeced84f587$export$b5836b71941fa3ed;
var $5e8bbeeced84f587$export$cf845f2c119da08a;
"use strict";
function $5e8bbeeced84f587$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $5e8bbeeced84f587$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $5e8bbeeced84f587$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $5e8bbeeced84f587$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $5e8bbeeced84f587$var$compare(left, last)) rightIndex < length && 0 > $5e8bbeeced84f587$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $5e8bbeeced84f587$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $5e8bbeeced84f587$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$5e8bbeeced84f587$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $5e8bbeeced84f587$var$localPerformance = performance;
    $5e8bbeeced84f587$export$c4744153514ff05d = function() {
        return $5e8bbeeced84f587$var$localPerformance.now();
    };
} else {
    var $5e8bbeeced84f587$var$localDate = Date, $5e8bbeeced84f587$var$initialTime = $5e8bbeeced84f587$var$localDate.now();
    $5e8bbeeced84f587$export$c4744153514ff05d = function() {
        return $5e8bbeeced84f587$var$localDate.now() - $5e8bbeeced84f587$var$initialTime;
    };
}
var $5e8bbeeced84f587$var$taskQueue = [], $5e8bbeeced84f587$var$timerQueue = [], $5e8bbeeced84f587$var$taskIdCounter = 1, $5e8bbeeced84f587$var$currentTask = null, $5e8bbeeced84f587$var$currentPriorityLevel = 3, $5e8bbeeced84f587$var$isPerformingWork = !1, $5e8bbeeced84f587$var$isHostCallbackScheduled = !1, $5e8bbeeced84f587$var$isHostTimeoutScheduled = !1, $5e8bbeeced84f587$var$needsPaint = !1, $5e8bbeeced84f587$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $5e8bbeeced84f587$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $5e8bbeeced84f587$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $5e8bbeeced84f587$var$advanceTimers(currentTime) {
    for(var timer = $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$timerQueue); null !== timer;){
        if (null === timer.callback) $5e8bbeeced84f587$var$pop($5e8bbeeced84f587$var$timerQueue);
        else if (timer.startTime <= currentTime) $5e8bbeeced84f587$var$pop($5e8bbeeced84f587$var$timerQueue), timer.sortIndex = timer.expirationTime, $5e8bbeeced84f587$var$push($5e8bbeeced84f587$var$taskQueue, timer);
        else break;
        timer = $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$timerQueue);
    }
}
function $5e8bbeeced84f587$var$handleTimeout(currentTime) {
    $5e8bbeeced84f587$var$isHostTimeoutScheduled = !1;
    $5e8bbeeced84f587$var$advanceTimers(currentTime);
    if (!$5e8bbeeced84f587$var$isHostCallbackScheduled) {
        if (null !== $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$taskQueue)) $5e8bbeeced84f587$var$isHostCallbackScheduled = !0, $5e8bbeeced84f587$var$isMessageLoopRunning || ($5e8bbeeced84f587$var$isMessageLoopRunning = !0, $5e8bbeeced84f587$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$timerQueue);
            null !== firstTimer && $5e8bbeeced84f587$var$requestHostTimeout($5e8bbeeced84f587$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $5e8bbeeced84f587$var$isMessageLoopRunning = !1, $5e8bbeeced84f587$var$taskTimeoutID = -1, $5e8bbeeced84f587$var$frameInterval = 5, $5e8bbeeced84f587$var$startTime = -1;
function $5e8bbeeced84f587$var$shouldYieldToHost() {
    return $5e8bbeeced84f587$var$needsPaint ? !0 : $5e8bbeeced84f587$export$c4744153514ff05d() - $5e8bbeeced84f587$var$startTime < $5e8bbeeced84f587$var$frameInterval ? !1 : !0;
}
function $5e8bbeeced84f587$var$performWorkUntilDeadline() {
    $5e8bbeeced84f587$var$needsPaint = !1;
    if ($5e8bbeeced84f587$var$isMessageLoopRunning) {
        var currentTime = $5e8bbeeced84f587$export$c4744153514ff05d();
        $5e8bbeeced84f587$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $5e8bbeeced84f587$var$isHostCallbackScheduled = !1;
                $5e8bbeeced84f587$var$isHostTimeoutScheduled && ($5e8bbeeced84f587$var$isHostTimeoutScheduled = !1, $5e8bbeeced84f587$var$localClearTimeout($5e8bbeeced84f587$var$taskTimeoutID), $5e8bbeeced84f587$var$taskTimeoutID = -1);
                $5e8bbeeced84f587$var$isPerformingWork = !0;
                var previousPriorityLevel = $5e8bbeeced84f587$var$currentPriorityLevel;
                try {
                    b: {
                        $5e8bbeeced84f587$var$advanceTimers(currentTime);
                        for($5e8bbeeced84f587$var$currentTask = $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$taskQueue); null !== $5e8bbeeced84f587$var$currentTask && !($5e8bbeeced84f587$var$currentTask.expirationTime > currentTime && $5e8bbeeced84f587$var$shouldYieldToHost());){
                            var callback = $5e8bbeeced84f587$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $5e8bbeeced84f587$var$currentTask.callback = null;
                                $5e8bbeeced84f587$var$currentPriorityLevel = $5e8bbeeced84f587$var$currentTask.priorityLevel;
                                var continuationCallback = callback($5e8bbeeced84f587$var$currentTask.expirationTime <= currentTime);
                                currentTime = $5e8bbeeced84f587$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $5e8bbeeced84f587$var$currentTask.callback = continuationCallback;
                                    $5e8bbeeced84f587$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $5e8bbeeced84f587$var$currentTask === $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$taskQueue) && $5e8bbeeced84f587$var$pop($5e8bbeeced84f587$var$taskQueue);
                                $5e8bbeeced84f587$var$advanceTimers(currentTime);
                            } else $5e8bbeeced84f587$var$pop($5e8bbeeced84f587$var$taskQueue);
                            $5e8bbeeced84f587$var$currentTask = $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$taskQueue);
                        }
                        if (null !== $5e8bbeeced84f587$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$timerQueue);
                            null !== firstTimer && $5e8bbeeced84f587$var$requestHostTimeout($5e8bbeeced84f587$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $5e8bbeeced84f587$var$currentTask = null, $5e8bbeeced84f587$var$currentPriorityLevel = previousPriorityLevel, $5e8bbeeced84f587$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $5e8bbeeced84f587$var$schedulePerformWorkUntilDeadline() : $5e8bbeeced84f587$var$isMessageLoopRunning = !1;
        }
    }
}
var $5e8bbeeced84f587$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $5e8bbeeced84f587$var$localSetImmediate) $5e8bbeeced84f587$var$schedulePerformWorkUntilDeadline = function() {
    $5e8bbeeced84f587$var$localSetImmediate($5e8bbeeced84f587$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $5e8bbeeced84f587$var$channel = new MessageChannel(), $5e8bbeeced84f587$var$port = $5e8bbeeced84f587$var$channel.port2;
    $5e8bbeeced84f587$var$channel.port1.onmessage = $5e8bbeeced84f587$var$performWorkUntilDeadline;
    $5e8bbeeced84f587$var$schedulePerformWorkUntilDeadline = function() {
        $5e8bbeeced84f587$var$port.postMessage(null);
    };
} else $5e8bbeeced84f587$var$schedulePerformWorkUntilDeadline = function() {
    $5e8bbeeced84f587$var$localSetTimeout($5e8bbeeced84f587$var$performWorkUntilDeadline, 0);
};
function $5e8bbeeced84f587$var$requestHostTimeout(callback, ms) {
    $5e8bbeeced84f587$var$taskTimeoutID = $5e8bbeeced84f587$var$localSetTimeout(function() {
        callback($5e8bbeeced84f587$export$c4744153514ff05d());
    }, ms);
}
$5e8bbeeced84f587$export$3e506c1ccc9cc1a7 = 5;
$5e8bbeeced84f587$export$e26fe2ed2fa76875 = 1;
$5e8bbeeced84f587$export$502329bbf4b505b1 = 4;
$5e8bbeeced84f587$export$6e3807111c4874c4 = 3;
$5e8bbeeced84f587$export$c27134553091fb3a = null;
$5e8bbeeced84f587$export$33ee1acdc04fd2a2 = 2;
$5e8bbeeced84f587$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$5e8bbeeced84f587$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $5e8bbeeced84f587$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$5e8bbeeced84f587$export$d3dfb8e4810cb555 = function() {
    return $5e8bbeeced84f587$var$currentPriorityLevel;
};
$5e8bbeeced84f587$export$72fdf0e06517287b = function(eventHandler) {
    switch($5e8bbeeced84f587$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $5e8bbeeced84f587$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $5e8bbeeced84f587$var$currentPriorityLevel;
    $5e8bbeeced84f587$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $5e8bbeeced84f587$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$5e8bbeeced84f587$export$816d2913ae6b83b1 = function() {
    $5e8bbeeced84f587$var$needsPaint = !0;
};
$5e8bbeeced84f587$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $5e8bbeeced84f587$var$currentPriorityLevel;
    $5e8bbeeced84f587$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $5e8bbeeced84f587$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$5e8bbeeced84f587$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $5e8bbeeced84f587$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $5e8bbeeced84f587$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $5e8bbeeced84f587$var$push($5e8bbeeced84f587$var$timerQueue, priorityLevel), null === $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$taskQueue) && priorityLevel === $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$timerQueue) && ($5e8bbeeced84f587$var$isHostTimeoutScheduled ? ($5e8bbeeced84f587$var$localClearTimeout($5e8bbeeced84f587$var$taskTimeoutID), $5e8bbeeced84f587$var$taskTimeoutID = -1) : $5e8bbeeced84f587$var$isHostTimeoutScheduled = !0, $5e8bbeeced84f587$var$requestHostTimeout($5e8bbeeced84f587$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $5e8bbeeced84f587$var$push($5e8bbeeced84f587$var$taskQueue, priorityLevel), $5e8bbeeced84f587$var$isHostCallbackScheduled || $5e8bbeeced84f587$var$isPerformingWork || ($5e8bbeeced84f587$var$isHostCallbackScheduled = !0, $5e8bbeeced84f587$var$isMessageLoopRunning || ($5e8bbeeced84f587$var$isMessageLoopRunning = !0, $5e8bbeeced84f587$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$5e8bbeeced84f587$export$b5836b71941fa3ed = $5e8bbeeced84f587$var$shouldYieldToHost;
$5e8bbeeced84f587$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $5e8bbeeced84f587$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $5e8bbeeced84f587$var$currentPriorityLevel;
        $5e8bbeeced84f587$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $5e8bbeeced84f587$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("6cds3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1aGg9"));

});

parcelRegister("9nHRL", function(module, exports) {
'use strict';
function $6d4849ee44552f5f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d4849ee44552f5f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d4849ee44552f5f$var$checkDCE();

module.exports = (parcelRequire("ildVp"));

});
parcelRegister("ildVp", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $d5a4fd5d9d270c0d$export$69ce8ef3fe5cead0; }, function (v) { return $d5a4fd5d9d270c0d$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $d5a4fd5d9d270c0d$export$d39a5bbd09211389; }, function (v) { return $d5a4fd5d9d270c0d$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $d5a4fd5d9d270c0d$export$cd75ccfd720a3cd4; }, function (v) { return $d5a4fd5d9d270c0d$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $d5a4fd5d9d270c0d$export$a0816fa17a9e79be; }, function (v) { return $d5a4fd5d9d270c0d$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $d5a4fd5d9d270c0d$export$7292efcadded39f3; }, function (v) { return $d5a4fd5d9d270c0d$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $d5a4fd5d9d270c0d$export$da407abadb9b8f86; }, function (v) { return $d5a4fd5d9d270c0d$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $d5a4fd5d9d270c0d$export$314cfea32580671c; }, function (v) { return $d5a4fd5d9d270c0d$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $d5a4fd5d9d270c0d$export$513ccb98c53b8039; }, function (v) { return $d5a4fd5d9d270c0d$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $d5a4fd5d9d270c0d$export$dbca993bc2d264a; }, function (v) { return $d5a4fd5d9d270c0d$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $d5a4fd5d9d270c0d$export$4797a8006f0655d0; }, function (v) { return $d5a4fd5d9d270c0d$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $d5a4fd5d9d270c0d$export$c78a37762a8d58e1; }, function (v) { return $d5a4fd5d9d270c0d$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $d5a4fd5d9d270c0d$export$606f11b2eb45ecc6; }, function (v) { return $d5a4fd5d9d270c0d$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $d5a4fd5d9d270c0d$export$f7e8a0bf92324b1e; }, function (v) { return $d5a4fd5d9d270c0d$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $d5a4fd5d9d270c0d$export$83d89fbfd8236492; }, function (v) { return $d5a4fd5d9d270c0d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d5a4fd5d9d270c0d$export$69ce8ef3fe5cead0;
var $d5a4fd5d9d270c0d$export$d39a5bbd09211389;
var $d5a4fd5d9d270c0d$export$cd75ccfd720a3cd4;
var $d5a4fd5d9d270c0d$export$a0816fa17a9e79be;
var $d5a4fd5d9d270c0d$export$7292efcadded39f3;
var $d5a4fd5d9d270c0d$export$da407abadb9b8f86;
var $d5a4fd5d9d270c0d$export$314cfea32580671c;
var $d5a4fd5d9d270c0d$export$513ccb98c53b8039;
var $d5a4fd5d9d270c0d$export$dbca993bc2d264a;
var $d5a4fd5d9d270c0d$export$4797a8006f0655d0;
var $d5a4fd5d9d270c0d$export$c78a37762a8d58e1;
var $d5a4fd5d9d270c0d$export$606f11b2eb45ecc6;
var $d5a4fd5d9d270c0d$export$f7e8a0bf92324b1e;
var $d5a4fd5d9d270c0d$export$83d89fbfd8236492;
"use strict";

var $6cds3 = parcelRequire("6cds3");
function $d5a4fd5d9d270c0d$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $d5a4fd5d9d270c0d$var$noop() {}
var $d5a4fd5d9d270c0d$var$Internals = {
    d: {
        f: $d5a4fd5d9d270c0d$var$noop,
        r: function() {
            throw Error($d5a4fd5d9d270c0d$var$formatProdErrorMessage(522));
        },
        D: $d5a4fd5d9d270c0d$var$noop,
        C: $d5a4fd5d9d270c0d$var$noop,
        L: $d5a4fd5d9d270c0d$var$noop,
        m: $d5a4fd5d9d270c0d$var$noop,
        X: $d5a4fd5d9d270c0d$var$noop,
        S: $d5a4fd5d9d270c0d$var$noop,
        M: $d5a4fd5d9d270c0d$var$noop
    },
    p: 0,
    findDOMNode: null
}, $d5a4fd5d9d270c0d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $d5a4fd5d9d270c0d$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $d5a4fd5d9d270c0d$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $d5a4fd5d9d270c0d$var$ReactSharedInternals = $6cds3.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $d5a4fd5d9d270c0d$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$d5a4fd5d9d270c0d$export$69ce8ef3fe5cead0 = $d5a4fd5d9d270c0d$var$Internals;
$d5a4fd5d9d270c0d$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($d5a4fd5d9d270c0d$var$formatProdErrorMessage(299));
    return $d5a4fd5d9d270c0d$var$createPortal$1(children, container, null, key);
};
$d5a4fd5d9d270c0d$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $d5a4fd5d9d270c0d$var$ReactSharedInternals.T, previousUpdatePriority = $d5a4fd5d9d270c0d$var$Internals.p;
    try {
        if ($d5a4fd5d9d270c0d$var$ReactSharedInternals.T = null, $d5a4fd5d9d270c0d$var$Internals.p = 2, fn) return fn();
    } finally{
        $d5a4fd5d9d270c0d$var$ReactSharedInternals.T = previousTransition, $d5a4fd5d9d270c0d$var$Internals.p = previousUpdatePriority, $d5a4fd5d9d270c0d$var$Internals.d.f();
    }
};
$d5a4fd5d9d270c0d$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $d5a4fd5d9d270c0d$var$Internals.d.C(href, options));
};
$d5a4fd5d9d270c0d$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $d5a4fd5d9d270c0d$var$Internals.d.D(href);
};
$d5a4fd5d9d270c0d$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $d5a4fd5d9d270c0d$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $d5a4fd5d9d270c0d$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $d5a4fd5d9d270c0d$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$d5a4fd5d9d270c0d$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $d5a4fd5d9d270c0d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $d5a4fd5d9d270c0d$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $d5a4fd5d9d270c0d$var$Internals.d.M(href);
    }
};
$d5a4fd5d9d270c0d$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $d5a4fd5d9d270c0d$var$getCrossOriginStringAs(as, options.crossOrigin);
        $d5a4fd5d9d270c0d$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$d5a4fd5d9d270c0d$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $d5a4fd5d9d270c0d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $d5a4fd5d9d270c0d$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $d5a4fd5d9d270c0d$var$Internals.d.m(href);
    }
};
$d5a4fd5d9d270c0d$export$4797a8006f0655d0 = function(form) {
    $d5a4fd5d9d270c0d$var$Internals.d.r(form);
};
$d5a4fd5d9d270c0d$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$d5a4fd5d9d270c0d$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $d5a4fd5d9d270c0d$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$d5a4fd5d9d270c0d$export$f7e8a0bf92324b1e = function() {
    return $d5a4fd5d9d270c0d$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$d5a4fd5d9d270c0d$export$83d89fbfd8236492 = "19.1.0";

});



parcelRegister("hFtc0", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $cdcce91081d78ae7$export$2b8d127b894957b9; }, function (v) { return $cdcce91081d78ae7$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $cdcce91081d78ae7$export$cea3a54a6425200c; }, function (v) { return $cdcce91081d78ae7$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $cdcce91081d78ae7$export$a7c73072b1a182ae; }, function (v) { return $cdcce91081d78ae7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $cdcce91081d78ae7$export$9f27bc3417b4524d; }, function (v) { return $cdcce91081d78ae7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $cdcce91081d78ae7$export$db77ccec0bb4ccac; }, function (v) { return $cdcce91081d78ae7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $cdcce91081d78ae7$export$8392c0c9d3dcbd35; }, function (v) { return $cdcce91081d78ae7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cdcce91081d78ae7$export$ffb0004e005737fa; }, function (v) { return $cdcce91081d78ae7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $cdcce91081d78ae7$export$b624eff549462981; }, function (v) { return $cdcce91081d78ae7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $cdcce91081d78ae7$export$7897aa7841a5380c; }, function (v) { return $cdcce91081d78ae7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $cdcce91081d78ae7$export$602eac185826482c; }, function (v) { return $cdcce91081d78ae7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $cdcce91081d78ae7$export$e2c29f18771995cb; }, function (v) { return $cdcce91081d78ae7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cdcce91081d78ae7$export$5f8d39834fd61797; }, function (v) { return $cdcce91081d78ae7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cdcce91081d78ae7$export$74bf444e3cd11ea5; }, function (v) { return $cdcce91081d78ae7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $cdcce91081d78ae7$export$92387174baf9b227; }, function (v) { return $cdcce91081d78ae7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $cdcce91081d78ae7$export$ec112efeb987d9c6; }, function (v) { return $cdcce91081d78ae7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $cdcce91081d78ae7$export$b706b080d889d2c9; }, function (v) { return $cdcce91081d78ae7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $cdcce91081d78ae7$export$5be5a87408f70ddc; }, function (v) { return $cdcce91081d78ae7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $cdcce91081d78ae7$export$45a5e7f76e0caa8d; }, function (v) { return $cdcce91081d78ae7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $cdcce91081d78ae7$export$455c2e768291efa6; }, function (v) { return $cdcce91081d78ae7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $cdcce91081d78ae7$export$9522e17588c12572; }, function (v) { return $cdcce91081d78ae7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $cdcce91081d78ae7$export$2110ac352bb060b9; }, function (v) { return $cdcce91081d78ae7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $cdcce91081d78ae7$export$56885ab8b9c456ab; }, function (v) { return $cdcce91081d78ae7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $cdcce91081d78ae7$export$d927fcb6adf8f9de; }, function (v) { return $cdcce91081d78ae7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $cdcce91081d78ae7$export$b82d16f27459e05a; }, function (v) { return $cdcce91081d78ae7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $cdcce91081d78ae7$export$522c17b4f5e123e8; }, function (v) { return $cdcce91081d78ae7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $cdcce91081d78ae7$export$1aabd8a0274ecfd6; }, function (v) { return $cdcce91081d78ae7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $cdcce91081d78ae7$export$9b621391a187a31a; }, function (v) { return $cdcce91081d78ae7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $cdcce91081d78ae7$export$f5bbd400c2f4426f; }, function (v) { return $cdcce91081d78ae7$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cdcce91081d78ae7$export$2b8d127b894957b9;
var $cdcce91081d78ae7$export$cea3a54a6425200c;
var $cdcce91081d78ae7$export$a7c73072b1a182ae;
var $cdcce91081d78ae7$export$9f27bc3417b4524d;
var $cdcce91081d78ae7$export$db77ccec0bb4ccac;
var $cdcce91081d78ae7$export$8392c0c9d3dcbd35;
var $cdcce91081d78ae7$export$ffb0004e005737fa;
var $cdcce91081d78ae7$export$b624eff549462981;
var $cdcce91081d78ae7$export$7897aa7841a5380c;
var $cdcce91081d78ae7$export$602eac185826482c;
var $cdcce91081d78ae7$export$e2c29f18771995cb;
var $cdcce91081d78ae7$export$5f8d39834fd61797;
var $cdcce91081d78ae7$export$74bf444e3cd11ea5;
var $cdcce91081d78ae7$export$92387174baf9b227;
var $cdcce91081d78ae7$export$ec112efeb987d9c6;
var $cdcce91081d78ae7$export$b706b080d889d2c9;
var $cdcce91081d78ae7$export$5be5a87408f70ddc;
var $cdcce91081d78ae7$export$45a5e7f76e0caa8d;
var $cdcce91081d78ae7$export$455c2e768291efa6;
var $cdcce91081d78ae7$export$9522e17588c12572;
var $cdcce91081d78ae7$export$2110ac352bb060b9;
var $cdcce91081d78ae7$export$56885ab8b9c456ab;
var $cdcce91081d78ae7$export$d927fcb6adf8f9de;
var $cdcce91081d78ae7$export$b82d16f27459e05a;
var $cdcce91081d78ae7$export$522c17b4f5e123e8;
var $cdcce91081d78ae7$export$1aabd8a0274ecfd6;
var $cdcce91081d78ae7$export$9b621391a187a31a;
var $cdcce91081d78ae7$export$f5bbd400c2f4426f;
'use strict';
var $cdcce91081d78ae7$var$b = "function" === typeof Symbol && Symbol.for, $cdcce91081d78ae7$var$c = $cdcce91081d78ae7$var$b ? Symbol.for("react.element") : 60103, $cdcce91081d78ae7$var$d = $cdcce91081d78ae7$var$b ? Symbol.for("react.portal") : 60106, $cdcce91081d78ae7$var$e = $cdcce91081d78ae7$var$b ? Symbol.for("react.fragment") : 60107, $cdcce91081d78ae7$var$f = $cdcce91081d78ae7$var$b ? Symbol.for("react.strict_mode") : 60108, $cdcce91081d78ae7$var$g = $cdcce91081d78ae7$var$b ? Symbol.for("react.profiler") : 60114, $cdcce91081d78ae7$var$h = $cdcce91081d78ae7$var$b ? Symbol.for("react.provider") : 60109, $cdcce91081d78ae7$var$k = $cdcce91081d78ae7$var$b ? Symbol.for("react.context") : 60110, $cdcce91081d78ae7$var$l = $cdcce91081d78ae7$var$b ? Symbol.for("react.async_mode") : 60111, $cdcce91081d78ae7$var$m = $cdcce91081d78ae7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $cdcce91081d78ae7$var$n = $cdcce91081d78ae7$var$b ? Symbol.for("react.forward_ref") : 60112, $cdcce91081d78ae7$var$p = $cdcce91081d78ae7$var$b ? Symbol.for("react.suspense") : 60113, $cdcce91081d78ae7$var$q = $cdcce91081d78ae7$var$b ? Symbol.for("react.suspense_list") : 60120, $cdcce91081d78ae7$var$r = $cdcce91081d78ae7$var$b ? Symbol.for("react.memo") : 60115, $cdcce91081d78ae7$var$t = $cdcce91081d78ae7$var$b ? Symbol.for("react.lazy") : 60116, $cdcce91081d78ae7$var$v = $cdcce91081d78ae7$var$b ? Symbol.for("react.block") : 60121, $cdcce91081d78ae7$var$w = $cdcce91081d78ae7$var$b ? Symbol.for("react.fundamental") : 60117, $cdcce91081d78ae7$var$x = $cdcce91081d78ae7$var$b ? Symbol.for("react.responder") : 60118, $cdcce91081d78ae7$var$y = $cdcce91081d78ae7$var$b ? Symbol.for("react.scope") : 60119;
function $cdcce91081d78ae7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $cdcce91081d78ae7$var$c:
                switch(a = a.type, a){
                    case $cdcce91081d78ae7$var$l:
                    case $cdcce91081d78ae7$var$m:
                    case $cdcce91081d78ae7$var$e:
                    case $cdcce91081d78ae7$var$g:
                    case $cdcce91081d78ae7$var$f:
                    case $cdcce91081d78ae7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cdcce91081d78ae7$var$k:
                            case $cdcce91081d78ae7$var$n:
                            case $cdcce91081d78ae7$var$t:
                            case $cdcce91081d78ae7$var$r:
                            case $cdcce91081d78ae7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $cdcce91081d78ae7$var$d:
                return u;
        }
    }
}
function $cdcce91081d78ae7$var$A(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$m;
}
$cdcce91081d78ae7$export$2b8d127b894957b9 = $cdcce91081d78ae7$var$l;
$cdcce91081d78ae7$export$cea3a54a6425200c = $cdcce91081d78ae7$var$m;
$cdcce91081d78ae7$export$a7c73072b1a182ae = $cdcce91081d78ae7$var$k;
$cdcce91081d78ae7$export$9f27bc3417b4524d = $cdcce91081d78ae7$var$h;
$cdcce91081d78ae7$export$db77ccec0bb4ccac = $cdcce91081d78ae7$var$c;
$cdcce91081d78ae7$export$8392c0c9d3dcbd35 = $cdcce91081d78ae7$var$n;
$cdcce91081d78ae7$export$ffb0004e005737fa = $cdcce91081d78ae7$var$e;
$cdcce91081d78ae7$export$b624eff549462981 = $cdcce91081d78ae7$var$t;
$cdcce91081d78ae7$export$7897aa7841a5380c = $cdcce91081d78ae7$var$r;
$cdcce91081d78ae7$export$602eac185826482c = $cdcce91081d78ae7$var$d;
$cdcce91081d78ae7$export$e2c29f18771995cb = $cdcce91081d78ae7$var$g;
$cdcce91081d78ae7$export$5f8d39834fd61797 = $cdcce91081d78ae7$var$f;
$cdcce91081d78ae7$export$74bf444e3cd11ea5 = $cdcce91081d78ae7$var$p;
$cdcce91081d78ae7$export$92387174baf9b227 = function(a) {
    return $cdcce91081d78ae7$var$A(a) || $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$l;
};
$cdcce91081d78ae7$export$ec112efeb987d9c6 = $cdcce91081d78ae7$var$A;
$cdcce91081d78ae7$export$b706b080d889d2c9 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$k;
};
$cdcce91081d78ae7$export$5be5a87408f70ddc = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$h;
};
$cdcce91081d78ae7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cdcce91081d78ae7$var$c;
};
$cdcce91081d78ae7$export$455c2e768291efa6 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$n;
};
$cdcce91081d78ae7$export$9522e17588c12572 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$e;
};
$cdcce91081d78ae7$export$2110ac352bb060b9 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$t;
};
$cdcce91081d78ae7$export$56885ab8b9c456ab = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$r;
};
$cdcce91081d78ae7$export$d927fcb6adf8f9de = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$d;
};
$cdcce91081d78ae7$export$b82d16f27459e05a = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$g;
};
$cdcce91081d78ae7$export$522c17b4f5e123e8 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$f;
};
$cdcce91081d78ae7$export$1aabd8a0274ecfd6 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$p;
};
$cdcce91081d78ae7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cdcce91081d78ae7$var$e || a === $cdcce91081d78ae7$var$m || a === $cdcce91081d78ae7$var$g || a === $cdcce91081d78ae7$var$f || a === $cdcce91081d78ae7$var$p || a === $cdcce91081d78ae7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $cdcce91081d78ae7$var$t || a.$$typeof === $cdcce91081d78ae7$var$r || a.$$typeof === $cdcce91081d78ae7$var$h || a.$$typeof === $cdcce91081d78ae7$var$k || a.$$typeof === $cdcce91081d78ae7$var$n || a.$$typeof === $cdcce91081d78ae7$var$w || a.$$typeof === $cdcce91081d78ae7$var$x || a.$$typeof === $cdcce91081d78ae7$var$y || a.$$typeof === $cdcce91081d78ae7$var$v);
};
$cdcce91081d78ae7$export$f5bbd400c2f4426f = $cdcce91081d78ae7$var$z;

});

parcelRegister("hK0WK", function(module, exports) {

$parcel$export(module.exports, "convert", function () { return $cea777862cb01c24$export$9c68d69a4c5bbcf9; }, function (v) { return $cea777862cb01c24$export$9c68d69a4c5bbcf9 = v; });
// Expose to the world
var $cea777862cb01c24$export$9c68d69a4c5bbcf9;

var $gzLuY = parcelRequire("gzLuY");
var $cea777862cb01c24$require$Buffer = $gzLuY.Buffer;
'use strict';

var $3KE7f = parcelRequire("3KE7f");
$cea777862cb01c24$export$9c68d69a4c5bbcf9 = $cea777862cb01c24$var$convert;
/**
 * Convert encoding of an UTF-8 string or a buffer
 *
 * @param {String|Buffer} str String to be converted
 * @param {String} to Encoding to be converted to
 * @param {String} [from='UTF-8'] Encoding to be converted from
 * @return {Buffer} Encoded string
 */ function $cea777862cb01c24$var$convert(str, to, from) {
    from = $cea777862cb01c24$var$checkEncoding(from || 'UTF-8');
    to = $cea777862cb01c24$var$checkEncoding(to || 'UTF-8');
    str = str || '';
    var result;
    if (from !== 'UTF-8' && typeof str === 'string') str = $cea777862cb01c24$require$Buffer.from(str, 'binary');
    if (from === to) {
        if (typeof str === 'string') result = $cea777862cb01c24$require$Buffer.from(str);
        else result = str;
    } else try {
        result = $cea777862cb01c24$var$convertIconvLite(str, to, from);
    } catch (E) {
        console.error(E);
        result = str;
    }
    if (typeof result === 'string') result = $cea777862cb01c24$require$Buffer.from(result, 'utf-8');
    return result;
}
/**
 * Convert encoding of astring with iconv-lite
 *
 * @param {String|Buffer} str String to be converted
 * @param {String} to Encoding to be converted to
 * @param {String} [from='UTF-8'] Encoding to be converted from
 * @return {Buffer} Encoded string
 */ function $cea777862cb01c24$var$convertIconvLite(str, to, from) {
    if (to === 'UTF-8') return $3KE7f.decode(str, from);
    else if (from === 'UTF-8') return $3KE7f.encode(str, to);
    else return $3KE7f.encode($3KE7f.decode(str, from), to);
}
/**
 * Converts charset name if needed
 *
 * @param {String} name Character set
 * @return {String} Character set name
 */ function $cea777862cb01c24$var$checkEncoding(name) {
    return (name || '').toString().trim().replace(/^latin[\-_]?(\d+)$/i, 'ISO-8859-$1').replace(/^win(?:dows)?[\-_]?(\d+)$/i, 'WINDOWS-$1').replace(/^utf[\-_]?(\d+)$/i, 'UTF-$1').replace(/^ks_c_5601\-1987$/i, 'CP949').replace(/^us[\-_]?ascii$/i, 'ASCII').toUpperCase();
}

});
parcelRegister("gzLuY", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $c114c26e12685207$export$a143d493d941bafc; }, function (v) { return $c114c26e12685207$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $c114c26e12685207$export$e4cf37d7f6fb9e0a; }, function (v) { return $c114c26e12685207$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $c114c26e12685207$export$f99ded8fe4b79145; }, function (v) { return $c114c26e12685207$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $c114c26e12685207$export$599f31c3813fae4d; }, function (v) { return $c114c26e12685207$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c114c26e12685207$export$a143d493d941bafc;
var $c114c26e12685207$export$e4cf37d7f6fb9e0a;
var $c114c26e12685207$export$f99ded8fe4b79145;
var $c114c26e12685207$export$599f31c3813fae4d;
'use strict';

var $7LFKz = parcelRequire("7LFKz");

var $69U7b = parcelRequire("69U7b");
const $c114c26e12685207$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$c114c26e12685207$export$a143d493d941bafc = $c114c26e12685207$var$Buffer;
$c114c26e12685207$export$e4cf37d7f6fb9e0a = $c114c26e12685207$var$SlowBuffer;
$c114c26e12685207$export$f99ded8fe4b79145 = 50;
const $c114c26e12685207$var$K_MAX_LENGTH = 0x7fffffff;
$c114c26e12685207$export$599f31c3813fae4d = $c114c26e12685207$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT = $c114c26e12685207$var$typedArraySupport();
if (!$c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c114c26e12685207$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c114c26e12685207$var$createBuffer(length) {
    if (length > $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c114c26e12685207$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c114c26e12685207$var$allocUnsafe(arg);
    }
    return $c114c26e12685207$var$from(arg, encodingOrOffset, length);
}
$c114c26e12685207$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c114c26e12685207$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $c114c26e12685207$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c114c26e12685207$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c114c26e12685207$var$isInstance(value, ArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, ArrayBuffer)) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($c114c26e12685207$var$isInstance(value, SharedArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, SharedArrayBuffer))) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c114c26e12685207$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $c114c26e12685207$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $c114c26e12685207$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c114c26e12685207$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c114c26e12685207$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c114c26e12685207$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c114c26e12685207$var$Buffer, Uint8Array);
function $c114c26e12685207$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c114c26e12685207$var$alloc(size, fill, encoding) {
    $c114c26e12685207$var$assertSize(size);
    if (size <= 0) return $c114c26e12685207$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $c114c26e12685207$var$createBuffer(size).fill(fill, encoding) : $c114c26e12685207$var$createBuffer(size).fill(fill);
    return $c114c26e12685207$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c114c26e12685207$var$Buffer.alloc = function(size, fill, encoding) {
    return $c114c26e12685207$var$alloc(size, fill, encoding);
};
function $c114c26e12685207$var$allocUnsafe(size) {
    $c114c26e12685207$var$assertSize(size);
    return $c114c26e12685207$var$createBuffer(size < 0 ? 0 : $c114c26e12685207$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c114c26e12685207$var$Buffer.allocUnsafe = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c114c26e12685207$var$Buffer.allocUnsafeSlow = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
function $c114c26e12685207$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $c114c26e12685207$var$byteLength(string, encoding) | 0;
    let buf = $c114c26e12685207$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c114c26e12685207$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $c114c26e12685207$var$checked(array.length) | 0;
    const buf = $c114c26e12685207$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c114c26e12685207$var$fromArrayView(arrayView) {
    if ($c114c26e12685207$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $c114c26e12685207$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c114c26e12685207$var$fromArrayLike(arrayView);
}
function $c114c26e12685207$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
function $c114c26e12685207$var$fromObject(obj) {
    if ($c114c26e12685207$var$Buffer.isBuffer(obj)) {
        const len = $c114c26e12685207$var$checked(obj.length) | 0;
        const buf = $c114c26e12685207$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $c114c26e12685207$var$numberIsNaN(obj.length)) return $c114c26e12685207$var$createBuffer(0);
        return $c114c26e12685207$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $c114c26e12685207$var$fromArrayLike(obj.data);
}
function $c114c26e12685207$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c114c26e12685207$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $c114c26e12685207$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c114c26e12685207$var$Buffer.alloc(+length);
}
$c114c26e12685207$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c114c26e12685207$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c114c26e12685207$var$Buffer.compare = function compare(a, b) {
    if ($c114c26e12685207$var$isInstance(a, Uint8Array)) a = $c114c26e12685207$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c114c26e12685207$var$isInstance(b, Uint8Array)) b = $c114c26e12685207$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(a) || !$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c114c26e12685207$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$c114c26e12685207$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c114c26e12685207$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $c114c26e12685207$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($c114c26e12685207$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) buf = $c114c26e12685207$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c114c26e12685207$var$byteLength(string, encoding) {
    if ($c114c26e12685207$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c114c26e12685207$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $c114c26e12685207$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $c114c26e12685207$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c114c26e12685207$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c114c26e12685207$var$Buffer.byteLength = $c114c26e12685207$var$byteLength;
function $c114c26e12685207$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $c114c26e12685207$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $c114c26e12685207$var$utf8Slice(this, start, end);
        case 'ascii':
            return $c114c26e12685207$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $c114c26e12685207$var$latin1Slice(this, start, end);
        case 'base64':
            return $c114c26e12685207$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c114c26e12685207$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c114c26e12685207$var$Buffer.prototype._isBuffer = true;
function $c114c26e12685207$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c114c26e12685207$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$c114c26e12685207$var$swap(this, i, i + 1);
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $c114c26e12685207$var$swap(this, i, i + 3);
        $c114c26e12685207$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $c114c26e12685207$var$swap(this, i, i + 7);
        $c114c26e12685207$var$swap(this, i + 1, i + 6);
        $c114c26e12685207$var$swap(this, i + 2, i + 5);
        $c114c26e12685207$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $c114c26e12685207$var$utf8Slice(this, 0, length);
    return $c114c26e12685207$var$slowToString.apply(this, arguments);
};
$c114c26e12685207$var$Buffer.prototype.toLocaleString = $c114c26e12685207$var$Buffer.prototype.toString;
$c114c26e12685207$var$Buffer.prototype.equals = function equals(b) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $c114c26e12685207$var$Buffer.compare(this, b) === 0;
};
$c114c26e12685207$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $c114c26e12685207$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($c114c26e12685207$var$customInspectSymbol) $c114c26e12685207$var$Buffer.prototype[$c114c26e12685207$var$customInspectSymbol] = $c114c26e12685207$var$Buffer.prototype.inspect;
$c114c26e12685207$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c114c26e12685207$var$isInstance(target, Uint8Array)) target = $c114c26e12685207$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c114c26e12685207$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c114c26e12685207$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $c114c26e12685207$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c114c26e12685207$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c114c26e12685207$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c114c26e12685207$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $c114c26e12685207$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c114c26e12685207$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c114c26e12685207$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c114c26e12685207$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c114c26e12685207$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c114c26e12685207$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c114c26e12685207$var$utf8Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c114c26e12685207$var$asciiWrite(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$asciiToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$base64Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$base64ToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$ucs2Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c114c26e12685207$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $c114c26e12685207$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $c114c26e12685207$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $c114c26e12685207$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $c114c26e12685207$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c114c26e12685207$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c114c26e12685207$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c114c26e12685207$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7LFKz.fromByteArray(buf);
    else return $7LFKz.fromByteArray(buf.slice(start, end));
}
function $c114c26e12685207$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c114c26e12685207$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c114c26e12685207$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c114c26e12685207$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c114c26e12685207$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c114c26e12685207$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $c114c26e12685207$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c114c26e12685207$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c114c26e12685207$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c114c26e12685207$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c114c26e12685207$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$c114c26e12685207$var$Buffer.prototype.readUintLE = $c114c26e12685207$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUintBE = $c114c26e12685207$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUint8 = $c114c26e12685207$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c114c26e12685207$var$Buffer.prototype.readUint16LE = $c114c26e12685207$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c114c26e12685207$var$Buffer.prototype.readUint16BE = $c114c26e12685207$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c114c26e12685207$var$Buffer.prototype.readUint32LE = $c114c26e12685207$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c114c26e12685207$var$Buffer.prototype.readUint32BE = $c114c26e12685207$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c114c26e12685207$var$Buffer.prototype.readBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c114c26e12685207$var$Buffer.prototype.readBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c114c26e12685207$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c114c26e12685207$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c114c26e12685207$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c114c26e12685207$var$Buffer.prototype.readBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$c114c26e12685207$var$Buffer.prototype.readBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$c114c26e12685207$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $69U7b.read(this, offset, true, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $69U7b.read(this, offset, false, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $69U7b.read(this, offset, true, 52, 8);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $69U7b.read(this, offset, false, 52, 8);
};
function $c114c26e12685207$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$c114c26e12685207$var$Buffer.prototype.writeUintLE = $c114c26e12685207$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUintBE = $c114c26e12685207$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUint8 = $c114c26e12685207$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16LE = $c114c26e12685207$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16BE = $c114c26e12685207$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32LE = $c114c26e12685207$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32BE = $c114c26e12685207$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c114c26e12685207$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c114c26e12685207$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$c114c26e12685207$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$c114c26e12685207$var$Buffer.prototype.writeBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $c114c26e12685207$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $c114c26e12685207$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $69U7b.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c114c26e12685207$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, false, noAssert);
};
function $c114c26e12685207$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $69U7b.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c114c26e12685207$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c114c26e12685207$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $c114c26e12685207$var$Buffer.isBuffer(val) ? val : $c114c26e12685207$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $c114c26e12685207$var$errors = {};
function $c114c26e12685207$var$E(sym, getMessage, Base) {
    $c114c26e12685207$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$c114c26e12685207$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$c114c26e12685207$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$c114c26e12685207$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c114c26e12685207$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $c114c26e12685207$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $c114c26e12685207$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $c114c26e12685207$var$checkBounds(buf, offset, byteLength) {
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c114c26e12685207$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $c114c26e12685207$var$checkBounds(buf, offset, byteLength);
}
function $c114c26e12685207$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $c114c26e12685207$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $c114c26e12685207$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c114c26e12685207$var$validateNumber(value, type);
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $c114c26e12685207$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $c114c26e12685207$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c114c26e12685207$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c114c26e12685207$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $c114c26e12685207$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $c114c26e12685207$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c114c26e12685207$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c114c26e12685207$var$base64ToBytes(str) {
    return $7LFKz.toByteArray($c114c26e12685207$var$base64clean(str));
}
function $c114c26e12685207$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c114c26e12685207$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c114c26e12685207$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $c114c26e12685207$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c114c26e12685207$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $c114c26e12685207$var$BufferBigIntNotDefined : fn;
}
function $c114c26e12685207$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("7LFKz", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $5a7d4ee62d502cb1$export$d622b2ad8d90c771; }, function (v) { return $5a7d4ee62d502cb1$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $5a7d4ee62d502cb1$export$6100ba28696e12de; }, function (v) { return $5a7d4ee62d502cb1$export$6100ba28696e12de = v; });
var $5a7d4ee62d502cb1$export$a48f0734ac7c2329;
var $5a7d4ee62d502cb1$export$d622b2ad8d90c771;
var $5a7d4ee62d502cb1$export$6100ba28696e12de;
'use strict';
$5a7d4ee62d502cb1$export$a48f0734ac7c2329 = $5a7d4ee62d502cb1$var$byteLength;
$5a7d4ee62d502cb1$export$d622b2ad8d90c771 = $5a7d4ee62d502cb1$var$toByteArray;
$5a7d4ee62d502cb1$export$6100ba28696e12de = $5a7d4ee62d502cb1$var$fromByteArray;
var $5a7d4ee62d502cb1$var$lookup = [];
var $5a7d4ee62d502cb1$var$revLookup = [];
var $5a7d4ee62d502cb1$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $5a7d4ee62d502cb1$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $5a7d4ee62d502cb1$var$i = 0, $5a7d4ee62d502cb1$var$len = $5a7d4ee62d502cb1$var$code.length; $5a7d4ee62d502cb1$var$i < $5a7d4ee62d502cb1$var$len; ++$5a7d4ee62d502cb1$var$i){
    $5a7d4ee62d502cb1$var$lookup[$5a7d4ee62d502cb1$var$i] = $5a7d4ee62d502cb1$var$code[$5a7d4ee62d502cb1$var$i];
    $5a7d4ee62d502cb1$var$revLookup[$5a7d4ee62d502cb1$var$code.charCodeAt($5a7d4ee62d502cb1$var$i)] = $5a7d4ee62d502cb1$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5a7d4ee62d502cb1$var$revLookup['-'.charCodeAt(0)] = 62;
$5a7d4ee62d502cb1$var$revLookup['_'.charCodeAt(0)] = 63;
function $5a7d4ee62d502cb1$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5a7d4ee62d502cb1$var$byteLength(b64) {
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$toByteArray(b64) {
    var tmp;
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5a7d4ee62d502cb1$var$Arr($5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 18 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 2 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 10 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5a7d4ee62d502cb1$var$tripletToBase64(num) {
    return $5a7d4ee62d502cb1$var$lookup[num >> 18 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 12 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 6 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num & 0x3F];
}
function $5a7d4ee62d502cb1$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5a7d4ee62d502cb1$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $5a7d4ee62d502cb1$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5a7d4ee62d502cb1$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 2] + $5a7d4ee62d502cb1$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 10] + $5a7d4ee62d502cb1$var$lookup[tmp >> 4 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("69U7b", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942; }, function (v) { return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $47bf1c92b6d3ec4f$export$68d8715fc104d294; }, function (v) { return $47bf1c92b6d3ec4f$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $47bf1c92b6d3ec4f$export$aafa59e2e03f2942;
var $47bf1c92b6d3ec4f$export$68d8715fc104d294;
$47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$47bf1c92b6d3ec4f$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("3KE7f", function(module, exports) {
"use strict";

var $llyme = parcelRequire("llyme");
var $2bb4c92d2883836a$require$Buffer = $llyme.Buffer;

var $jzWx9 = parcelRequire("jzWx9");
var $2bb4c92d2883836a$var$iconv = module.exports;
// All codecs and aliases are kept here, keyed by encoding name/alias.
// They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
$2bb4c92d2883836a$var$iconv.encodings = null;
// Characters emitted in case of error.
$2bb4c92d2883836a$var$iconv.defaultCharUnicode = "\uFFFD";
$2bb4c92d2883836a$var$iconv.defaultCharSingleByte = '?';
// Public API.
$2bb4c92d2883836a$var$iconv.encode = function encode(str, encoding, options) {
    str = "" + (str || ""); // Ensure string.
    var encoder = $2bb4c92d2883836a$var$iconv.getEncoder(encoding, options);
    var res = encoder.write(str);
    var trail = encoder.end();
    return trail && trail.length > 0 ? $2bb4c92d2883836a$require$Buffer.concat([
        res,
        trail
    ]) : res;
};
$2bb4c92d2883836a$var$iconv.decode = function decode(buf, encoding, options) {
    if (typeof buf === 'string') {
        if (!$2bb4c92d2883836a$var$iconv.skipDecodeWarning) {
            console.error('Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding');
            $2bb4c92d2883836a$var$iconv.skipDecodeWarning = true;
        }
        buf = $2bb4c92d2883836a$require$Buffer.from("" + (buf || ""), "binary"); // Ensure buffer.
    }
    var decoder = $2bb4c92d2883836a$var$iconv.getDecoder(encoding, options);
    var res = decoder.write(buf);
    var trail = decoder.end();
    return trail ? res + trail : res;
};
$2bb4c92d2883836a$var$iconv.encodingExists = function encodingExists(enc) {
    try {
        $2bb4c92d2883836a$var$iconv.getCodec(enc);
        return true;
    } catch (e) {
        return false;
    }
};
// Legacy aliases to convert functions
$2bb4c92d2883836a$var$iconv.toEncoding = $2bb4c92d2883836a$var$iconv.encode;
$2bb4c92d2883836a$var$iconv.fromEncoding = $2bb4c92d2883836a$var$iconv.decode;
// Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
$2bb4c92d2883836a$var$iconv._codecDataCache = {};

$2bb4c92d2883836a$var$iconv.getCodec = function getCodec(encoding) {
    if (!$2bb4c92d2883836a$var$iconv.encodings) $2bb4c92d2883836a$var$iconv.encodings = (parcelRequire("jgoBj")); // Lazy load all encoding definitions.
    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
    var enc = $2bb4c92d2883836a$var$iconv._canonicalizeEncoding(encoding);
    // Traverse iconv.encodings to find actual codec.
    var codecOptions = {};
    while(true){
        var codec = $2bb4c92d2883836a$var$iconv._codecDataCache[enc];
        if (codec) return codec;
        var codecDef = $2bb4c92d2883836a$var$iconv.encodings[enc];
        switch(typeof codecDef){
            case "string":
                enc = codecDef;
                break;
            case "object":
                for(var key in codecDef)codecOptions[key] = codecDef[key];
                if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                enc = codecDef.type;
                break;
            case "function":
                if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                // The codec function must load all tables and return object with .encoder and .decoder methods.
                // It'll be called only once (for each different options object).
                codec = new codecDef(codecOptions, $2bb4c92d2883836a$var$iconv);
                $2bb4c92d2883836a$var$iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
                return codec;
            default:
                throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '" + enc + "')");
        }
    }
};
$2bb4c92d2883836a$var$iconv._canonicalizeEncoding = function(encoding) {
    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
    return ('' + encoding).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, "");
};
$2bb4c92d2883836a$var$iconv.getEncoder = function getEncoder(encoding, options) {
    var codec = $2bb4c92d2883836a$var$iconv.getCodec(encoding), encoder = new codec.encoder(options, codec);
    if (codec.bomAware && options && options.addBOM) encoder = new $jzWx9.PrependBOM(encoder, options);
    return encoder;
};
$2bb4c92d2883836a$var$iconv.getDecoder = function getDecoder(encoding, options) {
    var codec = $2bb4c92d2883836a$var$iconv.getCodec(encoding), decoder = new codec.decoder(options, codec);
    if (codec.bomAware && !(options && options.stripBOM === false)) decoder = new $jzWx9.StripBOM(decoder, options);
    return decoder;
};

// Streaming API
// NOTE: Streaming API naturally depends on 'stream' module from Node.js. Unfortunately in browser environments this module can add
// up to 100Kb to the output bundle. To avoid unnecessary code bloat, we don't enable Streaming API in browser by default.
// If you would like to enable it explicitly, please add the following code to your app:
// > iconv.enableStreamingAPI(require('stream'));
$2bb4c92d2883836a$var$iconv.enableStreamingAPI = function enableStreamingAPI(stream_module) {
    if ($2bb4c92d2883836a$var$iconv.supportsStreams) return;
    // Dependency-inject stream module to create IconvLite stream classes.
    var streams = (parcelRequire("4dcSV"))(stream_module);
    // Not public API yet, but expose the stream classes.
    $2bb4c92d2883836a$var$iconv.IconvLiteEncoderStream = streams.IconvLiteEncoderStream;
    $2bb4c92d2883836a$var$iconv.IconvLiteDecoderStream = streams.IconvLiteDecoderStream;
    // Streaming API.
    $2bb4c92d2883836a$var$iconv.encodeStream = function encodeStream(encoding, options) {
        return new $2bb4c92d2883836a$var$iconv.IconvLiteEncoderStream($2bb4c92d2883836a$var$iconv.getEncoder(encoding, options), options);
    };
    $2bb4c92d2883836a$var$iconv.decodeStream = function decodeStream(encoding, options) {
        return new $2bb4c92d2883836a$var$iconv.IconvLiteDecoderStream($2bb4c92d2883836a$var$iconv.getDecoder(encoding, options), options);
    };
    $2bb4c92d2883836a$var$iconv.supportsStreams = true;
};
// Enable Streaming API automatically if 'stream' module is available and non-empty (the majority of environments).
var $2bb4c92d2883836a$var$stream_module;

try {
    $2bb4c92d2883836a$var$stream_module = (parcelRequire("aqbQf"));
} catch (e) {}
if ($2bb4c92d2883836a$var$stream_module && $2bb4c92d2883836a$var$stream_module.Transform) $2bb4c92d2883836a$var$iconv.enableStreamingAPI($2bb4c92d2883836a$var$stream_module);
else // In rare cases where 'stream' module is not available by default, throw a helpful exception.
$2bb4c92d2883836a$var$iconv.encodeStream = $2bb4c92d2883836a$var$iconv.decodeStream = function() {
    throw new Error("iconv-lite Streaming API is not enabled. Use iconv.enableStreamingAPI(require('stream')); to enable it.");
};

});
parcelRegister("llyme", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $a8i8g = parcelRequire("a8i8g");
'use strict';

var $gzLuY = parcelRequire("gzLuY");
var $f8a635d7da98a5fa$var$Buffer = $gzLuY.Buffer;
var $f8a635d7da98a5fa$var$safer = {};
var $f8a635d7da98a5fa$var$key;
for($f8a635d7da98a5fa$var$key in $gzLuY){
    if (!$gzLuY.hasOwnProperty($f8a635d7da98a5fa$var$key)) continue;
    if ($f8a635d7da98a5fa$var$key === 'SlowBuffer' || $f8a635d7da98a5fa$var$key === 'Buffer') continue;
    $f8a635d7da98a5fa$var$safer[$f8a635d7da98a5fa$var$key] = $gzLuY[$f8a635d7da98a5fa$var$key];
}
var $f8a635d7da98a5fa$var$Safer = $f8a635d7da98a5fa$var$safer.Buffer = {};
for($f8a635d7da98a5fa$var$key in $f8a635d7da98a5fa$var$Buffer){
    if (!$f8a635d7da98a5fa$var$Buffer.hasOwnProperty($f8a635d7da98a5fa$var$key)) continue;
    if ($f8a635d7da98a5fa$var$key === 'allocUnsafe' || $f8a635d7da98a5fa$var$key === 'allocUnsafeSlow') continue;
    $f8a635d7da98a5fa$var$Safer[$f8a635d7da98a5fa$var$key] = $f8a635d7da98a5fa$var$Buffer[$f8a635d7da98a5fa$var$key];
}
$f8a635d7da98a5fa$var$safer.Buffer.prototype = $f8a635d7da98a5fa$var$Buffer.prototype;
if (!$f8a635d7da98a5fa$var$Safer.from || $f8a635d7da98a5fa$var$Safer.from === Uint8Array.from) $f8a635d7da98a5fa$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === 'undefined') throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value);
    return $f8a635d7da98a5fa$var$Buffer(value, encodingOrOffset, length);
};
if (!$f8a635d7da98a5fa$var$Safer.alloc) $f8a635d7da98a5fa$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $f8a635d7da98a5fa$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === 'string') buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$f8a635d7da98a5fa$var$safer.kStringMaxLength) try {
    $f8a635d7da98a5fa$var$safer.kStringMaxLength = $a8i8g.binding('buffer').kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$f8a635d7da98a5fa$var$safer.constants) {
    $f8a635d7da98a5fa$var$safer.constants = {
        MAX_LENGTH: $f8a635d7da98a5fa$var$safer.kMaxLength
    };
    if ($f8a635d7da98a5fa$var$safer.kStringMaxLength) $f8a635d7da98a5fa$var$safer.constants.MAX_STRING_LENGTH = $f8a635d7da98a5fa$var$safer.kStringMaxLength;
}
module.exports = $f8a635d7da98a5fa$var$safer;

});

parcelRegister("jzWx9", function(module, exports) {

$parcel$export(module.exports, "PrependBOM", function () { return $e40eb0ca9c40b690$export$e46ffb123c920c9f; }, function (v) { return $e40eb0ca9c40b690$export$e46ffb123c920c9f = v; });
$parcel$export(module.exports, "StripBOM", function () { return $e40eb0ca9c40b690$export$99ac9f64d7386375; }, function (v) { return $e40eb0ca9c40b690$export$99ac9f64d7386375 = v; });
var $e40eb0ca9c40b690$export$e46ffb123c920c9f;
//------------------------------------------------------------------------------
var $e40eb0ca9c40b690$export$99ac9f64d7386375;
"use strict";
var $e40eb0ca9c40b690$var$BOMChar = '\uFEFF';
$e40eb0ca9c40b690$export$e46ffb123c920c9f = $e40eb0ca9c40b690$var$PrependBOMWrapper;
function $e40eb0ca9c40b690$var$PrependBOMWrapper(encoder, options) {
    this.encoder = encoder;
    this.addBOM = true;
}
$e40eb0ca9c40b690$var$PrependBOMWrapper.prototype.write = function(str) {
    if (this.addBOM) {
        str = $e40eb0ca9c40b690$var$BOMChar + str;
        this.addBOM = false;
    }
    return this.encoder.write(str);
};
$e40eb0ca9c40b690$var$PrependBOMWrapper.prototype.end = function() {
    return this.encoder.end();
};
$e40eb0ca9c40b690$export$99ac9f64d7386375 = $e40eb0ca9c40b690$var$StripBOMWrapper;
function $e40eb0ca9c40b690$var$StripBOMWrapper(decoder, options) {
    this.decoder = decoder;
    this.pass = false;
    this.options = options || {};
}
$e40eb0ca9c40b690$var$StripBOMWrapper.prototype.write = function(buf) {
    var res = this.decoder.write(buf);
    if (this.pass || !res) return res;
    if (res[0] === $e40eb0ca9c40b690$var$BOMChar) {
        res = res.slice(1);
        if (typeof this.options.stripBOM === 'function') this.options.stripBOM();
    }
    this.pass = true;
    return res;
};
$e40eb0ca9c40b690$var$StripBOMWrapper.prototype.end = function() {
    return this.decoder.end();
};

});

parcelRegister("jgoBj", function(module, exports) {
"use strict";









// Update this array if you add/rename/remove files in this directory.
// We support Browserify by skipping automatic module discovery and requiring modules directly.
var $e06298216eb6bc91$var$modules = [
    (parcelRequire("gCACd")),
    (parcelRequire("hZP7s")),
    (parcelRequire("6QibQ")),
    (parcelRequire("gJcfT")),
    (parcelRequire("k6SpY")),
    (parcelRequire("1RAb2")),
    (parcelRequire("dT4gJ")),
    (parcelRequire("8J3I3")),
    (parcelRequire("9CmWE"))
];
// Put all encoding/alias/codec definitions to single object and export it.
for(var $e06298216eb6bc91$var$i = 0; $e06298216eb6bc91$var$i < $e06298216eb6bc91$var$modules.length; $e06298216eb6bc91$var$i++){
    var $e06298216eb6bc91$var$module = $e06298216eb6bc91$var$modules[$e06298216eb6bc91$var$i];
    for(var $e06298216eb6bc91$var$enc in $e06298216eb6bc91$var$module)if (Object.prototype.hasOwnProperty.call($e06298216eb6bc91$var$module, $e06298216eb6bc91$var$enc)) module.exports[$e06298216eb6bc91$var$enc] = $e06298216eb6bc91$var$module[$e06298216eb6bc91$var$enc];
}

});
parcelRegister("gCACd", function(module, exports) {
"use strict";

var $llyme = parcelRequire("llyme");
var $c19c98fb8b9aa383$require$Buffer = $llyme.Buffer;
// Export Node.js internal encodings.
module.exports = {
    // Encodings
    utf8: {
        type: "_internal",
        bomAware: true
    },
    cesu8: {
        type: "_internal",
        bomAware: true
    },
    unicode11utf8: "utf8",
    ucs2: {
        type: "_internal",
        bomAware: true
    },
    utf16le: "ucs2",
    binary: {
        type: "_internal"
    },
    base64: {
        type: "_internal"
    },
    hex: {
        type: "_internal"
    },
    // Codec.
    _internal: $c19c98fb8b9aa383$var$InternalCodec
};
//------------------------------------------------------------------------------
function $c19c98fb8b9aa383$var$InternalCodec(codecOptions, iconv) {
    this.enc = codecOptions.encodingName;
    this.bomAware = codecOptions.bomAware;
    if (this.enc === "base64") this.encoder = $c19c98fb8b9aa383$var$InternalEncoderBase64;
    else if (this.enc === "cesu8") {
        this.enc = "utf8"; // Use utf8 for decoding.
        this.encoder = $c19c98fb8b9aa383$var$InternalEncoderCesu8;
        // Add decoder for versions of Node not supporting CESU-8
        if ($c19c98fb8b9aa383$require$Buffer.from('eda0bdedb2a9', 'hex').toString() !== "\uD83D\uDCA9") {
            this.decoder = $c19c98fb8b9aa383$var$InternalDecoderCesu8;
            this.defaultCharUnicode = iconv.defaultCharUnicode;
        }
    }
}
$c19c98fb8b9aa383$var$InternalCodec.prototype.encoder = $c19c98fb8b9aa383$var$InternalEncoder;
$c19c98fb8b9aa383$var$InternalCodec.prototype.decoder = $c19c98fb8b9aa383$var$InternalDecoder;

var $hXidu = parcelRequire("hXidu");
var $c19c98fb8b9aa383$require$StringDecoder = $hXidu.StringDecoder;
if (!$c19c98fb8b9aa383$require$StringDecoder.prototype.end) $c19c98fb8b9aa383$require$StringDecoder.prototype.end = function() {};
function $c19c98fb8b9aa383$var$InternalDecoder(options, codec) {
    this.decoder = new $c19c98fb8b9aa383$require$StringDecoder(codec.enc);
}
$c19c98fb8b9aa383$var$InternalDecoder.prototype.write = function(buf) {
    if (!$c19c98fb8b9aa383$require$Buffer.isBuffer(buf)) buf = $c19c98fb8b9aa383$require$Buffer.from(buf);
    return this.decoder.write(buf);
};
$c19c98fb8b9aa383$var$InternalDecoder.prototype.end = function() {
    return this.decoder.end();
};
//------------------------------------------------------------------------------
// Encoder is mostly trivial
function $c19c98fb8b9aa383$var$InternalEncoder(options, codec) {
    this.enc = codec.enc;
}
$c19c98fb8b9aa383$var$InternalEncoder.prototype.write = function(str) {
    return $c19c98fb8b9aa383$require$Buffer.from(str, this.enc);
};
$c19c98fb8b9aa383$var$InternalEncoder.prototype.end = function() {};
//------------------------------------------------------------------------------
// Except base64 encoder, which must keep its state.
function $c19c98fb8b9aa383$var$InternalEncoderBase64(options, codec) {
    this.prevStr = '';
}
$c19c98fb8b9aa383$var$InternalEncoderBase64.prototype.write = function(str) {
    str = this.prevStr + str;
    var completeQuads = str.length - str.length % 4;
    this.prevStr = str.slice(completeQuads);
    str = str.slice(0, completeQuads);
    return $c19c98fb8b9aa383$require$Buffer.from(str, "base64");
};
$c19c98fb8b9aa383$var$InternalEncoderBase64.prototype.end = function() {
    return $c19c98fb8b9aa383$require$Buffer.from(this.prevStr, "base64");
};
//------------------------------------------------------------------------------
// CESU-8 encoder is also special.
function $c19c98fb8b9aa383$var$InternalEncoderCesu8(options, codec) {}
$c19c98fb8b9aa383$var$InternalEncoderCesu8.prototype.write = function(str) {
    var buf = $c19c98fb8b9aa383$require$Buffer.alloc(str.length * 3), bufIdx = 0;
    for(var i = 0; i < str.length; i++){
        var charCode = str.charCodeAt(i);
        // Naive implementation, but it works because CESU-8 is especially easy
        // to convert from UTF-16 (which all JS strings are encoded in).
        if (charCode < 0x80) buf[bufIdx++] = charCode;
        else if (charCode < 0x800) {
            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        } else {
            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
            buf[bufIdx++] = 0x80 + (charCode >>> 6 & 0x3f);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        }
    }
    return buf.slice(0, bufIdx);
};
$c19c98fb8b9aa383$var$InternalEncoderCesu8.prototype.end = function() {};
//------------------------------------------------------------------------------
// CESU-8 decoder is not implemented in Node v4.0+
function $c19c98fb8b9aa383$var$InternalDecoderCesu8(options, codec) {
    this.acc = 0;
    this.contBytes = 0;
    this.accBytes = 0;
    this.defaultCharUnicode = codec.defaultCharUnicode;
}
$c19c98fb8b9aa383$var$InternalDecoderCesu8.prototype.write = function(buf) {
    var acc = this.acc, contBytes = this.contBytes, accBytes = this.accBytes, res = '';
    for(var i = 0; i < buf.length; i++){
        var curByte = buf[i];
        if ((curByte & 0xC0) !== 0x80) {
            if (contBytes > 0) {
                res += this.defaultCharUnicode;
                contBytes = 0;
            }
            if (curByte < 0x80) res += String.fromCharCode(curByte);
            else if (curByte < 0xE0) {
                acc = curByte & 0x1F;
                contBytes = 1;
                accBytes = 1;
            } else if (curByte < 0xF0) {
                acc = curByte & 0x0F;
                contBytes = 2;
                accBytes = 1;
            } else res += this.defaultCharUnicode;
        } else if (contBytes > 0) {
            acc = acc << 6 | curByte & 0x3f;
            contBytes--;
            accBytes++;
            if (contBytes === 0) {
                // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
                if (accBytes === 2 && acc < 0x80 && acc > 0) res += this.defaultCharUnicode;
                else if (accBytes === 3 && acc < 0x800) res += this.defaultCharUnicode;
                else // Actually add character.
                res += String.fromCharCode(acc);
            }
        } else res += this.defaultCharUnicode;
    }
    this.acc = acc;
    this.contBytes = contBytes;
    this.accBytes = accBytes;
    return res;
};
$c19c98fb8b9aa383$var$InternalDecoderCesu8.prototype.end = function() {
    var res = 0;
    if (this.contBytes > 0) res += this.defaultCharUnicode;
    return res;
};

});
parcelRegister("hXidu", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $d12613cfd4b43149$export$63a7aa211a91ed69; }, function (v) { return $d12613cfd4b43149$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $d12613cfd4b43149$export$63a7aa211a91ed69;
'use strict';

var $eN0t8 = parcelRequire("eN0t8");
var $d12613cfd4b43149$require$Buffer = $eN0t8.Buffer;
/*</replacement>*/ var $d12613cfd4b43149$var$isEncoding = $d12613cfd4b43149$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $d12613cfd4b43149$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $d12613cfd4b43149$var$normalizeEncoding(enc) {
    var nenc = $d12613cfd4b43149$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($d12613cfd4b43149$require$Buffer.isEncoding === $d12613cfd4b43149$var$isEncoding || !$d12613cfd4b43149$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$d12613cfd4b43149$export$63a7aa211a91ed69 = $d12613cfd4b43149$var$StringDecoder;
function $d12613cfd4b43149$var$StringDecoder(encoding) {
    this.encoding = $d12613cfd4b43149$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $d12613cfd4b43149$var$utf16Text;
            this.end = $d12613cfd4b43149$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $d12613cfd4b43149$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $d12613cfd4b43149$var$base64Text;
            this.end = $d12613cfd4b43149$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $d12613cfd4b43149$var$simpleWrite;
            this.end = $d12613cfd4b43149$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $d12613cfd4b43149$require$Buffer.allocUnsafe(nb);
}
$d12613cfd4b43149$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$d12613cfd4b43149$var$StringDecoder.prototype.end = $d12613cfd4b43149$var$utf8End;
// Returns only complete characters in a Buffer
$d12613cfd4b43149$var$StringDecoder.prototype.text = $d12613cfd4b43149$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$d12613cfd4b43149$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $d12613cfd4b43149$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $d12613cfd4b43149$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $d12613cfd4b43149$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d12613cfd4b43149$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d12613cfd4b43149$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $d12613cfd4b43149$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $d12613cfd4b43149$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $d12613cfd4b43149$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $d12613cfd4b43149$var$utf8Text(buf, i) {
    var total = $d12613cfd4b43149$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $d12613cfd4b43149$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $d12613cfd4b43149$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $d12613cfd4b43149$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $d12613cfd4b43149$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $d12613cfd4b43149$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $d12613cfd4b43149$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $d12613cfd4b43149$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("eN0t8", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $gzLuY = parcelRequire("gzLuY");
var $ac460165df72f91c$var$Buffer = $gzLuY.Buffer;
// alternative to using Object.keys for old browsers
function $ac460165df72f91c$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($ac460165df72f91c$var$Buffer.from && $ac460165df72f91c$var$Buffer.alloc && $ac460165df72f91c$var$Buffer.allocUnsafe && $ac460165df72f91c$var$Buffer.allocUnsafeSlow) module.exports = $gzLuY;
else {
    // Copy properties from require('buffer')
    $ac460165df72f91c$var$copyProps($gzLuY, module.exports);
    module.exports.Buffer = $ac460165df72f91c$var$SafeBuffer;
}
function $ac460165df72f91c$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $ac460165df72f91c$var$Buffer(arg, encodingOrOffset, length);
}
$ac460165df72f91c$var$SafeBuffer.prototype = Object.create($ac460165df72f91c$var$Buffer.prototype);
// Copy static methods from Buffer
$ac460165df72f91c$var$copyProps($ac460165df72f91c$var$Buffer, $ac460165df72f91c$var$SafeBuffer);
$ac460165df72f91c$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $ac460165df72f91c$var$Buffer(arg, encodingOrOffset, length);
};
$ac460165df72f91c$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $ac460165df72f91c$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$ac460165df72f91c$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $ac460165df72f91c$var$Buffer(size);
};
$ac460165df72f91c$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $gzLuY.SlowBuffer(size);
};

});



parcelRegister("hZP7s", function(module, exports) {

$parcel$export(module.exports, "_utf32", function () { return $d19fc966f3a35573$export$b2b6b8849c32811a; }, function (v) { return $d19fc966f3a35573$export$b2b6b8849c32811a = v; });
$parcel$export(module.exports, "utf32le", function () { return $d19fc966f3a35573$export$8ab18849c577cec0; }, function (v) { return $d19fc966f3a35573$export$8ab18849c577cec0 = v; });
$parcel$export(module.exports, "utf32be", function () { return $d19fc966f3a35573$export$197feba3617118ca; }, function (v) { return $d19fc966f3a35573$export$197feba3617118ca = v; });
$parcel$export(module.exports, "ucs4le", function () { return $d19fc966f3a35573$export$b3ab04f31ec3be1f; }, function (v) { return $d19fc966f3a35573$export$b3ab04f31ec3be1f = v; });
$parcel$export(module.exports, "ucs4be", function () { return $d19fc966f3a35573$export$a8734ff2aa536306; }, function (v) { return $d19fc966f3a35573$export$a8734ff2aa536306 = v; });
$parcel$export(module.exports, "utf32", function () { return $d19fc966f3a35573$export$43e4d86902f4e7e9; }, function (v) { return $d19fc966f3a35573$export$43e4d86902f4e7e9 = v; });
$parcel$export(module.exports, "ucs4", function () { return $d19fc966f3a35573$export$1350116c6c9180d2; }, function (v) { return $d19fc966f3a35573$export$1350116c6c9180d2 = v; });
// == UTF32-LE/BE codec. ==========================================================
var $d19fc966f3a35573$export$b2b6b8849c32811a;
var $d19fc966f3a35573$export$8ab18849c577cec0;
var $d19fc966f3a35573$export$197feba3617118ca;
// Aliases
var $d19fc966f3a35573$export$b3ab04f31ec3be1f;
var $d19fc966f3a35573$export$a8734ff2aa536306;
// == UTF-32 Auto codec =============================================================
// Decoder chooses automatically from UTF-32LE and UTF-32BE using BOM and space-based heuristic.
// Defaults to UTF-32LE. http://en.wikipedia.org/wiki/UTF-32
// Encoder/decoder default can be changed: iconv.decode(buf, 'utf32', {defaultEncoding: 'utf-32be'});
// Encoder prepends BOM (which can be overridden with (addBOM: false}).
var $d19fc966f3a35573$export$43e4d86902f4e7e9;
var $d19fc966f3a35573$export$1350116c6c9180d2;
'use strict';

var $llyme = parcelRequire("llyme");
var $d19fc966f3a35573$require$Buffer = $llyme.Buffer;
$d19fc966f3a35573$export$b2b6b8849c32811a = $d19fc966f3a35573$var$Utf32Codec;
function $d19fc966f3a35573$var$Utf32Codec(codecOptions, iconv) {
    this.iconv = iconv;
    this.bomAware = true;
    this.isLE = codecOptions.isLE;
}
$d19fc966f3a35573$export$8ab18849c577cec0 = {
    type: '_utf32',
    isLE: true
};
$d19fc966f3a35573$export$197feba3617118ca = {
    type: '_utf32',
    isLE: false
};
$d19fc966f3a35573$export$b3ab04f31ec3be1f = 'utf32le';
$d19fc966f3a35573$export$a8734ff2aa536306 = 'utf32be';
$d19fc966f3a35573$var$Utf32Codec.prototype.encoder = $d19fc966f3a35573$var$Utf32Encoder;
$d19fc966f3a35573$var$Utf32Codec.prototype.decoder = $d19fc966f3a35573$var$Utf32Decoder;
// -- Encoding
function $d19fc966f3a35573$var$Utf32Encoder(options, codec) {
    this.isLE = codec.isLE;
    this.highSurrogate = 0;
}
$d19fc966f3a35573$var$Utf32Encoder.prototype.write = function(str) {
    var src = $d19fc966f3a35573$require$Buffer.from(str, 'ucs2');
    var dst = $d19fc966f3a35573$require$Buffer.alloc(src.length * 2);
    var write32 = this.isLE ? dst.writeUInt32LE : dst.writeUInt32BE;
    var offset = 0;
    for(var i = 0; i < src.length; i += 2){
        var code = src.readUInt16LE(i);
        var isHighSurrogate = 0xD800 <= code && code < 0xDC00;
        var isLowSurrogate = 0xDC00 <= code && code < 0xE000;
        if (this.highSurrogate) {
            if (isHighSurrogate || !isLowSurrogate) {
                // There shouldn't be two high surrogates in a row, nor a high surrogate which isn't followed by a low
                // surrogate. If this happens, keep the pending high surrogate as a stand-alone semi-invalid character
                // (technically wrong, but expected by some applications, like Windows file names).
                write32.call(dst, this.highSurrogate, offset);
                offset += 4;
            } else {
                // Create 32-bit value from high and low surrogates;
                var codepoint = (this.highSurrogate - 0xD800 << 10 | code - 0xDC00) + 0x10000;
                write32.call(dst, codepoint, offset);
                offset += 4;
                this.highSurrogate = 0;
                continue;
            }
        }
        if (isHighSurrogate) this.highSurrogate = code;
        else {
            // Even if the current character is a low surrogate, with no previous high surrogate, we'll
            // encode it as a semi-invalid stand-alone character for the same reasons expressed above for
            // unpaired high surrogates.
            write32.call(dst, code, offset);
            offset += 4;
            this.highSurrogate = 0;
        }
    }
    if (offset < dst.length) dst = dst.slice(0, offset);
    return dst;
};
$d19fc966f3a35573$var$Utf32Encoder.prototype.end = function() {
    // Treat any leftover high surrogate as a semi-valid independent character.
    if (!this.highSurrogate) return;
    var buf = $d19fc966f3a35573$require$Buffer.alloc(4);
    if (this.isLE) buf.writeUInt32LE(this.highSurrogate, 0);
    else buf.writeUInt32BE(this.highSurrogate, 0);
    this.highSurrogate = 0;
    return buf;
};
// -- Decoding
function $d19fc966f3a35573$var$Utf32Decoder(options, codec) {
    this.isLE = codec.isLE;
    this.badChar = codec.iconv.defaultCharUnicode.charCodeAt(0);
    this.overflow = [];
}
$d19fc966f3a35573$var$Utf32Decoder.prototype.write = function(src) {
    if (src.length === 0) return '';
    var i = 0;
    var codepoint = 0;
    var dst = $d19fc966f3a35573$require$Buffer.alloc(src.length + 4);
    var offset = 0;
    var isLE = this.isLE;
    var overflow = this.overflow;
    var badChar = this.badChar;
    if (overflow.length > 0) {
        for(; i < src.length && overflow.length < 4; i++)overflow.push(src[i]);
        if (overflow.length === 4) {
            // NOTE: codepoint is a signed int32 and can be negative.
            // NOTE: We copied this block from below to help V8 optimize it (it works with array, not buffer).
            if (isLE) codepoint = overflow[i] | overflow[i + 1] << 8 | overflow[i + 2] << 16 | overflow[i + 3] << 24;
            else codepoint = overflow[i + 3] | overflow[i + 2] << 8 | overflow[i + 1] << 16 | overflow[i] << 24;
            overflow.length = 0;
            offset = $d19fc966f3a35573$var$_writeCodepoint(dst, offset, codepoint, badChar);
        }
    }
    // Main loop. Should be as optimized as possible.
    for(; i < src.length - 3; i += 4){
        // NOTE: codepoint is a signed int32 and can be negative.
        if (isLE) codepoint = src[i] | src[i + 1] << 8 | src[i + 2] << 16 | src[i + 3] << 24;
        else codepoint = src[i + 3] | src[i + 2] << 8 | src[i + 1] << 16 | src[i] << 24;
        offset = $d19fc966f3a35573$var$_writeCodepoint(dst, offset, codepoint, badChar);
    }
    // Keep overflowing bytes.
    for(; i < src.length; i++)overflow.push(src[i]);
    return dst.slice(0, offset).toString('ucs2');
};
function $d19fc966f3a35573$var$_writeCodepoint(dst, offset, codepoint, badChar) {
    // NOTE: codepoint is signed int32 and can be negative. We keep it that way to help V8 with optimizations.
    if (codepoint < 0 || codepoint > 0x10FFFF) // Not a valid Unicode codepoint
    codepoint = badChar;
    // Ephemeral Planes: Write high surrogate.
    if (codepoint >= 0x10000) {
        codepoint -= 0x10000;
        var high = 0xD800 | codepoint >> 10;
        dst[offset++] = high & 0xff;
        dst[offset++] = high >> 8;
        // Low surrogate is written below.
        var codepoint = 0xDC00 | codepoint & 0x3FF;
    }
    // Write BMP char or low surrogate.
    dst[offset++] = codepoint & 0xff;
    dst[offset++] = codepoint >> 8;
    return offset;
}
$d19fc966f3a35573$var$Utf32Decoder.prototype.end = function() {
    this.overflow.length = 0;
};
$d19fc966f3a35573$export$43e4d86902f4e7e9 = $d19fc966f3a35573$var$Utf32AutoCodec;
$d19fc966f3a35573$export$1350116c6c9180d2 = 'utf32';
function $d19fc966f3a35573$var$Utf32AutoCodec(options, iconv) {
    this.iconv = iconv;
}
$d19fc966f3a35573$var$Utf32AutoCodec.prototype.encoder = $d19fc966f3a35573$var$Utf32AutoEncoder;
$d19fc966f3a35573$var$Utf32AutoCodec.prototype.decoder = $d19fc966f3a35573$var$Utf32AutoDecoder;
// -- Encoding
function $d19fc966f3a35573$var$Utf32AutoEncoder(options, codec) {
    options = options || {};
    if (options.addBOM === undefined) options.addBOM = true;
    this.encoder = codec.iconv.getEncoder(options.defaultEncoding || 'utf-32le', options);
}
$d19fc966f3a35573$var$Utf32AutoEncoder.prototype.write = function(str) {
    return this.encoder.write(str);
};
$d19fc966f3a35573$var$Utf32AutoEncoder.prototype.end = function() {
    return this.encoder.end();
};
// -- Decoding
function $d19fc966f3a35573$var$Utf32AutoDecoder(options, codec) {
    this.decoder = null;
    this.initialBufs = [];
    this.initialBufsLen = 0;
    this.options = options || {};
    this.iconv = codec.iconv;
}
$d19fc966f3a35573$var$Utf32AutoDecoder.prototype.write = function(buf) {
    if (!this.decoder) {
        // Codec is not chosen yet. Accumulate initial bytes.
        this.initialBufs.push(buf);
        this.initialBufsLen += buf.length;
        if (this.initialBufsLen < 32) return '';
        // We have enough bytes -> detect endianness.
        var encoding = $d19fc966f3a35573$var$detectEncoding(this.initialBufs, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var resStr = '';
        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
        this.initialBufs.length = this.initialBufsLen = 0;
        return resStr;
    }
    return this.decoder.write(buf);
};
$d19fc966f3a35573$var$Utf32AutoDecoder.prototype.end = function() {
    if (!this.decoder) {
        var encoding = $d19fc966f3a35573$var$detectEncoding(this.initialBufs, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var resStr = '';
        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
        var trail = this.decoder.end();
        if (trail) resStr += trail;
        this.initialBufs.length = this.initialBufsLen = 0;
        return resStr;
    }
    return this.decoder.end();
};
function $d19fc966f3a35573$var$detectEncoding(bufs, defaultEncoding) {
    var b = [];
    var charsProcessed = 0;
    var invalidLE = 0, invalidBE = 0; // Number of invalid chars when decoded as LE or BE.
    var bmpCharsLE = 0, bmpCharsBE = 0; // Number of BMP chars when decoded as LE or BE.
    outer_loop: for(var i = 0; i < bufs.length; i++){
        var buf = bufs[i];
        for(var j = 0; j < buf.length; j++){
            b.push(buf[j]);
            if (b.length === 4) {
                if (charsProcessed === 0) {
                    // Check BOM first.
                    if (b[0] === 0xFF && b[1] === 0xFE && b[2] === 0 && b[3] === 0) return 'utf-32le';
                    if (b[0] === 0 && b[1] === 0 && b[2] === 0xFE && b[3] === 0xFF) return 'utf-32be';
                }
                if (b[0] !== 0 || b[1] > 0x10) invalidBE++;
                if (b[3] !== 0 || b[2] > 0x10) invalidLE++;
                if (b[0] === 0 && b[1] === 0 && (b[2] !== 0 || b[3] !== 0)) bmpCharsBE++;
                if ((b[0] !== 0 || b[1] !== 0) && b[2] === 0 && b[3] === 0) bmpCharsLE++;
                b.length = 0;
                charsProcessed++;
                if (charsProcessed >= 100) break outer_loop;
            }
        }
    }
    // Make decisions.
    if (bmpCharsBE - invalidBE > bmpCharsLE - invalidLE) return 'utf-32be';
    if (bmpCharsBE - invalidBE < bmpCharsLE - invalidLE) return 'utf-32le';
    // Couldn't decide (likely all zeros or not enough data).
    return defaultEncoding || 'utf-32le';
}

});

parcelRegister("6QibQ", function(module, exports) {

$parcel$export(module.exports, "utf16be", function () { return $4fb5b58fdac4bfe1$export$8b9ec48b10867f55; }, function (v) { return $4fb5b58fdac4bfe1$export$8b9ec48b10867f55 = v; });
$parcel$export(module.exports, "utf16", function () { return $4fb5b58fdac4bfe1$export$5e3087022f4331a5; }, function (v) { return $4fb5b58fdac4bfe1$export$5e3087022f4331a5 = v; });
// Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js
// == UTF16-BE codec. ==========================================================
var $4fb5b58fdac4bfe1$export$8b9ec48b10867f55;
// == UTF-16 codec =============================================================
// Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
// Defaults to UTF-16LE, as it's prevalent and default in Node.
// http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
// Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});
// Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).
var $4fb5b58fdac4bfe1$export$5e3087022f4331a5;
"use strict";

var $llyme = parcelRequire("llyme");
var $4fb5b58fdac4bfe1$require$Buffer = $llyme.Buffer;
$4fb5b58fdac4bfe1$export$8b9ec48b10867f55 = $4fb5b58fdac4bfe1$var$Utf16BECodec;
function $4fb5b58fdac4bfe1$var$Utf16BECodec() {}
$4fb5b58fdac4bfe1$var$Utf16BECodec.prototype.encoder = $4fb5b58fdac4bfe1$var$Utf16BEEncoder;
$4fb5b58fdac4bfe1$var$Utf16BECodec.prototype.decoder = $4fb5b58fdac4bfe1$var$Utf16BEDecoder;
$4fb5b58fdac4bfe1$var$Utf16BECodec.prototype.bomAware = true;
// -- Encoding
function $4fb5b58fdac4bfe1$var$Utf16BEEncoder() {}
$4fb5b58fdac4bfe1$var$Utf16BEEncoder.prototype.write = function(str) {
    var buf = $4fb5b58fdac4bfe1$require$Buffer.from(str, 'ucs2');
    for(var i = 0; i < buf.length; i += 2){
        var tmp = buf[i];
        buf[i] = buf[i + 1];
        buf[i + 1] = tmp;
    }
    return buf;
};
$4fb5b58fdac4bfe1$var$Utf16BEEncoder.prototype.end = function() {};
// -- Decoding
function $4fb5b58fdac4bfe1$var$Utf16BEDecoder() {
    this.overflowByte = -1;
}
$4fb5b58fdac4bfe1$var$Utf16BEDecoder.prototype.write = function(buf) {
    if (buf.length == 0) return '';
    var buf2 = $4fb5b58fdac4bfe1$require$Buffer.alloc(buf.length + 1), i = 0, j = 0;
    if (this.overflowByte !== -1) {
        buf2[0] = buf[0];
        buf2[1] = this.overflowByte;
        i = 1;
        j = 2;
    }
    for(; i < buf.length - 1; i += 2, j += 2){
        buf2[j] = buf[i + 1];
        buf2[j + 1] = buf[i];
    }
    this.overflowByte = i == buf.length - 1 ? buf[buf.length - 1] : -1;
    return buf2.slice(0, j).toString('ucs2');
};
$4fb5b58fdac4bfe1$var$Utf16BEDecoder.prototype.end = function() {
    this.overflowByte = -1;
};
$4fb5b58fdac4bfe1$export$5e3087022f4331a5 = $4fb5b58fdac4bfe1$var$Utf16Codec;
function $4fb5b58fdac4bfe1$var$Utf16Codec(codecOptions, iconv) {
    this.iconv = iconv;
}
$4fb5b58fdac4bfe1$var$Utf16Codec.prototype.encoder = $4fb5b58fdac4bfe1$var$Utf16Encoder;
$4fb5b58fdac4bfe1$var$Utf16Codec.prototype.decoder = $4fb5b58fdac4bfe1$var$Utf16Decoder;
// -- Encoding (pass-through)
function $4fb5b58fdac4bfe1$var$Utf16Encoder(options, codec) {
    options = options || {};
    if (options.addBOM === undefined) options.addBOM = true;
    this.encoder = codec.iconv.getEncoder('utf-16le', options);
}
$4fb5b58fdac4bfe1$var$Utf16Encoder.prototype.write = function(str) {
    return this.encoder.write(str);
};
$4fb5b58fdac4bfe1$var$Utf16Encoder.prototype.end = function() {
    return this.encoder.end();
};
// -- Decoding
function $4fb5b58fdac4bfe1$var$Utf16Decoder(options, codec) {
    this.decoder = null;
    this.initialBufs = [];
    this.initialBufsLen = 0;
    this.options = options || {};
    this.iconv = codec.iconv;
}
$4fb5b58fdac4bfe1$var$Utf16Decoder.prototype.write = function(buf) {
    if (!this.decoder) {
        // Codec is not chosen yet. Accumulate initial bytes.
        this.initialBufs.push(buf);
        this.initialBufsLen += buf.length;
        if (this.initialBufsLen < 16) return '';
        // We have enough bytes -> detect endianness.
        var encoding = $4fb5b58fdac4bfe1$var$detectEncoding(this.initialBufs, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var resStr = '';
        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
        this.initialBufs.length = this.initialBufsLen = 0;
        return resStr;
    }
    return this.decoder.write(buf);
};
$4fb5b58fdac4bfe1$var$Utf16Decoder.prototype.end = function() {
    if (!this.decoder) {
        var encoding = $4fb5b58fdac4bfe1$var$detectEncoding(this.initialBufs, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var resStr = '';
        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
        var trail = this.decoder.end();
        if (trail) resStr += trail;
        this.initialBufs.length = this.initialBufsLen = 0;
        return resStr;
    }
    return this.decoder.end();
};
function $4fb5b58fdac4bfe1$var$detectEncoding(bufs, defaultEncoding) {
    var b = [];
    var charsProcessed = 0;
    var asciiCharsLE = 0, asciiCharsBE = 0; // Number of ASCII chars when decoded as LE or BE.
    outer_loop: for(var i = 0; i < bufs.length; i++){
        var buf = bufs[i];
        for(var j = 0; j < buf.length; j++){
            b.push(buf[j]);
            if (b.length === 2) {
                if (charsProcessed === 0) {
                    // Check BOM first.
                    if (b[0] === 0xFF && b[1] === 0xFE) return 'utf-16le';
                    if (b[0] === 0xFE && b[1] === 0xFF) return 'utf-16be';
                }
                if (b[0] === 0 && b[1] !== 0) asciiCharsBE++;
                if (b[0] !== 0 && b[1] === 0) asciiCharsLE++;
                b.length = 0;
                charsProcessed++;
                if (charsProcessed >= 100) break outer_loop;
            }
        }
    }
    // Make decisions.
    // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
    // So, we count ASCII as if it was LE or BE, and decide from that.
    if (asciiCharsBE > asciiCharsLE) return 'utf-16be';
    if (asciiCharsBE < asciiCharsLE) return 'utf-16le';
    // Couldn't decide (likely all zeros or not enough data).
    return defaultEncoding || 'utf-16le';
}

});

parcelRegister("gJcfT", function(module, exports) {

$parcel$export(module.exports, "utf7", function () { return $c2da5af65eab1183$export$b2f9c8661b81cf99; }, function (v) { return $c2da5af65eab1183$export$b2f9c8661b81cf99 = v; });
$parcel$export(module.exports, "unicode11utf7", function () { return $c2da5af65eab1183$export$cc49de5f94fc4004; }, function (v) { return $c2da5af65eab1183$export$cc49de5f94fc4004 = v; });
$parcel$export(module.exports, "utf7imap", function () { return $c2da5af65eab1183$export$2488b28744623c18; }, function (v) { return $c2da5af65eab1183$export$2488b28744623c18 = v; });
// UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
// See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3
var $c2da5af65eab1183$export$b2f9c8661b81cf99;
var $c2da5af65eab1183$export$cc49de5f94fc4004;
// UTF-7-IMAP codec.
// RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
// Differences:
//  * Base64 part is started by "&" instead of "+"
//  * Direct characters are 0x20-0x7E, except "&" (0x26)
//  * In Base64, "," is used instead of "/"
//  * Base64 must not be used to represent direct characters.
//  * No implicit shift back from Base64 (should always end with '-')
//  * String must end in non-shifted position.
//  * "-&" while in base64 is not allowed.
var $c2da5af65eab1183$export$2488b28744623c18;
"use strict";

var $llyme = parcelRequire("llyme");
var $c2da5af65eab1183$require$Buffer = $llyme.Buffer;
$c2da5af65eab1183$export$b2f9c8661b81cf99 = $c2da5af65eab1183$var$Utf7Codec;
$c2da5af65eab1183$export$cc49de5f94fc4004 = 'utf7'; // Alias UNICODE-1-1-UTF-7
function $c2da5af65eab1183$var$Utf7Codec(codecOptions, iconv) {
    this.iconv = iconv;
}
$c2da5af65eab1183$var$Utf7Codec.prototype.encoder = $c2da5af65eab1183$var$Utf7Encoder;
$c2da5af65eab1183$var$Utf7Codec.prototype.decoder = $c2da5af65eab1183$var$Utf7Decoder;
$c2da5af65eab1183$var$Utf7Codec.prototype.bomAware = true;
// -- Encoding
var $c2da5af65eab1183$var$nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;
function $c2da5af65eab1183$var$Utf7Encoder(options, codec) {
    this.iconv = codec.iconv;
}
$c2da5af65eab1183$var$Utf7Encoder.prototype.write = function(str) {
    // Naive implementation.
    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
    return $c2da5af65eab1183$require$Buffer.from(str.replace($c2da5af65eab1183$var$nonDirectChars, (function(chunk) {
        return "+" + (chunk === '+' ? '' : this.iconv.encode(chunk, 'utf16-be').toString('base64').replace(/=+$/, '')) + "-";
    }).bind(this)));
};
$c2da5af65eab1183$var$Utf7Encoder.prototype.end = function() {};
// -- Decoding
function $c2da5af65eab1183$var$Utf7Decoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = '';
}
var $c2da5af65eab1183$var$base64Regex = /[A-Za-z0-9\/+]/;
var $c2da5af65eab1183$var$base64Chars = [];
for(var $c2da5af65eab1183$var$i = 0; $c2da5af65eab1183$var$i < 256; $c2da5af65eab1183$var$i++)$c2da5af65eab1183$var$base64Chars[$c2da5af65eab1183$var$i] = $c2da5af65eab1183$var$base64Regex.test(String.fromCharCode($c2da5af65eab1183$var$i));
var $c2da5af65eab1183$var$plusChar = '+'.charCodeAt(0), $c2da5af65eab1183$var$minusChar = '-'.charCodeAt(0), $c2da5af65eab1183$var$andChar = '&'.charCodeAt(0);
$c2da5af65eab1183$var$Utf7Decoder.prototype.write = function(buf) {
    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum;
    // The decoder is more involved as we must handle chunks in stream.
    for(var i = 0; i < buf.length; i++){
        if (!inBase64) // Write direct chars until '+'
        {
            if (buf[i] == $c2da5af65eab1183$var$plusChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i + 1;
                inBase64 = true;
            }
        } else if (!$c2da5af65eab1183$var$base64Chars[buf[i]]) {
            if (i == lastI && buf[i] == $c2da5af65eab1183$var$minusChar) res += "+";
            else {
                var b64str = base64Accum + this.iconv.decode(buf.slice(lastI, i), "ascii");
                res += this.iconv.decode($c2da5af65eab1183$require$Buffer.from(b64str, 'base64'), "utf16-be");
            }
            if (buf[i] != $c2da5af65eab1183$var$minusChar) i--;
            lastI = i + 1;
            inBase64 = false;
            base64Accum = '';
        }
    }
    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    else {
        var b64str = base64Accum + this.iconv.decode(buf.slice(lastI), "ascii");
        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);
        res += this.iconv.decode($c2da5af65eab1183$require$Buffer.from(b64str, 'base64'), "utf16-be");
    }
    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;
    return res;
};
$c2da5af65eab1183$var$Utf7Decoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode($c2da5af65eab1183$require$Buffer.from(this.base64Accum, 'base64'), "utf16-be");
    this.inBase64 = false;
    this.base64Accum = '';
    return res;
};
$c2da5af65eab1183$export$2488b28744623c18 = $c2da5af65eab1183$var$Utf7IMAPCodec;
function $c2da5af65eab1183$var$Utf7IMAPCodec(codecOptions, iconv) {
    this.iconv = iconv;
}
$c2da5af65eab1183$var$Utf7IMAPCodec.prototype.encoder = $c2da5af65eab1183$var$Utf7IMAPEncoder;
$c2da5af65eab1183$var$Utf7IMAPCodec.prototype.decoder = $c2da5af65eab1183$var$Utf7IMAPDecoder;
$c2da5af65eab1183$var$Utf7IMAPCodec.prototype.bomAware = true;
// -- Encoding
function $c2da5af65eab1183$var$Utf7IMAPEncoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = $c2da5af65eab1183$require$Buffer.alloc(6);
    this.base64AccumIdx = 0;
}
$c2da5af65eab1183$var$Utf7IMAPEncoder.prototype.write = function(str) {
    var inBase64 = this.inBase64, base64Accum = this.base64Accum, base64AccumIdx = this.base64AccumIdx, buf = $c2da5af65eab1183$require$Buffer.alloc(str.length * 5 + 10), bufIdx = 0;
    for(var i = 0; i < str.length; i++){
        var uChar = str.charCodeAt(i);
        if (0x20 <= uChar && uChar <= 0x7E) {
            if (inBase64) {
                if (base64AccumIdx > 0) {
                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
                    base64AccumIdx = 0;
                }
                buf[bufIdx++] = $c2da5af65eab1183$var$minusChar; // Write '-', then go to direct mode.
                inBase64 = false;
            }
            if (!inBase64) {
                buf[bufIdx++] = uChar; // Write direct character
                if (uChar === $c2da5af65eab1183$var$andChar) buf[bufIdx++] = $c2da5af65eab1183$var$minusChar;
            }
        } else {
            if (!inBase64) {
                buf[bufIdx++] = $c2da5af65eab1183$var$andChar; // Write '&', then go to base64 mode.
                inBase64 = true;
            }
            if (inBase64) {
                base64Accum[base64AccumIdx++] = uChar >> 8;
                base64Accum[base64AccumIdx++] = uChar & 0xFF;
                if (base64AccumIdx == base64Accum.length) {
                    bufIdx += buf.write(base64Accum.toString('base64').replace(/\//g, ','), bufIdx);
                    base64AccumIdx = 0;
                }
            }
        }
    }
    this.inBase64 = inBase64;
    this.base64AccumIdx = base64AccumIdx;
    return buf.slice(0, bufIdx);
};
$c2da5af65eab1183$var$Utf7IMAPEncoder.prototype.end = function() {
    var buf = $c2da5af65eab1183$require$Buffer.alloc(10), bufIdx = 0;
    if (this.inBase64) {
        if (this.base64AccumIdx > 0) {
            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
            this.base64AccumIdx = 0;
        }
        buf[bufIdx++] = $c2da5af65eab1183$var$minusChar; // Write '-', then go to direct mode.
        this.inBase64 = false;
    }
    return buf.slice(0, bufIdx);
};
// -- Decoding
function $c2da5af65eab1183$var$Utf7IMAPDecoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = '';
}
var $c2da5af65eab1183$var$base64IMAPChars = $c2da5af65eab1183$var$base64Chars.slice();
$c2da5af65eab1183$var$base64IMAPChars[','.charCodeAt(0)] = true;
$c2da5af65eab1183$var$Utf7IMAPDecoder.prototype.write = function(buf) {
    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum;
    // The decoder is more involved as we must handle chunks in stream.
    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).
    for(var i = 0; i < buf.length; i++){
        if (!inBase64) // Write direct chars until '&'
        {
            if (buf[i] == $c2da5af65eab1183$var$andChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i + 1;
                inBase64 = true;
            }
        } else if (!$c2da5af65eab1183$var$base64IMAPChars[buf[i]]) {
            if (i == lastI && buf[i] == $c2da5af65eab1183$var$minusChar) res += "&";
            else {
                var b64str = base64Accum + this.iconv.decode(buf.slice(lastI, i), "ascii").replace(/,/g, '/');
                res += this.iconv.decode($c2da5af65eab1183$require$Buffer.from(b64str, 'base64'), "utf16-be");
            }
            if (buf[i] != $c2da5af65eab1183$var$minusChar) i--;
            lastI = i + 1;
            inBase64 = false;
            base64Accum = '';
        }
    }
    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    else {
        var b64str = base64Accum + this.iconv.decode(buf.slice(lastI), "ascii").replace(/,/g, '/');
        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);
        res += this.iconv.decode($c2da5af65eab1183$require$Buffer.from(b64str, 'base64'), "utf16-be");
    }
    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;
    return res;
};
$c2da5af65eab1183$var$Utf7IMAPDecoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode($c2da5af65eab1183$require$Buffer.from(this.base64Accum, 'base64'), "utf16-be");
    this.inBase64 = false;
    this.base64Accum = '';
    return res;
};

});

parcelRegister("k6SpY", function(module, exports) {

$parcel$export(module.exports, "_sbcs", function () { return $ea3e94743cc5ded3$export$90ce6c201c0ff1a9; }, function (v) { return $ea3e94743cc5ded3$export$90ce6c201c0ff1a9 = v; });
// Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
// correspond to encoded bytes (if 128 - then lower half is ASCII). 
var $ea3e94743cc5ded3$export$90ce6c201c0ff1a9;
"use strict";

var $llyme = parcelRequire("llyme");
var $ea3e94743cc5ded3$require$Buffer = $llyme.Buffer;
$ea3e94743cc5ded3$export$90ce6c201c0ff1a9 = $ea3e94743cc5ded3$var$SBCSCodec;
function $ea3e94743cc5ded3$var$SBCSCodec(codecOptions, iconv) {
    if (!codecOptions) throw new Error("SBCS codec is called without the data.");
    // Prepare char buffer for decoding.
    if (!codecOptions.chars || codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256) throw new Error("Encoding '" + codecOptions.type + "' has incorrect 'chars' (must be of len 128 or 256)");
    if (codecOptions.chars.length === 128) {
        var asciiString = "";
        for(var i = 0; i < 128; i++)asciiString += String.fromCharCode(i);
        codecOptions.chars = asciiString + codecOptions.chars;
    }
    this.decodeBuf = $ea3e94743cc5ded3$require$Buffer.from(codecOptions.chars, 'ucs2');
    // Encoding buffer.
    var encodeBuf = $ea3e94743cc5ded3$require$Buffer.alloc(65536, iconv.defaultCharSingleByte.charCodeAt(0));
    for(var i = 0; i < codecOptions.chars.length; i++)encodeBuf[codecOptions.chars.charCodeAt(i)] = i;
    this.encodeBuf = encodeBuf;
}
$ea3e94743cc5ded3$var$SBCSCodec.prototype.encoder = $ea3e94743cc5ded3$var$SBCSEncoder;
$ea3e94743cc5ded3$var$SBCSCodec.prototype.decoder = $ea3e94743cc5ded3$var$SBCSDecoder;
function $ea3e94743cc5ded3$var$SBCSEncoder(options, codec) {
    this.encodeBuf = codec.encodeBuf;
}
$ea3e94743cc5ded3$var$SBCSEncoder.prototype.write = function(str) {
    var buf = $ea3e94743cc5ded3$require$Buffer.alloc(str.length);
    for(var i = 0; i < str.length; i++)buf[i] = this.encodeBuf[str.charCodeAt(i)];
    return buf;
};
$ea3e94743cc5ded3$var$SBCSEncoder.prototype.end = function() {};
function $ea3e94743cc5ded3$var$SBCSDecoder(options, codec) {
    this.decodeBuf = codec.decodeBuf;
}
$ea3e94743cc5ded3$var$SBCSDecoder.prototype.write = function(buf) {
    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
    var decodeBuf = this.decodeBuf;
    var newBuf = $ea3e94743cc5ded3$require$Buffer.alloc(buf.length * 2);
    var idx1 = 0, idx2 = 0;
    for(var i = 0; i < buf.length; i++){
        idx1 = buf[i] * 2;
        idx2 = i * 2;
        newBuf[idx2] = decodeBuf[idx1];
        newBuf[idx2 + 1] = decodeBuf[idx1 + 1];
    }
    return newBuf.toString('ucs2');
};
$ea3e94743cc5ded3$var$SBCSDecoder.prototype.end = function() {};

});

parcelRegister("1RAb2", function(module, exports) {
"use strict";
// Manually added data to be used by sbcs codec in addition to generated one.
module.exports = {
    // Not supported by iconv, not sure why.
    "10029": "maccenteuro",
    "maccenteuro": {
        "type": "_sbcs",
        "chars": "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026\xa0\u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7"
    },
    "808": "cp808",
    "ibm808": "cp808",
    "cp808": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\u20AC\u25A0\xa0"
    },
    "mik": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2514\u2534\u252C\u251C\u2500\u253C\u2563\u2551\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2510\u2591\u2592\u2593\u2502\u2524\u2116\xa7\u2557\u255D\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "cp720": {
        "type": "_sbcs",
        "chars": "\x80\x81\xe9\xe2\x84\xe0\x86\xe7\xea\xeb\xe8\xef\xee\x8d\x8e\x8f\x90\u0651\u0652\xf4\xa4\u0640\xfb\xf9\u0621\u0622\u0623\u0624\xa3\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0636\u0637\u0638\u0639\u063A\u0641\xb5\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u2261\u064B\u064C\u064D\u064E\u064F\u0650\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    // Aliases of generated encodings.
    "ascii8bit": "ascii",
    "usascii": "ascii",
    "ansix34": "ascii",
    "ansix341968": "ascii",
    "ansix341986": "ascii",
    "csascii": "ascii",
    "cp367": "ascii",
    "ibm367": "ascii",
    "isoir6": "ascii",
    "iso646us": "ascii",
    "iso646irv": "ascii",
    "us": "ascii",
    "latin1": "iso88591",
    "latin2": "iso88592",
    "latin3": "iso88593",
    "latin4": "iso88594",
    "latin5": "iso88599",
    "latin6": "iso885910",
    "latin7": "iso885913",
    "latin8": "iso885914",
    "latin9": "iso885915",
    "latin10": "iso885916",
    "csisolatin1": "iso88591",
    "csisolatin2": "iso88592",
    "csisolatin3": "iso88593",
    "csisolatin4": "iso88594",
    "csisolatincyrillic": "iso88595",
    "csisolatinarabic": "iso88596",
    "csisolatingreek": "iso88597",
    "csisolatinhebrew": "iso88598",
    "csisolatin5": "iso88599",
    "csisolatin6": "iso885910",
    "l1": "iso88591",
    "l2": "iso88592",
    "l3": "iso88593",
    "l4": "iso88594",
    "l5": "iso88599",
    "l6": "iso885910",
    "l7": "iso885913",
    "l8": "iso885914",
    "l9": "iso885915",
    "l10": "iso885916",
    "isoir14": "iso646jp",
    "isoir57": "iso646cn",
    "isoir100": "iso88591",
    "isoir101": "iso88592",
    "isoir109": "iso88593",
    "isoir110": "iso88594",
    "isoir144": "iso88595",
    "isoir127": "iso88596",
    "isoir126": "iso88597",
    "isoir138": "iso88598",
    "isoir148": "iso88599",
    "isoir157": "iso885910",
    "isoir166": "tis620",
    "isoir179": "iso885913",
    "isoir199": "iso885914",
    "isoir203": "iso885915",
    "isoir226": "iso885916",
    "cp819": "iso88591",
    "ibm819": "iso88591",
    "cyrillic": "iso88595",
    "arabic": "iso88596",
    "arabic8": "iso88596",
    "ecma114": "iso88596",
    "asmo708": "iso88596",
    "greek": "iso88597",
    "greek8": "iso88597",
    "ecma118": "iso88597",
    "elot928": "iso88597",
    "hebrew": "iso88598",
    "hebrew8": "iso88598",
    "turkish": "iso88599",
    "turkish8": "iso88599",
    "thai": "iso885911",
    "thai8": "iso885911",
    "celtic": "iso885914",
    "celtic8": "iso885914",
    "isoceltic": "iso885914",
    "tis6200": "tis620",
    "tis62025291": "tis620",
    "tis62025330": "tis620",
    "10000": "macroman",
    "10006": "macgreek",
    "10007": "maccyrillic",
    "10079": "maciceland",
    "10081": "macturkish",
    "cspc8codepage437": "cp437",
    "cspc775baltic": "cp775",
    "cspc850multilingual": "cp850",
    "cspcp852": "cp852",
    "cspc862latinhebrew": "cp862",
    "cpgr": "cp869",
    "msee": "cp1250",
    "mscyrl": "cp1251",
    "msansi": "cp1252",
    "msgreek": "cp1253",
    "msturk": "cp1254",
    "mshebr": "cp1255",
    "msarab": "cp1256",
    "winbaltrim": "cp1257",
    "cp20866": "koi8r",
    "20866": "koi8r",
    "ibm878": "koi8r",
    "cskoi8r": "koi8r",
    "cp21866": "koi8u",
    "21866": "koi8u",
    "ibm1168": "koi8u",
    "strk10482002": "rk1048",
    "tcvn5712": "tcvn",
    "tcvn57121": "tcvn",
    "gb198880": "iso646cn",
    "cn": "iso646cn",
    "csiso14jisc6220ro": "iso646jp",
    "jisc62201969ro": "iso646jp",
    "jp": "iso646jp",
    "cshproman8": "hproman8",
    "r8": "hproman8",
    "roman8": "hproman8",
    "xroman8": "hproman8",
    "ibm1051": "hproman8",
    "mac": "macintosh",
    "csmacintosh": "macintosh"
};

});

parcelRegister("dT4gJ", function(module, exports) {
"use strict";
// Generated data for sbcs codec. Don't edit manually. Regenerate using generation/gen-sbcs.js script.
module.exports = {
    "437": "cp437",
    "737": "cp737",
    "775": "cp775",
    "850": "cp850",
    "852": "cp852",
    "855": "cp855",
    "856": "cp856",
    "857": "cp857",
    "858": "cp858",
    "860": "cp860",
    "861": "cp861",
    "862": "cp862",
    "863": "cp863",
    "864": "cp864",
    "865": "cp865",
    "866": "cp866",
    "869": "cp869",
    "874": "windows874",
    "922": "cp922",
    "1046": "cp1046",
    "1124": "cp1124",
    "1125": "cp1125",
    "1129": "cp1129",
    "1133": "cp1133",
    "1161": "cp1161",
    "1162": "cp1162",
    "1163": "cp1163",
    "1250": "windows1250",
    "1251": "windows1251",
    "1252": "windows1252",
    "1253": "windows1253",
    "1254": "windows1254",
    "1255": "windows1255",
    "1256": "windows1256",
    "1257": "windows1257",
    "1258": "windows1258",
    "28591": "iso88591",
    "28592": "iso88592",
    "28593": "iso88593",
    "28594": "iso88594",
    "28595": "iso88595",
    "28596": "iso88596",
    "28597": "iso88597",
    "28598": "iso88598",
    "28599": "iso88599",
    "28600": "iso885910",
    "28601": "iso885911",
    "28603": "iso885913",
    "28604": "iso885914",
    "28605": "iso885915",
    "28606": "iso885916",
    "windows874": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\u2026\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "win874": "windows874",
    "cp874": "windows874",
    "windows1250": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\u0160\u2039\u015A\u0164\u017D\u0179\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0161\u203A\u015B\u0165\u017E\u017A\xa0\u02C7\u02D8\u0141\xa4\u0104\xa6\xa7\xa8\xa9\u015E\xab\xac\xad\xae\u017B\xb0\xb1\u02DB\u0142\xb4\xb5\xb6\xb7\xb8\u0105\u015F\xbb\u013D\u02DD\u013E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
    },
    "win1250": "windows1250",
    "cp1250": "windows1250",
    "windows1251": {
        "type": "_sbcs",
        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u040C\u040B\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u045C\u045B\u045F\xa0\u040E\u045E\u0408\xa4\u0490\xa6\xa7\u0401\xa9\u0404\xab\xac\xad\xae\u0407\xb0\xb1\u0406\u0456\u0491\xb5\xb6\xb7\u0451\u2116\u0454\xbb\u0458\u0405\u0455\u0457\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "win1251": "windows1251",
    "cp1251": "windows1251",
    "windows1252": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\u017D\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\u017E\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "win1252": "windows1252",
    "cp1252": "windows1252",
    "windows1253": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0385\u0386\xa3\xa4\xa5\xa6\xa7\xa8\xa9\uFFFD\xab\xac\xad\xae\u2015\xb0\xb1\xb2\xb3\u0384\xb5\xb6\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
    },
    "win1253": "windows1253",
    "cp1253": "windows1253",
    "windows1254": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
    },
    "win1254": "windows1254",
    "cp1254": "windows1254",
    "windows1255": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\xa1\xa2\xa3\u20AA\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\xbf\u05B0\u05B1\u05B2\u05B3\u05B4\u05B5\u05B6\u05B7\u05B8\u05B9\u05BA\u05BB\u05BC\u05BD\u05BE\u05BF\u05C0\u05C1\u05C2\u05C3\u05F0\u05F1\u05F2\u05F3\u05F4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
    },
    "win1255": "windows1255",
    "cp1255": "windows1255",
    "windows1256": {
        "type": "_sbcs",
        "chars": "\u20AC\u067E\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0679\u2039\u0152\u0686\u0698\u0688\u06AF\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u06A9\u2122\u0691\u203A\u0153\u200C\u200D\u06BA\xa0\u060C\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\u06BE\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\u061B\xbb\xbc\xbd\xbe\u061F\u06C1\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\xd7\u0637\u0638\u0639\u063A\u0640\u0641\u0642\u0643\xe0\u0644\xe2\u0645\u0646\u0647\u0648\xe7\xe8\xe9\xea\xeb\u0649\u064A\xee\xef\u064B\u064C\u064D\u064E\xf4\u064F\u0650\xf7\u0651\xf9\u0652\xfb\xfc\u200E\u200F\u06D2"
    },
    "win1256": "windows1256",
    "cp1256": "windows1256",
    "windows1257": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\xa8\u02C7\xb8\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\xaf\u02DB\uFFFD\xa0\uFFFD\xa2\xa3\xa4\uFFFD\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u02D9"
    },
    "win1257": "windows1257",
    "cp1257": "windows1257",
    "windows1258": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "win1258": "windows1258",
    "cp1258": "windows1258",
    "iso88591": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "cp28591": "iso88591",
    "iso88592": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u02D8\u0141\xa4\u013D\u015A\xa7\xa8\u0160\u015E\u0164\u0179\xad\u017D\u017B\xb0\u0105\u02DB\u0142\xb4\u013E\u015B\u02C7\xb8\u0161\u015F\u0165\u017A\u02DD\u017E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
    },
    "cp28592": "iso88592",
    "iso88593": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0126\u02D8\xa3\xa4\uFFFD\u0124\xa7\xa8\u0130\u015E\u011E\u0134\xad\uFFFD\u017B\xb0\u0127\xb2\xb3\xb4\xb5\u0125\xb7\xb8\u0131\u015F\u011F\u0135\xbd\uFFFD\u017C\xc0\xc1\xc2\uFFFD\xc4\u010A\u0108\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\uFFFD\xd1\xd2\xd3\xd4\u0120\xd6\xd7\u011C\xd9\xda\xdb\xdc\u016C\u015C\xdf\xe0\xe1\xe2\uFFFD\xe4\u010B\u0109\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\uFFFD\xf1\xf2\xf3\xf4\u0121\xf6\xf7\u011D\xf9\xfa\xfb\xfc\u016D\u015D\u02D9"
    },
    "cp28593": "iso88593",
    "iso88594": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0138\u0156\xa4\u0128\u013B\xa7\xa8\u0160\u0112\u0122\u0166\xad\u017D\xaf\xb0\u0105\u02DB\u0157\xb4\u0129\u013C\u02C7\xb8\u0161\u0113\u0123\u0167\u014A\u017E\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\u012A\u0110\u0145\u014C\u0136\xd4\xd5\xd6\xd7\xd8\u0172\xda\xdb\xdc\u0168\u016A\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\u012B\u0111\u0146\u014D\u0137\xf4\xf5\xf6\xf7\xf8\u0173\xfa\xfb\xfc\u0169\u016B\u02D9"
    },
    "cp28594": "iso88594",
    "iso88595": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0403\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0453\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
    },
    "cp28595": "iso88595",
    "iso88596": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\uFFFD\uFFFD\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u060C\xad\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u061B\uFFFD\uFFFD\uFFFD\u061F\uFFFD\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\u0638\u0639\u063A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "cp28596": "iso88596",
    "iso88597": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u2018\u2019\xa3\u20AC\u20AF\xa6\xa7\xa8\xa9\u037A\xab\xac\xad\uFFFD\u2015\xb0\xb1\xb2\xb3\u0384\u0385\u0386\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
    },
    "cp28597": "iso88597",
    "iso88598": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2017\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
    },
    "cp28598": "iso88598",
    "iso88599": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
    },
    "cp28599": "iso88599",
    "iso885910": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0112\u0122\u012A\u0128\u0136\xa7\u013B\u0110\u0160\u0166\u017D\xad\u016A\u014A\xb0\u0105\u0113\u0123\u012B\u0129\u0137\xb7\u013C\u0111\u0161\u0167\u017E\u2015\u016B\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\xcf\xd0\u0145\u014C\xd3\xd4\xd5\xd6\u0168\xd8\u0172\xda\xdb\xdc\xdd\xde\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\xef\xf0\u0146\u014D\xf3\xf4\xf5\xf6\u0169\xf8\u0173\xfa\xfb\xfc\xfd\xfe\u0138"
    },
    "cp28600": "iso885910",
    "iso885911": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "cp28601": "iso885911",
    "iso885913": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u201D\xa2\xa3\xa4\u201E\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\u201C\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u2019"
    },
    "cp28603": "iso885913",
    "iso885914": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u1E02\u1E03\xa3\u010A\u010B\u1E0A\xa7\u1E80\xa9\u1E82\u1E0B\u1EF2\xad\xae\u0178\u1E1E\u1E1F\u0120\u0121\u1E40\u1E41\xb6\u1E56\u1E81\u1E57\u1E83\u1E60\u1EF3\u1E84\u1E85\u1E61\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0174\xd1\xd2\xd3\xd4\xd5\xd6\u1E6A\xd8\xd9\xda\xdb\xdc\xdd\u0176\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0175\xf1\xf2\xf3\xf4\xf5\xf6\u1E6B\xf8\xf9\xfa\xfb\xfc\xfd\u0177\xff"
    },
    "cp28604": "iso885914",
    "iso885915": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\u0160\xa7\u0161\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u017D\xb5\xb6\xb7\u017E\xb9\xba\xbb\u0152\u0153\u0178\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "cp28605": "iso885915",
    "iso885916": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0105\u0141\u20AC\u201E\u0160\xa7\u0161\xa9\u0218\xab\u0179\xad\u017A\u017B\xb0\xb1\u010C\u0142\u017D\u201D\xb6\xb7\u017E\u010D\u0219\xbb\u0152\u0153\u0178\u017C\xc0\xc1\xc2\u0102\xc4\u0106\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0110\u0143\xd2\xd3\xd4\u0150\xd6\u015A\u0170\xd9\xda\xdb\xdc\u0118\u021A\xdf\xe0\xe1\xe2\u0103\xe4\u0107\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0111\u0144\xf2\xf3\xf4\u0151\xf6\u015B\u0171\xf9\xfa\xfb\xfc\u0119\u021B\xff"
    },
    "cp28606": "iso885916",
    "cp437": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm437": "cp437",
    "csibm437": "cp437",
    "cp737": {
        "type": "_sbcs",
        "chars": "\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u03C5\u03C6\u03C7\u03C8\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03C9\u03AC\u03AD\u03AE\u03CA\u03AF\u03CC\u03CD\u03CB\u03CE\u0386\u0388\u0389\u038A\u038C\u038E\u038F\xb1\u2265\u2264\u03AA\u03AB\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm737": "cp737",
    "csibm737": "cp737",
    "cp775": {
        "type": "_sbcs",
        "chars": "\u0106\xfc\xe9\u0101\xe4\u0123\xe5\u0107\u0142\u0113\u0156\u0157\u012B\u0179\xc4\xc5\xc9\xe6\xc6\u014D\xf6\u0122\xa2\u015A\u015B\xd6\xdc\xf8\xa3\xd8\xd7\xa4\u0100\u012A\xf3\u017B\u017C\u017A\u201D\xa6\xa9\xae\xac\xbd\xbc\u0141\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0104\u010C\u0118\u0116\u2563\u2551\u2557\u255D\u012E\u0160\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0172\u016A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u017D\u0105\u010D\u0119\u0117\u012F\u0161\u0173\u016B\u017E\u2518\u250C\u2588\u2584\u258C\u2590\u2580\xd3\xdf\u014C\u0143\xf5\xd5\xb5\u0144\u0136\u0137\u013B\u013C\u0146\u0112\u0145\u2019\xad\xb1\u201C\xbe\xb6\xa7\xf7\u201E\xb0\u2219\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm775": "cp775",
    "csibm775": "cp775",
    "cp850": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u0131\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm850": "cp850",
    "csibm850": "cp850",
    "cp852": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\u016F\u0107\xe7\u0142\xeb\u0150\u0151\xee\u0179\xc4\u0106\xc9\u0139\u013A\xf4\xf6\u013D\u013E\u015A\u015B\xd6\xdc\u0164\u0165\u0141\xd7\u010D\xe1\xed\xf3\xfa\u0104\u0105\u017D\u017E\u0118\u0119\xac\u017A\u010C\u015F\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\u011A\u015E\u2563\u2551\u2557\u255D\u017B\u017C\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0102\u0103\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u0111\u0110\u010E\xcb\u010F\u0147\xcd\xce\u011B\u2518\u250C\u2588\u2584\u0162\u016E\u2580\xd3\xdf\xd4\u0143\u0144\u0148\u0160\u0161\u0154\xda\u0155\u0170\xfd\xdd\u0163\xb4\xad\u02DD\u02DB\u02C7\u02D8\xa7\xf7\xb8\xb0\xa8\u02D9\u0171\u0158\u0159\u25A0\xa0"
    },
    "ibm852": "cp852",
    "csibm852": "cp852",
    "cp855": {
        "type": "_sbcs",
        "chars": "\u0452\u0402\u0453\u0403\u0451\u0401\u0454\u0404\u0455\u0405\u0456\u0406\u0457\u0407\u0458\u0408\u0459\u0409\u045A\u040A\u045B\u040B\u045C\u040C\u045E\u040E\u045F\u040F\u044E\u042E\u044A\u042A\u0430\u0410\u0431\u0411\u0446\u0426\u0434\u0414\u0435\u0415\u0444\u0424\u0433\u0413\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0445\u0425\u0438\u0418\u2563\u2551\u2557\u255D\u0439\u0419\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u043A\u041A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u043B\u041B\u043C\u041C\u043D\u041D\u043E\u041E\u043F\u2518\u250C\u2588\u2584\u041F\u044F\u2580\u042F\u0440\u0420\u0441\u0421\u0442\u0422\u0443\u0423\u0436\u0416\u0432\u0412\u044C\u042C\u2116\xad\u044B\u042B\u0437\u0417\u0448\u0428\u044D\u042D\u0449\u0429\u0447\u0427\xa7\u25A0\xa0"
    },
    "ibm855": "cp855",
    "csibm855": "cp855",
    "cp856": {
        "type": "_sbcs",
        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\xa3\uFFFD\xd7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xae\xac\xbd\xbc\uFFFD\xab\xbb\u2591\u2592\u2593\u2502\u2524\uFFFD\uFFFD\uFFFD\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\uFFFD\uFFFD\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2518\u250C\u2588\u2584\xa6\uFFFD\u2580\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xb5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm856": "cp856",
    "csibm856": "cp856",
    "cp857": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\u0131\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\u0130\xd6\xdc\xf8\xa3\xd8\u015E\u015F\xe1\xed\xf3\xfa\xf1\xd1\u011E\u011F\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xba\xaa\xca\xcb\xc8\uFFFD\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\uFFFD\xd7\xda\xdb\xd9\xec\xff\xaf\xb4\xad\xb1\uFFFD\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm857": "cp857",
    "csibm857": "cp857",
    "cp858": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u20AC\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm858": "cp858",
    "csibm858": "cp858",
    "cp860": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe3\xe0\xc1\xe7\xea\xca\xe8\xcd\xd4\xec\xc3\xc2\xc9\xc0\xc8\xf4\xf5\xf2\xda\xf9\xcc\xd5\xdc\xa2\xa3\xd9\u20A7\xd3\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xd2\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm860": "cp860",
    "csibm860": "cp860",
    "cp861": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xd0\xf0\xde\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xfe\xfb\xdd\xfd\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xc1\xcd\xd3\xda\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm861": "cp861",
    "csibm861": "cp861",
    "cp862": {
        "type": "_sbcs",
        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm862": "cp862",
    "csibm862": "cp862",
    "cp863": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xc2\xe0\xb6\xe7\xea\xeb\xe8\xef\xee\u2017\xc0\xa7\xc9\xc8\xca\xf4\xcb\xcf\xfb\xf9\xa4\xd4\xdc\xa2\xa3\xd9\xdb\u0192\xa6\xb4\xf3\xfa\xa8\xb8\xb3\xaf\xce\u2310\xac\xbd\xbc\xbe\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm863": "cp863",
    "csibm863": "cp863",
    "cp864": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$\u066A&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xb0\xb7\u2219\u221A\u2592\u2500\u2502\u253C\u2524\u252C\u251C\u2534\u2510\u250C\u2514\u2518\u03B2\u221E\u03C6\xb1\xbd\xbc\u2248\xab\xbb\uFEF7\uFEF8\uFFFD\uFFFD\uFEFB\uFEFC\uFFFD\xa0\xad\uFE82\xa3\xa4\uFE84\uFFFD\uFFFD\uFE8E\uFE8F\uFE95\uFE99\u060C\uFE9D\uFEA1\uFEA5\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFED1\u061B\uFEB1\uFEB5\uFEB9\u061F\xa2\uFE80\uFE81\uFE83\uFE85\uFECA\uFE8B\uFE8D\uFE91\uFE93\uFE97\uFE9B\uFE9F\uFEA3\uFEA7\uFEA9\uFEAB\uFEAD\uFEAF\uFEB3\uFEB7\uFEBB\uFEBF\uFEC1\uFEC5\uFECB\uFECF\xa6\xac\xf7\xd7\uFEC9\u0640\uFED3\uFED7\uFEDB\uFEDF\uFEE3\uFEE7\uFEEB\uFEED\uFEEF\uFEF3\uFEBD\uFECC\uFECE\uFECD\uFEE1\uFE7D\u0651\uFEE5\uFEE9\uFEEC\uFEF0\uFEF2\uFED0\uFED5\uFEF5\uFEF6\uFEDD\uFED9\uFEF1\u25A0\uFFFD"
    },
    "ibm864": "cp864",
    "csibm864": "cp864",
    "cp865": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xa4\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm865": "cp865",
    "csibm865": "cp865",
    "cp866": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\xa4\u25A0\xa0"
    },
    "ibm866": "cp866",
    "csibm866": "cp866",
    "cp869": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0386\uFFFD\xb7\xac\xa6\u2018\u2019\u0388\u2015\u0389\u038A\u03AA\u038C\uFFFD\uFFFD\u038E\u03AB\xa9\u038F\xb2\xb3\u03AC\xa3\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03CD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\xbd\u0398\u0399\xab\xbb\u2591\u2592\u2593\u2502\u2524\u039A\u039B\u039C\u039D\u2563\u2551\u2557\u255D\u039E\u039F\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u03A0\u03A1\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u2518\u250C\u2588\u2584\u03B4\u03B5\u2580\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u0384\xad\xb1\u03C5\u03C6\u03C7\xa7\u03C8\u0385\xb0\xa8\u03C9\u03CB\u03B0\u03CE\u25A0\xa0"
    },
    "ibm869": "cp869",
    "csibm869": "cp869",
    "cp922": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\u203E\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0160\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\u017D\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0161\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\u017E\xff"
    },
    "ibm922": "cp922",
    "csibm922": "cp922",
    "cp1046": {
        "type": "_sbcs",
        "chars": "\uFE88\xd7\xf7\uF8F6\uF8F5\uF8F4\uF8F7\uFE71\x88\u25A0\u2502\u2500\u2510\u250C\u2514\u2518\uFE79\uFE7B\uFE7D\uFE7F\uFE77\uFE8A\uFEF0\uFEF3\uFEF2\uFECE\uFECF\uFED0\uFEF6\uFEF8\uFEFA\uFEFC\xa0\uF8FA\uF8F9\uF8F8\xa4\uF8FB\uFE8B\uFE91\uFE97\uFE9B\uFE9F\uFEA3\u060C\xad\uFEA7\uFEB3\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFEB7\u061B\uFEBB\uFEBF\uFECA\u061F\uFECB\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\uFEC7\u0639\u063A\uFECC\uFE82\uFE84\uFE8E\uFED3\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFED7\uFEDB\uFEDF\uF8FC\uFEF5\uFEF7\uFEF9\uFEFB\uFEE3\uFEE7\uFEEC\uFEE9\uFFFD"
    },
    "ibm1046": "cp1046",
    "csibm1046": "cp1046",
    "cp1124": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0490\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0491\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
    },
    "ibm1124": "cp1124",
    "csibm1124": "cp1124",
    "cp1125": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0490\u0491\u0404\u0454\u0406\u0456\u0407\u0457\xb7\u221A\u2116\xa4\u25A0\xa0"
    },
    "ibm1125": "cp1125",
    "csibm1125": "cp1125",
    "cp1129": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "ibm1129": "cp1129",
    "csibm1129": "cp1129",
    "cp1133": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E81\u0E82\u0E84\u0E87\u0E88\u0EAA\u0E8A\u0E8D\u0E94\u0E95\u0E96\u0E97\u0E99\u0E9A\u0E9B\u0E9C\u0E9D\u0E9E\u0E9F\u0EA1\u0EA2\u0EA3\u0EA5\u0EA7\u0EAB\u0EAD\u0EAE\uFFFD\uFFFD\uFFFD\u0EAF\u0EB0\u0EB2\u0EB3\u0EB4\u0EB5\u0EB6\u0EB7\u0EB8\u0EB9\u0EBC\u0EB1\u0EBB\u0EBD\uFFFD\uFFFD\uFFFD\u0EC0\u0EC1\u0EC2\u0EC3\u0EC4\u0EC8\u0EC9\u0ECA\u0ECB\u0ECC\u0ECD\u0EC6\uFFFD\u0EDC\u0EDD\u20AD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0ED0\u0ED1\u0ED2\u0ED3\u0ED4\u0ED5\u0ED6\u0ED7\u0ED8\u0ED9\uFFFD\uFFFD\xa2\xac\xa6\uFFFD"
    },
    "ibm1133": "cp1133",
    "csibm1133": "cp1133",
    "cp1161": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E48\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\u0E49\u0E4A\u0E4B\u20AC\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\xa2\xac\xa6\xa0"
    },
    "ibm1161": "cp1161",
    "csibm1161": "cp1161",
    "cp1162": {
        "type": "_sbcs",
        "chars": "\u20AC\x81\x82\x83\x84\u2026\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "ibm1162": "cp1162",
    "csibm1162": "cp1162",
    "cp1163": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "ibm1163": "cp1163",
    "csibm1163": "cp1163",
    "maccroatian": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u2126\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uFFFD\xa9\u2044\xa4\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7"
    },
    "maccyrillic": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\xa2\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u2202\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
    },
    "macgreek": {
        "type": "_sbcs",
        "chars": "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\xad\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\u0387\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026\xa0\u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\uFFFD"
    },
    "maciceland": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macroman": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macromania": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u015E\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\u0103\u015F\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\u0162\u0163\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macthai": {
        "type": "_sbcs",
        "chars": "\xab\xbb\u2026\uF88C\uF88F\uF892\uF895\uF898\uF88B\uF88E\uF891\uF894\uF897\u201C\u201D\uF899\uFFFD\u2022\uF884\uF889\uF885\uF886\uF887\uF888\uF88A\uF88D\uF890\uF893\uF896\u2018\u2019\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFEFF\u200B\u2013\u2014\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u2122\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\xae\xa9\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "macturkish": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\uFFFD\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macukraine": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\u0490\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u0491\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
    },
    "koi8r": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u2553\u2554\u2555\u2556\u2557\u2558\u2559\u255A\u255B\u255C\u255D\u255E\u255F\u2560\u2561\u0401\u2562\u2563\u2564\u2565\u2566\u2567\u2568\u2569\u256A\u256B\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8u": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u255D\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8ru": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u045E\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u040E\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8t": {
        "type": "_sbcs",
        "chars": "\u049B\u0493\u201A\u0492\u201E\u2026\u2020\u2021\uFFFD\u2030\u04B3\u2039\u04B2\u04B7\u04B6\uFFFD\u049A\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u04EF\u04EE\u0451\xa4\u04E3\xa6\xa7\uFFFD\uFFFD\uFFFD\xab\xac\xad\xae\uFFFD\xb0\xb1\xb2\u0401\uFFFD\u04E2\xb6\xb7\uFFFD\u2116\uFFFD\xbb\uFFFD\uFFFD\uFFFD\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "armscii8": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\u0587\u0589)(\xbb\xab\u2014.\u055D,-\u058A\u2026\u055C\u055B\u055E\u0531\u0561\u0532\u0562\u0533\u0563\u0534\u0564\u0535\u0565\u0536\u0566\u0537\u0567\u0538\u0568\u0539\u0569\u053A\u056A\u053B\u056B\u053C\u056C\u053D\u056D\u053E\u056E\u053F\u056F\u0540\u0570\u0541\u0571\u0542\u0572\u0543\u0573\u0544\u0574\u0545\u0575\u0546\u0576\u0547\u0577\u0548\u0578\u0549\u0579\u054A\u057A\u054B\u057B\u054C\u057C\u054D\u057D\u054E\u057E\u054F\u057F\u0550\u0580\u0551\u0581\u0552\u0582\u0553\u0583\u0554\u0584\u0555\u0585\u0556\u0586\u055A\uFFFD"
    },
    "rk1048": {
        "type": "_sbcs",
        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u049A\u04BA\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u049B\u04BB\u045F\xa0\u04B0\u04B1\u04D8\xa4\u04E8\xa6\xa7\u0401\xa9\u0492\xab\xac\xad\xae\u04AE\xb0\xb1\u0406\u0456\u04E9\xb5\xb6\xb7\u0451\u2116\u0493\xbb\u04D9\u04A2\u04A3\u04AF\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "tcvn": {
        "type": "_sbcs",
        "chars": "\0\xda\u1EE4\x03\u1EEA\u1EEC\u1EEE\x07\b	\n\v\f\r\x0e\x0f\x10\u1EE8\u1EF0\u1EF2\u1EF6\u1EF8\xdd\u1EF4\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc0\u1EA2\xc3\xc1\u1EA0\u1EB6\u1EAC\xc8\u1EBA\u1EBC\xc9\u1EB8\u1EC6\xcc\u1EC8\u0128\xcd\u1ECA\xd2\u1ECE\xd5\xd3\u1ECC\u1ED8\u1EDC\u1EDE\u1EE0\u1EDA\u1EE2\xd9\u1EE6\u0168\xa0\u0102\xc2\xca\xd4\u01A0\u01AF\u0110\u0103\xe2\xea\xf4\u01A1\u01B0\u0111\u1EB0\u0300\u0309\u0303\u0301\u0323\xe0\u1EA3\xe3\xe1\u1EA1\u1EB2\u1EB1\u1EB3\u1EB5\u1EAF\u1EB4\u1EAE\u1EA6\u1EA8\u1EAA\u1EA4\u1EC0\u1EB7\u1EA7\u1EA9\u1EAB\u1EA5\u1EAD\xe8\u1EC2\u1EBB\u1EBD\xe9\u1EB9\u1EC1\u1EC3\u1EC5\u1EBF\u1EC7\xec\u1EC9\u1EC4\u1EBE\u1ED2\u0129\xed\u1ECB\xf2\u1ED4\u1ECF\xf5\xf3\u1ECD\u1ED3\u1ED5\u1ED7\u1ED1\u1ED9\u1EDD\u1EDF\u1EE1\u1EDB\u1EE3\xf9\u1ED6\u1EE7\u0169\xfa\u1EE5\u1EEB\u1EED\u1EEF\u1EE9\u1EF1\u1EF3\u1EF7\u1EF9\xfd\u1EF5\u1ED0"
    },
    "georgianacademy": {
        "type": "_sbcs",
        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10EF\u10F0\u10F1\u10F2\u10F3\u10F4\u10F5\u10F6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "georgianps": {
        "type": "_sbcs",
        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10F1\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10F2\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10F3\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10F4\u10EF\u10F0\u10F5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "pt154": {
        "type": "_sbcs",
        "chars": "\u0496\u0492\u04EE\u0493\u201E\u2026\u04B6\u04AE\u04B2\u04AF\u04A0\u04E2\u04A2\u049A\u04BA\u04B8\u0497\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u04B3\u04B7\u04A1\u04E3\u04A3\u049B\u04BB\u04B9\xa0\u040E\u045E\u0408\u04E8\u0498\u04B0\xa7\u0401\xa9\u04D8\xab\xac\u04EF\xae\u049C\xb0\u04B1\u0406\u0456\u0499\u04E9\xb6\xb7\u0451\u2116\u04D9\xbb\u0458\u04AA\u04AB\u049D\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "viscii": {
        "type": "_sbcs",
        "chars": "\0\x01\u1EB2\x03\x04\u1EB4\u1EAA\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\u1EF6\x15\x16\x17\x18\u1EF8\x1a\x1b\x1c\x1d\u1EF4\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u1EA0\u1EAE\u1EB0\u1EB6\u1EA4\u1EA6\u1EA8\u1EAC\u1EBC\u1EB8\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EE2\u1EDA\u1EDC\u1EDE\u1ECA\u1ECE\u1ECC\u1EC8\u1EE6\u0168\u1EE4\u1EF2\xd5\u1EAF\u1EB1\u1EB7\u1EA5\u1EA7\u1EA9\u1EAD\u1EBD\u1EB9\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1ED1\u1ED3\u1ED5\u1ED7\u1EE0\u01A0\u1ED9\u1EDD\u1EDF\u1ECB\u1EF0\u1EE8\u1EEA\u1EEC\u01A1\u1EDB\u01AF\xc0\xc1\xc2\xc3\u1EA2\u0102\u1EB3\u1EB5\xc8\xc9\xca\u1EBA\xcc\xcd\u0128\u1EF3\u0110\u1EE9\xd2\xd3\xd4\u1EA1\u1EF7\u1EEB\u1EED\xd9\xda\u1EF9\u1EF5\xdd\u1EE1\u01B0\xe0\xe1\xe2\xe3\u1EA3\u0103\u1EEF\u1EAB\xe8\xe9\xea\u1EBB\xec\xed\u0129\u1EC9\u0111\u1EF1\xf2\xf3\xf4\xf5\u1ECF\u1ECD\u1EE5\xf9\xfa\u0169\u1EE7\xfd\u1EE3\u1EEE"
    },
    "iso646cn": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#\xa5%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "iso646jp": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\xa5]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "hproman8": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xc0\xc2\xc8\xca\xcb\xce\xcf\xb4\u02CB\u02C6\xa8\u02DC\xd9\xdb\u20A4\xaf\xdd\xfd\xb0\xc7\xe7\xd1\xf1\xa1\xbf\xa4\xa3\xa5\xa7\u0192\xa2\xe2\xea\xf4\xfb\xe1\xe9\xf3\xfa\xe0\xe8\xf2\xf9\xe4\xeb\xf6\xfc\xc5\xee\xd8\xc6\xe5\xed\xf8\xe6\xc4\xec\xd6\xdc\xc9\xef\xdf\xd4\xc1\xc3\xe3\xd0\xf0\xcd\xcc\xd3\xd2\xd5\xf5\u0160\u0161\xda\u0178\xff\xde\xfe\xb7\xb5\xb6\xbe\u2014\xbc\xbd\xaa\xba\xab\u25A0\xbb\xb1\uFFFD"
    },
    "macintosh": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "ascii": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "tis620": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    }
};

});

parcelRegister("8J3I3", function(module, exports) {

$parcel$export(module.exports, "_dbcs", function () { return $65a56758ff5a3d30$export$d4d33b1e1c7abf2e; }, function (v) { return $65a56758ff5a3d30$export$d4d33b1e1c7abf2e = v; });
// Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
// Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
// To save memory and loading time, we read table files only when requested.
var $65a56758ff5a3d30$export$d4d33b1e1c7abf2e;
"use strict";

var $llyme = parcelRequire("llyme");
var $65a56758ff5a3d30$require$Buffer = $llyme.Buffer;
$65a56758ff5a3d30$export$d4d33b1e1c7abf2e = $65a56758ff5a3d30$var$DBCSCodec;
var $65a56758ff5a3d30$var$UNASSIGNED = -1, $65a56758ff5a3d30$var$GB18030_CODE = -2, $65a56758ff5a3d30$var$SEQ_START = -10, $65a56758ff5a3d30$var$NODE_START = -1000, $65a56758ff5a3d30$var$UNASSIGNED_NODE = new Array(0x100), $65a56758ff5a3d30$var$DEF_CHAR = -1;
for(var $65a56758ff5a3d30$var$i = 0; $65a56758ff5a3d30$var$i < 0x100; $65a56758ff5a3d30$var$i++)$65a56758ff5a3d30$var$UNASSIGNED_NODE[$65a56758ff5a3d30$var$i] = $65a56758ff5a3d30$var$UNASSIGNED;
// Class DBCSCodec reads and initializes mapping tables.
function $65a56758ff5a3d30$var$DBCSCodec(codecOptions, iconv) {
    this.encodingName = codecOptions.encodingName;
    if (!codecOptions) throw new Error("DBCS codec is called without the data.");
    if (!codecOptions.table) throw new Error("Encoding '" + this.encodingName + "' has no data.");
    // Load tables.
    var mappingTable = codecOptions.table();
    // Decode tables: MBCS -> Unicode.
    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
    // Trie root is decodeTables[0].
    // Values: >=  0 -> unicode character code. can be > 0xFFFF
    //         == UNASSIGNED -> unknown/unassigned sequence.
    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
    //         <= NODE_START -> index of the next node in our trie to process next byte.
    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
    this.decodeTables = [];
    this.decodeTables[0] = $65a56758ff5a3d30$var$UNASSIGNED_NODE.slice(0); // Create root node.
    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here. 
    this.decodeTableSeq = [];
    // Actual mapping tables consist of chunks. Use them to fill up decode tables.
    for(var i = 0; i < mappingTable.length; i++)this._addDecodeChunk(mappingTable[i]);
    // Load & create GB18030 tables when needed.
    if (typeof codecOptions.gb18030 === 'function') {
        this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.
        // Add GB18030 common decode nodes.
        var commonThirdByteNodeIdx = this.decodeTables.length;
        this.decodeTables.push($65a56758ff5a3d30$var$UNASSIGNED_NODE.slice(0));
        var commonFourthByteNodeIdx = this.decodeTables.length;
        this.decodeTables.push($65a56758ff5a3d30$var$UNASSIGNED_NODE.slice(0));
        // Fill out the tree
        var firstByteNode = this.decodeTables[0];
        for(var i = 0x81; i <= 0xFE; i++){
            var secondByteNode = this.decodeTables[$65a56758ff5a3d30$var$NODE_START - firstByteNode[i]];
            for(var j = 0x30; j <= 0x39; j++){
                if (secondByteNode[j] === $65a56758ff5a3d30$var$UNASSIGNED) secondByteNode[j] = $65a56758ff5a3d30$var$NODE_START - commonThirdByteNodeIdx;
                else if (secondByteNode[j] > $65a56758ff5a3d30$var$NODE_START) throw new Error("gb18030 decode tables conflict at byte 2");
                var thirdByteNode = this.decodeTables[$65a56758ff5a3d30$var$NODE_START - secondByteNode[j]];
                for(var k = 0x81; k <= 0xFE; k++){
                    if (thirdByteNode[k] === $65a56758ff5a3d30$var$UNASSIGNED) thirdByteNode[k] = $65a56758ff5a3d30$var$NODE_START - commonFourthByteNodeIdx;
                    else if (thirdByteNode[k] === $65a56758ff5a3d30$var$NODE_START - commonFourthByteNodeIdx) continue;
                    else if (thirdByteNode[k] > $65a56758ff5a3d30$var$NODE_START) throw new Error("gb18030 decode tables conflict at byte 3");
                    var fourthByteNode = this.decodeTables[$65a56758ff5a3d30$var$NODE_START - thirdByteNode[k]];
                    for(var l = 0x30; l <= 0x39; l++)if (fourthByteNode[l] === $65a56758ff5a3d30$var$UNASSIGNED) fourthByteNode[l] = $65a56758ff5a3d30$var$GB18030_CODE;
                }
            }
        }
    }
    this.defaultCharUnicode = iconv.defaultCharUnicode;
    // Encode tables: Unicode -> DBCS.
    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
    //         == UNASSIGNED -> no conversion found. Output a default char.
    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
    this.encodeTable = [];
    // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
    // means end of sequence (needed when one sequence is a strict subsequence of another).
    // Objects are kept separately from encodeTable to increase performance.
    this.encodeTableSeq = [];
    // Some chars can be decoded, but need not be encoded.
    var skipEncodeChars = {};
    if (codecOptions.encodeSkipVals) for(var i = 0; i < codecOptions.encodeSkipVals.length; i++){
        var val = codecOptions.encodeSkipVals[i];
        if (typeof val === 'number') skipEncodeChars[val] = true;
        else for(var j = val.from; j <= val.to; j++)skipEncodeChars[j] = true;
    }
    // Use decode trie to recursively fill out encode tables.
    this._fillEncodeTable(0, 0, skipEncodeChars);
    // Add more encoding pairs when needed.
    if (codecOptions.encodeAdd) {
        for(var uChar in codecOptions.encodeAdd)if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar)) this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
    }
    this.defCharSB = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
    if (this.defCharSB === $65a56758ff5a3d30$var$UNASSIGNED) this.defCharSB = this.encodeTable[0]['?'];
    if (this.defCharSB === $65a56758ff5a3d30$var$UNASSIGNED) this.defCharSB = "?".charCodeAt(0);
}
$65a56758ff5a3d30$var$DBCSCodec.prototype.encoder = $65a56758ff5a3d30$var$DBCSEncoder;
$65a56758ff5a3d30$var$DBCSCodec.prototype.decoder = $65a56758ff5a3d30$var$DBCSDecoder;
// Decoder helpers
$65a56758ff5a3d30$var$DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
    var bytes = [];
    for(; addr > 0; addr >>>= 8)bytes.push(addr & 0xFF);
    if (bytes.length == 0) bytes.push(0);
    var node = this.decodeTables[0];
    for(var i = bytes.length - 1; i > 0; i--){
        var val = node[bytes[i]];
        if (val == $65a56758ff5a3d30$var$UNASSIGNED) {
            node[bytes[i]] = $65a56758ff5a3d30$var$NODE_START - this.decodeTables.length;
            this.decodeTables.push(node = $65a56758ff5a3d30$var$UNASSIGNED_NODE.slice(0));
        } else if (val <= $65a56758ff5a3d30$var$NODE_START) node = this.decodeTables[$65a56758ff5a3d30$var$NODE_START - val];
        else throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
    }
    return node;
};
$65a56758ff5a3d30$var$DBCSCodec.prototype._addDecodeChunk = function(chunk) {
    // First element of chunk is the hex mbcs code where we start.
    var curAddr = parseInt(chunk[0], 16);
    // Choose the decoding node where we'll write our chars.
    var writeTable = this._getDecodeTrieNode(curAddr);
    curAddr = curAddr & 0xFF;
    // Write all other elements of the chunk to the table.
    for(var k = 1; k < chunk.length; k++){
        var part = chunk[k];
        if (typeof part === "string") for(var l = 0; l < part.length;){
            var code = part.charCodeAt(l++);
            if (0xD800 <= code && code < 0xDC00) {
                var codeTrail = part.charCodeAt(l++);
                if (0xDC00 <= codeTrail && codeTrail < 0xE000) writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
                else throw new Error("Incorrect surrogate pair in " + this.encodingName + " at chunk " + chunk[0]);
            } else if (0x0FF0 < code && code <= 0x0FFF) {
                var len = 0xFFF - code + 2;
                var seq = [];
                for(var m = 0; m < len; m++)seq.push(part.charCodeAt(l++)); // Simple variation: don't support surrogates or subsequences in seq.
                writeTable[curAddr++] = $65a56758ff5a3d30$var$SEQ_START - this.decodeTableSeq.length;
                this.decodeTableSeq.push(seq);
            } else writeTable[curAddr++] = code; // Basic char
        }
        else if (typeof part === "number") {
            var charCode = writeTable[curAddr - 1] + 1;
            for(var l = 0; l < part; l++)writeTable[curAddr++] = charCode++;
        } else throw new Error("Incorrect type '" + typeof part + "' given in " + this.encodingName + " at chunk " + chunk[0]);
    }
    if (curAddr > 0xFF) throw new Error("Incorrect chunk in " + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
};
// Encoder helpers
$65a56758ff5a3d30$var$DBCSCodec.prototype._getEncodeBucket = function(uCode) {
    var high = uCode >> 8; // This could be > 0xFF because of astral characters.
    if (this.encodeTable[high] === undefined) this.encodeTable[high] = $65a56758ff5a3d30$var$UNASSIGNED_NODE.slice(0); // Create bucket on demand.
    return this.encodeTable[high];
};
$65a56758ff5a3d30$var$DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    if (bucket[low] <= $65a56758ff5a3d30$var$SEQ_START) this.encodeTableSeq[$65a56758ff5a3d30$var$SEQ_START - bucket[low]][$65a56758ff5a3d30$var$DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
    else if (bucket[low] == $65a56758ff5a3d30$var$UNASSIGNED) bucket[low] = dbcsCode;
};
$65a56758ff5a3d30$var$DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
    // Get the root of character tree according to first character of the sequence.
    var uCode = seq[0];
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    var node;
    if (bucket[low] <= $65a56758ff5a3d30$var$SEQ_START) // There's already a sequence with  - use it.
    node = this.encodeTableSeq[$65a56758ff5a3d30$var$SEQ_START - bucket[low]];
    else {
        // There was no sequence object - allocate a new one.
        node = {};
        if (bucket[low] !== $65a56758ff5a3d30$var$UNASSIGNED) node[$65a56758ff5a3d30$var$DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
        bucket[low] = $65a56758ff5a3d30$var$SEQ_START - this.encodeTableSeq.length;
        this.encodeTableSeq.push(node);
    }
    // Traverse the character tree, allocating new nodes as needed.
    for(var j = 1; j < seq.length - 1; j++){
        var oldVal = node[uCode];
        if (typeof oldVal === 'object') node = oldVal;
        else {
            node = node[uCode] = {};
            if (oldVal !== undefined) node[$65a56758ff5a3d30$var$DEF_CHAR] = oldVal;
        }
    }
    // Set the leaf to given dbcsCode.
    uCode = seq[seq.length - 1];
    node[uCode] = dbcsCode;
};
$65a56758ff5a3d30$var$DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
    var node = this.decodeTables[nodeIdx];
    var hasValues = false;
    var subNodeEmpty = {};
    for(var i = 0; i < 0x100; i++){
        var uCode = node[i];
        var mbCode = prefix + i;
        if (skipEncodeChars[mbCode]) continue;
        if (uCode >= 0) {
            this._setEncodeChar(uCode, mbCode);
            hasValues = true;
        } else if (uCode <= $65a56758ff5a3d30$var$NODE_START) {
            var subNodeIdx = $65a56758ff5a3d30$var$NODE_START - uCode;
            if (!subNodeEmpty[subNodeIdx]) {
                var newPrefix = mbCode << 8 >>> 0; // NOTE: '>>> 0' keeps 32-bit num positive.
                if (this._fillEncodeTable(subNodeIdx, newPrefix, skipEncodeChars)) hasValues = true;
                else subNodeEmpty[subNodeIdx] = true;
            }
        } else if (uCode <= $65a56758ff5a3d30$var$SEQ_START) {
            this._setEncodeSequence(this.decodeTableSeq[$65a56758ff5a3d30$var$SEQ_START - uCode], mbCode);
            hasValues = true;
        }
    }
    return hasValues;
};
// == Encoder ==================================================================
function $65a56758ff5a3d30$var$DBCSEncoder(options, codec) {
    // Encoder state
    this.leadSurrogate = -1;
    this.seqObj = undefined;
    // Static data
    this.encodeTable = codec.encodeTable;
    this.encodeTableSeq = codec.encodeTableSeq;
    this.defaultCharSingleByte = codec.defCharSB;
    this.gb18030 = codec.gb18030;
}
$65a56758ff5a3d30$var$DBCSEncoder.prototype.write = function(str) {
    var newBuf = $65a56758ff5a3d30$require$Buffer.alloc(str.length * (this.gb18030 ? 4 : 3)), leadSurrogate = this.leadSurrogate, seqObj = this.seqObj, nextChar = -1, i = 0, j = 0;
    while(true){
        // 0. Get next character.
        if (nextChar === -1) {
            if (i == str.length) break;
            var uCode = str.charCodeAt(i++);
        } else {
            var uCode = nextChar;
            nextChar = -1;
        }
        // 1. Handle surrogates.
        if (0xD800 <= uCode && uCode < 0xE000) {
            if (uCode < 0xDC00) {
                if (leadSurrogate === -1) {
                    leadSurrogate = uCode;
                    continue;
                } else {
                    leadSurrogate = uCode;
                    // Double lead surrogate found.
                    uCode = $65a56758ff5a3d30$var$UNASSIGNED;
                }
            } else if (leadSurrogate !== -1) {
                uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
                leadSurrogate = -1;
            } else // Incomplete surrogate pair - only trail surrogate found.
            uCode = $65a56758ff5a3d30$var$UNASSIGNED;
        } else if (leadSurrogate !== -1) {
            // Incomplete surrogate pair - only lead surrogate found.
            nextChar = uCode;
            uCode = $65a56758ff5a3d30$var$UNASSIGNED; // Write an error, then current char.
            leadSurrogate = -1;
        }
        // 2. Convert uCode character.
        var dbcsCode = $65a56758ff5a3d30$var$UNASSIGNED;
        if (seqObj !== undefined && uCode != $65a56758ff5a3d30$var$UNASSIGNED) {
            var resCode = seqObj[uCode];
            if (typeof resCode === 'object') {
                seqObj = resCode;
                continue;
            } else if (typeof resCode == 'number') dbcsCode = resCode;
            else if (resCode == undefined) {
                // Try default character for this sequence
                resCode = seqObj[$65a56758ff5a3d30$var$DEF_CHAR];
                if (resCode !== undefined) {
                    dbcsCode = resCode; // Found. Write it.
                    nextChar = uCode; // Current character will be written too in the next iteration.
                }
            }
            seqObj = undefined;
        } else if (uCode >= 0) {
            var subtable = this.encodeTable[uCode >> 8];
            if (subtable !== undefined) dbcsCode = subtable[uCode & 0xFF];
            if (dbcsCode <= $65a56758ff5a3d30$var$SEQ_START) {
                seqObj = this.encodeTableSeq[$65a56758ff5a3d30$var$SEQ_START - dbcsCode];
                continue;
            }
            if (dbcsCode == $65a56758ff5a3d30$var$UNASSIGNED && this.gb18030) {
                // Use GB18030 algorithm to find character(s) to write.
                var idx = $65a56758ff5a3d30$var$findIdx(this.gb18030.uChars, uCode);
                if (idx != -1) {
                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600);
                    dbcsCode = dbcsCode % 12600;
                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260);
                    dbcsCode = dbcsCode % 1260;
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10);
                    dbcsCode = dbcsCode % 10;
                    newBuf[j++] = 0x30 + dbcsCode;
                    continue;
                }
            }
        }
        // 3. Write dbcsCode character.
        if (dbcsCode === $65a56758ff5a3d30$var$UNASSIGNED) dbcsCode = this.defaultCharSingleByte;
        if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
        else if (dbcsCode < 0x10000) {
            newBuf[j++] = dbcsCode >> 8; // high byte
            newBuf[j++] = dbcsCode & 0xFF; // low byte
        } else if (dbcsCode < 0x1000000) {
            newBuf[j++] = dbcsCode >> 16;
            newBuf[j++] = dbcsCode >> 8 & 0xFF;
            newBuf[j++] = dbcsCode & 0xFF;
        } else {
            newBuf[j++] = dbcsCode >>> 24;
            newBuf[j++] = dbcsCode >>> 16 & 0xFF;
            newBuf[j++] = dbcsCode >>> 8 & 0xFF;
            newBuf[j++] = dbcsCode & 0xFF;
        }
    }
    this.seqObj = seqObj;
    this.leadSurrogate = leadSurrogate;
    return newBuf.slice(0, j);
};
$65a56758ff5a3d30$var$DBCSEncoder.prototype.end = function() {
    if (this.leadSurrogate === -1 && this.seqObj === undefined) return; // All clean. Most often case.
    var newBuf = $65a56758ff5a3d30$require$Buffer.alloc(10), j = 0;
    if (this.seqObj) {
        var dbcsCode = this.seqObj[$65a56758ff5a3d30$var$DEF_CHAR];
        if (dbcsCode !== undefined) {
            if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
            else {
                newBuf[j++] = dbcsCode >> 8; // high byte
                newBuf[j++] = dbcsCode & 0xFF; // low byte
            }
        } else ;
        this.seqObj = undefined;
    }
    if (this.leadSurrogate !== -1) {
        // Incomplete surrogate pair - only lead surrogate found.
        newBuf[j++] = this.defaultCharSingleByte;
        this.leadSurrogate = -1;
    }
    return newBuf.slice(0, j);
};
// Export for testing
$65a56758ff5a3d30$var$DBCSEncoder.prototype.findIdx = $65a56758ff5a3d30$var$findIdx;
// == Decoder ==================================================================
function $65a56758ff5a3d30$var$DBCSDecoder(options, codec) {
    // Decoder state
    this.nodeIdx = 0;
    this.prevBytes = [];
    // Static data
    this.decodeTables = codec.decodeTables;
    this.decodeTableSeq = codec.decodeTableSeq;
    this.defaultCharUnicode = codec.defaultCharUnicode;
    this.gb18030 = codec.gb18030;
}
$65a56758ff5a3d30$var$DBCSDecoder.prototype.write = function(buf) {
    var newBuf = $65a56758ff5a3d30$require$Buffer.alloc(buf.length * 2), nodeIdx = this.nodeIdx, prevBytes = this.prevBytes, prevOffset = this.prevBytes.length, seqStart = -this.prevBytes.length, uCode;
    for(var i = 0, j = 0; i < buf.length; i++){
        var curByte = i >= 0 ? buf[i] : prevBytes[i + prevOffset];
        // Lookup in current trie node.
        var uCode = this.decodeTables[nodeIdx][curByte];
        if (uCode >= 0) ;
        else if (uCode === $65a56758ff5a3d30$var$UNASSIGNED) {
            // TODO: Callback with seq.
            uCode = this.defaultCharUnicode.charCodeAt(0);
            i = seqStart; // Skip one byte ('i' will be incremented by the for loop) and try to parse again.
        } else if (uCode === $65a56758ff5a3d30$var$GB18030_CODE) {
            if (i >= 3) var ptr = (buf[i - 3] - 0x81) * 12600 + (buf[i - 2] - 0x30) * 1260 + (buf[i - 1] - 0x81) * 10 + (curByte - 0x30);
            else var ptr = (prevBytes[i - 3 + prevOffset] - 0x81) * 12600 + ((i - 2 >= 0 ? buf[i - 2] : prevBytes[i - 2 + prevOffset]) - 0x30) * 1260 + ((i - 1 >= 0 ? buf[i - 1] : prevBytes[i - 1 + prevOffset]) - 0x81) * 10 + (curByte - 0x30);
            var idx = $65a56758ff5a3d30$var$findIdx(this.gb18030.gbChars, ptr);
            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
        } else if (uCode <= $65a56758ff5a3d30$var$NODE_START) {
            nodeIdx = $65a56758ff5a3d30$var$NODE_START - uCode;
            continue;
        } else if (uCode <= $65a56758ff5a3d30$var$SEQ_START) {
            var seq = this.decodeTableSeq[$65a56758ff5a3d30$var$SEQ_START - uCode];
            for(var k = 0; k < seq.length - 1; k++){
                uCode = seq[k];
                newBuf[j++] = uCode & 0xFF;
                newBuf[j++] = uCode >> 8;
            }
            uCode = seq[seq.length - 1];
        } else throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte);
        // Write the character to buffer, handling higher planes using surrogate pair.
        if (uCode >= 0x10000) {
            uCode -= 0x10000;
            var uCodeLead = 0xD800 | uCode >> 10;
            newBuf[j++] = uCodeLead & 0xFF;
            newBuf[j++] = uCodeLead >> 8;
            uCode = 0xDC00 | uCode & 0x3FF;
        }
        newBuf[j++] = uCode & 0xFF;
        newBuf[j++] = uCode >> 8;
        // Reset trie node.
        nodeIdx = 0;
        seqStart = i + 1;
    }
    this.nodeIdx = nodeIdx;
    this.prevBytes = seqStart >= 0 ? Array.prototype.slice.call(buf, seqStart) : prevBytes.slice(seqStart + prevOffset).concat(Array.prototype.slice.call(buf));
    return newBuf.slice(0, j).toString('ucs2');
};
$65a56758ff5a3d30$var$DBCSDecoder.prototype.end = function() {
    var ret = '';
    // Try to parse all remaining chars.
    while(this.prevBytes.length > 0){
        // Skip 1 character in the buffer.
        ret += this.defaultCharUnicode;
        var bytesArr = this.prevBytes.slice(1);
        // Parse remaining as usual.
        this.prevBytes = [];
        this.nodeIdx = 0;
        if (bytesArr.length > 0) ret += this.write(bytesArr);
    }
    this.prevBytes = [];
    this.nodeIdx = 0;
    return ret;
};
// Binary search for GB18030. Returns largest i such that table[i] <= val.
function $65a56758ff5a3d30$var$findIdx(table, val) {
    if (table[0] > val) return -1;
    var l = 0, r = table.length;
    while(l < r - 1){
        var mid = l + (r - l + 1 >> 1);
        if (table[mid] <= val) l = mid;
        else r = mid;
    }
    return l;
}

});

parcelRegister("9CmWE", function(module, exports) {
"use strict";












// Description of supported double byte encodings and aliases.
// Tables are not require()-d until they are needed to speed up library load.
// require()-s are direct to support Browserify.
module.exports = {
    // == Japanese/ShiftJIS ====================================================
    // All japanese encodings are based on JIS X set of standards:
    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
    //              Has several variations in 1978, 1983, 1990 and 1997.
    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
    //              2 planes, first is superset of 0208, second - revised 0212.
    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)
    // Byte encodings are:
    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
    //               0x00-0x7F       - lower part of 0201
    //               0x8E, 0xA1-0xDF - upper part of 0201
    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
    //               Used as-is in ISO2022 family.
    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
    //                0201-1976 Roman, 0208-1978, 0208-1983.
    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
    //
    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
    //
    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html
    'shiftjis': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("gpjpL"));
        },
        encodeAdd: {
            '\u00a5': 0x5C,
            '\u203E': 0x7E
        },
        encodeSkipVals: [
            {
                from: 0xED40,
                to: 0xF940
            }
        ]
    },
    'csshiftjis': 'shiftjis',
    'mskanji': 'shiftjis',
    'sjis': 'shiftjis',
    'windows31j': 'shiftjis',
    'ms31j': 'shiftjis',
    'xsjis': 'shiftjis',
    'windows932': 'shiftjis',
    'ms932': 'shiftjis',
    '932': 'shiftjis',
    'cp932': 'shiftjis',
    'eucjp': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("5nKA3"));
        },
        encodeAdd: {
            '\u00a5': 0x5C,
            '\u203E': 0x7E
        }
    },
    // TODO: KDDI extension to Shift_JIS
    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.
    // == Chinese/GBK ==========================================================
    // http://en.wikipedia.org/wiki/GBK
    // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder
    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
    'gb2312': 'cp936',
    'gb231280': 'cp936',
    'gb23121980': 'cp936',
    'csgb2312': 'cp936',
    'csiso58gb231280': 'cp936',
    'euccn': 'cp936',
    // Microsoft's CP936 is a subset and approximation of GBK.
    'windows936': 'cp936',
    'ms936': 'cp936',
    '936': 'cp936',
    'cp936': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("8Jkbm"));
        }
    },
    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
    'gbk': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("8Jkbm")).concat((parcelRequire("9IQ1F")));
        }
    },
    'xgbk': 'gbk',
    'isoir58': 'gbk',
    // GB18030 is an algorithmic extension of GBK.
    // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
    // http://icu-project.org/docs/papers/gb18030.html
    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
    'gb18030': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("8Jkbm")).concat((parcelRequire("9IQ1F")));
        },
        gb18030: function() {
            return (parcelRequire("8hI5g"));
        },
        encodeSkipVals: [
            0x80
        ],
        encodeAdd: {
            "\u20AC": 0xA2E3
        }
    },
    'chinese': 'gb18030',
    // == Korean ===============================================================
    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
    'windows949': 'cp949',
    'ms949': 'cp949',
    '949': 'cp949',
    'cp949': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("arsul"));
        }
    },
    'cseuckr': 'cp949',
    'csksc56011987': 'cp949',
    'euckr': 'cp949',
    'isoir149': 'cp949',
    'korean': 'cp949',
    'ksc56011987': 'cp949',
    'ksc56011989': 'cp949',
    'ksc5601': 'cp949',
    // == Big5/Taiwan/Hong Kong ================================================
    // There are lots of tables for Big5 and cp950. Please see the following links for history:
    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
    // Variations, in roughly number of defined chars:
    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
    //    Plus, it has 4 combining sequences.
    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
    // 
    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.
    'windows950': 'cp950',
    'ms950': 'cp950',
    '950': 'cp950',
    'cp950': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("f8vlO"));
        }
    },
    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
    'big5': 'big5hkscs',
    'big5hkscs': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("f8vlO")).concat((parcelRequire("ls33I")));
        },
        encodeSkipVals: [
            // Although Encoding Standard says we should avoid encoding to HKSCS area (See Step 1 of
            // https://encoding.spec.whatwg.org/#index-big5-pointer), we still do it to increase compatibility with ICU.
            // But if a single unicode point can be encoded both as HKSCS and regular Big5, we prefer the latter.
            0x8e69,
            0x8e6f,
            0x8e7e,
            0x8eab,
            0x8eb4,
            0x8ecd,
            0x8ed0,
            0x8f57,
            0x8f69,
            0x8f6e,
            0x8fcb,
            0x8ffe,
            0x906d,
            0x907a,
            0x90c4,
            0x90dc,
            0x90f1,
            0x91bf,
            0x92af,
            0x92b0,
            0x92b1,
            0x92b2,
            0x92d1,
            0x9447,
            0x94ca,
            0x95d9,
            0x96fc,
            0x9975,
            0x9b76,
            0x9b78,
            0x9b7b,
            0x9bc6,
            0x9bde,
            0x9bec,
            0x9bf6,
            0x9c42,
            0x9c53,
            0x9c62,
            0x9c68,
            0x9c6b,
            0x9c77,
            0x9cbc,
            0x9cbd,
            0x9cd0,
            0x9d57,
            0x9d5a,
            0x9dc4,
            0x9def,
            0x9dfb,
            0x9ea9,
            0x9eef,
            0x9efd,
            0x9f60,
            0x9fcb,
            0xa077,
            0xa0dc,
            0xa0df,
            0x8fcc,
            0x92c8,
            0x9644,
            0x96ed,
            // Step 2 of https://encoding.spec.whatwg.org/#index-big5-pointer: Use last pointer for U+2550, U+255E, U+2561, U+256A, U+5341, or U+5345
            0xa2a4,
            0xa2a5,
            0xa2a7,
            0xa2a6,
            0xa2cc,
            0xa2ce
        ]
    },
    'cnbig5': 'big5hkscs',
    'csbig5': 'big5hkscs',
    'xxbig5': 'big5hkscs'
};

});
parcelRegister("gpjpL", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",128],["a1","\uFF61",62],["8140","\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",9,"\uFF0B\uFF0D\xb1\xd7"],["8180","\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"],["81b8","\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"],["81c8","\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"],["81da","\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"],["81f0","\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"],["81fc","\u25EF"],["824f","\uFF10",9],["8260","\uFF21",25],["8281","\uFF41",25],["829f","\u3041",82],["8340","\u30A1",62],["8380","\u30E0",22],["839f","\u0391",16,"\u03A3",6],["83bf","\u03B1",16,"\u03C3",6],["8440","\u0410",5,"\u0401\u0416",25],["8470","\u0430",5,"\u0451\u0436",7],["8480","\u043E",17],["849f","\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"],["8740","\u2460",19,"\u2160",9],["875f","\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"],["877e","\u337B"],["8780","\u301D\u301F\u2116\u33CD\u2121\u32A4",4,"\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"],["889f","\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"],["8940","\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186"],["8980","\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"],["8a40","\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B"],["8a80","\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"],["8b40","\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551"],["8b80","\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"],["8c40","\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8"],["8c80","\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"],["8d40","\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D"],["8d80","\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"],["8e40","\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62"],["8e80","\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"],["8f40","\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3"],["8f80","\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"],["9040","\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8"],["9080","\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"],["9140","\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB"],["9180","\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"],["9240","\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4"],["9280","\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"],["9340","\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC"],["9380","\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"],["9440","\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885"],["9480","\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"],["9540","\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577"],["9580","\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"],["9640","\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6"],["9680","\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"],["9740","\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32"],["9780","\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"],["9840","\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"],["989f","\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"],["9940","\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED"],["9980","\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"],["9a40","\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638"],["9a80","\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"],["9b40","\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80"],["9b80","\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"],["9c40","\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060"],["9c80","\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"],["9d40","\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B"],["9d80","\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"],["9e40","\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E"],["9e80","\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"],["9f40","\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF"],["9f80","\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"],["e040","\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD"],["e080","\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"],["e140","\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF"],["e180","\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"],["e240","\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0"],["e280","\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"],["e340","\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37"],["e380","\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"],["e440","\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264"],["e480","\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"],["e540","\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC"],["e580","\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"],["e640","\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7"],["e680","\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"],["e740","\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C"],["e780","\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"],["e840","\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599"],["e880","\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"],["e940","\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43"],["e980","\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"],["ea40","\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF"],["ea80","\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0\u582F\u69C7\u9059\u7464\u51DC\u7199"],["ed40","\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F"],["ed80","\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"],["ee40","\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559"],["ee80","\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"],["eeef","\u2170",9,"\uFFE2\uFFE4\uFF07\uFF02"],["f040","\uE000",62],["f080","\uE03F",124],["f140","\uE0BC",62],["f180","\uE0FB",124],["f240","\uE178",62],["f280","\uE1B7",124],["f340","\uE234",62],["f380","\uE273",124],["f440","\uE2F0",62],["f480","\uE32F",124],["f540","\uE3AC",62],["f580","\uE3EB",124],["f640","\uE468",62],["f680","\uE4A7",124],["f740","\uE524",62],["f780","\uE563",124],["f840","\uE5E0",62],["f880","\uE61F",124],["f940","\uE69C"],["fa40","\u2170",9,"\u2160",9,"\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u2235\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A"],["fa80","\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F"],["fb40","\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19"],["fb80","\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9"],["fc40","\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"]]');

});

parcelRegister("5nKA3", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",127],["8ea1","\uFF61",62],["a1a1","\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",9,"\uFF0B\uFF0D\xb1\xd7\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7"],["a2a1","\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"],["a2ba","\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"],["a2ca","\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"],["a2dc","\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"],["a2f2","\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"],["a2fe","\u25EF"],["a3b0","\uFF10",9],["a3c1","\uFF21",25],["a3e1","\uFF41",25],["a4a1","\u3041",82],["a5a1","\u30A1",85],["a6a1","\u0391",16,"\u03A3",6],["a6c1","\u03B1",16,"\u03C3",6],["a7a1","\u0410",5,"\u0401\u0416",25],["a7d1","\u0430",5,"\u0451\u0436",25],["a8a1","\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"],["ada1","\u2460",19,"\u2160",9],["adc0","\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"],["addf","\u337B\u301D\u301F\u2116\u33CD\u2121\u32A4",4,"\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"],["b0a1","\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"],["b1a1","\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC"],["b2a1","\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"],["b3a1","\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431"],["b4a1","\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"],["b5a1","\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC"],["b6a1","\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"],["b7a1","\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372"],["b8a1","\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"],["b9a1","\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC"],["baa1","\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"],["bba1","\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642"],["bca1","\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"],["bda1","\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F"],["bea1","\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"],["bfa1","\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE"],["c0a1","\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"],["c1a1","\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E"],["c2a1","\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"],["c3a1","\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5"],["c4a1","\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"],["c5a1","\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230"],["c6a1","\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"],["c7a1","\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6"],["c8a1","\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"],["c9a1","\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D"],["caa1","\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"],["cba1","\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80"],["cca1","\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"],["cda1","\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483"],["cea1","\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"],["cfa1","\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"],["d0a1","\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"],["d1a1","\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8"],["d2a1","\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"],["d3a1","\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709"],["d4a1","\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"],["d5a1","\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53"],["d6a1","\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"],["d7a1","\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A"],["d8a1","\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"],["d9a1","\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC"],["daa1","\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"],["dba1","\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD"],["dca1","\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"],["dda1","\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE"],["dea1","\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"],["dfa1","\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC"],["e0a1","\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"],["e1a1","\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670"],["e2a1","\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"],["e3a1","\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50"],["e4a1","\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"],["e5a1","\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A"],["e6a1","\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"],["e7a1","\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9"],["e8a1","\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"],["e9a1","\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759"],["eaa1","\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"],["eba1","\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B"],["eca1","\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"],["eda1","\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8"],["eea1","\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"],["efa1","\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E"],["f0a1","\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"],["f1a1","\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7"],["f2a1","\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"],["f3a1","\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0"],["f4a1","\u582F\u69C7\u9059\u7464\u51DC\u7199"],["f9a1","\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7"],["faa1","\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"],["fba1","\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA"],["fca1","\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"],["fcf1","\u2170",9,"\uFFE2\uFFE4\uFF07\uFF02"],["8fa2af","\u02D8\u02C7\xb8\u02D9\u02DD\xaf\u02DB\u02DA\uFF5E\u0384\u0385"],["8fa2c2","\xa1\xa6\xbf"],["8fa2eb","\xba\xaa\xa9\xae\u2122\xa4\u2116"],["8fa6e1","\u0386\u0388\u0389\u038A\u03AA"],["8fa6e7","\u038C"],["8fa6e9","\u038E\u03AB"],["8fa6ec","\u038F"],["8fa6f1","\u03AC\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03C2\u03CD\u03CB\u03B0\u03CE"],["8fa7c2","\u0402",10,"\u040E\u040F"],["8fa7f2","\u0452",10,"\u045E\u045F"],["8fa9a1","\xc6\u0110"],["8fa9a4","\u0126"],["8fa9a6","\u0132"],["8fa9a8","\u0141\u013F"],["8fa9ab","\u014A\xd8\u0152"],["8fa9af","\u0166\xde"],["8fa9c1","\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0142\u0140\u0149\u014B\xf8\u0153\xdf\u0167\xfe"],["8faaa1","\xc1\xc0\xc4\xc2\u0102\u01CD\u0100\u0104\xc5\xc3\u0106\u0108\u010C\xc7\u010A\u010E\xc9\xc8\xcb\xca\u011A\u0116\u0112\u0118"],["8faaba","\u011C\u011E\u0122\u0120\u0124\xcd\xcc\xcf\xce\u01CF\u0130\u012A\u012E\u0128\u0134\u0136\u0139\u013D\u013B\u0143\u0147\u0145\xd1\xd3\xd2\xd6\xd4\u01D1\u0150\u014C\xd5\u0154\u0158\u0156\u015A\u015C\u0160\u015E\u0164\u0162\xda\xd9\xdc\xdb\u016C\u01D3\u0170\u016A\u0172\u016E\u0168\u01D7\u01DB\u01D9\u01D5\u0174\xdd\u0178\u0176\u0179\u017D\u017B"],["8faba1","\xe1\xe0\xe4\xe2\u0103\u01CE\u0101\u0105\xe5\xe3\u0107\u0109\u010D\xe7\u010B\u010F\xe9\xe8\xeb\xea\u011B\u0117\u0113\u0119\u01F5\u011D\u011F"],["8fabbd","\u0121\u0125\xed\xec\xef\xee\u01D0"],["8fabc5","\u012B\u012F\u0129\u0135\u0137\u013A\u013E\u013C\u0144\u0148\u0146\xf1\xf3\xf2\xf6\xf4\u01D2\u0151\u014D\xf5\u0155\u0159\u0157\u015B\u015D\u0161\u015F\u0165\u0163\xfa\xf9\xfc\xfb\u016D\u01D4\u0171\u016B\u0173\u016F\u0169\u01D8\u01DC\u01DA\u01D6\u0175\xfd\xff\u0177\u017A\u017E\u017C"],["8fb0a1","\u4E02\u4E04\u4E05\u4E0C\u4E12\u4E1F\u4E23\u4E24\u4E28\u4E2B\u4E2E\u4E2F\u4E30\u4E35\u4E40\u4E41\u4E44\u4E47\u4E51\u4E5A\u4E5C\u4E63\u4E68\u4E69\u4E74\u4E75\u4E79\u4E7F\u4E8D\u4E96\u4E97\u4E9D\u4EAF\u4EB9\u4EC3\u4ED0\u4EDA\u4EDB\u4EE0\u4EE1\u4EE2\u4EE8\u4EEF\u4EF1\u4EF3\u4EF5\u4EFD\u4EFE\u4EFF\u4F00\u4F02\u4F03\u4F08\u4F0B\u4F0C\u4F12\u4F15\u4F16\u4F17\u4F19\u4F2E\u4F31\u4F60\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E\u4F40\u4F42\u4F48\u4F49\u4F4B\u4F4C\u4F52\u4F54\u4F56\u4F58\u4F5F\u4F63\u4F6A\u4F6C\u4F6E\u4F71\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F7E\u4F81\u4F82\u4F84"],["8fb1a1","\u4F85\u4F89\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F94\u4F97\u4F99\u4F9A\u4F9E\u4F9F\u4FB2\u4FB7\u4FB9\u4FBB\u4FBC\u4FBD\u4FBE\u4FC0\u4FC1\u4FC5\u4FC6\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FCF\u4FD2\u4FDC\u4FE0\u4FE2\u4FF0\u4FF2\u4FFC\u4FFD\u4FFF\u5000\u5001\u5004\u5007\u500A\u500C\u500E\u5010\u5013\u5017\u5018\u501B\u501C\u501D\u501E\u5022\u5027\u502E\u5030\u5032\u5033\u5035\u5040\u5041\u5042\u5045\u5046\u504A\u504C\u504E\u5051\u5052\u5053\u5057\u5059\u505F\u5060\u5062\u5063\u5066\u5067\u506A\u506D\u5070\u5071\u503B\u5081\u5083\u5084\u5086\u508A\u508E\u508F\u5090"],["8fb2a1","\u5092\u5093\u5094\u5096\u509B\u509C\u509E",4,"\u50AA\u50AF\u50B0\u50B9\u50BA\u50BD\u50C0\u50C3\u50C4\u50C7\u50CC\u50CE\u50D0\u50D3\u50D4\u50D8\u50DC\u50DD\u50DF\u50E2\u50E4\u50E6\u50E8\u50E9\u50EF\u50F1\u50F6\u50FA\u50FE\u5103\u5106\u5107\u5108\u510B\u510C\u510D\u510E\u50F2\u5110\u5117\u5119\u511B\u511C\u511D\u511E\u5123\u5127\u5128\u512C\u512D\u512F\u5131\u5133\u5134\u5135\u5138\u5139\u5142\u514A\u514F\u5153\u5155\u5157\u5158\u515F\u5164\u5166\u517E\u5183\u5184\u518B\u518E\u5198\u519D\u51A1\u51A3\u51AD\u51B8\u51BA\u51BC\u51BE\u51BF\u51C2"],["8fb3a1","\u51C8\u51CF\u51D1\u51D2\u51D3\u51D5\u51D8\u51DE\u51E2\u51E5\u51EE\u51F2\u51F3\u51F4\u51F7\u5201\u5202\u5205\u5212\u5213\u5215\u5216\u5218\u5222\u5228\u5231\u5232\u5235\u523C\u5245\u5249\u5255\u5257\u5258\u525A\u525C\u525F\u5260\u5261\u5266\u526E\u5277\u5278\u5279\u5280\u5282\u5285\u528A\u528C\u5293\u5295\u5296\u5297\u5298\u529A\u529C\u52A4\u52A5\u52A6\u52A7\u52AF\u52B0\u52B6\u52B7\u52B8\u52BA\u52BB\u52BD\u52C0\u52C4\u52C6\u52C8\u52CC\u52CF\u52D1\u52D4\u52D6\u52DB\u52DC\u52E1\u52E5\u52E8\u52E9\u52EA\u52EC\u52F0\u52F1\u52F4\u52F6\u52F7\u5300\u5303\u530A\u530B"],["8fb4a1","\u530C\u5311\u5313\u5318\u531B\u531C\u531E\u531F\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u5330\u5332\u5335\u533C\u533D\u533E\u5342\u534C\u534B\u5359\u535B\u5361\u5363\u5365\u536C\u536D\u5372\u5379\u537E\u5383\u5387\u5388\u538E\u5393\u5394\u5399\u539D\u53A1\u53A4\u53AA\u53AB\u53AF\u53B2\u53B4\u53B5\u53B7\u53B8\u53BA\u53BD\u53C0\u53C5\u53CF\u53D2\u53D3\u53D5\u53DA\u53DD\u53DE\u53E0\u53E6\u53E7\u53F5\u5402\u5413\u541A\u5421\u5427\u5428\u542A\u542F\u5431\u5434\u5435\u5443\u5444\u5447\u544D\u544F\u545E\u5462\u5464\u5466\u5467\u5469\u546B\u546D\u546E\u5474\u547F"],["8fb5a1","\u5481\u5483\u5485\u5488\u5489\u548D\u5491\u5495\u5496\u549C\u549F\u54A1\u54A6\u54A7\u54A9\u54AA\u54AD\u54AE\u54B1\u54B7\u54B9\u54BA\u54BB\u54BF\u54C6\u54CA\u54CD\u54CE\u54E0\u54EA\u54EC\u54EF\u54F6\u54FC\u54FE\u54FF\u5500\u5501\u5505\u5508\u5509\u550C\u550D\u550E\u5515\u552A\u552B\u5532\u5535\u5536\u553B\u553C\u553D\u5541\u5547\u5549\u554A\u554D\u5550\u5551\u5558\u555A\u555B\u555E\u5560\u5561\u5564\u5566\u557F\u5581\u5582\u5586\u5588\u558E\u558F\u5591\u5592\u5593\u5594\u5597\u55A3\u55A4\u55AD\u55B2\u55BF\u55C1\u55C3\u55C6\u55C9\u55CB\u55CC\u55CE\u55D1\u55D2"],["8fb6a1","\u55D3\u55D7\u55D8\u55DB\u55DE\u55E2\u55E9\u55F6\u55FF\u5605\u5608\u560A\u560D",5,"\u5619\u562C\u5630\u5633\u5635\u5637\u5639\u563B\u563C\u563D\u563F\u5640\u5641\u5643\u5644\u5646\u5649\u564B\u564D\u564F\u5654\u565E\u5660\u5661\u5662\u5663\u5666\u5669\u566D\u566F\u5671\u5672\u5675\u5684\u5685\u5688\u568B\u568C\u5695\u5699\u569A\u569D\u569E\u569F\u56A6\u56A7\u56A8\u56A9\u56AB\u56AC\u56AD\u56B1\u56B3\u56B7\u56BE\u56C5\u56C9\u56CA\u56CB\u56CF\u56D0\u56CC\u56CD\u56D9\u56DC\u56DD\u56DF\u56E1\u56E4",4,"\u56F1\u56EB\u56ED"],["8fb7a1","\u56F6\u56F7\u5701\u5702\u5707\u570A\u570C\u5711\u5715\u571A\u571B\u571D\u5720\u5722\u5723\u5724\u5725\u5729\u572A\u572C\u572E\u572F\u5733\u5734\u573D\u573E\u573F\u5745\u5746\u574C\u574D\u5752\u5762\u5765\u5767\u5768\u576B\u576D",4,"\u5773\u5774\u5775\u5777\u5779\u577A\u577B\u577C\u577E\u5781\u5783\u578C\u5794\u5797\u5799\u579A\u579C\u579D\u579E\u579F\u57A1\u5795\u57A7\u57A8\u57A9\u57AC\u57B8\u57BD\u57C7\u57C8\u57CC\u57CF\u57D5\u57DD\u57DE\u57E4\u57E6\u57E7\u57E9\u57ED\u57F0\u57F5\u57F6\u57F8\u57FD\u57FE\u57FF\u5803\u5804\u5808\u5809\u57E1"],["8fb8a1","\u580C\u580D\u581B\u581E\u581F\u5820\u5826\u5827\u582D\u5832\u5839\u583F\u5849\u584C\u584D\u584F\u5850\u5855\u585F\u5861\u5864\u5867\u5868\u5878\u587C\u587F\u5880\u5881\u5887\u5888\u5889\u588A\u588C\u588D\u588F\u5890\u5894\u5896\u589D\u58A0\u58A1\u58A2\u58A6\u58A9\u58B1\u58B2\u58C4\u58BC\u58C2\u58C8\u58CD\u58CE\u58D0\u58D2\u58D4\u58D6\u58DA\u58DD\u58E1\u58E2\u58E9\u58F3\u5905\u5906\u590B\u590C\u5912\u5913\u5914\u8641\u591D\u5921\u5923\u5924\u5928\u592F\u5930\u5933\u5935\u5936\u593F\u5943\u5946\u5952\u5953\u5959\u595B\u595D\u595E\u595F\u5961\u5963\u596B\u596D"],["8fb9a1","\u596F\u5972\u5975\u5976\u5979\u597B\u597C\u598B\u598C\u598E\u5992\u5995\u5997\u599F\u59A4\u59A7\u59AD\u59AE\u59AF\u59B0\u59B3\u59B7\u59BA\u59BC\u59C1\u59C3\u59C4\u59C8\u59CA\u59CD\u59D2\u59DD\u59DE\u59DF\u59E3\u59E4\u59E7\u59EE\u59EF\u59F1\u59F2\u59F4\u59F7\u5A00\u5A04\u5A0C\u5A0D\u5A0E\u5A12\u5A13\u5A1E\u5A23\u5A24\u5A27\u5A28\u5A2A\u5A2D\u5A30\u5A44\u5A45\u5A47\u5A48\u5A4C\u5A50\u5A55\u5A5E\u5A63\u5A65\u5A67\u5A6D\u5A77\u5A7A\u5A7B\u5A7E\u5A8B\u5A90\u5A93\u5A96\u5A99\u5A9C\u5A9E\u5A9F\u5AA0\u5AA2\u5AA7\u5AAC\u5AB1\u5AB2\u5AB3\u5AB5\u5AB8\u5ABA\u5ABB\u5ABF"],["8fbaa1","\u5AC4\u5AC6\u5AC8\u5ACF\u5ADA\u5ADC\u5AE0\u5AE5\u5AEA\u5AEE\u5AF5\u5AF6\u5AFD\u5B00\u5B01\u5B08\u5B17\u5B34\u5B19\u5B1B\u5B1D\u5B21\u5B25\u5B2D\u5B38\u5B41\u5B4B\u5B4C\u5B52\u5B56\u5B5E\u5B68\u5B6E\u5B6F\u5B7C\u5B7D\u5B7E\u5B7F\u5B81\u5B84\u5B86\u5B8A\u5B8E\u5B90\u5B91\u5B93\u5B94\u5B96\u5BA8\u5BA9\u5BAC\u5BAD\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBC\u5BC0\u5BC1\u5BCD\u5BCF\u5BD6",4,"\u5BE0\u5BEF\u5BF1\u5BF4\u5BFD\u5C0C\u5C17\u5C1E\u5C1F\u5C23\u5C26\u5C29\u5C2B\u5C2C\u5C2E\u5C30\u5C32\u5C35\u5C36\u5C59\u5C5A\u5C5C\u5C62\u5C63\u5C67\u5C68\u5C69"],["8fbba1","\u5C6D\u5C70\u5C74\u5C75\u5C7A\u5C7B\u5C7C\u5C7D\u5C87\u5C88\u5C8A\u5C8F\u5C92\u5C9D\u5C9F\u5CA0\u5CA2\u5CA3\u5CA6\u5CAA\u5CB2\u5CB4\u5CB5\u5CBA\u5CC9\u5CCB\u5CD2\u5CDD\u5CD7\u5CEE\u5CF1\u5CF2\u5CF4\u5D01\u5D06\u5D0D\u5D12\u5D2B\u5D23\u5D24\u5D26\u5D27\u5D31\u5D34\u5D39\u5D3D\u5D3F\u5D42\u5D43\u5D46\u5D48\u5D55\u5D51\u5D59\u5D4A\u5D5F\u5D60\u5D61\u5D62\u5D64\u5D6A\u5D6D\u5D70\u5D79\u5D7A\u5D7E\u5D7F\u5D81\u5D83\u5D88\u5D8A\u5D92\u5D93\u5D94\u5D95\u5D99\u5D9B\u5D9F\u5DA0\u5DA7\u5DAB\u5DB0\u5DB4\u5DB8\u5DB9\u5DC3\u5DC7\u5DCB\u5DD0\u5DCE\u5DD8\u5DD9\u5DE0\u5DE4"],["8fbca1","\u5DE9\u5DF8\u5DF9\u5E00\u5E07\u5E0D\u5E12\u5E14\u5E15\u5E18\u5E1F\u5E20\u5E2E\u5E28\u5E32\u5E35\u5E3E\u5E4B\u5E50\u5E49\u5E51\u5E56\u5E58\u5E5B\u5E5C\u5E5E\u5E68\u5E6A",4,"\u5E70\u5E80\u5E8B\u5E8E\u5EA2\u5EA4\u5EA5\u5EA8\u5EAA\u5EAC\u5EB1\u5EB3\u5EBD\u5EBE\u5EBF\u5EC6\u5ECC\u5ECB\u5ECE\u5ED1\u5ED2\u5ED4\u5ED5\u5EDC\u5EDE\u5EE5\u5EEB\u5F02\u5F06\u5F07\u5F08\u5F0E\u5F19\u5F1C\u5F1D\u5F21\u5F22\u5F23\u5F24\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F34\u5F36\u5F3B\u5F3D\u5F3F\u5F40\u5F44\u5F45\u5F47\u5F4D\u5F50\u5F54\u5F58\u5F5B\u5F60\u5F63\u5F64\u5F67"],["8fbda1","\u5F6F\u5F72\u5F74\u5F75\u5F78\u5F7A\u5F7D\u5F7E\u5F89\u5F8D\u5F8F\u5F96\u5F9C\u5F9D\u5FA2\u5FA7\u5FAB\u5FA4\u5FAC\u5FAF\u5FB0\u5FB1\u5FB8\u5FC4\u5FC7\u5FC8\u5FC9\u5FCB\u5FD0",4,"\u5FDE\u5FE1\u5FE2\u5FE8\u5FE9\u5FEA\u5FEC\u5FED\u5FEE\u5FEF\u5FF2\u5FF3\u5FF6\u5FFA\u5FFC\u6007\u600A\u600D\u6013\u6014\u6017\u6018\u601A\u601F\u6024\u602D\u6033\u6035\u6040\u6047\u6048\u6049\u604C\u6051\u6054\u6056\u6057\u605D\u6061\u6067\u6071\u607E\u607F\u6082\u6086\u6088\u608A\u608E\u6091\u6093\u6095\u6098\u609D\u609E\u60A2\u60A4\u60A5\u60A8\u60B0\u60B1\u60B7"],["8fbea1","\u60BB\u60BE\u60C2\u60C4\u60C8\u60C9\u60CA\u60CB\u60CE\u60CF\u60D4\u60D5\u60D9\u60DB\u60DD\u60DE\u60E2\u60E5\u60F2\u60F5\u60F8\u60FC\u60FD\u6102\u6107\u610A\u610C\u6110",4,"\u6116\u6117\u6119\u611C\u611E\u6122\u612A\u612B\u6130\u6131\u6135\u6136\u6137\u6139\u6141\u6145\u6146\u6149\u615E\u6160\u616C\u6172\u6178\u617B\u617C\u617F\u6180\u6181\u6183\u6184\u618B\u618D\u6192\u6193\u6197\u6198\u619C\u619D\u619F\u61A0\u61A5\u61A8\u61AA\u61AD\u61B8\u61B9\u61BC\u61C0\u61C1\u61C2\u61CE\u61CF\u61D5\u61DC\u61DD\u61DE\u61DF\u61E1\u61E2\u61E7\u61E9\u61E5"],["8fbfa1","\u61EC\u61ED\u61EF\u6201\u6203\u6204\u6207\u6213\u6215\u621C\u6220\u6222\u6223\u6227\u6229\u622B\u6239\u623D\u6242\u6243\u6244\u6246\u624C\u6250\u6251\u6252\u6254\u6256\u625A\u625C\u6264\u626D\u626F\u6273\u627A\u627D\u628D\u628E\u628F\u6290\u62A6\u62A8\u62B3\u62B6\u62B7\u62BA\u62BE\u62BF\u62C4\u62CE\u62D5\u62D6\u62DA\u62EA\u62F2\u62F4\u62FC\u62FD\u6303\u6304\u630A\u630B\u630D\u6310\u6313\u6316\u6318\u6329\u632A\u632D\u6335\u6336\u6339\u633C\u6341\u6342\u6343\u6344\u6346\u634A\u634B\u634E\u6352\u6353\u6354\u6358\u635B\u6365\u6366\u636C\u636D\u6371\u6374\u6375"],["8fc0a1","\u6378\u637C\u637D\u637F\u6382\u6384\u6387\u638A\u6390\u6394\u6395\u6399\u639A\u639E\u63A4\u63A6\u63AD\u63AE\u63AF\u63BD\u63C1\u63C5\u63C8\u63CE\u63D1\u63D3\u63D4\u63D5\u63DC\u63E0\u63E5\u63EA\u63EC\u63F2\u63F3\u63F5\u63F8\u63F9\u6409\u640A\u6410\u6412\u6414\u6418\u641E\u6420\u6422\u6424\u6425\u6429\u642A\u642F\u6430\u6435\u643D\u643F\u644B\u644F\u6451\u6452\u6453\u6454\u645A\u645B\u645C\u645D\u645F\u6460\u6461\u6463\u646D\u6473\u6474\u647B\u647D\u6485\u6487\u648F\u6490\u6491\u6498\u6499\u649B\u649D\u649F\u64A1\u64A3\u64A6\u64A8\u64AC\u64B3\u64BD\u64BE\u64BF"],["8fc1a1","\u64C4\u64C9\u64CA\u64CB\u64CC\u64CE\u64D0\u64D1\u64D5\u64D7\u64E4\u64E5\u64E9\u64EA\u64ED\u64F0\u64F5\u64F7\u64FB\u64FF\u6501\u6504\u6508\u6509\u650A\u650F\u6513\u6514\u6516\u6519\u651B\u651E\u651F\u6522\u6526\u6529\u652E\u6531\u653A\u653C\u653D\u6543\u6547\u6549\u6550\u6552\u6554\u655F\u6560\u6567\u656B\u657A\u657D\u6581\u6585\u658A\u6592\u6595\u6598\u659D\u65A0\u65A3\u65A6\u65AE\u65B2\u65B3\u65B4\u65BF\u65C2\u65C8\u65C9\u65CE\u65D0\u65D4\u65D6\u65D8\u65DF\u65F0\u65F2\u65F4\u65F5\u65F9\u65FE\u65FF\u6600\u6604\u6608\u6609\u660D\u6611\u6612\u6615\u6616\u661D"],["8fc2a1","\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6631\u6633\u6639\u6637\u6640\u6645\u6646\u664A\u664C\u6651\u664E\u6657\u6658\u6659\u665B\u665C\u6660\u6661\u66FB\u666A\u666B\u666C\u667E\u6673\u6675\u667F\u6677\u6678\u6679\u667B\u6680\u667C\u668B\u668C\u668D\u6690\u6692\u6699\u669A\u669B\u669C\u669F\u66A0\u66A4\u66AD\u66B1\u66B2\u66B5\u66BB\u66BF\u66C0\u66C2\u66C3\u66C8\u66CC\u66CE\u66CF\u66D4\u66DB\u66DF\u66E8\u66EB\u66EC\u66EE\u66FA\u6705\u6707\u670E\u6713\u6719\u671C\u6720\u6722\u6733\u673E\u6745\u6747\u6748\u674C\u6754\u6755\u675D"],["8fc3a1","\u6766\u676C\u676E\u6774\u6776\u677B\u6781\u6784\u678E\u678F\u6791\u6793\u6796\u6798\u6799\u679B\u67B0\u67B1\u67B2\u67B5\u67BB\u67BC\u67BD\u67F9\u67C0\u67C2\u67C3\u67C5\u67C8\u67C9\u67D2\u67D7\u67D9\u67DC\u67E1\u67E6\u67F0\u67F2\u67F6\u67F7\u6852\u6814\u6819\u681D\u681F\u6828\u6827\u682C\u682D\u682F\u6830\u6831\u6833\u683B\u683F\u6844\u6845\u684A\u684C\u6855\u6857\u6858\u685B\u686B\u686E",4,"\u6875\u6879\u687A\u687B\u687C\u6882\u6884\u6886\u6888\u6896\u6898\u689A\u689C\u68A1\u68A3\u68A5\u68A9\u68AA\u68AE\u68B2\u68BB\u68C5\u68C8\u68CC\u68CF"],["8fc4a1","\u68D0\u68D1\u68D3\u68D6\u68D9\u68DC\u68DD\u68E5\u68E8\u68EA\u68EB\u68EC\u68ED\u68F0\u68F1\u68F5\u68F6\u68FB\u68FC\u68FD\u6906\u6909\u690A\u6910\u6911\u6913\u6916\u6917\u6931\u6933\u6935\u6938\u693B\u6942\u6945\u6949\u694E\u6957\u695B\u6963\u6964\u6965\u6966\u6968\u6969\u696C\u6970\u6971\u6972\u697A\u697B\u697F\u6980\u698D\u6992\u6996\u6998\u69A1\u69A5\u69A6\u69A8\u69AB\u69AD\u69AF\u69B7\u69B8\u69BA\u69BC\u69C5\u69C8\u69D1\u69D6\u69D7\u69E2\u69E5\u69EE\u69EF\u69F1\u69F3\u69F5\u69FE\u6A00\u6A01\u6A03\u6A0F\u6A11\u6A15\u6A1A\u6A1D\u6A20\u6A24\u6A28\u6A30\u6A32"],["8fc5a1","\u6A34\u6A37\u6A3B\u6A3E\u6A3F\u6A45\u6A46\u6A49\u6A4A\u6A4E\u6A50\u6A51\u6A52\u6A55\u6A56\u6A5B\u6A64\u6A67\u6A6A\u6A71\u6A73\u6A7E\u6A81\u6A83\u6A86\u6A87\u6A89\u6A8B\u6A91\u6A9B\u6A9D\u6A9E\u6A9F\u6AA5\u6AAB\u6AAF\u6AB0\u6AB1\u6AB4\u6ABD\u6ABE\u6ABF\u6AC6\u6AC9\u6AC8\u6ACC\u6AD0\u6AD4\u6AD5\u6AD6\u6ADC\u6ADD\u6AE4\u6AE7\u6AEC\u6AF0\u6AF1\u6AF2\u6AFC\u6AFD\u6B02\u6B03\u6B06\u6B07\u6B09\u6B0F\u6B10\u6B11\u6B17\u6B1B\u6B1E\u6B24\u6B28\u6B2B\u6B2C\u6B2F\u6B35\u6B36\u6B3B\u6B3F\u6B46\u6B4A\u6B4D\u6B52\u6B56\u6B58\u6B5D\u6B60\u6B67\u6B6B\u6B6E\u6B70\u6B75\u6B7D"],["8fc6a1","\u6B7E\u6B82\u6B85\u6B97\u6B9B\u6B9F\u6BA0\u6BA2\u6BA3\u6BA8\u6BA9\u6BAC\u6BAD\u6BAE\u6BB0\u6BB8\u6BB9\u6BBD\u6BBE\u6BC3\u6BC4\u6BC9\u6BCC\u6BD6\u6BDA\u6BE1\u6BE3\u6BE6\u6BE7\u6BEE\u6BF1\u6BF7\u6BF9\u6BFF\u6C02\u6C04\u6C05\u6C09\u6C0D\u6C0E\u6C10\u6C12\u6C19\u6C1F\u6C26\u6C27\u6C28\u6C2C\u6C2E\u6C33\u6C35\u6C36\u6C3A\u6C3B\u6C3F\u6C4A\u6C4B\u6C4D\u6C4F\u6C52\u6C54\u6C59\u6C5B\u6C5C\u6C6B\u6C6D\u6C6F\u6C74\u6C76\u6C78\u6C79\u6C7B\u6C85\u6C86\u6C87\u6C89\u6C94\u6C95\u6C97\u6C98\u6C9C\u6C9F\u6CB0\u6CB2\u6CB4\u6CC2\u6CC6\u6CCD\u6CCF\u6CD0\u6CD1\u6CD2\u6CD4\u6CD6"],["8fc7a1","\u6CDA\u6CDC\u6CE0\u6CE7\u6CE9\u6CEB\u6CEC\u6CEE\u6CF2\u6CF4\u6D04\u6D07\u6D0A\u6D0E\u6D0F\u6D11\u6D13\u6D1A\u6D26\u6D27\u6D28\u6C67\u6D2E\u6D2F\u6D31\u6D39\u6D3C\u6D3F\u6D57\u6D5E\u6D5F\u6D61\u6D65\u6D67\u6D6F\u6D70\u6D7C\u6D82\u6D87\u6D91\u6D92\u6D94\u6D96\u6D97\u6D98\u6DAA\u6DAC\u6DB4\u6DB7\u6DB9\u6DBD\u6DBF\u6DC4\u6DC8\u6DCA\u6DCE\u6DCF\u6DD6\u6DDB\u6DDD\u6DDF\u6DE0\u6DE2\u6DE5\u6DE9\u6DEF\u6DF0\u6DF4\u6DF6\u6DFC\u6E00\u6E04\u6E1E\u6E22\u6E27\u6E32\u6E36\u6E39\u6E3B\u6E3C\u6E44\u6E45\u6E48\u6E49\u6E4B\u6E4F\u6E51\u6E52\u6E53\u6E54\u6E57\u6E5C\u6E5D\u6E5E"],["8fc8a1","\u6E62\u6E63\u6E68\u6E73\u6E7B\u6E7D\u6E8D\u6E93\u6E99\u6EA0\u6EA7\u6EAD\u6EAE\u6EB1\u6EB3\u6EBB\u6EBF\u6EC0\u6EC1\u6EC3\u6EC7\u6EC8\u6ECA\u6ECD\u6ECE\u6ECF\u6EEB\u6EED\u6EEE\u6EF9\u6EFB\u6EFD\u6F04\u6F08\u6F0A\u6F0C\u6F0D\u6F16\u6F18\u6F1A\u6F1B\u6F26\u6F29\u6F2A\u6F2F\u6F30\u6F33\u6F36\u6F3B\u6F3C\u6F2D\u6F4F\u6F51\u6F52\u6F53\u6F57\u6F59\u6F5A\u6F5D\u6F5E\u6F61\u6F62\u6F68\u6F6C\u6F7D\u6F7E\u6F83\u6F87\u6F88\u6F8B\u6F8C\u6F8D\u6F90\u6F92\u6F93\u6F94\u6F96\u6F9A\u6F9F\u6FA0\u6FA5\u6FA6\u6FA7\u6FA8\u6FAE\u6FAF\u6FB0\u6FB5\u6FB6\u6FBC\u6FC5\u6FC7\u6FC8\u6FCA"],["8fc9a1","\u6FDA\u6FDE\u6FE8\u6FE9\u6FF0\u6FF5\u6FF9\u6FFC\u6FFD\u7000\u7005\u7006\u7007\u700D\u7017\u7020\u7023\u702F\u7034\u7037\u7039\u703C\u7043\u7044\u7048\u7049\u704A\u704B\u7054\u7055\u705D\u705E\u704E\u7064\u7065\u706C\u706E\u7075\u7076\u707E\u7081\u7085\u7086\u7094",4,"\u709B\u70A4\u70AB\u70B0\u70B1\u70B4\u70B7\u70CA\u70D1\u70D3\u70D4\u70D5\u70D6\u70D8\u70DC\u70E4\u70FA\u7103",4,"\u710B\u710C\u710F\u711E\u7120\u712B\u712D\u712F\u7130\u7131\u7138\u7141\u7145\u7146\u7147\u714A\u714B\u7150\u7152\u7157\u715A\u715C\u715E\u7160"],["8fcaa1","\u7168\u7179\u7180\u7185\u7187\u718C\u7192\u719A\u719B\u71A0\u71A2\u71AF\u71B0\u71B2\u71B3\u71BA\u71BF\u71C0\u71C1\u71C4\u71CB\u71CC\u71D3\u71D6\u71D9\u71DA\u71DC\u71F8\u71FE\u7200\u7207\u7208\u7209\u7213\u7217\u721A\u721D\u721F\u7224\u722B\u722F\u7234\u7238\u7239\u7241\u7242\u7243\u7245\u724E\u724F\u7250\u7253\u7255\u7256\u725A\u725C\u725E\u7260\u7263\u7268\u726B\u726E\u726F\u7271\u7277\u7278\u727B\u727C\u727F\u7284\u7289\u728D\u728E\u7293\u729B\u72A8\u72AD\u72AE\u72B1\u72B4\u72BE\u72C1\u72C7\u72C9\u72CC\u72D5\u72D6\u72D8\u72DF\u72E5\u72F3\u72F4\u72FA\u72FB"],["8fcba1","\u72FE\u7302\u7304\u7305\u7307\u730B\u730D\u7312\u7313\u7318\u7319\u731E\u7322\u7324\u7327\u7328\u732C\u7331\u7332\u7335\u733A\u733B\u733D\u7343\u734D\u7350\u7352\u7356\u7358\u735D\u735E\u735F\u7360\u7366\u7367\u7369\u736B\u736C\u736E\u736F\u7371\u7377\u7379\u737C\u7380\u7381\u7383\u7385\u7386\u738E\u7390\u7393\u7395\u7397\u7398\u739C\u739E\u739F\u73A0\u73A2\u73A5\u73A6\u73AA\u73AB\u73AD\u73B5\u73B7\u73B9\u73BC\u73BD\u73BF\u73C5\u73C6\u73C9\u73CB\u73CC\u73CF\u73D2\u73D3\u73D6\u73D9\u73DD\u73E1\u73E3\u73E6\u73E7\u73E9\u73F4\u73F5\u73F7\u73F9\u73FA\u73FB\u73FD"],["8fcca1","\u73FF\u7400\u7401\u7404\u7407\u740A\u7411\u741A\u741B\u7424\u7426\u7428",9,"\u7439\u7440\u7443\u7444\u7446\u7447\u744B\u744D\u7451\u7452\u7457\u745D\u7462\u7466\u7467\u7468\u746B\u746D\u746E\u7471\u7472\u7480\u7481\u7485\u7486\u7487\u7489\u748F\u7490\u7491\u7492\u7498\u7499\u749A\u749C\u749F\u74A0\u74A1\u74A3\u74A6\u74A8\u74A9\u74AA\u74AB\u74AE\u74AF\u74B1\u74B2\u74B5\u74B9\u74BB\u74BF\u74C8\u74C9\u74CC\u74D0\u74D3\u74D8\u74DA\u74DB\u74DE\u74DF\u74E4\u74E8\u74EA\u74EB\u74EF\u74F4\u74FA\u74FB\u74FC\u74FF\u7506"],["8fcda1","\u7512\u7516\u7517\u7520\u7521\u7524\u7527\u7529\u752A\u752F\u7536\u7539\u753D\u753E\u753F\u7540\u7543\u7547\u7548\u754E\u7550\u7552\u7557\u755E\u755F\u7561\u756F\u7571\u7579",5,"\u7581\u7585\u7590\u7592\u7593\u7595\u7599\u759C\u75A2\u75A4\u75B4\u75BA\u75BF\u75C0\u75C1\u75C4\u75C6\u75CC\u75CE\u75CF\u75D7\u75DC\u75DF\u75E0\u75E1\u75E4\u75E7\u75EC\u75EE\u75EF\u75F1\u75F9\u7600\u7602\u7603\u7604\u7607\u7608\u760A\u760C\u760F\u7612\u7613\u7615\u7616\u7619\u761B\u761C\u761D\u761E\u7623\u7625\u7626\u7629\u762D\u7632\u7633\u7635\u7638\u7639"],["8fcea1","\u763A\u763C\u764A\u7640\u7641\u7643\u7644\u7645\u7649\u764B\u7655\u7659\u765F\u7664\u7665\u766D\u766E\u766F\u7671\u7674\u7681\u7685\u768C\u768D\u7695\u769B\u769C\u769D\u769F\u76A0\u76A2",6,"\u76AA\u76AD\u76BD\u76C1\u76C5\u76C9\u76CB\u76CC\u76CE\u76D4\u76D9\u76E0\u76E6\u76E8\u76EC\u76F0\u76F1\u76F6\u76F9\u76FC\u7700\u7706\u770A\u770E\u7712\u7714\u7715\u7717\u7719\u771A\u771C\u7722\u7728\u772D\u772E\u772F\u7734\u7735\u7736\u7739\u773D\u773E\u7742\u7745\u7746\u774A\u774D\u774E\u774F\u7752\u7756\u7757\u775C\u775E\u775F\u7760\u7762"],["8fcfa1","\u7764\u7767\u776A\u776C\u7770\u7772\u7773\u7774\u777A\u777D\u7780\u7784\u778C\u778D\u7794\u7795\u7796\u779A\u779F\u77A2\u77A7\u77AA\u77AE\u77AF\u77B1\u77B5\u77BE\u77C3\u77C9\u77D1\u77D2\u77D5\u77D9\u77DE\u77DF\u77E0\u77E4\u77E6\u77EA\u77EC\u77F0\u77F1\u77F4\u77F8\u77FB\u7805\u7806\u7809\u780D\u780E\u7811\u781D\u7821\u7822\u7823\u782D\u782E\u7830\u7835\u7837\u7843\u7844\u7847\u7848\u784C\u784E\u7852\u785C\u785E\u7860\u7861\u7863\u7864\u7868\u786A\u786E\u787A\u787E\u788A\u788F\u7894\u7898\u78A1\u789D\u789E\u789F\u78A4\u78A8\u78AC\u78AD\u78B0\u78B1\u78B2\u78B3"],["8fd0a1","\u78BB\u78BD\u78BF\u78C7\u78C8\u78C9\u78CC\u78CE\u78D2\u78D3\u78D5\u78D6\u78E4\u78DB\u78DF\u78E0\u78E1\u78E6\u78EA\u78F2\u78F3\u7900\u78F6\u78F7\u78FA\u78FB\u78FF\u7906\u790C\u7910\u791A\u791C\u791E\u791F\u7920\u7925\u7927\u7929\u792D\u7931\u7934\u7935\u793B\u793D\u793F\u7944\u7945\u7946\u794A\u794B\u794F\u7951\u7954\u7958\u795B\u795C\u7967\u7969\u796B\u7972\u7979\u797B\u797C\u797E\u798B\u798C\u7991\u7993\u7994\u7995\u7996\u7998\u799B\u799C\u79A1\u79A8\u79A9\u79AB\u79AF\u79B1\u79B4\u79B8\u79BB\u79C2\u79C4\u79C7\u79C8\u79CA\u79CF\u79D4\u79D6\u79DA\u79DD\u79DE"],["8fd1a1","\u79E0\u79E2\u79E5\u79EA\u79EB\u79ED\u79F1\u79F8\u79FC\u7A02\u7A03\u7A07\u7A09\u7A0A\u7A0C\u7A11\u7A15\u7A1B\u7A1E\u7A21\u7A27\u7A2B\u7A2D\u7A2F\u7A30\u7A34\u7A35\u7A38\u7A39\u7A3A\u7A44\u7A45\u7A47\u7A48\u7A4C\u7A55\u7A56\u7A59\u7A5C\u7A5D\u7A5F\u7A60\u7A65\u7A67\u7A6A\u7A6D\u7A75\u7A78\u7A7E\u7A80\u7A82\u7A85\u7A86\u7A8A\u7A8B\u7A90\u7A91\u7A94\u7A9E\u7AA0\u7AA3\u7AAC\u7AB3\u7AB5\u7AB9\u7ABB\u7ABC\u7AC6\u7AC9\u7ACC\u7ACE\u7AD1\u7ADB\u7AE8\u7AE9\u7AEB\u7AEC\u7AF1\u7AF4\u7AFB\u7AFD\u7AFE\u7B07\u7B14\u7B1F\u7B23\u7B27\u7B29\u7B2A\u7B2B\u7B2D\u7B2E\u7B2F\u7B30"],["8fd2a1","\u7B31\u7B34\u7B3D\u7B3F\u7B40\u7B41\u7B47\u7B4E\u7B55\u7B60\u7B64\u7B66\u7B69\u7B6A\u7B6D\u7B6F\u7B72\u7B73\u7B77\u7B84\u7B89\u7B8E\u7B90\u7B91\u7B96\u7B9B\u7B9E\u7BA0\u7BA5\u7BAC\u7BAF\u7BB0\u7BB2\u7BB5\u7BB6\u7BBA\u7BBB\u7BBC\u7BBD\u7BC2\u7BC5\u7BC8\u7BCA\u7BD4\u7BD6\u7BD7\u7BD9\u7BDA\u7BDB\u7BE8\u7BEA\u7BF2\u7BF4\u7BF5\u7BF8\u7BF9\u7BFA\u7BFC\u7BFE\u7C01\u7C02\u7C03\u7C04\u7C06\u7C09\u7C0B\u7C0C\u7C0E\u7C0F\u7C19\u7C1B\u7C20\u7C25\u7C26\u7C28\u7C2C\u7C31\u7C33\u7C34\u7C36\u7C39\u7C3A\u7C46\u7C4A\u7C55\u7C51\u7C52\u7C53\u7C59",5],["8fd3a1","\u7C61\u7C63\u7C67\u7C69\u7C6D\u7C6E\u7C70\u7C72\u7C79\u7C7C\u7C7D\u7C86\u7C87\u7C8F\u7C94\u7C9E\u7CA0\u7CA6\u7CB0\u7CB6\u7CB7\u7CBA\u7CBB\u7CBC\u7CBF\u7CC4\u7CC7\u7CC8\u7CC9\u7CCD\u7CCF\u7CD3\u7CD4\u7CD5\u7CD7\u7CD9\u7CDA\u7CDD\u7CE6\u7CE9\u7CEB\u7CF5\u7D03\u7D07\u7D08\u7D09\u7D0F\u7D11\u7D12\u7D13\u7D16\u7D1D\u7D1E\u7D23\u7D26\u7D2A\u7D2D\u7D31\u7D3C\u7D3D\u7D3E\u7D40\u7D41\u7D47\u7D48\u7D4D\u7D51\u7D53\u7D57\u7D59\u7D5A\u7D5C\u7D5D\u7D65\u7D67\u7D6A\u7D70\u7D78\u7D7A\u7D7B\u7D7F\u7D81\u7D82\u7D83\u7D85\u7D86\u7D88\u7D8B\u7D8C\u7D8D\u7D91\u7D96\u7D97\u7D9D"],["8fd4a1","\u7D9E\u7DA6\u7DA7\u7DAA\u7DB3\u7DB6\u7DB7\u7DB9\u7DC2",4,"\u7DCC\u7DCD\u7DCE\u7DD7\u7DD9\u7E00\u7DE2\u7DE5\u7DE6\u7DEA\u7DEB\u7DED\u7DF1\u7DF5\u7DF6\u7DF9\u7DFA\u7E08\u7E10\u7E11\u7E15\u7E17\u7E1C\u7E1D\u7E20\u7E27\u7E28\u7E2C\u7E2D\u7E2F\u7E33\u7E36\u7E3F\u7E44\u7E45\u7E47\u7E4E\u7E50\u7E52\u7E58\u7E5F\u7E61\u7E62\u7E65\u7E6B\u7E6E\u7E6F\u7E73\u7E78\u7E7E\u7E81\u7E86\u7E87\u7E8A\u7E8D\u7E91\u7E95\u7E98\u7E9A\u7E9D\u7E9E\u7F3C\u7F3B\u7F3D\u7F3E\u7F3F\u7F43\u7F44\u7F47\u7F4F\u7F52\u7F53\u7F5B\u7F5C\u7F5D\u7F61\u7F63\u7F64\u7F65\u7F66\u7F6D"],["8fd5a1","\u7F71\u7F7D\u7F7E\u7F7F\u7F80\u7F8B\u7F8D\u7F8F\u7F90\u7F91\u7F96\u7F97\u7F9C\u7FA1\u7FA2\u7FA6\u7FAA\u7FAD\u7FB4\u7FBC\u7FBF\u7FC0\u7FC3\u7FC8\u7FCE\u7FCF\u7FDB\u7FDF\u7FE3\u7FE5\u7FE8\u7FEC\u7FEE\u7FEF\u7FF2\u7FFA\u7FFD\u7FFE\u7FFF\u8007\u8008\u800A\u800D\u800E\u800F\u8011\u8013\u8014\u8016\u801D\u801E\u801F\u8020\u8024\u8026\u802C\u802E\u8030\u8034\u8035\u8037\u8039\u803A\u803C\u803E\u8040\u8044\u8060\u8064\u8066\u806D\u8071\u8075\u8081\u8088\u808E\u809C\u809E\u80A6\u80A7\u80AB\u80B8\u80B9\u80C8\u80CD\u80CF\u80D2\u80D4\u80D5\u80D7\u80D8\u80E0\u80ED\u80EE"],["8fd6a1","\u80F0\u80F2\u80F3\u80F6\u80F9\u80FA\u80FE\u8103\u810B\u8116\u8117\u8118\u811C\u811E\u8120\u8124\u8127\u812C\u8130\u8135\u813A\u813C\u8145\u8147\u814A\u814C\u8152\u8157\u8160\u8161\u8167\u8168\u8169\u816D\u816F\u8177\u8181\u8190\u8184\u8185\u8186\u818B\u818E\u8196\u8198\u819B\u819E\u81A2\u81AE\u81B2\u81B4\u81BB\u81CB\u81C3\u81C5\u81CA\u81CE\u81CF\u81D5\u81D7\u81DB\u81DD\u81DE\u81E1\u81E4\u81EB\u81EC\u81F0\u81F1\u81F2\u81F5\u81F6\u81F8\u81F9\u81FD\u81FF\u8200\u8203\u820F\u8213\u8214\u8219\u821A\u821D\u8221\u8222\u8228\u8232\u8234\u823A\u8243\u8244\u8245\u8246"],["8fd7a1","\u824B\u824E\u824F\u8251\u8256\u825C\u8260\u8263\u8267\u826D\u8274\u827B\u827D\u827F\u8280\u8281\u8283\u8284\u8287\u8289\u828A\u828E\u8291\u8294\u8296\u8298\u829A\u829B\u82A0\u82A1\u82A3\u82A4\u82A7\u82A8\u82A9\u82AA\u82AE\u82B0\u82B2\u82B4\u82B7\u82BA\u82BC\u82BE\u82BF\u82C6\u82D0\u82D5\u82DA\u82E0\u82E2\u82E4\u82E8\u82EA\u82ED\u82EF\u82F6\u82F7\u82FD\u82FE\u8300\u8301\u8307\u8308\u830A\u830B\u8354\u831B\u831D\u831E\u831F\u8321\u8322\u832C\u832D\u832E\u8330\u8333\u8337\u833A\u833C\u833D\u8342\u8343\u8344\u8347\u834D\u834E\u8351\u8355\u8356\u8357\u8370\u8378"],["8fd8a1","\u837D\u837F\u8380\u8382\u8384\u8386\u838D\u8392\u8394\u8395\u8398\u8399\u839B\u839C\u839D\u83A6\u83A7\u83A9\u83AC\u83BE\u83BF\u83C0\u83C7\u83C9\u83CF\u83D0\u83D1\u83D4\u83DD\u8353\u83E8\u83EA\u83F6\u83F8\u83F9\u83FC\u8401\u8406\u840A\u840F\u8411\u8415\u8419\u83AD\u842F\u8439\u8445\u8447\u8448\u844A\u844D\u844F\u8451\u8452\u8456\u8458\u8459\u845A\u845C\u8460\u8464\u8465\u8467\u846A\u8470\u8473\u8474\u8476\u8478\u847C\u847D\u8481\u8485\u8492\u8493\u8495\u849E\u84A6\u84A8\u84A9\u84AA\u84AF\u84B1\u84B4\u84BA\u84BD\u84BE\u84C0\u84C2\u84C7\u84C8\u84CC\u84CF\u84D3"],["8fd9a1","\u84DC\u84E7\u84EA\u84EF\u84F0\u84F1\u84F2\u84F7\u8532\u84FA\u84FB\u84FD\u8502\u8503\u8507\u850C\u850E\u8510\u851C\u851E\u8522\u8523\u8524\u8525\u8527\u852A\u852B\u852F\u8533\u8534\u8536\u853F\u8546\u854F",4,"\u8556\u8559\u855C",6,"\u8564\u856B\u856F\u8579\u857A\u857B\u857D\u857F\u8581\u8585\u8586\u8589\u858B\u858C\u858F\u8593\u8598\u859D\u859F\u85A0\u85A2\u85A5\u85A7\u85B4\u85B6\u85B7\u85B8\u85BC\u85BD\u85BE\u85BF\u85C2\u85C7\u85CA\u85CB\u85CE\u85AD\u85D8\u85DA\u85DF\u85E0\u85E6\u85E8\u85ED\u85F3\u85F6\u85FC"],["8fdaa1","\u85FF\u8600\u8604\u8605\u860D\u860E\u8610\u8611\u8612\u8618\u8619\u861B\u861E\u8621\u8627\u8629\u8636\u8638\u863A\u863C\u863D\u8640\u8642\u8646\u8652\u8653\u8656\u8657\u8658\u8659\u865D\u8660",4,"\u8669\u866C\u866F\u8675\u8676\u8677\u867A\u868D\u8691\u8696\u8698\u869A\u869C\u86A1\u86A6\u86A7\u86A8\u86AD\u86B1\u86B3\u86B4\u86B5\u86B7\u86B8\u86B9\u86BF\u86C0\u86C1\u86C3\u86C5\u86D1\u86D2\u86D5\u86D7\u86DA\u86DC\u86E0\u86E3\u86E5\u86E7\u8688\u86FA\u86FC\u86FD\u8704\u8705\u8707\u870B\u870E\u870F\u8710\u8713\u8714\u8719\u871E\u871F\u8721\u8723"],["8fdba1","\u8728\u872E\u872F\u8731\u8732\u8739\u873A\u873C\u873D\u873E\u8740\u8743\u8745\u874D\u8758\u875D\u8761\u8764\u8765\u876F\u8771\u8772\u877B\u8783",6,"\u878B\u878C\u8790\u8793\u8795\u8797\u8798\u8799\u879E\u87A0\u87A3\u87A7\u87AC\u87AD\u87AE\u87B1\u87B5\u87BE\u87BF\u87C1\u87C8\u87C9\u87CA\u87CE\u87D5\u87D6\u87D9\u87DA\u87DC\u87DF\u87E2\u87E3\u87E4\u87EA\u87EB\u87ED\u87F1\u87F3\u87F8\u87FA\u87FF\u8801\u8803\u8806\u8809\u880A\u880B\u8810\u8819\u8812\u8813\u8814\u8818\u881A\u881B\u881C\u881E\u881F\u8828\u882D\u882E\u8830\u8832\u8835"],["8fdca1","\u883A\u883C\u8841\u8843\u8845\u8848\u8849\u884A\u884B\u884E\u8851\u8855\u8856\u8858\u885A\u885C\u885F\u8860\u8864\u8869\u8871\u8879\u887B\u8880\u8898\u889A\u889B\u889C\u889F\u88A0\u88A8\u88AA\u88BA\u88BD\u88BE\u88C0\u88CA",4,"\u88D1\u88D2\u88D3\u88DB\u88DE\u88E7\u88EF\u88F0\u88F1\u88F5\u88F7\u8901\u8906\u890D\u890E\u890F\u8915\u8916\u8918\u8919\u891A\u891C\u8920\u8926\u8927\u8928\u8930\u8931\u8932\u8935\u8939\u893A\u893E\u8940\u8942\u8945\u8946\u8949\u894F\u8952\u8957\u895A\u895B\u895C\u8961\u8962\u8963\u896B\u896E\u8970\u8973\u8975\u897A"],["8fdda1","\u897B\u897C\u897D\u8989\u898D\u8990\u8994\u8995\u899B\u899C\u899F\u89A0\u89A5\u89B0\u89B4\u89B5\u89B6\u89B7\u89BC\u89D4",4,"\u89E5\u89E9\u89EB\u89ED\u89F1\u89F3\u89F6\u89F9\u89FD\u89FF\u8A04\u8A05\u8A07\u8A0F\u8A11\u8A12\u8A14\u8A15\u8A1E\u8A20\u8A22\u8A24\u8A26\u8A2B\u8A2C\u8A2F\u8A35\u8A37\u8A3D\u8A3E\u8A40\u8A43\u8A45\u8A47\u8A49\u8A4D\u8A4E\u8A53\u8A56\u8A57\u8A58\u8A5C\u8A5D\u8A61\u8A65\u8A67\u8A75\u8A76\u8A77\u8A79\u8A7A\u8A7B\u8A7E\u8A7F\u8A80\u8A83\u8A86\u8A8B\u8A8F\u8A90\u8A92\u8A96\u8A97\u8A99\u8A9F\u8AA7\u8AA9\u8AAE\u8AAF\u8AB3"],["8fdea1","\u8AB6\u8AB7\u8ABB\u8ABE\u8AC3\u8AC6\u8AC8\u8AC9\u8ACA\u8AD1\u8AD3\u8AD4\u8AD5\u8AD7\u8ADD\u8ADF\u8AEC\u8AF0\u8AF4\u8AF5\u8AF6\u8AFC\u8AFF\u8B05\u8B06\u8B0B\u8B11\u8B1C\u8B1E\u8B1F\u8B0A\u8B2D\u8B30\u8B37\u8B3C\u8B42",4,"\u8B48\u8B52\u8B53\u8B54\u8B59\u8B4D\u8B5E\u8B63\u8B6D\u8B76\u8B78\u8B79\u8B7C\u8B7E\u8B81\u8B84\u8B85\u8B8B\u8B8D\u8B8F\u8B94\u8B95\u8B9C\u8B9E\u8B9F\u8C38\u8C39\u8C3D\u8C3E\u8C45\u8C47\u8C49\u8C4B\u8C4F\u8C51\u8C53\u8C54\u8C57\u8C58\u8C5B\u8C5D\u8C59\u8C63\u8C64\u8C66\u8C68\u8C69\u8C6D\u8C73\u8C75\u8C76\u8C7B\u8C7E\u8C86"],["8fdfa1","\u8C87\u8C8B\u8C90\u8C92\u8C93\u8C99\u8C9B\u8C9C\u8CA4\u8CB9\u8CBA\u8CC5\u8CC6\u8CC9\u8CCB\u8CCF\u8CD6\u8CD5\u8CD9\u8CDD\u8CE1\u8CE8\u8CEC\u8CEF\u8CF0\u8CF2\u8CF5\u8CF7\u8CF8\u8CFE\u8CFF\u8D01\u8D03\u8D09\u8D12\u8D17\u8D1B\u8D65\u8D69\u8D6C\u8D6E\u8D7F\u8D82\u8D84\u8D88\u8D8D\u8D90\u8D91\u8D95\u8D9E\u8D9F\u8DA0\u8DA6\u8DAB\u8DAC\u8DAF\u8DB2\u8DB5\u8DB7\u8DB9\u8DBB\u8DC0\u8DC5\u8DC6\u8DC7\u8DC8\u8DCA\u8DCE\u8DD1\u8DD4\u8DD5\u8DD7\u8DD9\u8DE4\u8DE5\u8DE7\u8DEC\u8DF0\u8DBC\u8DF1\u8DF2\u8DF4\u8DFD\u8E01\u8E04\u8E05\u8E06\u8E0B\u8E11\u8E14\u8E16\u8E20\u8E21\u8E22"],["8fe0a1","\u8E23\u8E26\u8E27\u8E31\u8E33\u8E36\u8E37\u8E38\u8E39\u8E3D\u8E40\u8E41\u8E4B\u8E4D\u8E4E\u8E4F\u8E54\u8E5B\u8E5C\u8E5D\u8E5E\u8E61\u8E62\u8E69\u8E6C\u8E6D\u8E6F\u8E70\u8E71\u8E79\u8E7A\u8E7B\u8E82\u8E83\u8E89\u8E90\u8E92\u8E95\u8E9A\u8E9B\u8E9D\u8E9E\u8EA2\u8EA7\u8EA9\u8EAD\u8EAE\u8EB3\u8EB5\u8EBA\u8EBB\u8EC0\u8EC1\u8EC3\u8EC4\u8EC7\u8ECF\u8ED1\u8ED4\u8EDC\u8EE8\u8EEE\u8EF0\u8EF1\u8EF7\u8EF9\u8EFA\u8EED\u8F00\u8F02\u8F07\u8F08\u8F0F\u8F10\u8F16\u8F17\u8F18\u8F1E\u8F20\u8F21\u8F23\u8F25\u8F27\u8F28\u8F2C\u8F2D\u8F2E\u8F34\u8F35\u8F36\u8F37\u8F3A\u8F40\u8F41"],["8fe1a1","\u8F43\u8F47\u8F4F\u8F51",4,"\u8F58\u8F5D\u8F5E\u8F65\u8F9D\u8FA0\u8FA1\u8FA4\u8FA5\u8FA6\u8FB5\u8FB6\u8FB8\u8FBE\u8FC0\u8FC1\u8FC6\u8FCA\u8FCB\u8FCD\u8FD0\u8FD2\u8FD3\u8FD5\u8FE0\u8FE3\u8FE4\u8FE8\u8FEE\u8FF1\u8FF5\u8FF6\u8FFB\u8FFE\u9002\u9004\u9008\u900C\u9018\u901B\u9028\u9029\u902F\u902A\u902C\u902D\u9033\u9034\u9037\u903F\u9043\u9044\u904C\u905B\u905D\u9062\u9066\u9067\u906C\u9070\u9074\u9079\u9085\u9088\u908B\u908C\u908E\u9090\u9095\u9097\u9098\u9099\u909B\u90A0\u90A1\u90A2\u90A5\u90B0\u90B2\u90B3\u90B4\u90B6\u90BD\u90CC\u90BE\u90C3"],["8fe2a1","\u90C4\u90C5\u90C7\u90C8\u90D5\u90D7\u90D8\u90D9\u90DC\u90DD\u90DF\u90E5\u90D2\u90F6\u90EB\u90EF\u90F0\u90F4\u90FE\u90FF\u9100\u9104\u9105\u9106\u9108\u910D\u9110\u9114\u9116\u9117\u9118\u911A\u911C\u911E\u9120\u9125\u9122\u9123\u9127\u9129\u912E\u912F\u9131\u9134\u9136\u9137\u9139\u913A\u913C\u913D\u9143\u9147\u9148\u914F\u9153\u9157\u9159\u915A\u915B\u9161\u9164\u9167\u916D\u9174\u9179\u917A\u917B\u9181\u9183\u9185\u9186\u918A\u918E\u9191\u9193\u9194\u9195\u9198\u919E\u91A1\u91A6\u91A8\u91AC\u91AD\u91AE\u91B0\u91B1\u91B2\u91B3\u91B6\u91BB\u91BC\u91BD\u91BF"],["8fe3a1","\u91C2\u91C3\u91C5\u91D3\u91D4\u91D7\u91D9\u91DA\u91DE\u91E4\u91E5\u91E9\u91EA\u91EC",5,"\u91F7\u91F9\u91FB\u91FD\u9200\u9201\u9204\u9205\u9206\u9207\u9209\u920A\u920C\u9210\u9212\u9213\u9216\u9218\u921C\u921D\u9223\u9224\u9225\u9226\u9228\u922E\u922F\u9230\u9233\u9235\u9236\u9238\u9239\u923A\u923C\u923E\u9240\u9242\u9243\u9246\u9247\u924A\u924D\u924E\u924F\u9251\u9258\u9259\u925C\u925D\u9260\u9261\u9265\u9267\u9268\u9269\u926E\u926F\u9270\u9275",4,"\u927B\u927C\u927D\u927F\u9288\u9289\u928A\u928D\u928E\u9292\u9297"],["8fe4a1","\u9299\u929F\u92A0\u92A4\u92A5\u92A7\u92A8\u92AB\u92AF\u92B2\u92B6\u92B8\u92BA\u92BB\u92BC\u92BD\u92BF",4,"\u92C5\u92C6\u92C7\u92C8\u92CB\u92CC\u92CD\u92CE\u92D0\u92D3\u92D5\u92D7\u92D8\u92D9\u92DC\u92DD\u92DF\u92E0\u92E1\u92E3\u92E5\u92E7\u92E8\u92EC\u92EE\u92F0\u92F9\u92FB\u92FF\u9300\u9302\u9308\u930D\u9311\u9314\u9315\u931C\u931D\u931E\u931F\u9321\u9324\u9325\u9327\u9329\u932A\u9333\u9334\u9336\u9337\u9347\u9348\u9349\u9350\u9351\u9352\u9355\u9357\u9358\u935A\u935E\u9364\u9365\u9367\u9369\u936A\u936D\u936F\u9370\u9371\u9373\u9374\u9376"],["8fe5a1","\u937A\u937D\u937F\u9380\u9381\u9382\u9388\u938A\u938B\u938D\u938F\u9392\u9395\u9398\u939B\u939E\u93A1\u93A3\u93A4\u93A6\u93A8\u93AB\u93B4\u93B5\u93B6\u93BA\u93A9\u93C1\u93C4\u93C5\u93C6\u93C7\u93C9",4,"\u93D3\u93D9\u93DC\u93DE\u93DF\u93E2\u93E6\u93E7\u93F9\u93F7\u93F8\u93FA\u93FB\u93FD\u9401\u9402\u9404\u9408\u9409\u940D\u940E\u940F\u9415\u9416\u9417\u941F\u942E\u942F\u9431\u9432\u9433\u9434\u943B\u943F\u943D\u9443\u9445\u9448\u944A\u944C\u9455\u9459\u945C\u945F\u9461\u9463\u9468\u946B\u946D\u946E\u946F\u9471\u9472\u9484\u9483\u9578\u9579"],["8fe6a1","\u957E\u9584\u9588\u958C\u958D\u958E\u959D\u959E\u959F\u95A1\u95A6\u95A9\u95AB\u95AC\u95B4\u95B6\u95BA\u95BD\u95BF\u95C6\u95C8\u95C9\u95CB\u95D0\u95D1\u95D2\u95D3\u95D9\u95DA\u95DD\u95DE\u95DF\u95E0\u95E4\u95E6\u961D\u961E\u9622\u9624\u9625\u9626\u962C\u9631\u9633\u9637\u9638\u9639\u963A\u963C\u963D\u9641\u9652\u9654\u9656\u9657\u9658\u9661\u966E\u9674\u967B\u967C\u967E\u967F\u9681\u9682\u9683\u9684\u9689\u9691\u9696\u969A\u969D\u969F\u96A4\u96A5\u96A6\u96A9\u96AE\u96AF\u96B3\u96BA\u96CA\u96D2\u5DB2\u96D8\u96DA\u96DD\u96DE\u96DF\u96E9\u96EF\u96F1\u96FA\u9702"],["8fe7a1","\u9703\u9705\u9709\u971A\u971B\u971D\u9721\u9722\u9723\u9728\u9731\u9733\u9741\u9743\u974A\u974E\u974F\u9755\u9757\u9758\u975A\u975B\u9763\u9767\u976A\u976E\u9773\u9776\u9777\u9778\u977B\u977D\u977F\u9780\u9789\u9795\u9796\u9797\u9799\u979A\u979E\u979F\u97A2\u97AC\u97AE\u97B1\u97B2\u97B5\u97B6\u97B8\u97B9\u97BA\u97BC\u97BE\u97BF\u97C1\u97C4\u97C5\u97C7\u97C9\u97CA\u97CC\u97CD\u97CE\u97D0\u97D1\u97D4\u97D7\u97D8\u97D9\u97DD\u97DE\u97E0\u97DB\u97E1\u97E4\u97EF\u97F1\u97F4\u97F7\u97F8\u97FA\u9807\u980A\u9819\u980D\u980E\u9814\u9816\u981C\u981E\u9820\u9823\u9826"],["8fe8a1","\u982B\u982E\u982F\u9830\u9832\u9833\u9835\u9825\u983E\u9844\u9847\u984A\u9851\u9852\u9853\u9856\u9857\u9859\u985A\u9862\u9863\u9865\u9866\u986A\u986C\u98AB\u98AD\u98AE\u98B0\u98B4\u98B7\u98B8\u98BA\u98BB\u98BF\u98C2\u98C5\u98C8\u98CC\u98E1\u98E3\u98E5\u98E6\u98E7\u98EA\u98F3\u98F6\u9902\u9907\u9908\u9911\u9915\u9916\u9917\u991A\u991B\u991C\u991F\u9922\u9926\u9927\u992B\u9931",4,"\u9939\u993A\u993B\u993C\u9940\u9941\u9946\u9947\u9948\u994D\u994E\u9954\u9958\u9959\u995B\u995C\u995E\u995F\u9960\u999B\u999D\u999F\u99A6\u99B0\u99B1\u99B2\u99B5"],["8fe9a1","\u99B9\u99BA\u99BD\u99BF\u99C3\u99C9\u99D3\u99D4\u99D9\u99DA\u99DC\u99DE\u99E7\u99EA\u99EB\u99EC\u99F0\u99F4\u99F5\u99F9\u99FD\u99FE\u9A02\u9A03\u9A04\u9A0B\u9A0C\u9A10\u9A11\u9A16\u9A1E\u9A20\u9A22\u9A23\u9A24\u9A27\u9A2D\u9A2E\u9A33\u9A35\u9A36\u9A38\u9A47\u9A41\u9A44\u9A4A\u9A4B\u9A4C\u9A4E\u9A51\u9A54\u9A56\u9A5D\u9AAA\u9AAC\u9AAE\u9AAF\u9AB2\u9AB4\u9AB5\u9AB6\u9AB9\u9ABB\u9ABE\u9ABF\u9AC1\u9AC3\u9AC6\u9AC8\u9ACE\u9AD0\u9AD2\u9AD5\u9AD6\u9AD7\u9ADB\u9ADC\u9AE0\u9AE4\u9AE5\u9AE7\u9AE9\u9AEC\u9AF2\u9AF3\u9AF5\u9AF9\u9AFA\u9AFD\u9AFF",4],["8feaa1","\u9B04\u9B05\u9B08\u9B09\u9B0B\u9B0C\u9B0D\u9B0E\u9B10\u9B12\u9B16\u9B19\u9B1B\u9B1C\u9B20\u9B26\u9B2B\u9B2D\u9B33\u9B34\u9B35\u9B37\u9B39\u9B3A\u9B3D\u9B48\u9B4B\u9B4C\u9B55\u9B56\u9B57\u9B5B\u9B5E\u9B61\u9B63\u9B65\u9B66\u9B68\u9B6A",4,"\u9B73\u9B75\u9B77\u9B78\u9B79\u9B7F\u9B80\u9B84\u9B85\u9B86\u9B87\u9B89\u9B8A\u9B8B\u9B8D\u9B8F\u9B90\u9B94\u9B9A\u9B9D\u9B9E\u9BA6\u9BA7\u9BA9\u9BAC\u9BB0\u9BB1\u9BB2\u9BB7\u9BB8\u9BBB\u9BBC\u9BBE\u9BBF\u9BC1\u9BC7\u9BC8\u9BCE\u9BD0\u9BD7\u9BD8\u9BDD\u9BDF\u9BE5\u9BE7\u9BEA\u9BEB\u9BEF\u9BF3\u9BF7\u9BF8"],["8feba1","\u9BF9\u9BFA\u9BFD\u9BFF\u9C00\u9C02\u9C0B\u9C0F\u9C11\u9C16\u9C18\u9C19\u9C1A\u9C1C\u9C1E\u9C22\u9C23\u9C26",4,"\u9C31\u9C35\u9C36\u9C37\u9C3D\u9C41\u9C43\u9C44\u9C45\u9C49\u9C4A\u9C4E\u9C4F\u9C50\u9C53\u9C54\u9C56\u9C58\u9C5B\u9C5D\u9C5E\u9C5F\u9C63\u9C69\u9C6A\u9C5C\u9C6B\u9C68\u9C6E\u9C70\u9C72\u9C75\u9C77\u9C7B\u9CE6\u9CF2\u9CF7\u9CF9\u9D0B\u9D02\u9D11\u9D17\u9D18\u9D1C\u9D1D\u9D1E\u9D2F\u9D30\u9D32\u9D33\u9D34\u9D3A\u9D3C\u9D45\u9D3D\u9D42\u9D43\u9D47\u9D4A\u9D53\u9D54\u9D5F\u9D63\u9D62\u9D65\u9D69\u9D6A\u9D6B\u9D70\u9D76\u9D77\u9D7B"],["8feca1","\u9D7C\u9D7E\u9D83\u9D84\u9D86\u9D8A\u9D8D\u9D8E\u9D92\u9D93\u9D95\u9D96\u9D97\u9D98\u9DA1\u9DAA\u9DAC\u9DAE\u9DB1\u9DB5\u9DB9\u9DBC\u9DBF\u9DC3\u9DC7\u9DC9\u9DCA\u9DD4\u9DD5\u9DD6\u9DD7\u9DDA\u9DDE\u9DDF\u9DE0\u9DE5\u9DE7\u9DE9\u9DEB\u9DEE\u9DF0\u9DF3\u9DF4\u9DFE\u9E0A\u9E02\u9E07\u9E0E\u9E10\u9E11\u9E12\u9E15\u9E16\u9E19\u9E1C\u9E1D\u9E7A\u9E7B\u9E7C\u9E80\u9E82\u9E83\u9E84\u9E85\u9E87\u9E8E\u9E8F\u9E96\u9E98\u9E9B\u9E9E\u9EA4\u9EA8\u9EAC\u9EAE\u9EAF\u9EB0\u9EB3\u9EB4\u9EB5\u9EC6\u9EC8\u9ECB\u9ED5\u9EDF\u9EE4\u9EE7\u9EEC\u9EED\u9EEE\u9EF0\u9EF1\u9EF2\u9EF5"],["8feda1","\u9EF8\u9EFF\u9F02\u9F03\u9F09\u9F0F\u9F10\u9F11\u9F12\u9F14\u9F16\u9F17\u9F19\u9F1A\u9F1B\u9F1F\u9F22\u9F26\u9F2A\u9F2B\u9F2F\u9F31\u9F32\u9F34\u9F37\u9F39\u9F3A\u9F3C\u9F3D\u9F3F\u9F41\u9F43",4,"\u9F53\u9F55\u9F56\u9F57\u9F58\u9F5A\u9F5D\u9F5E\u9F68\u9F69\u9F6D",4,"\u9F73\u9F75\u9F7A\u9F7D\u9F8F\u9F90\u9F91\u9F92\u9F94\u9F96\u9F97\u9F9E\u9FA1\u9FA2\u9FA3\u9FA5"]]');

});

parcelRegister("8Jkbm", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",127,"\u20AC"],["8140","\u4E02\u4E04\u4E05\u4E06\u4E0F\u4E12\u4E17\u4E1F\u4E20\u4E21\u4E23\u4E26\u4E29\u4E2E\u4E2F\u4E31\u4E33\u4E35\u4E37\u4E3C\u4E40\u4E41\u4E42\u4E44\u4E46\u4E4A\u4E51\u4E55\u4E57\u4E5A\u4E5B\u4E62\u4E63\u4E64\u4E65\u4E67\u4E68\u4E6A",5,"\u4E72\u4E74",9,"\u4E7F",6,"\u4E87\u4E8A"],["8180","\u4E90\u4E96\u4E97\u4E99\u4E9C\u4E9D\u4E9E\u4EA3\u4EAA\u4EAF\u4EB0\u4EB1\u4EB4\u4EB6\u4EB7\u4EB8\u4EB9\u4EBC\u4EBD\u4EBE\u4EC8\u4ECC\u4ECF\u4ED0\u4ED2\u4EDA\u4EDB\u4EDC\u4EE0\u4EE2\u4EE6\u4EE7\u4EE9\u4EED\u4EEE\u4EEF\u4EF1\u4EF4\u4EF8\u4EF9\u4EFA\u4EFC\u4EFE\u4F00\u4F02",6,"\u4F0B\u4F0C\u4F12",4,"\u4F1C\u4F1D\u4F21\u4F23\u4F28\u4F29\u4F2C\u4F2D\u4F2E\u4F31\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E",4,"\u4F44\u4F45\u4F47",5,"\u4F52\u4F54\u4F56\u4F61\u4F62\u4F66\u4F68\u4F6A\u4F6B\u4F6D\u4F6E\u4F71\u4F72\u4F75\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F80\u4F81\u4F82\u4F85\u4F86\u4F87\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F95\u4F96\u4F98\u4F99\u4F9A\u4F9C\u4F9E\u4F9F\u4FA1\u4FA2"],["8240","\u4FA4\u4FAB\u4FAD\u4FB0",4,"\u4FB6",8,"\u4FC0\u4FC1\u4FC2\u4FC6\u4FC7\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FD2",4,"\u4FD9\u4FDB\u4FE0\u4FE2\u4FE4\u4FE5\u4FE7\u4FEB\u4FEC\u4FF0\u4FF2\u4FF4\u4FF5\u4FF6\u4FF7\u4FF9\u4FFB\u4FFC\u4FFD\u4FFF",11],["8280","\u500B\u500E\u5010\u5011\u5013\u5015\u5016\u5017\u501B\u501D\u501E\u5020\u5022\u5023\u5024\u5027\u502B\u502F",10,"\u503B\u503D\u503F\u5040\u5041\u5042\u5044\u5045\u5046\u5049\u504A\u504B\u504D\u5050",4,"\u5056\u5057\u5058\u5059\u505B\u505D",7,"\u5066",5,"\u506D",8,"\u5078\u5079\u507A\u507C\u507D\u5081\u5082\u5083\u5084\u5086\u5087\u5089\u508A\u508B\u508C\u508E",20,"\u50A4\u50A6\u50AA\u50AB\u50AD",4,"\u50B3",6,"\u50BC"],["8340","\u50BD",17,"\u50D0",5,"\u50D7\u50D8\u50D9\u50DB",10,"\u50E8\u50E9\u50EA\u50EB\u50EF\u50F0\u50F1\u50F2\u50F4\u50F6",4,"\u50FC",9,"\u5108"],["8380","\u5109\u510A\u510C",5,"\u5113",13,"\u5122",28,"\u5142\u5147\u514A\u514C\u514E\u514F\u5150\u5152\u5153\u5157\u5158\u5159\u515B\u515D",4,"\u5163\u5164\u5166\u5167\u5169\u516A\u516F\u5172\u517A\u517E\u517F\u5183\u5184\u5186\u5187\u518A\u518B\u518E\u518F\u5190\u5191\u5193\u5194\u5198\u519A\u519D\u519E\u519F\u51A1\u51A3\u51A6",4,"\u51AD\u51AE\u51B4\u51B8\u51B9\u51BA\u51BE\u51BF\u51C1\u51C2\u51C3\u51C5\u51C8\u51CA\u51CD\u51CE\u51D0\u51D2",5],["8440","\u51D8\u51D9\u51DA\u51DC\u51DE\u51DF\u51E2\u51E3\u51E5",5,"\u51EC\u51EE\u51F1\u51F2\u51F4\u51F7\u51FE\u5204\u5205\u5209\u520B\u520C\u520F\u5210\u5213\u5214\u5215\u521C\u521E\u521F\u5221\u5222\u5223\u5225\u5226\u5227\u522A\u522C\u522F\u5231\u5232\u5234\u5235\u523C\u523E\u5244",5,"\u524B\u524E\u524F\u5252\u5253\u5255\u5257\u5258"],["8480","\u5259\u525A\u525B\u525D\u525F\u5260\u5262\u5263\u5264\u5266\u5268\u526B\u526C\u526D\u526E\u5270\u5271\u5273",9,"\u527E\u5280\u5283",4,"\u5289",6,"\u5291\u5292\u5294",6,"\u529C\u52A4\u52A5\u52A6\u52A7\u52AE\u52AF\u52B0\u52B4",9,"\u52C0\u52C1\u52C2\u52C4\u52C5\u52C6\u52C8\u52CA\u52CC\u52CD\u52CE\u52CF\u52D1\u52D3\u52D4\u52D5\u52D7\u52D9",5,"\u52E0\u52E1\u52E2\u52E3\u52E5",10,"\u52F1",7,"\u52FB\u52FC\u52FD\u5301\u5302\u5303\u5304\u5307\u5309\u530A\u530B\u530C\u530E"],["8540","\u5311\u5312\u5313\u5314\u5318\u531B\u531C\u531E\u531F\u5322\u5324\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u532F",9,"\u533C\u533D\u5340\u5342\u5344\u5346\u534B\u534C\u534D\u5350\u5354\u5358\u5359\u535B\u535D\u5365\u5368\u536A\u536C\u536D\u5372\u5376\u5379\u537B\u537C\u537D\u537E\u5380\u5381\u5383\u5387\u5388\u538A\u538E\u538F"],["8580","\u5390",4,"\u5396\u5397\u5399\u539B\u539C\u539E\u53A0\u53A1\u53A4\u53A7\u53AA\u53AB\u53AC\u53AD\u53AF",6,"\u53B7\u53B8\u53B9\u53BA\u53BC\u53BD\u53BE\u53C0\u53C3",4,"\u53CE\u53CF\u53D0\u53D2\u53D3\u53D5\u53DA\u53DC\u53DD\u53DE\u53E1\u53E2\u53E7\u53F4\u53FA\u53FE\u53FF\u5400\u5402\u5405\u5407\u540B\u5414\u5418\u5419\u541A\u541C\u5422\u5424\u5425\u542A\u5430\u5433\u5436\u5437\u543A\u543D\u543F\u5441\u5442\u5444\u5445\u5447\u5449\u544C\u544D\u544E\u544F\u5451\u545A\u545D",4,"\u5463\u5465\u5467\u5469",7,"\u5474\u5479\u547A\u547E\u547F\u5481\u5483\u5485\u5487\u5488\u5489\u548A\u548D\u5491\u5493\u5497\u5498\u549C\u549E\u549F\u54A0\u54A1"],["8640","\u54A2\u54A5\u54AE\u54B0\u54B2\u54B5\u54B6\u54B7\u54B9\u54BA\u54BC\u54BE\u54C3\u54C5\u54CA\u54CB\u54D6\u54D8\u54DB\u54E0",4,"\u54EB\u54EC\u54EF\u54F0\u54F1\u54F4",5,"\u54FB\u54FE\u5500\u5502\u5503\u5504\u5505\u5508\u550A",4,"\u5512\u5513\u5515",5,"\u551C\u551D\u551E\u551F\u5521\u5525\u5526"],["8680","\u5528\u5529\u552B\u552D\u5532\u5534\u5535\u5536\u5538\u5539\u553A\u553B\u553D\u5540\u5542\u5545\u5547\u5548\u554B",4,"\u5551\u5552\u5553\u5554\u5557",4,"\u555D\u555E\u555F\u5560\u5562\u5563\u5568\u5569\u556B\u556F",5,"\u5579\u557A\u557D\u557F\u5585\u5586\u558C\u558D\u558E\u5590\u5592\u5593\u5595\u5596\u5597\u559A\u559B\u559E\u55A0",6,"\u55A8",8,"\u55B2\u55B4\u55B6\u55B8\u55BA\u55BC\u55BF",4,"\u55C6\u55C7\u55C8\u55CA\u55CB\u55CE\u55CF\u55D0\u55D5\u55D7",4,"\u55DE\u55E0\u55E2\u55E7\u55E9\u55ED\u55EE\u55F0\u55F1\u55F4\u55F6\u55F8",4,"\u55FF\u5602\u5603\u5604\u5605"],["8740","\u5606\u5607\u560A\u560B\u560D\u5610",7,"\u5619\u561A\u561C\u561D\u5620\u5621\u5622\u5625\u5626\u5628\u5629\u562A\u562B\u562E\u562F\u5630\u5633\u5635\u5637\u5638\u563A\u563C\u563D\u563E\u5640",11,"\u564F",4,"\u5655\u5656\u565A\u565B\u565D",4],["8780","\u5663\u5665\u5666\u5667\u566D\u566E\u566F\u5670\u5672\u5673\u5674\u5675\u5677\u5678\u5679\u567A\u567D",7,"\u5687",6,"\u5690\u5691\u5692\u5694",14,"\u56A4",10,"\u56B0",6,"\u56B8\u56B9\u56BA\u56BB\u56BD",12,"\u56CB",8,"\u56D5\u56D6\u56D8\u56D9\u56DC\u56E3\u56E5",5,"\u56EC\u56EE\u56EF\u56F2\u56F3\u56F6\u56F7\u56F8\u56FB\u56FC\u5700\u5701\u5702\u5705\u5707\u570B",6],["8840","\u5712",9,"\u571D\u571E\u5720\u5721\u5722\u5724\u5725\u5726\u5727\u572B\u5731\u5732\u5734",4,"\u573C\u573D\u573F\u5741\u5743\u5744\u5745\u5746\u5748\u5749\u574B\u5752",4,"\u5758\u5759\u5762\u5763\u5765\u5767\u576C\u576E\u5770\u5771\u5772\u5774\u5775\u5778\u5779\u577A\u577D\u577E\u577F\u5780"],["8880","\u5781\u5787\u5788\u5789\u578A\u578D",4,"\u5794",6,"\u579C\u579D\u579E\u579F\u57A5\u57A8\u57AA\u57AC\u57AF\u57B0\u57B1\u57B3\u57B5\u57B6\u57B7\u57B9",8,"\u57C4",6,"\u57CC\u57CD\u57D0\u57D1\u57D3\u57D6\u57D7\u57DB\u57DC\u57DE\u57E1\u57E2\u57E3\u57E5",7,"\u57EE\u57F0\u57F1\u57F2\u57F3\u57F5\u57F6\u57F7\u57FB\u57FC\u57FE\u57FF\u5801\u5803\u5804\u5805\u5808\u5809\u580A\u580C\u580E\u580F\u5810\u5812\u5813\u5814\u5816\u5817\u5818\u581A\u581B\u581C\u581D\u581F\u5822\u5823\u5825",4,"\u582B",4,"\u5831\u5832\u5833\u5834\u5836",7],["8940","\u583E",5,"\u5845",6,"\u584E\u584F\u5850\u5852\u5853\u5855\u5856\u5857\u5859",4,"\u585F",5,"\u5866",4,"\u586D",16,"\u587F\u5882\u5884\u5886\u5887\u5888\u588A\u588B\u588C"],["8980","\u588D",4,"\u5894",4,"\u589B\u589C\u589D\u58A0",7,"\u58AA",17,"\u58BD\u58BE\u58BF\u58C0\u58C2\u58C3\u58C4\u58C6",10,"\u58D2\u58D3\u58D4\u58D6",13,"\u58E5",5,"\u58ED\u58EF\u58F1\u58F2\u58F4\u58F5\u58F7\u58F8\u58FA",7,"\u5903\u5905\u5906\u5908",4,"\u590E\u5910\u5911\u5912\u5913\u5917\u5918\u591B\u591D\u591E\u5920\u5921\u5922\u5923\u5926\u5928\u592C\u5930\u5932\u5933\u5935\u5936\u593B"],["8a40","\u593D\u593E\u593F\u5940\u5943\u5945\u5946\u594A\u594C\u594D\u5950\u5952\u5953\u5959\u595B",4,"\u5961\u5963\u5964\u5966",12,"\u5975\u5977\u597A\u597B\u597C\u597E\u597F\u5980\u5985\u5989\u598B\u598C\u598E\u598F\u5990\u5991\u5994\u5995\u5998\u599A\u599B\u599C\u599D\u599F\u59A0\u59A1\u59A2\u59A6"],["8a80","\u59A7\u59AC\u59AD\u59B0\u59B1\u59B3",5,"\u59BA\u59BC\u59BD\u59BF",6,"\u59C7\u59C8\u59C9\u59CC\u59CD\u59CE\u59CF\u59D5\u59D6\u59D9\u59DB\u59DE",4,"\u59E4\u59E6\u59E7\u59E9\u59EA\u59EB\u59ED",11,"\u59FA\u59FC\u59FD\u59FE\u5A00\u5A02\u5A0A\u5A0B\u5A0D\u5A0E\u5A0F\u5A10\u5A12\u5A14\u5A15\u5A16\u5A17\u5A19\u5A1A\u5A1B\u5A1D\u5A1E\u5A21\u5A22\u5A24\u5A26\u5A27\u5A28\u5A2A",6,"\u5A33\u5A35\u5A37",4,"\u5A3D\u5A3E\u5A3F\u5A41",4,"\u5A47\u5A48\u5A4B",9,"\u5A56\u5A57\u5A58\u5A59\u5A5B",5],["8b40","\u5A61\u5A63\u5A64\u5A65\u5A66\u5A68\u5A69\u5A6B",8,"\u5A78\u5A79\u5A7B\u5A7C\u5A7D\u5A7E\u5A80",17,"\u5A93",6,"\u5A9C",13,"\u5AAB\u5AAC"],["8b80","\u5AAD",4,"\u5AB4\u5AB6\u5AB7\u5AB9",4,"\u5ABF\u5AC0\u5AC3",5,"\u5ACA\u5ACB\u5ACD",4,"\u5AD3\u5AD5\u5AD7\u5AD9\u5ADA\u5ADB\u5ADD\u5ADE\u5ADF\u5AE2\u5AE4\u5AE5\u5AE7\u5AE8\u5AEA\u5AEC",4,"\u5AF2",22,"\u5B0A",11,"\u5B18",25,"\u5B33\u5B35\u5B36\u5B38",7,"\u5B41",6],["8c40","\u5B48",7,"\u5B52\u5B56\u5B5E\u5B60\u5B61\u5B67\u5B68\u5B6B\u5B6D\u5B6E\u5B6F\u5B72\u5B74\u5B76\u5B77\u5B78\u5B79\u5B7B\u5B7C\u5B7E\u5B7F\u5B82\u5B86\u5B8A\u5B8D\u5B8E\u5B90\u5B91\u5B92\u5B94\u5B96\u5B9F\u5BA7\u5BA8\u5BA9\u5BAC\u5BAD\u5BAE\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBB\u5BBC\u5BC0\u5BC1\u5BC3\u5BC8\u5BC9\u5BCA\u5BCB\u5BCD\u5BCE\u5BCF"],["8c80","\u5BD1\u5BD4",8,"\u5BE0\u5BE2\u5BE3\u5BE6\u5BE7\u5BE9",4,"\u5BEF\u5BF1",6,"\u5BFD\u5BFE\u5C00\u5C02\u5C03\u5C05\u5C07\u5C08\u5C0B\u5C0C\u5C0D\u5C0E\u5C10\u5C12\u5C13\u5C17\u5C19\u5C1B\u5C1E\u5C1F\u5C20\u5C21\u5C23\u5C26\u5C28\u5C29\u5C2A\u5C2B\u5C2D\u5C2E\u5C2F\u5C30\u5C32\u5C33\u5C35\u5C36\u5C37\u5C43\u5C44\u5C46\u5C47\u5C4C\u5C4D\u5C52\u5C53\u5C54\u5C56\u5C57\u5C58\u5C5A\u5C5B\u5C5C\u5C5D\u5C5F\u5C62\u5C64\u5C67",6,"\u5C70\u5C72",6,"\u5C7B\u5C7C\u5C7D\u5C7E\u5C80\u5C83",4,"\u5C89\u5C8A\u5C8B\u5C8E\u5C8F\u5C92\u5C93\u5C95\u5C9D",4,"\u5CA4",4],["8d40","\u5CAA\u5CAE\u5CAF\u5CB0\u5CB2\u5CB4\u5CB6\u5CB9\u5CBA\u5CBB\u5CBC\u5CBE\u5CC0\u5CC2\u5CC3\u5CC5",5,"\u5CCC",5,"\u5CD3",5,"\u5CDA",6,"\u5CE2\u5CE3\u5CE7\u5CE9\u5CEB\u5CEC\u5CEE\u5CEF\u5CF1",9,"\u5CFC",4],["8d80","\u5D01\u5D04\u5D05\u5D08",5,"\u5D0F",4,"\u5D15\u5D17\u5D18\u5D19\u5D1A\u5D1C\u5D1D\u5D1F",4,"\u5D25\u5D28\u5D2A\u5D2B\u5D2C\u5D2F",4,"\u5D35",7,"\u5D3F",7,"\u5D48\u5D49\u5D4D",10,"\u5D59\u5D5A\u5D5C\u5D5E",10,"\u5D6A\u5D6D\u5D6E\u5D70\u5D71\u5D72\u5D73\u5D75",12,"\u5D83",21,"\u5D9A\u5D9B\u5D9C\u5D9E\u5D9F\u5DA0"],["8e40","\u5DA1",21,"\u5DB8",12,"\u5DC6",6,"\u5DCE",12,"\u5DDC\u5DDF\u5DE0\u5DE3\u5DE4\u5DEA\u5DEC\u5DED"],["8e80","\u5DF0\u5DF5\u5DF6\u5DF8",4,"\u5DFF\u5E00\u5E04\u5E07\u5E09\u5E0A\u5E0B\u5E0D\u5E0E\u5E12\u5E13\u5E17\u5E1E",7,"\u5E28",4,"\u5E2F\u5E30\u5E32",4,"\u5E39\u5E3A\u5E3E\u5E3F\u5E40\u5E41\u5E43\u5E46",5,"\u5E4D",6,"\u5E56",4,"\u5E5C\u5E5D\u5E5F\u5E60\u5E63",14,"\u5E75\u5E77\u5E79\u5E7E\u5E81\u5E82\u5E83\u5E85\u5E88\u5E89\u5E8C\u5E8D\u5E8E\u5E92\u5E98\u5E9B\u5E9D\u5EA1\u5EA2\u5EA3\u5EA4\u5EA8",4,"\u5EAE",4,"\u5EB4\u5EBA\u5EBB\u5EBC\u5EBD\u5EBF",6],["8f40","\u5EC6\u5EC7\u5EC8\u5ECB",5,"\u5ED4\u5ED5\u5ED7\u5ED8\u5ED9\u5EDA\u5EDC",11,"\u5EE9\u5EEB",8,"\u5EF5\u5EF8\u5EF9\u5EFB\u5EFC\u5EFD\u5F05\u5F06\u5F07\u5F09\u5F0C\u5F0D\u5F0E\u5F10\u5F12\u5F14\u5F16\u5F19\u5F1A\u5F1C\u5F1D\u5F1E\u5F21\u5F22\u5F23\u5F24"],["8f80","\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F32",6,"\u5F3B\u5F3D\u5F3E\u5F3F\u5F41",14,"\u5F51\u5F54\u5F59\u5F5A\u5F5B\u5F5C\u5F5E\u5F5F\u5F60\u5F63\u5F65\u5F67\u5F68\u5F6B\u5F6E\u5F6F\u5F72\u5F74\u5F75\u5F76\u5F78\u5F7A\u5F7D\u5F7E\u5F7F\u5F83\u5F86\u5F8D\u5F8E\u5F8F\u5F91\u5F93\u5F94\u5F96\u5F9A\u5F9B\u5F9D\u5F9E\u5F9F\u5FA0\u5FA2",5,"\u5FA9\u5FAB\u5FAC\u5FAF",5,"\u5FB6\u5FB8\u5FB9\u5FBA\u5FBB\u5FBE",4,"\u5FC7\u5FC8\u5FCA\u5FCB\u5FCE\u5FD3\u5FD4\u5FD5\u5FDA\u5FDB\u5FDC\u5FDE\u5FDF\u5FE2\u5FE3\u5FE5\u5FE6\u5FE8\u5FE9\u5FEC\u5FEF\u5FF0\u5FF2\u5FF3\u5FF4\u5FF6\u5FF7\u5FF9\u5FFA\u5FFC\u6007"],["9040","\u6008\u6009\u600B\u600C\u6010\u6011\u6013\u6017\u6018\u601A\u601E\u601F\u6022\u6023\u6024\u602C\u602D\u602E\u6030",4,"\u6036",4,"\u603D\u603E\u6040\u6044",6,"\u604C\u604E\u604F\u6051\u6053\u6054\u6056\u6057\u6058\u605B\u605C\u605E\u605F\u6060\u6061\u6065\u6066\u606E\u6071\u6072\u6074\u6075\u6077\u607E\u6080"],["9080","\u6081\u6082\u6085\u6086\u6087\u6088\u608A\u608B\u608E\u608F\u6090\u6091\u6093\u6095\u6097\u6098\u6099\u609C\u609E\u60A1\u60A2\u60A4\u60A5\u60A7\u60A9\u60AA\u60AE\u60B0\u60B3\u60B5\u60B6\u60B7\u60B9\u60BA\u60BD",7,"\u60C7\u60C8\u60C9\u60CC",4,"\u60D2\u60D3\u60D4\u60D6\u60D7\u60D9\u60DB\u60DE\u60E1",4,"\u60EA\u60F1\u60F2\u60F5\u60F7\u60F8\u60FB",4,"\u6102\u6103\u6104\u6105\u6107\u610A\u610B\u610C\u6110",4,"\u6116\u6117\u6118\u6119\u611B\u611C\u611D\u611E\u6121\u6122\u6125\u6128\u6129\u612A\u612C",18,"\u6140",6],["9140","\u6147\u6149\u614B\u614D\u614F\u6150\u6152\u6153\u6154\u6156",6,"\u615E\u615F\u6160\u6161\u6163\u6164\u6165\u6166\u6169",6,"\u6171\u6172\u6173\u6174\u6176\u6178",18,"\u618C\u618D\u618F",4,"\u6195"],["9180","\u6196",6,"\u619E",8,"\u61AA\u61AB\u61AD",9,"\u61B8",5,"\u61BF\u61C0\u61C1\u61C3",4,"\u61C9\u61CC",4,"\u61D3\u61D5",16,"\u61E7",13,"\u61F6",8,"\u6200",5,"\u6207\u6209\u6213\u6214\u6219\u621C\u621D\u621E\u6220\u6223\u6226\u6227\u6228\u6229\u622B\u622D\u622F\u6230\u6231\u6232\u6235\u6236\u6238",4,"\u6242\u6244\u6245\u6246\u624A"],["9240","\u624F\u6250\u6255\u6256\u6257\u6259\u625A\u625C",6,"\u6264\u6265\u6268\u6271\u6272\u6274\u6275\u6277\u6278\u627A\u627B\u627D\u6281\u6282\u6283\u6285\u6286\u6287\u6288\u628B",5,"\u6294\u6299\u629C\u629D\u629E\u62A3\u62A6\u62A7\u62A9\u62AA\u62AD\u62AE\u62AF\u62B0\u62B2\u62B3\u62B4\u62B6\u62B7\u62B8\u62BA\u62BE\u62C0\u62C1"],["9280","\u62C3\u62CB\u62CF\u62D1\u62D5\u62DD\u62DE\u62E0\u62E1\u62E4\u62EA\u62EB\u62F0\u62F2\u62F5\u62F8\u62F9\u62FA\u62FB\u6300\u6303\u6304\u6305\u6306\u630A\u630B\u630C\u630D\u630F\u6310\u6312\u6313\u6314\u6315\u6317\u6318\u6319\u631C\u6326\u6327\u6329\u632C\u632D\u632E\u6330\u6331\u6333",5,"\u633B\u633C\u633E\u633F\u6340\u6341\u6344\u6347\u6348\u634A\u6351\u6352\u6353\u6354\u6356",7,"\u6360\u6364\u6365\u6366\u6368\u636A\u636B\u636C\u636F\u6370\u6372\u6373\u6374\u6375\u6378\u6379\u637C\u637D\u637E\u637F\u6381\u6383\u6384\u6385\u6386\u638B\u638D\u6391\u6393\u6394\u6395\u6397\u6399",6,"\u63A1\u63A4\u63A6\u63AB\u63AF\u63B1\u63B2\u63B5\u63B6\u63B9\u63BB\u63BD\u63BF\u63C0"],["9340","\u63C1\u63C2\u63C3\u63C5\u63C7\u63C8\u63CA\u63CB\u63CC\u63D1\u63D3\u63D4\u63D5\u63D7",6,"\u63DF\u63E2\u63E4",4,"\u63EB\u63EC\u63EE\u63EF\u63F0\u63F1\u63F3\u63F5\u63F7\u63F9\u63FA\u63FB\u63FC\u63FE\u6403\u6404\u6406",4,"\u640D\u640E\u6411\u6412\u6415",5,"\u641D\u641F\u6422\u6423\u6424"],["9380","\u6425\u6427\u6428\u6429\u642B\u642E",5,"\u6435",4,"\u643B\u643C\u643E\u6440\u6442\u6443\u6449\u644B",6,"\u6453\u6455\u6456\u6457\u6459",4,"\u645F",7,"\u6468\u646A\u646B\u646C\u646E",9,"\u647B",6,"\u6483\u6486\u6488",8,"\u6493\u6494\u6497\u6498\u649A\u649B\u649C\u649D\u649F",4,"\u64A5\u64A6\u64A7\u64A8\u64AA\u64AB\u64AF\u64B1\u64B2\u64B3\u64B4\u64B6\u64B9\u64BB\u64BD\u64BE\u64BF\u64C1\u64C3\u64C4\u64C6",6,"\u64CF\u64D1\u64D3\u64D4\u64D5\u64D6\u64D9\u64DA"],["9440","\u64DB\u64DC\u64DD\u64DF\u64E0\u64E1\u64E3\u64E5\u64E7",24,"\u6501",7,"\u650A",7,"\u6513",4,"\u6519",8],["9480","\u6522\u6523\u6524\u6526",4,"\u652C\u652D\u6530\u6531\u6532\u6533\u6537\u653A\u653C\u653D\u6540",4,"\u6546\u6547\u654A\u654B\u654D\u654E\u6550\u6552\u6553\u6554\u6557\u6558\u655A\u655C\u655F\u6560\u6561\u6564\u6565\u6567\u6568\u6569\u656A\u656D\u656E\u656F\u6571\u6573\u6575\u6576\u6578",14,"\u6588\u6589\u658A\u658D\u658E\u658F\u6592\u6594\u6595\u6596\u6598\u659A\u659D\u659E\u65A0\u65A2\u65A3\u65A6\u65A8\u65AA\u65AC\u65AE\u65B1",7,"\u65BA\u65BB\u65BE\u65BF\u65C0\u65C2\u65C7\u65C8\u65C9\u65CA\u65CD\u65D0\u65D1\u65D3\u65D4\u65D5\u65D8",7,"\u65E1\u65E3\u65E4\u65EA\u65EB"],["9540","\u65F2\u65F3\u65F4\u65F5\u65F8\u65F9\u65FB",4,"\u6601\u6604\u6605\u6607\u6608\u6609\u660B\u660D\u6610\u6611\u6612\u6616\u6617\u6618\u661A\u661B\u661C\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6632\u6633\u6637",4,"\u663D\u663F\u6640\u6642\u6644",6,"\u664D\u664E\u6650\u6651\u6658"],["9580","\u6659\u665B\u665C\u665D\u665E\u6660\u6662\u6663\u6665\u6667\u6669",4,"\u6671\u6672\u6673\u6675\u6678\u6679\u667B\u667C\u667D\u667F\u6680\u6681\u6683\u6685\u6686\u6688\u6689\u668A\u668B\u668D\u668E\u668F\u6690\u6692\u6693\u6694\u6695\u6698",4,"\u669E",8,"\u66A9",4,"\u66AF",4,"\u66B5\u66B6\u66B7\u66B8\u66BA\u66BB\u66BC\u66BD\u66BF",25,"\u66DA\u66DE",7,"\u66E7\u66E8\u66EA",5,"\u66F1\u66F5\u66F6\u66F8\u66FA\u66FB\u66FD\u6701\u6702\u6703"],["9640","\u6704\u6705\u6706\u6707\u670C\u670E\u670F\u6711\u6712\u6713\u6716\u6718\u6719\u671A\u671C\u671E\u6720",5,"\u6727\u6729\u672E\u6730\u6732\u6733\u6736\u6737\u6738\u6739\u673B\u673C\u673E\u673F\u6741\u6744\u6745\u6747\u674A\u674B\u674D\u6752\u6754\u6755\u6757",4,"\u675D\u6762\u6763\u6764\u6766\u6767\u676B\u676C\u676E\u6771\u6774\u6776"],["9680","\u6778\u6779\u677A\u677B\u677D\u6780\u6782\u6783\u6785\u6786\u6788\u678A\u678C\u678D\u678E\u678F\u6791\u6792\u6793\u6794\u6796\u6799\u679B\u679F\u67A0\u67A1\u67A4\u67A6\u67A9\u67AC\u67AE\u67B1\u67B2\u67B4\u67B9",7,"\u67C2\u67C5",9,"\u67D5\u67D6\u67D7\u67DB\u67DF\u67E1\u67E3\u67E4\u67E6\u67E7\u67E8\u67EA\u67EB\u67ED\u67EE\u67F2\u67F5",7,"\u67FE\u6801\u6802\u6803\u6804\u6806\u680D\u6810\u6812\u6814\u6815\u6818",4,"\u681E\u681F\u6820\u6822",6,"\u682B",6,"\u6834\u6835\u6836\u683A\u683B\u683F\u6847\u684B\u684D\u684F\u6852\u6856",5],["9740","\u685C\u685D\u685E\u685F\u686A\u686C",7,"\u6875\u6878",8,"\u6882\u6884\u6887",7,"\u6890\u6891\u6892\u6894\u6895\u6896\u6898",9,"\u68A3\u68A4\u68A5\u68A9\u68AA\u68AB\u68AC\u68AE\u68B1\u68B2\u68B4\u68B6\u68B7\u68B8"],["9780","\u68B9",6,"\u68C1\u68C3",5,"\u68CA\u68CC\u68CE\u68CF\u68D0\u68D1\u68D3\u68D4\u68D6\u68D7\u68D9\u68DB",4,"\u68E1\u68E2\u68E4",9,"\u68EF\u68F2\u68F3\u68F4\u68F6\u68F7\u68F8\u68FB\u68FD\u68FE\u68FF\u6900\u6902\u6903\u6904\u6906",4,"\u690C\u690F\u6911\u6913",11,"\u6921\u6922\u6923\u6925",7,"\u692E\u692F\u6931\u6932\u6933\u6935\u6936\u6937\u6938\u693A\u693B\u693C\u693E\u6940\u6941\u6943",16,"\u6955\u6956\u6958\u6959\u695B\u695C\u695F"],["9840","\u6961\u6962\u6964\u6965\u6967\u6968\u6969\u696A\u696C\u696D\u696F\u6970\u6972",4,"\u697A\u697B\u697D\u697E\u697F\u6981\u6983\u6985\u698A\u698B\u698C\u698E",5,"\u6996\u6997\u6999\u699A\u699D",9,"\u69A9\u69AA\u69AC\u69AE\u69AF\u69B0\u69B2\u69B3\u69B5\u69B6\u69B8\u69B9\u69BA\u69BC\u69BD"],["9880","\u69BE\u69BF\u69C0\u69C2",7,"\u69CB\u69CD\u69CF\u69D1\u69D2\u69D3\u69D5",5,"\u69DC\u69DD\u69DE\u69E1",11,"\u69EE\u69EF\u69F0\u69F1\u69F3",9,"\u69FE\u6A00",9,"\u6A0B",11,"\u6A19",5,"\u6A20\u6A22",5,"\u6A29\u6A2B\u6A2C\u6A2D\u6A2E\u6A30\u6A32\u6A33\u6A34\u6A36",6,"\u6A3F",4,"\u6A45\u6A46\u6A48",7,"\u6A51",6,"\u6A5A"],["9940","\u6A5C",4,"\u6A62\u6A63\u6A64\u6A66",10,"\u6A72",6,"\u6A7A\u6A7B\u6A7D\u6A7E\u6A7F\u6A81\u6A82\u6A83\u6A85",8,"\u6A8F\u6A92",4,"\u6A98",7,"\u6AA1",5],["9980","\u6AA7\u6AA8\u6AAA\u6AAD",114,"\u6B25\u6B26\u6B28",6],["9a40","\u6B2F\u6B30\u6B31\u6B33\u6B34\u6B35\u6B36\u6B38\u6B3B\u6B3C\u6B3D\u6B3F\u6B40\u6B41\u6B42\u6B44\u6B45\u6B48\u6B4A\u6B4B\u6B4D",11,"\u6B5A",7,"\u6B68\u6B69\u6B6B",13,"\u6B7A\u6B7D\u6B7E\u6B7F\u6B80\u6B85\u6B88"],["9a80","\u6B8C\u6B8E\u6B8F\u6B90\u6B91\u6B94\u6B95\u6B97\u6B98\u6B99\u6B9C",4,"\u6BA2",7,"\u6BAB",7,"\u6BB6\u6BB8",6,"\u6BC0\u6BC3\u6BC4\u6BC6",4,"\u6BCC\u6BCE\u6BD0\u6BD1\u6BD8\u6BDA\u6BDC",4,"\u6BE2",7,"\u6BEC\u6BED\u6BEE\u6BF0\u6BF1\u6BF2\u6BF4\u6BF6\u6BF7\u6BF8\u6BFA\u6BFB\u6BFC\u6BFE",6,"\u6C08",4,"\u6C0E\u6C12\u6C17\u6C1C\u6C1D\u6C1E\u6C20\u6C23\u6C25\u6C2B\u6C2C\u6C2D\u6C31\u6C33\u6C36\u6C37\u6C39\u6C3A\u6C3B\u6C3C\u6C3E\u6C3F\u6C43\u6C44\u6C45\u6C48\u6C4B",4,"\u6C51\u6C52\u6C53\u6C56\u6C58"],["9b40","\u6C59\u6C5A\u6C62\u6C63\u6C65\u6C66\u6C67\u6C6B",4,"\u6C71\u6C73\u6C75\u6C77\u6C78\u6C7A\u6C7B\u6C7C\u6C7F\u6C80\u6C84\u6C87\u6C8A\u6C8B\u6C8D\u6C8E\u6C91\u6C92\u6C95\u6C96\u6C97\u6C98\u6C9A\u6C9C\u6C9D\u6C9E\u6CA0\u6CA2\u6CA8\u6CAC\u6CAF\u6CB0\u6CB4\u6CB5\u6CB6\u6CB7\u6CBA\u6CC0\u6CC1\u6CC2\u6CC3\u6CC6\u6CC7\u6CC8\u6CCB\u6CCD\u6CCE\u6CCF\u6CD1\u6CD2\u6CD8"],["9b80","\u6CD9\u6CDA\u6CDC\u6CDD\u6CDF\u6CE4\u6CE6\u6CE7\u6CE9\u6CEC\u6CED\u6CF2\u6CF4\u6CF9\u6CFF\u6D00\u6D02\u6D03\u6D05\u6D06\u6D08\u6D09\u6D0A\u6D0D\u6D0F\u6D10\u6D11\u6D13\u6D14\u6D15\u6D16\u6D18\u6D1C\u6D1D\u6D1F",5,"\u6D26\u6D28\u6D29\u6D2C\u6D2D\u6D2F\u6D30\u6D34\u6D36\u6D37\u6D38\u6D3A\u6D3F\u6D40\u6D42\u6D44\u6D49\u6D4C\u6D50\u6D55\u6D56\u6D57\u6D58\u6D5B\u6D5D\u6D5F\u6D61\u6D62\u6D64\u6D65\u6D67\u6D68\u6D6B\u6D6C\u6D6D\u6D70\u6D71\u6D72\u6D73\u6D75\u6D76\u6D79\u6D7A\u6D7B\u6D7D",4,"\u6D83\u6D84\u6D86\u6D87\u6D8A\u6D8B\u6D8D\u6D8F\u6D90\u6D92\u6D96",4,"\u6D9C\u6DA2\u6DA5\u6DAC\u6DAD\u6DB0\u6DB1\u6DB3\u6DB4\u6DB6\u6DB7\u6DB9",5,"\u6DC1\u6DC2\u6DC3\u6DC8\u6DC9\u6DCA"],["9c40","\u6DCD\u6DCE\u6DCF\u6DD0\u6DD2\u6DD3\u6DD4\u6DD5\u6DD7\u6DDA\u6DDB\u6DDC\u6DDF\u6DE2\u6DE3\u6DE5\u6DE7\u6DE8\u6DE9\u6DEA\u6DED\u6DEF\u6DF0\u6DF2\u6DF4\u6DF5\u6DF6\u6DF8\u6DFA\u6DFD",7,"\u6E06\u6E07\u6E08\u6E09\u6E0B\u6E0F\u6E12\u6E13\u6E15\u6E18\u6E19\u6E1B\u6E1C\u6E1E\u6E1F\u6E22\u6E26\u6E27\u6E28\u6E2A\u6E2C\u6E2E\u6E30\u6E31\u6E33\u6E35"],["9c80","\u6E36\u6E37\u6E39\u6E3B",7,"\u6E45",7,"\u6E4F\u6E50\u6E51\u6E52\u6E55\u6E57\u6E59\u6E5A\u6E5C\u6E5D\u6E5E\u6E60",10,"\u6E6C\u6E6D\u6E6F",14,"\u6E80\u6E81\u6E82\u6E84\u6E87\u6E88\u6E8A",4,"\u6E91",6,"\u6E99\u6E9A\u6E9B\u6E9D\u6E9E\u6EA0\u6EA1\u6EA3\u6EA4\u6EA6\u6EA8\u6EA9\u6EAB\u6EAC\u6EAD\u6EAE\u6EB0\u6EB3\u6EB5\u6EB8\u6EB9\u6EBC\u6EBE\u6EBF\u6EC0\u6EC3\u6EC4\u6EC5\u6EC6\u6EC8\u6EC9\u6ECA\u6ECC\u6ECD\u6ECE\u6ED0\u6ED2\u6ED6\u6ED8\u6ED9\u6EDB\u6EDC\u6EDD\u6EE3\u6EE7\u6EEA",5],["9d40","\u6EF0\u6EF1\u6EF2\u6EF3\u6EF5\u6EF6\u6EF7\u6EF8\u6EFA",7,"\u6F03\u6F04\u6F05\u6F07\u6F08\u6F0A",4,"\u6F10\u6F11\u6F12\u6F16",9,"\u6F21\u6F22\u6F23\u6F25\u6F26\u6F27\u6F28\u6F2C\u6F2E\u6F30\u6F32\u6F34\u6F35\u6F37",6,"\u6F3F\u6F40\u6F41\u6F42"],["9d80","\u6F43\u6F44\u6F45\u6F48\u6F49\u6F4A\u6F4C\u6F4E",9,"\u6F59\u6F5A\u6F5B\u6F5D\u6F5F\u6F60\u6F61\u6F63\u6F64\u6F65\u6F67",5,"\u6F6F\u6F70\u6F71\u6F73\u6F75\u6F76\u6F77\u6F79\u6F7B\u6F7D",6,"\u6F85\u6F86\u6F87\u6F8A\u6F8B\u6F8F",12,"\u6F9D\u6F9E\u6F9F\u6FA0\u6FA2",4,"\u6FA8",10,"\u6FB4\u6FB5\u6FB7\u6FB8\u6FBA",5,"\u6FC1\u6FC3",5,"\u6FCA",6,"\u6FD3",10,"\u6FDF\u6FE2\u6FE3\u6FE4\u6FE5"],["9e40","\u6FE6",7,"\u6FF0",32,"\u7012",7,"\u701C",6,"\u7024",6],["9e80","\u702B",9,"\u7036\u7037\u7038\u703A",17,"\u704D\u704E\u7050",13,"\u705F",11,"\u706E\u7071\u7072\u7073\u7074\u7077\u7079\u707A\u707B\u707D\u7081\u7082\u7083\u7084\u7086\u7087\u7088\u708B\u708C\u708D\u708F\u7090\u7091\u7093\u7097\u7098\u709A\u709B\u709E",12,"\u70B0\u70B2\u70B4\u70B5\u70B6\u70BA\u70BE\u70BF\u70C4\u70C5\u70C6\u70C7\u70C9\u70CB",12,"\u70DA"],["9f40","\u70DC\u70DD\u70DE\u70E0\u70E1\u70E2\u70E3\u70E5\u70EA\u70EE\u70F0",6,"\u70F8\u70FA\u70FB\u70FC\u70FE",10,"\u710B",4,"\u7111\u7112\u7114\u7117\u711B",10,"\u7127",7,"\u7132\u7133\u7134"],["9f80","\u7135\u7137",13,"\u7146\u7147\u7148\u7149\u714B\u714D\u714F",12,"\u715D\u715F",4,"\u7165\u7169",4,"\u716F\u7170\u7171\u7174\u7175\u7176\u7177\u7179\u717B\u717C\u717E",5,"\u7185",4,"\u718B\u718C\u718D\u718E\u7190\u7191\u7192\u7193\u7195\u7196\u7197\u719A",4,"\u71A1",6,"\u71A9\u71AA\u71AB\u71AD",5,"\u71B4\u71B6\u71B7\u71B8\u71BA",8,"\u71C4",9,"\u71CF",4],["a040","\u71D6",9,"\u71E1\u71E2\u71E3\u71E4\u71E6\u71E8",5,"\u71EF",9,"\u71FA",11,"\u7207",19],["a080","\u721B\u721C\u721E",9,"\u7229\u722B\u722D\u722E\u722F\u7232\u7233\u7234\u723A\u723C\u723E\u7240",6,"\u7249\u724A\u724B\u724E\u724F\u7250\u7251\u7253\u7254\u7255\u7257\u7258\u725A\u725C\u725E\u7260\u7263\u7264\u7265\u7268\u726A\u726B\u726C\u726D\u7270\u7271\u7273\u7274\u7276\u7277\u7278\u727B\u727C\u727D\u7282\u7283\u7285",4,"\u728C\u728E\u7290\u7291\u7293",11,"\u72A0",11,"\u72AE\u72B1\u72B2\u72B3\u72B5\u72BA",6,"\u72C5\u72C6\u72C7\u72C9\u72CA\u72CB\u72CC\u72CF\u72D1\u72D3\u72D4\u72D5\u72D6\u72D8\u72DA\u72DB"],["a1a1","\u3000\u3001\u3002\xb7\u02C9\u02C7\xa8\u3003\u3005\u2014\uFF5E\u2016\u2026\u2018\u2019\u201C\u201D\u3014\u3015\u3008",7,"\u3016\u3017\u3010\u3011\xb1\xd7\xf7\u2236\u2227\u2228\u2211\u220F\u222A\u2229\u2208\u2237\u221A\u22A5\u2225\u2220\u2312\u2299\u222B\u222E\u2261\u224C\u2248\u223D\u221D\u2260\u226E\u226F\u2264\u2265\u221E\u2235\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFF04\xa4\uFFE0\uFFE1\u2030\xa7\u2116\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u203B\u2192\u2190\u2191\u2193\u3013"],["a2a1","\u2170",9],["a2b1","\u2488",19,"\u2474",19,"\u2460",9],["a2e5","\u3220",9],["a2f1","\u2160",11],["a3a1","\uFF01\uFF02\uFF03\uFFE5\uFF05",88,"\uFFE3"],["a4a1","\u3041",82],["a5a1","\u30A1",85],["a6a1","\u0391",16,"\u03A3",6],["a6c1","\u03B1",16,"\u03C3",6],["a6e0","\uFE35\uFE36\uFE39\uFE3A\uFE3F\uFE40\uFE3D\uFE3E\uFE41\uFE42\uFE43\uFE44"],["a6ee","\uFE3B\uFE3C\uFE37\uFE38\uFE31"],["a6f4","\uFE33\uFE34"],["a7a1","\u0410",5,"\u0401\u0416",25],["a7d1","\u0430",5,"\u0451\u0436",25],["a840","\u02CA\u02CB\u02D9\u2013\u2015\u2025\u2035\u2105\u2109\u2196\u2197\u2198\u2199\u2215\u221F\u2223\u2252\u2266\u2267\u22BF\u2550",35,"\u2581",6],["a880","\u2588",7,"\u2593\u2594\u2595\u25BC\u25BD\u25E2\u25E3\u25E4\u25E5\u2609\u2295\u3012\u301D\u301E"],["a8a1","\u0101\xe1\u01CE\xe0\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA\u01DC\xfc\xea\u0251"],["a8bd","\u0144\u0148"],["a8c0","\u0261"],["a8c5","\u3105",36],["a940","\u3021",8,"\u32A3\u338E\u338F\u339C\u339D\u339E\u33A1\u33C4\u33CE\u33D1\u33D2\u33D5\uFE30\uFFE2\uFFE4"],["a959","\u2121\u3231"],["a95c","\u2010"],["a960","\u30FC\u309B\u309C\u30FD\u30FE\u3006\u309D\u309E\uFE49",9,"\uFE54\uFE55\uFE56\uFE57\uFE59",8],["a980","\uFE62",4,"\uFE68\uFE69\uFE6A\uFE6B"],["a996","\u3007"],["a9a4","\u2500",75],["aa40","\u72DC\u72DD\u72DF\u72E2",5,"\u72EA\u72EB\u72F5\u72F6\u72F9\u72FD\u72FE\u72FF\u7300\u7302\u7304",5,"\u730B\u730C\u730D\u730F\u7310\u7311\u7312\u7314\u7318\u7319\u731A\u731F\u7320\u7323\u7324\u7326\u7327\u7328\u732D\u732F\u7330\u7332\u7333\u7335\u7336\u733A\u733B\u733C\u733D\u7340",8],["aa80","\u7349\u734A\u734B\u734C\u734E\u734F\u7351\u7353\u7354\u7355\u7356\u7358",7,"\u7361",10,"\u736E\u7370\u7371"],["ab40","\u7372",11,"\u737F",4,"\u7385\u7386\u7388\u738A\u738C\u738D\u738F\u7390\u7392\u7393\u7394\u7395\u7397\u7398\u7399\u739A\u739C\u739D\u739E\u73A0\u73A1\u73A3",5,"\u73AA\u73AC\u73AD\u73B1\u73B4\u73B5\u73B6\u73B8\u73B9\u73BC\u73BD\u73BE\u73BF\u73C1\u73C3",4],["ab80","\u73CB\u73CC\u73CE\u73D2",6,"\u73DA\u73DB\u73DC\u73DD\u73DF\u73E1\u73E2\u73E3\u73E4\u73E6\u73E8\u73EA\u73EB\u73EC\u73EE\u73EF\u73F0\u73F1\u73F3",4],["ac40","\u73F8",10,"\u7404\u7407\u7408\u740B\u740C\u740D\u740E\u7411",8,"\u741C",5,"\u7423\u7424\u7427\u7429\u742B\u742D\u742F\u7431\u7432\u7437",4,"\u743D\u743E\u743F\u7440\u7442",11],["ac80","\u744E",6,"\u7456\u7458\u745D\u7460",12,"\u746E\u746F\u7471",4,"\u7478\u7479\u747A"],["ad40","\u747B\u747C\u747D\u747F\u7482\u7484\u7485\u7486\u7488\u7489\u748A\u748C\u748D\u748F\u7491",10,"\u749D\u749F",7,"\u74AA",15,"\u74BB",12],["ad80","\u74C8",9,"\u74D3",8,"\u74DD\u74DF\u74E1\u74E5\u74E7",6,"\u74F0\u74F1\u74F2"],["ae40","\u74F3\u74F5\u74F8",6,"\u7500\u7501\u7502\u7503\u7505",7,"\u750E\u7510\u7512\u7514\u7515\u7516\u7517\u751B\u751D\u751E\u7520",4,"\u7526\u7527\u752A\u752E\u7534\u7536\u7539\u753C\u753D\u753F\u7541\u7542\u7543\u7544\u7546\u7547\u7549\u754A\u754D\u7550\u7551\u7552\u7553\u7555\u7556\u7557\u7558"],["ae80","\u755D",7,"\u7567\u7568\u7569\u756B",6,"\u7573\u7575\u7576\u7577\u757A",4,"\u7580\u7581\u7582\u7584\u7585\u7587"],["af40","\u7588\u7589\u758A\u758C\u758D\u758E\u7590\u7593\u7595\u7598\u759B\u759C\u759E\u75A2\u75A6",4,"\u75AD\u75B6\u75B7\u75BA\u75BB\u75BF\u75C0\u75C1\u75C6\u75CB\u75CC\u75CE\u75CF\u75D0\u75D1\u75D3\u75D7\u75D9\u75DA\u75DC\u75DD\u75DF\u75E0\u75E1\u75E5\u75E9\u75EC\u75ED\u75EE\u75EF\u75F2\u75F3\u75F5\u75F6\u75F7\u75F8\u75FA\u75FB\u75FD\u75FE\u7602\u7604\u7606\u7607"],["af80","\u7608\u7609\u760B\u760D\u760E\u760F\u7611\u7612\u7613\u7614\u7616\u761A\u761C\u761D\u761E\u7621\u7623\u7627\u7628\u762C\u762E\u762F\u7631\u7632\u7636\u7637\u7639\u763A\u763B\u763D\u7641\u7642\u7644"],["b040","\u7645",6,"\u764E",5,"\u7655\u7657",4,"\u765D\u765F\u7660\u7661\u7662\u7664",6,"\u766C\u766D\u766E\u7670",7,"\u7679\u767A\u767C\u767F\u7680\u7681\u7683\u7685\u7689\u768A\u768C\u768D\u768F\u7690\u7692\u7694\u7695\u7697\u7698\u769A\u769B"],["b080","\u769C",7,"\u76A5",8,"\u76AF\u76B0\u76B3\u76B5",9,"\u76C0\u76C1\u76C3\u554A\u963F\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u80AE\u6602\u76CE\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u82DE\u80DE\u5305\u8912\u5265"],["b140","\u76C4\u76C7\u76C9\u76CB\u76CC\u76D3\u76D5\u76D9\u76DA\u76DC\u76DD\u76DE\u76E0",4,"\u76E6",7,"\u76F0\u76F3\u76F5\u76F6\u76F7\u76FA\u76FB\u76FD\u76FF\u7700\u7702\u7703\u7705\u7706\u770A\u770C\u770E",10,"\u771B\u771C\u771D\u771E\u7721\u7723\u7724\u7725\u7727\u772A\u772B"],["b180","\u772C\u772E\u7730",4,"\u7739\u773B\u773D\u773E\u773F\u7742\u7744\u7745\u7746\u7748",7,"\u7752",7,"\u775C\u8584\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5954\u82EF\u672C\u7B28\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u6807\u5F6A\u8198\u8868\u9CD6\u618B\u522B\u762A\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3"],["b240","\u775D\u775E\u775F\u7760\u7764\u7767\u7769\u776A\u776D",11,"\u777A\u777B\u777C\u7781\u7782\u7783\u7786",5,"\u778F\u7790\u7793",11,"\u77A1\u77A3\u77A4\u77A6\u77A8\u77AB\u77AD\u77AE\u77AF\u77B1\u77B2\u77B4\u77B6",4],["b280","\u77BC\u77BE\u77C0",12,"\u77CE",8,"\u77D8\u77D9\u77DA\u77DD",4,"\u77E4\u75C5\u5E76\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u64E6\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u82CD\u8231\u4ED3\u6CA7\u85CF\u64CD\u7CD9\u69FD\u66F9\u8349\u5395\u7B56\u4FA7\u518C\u6D4B\u5C42\u8E6D\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u62C6\u67F4\u8C7A\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u660C\u7316"],["b340","\u77E6\u77E8\u77EA\u77EF\u77F0\u77F1\u77F2\u77F4\u77F5\u77F7\u77F9\u77FA\u77FB\u77FC\u7803",5,"\u780A\u780B\u780E\u780F\u7810\u7813\u7815\u7819\u781B\u781E\u7820\u7821\u7822\u7824\u7828\u782A\u782B\u782E\u782F\u7831\u7832\u7833\u7835\u7836\u783D\u783F\u7841\u7842\u7843\u7844\u7846\u7848\u7849\u784A\u784B\u784D\u784F\u7851\u7853\u7854\u7858\u7859\u785A"],["b380","\u785B\u785C\u785E",11,"\u786F",7,"\u7878\u7879\u787A\u787B\u787D",6,"\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u6491\u79F0\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u5145\u51B2\u866B\u5D07\u5BA0\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A"],["b440","\u7884\u7885\u7886\u7888\u788A\u788B\u788F\u7890\u7892\u7894\u7895\u7896\u7899\u789D\u789E\u78A0\u78A2\u78A4\u78A6\u78A8",7,"\u78B5\u78B6\u78B7\u78B8\u78BA\u78BB\u78BC\u78BD\u78BF\u78C0\u78C2\u78C3\u78C4\u78C6\u78C7\u78C8\u78CC\u78CD\u78CE\u78CF\u78D1\u78D2\u78D3\u78D6\u78D7\u78D8\u78DA",9],["b480","\u78E4\u78E5\u78E6\u78E7\u78E9\u78EA\u78EB\u78ED",4,"\u78F3\u78F5\u78F6\u78F8\u78F9\u78FB",5,"\u7902\u7903\u7904\u7906",6,"\u7840\u50A8\u77D7\u6410\u89E6\u5904\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u5439\u708A\u6376\u9524\u5782\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u6233\u7EF0\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u51D1\u7C97\u918B\u7C07\u4FC3\u8E7F\u7BE1\u7A9C\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u6751\u5B58\u5BF8\u78CB\u64AE\u6413\u63AA\u632B\u9519\u642D\u8FBE\u7B54\u7629\u6253\u5927\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E"],["b540","\u790D",5,"\u7914",9,"\u791F",4,"\u7925",14,"\u7935",4,"\u793D\u793F\u7942\u7943\u7944\u7945\u7947\u794A",8,"\u7954\u7955\u7958\u7959\u7961\u7963"],["b580","\u7964\u7966\u7969\u796A\u796B\u796C\u796E\u7970",6,"\u7979\u797B",4,"\u7982\u7983\u7986\u7987\u7988\u7989\u798B\u798C\u798D\u798E\u7990\u7991\u7992\u6020\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u5F53\u6321\u515A\u8361\u6863\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u5FB7\u5F97\u7684\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0"],["b640","\u7993",6,"\u799B",11,"\u79A8",10,"\u79B4",4,"\u79BC\u79BF\u79C2\u79C4\u79C5\u79C7\u79C8\u79CA\u79CC\u79CE\u79CF\u79D0\u79D3\u79D4\u79D6\u79D7\u79D9",5,"\u79E0\u79E1\u79E2\u79E5\u79E8\u79EA"],["b680","\u79EC\u79EE\u79F1",6,"\u79F9\u79FA\u79FC\u79FE\u79FF\u7A01\u7A04\u7A05\u7A07\u7A08\u7A09\u7A0A\u7A0C\u7A0F",4,"\u7A15\u7A16\u7A18\u7A19\u7A1B\u7A1C\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5806\u5151\u961F\u5BF9\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u6069\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C"],["b740","\u7A1D\u7A1F\u7A21\u7A22\u7A24",14,"\u7A34\u7A35\u7A36\u7A38\u7A3A\u7A3E\u7A40",5,"\u7A47",9,"\u7A52",4,"\u7A58",16],["b780","\u7A69",6,"\u7A71\u7A72\u7A73\u7A75\u7A7B\u7A7C\u7A7D\u7A7E\u7A82\u7A85\u7A87\u7A89\u7A8A\u7A8B\u7A8C\u7A8E\u7A8F\u7A90\u7A93\u7A94\u7A99\u7A9A\u7A9B\u7A9E\u7AA1\u7AA2\u8D30\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D"],["b840","\u7AA3\u7AA4\u7AA7\u7AA9\u7AAA\u7AAB\u7AAE",4,"\u7AB4",10,"\u7AC0",10,"\u7ACC",9,"\u7AD7\u7AD8\u7ADA\u7ADB\u7ADC\u7ADD\u7AE1\u7AE2\u7AE4\u7AE7",5,"\u7AEE\u7AF0\u7AF1\u7AF2\u7AF3"],["b880","\u7AF4",4,"\u7AFB\u7AFC\u7AFE\u7B00\u7B01\u7B02\u7B05\u7B07\u7B09\u7B0C\u7B0D\u7B0E\u7B10\u7B12\u7B13\u7B16\u7B17\u7B18\u7B1A\u7B1C\u7B1D\u7B1F\u7B21\u7B22\u7B23\u7B27\u7B29\u7B2D\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5676\u560E\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6760\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u86E4\u9601\u9694\u94EC\u4E2A\u5404\u7ED9\u6839\u8DDF\u8015\u66F4\u5E9A\u7FB9"],["b940","\u7B2F\u7B30\u7B32\u7B34\u7B35\u7B36\u7B37\u7B39\u7B3B\u7B3D\u7B3F",5,"\u7B46\u7B48\u7B4A\u7B4D\u7B4E\u7B53\u7B55\u7B57\u7B59\u7B5C\u7B5E\u7B5F\u7B61\u7B63",10,"\u7B6F\u7B70\u7B73\u7B74\u7B76\u7B78\u7B7A\u7B7C\u7B7D\u7B7F\u7B81\u7B82\u7B83\u7B84\u7B86",6,"\u7B8E\u7B8F"],["b980","\u7B91\u7B92\u7B93\u7B96\u7B98\u7B99\u7B9A\u7B9B\u7B9E\u7B9F\u7BA0\u7BA3\u7BA4\u7BA5\u7BAE\u7BAF\u7BB0\u7BB2\u7BB3\u7BB5\u7BB6\u7BB7\u7BB9",7,"\u7BC2\u7BC3\u7BC4\u57C2\u803F\u6897\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u522E\u74DC\u5250\u5BE1\u6302\u8902\u4E56\u62D0\u602A\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u5149\u5E7F\u901B\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u8F8A\u6EDA\u68CD\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u54C8"],["ba40","\u7BC5\u7BC8\u7BC9\u7BCA\u7BCB\u7BCD\u7BCE\u7BCF\u7BD0\u7BD2\u7BD4",4,"\u7BDB\u7BDC\u7BDE\u7BDF\u7BE0\u7BE2\u7BE3\u7BE4\u7BE7\u7BE8\u7BE9\u7BEB\u7BEC\u7BED\u7BEF\u7BF0\u7BF2",4,"\u7BF8\u7BF9\u7BFA\u7BFB\u7BFD\u7BFF",7,"\u7C08\u7C09\u7C0A\u7C0D\u7C0E\u7C10",5,"\u7C17\u7C18\u7C19"],["ba80","\u7C1A",4,"\u7C20",5,"\u7C28\u7C29\u7C2B",12,"\u7C39",5,"\u7C42\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u592F\u676D\u822A\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u563F\u9ED1\u75D5\u5F88\u72E0\u6068\u54FC\u4EA8\u6A2A\u8861\u6052\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56"],["bb40","\u7C43",9,"\u7C4E",36,"\u7C75",5,"\u7C7E",9],["bb80","\u7C88\u7C8A",6,"\u7C93\u7C94\u7C96\u7C99\u7C9A\u7C9B\u7CA0\u7CA1\u7CA3\u7CA6\u7CA7\u7CA8\u7CA9\u7CAB\u7CAC\u7CAD\u7CAF\u7CB0\u7CB4",4,"\u7CBA\u7CBB\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u69D0\u5F8A\u6000\u6DEE\u574F\u6B22\u73AF\u6853\u8FD8\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95"],["bc40","\u7CBF\u7CC0\u7CC2\u7CC3\u7CC4\u7CC6\u7CC9\u7CCB\u7CCE",6,"\u7CD8\u7CDA\u7CDB\u7CDD\u7CDE\u7CE1",6,"\u7CE9",5,"\u7CF0",7,"\u7CF9\u7CFA\u7CFC",13,"\u7D0B",5],["bc80","\u7D11",14,"\u7D21\u7D23\u7D24\u7D25\u7D26\u7D28\u7D29\u7D2A\u7D2C\u7D2D\u7D2E\u7D30",6,"\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6"],["bd40","\u7D37",54,"\u7D6F",7],["bd80","\u7D78",32,"\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78"],["be40","\u7D99",12,"\u7DA7",6,"\u7DAF",42],["be80","\u7DDA",32,"\u5C3D\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u70AF\u7A98\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u97A0\u62D8\u72D9\u75BD\u5C45\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u5747\u83CC\u94A7\u519B\u541B\u5CFB"],["bf40","\u7DFB",62],["bf80","\u7E3A\u7E3C",4,"\u7E42",4,"\u7E48",21,"\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u5580\u5496\u5361\u54AF\u5F00\u63E9\u6977\u51EF\u6168\u520A\u582A\u52D8\u574E\u780D\u770B\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u8003\u62F7\u70E4\u9760\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u80AF\u5543\u57A6\u6073\u5751\u542D\u7A7A\u6050\u5B54\u63A7\u62A0\u53E3\u6263\u5BC7\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5938\u57AE\u630E\u8DE8\u80EF\u5757\u7B77\u4FA9\u5FEB\u5BBD\u6B3E\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080"],["c040","\u7E5E",35,"\u7E83",23,"\u7E9C\u7E9D\u7E9E"],["c080","\u7EAE\u7EB4\u7EBB\u7EBC\u7ED6\u7EE4\u7EEC\u7EF9\u7F0A\u7F10\u7F1E\u7F37\u7F39\u7F3B",6,"\u7F43\u7F46",9,"\u7F52\u7F53\u9988\u6127\u6E83\u5764\u6606\u6346\u56F0\u62EC\u6269\u5ED3\u9614\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u83B1\u6765\u8D56\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u52D2\u4E50\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u808B\u7C7B\u6CEA\u68F1\u695E\u51B7\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0"],["c140","\u7F56\u7F59\u7F5B\u7F5C\u7F5D\u7F5E\u7F60\u7F63",4,"\u7F6B\u7F6C\u7F6D\u7F6F\u7F70\u7F73\u7F75\u7F76\u7F77\u7F78\u7F7A\u7F7B\u7F7C\u7F7D\u7F7F\u7F80\u7F82",7,"\u7F8B\u7F8D\u7F8F",4,"\u7F95",4,"\u7F9B\u7F9C\u7FA0\u7FA2\u7FA3\u7FA5\u7FA6\u7FA8",6,"\u7FB1"],["c180","\u7FB3",4,"\u7FBA\u7FBB\u7FBE\u7FC0\u7FC2\u7FC3\u7FC4\u7FC6\u7FC7\u7FC8\u7FC9\u7FCB\u7FCD\u7FCF",4,"\u7FD6\u7FD7\u7FD9",5,"\u7FE2\u7FE3\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u5217\u88C2\u70C8\u52A3\u730E\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u9F99\u804B\u5499\u7B3C\u7ABF"],["c240","\u7FE4\u7FE7\u7FE8\u7FEA\u7FEB\u7FEC\u7FED\u7FEF\u7FF2\u7FF4",6,"\u7FFD\u7FFE\u7FFF\u8002\u8007\u8008\u8009\u800A\u800E\u800F\u8011\u8013\u801A\u801B\u801D\u801E\u801F\u8021\u8023\u8024\u802B",5,"\u8032\u8034\u8039\u803A\u803C\u803E\u8040\u8041\u8044\u8045\u8047\u8048\u8049\u804E\u804F\u8050\u8051\u8053\u8055\u8056\u8057"],["c280","\u8059\u805B",13,"\u806B",5,"\u8072",11,"\u9686\u5784\u62E2\u9647\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u5CE6\u631B\u5B6A\u6EE6\u5375\u4E71\u63A0\u7565\u62A1\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B"],["c340","\u807E\u8081\u8082\u8085\u8088\u808A\u808D",5,"\u8094\u8095\u8097\u8099\u809E\u80A3\u80A6\u80A7\u80A8\u80AC\u80B0\u80B3\u80B5\u80B6\u80B8\u80B9\u80BB\u80C5\u80C7",4,"\u80CF",6,"\u80D8\u80DF\u80E0\u80E2\u80E3\u80E6\u80EE\u80F5\u80F7\u80F9\u80FB\u80FE\u80FF\u8100\u8101\u8103\u8104\u8105\u8107\u8108\u810B"],["c380","\u810C\u8115\u8117\u8119\u811B\u811C\u811D\u811F",12,"\u812D\u812E\u8130\u8133\u8134\u8135\u8137\u8139",4,"\u813F\u8C29\u8292\u832B\u76F2\u6C13\u5FD9\u83BD\u732B\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4E48\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u95E8\u95F7\u4EEC\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u8511\u706D\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u660E\u879F\u9E23\u94ED\u540D\u547D\u8C2C\u6478"],["c440","\u8140",5,"\u8147\u8149\u814D\u814E\u814F\u8152\u8156\u8157\u8158\u815B",4,"\u8161\u8162\u8163\u8164\u8166\u8168\u816A\u816B\u816C\u816F\u8172\u8173\u8175\u8176\u8177\u8178\u8181\u8183",4,"\u8189\u818B\u818C\u818D\u818E\u8190\u8192",5,"\u8199\u819A\u819E",4,"\u81A4\u81A5"],["c480","\u81A7\u81A9\u81AB",7,"\u81B4",5,"\u81BC\u81BD\u81BE\u81BF\u81C4\u81C5\u81C7\u81C8\u81C9\u81CB\u81CD",6,"\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C0B\u725F\u67D0\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u6C16\u4E43\u5976\u8010\u5948\u5357\u7537\u96BE\u56CA\u6320\u8111\u607C\u95F9\u6DD6\u5462\u9981\u5185\u5AE9\u80FD\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5A18\u917F\u9E1F\u5C3F\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u60A8\u67E0\u72DE\u51DD\u5B81"],["c540","\u81D4",14,"\u81E4\u81E5\u81E6\u81E8\u81E9\u81EB\u81EE",4,"\u81F5",5,"\u81FD\u81FF\u8203\u8207",4,"\u820E\u820F\u8211\u8213\u8215",5,"\u821D\u8220\u8224\u8225\u8226\u8227\u8229\u822E\u8232\u823A\u823C\u823D\u823F"],["c580","\u8240\u8241\u8242\u8243\u8245\u8246\u8248\u824A\u824C\u824D\u824E\u8250",7,"\u8259\u825B\u825C\u825D\u825E\u8260",7,"\u8269\u62E7\u6CDE\u725B\u626D\u94AE\u7EBD\u8113\u6D53\u519C\u5F04\u5974\u52AA\u6012\u5973\u6696\u8650\u759F\u632A\u61E6\u7CEF\u8BFA\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u556A\u8DB4\u722C\u5E15\u6015\u7436\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u4E53\u5E9E\u65C1\u802A\u80D6\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u55B7\u76C6\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7"],["c640","\u826A\u826B\u826C\u826D\u8271\u8275\u8276\u8277\u8278\u827B\u827C\u8280\u8281\u8283\u8285\u8286\u8287\u8289\u828C\u8290\u8293\u8294\u8295\u8296\u829A\u829B\u829E\u82A0\u82A2\u82A3\u82A7\u82B2\u82B5\u82B6\u82BA\u82BB\u82BC\u82BF\u82C0\u82C2\u82C3\u82C5\u82C6\u82C9\u82D0\u82D6\u82D9\u82DA\u82DD\u82E2\u82E7\u82E8\u82E9\u82EA\u82EC\u82ED\u82EE\u82F0\u82F2\u82F3\u82F5\u82F6\u82F8"],["c680","\u82FA\u82FC",4,"\u830A\u830B\u830D\u8310\u8312\u8313\u8316\u8318\u8319\u831D",9,"\u8329\u832A\u832E\u8330\u8332\u8337\u833B\u833D\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u7BC7\u504F\u7247\u9A97\u98D8\u6F02\u74E2\u7968\u6487\u77A5\u62FC\u9891\u8D2B\u54C1\u8058\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u5256\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u6390"],["c740","\u833E\u833F\u8341\u8342\u8344\u8345\u8348\u834A",4,"\u8353\u8355",4,"\u835D\u8362\u8370",6,"\u8379\u837A\u837E",6,"\u8387\u8388\u838A\u838B\u838C\u838D\u838F\u8390\u8391\u8394\u8395\u8396\u8397\u8399\u839A\u839D\u839F\u83A1",6,"\u83AC\u83AD\u83AE"],["c780","\u83AF\u83B5\u83BB\u83BE\u83BF\u83C2\u83C3\u83C4\u83C6\u83C8\u83C9\u83CB\u83CD\u83CE\u83D0\u83D1\u83D2\u83D3\u83D5\u83D7\u83D9\u83DA\u83DB\u83DE\u83E2\u83E3\u83E4\u83E6\u83E7\u83E8\u83EB\u83EC\u83ED\u6070\u6D3D\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5207\u8304\u4E14\u602F\u7A83\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u743C\u7A77\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20"],["c840","\u83EE\u83EF\u83F3",4,"\u83FA\u83FB\u83FC\u83FE\u83FF\u8400\u8402\u8405\u8407\u8408\u8409\u840A\u8410\u8412",5,"\u8419\u841A\u841B\u841E",5,"\u8429",7,"\u8432",5,"\u8439\u843A\u843B\u843E",7,"\u8447\u8448\u8449"],["c880","\u844A",6,"\u8452",4,"\u8458\u845D\u845E\u845F\u8460\u8462\u8464",4,"\u846A\u846E\u846F\u8470\u8472\u8474\u8477\u8479\u847B\u847C\u53D6\u5A36\u9F8B\u8DA3\u53BB\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u88D9\u7FA4\u7136\u71C3\u5189\u67D3\u74E4\u58E4\u6518\u56B7\u8BA9\u9976\u6270\u7ED5\u60F9\u70ED\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u6254\u4ECD\u65E5\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u63C9\u67D4\u8089\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u8F6F\u962E\u854A\u745E\u9510\u95F0\u6DA6\u82E5\u5F31\u6492\u6D12\u8428\u816E\u9CC3\u585E\u8D5B\u4E09\u53C1"],["c940","\u847D",4,"\u8483\u8484\u8485\u8486\u848A\u848D\u848F",7,"\u8498\u849A\u849B\u849D\u849E\u849F\u84A0\u84A2",12,"\u84B0\u84B1\u84B3\u84B5\u84B6\u84B7\u84BB\u84BC\u84BE\u84C0\u84C2\u84C3\u84C5\u84C6\u84C7\u84C8\u84CB\u84CC\u84CE\u84CF\u84D2\u84D4\u84D5\u84D7"],["c980","\u84D8",4,"\u84DE\u84E1\u84E2\u84E4\u84E7",4,"\u84ED\u84EE\u84EF\u84F1",10,"\u84FD\u84FE\u8500\u8501\u8502\u4F1E\u6563\u6851\u55D3\u4E27\u6414\u9A9A\u626B\u5AC2\u745F\u8272\u6DA9\u68EE\u50E7\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u7B5B\u6652\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u58F0\u751F\u7525\u7272\u5347\u7EF3"],["ca40","\u8503",8,"\u850D\u850E\u850F\u8510\u8512\u8514\u8515\u8516\u8518\u8519\u851B\u851C\u851D\u851E\u8520\u8522",8,"\u852D",9,"\u853E",4,"\u8544\u8545\u8546\u8547\u854B",10],["ca80","\u8557\u8558\u855A\u855B\u855C\u855D\u855F",4,"\u8565\u8566\u8567\u8569",8,"\u8573\u8575\u8576\u8577\u8578\u857C\u857D\u857F\u8580\u8581\u7701\u76DB\u5269\u80DC\u5723\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31"],["cb40","\u8582\u8583\u8586\u8588",6,"\u8590",10,"\u859D",6,"\u85A5\u85A6\u85A7\u85A9\u85AB\u85AC\u85AD\u85B1",5,"\u85B8\u85BA",6,"\u85C2",6,"\u85CA",4,"\u85D1\u85D2"],["cb80","\u85D4\u85D6",5,"\u85DD",6,"\u85E5\u85E6\u85E7\u85E8\u85EA",14,"\u6055\u5237\u800D\u6454\u8870\u7529\u5E05\u6813\u62F4\u971C\u53CC\u723D\u8C01\u6C34\u7761\u7A0E\u542E\u77AC\u987A\u821C\u8BF4\u7855\u6714\u70C1\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u641C\u8258\u64DE\u55FD\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u9178\u849C\u7B97\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u5B59\u635F\u7B0B\u84D1\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u584C\u4ED6\u5B83\u5979\u5854"],["cc40","\u85F9\u85FA\u85FC\u85FD\u85FE\u8600",4,"\u8606",10,"\u8612\u8613\u8614\u8615\u8617",15,"\u8628\u862A",13,"\u8639\u863A\u863B\u863D\u863E\u863F\u8640"],["cc80","\u8641",11,"\u8652\u8653\u8655",4,"\u865B\u865C\u865D\u865F\u8660\u8661\u8663",7,"\u736D\u631E\u8E4B\u8E0F\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u5018\u8EBA\u6DCC\u8D9F\u70EB\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u7279\u85E4\u817E\u75BC\u8A8A\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u6311\u6761\u8FE2\u773A\u8DF3\u8D34\u94C1\u5E16\u5385\u542C\u70C3"],["cd40","\u866D\u866F\u8670\u8672",6,"\u8683",6,"\u868E",4,"\u8694\u8696",5,"\u869E",4,"\u86A5\u86A6\u86AB\u86AD\u86AE\u86B2\u86B3\u86B7\u86B8\u86B9\u86BB",4,"\u86C1\u86C2\u86C3\u86C5\u86C8\u86CC\u86CD\u86D2\u86D3\u86D5\u86D6\u86D7\u86DA\u86DC"],["cd80","\u86DD\u86E0\u86E1\u86E2\u86E3\u86E5\u86E6\u86E7\u86E8\u86EA\u86EB\u86EC\u86EF\u86F5\u86F6\u86F7\u86FA\u86FB\u86FC\u86FD\u86FF\u8701\u8704\u8705\u8706\u870B\u870C\u870E\u870F\u8710\u8711\u8714\u8716\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u5077\u6295\u5934\u900F\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u6E4D\u56E2\u63A8\u9893\u817F\u8715\u892A\u9000\u541E\u5C6F\u81C0\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u6B6A\u5916\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u5A01"],["ce40","\u8719\u871B\u871D\u871F\u8720\u8724\u8726\u8727\u8728\u872A\u872B\u872C\u872D\u872F\u8730\u8732\u8733\u8735\u8736\u8738\u8739\u873A\u873C\u873D\u8740",6,"\u874A\u874B\u874D\u874F\u8750\u8751\u8752\u8754\u8755\u8756\u8758\u875A",5,"\u8761\u8762\u8766",7,"\u876F\u8771\u8772\u8773\u8775"],["ce80","\u8777\u8778\u8779\u877A\u877F\u8780\u8781\u8784\u8786\u8787\u8789\u878A\u878C\u878E",4,"\u8794\u8795\u8796\u8798",6,"\u87A0",4,"\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u55E1\u7FC1\u74EE\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A"],["cf40","\u87A5\u87A6\u87A7\u87A9\u87AA\u87AE\u87B0\u87B1\u87B2\u87B4\u87B6\u87B7\u87B8\u87B9\u87BB\u87BC\u87BE\u87BF\u87C1",4,"\u87C7\u87C8\u87C9\u87CC",4,"\u87D4",6,"\u87DC\u87DD\u87DE\u87DF\u87E1\u87E2\u87E3\u87E4\u87E6\u87E7\u87E8\u87E9\u87EB\u87EC\u87ED\u87EF",9],["cf80","\u87FA\u87FB\u87FC\u87FD\u87FF\u8800\u8801\u8802\u8804",5,"\u880B",7,"\u8814\u8817\u8818\u8819\u881A\u881C",4,"\u8823\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653"],["d040","\u8824",13,"\u8833",5,"\u883A\u883B\u883D\u883E\u883F\u8841\u8842\u8843\u8846",5,"\u884E",5,"\u8855\u8856\u8858\u885A",6,"\u8866\u8867\u886A\u886D\u886F\u8871\u8873\u8874\u8875\u8876\u8878\u8879\u887A"],["d080","\u887B\u887C\u8880\u8883\u8886\u8887\u8889\u888A\u888C\u888E\u888F\u8890\u8891\u8893\u8894\u8895\u8897",4,"\u889D",4,"\u88A3\u88A5",5,"\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384"],["d140","\u88AC\u88AE\u88AF\u88B0\u88B2",4,"\u88B8\u88B9\u88BA\u88BB\u88BD\u88BE\u88BF\u88C0\u88C3\u88C4\u88C7\u88C8\u88CA\u88CB\u88CC\u88CD\u88CF\u88D0\u88D1\u88D3\u88D6\u88D7\u88DA",4,"\u88E0\u88E1\u88E6\u88E7\u88E9",6,"\u88F2\u88F5\u88F6\u88F7\u88FA\u88FB\u88FD\u88FF\u8900\u8901\u8903",5],["d180","\u8909\u890B",4,"\u8911\u8914",4,"\u891C",4,"\u8922\u8923\u8924\u8926\u8927\u8928\u8929\u892C\u892D\u892E\u892F\u8931\u8932\u8933\u8935\u8937\u9009\u7663\u7729\u7EDA\u9774\u859B\u5B66\u7A74\u96EA\u8840\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u9080\u8170\u5996\u7476"],["d240","\u8938",8,"\u8942\u8943\u8945",24,"\u8960",5,"\u8967",19,"\u897C"],["d280","\u897D\u897E\u8980\u8982\u8984\u8985\u8987",26,"\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690"],["d340","\u89A2",30,"\u89C3\u89CD\u89D3\u89D4\u89D5\u89D7\u89D8\u89D9\u89DB\u89DD\u89DF\u89E0\u89E1\u89E2\u89E4\u89E7\u89E8\u89E9\u89EA\u89EC\u89ED\u89EE\u89F0\u89F1\u89F2\u89F4",6],["d380","\u89FB",4,"\u8A01",5,"\u8A08",21,"\u5370\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u54DF\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89"],["d440","\u8A1E",31,"\u8A3F",8,"\u8A49",21],["d480","\u8A5F",25,"\u8A7A",6,"\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u531D\u7838\u6742\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u6512\u6682\u8D5E\u8D43\u810F\u846C\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u8D23\u62E9\u5219\u6CFD\u8D3C\u600E\u589E\u618E\u66FE\u8D60\u624E\u55B3\u6E23\u672D\u8F67"],["d540","\u8A81",7,"\u8A8B",7,"\u8A94",46],["d580","\u8AC3",32,"\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F"],["d640","\u8AE4",34,"\u8B08",27],["d680","\u8B24\u8B25\u8B27",30,"\u5E27\u75C7\u90D1\u8BC1\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51"],["d740","\u8B46",31,"\u8B67",4,"\u8B6D",25],["d780","\u8B87",24,"\u8BAC\u8BB1\u8BBB\u8BC7\u8BD0\u8BEA\u8C09\u8C1E\u4F4F\u6CE8\u795D\u9A7B\u6293\u722A\u62FD\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8C06\u51C6\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u5544\u7740\u707C\u6D4A\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u90B9\u8D70\u594F\u63CD\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u94BB\u7E82\u5634\u9189\u6700\u7F6A\u5C0A\u9075\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7"],["d840","\u8C38",8,"\u8C42\u8C43\u8C44\u8C45\u8C48\u8C4A\u8C4B\u8C4D",7,"\u8C56\u8C57\u8C58\u8C59\u8C5B",5,"\u8C63",6,"\u8C6C",6,"\u8C74\u8C75\u8C76\u8C77\u8C7B",6,"\u8C83\u8C84\u8C86\u8C87"],["d880","\u8C88\u8C8B\u8C8D",6,"\u8C95\u8C96\u8C97\u8C99",20,"\u4E8D\u4E0C\u5140\u4E10\u5EFF\u5345\u4E15\u4E98\u4E1E\u9B32\u5B6C\u5669\u4E28\u79BA\u4E3F\u5315\u4E47\u592D\u723B\u536E\u6C10\u56DF\u80E4\u9997\u6BD3\u777E\u9F17\u4E36\u4E9F\u9F10\u4E5C\u4E69\u4E93\u8288\u5B5B\u556C\u560F\u4EC4\u538D\u539D\u53A3\u53A5\u53AE\u9765\u8D5D\u531A\u53F5\u5326\u532E\u533E\u8D5C\u5366\u5363\u5202\u5208\u520E\u522D\u5233\u523F\u5240\u524C\u525E\u5261\u525C\u84AF\u527D\u5282\u5281\u5290\u5293\u5182\u7F54\u4EBB\u4EC3\u4EC9\u4EC2\u4EE8\u4EE1\u4EEB\u4EDE\u4F1B\u4EF3\u4F22\u4F64\u4EF5\u4F25\u4F27\u4F09\u4F2B\u4F5E\u4F67\u6538\u4F5A\u4F5D"],["d940","\u8CAE",62],["d980","\u8CED",32,"\u4F5F\u4F57\u4F32\u4F3D\u4F76\u4F74\u4F91\u4F89\u4F83\u4F8F\u4F7E\u4F7B\u4FAA\u4F7C\u4FAC\u4F94\u4FE6\u4FE8\u4FEA\u4FC5\u4FDA\u4FE3\u4FDC\u4FD1\u4FDF\u4FF8\u5029\u504C\u4FF3\u502C\u500F\u502E\u502D\u4FFE\u501C\u500C\u5025\u5028\u507E\u5043\u5055\u5048\u504E\u506C\u507B\u50A5\u50A7\u50A9\u50BA\u50D6\u5106\u50ED\u50EC\u50E6\u50EE\u5107\u510B\u4EDD\u6C3D\u4F58\u4F65\u4FCE\u9FA0\u6C46\u7C74\u516E\u5DFD\u9EC9\u9998\u5181\u5914\u52F9\u530D\u8A07\u5310\u51EB\u5919\u5155\u4EA0\u5156\u4EB3\u886E\u88A4\u4EB5\u8114\u88D2\u7980\u5B34\u8803\u7FB8\u51AB\u51B1\u51BD\u51BC"],["da40","\u8D0E",14,"\u8D20\u8D51\u8D52\u8D57\u8D5F\u8D65\u8D68\u8D69\u8D6A\u8D6C\u8D6E\u8D6F\u8D71\u8D72\u8D78",8,"\u8D82\u8D83\u8D86\u8D87\u8D88\u8D89\u8D8C",4,"\u8D92\u8D93\u8D95",9,"\u8DA0\u8DA1"],["da80","\u8DA2\u8DA4",12,"\u8DB2\u8DB6\u8DB7\u8DB9\u8DBB\u8DBD\u8DC0\u8DC1\u8DC2\u8DC5\u8DC7\u8DC8\u8DC9\u8DCA\u8DCD\u8DD0\u8DD2\u8DD3\u8DD4\u51C7\u5196\u51A2\u51A5\u8BA0\u8BA6\u8BA7\u8BAA\u8BB4\u8BB5\u8BB7\u8BC2\u8BC3\u8BCB\u8BCF\u8BCE\u8BD2\u8BD3\u8BD4\u8BD6\u8BD8\u8BD9\u8BDC\u8BDF\u8BE0\u8BE4\u8BE8\u8BE9\u8BEE\u8BF0\u8BF3\u8BF6\u8BF9\u8BFC\u8BFF\u8C00\u8C02\u8C04\u8C07\u8C0C\u8C0F\u8C11\u8C12\u8C14\u8C15\u8C16\u8C19\u8C1B\u8C18\u8C1D\u8C1F\u8C20\u8C21\u8C25\u8C27\u8C2A\u8C2B\u8C2E\u8C2F\u8C32\u8C33\u8C35\u8C36\u5369\u537A\u961D\u9622\u9621\u9631\u962A\u963D\u963C\u9642\u9649\u9654\u965F\u9667\u966C\u9672\u9674\u9688\u968D\u9697\u96B0\u9097\u909B\u909D\u9099\u90AC\u90A1\u90B4\u90B3\u90B6\u90BA"],["db40","\u8DD5\u8DD8\u8DD9\u8DDC\u8DE0\u8DE1\u8DE2\u8DE5\u8DE6\u8DE7\u8DE9\u8DED\u8DEE\u8DF0\u8DF1\u8DF2\u8DF4\u8DF6\u8DFC\u8DFE",6,"\u8E06\u8E07\u8E08\u8E0B\u8E0D\u8E0E\u8E10\u8E11\u8E12\u8E13\u8E15",7,"\u8E20\u8E21\u8E24",4,"\u8E2B\u8E2D\u8E30\u8E32\u8E33\u8E34\u8E36\u8E37\u8E38\u8E3B\u8E3C\u8E3E"],["db80","\u8E3F\u8E43\u8E45\u8E46\u8E4C",4,"\u8E53",5,"\u8E5A",11,"\u8E67\u8E68\u8E6A\u8E6B\u8E6E\u8E71\u90B8\u90B0\u90CF\u90C5\u90BE\u90D0\u90C4\u90C7\u90D3\u90E6\u90E2\u90DC\u90D7\u90DB\u90EB\u90EF\u90FE\u9104\u9122\u911E\u9123\u9131\u912F\u9139\u9143\u9146\u520D\u5942\u52A2\u52AC\u52AD\u52BE\u54FF\u52D0\u52D6\u52F0\u53DF\u71EE\u77CD\u5EF4\u51F5\u51FC\u9B2F\u53B6\u5F01\u755A\u5DEF\u574C\u57A9\u57A1\u587E\u58BC\u58C5\u58D1\u5729\u572C\u572A\u5733\u5739\u572E\u572F\u575C\u573B\u5742\u5769\u5785\u576B\u5786\u577C\u577B\u5768\u576D\u5776\u5773\u57AD\u57A4\u578C\u57B2\u57CF\u57A7\u57B4\u5793\u57A0\u57D5\u57D8\u57DA\u57D9\u57D2\u57B8\u57F4\u57EF\u57F8\u57E4\u57DD"],["dc40","\u8E73\u8E75\u8E77",4,"\u8E7D\u8E7E\u8E80\u8E82\u8E83\u8E84\u8E86\u8E88",6,"\u8E91\u8E92\u8E93\u8E95",6,"\u8E9D\u8E9F",11,"\u8EAD\u8EAE\u8EB0\u8EB1\u8EB3",6,"\u8EBB",7],["dc80","\u8EC3",10,"\u8ECF",21,"\u580B\u580D\u57FD\u57ED\u5800\u581E\u5819\u5844\u5820\u5865\u586C\u5881\u5889\u589A\u5880\u99A8\u9F19\u61FF\u8279\u827D\u827F\u828F\u828A\u82A8\u8284\u828E\u8291\u8297\u8299\u82AB\u82B8\u82BE\u82B0\u82C8\u82CA\u82E3\u8298\u82B7\u82AE\u82CB\u82CC\u82C1\u82A9\u82B4\u82A1\u82AA\u829F\u82C4\u82CE\u82A4\u82E1\u8309\u82F7\u82E4\u830F\u8307\u82DC\u82F4\u82D2\u82D8\u830C\u82FB\u82D3\u8311\u831A\u8306\u8314\u8315\u82E0\u82D5\u831C\u8351\u835B\u835C\u8308\u8392\u833C\u8334\u8331\u839B\u835E\u832F\u834F\u8347\u8343\u835F\u8340\u8317\u8360\u832D\u833A\u8333\u8366\u8365"],["dd40","\u8EE5",62],["dd80","\u8F24",32,"\u8368\u831B\u8369\u836C\u836A\u836D\u836E\u83B0\u8378\u83B3\u83B4\u83A0\u83AA\u8393\u839C\u8385\u837C\u83B6\u83A9\u837D\u83B8\u837B\u8398\u839E\u83A8\u83BA\u83BC\u83C1\u8401\u83E5\u83D8\u5807\u8418\u840B\u83DD\u83FD\u83D6\u841C\u8438\u8411\u8406\u83D4\u83DF\u840F\u8403\u83F8\u83F9\u83EA\u83C5\u83C0\u8426\u83F0\u83E1\u845C\u8451\u845A\u8459\u8473\u8487\u8488\u847A\u8489\u8478\u843C\u8446\u8469\u8476\u848C\u848E\u8431\u846D\u84C1\u84CD\u84D0\u84E6\u84BD\u84D3\u84CA\u84BF\u84BA\u84E0\u84A1\u84B9\u84B4\u8497\u84E5\u84E3\u850C\u750D\u8538\u84F0\u8539\u851F\u853A"],["de40","\u8F45",32,"\u8F6A\u8F80\u8F8C\u8F92\u8F9D\u8FA0\u8FA1\u8FA2\u8FA4\u8FA5\u8FA6\u8FA7\u8FAA\u8FAC\u8FAD\u8FAE\u8FAF\u8FB2\u8FB3\u8FB4\u8FB5\u8FB7\u8FB8\u8FBA\u8FBB\u8FBC\u8FBF\u8FC0\u8FC3\u8FC6"],["de80","\u8FC9",4,"\u8FCF\u8FD2\u8FD6\u8FD7\u8FDA\u8FE0\u8FE1\u8FE3\u8FE7\u8FEC\u8FEF\u8FF1\u8FF2\u8FF4\u8FF5\u8FF6\u8FFA\u8FFB\u8FFC\u8FFE\u8FFF\u9007\u9008\u900C\u900E\u9013\u9015\u9018\u8556\u853B\u84FF\u84FC\u8559\u8548\u8568\u8564\u855E\u857A\u77A2\u8543\u8572\u857B\u85A4\u85A8\u8587\u858F\u8579\u85AE\u859C\u8585\u85B9\u85B7\u85B0\u85D3\u85C1\u85DC\u85FF\u8627\u8605\u8629\u8616\u863C\u5EFE\u5F08\u593C\u5941\u8037\u5955\u595A\u5958\u530F\u5C22\u5C25\u5C2C\u5C34\u624C\u626A\u629F\u62BB\u62CA\u62DA\u62D7\u62EE\u6322\u62F6\u6339\u634B\u6343\u63AD\u63F6\u6371\u637A\u638E\u63B4\u636D\u63AC\u638A\u6369\u63AE\u63BC\u63F2\u63F8\u63E0\u63FF\u63C4\u63DE\u63CE\u6452\u63C6\u63BE\u6445\u6441\u640B\u641B\u6420\u640C\u6426\u6421\u645E\u6484\u646D\u6496"],["df40","\u9019\u901C\u9023\u9024\u9025\u9027",5,"\u9030",4,"\u9037\u9039\u903A\u903D\u903F\u9040\u9043\u9045\u9046\u9048",4,"\u904E\u9054\u9055\u9056\u9059\u905A\u905C",5,"\u9064\u9066\u9067\u9069\u906A\u906B\u906C\u906F",4,"\u9076",6,"\u907E\u9081"],["df80","\u9084\u9085\u9086\u9087\u9089\u908A\u908C",4,"\u9092\u9094\u9096\u9098\u909A\u909C\u909E\u909F\u90A0\u90A4\u90A5\u90A7\u90A8\u90A9\u90AB\u90AD\u90B2\u90B7\u90BC\u90BD\u90BF\u90C0\u647A\u64B7\u64B8\u6499\u64BA\u64C0\u64D0\u64D7\u64E4\u64E2\u6509\u6525\u652E\u5F0B\u5FD2\u7519\u5F11\u535F\u53F1\u53FD\u53E9\u53E8\u53FB\u5412\u5416\u5406\u544B\u5452\u5453\u5454\u5456\u5443\u5421\u5457\u5459\u5423\u5432\u5482\u5494\u5477\u5471\u5464\u549A\u549B\u5484\u5476\u5466\u549D\u54D0\u54AD\u54C2\u54B4\u54D2\u54A7\u54A6\u54D3\u54D4\u5472\u54A3\u54D5\u54BB\u54BF\u54CC\u54D9\u54DA\u54DC\u54A9\u54AA\u54A4\u54DD\u54CF\u54DE\u551B\u54E7\u5520\u54FD\u5514\u54F3\u5522\u5523\u550F\u5511\u5527\u552A\u5567\u558F\u55B5\u5549\u556D\u5541\u5555\u553F\u5550\u553C"],["e040","\u90C2\u90C3\u90C6\u90C8\u90C9\u90CB\u90CC\u90CD\u90D2\u90D4\u90D5\u90D6\u90D8\u90D9\u90DA\u90DE\u90DF\u90E0\u90E3\u90E4\u90E5\u90E9\u90EA\u90EC\u90EE\u90F0\u90F1\u90F2\u90F3\u90F5\u90F6\u90F7\u90F9\u90FA\u90FB\u90FC\u90FF\u9100\u9101\u9103\u9105",19,"\u911A\u911B\u911C"],["e080","\u911D\u911F\u9120\u9121\u9124",10,"\u9130\u9132",6,"\u913A",8,"\u9144\u5537\u5556\u5575\u5576\u5577\u5533\u5530\u555C\u558B\u55D2\u5583\u55B1\u55B9\u5588\u5581\u559F\u557E\u55D6\u5591\u557B\u55DF\u55BD\u55BE\u5594\u5599\u55EA\u55F7\u55C9\u561F\u55D1\u55EB\u55EC\u55D4\u55E6\u55DD\u55C4\u55EF\u55E5\u55F2\u55F3\u55CC\u55CD\u55E8\u55F5\u55E4\u8F94\u561E\u5608\u560C\u5601\u5624\u5623\u55FE\u5600\u5627\u562D\u5658\u5639\u5657\u562C\u564D\u5662\u5659\u565C\u564C\u5654\u5686\u5664\u5671\u566B\u567B\u567C\u5685\u5693\u56AF\u56D4\u56D7\u56DD\u56E1\u56F5\u56EB\u56F9\u56FF\u5704\u570A\u5709\u571C\u5E0F\u5E19\u5E14\u5E11\u5E31\u5E3B\u5E3C"],["e140","\u9145\u9147\u9148\u9151\u9153\u9154\u9155\u9156\u9158\u9159\u915B\u915C\u915F\u9160\u9166\u9167\u9168\u916B\u916D\u9173\u917A\u917B\u917C\u9180",4,"\u9186\u9188\u918A\u918E\u918F\u9193",6,"\u919C",5,"\u91A4",5,"\u91AB\u91AC\u91B0\u91B1\u91B2\u91B3\u91B6\u91B7\u91B8\u91B9\u91BB"],["e180","\u91BC",10,"\u91C8\u91CB\u91D0\u91D2",9,"\u91DD",8,"\u5E37\u5E44\u5E54\u5E5B\u5E5E\u5E61\u5C8C\u5C7A\u5C8D\u5C90\u5C96\u5C88\u5C98\u5C99\u5C91\u5C9A\u5C9C\u5CB5\u5CA2\u5CBD\u5CAC\u5CAB\u5CB1\u5CA3\u5CC1\u5CB7\u5CC4\u5CD2\u5CE4\u5CCB\u5CE5\u5D02\u5D03\u5D27\u5D26\u5D2E\u5D24\u5D1E\u5D06\u5D1B\u5D58\u5D3E\u5D34\u5D3D\u5D6C\u5D5B\u5D6F\u5D5D\u5D6B\u5D4B\u5D4A\u5D69\u5D74\u5D82\u5D99\u5D9D\u8C73\u5DB7\u5DC5\u5F73\u5F77\u5F82\u5F87\u5F89\u5F8C\u5F95\u5F99\u5F9C\u5FA8\u5FAD\u5FB5\u5FBC\u8862\u5F61\u72AD\u72B0\u72B4\u72B7\u72B8\u72C3\u72C1\u72CE\u72CD\u72D2\u72E8\u72EF\u72E9\u72F2\u72F4\u72F7\u7301\u72F3\u7303\u72FA"],["e240","\u91E6",62],["e280","\u9225",32,"\u72FB\u7317\u7313\u7321\u730A\u731E\u731D\u7315\u7322\u7339\u7325\u732C\u7338\u7331\u7350\u734D\u7357\u7360\u736C\u736F\u737E\u821B\u5925\u98E7\u5924\u5902\u9963\u9967",5,"\u9974\u9977\u997D\u9980\u9984\u9987\u998A\u998D\u9990\u9991\u9993\u9994\u9995\u5E80\u5E91\u5E8B\u5E96\u5EA5\u5EA0\u5EB9\u5EB5\u5EBE\u5EB3\u8D53\u5ED2\u5ED1\u5EDB\u5EE8\u5EEA\u81BA\u5FC4\u5FC9\u5FD6\u5FCF\u6003\u5FEE\u6004\u5FE1\u5FE4\u5FFE\u6005\u6006\u5FEA\u5FED\u5FF8\u6019\u6035\u6026\u601B\u600F\u600D\u6029\u602B\u600A\u603F\u6021\u6078\u6079\u607B\u607A\u6042"],["e340","\u9246",45,"\u9275",16],["e380","\u9286",7,"\u928F",24,"\u606A\u607D\u6096\u609A\u60AD\u609D\u6083\u6092\u608C\u609B\u60EC\u60BB\u60B1\u60DD\u60D8\u60C6\u60DA\u60B4\u6120\u6126\u6115\u6123\u60F4\u6100\u610E\u612B\u614A\u6175\u61AC\u6194\u61A7\u61B7\u61D4\u61F5\u5FDD\u96B3\u95E9\u95EB\u95F1\u95F3\u95F5\u95F6\u95FC\u95FE\u9603\u9604\u9606\u9608\u960A\u960B\u960C\u960D\u960F\u9612\u9615\u9616\u9617\u9619\u961A\u4E2C\u723F\u6215\u6C35\u6C54\u6C5C\u6C4A\u6CA3\u6C85\u6C90\u6C94\u6C8C\u6C68\u6C69\u6C74\u6C76\u6C86\u6CA9\u6CD0\u6CD4\u6CAD\u6CF7\u6CF8\u6CF1\u6CD7\u6CB2\u6CE0\u6CD6\u6CFA\u6CEB\u6CEE\u6CB1\u6CD3\u6CEF\u6CFE"],["e440","\u92A8",5,"\u92AF",24,"\u92C9",31],["e480","\u92E9",32,"\u6D39\u6D27\u6D0C\u6D43\u6D48\u6D07\u6D04\u6D19\u6D0E\u6D2B\u6D4D\u6D2E\u6D35\u6D1A\u6D4F\u6D52\u6D54\u6D33\u6D91\u6D6F\u6D9E\u6DA0\u6D5E\u6D93\u6D94\u6D5C\u6D60\u6D7C\u6D63\u6E1A\u6DC7\u6DC5\u6DDE\u6E0E\u6DBF\u6DE0\u6E11\u6DE6\u6DDD\u6DD9\u6E16\u6DAB\u6E0C\u6DAE\u6E2B\u6E6E\u6E4E\u6E6B\u6EB2\u6E5F\u6E86\u6E53\u6E54\u6E32\u6E25\u6E44\u6EDF\u6EB1\u6E98\u6EE0\u6F2D\u6EE2\u6EA5\u6EA7\u6EBD\u6EBB\u6EB7\u6ED7\u6EB4\u6ECF\u6E8F\u6EC2\u6E9F\u6F62\u6F46\u6F47\u6F24\u6F15\u6EF9\u6F2F\u6F36\u6F4B\u6F74\u6F2A\u6F09\u6F29\u6F89\u6F8D\u6F8C\u6F78\u6F72\u6F7C\u6F7A\u6FD1"],["e540","\u930A",51,"\u933F",10],["e580","\u934A",31,"\u936B\u6FC9\u6FA7\u6FB9\u6FB6\u6FC2\u6FE1\u6FEE\u6FDE\u6FE0\u6FEF\u701A\u7023\u701B\u7039\u7035\u704F\u705E\u5B80\u5B84\u5B95\u5B93\u5BA5\u5BB8\u752F\u9A9E\u6434\u5BE4\u5BEE\u8930\u5BF0\u8E47\u8B07\u8FB6\u8FD3\u8FD5\u8FE5\u8FEE\u8FE4\u8FE9\u8FE6\u8FF3\u8FE8\u9005\u9004\u900B\u9026\u9011\u900D\u9016\u9021\u9035\u9036\u902D\u902F\u9044\u9051\u9052\u9050\u9068\u9058\u9062\u905B\u66B9\u9074\u907D\u9082\u9088\u9083\u908B\u5F50\u5F57\u5F56\u5F58\u5C3B\u54AB\u5C50\u5C59\u5B71\u5C63\u5C66\u7FBC\u5F2A\u5F29\u5F2D\u8274\u5F3C\u9B3B\u5C6E\u5981\u5983\u598D\u59A9\u59AA\u59A3"],["e640","\u936C",34,"\u9390",27],["e680","\u93AC",29,"\u93CB\u93CC\u93CD\u5997\u59CA\u59AB\u599E\u59A4\u59D2\u59B2\u59AF\u59D7\u59BE\u5A05\u5A06\u59DD\u5A08\u59E3\u59D8\u59F9\u5A0C\u5A09\u5A32\u5A34\u5A11\u5A23\u5A13\u5A40\u5A67\u5A4A\u5A55\u5A3C\u5A62\u5A75\u80EC\u5AAA\u5A9B\u5A77\u5A7A\u5ABE\u5AEB\u5AB2\u5AD2\u5AD4\u5AB8\u5AE0\u5AE3\u5AF1\u5AD6\u5AE6\u5AD8\u5ADC\u5B09\u5B17\u5B16\u5B32\u5B37\u5B40\u5C15\u5C1C\u5B5A\u5B65\u5B73\u5B51\u5B53\u5B62\u9A75\u9A77\u9A78\u9A7A\u9A7F\u9A7D\u9A80\u9A81\u9A85\u9A88\u9A8A\u9A90\u9A92\u9A93\u9A96\u9A98\u9A9B\u9A9C\u9A9D\u9A9F\u9AA0\u9AA2\u9AA3\u9AA5\u9AA7\u7E9F\u7EA1\u7EA3\u7EA5\u7EA8\u7EA9"],["e740","\u93CE",7,"\u93D7",54],["e780","\u940E",32,"\u7EAD\u7EB0\u7EBE\u7EC0\u7EC1\u7EC2\u7EC9\u7ECB\u7ECC\u7ED0\u7ED4\u7ED7\u7EDB\u7EE0\u7EE1\u7EE8\u7EEB\u7EEE\u7EEF\u7EF1\u7EF2\u7F0D\u7EF6\u7EFA\u7EFB\u7EFE\u7F01\u7F02\u7F03\u7F07\u7F08\u7F0B\u7F0C\u7F0F\u7F11\u7F12\u7F17\u7F19\u7F1C\u7F1B\u7F1F\u7F21",6,"\u7F2A\u7F2B\u7F2C\u7F2D\u7F2F",4,"\u7F35\u5E7A\u757F\u5DDB\u753E\u9095\u738E\u7391\u73AE\u73A2\u739F\u73CF\u73C2\u73D1\u73B7\u73B3\u73C0\u73C9\u73C8\u73E5\u73D9\u987C\u740A\u73E9\u73E7\u73DE\u73BA\u73F2\u740F\u742A\u745B\u7426\u7425\u7428\u7430\u742E\u742C"],["e840","\u942F",14,"\u943F",43,"\u946C\u946D\u946E\u946F"],["e880","\u9470",20,"\u9491\u9496\u9498\u94C7\u94CF\u94D3\u94D4\u94DA\u94E6\u94FB\u951C\u9520\u741B\u741A\u7441\u745C\u7457\u7455\u7459\u7477\u746D\u747E\u749C\u748E\u7480\u7481\u7487\u748B\u749E\u74A8\u74A9\u7490\u74A7\u74D2\u74BA\u97EA\u97EB\u97EC\u674C\u6753\u675E\u6748\u6769\u67A5\u6787\u676A\u6773\u6798\u67A7\u6775\u67A8\u679E\u67AD\u678B\u6777\u677C\u67F0\u6809\u67D8\u680A\u67E9\u67B0\u680C\u67D9\u67B5\u67DA\u67B3\u67DD\u6800\u67C3\u67B8\u67E2\u680E\u67C1\u67FD\u6832\u6833\u6860\u6861\u684E\u6862\u6844\u6864\u6883\u681D\u6855\u6866\u6841\u6867\u6840\u683E\u684A\u6849\u6829\u68B5\u688F\u6874\u6877\u6893\u686B\u68C2\u696E\u68FC\u691F\u6920\u68F9"],["e940","\u9527\u9533\u953D\u9543\u9548\u954B\u9555\u955A\u9560\u956E\u9574\u9575\u9577",7,"\u9580",42],["e980","\u95AB",32,"\u6924\u68F0\u690B\u6901\u6957\u68E3\u6910\u6971\u6939\u6960\u6942\u695D\u6984\u696B\u6980\u6998\u6978\u6934\u69CC\u6987\u6988\u69CE\u6989\u6966\u6963\u6979\u699B\u69A7\u69BB\u69AB\u69AD\u69D4\u69B1\u69C1\u69CA\u69DF\u6995\u69E0\u698D\u69FF\u6A2F\u69ED\u6A17\u6A18\u6A65\u69F2\u6A44\u6A3E\u6AA0\u6A50\u6A5B\u6A35\u6A8E\u6A79\u6A3D\u6A28\u6A58\u6A7C\u6A91\u6A90\u6AA9\u6A97\u6AAB\u7337\u7352\u6B81\u6B82\u6B87\u6B84\u6B92\u6B93\u6B8D\u6B9A\u6B9B\u6BA1\u6BAA\u8F6B\u8F6D\u8F71\u8F72\u8F73\u8F75\u8F76\u8F78\u8F77\u8F79\u8F7A\u8F7C\u8F7E\u8F81\u8F82\u8F84\u8F87\u8F8B"],["ea40","\u95CC",27,"\u95EC\u95FF\u9607\u9613\u9618\u961B\u961E\u9620\u9623",6,"\u962B\u962C\u962D\u962F\u9630\u9637\u9638\u9639\u963A\u963E\u9641\u9643\u964A\u964E\u964F\u9651\u9652\u9653\u9656\u9657"],["ea80","\u9658\u9659\u965A\u965C\u965D\u965E\u9660\u9663\u9665\u9666\u966B\u966D",4,"\u9673\u9678",12,"\u9687\u9689\u968A\u8F8D\u8F8E\u8F8F\u8F98\u8F9A\u8ECE\u620B\u6217\u621B\u621F\u6222\u6221\u6225\u6224\u622C\u81E7\u74EF\u74F4\u74FF\u750F\u7511\u7513\u6534\u65EE\u65EF\u65F0\u660A\u6619\u6772\u6603\u6615\u6600\u7085\u66F7\u661D\u6634\u6631\u6636\u6635\u8006\u665F\u6654\u6641\u664F\u6656\u6661\u6657\u6677\u6684\u668C\u66A7\u669D\u66BE\u66DB\u66DC\u66E6\u66E9\u8D32\u8D33\u8D36\u8D3B\u8D3D\u8D40\u8D45\u8D46\u8D48\u8D49\u8D47\u8D4D\u8D55\u8D59\u89C7\u89CA\u89CB\u89CC\u89CE\u89CF\u89D0\u89D1\u726E\u729F\u725D\u7266\u726F\u727E\u727F\u7284\u728B\u728D\u728F\u7292\u6308\u6332\u63B0"],["eb40","\u968C\u968E\u9691\u9692\u9693\u9695\u9696\u969A\u969B\u969D",9,"\u96A8",7,"\u96B1\u96B2\u96B4\u96B5\u96B7\u96B8\u96BA\u96BB\u96BF\u96C2\u96C3\u96C8\u96CA\u96CB\u96D0\u96D1\u96D3\u96D4\u96D6",9,"\u96E1",6,"\u96EB"],["eb80","\u96EC\u96ED\u96EE\u96F0\u96F1\u96F2\u96F4\u96F5\u96F8\u96FA\u96FB\u96FC\u96FD\u96FF\u9702\u9703\u9705\u970A\u970B\u970C\u9710\u9711\u9712\u9714\u9715\u9717",4,"\u971D\u971F\u9720\u643F\u64D8\u8004\u6BEA\u6BF3\u6BFD\u6BF5\u6BF9\u6C05\u6C07\u6C06\u6C0D\u6C15\u6C18\u6C19\u6C1A\u6C21\u6C29\u6C24\u6C2A\u6C32\u6535\u6555\u656B\u724D\u7252\u7256\u7230\u8662\u5216\u809F\u809C\u8093\u80BC\u670A\u80BD\u80B1\u80AB\u80AD\u80B4\u80B7\u80E7\u80E8\u80E9\u80EA\u80DB\u80C2\u80C4\u80D9\u80CD\u80D7\u6710\u80DD\u80EB\u80F1\u80F4\u80ED\u810D\u810E\u80F2\u80FC\u6715\u8112\u8C5A\u8136\u811E\u812C\u8118\u8132\u8148\u814C\u8153\u8174\u8159\u815A\u8171\u8160\u8169\u817C\u817D\u816D\u8167\u584D\u5AB5\u8188\u8182\u8191\u6ED5\u81A3\u81AA\u81CC\u6726\u81CA\u81BB"],["ec40","\u9721",8,"\u972B\u972C\u972E\u972F\u9731\u9733",4,"\u973A\u973B\u973C\u973D\u973F",18,"\u9754\u9755\u9757\u9758\u975A\u975C\u975D\u975F\u9763\u9764\u9766\u9767\u9768\u976A",7],["ec80","\u9772\u9775\u9777",4,"\u977D",7,"\u9786",4,"\u978C\u978E\u978F\u9790\u9793\u9795\u9796\u9797\u9799",4,"\u81C1\u81A6\u6B24\u6B37\u6B39\u6B43\u6B46\u6B59\u98D1\u98D2\u98D3\u98D5\u98D9\u98DA\u6BB3\u5F40\u6BC2\u89F3\u6590\u9F51\u6593\u65BC\u65C6\u65C4\u65C3\u65CC\u65CE\u65D2\u65D6\u7080\u709C\u7096\u709D\u70BB\u70C0\u70B7\u70AB\u70B1\u70E8\u70CA\u7110\u7113\u7116\u712F\u7131\u7173\u715C\u7168\u7145\u7172\u714A\u7178\u717A\u7198\u71B3\u71B5\u71A8\u71A0\u71E0\u71D4\u71E7\u71F9\u721D\u7228\u706C\u7118\u7166\u71B9\u623E\u623D\u6243\u6248\u6249\u793B\u7940\u7946\u7949\u795B\u795C\u7953\u795A\u7962\u7957\u7960\u796F\u7967\u797A\u7985\u798A\u799A\u79A7\u79B3\u5FD1\u5FD0"],["ed40","\u979E\u979F\u97A1\u97A2\u97A4",6,"\u97AC\u97AE\u97B0\u97B1\u97B3\u97B5",46],["ed80","\u97E4\u97E5\u97E8\u97EE",4,"\u97F4\u97F7",23,"\u603C\u605D\u605A\u6067\u6041\u6059\u6063\u60AB\u6106\u610D\u615D\u61A9\u619D\u61CB\u61D1\u6206\u8080\u807F\u6C93\u6CF6\u6DFC\u77F6\u77F8\u7800\u7809\u7817\u7818\u7811\u65AB\u782D\u781C\u781D\u7839\u783A\u783B\u781F\u783C\u7825\u782C\u7823\u7829\u784E\u786D\u7856\u7857\u7826\u7850\u7847\u784C\u786A\u789B\u7893\u789A\u7887\u789C\u78A1\u78A3\u78B2\u78B9\u78A5\u78D4\u78D9\u78C9\u78EC\u78F2\u7905\u78F4\u7913\u7924\u791E\u7934\u9F9B\u9EF9\u9EFB\u9EFC\u76F1\u7704\u770D\u76F9\u7707\u7708\u771A\u7722\u7719\u772D\u7726\u7735\u7738\u7750\u7751\u7747\u7743\u775A\u7768"],["ee40","\u980F",62],["ee80","\u984E",32,"\u7762\u7765\u777F\u778D\u777D\u7780\u778C\u7791\u779F\u77A0\u77B0\u77B5\u77BD\u753A\u7540\u754E\u754B\u7548\u755B\u7572\u7579\u7583\u7F58\u7F61\u7F5F\u8A48\u7F68\u7F74\u7F71\u7F79\u7F81\u7F7E\u76CD\u76E5\u8832\u9485\u9486\u9487\u948B\u948A\u948C\u948D\u948F\u9490\u9494\u9497\u9495\u949A\u949B\u949C\u94A3\u94A4\u94AB\u94AA\u94AD\u94AC\u94AF\u94B0\u94B2\u94B4\u94B6",4,"\u94BC\u94BD\u94BF\u94C4\u94C8",6,"\u94D0\u94D1\u94D2\u94D5\u94D6\u94D7\u94D9\u94D8\u94DB\u94DE\u94DF\u94E0\u94E2\u94E4\u94E5\u94E7\u94E8\u94EA"],["ef40","\u986F",5,"\u988B\u988E\u9892\u9895\u9899\u98A3\u98A8",37,"\u98CF\u98D0\u98D4\u98D6\u98D7\u98DB\u98DC\u98DD\u98E0",4],["ef80","\u98E5\u98E6\u98E9",30,"\u94E9\u94EB\u94EE\u94EF\u94F3\u94F4\u94F5\u94F7\u94F9\u94FC\u94FD\u94FF\u9503\u9502\u9506\u9507\u9509\u950A\u950D\u950E\u950F\u9512",4,"\u9518\u951B\u951D\u951E\u951F\u9522\u952A\u952B\u9529\u952C\u9531\u9532\u9534\u9536\u9537\u9538\u953C\u953E\u953F\u9542\u9535\u9544\u9545\u9546\u9549\u954C\u954E\u954F\u9552\u9553\u9554\u9556\u9557\u9558\u9559\u955B\u955E\u955F\u955D\u9561\u9562\u9564",8,"\u956F\u9571\u9572\u9573\u953A\u77E7\u77EC\u96C9\u79D5\u79ED\u79E3\u79EB\u7A06\u5D47\u7A03\u7A02\u7A1E\u7A14"],["f040","\u9908",4,"\u990E\u990F\u9911",28,"\u992F",26],["f080","\u994A",9,"\u9956",12,"\u9964\u9966\u9973\u9978\u9979\u997B\u997E\u9982\u9983\u9989\u7A39\u7A37\u7A51\u9ECF\u99A5\u7A70\u7688\u768E\u7693\u7699\u76A4\u74DE\u74E0\u752C\u9E20\u9E22\u9E28",4,"\u9E32\u9E31\u9E36\u9E38\u9E37\u9E39\u9E3A\u9E3E\u9E41\u9E42\u9E44\u9E46\u9E47\u9E48\u9E49\u9E4B\u9E4C\u9E4E\u9E51\u9E55\u9E57\u9E5A\u9E5B\u9E5C\u9E5E\u9E63\u9E66",6,"\u9E71\u9E6D\u9E73\u7592\u7594\u7596\u75A0\u759D\u75AC\u75A3\u75B3\u75B4\u75B8\u75C4\u75B1\u75B0\u75C3\u75C2\u75D6\u75CD\u75E3\u75E8\u75E6\u75E4\u75EB\u75E7\u7603\u75F1\u75FC\u75FF\u7610\u7600\u7605\u760C\u7617\u760A\u7625\u7618\u7615\u7619"],["f140","\u998C\u998E\u999A",10,"\u99A6\u99A7\u99A9",47],["f180","\u99D9",32,"\u761B\u763C\u7622\u7620\u7640\u762D\u7630\u763F\u7635\u7643\u763E\u7633\u764D\u765E\u7654\u765C\u7656\u766B\u766F\u7FCA\u7AE6\u7A78\u7A79\u7A80\u7A86\u7A88\u7A95\u7AA6\u7AA0\u7AAC\u7AA8\u7AAD\u7AB3\u8864\u8869\u8872\u887D\u887F\u8882\u88A2\u88C6\u88B7\u88BC\u88C9\u88E2\u88CE\u88E3\u88E5\u88F1\u891A\u88FC\u88E8\u88FE\u88F0\u8921\u8919\u8913\u891B\u890A\u8934\u892B\u8936\u8941\u8966\u897B\u758B\u80E5\u76B2\u76B4\u77DC\u8012\u8014\u8016\u801C\u8020\u8022\u8025\u8026\u8027\u8029\u8028\u8031\u800B\u8035\u8043\u8046\u804D\u8052\u8069\u8071\u8983\u9878\u9880\u9883"],["f240","\u99FA",62],["f280","\u9A39",32,"\u9889\u988C\u988D\u988F\u9894\u989A\u989B\u989E\u989F\u98A1\u98A2\u98A5\u98A6\u864D\u8654\u866C\u866E\u867F\u867A\u867C\u867B\u86A8\u868D\u868B\u86AC\u869D\u86A7\u86A3\u86AA\u8693\u86A9\u86B6\u86C4\u86B5\u86CE\u86B0\u86BA\u86B1\u86AF\u86C9\u86CF\u86B4\u86E9\u86F1\u86F2\u86ED\u86F3\u86D0\u8713\u86DE\u86F4\u86DF\u86D8\u86D1\u8703\u8707\u86F8\u8708\u870A\u870D\u8709\u8723\u873B\u871E\u8725\u872E\u871A\u873E\u8748\u8734\u8731\u8729\u8737\u873F\u8782\u8722\u877D\u877E\u877B\u8760\u8770\u874C\u876E\u878B\u8753\u8763\u877C\u8764\u8759\u8765\u8793\u87AF\u87A8\u87D2"],["f340","\u9A5A",17,"\u9A72\u9A83\u9A89\u9A8D\u9A8E\u9A94\u9A95\u9A99\u9AA6\u9AA9",6,"\u9AB2\u9AB3\u9AB4\u9AB5\u9AB9\u9ABB\u9ABD\u9ABE\u9ABF\u9AC3\u9AC4\u9AC6",4,"\u9ACD\u9ACE\u9ACF\u9AD0\u9AD2\u9AD4\u9AD5\u9AD6\u9AD7\u9AD9\u9ADA\u9ADB\u9ADC"],["f380","\u9ADD\u9ADE\u9AE0\u9AE2\u9AE3\u9AE4\u9AE5\u9AE7\u9AE8\u9AE9\u9AEA\u9AEC\u9AEE\u9AF0",8,"\u9AFA\u9AFC",6,"\u9B04\u9B05\u9B06\u87C6\u8788\u8785\u87AD\u8797\u8783\u87AB\u87E5\u87AC\u87B5\u87B3\u87CB\u87D3\u87BD\u87D1\u87C0\u87CA\u87DB\u87EA\u87E0\u87EE\u8816\u8813\u87FE\u880A\u881B\u8821\u8839\u883C\u7F36\u7F42\u7F44\u7F45\u8210\u7AFA\u7AFD\u7B08\u7B03\u7B04\u7B15\u7B0A\u7B2B\u7B0F\u7B47\u7B38\u7B2A\u7B19\u7B2E\u7B31\u7B20\u7B25\u7B24\u7B33\u7B3E\u7B1E\u7B58\u7B5A\u7B45\u7B75\u7B4C\u7B5D\u7B60\u7B6E\u7B7B\u7B62\u7B72\u7B71\u7B90\u7BA6\u7BA7\u7BB8\u7BAC\u7B9D\u7BA8\u7B85\u7BAA\u7B9C\u7BA2\u7BAB\u7BB4\u7BD1\u7BC1\u7BCC\u7BDD\u7BDA\u7BE5\u7BE6\u7BEA\u7C0C\u7BFE\u7BFC\u7C0F\u7C16\u7C0B"],["f440","\u9B07\u9B09",5,"\u9B10\u9B11\u9B12\u9B14",10,"\u9B20\u9B21\u9B22\u9B24",10,"\u9B30\u9B31\u9B33",7,"\u9B3D\u9B3E\u9B3F\u9B40\u9B46\u9B4A\u9B4B\u9B4C\u9B4E\u9B50\u9B52\u9B53\u9B55",5],["f480","\u9B5B",32,"\u7C1F\u7C2A\u7C26\u7C38\u7C41\u7C40\u81FE\u8201\u8202\u8204\u81EC\u8844\u8221\u8222\u8223\u822D\u822F\u8228\u822B\u8238\u823B\u8233\u8234\u823E\u8244\u8249\u824B\u824F\u825A\u825F\u8268\u887E\u8885\u8888\u88D8\u88DF\u895E\u7F9D\u7F9F\u7FA7\u7FAF\u7FB0\u7FB2\u7C7C\u6549\u7C91\u7C9D\u7C9C\u7C9E\u7CA2\u7CB2\u7CBC\u7CBD\u7CC1\u7CC7\u7CCC\u7CCD\u7CC8\u7CC5\u7CD7\u7CE8\u826E\u66A8\u7FBF\u7FCE\u7FD5\u7FE5\u7FE1\u7FE6\u7FE9\u7FEE\u7FF3\u7CF8\u7D77\u7DA6\u7DAE\u7E47\u7E9B\u9EB8\u9EB4\u8D73\u8D84\u8D94\u8D91\u8DB1\u8D67\u8D6D\u8C47\u8C49\u914A\u9150\u914E\u914F\u9164"],["f540","\u9B7C",62],["f580","\u9BBB",32,"\u9162\u9161\u9170\u9169\u916F\u917D\u917E\u9172\u9174\u9179\u918C\u9185\u9190\u918D\u9191\u91A2\u91A3\u91AA\u91AD\u91AE\u91AF\u91B5\u91B4\u91BA\u8C55\u9E7E\u8DB8\u8DEB\u8E05\u8E59\u8E69\u8DB5\u8DBF\u8DBC\u8DBA\u8DC4\u8DD6\u8DD7\u8DDA\u8DDE\u8DCE\u8DCF\u8DDB\u8DC6\u8DEC\u8DF7\u8DF8\u8DE3\u8DF9\u8DFB\u8DE4\u8E09\u8DFD\u8E14\u8E1D\u8E1F\u8E2C\u8E2E\u8E23\u8E2F\u8E3A\u8E40\u8E39\u8E35\u8E3D\u8E31\u8E49\u8E41\u8E42\u8E51\u8E52\u8E4A\u8E70\u8E76\u8E7C\u8E6F\u8E74\u8E85\u8E8F\u8E94\u8E90\u8E9C\u8E9E\u8C78\u8C82\u8C8A\u8C85\u8C98\u8C94\u659B\u89D6\u89DE\u89DA\u89DC"],["f640","\u9BDC",62],["f680","\u9C1B",32,"\u89E5\u89EB\u89EF\u8A3E\u8B26\u9753\u96E9\u96F3\u96EF\u9706\u9701\u9708\u970F\u970E\u972A\u972D\u9730\u973E\u9F80\u9F83\u9F85",5,"\u9F8C\u9EFE\u9F0B\u9F0D\u96B9\u96BC\u96BD\u96CE\u96D2\u77BF\u96E0\u928E\u92AE\u92C8\u933E\u936A\u93CA\u938F\u943E\u946B\u9C7F\u9C82\u9C85\u9C86\u9C87\u9C88\u7A23\u9C8B\u9C8E\u9C90\u9C91\u9C92\u9C94\u9C95\u9C9A\u9C9B\u9C9E",5,"\u9CA5",4,"\u9CAB\u9CAD\u9CAE\u9CB0",7,"\u9CBA\u9CBB\u9CBC\u9CBD\u9CC4\u9CC5\u9CC6\u9CC7\u9CCA\u9CCB"],["f740","\u9C3C",62],["f780","\u9C7B\u9C7D\u9C7E\u9C80\u9C83\u9C84\u9C89\u9C8A\u9C8C\u9C8F\u9C93\u9C96\u9C97\u9C98\u9C99\u9C9D\u9CAA\u9CAC\u9CAF\u9CB9\u9CBE",4,"\u9CC8\u9CC9\u9CD1\u9CD2\u9CDA\u9CDB\u9CE0\u9CE1\u9CCC",4,"\u9CD3\u9CD4\u9CD5\u9CD7\u9CD8\u9CD9\u9CDC\u9CDD\u9CDF\u9CE2\u977C\u9785\u9791\u9792\u9794\u97AF\u97AB\u97A3\u97B2\u97B4\u9AB1\u9AB0\u9AB7\u9E58\u9AB6\u9ABA\u9ABC\u9AC1\u9AC0\u9AC5\u9AC2\u9ACB\u9ACC\u9AD1\u9B45\u9B43\u9B47\u9B49\u9B48\u9B4D\u9B51\u98E8\u990D\u992E\u9955\u9954\u9ADF\u9AE1\u9AE6\u9AEF\u9AEB\u9AFB\u9AED\u9AF9\u9B08\u9B0F\u9B13\u9B1F\u9B23\u9EBD\u9EBE\u7E3B\u9E82\u9E87\u9E88\u9E8B\u9E92\u93D6\u9E9D\u9E9F\u9EDB\u9EDC\u9EDD\u9EE0\u9EDF\u9EE2\u9EE9\u9EE7\u9EE5\u9EEA\u9EEF\u9F22\u9F2C\u9F2F\u9F39\u9F37\u9F3D\u9F3E\u9F44"],["f840","\u9CE3",62],["f880","\u9D22",32],["f940","\u9D43",62],["f980","\u9D82",32],["fa40","\u9DA3",62],["fa80","\u9DE2",32],["fb40","\u9E03",27,"\u9E24\u9E27\u9E2E\u9E30\u9E34\u9E3B\u9E3C\u9E40\u9E4D\u9E50\u9E52\u9E53\u9E54\u9E56\u9E59\u9E5D\u9E5F\u9E60\u9E61\u9E62\u9E65\u9E6E\u9E6F\u9E72\u9E74",9,"\u9E80"],["fb80","\u9E81\u9E83\u9E84\u9E85\u9E86\u9E89\u9E8A\u9E8C",5,"\u9E94",8,"\u9E9E\u9EA0",5,"\u9EA7\u9EA8\u9EA9\u9EAA"],["fc40","\u9EAB",8,"\u9EB5\u9EB6\u9EB7\u9EB9\u9EBA\u9EBC\u9EBF",4,"\u9EC5\u9EC6\u9EC7\u9EC8\u9ECA\u9ECB\u9ECC\u9ED0\u9ED2\u9ED3\u9ED5\u9ED6\u9ED7\u9ED9\u9EDA\u9EDE\u9EE1\u9EE3\u9EE4\u9EE6\u9EE8\u9EEB\u9EEC\u9EED\u9EEE\u9EF0",8,"\u9EFA\u9EFD\u9EFF",6],["fc80","\u9F06",4,"\u9F0C\u9F0F\u9F11\u9F12\u9F14\u9F15\u9F16\u9F18\u9F1A",5,"\u9F21\u9F23",8,"\u9F2D\u9F2E\u9F30\u9F31"],["fd40","\u9F32",4,"\u9F38\u9F3A\u9F3C\u9F3F",4,"\u9F45",10,"\u9F52",38],["fd80","\u9F79",5,"\u9F81\u9F82\u9F8D",11,"\u9F9C\u9F9D\u9F9E\u9FA1",4,"\uF92C\uF979\uF995\uF9E7\uF9F1"],["fe40","\uFA0C\uFA0D\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA18\uFA1F\uFA20\uFA21\uFA23\uFA24\uFA27\uFA28\uFA29"]]');

});

parcelRegister("9IQ1F", function(module, exports) {
module.exports = JSON.parse('[["a140","\uE4C6",62],["a180","\uE505",32],["a240","\uE526",62],["a280","\uE565",32],["a2ab","\uE766",5],["a2e3","\u20AC\uE76D"],["a2ef","\uE76E\uE76F"],["a2fd","\uE770\uE771"],["a340","\uE586",62],["a380","\uE5C5",31,"\u3000"],["a440","\uE5E6",62],["a480","\uE625",32],["a4f4","\uE772",10],["a540","\uE646",62],["a580","\uE685",32],["a5f7","\uE77D",7],["a640","\uE6A6",62],["a680","\uE6E5",32],["a6b9","\uE785",7],["a6d9","\uE78D",6],["a6ec","\uE794\uE795"],["a6f3","\uE796"],["a6f6","\uE797",8],["a740","\uE706",62],["a780","\uE745",32],["a7c2","\uE7A0",14],["a7f2","\uE7AF",12],["a896","\uE7BC",10],["a8bc","\u1E3F"],["a8bf","\u01F9"],["a8c1","\uE7C9\uE7CA\uE7CB\uE7CC"],["a8ea","\uE7CD",20],["a958","\uE7E2"],["a95b","\uE7E3"],["a95d","\uE7E4\uE7E5\uE7E6"],["a989","\u303E\u2FF0",11],["a997","\uE7F4",12],["a9f0","\uE801",14],["aaa1","\uE000",93],["aba1","\uE05E",93],["aca1","\uE0BC",93],["ada1","\uE11A",93],["aea1","\uE178",93],["afa1","\uE1D6",93],["d7fa","\uE810",4],["f8a1","\uE234",93],["f9a1","\uE292",93],["faa1","\uE2F0",93],["fba1","\uE34E",93],["fca1","\uE3AC",93],["fda1","\uE40A",93],["fe50","\u2E81\uE816\uE817\uE818\u2E84\u3473\u3447\u2E88\u2E8B\uE81E\u359E\u361A\u360E\u2E8C\u2E97\u396E\u3918\uE826\u39CF\u39DF\u3A73\u39D0\uE82B\uE82C\u3B4E\u3C6E\u3CE0\u2EA7\uE831\uE832\u2EAA\u4056\u415F\u2EAE\u4337\u2EB3\u2EB6\u2EB7\uE83B\u43B1\u43AC\u2EBB\u43DD\u44D6\u4661\u464C\uE843"],["fe80","\u4723\u4729\u477C\u478D\u2ECA\u4947\u497A\u497D\u4982\u4983\u4985\u4986\u499F\u499B\u49B7\u49B6\uE854\uE855\u4CA3\u4C9F\u4CA0\u4CA1\u4C77\u4CA2\u4D13",6,"\u4DAE\uE864\uE468",93],["8135f437","\uE7C7"]]');

});

parcelRegister("8hI5g", function(module, exports) {
module.exports = JSON.parse("{\"uChars\":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],\"gbChars\":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}");

});

parcelRegister("arsul", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",127],["8141","\uAC02\uAC03\uAC05\uAC06\uAC0B",4,"\uAC18\uAC1E\uAC1F\uAC21\uAC22\uAC23\uAC25",6,"\uAC2E\uAC32\uAC33\uAC34"],["8161","\uAC35\uAC36\uAC37\uAC3A\uAC3B\uAC3D\uAC3E\uAC3F\uAC41",9,"\uAC4C\uAC4E",5,"\uAC55"],["8181","\uAC56\uAC57\uAC59\uAC5A\uAC5B\uAC5D",18,"\uAC72\uAC73\uAC75\uAC76\uAC79\uAC7B",4,"\uAC82\uAC87\uAC88\uAC8D\uAC8E\uAC8F\uAC91\uAC92\uAC93\uAC95",6,"\uAC9E\uACA2",5,"\uACAB\uACAD\uACAE\uACB1",6,"\uACBA\uACBE\uACBF\uACC0\uACC2\uACC3\uACC5\uACC6\uACC7\uACC9\uACCA\uACCB\uACCD",7,"\uACD6\uACD8",7,"\uACE2\uACE3\uACE5\uACE6\uACE9\uACEB\uACED\uACEE\uACF2\uACF4\uACF7",4,"\uACFE\uACFF\uAD01\uAD02\uAD03\uAD05\uAD07",4,"\uAD0E\uAD10\uAD12\uAD13"],["8241","\uAD14\uAD15\uAD16\uAD17\uAD19\uAD1A\uAD1B\uAD1D\uAD1E\uAD1F\uAD21",7,"\uAD2A\uAD2B\uAD2E",5],["8261","\uAD36\uAD37\uAD39\uAD3A\uAD3B\uAD3D",6,"\uAD46\uAD48\uAD4A",5,"\uAD51\uAD52\uAD53\uAD55\uAD56\uAD57"],["8281","\uAD59",7,"\uAD62\uAD64",7,"\uAD6E\uAD6F\uAD71\uAD72\uAD77\uAD78\uAD79\uAD7A\uAD7E\uAD80\uAD83",4,"\uAD8A\uAD8B\uAD8D\uAD8E\uAD8F\uAD91",10,"\uAD9E",5,"\uADA5",17,"\uADB8",7,"\uADC2\uADC3\uADC5\uADC6\uADC7\uADC9",6,"\uADD2\uADD4",7,"\uADDD\uADDE\uADDF\uADE1\uADE2\uADE3\uADE5",18],["8341","\uADFA\uADFB\uADFD\uADFE\uAE02",5,"\uAE0A\uAE0C\uAE0E",5,"\uAE15",7],["8361","\uAE1D",18,"\uAE32\uAE33\uAE35\uAE36\uAE39\uAE3B\uAE3C"],["8381","\uAE3D\uAE3E\uAE3F\uAE42\uAE44\uAE47\uAE48\uAE49\uAE4B\uAE4F\uAE51\uAE52\uAE53\uAE55\uAE57",4,"\uAE5E\uAE62\uAE63\uAE64\uAE66\uAE67\uAE6A\uAE6B\uAE6D\uAE6E\uAE6F\uAE71",6,"\uAE7A\uAE7E",5,"\uAE86",5,"\uAE8D",46,"\uAEBF\uAEC1\uAEC2\uAEC3\uAEC5",6,"\uAECE\uAED2",5,"\uAEDA\uAEDB\uAEDD",8],["8441","\uAEE6\uAEE7\uAEE9\uAEEA\uAEEC\uAEEE",5,"\uAEF5\uAEF6\uAEF7\uAEF9\uAEFA\uAEFB\uAEFD",8],["8461","\uAF06\uAF09\uAF0A\uAF0B\uAF0C\uAF0E\uAF0F\uAF11",18],["8481","\uAF24",7,"\uAF2E\uAF2F\uAF31\uAF33\uAF35",6,"\uAF3E\uAF40\uAF44\uAF45\uAF46\uAF47\uAF4A",5,"\uAF51",10,"\uAF5E",5,"\uAF66",18,"\uAF7A",5,"\uAF81\uAF82\uAF83\uAF85\uAF86\uAF87\uAF89",6,"\uAF92\uAF93\uAF94\uAF96",5,"\uAF9D",26,"\uAFBA\uAFBB\uAFBD\uAFBE"],["8541","\uAFBF\uAFC1",5,"\uAFCA\uAFCC\uAFCF",4,"\uAFD5",6,"\uAFDD",4],["8561","\uAFE2",5,"\uAFEA",5,"\uAFF2\uAFF3\uAFF5\uAFF6\uAFF7\uAFF9",6,"\uB002\uB003"],["8581","\uB005",6,"\uB00D\uB00E\uB00F\uB011\uB012\uB013\uB015",6,"\uB01E",9,"\uB029",26,"\uB046\uB047\uB049\uB04B\uB04D\uB04F\uB050\uB051\uB052\uB056\uB058\uB05A\uB05B\uB05C\uB05E",29,"\uB07E\uB07F\uB081\uB082\uB083\uB085",6,"\uB08E\uB090\uB092",5,"\uB09B\uB09D\uB09E\uB0A3\uB0A4"],["8641","\uB0A5\uB0A6\uB0A7\uB0AA\uB0B0\uB0B2\uB0B6\uB0B7\uB0B9\uB0BA\uB0BB\uB0BD",6,"\uB0C6\uB0CA",5,"\uB0D2"],["8661","\uB0D3\uB0D5\uB0D6\uB0D7\uB0D9",6,"\uB0E1\uB0E2\uB0E3\uB0E4\uB0E6",10],["8681","\uB0F1",22,"\uB10A\uB10D\uB10E\uB10F\uB111\uB114\uB115\uB116\uB117\uB11A\uB11E",4,"\uB126\uB127\uB129\uB12A\uB12B\uB12D",6,"\uB136\uB13A",5,"\uB142\uB143\uB145\uB146\uB147\uB149",6,"\uB152\uB153\uB156\uB157\uB159\uB15A\uB15B\uB15D\uB15E\uB15F\uB161",22,"\uB17A\uB17B\uB17D\uB17E\uB17F\uB181\uB183",4,"\uB18A\uB18C\uB18E\uB18F\uB190\uB191\uB195\uB196\uB197\uB199\uB19A\uB19B\uB19D"],["8741","\uB19E",9,"\uB1A9",15],["8761","\uB1B9",18,"\uB1CD\uB1CE\uB1CF\uB1D1\uB1D2\uB1D3\uB1D5"],["8781","\uB1D6",5,"\uB1DE\uB1E0",7,"\uB1EA\uB1EB\uB1ED\uB1EE\uB1EF\uB1F1",7,"\uB1FA\uB1FC\uB1FE",5,"\uB206\uB207\uB209\uB20A\uB20D",6,"\uB216\uB218\uB21A",5,"\uB221",18,"\uB235",6,"\uB23D",26,"\uB259\uB25A\uB25B\uB25D\uB25E\uB25F\uB261",6,"\uB26A",4],["8841","\uB26F",4,"\uB276",5,"\uB27D",6,"\uB286\uB287\uB288\uB28A",4],["8861","\uB28F\uB292\uB293\uB295\uB296\uB297\uB29B",4,"\uB2A2\uB2A4\uB2A7\uB2A8\uB2A9\uB2AB\uB2AD\uB2AE\uB2AF\uB2B1\uB2B2\uB2B3\uB2B5\uB2B6\uB2B7"],["8881","\uB2B8",15,"\uB2CA\uB2CB\uB2CD\uB2CE\uB2CF\uB2D1\uB2D3",4,"\uB2DA\uB2DC\uB2DE\uB2DF\uB2E0\uB2E1\uB2E3\uB2E7\uB2E9\uB2EA\uB2F0\uB2F1\uB2F2\uB2F6\uB2FC\uB2FD\uB2FE\uB302\uB303\uB305\uB306\uB307\uB309",6,"\uB312\uB316",5,"\uB31D",54,"\uB357\uB359\uB35A\uB35D\uB360\uB361\uB362\uB363"],["8941","\uB366\uB368\uB36A\uB36C\uB36D\uB36F\uB372\uB373\uB375\uB376\uB377\uB379",6,"\uB382\uB386",5,"\uB38D"],["8961","\uB38E\uB38F\uB391\uB392\uB393\uB395",10,"\uB3A2",5,"\uB3A9\uB3AA\uB3AB\uB3AD"],["8981","\uB3AE",21,"\uB3C6\uB3C7\uB3C9\uB3CA\uB3CD\uB3CF\uB3D1\uB3D2\uB3D3\uB3D6\uB3D8\uB3DA\uB3DC\uB3DE\uB3DF\uB3E1\uB3E2\uB3E3\uB3E5\uB3E6\uB3E7\uB3E9",18,"\uB3FD",18,"\uB411",6,"\uB419\uB41A\uB41B\uB41D\uB41E\uB41F\uB421",6,"\uB42A\uB42C",7,"\uB435",15],["8a41","\uB445",10,"\uB452\uB453\uB455\uB456\uB457\uB459",6,"\uB462\uB464\uB466"],["8a61","\uB467",4,"\uB46D",18,"\uB481\uB482"],["8a81","\uB483",4,"\uB489",19,"\uB49E",5,"\uB4A5\uB4A6\uB4A7\uB4A9\uB4AA\uB4AB\uB4AD",7,"\uB4B6\uB4B8\uB4BA",5,"\uB4C1\uB4C2\uB4C3\uB4C5\uB4C6\uB4C7\uB4C9",6,"\uB4D1\uB4D2\uB4D3\uB4D4\uB4D6",5,"\uB4DE\uB4DF\uB4E1\uB4E2\uB4E5\uB4E7",4,"\uB4EE\uB4F0\uB4F2",5,"\uB4F9",26,"\uB516\uB517\uB519\uB51A\uB51D"],["8b41","\uB51E",5,"\uB526\uB52B",4,"\uB532\uB533\uB535\uB536\uB537\uB539",6,"\uB542\uB546"],["8b61","\uB547\uB548\uB549\uB54A\uB54E\uB54F\uB551\uB552\uB553\uB555",6,"\uB55E\uB562",8],["8b81","\uB56B",52,"\uB5A2\uB5A3\uB5A5\uB5A6\uB5A7\uB5A9\uB5AC\uB5AD\uB5AE\uB5AF\uB5B2\uB5B6",4,"\uB5BE\uB5BF\uB5C1\uB5C2\uB5C3\uB5C5",6,"\uB5CE\uB5D2",5,"\uB5D9",18,"\uB5ED",18],["8c41","\uB600",15,"\uB612\uB613\uB615\uB616\uB617\uB619",4],["8c61","\uB61E",6,"\uB626",5,"\uB62D",6,"\uB635",5],["8c81","\uB63B",12,"\uB649",26,"\uB665\uB666\uB667\uB669",50,"\uB69E\uB69F\uB6A1\uB6A2\uB6A3\uB6A5",5,"\uB6AD\uB6AE\uB6AF\uB6B0\uB6B2",16],["8d41","\uB6C3",16,"\uB6D5",8],["8d61","\uB6DE",17,"\uB6F1\uB6F2\uB6F3\uB6F5\uB6F6\uB6F7\uB6F9\uB6FA"],["8d81","\uB6FB",4,"\uB702\uB703\uB704\uB706",33,"\uB72A\uB72B\uB72D\uB72E\uB731",6,"\uB73A\uB73C",7,"\uB745\uB746\uB747\uB749\uB74A\uB74B\uB74D",6,"\uB756",9,"\uB761\uB762\uB763\uB765\uB766\uB767\uB769",6,"\uB772\uB774\uB776",5,"\uB77E\uB77F\uB781\uB782\uB783\uB785",6,"\uB78E\uB793\uB794\uB795\uB79A\uB79B\uB79D\uB79E"],["8e41","\uB79F\uB7A1",6,"\uB7AA\uB7AE",5,"\uB7B6\uB7B7\uB7B9",8],["8e61","\uB7C2",4,"\uB7C8\uB7CA",19],["8e81","\uB7DE",13,"\uB7EE\uB7EF\uB7F1\uB7F2\uB7F3\uB7F5",6,"\uB7FE\uB802",4,"\uB80A\uB80B\uB80D\uB80E\uB80F\uB811",6,"\uB81A\uB81C\uB81E",5,"\uB826\uB827\uB829\uB82A\uB82B\uB82D",6,"\uB836\uB83A",5,"\uB841\uB842\uB843\uB845",11,"\uB852\uB854",7,"\uB85E\uB85F\uB861\uB862\uB863\uB865",6,"\uB86E\uB870\uB872",5,"\uB879\uB87A\uB87B\uB87D",7],["8f41","\uB885",7,"\uB88E",17],["8f61","\uB8A0",7,"\uB8A9",6,"\uB8B1\uB8B2\uB8B3\uB8B5\uB8B6\uB8B7\uB8B9",4],["8f81","\uB8BE\uB8BF\uB8C2\uB8C4\uB8C6",5,"\uB8CD\uB8CE\uB8CF\uB8D1\uB8D2\uB8D3\uB8D5",7,"\uB8DE\uB8E0\uB8E2",5,"\uB8EA\uB8EB\uB8ED\uB8EE\uB8EF\uB8F1",6,"\uB8FA\uB8FC\uB8FE",5,"\uB905",18,"\uB919",6,"\uB921",26,"\uB93E\uB93F\uB941\uB942\uB943\uB945",6,"\uB94D\uB94E\uB950\uB952",5],["9041","\uB95A\uB95B\uB95D\uB95E\uB95F\uB961",6,"\uB96A\uB96C\uB96E",5,"\uB976\uB977\uB979\uB97A\uB97B\uB97D"],["9061","\uB97E",5,"\uB986\uB988\uB98B\uB98C\uB98F",15],["9081","\uB99F",12,"\uB9AE\uB9AF\uB9B1\uB9B2\uB9B3\uB9B5",6,"\uB9BE\uB9C0\uB9C2",5,"\uB9CA\uB9CB\uB9CD\uB9D3",4,"\uB9DA\uB9DC\uB9DF\uB9E0\uB9E2\uB9E6\uB9E7\uB9E9\uB9EA\uB9EB\uB9ED",6,"\uB9F6\uB9FB",4,"\uBA02",5,"\uBA09",11,"\uBA16",33,"\uBA3A\uBA3B\uBA3D\uBA3E\uBA3F\uBA41\uBA43\uBA44\uBA45\uBA46"],["9141","\uBA47\uBA4A\uBA4C\uBA4F\uBA50\uBA51\uBA52\uBA56\uBA57\uBA59\uBA5A\uBA5B\uBA5D",6,"\uBA66\uBA6A",5],["9161","\uBA72\uBA73\uBA75\uBA76\uBA77\uBA79",9,"\uBA86\uBA88\uBA89\uBA8A\uBA8B\uBA8D",5],["9181","\uBA93",20,"\uBAAA\uBAAD\uBAAE\uBAAF\uBAB1\uBAB3",4,"\uBABA\uBABC\uBABE",5,"\uBAC5\uBAC6\uBAC7\uBAC9",14,"\uBADA",33,"\uBAFD\uBAFE\uBAFF\uBB01\uBB02\uBB03\uBB05",7,"\uBB0E\uBB10\uBB12",5,"\uBB19\uBB1A\uBB1B\uBB1D\uBB1E\uBB1F\uBB21",6],["9241","\uBB28\uBB2A\uBB2C",7,"\uBB37\uBB39\uBB3A\uBB3F",4,"\uBB46\uBB48\uBB4A\uBB4B\uBB4C\uBB4E\uBB51\uBB52"],["9261","\uBB53\uBB55\uBB56\uBB57\uBB59",7,"\uBB62\uBB64",7,"\uBB6D",4],["9281","\uBB72",21,"\uBB89\uBB8A\uBB8B\uBB8D\uBB8E\uBB8F\uBB91",18,"\uBBA5\uBBA6\uBBA7\uBBA9\uBBAA\uBBAB\uBBAD",6,"\uBBB5\uBBB6\uBBB8",7,"\uBBC1\uBBC2\uBBC3\uBBC5\uBBC6\uBBC7\uBBC9",6,"\uBBD1\uBBD2\uBBD4",35,"\uBBFA\uBBFB\uBBFD\uBBFE\uBC01"],["9341","\uBC03",4,"\uBC0A\uBC0E\uBC10\uBC12\uBC13\uBC19\uBC1A\uBC20\uBC21\uBC22\uBC23\uBC26\uBC28\uBC2A\uBC2B\uBC2C\uBC2E\uBC2F\uBC32\uBC33\uBC35"],["9361","\uBC36\uBC37\uBC39",6,"\uBC42\uBC46\uBC47\uBC48\uBC4A\uBC4B\uBC4E\uBC4F\uBC51",8],["9381","\uBC5A\uBC5B\uBC5C\uBC5E",37,"\uBC86\uBC87\uBC89\uBC8A\uBC8D\uBC8F",4,"\uBC96\uBC98\uBC9B",4,"\uBCA2\uBCA3\uBCA5\uBCA6\uBCA9",6,"\uBCB2\uBCB6",5,"\uBCBE\uBCBF\uBCC1\uBCC2\uBCC3\uBCC5",7,"\uBCCE\uBCD2\uBCD3\uBCD4\uBCD6\uBCD7\uBCD9\uBCDA\uBCDB\uBCDD",22,"\uBCF7\uBCF9\uBCFA\uBCFB\uBCFD"],["9441","\uBCFE",5,"\uBD06\uBD08\uBD0A",5,"\uBD11\uBD12\uBD13\uBD15",8],["9461","\uBD1E",5,"\uBD25",6,"\uBD2D",12],["9481","\uBD3A",5,"\uBD41",6,"\uBD4A\uBD4B\uBD4D\uBD4E\uBD4F\uBD51",6,"\uBD5A",9,"\uBD65\uBD66\uBD67\uBD69",22,"\uBD82\uBD83\uBD85\uBD86\uBD8B",4,"\uBD92\uBD94\uBD96\uBD97\uBD98\uBD9B\uBD9D",6,"\uBDA5",10,"\uBDB1",6,"\uBDB9",24],["9541","\uBDD2\uBDD3\uBDD6\uBDD7\uBDD9\uBDDA\uBDDB\uBDDD",11,"\uBDEA",5,"\uBDF1"],["9561","\uBDF2\uBDF3\uBDF5\uBDF6\uBDF7\uBDF9",6,"\uBE01\uBE02\uBE04\uBE06",5,"\uBE0E\uBE0F\uBE11\uBE12\uBE13"],["9581","\uBE15",6,"\uBE1E\uBE20",35,"\uBE46\uBE47\uBE49\uBE4A\uBE4B\uBE4D\uBE4F",4,"\uBE56\uBE58\uBE5C\uBE5D\uBE5E\uBE5F\uBE62\uBE63\uBE65\uBE66\uBE67\uBE69\uBE6B",4,"\uBE72\uBE76",4,"\uBE7E\uBE7F\uBE81\uBE82\uBE83\uBE85",6,"\uBE8E\uBE92",5,"\uBE9A",13,"\uBEA9",14],["9641","\uBEB8",23,"\uBED2\uBED3"],["9661","\uBED5\uBED6\uBED9",6,"\uBEE1\uBEE2\uBEE6",5,"\uBEED",8],["9681","\uBEF6",10,"\uBF02",5,"\uBF0A",13,"\uBF1A\uBF1E",33,"\uBF42\uBF43\uBF45\uBF46\uBF47\uBF49",6,"\uBF52\uBF53\uBF54\uBF56",44],["9741","\uBF83",16,"\uBF95",8],["9761","\uBF9E",17,"\uBFB1",7],["9781","\uBFB9",11,"\uBFC6",5,"\uBFCE\uBFCF\uBFD1\uBFD2\uBFD3\uBFD5",6,"\uBFDD\uBFDE\uBFE0\uBFE2",89,"\uC03D\uC03E\uC03F"],["9841","\uC040",16,"\uC052",5,"\uC059\uC05A\uC05B"],["9861","\uC05D\uC05E\uC05F\uC061",6,"\uC06A",15],["9881","\uC07A",21,"\uC092\uC093\uC095\uC096\uC097\uC099",6,"\uC0A2\uC0A4\uC0A6",5,"\uC0AE\uC0B1\uC0B2\uC0B7",4,"\uC0BE\uC0C2\uC0C3\uC0C4\uC0C6\uC0C7\uC0CA\uC0CB\uC0CD\uC0CE\uC0CF\uC0D1",6,"\uC0DA\uC0DE",5,"\uC0E6\uC0E7\uC0E9\uC0EA\uC0EB\uC0ED",6,"\uC0F6\uC0F8\uC0FA",5,"\uC101\uC102\uC103\uC105\uC106\uC107\uC109",6,"\uC111\uC112\uC113\uC114\uC116",5,"\uC121\uC122\uC125\uC128\uC129\uC12A\uC12B\uC12E"],["9941","\uC132\uC133\uC134\uC135\uC137\uC13A\uC13B\uC13D\uC13E\uC13F\uC141",6,"\uC14A\uC14E",5,"\uC156\uC157"],["9961","\uC159\uC15A\uC15B\uC15D",6,"\uC166\uC16A",5,"\uC171\uC172\uC173\uC175\uC176\uC177\uC179\uC17A\uC17B"],["9981","\uC17C",8,"\uC186",5,"\uC18F\uC191\uC192\uC193\uC195\uC197",4,"\uC19E\uC1A0\uC1A2\uC1A3\uC1A4\uC1A6\uC1A7\uC1AA\uC1AB\uC1AD\uC1AE\uC1AF\uC1B1",11,"\uC1BE",5,"\uC1C5\uC1C6\uC1C7\uC1C9\uC1CA\uC1CB\uC1CD",6,"\uC1D5\uC1D6\uC1D9",6,"\uC1E1\uC1E2\uC1E3\uC1E5\uC1E6\uC1E7\uC1E9",6,"\uC1F2\uC1F4",7,"\uC1FE\uC1FF\uC201\uC202\uC203\uC205",6,"\uC20E\uC210\uC212",5,"\uC21A\uC21B\uC21D\uC21E\uC221\uC222\uC223"],["9a41","\uC224\uC225\uC226\uC227\uC22A\uC22C\uC22E\uC230\uC233\uC235",16],["9a61","\uC246\uC247\uC249",6,"\uC252\uC253\uC255\uC256\uC257\uC259",6,"\uC261\uC262\uC263\uC264\uC266"],["9a81","\uC267",4,"\uC26E\uC26F\uC271\uC272\uC273\uC275",6,"\uC27E\uC280\uC282",5,"\uC28A",5,"\uC291",6,"\uC299\uC29A\uC29C\uC29E",5,"\uC2A6\uC2A7\uC2A9\uC2AA\uC2AB\uC2AE",5,"\uC2B6\uC2B8\uC2BA",33,"\uC2DE\uC2DF\uC2E1\uC2E2\uC2E5",5,"\uC2EE\uC2F0\uC2F2\uC2F3\uC2F4\uC2F5\uC2F7\uC2FA\uC2FD\uC2FE\uC2FF\uC301",6,"\uC30A\uC30B\uC30E\uC30F"],["9b41","\uC310\uC311\uC312\uC316\uC317\uC319\uC31A\uC31B\uC31D",6,"\uC326\uC327\uC32A",8],["9b61","\uC333",17,"\uC346",7],["9b81","\uC34E",25,"\uC36A\uC36B\uC36D\uC36E\uC36F\uC371\uC373",4,"\uC37A\uC37B\uC37E",5,"\uC385\uC386\uC387\uC389\uC38A\uC38B\uC38D",50,"\uC3C1",22,"\uC3DA"],["9c41","\uC3DB\uC3DD\uC3DE\uC3E1\uC3E3",4,"\uC3EA\uC3EB\uC3EC\uC3EE",5,"\uC3F6\uC3F7\uC3F9",5],["9c61","\uC3FF",8,"\uC409",6,"\uC411",9],["9c81","\uC41B",8,"\uC425",6,"\uC42D\uC42E\uC42F\uC431\uC432\uC433\uC435",6,"\uC43E",9,"\uC449",26,"\uC466\uC467\uC469\uC46A\uC46B\uC46D",6,"\uC476\uC477\uC478\uC47A",5,"\uC481",18,"\uC495",6,"\uC49D",12],["9d41","\uC4AA",13,"\uC4B9\uC4BA\uC4BB\uC4BD",8],["9d61","\uC4C6",25],["9d81","\uC4E0",8,"\uC4EA",5,"\uC4F2\uC4F3\uC4F5\uC4F6\uC4F7\uC4F9\uC4FB\uC4FC\uC4FD\uC4FE\uC502",9,"\uC50D\uC50E\uC50F\uC511\uC512\uC513\uC515",6,"\uC51D",10,"\uC52A\uC52B\uC52D\uC52E\uC52F\uC531",6,"\uC53A\uC53C\uC53E",5,"\uC546\uC547\uC54B\uC54F\uC550\uC551\uC552\uC556\uC55A\uC55B\uC55C\uC55F\uC562\uC563\uC565\uC566\uC567\uC569",6,"\uC572\uC576",5,"\uC57E\uC57F\uC581\uC582\uC583\uC585\uC586\uC588\uC589\uC58A\uC58B\uC58E\uC590\uC592\uC593\uC594"],["9e41","\uC596\uC599\uC59A\uC59B\uC59D\uC59E\uC59F\uC5A1",7,"\uC5AA",9,"\uC5B6"],["9e61","\uC5B7\uC5BA\uC5BF",4,"\uC5CB\uC5CD\uC5CF\uC5D2\uC5D3\uC5D5\uC5D6\uC5D7\uC5D9",6,"\uC5E2\uC5E4\uC5E6\uC5E7"],["9e81","\uC5E8\uC5E9\uC5EA\uC5EB\uC5EF\uC5F1\uC5F2\uC5F3\uC5F5\uC5F8\uC5F9\uC5FA\uC5FB\uC602\uC603\uC604\uC609\uC60A\uC60B\uC60D\uC60E\uC60F\uC611",6,"\uC61A\uC61D",6,"\uC626\uC627\uC629\uC62A\uC62B\uC62F\uC631\uC632\uC636\uC638\uC63A\uC63C\uC63D\uC63E\uC63F\uC642\uC643\uC645\uC646\uC647\uC649",6,"\uC652\uC656",5,"\uC65E\uC65F\uC661",10,"\uC66D\uC66E\uC670\uC672",5,"\uC67A\uC67B\uC67D\uC67E\uC67F\uC681",6,"\uC68A\uC68C\uC68E",5,"\uC696\uC697\uC699\uC69A\uC69B\uC69D",6,"\uC6A6"],["9f41","\uC6A8\uC6AA",5,"\uC6B2\uC6B3\uC6B5\uC6B6\uC6B7\uC6BB",4,"\uC6C2\uC6C4\uC6C6",5,"\uC6CE"],["9f61","\uC6CF\uC6D1\uC6D2\uC6D3\uC6D5",6,"\uC6DE\uC6DF\uC6E2",5,"\uC6EA\uC6EB\uC6ED\uC6EE\uC6EF\uC6F1\uC6F2"],["9f81","\uC6F3",4,"\uC6FA\uC6FB\uC6FC\uC6FE",5,"\uC706\uC707\uC709\uC70A\uC70B\uC70D",6,"\uC716\uC718\uC71A",5,"\uC722\uC723\uC725\uC726\uC727\uC729",6,"\uC732\uC734\uC736\uC738\uC739\uC73A\uC73B\uC73E\uC73F\uC741\uC742\uC743\uC745",4,"\uC74B\uC74E\uC750\uC759\uC75A\uC75B\uC75D\uC75E\uC75F\uC761",6,"\uC769\uC76A\uC76C",7,"\uC776\uC777\uC779\uC77A\uC77B\uC77F\uC780\uC781\uC782\uC786\uC78B\uC78C\uC78D\uC78F\uC792\uC793\uC795\uC799\uC79B",4,"\uC7A2\uC7A7",4,"\uC7AE\uC7AF\uC7B1\uC7B2\uC7B3\uC7B5\uC7B6\uC7B7"],["a041","\uC7B8\uC7B9\uC7BA\uC7BB\uC7BE\uC7C2",5,"\uC7CA\uC7CB\uC7CD\uC7CF\uC7D1",6,"\uC7D9\uC7DA\uC7DB\uC7DC"],["a061","\uC7DE",5,"\uC7E5\uC7E6\uC7E7\uC7E9\uC7EA\uC7EB\uC7ED",13],["a081","\uC7FB",4,"\uC802\uC803\uC805\uC806\uC807\uC809\uC80B",4,"\uC812\uC814\uC817",4,"\uC81E\uC81F\uC821\uC822\uC823\uC825",6,"\uC82E\uC830\uC832",5,"\uC839\uC83A\uC83B\uC83D\uC83E\uC83F\uC841",6,"\uC84A\uC84B\uC84E",5,"\uC855",26,"\uC872\uC873\uC875\uC876\uC877\uC879\uC87B",4,"\uC882\uC884\uC888\uC889\uC88A\uC88E",5,"\uC895",7,"\uC89E\uC8A0\uC8A2\uC8A3\uC8A4"],["a141","\uC8A5\uC8A6\uC8A7\uC8A9",18,"\uC8BE\uC8BF\uC8C0\uC8C1"],["a161","\uC8C2\uC8C3\uC8C5\uC8C6\uC8C7\uC8C9\uC8CA\uC8CB\uC8CD",6,"\uC8D6\uC8D8\uC8DA",5,"\uC8E2\uC8E3\uC8E5"],["a181","\uC8E6",14,"\uC8F6",5,"\uC8FE\uC8FF\uC901\uC902\uC903\uC907",4,"\uC90E\u3000\u3001\u3002\xb7\u2025\u2026\xa8\u3003\xad\u2015\u2225\uFF3C\u223C\u2018\u2019\u201C\u201D\u3014\u3015\u3008",9,"\xb1\xd7\xf7\u2260\u2264\u2265\u221E\u2234\xb0\u2032\u2033\u2103\u212B\uFFE0\uFFE1\uFFE5\u2642\u2640\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\xa7\u203B\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u2192\u2190\u2191\u2193\u2194\u3013\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229\u2227\u2228\uFFE2"],["a241","\uC910\uC912",5,"\uC919",18],["a261","\uC92D",6,"\uC935",18],["a281","\uC948",7,"\uC952\uC953\uC955\uC956\uC957\uC959",6,"\uC962\uC964",7,"\uC96D\uC96E\uC96F\u21D2\u21D4\u2200\u2203\xb4\uFF5E\u02C7\u02D8\u02DD\u02DA\u02D9\xb8\u02DB\xa1\xbf\u02D0\u222E\u2211\u220F\xa4\u2109\u2030\u25C1\u25C0\u25B7\u25B6\u2664\u2660\u2661\u2665\u2667\u2663\u2299\u25C8\u25A3\u25D0\u25D1\u2592\u25A4\u25A5\u25A8\u25A7\u25A6\u25A9\u2668\u260F\u260E\u261C\u261E\xb6\u2020\u2021\u2195\u2197\u2199\u2196\u2198\u266D\u2669\u266A\u266C\u327F\u321C\u2116\u33C7\u2122\u33C2\u33D8\u2121\u20AC\xae"],["a341","\uC971\uC972\uC973\uC975",6,"\uC97D",10,"\uC98A\uC98B\uC98D\uC98E\uC98F"],["a361","\uC991",6,"\uC99A\uC99C\uC99E",16],["a381","\uC9AF",16,"\uC9C2\uC9C3\uC9C5\uC9C6\uC9C9\uC9CB",4,"\uC9D2\uC9D4\uC9D7\uC9D8\uC9DB\uFF01",58,"\uFFE6\uFF3D",32,"\uFFE3"],["a441","\uC9DE\uC9DF\uC9E1\uC9E3\uC9E5\uC9E6\uC9E8\uC9E9\uC9EA\uC9EB\uC9EE\uC9F2",5,"\uC9FA\uC9FB\uC9FD\uC9FE\uC9FF\uCA01\uCA02\uCA03\uCA04"],["a461","\uCA05\uCA06\uCA07\uCA0A\uCA0E",5,"\uCA15\uCA16\uCA17\uCA19",12],["a481","\uCA26\uCA27\uCA28\uCA2A",28,"\u3131",93],["a541","\uCA47",4,"\uCA4E\uCA4F\uCA51\uCA52\uCA53\uCA55",6,"\uCA5E\uCA62",5,"\uCA69\uCA6A"],["a561","\uCA6B",17,"\uCA7E",5,"\uCA85\uCA86"],["a581","\uCA87",16,"\uCA99",14,"\u2170",9],["a5b0","\u2160",9],["a5c1","\u0391",16,"\u03A3",6],["a5e1","\u03B1",16,"\u03C3",6],["a641","\uCAA8",19,"\uCABE\uCABF\uCAC1\uCAC2\uCAC3\uCAC5"],["a661","\uCAC6",5,"\uCACE\uCAD0\uCAD2\uCAD4\uCAD5\uCAD6\uCAD7\uCADA",5,"\uCAE1",6],["a681","\uCAE8\uCAE9\uCAEA\uCAEB\uCAED",6,"\uCAF5",18,"\uCB09\uCB0A\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542\u2512\u2511\u251A\u2519\u2516\u2515\u250E\u250D\u251E\u251F\u2521\u2522\u2526\u2527\u2529\u252A\u252D\u252E\u2531\u2532\u2535\u2536\u2539\u253A\u253D\u253E\u2540\u2541\u2543",7],["a741","\uCB0B",4,"\uCB11\uCB12\uCB13\uCB15\uCB16\uCB17\uCB19",6,"\uCB22",7],["a761","\uCB2A",22,"\uCB42\uCB43\uCB44"],["a781","\uCB45\uCB46\uCB47\uCB4A\uCB4B\uCB4D\uCB4E\uCB4F\uCB51",6,"\uCB5A\uCB5B\uCB5C\uCB5E",5,"\uCB65",7,"\u3395\u3396\u3397\u2113\u3398\u33C4\u33A3\u33A4\u33A5\u33A6\u3399",9,"\u33CA\u338D\u338E\u338F\u33CF\u3388\u3389\u33C8\u33A7\u33A8\u33B0",9,"\u3380",4,"\u33BA",5,"\u3390",4,"\u2126\u33C0\u33C1\u338A\u338B\u338C\u33D6\u33C5\u33AD\u33AE\u33AF\u33DB\u33A9\u33AA\u33AB\u33AC\u33DD\u33D0\u33D3\u33C3\u33C9\u33DC\u33C6"],["a841","\uCB6D",10,"\uCB7A",14],["a861","\uCB89",18,"\uCB9D",6],["a881","\uCBA4",19,"\uCBB9",11,"\xc6\xd0\xaa\u0126"],["a8a6","\u0132"],["a8a8","\u013F\u0141\xd8\u0152\xba\xde\u0166\u014A"],["a8b1","\u3260",27,"\u24D0",25,"\u2460",14,"\xbd\u2153\u2154\xbc\xbe\u215B\u215C\u215D\u215E"],["a941","\uCBC5",14,"\uCBD5",10],["a961","\uCBE0\uCBE1\uCBE2\uCBE3\uCBE5\uCBE6\uCBE8\uCBEA",18],["a981","\uCBFD",14,"\uCC0E\uCC0F\uCC11\uCC12\uCC13\uCC15",6,"\uCC1E\uCC1F\uCC20\uCC23\uCC24\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0140\u0142\xf8\u0153\xdf\xfe\u0167\u014B\u0149\u3200",27,"\u249C",25,"\u2474",14,"\xb9\xb2\xb3\u2074\u207F\u2081\u2082\u2083\u2084"],["aa41","\uCC25\uCC26\uCC2A\uCC2B\uCC2D\uCC2F\uCC31",6,"\uCC3A\uCC3F",4,"\uCC46\uCC47\uCC49\uCC4A\uCC4B\uCC4D\uCC4E"],["aa61","\uCC4F",4,"\uCC56\uCC5A",5,"\uCC61\uCC62\uCC63\uCC65\uCC67\uCC69",6,"\uCC71\uCC72"],["aa81","\uCC73\uCC74\uCC76",29,"\u3041",82],["ab41","\uCC94\uCC95\uCC96\uCC97\uCC9A\uCC9B\uCC9D\uCC9E\uCC9F\uCCA1",6,"\uCCAA\uCCAE",5,"\uCCB6\uCCB7\uCCB9"],["ab61","\uCCBA\uCCBB\uCCBD",6,"\uCCC6\uCCC8\uCCCA",5,"\uCCD1\uCCD2\uCCD3\uCCD5",5],["ab81","\uCCDB",8,"\uCCE5",6,"\uCCED\uCCEE\uCCEF\uCCF1",12,"\u30A1",85],["ac41","\uCCFE\uCCFF\uCD00\uCD02",5,"\uCD0A\uCD0B\uCD0D\uCD0E\uCD0F\uCD11",6,"\uCD1A\uCD1C\uCD1E\uCD1F\uCD20"],["ac61","\uCD21\uCD22\uCD23\uCD25\uCD26\uCD27\uCD29\uCD2A\uCD2B\uCD2D",11,"\uCD3A",4],["ac81","\uCD3F",28,"\uCD5D\uCD5E\uCD5F\u0410",5,"\u0401\u0416",25],["acd1","\u0430",5,"\u0451\u0436",25],["ad41","\uCD61\uCD62\uCD63\uCD65",6,"\uCD6E\uCD70\uCD72",5,"\uCD79",7],["ad61","\uCD81",6,"\uCD89",10,"\uCD96\uCD97\uCD99\uCD9A\uCD9B\uCD9D\uCD9E\uCD9F"],["ad81","\uCDA0\uCDA1\uCDA2\uCDA3\uCDA6\uCDA8\uCDAA",5,"\uCDB1",18,"\uCDC5"],["ae41","\uCDC6",5,"\uCDCD\uCDCE\uCDCF\uCDD1",16],["ae61","\uCDE2",5,"\uCDE9\uCDEA\uCDEB\uCDED\uCDEE\uCDEF\uCDF1",6,"\uCDFA\uCDFC\uCDFE",4],["ae81","\uCE03\uCE05\uCE06\uCE07\uCE09\uCE0A\uCE0B\uCE0D",6,"\uCE15\uCE16\uCE17\uCE18\uCE1A",5,"\uCE22\uCE23\uCE25\uCE26\uCE27\uCE29\uCE2A\uCE2B"],["af41","\uCE2C\uCE2D\uCE2E\uCE2F\uCE32\uCE34\uCE36",19],["af61","\uCE4A",13,"\uCE5A\uCE5B\uCE5D\uCE5E\uCE62",5,"\uCE6A\uCE6C"],["af81","\uCE6E",5,"\uCE76\uCE77\uCE79\uCE7A\uCE7B\uCE7D",6,"\uCE86\uCE88\uCE8A",5,"\uCE92\uCE93\uCE95\uCE96\uCE97\uCE99"],["b041","\uCE9A",5,"\uCEA2\uCEA6",5,"\uCEAE",12],["b061","\uCEBB",5,"\uCEC2",19],["b081","\uCED6",13,"\uCEE6\uCEE7\uCEE9\uCEEA\uCEED",6,"\uCEF6\uCEFA",5,"\uAC00\uAC01\uAC04\uAC07\uAC08\uAC09\uAC0A\uAC10",7,"\uAC19",4,"\uAC20\uAC24\uAC2C\uAC2D\uAC2F\uAC30\uAC31\uAC38\uAC39\uAC3C\uAC40\uAC4B\uAC4D\uAC54\uAC58\uAC5C\uAC70\uAC71\uAC74\uAC77\uAC78\uAC7A\uAC80\uAC81\uAC83\uAC84\uAC85\uAC86\uAC89\uAC8A\uAC8B\uAC8C\uAC90\uAC94\uAC9C\uAC9D\uAC9F\uACA0\uACA1\uACA8\uACA9\uACAA\uACAC\uACAF\uACB0\uACB8\uACB9\uACBB\uACBC\uACBD\uACC1\uACC4\uACC8\uACCC\uACD5\uACD7\uACE0\uACE1\uACE4\uACE7\uACE8\uACEA\uACEC\uACEF\uACF0\uACF1\uACF3\uACF5\uACF6\uACFC\uACFD\uAD00\uAD04\uAD06"],["b141","\uCF02\uCF03\uCF05\uCF06\uCF07\uCF09",6,"\uCF12\uCF14\uCF16",5,"\uCF1D\uCF1E\uCF1F\uCF21\uCF22\uCF23"],["b161","\uCF25",6,"\uCF2E\uCF32",5,"\uCF39",11],["b181","\uCF45",14,"\uCF56\uCF57\uCF59\uCF5A\uCF5B\uCF5D",6,"\uCF66\uCF68\uCF6A\uCF6B\uCF6C\uAD0C\uAD0D\uAD0F\uAD11\uAD18\uAD1C\uAD20\uAD29\uAD2C\uAD2D\uAD34\uAD35\uAD38\uAD3C\uAD44\uAD45\uAD47\uAD49\uAD50\uAD54\uAD58\uAD61\uAD63\uAD6C\uAD6D\uAD70\uAD73\uAD74\uAD75\uAD76\uAD7B\uAD7C\uAD7D\uAD7F\uAD81\uAD82\uAD88\uAD89\uAD8C\uAD90\uAD9C\uAD9D\uADA4\uADB7\uADC0\uADC1\uADC4\uADC8\uADD0\uADD1\uADD3\uADDC\uADE0\uADE4\uADF8\uADF9\uADFC\uADFF\uAE00\uAE01\uAE08\uAE09\uAE0B\uAE0D\uAE14\uAE30\uAE31\uAE34\uAE37\uAE38\uAE3A\uAE40\uAE41\uAE43\uAE45\uAE46\uAE4A\uAE4C\uAE4D\uAE4E\uAE50\uAE54\uAE56\uAE5C\uAE5D\uAE5F\uAE60\uAE61\uAE65\uAE68\uAE69\uAE6C\uAE70\uAE78"],["b241","\uCF6D\uCF6E\uCF6F\uCF72\uCF73\uCF75\uCF76\uCF77\uCF79",6,"\uCF81\uCF82\uCF83\uCF84\uCF86",5,"\uCF8D"],["b261","\uCF8E",18,"\uCFA2",5,"\uCFA9"],["b281","\uCFAA",5,"\uCFB1",18,"\uCFC5",6,"\uAE79\uAE7B\uAE7C\uAE7D\uAE84\uAE85\uAE8C\uAEBC\uAEBD\uAEBE\uAEC0\uAEC4\uAECC\uAECD\uAECF\uAED0\uAED1\uAED8\uAED9\uAEDC\uAEE8\uAEEB\uAEED\uAEF4\uAEF8\uAEFC\uAF07\uAF08\uAF0D\uAF10\uAF2C\uAF2D\uAF30\uAF32\uAF34\uAF3C\uAF3D\uAF3F\uAF41\uAF42\uAF43\uAF48\uAF49\uAF50\uAF5C\uAF5D\uAF64\uAF65\uAF79\uAF80\uAF84\uAF88\uAF90\uAF91\uAF95\uAF9C\uAFB8\uAFB9\uAFBC\uAFC0\uAFC7\uAFC8\uAFC9\uAFCB\uAFCD\uAFCE\uAFD4\uAFDC\uAFE8\uAFE9\uAFF0\uAFF1\uAFF4\uAFF8\uB000\uB001\uB004\uB00C\uB010\uB014\uB01C\uB01D\uB028\uB044\uB045\uB048\uB04A\uB04C\uB04E\uB053\uB054\uB055\uB057\uB059"],["b341","\uCFCC",19,"\uCFE2\uCFE3\uCFE5\uCFE6\uCFE7\uCFE9"],["b361","\uCFEA",5,"\uCFF2\uCFF4\uCFF6",5,"\uCFFD\uCFFE\uCFFF\uD001\uD002\uD003\uD005",5],["b381","\uD00B",5,"\uD012",5,"\uD019",19,"\uB05D\uB07C\uB07D\uB080\uB084\uB08C\uB08D\uB08F\uB091\uB098\uB099\uB09A\uB09C\uB09F\uB0A0\uB0A1\uB0A2\uB0A8\uB0A9\uB0AB",4,"\uB0B1\uB0B3\uB0B4\uB0B5\uB0B8\uB0BC\uB0C4\uB0C5\uB0C7\uB0C8\uB0C9\uB0D0\uB0D1\uB0D4\uB0D8\uB0E0\uB0E5\uB108\uB109\uB10B\uB10C\uB110\uB112\uB113\uB118\uB119\uB11B\uB11C\uB11D\uB123\uB124\uB125\uB128\uB12C\uB134\uB135\uB137\uB138\uB139\uB140\uB141\uB144\uB148\uB150\uB151\uB154\uB155\uB158\uB15C\uB160\uB178\uB179\uB17C\uB180\uB182\uB188\uB189\uB18B\uB18D\uB192\uB193\uB194\uB198\uB19C\uB1A8\uB1CC\uB1D0\uB1D4\uB1DC\uB1DD"],["b441","\uD02E",5,"\uD036\uD037\uD039\uD03A\uD03B\uD03D",6,"\uD046\uD048\uD04A",5],["b461","\uD051\uD052\uD053\uD055\uD056\uD057\uD059",6,"\uD061",10,"\uD06E\uD06F"],["b481","\uD071\uD072\uD073\uD075",6,"\uD07E\uD07F\uD080\uD082",18,"\uB1DF\uB1E8\uB1E9\uB1EC\uB1F0\uB1F9\uB1FB\uB1FD\uB204\uB205\uB208\uB20B\uB20C\uB214\uB215\uB217\uB219\uB220\uB234\uB23C\uB258\uB25C\uB260\uB268\uB269\uB274\uB275\uB27C\uB284\uB285\uB289\uB290\uB291\uB294\uB298\uB299\uB29A\uB2A0\uB2A1\uB2A3\uB2A5\uB2A6\uB2AA\uB2AC\uB2B0\uB2B4\uB2C8\uB2C9\uB2CC\uB2D0\uB2D2\uB2D8\uB2D9\uB2DB\uB2DD\uB2E2\uB2E4\uB2E5\uB2E6\uB2E8\uB2EB",4,"\uB2F3\uB2F4\uB2F5\uB2F7",4,"\uB2FF\uB300\uB301\uB304\uB308\uB310\uB311\uB313\uB314\uB315\uB31C\uB354\uB355\uB356\uB358\uB35B\uB35C\uB35E\uB35F\uB364\uB365"],["b541","\uD095",14,"\uD0A6\uD0A7\uD0A9\uD0AA\uD0AB\uD0AD",5],["b561","\uD0B3\uD0B6\uD0B8\uD0BA",5,"\uD0C2\uD0C3\uD0C5\uD0C6\uD0C7\uD0CA",5,"\uD0D2\uD0D6",4],["b581","\uD0DB\uD0DE\uD0DF\uD0E1\uD0E2\uD0E3\uD0E5",6,"\uD0EE\uD0F2",5,"\uD0F9",11,"\uB367\uB369\uB36B\uB36E\uB370\uB371\uB374\uB378\uB380\uB381\uB383\uB384\uB385\uB38C\uB390\uB394\uB3A0\uB3A1\uB3A8\uB3AC\uB3C4\uB3C5\uB3C8\uB3CB\uB3CC\uB3CE\uB3D0\uB3D4\uB3D5\uB3D7\uB3D9\uB3DB\uB3DD\uB3E0\uB3E4\uB3E8\uB3FC\uB410\uB418\uB41C\uB420\uB428\uB429\uB42B\uB434\uB450\uB451\uB454\uB458\uB460\uB461\uB463\uB465\uB46C\uB480\uB488\uB49D\uB4A4\uB4A8\uB4AC\uB4B5\uB4B7\uB4B9\uB4C0\uB4C4\uB4C8\uB4D0\uB4D5\uB4DC\uB4DD\uB4E0\uB4E3\uB4E4\uB4E6\uB4EC\uB4ED\uB4EF\uB4F1\uB4F8\uB514\uB515\uB518\uB51B\uB51C\uB524\uB525\uB527\uB528\uB529\uB52A\uB530\uB531\uB534\uB538"],["b641","\uD105",7,"\uD10E",17],["b661","\uD120",15,"\uD132\uD133\uD135\uD136\uD137\uD139\uD13B\uD13C\uD13D\uD13E"],["b681","\uD13F\uD142\uD146",5,"\uD14E\uD14F\uD151\uD152\uD153\uD155",6,"\uD15E\uD160\uD162",5,"\uD169\uD16A\uD16B\uD16D\uB540\uB541\uB543\uB544\uB545\uB54B\uB54C\uB54D\uB550\uB554\uB55C\uB55D\uB55F\uB560\uB561\uB5A0\uB5A1\uB5A4\uB5A8\uB5AA\uB5AB\uB5B0\uB5B1\uB5B3\uB5B4\uB5B5\uB5BB\uB5BC\uB5BD\uB5C0\uB5C4\uB5CC\uB5CD\uB5CF\uB5D0\uB5D1\uB5D8\uB5EC\uB610\uB611\uB614\uB618\uB625\uB62C\uB634\uB648\uB664\uB668\uB69C\uB69D\uB6A0\uB6A4\uB6AB\uB6AC\uB6B1\uB6D4\uB6F0\uB6F4\uB6F8\uB700\uB701\uB705\uB728\uB729\uB72C\uB72F\uB730\uB738\uB739\uB73B\uB744\uB748\uB74C\uB754\uB755\uB760\uB764\uB768\uB770\uB771\uB773\uB775\uB77C\uB77D\uB780\uB784\uB78C\uB78D\uB78F\uB790\uB791\uB792\uB796\uB797"],["b741","\uD16E",13,"\uD17D",6,"\uD185\uD186\uD187\uD189\uD18A"],["b761","\uD18B",20,"\uD1A2\uD1A3\uD1A5\uD1A6\uD1A7"],["b781","\uD1A9",6,"\uD1B2\uD1B4\uD1B6\uD1B7\uD1B8\uD1B9\uD1BB\uD1BD\uD1BE\uD1BF\uD1C1",14,"\uB798\uB799\uB79C\uB7A0\uB7A8\uB7A9\uB7AB\uB7AC\uB7AD\uB7B4\uB7B5\uB7B8\uB7C7\uB7C9\uB7EC\uB7ED\uB7F0\uB7F4\uB7FC\uB7FD\uB7FF\uB800\uB801\uB807\uB808\uB809\uB80C\uB810\uB818\uB819\uB81B\uB81D\uB824\uB825\uB828\uB82C\uB834\uB835\uB837\uB838\uB839\uB840\uB844\uB851\uB853\uB85C\uB85D\uB860\uB864\uB86C\uB86D\uB86F\uB871\uB878\uB87C\uB88D\uB8A8\uB8B0\uB8B4\uB8B8\uB8C0\uB8C1\uB8C3\uB8C5\uB8CC\uB8D0\uB8D4\uB8DD\uB8DF\uB8E1\uB8E8\uB8E9\uB8EC\uB8F0\uB8F8\uB8F9\uB8FB\uB8FD\uB904\uB918\uB920\uB93C\uB93D\uB940\uB944\uB94C\uB94F\uB951\uB958\uB959\uB95C\uB960\uB968\uB969"],["b841","\uD1D0",7,"\uD1D9",17],["b861","\uD1EB",8,"\uD1F5\uD1F6\uD1F7\uD1F9",13],["b881","\uD208\uD20A",5,"\uD211",24,"\uB96B\uB96D\uB974\uB975\uB978\uB97C\uB984\uB985\uB987\uB989\uB98A\uB98D\uB98E\uB9AC\uB9AD\uB9B0\uB9B4\uB9BC\uB9BD\uB9BF\uB9C1\uB9C8\uB9C9\uB9CC\uB9CE",4,"\uB9D8\uB9D9\uB9DB\uB9DD\uB9DE\uB9E1\uB9E3\uB9E4\uB9E5\uB9E8\uB9EC\uB9F4\uB9F5\uB9F7\uB9F8\uB9F9\uB9FA\uBA00\uBA01\uBA08\uBA15\uBA38\uBA39\uBA3C\uBA40\uBA42\uBA48\uBA49\uBA4B\uBA4D\uBA4E\uBA53\uBA54\uBA55\uBA58\uBA5C\uBA64\uBA65\uBA67\uBA68\uBA69\uBA70\uBA71\uBA74\uBA78\uBA83\uBA84\uBA85\uBA87\uBA8C\uBAA8\uBAA9\uBAAB\uBAAC\uBAB0\uBAB2\uBAB8\uBAB9\uBABB\uBABD\uBAC4\uBAC8\uBAD8\uBAD9\uBAFC"],["b941","\uD22A\uD22B\uD22E\uD22F\uD231\uD232\uD233\uD235",6,"\uD23E\uD240\uD242",5,"\uD249\uD24A\uD24B\uD24C"],["b961","\uD24D",14,"\uD25D",6,"\uD265\uD266\uD267\uD268"],["b981","\uD269",22,"\uD282\uD283\uD285\uD286\uD287\uD289\uD28A\uD28B\uD28C\uBB00\uBB04\uBB0D\uBB0F\uBB11\uBB18\uBB1C\uBB20\uBB29\uBB2B\uBB34\uBB35\uBB36\uBB38\uBB3B\uBB3C\uBB3D\uBB3E\uBB44\uBB45\uBB47\uBB49\uBB4D\uBB4F\uBB50\uBB54\uBB58\uBB61\uBB63\uBB6C\uBB88\uBB8C\uBB90\uBBA4\uBBA8\uBBAC\uBBB4\uBBB7\uBBC0\uBBC4\uBBC8\uBBD0\uBBD3\uBBF8\uBBF9\uBBFC\uBBFF\uBC00\uBC02\uBC08\uBC09\uBC0B\uBC0C\uBC0D\uBC0F\uBC11\uBC14",4,"\uBC1B",4,"\uBC24\uBC25\uBC27\uBC29\uBC2D\uBC30\uBC31\uBC34\uBC38\uBC40\uBC41\uBC43\uBC44\uBC45\uBC49\uBC4C\uBC4D\uBC50\uBC5D\uBC84\uBC85\uBC88\uBC8B\uBC8C\uBC8E\uBC94\uBC95\uBC97"],["ba41","\uD28D\uD28E\uD28F\uD292\uD293\uD294\uD296",5,"\uD29D\uD29E\uD29F\uD2A1\uD2A2\uD2A3\uD2A5",6,"\uD2AD"],["ba61","\uD2AE\uD2AF\uD2B0\uD2B2",5,"\uD2BA\uD2BB\uD2BD\uD2BE\uD2C1\uD2C3",4,"\uD2CA\uD2CC",5],["ba81","\uD2D2\uD2D3\uD2D5\uD2D6\uD2D7\uD2D9\uD2DA\uD2DB\uD2DD",6,"\uD2E6",9,"\uD2F2\uD2F3\uD2F5\uD2F6\uD2F7\uD2F9\uD2FA\uBC99\uBC9A\uBCA0\uBCA1\uBCA4\uBCA7\uBCA8\uBCB0\uBCB1\uBCB3\uBCB4\uBCB5\uBCBC\uBCBD\uBCC0\uBCC4\uBCCD\uBCCF\uBCD0\uBCD1\uBCD5\uBCD8\uBCDC\uBCF4\uBCF5\uBCF6\uBCF8\uBCFC\uBD04\uBD05\uBD07\uBD09\uBD10\uBD14\uBD24\uBD2C\uBD40\uBD48\uBD49\uBD4C\uBD50\uBD58\uBD59\uBD64\uBD68\uBD80\uBD81\uBD84\uBD87\uBD88\uBD89\uBD8A\uBD90\uBD91\uBD93\uBD95\uBD99\uBD9A\uBD9C\uBDA4\uBDB0\uBDB8\uBDD4\uBDD5\uBDD8\uBDDC\uBDE9\uBDF0\uBDF4\uBDF8\uBE00\uBE03\uBE05\uBE0C\uBE0D\uBE10\uBE14\uBE1C\uBE1D\uBE1F\uBE44\uBE45\uBE48\uBE4C\uBE4E\uBE54\uBE55\uBE57\uBE59\uBE5A\uBE5B\uBE60\uBE61\uBE64"],["bb41","\uD2FB",4,"\uD302\uD304\uD306",5,"\uD30F\uD311\uD312\uD313\uD315\uD317",4,"\uD31E\uD322\uD323"],["bb61","\uD324\uD326\uD327\uD32A\uD32B\uD32D\uD32E\uD32F\uD331",6,"\uD33A\uD33E",5,"\uD346\uD347\uD348\uD349"],["bb81","\uD34A",31,"\uBE68\uBE6A\uBE70\uBE71\uBE73\uBE74\uBE75\uBE7B\uBE7C\uBE7D\uBE80\uBE84\uBE8C\uBE8D\uBE8F\uBE90\uBE91\uBE98\uBE99\uBEA8\uBED0\uBED1\uBED4\uBED7\uBED8\uBEE0\uBEE3\uBEE4\uBEE5\uBEEC\uBF01\uBF08\uBF09\uBF18\uBF19\uBF1B\uBF1C\uBF1D\uBF40\uBF41\uBF44\uBF48\uBF50\uBF51\uBF55\uBF94\uBFB0\uBFC5\uBFCC\uBFCD\uBFD0\uBFD4\uBFDC\uBFDF\uBFE1\uC03C\uC051\uC058\uC05C\uC060\uC068\uC069\uC090\uC091\uC094\uC098\uC0A0\uC0A1\uC0A3\uC0A5\uC0AC\uC0AD\uC0AF\uC0B0\uC0B3\uC0B4\uC0B5\uC0B6\uC0BC\uC0BD\uC0BF\uC0C0\uC0C1\uC0C5\uC0C8\uC0C9\uC0CC\uC0D0\uC0D8\uC0D9\uC0DB\uC0DC\uC0DD\uC0E4"],["bc41","\uD36A",17,"\uD37E\uD37F\uD381\uD382\uD383\uD385\uD386\uD387"],["bc61","\uD388\uD389\uD38A\uD38B\uD38E\uD392",5,"\uD39A\uD39B\uD39D\uD39E\uD39F\uD3A1",6,"\uD3AA\uD3AC\uD3AE"],["bc81","\uD3AF",4,"\uD3B5\uD3B6\uD3B7\uD3B9\uD3BA\uD3BB\uD3BD",6,"\uD3C6\uD3C7\uD3CA",5,"\uD3D1",5,"\uC0E5\uC0E8\uC0EC\uC0F4\uC0F5\uC0F7\uC0F9\uC100\uC104\uC108\uC110\uC115\uC11C",4,"\uC123\uC124\uC126\uC127\uC12C\uC12D\uC12F\uC130\uC131\uC136\uC138\uC139\uC13C\uC140\uC148\uC149\uC14B\uC14C\uC14D\uC154\uC155\uC158\uC15C\uC164\uC165\uC167\uC168\uC169\uC170\uC174\uC178\uC185\uC18C\uC18D\uC18E\uC190\uC194\uC196\uC19C\uC19D\uC19F\uC1A1\uC1A5\uC1A8\uC1A9\uC1AC\uC1B0\uC1BD\uC1C4\uC1C8\uC1CC\uC1D4\uC1D7\uC1D8\uC1E0\uC1E4\uC1E8\uC1F0\uC1F1\uC1F3\uC1FC\uC1FD\uC200\uC204\uC20C\uC20D\uC20F\uC211\uC218\uC219\uC21C\uC21F\uC220\uC228\uC229\uC22B\uC22D"],["bd41","\uD3D7\uD3D9",7,"\uD3E2\uD3E4",7,"\uD3EE\uD3EF\uD3F1\uD3F2\uD3F3\uD3F5\uD3F6\uD3F7"],["bd61","\uD3F8\uD3F9\uD3FA\uD3FB\uD3FE\uD400\uD402",5,"\uD409",13],["bd81","\uD417",5,"\uD41E",25,"\uC22F\uC231\uC232\uC234\uC248\uC250\uC251\uC254\uC258\uC260\uC265\uC26C\uC26D\uC270\uC274\uC27C\uC27D\uC27F\uC281\uC288\uC289\uC290\uC298\uC29B\uC29D\uC2A4\uC2A5\uC2A8\uC2AC\uC2AD\uC2B4\uC2B5\uC2B7\uC2B9\uC2DC\uC2DD\uC2E0\uC2E3\uC2E4\uC2EB\uC2EC\uC2ED\uC2EF\uC2F1\uC2F6\uC2F8\uC2F9\uC2FB\uC2FC\uC300\uC308\uC309\uC30C\uC30D\uC313\uC314\uC315\uC318\uC31C\uC324\uC325\uC328\uC329\uC345\uC368\uC369\uC36C\uC370\uC372\uC378\uC379\uC37C\uC37D\uC384\uC388\uC38C\uC3C0\uC3D8\uC3D9\uC3DC\uC3DF\uC3E0\uC3E2\uC3E8\uC3E9\uC3ED\uC3F4\uC3F5\uC3F8\uC408\uC410\uC424\uC42C\uC430"],["be41","\uD438",7,"\uD441\uD442\uD443\uD445",14],["be61","\uD454",7,"\uD45D\uD45E\uD45F\uD461\uD462\uD463\uD465",7,"\uD46E\uD470\uD471\uD472"],["be81","\uD473",4,"\uD47A\uD47B\uD47D\uD47E\uD481\uD483",4,"\uD48A\uD48C\uD48E",5,"\uD495",8,"\uC434\uC43C\uC43D\uC448\uC464\uC465\uC468\uC46C\uC474\uC475\uC479\uC480\uC494\uC49C\uC4B8\uC4BC\uC4E9\uC4F0\uC4F1\uC4F4\uC4F8\uC4FA\uC4FF\uC500\uC501\uC50C\uC510\uC514\uC51C\uC528\uC529\uC52C\uC530\uC538\uC539\uC53B\uC53D\uC544\uC545\uC548\uC549\uC54A\uC54C\uC54D\uC54E\uC553\uC554\uC555\uC557\uC558\uC559\uC55D\uC55E\uC560\uC561\uC564\uC568\uC570\uC571\uC573\uC574\uC575\uC57C\uC57D\uC580\uC584\uC587\uC58C\uC58D\uC58F\uC591\uC595\uC597\uC598\uC59C\uC5A0\uC5A9\uC5B4\uC5B5\uC5B8\uC5B9\uC5BB\uC5BC\uC5BD\uC5BE\uC5C4",6,"\uC5CC\uC5CE"],["bf41","\uD49E",10,"\uD4AA",14],["bf61","\uD4B9",18,"\uD4CD\uD4CE\uD4CF\uD4D1\uD4D2\uD4D3\uD4D5"],["bf81","\uD4D6",5,"\uD4DD\uD4DE\uD4E0",7,"\uD4E9\uD4EA\uD4EB\uD4ED\uD4EE\uD4EF\uD4F1",6,"\uD4F9\uD4FA\uD4FC\uC5D0\uC5D1\uC5D4\uC5D8\uC5E0\uC5E1\uC5E3\uC5E5\uC5EC\uC5ED\uC5EE\uC5F0\uC5F4\uC5F6\uC5F7\uC5FC",5,"\uC605\uC606\uC607\uC608\uC60C\uC610\uC618\uC619\uC61B\uC61C\uC624\uC625\uC628\uC62C\uC62D\uC62E\uC630\uC633\uC634\uC635\uC637\uC639\uC63B\uC640\uC641\uC644\uC648\uC650\uC651\uC653\uC654\uC655\uC65C\uC65D\uC660\uC66C\uC66F\uC671\uC678\uC679\uC67C\uC680\uC688\uC689\uC68B\uC68D\uC694\uC695\uC698\uC69C\uC6A4\uC6A5\uC6A7\uC6A9\uC6B0\uC6B1\uC6B4\uC6B8\uC6B9\uC6BA\uC6C0\uC6C1\uC6C3\uC6C5\uC6CC\uC6CD\uC6D0\uC6D4\uC6DC\uC6DD\uC6E0\uC6E1\uC6E8"],["c041","\uD4FE",5,"\uD505\uD506\uD507\uD509\uD50A\uD50B\uD50D",6,"\uD516\uD518",5],["c061","\uD51E",25],["c081","\uD538\uD539\uD53A\uD53B\uD53E\uD53F\uD541\uD542\uD543\uD545",6,"\uD54E\uD550\uD552",5,"\uD55A\uD55B\uD55D\uD55E\uD55F\uD561\uD562\uD563\uC6E9\uC6EC\uC6F0\uC6F8\uC6F9\uC6FD\uC704\uC705\uC708\uC70C\uC714\uC715\uC717\uC719\uC720\uC721\uC724\uC728\uC730\uC731\uC733\uC735\uC737\uC73C\uC73D\uC740\uC744\uC74A\uC74C\uC74D\uC74F\uC751",7,"\uC75C\uC760\uC768\uC76B\uC774\uC775\uC778\uC77C\uC77D\uC77E\uC783\uC784\uC785\uC787\uC788\uC789\uC78A\uC78E\uC790\uC791\uC794\uC796\uC797\uC798\uC79A\uC7A0\uC7A1\uC7A3\uC7A4\uC7A5\uC7A6\uC7AC\uC7AD\uC7B0\uC7B4\uC7BC\uC7BD\uC7BF\uC7C0\uC7C1\uC7C8\uC7C9\uC7CC\uC7CE\uC7D0\uC7D8\uC7DD\uC7E4\uC7E8\uC7EC\uC800\uC801\uC804\uC808\uC80A"],["c141","\uD564\uD566\uD567\uD56A\uD56C\uD56E",5,"\uD576\uD577\uD579\uD57A\uD57B\uD57D",6,"\uD586\uD58A\uD58B"],["c161","\uD58C\uD58D\uD58E\uD58F\uD591",19,"\uD5A6\uD5A7"],["c181","\uD5A8",31,"\uC810\uC811\uC813\uC815\uC816\uC81C\uC81D\uC820\uC824\uC82C\uC82D\uC82F\uC831\uC838\uC83C\uC840\uC848\uC849\uC84C\uC84D\uC854\uC870\uC871\uC874\uC878\uC87A\uC880\uC881\uC883\uC885\uC886\uC887\uC88B\uC88C\uC88D\uC894\uC89D\uC89F\uC8A1\uC8A8\uC8BC\uC8BD\uC8C4\uC8C8\uC8CC\uC8D4\uC8D5\uC8D7\uC8D9\uC8E0\uC8E1\uC8E4\uC8F5\uC8FC\uC8FD\uC900\uC904\uC905\uC906\uC90C\uC90D\uC90F\uC911\uC918\uC92C\uC934\uC950\uC951\uC954\uC958\uC960\uC961\uC963\uC96C\uC970\uC974\uC97C\uC988\uC989\uC98C\uC990\uC998\uC999\uC99B\uC99D\uC9C0\uC9C1\uC9C4\uC9C7\uC9C8\uC9CA\uC9D0\uC9D1\uC9D3"],["c241","\uD5CA\uD5CB\uD5CD\uD5CE\uD5CF\uD5D1\uD5D3",4,"\uD5DA\uD5DC\uD5DE",5,"\uD5E6\uD5E7\uD5E9\uD5EA\uD5EB\uD5ED\uD5EE"],["c261","\uD5EF",4,"\uD5F6\uD5F8\uD5FA",5,"\uD602\uD603\uD605\uD606\uD607\uD609",6,"\uD612"],["c281","\uD616",5,"\uD61D\uD61E\uD61F\uD621\uD622\uD623\uD625",7,"\uD62E",9,"\uD63A\uD63B\uC9D5\uC9D6\uC9D9\uC9DA\uC9DC\uC9DD\uC9E0\uC9E2\uC9E4\uC9E7\uC9EC\uC9ED\uC9EF\uC9F0\uC9F1\uC9F8\uC9F9\uC9FC\uCA00\uCA08\uCA09\uCA0B\uCA0C\uCA0D\uCA14\uCA18\uCA29\uCA4C\uCA4D\uCA50\uCA54\uCA5C\uCA5D\uCA5F\uCA60\uCA61\uCA68\uCA7D\uCA84\uCA98\uCABC\uCABD\uCAC0\uCAC4\uCACC\uCACD\uCACF\uCAD1\uCAD3\uCAD8\uCAD9\uCAE0\uCAEC\uCAF4\uCB08\uCB10\uCB14\uCB18\uCB20\uCB21\uCB41\uCB48\uCB49\uCB4C\uCB50\uCB58\uCB59\uCB5D\uCB64\uCB78\uCB79\uCB9C\uCBB8\uCBD4\uCBE4\uCBE7\uCBE9\uCC0C\uCC0D\uCC10\uCC14\uCC1C\uCC1D\uCC21\uCC22\uCC27\uCC28\uCC29\uCC2C\uCC2E\uCC30\uCC38\uCC39\uCC3B"],["c341","\uD63D\uD63E\uD63F\uD641\uD642\uD643\uD644\uD646\uD647\uD64A\uD64C\uD64E\uD64F\uD650\uD652\uD653\uD656\uD657\uD659\uD65A\uD65B\uD65D",4],["c361","\uD662",4,"\uD668\uD66A",5,"\uD672\uD673\uD675",11],["c381","\uD681\uD682\uD684\uD686",5,"\uD68E\uD68F\uD691\uD692\uD693\uD695",7,"\uD69E\uD6A0\uD6A2",5,"\uD6A9\uD6AA\uCC3C\uCC3D\uCC3E\uCC44\uCC45\uCC48\uCC4C\uCC54\uCC55\uCC57\uCC58\uCC59\uCC60\uCC64\uCC66\uCC68\uCC70\uCC75\uCC98\uCC99\uCC9C\uCCA0\uCCA8\uCCA9\uCCAB\uCCAC\uCCAD\uCCB4\uCCB5\uCCB8\uCCBC\uCCC4\uCCC5\uCCC7\uCCC9\uCCD0\uCCD4\uCCE4\uCCEC\uCCF0\uCD01\uCD08\uCD09\uCD0C\uCD10\uCD18\uCD19\uCD1B\uCD1D\uCD24\uCD28\uCD2C\uCD39\uCD5C\uCD60\uCD64\uCD6C\uCD6D\uCD6F\uCD71\uCD78\uCD88\uCD94\uCD95\uCD98\uCD9C\uCDA4\uCDA5\uCDA7\uCDA9\uCDB0\uCDC4\uCDCC\uCDD0\uCDE8\uCDEC\uCDF0\uCDF8\uCDF9\uCDFB\uCDFD\uCE04\uCE08\uCE0C\uCE14\uCE19\uCE20\uCE21\uCE24\uCE28\uCE30\uCE31\uCE33\uCE35"],["c441","\uD6AB\uD6AD\uD6AE\uD6AF\uD6B1",7,"\uD6BA\uD6BC",7,"\uD6C6\uD6C7\uD6C9\uD6CA\uD6CB"],["c461","\uD6CD\uD6CE\uD6CF\uD6D0\uD6D2\uD6D3\uD6D5\uD6D6\uD6D8\uD6DA",5,"\uD6E1\uD6E2\uD6E3\uD6E5\uD6E6\uD6E7\uD6E9",4],["c481","\uD6EE\uD6EF\uD6F1\uD6F2\uD6F3\uD6F4\uD6F6",5,"\uD6FE\uD6FF\uD701\uD702\uD703\uD705",11,"\uD712\uD713\uD714\uCE58\uCE59\uCE5C\uCE5F\uCE60\uCE61\uCE68\uCE69\uCE6B\uCE6D\uCE74\uCE75\uCE78\uCE7C\uCE84\uCE85\uCE87\uCE89\uCE90\uCE91\uCE94\uCE98\uCEA0\uCEA1\uCEA3\uCEA4\uCEA5\uCEAC\uCEAD\uCEC1\uCEE4\uCEE5\uCEE8\uCEEB\uCEEC\uCEF4\uCEF5\uCEF7\uCEF8\uCEF9\uCF00\uCF01\uCF04\uCF08\uCF10\uCF11\uCF13\uCF15\uCF1C\uCF20\uCF24\uCF2C\uCF2D\uCF2F\uCF30\uCF31\uCF38\uCF54\uCF55\uCF58\uCF5C\uCF64\uCF65\uCF67\uCF69\uCF70\uCF71\uCF74\uCF78\uCF80\uCF85\uCF8C\uCFA1\uCFA8\uCFB0\uCFC4\uCFE0\uCFE1\uCFE4\uCFE8\uCFF0\uCFF1\uCFF3\uCFF5\uCFFC\uD000\uD004\uD011\uD018\uD02D\uD034\uD035\uD038\uD03C"],["c541","\uD715\uD716\uD717\uD71A\uD71B\uD71D\uD71E\uD71F\uD721",6,"\uD72A\uD72C\uD72E",5,"\uD736\uD737\uD739"],["c561","\uD73A\uD73B\uD73D",6,"\uD745\uD746\uD748\uD74A",5,"\uD752\uD753\uD755\uD75A",4],["c581","\uD75F\uD762\uD764\uD766\uD767\uD768\uD76A\uD76B\uD76D\uD76E\uD76F\uD771\uD772\uD773\uD775",6,"\uD77E\uD77F\uD780\uD782",5,"\uD78A\uD78B\uD044\uD045\uD047\uD049\uD050\uD054\uD058\uD060\uD06C\uD06D\uD070\uD074\uD07C\uD07D\uD081\uD0A4\uD0A5\uD0A8\uD0AC\uD0B4\uD0B5\uD0B7\uD0B9\uD0C0\uD0C1\uD0C4\uD0C8\uD0C9\uD0D0\uD0D1\uD0D3\uD0D4\uD0D5\uD0DC\uD0DD\uD0E0\uD0E4\uD0EC\uD0ED\uD0EF\uD0F0\uD0F1\uD0F8\uD10D\uD130\uD131\uD134\uD138\uD13A\uD140\uD141\uD143\uD144\uD145\uD14C\uD14D\uD150\uD154\uD15C\uD15D\uD15F\uD161\uD168\uD16C\uD17C\uD184\uD188\uD1A0\uD1A1\uD1A4\uD1A8\uD1B0\uD1B1\uD1B3\uD1B5\uD1BA\uD1BC\uD1C0\uD1D8\uD1F4\uD1F8\uD207\uD209\uD210\uD22C\uD22D\uD230\uD234\uD23C\uD23D\uD23F\uD241\uD248\uD25C"],["c641","\uD78D\uD78E\uD78F\uD791",6,"\uD79A\uD79C\uD79E",5],["c6a1","\uD264\uD280\uD281\uD284\uD288\uD290\uD291\uD295\uD29C\uD2A0\uD2A4\uD2AC\uD2B1\uD2B8\uD2B9\uD2BC\uD2BF\uD2C0\uD2C2\uD2C8\uD2C9\uD2CB\uD2D4\uD2D8\uD2DC\uD2E4\uD2E5\uD2F0\uD2F1\uD2F4\uD2F8\uD300\uD301\uD303\uD305\uD30C\uD30D\uD30E\uD310\uD314\uD316\uD31C\uD31D\uD31F\uD320\uD321\uD325\uD328\uD329\uD32C\uD330\uD338\uD339\uD33B\uD33C\uD33D\uD344\uD345\uD37C\uD37D\uD380\uD384\uD38C\uD38D\uD38F\uD390\uD391\uD398\uD399\uD39C\uD3A0\uD3A8\uD3A9\uD3AB\uD3AD\uD3B4\uD3B8\uD3BC\uD3C4\uD3C5\uD3C8\uD3C9\uD3D0\uD3D8\uD3E1\uD3E3\uD3EC\uD3ED\uD3F0\uD3F4\uD3FC\uD3FD\uD3FF\uD401"],["c7a1","\uD408\uD41D\uD440\uD444\uD45C\uD460\uD464\uD46D\uD46F\uD478\uD479\uD47C\uD47F\uD480\uD482\uD488\uD489\uD48B\uD48D\uD494\uD4A9\uD4CC\uD4D0\uD4D4\uD4DC\uD4DF\uD4E8\uD4EC\uD4F0\uD4F8\uD4FB\uD4FD\uD504\uD508\uD50C\uD514\uD515\uD517\uD53C\uD53D\uD540\uD544\uD54C\uD54D\uD54F\uD551\uD558\uD559\uD55C\uD560\uD565\uD568\uD569\uD56B\uD56D\uD574\uD575\uD578\uD57C\uD584\uD585\uD587\uD588\uD589\uD590\uD5A5\uD5C8\uD5C9\uD5CC\uD5D0\uD5D2\uD5D8\uD5D9\uD5DB\uD5DD\uD5E4\uD5E5\uD5E8\uD5EC\uD5F4\uD5F5\uD5F7\uD5F9\uD600\uD601\uD604\uD608\uD610\uD611\uD613\uD614\uD615\uD61C\uD620"],["c8a1","\uD624\uD62D\uD638\uD639\uD63C\uD640\uD645\uD648\uD649\uD64B\uD64D\uD651\uD654\uD655\uD658\uD65C\uD667\uD669\uD670\uD671\uD674\uD683\uD685\uD68C\uD68D\uD690\uD694\uD69D\uD69F\uD6A1\uD6A8\uD6AC\uD6B0\uD6B9\uD6BB\uD6C4\uD6C5\uD6C8\uD6CC\uD6D1\uD6D4\uD6D7\uD6D9\uD6E0\uD6E4\uD6E8\uD6F0\uD6F5\uD6FC\uD6FD\uD700\uD704\uD711\uD718\uD719\uD71C\uD720\uD728\uD729\uD72B\uD72D\uD734\uD735\uD738\uD73C\uD744\uD747\uD749\uD750\uD751\uD754\uD756\uD757\uD758\uD759\uD760\uD761\uD763\uD765\uD769\uD76C\uD770\uD774\uD77C\uD77D\uD781\uD788\uD789\uD78C\uD790\uD798\uD799\uD79B\uD79D"],["caa1","\u4F3D\u4F73\u5047\u50F9\u52A0\u53EF\u5475\u54E5\u5609\u5AC1\u5BB6\u6687\u67B6\u67B7\u67EF\u6B4C\u73C2\u75C2\u7A3C\u82DB\u8304\u8857\u8888\u8A36\u8CC8\u8DCF\u8EFB\u8FE6\u99D5\u523B\u5374\u5404\u606A\u6164\u6BBC\u73CF\u811A\u89BA\u89D2\u95A3\u4F83\u520A\u58BE\u5978\u59E6\u5E72\u5E79\u61C7\u63C0\u6746\u67EC\u687F\u6F97\u764E\u770B\u78F5\u7A08\u7AFF\u7C21\u809D\u826E\u8271\u8AEB\u9593\u4E6B\u559D\u66F7\u6E34\u78A3\u7AED\u845B\u8910\u874E\u97A8\u52D8\u574E\u582A\u5D4C\u611F\u61BE\u6221\u6562\u67D1\u6A44\u6E1B\u7518\u75B3\u76E3\u77B0\u7D3A\u90AF\u9451\u9452\u9F95"],["cba1","\u5323\u5CAC\u7532\u80DB\u9240\u9598\u525B\u5808\u59DC\u5CA1\u5D17\u5EB7\u5F3A\u5F4A\u6177\u6C5F\u757A\u7586\u7CE0\u7D73\u7DB1\u7F8C\u8154\u8221\u8591\u8941\u8B1B\u92FC\u964D\u9C47\u4ECB\u4EF7\u500B\u51F1\u584F\u6137\u613E\u6168\u6539\u69EA\u6F11\u75A5\u7686\u76D6\u7B87\u82A5\u84CB\uF900\u93A7\u958B\u5580\u5BA2\u5751\uF901\u7CB3\u7FB9\u91B5\u5028\u53BB\u5C45\u5DE8\u62D2\u636E\u64DA\u64E7\u6E20\u70AC\u795B\u8DDD\u8E1E\uF902\u907D\u9245\u92F8\u4E7E\u4EF6\u5065\u5DFE\u5EFA\u6106\u6957\u8171\u8654\u8E47\u9375\u9A2B\u4E5E\u5091\u6770\u6840\u5109\u528D\u5292\u6AA2"],["cca1","\u77BC\u9210\u9ED4\u52AB\u602F\u8FF2\u5048\u61A9\u63ED\u64CA\u683C\u6A84\u6FC0\u8188\u89A1\u9694\u5805\u727D\u72AC\u7504\u7D79\u7E6D\u80A9\u898B\u8B74\u9063\u9D51\u6289\u6C7A\u6F54\u7D50\u7F3A\u8A23\u517C\u614A\u7B9D\u8B19\u9257\u938C\u4EAC\u4FD3\u501E\u50BE\u5106\u52C1\u52CD\u537F\u5770\u5883\u5E9A\u5F91\u6176\u61AC\u64CE\u656C\u666F\u66BB\u66F4\u6897\u6D87\u7085\u70F1\u749F\u74A5\u74CA\u75D9\u786C\u78EC\u7ADF\u7AF6\u7D45\u7D93\u8015\u803F\u811B\u8396\u8B66\u8F15\u9015\u93E1\u9803\u9838\u9A5A\u9BE8\u4FC2\u5553\u583A\u5951\u5B63\u5C46\u60B8\u6212\u6842\u68B0"],["cda1","\u68E8\u6EAA\u754C\u7678\u78CE\u7A3D\u7CFB\u7E6B\u7E7C\u8A08\u8AA1\u8C3F\u968E\u9DC4\u53E4\u53E9\u544A\u5471\u56FA\u59D1\u5B64\u5C3B\u5EAB\u62F7\u6537\u6545\u6572\u66A0\u67AF\u69C1\u6CBD\u75FC\u7690\u777E\u7A3F\u7F94\u8003\u80A1\u818F\u82E6\u82FD\u83F0\u85C1\u8831\u88B4\u8AA5\uF903\u8F9C\u932E\u96C7\u9867\u9AD8\u9F13\u54ED\u659B\u66F2\u688F\u7A40\u8C37\u9D60\u56F0\u5764\u5D11\u6606\u68B1\u68CD\u6EFE\u7428\u889E\u9BE4\u6C68\uF904\u9AA8\u4F9B\u516C\u5171\u529F\u5B54\u5DE5\u6050\u606D\u62F1\u63A7\u653B\u73D9\u7A7A\u86A3\u8CA2\u978F\u4E32\u5BE1\u6208\u679C\u74DC"],["cea1","\u79D1\u83D3\u8A87\u8AB2\u8DE8\u904E\u934B\u9846\u5ED3\u69E8\u85FF\u90ED\uF905\u51A0\u5B98\u5BEC\u6163\u68FA\u6B3E\u704C\u742F\u74D8\u7BA1\u7F50\u83C5\u89C0\u8CAB\u95DC\u9928\u522E\u605D\u62EC\u9002\u4F8A\u5149\u5321\u58D9\u5EE3\u66E0\u6D38\u709A\u72C2\u73D6\u7B50\u80F1\u945B\u5366\u639B\u7F6B\u4E56\u5080\u584A\u58DE\u602A\u6127\u62D0\u69D0\u9B41\u5B8F\u7D18\u80B1\u8F5F\u4EA4\u50D1\u54AC\u55AC\u5B0C\u5DA0\u5DE7\u652A\u654E\u6821\u6A4B\u72E1\u768E\u77EF\u7D5E\u7FF9\u81A0\u854E\u86DF\u8F03\u8F4E\u90CA\u9903\u9A55\u9BAB\u4E18\u4E45\u4E5D\u4EC7\u4FF1\u5177\u52FE"],["cfa1","\u5340\u53E3\u53E5\u548E\u5614\u5775\u57A2\u5BC7\u5D87\u5ED0\u61FC\u62D8\u6551\u67B8\u67E9\u69CB\u6B50\u6BC6\u6BEC\u6C42\u6E9D\u7078\u72D7\u7396\u7403\u77BF\u77E9\u7A76\u7D7F\u8009\u81FC\u8205\u820A\u82DF\u8862\u8B33\u8CFC\u8EC0\u9011\u90B1\u9264\u92B6\u99D2\u9A45\u9CE9\u9DD7\u9F9C\u570B\u5C40\u83CA\u97A0\u97AB\u9EB4\u541B\u7A98\u7FA4\u88D9\u8ECD\u90E1\u5800\u5C48\u6398\u7A9F\u5BAE\u5F13\u7A79\u7AAE\u828E\u8EAC\u5026\u5238\u52F8\u5377\u5708\u62F3\u6372\u6B0A\u6DC3\u7737\u53A5\u7357\u8568\u8E76\u95D5\u673A\u6AC3\u6F70\u8A6D\u8ECC\u994B\uF906\u6677\u6B78\u8CB4"],["d0a1","\u9B3C\uF907\u53EB\u572D\u594E\u63C6\u69FB\u73EA\u7845\u7ABA\u7AC5\u7CFE\u8475\u898F\u8D73\u9035\u95A8\u52FB\u5747\u7547\u7B60\u83CC\u921E\uF908\u6A58\u514B\u524B\u5287\u621F\u68D8\u6975\u9699\u50C5\u52A4\u52E4\u61C3\u65A4\u6839\u69FF\u747E\u7B4B\u82B9\u83EB\u89B2\u8B39\u8FD1\u9949\uF909\u4ECA\u5997\u64D2\u6611\u6A8E\u7434\u7981\u79BD\u82A9\u887E\u887F\u895F\uF90A\u9326\u4F0B\u53CA\u6025\u6271\u6C72\u7D1A\u7D66\u4E98\u5162\u77DC\u80AF\u4F01\u4F0E\u5176\u5180\u55DC\u5668\u573B\u57FA\u57FC\u5914\u5947\u5993\u5BC4\u5C90\u5D0E\u5DF1\u5E7E\u5FCC\u6280\u65D7\u65E3"],["d1a1","\u671E\u671F\u675E\u68CB\u68C4\u6A5F\u6B3A\u6C23\u6C7D\u6C82\u6DC7\u7398\u7426\u742A\u7482\u74A3\u7578\u757F\u7881\u78EF\u7941\u7947\u7948\u797A\u7B95\u7D00\u7DBA\u7F88\u8006\u802D\u808C\u8A18\u8B4F\u8C48\u8D77\u9321\u9324\u98E2\u9951\u9A0E\u9A0F\u9A65\u9E92\u7DCA\u4F76\u5409\u62EE\u6854\u91D1\u55AB\u513A\uF90B\uF90C\u5A1C\u61E6\uF90D\u62CF\u62FF\uF90E",5,"\u90A3\uF914",4,"\u8AFE\uF919\uF91A\uF91B\uF91C\u6696\uF91D\u7156\uF91E\uF91F\u96E3\uF920\u634F\u637A\u5357\uF921\u678F\u6960\u6E73\uF922\u7537\uF923\uF924\uF925"],["d2a1","\u7D0D\uF926\uF927\u8872\u56CA\u5A18\uF928",4,"\u4E43\uF92D\u5167\u5948\u67F0\u8010\uF92E\u5973\u5E74\u649A\u79CA\u5FF5\u606C\u62C8\u637B\u5BE7\u5BD7\u52AA\uF92F\u5974\u5F29\u6012\uF930\uF931\uF932\u7459\uF933",5,"\u99D1\uF939",10,"\u6FC3\uF944\uF945\u81BF\u8FB2\u60F1\uF946\uF947\u8166\uF948\uF949\u5C3F\uF94A",7,"\u5AE9\u8A25\u677B\u7D10\uF952",5,"\u80FD\uF958\uF959\u5C3C\u6CE5\u533F\u6EBA\u591A\u8336"],["d3a1","\u4E39\u4EB6\u4F46\u55AE\u5718\u58C7\u5F56\u65B7\u65E6\u6A80\u6BB5\u6E4D\u77ED\u7AEF\u7C1E\u7DDE\u86CB\u8892\u9132\u935B\u64BB\u6FBE\u737A\u75B8\u9054\u5556\u574D\u61BA\u64D4\u66C7\u6DE1\u6E5B\u6F6D\u6FB9\u75F0\u8043\u81BD\u8541\u8983\u8AC7\u8B5A\u931F\u6C93\u7553\u7B54\u8E0F\u905D\u5510\u5802\u5858\u5E62\u6207\u649E\u68E0\u7576\u7CD6\u87B3\u9EE8\u4EE3\u5788\u576E\u5927\u5C0D\u5CB1\u5E36\u5F85\u6234\u64E1\u73B3\u81FA\u888B\u8CB8\u968A\u9EDB\u5B85\u5FB7\u60B3\u5012\u5200\u5230\u5716\u5835\u5857\u5C0E\u5C60\u5CF6\u5D8B\u5EA6\u5F92\u60BC\u6311\u6389\u6417\u6843"],["d4a1","\u68F9\u6AC2\u6DD8\u6E21\u6ED4\u6FE4\u71FE\u76DC\u7779\u79B1\u7A3B\u8404\u89A9\u8CED\u8DF3\u8E48\u9003\u9014\u9053\u90FD\u934D\u9676\u97DC\u6BD2\u7006\u7258\u72A2\u7368\u7763\u79BF\u7BE4\u7E9B\u8B80\u58A9\u60C7\u6566\u65FD\u66BE\u6C8C\u711E\u71C9\u8C5A\u9813\u4E6D\u7A81\u4EDD\u51AC\u51CD\u52D5\u540C\u61A7\u6771\u6850\u68DF\u6D1E\u6F7C\u75BC\u77B3\u7AE5\u80F4\u8463\u9285\u515C\u6597\u675C\u6793\u75D8\u7AC7\u8373\uF95A\u8C46\u9017\u982D\u5C6F\u81C0\u829A\u9041\u906F\u920D\u5F97\u5D9D\u6A59\u71C8\u767B\u7B49\u85E4\u8B04\u9127\u9A30\u5587\u61F6\uF95B\u7669\u7F85"],["d5a1","\u863F\u87BA\u88F8\u908F\uF95C\u6D1B\u70D9\u73DE\u7D61\u843D\uF95D\u916A\u99F1\uF95E\u4E82\u5375\u6B04\u6B12\u703E\u721B\u862D\u9E1E\u524C\u8FA3\u5D50\u64E5\u652C\u6B16\u6FEB\u7C43\u7E9C\u85CD\u8964\u89BD\u62C9\u81D8\u881F\u5ECA\u6717\u6D6A\u72FC\u7405\u746F\u8782\u90DE\u4F86\u5D0D\u5FA0\u840A\u51B7\u63A0\u7565\u4EAE\u5006\u5169\u51C9\u6881\u6A11\u7CAE\u7CB1\u7CE7\u826F\u8AD2\u8F1B\u91CF\u4FB6\u5137\u52F5\u5442\u5EEC\u616E\u623E\u65C5\u6ADA\u6FFE\u792A\u85DC\u8823\u95AD\u9A62\u9A6A\u9E97\u9ECE\u529B\u66C6\u6B77\u701D\u792B\u8F62\u9742\u6190\u6200\u6523\u6F23"],["d6a1","\u7149\u7489\u7DF4\u806F\u84EE\u8F26\u9023\u934A\u51BD\u5217\u52A3\u6D0C\u70C8\u88C2\u5EC9\u6582\u6BAE\u6FC2\u7C3E\u7375\u4EE4\u4F36\u56F9\uF95F\u5CBA\u5DBA\u601C\u73B2\u7B2D\u7F9A\u7FCE\u8046\u901E\u9234\u96F6\u9748\u9818\u9F61\u4F8B\u6FA7\u79AE\u91B4\u96B7\u52DE\uF960\u6488\u64C4\u6AD3\u6F5E\u7018\u7210\u76E7\u8001\u8606\u865C\u8DEF\u8F05\u9732\u9B6F\u9DFA\u9E75\u788C\u797F\u7DA0\u83C9\u9304\u9E7F\u9E93\u8AD6\u58DF\u5F04\u6727\u7027\u74CF\u7C60\u807E\u5121\u7028\u7262\u78CA\u8CC2\u8CDA\u8CF4\u96F7\u4E86\u50DA\u5BEE\u5ED6\u6599\u71CE\u7642\u77AD\u804A\u84FC"],["d7a1","\u907C\u9B27\u9F8D\u58D8\u5A41\u5C62\u6A13\u6DDA\u6F0F\u763B\u7D2F\u7E37\u851E\u8938\u93E4\u964B\u5289\u65D2\u67F3\u69B4\u6D41\u6E9C\u700F\u7409\u7460\u7559\u7624\u786B\u8B2C\u985E\u516D\u622E\u9678\u4F96\u502B\u5D19\u6DEA\u7DB8\u8F2A\u5F8B\u6144\u6817\uF961\u9686\u52D2\u808B\u51DC\u51CC\u695E\u7A1C\u7DBE\u83F1\u9675\u4FDA\u5229\u5398\u540F\u550E\u5C65\u60A7\u674E\u68A8\u6D6C\u7281\u72F8\u7406\u7483\uF962\u75E2\u7C6C\u7F79\u7FB8\u8389\u88CF\u88E1\u91CC\u91D0\u96E2\u9BC9\u541D\u6F7E\u71D0\u7498\u85FA\u8EAA\u96A3\u9C57\u9E9F\u6797\u6DCB\u7433\u81E8\u9716\u782C"],["d8a1","\u7ACB\u7B20\u7C92\u6469\u746A\u75F2\u78BC\u78E8\u99AC\u9B54\u9EBB\u5BDE\u5E55\u6F20\u819C\u83AB\u9088\u4E07\u534D\u5A29\u5DD2\u5F4E\u6162\u633D\u6669\u66FC\u6EFF\u6F2B\u7063\u779E\u842C\u8513\u883B\u8F13\u9945\u9C3B\u551C\u62B9\u672B\u6CAB\u8309\u896A\u977A\u4EA1\u5984\u5FD8\u5FD9\u671B\u7DB2\u7F54\u8292\u832B\u83BD\u8F1E\u9099\u57CB\u59B9\u5A92\u5BD0\u6627\u679A\u6885\u6BCF\u7164\u7F75\u8CB7\u8CE3\u9081\u9B45\u8108\u8C8A\u964C\u9A40\u9EA5\u5B5F\u6C13\u731B\u76F2\u76DF\u840C\u51AA\u8993\u514D\u5195\u52C9\u68C9\u6C94\u7704\u7720\u7DBF\u7DEC\u9762\u9EB5\u6EC5"],["d9a1","\u8511\u51A5\u540D\u547D\u660E\u669D\u6927\u6E9F\u76BF\u7791\u8317\u84C2\u879F\u9169\u9298\u9CF4\u8882\u4FAE\u5192\u52DF\u59C6\u5E3D\u6155\u6478\u6479\u66AE\u67D0\u6A21\u6BCD\u6BDB\u725F\u7261\u7441\u7738\u77DB\u8017\u82BC\u8305\u8B00\u8B28\u8C8C\u6728\u6C90\u7267\u76EE\u7766\u7A46\u9DA9\u6B7F\u6C92\u5922\u6726\u8499\u536F\u5893\u5999\u5EDF\u63CF\u6634\u6773\u6E3A\u732B\u7AD7\u82D7\u9328\u52D9\u5DEB\u61AE\u61CB\u620A\u62C7\u64AB\u65E0\u6959\u6B66\u6BCB\u7121\u73F7\u755D\u7E46\u821E\u8302\u856A\u8AA3\u8CBF\u9727\u9D61\u58A8\u9ED8\u5011\u520E\u543B\u554F\u6587"],["daa1","\u6C76\u7D0A\u7D0B\u805E\u868A\u9580\u96EF\u52FF\u6C95\u7269\u5473\u5A9A\u5C3E\u5D4B\u5F4C\u5FAE\u672A\u68B6\u6963\u6E3C\u6E44\u7709\u7C73\u7F8E\u8587\u8B0E\u8FF7\u9761\u9EF4\u5CB7\u60B6\u610D\u61AB\u654F\u65FB\u65FC\u6C11\u6CEF\u739F\u73C9\u7DE1\u9594\u5BC6\u871C\u8B10\u525D\u535A\u62CD\u640F\u64B2\u6734\u6A38\u6CCA\u73C0\u749E\u7B94\u7C95\u7E1B\u818A\u8236\u8584\u8FEB\u96F9\u99C1\u4F34\u534A\u53CD\u53DB\u62CC\u642C\u6500\u6591\u69C3\u6CEE\u6F58\u73ED\u7554\u7622\u76E4\u76FC\u78D0\u78FB\u792C\u7D46\u822C\u87E0\u8FD4\u9812\u98EF\u52C3\u62D4\u64A5\u6E24\u6F51"],["dba1","\u767C\u8DCB\u91B1\u9262\u9AEE\u9B43\u5023\u508D\u574A\u59A8\u5C28\u5E47\u5F77\u623F\u653E\u65B9\u65C1\u6609\u678B\u699C\u6EC2\u78C5\u7D21\u80AA\u8180\u822B\u82B3\u84A1\u868C\u8A2A\u8B17\u90A6\u9632\u9F90\u500D\u4FF3\uF963\u57F9\u5F98\u62DC\u6392\u676F\u6E43\u7119\u76C3\u80CC\u80DA\u88F4\u88F5\u8919\u8CE0\u8F29\u914D\u966A\u4F2F\u4F70\u5E1B\u67CF\u6822\u767D\u767E\u9B44\u5E61\u6A0A\u7169\u71D4\u756A\uF964\u7E41\u8543\u85E9\u98DC\u4F10\u7B4F\u7F70\u95A5\u51E1\u5E06\u68B5\u6C3E\u6C4E\u6CDB\u72AF\u7BC4\u8303\u6CD5\u743A\u50FB\u5288\u58C1\u64D8\u6A97\u74A7\u7656"],["dca1","\u78A7\u8617\u95E2\u9739\uF965\u535E\u5F01\u8B8A\u8FA8\u8FAF\u908A\u5225\u77A5\u9C49\u9F08\u4E19\u5002\u5175\u5C5B\u5E77\u661E\u663A\u67C4\u68C5\u70B3\u7501\u75C5\u79C9\u7ADD\u8F27\u9920\u9A08\u4FDD\u5821\u5831\u5BF6\u666E\u6B65\u6D11\u6E7A\u6F7D\u73E4\u752B\u83E9\u88DC\u8913\u8B5C\u8F14\u4F0F\u50D5\u5310\u535C\u5B93\u5FA9\u670D\u798F\u8179\u832F\u8514\u8907\u8986\u8F39\u8F3B\u99A5\u9C12\u672C\u4E76\u4FF8\u5949\u5C01\u5CEF\u5CF0\u6367\u68D2\u70FD\u71A2\u742B\u7E2B\u84EC\u8702\u9022\u92D2\u9CF3\u4E0D\u4ED8\u4FEF\u5085\u5256\u526F\u5426\u5490\u57E0\u592B\u5A66"],["dda1","\u5B5A\u5B75\u5BCC\u5E9C\uF966\u6276\u6577\u65A7\u6D6E\u6EA5\u7236\u7B26\u7C3F\u7F36\u8150\u8151\u819A\u8240\u8299\u83A9\u8A03\u8CA0\u8CE6\u8CFB\u8D74\u8DBA\u90E8\u91DC\u961C\u9644\u99D9\u9CE7\u5317\u5206\u5429\u5674\u58B3\u5954\u596E\u5FFF\u61A4\u626E\u6610\u6C7E\u711A\u76C6\u7C89\u7CDE\u7D1B\u82AC\u8CC1\u96F0\uF967\u4F5B\u5F17\u5F7F\u62C2\u5D29\u670B\u68DA\u787C\u7E43\u9D6C\u4E15\u5099\u5315\u532A\u5351\u5983\u5A62\u5E87\u60B2\u618A\u6249\u6279\u6590\u6787\u69A7\u6BD4\u6BD6\u6BD7\u6BD8\u6CB8\uF968\u7435\u75FA\u7812\u7891\u79D5\u79D8\u7C83\u7DCB\u7FE1\u80A5"],["dea1","\u813E\u81C2\u83F2\u871A\u88E8\u8AB9\u8B6C\u8CBB\u9119\u975E\u98DB\u9F3B\u56AC\u5B2A\u5F6C\u658C\u6AB3\u6BAF\u6D5C\u6FF1\u7015\u725D\u73AD\u8CA7\u8CD3\u983B\u6191\u6C37\u8058\u9A01\u4E4D\u4E8B\u4E9B\u4ED5\u4F3A\u4F3C\u4F7F\u4FDF\u50FF\u53F2\u53F8\u5506\u55E3\u56DB\u58EB\u5962\u5A11\u5BEB\u5BFA\u5C04\u5DF3\u5E2B\u5F99\u601D\u6368\u659C\u65AF\u67F6\u67FB\u68AD\u6B7B\u6C99\u6CD7\u6E23\u7009\u7345\u7802\u793E\u7940\u7960\u79C1\u7BE9\u7D17\u7D72\u8086\u820D\u838E\u84D1\u86C7\u88DF\u8A50\u8A5E\u8B1D\u8CDC\u8D66\u8FAD\u90AA\u98FC\u99DF\u9E9D\u524A\uF969\u6714\uF96A"],["dfa1","\u5098\u522A\u5C71\u6563\u6C55\u73CA\u7523\u759D\u7B97\u849C\u9178\u9730\u4E77\u6492\u6BBA\u715E\u85A9\u4E09\uF96B\u6749\u68EE\u6E17\u829F\u8518\u886B\u63F7\u6F81\u9212\u98AF\u4E0A\u50B7\u50CF\u511F\u5546\u55AA\u5617\u5B40\u5C19\u5CE0\u5E38\u5E8A\u5EA0\u5EC2\u60F3\u6851\u6A61\u6E58\u723D\u7240\u72C0\u76F8\u7965\u7BB1\u7FD4\u88F3\u89F4\u8A73\u8C61\u8CDE\u971C\u585E\u74BD\u8CFD\u55C7\uF96C\u7A61\u7D22\u8272\u7272\u751F\u7525\uF96D\u7B19\u5885\u58FB\u5DBC\u5E8F\u5EB6\u5F90\u6055\u6292\u637F\u654D\u6691\u66D9\u66F8\u6816\u68F2\u7280\u745E\u7B6E\u7D6E\u7DD6\u7F72"],["e0a1","\u80E5\u8212\u85AF\u897F\u8A93\u901D\u92E4\u9ECD\u9F20\u5915\u596D\u5E2D\u60DC\u6614\u6673\u6790\u6C50\u6DC5\u6F5F\u77F3\u78A9\u84C6\u91CB\u932B\u4ED9\u50CA\u5148\u5584\u5B0B\u5BA3\u6247\u657E\u65CB\u6E32\u717D\u7401\u7444\u7487\u74BF\u766C\u79AA\u7DDA\u7E55\u7FA8\u817A\u81B3\u8239\u861A\u87EC\u8A75\u8DE3\u9078\u9291\u9425\u994D\u9BAE\u5368\u5C51\u6954\u6CC4\u6D29\u6E2B\u820C\u859B\u893B\u8A2D\u8AAA\u96EA\u9F67\u5261\u66B9\u6BB2\u7E96\u87FE\u8D0D\u9583\u965D\u651D\u6D89\u71EE\uF96E\u57CE\u59D3\u5BAC\u6027\u60FA\u6210\u661F\u665F\u7329\u73F9\u76DB\u7701\u7B6C"],["e1a1","\u8056\u8072\u8165\u8AA0\u9192\u4E16\u52E2\u6B72\u6D17\u7A05\u7B39\u7D30\uF96F\u8CB0\u53EC\u562F\u5851\u5BB5\u5C0F\u5C11\u5DE2\u6240\u6383\u6414\u662D\u68B3\u6CBC\u6D88\u6EAF\u701F\u70A4\u71D2\u7526\u758F\u758E\u7619\u7B11\u7BE0\u7C2B\u7D20\u7D39\u852C\u856D\u8607\u8A34\u900D\u9061\u90B5\u92B7\u97F6\u9A37\u4FD7\u5C6C\u675F\u6D91\u7C9F\u7E8C\u8B16\u8D16\u901F\u5B6B\u5DFD\u640D\u84C0\u905C\u98E1\u7387\u5B8B\u609A\u677E\u6DDE\u8A1F\u8AA6\u9001\u980C\u5237\uF970\u7051\u788E\u9396\u8870\u91D7\u4FEE\u53D7\u55FD\u56DA\u5782\u58FD\u5AC2\u5B88\u5CAB\u5CC0\u5E25\u6101"],["e2a1","\u620D\u624B\u6388\u641C\u6536\u6578\u6A39\u6B8A\u6C34\u6D19\u6F31\u71E7\u72E9\u7378\u7407\u74B2\u7626\u7761\u79C0\u7A57\u7AEA\u7CB9\u7D8F\u7DAC\u7E61\u7F9E\u8129\u8331\u8490\u84DA\u85EA\u8896\u8AB0\u8B90\u8F38\u9042\u9083\u916C\u9296\u92B9\u968B\u96A7\u96A8\u96D6\u9700\u9808\u9996\u9AD3\u9B1A\u53D4\u587E\u5919\u5B70\u5BBF\u6DD1\u6F5A\u719F\u7421\u74B9\u8085\u83FD\u5DE1\u5F87\u5FAA\u6042\u65EC\u6812\u696F\u6A53\u6B89\u6D35\u6DF3\u73E3\u76FE\u77AC\u7B4D\u7D14\u8123\u821C\u8340\u84F4\u8563\u8A62\u8AC4\u9187\u931E\u9806\u99B4\u620C\u8853\u8FF0\u9265\u5D07\u5D27"],["e3a1","\u5D69\u745F\u819D\u8768\u6FD5\u62FE\u7FD2\u8936\u8972\u4E1E\u4E58\u50E7\u52DD\u5347\u627F\u6607\u7E69\u8805\u965E\u4F8D\u5319\u5636\u59CB\u5AA4\u5C38\u5C4E\u5C4D\u5E02\u5F11\u6043\u65BD\u662F\u6642\u67BE\u67F4\u731C\u77E2\u793A\u7FC5\u8494\u84CD\u8996\u8A66\u8A69\u8AE1\u8C55\u8C7A\u57F4\u5BD4\u5F0F\u606F\u62ED\u690D\u6B96\u6E5C\u7184\u7BD2\u8755\u8B58\u8EFE\u98DF\u98FE\u4F38\u4F81\u4FE1\u547B\u5A20\u5BB8\u613C\u65B0\u6668\u71FC\u7533\u795E\u7D33\u814E\u81E3\u8398\u85AA\u85CE\u8703\u8A0A\u8EAB\u8F9B\uF971\u8FC5\u5931\u5BA4\u5BE6\u6089\u5BE9\u5C0B\u5FC3\u6C81"],["e4a1","\uF972\u6DF1\u700B\u751A\u82AF\u8AF6\u4EC0\u5341\uF973\u96D9\u6C0F\u4E9E\u4FC4\u5152\u555E\u5A25\u5CE8\u6211\u7259\u82BD\u83AA\u86FE\u8859\u8A1D\u963F\u96C5\u9913\u9D09\u9D5D\u580A\u5CB3\u5DBD\u5E44\u60E1\u6115\u63E1\u6A02\u6E25\u9102\u9354\u984E\u9C10\u9F77\u5B89\u5CB8\u6309\u664F\u6848\u773C\u96C1\u978D\u9854\u9B9F\u65A1\u8B01\u8ECB\u95BC\u5535\u5CA9\u5DD6\u5EB5\u6697\u764C\u83F4\u95C7\u58D3\u62BC\u72CE\u9D28\u4EF0\u592E\u600F\u663B\u6B83\u79E7\u9D26\u5393\u54C0\u57C3\u5D16\u611B\u66D6\u6DAF\u788D\u827E\u9698\u9744\u5384\u627C\u6396\u6DB2\u7E0A\u814B\u984D"],["e5a1","\u6AFB\u7F4C\u9DAF\u9E1A\u4E5F\u503B\u51B6\u591C\u60F9\u63F6\u6930\u723A\u8036\uF974\u91CE\u5F31\uF975\uF976\u7D04\u82E5\u846F\u84BB\u85E5\u8E8D\uF977\u4F6F\uF978\uF979\u58E4\u5B43\u6059\u63DA\u6518\u656D\u6698\uF97A\u694A\u6A23\u6D0B\u7001\u716C\u75D2\u760D\u79B3\u7A70\uF97B\u7F8A\uF97C\u8944\uF97D\u8B93\u91C0\u967D\uF97E\u990A\u5704\u5FA1\u65BC\u6F01\u7600\u79A6\u8A9E\u99AD\u9B5A\u9F6C\u5104\u61B6\u6291\u6A8D\u81C6\u5043\u5830\u5F66\u7109\u8A00\u8AFA\u5B7C\u8616\u4FFA\u513C\u56B4\u5944\u63A9\u6DF9\u5DAA\u696D\u5186\u4E88\u4F59\uF97F\uF980\uF981\u5982\uF982"],["e6a1","\uF983\u6B5F\u6C5D\uF984\u74B5\u7916\uF985\u8207\u8245\u8339\u8F3F\u8F5D\uF986\u9918\uF987\uF988\uF989\u4EA6\uF98A\u57DF\u5F79\u6613\uF98B\uF98C\u75AB\u7E79\u8B6F\uF98D\u9006\u9A5B\u56A5\u5827\u59F8\u5A1F\u5BB4\uF98E\u5EF6\uF98F\uF990\u6350\u633B\uF991\u693D\u6C87\u6CBF\u6D8E\u6D93\u6DF5\u6F14\uF992\u70DF\u7136\u7159\uF993\u71C3\u71D5\uF994\u784F\u786F\uF995\u7B75\u7DE3\uF996\u7E2F\uF997\u884D\u8EDF\uF998\uF999\uF99A\u925B\uF99B\u9CF6\uF99C\uF99D\uF99E\u6085\u6D85\uF99F\u71B1\uF9A0\uF9A1\u95B1\u53AD\uF9A2\uF9A3\uF9A4\u67D3\uF9A5\u708E\u7130\u7430\u8276\u82D2"],["e7a1","\uF9A6\u95BB\u9AE5\u9E7D\u66C4\uF9A7\u71C1\u8449\uF9A8\uF9A9\u584B\uF9AA\uF9AB\u5DB8\u5F71\uF9AC\u6620\u668E\u6979\u69AE\u6C38\u6CF3\u6E36\u6F41\u6FDA\u701B\u702F\u7150\u71DF\u7370\uF9AD\u745B\uF9AE\u74D4\u76C8\u7A4E\u7E93\uF9AF\uF9B0\u82F1\u8A60\u8FCE\uF9B1\u9348\uF9B2\u9719\uF9B3\uF9B4\u4E42\u502A\uF9B5\u5208\u53E1\u66F3\u6C6D\u6FCA\u730A\u777F\u7A62\u82AE\u85DD\u8602\uF9B6\u88D4\u8A63\u8B7D\u8C6B\uF9B7\u92B3\uF9B8\u9713\u9810\u4E94\u4F0D\u4FC9\u50B2\u5348\u543E\u5433\u55DA\u5862\u58BA\u5967\u5A1B\u5BE4\u609F\uF9B9\u61CA\u6556\u65FF\u6664\u68A7\u6C5A\u6FB3"],["e8a1","\u70CF\u71AC\u7352\u7B7D\u8708\u8AA4\u9C32\u9F07\u5C4B\u6C83\u7344\u7389\u923A\u6EAB\u7465\u761F\u7A69\u7E15\u860A\u5140\u58C5\u64C1\u74EE\u7515\u7670\u7FC1\u9095\u96CD\u9954\u6E26\u74E6\u7AA9\u7AAA\u81E5\u86D9\u8778\u8A1B\u5A49\u5B8C\u5B9B\u68A1\u6900\u6D63\u73A9\u7413\u742C\u7897\u7DE9\u7FEB\u8118\u8155\u839E\u8C4C\u962E\u9811\u66F0\u5F80\u65FA\u6789\u6C6A\u738B\u502D\u5A03\u6B6A\u77EE\u5916\u5D6C\u5DCD\u7325\u754F\uF9BA\uF9BB\u50E5\u51F9\u582F\u592D\u5996\u59DA\u5BE5\uF9BC\uF9BD\u5DA2\u62D7\u6416\u6493\u64FE\uF9BE\u66DC\uF9BF\u6A48\uF9C0\u71FF\u7464\uF9C1"],["e9a1","\u7A88\u7AAF\u7E47\u7E5E\u8000\u8170\uF9C2\u87EF\u8981\u8B20\u9059\uF9C3\u9080\u9952\u617E\u6B32\u6D74\u7E1F\u8925\u8FB1\u4FD1\u50AD\u5197\u52C7\u57C7\u5889\u5BB9\u5EB8\u6142\u6995\u6D8C\u6E67\u6EB6\u7194\u7462\u7528\u752C\u8073\u8338\u84C9\u8E0A\u9394\u93DE\uF9C4\u4E8E\u4F51\u5076\u512A\u53C8\u53CB\u53F3\u5B87\u5BD3\u5C24\u611A\u6182\u65F4\u725B\u7397\u7440\u76C2\u7950\u7991\u79B9\u7D06\u7FBD\u828B\u85D5\u865E\u8FC2\u9047\u90F5\u91EA\u9685\u96E8\u96E9\u52D6\u5F67\u65ED\u6631\u682F\u715C\u7A36\u90C1\u980A\u4E91\uF9C5\u6A52\u6B9E\u6F90\u7189\u8018\u82B8\u8553"],["eaa1","\u904B\u9695\u96F2\u97FB\u851A\u9B31\u4E90\u718A\u96C4\u5143\u539F\u54E1\u5713\u5712\u57A3\u5A9B\u5AC4\u5BC3\u6028\u613F\u63F4\u6C85\u6D39\u6E72\u6E90\u7230\u733F\u7457\u82D1\u8881\u8F45\u9060\uF9C6\u9662\u9858\u9D1B\u6708\u8D8A\u925E\u4F4D\u5049\u50DE\u5371\u570D\u59D4\u5A01\u5C09\u6170\u6690\u6E2D\u7232\u744B\u7DEF\u80C3\u840E\u8466\u853F\u875F\u885B\u8918\u8B02\u9055\u97CB\u9B4F\u4E73\u4F91\u5112\u516A\uF9C7\u552F\u55A9\u5B7A\u5BA5\u5E7C\u5E7D\u5EBE\u60A0\u60DF\u6108\u6109\u63C4\u6538\u6709\uF9C8\u67D4\u67DA\uF9C9\u6961\u6962\u6CB9\u6D27\uF9CA\u6E38\uF9CB"],["eba1","\u6FE1\u7336\u7337\uF9CC\u745C\u7531\uF9CD\u7652\uF9CE\uF9CF\u7DAD\u81FE\u8438\u88D5\u8A98\u8ADB\u8AED\u8E30\u8E42\u904A\u903E\u907A\u9149\u91C9\u936E\uF9D0\uF9D1\u5809\uF9D2\u6BD3\u8089\u80B2\uF9D3\uF9D4\u5141\u596B\u5C39\uF9D5\uF9D6\u6F64\u73A7\u80E4\u8D07\uF9D7\u9217\u958F\uF9D8\uF9D9\uF9DA\uF9DB\u807F\u620E\u701C\u7D68\u878D\uF9DC\u57A0\u6069\u6147\u6BB7\u8ABE\u9280\u96B1\u4E59\u541F\u6DEB\u852D\u9670\u97F3\u98EE\u63D6\u6CE3\u9091\u51DD\u61C9\u81BA\u9DF9\u4F9D\u501A\u5100\u5B9C\u610F\u61FF\u64EC\u6905\u6BC5\u7591\u77E3\u7FA9\u8264\u858F\u87FB\u8863\u8ABC"],["eca1","\u8B70\u91AB\u4E8C\u4EE5\u4F0A\uF9DD\uF9DE\u5937\u59E8\uF9DF\u5DF2\u5F1B\u5F5B\u6021\uF9E0\uF9E1\uF9E2\uF9E3\u723E\u73E5\uF9E4\u7570\u75CD\uF9E5\u79FB\uF9E6\u800C\u8033\u8084\u82E1\u8351\uF9E7\uF9E8\u8CBD\u8CB3\u9087\uF9E9\uF9EA\u98F4\u990C\uF9EB\uF9EC\u7037\u76CA\u7FCA\u7FCC\u7FFC\u8B1A\u4EBA\u4EC1\u5203\u5370\uF9ED\u54BD\u56E0\u59FB\u5BC5\u5F15\u5FCD\u6E6E\uF9EE\uF9EF\u7D6A\u8335\uF9F0\u8693\u8A8D\uF9F1\u976D\u9777\uF9F2\uF9F3\u4E00\u4F5A\u4F7E\u58F9\u65E5\u6EA2\u9038\u93B0\u99B9\u4EFB\u58EC\u598A\u59D9\u6041\uF9F4\uF9F5\u7A14\uF9F6\u834F\u8CC3\u5165\u5344"],["eda1","\uF9F7\uF9F8\uF9F9\u4ECD\u5269\u5B55\u82BF\u4ED4\u523A\u54A8\u59C9\u59FF\u5B50\u5B57\u5B5C\u6063\u6148\u6ECB\u7099\u716E\u7386\u74F7\u75B5\u78C1\u7D2B\u8005\u81EA\u8328\u8517\u85C9\u8AEE\u8CC7\u96CC\u4F5C\u52FA\u56BC\u65AB\u6628\u707C\u70B8\u7235\u7DBD\u828D\u914C\u96C0\u9D72\u5B71\u68E7\u6B98\u6F7A\u76DE\u5C91\u66AB\u6F5B\u7BB4\u7C2A\u8836\u96DC\u4E08\u4ED7\u5320\u5834\u58BB\u58EF\u596C\u5C07\u5E33\u5E84\u5F35\u638C\u66B2\u6756\u6A1F\u6AA3\u6B0C\u6F3F\u7246\uF9FA\u7350\u748B\u7AE0\u7CA7\u8178\u81DF\u81E7\u838A\u846C\u8523\u8594\u85CF\u88DD\u8D13\u91AC\u9577"],["eea1","\u969C\u518D\u54C9\u5728\u5BB0\u624D\u6750\u683D\u6893\u6E3D\u6ED3\u707D\u7E21\u88C1\u8CA1\u8F09\u9F4B\u9F4E\u722D\u7B8F\u8ACD\u931A\u4F47\u4F4E\u5132\u5480\u59D0\u5E95\u62B5\u6775\u696E\u6A17\u6CAE\u6E1A\u72D9\u732A\u75BD\u7BB8\u7D35\u82E7\u83F9\u8457\u85F7\u8A5B\u8CAF\u8E87\u9019\u90B8\u96CE\u9F5F\u52E3\u540A\u5AE1\u5BC2\u6458\u6575\u6EF4\u72C4\uF9FB\u7684\u7A4D\u7B1B\u7C4D\u7E3E\u7FDF\u837B\u8B2B\u8CCA\u8D64\u8DE1\u8E5F\u8FEA\u8FF9\u9069\u93D1\u4F43\u4F7A\u50B3\u5168\u5178\u524D\u526A\u5861\u587C\u5960\u5C08\u5C55\u5EDB\u609B\u6230\u6813\u6BBF\u6C08\u6FB1"],["efa1","\u714E\u7420\u7530\u7538\u7551\u7672\u7B4C\u7B8B\u7BAD\u7BC6\u7E8F\u8A6E\u8F3E\u8F49\u923F\u9293\u9322\u942B\u96FB\u985A\u986B\u991E\u5207\u622A\u6298\u6D59\u7664\u7ACA\u7BC0\u7D76\u5360\u5CBE\u5E97\u6F38\u70B9\u7C98\u9711\u9B8E\u9EDE\u63A5\u647A\u8776\u4E01\u4E95\u4EAD\u505C\u5075\u5448\u59C3\u5B9A\u5E40\u5EAD\u5EF7\u5F81\u60C5\u633A\u653F\u6574\u65CC\u6676\u6678\u67FE\u6968\u6A89\u6B63\u6C40\u6DC0\u6DE8\u6E1F\u6E5E\u701E\u70A1\u738E\u73FD\u753A\u775B\u7887\u798E\u7A0B\u7A7D\u7CBE\u7D8E\u8247\u8A02\u8AEA\u8C9E\u912D\u914A\u91D8\u9266\u92CC\u9320\u9706\u9756"],["f0a1","\u975C\u9802\u9F0E\u5236\u5291\u557C\u5824\u5E1D\u5F1F\u608C\u63D0\u68AF\u6FDF\u796D\u7B2C\u81CD\u85BA\u88FD\u8AF8\u8E44\u918D\u9664\u969B\u973D\u984C\u9F4A\u4FCE\u5146\u51CB\u52A9\u5632\u5F14\u5F6B\u63AA\u64CD\u65E9\u6641\u66FA\u66F9\u671D\u689D\u68D7\u69FD\u6F15\u6F6E\u7167\u71E5\u722A\u74AA\u773A\u7956\u795A\u79DF\u7A20\u7A95\u7C97\u7CDF\u7D44\u7E70\u8087\u85FB\u86A4\u8A54\u8ABF\u8D99\u8E81\u9020\u906D\u91E3\u963B\u96D5\u9CE5\u65CF\u7C07\u8DB3\u93C3\u5B58\u5C0A\u5352\u62D9\u731D\u5027\u5B97\u5F9E\u60B0\u616B\u68D5\u6DD9\u742E\u7A2E\u7D42\u7D9C\u7E31\u816B"],["f1a1","\u8E2A\u8E35\u937E\u9418\u4F50\u5750\u5DE6\u5EA7\u632B\u7F6A\u4E3B\u4F4F\u4F8F\u505A\u59DD\u80C4\u546A\u5468\u55FE\u594F\u5B99\u5DDE\u5EDA\u665D\u6731\u67F1\u682A\u6CE8\u6D32\u6E4A\u6F8D\u70B7\u73E0\u7587\u7C4C\u7D02\u7D2C\u7DA2\u821F\u86DB\u8A3B\u8A85\u8D70\u8E8A\u8F33\u9031\u914E\u9152\u9444\u99D0\u7AF9\u7CA5\u4FCA\u5101\u51C6\u57C8\u5BEF\u5CFB\u6659\u6A3D\u6D5A\u6E96\u6FEC\u710C\u756F\u7AE3\u8822\u9021\u9075\u96CB\u99FF\u8301\u4E2D\u4EF2\u8846\u91CD\u537D\u6ADB\u696B\u6C41\u847A\u589E\u618E\u66FE\u62EF\u70DD\u7511\u75C7\u7E52\u84B8\u8B49\u8D08\u4E4B\u53EA"],["f2a1","\u54AB\u5730\u5740\u5FD7\u6301\u6307\u646F\u652F\u65E8\u667A\u679D\u67B3\u6B62\u6C60\u6C9A\u6F2C\u77E5\u7825\u7949\u7957\u7D19\u80A2\u8102\u81F3\u829D\u82B7\u8718\u8A8C\uF9FC\u8D04\u8DBE\u9072\u76F4\u7A19\u7A37\u7E54\u8077\u5507\u55D4\u5875\u632F\u6422\u6649\u664B\u686D\u699B\u6B84\u6D25\u6EB1\u73CD\u7468\u74A1\u755B\u75B9\u76E1\u771E\u778B\u79E6\u7E09\u7E1D\u81FB\u852F\u8897\u8A3A\u8CD1\u8EEB\u8FB0\u9032\u93AD\u9663\u9673\u9707\u4F84\u53F1\u59EA\u5AC9\u5E19\u684E\u74C6\u75BE\u79E9\u7A92\u81A3\u86ED\u8CEA\u8DCC\u8FED\u659F\u6715\uF9FD\u57F7\u6F57\u7DDD\u8F2F"],["f3a1","\u93F6\u96C6\u5FB5\u61F2\u6F84\u4E14\u4F98\u501F\u53C9\u55DF\u5D6F\u5DEE\u6B21\u6B64\u78CB\u7B9A\uF9FE\u8E49\u8ECA\u906E\u6349\u643E\u7740\u7A84\u932F\u947F\u9F6A\u64B0\u6FAF\u71E6\u74A8\u74DA\u7AC4\u7C12\u7E82\u7CB2\u7E98\u8B9A\u8D0A\u947D\u9910\u994C\u5239\u5BDF\u64E6\u672D\u7D2E\u50ED\u53C3\u5879\u6158\u6159\u61FA\u65AC\u7AD9\u8B92\u8B96\u5009\u5021\u5275\u5531\u5A3C\u5EE0\u5F70\u6134\u655E\u660C\u6636\u66A2\u69CD\u6EC4\u6F32\u7316\u7621\u7A93\u8139\u8259\u83D6\u84BC\u50B5\u57F0\u5BC0\u5BE8\u5F69\u63A1\u7826\u7DB5\u83DC\u8521\u91C7\u91F5\u518A\u67F5\u7B56"],["f4a1","\u8CAC\u51C4\u59BB\u60BD\u8655\u501C\uF9FF\u5254\u5C3A\u617D\u621A\u62D3\u64F2\u65A5\u6ECC\u7620\u810A\u8E60\u965F\u96BB\u4EDF\u5343\u5598\u5929\u5DDD\u64C5\u6CC9\u6DFA\u7394\u7A7F\u821B\u85A6\u8CE4\u8E10\u9077\u91E7\u95E1\u9621\u97C6\u51F8\u54F2\u5586\u5FB9\u64A4\u6F88\u7DB4\u8F1F\u8F4D\u9435\u50C9\u5C16\u6CBE\u6DFB\u751B\u77BB\u7C3D\u7C64\u8A79\u8AC2\u581E\u59BE\u5E16\u6377\u7252\u758A\u776B\u8ADC\u8CBC\u8F12\u5EF3\u6674\u6DF8\u807D\u83C1\u8ACB\u9751\u9BD6\uFA00\u5243\u66FF\u6D95\u6EEF\u7DE0\u8AE6\u902E\u905E\u9AD4\u521D\u527F\u54E8\u6194\u6284\u62DB\u68A2"],["f5a1","\u6912\u695A\u6A35\u7092\u7126\u785D\u7901\u790E\u79D2\u7A0D\u8096\u8278\u82D5\u8349\u8549\u8C82\u8D85\u9162\u918B\u91AE\u4FC3\u56D1\u71ED\u77D7\u8700\u89F8\u5BF8\u5FD6\u6751\u90A8\u53E2\u585A\u5BF5\u60A4\u6181\u6460\u7E3D\u8070\u8525\u9283\u64AE\u50AC\u5D14\u6700\u589C\u62BD\u63A8\u690E\u6978\u6A1E\u6E6B\u76BA\u79CB\u82BB\u8429\u8ACF\u8DA8\u8FFD\u9112\u914B\u919C\u9310\u9318\u939A\u96DB\u9A36\u9C0D\u4E11\u755C\u795D\u7AFA\u7B51\u7BC9\u7E2E\u84C4\u8E59\u8E74\u8EF8\u9010\u6625\u693F\u7443\u51FA\u672E\u9EDC\u5145\u5FE0\u6C96\u87F2\u885D\u8877\u60B4\u81B5\u8403"],["f6a1","\u8D05\u53D6\u5439\u5634\u5A36\u5C31\u708A\u7FE0\u805A\u8106\u81ED\u8DA3\u9189\u9A5F\u9DF2\u5074\u4EC4\u53A0\u60FB\u6E2C\u5C64\u4F88\u5024\u55E4\u5CD9\u5E5F\u6065\u6894\u6CBB\u6DC4\u71BE\u75D4\u75F4\u7661\u7A1A\u7A49\u7DC7\u7DFB\u7F6E\u81F4\u86A9\u8F1C\u96C9\u99B3\u9F52\u5247\u52C5\u98ED\u89AA\u4E03\u67D2\u6F06\u4FB5\u5BE2\u6795\u6C88\u6D78\u741B\u7827\u91DD\u937C\u87C4\u79E4\u7A31\u5FEB\u4ED6\u54A4\u553E\u58AE\u59A5\u60F0\u6253\u62D6\u6736\u6955\u8235\u9640\u99B1\u99DD\u502C\u5353\u5544\u577C\uFA01\u6258\uFA02\u64E2\u666B\u67DD\u6FC1\u6FEF\u7422\u7438\u8A17"],["f7a1","\u9438\u5451\u5606\u5766\u5F48\u619A\u6B4E\u7058\u70AD\u7DBB\u8A95\u596A\u812B\u63A2\u7708\u803D\u8CAA\u5854\u642D\u69BB\u5B95\u5E11\u6E6F\uFA03\u8569\u514C\u53F0\u592A\u6020\u614B\u6B86\u6C70\u6CF0\u7B1E\u80CE\u82D4\u8DC6\u90B0\u98B1\uFA04\u64C7\u6FA4\u6491\u6504\u514E\u5410\u571F\u8A0E\u615F\u6876\uFA05\u75DB\u7B52\u7D71\u901A\u5806\u69CC\u817F\u892A\u9000\u9839\u5078\u5957\u59AC\u6295\u900F\u9B2A\u615D\u7279\u95D6\u5761\u5A46\u5DF4\u628A\u64AD\u64FA\u6777\u6CE2\u6D3E\u722C\u7436\u7834\u7F77\u82AD\u8DDB\u9817\u5224\u5742\u677F\u7248\u74E3\u8CA9\u8FA6\u9211"],["f8a1","\u962A\u516B\u53ED\u634C\u4F69\u5504\u6096\u6557\u6C9B\u6D7F\u724C\u72FD\u7A17\u8987\u8C9D\u5F6D\u6F8E\u70F9\u81A8\u610E\u4FBF\u504F\u6241\u7247\u7BC7\u7DE8\u7FE9\u904D\u97AD\u9A19\u8CB6\u576A\u5E73\u67B0\u840D\u8A55\u5420\u5B16\u5E63\u5EE2\u5F0A\u6583\u80BA\u853D\u9589\u965B\u4F48\u5305\u530D\u530F\u5486\u54FA\u5703\u5E03\u6016\u629B\u62B1\u6355\uFA06\u6CE1\u6D66\u75B1\u7832\u80DE\u812F\u82DE\u8461\u84B2\u888D\u8912\u900B\u92EA\u98FD\u9B91\u5E45\u66B4\u66DD\u7011\u7206\uFA07\u4FF5\u527D\u5F6A\u6153\u6753\u6A19\u6F02\u74E2\u7968\u8868\u8C79\u98C7\u98C4\u9A43"],["f9a1","\u54C1\u7A1F\u6953\u8AF7\u8C4A\u98A8\u99AE\u5F7C\u62AB\u75B2\u76AE\u88AB\u907F\u9642\u5339\u5F3C\u5FC5\u6CCC\u73CC\u7562\u758B\u7B46\u82FE\u999D\u4E4F\u903C\u4E0B\u4F55\u53A6\u590F\u5EC8\u6630\u6CB3\u7455\u8377\u8766\u8CC0\u9050\u971E\u9C15\u58D1\u5B78\u8650\u8B14\u9DB4\u5BD2\u6068\u608D\u65F1\u6C57\u6F22\u6FA3\u701A\u7F55\u7FF0\u9591\u9592\u9650\u97D3\u5272\u8F44\u51FD\u542B\u54B8\u5563\u558A\u6ABB\u6DB5\u7DD8\u8266\u929C\u9677\u9E79\u5408\u54C8\u76D2\u86E4\u95A4\u95D4\u965C\u4EA2\u4F09\u59EE\u5AE6\u5DF7\u6052\u6297\u676D\u6841\u6C86\u6E2F\u7F38\u809B\u822A"],["faa1","\uFA08\uFA09\u9805\u4EA5\u5055\u54B3\u5793\u595A\u5B69\u5BB3\u61C8\u6977\u6D77\u7023\u87F9\u89E3\u8A72\u8AE7\u9082\u99ED\u9AB8\u52BE\u6838\u5016\u5E78\u674F\u8347\u884C\u4EAB\u5411\u56AE\u73E6\u9115\u97FF\u9909\u9957\u9999\u5653\u589F\u865B\u8A31\u61B2\u6AF6\u737B\u8ED2\u6B47\u96AA\u9A57\u5955\u7200\u8D6B\u9769\u4FD4\u5CF4\u5F26\u61F8\u665B\u6CEB\u70AB\u7384\u73B9\u73FE\u7729\u774D\u7D43\u7D62\u7E23\u8237\u8852\uFA0A\u8CE2\u9249\u986F\u5B51\u7A74\u8840\u9801\u5ACC\u4FE0\u5354\u593E\u5CFD\u633E\u6D79\u72F9\u8105\u8107\u83A2\u92CF\u9830\u4EA8\u5144\u5211\u578B"],["fba1","\u5F62\u6CC2\u6ECE\u7005\u7050\u70AF\u7192\u73E9\u7469\u834A\u87A2\u8861\u9008\u90A2\u93A3\u99A8\u516E\u5F57\u60E0\u6167\u66B3\u8559\u8E4A\u91AF\u978B\u4E4E\u4E92\u547C\u58D5\u58FA\u597D\u5CB5\u5F27\u6236\u6248\u660A\u6667\u6BEB\u6D69\u6DCF\u6E56\u6EF8\u6F94\u6FE0\u6FE9\u705D\u72D0\u7425\u745A\u74E0\u7693\u795C\u7CCA\u7E1E\u80E1\u82A6\u846B\u84BF\u864E\u865F\u8774\u8B77\u8C6A\u93AC\u9800\u9865\u60D1\u6216\u9177\u5A5A\u660F\u6DF7\u6E3E\u743F\u9B42\u5FFD\u60DA\u7B0F\u54C4\u5F18\u6C5E\u6CD3\u6D2A\u70D8\u7D05\u8679\u8A0C\u9D3B\u5316\u548C\u5B05\u6A3A\u706B\u7575"],["fca1","\u798D\u79BE\u82B1\u83EF\u8A71\u8B41\u8CA8\u9774\uFA0B\u64F4\u652B\u78BA\u78BB\u7A6B\u4E38\u559A\u5950\u5BA6\u5E7B\u60A3\u63DB\u6B61\u6665\u6853\u6E19\u7165\u74B0\u7D08\u9084\u9A69\u9C25\u6D3B\u6ED1\u733E\u8C41\u95CA\u51F0\u5E4C\u5FA8\u604D\u60F6\u6130\u614C\u6643\u6644\u69A5\u6CC1\u6E5F\u6EC9\u6F62\u714C\u749C\u7687\u7BC1\u7C27\u8352\u8757\u9051\u968D\u9EC3\u532F\u56DE\u5EFB\u5F8A\u6062\u6094\u61F7\u6666\u6703\u6A9C\u6DEE\u6FAE\u7070\u736A\u7E6A\u81BE\u8334\u86D4\u8AA8\u8CC4\u5283\u7372\u5B96\u6A6B\u9404\u54EE\u5686\u5B5D\u6548\u6585\u66C9\u689F\u6D8D\u6DC6"],["fda1","\u723B\u80B4\u9175\u9A4D\u4FAF\u5019\u539A\u540E\u543C\u5589\u55C5\u5E3F\u5F8C\u673D\u7166\u73DD\u9005\u52DB\u52F3\u5864\u58CE\u7104\u718F\u71FB\u85B0\u8A13\u6688\u85A8\u55A7\u6684\u714A\u8431\u5349\u5599\u6BC1\u5F59\u5FBD\u63EE\u6689\u7147\u8AF1\u8F1D\u9EBE\u4F11\u643A\u70CB\u7566\u8667\u6064\u8B4E\u9DF8\u5147\u51F6\u5308\u6D36\u80F8\u9ED1\u6615\u6B23\u7098\u75D5\u5403\u5C79\u7D07\u8A16\u6B20\u6B3D\u6B46\u5438\u6070\u6D3D\u7FD5\u8208\u50D6\u51DE\u559C\u566B\u56CD\u59EC\u5B09\u5E0C\u6199\u6198\u6231\u665E\u66E6\u7199\u71B9\u71BA\u72A7\u79A7\u7A00\u7FB2\u8A70"]]');

});

parcelRegister("f8vlO", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",127],["a140","\u3000\uFF0C\u3001\u3002\uFF0E\u2027\uFF1B\uFF1A\uFF1F\uFF01\uFE30\u2026\u2025\uFE50\uFE51\uFE52\xb7\uFE54\uFE55\uFE56\uFE57\uFF5C\u2013\uFE31\u2014\uFE33\u2574\uFE34\uFE4F\uFF08\uFF09\uFE35\uFE36\uFF5B\uFF5D\uFE37\uFE38\u3014\u3015\uFE39\uFE3A\u3010\u3011\uFE3B\uFE3C\u300A\u300B\uFE3D\uFE3E\u3008\u3009\uFE3F\uFE40\u300C\u300D\uFE41\uFE42\u300E\u300F\uFE43\uFE44\uFE59\uFE5A"],["a1a1","\uFE5B\uFE5C\uFE5D\uFE5E\u2018\u2019\u201C\u201D\u301D\u301E\u2035\u2032\uFF03\uFF06\uFF0A\u203B\xa7\u3003\u25CB\u25CF\u25B3\u25B2\u25CE\u2606\u2605\u25C7\u25C6\u25A1\u25A0\u25BD\u25BC\u32A3\u2105\xaf\uFFE3\uFF3F\u02CD\uFE49\uFE4A\uFE4D\uFE4E\uFE4B\uFE4C\uFE5F\uFE60\uFE61\uFF0B\uFF0D\xd7\xf7\xb1\u221A\uFF1C\uFF1E\uFF1D\u2266\u2267\u2260\u221E\u2252\u2261\uFE62",4,"\uFF5E\u2229\u222A\u22A5\u2220\u221F\u22BF\u33D2\u33D1\u222B\u222E\u2235\u2234\u2640\u2642\u2295\u2299\u2191\u2193\u2190\u2192\u2196\u2197\u2199\u2198\u2225\u2223\uFF0F"],["a240","\uFF3C\u2215\uFE68\uFF04\uFFE5\u3012\uFFE0\uFFE1\uFF05\uFF20\u2103\u2109\uFE69\uFE6A\uFE6B\u33D5\u339C\u339D\u339E\u33CE\u33A1\u338E\u338F\u33C4\xb0\u5159\u515B\u515E\u515D\u5161\u5163\u55E7\u74E9\u7CCE\u2581",7,"\u258F\u258E\u258D\u258C\u258B\u258A\u2589\u253C\u2534\u252C\u2524\u251C\u2594\u2500\u2502\u2595\u250C\u2510\u2514\u2518\u256D"],["a2a1","\u256E\u2570\u256F\u2550\u255E\u256A\u2561\u25E2\u25E3\u25E5\u25E4\u2571\u2572\u2573\uFF10",9,"\u2160",9,"\u3021",8,"\u5341\u5344\u5345\uFF21",25,"\uFF41",21],["a340","\uFF57\uFF58\uFF59\uFF5A\u0391",16,"\u03A3",6,"\u03B1",16,"\u03C3",6,"\u3105",10],["a3a1","\u3110",25,"\u02D9\u02C9\u02CA\u02C7\u02CB"],["a3e1","\u20AC"],["a440","\u4E00\u4E59\u4E01\u4E03\u4E43\u4E5D\u4E86\u4E8C\u4EBA\u513F\u5165\u516B\u51E0\u5200\u5201\u529B\u5315\u5341\u535C\u53C8\u4E09\u4E0B\u4E08\u4E0A\u4E2B\u4E38\u51E1\u4E45\u4E48\u4E5F\u4E5E\u4E8E\u4EA1\u5140\u5203\u52FA\u5343\u53C9\u53E3\u571F\u58EB\u5915\u5927\u5973\u5B50\u5B51\u5B53\u5BF8\u5C0F\u5C22\u5C38\u5C71\u5DDD\u5DE5\u5DF1\u5DF2\u5DF3\u5DFE\u5E72\u5EFE\u5F0B\u5F13\u624D"],["a4a1","\u4E11\u4E10\u4E0D\u4E2D\u4E30\u4E39\u4E4B\u5C39\u4E88\u4E91\u4E95\u4E92\u4E94\u4EA2\u4EC1\u4EC0\u4EC3\u4EC6\u4EC7\u4ECD\u4ECA\u4ECB\u4EC4\u5143\u5141\u5167\u516D\u516E\u516C\u5197\u51F6\u5206\u5207\u5208\u52FB\u52FE\u52FF\u5316\u5339\u5348\u5347\u5345\u535E\u5384\u53CB\u53CA\u53CD\u58EC\u5929\u592B\u592A\u592D\u5B54\u5C11\u5C24\u5C3A\u5C6F\u5DF4\u5E7B\u5EFF\u5F14\u5F15\u5FC3\u6208\u6236\u624B\u624E\u652F\u6587\u6597\u65A4\u65B9\u65E5\u66F0\u6708\u6728\u6B20\u6B62\u6B79\u6BCB\u6BD4\u6BDB\u6C0F\u6C34\u706B\u722A\u7236\u723B\u7247\u7259\u725B\u72AC\u738B\u4E19"],["a540","\u4E16\u4E15\u4E14\u4E18\u4E3B\u4E4D\u4E4F\u4E4E\u4EE5\u4ED8\u4ED4\u4ED5\u4ED6\u4ED7\u4EE3\u4EE4\u4ED9\u4EDE\u5145\u5144\u5189\u518A\u51AC\u51F9\u51FA\u51F8\u520A\u52A0\u529F\u5305\u5306\u5317\u531D\u4EDF\u534A\u5349\u5361\u5360\u536F\u536E\u53BB\u53EF\u53E4\u53F3\u53EC\u53EE\u53E9\u53E8\u53FC\u53F8\u53F5\u53EB\u53E6\u53EA\u53F2\u53F1\u53F0\u53E5\u53ED\u53FB\u56DB\u56DA\u5916"],["a5a1","\u592E\u5931\u5974\u5976\u5B55\u5B83\u5C3C\u5DE8\u5DE7\u5DE6\u5E02\u5E03\u5E73\u5E7C\u5F01\u5F18\u5F17\u5FC5\u620A\u6253\u6254\u6252\u6251\u65A5\u65E6\u672E\u672C\u672A\u672B\u672D\u6B63\u6BCD\u6C11\u6C10\u6C38\u6C41\u6C40\u6C3E\u72AF\u7384\u7389\u74DC\u74E6\u7518\u751F\u7528\u7529\u7530\u7531\u7532\u7533\u758B\u767D\u76AE\u76BF\u76EE\u77DB\u77E2\u77F3\u793A\u79BE\u7A74\u7ACB\u4E1E\u4E1F\u4E52\u4E53\u4E69\u4E99\u4EA4\u4EA6\u4EA5\u4EFF\u4F09\u4F19\u4F0A\u4F15\u4F0D\u4F10\u4F11\u4F0F\u4EF2\u4EF6\u4EFB\u4EF0\u4EF3\u4EFD\u4F01\u4F0B\u5149\u5147\u5146\u5148\u5168"],["a640","\u5171\u518D\u51B0\u5217\u5211\u5212\u520E\u5216\u52A3\u5308\u5321\u5320\u5370\u5371\u5409\u540F\u540C\u540A\u5410\u5401\u540B\u5404\u5411\u540D\u5408\u5403\u540E\u5406\u5412\u56E0\u56DE\u56DD\u5733\u5730\u5728\u572D\u572C\u572F\u5729\u5919\u591A\u5937\u5938\u5984\u5978\u5983\u597D\u5979\u5982\u5981\u5B57\u5B58\u5B87\u5B88\u5B85\u5B89\u5BFA\u5C16\u5C79\u5DDE\u5E06\u5E76\u5E74"],["a6a1","\u5F0F\u5F1B\u5FD9\u5FD6\u620E\u620C\u620D\u6210\u6263\u625B\u6258\u6536\u65E9\u65E8\u65EC\u65ED\u66F2\u66F3\u6709\u673D\u6734\u6731\u6735\u6B21\u6B64\u6B7B\u6C16\u6C5D\u6C57\u6C59\u6C5F\u6C60\u6C50\u6C55\u6C61\u6C5B\u6C4D\u6C4E\u7070\u725F\u725D\u767E\u7AF9\u7C73\u7CF8\u7F36\u7F8A\u7FBD\u8001\u8003\u800C\u8012\u8033\u807F\u8089\u808B\u808C\u81E3\u81EA\u81F3\u81FC\u820C\u821B\u821F\u826E\u8272\u827E\u866B\u8840\u884C\u8863\u897F\u9621\u4E32\u4EA8\u4F4D\u4F4F\u4F47\u4F57\u4F5E\u4F34\u4F5B\u4F55\u4F30\u4F50\u4F51\u4F3D\u4F3A\u4F38\u4F43\u4F54\u4F3C\u4F46\u4F63"],["a740","\u4F5C\u4F60\u4F2F\u4F4E\u4F36\u4F59\u4F5D\u4F48\u4F5A\u514C\u514B\u514D\u5175\u51B6\u51B7\u5225\u5224\u5229\u522A\u5228\u52AB\u52A9\u52AA\u52AC\u5323\u5373\u5375\u541D\u542D\u541E\u543E\u5426\u544E\u5427\u5446\u5443\u5433\u5448\u5442\u541B\u5429\u544A\u5439\u543B\u5438\u542E\u5435\u5436\u5420\u543C\u5440\u5431\u542B\u541F\u542C\u56EA\u56F0\u56E4\u56EB\u574A\u5751\u5740\u574D"],["a7a1","\u5747\u574E\u573E\u5750\u574F\u573B\u58EF\u593E\u599D\u5992\u59A8\u599E\u59A3\u5999\u5996\u598D\u59A4\u5993\u598A\u59A5\u5B5D\u5B5C\u5B5A\u5B5B\u5B8C\u5B8B\u5B8F\u5C2C\u5C40\u5C41\u5C3F\u5C3E\u5C90\u5C91\u5C94\u5C8C\u5DEB\u5E0C\u5E8F\u5E87\u5E8A\u5EF7\u5F04\u5F1F\u5F64\u5F62\u5F77\u5F79\u5FD8\u5FCC\u5FD7\u5FCD\u5FF1\u5FEB\u5FF8\u5FEA\u6212\u6211\u6284\u6297\u6296\u6280\u6276\u6289\u626D\u628A\u627C\u627E\u6279\u6273\u6292\u626F\u6298\u626E\u6295\u6293\u6291\u6286\u6539\u653B\u6538\u65F1\u66F4\u675F\u674E\u674F\u6750\u6751\u675C\u6756\u675E\u6749\u6746\u6760"],["a840","\u6753\u6757\u6B65\u6BCF\u6C42\u6C5E\u6C99\u6C81\u6C88\u6C89\u6C85\u6C9B\u6C6A\u6C7A\u6C90\u6C70\u6C8C\u6C68\u6C96\u6C92\u6C7D\u6C83\u6C72\u6C7E\u6C74\u6C86\u6C76\u6C8D\u6C94\u6C98\u6C82\u7076\u707C\u707D\u7078\u7262\u7261\u7260\u72C4\u72C2\u7396\u752C\u752B\u7537\u7538\u7682\u76EF\u77E3\u79C1\u79C0\u79BF\u7A76\u7CFB\u7F55\u8096\u8093\u809D\u8098\u809B\u809A\u80B2\u826F\u8292"],["a8a1","\u828B\u828D\u898B\u89D2\u8A00\u8C37\u8C46\u8C55\u8C9D\u8D64\u8D70\u8DB3\u8EAB\u8ECA\u8F9B\u8FB0\u8FC2\u8FC6\u8FC5\u8FC4\u5DE1\u9091\u90A2\u90AA\u90A6\u90A3\u9149\u91C6\u91CC\u9632\u962E\u9631\u962A\u962C\u4E26\u4E56\u4E73\u4E8B\u4E9B\u4E9E\u4EAB\u4EAC\u4F6F\u4F9D\u4F8D\u4F73\u4F7F\u4F6C\u4F9B\u4F8B\u4F86\u4F83\u4F70\u4F75\u4F88\u4F69\u4F7B\u4F96\u4F7E\u4F8F\u4F91\u4F7A\u5154\u5152\u5155\u5169\u5177\u5176\u5178\u51BD\u51FD\u523B\u5238\u5237\u523A\u5230\u522E\u5236\u5241\u52BE\u52BB\u5352\u5354\u5353\u5351\u5366\u5377\u5378\u5379\u53D6\u53D4\u53D7\u5473\u5475"],["a940","\u5496\u5478\u5495\u5480\u547B\u5477\u5484\u5492\u5486\u547C\u5490\u5471\u5476\u548C\u549A\u5462\u5468\u548B\u547D\u548E\u56FA\u5783\u5777\u576A\u5769\u5761\u5766\u5764\u577C\u591C\u5949\u5947\u5948\u5944\u5954\u59BE\u59BB\u59D4\u59B9\u59AE\u59D1\u59C6\u59D0\u59CD\u59CB\u59D3\u59CA\u59AF\u59B3\u59D2\u59C5\u5B5F\u5B64\u5B63\u5B97\u5B9A\u5B98\u5B9C\u5B99\u5B9B\u5C1A\u5C48\u5C45"],["a9a1","\u5C46\u5CB7\u5CA1\u5CB8\u5CA9\u5CAB\u5CB1\u5CB3\u5E18\u5E1A\u5E16\u5E15\u5E1B\u5E11\u5E78\u5E9A\u5E97\u5E9C\u5E95\u5E96\u5EF6\u5F26\u5F27\u5F29\u5F80\u5F81\u5F7F\u5F7C\u5FDD\u5FE0\u5FFD\u5FF5\u5FFF\u600F\u6014\u602F\u6035\u6016\u602A\u6015\u6021\u6027\u6029\u602B\u601B\u6216\u6215\u623F\u623E\u6240\u627F\u62C9\u62CC\u62C4\u62BF\u62C2\u62B9\u62D2\u62DB\u62AB\u62D3\u62D4\u62CB\u62C8\u62A8\u62BD\u62BC\u62D0\u62D9\u62C7\u62CD\u62B5\u62DA\u62B1\u62D8\u62D6\u62D7\u62C6\u62AC\u62CE\u653E\u65A7\u65BC\u65FA\u6614\u6613\u660C\u6606\u6602\u660E\u6600\u660F\u6615\u660A"],["aa40","\u6607\u670D\u670B\u676D\u678B\u6795\u6771\u679C\u6773\u6777\u6787\u679D\u6797\u676F\u6770\u677F\u6789\u677E\u6790\u6775\u679A\u6793\u677C\u676A\u6772\u6B23\u6B66\u6B67\u6B7F\u6C13\u6C1B\u6CE3\u6CE8\u6CF3\u6CB1\u6CCC\u6CE5\u6CB3\u6CBD\u6CBE\u6CBC\u6CE2\u6CAB\u6CD5\u6CD3\u6CB8\u6CC4\u6CB9\u6CC1\u6CAE\u6CD7\u6CC5\u6CF1\u6CBF\u6CBB\u6CE1\u6CDB\u6CCA\u6CAC\u6CEF\u6CDC\u6CD6\u6CE0"],["aaa1","\u7095\u708E\u7092\u708A\u7099\u722C\u722D\u7238\u7248\u7267\u7269\u72C0\u72CE\u72D9\u72D7\u72D0\u73A9\u73A8\u739F\u73AB\u73A5\u753D\u759D\u7599\u759A\u7684\u76C2\u76F2\u76F4\u77E5\u77FD\u793E\u7940\u7941\u79C9\u79C8\u7A7A\u7A79\u7AFA\u7CFE\u7F54\u7F8C\u7F8B\u8005\u80BA\u80A5\u80A2\u80B1\u80A1\u80AB\u80A9\u80B4\u80AA\u80AF\u81E5\u81FE\u820D\u82B3\u829D\u8299\u82AD\u82BD\u829F\u82B9\u82B1\u82AC\u82A5\u82AF\u82B8\u82A3\u82B0\u82BE\u82B7\u864E\u8671\u521D\u8868\u8ECB\u8FCE\u8FD4\u8FD1\u90B5\u90B8\u90B1\u90B6\u91C7\u91D1\u9577\u9580\u961C\u9640\u963F\u963B\u9644"],["ab40","\u9642\u96B9\u96E8\u9752\u975E\u4E9F\u4EAD\u4EAE\u4FE1\u4FB5\u4FAF\u4FBF\u4FE0\u4FD1\u4FCF\u4FDD\u4FC3\u4FB6\u4FD8\u4FDF\u4FCA\u4FD7\u4FAE\u4FD0\u4FC4\u4FC2\u4FDA\u4FCE\u4FDE\u4FB7\u5157\u5192\u5191\u51A0\u524E\u5243\u524A\u524D\u524C\u524B\u5247\u52C7\u52C9\u52C3\u52C1\u530D\u5357\u537B\u539A\u53DB\u54AC\u54C0\u54A8\u54CE\u54C9\u54B8\u54A6\u54B3\u54C7\u54C2\u54BD\u54AA\u54C1"],["aba1","\u54C4\u54C8\u54AF\u54AB\u54B1\u54BB\u54A9\u54A7\u54BF\u56FF\u5782\u578B\u57A0\u57A3\u57A2\u57CE\u57AE\u5793\u5955\u5951\u594F\u594E\u5950\u59DC\u59D8\u59FF\u59E3\u59E8\u5A03\u59E5\u59EA\u59DA\u59E6\u5A01\u59FB\u5B69\u5BA3\u5BA6\u5BA4\u5BA2\u5BA5\u5C01\u5C4E\u5C4F\u5C4D\u5C4B\u5CD9\u5CD2\u5DF7\u5E1D\u5E25\u5E1F\u5E7D\u5EA0\u5EA6\u5EFA\u5F08\u5F2D\u5F65\u5F88\u5F85\u5F8A\u5F8B\u5F87\u5F8C\u5F89\u6012\u601D\u6020\u6025\u600E\u6028\u604D\u6070\u6068\u6062\u6046\u6043\u606C\u606B\u606A\u6064\u6241\u62DC\u6316\u6309\u62FC\u62ED\u6301\u62EE\u62FD\u6307\u62F1\u62F7"],["ac40","\u62EF\u62EC\u62FE\u62F4\u6311\u6302\u653F\u6545\u65AB\u65BD\u65E2\u6625\u662D\u6620\u6627\u662F\u661F\u6628\u6631\u6624\u66F7\u67FF\u67D3\u67F1\u67D4\u67D0\u67EC\u67B6\u67AF\u67F5\u67E9\u67EF\u67C4\u67D1\u67B4\u67DA\u67E5\u67B8\u67CF\u67DE\u67F3\u67B0\u67D9\u67E2\u67DD\u67D2\u6B6A\u6B83\u6B86\u6BB5\u6BD2\u6BD7\u6C1F\u6CC9\u6D0B\u6D32\u6D2A\u6D41\u6D25\u6D0C\u6D31\u6D1E\u6D17"],["aca1","\u6D3B\u6D3D\u6D3E\u6D36\u6D1B\u6CF5\u6D39\u6D27\u6D38\u6D29\u6D2E\u6D35\u6D0E\u6D2B\u70AB\u70BA\u70B3\u70AC\u70AF\u70AD\u70B8\u70AE\u70A4\u7230\u7272\u726F\u7274\u72E9\u72E0\u72E1\u73B7\u73CA\u73BB\u73B2\u73CD\u73C0\u73B3\u751A\u752D\u754F\u754C\u754E\u754B\u75AB\u75A4\u75A5\u75A2\u75A3\u7678\u7686\u7687\u7688\u76C8\u76C6\u76C3\u76C5\u7701\u76F9\u76F8\u7709\u770B\u76FE\u76FC\u7707\u77DC\u7802\u7814\u780C\u780D\u7946\u7949\u7948\u7947\u79B9\u79BA\u79D1\u79D2\u79CB\u7A7F\u7A81\u7AFF\u7AFD\u7C7D\u7D02\u7D05\u7D00\u7D09\u7D07\u7D04\u7D06\u7F38\u7F8E\u7FBF\u8004"],["ad40","\u8010\u800D\u8011\u8036\u80D6\u80E5\u80DA\u80C3\u80C4\u80CC\u80E1\u80DB\u80CE\u80DE\u80E4\u80DD\u81F4\u8222\u82E7\u8303\u8305\u82E3\u82DB\u82E6\u8304\u82E5\u8302\u8309\u82D2\u82D7\u82F1\u8301\u82DC\u82D4\u82D1\u82DE\u82D3\u82DF\u82EF\u8306\u8650\u8679\u867B\u867A\u884D\u886B\u8981\u89D4\u8A08\u8A02\u8A03\u8C9E\u8CA0\u8D74\u8D73\u8DB4\u8ECD\u8ECC\u8FF0\u8FE6\u8FE2\u8FEA\u8FE5"],["ada1","\u8FED\u8FEB\u8FE4\u8FE8\u90CA\u90CE\u90C1\u90C3\u914B\u914A\u91CD\u9582\u9650\u964B\u964C\u964D\u9762\u9769\u97CB\u97ED\u97F3\u9801\u98A8\u98DB\u98DF\u9996\u9999\u4E58\u4EB3\u500C\u500D\u5023\u4FEF\u5026\u5025\u4FF8\u5029\u5016\u5006\u503C\u501F\u501A\u5012\u5011\u4FFA\u5000\u5014\u5028\u4FF1\u5021\u500B\u5019\u5018\u4FF3\u4FEE\u502D\u502A\u4FFE\u502B\u5009\u517C\u51A4\u51A5\u51A2\u51CD\u51CC\u51C6\u51CB\u5256\u525C\u5254\u525B\u525D\u532A\u537F\u539F\u539D\u53DF\u54E8\u5510\u5501\u5537\u54FC\u54E5\u54F2\u5506\u54FA\u5514\u54E9\u54ED\u54E1\u5509\u54EE\u54EA"],["ae40","\u54E6\u5527\u5507\u54FD\u550F\u5703\u5704\u57C2\u57D4\u57CB\u57C3\u5809\u590F\u5957\u5958\u595A\u5A11\u5A18\u5A1C\u5A1F\u5A1B\u5A13\u59EC\u5A20\u5A23\u5A29\u5A25\u5A0C\u5A09\u5B6B\u5C58\u5BB0\u5BB3\u5BB6\u5BB4\u5BAE\u5BB5\u5BB9\u5BB8\u5C04\u5C51\u5C55\u5C50\u5CED\u5CFD\u5CFB\u5CEA\u5CE8\u5CF0\u5CF6\u5D01\u5CF4\u5DEE\u5E2D\u5E2B\u5EAB\u5EAD\u5EA7\u5F31\u5F92\u5F91\u5F90\u6059"],["aea1","\u6063\u6065\u6050\u6055\u606D\u6069\u606F\u6084\u609F\u609A\u608D\u6094\u608C\u6085\u6096\u6247\u62F3\u6308\u62FF\u634E\u633E\u632F\u6355\u6342\u6346\u634F\u6349\u633A\u6350\u633D\u632A\u632B\u6328\u634D\u634C\u6548\u6549\u6599\u65C1\u65C5\u6642\u6649\u664F\u6643\u6652\u664C\u6645\u6641\u66F8\u6714\u6715\u6717\u6821\u6838\u6848\u6846\u6853\u6839\u6842\u6854\u6829\u68B3\u6817\u684C\u6851\u683D\u67F4\u6850\u6840\u683C\u6843\u682A\u6845\u6813\u6818\u6841\u6B8A\u6B89\u6BB7\u6C23\u6C27\u6C28\u6C26\u6C24\u6CF0\u6D6A\u6D95\u6D88\u6D87\u6D66\u6D78\u6D77\u6D59\u6D93"],["af40","\u6D6C\u6D89\u6D6E\u6D5A\u6D74\u6D69\u6D8C\u6D8A\u6D79\u6D85\u6D65\u6D94\u70CA\u70D8\u70E4\u70D9\u70C8\u70CF\u7239\u7279\u72FC\u72F9\u72FD\u72F8\u72F7\u7386\u73ED\u7409\u73EE\u73E0\u73EA\u73DE\u7554\u755D\u755C\u755A\u7559\u75BE\u75C5\u75C7\u75B2\u75B3\u75BD\u75BC\u75B9\u75C2\u75B8\u768B\u76B0\u76CA\u76CD\u76CE\u7729\u771F\u7720\u7728\u77E9\u7830\u7827\u7838\u781D\u7834\u7837"],["afa1","\u7825\u782D\u7820\u781F\u7832\u7955\u7950\u7960\u795F\u7956\u795E\u795D\u7957\u795A\u79E4\u79E3\u79E7\u79DF\u79E6\u79E9\u79D8\u7A84\u7A88\u7AD9\u7B06\u7B11\u7C89\u7D21\u7D17\u7D0B\u7D0A\u7D20\u7D22\u7D14\u7D10\u7D15\u7D1A\u7D1C\u7D0D\u7D19\u7D1B\u7F3A\u7F5F\u7F94\u7FC5\u7FC1\u8006\u8018\u8015\u8019\u8017\u803D\u803F\u80F1\u8102\u80F0\u8105\u80ED\u80F4\u8106\u80F8\u80F3\u8108\u80FD\u810A\u80FC\u80EF\u81ED\u81EC\u8200\u8210\u822A\u822B\u8228\u822C\u82BB\u832B\u8352\u8354\u834A\u8338\u8350\u8349\u8335\u8334\u834F\u8332\u8339\u8336\u8317\u8340\u8331\u8328\u8343"],["b040","\u8654\u868A\u86AA\u8693\u86A4\u86A9\u868C\u86A3\u869C\u8870\u8877\u8881\u8882\u887D\u8879\u8A18\u8A10\u8A0E\u8A0C\u8A15\u8A0A\u8A17\u8A13\u8A16\u8A0F\u8A11\u8C48\u8C7A\u8C79\u8CA1\u8CA2\u8D77\u8EAC\u8ED2\u8ED4\u8ECF\u8FB1\u9001\u9006\u8FF7\u9000\u8FFA\u8FF4\u9003\u8FFD\u9005\u8FF8\u9095\u90E1\u90DD\u90E2\u9152\u914D\u914C\u91D8\u91DD\u91D7\u91DC\u91D9\u9583\u9662\u9663\u9661"],["b0a1","\u965B\u965D\u9664\u9658\u965E\u96BB\u98E2\u99AC\u9AA8\u9AD8\u9B25\u9B32\u9B3C\u4E7E\u507A\u507D\u505C\u5047\u5043\u504C\u505A\u5049\u5065\u5076\u504E\u5055\u5075\u5074\u5077\u504F\u500F\u506F\u506D\u515C\u5195\u51F0\u526A\u526F\u52D2\u52D9\u52D8\u52D5\u5310\u530F\u5319\u533F\u5340\u533E\u53C3\u66FC\u5546\u556A\u5566\u5544\u555E\u5561\u5543\u554A\u5531\u5556\u554F\u5555\u552F\u5564\u5538\u552E\u555C\u552C\u5563\u5533\u5541\u5557\u5708\u570B\u5709\u57DF\u5805\u580A\u5806\u57E0\u57E4\u57FA\u5802\u5835\u57F7\u57F9\u5920\u5962\u5A36\u5A41\u5A49\u5A66\u5A6A\u5A40"],["b140","\u5A3C\u5A62\u5A5A\u5A46\u5A4A\u5B70\u5BC7\u5BC5\u5BC4\u5BC2\u5BBF\u5BC6\u5C09\u5C08\u5C07\u5C60\u5C5C\u5C5D\u5D07\u5D06\u5D0E\u5D1B\u5D16\u5D22\u5D11\u5D29\u5D14\u5D19\u5D24\u5D27\u5D17\u5DE2\u5E38\u5E36\u5E33\u5E37\u5EB7\u5EB8\u5EB6\u5EB5\u5EBE\u5F35\u5F37\u5F57\u5F6C\u5F69\u5F6B\u5F97\u5F99\u5F9E\u5F98\u5FA1\u5FA0\u5F9C\u607F\u60A3\u6089\u60A0\u60A8\u60CB\u60B4\u60E6\u60BD"],["b1a1","\u60C5\u60BB\u60B5\u60DC\u60BC\u60D8\u60D5\u60C6\u60DF\u60B8\u60DA\u60C7\u621A\u621B\u6248\u63A0\u63A7\u6372\u6396\u63A2\u63A5\u6377\u6367\u6398\u63AA\u6371\u63A9\u6389\u6383\u639B\u636B\u63A8\u6384\u6388\u6399\u63A1\u63AC\u6392\u638F\u6380\u637B\u6369\u6368\u637A\u655D\u6556\u6551\u6559\u6557\u555F\u654F\u6558\u6555\u6554\u659C\u659B\u65AC\u65CF\u65CB\u65CC\u65CE\u665D\u665A\u6664\u6668\u6666\u665E\u66F9\u52D7\u671B\u6881\u68AF\u68A2\u6893\u68B5\u687F\u6876\u68B1\u68A7\u6897\u68B0\u6883\u68C4\u68AD\u6886\u6885\u6894\u689D\u68A8\u689F\u68A1\u6882\u6B32\u6BBA"],["b240","\u6BEB\u6BEC\u6C2B\u6D8E\u6DBC\u6DF3\u6DD9\u6DB2\u6DE1\u6DCC\u6DE4\u6DFB\u6DFA\u6E05\u6DC7\u6DCB\u6DAF\u6DD1\u6DAE\u6DDE\u6DF9\u6DB8\u6DF7\u6DF5\u6DC5\u6DD2\u6E1A\u6DB5\u6DDA\u6DEB\u6DD8\u6DEA\u6DF1\u6DEE\u6DE8\u6DC6\u6DC4\u6DAA\u6DEC\u6DBF\u6DE6\u70F9\u7109\u710A\u70FD\u70EF\u723D\u727D\u7281\u731C\u731B\u7316\u7313\u7319\u7387\u7405\u740A\u7403\u7406\u73FE\u740D\u74E0\u74F6"],["b2a1","\u74F7\u751C\u7522\u7565\u7566\u7562\u7570\u758F\u75D4\u75D5\u75B5\u75CA\u75CD\u768E\u76D4\u76D2\u76DB\u7737\u773E\u773C\u7736\u7738\u773A\u786B\u7843\u784E\u7965\u7968\u796D\u79FB\u7A92\u7A95\u7B20\u7B28\u7B1B\u7B2C\u7B26\u7B19\u7B1E\u7B2E\u7C92\u7C97\u7C95\u7D46\u7D43\u7D71\u7D2E\u7D39\u7D3C\u7D40\u7D30\u7D33\u7D44\u7D2F\u7D42\u7D32\u7D31\u7F3D\u7F9E\u7F9A\u7FCC\u7FCE\u7FD2\u801C\u804A\u8046\u812F\u8116\u8123\u812B\u8129\u8130\u8124\u8202\u8235\u8237\u8236\u8239\u838E\u839E\u8398\u8378\u83A2\u8396\u83BD\u83AB\u8392\u838A\u8393\u8389\u83A0\u8377\u837B\u837C"],["b340","\u8386\u83A7\u8655\u5F6A\u86C7\u86C0\u86B6\u86C4\u86B5\u86C6\u86CB\u86B1\u86AF\u86C9\u8853\u889E\u8888\u88AB\u8892\u8896\u888D\u888B\u8993\u898F\u8A2A\u8A1D\u8A23\u8A25\u8A31\u8A2D\u8A1F\u8A1B\u8A22\u8C49\u8C5A\u8CA9\u8CAC\u8CAB\u8CA8\u8CAA\u8CA7\u8D67\u8D66\u8DBE\u8DBA\u8EDB\u8EDF\u9019\u900D\u901A\u9017\u9023\u901F\u901D\u9010\u9015\u901E\u9020\u900F\u9022\u9016\u901B\u9014"],["b3a1","\u90E8\u90ED\u90FD\u9157\u91CE\u91F5\u91E6\u91E3\u91E7\u91ED\u91E9\u9589\u966A\u9675\u9673\u9678\u9670\u9674\u9676\u9677\u966C\u96C0\u96EA\u96E9\u7AE0\u7ADF\u9802\u9803\u9B5A\u9CE5\u9E75\u9E7F\u9EA5\u9EBB\u50A2\u508D\u5085\u5099\u5091\u5080\u5096\u5098\u509A\u6700\u51F1\u5272\u5274\u5275\u5269\u52DE\u52DD\u52DB\u535A\u53A5\u557B\u5580\u55A7\u557C\u558A\u559D\u5598\u5582\u559C\u55AA\u5594\u5587\u558B\u5583\u55B3\u55AE\u559F\u553E\u55B2\u559A\u55BB\u55AC\u55B1\u557E\u5589\u55AB\u5599\u570D\u582F\u582A\u5834\u5824\u5830\u5831\u5821\u581D\u5820\u58F9\u58FA\u5960"],["b440","\u5A77\u5A9A\u5A7F\u5A92\u5A9B\u5AA7\u5B73\u5B71\u5BD2\u5BCC\u5BD3\u5BD0\u5C0A\u5C0B\u5C31\u5D4C\u5D50\u5D34\u5D47\u5DFD\u5E45\u5E3D\u5E40\u5E43\u5E7E\u5ECA\u5EC1\u5EC2\u5EC4\u5F3C\u5F6D\u5FA9\u5FAA\u5FA8\u60D1\u60E1\u60B2\u60B6\u60E0\u611C\u6123\u60FA\u6115\u60F0\u60FB\u60F4\u6168\u60F1\u610E\u60F6\u6109\u6100\u6112\u621F\u6249\u63A3\u638C\u63CF\u63C0\u63E9\u63C9\u63C6\u63CD"],["b4a1","\u63D2\u63E3\u63D0\u63E1\u63D6\u63ED\u63EE\u6376\u63F4\u63EA\u63DB\u6452\u63DA\u63F9\u655E\u6566\u6562\u6563\u6591\u6590\u65AF\u666E\u6670\u6674\u6676\u666F\u6691\u667A\u667E\u6677\u66FE\u66FF\u671F\u671D\u68FA\u68D5\u68E0\u68D8\u68D7\u6905\u68DF\u68F5\u68EE\u68E7\u68F9\u68D2\u68F2\u68E3\u68CB\u68CD\u690D\u6912\u690E\u68C9\u68DA\u696E\u68FB\u6B3E\u6B3A\u6B3D\u6B98\u6B96\u6BBC\u6BEF\u6C2E\u6C2F\u6C2C\u6E2F\u6E38\u6E54\u6E21\u6E32\u6E67\u6E4A\u6E20\u6E25\u6E23\u6E1B\u6E5B\u6E58\u6E24\u6E56\u6E6E\u6E2D\u6E26\u6E6F\u6E34\u6E4D\u6E3A\u6E2C\u6E43\u6E1D\u6E3E\u6ECB"],["b540","\u6E89\u6E19\u6E4E\u6E63\u6E44\u6E72\u6E69\u6E5F\u7119\u711A\u7126\u7130\u7121\u7136\u716E\u711C\u724C\u7284\u7280\u7336\u7325\u7334\u7329\u743A\u742A\u7433\u7422\u7425\u7435\u7436\u7434\u742F\u741B\u7426\u7428\u7525\u7526\u756B\u756A\u75E2\u75DB\u75E3\u75D9\u75D8\u75DE\u75E0\u767B\u767C\u7696\u7693\u76B4\u76DC\u774F\u77ED\u785D\u786C\u786F\u7A0D\u7A08\u7A0B\u7A05\u7A00\u7A98"],["b5a1","\u7A97\u7A96\u7AE5\u7AE3\u7B49\u7B56\u7B46\u7B50\u7B52\u7B54\u7B4D\u7B4B\u7B4F\u7B51\u7C9F\u7CA5\u7D5E\u7D50\u7D68\u7D55\u7D2B\u7D6E\u7D72\u7D61\u7D66\u7D62\u7D70\u7D73\u5584\u7FD4\u7FD5\u800B\u8052\u8085\u8155\u8154\u814B\u8151\u814E\u8139\u8146\u813E\u814C\u8153\u8174\u8212\u821C\u83E9\u8403\u83F8\u840D\u83E0\u83C5\u840B\u83C1\u83EF\u83F1\u83F4\u8457\u840A\u83F0\u840C\u83CC\u83FD\u83F2\u83CA\u8438\u840E\u8404\u83DC\u8407\u83D4\u83DF\u865B\u86DF\u86D9\u86ED\u86D4\u86DB\u86E4\u86D0\u86DE\u8857\u88C1\u88C2\u88B1\u8983\u8996\u8A3B\u8A60\u8A55\u8A5E\u8A3C\u8A41"],["b640","\u8A54\u8A5B\u8A50\u8A46\u8A34\u8A3A\u8A36\u8A56\u8C61\u8C82\u8CAF\u8CBC\u8CB3\u8CBD\u8CC1\u8CBB\u8CC0\u8CB4\u8CB7\u8CB6\u8CBF\u8CB8\u8D8A\u8D85\u8D81\u8DCE\u8DDD\u8DCB\u8DDA\u8DD1\u8DCC\u8DDB\u8DC6\u8EFB\u8EF8\u8EFC\u8F9C\u902E\u9035\u9031\u9038\u9032\u9036\u9102\u90F5\u9109\u90FE\u9163\u9165\u91CF\u9214\u9215\u9223\u9209\u921E\u920D\u9210\u9207\u9211\u9594\u958F\u958B\u9591"],["b6a1","\u9593\u9592\u958E\u968A\u968E\u968B\u967D\u9685\u9686\u968D\u9672\u9684\u96C1\u96C5\u96C4\u96C6\u96C7\u96EF\u96F2\u97CC\u9805\u9806\u9808\u98E7\u98EA\u98EF\u98E9\u98F2\u98ED\u99AE\u99AD\u9EC3\u9ECD\u9ED1\u4E82\u50AD\u50B5\u50B2\u50B3\u50C5\u50BE\u50AC\u50B7\u50BB\u50AF\u50C7\u527F\u5277\u527D\u52DF\u52E6\u52E4\u52E2\u52E3\u532F\u55DF\u55E8\u55D3\u55E6\u55CE\u55DC\u55C7\u55D1\u55E3\u55E4\u55EF\u55DA\u55E1\u55C5\u55C6\u55E5\u55C9\u5712\u5713\u585E\u5851\u5858\u5857\u585A\u5854\u586B\u584C\u586D\u584A\u5862\u5852\u584B\u5967\u5AC1\u5AC9\u5ACC\u5ABE\u5ABD\u5ABC"],["b740","\u5AB3\u5AC2\u5AB2\u5D69\u5D6F\u5E4C\u5E79\u5EC9\u5EC8\u5F12\u5F59\u5FAC\u5FAE\u611A\u610F\u6148\u611F\u60F3\u611B\u60F9\u6101\u6108\u614E\u614C\u6144\u614D\u613E\u6134\u6127\u610D\u6106\u6137\u6221\u6222\u6413\u643E\u641E\u642A\u642D\u643D\u642C\u640F\u641C\u6414\u640D\u6436\u6416\u6417\u6406\u656C\u659F\u65B0\u6697\u6689\u6687\u6688\u6696\u6684\u6698\u668D\u6703\u6994\u696D"],["b7a1","\u695A\u6977\u6960\u6954\u6975\u6930\u6982\u694A\u6968\u696B\u695E\u6953\u6979\u6986\u695D\u6963\u695B\u6B47\u6B72\u6BC0\u6BBF\u6BD3\u6BFD\u6EA2\u6EAF\u6ED3\u6EB6\u6EC2\u6E90\u6E9D\u6EC7\u6EC5\u6EA5\u6E98\u6EBC\u6EBA\u6EAB\u6ED1\u6E96\u6E9C\u6EC4\u6ED4\u6EAA\u6EA7\u6EB4\u714E\u7159\u7169\u7164\u7149\u7167\u715C\u716C\u7166\u714C\u7165\u715E\u7146\u7168\u7156\u723A\u7252\u7337\u7345\u733F\u733E\u746F\u745A\u7455\u745F\u745E\u7441\u743F\u7459\u745B\u745C\u7576\u7578\u7600\u75F0\u7601\u75F2\u75F1\u75FA\u75FF\u75F4\u75F3\u76DE\u76DF\u775B\u776B\u7766\u775E\u7763"],["b840","\u7779\u776A\u776C\u775C\u7765\u7768\u7762\u77EE\u788E\u78B0\u7897\u7898\u788C\u7889\u787C\u7891\u7893\u787F\u797A\u797F\u7981\u842C\u79BD\u7A1C\u7A1A\u7A20\u7A14\u7A1F\u7A1E\u7A9F\u7AA0\u7B77\u7BC0\u7B60\u7B6E\u7B67\u7CB1\u7CB3\u7CB5\u7D93\u7D79\u7D91\u7D81\u7D8F\u7D5B\u7F6E\u7F69\u7F6A\u7F72\u7FA9\u7FA8\u7FA4\u8056\u8058\u8086\u8084\u8171\u8170\u8178\u8165\u816E\u8173\u816B"],["b8a1","\u8179\u817A\u8166\u8205\u8247\u8482\u8477\u843D\u8431\u8475\u8466\u846B\u8449\u846C\u845B\u843C\u8435\u8461\u8463\u8469\u846D\u8446\u865E\u865C\u865F\u86F9\u8713\u8708\u8707\u8700\u86FE\u86FB\u8702\u8703\u8706\u870A\u8859\u88DF\u88D4\u88D9\u88DC\u88D8\u88DD\u88E1\u88CA\u88D5\u88D2\u899C\u89E3\u8A6B\u8A72\u8A73\u8A66\u8A69\u8A70\u8A87\u8A7C\u8A63\u8AA0\u8A71\u8A85\u8A6D\u8A62\u8A6E\u8A6C\u8A79\u8A7B\u8A3E\u8A68\u8C62\u8C8A\u8C89\u8CCA\u8CC7\u8CC8\u8CC4\u8CB2\u8CC3\u8CC2\u8CC5\u8DE1\u8DDF\u8DE8\u8DEF\u8DF3\u8DFA\u8DEA\u8DE4\u8DE6\u8EB2\u8F03\u8F09\u8EFE\u8F0A"],["b940","\u8F9F\u8FB2\u904B\u904A\u9053\u9042\u9054\u903C\u9055\u9050\u9047\u904F\u904E\u904D\u9051\u903E\u9041\u9112\u9117\u916C\u916A\u9169\u91C9\u9237\u9257\u9238\u923D\u9240\u923E\u925B\u924B\u9264\u9251\u9234\u9249\u924D\u9245\u9239\u923F\u925A\u9598\u9698\u9694\u9695\u96CD\u96CB\u96C9\u96CA\u96F7\u96FB\u96F9\u96F6\u9756\u9774\u9776\u9810\u9811\u9813\u980A\u9812\u980C\u98FC\u98F4"],["b9a1","\u98FD\u98FE\u99B3\u99B1\u99B4\u9AE1\u9CE9\u9E82\u9F0E\u9F13\u9F20\u50E7\u50EE\u50E5\u50D6\u50ED\u50DA\u50D5\u50CF\u50D1\u50F1\u50CE\u50E9\u5162\u51F3\u5283\u5282\u5331\u53AD\u55FE\u5600\u561B\u5617\u55FD\u5614\u5606\u5609\u560D\u560E\u55F7\u5616\u561F\u5608\u5610\u55F6\u5718\u5716\u5875\u587E\u5883\u5893\u588A\u5879\u5885\u587D\u58FD\u5925\u5922\u5924\u596A\u5969\u5AE1\u5AE6\u5AE9\u5AD7\u5AD6\u5AD8\u5AE3\u5B75\u5BDE\u5BE7\u5BE1\u5BE5\u5BE6\u5BE8\u5BE2\u5BE4\u5BDF\u5C0D\u5C62\u5D84\u5D87\u5E5B\u5E63\u5E55\u5E57\u5E54\u5ED3\u5ED6\u5F0A\u5F46\u5F70\u5FB9\u6147"],["ba40","\u613F\u614B\u6177\u6162\u6163\u615F\u615A\u6158\u6175\u622A\u6487\u6458\u6454\u64A4\u6478\u645F\u647A\u6451\u6467\u6434\u646D\u647B\u6572\u65A1\u65D7\u65D6\u66A2\u66A8\u669D\u699C\u69A8\u6995\u69C1\u69AE\u69D3\u69CB\u699B\u69B7\u69BB\u69AB\u69B4\u69D0\u69CD\u69AD\u69CC\u69A6\u69C3\u69A3\u6B49\u6B4C\u6C33\u6F33\u6F14\u6EFE\u6F13\u6EF4\u6F29\u6F3E\u6F20\u6F2C\u6F0F\u6F02\u6F22"],["baa1","\u6EFF\u6EEF\u6F06\u6F31\u6F38\u6F32\u6F23\u6F15\u6F2B\u6F2F\u6F88\u6F2A\u6EEC\u6F01\u6EF2\u6ECC\u6EF7\u7194\u7199\u717D\u718A\u7184\u7192\u723E\u7292\u7296\u7344\u7350\u7464\u7463\u746A\u7470\u746D\u7504\u7591\u7627\u760D\u760B\u7609\u7613\u76E1\u76E3\u7784\u777D\u777F\u7761\u78C1\u789F\u78A7\u78B3\u78A9\u78A3\u798E\u798F\u798D\u7A2E\u7A31\u7AAA\u7AA9\u7AED\u7AEF\u7BA1\u7B95\u7B8B\u7B75\u7B97\u7B9D\u7B94\u7B8F\u7BB8\u7B87\u7B84\u7CB9\u7CBD\u7CBE\u7DBB\u7DB0\u7D9C\u7DBD\u7DBE\u7DA0\u7DCA\u7DB4\u7DB2\u7DB1\u7DBA\u7DA2\u7DBF\u7DB5\u7DB8\u7DAD\u7DD2\u7DC7\u7DAC"],["bb40","\u7F70\u7FE0\u7FE1\u7FDF\u805E\u805A\u8087\u8150\u8180\u818F\u8188\u818A\u817F\u8182\u81E7\u81FA\u8207\u8214\u821E\u824B\u84C9\u84BF\u84C6\u84C4\u8499\u849E\u84B2\u849C\u84CB\u84B8\u84C0\u84D3\u8490\u84BC\u84D1\u84CA\u873F\u871C\u873B\u8722\u8725\u8734\u8718\u8755\u8737\u8729\u88F3\u8902\u88F4\u88F9\u88F8\u88FD\u88E8\u891A\u88EF\u8AA6\u8A8C\u8A9E\u8AA3\u8A8D\u8AA1\u8A93\u8AA4"],["bba1","\u8AAA\u8AA5\u8AA8\u8A98\u8A91\u8A9A\u8AA7\u8C6A\u8C8D\u8C8C\u8CD3\u8CD1\u8CD2\u8D6B\u8D99\u8D95\u8DFC\u8F14\u8F12\u8F15\u8F13\u8FA3\u9060\u9058\u905C\u9063\u9059\u905E\u9062\u905D\u905B\u9119\u9118\u911E\u9175\u9178\u9177\u9174\u9278\u9280\u9285\u9298\u9296\u927B\u9293\u929C\u92A8\u927C\u9291\u95A1\u95A8\u95A9\u95A3\u95A5\u95A4\u9699\u969C\u969B\u96CC\u96D2\u9700\u977C\u9785\u97F6\u9817\u9818\u98AF\u98B1\u9903\u9905\u990C\u9909\u99C1\u9AAF\u9AB0\u9AE6\u9B41\u9B42\u9CF4\u9CF6\u9CF3\u9EBC\u9F3B\u9F4A\u5104\u5100\u50FB\u50F5\u50F9\u5102\u5108\u5109\u5105\u51DC"],["bc40","\u5287\u5288\u5289\u528D\u528A\u52F0\u53B2\u562E\u563B\u5639\u5632\u563F\u5634\u5629\u5653\u564E\u5657\u5674\u5636\u562F\u5630\u5880\u589F\u589E\u58B3\u589C\u58AE\u58A9\u58A6\u596D\u5B09\u5AFB\u5B0B\u5AF5\u5B0C\u5B08\u5BEE\u5BEC\u5BE9\u5BEB\u5C64\u5C65\u5D9D\u5D94\u5E62\u5E5F\u5E61\u5EE2\u5EDA\u5EDF\u5EDD\u5EE3\u5EE0\u5F48\u5F71\u5FB7\u5FB5\u6176\u6167\u616E\u615D\u6155\u6182"],["bca1","\u617C\u6170\u616B\u617E\u61A7\u6190\u61AB\u618E\u61AC\u619A\u61A4\u6194\u61AE\u622E\u6469\u646F\u6479\u649E\u64B2\u6488\u6490\u64B0\u64A5\u6493\u6495\u64A9\u6492\u64AE\u64AD\u64AB\u649A\u64AC\u6499\u64A2\u64B3\u6575\u6577\u6578\u66AE\u66AB\u66B4\u66B1\u6A23\u6A1F\u69E8\u6A01\u6A1E\u6A19\u69FD\u6A21\u6A13\u6A0A\u69F3\u6A02\u6A05\u69ED\u6A11\u6B50\u6B4E\u6BA4\u6BC5\u6BC6\u6F3F\u6F7C\u6F84\u6F51\u6F66\u6F54\u6F86\u6F6D\u6F5B\u6F78\u6F6E\u6F8E\u6F7A\u6F70\u6F64\u6F97\u6F58\u6ED5\u6F6F\u6F60\u6F5F\u719F\u71AC\u71B1\u71A8\u7256\u729B\u734E\u7357\u7469\u748B\u7483"],["bd40","\u747E\u7480\u757F\u7620\u7629\u761F\u7624\u7626\u7621\u7622\u769A\u76BA\u76E4\u778E\u7787\u778C\u7791\u778B\u78CB\u78C5\u78BA\u78CA\u78BE\u78D5\u78BC\u78D0\u7A3F\u7A3C\u7A40\u7A3D\u7A37\u7A3B\u7AAF\u7AAE\u7BAD\u7BB1\u7BC4\u7BB4\u7BC6\u7BC7\u7BC1\u7BA0\u7BCC\u7CCA\u7DE0\u7DF4\u7DEF\u7DFB\u7DD8\u7DEC\u7DDD\u7DE8\u7DE3\u7DDA\u7DDE\u7DE9\u7D9E\u7DD9\u7DF2\u7DF9\u7F75\u7F77\u7FAF"],["bda1","\u7FE9\u8026\u819B\u819C\u819D\u81A0\u819A\u8198\u8517\u853D\u851A\u84EE\u852C\u852D\u8513\u8511\u8523\u8521\u8514\u84EC\u8525\u84FF\u8506\u8782\u8774\u8776\u8760\u8766\u8778\u8768\u8759\u8757\u874C\u8753\u885B\u885D\u8910\u8907\u8912\u8913\u8915\u890A\u8ABC\u8AD2\u8AC7\u8AC4\u8A95\u8ACB\u8AF8\u8AB2\u8AC9\u8AC2\u8ABF\u8AB0\u8AD6\u8ACD\u8AB6\u8AB9\u8ADB\u8C4C\u8C4E\u8C6C\u8CE0\u8CDE\u8CE6\u8CE4\u8CEC\u8CED\u8CE2\u8CE3\u8CDC\u8CEA\u8CE1\u8D6D\u8D9F\u8DA3\u8E2B\u8E10\u8E1D\u8E22\u8E0F\u8E29\u8E1F\u8E21\u8E1E\u8EBA\u8F1D\u8F1B\u8F1F\u8F29\u8F26\u8F2A\u8F1C\u8F1E"],["be40","\u8F25\u9069\u906E\u9068\u906D\u9077\u9130\u912D\u9127\u9131\u9187\u9189\u918B\u9183\u92C5\u92BB\u92B7\u92EA\u92AC\u92E4\u92C1\u92B3\u92BC\u92D2\u92C7\u92F0\u92B2\u95AD\u95B1\u9704\u9706\u9707\u9709\u9760\u978D\u978B\u978F\u9821\u982B\u981C\u98B3\u990A\u9913\u9912\u9918\u99DD\u99D0\u99DF\u99DB\u99D1\u99D5\u99D2\u99D9\u9AB7\u9AEE\u9AEF\u9B27\u9B45\u9B44\u9B77\u9B6F\u9D06\u9D09"],["bea1","\u9D03\u9EA9\u9EBE\u9ECE\u58A8\u9F52\u5112\u5118\u5114\u5110\u5115\u5180\u51AA\u51DD\u5291\u5293\u52F3\u5659\u566B\u5679\u5669\u5664\u5678\u566A\u5668\u5665\u5671\u566F\u566C\u5662\u5676\u58C1\u58BE\u58C7\u58C5\u596E\u5B1D\u5B34\u5B78\u5BF0\u5C0E\u5F4A\u61B2\u6191\u61A9\u618A\u61CD\u61B6\u61BE\u61CA\u61C8\u6230\u64C5\u64C1\u64CB\u64BB\u64BC\u64DA\u64C4\u64C7\u64C2\u64CD\u64BF\u64D2\u64D4\u64BE\u6574\u66C6\u66C9\u66B9\u66C4\u66C7\u66B8\u6A3D\u6A38\u6A3A\u6A59\u6A6B\u6A58\u6A39\u6A44\u6A62\u6A61\u6A4B\u6A47\u6A35\u6A5F\u6A48\u6B59\u6B77\u6C05\u6FC2\u6FB1\u6FA1"],["bf40","\u6FC3\u6FA4\u6FC1\u6FA7\u6FB3\u6FC0\u6FB9\u6FB6\u6FA6\u6FA0\u6FB4\u71BE\u71C9\u71D0\u71D2\u71C8\u71D5\u71B9\u71CE\u71D9\u71DC\u71C3\u71C4\u7368\u749C\u74A3\u7498\u749F\u749E\u74E2\u750C\u750D\u7634\u7638\u763A\u76E7\u76E5\u77A0\u779E\u779F\u77A5\u78E8\u78DA\u78EC\u78E7\u79A6\u7A4D\u7A4E\u7A46\u7A4C\u7A4B\u7ABA\u7BD9\u7C11\u7BC9\u7BE4\u7BDB\u7BE1\u7BE9\u7BE6\u7CD5\u7CD6\u7E0A"],["bfa1","\u7E11\u7E08\u7E1B\u7E23\u7E1E\u7E1D\u7E09\u7E10\u7F79\u7FB2\u7FF0\u7FF1\u7FEE\u8028\u81B3\u81A9\u81A8\u81FB\u8208\u8258\u8259\u854A\u8559\u8548\u8568\u8569\u8543\u8549\u856D\u856A\u855E\u8783\u879F\u879E\u87A2\u878D\u8861\u892A\u8932\u8925\u892B\u8921\u89AA\u89A6\u8AE6\u8AFA\u8AEB\u8AF1\u8B00\u8ADC\u8AE7\u8AEE\u8AFE\u8B01\u8B02\u8AF7\u8AED\u8AF3\u8AF6\u8AFC\u8C6B\u8C6D\u8C93\u8CF4\u8E44\u8E31\u8E34\u8E42\u8E39\u8E35\u8F3B\u8F2F\u8F38\u8F33\u8FA8\u8FA6\u9075\u9074\u9078\u9072\u907C\u907A\u9134\u9192\u9320\u9336\u92F8\u9333\u932F\u9322\u92FC\u932B\u9304\u931A"],["c040","\u9310\u9326\u9321\u9315\u932E\u9319\u95BB\u96A7\u96A8\u96AA\u96D5\u970E\u9711\u9716\u970D\u9713\u970F\u975B\u975C\u9766\u9798\u9830\u9838\u983B\u9837\u982D\u9839\u9824\u9910\u9928\u991E\u991B\u9921\u991A\u99ED\u99E2\u99F1\u9AB8\u9ABC\u9AFB\u9AED\u9B28\u9B91\u9D15\u9D23\u9D26\u9D28\u9D12\u9D1B\u9ED8\u9ED4\u9F8D\u9F9C\u512A\u511F\u5121\u5132\u52F5\u568E\u5680\u5690\u5685\u5687"],["c0a1","\u568F\u58D5\u58D3\u58D1\u58CE\u5B30\u5B2A\u5B24\u5B7A\u5C37\u5C68\u5DBC\u5DBA\u5DBD\u5DB8\u5E6B\u5F4C\u5FBD\u61C9\u61C2\u61C7\u61E6\u61CB\u6232\u6234\u64CE\u64CA\u64D8\u64E0\u64F0\u64E6\u64EC\u64F1\u64E2\u64ED\u6582\u6583\u66D9\u66D6\u6A80\u6A94\u6A84\u6AA2\u6A9C\u6ADB\u6AA3\u6A7E\u6A97\u6A90\u6AA0\u6B5C\u6BAE\u6BDA\u6C08\u6FD8\u6FF1\u6FDF\u6FE0\u6FDB\u6FE4\u6FEB\u6FEF\u6F80\u6FEC\u6FE1\u6FE9\u6FD5\u6FEE\u6FF0\u71E7\u71DF\u71EE\u71E6\u71E5\u71ED\u71EC\u71F4\u71E0\u7235\u7246\u7370\u7372\u74A9\u74B0\u74A6\u74A8\u7646\u7642\u764C\u76EA\u77B3\u77AA\u77B0\u77AC"],["c140","\u77A7\u77AD\u77EF\u78F7\u78FA\u78F4\u78EF\u7901\u79A7\u79AA\u7A57\u7ABF\u7C07\u7C0D\u7BFE\u7BF7\u7C0C\u7BE0\u7CE0\u7CDC\u7CDE\u7CE2\u7CDF\u7CD9\u7CDD\u7E2E\u7E3E\u7E46\u7E37\u7E32\u7E43\u7E2B\u7E3D\u7E31\u7E45\u7E41\u7E34\u7E39\u7E48\u7E35\u7E3F\u7E2F\u7F44\u7FF3\u7FFC\u8071\u8072\u8070\u806F\u8073\u81C6\u81C3\u81BA\u81C2\u81C0\u81BF\u81BD\u81C9\u81BE\u81E8\u8209\u8271\u85AA"],["c1a1","\u8584\u857E\u859C\u8591\u8594\u85AF\u859B\u8587\u85A8\u858A\u8667\u87C0\u87D1\u87B3\u87D2\u87C6\u87AB\u87BB\u87BA\u87C8\u87CB\u893B\u8936\u8944\u8938\u893D\u89AC\u8B0E\u8B17\u8B19\u8B1B\u8B0A\u8B20\u8B1D\u8B04\u8B10\u8C41\u8C3F\u8C73\u8CFA\u8CFD\u8CFC\u8CF8\u8CFB\u8DA8\u8E49\u8E4B\u8E48\u8E4A\u8F44\u8F3E\u8F42\u8F45\u8F3F\u907F\u907D\u9084\u9081\u9082\u9080\u9139\u91A3\u919E\u919C\u934D\u9382\u9328\u9375\u934A\u9365\u934B\u9318\u937E\u936C\u935B\u9370\u935A\u9354\u95CA\u95CB\u95CC\u95C8\u95C6\u96B1\u96B8\u96D6\u971C\u971E\u97A0\u97D3\u9846\u98B6\u9935\u9A01"],["c240","\u99FF\u9BAE\u9BAB\u9BAA\u9BAD\u9D3B\u9D3F\u9E8B\u9ECF\u9EDE\u9EDC\u9EDD\u9EDB\u9F3E\u9F4B\u53E2\u5695\u56AE\u58D9\u58D8\u5B38\u5F5D\u61E3\u6233\u64F4\u64F2\u64FE\u6506\u64FA\u64FB\u64F7\u65B7\u66DC\u6726\u6AB3\u6AAC\u6AC3\u6ABB\u6AB8\u6AC2\u6AAE\u6AAF\u6B5F\u6B78\u6BAF\u7009\u700B\u6FFE\u7006\u6FFA\u7011\u700F\u71FB\u71FC\u71FE\u71F8\u7377\u7375\u74A7\u74BF\u7515\u7656\u7658"],["c2a1","\u7652\u77BD\u77BF\u77BB\u77BC\u790E\u79AE\u7A61\u7A62\u7A60\u7AC4\u7AC5\u7C2B\u7C27\u7C2A\u7C1E\u7C23\u7C21\u7CE7\u7E54\u7E55\u7E5E\u7E5A\u7E61\u7E52\u7E59\u7F48\u7FF9\u7FFB\u8077\u8076\u81CD\u81CF\u820A\u85CF\u85A9\u85CD\u85D0\u85C9\u85B0\u85BA\u85B9\u85A6\u87EF\u87EC\u87F2\u87E0\u8986\u89B2\u89F4\u8B28\u8B39\u8B2C\u8B2B\u8C50\u8D05\u8E59\u8E63\u8E66\u8E64\u8E5F\u8E55\u8EC0\u8F49\u8F4D\u9087\u9083\u9088\u91AB\u91AC\u91D0\u9394\u938A\u9396\u93A2\u93B3\u93AE\u93AC\u93B0\u9398\u939A\u9397\u95D4\u95D6\u95D0\u95D5\u96E2\u96DC\u96D9\u96DB\u96DE\u9724\u97A3\u97A6"],["c340","\u97AD\u97F9\u984D\u984F\u984C\u984E\u9853\u98BA\u993E\u993F\u993D\u992E\u99A5\u9A0E\u9AC1\u9B03\u9B06\u9B4F\u9B4E\u9B4D\u9BCA\u9BC9\u9BFD\u9BC8\u9BC0\u9D51\u9D5D\u9D60\u9EE0\u9F15\u9F2C\u5133\u56A5\u58DE\u58DF\u58E2\u5BF5\u9F90\u5EEC\u61F2\u61F7\u61F6\u61F5\u6500\u650F\u66E0\u66DD\u6AE5\u6ADD\u6ADA\u6AD3\u701B\u701F\u7028\u701A\u701D\u7015\u7018\u7206\u720D\u7258\u72A2\u7378"],["c3a1","\u737A\u74BD\u74CA\u74E3\u7587\u7586\u765F\u7661\u77C7\u7919\u79B1\u7A6B\u7A69\u7C3E\u7C3F\u7C38\u7C3D\u7C37\u7C40\u7E6B\u7E6D\u7E79\u7E69\u7E6A\u7F85\u7E73\u7FB6\u7FB9\u7FB8\u81D8\u85E9\u85DD\u85EA\u85D5\u85E4\u85E5\u85F7\u87FB\u8805\u880D\u87F9\u87FE\u8960\u895F\u8956\u895E\u8B41\u8B5C\u8B58\u8B49\u8B5A\u8B4E\u8B4F\u8B46\u8B59\u8D08\u8D0A\u8E7C\u8E72\u8E87\u8E76\u8E6C\u8E7A\u8E74\u8F54\u8F4E\u8FAD\u908A\u908B\u91B1\u91AE\u93E1\u93D1\u93DF\u93C3\u93C8\u93DC\u93DD\u93D6\u93E2\u93CD\u93D8\u93E4\u93D7\u93E8\u95DC\u96B4\u96E3\u972A\u9727\u9761\u97DC\u97FB\u985E"],["c440","\u9858\u985B\u98BC\u9945\u9949\u9A16\u9A19\u9B0D\u9BE8\u9BE7\u9BD6\u9BDB\u9D89\u9D61\u9D72\u9D6A\u9D6C\u9E92\u9E97\u9E93\u9EB4\u52F8\u56A8\u56B7\u56B6\u56B4\u56BC\u58E4\u5B40\u5B43\u5B7D\u5BF6\u5DC9\u61F8\u61FA\u6518\u6514\u6519\u66E6\u6727\u6AEC\u703E\u7030\u7032\u7210\u737B\u74CF\u7662\u7665\u7926\u792A\u792C\u792B\u7AC7\u7AF6\u7C4C\u7C43\u7C4D\u7CEF\u7CF0\u8FAE\u7E7D\u7E7C"],["c4a1","\u7E82\u7F4C\u8000\u81DA\u8266\u85FB\u85F9\u8611\u85FA\u8606\u860B\u8607\u860A\u8814\u8815\u8964\u89BA\u89F8\u8B70\u8B6C\u8B66\u8B6F\u8B5F\u8B6B\u8D0F\u8D0D\u8E89\u8E81\u8E85\u8E82\u91B4\u91CB\u9418\u9403\u93FD\u95E1\u9730\u98C4\u9952\u9951\u99A8\u9A2B\u9A30\u9A37\u9A35\u9C13\u9C0D\u9E79\u9EB5\u9EE8\u9F2F\u9F5F\u9F63\u9F61\u5137\u5138\u56C1\u56C0\u56C2\u5914\u5C6C\u5DCD\u61FC\u61FE\u651D\u651C\u6595\u66E9\u6AFB\u6B04\u6AFA\u6BB2\u704C\u721B\u72A7\u74D6\u74D4\u7669\u77D3\u7C50\u7E8F\u7E8C\u7FBC\u8617\u862D\u861A\u8823\u8822\u8821\u881F\u896A\u896C\u89BD\u8B74"],["c540","\u8B77\u8B7D\u8D13\u8E8A\u8E8D\u8E8B\u8F5F\u8FAF\u91BA\u942E\u9433\u9435\u943A\u9438\u9432\u942B\u95E2\u9738\u9739\u9732\u97FF\u9867\u9865\u9957\u9A45\u9A43\u9A40\u9A3E\u9ACF\u9B54\u9B51\u9C2D\u9C25\u9DAF\u9DB4\u9DC2\u9DB8\u9E9D\u9EEF\u9F19\u9F5C\u9F66\u9F67\u513C\u513B\u56C8\u56CA\u56C9\u5B7F\u5DD4\u5DD2\u5F4E\u61FF\u6524\u6B0A\u6B61\u7051\u7058\u7380\u74E4\u758A\u766E\u766C"],["c5a1","\u79B3\u7C60\u7C5F\u807E\u807D\u81DF\u8972\u896F\u89FC\u8B80\u8D16\u8D17\u8E91\u8E93\u8F61\u9148\u9444\u9451\u9452\u973D\u973E\u97C3\u97C1\u986B\u9955\u9A55\u9A4D\u9AD2\u9B1A\u9C49\u9C31\u9C3E\u9C3B\u9DD3\u9DD7\u9F34\u9F6C\u9F6A\u9F94\u56CC\u5DD6\u6200\u6523\u652B\u652A\u66EC\u6B10\u74DA\u7ACA\u7C64\u7C63\u7C65\u7E93\u7E96\u7E94\u81E2\u8638\u863F\u8831\u8B8A\u9090\u908F\u9463\u9460\u9464\u9768\u986F\u995C\u9A5A\u9A5B\u9A57\u9AD3\u9AD4\u9AD1\u9C54\u9C57\u9C56\u9DE5\u9E9F\u9EF4\u56D1\u58E9\u652C\u705E\u7671\u7672\u77D7\u7F50\u7F88\u8836\u8839\u8862\u8B93\u8B92"],["c640","\u8B96\u8277\u8D1B\u91C0\u946A\u9742\u9748\u9744\u97C6\u9870\u9A5F\u9B22\u9B58\u9C5F\u9DF9\u9DFA\u9E7C\u9E7D\u9F07\u9F77\u9F72\u5EF3\u6B16\u7063\u7C6C\u7C6E\u883B\u89C0\u8EA1\u91C1\u9472\u9470\u9871\u995E\u9AD6\u9B23\u9ECC\u7064\u77DA\u8B9A\u9477\u97C9\u9A62\u9A65\u7E9C\u8B9C\u8EAA\u91C5\u947D\u947E\u947C\u9C77\u9C78\u9EF7\u8C54\u947F\u9E1A\u7228\u9A6A\u9B31\u9E1B\u9E1E\u7C72"],["c940","\u4E42\u4E5C\u51F5\u531A\u5382\u4E07\u4E0C\u4E47\u4E8D\u56D7\uFA0C\u5C6E\u5F73\u4E0F\u5187\u4E0E\u4E2E\u4E93\u4EC2\u4EC9\u4EC8\u5198\u52FC\u536C\u53B9\u5720\u5903\u592C\u5C10\u5DFF\u65E1\u6BB3\u6BCC\u6C14\u723F\u4E31\u4E3C\u4EE8\u4EDC\u4EE9\u4EE1\u4EDD\u4EDA\u520C\u531C\u534C\u5722\u5723\u5917\u592F\u5B81\u5B84\u5C12\u5C3B\u5C74\u5C73\u5E04\u5E80\u5E82\u5FC9\u6209\u6250\u6C15"],["c9a1","\u6C36\u6C43\u6C3F\u6C3B\u72AE\u72B0\u738A\u79B8\u808A\u961E\u4F0E\u4F18\u4F2C\u4EF5\u4F14\u4EF1\u4F00\u4EF7\u4F08\u4F1D\u4F02\u4F05\u4F22\u4F13\u4F04\u4EF4\u4F12\u51B1\u5213\u5209\u5210\u52A6\u5322\u531F\u534D\u538A\u5407\u56E1\u56DF\u572E\u572A\u5734\u593C\u5980\u597C\u5985\u597B\u597E\u5977\u597F\u5B56\u5C15\u5C25\u5C7C\u5C7A\u5C7B\u5C7E\u5DDF\u5E75\u5E84\u5F02\u5F1A\u5F74\u5FD5\u5FD4\u5FCF\u625C\u625E\u6264\u6261\u6266\u6262\u6259\u6260\u625A\u6265\u65EF\u65EE\u673E\u6739\u6738\u673B\u673A\u673F\u673C\u6733\u6C18\u6C46\u6C52\u6C5C\u6C4F\u6C4A\u6C54\u6C4B"],["ca40","\u6C4C\u7071\u725E\u72B4\u72B5\u738E\u752A\u767F\u7A75\u7F51\u8278\u827C\u8280\u827D\u827F\u864D\u897E\u9099\u9097\u9098\u909B\u9094\u9622\u9624\u9620\u9623\u4F56\u4F3B\u4F62\u4F49\u4F53\u4F64\u4F3E\u4F67\u4F52\u4F5F\u4F41\u4F58\u4F2D\u4F33\u4F3F\u4F61\u518F\u51B9\u521C\u521E\u5221\u52AD\u52AE\u5309\u5363\u5372\u538E\u538F\u5430\u5437\u542A\u5454\u5445\u5419\u541C\u5425\u5418"],["caa1","\u543D\u544F\u5441\u5428\u5424\u5447\u56EE\u56E7\u56E5\u5741\u5745\u574C\u5749\u574B\u5752\u5906\u5940\u59A6\u5998\u59A0\u5997\u598E\u59A2\u5990\u598F\u59A7\u59A1\u5B8E\u5B92\u5C28\u5C2A\u5C8D\u5C8F\u5C88\u5C8B\u5C89\u5C92\u5C8A\u5C86\u5C93\u5C95\u5DE0\u5E0A\u5E0E\u5E8B\u5E89\u5E8C\u5E88\u5E8D\u5F05\u5F1D\u5F78\u5F76\u5FD2\u5FD1\u5FD0\u5FED\u5FE8\u5FEE\u5FF3\u5FE1\u5FE4\u5FE3\u5FFA\u5FEF\u5FF7\u5FFB\u6000\u5FF4\u623A\u6283\u628C\u628E\u628F\u6294\u6287\u6271\u627B\u627A\u6270\u6281\u6288\u6277\u627D\u6272\u6274\u6537\u65F0\u65F4\u65F3\u65F2\u65F5\u6745\u6747"],["cb40","\u6759\u6755\u674C\u6748\u675D\u674D\u675A\u674B\u6BD0\u6C19\u6C1A\u6C78\u6C67\u6C6B\u6C84\u6C8B\u6C8F\u6C71\u6C6F\u6C69\u6C9A\u6C6D\u6C87\u6C95\u6C9C\u6C66\u6C73\u6C65\u6C7B\u6C8E\u7074\u707A\u7263\u72BF\u72BD\u72C3\u72C6\u72C1\u72BA\u72C5\u7395\u7397\u7393\u7394\u7392\u753A\u7539\u7594\u7595\u7681\u793D\u8034\u8095\u8099\u8090\u8092\u809C\u8290\u828F\u8285\u828E\u8291\u8293"],["cba1","\u828A\u8283\u8284\u8C78\u8FC9\u8FBF\u909F\u90A1\u90A5\u909E\u90A7\u90A0\u9630\u9628\u962F\u962D\u4E33\u4F98\u4F7C\u4F85\u4F7D\u4F80\u4F87\u4F76\u4F74\u4F89\u4F84\u4F77\u4F4C\u4F97\u4F6A\u4F9A\u4F79\u4F81\u4F78\u4F90\u4F9C\u4F94\u4F9E\u4F92\u4F82\u4F95\u4F6B\u4F6E\u519E\u51BC\u51BE\u5235\u5232\u5233\u5246\u5231\u52BC\u530A\u530B\u533C\u5392\u5394\u5487\u547F\u5481\u5491\u5482\u5488\u546B\u547A\u547E\u5465\u546C\u5474\u5466\u548D\u546F\u5461\u5460\u5498\u5463\u5467\u5464\u56F7\u56F9\u576F\u5772\u576D\u576B\u5771\u5770\u5776\u5780\u5775\u577B\u5773\u5774\u5762"],["cc40","\u5768\u577D\u590C\u5945\u59B5\u59BA\u59CF\u59CE\u59B2\u59CC\u59C1\u59B6\u59BC\u59C3\u59D6\u59B1\u59BD\u59C0\u59C8\u59B4\u59C7\u5B62\u5B65\u5B93\u5B95\u5C44\u5C47\u5CAE\u5CA4\u5CA0\u5CB5\u5CAF\u5CA8\u5CAC\u5C9F\u5CA3\u5CAD\u5CA2\u5CAA\u5CA7\u5C9D\u5CA5\u5CB6\u5CB0\u5CA6\u5E17\u5E14\u5E19\u5F28\u5F22\u5F23\u5F24\u5F54\u5F82\u5F7E\u5F7D\u5FDE\u5FE5\u602D\u6026\u6019\u6032\u600B"],["cca1","\u6034\u600A\u6017\u6033\u601A\u601E\u602C\u6022\u600D\u6010\u602E\u6013\u6011\u600C\u6009\u601C\u6214\u623D\u62AD\u62B4\u62D1\u62BE\u62AA\u62B6\u62CA\u62AE\u62B3\u62AF\u62BB\u62A9\u62B0\u62B8\u653D\u65A8\u65BB\u6609\u65FC\u6604\u6612\u6608\u65FB\u6603\u660B\u660D\u6605\u65FD\u6611\u6610\u66F6\u670A\u6785\u676C\u678E\u6792\u6776\u677B\u6798\u6786\u6784\u6774\u678D\u678C\u677A\u679F\u6791\u6799\u6783\u677D\u6781\u6778\u6779\u6794\u6B25\u6B80\u6B7E\u6BDE\u6C1D\u6C93\u6CEC\u6CEB\u6CEE\u6CD9\u6CB6\u6CD4\u6CAD\u6CE7\u6CB7\u6CD0\u6CC2\u6CBA\u6CC3\u6CC6\u6CED\u6CF2"],["cd40","\u6CD2\u6CDD\u6CB4\u6C8A\u6C9D\u6C80\u6CDE\u6CC0\u6D30\u6CCD\u6CC7\u6CB0\u6CF9\u6CCF\u6CE9\u6CD1\u7094\u7098\u7085\u7093\u7086\u7084\u7091\u7096\u7082\u709A\u7083\u726A\u72D6\u72CB\u72D8\u72C9\u72DC\u72D2\u72D4\u72DA\u72CC\u72D1\u73A4\u73A1\u73AD\u73A6\u73A2\u73A0\u73AC\u739D\u74DD\u74E8\u753F\u7540\u753E\u758C\u7598\u76AF\u76F3\u76F1\u76F0\u76F5\u77F8\u77FC\u77F9\u77FB\u77FA"],["cda1","\u77F7\u7942\u793F\u79C5\u7A78\u7A7B\u7AFB\u7C75\u7CFD\u8035\u808F\u80AE\u80A3\u80B8\u80B5\u80AD\u8220\u82A0\u82C0\u82AB\u829A\u8298\u829B\u82B5\u82A7\u82AE\u82BC\u829E\u82BA\u82B4\u82A8\u82A1\u82A9\u82C2\u82A4\u82C3\u82B6\u82A2\u8670\u866F\u866D\u866E\u8C56\u8FD2\u8FCB\u8FD3\u8FCD\u8FD6\u8FD5\u8FD7\u90B2\u90B4\u90AF\u90B3\u90B0\u9639\u963D\u963C\u963A\u9643\u4FCD\u4FC5\u4FD3\u4FB2\u4FC9\u4FCB\u4FC1\u4FD4\u4FDC\u4FD9\u4FBB\u4FB3\u4FDB\u4FC7\u4FD6\u4FBA\u4FC0\u4FB9\u4FEC\u5244\u5249\u52C0\u52C2\u533D\u537C\u5397\u5396\u5399\u5398\u54BA\u54A1\u54AD\u54A5\u54CF"],["ce40","\u54C3\u830D\u54B7\u54AE\u54D6\u54B6\u54C5\u54C6\u54A0\u5470\u54BC\u54A2\u54BE\u5472\u54DE\u54B0\u57B5\u579E\u579F\u57A4\u578C\u5797\u579D\u579B\u5794\u5798\u578F\u5799\u57A5\u579A\u5795\u58F4\u590D\u5953\u59E1\u59DE\u59EE\u5A00\u59F1\u59DD\u59FA\u59FD\u59FC\u59F6\u59E4\u59F2\u59F7\u59DB\u59E9\u59F3\u59F5\u59E0\u59FE\u59F4\u59ED\u5BA8\u5C4C\u5CD0\u5CD8\u5CCC\u5CD7\u5CCB\u5CDB"],["cea1","\u5CDE\u5CDA\u5CC9\u5CC7\u5CCA\u5CD6\u5CD3\u5CD4\u5CCF\u5CC8\u5CC6\u5CCE\u5CDF\u5CF8\u5DF9\u5E21\u5E22\u5E23\u5E20\u5E24\u5EB0\u5EA4\u5EA2\u5E9B\u5EA3\u5EA5\u5F07\u5F2E\u5F56\u5F86\u6037\u6039\u6054\u6072\u605E\u6045\u6053\u6047\u6049\u605B\u604C\u6040\u6042\u605F\u6024\u6044\u6058\u6066\u606E\u6242\u6243\u62CF\u630D\u630B\u62F5\u630E\u6303\u62EB\u62F9\u630F\u630C\u62F8\u62F6\u6300\u6313\u6314\u62FA\u6315\u62FB\u62F0\u6541\u6543\u65AA\u65BF\u6636\u6621\u6632\u6635\u661C\u6626\u6622\u6633\u662B\u663A\u661D\u6634\u6639\u662E\u670F\u6710\u67C1\u67F2\u67C8\u67BA"],["cf40","\u67DC\u67BB\u67F8\u67D8\u67C0\u67B7\u67C5\u67EB\u67E4\u67DF\u67B5\u67CD\u67B3\u67F7\u67F6\u67EE\u67E3\u67C2\u67B9\u67CE\u67E7\u67F0\u67B2\u67FC\u67C6\u67ED\u67CC\u67AE\u67E6\u67DB\u67FA\u67C9\u67CA\u67C3\u67EA\u67CB\u6B28\u6B82\u6B84\u6BB6\u6BD6\u6BD8\u6BE0\u6C20\u6C21\u6D28\u6D34\u6D2D\u6D1F\u6D3C\u6D3F\u6D12\u6D0A\u6CDA\u6D33\u6D04\u6D19\u6D3A\u6D1A\u6D11\u6D00\u6D1D\u6D42"],["cfa1","\u6D01\u6D18\u6D37\u6D03\u6D0F\u6D40\u6D07\u6D20\u6D2C\u6D08\u6D22\u6D09\u6D10\u70B7\u709F\u70BE\u70B1\u70B0\u70A1\u70B4\u70B5\u70A9\u7241\u7249\u724A\u726C\u7270\u7273\u726E\u72CA\u72E4\u72E8\u72EB\u72DF\u72EA\u72E6\u72E3\u7385\u73CC\u73C2\u73C8\u73C5\u73B9\u73B6\u73B5\u73B4\u73EB\u73BF\u73C7\u73BE\u73C3\u73C6\u73B8\u73CB\u74EC\u74EE\u752E\u7547\u7548\u75A7\u75AA\u7679\u76C4\u7708\u7703\u7704\u7705\u770A\u76F7\u76FB\u76FA\u77E7\u77E8\u7806\u7811\u7812\u7805\u7810\u780F\u780E\u7809\u7803\u7813\u794A\u794C\u794B\u7945\u7944\u79D5\u79CD\u79CF\u79D6\u79CE\u7A80"],["d040","\u7A7E\u7AD1\u7B00\u7B01\u7C7A\u7C78\u7C79\u7C7F\u7C80\u7C81\u7D03\u7D08\u7D01\u7F58\u7F91\u7F8D\u7FBE\u8007\u800E\u800F\u8014\u8037\u80D8\u80C7\u80E0\u80D1\u80C8\u80C2\u80D0\u80C5\u80E3\u80D9\u80DC\u80CA\u80D5\u80C9\u80CF\u80D7\u80E6\u80CD\u81FF\u8221\u8294\u82D9\u82FE\u82F9\u8307\u82E8\u8300\u82D5\u833A\u82EB\u82D6\u82F4\u82EC\u82E1\u82F2\u82F5\u830C\u82FB\u82F6\u82F0\u82EA"],["d0a1","\u82E4\u82E0\u82FA\u82F3\u82ED\u8677\u8674\u867C\u8673\u8841\u884E\u8867\u886A\u8869\u89D3\u8A04\u8A07\u8D72\u8FE3\u8FE1\u8FEE\u8FE0\u90F1\u90BD\u90BF\u90D5\u90C5\u90BE\u90C7\u90CB\u90C8\u91D4\u91D3\u9654\u964F\u9651\u9653\u964A\u964E\u501E\u5005\u5007\u5013\u5022\u5030\u501B\u4FF5\u4FF4\u5033\u5037\u502C\u4FF6\u4FF7\u5017\u501C\u5020\u5027\u5035\u502F\u5031\u500E\u515A\u5194\u5193\u51CA\u51C4\u51C5\u51C8\u51CE\u5261\u525A\u5252\u525E\u525F\u5255\u5262\u52CD\u530E\u539E\u5526\u54E2\u5517\u5512\u54E7\u54F3\u54E4\u551A\u54FF\u5504\u5508\u54EB\u5511\u5505\u54F1"],["d140","\u550A\u54FB\u54F7\u54F8\u54E0\u550E\u5503\u550B\u5701\u5702\u57CC\u5832\u57D5\u57D2\u57BA\u57C6\u57BD\u57BC\u57B8\u57B6\u57BF\u57C7\u57D0\u57B9\u57C1\u590E\u594A\u5A19\u5A16\u5A2D\u5A2E\u5A15\u5A0F\u5A17\u5A0A\u5A1E\u5A33\u5B6C\u5BA7\u5BAD\u5BAC\u5C03\u5C56\u5C54\u5CEC\u5CFF\u5CEE\u5CF1\u5CF7\u5D00\u5CF9\u5E29\u5E28\u5EA8\u5EAE\u5EAA\u5EAC\u5F33\u5F30\u5F67\u605D\u605A\u6067"],["d1a1","\u6041\u60A2\u6088\u6080\u6092\u6081\u609D\u6083\u6095\u609B\u6097\u6087\u609C\u608E\u6219\u6246\u62F2\u6310\u6356\u632C\u6344\u6345\u6336\u6343\u63E4\u6339\u634B\u634A\u633C\u6329\u6341\u6334\u6358\u6354\u6359\u632D\u6347\u6333\u635A\u6351\u6338\u6357\u6340\u6348\u654A\u6546\u65C6\u65C3\u65C4\u65C2\u664A\u665F\u6647\u6651\u6712\u6713\u681F\u681A\u6849\u6832\u6833\u683B\u684B\u684F\u6816\u6831\u681C\u6835\u682B\u682D\u682F\u684E\u6844\u6834\u681D\u6812\u6814\u6826\u6828\u682E\u684D\u683A\u6825\u6820\u6B2C\u6B2F\u6B2D\u6B31\u6B34\u6B6D\u8082\u6B88\u6BE6\u6BE4"],["d240","\u6BE8\u6BE3\u6BE2\u6BE7\u6C25\u6D7A\u6D63\u6D64\u6D76\u6D0D\u6D61\u6D92\u6D58\u6D62\u6D6D\u6D6F\u6D91\u6D8D\u6DEF\u6D7F\u6D86\u6D5E\u6D67\u6D60\u6D97\u6D70\u6D7C\u6D5F\u6D82\u6D98\u6D2F\u6D68\u6D8B\u6D7E\u6D80\u6D84\u6D16\u6D83\u6D7B\u6D7D\u6D75\u6D90\u70DC\u70D3\u70D1\u70DD\u70CB\u7F39\u70E2\u70D7\u70D2\u70DE\u70E0\u70D4\u70CD\u70C5\u70C6\u70C7\u70DA\u70CE\u70E1\u7242\u7278"],["d2a1","\u7277\u7276\u7300\u72FA\u72F4\u72FE\u72F6\u72F3\u72FB\u7301\u73D3\u73D9\u73E5\u73D6\u73BC\u73E7\u73E3\u73E9\u73DC\u73D2\u73DB\u73D4\u73DD\u73DA\u73D7\u73D8\u73E8\u74DE\u74DF\u74F4\u74F5\u7521\u755B\u755F\u75B0\u75C1\u75BB\u75C4\u75C0\u75BF\u75B6\u75BA\u768A\u76C9\u771D\u771B\u7710\u7713\u7712\u7723\u7711\u7715\u7719\u771A\u7722\u7727\u7823\u782C\u7822\u7835\u782F\u7828\u782E\u782B\u7821\u7829\u7833\u782A\u7831\u7954\u795B\u794F\u795C\u7953\u7952\u7951\u79EB\u79EC\u79E0\u79EE\u79ED\u79EA\u79DC\u79DE\u79DD\u7A86\u7A89\u7A85\u7A8B\u7A8C\u7A8A\u7A87\u7AD8\u7B10"],["d340","\u7B04\u7B13\u7B05\u7B0F\u7B08\u7B0A\u7B0E\u7B09\u7B12\u7C84\u7C91\u7C8A\u7C8C\u7C88\u7C8D\u7C85\u7D1E\u7D1D\u7D11\u7D0E\u7D18\u7D16\u7D13\u7D1F\u7D12\u7D0F\u7D0C\u7F5C\u7F61\u7F5E\u7F60\u7F5D\u7F5B\u7F96\u7F92\u7FC3\u7FC2\u7FC0\u8016\u803E\u8039\u80FA\u80F2\u80F9\u80F5\u8101\u80FB\u8100\u8201\u822F\u8225\u8333\u832D\u8344\u8319\u8351\u8325\u8356\u833F\u8341\u8326\u831C\u8322"],["d3a1","\u8342\u834E\u831B\u832A\u8308\u833C\u834D\u8316\u8324\u8320\u8337\u832F\u8329\u8347\u8345\u834C\u8353\u831E\u832C\u834B\u8327\u8348\u8653\u8652\u86A2\u86A8\u8696\u868D\u8691\u869E\u8687\u8697\u8686\u868B\u869A\u8685\u86A5\u8699\u86A1\u86A7\u8695\u8698\u868E\u869D\u8690\u8694\u8843\u8844\u886D\u8875\u8876\u8872\u8880\u8871\u887F\u886F\u8883\u887E\u8874\u887C\u8A12\u8C47\u8C57\u8C7B\u8CA4\u8CA3\u8D76\u8D78\u8DB5\u8DB7\u8DB6\u8ED1\u8ED3\u8FFE\u8FF5\u9002\u8FFF\u8FFB\u9004\u8FFC\u8FF6\u90D6\u90E0\u90D9\u90DA\u90E3\u90DF\u90E5\u90D8\u90DB\u90D7\u90DC\u90E4\u9150"],["d440","\u914E\u914F\u91D5\u91E2\u91DA\u965C\u965F\u96BC\u98E3\u9ADF\u9B2F\u4E7F\u5070\u506A\u5061\u505E\u5060\u5053\u504B\u505D\u5072\u5048\u504D\u5041\u505B\u504A\u5062\u5015\u5045\u505F\u5069\u506B\u5063\u5064\u5046\u5040\u506E\u5073\u5057\u5051\u51D0\u526B\u526D\u526C\u526E\u52D6\u52D3\u532D\u539C\u5575\u5576\u553C\u554D\u5550\u5534\u552A\u5551\u5562\u5536\u5535\u5530\u5552\u5545"],["d4a1","\u550C\u5532\u5565\u554E\u5539\u5548\u552D\u553B\u5540\u554B\u570A\u5707\u57FB\u5814\u57E2\u57F6\u57DC\u57F4\u5800\u57ED\u57FD\u5808\u57F8\u580B\u57F3\u57CF\u5807\u57EE\u57E3\u57F2\u57E5\u57EC\u57E1\u580E\u57FC\u5810\u57E7\u5801\u580C\u57F1\u57E9\u57F0\u580D\u5804\u595C\u5A60\u5A58\u5A55\u5A67\u5A5E\u5A38\u5A35\u5A6D\u5A50\u5A5F\u5A65\u5A6C\u5A53\u5A64\u5A57\u5A43\u5A5D\u5A52\u5A44\u5A5B\u5A48\u5A8E\u5A3E\u5A4D\u5A39\u5A4C\u5A70\u5A69\u5A47\u5A51\u5A56\u5A42\u5A5C\u5B72\u5B6E\u5BC1\u5BC0\u5C59\u5D1E\u5D0B\u5D1D\u5D1A\u5D20\u5D0C\u5D28\u5D0D\u5D26\u5D25\u5D0F"],["d540","\u5D30\u5D12\u5D23\u5D1F\u5D2E\u5E3E\u5E34\u5EB1\u5EB4\u5EB9\u5EB2\u5EB3\u5F36\u5F38\u5F9B\u5F96\u5F9F\u608A\u6090\u6086\u60BE\u60B0\u60BA\u60D3\u60D4\u60CF\u60E4\u60D9\u60DD\u60C8\u60B1\u60DB\u60B7\u60CA\u60BF\u60C3\u60CD\u60C0\u6332\u6365\u638A\u6382\u637D\u63BD\u639E\u63AD\u639D\u6397\u63AB\u638E\u636F\u6387\u6390\u636E\u63AF\u6375\u639C\u636D\u63AE\u637C\u63A4\u633B\u639F"],["d5a1","\u6378\u6385\u6381\u6391\u638D\u6370\u6553\u65CD\u6665\u6661\u665B\u6659\u665C\u6662\u6718\u6879\u6887\u6890\u689C\u686D\u686E\u68AE\u68AB\u6956\u686F\u68A3\u68AC\u68A9\u6875\u6874\u68B2\u688F\u6877\u6892\u687C\u686B\u6872\u68AA\u6880\u6871\u687E\u689B\u6896\u688B\u68A0\u6889\u68A4\u6878\u687B\u6891\u688C\u688A\u687D\u6B36\u6B33\u6B37\u6B38\u6B91\u6B8F\u6B8D\u6B8E\u6B8C\u6C2A\u6DC0\u6DAB\u6DB4\u6DB3\u6E74\u6DAC\u6DE9\u6DE2\u6DB7\u6DF6\u6DD4\u6E00\u6DC8\u6DE0\u6DDF\u6DD6\u6DBE\u6DE5\u6DDC\u6DDD\u6DDB\u6DF4\u6DCA\u6DBD\u6DED\u6DF0\u6DBA\u6DD5\u6DC2\u6DCF\u6DC9"],["d640","\u6DD0\u6DF2\u6DD3\u6DFD\u6DD7\u6DCD\u6DE3\u6DBB\u70FA\u710D\u70F7\u7117\u70F4\u710C\u70F0\u7104\u70F3\u7110\u70FC\u70FF\u7106\u7113\u7100\u70F8\u70F6\u710B\u7102\u710E\u727E\u727B\u727C\u727F\u731D\u7317\u7307\u7311\u7318\u730A\u7308\u72FF\u730F\u731E\u7388\u73F6\u73F8\u73F5\u7404\u7401\u73FD\u7407\u7400\u73FA\u73FC\u73FF\u740C\u740B\u73F4\u7408\u7564\u7563\u75CE\u75D2\u75CF"],["d6a1","\u75CB\u75CC\u75D1\u75D0\u768F\u7689\u76D3\u7739\u772F\u772D\u7731\u7732\u7734\u7733\u773D\u7725\u773B\u7735\u7848\u7852\u7849\u784D\u784A\u784C\u7826\u7845\u7850\u7964\u7967\u7969\u796A\u7963\u796B\u7961\u79BB\u79FA\u79F8\u79F6\u79F7\u7A8F\u7A94\u7A90\u7B35\u7B47\u7B34\u7B25\u7B30\u7B22\u7B24\u7B33\u7B18\u7B2A\u7B1D\u7B31\u7B2B\u7B2D\u7B2F\u7B32\u7B38\u7B1A\u7B23\u7C94\u7C98\u7C96\u7CA3\u7D35\u7D3D\u7D38\u7D36\u7D3A\u7D45\u7D2C\u7D29\u7D41\u7D47\u7D3E\u7D3F\u7D4A\u7D3B\u7D28\u7F63\u7F95\u7F9C\u7F9D\u7F9B\u7FCA\u7FCB\u7FCD\u7FD0\u7FD1\u7FC7\u7FCF\u7FC9\u801F"],["d740","\u801E\u801B\u8047\u8043\u8048\u8118\u8125\u8119\u811B\u812D\u811F\u812C\u811E\u8121\u8115\u8127\u811D\u8122\u8211\u8238\u8233\u823A\u8234\u8232\u8274\u8390\u83A3\u83A8\u838D\u837A\u8373\u83A4\u8374\u838F\u8381\u8395\u8399\u8375\u8394\u83A9\u837D\u8383\u838C\u839D\u839B\u83AA\u838B\u837E\u83A5\u83AF\u8388\u8397\u83B0\u837F\u83A6\u8387\u83AE\u8376\u839A\u8659\u8656\u86BF\u86B7"],["d7a1","\u86C2\u86C1\u86C5\u86BA\u86B0\u86C8\u86B9\u86B3\u86B8\u86CC\u86B4\u86BB\u86BC\u86C3\u86BD\u86BE\u8852\u8889\u8895\u88A8\u88A2\u88AA\u889A\u8891\u88A1\u889F\u8898\u88A7\u8899\u889B\u8897\u88A4\u88AC\u888C\u8893\u888E\u8982\u89D6\u89D9\u89D5\u8A30\u8A27\u8A2C\u8A1E\u8C39\u8C3B\u8C5C\u8C5D\u8C7D\u8CA5\u8D7D\u8D7B\u8D79\u8DBC\u8DC2\u8DB9\u8DBF\u8DC1\u8ED8\u8EDE\u8EDD\u8EDC\u8ED7\u8EE0\u8EE1\u9024\u900B\u9011\u901C\u900C\u9021\u90EF\u90EA\u90F0\u90F4\u90F2\u90F3\u90D4\u90EB\u90EC\u90E9\u9156\u9158\u915A\u9153\u9155\u91EC\u91F4\u91F1\u91F3\u91F8\u91E4\u91F9\u91EA"],["d840","\u91EB\u91F7\u91E8\u91EE\u957A\u9586\u9588\u967C\u966D\u966B\u9671\u966F\u96BF\u976A\u9804\u98E5\u9997\u509B\u5095\u5094\u509E\u508B\u50A3\u5083\u508C\u508E\u509D\u5068\u509C\u5092\u5082\u5087\u515F\u51D4\u5312\u5311\u53A4\u53A7\u5591\u55A8\u55A5\u55AD\u5577\u5645\u55A2\u5593\u5588\u558F\u55B5\u5581\u55A3\u5592\u55A4\u557D\u558C\u55A6\u557F\u5595\u55A1\u558E\u570C\u5829\u5837"],["d8a1","\u5819\u581E\u5827\u5823\u5828\u57F5\u5848\u5825\u581C\u581B\u5833\u583F\u5836\u582E\u5839\u5838\u582D\u582C\u583B\u5961\u5AAF\u5A94\u5A9F\u5A7A\u5AA2\u5A9E\u5A78\u5AA6\u5A7C\u5AA5\u5AAC\u5A95\u5AAE\u5A37\u5A84\u5A8A\u5A97\u5A83\u5A8B\u5AA9\u5A7B\u5A7D\u5A8C\u5A9C\u5A8F\u5A93\u5A9D\u5BEA\u5BCD\u5BCB\u5BD4\u5BD1\u5BCA\u5BCE\u5C0C\u5C30\u5D37\u5D43\u5D6B\u5D41\u5D4B\u5D3F\u5D35\u5D51\u5D4E\u5D55\u5D33\u5D3A\u5D52\u5D3D\u5D31\u5D59\u5D42\u5D39\u5D49\u5D38\u5D3C\u5D32\u5D36\u5D40\u5D45\u5E44\u5E41\u5F58\u5FA6\u5FA5\u5FAB\u60C9\u60B9\u60CC\u60E2\u60CE\u60C4\u6114"],["d940","\u60F2\u610A\u6116\u6105\u60F5\u6113\u60F8\u60FC\u60FE\u60C1\u6103\u6118\u611D\u6110\u60FF\u6104\u610B\u624A\u6394\u63B1\u63B0\u63CE\u63E5\u63E8\u63EF\u63C3\u649D\u63F3\u63CA\u63E0\u63F6\u63D5\u63F2\u63F5\u6461\u63DF\u63BE\u63DD\u63DC\u63C4\u63D8\u63D3\u63C2\u63C7\u63CC\u63CB\u63C8\u63F0\u63D7\u63D9\u6532\u6567\u656A\u6564\u655C\u6568\u6565\u658C\u659D\u659E\u65AE\u65D0\u65D2"],["d9a1","\u667C\u666C\u667B\u6680\u6671\u6679\u666A\u6672\u6701\u690C\u68D3\u6904\u68DC\u692A\u68EC\u68EA\u68F1\u690F\u68D6\u68F7\u68EB\u68E4\u68F6\u6913\u6910\u68F3\u68E1\u6907\u68CC\u6908\u6970\u68B4\u6911\u68EF\u68C6\u6914\u68F8\u68D0\u68FD\u68FC\u68E8\u690B\u690A\u6917\u68CE\u68C8\u68DD\u68DE\u68E6\u68F4\u68D1\u6906\u68D4\u68E9\u6915\u6925\u68C7\u6B39\u6B3B\u6B3F\u6B3C\u6B94\u6B97\u6B99\u6B95\u6BBD\u6BF0\u6BF2\u6BF3\u6C30\u6DFC\u6E46\u6E47\u6E1F\u6E49\u6E88\u6E3C\u6E3D\u6E45\u6E62\u6E2B\u6E3F\u6E41\u6E5D\u6E73\u6E1C\u6E33\u6E4B\u6E40\u6E51\u6E3B\u6E03\u6E2E\u6E5E"],["da40","\u6E68\u6E5C\u6E61\u6E31\u6E28\u6E60\u6E71\u6E6B\u6E39\u6E22\u6E30\u6E53\u6E65\u6E27\u6E78\u6E64\u6E77\u6E55\u6E79\u6E52\u6E66\u6E35\u6E36\u6E5A\u7120\u711E\u712F\u70FB\u712E\u7131\u7123\u7125\u7122\u7132\u711F\u7128\u713A\u711B\u724B\u725A\u7288\u7289\u7286\u7285\u728B\u7312\u730B\u7330\u7322\u7331\u7333\u7327\u7332\u732D\u7326\u7323\u7335\u730C\u742E\u742C\u7430\u742B\u7416"],["daa1","\u741A\u7421\u742D\u7431\u7424\u7423\u741D\u7429\u7420\u7432\u74FB\u752F\u756F\u756C\u75E7\u75DA\u75E1\u75E6\u75DD\u75DF\u75E4\u75D7\u7695\u7692\u76DA\u7746\u7747\u7744\u774D\u7745\u774A\u774E\u774B\u774C\u77DE\u77EC\u7860\u7864\u7865\u785C\u786D\u7871\u786A\u786E\u7870\u7869\u7868\u785E\u7862\u7974\u7973\u7972\u7970\u7A02\u7A0A\u7A03\u7A0C\u7A04\u7A99\u7AE6\u7AE4\u7B4A\u7B3B\u7B44\u7B48\u7B4C\u7B4E\u7B40\u7B58\u7B45\u7CA2\u7C9E\u7CA8\u7CA1\u7D58\u7D6F\u7D63\u7D53\u7D56\u7D67\u7D6A\u7D4F\u7D6D\u7D5C\u7D6B\u7D52\u7D54\u7D69\u7D51\u7D5F\u7D4E\u7F3E\u7F3F\u7F65"],["db40","\u7F66\u7FA2\u7FA0\u7FA1\u7FD7\u8051\u804F\u8050\u80FE\u80D4\u8143\u814A\u8152\u814F\u8147\u813D\u814D\u813A\u81E6\u81EE\u81F7\u81F8\u81F9\u8204\u823C\u823D\u823F\u8275\u833B\u83CF\u83F9\u8423\u83C0\u83E8\u8412\u83E7\u83E4\u83FC\u83F6\u8410\u83C6\u83C8\u83EB\u83E3\u83BF\u8401\u83DD\u83E5\u83D8\u83FF\u83E1\u83CB\u83CE\u83D6\u83F5\u83C9\u8409\u840F\u83DE\u8411\u8406\u83C2\u83F3"],["dba1","\u83D5\u83FA\u83C7\u83D1\u83EA\u8413\u83C3\u83EC\u83EE\u83C4\u83FB\u83D7\u83E2\u841B\u83DB\u83FE\u86D8\u86E2\u86E6\u86D3\u86E3\u86DA\u86EA\u86DD\u86EB\u86DC\u86EC\u86E9\u86D7\u86E8\u86D1\u8848\u8856\u8855\u88BA\u88D7\u88B9\u88B8\u88C0\u88BE\u88B6\u88BC\u88B7\u88BD\u88B2\u8901\u88C9\u8995\u8998\u8997\u89DD\u89DA\u89DB\u8A4E\u8A4D\u8A39\u8A59\u8A40\u8A57\u8A58\u8A44\u8A45\u8A52\u8A48\u8A51\u8A4A\u8A4C\u8A4F\u8C5F\u8C81\u8C80\u8CBA\u8CBE\u8CB0\u8CB9\u8CB5\u8D84\u8D80\u8D89\u8DD8\u8DD3\u8DCD\u8DC7\u8DD6\u8DDC\u8DCF\u8DD5\u8DD9\u8DC8\u8DD7\u8DC5\u8EEF\u8EF7\u8EFA"],["dc40","\u8EF9\u8EE6\u8EEE\u8EE5\u8EF5\u8EE7\u8EE8\u8EF6\u8EEB\u8EF1\u8EEC\u8EF4\u8EE9\u902D\u9034\u902F\u9106\u912C\u9104\u90FF\u90FC\u9108\u90F9\u90FB\u9101\u9100\u9107\u9105\u9103\u9161\u9164\u915F\u9162\u9160\u9201\u920A\u9225\u9203\u921A\u9226\u920F\u920C\u9200\u9212\u91FF\u91FD\u9206\u9204\u9227\u9202\u921C\u9224\u9219\u9217\u9205\u9216\u957B\u958D\u958C\u9590\u9687\u967E\u9688"],["dca1","\u9689\u9683\u9680\u96C2\u96C8\u96C3\u96F1\u96F0\u976C\u9770\u976E\u9807\u98A9\u98EB\u9CE6\u9EF9\u4E83\u4E84\u4EB6\u50BD\u50BF\u50C6\u50AE\u50C4\u50CA\u50B4\u50C8\u50C2\u50B0\u50C1\u50BA\u50B1\u50CB\u50C9\u50B6\u50B8\u51D7\u527A\u5278\u527B\u527C\u55C3\u55DB\u55CC\u55D0\u55CB\u55CA\u55DD\u55C0\u55D4\u55C4\u55E9\u55BF\u55D2\u558D\u55CF\u55D5\u55E2\u55D6\u55C8\u55F2\u55CD\u55D9\u55C2\u5714\u5853\u5868\u5864\u584F\u584D\u5849\u586F\u5855\u584E\u585D\u5859\u5865\u585B\u583D\u5863\u5871\u58FC\u5AC7\u5AC4\u5ACB\u5ABA\u5AB8\u5AB1\u5AB5\u5AB0\u5ABF\u5AC8\u5ABB\u5AC6"],["dd40","\u5AB7\u5AC0\u5ACA\u5AB4\u5AB6\u5ACD\u5AB9\u5A90\u5BD6\u5BD8\u5BD9\u5C1F\u5C33\u5D71\u5D63\u5D4A\u5D65\u5D72\u5D6C\u5D5E\u5D68\u5D67\u5D62\u5DF0\u5E4F\u5E4E\u5E4A\u5E4D\u5E4B\u5EC5\u5ECC\u5EC6\u5ECB\u5EC7\u5F40\u5FAF\u5FAD\u60F7\u6149\u614A\u612B\u6145\u6136\u6132\u612E\u6146\u612F\u614F\u6129\u6140\u6220\u9168\u6223\u6225\u6224\u63C5\u63F1\u63EB\u6410\u6412\u6409\u6420\u6424"],["dda1","\u6433\u6443\u641F\u6415\u6418\u6439\u6437\u6422\u6423\u640C\u6426\u6430\u6428\u6441\u6435\u642F\u640A\u641A\u6440\u6425\u6427\u640B\u63E7\u641B\u642E\u6421\u640E\u656F\u6592\u65D3\u6686\u668C\u6695\u6690\u668B\u668A\u6699\u6694\u6678\u6720\u6966\u695F\u6938\u694E\u6962\u6971\u693F\u6945\u696A\u6939\u6942\u6957\u6959\u697A\u6948\u6949\u6935\u696C\u6933\u693D\u6965\u68F0\u6978\u6934\u6969\u6940\u696F\u6944\u6976\u6958\u6941\u6974\u694C\u693B\u694B\u6937\u695C\u694F\u6951\u6932\u6952\u692F\u697B\u693C\u6B46\u6B45\u6B43\u6B42\u6B48\u6B41\u6B9B\uFA0D\u6BFB\u6BFC"],["de40","\u6BF9\u6BF7\u6BF8\u6E9B\u6ED6\u6EC8\u6E8F\u6EC0\u6E9F\u6E93\u6E94\u6EA0\u6EB1\u6EB9\u6EC6\u6ED2\u6EBD\u6EC1\u6E9E\u6EC9\u6EB7\u6EB0\u6ECD\u6EA6\u6ECF\u6EB2\u6EBE\u6EC3\u6EDC\u6ED8\u6E99\u6E92\u6E8E\u6E8D\u6EA4\u6EA1\u6EBF\u6EB3\u6ED0\u6ECA\u6E97\u6EAE\u6EA3\u7147\u7154\u7152\u7163\u7160\u7141\u715D\u7162\u7172\u7178\u716A\u7161\u7142\u7158\u7143\u714B\u7170\u715F\u7150\u7153"],["dea1","\u7144\u714D\u715A\u724F\u728D\u728C\u7291\u7290\u728E\u733C\u7342\u733B\u733A\u7340\u734A\u7349\u7444\u744A\u744B\u7452\u7451\u7457\u7440\u744F\u7450\u744E\u7442\u7446\u744D\u7454\u74E1\u74FF\u74FE\u74FD\u751D\u7579\u7577\u6983\u75EF\u760F\u7603\u75F7\u75FE\u75FC\u75F9\u75F8\u7610\u75FB\u75F6\u75ED\u75F5\u75FD\u7699\u76B5\u76DD\u7755\u775F\u7760\u7752\u7756\u775A\u7769\u7767\u7754\u7759\u776D\u77E0\u7887\u789A\u7894\u788F\u7884\u7895\u7885\u7886\u78A1\u7883\u7879\u7899\u7880\u7896\u787B\u797C\u7982\u797D\u7979\u7A11\u7A18\u7A19\u7A12\u7A17\u7A15\u7A22\u7A13"],["df40","\u7A1B\u7A10\u7AA3\u7AA2\u7A9E\u7AEB\u7B66\u7B64\u7B6D\u7B74\u7B69\u7B72\u7B65\u7B73\u7B71\u7B70\u7B61\u7B78\u7B76\u7B63\u7CB2\u7CB4\u7CAF\u7D88\u7D86\u7D80\u7D8D\u7D7F\u7D85\u7D7A\u7D8E\u7D7B\u7D83\u7D7C\u7D8C\u7D94\u7D84\u7D7D\u7D92\u7F6D\u7F6B\u7F67\u7F68\u7F6C\u7FA6\u7FA5\u7FA7\u7FDB\u7FDC\u8021\u8164\u8160\u8177\u815C\u8169\u815B\u8162\u8172\u6721\u815E\u8176\u8167\u816F"],["dfa1","\u8144\u8161\u821D\u8249\u8244\u8240\u8242\u8245\u84F1\u843F\u8456\u8476\u8479\u848F\u848D\u8465\u8451\u8440\u8486\u8467\u8430\u844D\u847D\u845A\u8459\u8474\u8473\u845D\u8507\u845E\u8437\u843A\u8434\u847A\u8443\u8478\u8432\u8445\u8429\u83D9\u844B\u842F\u8442\u842D\u845F\u8470\u8439\u844E\u844C\u8452\u846F\u84C5\u848E\u843B\u8447\u8436\u8433\u8468\u847E\u8444\u842B\u8460\u8454\u846E\u8450\u870B\u8704\u86F7\u870C\u86FA\u86D6\u86F5\u874D\u86F8\u870E\u8709\u8701\u86F6\u870D\u8705\u88D6\u88CB\u88CD\u88CE\u88DE\u88DB\u88DA\u88CC\u88D0\u8985\u899B\u89DF\u89E5\u89E4"],["e040","\u89E1\u89E0\u89E2\u89DC\u89E6\u8A76\u8A86\u8A7F\u8A61\u8A3F\u8A77\u8A82\u8A84\u8A75\u8A83\u8A81\u8A74\u8A7A\u8C3C\u8C4B\u8C4A\u8C65\u8C64\u8C66\u8C86\u8C84\u8C85\u8CCC\u8D68\u8D69\u8D91\u8D8C\u8D8E\u8D8F\u8D8D\u8D93\u8D94\u8D90\u8D92\u8DF0\u8DE0\u8DEC\u8DF1\u8DEE\u8DD0\u8DE9\u8DE3\u8DE2\u8DE7\u8DF2\u8DEB\u8DF4\u8F06\u8EFF\u8F01\u8F00\u8F05\u8F07\u8F08\u8F02\u8F0B\u9052\u903F"],["e0a1","\u9044\u9049\u903D\u9110\u910D\u910F\u9111\u9116\u9114\u910B\u910E\u916E\u916F\u9248\u9252\u9230\u923A\u9266\u9233\u9265\u925E\u9283\u922E\u924A\u9246\u926D\u926C\u924F\u9260\u9267\u926F\u9236\u9261\u9270\u9231\u9254\u9263\u9250\u9272\u924E\u9253\u924C\u9256\u9232\u959F\u959C\u959E\u959B\u9692\u9693\u9691\u9697\u96CE\u96FA\u96FD\u96F8\u96F5\u9773\u9777\u9778\u9772\u980F\u980D\u980E\u98AC\u98F6\u98F9\u99AF\u99B2\u99B0\u99B5\u9AAD\u9AAB\u9B5B\u9CEA\u9CED\u9CE7\u9E80\u9EFD\u50E6\u50D4\u50D7\u50E8\u50F3\u50DB\u50EA\u50DD\u50E4\u50D3\u50EC\u50F0\u50EF\u50E3\u50E0"],["e140","\u51D8\u5280\u5281\u52E9\u52EB\u5330\u53AC\u5627\u5615\u560C\u5612\u55FC\u560F\u561C\u5601\u5613\u5602\u55FA\u561D\u5604\u55FF\u55F9\u5889\u587C\u5890\u5898\u5886\u5881\u587F\u5874\u588B\u587A\u5887\u5891\u588E\u5876\u5882\u5888\u587B\u5894\u588F\u58FE\u596B\u5ADC\u5AEE\u5AE5\u5AD5\u5AEA\u5ADA\u5AED\u5AEB\u5AF3\u5AE2\u5AE0\u5ADB\u5AEC\u5ADE\u5ADD\u5AD9\u5AE8\u5ADF\u5B77\u5BE0"],["e1a1","\u5BE3\u5C63\u5D82\u5D80\u5D7D\u5D86\u5D7A\u5D81\u5D77\u5D8A\u5D89\u5D88\u5D7E\u5D7C\u5D8D\u5D79\u5D7F\u5E58\u5E59\u5E53\u5ED8\u5ED1\u5ED7\u5ECE\u5EDC\u5ED5\u5ED9\u5ED2\u5ED4\u5F44\u5F43\u5F6F\u5FB6\u612C\u6128\u6141\u615E\u6171\u6173\u6152\u6153\u6172\u616C\u6180\u6174\u6154\u617A\u615B\u6165\u613B\u616A\u6161\u6156\u6229\u6227\u622B\u642B\u644D\u645B\u645D\u6474\u6476\u6472\u6473\u647D\u6475\u6466\u64A6\u644E\u6482\u645E\u645C\u644B\u6453\u6460\u6450\u647F\u643F\u646C\u646B\u6459\u6465\u6477\u6573\u65A0\u66A1\u66A0\u669F\u6705\u6704\u6722\u69B1\u69B6\u69C9"],["e240","\u69A0\u69CE\u6996\u69B0\u69AC\u69BC\u6991\u6999\u698E\u69A7\u698D\u69A9\u69BE\u69AF\u69BF\u69C4\u69BD\u69A4\u69D4\u69B9\u69CA\u699A\u69CF\u69B3\u6993\u69AA\u69A1\u699E\u69D9\u6997\u6990\u69C2\u69B5\u69A5\u69C6\u6B4A\u6B4D\u6B4B\u6B9E\u6B9F\u6BA0\u6BC3\u6BC4\u6BFE\u6ECE\u6EF5\u6EF1\u6F03\u6F25\u6EF8\u6F37\u6EFB\u6F2E\u6F09\u6F4E\u6F19\u6F1A\u6F27\u6F18\u6F3B\u6F12\u6EED\u6F0A"],["e2a1","\u6F36\u6F73\u6EF9\u6EEE\u6F2D\u6F40\u6F30\u6F3C\u6F35\u6EEB\u6F07\u6F0E\u6F43\u6F05\u6EFD\u6EF6\u6F39\u6F1C\u6EFC\u6F3A\u6F1F\u6F0D\u6F1E\u6F08\u6F21\u7187\u7190\u7189\u7180\u7185\u7182\u718F\u717B\u7186\u7181\u7197\u7244\u7253\u7297\u7295\u7293\u7343\u734D\u7351\u734C\u7462\u7473\u7471\u7475\u7472\u7467\u746E\u7500\u7502\u7503\u757D\u7590\u7616\u7608\u760C\u7615\u7611\u760A\u7614\u76B8\u7781\u777C\u7785\u7782\u776E\u7780\u776F\u777E\u7783\u78B2\u78AA\u78B4\u78AD\u78A8\u787E\u78AB\u789E\u78A5\u78A0\u78AC\u78A2\u78A4\u7998\u798A\u798B\u7996\u7995\u7994\u7993"],["e340","\u7997\u7988\u7992\u7990\u7A2B\u7A4A\u7A30\u7A2F\u7A28\u7A26\u7AA8\u7AAB\u7AAC\u7AEE\u7B88\u7B9C\u7B8A\u7B91\u7B90\u7B96\u7B8D\u7B8C\u7B9B\u7B8E\u7B85\u7B98\u5284\u7B99\u7BA4\u7B82\u7CBB\u7CBF\u7CBC\u7CBA\u7DA7\u7DB7\u7DC2\u7DA3\u7DAA\u7DC1\u7DC0\u7DC5\u7D9D\u7DCE\u7DC4\u7DC6\u7DCB\u7DCC\u7DAF\u7DB9\u7D96\u7DBC\u7D9F\u7DA6\u7DAE\u7DA9\u7DA1\u7DC9\u7F73\u7FE2\u7FE3\u7FE5\u7FDE"],["e3a1","\u8024\u805D\u805C\u8189\u8186\u8183\u8187\u818D\u818C\u818B\u8215\u8497\u84A4\u84A1\u849F\u84BA\u84CE\u84C2\u84AC\u84AE\u84AB\u84B9\u84B4\u84C1\u84CD\u84AA\u849A\u84B1\u84D0\u849D\u84A7\u84BB\u84A2\u8494\u84C7\u84CC\u849B\u84A9\u84AF\u84A8\u84D6\u8498\u84B6\u84CF\u84A0\u84D7\u84D4\u84D2\u84DB\u84B0\u8491\u8661\u8733\u8723\u8728\u876B\u8740\u872E\u871E\u8721\u8719\u871B\u8743\u872C\u8741\u873E\u8746\u8720\u8732\u872A\u872D\u873C\u8712\u873A\u8731\u8735\u8742\u8726\u8727\u8738\u8724\u871A\u8730\u8711\u88F7\u88E7\u88F1\u88F2\u88FA\u88FE\u88EE\u88FC\u88F6\u88FB"],["e440","\u88F0\u88EC\u88EB\u899D\u89A1\u899F\u899E\u89E9\u89EB\u89E8\u8AAB\u8A99\u8A8B\u8A92\u8A8F\u8A96\u8C3D\u8C68\u8C69\u8CD5\u8CCF\u8CD7\u8D96\u8E09\u8E02\u8DFF\u8E0D\u8DFD\u8E0A\u8E03\u8E07\u8E06\u8E05\u8DFE\u8E00\u8E04\u8F10\u8F11\u8F0E\u8F0D\u9123\u911C\u9120\u9122\u911F\u911D\u911A\u9124\u9121\u911B\u917A\u9172\u9179\u9173\u92A5\u92A4\u9276\u929B\u927A\u92A0\u9294\u92AA\u928D"],["e4a1","\u92A6\u929A\u92AB\u9279\u9297\u927F\u92A3\u92EE\u928E\u9282\u9295\u92A2\u927D\u9288\u92A1\u928A\u9286\u928C\u9299\u92A7\u927E\u9287\u92A9\u929D\u928B\u922D\u969E\u96A1\u96FF\u9758\u977D\u977A\u977E\u9783\u9780\u9782\u977B\u9784\u9781\u977F\u97CE\u97CD\u9816\u98AD\u98AE\u9902\u9900\u9907\u999D\u999C\u99C3\u99B9\u99BB\u99BA\u99C2\u99BD\u99C7\u9AB1\u9AE3\u9AE7\u9B3E\u9B3F\u9B60\u9B61\u9B5F\u9CF1\u9CF2\u9CF5\u9EA7\u50FF\u5103\u5130\u50F8\u5106\u5107\u50F6\u50FE\u510B\u510C\u50FD\u510A\u528B\u528C\u52F1\u52EF\u5648\u5642\u564C\u5635\u5641\u564A\u5649\u5646\u5658"],["e540","\u565A\u5640\u5633\u563D\u562C\u563E\u5638\u562A\u563A\u571A\u58AB\u589D\u58B1\u58A0\u58A3\u58AF\u58AC\u58A5\u58A1\u58FF\u5AFF\u5AF4\u5AFD\u5AF7\u5AF6\u5B03\u5AF8\u5B02\u5AF9\u5B01\u5B07\u5B05\u5B0F\u5C67\u5D99\u5D97\u5D9F\u5D92\u5DA2\u5D93\u5D95\u5DA0\u5D9C\u5DA1\u5D9A\u5D9E\u5E69\u5E5D\u5E60\u5E5C\u7DF3\u5EDB\u5EDE\u5EE1\u5F49\u5FB2\u618B\u6183\u6179\u61B1\u61B0\u61A2\u6189"],["e5a1","\u619B\u6193\u61AF\u61AD\u619F\u6192\u61AA\u61A1\u618D\u6166\u61B3\u622D\u646E\u6470\u6496\u64A0\u6485\u6497\u649C\u648F\u648B\u648A\u648C\u64A3\u649F\u6468\u64B1\u6498\u6576\u657A\u6579\u657B\u65B2\u65B3\u66B5\u66B0\u66A9\u66B2\u66B7\u66AA\u66AF\u6A00\u6A06\u6A17\u69E5\u69F8\u6A15\u69F1\u69E4\u6A20\u69FF\u69EC\u69E2\u6A1B\u6A1D\u69FE\u6A27\u69F2\u69EE\u6A14\u69F7\u69E7\u6A40\u6A08\u69E6\u69FB\u6A0D\u69FC\u69EB\u6A09\u6A04\u6A18\u6A25\u6A0F\u69F6\u6A26\u6A07\u69F4\u6A16\u6B51\u6BA5\u6BA3\u6BA2\u6BA6\u6C01\u6C00\u6BFF\u6C02\u6F41\u6F26\u6F7E\u6F87\u6FC6\u6F92"],["e640","\u6F8D\u6F89\u6F8C\u6F62\u6F4F\u6F85\u6F5A\u6F96\u6F76\u6F6C\u6F82\u6F55\u6F72\u6F52\u6F50\u6F57\u6F94\u6F93\u6F5D\u6F00\u6F61\u6F6B\u6F7D\u6F67\u6F90\u6F53\u6F8B\u6F69\u6F7F\u6F95\u6F63\u6F77\u6F6A\u6F7B\u71B2\u71AF\u719B\u71B0\u71A0\u719A\u71A9\u71B5\u719D\u71A5\u719E\u71A4\u71A1\u71AA\u719C\u71A7\u71B3\u7298\u729A\u7358\u7352\u735E\u735F\u7360\u735D\u735B\u7361\u735A\u7359"],["e6a1","\u7362\u7487\u7489\u748A\u7486\u7481\u747D\u7485\u7488\u747C\u7479\u7508\u7507\u757E\u7625\u761E\u7619\u761D\u761C\u7623\u761A\u7628\u761B\u769C\u769D\u769E\u769B\u778D\u778F\u7789\u7788\u78CD\u78BB\u78CF\u78CC\u78D1\u78CE\u78D4\u78C8\u78C3\u78C4\u78C9\u799A\u79A1\u79A0\u799C\u79A2\u799B\u6B76\u7A39\u7AB2\u7AB4\u7AB3\u7BB7\u7BCB\u7BBE\u7BAC\u7BCE\u7BAF\u7BB9\u7BCA\u7BB5\u7CC5\u7CC8\u7CCC\u7CCB\u7DF7\u7DDB\u7DEA\u7DE7\u7DD7\u7DE1\u7E03\u7DFA\u7DE6\u7DF6\u7DF1\u7DF0\u7DEE\u7DDF\u7F76\u7FAC\u7FB0\u7FAD\u7FED\u7FEB\u7FEA\u7FEC\u7FE6\u7FE8\u8064\u8067\u81A3\u819F"],["e740","\u819E\u8195\u81A2\u8199\u8197\u8216\u824F\u8253\u8252\u8250\u824E\u8251\u8524\u853B\u850F\u8500\u8529\u850E\u8509\u850D\u851F\u850A\u8527\u851C\u84FB\u852B\u84FA\u8508\u850C\u84F4\u852A\u84F2\u8515\u84F7\u84EB\u84F3\u84FC\u8512\u84EA\u84E9\u8516\u84FE\u8528\u851D\u852E\u8502\u84FD\u851E\u84F6\u8531\u8526\u84E7\u84E8\u84F0\u84EF\u84F9\u8518\u8520\u8530\u850B\u8519\u852F\u8662"],["e7a1","\u8756\u8763\u8764\u8777\u87E1\u8773\u8758\u8754\u875B\u8752\u8761\u875A\u8751\u875E\u876D\u876A\u8750\u874E\u875F\u875D\u876F\u876C\u877A\u876E\u875C\u8765\u874F\u877B\u8775\u8762\u8767\u8769\u885A\u8905\u890C\u8914\u890B\u8917\u8918\u8919\u8906\u8916\u8911\u890E\u8909\u89A2\u89A4\u89A3\u89ED\u89F0\u89EC\u8ACF\u8AC6\u8AB8\u8AD3\u8AD1\u8AD4\u8AD5\u8ABB\u8AD7\u8ABE\u8AC0\u8AC5\u8AD8\u8AC3\u8ABA\u8ABD\u8AD9\u8C3E\u8C4D\u8C8F\u8CE5\u8CDF\u8CD9\u8CE8\u8CDA\u8CDD\u8CE7\u8DA0\u8D9C\u8DA1\u8D9B\u8E20\u8E23\u8E25\u8E24\u8E2E\u8E15\u8E1B\u8E16\u8E11\u8E19\u8E26\u8E27"],["e840","\u8E14\u8E12\u8E18\u8E13\u8E1C\u8E17\u8E1A\u8F2C\u8F24\u8F18\u8F1A\u8F20\u8F23\u8F16\u8F17\u9073\u9070\u906F\u9067\u906B\u912F\u912B\u9129\u912A\u9132\u9126\u912E\u9185\u9186\u918A\u9181\u9182\u9184\u9180\u92D0\u92C3\u92C4\u92C0\u92D9\u92B6\u92CF\u92F1\u92DF\u92D8\u92E9\u92D7\u92DD\u92CC\u92EF\u92C2\u92E8\u92CA\u92C8\u92CE\u92E6\u92CD\u92D5\u92C9\u92E0\u92DE\u92E7\u92D1\u92D3"],["e8a1","\u92B5\u92E1\u92C6\u92B4\u957C\u95AC\u95AB\u95AE\u95B0\u96A4\u96A2\u96D3\u9705\u9708\u9702\u975A\u978A\u978E\u9788\u97D0\u97CF\u981E\u981D\u9826\u9829\u9828\u9820\u981B\u9827\u98B2\u9908\u98FA\u9911\u9914\u9916\u9917\u9915\u99DC\u99CD\u99CF\u99D3\u99D4\u99CE\u99C9\u99D6\u99D8\u99CB\u99D7\u99CC\u9AB3\u9AEC\u9AEB\u9AF3\u9AF2\u9AF1\u9B46\u9B43\u9B67\u9B74\u9B71\u9B66\u9B76\u9B75\u9B70\u9B68\u9B64\u9B6C\u9CFC\u9CFA\u9CFD\u9CFF\u9CF7\u9D07\u9D00\u9CF9\u9CFB\u9D08\u9D05\u9D04\u9E83\u9ED3\u9F0F\u9F10\u511C\u5113\u5117\u511A\u5111\u51DE\u5334\u53E1\u5670\u5660\u566E"],["e940","\u5673\u5666\u5663\u566D\u5672\u565E\u5677\u571C\u571B\u58C8\u58BD\u58C9\u58BF\u58BA\u58C2\u58BC\u58C6\u5B17\u5B19\u5B1B\u5B21\u5B14\u5B13\u5B10\u5B16\u5B28\u5B1A\u5B20\u5B1E\u5BEF\u5DAC\u5DB1\u5DA9\u5DA7\u5DB5\u5DB0\u5DAE\u5DAA\u5DA8\u5DB2\u5DAD\u5DAF\u5DB4\u5E67\u5E68\u5E66\u5E6F\u5EE9\u5EE7\u5EE6\u5EE8\u5EE5\u5F4B\u5FBC\u619D\u61A8\u6196\u61C5\u61B4\u61C6\u61C1\u61CC\u61BA"],["e9a1","\u61BF\u61B8\u618C\u64D7\u64D6\u64D0\u64CF\u64C9\u64BD\u6489\u64C3\u64DB\u64F3\u64D9\u6533\u657F\u657C\u65A2\u66C8\u66BE\u66C0\u66CA\u66CB\u66CF\u66BD\u66BB\u66BA\u66CC\u6723\u6A34\u6A66\u6A49\u6A67\u6A32\u6A68\u6A3E\u6A5D\u6A6D\u6A76\u6A5B\u6A51\u6A28\u6A5A\u6A3B\u6A3F\u6A41\u6A6A\u6A64\u6A50\u6A4F\u6A54\u6A6F\u6A69\u6A60\u6A3C\u6A5E\u6A56\u6A55\u6A4D\u6A4E\u6A46\u6B55\u6B54\u6B56\u6BA7\u6BAA\u6BAB\u6BC8\u6BC7\u6C04\u6C03\u6C06\u6FAD\u6FCB\u6FA3\u6FC7\u6FBC\u6FCE\u6FC8\u6F5E\u6FC4\u6FBD\u6F9E\u6FCA\u6FA8\u7004\u6FA5\u6FAE\u6FBA\u6FAC\u6FAA\u6FCF\u6FBF\u6FB8"],["ea40","\u6FA2\u6FC9\u6FAB\u6FCD\u6FAF\u6FB2\u6FB0\u71C5\u71C2\u71BF\u71B8\u71D6\u71C0\u71C1\u71CB\u71D4\u71CA\u71C7\u71CF\u71BD\u71D8\u71BC\u71C6\u71DA\u71DB\u729D\u729E\u7369\u7366\u7367\u736C\u7365\u736B\u736A\u747F\u749A\u74A0\u7494\u7492\u7495\u74A1\u750B\u7580\u762F\u762D\u7631\u763D\u7633\u763C\u7635\u7632\u7630\u76BB\u76E6\u779A\u779D\u77A1\u779C\u779B\u77A2\u77A3\u7795\u7799"],["eaa1","\u7797\u78DD\u78E9\u78E5\u78EA\u78DE\u78E3\u78DB\u78E1\u78E2\u78ED\u78DF\u78E0\u79A4\u7A44\u7A48\u7A47\u7AB6\u7AB8\u7AB5\u7AB1\u7AB7\u7BDE\u7BE3\u7BE7\u7BDD\u7BD5\u7BE5\u7BDA\u7BE8\u7BF9\u7BD4\u7BEA\u7BE2\u7BDC\u7BEB\u7BD8\u7BDF\u7CD2\u7CD4\u7CD7\u7CD0\u7CD1\u7E12\u7E21\u7E17\u7E0C\u7E1F\u7E20\u7E13\u7E0E\u7E1C\u7E15\u7E1A\u7E22\u7E0B\u7E0F\u7E16\u7E0D\u7E14\u7E25\u7E24\u7F43\u7F7B\u7F7C\u7F7A\u7FB1\u7FEF\u802A\u8029\u806C\u81B1\u81A6\u81AE\u81B9\u81B5\u81AB\u81B0\u81AC\u81B4\u81B2\u81B7\u81A7\u81F2\u8255\u8256\u8257\u8556\u8545\u856B\u854D\u8553\u8561\u8558"],["eb40","\u8540\u8546\u8564\u8541\u8562\u8544\u8551\u8547\u8563\u853E\u855B\u8571\u854E\u856E\u8575\u8555\u8567\u8560\u858C\u8566\u855D\u8554\u8565\u856C\u8663\u8665\u8664\u879B\u878F\u8797\u8793\u8792\u8788\u8781\u8796\u8798\u8779\u8787\u87A3\u8785\u8790\u8791\u879D\u8784\u8794\u879C\u879A\u8789\u891E\u8926\u8930\u892D\u892E\u8927\u8931\u8922\u8929\u8923\u892F\u892C\u891F\u89F1\u8AE0"],["eba1","\u8AE2\u8AF2\u8AF4\u8AF5\u8ADD\u8B14\u8AE4\u8ADF\u8AF0\u8AC8\u8ADE\u8AE1\u8AE8\u8AFF\u8AEF\u8AFB\u8C91\u8C92\u8C90\u8CF5\u8CEE\u8CF1\u8CF0\u8CF3\u8D6C\u8D6E\u8DA5\u8DA7\u8E33\u8E3E\u8E38\u8E40\u8E45\u8E36\u8E3C\u8E3D\u8E41\u8E30\u8E3F\u8EBD\u8F36\u8F2E\u8F35\u8F32\u8F39\u8F37\u8F34\u9076\u9079\u907B\u9086\u90FA\u9133\u9135\u9136\u9193\u9190\u9191\u918D\u918F\u9327\u931E\u9308\u931F\u9306\u930F\u937A\u9338\u933C\u931B\u9323\u9312\u9301\u9346\u932D\u930E\u930D\u92CB\u931D\u92FA\u9325\u9313\u92F9\u92F7\u9334\u9302\u9324\u92FF\u9329\u9339\u9335\u932A\u9314\u930C"],["ec40","\u930B\u92FE\u9309\u9300\u92FB\u9316\u95BC\u95CD\u95BE\u95B9\u95BA\u95B6\u95BF\u95B5\u95BD\u96A9\u96D4\u970B\u9712\u9710\u9799\u9797\u9794\u97F0\u97F8\u9835\u982F\u9832\u9924\u991F\u9927\u9929\u999E\u99EE\u99EC\u99E5\u99E4\u99F0\u99E3\u99EA\u99E9\u99E7\u9AB9\u9ABF\u9AB4\u9ABB\u9AF6\u9AFA\u9AF9\u9AF7\u9B33\u9B80\u9B85\u9B87\u9B7C\u9B7E\u9B7B\u9B82\u9B93\u9B92\u9B90\u9B7A\u9B95"],["eca1","\u9B7D\u9B88\u9D25\u9D17\u9D20\u9D1E\u9D14\u9D29\u9D1D\u9D18\u9D22\u9D10\u9D19\u9D1F\u9E88\u9E86\u9E87\u9EAE\u9EAD\u9ED5\u9ED6\u9EFA\u9F12\u9F3D\u5126\u5125\u5122\u5124\u5120\u5129\u52F4\u5693\u568C\u568D\u5686\u5684\u5683\u567E\u5682\u567F\u5681\u58D6\u58D4\u58CF\u58D2\u5B2D\u5B25\u5B32\u5B23\u5B2C\u5B27\u5B26\u5B2F\u5B2E\u5B7B\u5BF1\u5BF2\u5DB7\u5E6C\u5E6A\u5FBE\u5FBB\u61C3\u61B5\u61BC\u61E7\u61E0\u61E5\u61E4\u61E8\u61DE\u64EF\u64E9\u64E3\u64EB\u64E4\u64E8\u6581\u6580\u65B6\u65DA\u66D2\u6A8D\u6A96\u6A81\u6AA5\u6A89\u6A9F\u6A9B\u6AA1\u6A9E\u6A87\u6A93\u6A8E"],["ed40","\u6A95\u6A83\u6AA8\u6AA4\u6A91\u6A7F\u6AA6\u6A9A\u6A85\u6A8C\u6A92\u6B5B\u6BAD\u6C09\u6FCC\u6FA9\u6FF4\u6FD4\u6FE3\u6FDC\u6FED\u6FE7\u6FE6\u6FDE\u6FF2\u6FDD\u6FE2\u6FE8\u71E1\u71F1\u71E8\u71F2\u71E4\u71F0\u71E2\u7373\u736E\u736F\u7497\u74B2\u74AB\u7490\u74AA\u74AD\u74B1\u74A5\u74AF\u7510\u7511\u7512\u750F\u7584\u7643\u7648\u7649\u7647\u76A4\u76E9\u77B5\u77AB\u77B2\u77B7\u77B6"],["eda1","\u77B4\u77B1\u77A8\u77F0\u78F3\u78FD\u7902\u78FB\u78FC\u78F2\u7905\u78F9\u78FE\u7904\u79AB\u79A8\u7A5C\u7A5B\u7A56\u7A58\u7A54\u7A5A\u7ABE\u7AC0\u7AC1\u7C05\u7C0F\u7BF2\u7C00\u7BFF\u7BFB\u7C0E\u7BF4\u7C0B\u7BF3\u7C02\u7C09\u7C03\u7C01\u7BF8\u7BFD\u7C06\u7BF0\u7BF1\u7C10\u7C0A\u7CE8\u7E2D\u7E3C\u7E42\u7E33\u9848\u7E38\u7E2A\u7E49\u7E40\u7E47\u7E29\u7E4C\u7E30\u7E3B\u7E36\u7E44\u7E3A\u7F45\u7F7F\u7F7E\u7F7D\u7FF4\u7FF2\u802C\u81BB\u81C4\u81CC\u81CA\u81C5\u81C7\u81BC\u81E9\u825B\u825A\u825C\u8583\u8580\u858F\u85A7\u8595\u85A0\u858B\u85A3\u857B\u85A4\u859A\u859E"],["ee40","\u8577\u857C\u8589\u85A1\u857A\u8578\u8557\u858E\u8596\u8586\u858D\u8599\u859D\u8581\u85A2\u8582\u8588\u8585\u8579\u8576\u8598\u8590\u859F\u8668\u87BE\u87AA\u87AD\u87C5\u87B0\u87AC\u87B9\u87B5\u87BC\u87AE\u87C9\u87C3\u87C2\u87CC\u87B7\u87AF\u87C4\u87CA\u87B4\u87B6\u87BF\u87B8\u87BD\u87DE\u87B2\u8935\u8933\u893C\u893E\u8941\u8952\u8937\u8942\u89AD\u89AF\u89AE\u89F2\u89F3\u8B1E"],["eea1","\u8B18\u8B16\u8B11\u8B05\u8B0B\u8B22\u8B0F\u8B12\u8B15\u8B07\u8B0D\u8B08\u8B06\u8B1C\u8B13\u8B1A\u8C4F\u8C70\u8C72\u8C71\u8C6F\u8C95\u8C94\u8CF9\u8D6F\u8E4E\u8E4D\u8E53\u8E50\u8E4C\u8E47\u8F43\u8F40\u9085\u907E\u9138\u919A\u91A2\u919B\u9199\u919F\u91A1\u919D\u91A0\u93A1\u9383\u93AF\u9364\u9356\u9347\u937C\u9358\u935C\u9376\u9349\u9350\u9351\u9360\u936D\u938F\u934C\u936A\u9379\u9357\u9355\u9352\u934F\u9371\u9377\u937B\u9361\u935E\u9363\u9367\u9380\u934E\u9359\u95C7\u95C0\u95C9\u95C3\u95C5\u95B7\u96AE\u96B0\u96AC\u9720\u971F\u9718\u971D\u9719\u979A\u97A1\u979C"],["ef40","\u979E\u979D\u97D5\u97D4\u97F1\u9841\u9844\u984A\u9849\u9845\u9843\u9925\u992B\u992C\u992A\u9933\u9932\u992F\u992D\u9931\u9930\u9998\u99A3\u99A1\u9A02\u99FA\u99F4\u99F7\u99F9\u99F8\u99F6\u99FB\u99FD\u99FE\u99FC\u9A03\u9ABE\u9AFE\u9AFD\u9B01\u9AFC\u9B48\u9B9A\u9BA8\u9B9E\u9B9B\u9BA6\u9BA1\u9BA5\u9BA4\u9B86\u9BA2\u9BA0\u9BAF\u9D33\u9D41\u9D67\u9D36\u9D2E\u9D2F\u9D31\u9D38\u9D30"],["efa1","\u9D45\u9D42\u9D43\u9D3E\u9D37\u9D40\u9D3D\u7FF5\u9D2D\u9E8A\u9E89\u9E8D\u9EB0\u9EC8\u9EDA\u9EFB\u9EFF\u9F24\u9F23\u9F22\u9F54\u9FA0\u5131\u512D\u512E\u5698\u569C\u5697\u569A\u569D\u5699\u5970\u5B3C\u5C69\u5C6A\u5DC0\u5E6D\u5E6E\u61D8\u61DF\u61ED\u61EE\u61F1\u61EA\u61F0\u61EB\u61D6\u61E9\u64FF\u6504\u64FD\u64F8\u6501\u6503\u64FC\u6594\u65DB\u66DA\u66DB\u66D8\u6AC5\u6AB9\u6ABD\u6AE1\u6AC6\u6ABA\u6AB6\u6AB7\u6AC7\u6AB4\u6AAD\u6B5E\u6BC9\u6C0B\u7007\u700C\u700D\u7001\u7005\u7014\u700E\u6FFF\u7000\u6FFB\u7026\u6FFC\u6FF7\u700A\u7201\u71FF\u71F9\u7203\u71FD\u7376"],["f040","\u74B8\u74C0\u74B5\u74C1\u74BE\u74B6\u74BB\u74C2\u7514\u7513\u765C\u7664\u7659\u7650\u7653\u7657\u765A\u76A6\u76BD\u76EC\u77C2\u77BA\u78FF\u790C\u7913\u7914\u7909\u7910\u7912\u7911\u79AD\u79AC\u7A5F\u7C1C\u7C29\u7C19\u7C20\u7C1F\u7C2D\u7C1D\u7C26\u7C28\u7C22\u7C25\u7C30\u7E5C\u7E50\u7E56\u7E63\u7E58\u7E62\u7E5F\u7E51\u7E60\u7E57\u7E53\u7FB5\u7FB3\u7FF7\u7FF8\u8075\u81D1\u81D2"],["f0a1","\u81D0\u825F\u825E\u85B4\u85C6\u85C0\u85C3\u85C2\u85B3\u85B5\u85BD\u85C7\u85C4\u85BF\u85CB\u85CE\u85C8\u85C5\u85B1\u85B6\u85D2\u8624\u85B8\u85B7\u85BE\u8669\u87E7\u87E6\u87E2\u87DB\u87EB\u87EA\u87E5\u87DF\u87F3\u87E4\u87D4\u87DC\u87D3\u87ED\u87D8\u87E3\u87A4\u87D7\u87D9\u8801\u87F4\u87E8\u87DD\u8953\u894B\u894F\u894C\u8946\u8950\u8951\u8949\u8B2A\u8B27\u8B23\u8B33\u8B30\u8B35\u8B47\u8B2F\u8B3C\u8B3E\u8B31\u8B25\u8B37\u8B26\u8B36\u8B2E\u8B24\u8B3B\u8B3D\u8B3A\u8C42\u8C75\u8C99\u8C98\u8C97\u8CFE\u8D04\u8D02\u8D00\u8E5C\u8E62\u8E60\u8E57\u8E56\u8E5E\u8E65\u8E67"],["f140","\u8E5B\u8E5A\u8E61\u8E5D\u8E69\u8E54\u8F46\u8F47\u8F48\u8F4B\u9128\u913A\u913B\u913E\u91A8\u91A5\u91A7\u91AF\u91AA\u93B5\u938C\u9392\u93B7\u939B\u939D\u9389\u93A7\u938E\u93AA\u939E\u93A6\u9395\u9388\u9399\u939F\u938D\u93B1\u9391\u93B2\u93A4\u93A8\u93B4\u93A3\u93A5\u95D2\u95D3\u95D1\u96B3\u96D7\u96DA\u5DC2\u96DF\u96D8\u96DD\u9723\u9722\u9725\u97AC\u97AE\u97A8\u97AB\u97A4\u97AA"],["f1a1","\u97A2\u97A5\u97D7\u97D9\u97D6\u97D8\u97FA\u9850\u9851\u9852\u98B8\u9941\u993C\u993A\u9A0F\u9A0B\u9A09\u9A0D\u9A04\u9A11\u9A0A\u9A05\u9A07\u9A06\u9AC0\u9ADC\u9B08\u9B04\u9B05\u9B29\u9B35\u9B4A\u9B4C\u9B4B\u9BC7\u9BC6\u9BC3\u9BBF\u9BC1\u9BB5\u9BB8\u9BD3\u9BB6\u9BC4\u9BB9\u9BBD\u9D5C\u9D53\u9D4F\u9D4A\u9D5B\u9D4B\u9D59\u9D56\u9D4C\u9D57\u9D52\u9D54\u9D5F\u9D58\u9D5A\u9E8E\u9E8C\u9EDF\u9F01\u9F00\u9F16\u9F25\u9F2B\u9F2A\u9F29\u9F28\u9F4C\u9F55\u5134\u5135\u5296\u52F7\u53B4\u56AB\u56AD\u56A6\u56A7\u56AA\u56AC\u58DA\u58DD\u58DB\u5912\u5B3D\u5B3E\u5B3F\u5DC3\u5E70"],["f240","\u5FBF\u61FB\u6507\u6510\u650D\u6509\u650C\u650E\u6584\u65DE\u65DD\u66DE\u6AE7\u6AE0\u6ACC\u6AD1\u6AD9\u6ACB\u6ADF\u6ADC\u6AD0\u6AEB\u6ACF\u6ACD\u6ADE\u6B60\u6BB0\u6C0C\u7019\u7027\u7020\u7016\u702B\u7021\u7022\u7023\u7029\u7017\u7024\u701C\u702A\u720C\u720A\u7207\u7202\u7205\u72A5\u72A6\u72A4\u72A3\u72A1\u74CB\u74C5\u74B7\u74C3\u7516\u7660\u77C9\u77CA\u77C4\u77F1\u791D\u791B"],["f2a1","\u7921\u791C\u7917\u791E\u79B0\u7A67\u7A68\u7C33\u7C3C\u7C39\u7C2C\u7C3B\u7CEC\u7CEA\u7E76\u7E75\u7E78\u7E70\u7E77\u7E6F\u7E7A\u7E72\u7E74\u7E68\u7F4B\u7F4A\u7F83\u7F86\u7FB7\u7FFD\u7FFE\u8078\u81D7\u81D5\u8264\u8261\u8263\u85EB\u85F1\u85ED\u85D9\u85E1\u85E8\u85DA\u85D7\u85EC\u85F2\u85F8\u85D8\u85DF\u85E3\u85DC\u85D1\u85F0\u85E6\u85EF\u85DE\u85E2\u8800\u87FA\u8803\u87F6\u87F7\u8809\u880C\u880B\u8806\u87FC\u8808\u87FF\u880A\u8802\u8962\u895A\u895B\u8957\u8961\u895C\u8958\u895D\u8959\u8988\u89B7\u89B6\u89F6\u8B50\u8B48\u8B4A\u8B40\u8B53\u8B56\u8B54\u8B4B\u8B55"],["f340","\u8B51\u8B42\u8B52\u8B57\u8C43\u8C77\u8C76\u8C9A\u8D06\u8D07\u8D09\u8DAC\u8DAA\u8DAD\u8DAB\u8E6D\u8E78\u8E73\u8E6A\u8E6F\u8E7B\u8EC2\u8F52\u8F51\u8F4F\u8F50\u8F53\u8FB4\u9140\u913F\u91B0\u91AD\u93DE\u93C7\u93CF\u93C2\u93DA\u93D0\u93F9\u93EC\u93CC\u93D9\u93A9\u93E6\u93CA\u93D4\u93EE\u93E3\u93D5\u93C4\u93CE\u93C0\u93D2\u93E7\u957D\u95DA\u95DB\u96E1\u9729\u972B\u972C\u9728\u9726"],["f3a1","\u97B3\u97B7\u97B6\u97DD\u97DE\u97DF\u985C\u9859\u985D\u9857\u98BF\u98BD\u98BB\u98BE\u9948\u9947\u9943\u99A6\u99A7\u9A1A\u9A15\u9A25\u9A1D\u9A24\u9A1B\u9A22\u9A20\u9A27\u9A23\u9A1E\u9A1C\u9A14\u9AC2\u9B0B\u9B0A\u9B0E\u9B0C\u9B37\u9BEA\u9BEB\u9BE0\u9BDE\u9BE4\u9BE6\u9BE2\u9BF0\u9BD4\u9BD7\u9BEC\u9BDC\u9BD9\u9BE5\u9BD5\u9BE1\u9BDA\u9D77\u9D81\u9D8A\u9D84\u9D88\u9D71\u9D80\u9D78\u9D86\u9D8B\u9D8C\u9D7D\u9D6B\u9D74\u9D75\u9D70\u9D69\u9D85\u9D73\u9D7B\u9D82\u9D6F\u9D79\u9D7F\u9D87\u9D68\u9E94\u9E91\u9EC0\u9EFC\u9F2D\u9F40\u9F41\u9F4D\u9F56\u9F57\u9F58\u5337\u56B2"],["f440","\u56B5\u56B3\u58E3\u5B45\u5DC6\u5DC7\u5EEE\u5EEF\u5FC0\u5FC1\u61F9\u6517\u6516\u6515\u6513\u65DF\u66E8\u66E3\u66E4\u6AF3\u6AF0\u6AEA\u6AE8\u6AF9\u6AF1\u6AEE\u6AEF\u703C\u7035\u702F\u7037\u7034\u7031\u7042\u7038\u703F\u703A\u7039\u7040\u703B\u7033\u7041\u7213\u7214\u72A8\u737D\u737C\u74BA\u76AB\u76AA\u76BE\u76ED\u77CC\u77CE\u77CF\u77CD\u77F2\u7925\u7923\u7927\u7928\u7924\u7929"],["f4a1","\u79B2\u7A6E\u7A6C\u7A6D\u7AF7\u7C49\u7C48\u7C4A\u7C47\u7C45\u7CEE\u7E7B\u7E7E\u7E81\u7E80\u7FBA\u7FFF\u8079\u81DB\u81D9\u820B\u8268\u8269\u8622\u85FF\u8601\u85FE\u861B\u8600\u85F6\u8604\u8609\u8605\u860C\u85FD\u8819\u8810\u8811\u8817\u8813\u8816\u8963\u8966\u89B9\u89F7\u8B60\u8B6A\u8B5D\u8B68\u8B63\u8B65\u8B67\u8B6D\u8DAE\u8E86\u8E88\u8E84\u8F59\u8F56\u8F57\u8F55\u8F58\u8F5A\u908D\u9143\u9141\u91B7\u91B5\u91B2\u91B3\u940B\u9413\u93FB\u9420\u940F\u9414\u93FE\u9415\u9410\u9428\u9419\u940D\u93F5\u9400\u93F7\u9407\u940E\u9416\u9412\u93FA\u9409\u93F8\u940A\u93FF"],["f540","\u93FC\u940C\u93F6\u9411\u9406\u95DE\u95E0\u95DF\u972E\u972F\u97B9\u97BB\u97FD\u97FE\u9860\u9862\u9863\u985F\u98C1\u98C2\u9950\u994E\u9959\u994C\u994B\u9953\u9A32\u9A34\u9A31\u9A2C\u9A2A\u9A36\u9A29\u9A2E\u9A38\u9A2D\u9AC7\u9ACA\u9AC6\u9B10\u9B12\u9B11\u9C0B\u9C08\u9BF7\u9C05\u9C12\u9BF8\u9C40\u9C07\u9C0E\u9C06\u9C17\u9C14\u9C09\u9D9F\u9D99\u9DA4\u9D9D\u9D92\u9D98\u9D90\u9D9B"],["f5a1","\u9DA0\u9D94\u9D9C\u9DAA\u9D97\u9DA1\u9D9A\u9DA2\u9DA8\u9D9E\u9DA3\u9DBF\u9DA9\u9D96\u9DA6\u9DA7\u9E99\u9E9B\u9E9A\u9EE5\u9EE4\u9EE7\u9EE6\u9F30\u9F2E\u9F5B\u9F60\u9F5E\u9F5D\u9F59\u9F91\u513A\u5139\u5298\u5297\u56C3\u56BD\u56BE\u5B48\u5B47\u5DCB\u5DCF\u5EF1\u61FD\u651B\u6B02\u6AFC\u6B03\u6AF8\u6B00\u7043\u7044\u704A\u7048\u7049\u7045\u7046\u721D\u721A\u7219\u737E\u7517\u766A\u77D0\u792D\u7931\u792F\u7C54\u7C53\u7CF2\u7E8A\u7E87\u7E88\u7E8B\u7E86\u7E8D\u7F4D\u7FBB\u8030\u81DD\u8618\u862A\u8626\u861F\u8623\u861C\u8619\u8627\u862E\u8621\u8620\u8629\u861E\u8625"],["f640","\u8829\u881D\u881B\u8820\u8824\u881C\u882B\u884A\u896D\u8969\u896E\u896B\u89FA\u8B79\u8B78\u8B45\u8B7A\u8B7B\u8D10\u8D14\u8DAF\u8E8E\u8E8C\u8F5E\u8F5B\u8F5D\u9146\u9144\u9145\u91B9\u943F\u943B\u9436\u9429\u943D\u943C\u9430\u9439\u942A\u9437\u942C\u9440\u9431\u95E5\u95E4\u95E3\u9735\u973A\u97BF\u97E1\u9864\u98C9\u98C6\u98C0\u9958\u9956\u9A39\u9A3D\u9A46\u9A44\u9A42\u9A41\u9A3A"],["f6a1","\u9A3F\u9ACD\u9B15\u9B17\u9B18\u9B16\u9B3A\u9B52\u9C2B\u9C1D\u9C1C\u9C2C\u9C23\u9C28\u9C29\u9C24\u9C21\u9DB7\u9DB6\u9DBC\u9DC1\u9DC7\u9DCA\u9DCF\u9DBE\u9DC5\u9DC3\u9DBB\u9DB5\u9DCE\u9DB9\u9DBA\u9DAC\u9DC8\u9DB1\u9DAD\u9DCC\u9DB3\u9DCD\u9DB2\u9E7A\u9E9C\u9EEB\u9EEE\u9EED\u9F1B\u9F18\u9F1A\u9F31\u9F4E\u9F65\u9F64\u9F92\u4EB9\u56C6\u56C5\u56CB\u5971\u5B4B\u5B4C\u5DD5\u5DD1\u5EF2\u6521\u6520\u6526\u6522\u6B0B\u6B08\u6B09\u6C0D\u7055\u7056\u7057\u7052\u721E\u721F\u72A9\u737F\u74D8\u74D5\u74D9\u74D7\u766D\u76AD\u7935\u79B4\u7A70\u7A71\u7C57\u7C5C\u7C59\u7C5B\u7C5A"],["f740","\u7CF4\u7CF1\u7E91\u7F4F\u7F87\u81DE\u826B\u8634\u8635\u8633\u862C\u8632\u8636\u882C\u8828\u8826\u882A\u8825\u8971\u89BF\u89BE\u89FB\u8B7E\u8B84\u8B82\u8B86\u8B85\u8B7F\u8D15\u8E95\u8E94\u8E9A\u8E92\u8E90\u8E96\u8E97\u8F60\u8F62\u9147\u944C\u9450\u944A\u944B\u944F\u9447\u9445\u9448\u9449\u9446\u973F\u97E3\u986A\u9869\u98CB\u9954\u995B\u9A4E\u9A53\u9A54\u9A4C\u9A4F\u9A48\u9A4A"],["f7a1","\u9A49\u9A52\u9A50\u9AD0\u9B19\u9B2B\u9B3B\u9B56\u9B55\u9C46\u9C48\u9C3F\u9C44\u9C39\u9C33\u9C41\u9C3C\u9C37\u9C34\u9C32\u9C3D\u9C36\u9DDB\u9DD2\u9DDE\u9DDA\u9DCB\u9DD0\u9DDC\u9DD1\u9DDF\u9DE9\u9DD9\u9DD8\u9DD6\u9DF5\u9DD5\u9DDD\u9EB6\u9EF0\u9F35\u9F33\u9F32\u9F42\u9F6B\u9F95\u9FA2\u513D\u5299\u58E8\u58E7\u5972\u5B4D\u5DD8\u882F\u5F4F\u6201\u6203\u6204\u6529\u6525\u6596\u66EB\u6B11\u6B12\u6B0F\u6BCA\u705B\u705A\u7222\u7382\u7381\u7383\u7670\u77D4\u7C67\u7C66\u7E95\u826C\u863A\u8640\u8639\u863C\u8631\u863B\u863E\u8830\u8832\u882E\u8833\u8976\u8974\u8973\u89FE"],["f840","\u8B8C\u8B8E\u8B8B\u8B88\u8C45\u8D19\u8E98\u8F64\u8F63\u91BC\u9462\u9455\u945D\u9457\u945E\u97C4\u97C5\u9800\u9A56\u9A59\u9B1E\u9B1F\u9B20\u9C52\u9C58\u9C50\u9C4A\u9C4D\u9C4B\u9C55\u9C59\u9C4C\u9C4E\u9DFB\u9DF7\u9DEF\u9DE3\u9DEB\u9DF8\u9DE4\u9DF6\u9DE1\u9DEE\u9DE6\u9DF2\u9DF0\u9DE2\u9DEC\u9DF4\u9DF3\u9DE8\u9DED\u9EC2\u9ED0\u9EF2\u9EF3\u9F06\u9F1C\u9F38\u9F37\u9F36\u9F43\u9F4F"],["f8a1","\u9F71\u9F70\u9F6E\u9F6F\u56D3\u56CD\u5B4E\u5C6D\u652D\u66ED\u66EE\u6B13\u705F\u7061\u705D\u7060\u7223\u74DB\u74E5\u77D5\u7938\u79B7\u79B6\u7C6A\u7E97\u7F89\u826D\u8643\u8838\u8837\u8835\u884B\u8B94\u8B95\u8E9E\u8E9F\u8EA0\u8E9D\u91BE\u91BD\u91C2\u946B\u9468\u9469\u96E5\u9746\u9743\u9747\u97C7\u97E5\u9A5E\u9AD5\u9B59\u9C63\u9C67\u9C66\u9C62\u9C5E\u9C60\u9E02\u9DFE\u9E07\u9E03\u9E06\u9E05\u9E00\u9E01\u9E09\u9DFF\u9DFD\u9E04\u9EA0\u9F1E\u9F46\u9F74\u9F75\u9F76\u56D4\u652E\u65B8\u6B18\u6B19\u6B17\u6B1A\u7062\u7226\u72AA\u77D8\u77D9\u7939\u7C69\u7C6B\u7CF6\u7E9A"],["f940","\u7E98\u7E9B\u7E99\u81E0\u81E1\u8646\u8647\u8648\u8979\u897A\u897C\u897B\u89FF\u8B98\u8B99\u8EA5\u8EA4\u8EA3\u946E\u946D\u946F\u9471\u9473\u9749\u9872\u995F\u9C68\u9C6E\u9C6D\u9E0B\u9E0D\u9E10\u9E0F\u9E12\u9E11\u9EA1\u9EF5\u9F09\u9F47\u9F78\u9F7B\u9F7A\u9F79\u571E\u7066\u7C6F\u883C\u8DB2\u8EA6\u91C3\u9474\u9478\u9476\u9475\u9A60\u9C74\u9C73\u9C71\u9C75\u9E14\u9E13\u9EF6\u9F0A"],["f9a1","\u9FA4\u7068\u7065\u7CF7\u866A\u883E\u883D\u883F\u8B9E\u8C9C\u8EA9\u8EC9\u974B\u9873\u9874\u98CC\u9961\u99AB\u9A64\u9A66\u9A67\u9B24\u9E15\u9E17\u9F48\u6207\u6B1E\u7227\u864C\u8EA8\u9482\u9480\u9481\u9A69\u9A68\u9B2E\u9E19\u7229\u864B\u8B9F\u9483\u9C79\u9EB7\u7675\u9A6B\u9C7A\u9E1D\u7069\u706A\u9EA4\u9F7E\u9F49\u9F98\u7881\u92B9\u88CF\u58BB\u6052\u7CA7\u5AFA\u2554\u2566\u2557\u2560\u256C\u2563\u255A\u2569\u255D\u2552\u2564\u2555\u255E\u256A\u2561\u2558\u2567\u255B\u2553\u2565\u2556\u255F\u256B\u2562\u2559\u2568\u255C\u2551\u2550\u256D\u256E\u2570\u256F\u2593"]]');

});

parcelRegister("ls33I", function(module, exports) {
module.exports = JSON.parse('[["8740","\u43F0\u4C32\u4603\u45A6\u4578\uD85C\uDE67\u4D77\u45B3\uD85F\uDCB1\u4CE2\uD85F\uDCC5\u3B95\u4736\u4744\u4C47\u4C40\uD850\uDEBF\uD84D\uDE17\uD85C\uDF52\uD85B\uDE8B\uD85C\uDCD2\u4C57\uD868\uDF51\u474F\u45DA\u4C85\uD85F\uDC6C\u4D07\u4AA4\u46A1\uD85A\uDF23\u7225\uD856\uDE54\uD846\uDE63\uD84F\uDE06\uD84F\uDF61\u664D\u56FB"],["8767","\u7D95\u591D\uD862\uDFB9\u3DF4\u9734\uD85E\uDFEF\u5BDB\uD847\uDD5E\u5AA4\u3625\uD867\uDEB0\u5AD1\u5BB7\u5CFC\u676E\u8593\uD866\uDD45\u7461\u749D\u3875\uD847\uDD53\uD84D\uDE9E\uD858\uDC21\u3EEC"],["87a1","\uD856\uDCDE\u3AF5\u7AFC\u9F97\uD850\uDD61\uD862\uDD0D\uD84C\uDDEA\uD842\uDE8A\uD84C\uDE5E\u430A\u8484\u9F96\u942F\u4930\u8613\u5896\u974A\u9218\u79D0\u7A32\u6660\u6A29\u889D\u744C\u7BC5\u6782\u7A2C\u524F\u9046\u34E6\u73C4\uD857\uDDB9\u74C6\u9FC7\u57B3\u492F\u544C\u4131\uD84D\uDE8E\u5818\u7A72\uD85E\uDF65\u8B8F\u46AE\uD85B\uDE88\u4181\uD857\uDD99\u7BAE\uD849\uDCBC\u9FC8\uD849\uDCC1\uD849\uDCC9\uD849\uDCCC\u9FC9\u8504\uD84D\uDDBB\u40B4\u9FCA\u44E1\uD86B\uDDFF\u62C1\u706E\u9FCB"],["8840","\u31C0",4,"\uD840\uDD0C\u31C5\uD840\uDCD1\uD840\uDCCD\u31C6\u31C7\uD840\uDCCB\uD847\uDFE8\u31C8\uD840\uDCCA\u31C9\u31CA\u31CB\u31CC\uD840\uDD0E\u31CD\u31CE\u0100\xc1\u01CD\xc0\u0112\xc9\u011A\xc8\u014C\xd3\u01D1\xd2\u0FFF\xca\u0304\u1EBE\u0FFF\xca\u030C\u1EC0\xca\u0101\xe1\u01CE\xe0\u0251\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA"],["88a1","\u01DC\xfc\u0FFF\xea\u0304\u1EBF\u0FFF\xea\u030C\u1EC1\xea\u0261\u23DA\u23DB"],["8940","\uD868\uDFA9\uD844\uDD45"],["8943","\u650A"],["8946","\u4E3D\u6EDD\u9D4E\u91DF"],["894c","\uD85D\uDF35\u6491\u4F1A\u4F28\u4FA8\u5156\u5174\u519C\u51E4\u52A1\u52A8\u533B\u534E\u53D1\u53D8\u56E2\u58F0\u5904\u5907\u5932\u5934\u5B66\u5B9E\u5B9F\u5C9A\u5E86\u603B\u6589\u67FE\u6804\u6865\u6D4E\u70BC\u7535\u7EA4\u7EAC\u7EBA\u7EC7\u7ECF\u7EDF\u7F06\u7F37\u827A\u82CF\u836F\u89C6\u8BBE\u8BE2\u8F66\u8F67\u8F6E"],["89a1","\u7411\u7CFC\u7DCD\u6946\u7AC9\u5227"],["89ab","\u918C\u78B8\u915E\u80BC"],["89b0","\u8D0B\u80F6\uD842\uDDE7"],["89b5","\u809F\u9EC7\u4CCD\u9DC9\u9E0C\u4C3E\uD867\uDDF6\uD85C\uDC0E\u9E0A\uD868\uDD33\u35C1"],["89c1","\u6E9A\u823E\u7519"],["89c5","\u4911\u9A6C\u9A8F\u9F99\u7987\uD861\uDC6C\uD847\uDDCA\uD841\uDDD0\uD84A\uDEE6\u4E24\u4E81\u4E80\u4E87\u4EBF\u4EEB\u4F37\u344C\u4FBD\u3E48\u5003\u5088\u347D\u3493\u34A5\u5186\u5905\u51DB\u51FC\u5205\u4E89\u5279\u5290\u5327\u35C7\u53A9\u3551\u53B0\u3553\u53C2\u5423\u356D\u3572\u3681\u5493\u54A3\u54B4\u54B9\u54D0\u54EF\u5518\u5523\u5528\u3598\u553F\u35A5\u35BF\u55D7\u35C5"],["8a40","\uD85F\uDD84\u5525"],["8a43","\uD843\uDC42\uD843\uDD15\uD854\uDD2B\u5590\uD84B\uDCC6\u39EC\uD840\uDF41\u8E46\uD853\uDDB8\uD865\uDCE5\u4053\uD860\uDCBE\u777A\uD84B\uDC38\u3A34\u47D5\uD860\uDD5D\uD85A\uDDF2\uD853\uDDEA\u64DD\uD843\uDD7C\uD843\uDFB4\uD843\uDCD5\uD844\uDCF4\u648D\u8E7E\uD843\uDE96\uD843\uDC0B\uD843\uDF64\uD84B\uDCA9\uD860\uDE56\uD851\uDCD3"],["8a64","\uD843\uDD46\uD866\uDE4D\uD860\uDCE9\u47F4\uD853\uDEA7\uD84B\uDCC2\u9AB2\u3A67\uD865\uDDF4\u3FED\u3506\uD854\uDEC7\uD865\uDFD4\uD85E\uDCC8\uD84B\uDD44\u9D6E\u9815"],["8a76","\u43D9\uD858\uDCA5\u64B4\u54E3\uD84B\uDD4C\uD84A\uDFCA\uD844\uDC77\u39FB\uD844\uDC6F"],["8aa1","\uD859\uDEDA\uD859\uDF16\uD85E\uDDA0\u64EA\uD854\uDC52\uD843\uDC43\u8E68\uD848\uDDA1\uD862\uDF4C\uD841\uDF31"],["8aac","\u480B\uD840\uDDA9\u3FFA\u5873\uD84B\uDD8D"],["8ab2","\uD851\uDDC8\uD841\uDCFC\uD858\uDC97\uD843\uDF4C\uD843\uDD96\u5579\u40BB\u43BA"],["8abb","\u4AB4\uD84A\uDE66\uD844\uDC9D\u81AA\u98F5\uD843\uDD9C\u6379\u39FE\uD849\uDF75\u8DC0\u56A1\u647C\u3E43"],["8ac9","\uD869\uDE01\uD843\uDE09\uD84A\uDECF\uD84B\uDCC9"],["8ace","\uD844\uDCC8\uD84E\uDDC2\u3992\u3A06\uD860\uDE9B\u3578\uD857\uDE49\uD848\uDCC7\u5652\uD843\uDF31\uD84B\uDCB2\uD865\uDF20\u34BC\u6C3D\uD853\uDE3B"],["8adf","\uD85D\uDD74\uD84B\uDE8B\uD848\uDE08\uD869\uDE5B\uD863\uDCCD\uD843\uDE7A\uD843\uDC34\uD85A\uDC1C\u7F93\uD844\uDCCF\uD84A\uDC03\uD84A\uDD39\u35FB\uD854\uDDE3\uD843\uDE8C\uD843\uDF8D\uD843\uDEAA\u3F93\uD843\uDF30\uD843\uDD47\uD844\uDD4F\uD843\uDE4C"],["8af6","\uD843\uDEAB\uD842\uDFA9\uD843\uDD48\uD844\uDCC0\uD844\uDD3D\u3FF9\uD849\uDE96\u6432\uD843\uDFAD"],["8b40","\uD84C\uDFF4\uD85D\uDE39\uD84A\uDFCE\uD843\uDD7E\uD843\uDD7F\uD84B\uDC51\uD84B\uDC55\u3A18\uD843\uDE98\uD844\uDCC7\uD843\uDF2E\uD869\uDE32\uD85A\uDF50\uD863\uDCD2\uD863\uDD99\uD863\uDCCA\u95AA\u54CC\u82C4\u55B9"],["8b55","\uD867\uDEC3\u9C26\u9AB6\uD85D\uDF5E\uD84B\uDDEE\u7140\u816D\u80EC\u5C1C\uD859\uDD72\u8134\u3797\u535F\uD860\uDCBD\u91B6\uD843\uDEFA\uD843\uDE0F\uD843\uDE77\uD843\uDEFB\u35DD\uD853\uDDEB\u3609\uD843\uDCD6\u56AF\uD849\uDFB5\uD844\uDCC9\uD843\uDE10\uD843\uDE78\uD844\uDC78\uD844\uDD48\uD860\uDE07\uD845\uDC55\uD843\uDE79\uD853\uDE50\uD84B\uDDA4\u5A54\uD844\uDC1D\uD844\uDC1E\uD844\uDCF5\uD844\uDCF6\u579C\uD843\uDE11"],["8ba1","\uD85D\uDE94\uD860\uDECD\uD843\uDFB5\uD843\uDE7B\uD854\uDD7E\u3703\uD843\uDFB6\uD844\uDD80\uD854\uDED8\uD868\uDEBD\uD852\uDDDA\uD846\uDC3A\uD850\uDD77\uD860\uDE7C\u5899\u5268\u361A\uD855\uDF3D\u7BB2\u5B68\u4800\u4B2C\u9F27\u49E7\u9C1F\u9B8D\uD856\uDF74\uD84C\uDD3D\u55FB\u35F2\u5689\u4E28\u5902\uD846\uDFC1\uD87E\uDC78\u9751\uD840\uDC86\u4E5B\u4EBB\u353E\u5C23\u5F51\u5FC4\u38FA\u624C\u6535\u6B7A\u6C35\u6C3A\u706C\u722B\u4E2C\u72AD\uD852\uDCE9\u7F52\u793B\u7CF9\u7F53\uD858\uDE6A\u34C1"],["8bde","\uD858\uDF4B\u8002\u8080\uD859\uDE12\uD85A\uDD51\u535D\u8864\u89C1\uD85E\uDCB2\u8BA0\u8D1D\u9485\u9578\u957F\u95E8\uD863\uDE0F\u97E6\u9875\u98CE\u98DE\u9963\uD866\uDC10\u9C7C\u9E1F\u9EC4\u6B6F\uF907\u4E37\uD840\uDC87\u961D\u6237\u94A2"],["8c40","\u503B\u6DFE\uD867\uDC73\u9FA6\u3DC9\u888F\uD850\uDD4E\u7077\u5CF5\u4B20\uD854\uDDCD\u3559\uD857\uDD30\u6122\uD862\uDE32\u8FA7\u91F6\u7191\u6719\u73BA\uD84C\uDE81\uD868\uDD07\u3C8B\uD846\uDD80\u4B10\u78E4\u7402\u51AE\uD861\uDF0F\u4009\u6A63\uD868\uDEBA\u4223\u860F\uD842\uDE6F\u7A2A\uD866\uDD47\uD862\uDEEA\u9755\u704D\u5324\uD848\uDC7E\u93F4\u76D9\uD862\uDDE3\u9FA7\u77DD\u4EA3\u4FF0\u50BC\u4E2F\u4F17\u9FA8\u5434\u7D8B\u5892\u58D0\uD847\uDDB6\u5E92\u5E99\u5FC2\uD849\uDF12\u658B"],["8ca1","\uD84C\uDFF9\u6919\u6A43\uD84F\uDC63\u6CFF"],["8ca7","\u7200\uD851\uDD05\u738C\u3EDB\uD852\uDE13\u5B15\u74B9\u8B83\uD857\uDCA4\uD855\uDE95\u7A93\u7BEC\u7CC3\u7E6C\u82F8\u8597\u9FA9\u8890\u9FAA\u8EB9\u9FAB\u8FCF\u855F\u99E0\u9221\u9FAC\uD863\uDDB9\uD845\uDC3F\u4071\u42A2\u5A1A"],["8cc9","\u9868\u676B\u4276\u573D"],["8cce","\u85D6\uD852\uDD7B\u82BF\uD85C\uDD0D\u4C81\uD85B\uDD74\u5D7B\uD85A\uDF15\uD85B\uDFBE\u9FAD\u9FAE\u5B96\u9FAF\u66E7\u7E5B\u6E57\u79CA\u3D88\u44C3\uD84C\uDE56\uD849\uDF96\u439A\u4536"],["8ce6","\u5CD5\uD84E\uDF1A\u8AF9\u5C78\u3D12\uD84D\uDD51\u5D78\u9FB2\u7157\u4558\uD850\uDCEC\uD847\uDE23\u4C77\u3978\u344A\uD840\uDDA4\uD85B\uDC41\u8ACC\u4FB4\uD840\uDE39\u59BF\u816C\u9856\uD866\uDCFA\u5F3B"],["8d40","\uD842\uDF9F"],["8d42","\uD848\uDDC1\uD862\uDD6D\u4102\u46BB\uD864\uDC79\u3F07\u9FB3\uD868\uDDB5\u40F8\u37D6\u46F7\uD85B\uDC46\u417C\uD861\uDEB2\uD85C\uDFFF\u456D\u38D4\uD855\uDC9A\u4561\u451B\u4D89\u4C7B\u4D76\u45EA\u3FC8\uD852\uDF0F\u3661\u44DE\u44BD\u41ED\u5D3E\u5D48\u5D56\u3DFC\u380F\u5DA4\u5DB9\u3820\u3838\u5E42\u5EBD\u5F25\u5F83\u3908\u3914\u393F\u394D\u60D7\u613D\u5CE5\u3989\u61B7\u61B9\u61CF\u39B8\u622C\u6290\u62E5\u6318\u39F8\u56B1"],["8da1","\u3A03\u63E2\u63FB\u6407\u645A\u3A4B\u64C0\u5D15\u5621\u9F9F\u3A97\u6586\u3ABD\u65FF\u6653\u3AF2\u6692\u3B22\u6716\u3B42\u67A4\u6800\u3B58\u684A\u6884\u3B72\u3B71\u3B7B\u6909\u6943\u725C\u6964\u699F\u6985\u3BBC\u69D6\u3BDD\u6A65\u6A74\u6A71\u6A82\u3BEC\u6A99\u3BF2\u6AAB\u6AB5\u6AD4\u6AF6\u6B81\u6BC1\u6BEA\u6C75\u6CAA\u3CCB\u6D02\u6D06\u6D26\u6D81\u3CEF\u6DA4\u6DB1\u6E15\u6E18\u6E29\u6E86\uD862\uDDC0\u6EBB\u6EE2\u6EDA\u9F7F\u6EE8\u6EE9\u6F24\u6F34\u3D46\uD84F\uDF41\u6F81\u6FBE\u3D6A\u3D75\u71B7\u5C99\u3D8A\u702C\u3D91\u7050\u7054\u706F\u707F\u7089\uD840\uDF25\u43C1\u35F1\uD843\uDED8"],["8e40","\uD84F\uDED7\u57BE\uD85B\uDED3\u713E\uD855\uDFE0\u364E\u69A2\uD862\uDFE9\u5B74\u7A49\uD856\uDCE1\uD865\uDCD9\u7A65\u7A7D\uD856\uDDAC\u7ABB\u7AB0\u7AC2\u7AC3\u71D1\uD859\uDC8D\u41CA\u7ADA\u7ADD\u7AEA\u41EF\u54B2\uD857\uDC01\u7B0B\u7B55\u7B29\uD854\uDF0E\uD857\uDCFE\u7BA2\u7B6F\u839C\uD856\uDFB4\uD85B\uDC7F\u7BD0\u8421\u7B92\u7BB8\uD857\uDD20\u3DAD\uD857\uDC65\u8492\u7BFA\u7C06\u7C35\uD857\uDCC1\u7C44\u7C83\uD852\uDC82\u7CA6\u667D\uD851\uDD78\u7CC9\u7CC7\u7CE6\u7C74\u7CF3\u7CF5\u7CCE"],["8ea1","\u7E67\u451D\uD85B\uDE44\u7D5D\uD85B\uDED6\u748D\u7D89\u7DAB\u7135\u7DB3\u7DD2\uD850\uDC57\uD858\uDC29\u7DE4\u3D13\u7DF5\uD845\uDFF9\u7DE5\uD860\uDF6D\u7E1D\uD858\uDD21\uD858\uDD5A\u7E6E\u7E92\u432B\u946C\u7E27\u7F40\u7F41\u7F47\u7936\uD858\uDED0\u99E1\u7F97\uD858\uDF51\u7FA3\uD845\uDE61\uD840\uDC68\u455C\uD84D\uDF66\u4503\uD860\uDF3A\u7FFA\uD859\uDC89\u8005\u8008\u801D\u8028\u802F\uD868\uDC87\uD85B\uDCC3\u803B\u803C\u8061\uD849\uDF14\u4989\uD859\uDE26\uD84F\uDDE3\uD859\uDEE8\u6725\u80A7\uD862\uDE48\u8107\u811A\u58B0\uD849\uDEF6\u6C7F\uD859\uDC98\uD853\uDFB8\u64E7\uD845\uDC8A\u8218\uD846\uDC5E\u6A53\uD852\uDE65\uD852\uDE95\u447A\u8229\uD842\uDF0D\uD85A\uDE52\uD84F\uDD7E\u4FF9\uD845\uDCFD\u84E2\u8362\uD85A\uDF0A\uD852\uDDA7\uD84D\uDD30\uD845\uDF73\uD84F\uDDF8\u82AA\u691B\uD87E\uDD94\u41DB"],["8f40","\u854B\u82D0\u831A\uD843\uDE16\uD845\uDFB4\u36C1\uD84C\uDD7D\uD84D\uDD5A\u827B\u82E2\u8318\uD84F\uDE8B\uD85B\uDDA3\uD85A\uDF05\uD85A\uDF97\uD84D\uDDCE\u3DBF\u831D\u55EC\u8385\u450B\uD85B\uDDA5\u83AC\u83C1\u83D3\u347E\uD85B\uDED4\u6A57\u855A\u3496\uD85B\uDE42\uD84B\uDEEF\u8458\uD856\uDFE4\u8471\u3DD3\u44E4\u6AA7\u844A\uD84F\uDCB5\u7958\u84A8\uD85A\uDF96\uD85B\uDE77\uD85B\uDE43\u84DE\u840F\u8391\u44A0\u8493\u84E4\uD857\uDC91\u4240\uD857\uDCC0\u4543\u8534\u5AF2\uD85B\uDE99\u4527\u8573\u4516\u67BF\u8616"],["8fa1","\uD861\uDE25\uD861\uDE3B\u85C1\uD85C\uDC88\u8602\uD845\uDD82\uD85C\uDCCD\uD87E\uDDB2\u456A\u8628\u3648\uD846\uDCA2\u53F7\uD85C\uDF9A\u867E\u8771\uD868\uDCF8\u87EE\uD84B\uDC27\u87B1\u87DA\u880F\u5661\u866C\u6856\u460F\u8845\u8846\uD85D\uDDE0\uD84F\uDDB9\uD85D\uDDE4\u885E\u889C\u465B\u88B4\u88B5\u63C1\u88C5\u7777\uD85D\uDF0F\u8987\u898A\u89A6\u89A9\u89A7\u89BC\uD862\uDE25\u89E7\uD85E\uDD24\uD85E\uDEBD\u8A9C\u7793\u91FE\u8A90\uD85E\uDE59\u7AE9\uD85E\uDF3A\uD84F\uDF8F\u4713\uD85E\uDF38\u717C\u8B0C\u8B1F\uD855\uDC30\uD855\uDD65\u8B3F\u8B4C\u8B4D\u8AA9\uD852\uDE7A\u8B90\u8B9B\u8AAF\uD845\uDEDF\u4615\u884F\u8C9B\uD85F\uDD54\uD85F\uDD8F\uD87E\uDDD4\u3725\uD85F\uDD53\u8CD6\uD85F\uDD98\uD85F\uDDBD\u8D12\u8D03\uD846\uDD10\u8CDB\u705C\u8D11\uD853\uDCC9\u3ED0\u8D77"],["9040","\u8DA9\uD860\uDC02\uD844\uDC14\uD852\uDD8A\u3B7C\uD860\uDDBC\uD85C\uDD0C\u7AE7\u8EAD\u8EB6\u8EC3\u92D4\u8F19\u8F2D\uD860\uDF65\uD861\uDC12\u8FA5\u9303\uD868\uDE9F\uD842\uDE50\u8FB3\u492A\uD862\uDDDE\uD861\uDD3D\uD84F\uDDBB\u5EF8\uD84C\uDE62\u8FF9\uD868\uDC14\uD861\uDEBC\uD861\uDD01\uD848\uDF25\u3980\uD85B\uDED7\u9037\uD861\uDD3C\uD85E\uDEBE\u9061\uD861\uDD6C\uD861\uDE0B\u90A8\uD861\uDF13\u90C4\uD861\uDEE6\u90AE\u90FD\u9167\u3AF0\u91A9\u91C4\u7CAC\uD862\uDD33\uD847\uDE89\u920E\u6C9F\u9241\u9262\uD855\uDDB9\u92B9\uD862\uDEC6\uD84F\uDC9B\uD862\uDF0C\uD855\uDDDB"],["90a1","\uD843\uDD31\u932C\u936B\uD862\uDEE1\uD862\uDFEB\u708F\u5AC3\uD862\uDEE2\uD862\uDEE5\u4965\u9244\uD862\uDFEC\uD863\uDC39\uD862\uDFFF\u9373\u945B\u8EBC\u9585\u95A6\u9426\u95A0\u6FF6\u42B9\uD849\uDE7A\uD861\uDED8\uD844\uDE7C\uD84F\uDE2E\u49DF\u6C1C\u967B\u9696\u416C\u96A3\uD85B\uDED5\u61DA\u96B6\u78F5\uD862\uDEE0\u96BD\u53CC\u49A1\uD85B\uDCB8\uD840\uDE74\uD859\uDC10\uD864\uDCAF\uD864\uDCE5\uD852\uDED1\uD846\uDD15\uD84C\uDF0A\u9731\u8642\u9736\u4A0F\u453D\u4585\uD852\uDEE9\u7075\u5B41\u971B\u975C\uD864\uDDD5\u9757\u5B4A\uD864\uDDEB\u975F\u9425\u50D0\uD84C\uDCB7\uD84C\uDCBC\u9789\u979F\u97B1\u97BE\u97C0\u97D2\u97E0\uD855\uDC6C\u97EE\u741C\uD865\uDC33\u97FF\u97F5\uD865\uDC1D\uD85E\uDD7A\u4AD1\u9834\u9833\u984B\u9866\u3B0E\uD85C\uDD75\u3D51\uD841\uDE30\uD850\uDD5C"],["9140","\uD855\uDF06\u98CA\u98B7\u98C8\u98C7\u4AFF\uD85B\uDD27\uD845\uDED3\u55B0\u98E1\u98E6\u98EC\u9378\u9939\uD852\uDE29\u4B72\uD866\uDC57\uD866\uDD05\u99F5\u9A0C\u9A3B\u9A10\u9A58\uD855\uDF25\u36C4\uD864\uDCB1\uD866\uDFD5\u9AE0\u9AE2\uD866\uDF05\u9AF4\u4C0E\u9B14\u9B2D\uD861\uDE00\u5034\u9B34\uD85A\uDDA8\u38C3\uD84C\uDC7D\u9B50\u9B40\uD867\uDD3E\u5A45\uD846\uDC63\u9B8E\uD850\uDE4B\u9C02\u9BFF\u9C0C\uD867\uDE68\u9DD4\uD867\uDFB7\uD868\uDD92\uD868\uDDAB\uD868\uDCE1\uD868\uDD23\uD868\uDDDF\u9D7E\u9D83\uD868\uDD34\u9E0E\u6888"],["91a1","\u9DC4\uD848\uDD5B\uD868\uDD93\uD868\uDE20\uD846\uDD3B\uD868\uDE33\u9D39\uD868\uDCB9\uD868\uDEB4\u9E90\u9E95\u9E9E\u9EA2\u4D34\u9EAA\u9EAF\uD850\uDF64\u9EC1\u3B60\u39E5\u3D1D\u4F32\u37BE\uD863\uDC2B\u9F02\u9F08\u4B96\u9424\uD85B\uDDA2\u9F17\u9F16\u9F39\u569F\u568A\u9F45\u99B8\uD864\uDC8B\u97F2\u847F\u9F62\u9F69\u7ADC\u9F8E\u7216\u4BBE\uD852\uDD75\uD852\uDDBB\u7177\uD852\uDDF8\uD850\uDF48\uD852\uDE51\u739E\uD862\uDFDA\uD846\uDCFA\u799F\uD862\uDD7E\uD863\uDE36\u9369\u93F3\uD862\uDE44\u92EC\u9381\u93CB\uD862\uDD6C\uD851\uDCB9\u7217\u3EEB\u7772\u7A43\u70D0\uD851\uDC73\uD850\uDFF8\u717E\uD845\uDFEF\u70A3\uD846\uDCBE\uD84D\uDD99\u3EC7\uD846\uDC85\uD855\uDC2F\uD845\uDFF8\u3722\uD845\uDEFB\uD846\uDC39\u36E1\uD845\uDF74\uD846\uDCD1\uD857\uDF4B\u3723\uD845\uDEC0\u575B\uD852\uDE25\uD844\uDFFE\uD844\uDEA8"],["9240","\uD844\uDFC6\uD845\uDCB6\u8503\uD84D\uDEA6\u8503\u8455\uD852\uDD94\uD85C\uDD65\uD84F\uDE31\uD855\uDD5C\uD84F\uDEFB\uD85C\uDC52\u44F4\uD84D\uDEEE\uD866\uDD9D\uD85B\uDF26\u67F9\u3733\u3C15\u3DE7\u586C\uD846\uDD22\u6810\u4057\uD84D\uDF3F\uD850\uDCE1\uD850\uDC8B\uD850\uDD0F\uD85B\uDC21\u54CB\u569E\uD859\uDEB1\u5692\uD843\uDFDF\uD842\uDFA8\uD843\uDE0D\u93C6\uD862\uDF13\u939C\u4EF8\u512B\u3819\uD851\uDC36\u4EBC\uD841\uDC65\uD840\uDF7F\u4F4B\u4F8A\uD855\uDE51\u5A68\uD840\uDDAB\uD840\uDFCB\u3999\uD840\uDF0A\uD841\uDC14\u3435\u4F29\uD840\uDEC0\uD863\uDEB3\uD840\uDE75\u8ADA\uD840\uDE0C\u4E98"],["92a1","\u50CD\u510D\u4FA2\u4F03\uD852\uDE0E\uD84F\uDE8A\u4F42\u502E\u506C\u5081\u4FCC\u4FE5\u5058\u50FC\u5159\u515B\u515D\u515E\u6E76\uD84D\uDD95\uD84F\uDE39\uD84F\uDEBF\u6D72\uD846\uDC84\uD84F\uDE89\u51A8\u51C3\uD841\uDDE0\u44DD\uD841\uDCA3\uD841\uDC92\uD841\uDC91\u8D7A\uD862\uDE9C\uD841\uDF0E\u5259\u52A4\uD842\uDC73\u52E1\u936E\u467A\u718C\uD850\uDF8C\uD843\uDC20\uD852\uDDAC\uD844\uDCE4\u69D1\uD843\uDE1D\u7479\u3EDE\u7499\u7414\u7456\u7398\u4B8E\uD852\uDEBC\uD850\uDC8D\u53D0\u3584\u720F\uD850\uDCC9\u55B4\uD840\uDF45\u54CD\uD842\uDFC6\u571D\u925D\u96F4\u9366\u57DD\u578D\u577F\u363E\u58CB\u5A99\uD862\uDE46\uD845\uDEFA\uD845\uDF6F\uD845\uDF10\u5A2C\u59B8\u928F\u5A7E\u5ACF\u5A12\uD856\uDD46\uD846\uDDF3\uD846\uDC61\uD850\uDE95\u36F5\u6D05\u7443\u5A21\uD857\uDE83"],["9340","\u5A81\uD862\uDFD7\uD841\uDC13\u93E0\u748C\uD844\uDF03\u7105\u4972\u9408\uD862\uDDFB\u93BD\u37A0\u5C1E\u5C9E\u5E5E\u5E48\uD846\uDD96\uD846\uDD7C\uD84E\uDEEE\u5ECD\u5B4F\uD846\uDD03\uD846\uDD04\u3701\uD846\uDCA0\u36DD\uD845\uDEFE\u36D3\u812A\uD862\uDE47\uD847\uDDBA\uD84D\uDC72\uD862\uDDA8\u5F0C\u5F0E\uD846\uDD27\uD845\uDFAB\u5A6B\uD845\uDF3B\u5B44\u8614\uD85D\uDDFD\u8860\u607E\uD84A\uDC60\uD849\uDE2B\u5FDB\u3EB8\uD849\uDDAF\uD849\uDDBE\uD864\uDC88\uD85B\uDF73\u61C0\uD840\uDC3E\uD840\uDC46\uD849\uDE1B\u6199\u6198\u6075\uD84B\uDC9B\uD84B\uDD07\uD851\uDED4\uD864\uDD4D"],["93a1","\u6471\uD851\uDE65\uD84A\uDF6A\u3A29\uD84A\uDF22\uD84D\uDC50\uD866\uDCEA\uD84B\uDE78\u6337\uD869\uDC5B\u64B6\u6331\u63D1\uD852\uDDE3\uD84B\uDD67\u62A4\uD84B\uDCA1\u643B\u656B\u6972\u3BF4\uD84C\uDC8E\uD84C\uDEAD\uD852\uDD89\uD84C\uDEAB\u550D\uD84C\uDEE0\uD846\uDCD9\uD865\uDC3F\u66CE\uD84C\uDE89\uD84C\uDDB3\u3AE0\u4190\uD855\uDD84\uD862\uDF22\uD855\uDD8F\uD845\uDEFC\uD855\uDD5B\uD855\uDC25\u78EE\uD84C\uDD03\uD846\uDC2A\uD84C\uDE34\u3464\uD84C\uDE0F\uD84C\uDD82\uD850\uDEC9\u668E\uD85B\uDD24\u666B\u4B93\u6630\uD85E\uDC70\uD847\uDDEB\u6663\uD84C\uDED2\uD84C\uDEE1\u661E\uD856\uDC72\u38D1\uD84E\uDC3A\uD84D\uDFBC\u3B99\uD84D\uDFA2\uD84C\uDFFE\u74D0\u3B96\u678F\uD851\uDE2A\u68B6\u681E\u3BC4\u6ABE\u3863\uD84D\uDFD5\uD851\uDC87\u6A33\u6A52\u6AC9\u6B05\uD846\uDD12\u6511\u6898\u6A4C\u3BD7\u6A7A\u6B57\uD84F\uDFC0\uD84F\uDC9A\u93A0\u92F2\uD862\uDFEA\uD862\uDECB"],["9440","\u9289\uD860\uDC1E\uD862\uDDDC\u9467\u6DA5\u6F0B\uD852\uDDEC\u6D67\uD84F\uDF7F\u3D8F\u6E04\uD850\uDC3C\u5A3D\u6E0A\u5847\u6D24\u7842\u713B\uD850\uDF1A\uD850\uDE76\u70F1\u7250\u7287\u7294\uD851\uDF8F\uD851\uDF25\u5179\uD852\uDEA4\uD841\uDDEB\u747A\uD84F\uDEF8\uD84D\uDE5F\uD852\uDE4A\uD852\uDD17\uD857\uDFE1\u3F06\u3EB1\uD852\uDEDF\uD863\uDC23\uD84F\uDF35\u60A7\u3EF3\u74CC\u743C\u9387\u7437\u449F\uD85B\uDDEA\u4551\u7583\u3F63\uD853\uDCD9\uD853\uDD06\u3F58\u7555\u7673\uD869\uDDC6\u3B19\u7468\uD862\uDECC\uD852\uDDAB\uD852\uDD8E\u3AFB"],["94a1","\u3DCD\uD852\uDE4E\u3EFF\uD852\uDDC5\uD852\uDCF3\u91FA\u5732\u9342\uD862\uDEE3\uD846\uDC64\u50DF\uD854\uDE21\uD854\uDDE7\u7778\uD84C\uDE32\u770E\u770F\u777B\uD851\uDE97\uD84D\uDF81\u3A5E\uD852\uDCF0\u7438\u749B\u3EBF\uD852\uDEBA\uD852\uDEC7\u40C8\uD852\uDE96\uD858\uDDAE\u9307\uD855\uDD81\u781E\u788D\u7888\u78D2\u73D0\u7959\uD85D\uDF41\uD855\uDEE3\u410E\u799B\u8496\u79A5\u6A2D\uD84F\uDEFA\u7A3A\u79F4\u416E\uD845\uDEE6\u4132\u9235\u79F1\uD843\uDD4C\uD852\uDD8C\uD840\uDE99\uD84F\uDDBA\uD845\uDF6E\u3597\u556B\u3570\u36AA\uD840\uDDD4\uD843\uDC0D\u7AE2\u5A59\uD849\uDEF5\uD856\uDEAF\uD856\uDE9C\u5A0D\uD840\uDE5B\u78F0\u5A2A\uD856\uDFC6\u7AFE\u41F9\u7C5D\u7C6D\u4211\uD856\uDFB3\uD857\uDEBC\uD857\uDEA6\u7CCD\uD852\uDDF9\uD845\uDFB0\u7C8E\u7C7C\u7CAE\u6AB2\u7DDC\u7E07\u7DD3\u7F4E\uD858\uDE61"],["9540","\uD858\uDD5C\uD85E\uDF48\u7D97\uD857\uDE82\u426A\uD85A\uDF75\uD842\uDD16\u67D6\uD840\uDC4E\uD84D\uDDCF\u57C4\uD859\uDC12\uD858\uDFF8\uD852\uDD62\u7FDD\u7B27\uD842\uDC2C\uD856\uDEE9\uD857\uDD43\u7B0C\uD857\uDE0E\u99E6\u8645\u9A63\u6A1C\uD84D\uDC3F\u39E2\uD852\uDDF7\uD859\uDDAD\u9A1F\uD859\uDDA0\u8480\uD85C\uDD27\uD85B\uDCD1\u44EA\u8137\u4402\u80C6\u8109\u8142\uD859\uDFB4\u98C3\uD85A\uDE42\u8262\u8265\uD85A\uDE51\u8453\uD85B\uDDA7\u8610\uD85C\uDE1B\u5A86\u417F\uD846\uDC40\u5B2B\uD846\uDCA1\u5AE4\uD846\uDCD8\u86A0\uD87E\uDDBC\uD84F\uDD8F\u882D\uD85D\uDC22\u5A02"],["95a1","\u886E\u4F45\u8887\u88BF\u88E6\u8965\u894D\uD855\uDE83\u8954\uD85D\uDF85\uD85D\uDF84\uD862\uDFF5\uD862\uDFD9\uD862\uDF9C\uD862\uDDF9\u3EAD\u84A3\u46F5\u46CF\u37F2\u8A3D\u8A1C\uD865\uDC48\u5F4D\u922B\uD850\uDE84\u65D4\u7129\u70C4\uD846\uDC45\u9D6D\u8C9F\u8CE9\uD85F\uDDDC\u599A\u77C3\u59F0\u436E\u36D4\u8E2A\u8EA7\uD853\uDC09\u8F30\u8F4A\u42F4\u6C58\u6FBB\uD848\uDF21\u489B\u6F79\u6E8B\uD845\uDFDA\u9BE9\u36B5\uD852\uDD2F\u90BB\u9097\u5571\u4906\u91BB\u9404\uD862\uDE4B\u4062\uD862\uDEFC\u9427\uD863\uDC1D\uD863\uDC3B\u84E5\u8A2B\u9599\u95A7\u9597\u9596\uD863\uDD34\u7445\u3EC2\uD852\uDCFF\uD852\uDE42\uD850\uDFEA\u3EE7\uD84C\uDE25\u968F\uD863\uDEE7\uD863\uDE66\uD863\uDE65\u3ECC\uD852\uDDED\uD852\uDE78\uD84F\uDFEE\u7412\u746B\u3EFC\u9741\uD864\uDCB0"],["9640","\u6847\u4A1D\uD864\uDC93\uD855\uDFDF\u975D\u9368\uD862\uDD89\uD863\uDC26\uD862\uDF2F\uD858\uDFBE\u92BA\u5B11\u8B69\u493C\u73F9\uD850\uDE1B\u979B\u9771\u9938\uD843\uDF26\u5DC1\uD862\uDFC5\uD852\uDEB2\u981F\uD865\uDCDA\u92F6\uD865\uDDD7\u91E5\u44C0\uD862\uDF50\uD852\uDE67\uD862\uDF64\u98DC\uD862\uDE45\u3F00\u922A\u4925\u8414\u993B\u994D\uD85E\uDF06\u3DFD\u999B\u4B6F\u99AA\u9A5C\uD862\uDF65\uD856\uDCC8\u6A8F\u9A21\u5AFE\u9A2F\uD866\uDCF1\u4B90\uD866\uDD48\u99BC\u4BBD\u4B97\u937D\u5872\uD844\uDF02\u5822\uD852\uDDB8"],["96a1","\uD845\uDCE8\u7844\uD849\uDF1F\uD84F\uDDB8\u68C5\u3D7D\u9458\u3927\u6150\uD849\uDF81\uD84A\uDD6B\u6107\u9C4F\u9C53\u9C7B\u9C35\u9C10\u9B7F\u9BCF\uD867\uDE2D\u9B9F\uD868\uDDF5\uD868\uDCFE\u9D21\u4CAE\uD850\uDD04\u9E18\u4CB0\u9D0C\uD868\uDDB4\uD868\uDCED\uD868\uDCF3\uD866\uDD2F\u9DA5\u84BD\uD85B\uDE12\uD85B\uDFDF\uD85A\uDF82\u85FC\u4533\uD85B\uDDA4\uD85B\uDE84\uD85B\uDDF0\u8420\u85EE\uD85B\uDE00\uD84D\uDFD7\uD858\uDC64\u79E2\uD84D\uDD9C\uD84D\uDE40\u492D\uD852\uDDDE\u3D62\u93DB\u92BE\u9348\uD840\uDEBF\u78B9\u9277\u944D\u4FE4\u3440\u9064\uD855\uDD5D\u783D\u7854\u78B6\u784B\uD845\uDF57\uD84C\uDDC9\uD852\uDD41\u369A\u4F72\u6FDA\u6FD9\u701E\u701E\u5414\uD850\uDDB5\u57BB\u58F3\u578A\u9D16\u57D7\u7134\u34AF\uD850\uDDAC\u71EB\uD85B\uDC40\uD853\uDF97\u5B28\uD845\uDFB5\uD862\uDE49"],["9740","\u610C\u5ACE\u5A0B\u42BC\uD851\uDC88\u372C\u4B7B\uD862\uDDFC\u93BB\u93B8\uD846\uDCD6\uD843\uDF1D\u8472\uD85B\uDCC0\uD845\uDC13\uD850\uDEFA\uD84B\uDC26\uD850\uDFC1\u5994\uD84F\uDDB7\uD859\uDF41\u7DA8\uD858\uDD5B\uD858\uDCA4\uD852\uDDB9\uD852\uDD8B\uD862\uDDFA\u92E5\u73E2\u3EE9\u74B4\uD862\uDF63\uD846\uDC9F\u3EE1\uD852\uDEB3\u6AD8\u73F3\u73FB\u3ED6\uD852\uDE3E\uD852\uDE94\uD845\uDFD9\uD852\uDE66\uD840\uDFA7\uD845\uDC24\uD852\uDDE5\u7448\uD852\uDD16\u70A5\uD852\uDD76\u9284\u73E6\u935F\uD841\uDCFE\u9331\uD862\uDECE\uD862\uDE16\u9386\uD862\uDFE7\uD855\uDDD5\u4935\uD862\uDE82\u716B"],["97a1","\uD852\uDD43\uD843\uDCFF\u56A4\uD841\uDE1A\uD842\uDFEB\uD843\uDCB8\u5502\u79C4\uD845\uDFFA\u7DFE\uD845\uDEC2\uD852\uDE50\uD846\uDC52\u452E\u9401\u370A\uD862\uDEC0\uD852\uDDAD\u59B0\uD846\uDCBF\uD846\uDC83\uD85D\uDC84\u5AA1\u36E2\uD84F\uDD5B\u36B0\u925F\u5A79\uD862\uDE81\uD846\uDC62\u9374\u3CCD\uD842\uDEB4\u4A96\u398A\u50F4\u3D69\u3D4C\uD844\uDF9C\u7175\u42FB\uD860\uDE18\u6E0F\uD864\uDCE4\u44EB\u6D57\uD85F\uDE4F\u7067\u6CAF\u3CD6\uD84F\uDFED\uD84F\uDE2D\u6E02\u6F0C\u3D6F\uD840\uDFF5\u7551\u36BC\u34C8\u4680\u3EDA\u4871\u59C4\u926E\u493E\u8F41\uD863\uDC1C\uD85A\uDFC0\u5812\u57C8\u36D6\uD845\uDC52\u70FE\uD850\uDF62\uD852\uDE71\uD84B\uDFE3\uD844\uDEB0\uD848\uDFBD\u68B9\u6967\uD844\uDF98\uD84D\uDCE5\uD85E\uDFF4\uD84D\uDEDF\uD862\uDE83\uD84D\uDFD6\uD84C\uDFFA\uD853\uDC9F\u6A1A\uD84D\uDEAD\uD85B\uDCB7\u843E\u44DF\u44CE"],["9840","\uD85B\uDD26\uD85B\uDD51\uD85B\uDC82\uD85B\uDFDE\u6F17\uD85C\uDD09\u833D\uD845\uDF3A\u83ED\uD85B\uDC80\uD85C\uDC53\uD845\uDFDB\u5989\u5A82\uD845\uDFB3\u5A61\u5A71\uD846\uDD05\uD850\uDDFC\u372D\u59EF\uD845\uDF3C\u36C7\u718E\u9390\u669A\uD850\uDEA5\u5A6E\u5A2B\uD850\uDE93\u6A2B\uD84F\uDEF9\uD85D\uDF36\uD851\uDC5B\uD850\uDECA\u711D\uD850\uDE59\uD862\uDDE1\u4FB0\uD85B\uDD28\u5CC2\uD851\uDCCE\uD85F\uDE4D\uD850\uDFBD\u6A0C\uD850\uDE56\uD844\uDF04\u70A6\u7133\uD850\uDFE9\u3DA5\u6CDF\uD87E\uDC25\uD852\uDE4F\u7E65\u59EB\u5D2F\u3DF3\u5F5C\uD852\uDE5D\uD845\uDFDF\u7DA4\u8426"],["98a1","\u5485\uD84E\uDEFA\uD84C\uDF00\uD840\uDE14\u577E\uD842\uDCD5\uD841\uDE19\u3FE5\uD847\uDF9E\uD868\uDEB6\u7003\uD864\uDD5B\u5D70\u738F\u7CD3\uD862\uDE59\uD865\uDC20\u4FC8\u7FE7\u72CD\u7310\uD85E\uDEF4\u7338\u7339\uD855\uDEF6\u7341\u7348\u3EA9\uD85E\uDF18\u906C\u71F5\uD852\uDCF2\u73E1\u81F6\u3ECA\u770C\u3ED1\u6CA2\u56FD\u7419\u741E\u741F\u3EE2\u3EF0\u3EF4\u3EFA\u74D3\u3F0E\u3F53\u7542\u756D\u7572\u758D\u3F7C\u75C8\u75DC\u3FC0\u764D\u3FD7\u7674\u3FDC\u767A\uD853\uDF5C\u7188\u5623\u8980\u5869\u401D\u7743\u4039\u6761\u4045\u35DB\u7798\u406A\u406F\u5C5E\u77BE\u77CB\u58F2\u7818\u70B9\u781C\u40A8\u7839\u7847\u7851\u7866\u8448\uD855\uDD35\u7933\u6803\u7932\u4103"],["9940","\u4109\u7991\u7999\u8FBB\u7A06\u8FBC\u4167\u7A91\u41B2\u7ABC\u8279\u41C4\u7ACF\u7ADB\u41CF\u4E21\u7B62\u7B6C\u7B7B\u7C12\u7C1B\u4260\u427A\u7C7B\u7C9C\u428C\u7CB8\u4294\u7CED\u8F93\u70C0\uD843\uDCCF\u7DCF\u7DD4\u7DD0\u7DFD\u7FAE\u7FB4\u729F\u4397\u8020\u8025\u7B39\u802E\u8031\u8054\u3DCC\u57B4\u70A0\u80B7\u80E9\u43ED\u810C\u732A\u810E\u8112\u7560\u8114\u4401\u3B39\u8156\u8159\u815A"],["99a1","\u4413\u583A\u817C\u8184\u4425\u8193\u442D\u81A5\u57EF\u81C1\u81E4\u8254\u448F\u82A6\u8276\u82CA\u82D8\u82FF\u44B0\u8357\u9669\u698A\u8405\u70F5\u8464\u60E3\u8488\u4504\u84BE\u84E1\u84F8\u8510\u8538\u8552\u453B\u856F\u8570\u85E0\u4577\u8672\u8692\u86B2\u86EF\u9645\u878B\u4606\u4617\u88AE\u88FF\u8924\u8947\u8991\uD85E\uDD67\u8A29\u8A38\u8A94\u8AB4\u8C51\u8CD4\u8CF2\u8D1C\u4798\u585F\u8DC3\u47ED\u4EEE\u8E3A\u55D8\u5754\u8E71\u55F5\u8EB0\u4837\u8ECE\u8EE2\u8EE4\u8EED\u8EF2\u8FB7\u8FC1\u8FCA\u8FCC\u9033\u99C4\u48AD\u98E0\u9213\u491E\u9228\u9258\u926B\u92B1\u92AE\u92BF"],["9a40","\u92E3\u92EB\u92F3\u92F4\u92FD\u9343\u9384\u93AD\u4945\u4951\u9EBF\u9417\u5301\u941D\u942D\u943E\u496A\u9454\u9479\u952D\u95A2\u49A7\u95F4\u9633\u49E5\u67A0\u4A24\u9740\u4A35\u97B2\u97C2\u5654\u4AE4\u60E8\u98B9\u4B19\u98F1\u5844\u990E\u9919\u51B4\u991C\u9937\u9942\u995D\u9962\u4B70\u99C5\u4B9D\u9A3C\u9B0F\u7A83\u9B69\u9B81\u9BDD\u9BF1\u9BF4\u4C6D\u9C20\u376F\uD846\uDFC2\u9D49\u9C3A"],["9aa1","\u9EFE\u5650\u9D93\u9DBD\u9DC0\u9DFC\u94F6\u8FB6\u9E7B\u9EAC\u9EB1\u9EBD\u9EC6\u94DC\u9EE2\u9EF1\u9EF8\u7AC8\u9F44\uD840\uDC94\uD840\uDEB7\uD840\uDFA0\u691A\u94C3\u59AC\uD841\uDCD7\u5840\u94C1\u37B9\uD841\uDDD5\uD841\uDE15\uD841\uDE76\uD845\uDEBA\u5757\u7173\uD842\uDEC2\uD842\uDECD\uD842\uDFBF\u546A\uD87E\uDC3B\uD842\uDFCB\u549E\uD842\uDFFB\uD843\uDC3B\uD843\uDC53\uD843\uDC65\uD843\uDC7C\u60E7\uD843\uDC8D\u567A\uD843\uDCB5\uD843\uDCDD\uD843\uDCED\uD843\uDD6F\uD843\uDDB2\uD843\uDDC8\u6955\u9C2F\u87A5\uD843\uDE04\uD843\uDE0E\uD843\uDED7\uD843\uDF90\uD843\uDF2D\uD843\uDE73\u5C20\uD843\uDFBC\u5E0B\uD844\uDC5C\uD844\uDC4F\uD844\uDC76\u671E\uD844\uDC7B\uD844\uDC88\uD844\uDC96\u3647\uD844\uDCBF\uD844\uDCD3\uD844\uDD2F\uD844\uDD3B\u5364\u84AD\uD844\uDEE3\uD844\uDF75\uD844\uDF36\u8B81\uD845\uDD77\uD845\uDE19\uD845\uDFC3\uD845\uDFC7\u4E78\u70BB\uD846\uDC2D\uD846\uDD6A"],["9b40","\uD846\uDE2D\uD846\uDE45\uD847\uDC2A\uD847\uDC70\uD847\uDCAC\uD847\uDEC8\u62C3\uD847\uDED5\uD847\uDF15\u7198\u6855\uD848\uDC45\u69E9\u36C8\uD848\uDE7C\uD848\uDFD7\uD848\uDFFA\uD849\uDF2A\uD84A\uDC71\uD84A\uDD4F\u82FD\uD84A\uDD67\uD84A\uDD93\uD84A\uDED5\u89A5\uD84A\uDEE8\u8FA0\uD84A\uDF0E\u97B8\uD84A\uDF3F\u9847\u9ABD\uD84B\uDC4C"],["9b62","\uD84B\uDC88\uD84B\uDCB7\uD856\uDFE8\uD84B\uDD08\uD84B\uDD12\uD84B\uDDB7\uD84B\uDD95\uD84B\uDE42\uD84B\uDF74\uD84B\uDFCC\uD84C\uDC33\uD84C\uDC66\uD84C\uDF1F\uD84C\uDFDE\u5FB1\u6648\u66BF\uD85E\uDE79\uD84D\uDD67\uD84D\uDDF3\u7201\uD852\uDDBA\u77D7\uD84D\uDE1A\uD84D\uDF16\u7E87\uD840\uDF46\u58B5\u670E"],["9ba1","\u6918\uD84E\uDEA7\uD85D\uDE57\uD857\uDFE2\uD84F\uDE11\uD84F\uDEB9\uD85D\uDDFE\uD848\uDC9A\u48D0\u4AB8\uD850\uDD19\uD862\uDE9A\uD850\uDEEE\uD850\uDF0D\uD850\uDC3B\uD850\uDF34\uD850\uDF96\uD852\uDE45\uD841\uDDCA\u51D2\uD841\uDE11\u599F\uD847\uDEA8\u3BBE\uD84F\uDCFF\uD851\uDC04\uD851\uDCD6\u5788\uD851\uDE74\u399B\uD851\uDF2F\uD861\uDDE8\uD866\uDDC9\u3762\uD848\uDDC3\u8B5E\uD862\uDF4E\u99D6\uD852\uDC12\uD852\uDCFB\uD852\uDE15\u7209\uD852\uDEC0\uD843\uDC78\u5965\uD853\uDEA5\uD853\uDF86\uD841\uDF79\u8EDA\uD854\uDC2C\u528F\u573F\u7171\uD854\uDE99\uD855\uDC19\uD84F\uDF4A\uD852\uDEA7\u55BC\uD855\uDC46\uD855\uDC6E\uD85A\uDF52\u91D4\u3473\uD855\uDD3F\uD85D\uDE32\uD855\uDD5E\u4718\uD855\uDD62\uD855\uDD66\uD855\uDFC7\uD852\uDD3F\uD856\uDC5D\u5066\u34FB\uD84C\uDFCC\u60DE\uD856\uDD03\u477C\uD862\uDD48\uD856\uDEAE\uD856\uDF89\uD857\uDC06\uD847\uDD90\u57A1\u7151\u6FB6\uD858\uDD02\uD85F\uDC12\u9056\uD858\uDDB2\uD853\uDF9A\u8B62\uD859\uDC02\uD859\uDC4A"],["9c40","\u5D5B\uD85A\uDFF7\u8F36\uD859\uDC84\uD846\uDD1C\u8AEA\uD852\uDDF6\uD859\uDC88\uD84F\uDFEF\uD859\uDD12\u4BC0\uD859\uDDBF\uD859\uDEB5\uD849\uDF1B\u9465\uD855\uDFE1\u6195\u5A27\uD87E\uDCCD\u4FBB\u56B9\uD851\uDD21\uD859\uDEFC\u4E6A\uD852\uDD34\u9656\u6D8F\uD85B\uDCBD\u3618\u8977\uD859\uDF99\uD85A\uDC6E\uD859\uDC11\uD85A\uDC5E\u71DF\uD85A\uDCC7\u7B42\uD864\uDCC0\uD842\uDE11\uD85A\uDD26\u9104\uD85A\uDD39\u7A45\u9DF0\uD85A\uDDFA\u9A26\uD85A\uDE2D\u365F\uD859\uDC69\uD840\uDC21\u7983\uD85A\uDE34\uD85A\uDF5B\u5D2C\uD84D\uDD19\u83CF\uD85A\uDF9D\u46D0\uD85B\uDCA4\u753B\u8865\uD85B\uDDAE\u58B6"],["9ca1","\u371C\uD849\uDD8D\uD85C\uDC4B\uD85C\uDDCD\u3C54\uD85C\uDE80\uD85C\uDE85\u9281\uD848\uDD7A\uD85C\uDE8B\u9330\uD85C\uDEE6\uD852\uDDD0\u6C39\u949F\uD85D\uDC50\uD843\uDEF8\u8827\u88F5\uD84A\uDD26\uD861\uDC73\uD845\uDFB1\u6EB8\uD852\uDE2A\uD846\uDC20\u39A4\u36B9\u5C10\u79E3\u453F\u66B6\uD867\uDCAD\uD866\uDCA4\u8943\uD85D\uDFCC\uD85E\uDC58\u56D6\u40DF\uD845\uDE0A\u39A1\uD84D\uDF2F\uD860\uDCE8\uD844\uDFC5\u71AD\u8366\uD85E\uDDDD\uD864\uDDA8\u5A67\u4CB7\uD85C\uDCAF\uD862\uDDAB\uD85E\uDDFD\uD85E\uDE0A\uD85E\uDF0B\uD85F\uDD66\uD850\uDD7A\u7B43\u797E\uD860\uDC09\u6FB5\uD868\uDEDF\u6A03\uD860\uDF18\u53A2\uD85B\uDE07\u93BF\u6836\u975D\uD860\uDD6F\uD860\uDC23\uD85A\uDDB5\uD844\uDFED\uD84C\uDE2F\uD860\uDC48\u5D85\uD863\uDC30\uD860\uDC83\u5715\u9823\uD862\uDD49\u5DAB\uD852\uDD88\u65BE\u69D5\u53D2\uD852\uDEA5\uD84F\uDF81\u3C11\u6736\uD860\uDC90\uD860\uDCF4\uD860\uDD2E\uD847\uDFA1\uD860\uDD4F"],["9d40","\uD860\uDD89\uD860\uDDAF\uD860\uDE1A\uD860\uDF06\uD860\uDF2F\uD860\uDF8A\u35CA\uD861\uDC68\uD861\uDEAA\u48FA\u63E6\uD862\uDD56\u7808\u9255\uD862\uDDB8\u43F2\uD862\uDDE7\u43DF\uD862\uDDE8\uD862\uDF46\uD862\uDFD4\u59F8\uD863\uDC09\u8F0B\uD863\uDFC5\uD864\uDCEC\u7B51\uD864\uDD10\uD864\uDD3C\u3DF7\uD864\uDD5E\uD852\uDECA\u8FD0\u728F\u568B\uD865\uDCE7\uD865\uDDE9\uD865\uDDB0\uD865\uDDB8\uD865\uDF32\uD866\uDCD1\uD866\uDD49\uD866\uDD6A\uD866\uDDC3\uD866\uDE28\uD866\uDF0E\uD867\uDD5A\uD867\uDD9B\u7E9F\uD867\uDEF8\uD867\uDF23\u4CA4\u9547\uD868\uDE93\u71A2\uD868\uDEFF\u4D91\u9012\uD869\uDDCB\u4D9C\uD843\uDC9C\u8FBE\u55C1"],["9da1","\u8FBA\uD849\uDCB0\u8FB9\uD852\uDE93\u4509\u7E7F\u6F56\u6AB1\u4EEA\u34E4\uD862\uDF2C\uD85E\uDC9D\u373A\u8E80\uD845\uDFF5\uD860\uDC24\uD862\uDF6C\uD862\uDF99\uD85E\uDE3E\uD859\uDEAF\u3DEB\uD85D\uDE55\uD84F\uDCB7\uD855\uDE35\uD856\uDD56\u4E9A\uD857\uDE81\uD858\uDE58\u56BF\uD843\uDE6D\u8E0E\u5B6D\uD84F\uDE88\uD853\uDC9E\u63DE\u62D0\uD845\uDFF6\uD846\uDC7B\u6530\u562D\uD857\uDC4A\u541A\uD854\uDF11\u3DC6\uD867\uDD98\u4C7D\u5622\u561E\u7F49\uD857\uDED8\u5975\uD84F\uDD40\u8770\u4E1C\uD843\uDFEA\uD843\uDD49\uD84D\uDEBA\u8117\u9D5E\u8D18\u763B\u9C45\u764E\u77B9\u9345\u5432\u8148\u82F7\u5625\u8132\u8418\u80BD\u55EA\u7962\u5643\u5416\uD843\uDE9D\u35CE\u5605\u55F1\u66F1\uD860\uDEE2\u362D\u7534\u55F0\u55BA\u5497\u5572\uD843\uDC41\uD843\uDC96\u5ED0\uD854\uDD48\uD843\uDE76\uD84B\uDC62"],["9e40","\uD843\uDEA2\u9EAB\u7D5A\u55DE\uD844\uDC75\u629D\u976D\u5494\u8CCD\u71F6\u9176\u63FC\u63B9\u63FE\u5569\uD84A\uDF43\u9C72\uD84B\uDEB3\u519A\u34DF\uD843\uDDA7\u51A7\u544D\u551E\u5513\u7666\u8E2D\uD85A\uDC8A\u75B1\u80B6\u8804\u8786\u88C7\u81B6\u841C\uD844\uDCC1\u44EC\u7304\uD851\uDF06\u5B90\u830B\uD85A\uDC93\u567B\uD849\uDEF4\uD85F\uDD2F\uD850\uDDA3\uD85F\uDD73\uD85B\uDED0\uD85C\uDEB6\u9170\uD844\uDDD9\u9208\uD84F\uDCFC\uD869\uDEA9\uD843\uDEAC\uD843\uDEF9\u7266\uD847\uDCA2\u474E\uD853\uDFC2\uD85F\uDFF9\uD843\uDFEB\u40FA"],["9ea1","\u9C5D\u651F\uD84B\uDDA0\u48F3\uD851\uDFE0\uD867\uDD7C\uD843\uDFEC\uD843\uDE0A\u6062\uD85D\uDDA3\uD843\uDFED"],["9ead","\uD858\uDC48\uD844\uDD87\u71A3\u7E8E\u9D50\u4E1A\u4E04\u3577\u5B0D\u6CB2\u5367\u36AC\u39DC\u537D\u36A5\uD851\uDE18\u589A\uD852\uDF6E\u822D\u544B\u57AA\uD856\uDE95\uD842\uDD79"],["9ec5","\u3A52\uD849\uDC65\u7374\uD867\uDEAC\u4D09\u9BED\uD84F\uDCFE\uD867\uDF30\u4C5B\uD853\uDFA9\uD865\uDD9E\uD867\uDFDE\u845C\uD84F\uDDB6\uD85C\uDEB2\uD859\uDFB3\uD84D\uDF20\u632E\u7D25\uD84F\uDEF7\uD84F\uDE2C\u3A2A\u9008\u52CC\u3E74\u367A\u45E9\uD841\uDC8E\u7640\u5AF0\uD843\uDEB6\u787A\uD85F\uDF2E\u58A7\u40BF\u567C\u9B8B\u5D74\u7654\uD869\uDC34\u9E85\u4CE1\u75F9\u37FB\u6119\uD84C\uDCDA\uD850\uDFF2"],["9ef5","\u565D\uD844\uDEA9\u57A7\uD852\uDD63\uD867\uDE06\u5234\uD85C\uDCAE\u35AD\u6C4A\u9D7C"],["9f40","\u7C56\u9B39\u57DE\uD845\uDF6C\u5C53\u64D3\uD865\uDCD0\uD858\uDF35\uD85C\uDD64\u86AD\uD843\uDD28\uD85B\uDD22\uD852\uDEE2\uD843\uDD71"],["9f4f","\u51FE\uD847\uDF0F\u5D8E\u9703\uD847\uDDD1\u9E81\u904C\u7B1F\u9B02\u5CD1\u7BA3\u6268\u6335\u9AFF\u7BCF\u9B2A\u7C7E\u9B2E\u7C42\u7C86\u9C15\u7BFC\u9B09\u9F17\u9C1B\uD852\uDD3E\u9F5A\u5573\u5BC3\u4FFD\u9E98\u4FF2\u5260\u3E06\u52D1\u5767\u5056\u59B7\u5E12\u97C8\u9DAB\u8F5C\u5469\u97B4\u9940\u97BA\u532C\u6130"],["9fa1","\u692C\u53DA\u9C0A\u9D02\u4C3B\u9641\u6980\u50A6\u7546\uD845\uDF6D\u99DA\u5273"],["9fae","\u9159\u9681\u915C"],["9fb2","\u9151\uD863\uDE97\u637F\uD85B\uDD23\u6ACA\u5611\u918E\u757A\u6285\uD840\uDFFC\u734F\u7C70\uD857\uDC21\uD84F\uDCFD"],["9fc1","\uD852\uDD19\u76D6\u9B9D\u4E2A\uD843\uDCD4\u83BE\u8842"],["9fc9","\u5C4A\u69C0\u50ED\u577A\u521F\u5DF5\u4ECE\u6C31\uD840\uDDF2\u4F39\u549C\u54DA\u529A\u8D82\u35FE\u5F0C\u35F3"],["9fdb","\u6B52\u917C\u9FA5\u9B97\u982E\u98B4\u9ABA\u9EA8\u9E84\u717A\u7B14"],["9fe7","\u6BFA\u8818\u7F78"],["9feb","\u5620\uD869\uDE4A\u8E77\u9F53"],["9ff0","\u8DD4\u8E4F\u9E1C\u8E01\u6282\uD860\uDF7D\u8E28\u8E75\u7AD3\uD852\uDE77\u7A3E\u78D8\u6CEA\u8A67\u7607"],["a040","\uD862\uDE5A\u9F26\u6CCE\u87D6\u75C3\uD868\uDEB2\u7853\uD87E\uDC40\u8D0C\u72E2\u7371\u8B2D\u7302\u74F1\u8CEB\uD852\uDEBB\u862F\u5FBA\u88A0\u44B7"],["a055","\uD846\uDC3B\uD85B\uDE05"],["a058","\u8A7E\uD849\uDD1B"],["a05b","\u60FD\u7667\u9AD7\u9D44\u936E\u9B8F\u87F5"],["a063","\u880F\u8CF7\u732C\u9721\u9BB0\u35D6\u72B2\u4C07\u7C51\u994A\uD858\uDD59\u6159\u4C04\u9E96\u617D"],["a073","\u575F\u616F\u62A6\u6239\u62CE\u3A5C\u61E2\u53AA\uD84C\uDFF5\u6364\u6802\u35D2"],["a0a1","\u5D57\uD862\uDFC2\u8FDA\uD863\uDE39"],["a0a6","\u50D9\uD847\uDD46\u7906\u5332\u9638\uD843\uDF3B\u4065"],["a0ae","\u77FE"],["a0b0","\u7CC2\uD857\uDF1A\u7CDA\u7A2D\u8066\u8063\u7D4D\u7505\u74F2\u8994\u821A\u670C\u8062\uD85D\uDC86\u805B\u74F0\u8103\u7724\u8989\uD859\uDFCC\u7553\uD85B\uDED1\u87A9\u87CE\u81C8\u878C\u8A49\u8CAD\u8B43\u772B\u74F8\u84DA\u3635\u69B2\u8DA6"],["a0d4","\u89A9\u7468\u6DB9\u87C1\uD850\uDC11\u74E7\u3DDB\u7176\u60A4\u619C\u3CD1\u7162\u6077"],["a0e2","\u7F71\uD862\uDF2D\u7250\u60E9\u4B7E\u5220\u3C18\uD84F\uDCC7\uD857\uDED7\uD85D\uDE56\uD855\uDD31\uD846\uDD44\uD844\uDEFE\uD866\uDD03\uD85B\uDDDC\uD85C\uDCAD\u5CC1\uD858\uDDAD\uD862\uDE0F\uD84D\uDE77\uD840\uDCEE\uD85A\uDC46\uD853\uDF0E\u4562\u5B1F\uD858\uDF4C\u9F50\u9EA6\uD858\uDE6B"],["a3c0","\u2400",31,"\u2421"],["c6a1","\u2460",9,"\u2474",9,"\u2170",9,"\u4E36\u4E3F\u4E85\u4EA0\u5182\u5196\u51AB\u52F9\u5338\u5369\u53B6\u590A\u5B80\u5DDB\u2F33\u5E7F\u5EF4\u5F50\u5F61\u6534\u65E0\u7592\u7676\u8FB5\u96B6\xa8\u02C6\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\uFF3B\uFF3D\u273D\u3041",23],["c740","\u3059",58,"\u30A1\u30A2\u30A3\u30A4"],["c7a1","\u30A5",81,"\u0410",5,"\u0401\u0416",4],["c840","\u041B",26,"\u0451\u0436",25,"\u21E7\u21B8\u21B9\u31CF\uD840\uDCCC\u4E5A\uD840\uDC8A\u5202\u4491"],["c8a1","\u9FB0\u5188\u9FB1\uD85D\uDE07"],["c8cd","\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u309B\u309C\u2E80\u2E84\u2E86\u2E87\u2E88\u2E8A\u2E8C\u2E8D\u2E95\u2E9C\u2E9D\u2EA5\u2EA7\u2EAA\u2EAC\u2EAE\u2EB6\u2EBC\u2EBE\u2EC6\u2ECA\u2ECC\u2ECD\u2ECF\u2ED6\u2ED7\u2EDE\u2EE3"],["c8f5","\u0283\u0250\u025B\u0254\u0275\u0153\xf8\u014B\u028A\u026A"],["f9fe","\uFFED"],["fa40","\uD841\uDD47\u92DB\uD841\uDDDF\uD84F\uDFC5\u854C\u42B5\u73EF\u51B5\u3649\uD852\uDD42\uD862\uDDE4\u9344\uD846\uDDDB\u82EE\uD84F\uDCC8\u783C\u6744\u62DF\uD852\uDD33\uD862\uDDAA\uD840\uDEA0\uD85A\uDFB3\uD844\uDF05\u4FAB\uD849\uDCED\u5008\uD85B\uDD29\uD85E\uDE84\uD84D\uDE00\uD852\uDEB1\uD849\uDD13\u5029\uD840\uDF7E\u5FA4\uD840\uDF80\uD840\uDF47\u6EDB\uD841\uDC1F\u507D\u5101\u347A\u510E\u986C\u3743\u8416\uD852\uDDA4\uD841\uDC87\u5160\uD84C\uDFB4\u516A\uD842\uDFFF\uD848\uDCFC\uD840\uDEE5\uD849\uDD30\uD841\uDD8E\uD84C\uDE33\uD846\uDD83\u5B82\u877D\uD841\uDDB3\uD84F\uDC99\u51B2\u51B8"],["faa1","\u9D34\u51C9\u51CF\u51D1\u3CDC\u51D3\uD852\uDEA6\u51B3\u51E2\u5342\u51ED\u83CD\u693E\uD84D\uDF2D\u5F7B\u520B\u5226\u523C\u52B5\u5257\u5294\u52B9\u52C5\u7C15\u8542\u52E0\u860D\uD85A\uDF13\u5305\uD862\uDEDE\u5549\u6ED9\uD84F\uDF80\uD842\uDD54\uD84F\uDFEC\u5333\u5344\uD842\uDFE2\u6CCB\uD845\uDF26\u681B\u73D5\u604A\u3EAA\u38CC\uD845\uDEE8\u71DD\u44A2\u536D\u5374\uD861\uDEAB\u537E\u537F\uD845\uDD96\uD845\uDE13\u77E6\u5393\uD862\uDE9B\u53A0\u53AB\u53AE\u73A7\uD855\uDF72\u3F59\u739C\u53C1\u53C5\u6C49\u4E49\u57FE\u53D9\u3AAB\uD842\uDF8F\u53E0\uD84F\uDFEB\uD84B\uDDA3\u53F6\uD843\uDC77\u5413\u7079\u552B\u6657\u6D5B\u546D\uD85A\uDF53\uD843\uDD74\u555D\u548F\u54A4\u47A6\uD845\uDF0D\uD843\uDEDD\u3DB4\uD843\uDD4D"],["fb40","\uD862\uDDBC\uD849\uDE98\u5547\u4CED\u542F\u7417\u5586\u55A9\u5605\uD846\uDCD7\uD850\uDC3A\u4552\uD851\uDC35\u66B3\uD844\uDCB4\u5637\u66CD\uD84C\uDE8A\u66A4\u66AD\u564D\u564F\u78F1\u56F1\u9787\u53FE\u5700\u56EF\u56ED\uD862\uDF66\u3623\uD844\uDE4F\u5746\uD850\uDDA5\u6C6E\u708B\u5742\u36B1\uD85B\uDC7E\u57E6\uD845\uDC16\u5803\uD845\uDC54\uD850\uDF63\u5826\uD852\uDFF5\u585C\u58AA\u3561\u58E0\u58DC\uD844\uDE3C\u58FB\u5BFF\u5743\uD868\uDD50\uD850\uDE78\u93D3\u35A1\u591F\u68A6\u36C3\u6E59"],["fba1","\uD845\uDE3E\u5A24\u5553\uD845\uDE92\u8505\u59C9\uD843\uDD4E\uD85B\uDC81\uD85B\uDD2A\uD845\uDFDC\u59D9\uD845\uDFFB\uD845\uDFB2\uD85B\uDDA6\u6D71\uD846\uDC28\uD845\uDED5\u59F9\uD85B\uDE45\u5AAB\u5A63\u36E6\uD852\uDDA9\u5A77\u3708\u5A96\u7465\u5AD3\uD85B\uDFA1\uD849\uDD54\u3D85\uD846\uDD11\u3732\uD845\uDEB8\u5E83\u52D0\u5B76\u6588\u5B7C\uD85E\uDE0E\u4004\u485D\uD840\uDE04\u5BD5\u6160\uD846\uDE34\uD856\uDDCC\uD841\uDDA5\u5BF3\u5B9D\u4D10\u5C05\uD846\uDF44\u5C13\u73CE\u5C14\uD847\uDCA5\uD85A\uDF28\u5C49\u48DD\u5C85\u5CE9\u5CEF\u5D8B\uD847\uDDF9\uD847\uDE37\u5D10\u5D18\u5D46\uD847\uDEA4\u5CBA\u5DD7\u82FC\u382D\uD852\uDD01\uD848\uDC49\uD848\uDD73\u8287\u3836\u3BC2\u5E2E\u6A8A\u5E75\u5E7A\uD851\uDCBC\uD843\uDCD3\u53A6\u4EB7\u5ED0\u53A8\uD845\uDF71\u5E09\u5EF4\uD861\uDC82"],["fc40","\u5EF9\u5EFB\u38A0\u5EFC\u683E\u941B\u5F0D\uD840\uDDC1\uD87E\uDC94\u3ADE\u48AE\uD844\uDF3A\u5F3A\uD85A\uDC88\uD848\uDFD0\u5F58\uD849\uDC71\u5F63\u97BD\uD85B\uDE6E\u5F72\u9340\uD862\uDE36\u5FA7\u5DB6\u3D5F\uD854\uDE50\uD847\uDF6A\uD85C\uDCF8\uD849\uDE68\u91D6\uD840\uDE9E\uD862\uDE29\u6031\u6685\uD846\uDC77\u3963\u3DC7\u3639\u5790\uD849\uDFB4\u7971\u3E40\u609E\u60A4\u60B3\uD852\uDD82\uD852\uDD8F\uD85E\uDE53\u74A4\u50E1\u5AA0\u6164\u8424\u6142\uD87E\uDCA6\uD85B\uDED2\u6181\u51F4\uD841\uDE56\u6187\u5BAA\uD84F\uDFB7"],["fca1","\uD84A\uDC5F\u61D3\uD862\uDF9D\uD866\uDD5D\u61D0\u3932\uD84A\uDD80\uD84A\uDCC1\u6023\u615C\u651E\u638B\uD840\uDD18\u62C5\uD845\uDF70\u62D5\uD84B\uDE0D\u636C\uD852\uDDDF\u3A17\u6438\u63F8\uD844\uDF8E\uD845\uDFFC\u6490\u6F8A\uD84B\uDE36\u9814\uD850\uDC8C\uD855\uDF1D\u64E1\u64E5\u947B\u3A66\u643A\u3A57\u654D\u6F16\uD852\uDE28\uD852\uDE23\u6585\u656D\u655F\uD84C\uDC7E\u65B5\uD852\uDD40\u4B37\u65D1\u40D8\uD846\uDC29\u65E0\u65E3\u5FDF\uD84D\uDC00\u6618\uD84C\uDDF7\uD84C\uDDF8\u6644\uD84C\uDDA4\uD84C\uDDA5\u664B\uD843\uDE75\u6667\uD854\uDDE6\u6673\u6674\uD847\uDE3D\uD84C\uDE31\uD861\uDDF4\uD84C\uDDC8\uD854\uDF13\u77C5\uD84A\uDCF7\u99A4\u6702\uD850\uDF9C\uD852\uDE21\u3B2B\u69FA\uD84D\uDFC2\u675E\u6767\u6762\uD850\uDDCD\uD864\uDCED\u67D7\u44E9\u6822\u6E50\u923C\u6801\uD84C\uDFE6\uD85B\uDDA0\u685D"],["fd40","\uD84D\uDC6F\u69E1\u6A0B\uD862\uDEDF\u6973\u68C3\uD84D\uDDCD\u6901\u6900\u3D32\u3A01\uD84D\uDE3C\u3B80\u67AC\u6961\uD862\uDE4A\u42FC\u6936\u6998\u3BA1\uD840\uDFC9\u8363\u5090\u69F9\uD84D\uDE59\uD848\uDD2A\u6A45\uD84D\uDF03\u6A9D\u3BF3\u67B1\u6AC8\uD864\uDD9C\u3C0D\u6B1D\uD842\uDD23\u60DE\u6B35\u6B74\uD849\uDFCD\u6EB5\uD84E\uDEDB\uD840\uDFB5\uD846\uDD58\u3740\u5421\uD84E\uDF5A\u6BE1\uD84F\uDEFC\u6BDC\u6C37\uD849\uDC8B\uD852\uDCF1\uD85A\uDF51\u6C5A\u8226\u6C79\uD84F\uDDBC\u44C5\uD84F\uDDBD\uD850\uDDA4\uD852\uDD0C\uD852\uDD00"],["fda1","\uD84F\uDCC9\u36E5\u3CEB\uD843\uDD32\u9B83\uD84C\uDDF9\uD849\uDC91\u7F8F\u6837\uD85B\uDD25\uD85B\uDDA1\uD85B\uDDEB\u6D96\u6D5C\u6E7C\u6F04\uD852\uDD7F\uD850\uDC85\uD85B\uDE72\u8533\uD85B\uDF74\u51C7\u6C9C\u6E1D\u842E\uD862\uDF21\u6E2F\uD84F\uDE2F\u7453\uD84F\uDF82\u79CC\u6E4F\u5A91\uD84C\uDC4B\u6FF8\u370D\u6F9D\uD84F\uDE30\u6EFA\uD845\uDC97\uD850\uDC3D\u4555\u93F0\u6F44\u6F5C\u3D4E\u6F74\uD864\uDD70\u3D3B\u6F9F\uD850\uDD44\u6FD3\uD850\uDC91\uD850\uDD55\uD850\uDC39\uD84F\uDFF0\uD84F\uDFB4\uD850\uDD3F\u51DF\uD850\uDD56\uD850\uDD57\uD850\uDD40\uD858\uDDDD\u704B\u707E\u70A7\u7081\u70CC\u70D5\u70D6\u70DF\u4104\u3DE8\u71B4\u7196\uD850\uDE77\u712B\u7145\u5A88\u714A\u716E\u5C9C\uD850\uDF65\u714F\u9362\uD850\uDEC1\u712C\uD851\uDC5A\uD852\uDE27\uD852\uDE22\u71BA\uD862\uDFE8\u70BD\u720E"],["fe40","\u9442\u7215\u5911\u9443\u7224\u9341\uD855\uDE05\u722E\u7240\uD852\uDD74\u68BD\u7255\u7257\u3E55\uD84C\uDC44\u680D\u6F3D\u7282\u732A\u732B\uD852\uDC23\uD862\uDC2B\u48ED\uD862\uDC04\u7328\u732E\u73CF\u73AA\uD843\uDC3A\uD85A\uDE2E\u73C9\u7449\uD850\uDDE2\uD845\uDEE7\uD852\uDE24\u6623\u36C5\uD852\uDDB7\uD852\uDD8D\uD852\uDDFB\u73F7\u7415\u6903\uD852\uDE26\u7439\uD841\uDDC3\u3ED7\u745C\uD84A\uDCAD\u7460\uD863\uDEB2\u7447\u73E4\u7476\u83B9\u746C\u3730\u7474\u93F1\u6A2C\u7482\u4953\uD852\uDE8C"],["fea1","\uD850\uDD5F\uD852\uDE79\uD862\uDF8F\u5B46\uD863\uDC03\uD846\uDC9E\u74C8\uD846\uDD88\u750E\u74E9\u751E\uD863\uDED9\uD846\uDE4B\u5BD7\uD863\uDEAC\u9385\u754D\u754A\u7567\u756E\uD853\uDF82\u3F04\uD853\uDD13\u758E\u745D\u759E\u75B4\u7602\u762C\u7651\u764F\u766F\u7676\uD858\uDFF5\u7690\u81EF\u37F8\uD85A\uDD11\uD85A\uDD0E\u76A1\u76A5\u76B7\u76CC\uD85B\uDF9F\u8462\uD854\uDC9D\uD854\uDD7D\uD847\uDE1C\u771E\u7726\u7740\u64AF\uD854\uDE20\u7758\uD84C\uDEAC\u77AF\uD862\uDD64\uD862\uDD68\uD845\uDEC1\u77F4\u7809\uD844\uDF76\uD852\uDE12\u68CA\u78AF\u78C7\u78D3\u96A5\u792E\uD855\uDDE0\u78D7\u7934\u78B1\uD85D\uDE0C\u8FB8\u8884\uD862\uDF2B\uD858\uDC83\uD849\uDE1C\u7986\u8900\u6902\u7980\uD856\uDC57\u799D\uD85E\uDF39\u793C\u79A9\u6E2A\uD85C\uDD26\u3EA8\u79C6\uD864\uDD0D\u79D4"]]');

});



parcelRegister("4dcSV", function(module, exports) {
"use strict";

var $llyme = parcelRequire("llyme");
var $31125f03a1f0e293$require$Buffer = $llyme.Buffer;
// NOTE: Due to 'stream' module being pretty large (~100Kb, significant in browser environments), 
// we opt to dependency-inject it instead of creating a hard dependency.
module.exports = function(stream_module) {
    var Transform = stream_module.Transform;
    // == Encoder stream =======================================================
    function IconvLiteEncoderStream(conv, options) {
        this.conv = conv;
        options = options || {};
        options.decodeStrings = false; // We accept only strings, so we don't need to decode them.
        Transform.call(this, options);
    }
    IconvLiteEncoderStream.prototype = Object.create(Transform.prototype, {
        constructor: {
            value: IconvLiteEncoderStream
        }
    });
    IconvLiteEncoderStream.prototype._transform = function(chunk, encoding, done) {
        if (typeof chunk != 'string') return done(new Error("Iconv encoding stream needs strings as its input."));
        try {
            var res = this.conv.write(chunk);
            if (res && res.length) this.push(res);
            done();
        } catch (e) {
            done(e);
        }
    };
    IconvLiteEncoderStream.prototype._flush = function(done) {
        try {
            var res = this.conv.end();
            if (res && res.length) this.push(res);
            done();
        } catch (e) {
            done(e);
        }
    };
    IconvLiteEncoderStream.prototype.collect = function(cb) {
        var chunks = [];
        this.on('error', cb);
        this.on('data', function(chunk) {
            chunks.push(chunk);
        });
        this.on('end', function() {
            cb(null, $31125f03a1f0e293$require$Buffer.concat(chunks));
        });
        return this;
    };
    // == Decoder stream =======================================================
    function IconvLiteDecoderStream(conv, options) {
        this.conv = conv;
        options = options || {};
        options.encoding = this.encoding = 'utf8'; // We output strings.
        Transform.call(this, options);
    }
    IconvLiteDecoderStream.prototype = Object.create(Transform.prototype, {
        constructor: {
            value: IconvLiteDecoderStream
        }
    });
    IconvLiteDecoderStream.prototype._transform = function(chunk, encoding, done) {
        if (!$31125f03a1f0e293$require$Buffer.isBuffer(chunk) && !(chunk instanceof Uint8Array)) return done(new Error("Iconv decoding stream needs buffers as its input."));
        try {
            var res = this.conv.write(chunk);
            if (res && res.length) this.push(res, this.encoding);
            done();
        } catch (e) {
            done(e);
        }
    };
    IconvLiteDecoderStream.prototype._flush = function(done) {
        try {
            var res = this.conv.end();
            if (res && res.length) this.push(res, this.encoding);
            done();
        } catch (e) {
            done(e);
        }
    };
    IconvLiteDecoderStream.prototype.collect = function(cb) {
        var res = '';
        this.on('error', cb);
        this.on('data', function(chunk) {
            res += chunk;
        });
        this.on('end', function() {
            cb(null, res);
        });
        return this;
    };
    return {
        IconvLiteEncoderStream: IconvLiteEncoderStream,
        IconvLiteDecoderStream: IconvLiteDecoderStream
    };
};

});

parcelRegister("aqbQf", function(module, exports) {
"use strict";

});



parcelRegister("lrct3", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $aGGuH = parcelRequire("aGGuH");
function $f9b5ca6aeff231cf$var$emptyFunction() {}
function $f9b5ca6aeff231cf$var$emptyFunctionWithReset() {}
$f9b5ca6aeff231cf$var$emptyFunctionWithReset.resetWarningCache = $f9b5ca6aeff231cf$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aGGuH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f9b5ca6aeff231cf$var$emptyFunctionWithReset,
        resetWarningCache: $f9b5ca6aeff231cf$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("aGGuH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $7c7eca1397927a3e$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $7c7eca1397927a3e$var$ReactPropTypesSecret;

});


var $0a122f6f26c7affa$exports = {};


(parcelRequire("lGKbD")).register((parcelRequire("17QCl")).getBundleURL('cTKOQ'), JSON.parse("[\"cTKOQ\",\"index.js\",\"cyFLz\",\"close.1c084d12.svg\",\"UcXNt\",\"camera.7b7eb65e.svg\",\"1PEQe\",\"tooltip_circle.0abc46b4.svg\",\"6Mab7\",\"light_bulb.1081abef.svg\",\"fUIaj\",\"close_bubble.fa55c8f8.svg\",\"gFk4U\",\"01_LOGO_G.174ab27e.png\",\"khgW0\",\"logo.fd1b9030.svg\",\"9lufK\",\"fpt-logo-white.9c45b675.png\",\"bCrjg\",\"box.89fb2978.svg\",\"e3ab2\",\"boxDark.a94f06ef.svg\",\"fZib3\",\"shoe.65ca96a5.png\",\"cHwAd\",\"spinner.0ceda41f.svg\",\"gDN53\",\"scale.9b1eac7a.svg\",\"kOH1u\",\"teaser1.6d626856.png\",\"bGVie\",\"teaser2.7643ca25.png\",\"6jC9n\",\"teaser3.522bcb65.png\",\"csRFk\",\"ellipse.b77d5946.svg\",\"cRQrl\",\"progress1.7773e258.svg\",\"5VFuO\",\"progress2.80dc5960.svg\",\"lVsep\",\"progress3.28cf7383.svg\",\"NovuI\",\"underline.f0ed439f.png\",\"dPZaK\",\"long_underline.10ebb010.png\",\"hhpV2\",\"female.4acafb18.svg\",\"gf31B\",\"female1.7f48eeca.svg\",\"dQBWA\",\"female2.3d93e181.svg\",\"kO9ob\",\"female3.06273bf5.svg\",\"9GMfK\",\"female4.139458ef.svg\",\"kUZFx\",\"female5.8f9a60ed.svg\",\"667yX\",\"female6.630bb5bb.svg\",\"ksgFO\",\"female7.c74a53b9.svg\",\"fbRZP\",\"female8.44cf9ff1.svg\",\"8bOBi\",\"female9.13e05822.svg\",\"gN5lY\",\"female10.b0ec6ea2.svg\",\"eKQIN\",\"female11.188562d3.svg\",\"jOnLw\",\"female12.7118baa7.svg\",\"j3ujZ\",\"male.e94ed173.svg\",\"8pBuG\",\"male1.b3362ea1.svg\",\"aCxfK\",\"male2.3eccede1.svg\",\"32GhJ\",\"male3.eb50e737.svg\",\"cU905\",\"male4.abd18d50.svg\",\"4OMUw\",\"male5.bf938049.svg\",\"fLkLK\",\"male6.ce07ef37.svg\",\"lSpzU\",\"male7.8f301d9e.svg\",\"55oFT\",\"male8.de003ba3.svg\",\"bbzB4\",\"male9.1a2a9490.svg\",\"dFjNf\",\"male10.eba6d705.svg\",\"bvJmB\",\"male11.267a0ebe.svg\",\"iR2Wr\",\"save-earth@3x.7557f776.png\",\"euHF8\",\"loader_three_dots.7c598ce9.svg\",\"b8g4v\",\"Yuri@3x.50b38a9a.png\",\"8ggxH\",\"fpt_logo_simple.dfd9049d.png\",\"h39zH\",\"fpt_logo_light_blue.568f9680.png\",\"70bC5\",\"arrow_right.fbcf2231.png\",\"40tfB\",\"arrow_box.3b50ec99.svg\",\"6h8vg\",\"loader_three_dots_black.f408a43c.svg\",\"9RjVu\",\"shoes_spritesheet.11779f0b.png\",\"7MxGU\",\"ring_spinner.1dcaeae3.png\",\"bFs8j\",\"co2Icon.209a90a6.svg\",\"knwD8\",\"shareIcon.bd875a6b.svg\",\"cm4TP\",\"icon_footwear.c00dc534.png\",\"lh8UP\",\"arrow_custom_select.dee6d95b.svg\",\"83voa\",\"icon-measure-minipod.d373e5ee.svg\",\"27Ude\",\"icon-measure-manual.c3fa48f8.svg\",\"fRcwx\",\"icon-measure-minipod-page.d8bac61d.svg\",\"gLtlN\",\"tube-spinner.ca636e80.svg\",\"dw1bH\",\"icon-measurement-archetype.37a263b8.svg\",\"4wSPx\",\"icon-archetype-high-selected.122f0bb6.svg\",\"bwVYg\",\"icon-measurement-camera.532351aa.svg\",\"fPqUi\",\"icon-partner.44595664.svg\",\"gLzyd\",\"logo-footprint-horizontal.cae6764b.svg\",\"8iOIs\",\"icon-language@3x.184b776b.png\",\"fSKWx\",\"icon-info@3x.d2b61fe2.png\",\"fiSe2\",\"caret.64ef683b.svg\",\"3BzUm\",\"icon-size.064f0a72.svg\",\"fUPri\",\"checkbox-active.447bec1f.svg\",\"gs9Wk\",\"fasttrack-mode.ed887b57.svg\",\"fBebI\",\"driver-small-logo.2b40bbc6.svg\",\"3GobP\",\"UniversalSans-v1-2-50-100-0-713112212111-01-600.21f24dfd.woff\",\"1VNze\",\"UniversalSans-v1-2-50-100-0-713112212111-01-890.e1f0a0d5.woff\",\"hr9x2\",\"SourceSans3-Regular.c0531453.ttf\",\"6BjfU\",\"Inter-Regular.21ee491a.ttf\",\"8KLgz\",\"Inter-Medium.d81b2b8e.ttf\",\"hSoPM\",\"Inter-SemiBold.9d533a97.ttf\",\"8E31r\",\"Inter-Bold.2a398d70.ttf\",\"61ifs\",\"Inter-900.4c50ba1d.ttf\",\"76vB9\",\"Rubik-Regular.9c6c8506.ttf\",\"1laSj\",\"Rubik-SemiBold.b8efe26a.ttf\",\"kk6Q6\",\"Rubik-Bold.9884cdc5.ttf\",\"jTN55\",\"index.css\"]"));

var $fba0f23e9e6a11bb$exports = {};
'use strict';

$fba0f23e9e6a11bb$exports = (parcelRequire("ccFxc"));


parcelRequire("6cds3");
var $64d0b1ebdd6bcffe$exports = {};
'use strict';
function $64d0b1ebdd6bcffe$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($64d0b1ebdd6bcffe$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$64d0b1ebdd6bcffe$var$checkDCE();

$64d0b1ebdd6bcffe$exports = (parcelRequire("fxpQW"));




var $6cds3 = parcelRequire("6cds3");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $bdada218cd594db7$var$extendStatics = function(d, b) {
    $bdada218cd594db7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $bdada218cd594db7$var$extendStatics(d, b);
};
function $bdada218cd594db7$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $bdada218cd594db7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bdada218cd594db7$export$18ce0697a983be9b = function() {
    $bdada218cd594db7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bdada218cd594db7$export$18ce0697a983be9b.apply(this, arguments);
};
function $bdada218cd594db7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bdada218cd594db7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $bdada218cd594db7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $bdada218cd594db7$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $bdada218cd594db7$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $bdada218cd594db7$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $bdada218cd594db7$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $bdada218cd594db7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $bdada218cd594db7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bdada218cd594db7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $bdada218cd594db7$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $bdada218cd594db7$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $bdada218cd594db7$export$45d3717a4c69092e(o, m, p);
}
function $bdada218cd594db7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $bdada218cd594db7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $bdada218cd594db7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($bdada218cd594db7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $bdada218cd594db7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $bdada218cd594db7$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $bdada218cd594db7$export$10c90e4f7922046c(v) {
    return this instanceof $bdada218cd594db7$export$10c90e4f7922046c ? (this.v = v, this) : new $bdada218cd594db7$export$10c90e4f7922046c(v);
}
function $bdada218cd594db7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $bdada218cd594db7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $bdada218cd594db7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $bdada218cd594db7$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $bdada218cd594db7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $bdada218cd594db7$export$19a8beecd37a4c45 === "function" ? $bdada218cd594db7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $bdada218cd594db7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $bdada218cd594db7$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $bdada218cd594db7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bdada218cd594db7$export$45d3717a4c69092e(result, mod, k);
    }
    $bdada218cd594db7$var$__setModuleDefault(result, mod);
    return result;
}
function $bdada218cd594db7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $bdada218cd594db7$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $bdada218cd594db7$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $bdada218cd594db7$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $bdada218cd594db7$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $bdada218cd594db7$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $bdada218cd594db7$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $bdada218cd594db7$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $bdada218cd594db7$export$2e2bcd8739ae039 = {
    __extends: $bdada218cd594db7$export$a8ba968b8961cb8a,
    __assign: $bdada218cd594db7$export$18ce0697a983be9b,
    __rest: $bdada218cd594db7$export$3c9a16f847548506,
    __decorate: $bdada218cd594db7$export$29e00dfd3077644b,
    __param: $bdada218cd594db7$export$d5ad3fd78186038f,
    __metadata: $bdada218cd594db7$export$f1db080c865becb9,
    __awaiter: $bdada218cd594db7$export$1050f835b63b671e,
    __generator: $bdada218cd594db7$export$67ebef60e6f28a6,
    __createBinding: $bdada218cd594db7$export$45d3717a4c69092e,
    __exportStar: $bdada218cd594db7$export$f33643c0debef087,
    __values: $bdada218cd594db7$export$19a8beecd37a4c45,
    __read: $bdada218cd594db7$export$8d051b38c9118094,
    __spread: $bdada218cd594db7$export$afc72e2116322959,
    __spreadArrays: $bdada218cd594db7$export$6388937ca91ccae8,
    __spreadArray: $bdada218cd594db7$export$1216008129fb82ed,
    __await: $bdada218cd594db7$export$10c90e4f7922046c,
    __asyncGenerator: $bdada218cd594db7$export$e427f37a30a4de9b,
    __asyncDelegator: $bdada218cd594db7$export$bbd80228419bb833,
    __asyncValues: $bdada218cd594db7$export$e3b29a3d6162315f,
    __makeTemplateObject: $bdada218cd594db7$export$4fb47efe1390b86f,
    __importStar: $bdada218cd594db7$export$c21735bcef00d192,
    __importDefault: $bdada218cd594db7$export$da59b14a69baef04,
    __classPrivateFieldGet: $bdada218cd594db7$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $bdada218cd594db7$export$d40a35129aaff81f,
    __classPrivateFieldIn: $bdada218cd594db7$export$81fdc39f203e4e04,
    __addDisposableResource: $bdada218cd594db7$export$88ac25d8e944e405,
    __disposeResources: $bdada218cd594db7$export$8f076105dc360e92
};


function $cc7fdb626f425e02$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $ae1436a51f26d258$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $ae1436a51f26d258$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $cc7fdb626f425e02$export$2e2bcd8739ae039)(function(prop) {
    return $ae1436a51f26d258$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $6cds3 = parcelRequire("6cds3");
var $37b3ef32bfd5cb93$exports = {};
//
$37b3ef32bfd5cb93$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $55fca618e7164f46$export$71ad59f2e432cfe8 = "-ms-";
var $55fca618e7164f46$export$2c0f367103c8d01c = "-moz-";
var $55fca618e7164f46$export$39dfd62a25e0fe93 = "-webkit-";
var $55fca618e7164f46$export$a29989082612d0d9 = "comm";
var $55fca618e7164f46$export$aa3a2e812ca8570d = "rule";
var $55fca618e7164f46$export$527d108ccf083c2b = "decl";
var $55fca618e7164f46$export$d3d35020fa5b54f0 = "@page";
var $55fca618e7164f46$export$500415a86c544f73 = "@media";
var $55fca618e7164f46$export$a763edbf796b780a = "@import";
var $55fca618e7164f46$export$2790aeb8b4e5c826 = "@charset";
var $55fca618e7164f46$export$1cc683e23b84b133 = "@viewport";
var $55fca618e7164f46$export$9447a5efea57e862 = "@supports";
var $55fca618e7164f46$export$ef011b4e114b1fba = "@document";
var $55fca618e7164f46$export$6aad947bda0f3f46 = "@namespace";
var $55fca618e7164f46$export$b44a8529a35fcb60 = "@keyframes";
var $55fca618e7164f46$export$2c16de31893252e6 = "@font-face";
var $55fca618e7164f46$export$3d846dd52e150c6f = "@counter-style";
var $55fca618e7164f46$export$22314bfbb57653fe = "@font-feature-values";
var $55fca618e7164f46$export$d773506282b3cfe6 = "@layer";
var $55fca618e7164f46$export$1c5a554c78c0cd12 = "@scope";
var $55fca618e7164f46$export$2335f513bbd82c6d = Math.abs;
var $55fca618e7164f46$export$6788812c4e6611e6 = String.fromCharCode;
var $55fca618e7164f46$export$e6e34fd1f2686227 = Object.assign;
function $55fca618e7164f46$export$d6af199866bfb566(e, r) {
    return $55fca618e7164f46$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 0)) << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 1)) << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 2)) << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 3) : 0;
}
function $55fca618e7164f46$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $55fca618e7164f46$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $55fca618e7164f46$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $55fca618e7164f46$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $55fca618e7164f46$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $55fca618e7164f46$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $55fca618e7164f46$export$36776f635604f274(e) {
    return e.length;
}
function $55fca618e7164f46$export$f9084667e487ed46(e) {
    return e.length;
}
function $55fca618e7164f46$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $55fca618e7164f46$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $55fca618e7164f46$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$55fca618e7164f46$export$4659b591c19bdf3d(e, r);
    });
}
var $55fca618e7164f46$export$53f1d5ea8de3d7c = 1;
var $55fca618e7164f46$export$4e0c71f277ca26b3 = 1;
var $55fca618e7164f46$export$f24224f1c91d8156 = 0;
var $55fca618e7164f46$export$5880b8b5730aff45 = 0;
var $55fca618e7164f46$export$c0306caf338ac095 = 0;
var $55fca618e7164f46$export$30a86d91af8ff6e6 = "";
function $55fca618e7164f46$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $55fca618e7164f46$export$53f1d5ea8de3d7c,
        column: $55fca618e7164f46$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $55fca618e7164f46$export$784d13d8ee351f07(e, r) {
    return $55fca618e7164f46$export$e6e34fd1f2686227($55fca618e7164f46$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $55fca618e7164f46$export$590e8b2c435046d9(e) {
    while(e.root)e = $55fca618e7164f46$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $55fca618e7164f46$export$10d8903dec122b9d(e, e.siblings);
}
function $55fca618e7164f46$export$eba6f6f03b0a92e7() {
    return $55fca618e7164f46$export$c0306caf338ac095;
}
function $55fca618e7164f46$export$232faf9add678146() {
    $55fca618e7164f46$export$c0306caf338ac095 = $55fca618e7164f46$export$5880b8b5730aff45 > 0 ? $55fca618e7164f46$export$a9db5e087081082d($55fca618e7164f46$export$30a86d91af8ff6e6, --$55fca618e7164f46$export$5880b8b5730aff45) : 0;
    if ($55fca618e7164f46$export$4e0c71f277ca26b3--, $55fca618e7164f46$export$c0306caf338ac095 === 10) $55fca618e7164f46$export$4e0c71f277ca26b3 = 1, $55fca618e7164f46$export$53f1d5ea8de3d7c--;
    return $55fca618e7164f46$export$c0306caf338ac095;
}
function $55fca618e7164f46$export$48cfd1e771a65c4f() {
    $55fca618e7164f46$export$c0306caf338ac095 = $55fca618e7164f46$export$5880b8b5730aff45 < $55fca618e7164f46$export$f24224f1c91d8156 ? $55fca618e7164f46$export$a9db5e087081082d($55fca618e7164f46$export$30a86d91af8ff6e6, $55fca618e7164f46$export$5880b8b5730aff45++) : 0;
    if ($55fca618e7164f46$export$4e0c71f277ca26b3++, $55fca618e7164f46$export$c0306caf338ac095 === 10) $55fca618e7164f46$export$4e0c71f277ca26b3 = 1, $55fca618e7164f46$export$53f1d5ea8de3d7c++;
    return $55fca618e7164f46$export$c0306caf338ac095;
}
function $55fca618e7164f46$export$4d3fb11e950abb9e() {
    return $55fca618e7164f46$export$a9db5e087081082d($55fca618e7164f46$export$30a86d91af8ff6e6, $55fca618e7164f46$export$5880b8b5730aff45);
}
function $55fca618e7164f46$export$e88cb2efb12ae807() {
    return $55fca618e7164f46$export$5880b8b5730aff45;
}
function $55fca618e7164f46$export$58adb3bec8346d0f(e, r) {
    return $55fca618e7164f46$export$2f35ab04d2335697($55fca618e7164f46$export$30a86d91af8ff6e6, e, r);
}
function $55fca618e7164f46$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $55fca618e7164f46$export$2de70f21292aac9e(e) {
    return $55fca618e7164f46$export$53f1d5ea8de3d7c = $55fca618e7164f46$export$4e0c71f277ca26b3 = 1, $55fca618e7164f46$export$f24224f1c91d8156 = $55fca618e7164f46$export$36776f635604f274($55fca618e7164f46$export$30a86d91af8ff6e6 = e), $55fca618e7164f46$export$5880b8b5730aff45 = 0, [];
}
function $55fca618e7164f46$export$45918ac1574455b1(e) {
    return $55fca618e7164f46$export$30a86d91af8ff6e6 = "", e;
}
function $55fca618e7164f46$export$410ac95b9ec204b8(e) {
    return $55fca618e7164f46$export$87c2784dc9fc4ab($55fca618e7164f46$export$58adb3bec8346d0f($55fca618e7164f46$export$5880b8b5730aff45 - 1, $55fca618e7164f46$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $55fca618e7164f46$export$660b2ee2d4fb4eff(e) {
    return $55fca618e7164f46$export$45918ac1574455b1($55fca618e7164f46$export$5f8c09e3ae6f64e1($55fca618e7164f46$export$2de70f21292aac9e(e)));
}
function $55fca618e7164f46$export$7af1228ff777d175(e) {
    while($55fca618e7164f46$export$c0306caf338ac095 = $55fca618e7164f46$export$4d3fb11e950abb9e())if ($55fca618e7164f46$export$c0306caf338ac095 < 33) $55fca618e7164f46$export$48cfd1e771a65c4f();
    else break;
    return $55fca618e7164f46$export$9e1725a4cfeada27(e) > 2 || $55fca618e7164f46$export$9e1725a4cfeada27($55fca618e7164f46$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $55fca618e7164f46$export$5f8c09e3ae6f64e1(e) {
    while($55fca618e7164f46$export$48cfd1e771a65c4f())switch($55fca618e7164f46$export$9e1725a4cfeada27($55fca618e7164f46$export$c0306caf338ac095)){
        case 0:
            $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$c2ab62c7bf24634($55fca618e7164f46$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$410ac95b9ec204b8($55fca618e7164f46$export$c0306caf338ac095), e);
            break;
        default:
            $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$6788812c4e6611e6($55fca618e7164f46$export$c0306caf338ac095), e);
    }
    return e;
}
function $55fca618e7164f46$export$955ba06d119e085e(e, r) {
    while(--r && $55fca618e7164f46$export$48cfd1e771a65c4f())if ($55fca618e7164f46$export$c0306caf338ac095 < 48 || $55fca618e7164f46$export$c0306caf338ac095 > 102 || $55fca618e7164f46$export$c0306caf338ac095 > 57 && $55fca618e7164f46$export$c0306caf338ac095 < 65 || $55fca618e7164f46$export$c0306caf338ac095 > 70 && $55fca618e7164f46$export$c0306caf338ac095 < 97) break;
    return $55fca618e7164f46$export$58adb3bec8346d0f(e, $55fca618e7164f46$export$e88cb2efb12ae807() + (r < 6 && $55fca618e7164f46$export$4d3fb11e950abb9e() == 32 && $55fca618e7164f46$export$48cfd1e771a65c4f() == 32));
}
function $55fca618e7164f46$export$c889f2fcc19dbf12(e) {
    while($55fca618e7164f46$export$48cfd1e771a65c4f())switch($55fca618e7164f46$export$c0306caf338ac095){
        case e:
            return $55fca618e7164f46$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $55fca618e7164f46$export$c889f2fcc19dbf12($55fca618e7164f46$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $55fca618e7164f46$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $55fca618e7164f46$export$48cfd1e771a65c4f();
            break;
    }
    return $55fca618e7164f46$export$5880b8b5730aff45;
}
function $55fca618e7164f46$export$4254d4e2b3745c4c(e, r) {
    while($55fca618e7164f46$export$48cfd1e771a65c4f())if (e + $55fca618e7164f46$export$c0306caf338ac095 === 57) break;
    else if (e + $55fca618e7164f46$export$c0306caf338ac095 === 84 && $55fca618e7164f46$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $55fca618e7164f46$export$58adb3bec8346d0f(r, $55fca618e7164f46$export$5880b8b5730aff45 - 1) + "*" + $55fca618e7164f46$export$6788812c4e6611e6(e === 47 ? e : $55fca618e7164f46$export$48cfd1e771a65c4f());
}
function $55fca618e7164f46$export$c2ab62c7bf24634(e) {
    while(!$55fca618e7164f46$export$9e1725a4cfeada27($55fca618e7164f46$export$4d3fb11e950abb9e()))$55fca618e7164f46$export$48cfd1e771a65c4f();
    return $55fca618e7164f46$export$58adb3bec8346d0f(e, $55fca618e7164f46$export$5880b8b5730aff45);
}
function $55fca618e7164f46$export$ef7acd7185315e22(e) {
    return $55fca618e7164f46$export$45918ac1574455b1($55fca618e7164f46$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $55fca618e7164f46$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $55fca618e7164f46$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $55fca618e7164f46$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $55fca618e7164f46$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($55fca618e7164f46$export$f8e21b1e77979a08(z += $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $55fca618e7164f46$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $55fca618e7164f46$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $55fca618e7164f46$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $55fca618e7164f46$export$955ba06d119e085e($55fca618e7164f46$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($55fca618e7164f46$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$4a34f930e789283c($55fca618e7164f46$export$4254d4e2b3745c4c($55fca618e7164f46$export$48cfd1e771a65c4f(), $55fca618e7164f46$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $55fca618e7164f46$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $55fca618e7164f46$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $55fca618e7164f46$export$36776f635604f274(z) - l) $55fca618e7164f46$export$10d8903dec122b9d(p > 32 ? $55fca618e7164f46$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $55fca618e7164f46$export$f8483753829ec8f3($55fca618e7164f46$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $55fca618e7164f46$export$10d8903dec122b9d(j = $55fca618e7164f46$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $55fca618e7164f46$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $55fca618e7164f46$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $55fca618e7164f46$export$98e6a39c04603d36(e, j, j, n && $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $55fca618e7164f46$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $55fca618e7164f46$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $55fca618e7164f46$export$232faf9add678146() == 125) continue;
            }
            switch(z += $55fca618e7164f46$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($55fca618e7164f46$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($55fca618e7164f46$export$4d3fb11e950abb9e() === 45) z += $55fca618e7164f46$export$410ac95b9ec204b8($55fca618e7164f46$export$48cfd1e771a65c4f());
                    v = $55fca618e7164f46$export$4d3fb11e950abb9e(), o = l = $55fca618e7164f46$export$36776f635604f274(k = z += $55fca618e7164f46$export$c2ab62c7bf24634($55fca618e7164f46$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $55fca618e7164f46$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $55fca618e7164f46$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $55fca618e7164f46$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $55fca618e7164f46$export$2f35ab04d2335697(e, p + 1, p = $55fca618e7164f46$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $55fca618e7164f46$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $55fca618e7164f46$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $55fca618e7164f46$export$35059013cd4a06db(e, r, a, s === 0 ? $55fca618e7164f46$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $55fca618e7164f46$export$4a34f930e789283c(e, r, a, c) {
    return $55fca618e7164f46$export$35059013cd4a06db(e, r, a, $55fca618e7164f46$export$a29989082612d0d9, $55fca618e7164f46$export$6788812c4e6611e6($55fca618e7164f46$export$eba6f6f03b0a92e7()), $55fca618e7164f46$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $55fca618e7164f46$export$f8483753829ec8f3(e, r, a, n, c) {
    return $55fca618e7164f46$export$35059013cd4a06db(e, r, a, $55fca618e7164f46$export$527d108ccf083c2b, $55fca618e7164f46$export$2f35ab04d2335697(e, 0, n), $55fca618e7164f46$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $55fca618e7164f46$export$82e9f45cca5ba907(n, c, s) {
    switch($55fca618e7164f46$export$d6af199866bfb566(n, c)){
        case 5103:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $55fca618e7164f46$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$2c0f367103c8d01c + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($55fca618e7164f46$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "box-$1$2" + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-item-" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$55fca618e7164f46$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $55fca618e7164f46$export$71ad59f2e432cfe8 + "grid-row-" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-line-pack" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + "box-" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-grow", "") + $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "box-pack:$3" + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $55fca618e7164f46$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$55fca618e7164f46$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $55fca618e7164f46$export$71ad59f2e432cfe8 + "grid-column-align" + $55fca618e7164f46$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $55fca618e7164f46$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$55fca618e7164f46$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$55fca618e7164f46$export$f8e21b1e77979a08(s, "span", 0) ? $55fca618e7164f46$export$4659b591c19bdf3d(s, /\d+/) : +$55fca618e7164f46$export$4659b591c19bdf3d(s, /\d+/) - +$55fca618e7164f46$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $55fca618e7164f46$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($55fca618e7164f46$export$36776f635604f274(n) - 1 - c > 6) switch($55fca618e7164f46$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($55fca618e7164f46$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $55fca618e7164f46$export$2c0f367103c8d01c + ($55fca618e7164f46$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$55fca618e7164f46$export$f8e21b1e77979a08(n, "stretch", 0) ? $55fca618e7164f46$export$82e9f45cca5ba907($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $55fca618e7164f46$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $55fca618e7164f46$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($55fca618e7164f46$export$a9db5e087081082d(n, c + 6) === 121) return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, ":", ":" + $55fca618e7164f46$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($55fca618e7164f46$export$a9db5e087081082d(n, $55fca618e7164f46$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + ($55fca618e7164f46$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $55fca618e7164f46$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, ":", ":" + $55fca618e7164f46$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $55fca618e7164f46$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $55fca618e7164f46$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $55fca618e7164f46$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $55fca618e7164f46$export$a763edbf796b780a:
        case $55fca618e7164f46$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $55fca618e7164f46$export$a29989082612d0d9:
            return "";
        case $55fca618e7164f46$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $55fca618e7164f46$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $55fca618e7164f46$export$aa3a2e812ca8570d:
            if (!$55fca618e7164f46$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $55fca618e7164f46$export$36776f635604f274(a = $55fca618e7164f46$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $55fca618e7164f46$export$5a7767152ae0305f(e) {
    var r = $55fca618e7164f46$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $55fca618e7164f46$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $55fca618e7164f46$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $55fca618e7164f46$export$527d108ccf083c2b:
                n.return = $55fca618e7164f46$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $55fca618e7164f46$export$b44a8529a35fcb60:
                return $55fca618e7164f46$export$dfdc1655ccc5b9cb([
                    $55fca618e7164f46$export$784d13d8ee351f07(n, {
                        value: $55fca618e7164f46$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $55fca618e7164f46$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $55fca618e7164f46$export$aa3a2e812ca8570d:
                if (n.length) return $55fca618e7164f46$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($55fca618e7164f46$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $55fca618e7164f46$export$590e8b2c435046d9($55fca618e7164f46$export$784d13d8ee351f07(n, {
                                props: [
                                    $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $55fca618e7164f46$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $55fca618e7164f46$export$590e8b2c435046d9($55fca618e7164f46$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $55fca618e7164f46$export$e6e34fd1f2686227(n, {
                                props: $55fca618e7164f46$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $55fca618e7164f46$export$590e8b2c435046d9($55fca618e7164f46$export$784d13d8ee351f07(n, {
                                props: [
                                    $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $55fca618e7164f46$export$590e8b2c435046d9($55fca618e7164f46$export$784d13d8ee351f07(n, {
                                props: [
                                    $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $55fca618e7164f46$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $55fca618e7164f46$export$590e8b2c435046d9($55fca618e7164f46$export$784d13d8ee351f07(n, {
                                props: [
                                    $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $55fca618e7164f46$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $55fca618e7164f46$export$590e8b2c435046d9($55fca618e7164f46$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $55fca618e7164f46$export$e6e34fd1f2686227(n, {
                                props: $55fca618e7164f46$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $55fca618e7164f46$export$76a88f7de6507443(e) {
    switch(e.type){
        case $55fca618e7164f46$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $55fca618e7164f46$export$1be1fc439b849fdf($55fca618e7164f46$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($55fca618e7164f46$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $55fca618e7164f46$export$2f35ab04d2335697(r, 1, $55fca618e7164f46$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $55fca618e7164f46$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $55fca618e7164f46$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $55fca618e7164f46$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $b62f2dc75e2ff17e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $a8i8g = parcelRequire("a8i8g");
var $e94f79f42775c5f5$var$f = ("undefined" != typeof $a8i8g && void 0 !== $a8i8g.env && undefined, "data-styled"), $e94f79f42775c5f5$var$m = "active", $e94f79f42775c5f5$var$y = "data-styled-version", $e94f79f42775c5f5$export$83d89fbfd8236492 = "6.1.13", $e94f79f42775c5f5$var$g = "/*!sc*/\n", $e94f79f42775c5f5$var$S = "undefined" != typeof window && "HTMLElement" in window, $e94f79f42775c5f5$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $a8i8g && $a8i8g.env, "undefined" != typeof $a8i8g && $a8i8g.env, false)), $e94f79f42775c5f5$var$b = {}, $e94f79f42775c5f5$var$E = /invalid hook call/i, $e94f79f42775c5f5$var$N = new Set, $e94f79f42775c5f5$var$P = function(t, n) {
    var o, s, i, a, e;
}, $e94f79f42775c5f5$var$_ = Object.freeze([]), $e94f79f42775c5f5$var$C = Object.freeze({});
function $e94f79f42775c5f5$var$I(e, t, n) {
    return void 0 === n && (n = $e94f79f42775c5f5$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $e94f79f42775c5f5$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $e94f79f42775c5f5$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $e94f79f42775c5f5$var$D = /(^-|-$)/g;
function $e94f79f42775c5f5$var$R(e) {
    return e.replace($e94f79f42775c5f5$var$O, "-").replace($e94f79f42775c5f5$var$D, "");
}
var $e94f79f42775c5f5$var$T = /(a)(d)/gi, $e94f79f42775c5f5$var$k = 52, $e94f79f42775c5f5$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $e94f79f42775c5f5$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $e94f79f42775c5f5$var$k; t = t / $e94f79f42775c5f5$var$k | 0)n = $e94f79f42775c5f5$var$j(t % $e94f79f42775c5f5$var$k) + n;
    return ($e94f79f42775c5f5$var$j(t % $e94f79f42775c5f5$var$k) + n).replace($e94f79f42775c5f5$var$T, "$1-$2");
}
var $e94f79f42775c5f5$var$V, $e94f79f42775c5f5$var$F = 5381, $e94f79f42775c5f5$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $e94f79f42775c5f5$var$z = function(e) {
    return $e94f79f42775c5f5$var$M($e94f79f42775c5f5$var$F, e);
};
function $e94f79f42775c5f5$var$$(e) {
    return $e94f79f42775c5f5$var$x($e94f79f42775c5f5$var$z(e) >>> 0);
}
function $e94f79f42775c5f5$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $e94f79f42775c5f5$var$L(e) {
    return "string" == typeof e && true;
}
var $e94f79f42775c5f5$var$G = "function" == typeof Symbol && Symbol.for, $e94f79f42775c5f5$var$Y = $e94f79f42775c5f5$var$G ? Symbol.for("react.memo") : 60115, $e94f79f42775c5f5$var$W = $e94f79f42775c5f5$var$G ? Symbol.for("react.forward_ref") : 60112, $e94f79f42775c5f5$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $e94f79f42775c5f5$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $e94f79f42775c5f5$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $e94f79f42775c5f5$var$J = (($e94f79f42775c5f5$var$V = {})[$e94f79f42775c5f5$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $e94f79f42775c5f5$var$V[$e94f79f42775c5f5$var$Y] = $e94f79f42775c5f5$var$U, $e94f79f42775c5f5$var$V);
function $e94f79f42775c5f5$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $e94f79f42775c5f5$var$Y ? $e94f79f42775c5f5$var$U : "$$typeof" in e ? $e94f79f42775c5f5$var$J[e.$$typeof] : $e94f79f42775c5f5$var$q;
}
var $e94f79f42775c5f5$var$Z = Object.defineProperty, $e94f79f42775c5f5$var$K = Object.getOwnPropertyNames, $e94f79f42775c5f5$var$Q = Object.getOwnPropertySymbols, $e94f79f42775c5f5$var$ee = Object.getOwnPropertyDescriptor, $e94f79f42775c5f5$var$te = Object.getPrototypeOf, $e94f79f42775c5f5$var$ne = Object.prototype;
function $e94f79f42775c5f5$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($e94f79f42775c5f5$var$ne) {
            var o = $e94f79f42775c5f5$var$te(t);
            o && o !== $e94f79f42775c5f5$var$ne && $e94f79f42775c5f5$var$oe(e, o, n);
        }
        var r = $e94f79f42775c5f5$var$K(t);
        $e94f79f42775c5f5$var$Q && (r = r.concat($e94f79f42775c5f5$var$Q(t)));
        for(var s = $e94f79f42775c5f5$var$X(e), i = $e94f79f42775c5f5$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $e94f79f42775c5f5$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $e94f79f42775c5f5$var$ee(t, c);
                try {
                    $e94f79f42775c5f5$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $e94f79f42775c5f5$var$re(e) {
    return "function" == typeof e;
}
function $e94f79f42775c5f5$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $e94f79f42775c5f5$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $e94f79f42775c5f5$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $e94f79f42775c5f5$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $e94f79f42775c5f5$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$e94f79f42775c5f5$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $e94f79f42775c5f5$var$le(e[o], t[o]);
    else if ($e94f79f42775c5f5$var$ce(t)) for(var o in t)e[o] = $e94f79f42775c5f5$var$le(e[o], t[o]);
    return e;
}
function $e94f79f42775c5f5$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $e94f79f42775c5f5$var$pe = {};
function $e94f79f42775c5f5$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $e94f79f42775c5f5$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $e94f79f42775c5f5$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $e94f79f42775c5f5$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($e94f79f42775c5f5$var$g);
        return t;
    }, e;
}(), $e94f79f42775c5f5$var$me = 1073741824, $e94f79f42775c5f5$var$ye = new Map, $e94f79f42775c5f5$var$ve = new Map, $e94f79f42775c5f5$var$ge = 1, $e94f79f42775c5f5$var$Se = function(e) {
    if ($e94f79f42775c5f5$var$ye.has(e)) return $e94f79f42775c5f5$var$ye.get(e);
    for(; $e94f79f42775c5f5$var$ve.has($e94f79f42775c5f5$var$ge);)$e94f79f42775c5f5$var$ge++;
    var t = $e94f79f42775c5f5$var$ge++;
    return $e94f79f42775c5f5$var$ye.set(e, t), $e94f79f42775c5f5$var$ve.set(t, e), t;
}, $e94f79f42775c5f5$var$we = function(e, t) {
    $e94f79f42775c5f5$var$ge = t + 1, $e94f79f42775c5f5$var$ye.set(e, t), $e94f79f42775c5f5$var$ve.set(t, e);
}, $e94f79f42775c5f5$var$be = "style[".concat($e94f79f42775c5f5$var$f, "][").concat($e94f79f42775c5f5$var$y, '="').concat($e94f79f42775c5f5$export$83d89fbfd8236492, '"]'), $e94f79f42775c5f5$var$Ee = new RegExp("^".concat($e94f79f42775c5f5$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $e94f79f42775c5f5$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $e94f79f42775c5f5$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($e94f79f42775c5f5$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($e94f79f42775c5f5$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($e94f79f42775c5f5$var$we(u, l), $e94f79f42775c5f5$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $e94f79f42775c5f5$var$_e = function(e) {
    for(var t = document.querySelectorAll($e94f79f42775c5f5$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($e94f79f42775c5f5$var$f) !== $e94f79f42775c5f5$var$m && ($e94f79f42775c5f5$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $e94f79f42775c5f5$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $e94f79f42775c5f5$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($e94f79f42775c5f5$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($e94f79f42775c5f5$var$f, $e94f79f42775c5f5$var$m), o.setAttribute($e94f79f42775c5f5$var$y, $e94f79f42775c5f5$export$83d89fbfd8236492);
    var i = $e94f79f42775c5f5$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $e94f79f42775c5f5$var$Ae = function() {
    function e(e) {
        this.element = $e94f79f42775c5f5$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $e94f79f42775c5f5$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $e94f79f42775c5f5$var$Oe = function() {
    function e(e) {
        this.element = $e94f79f42775c5f5$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $e94f79f42775c5f5$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $e94f79f42775c5f5$var$Re = $e94f79f42775c5f5$var$S, $e94f79f42775c5f5$var$Te = {
    isServer: !$e94f79f42775c5f5$var$S,
    useCSSOMInjection: !$e94f79f42775c5f5$var$w
}, $e94f79f42775c5f5$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $e94f79f42775c5f5$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $bdada218cd594db7$export$18ce0697a983be9b)((0, $bdada218cd594db7$export$18ce0697a983be9b)({}, $e94f79f42775c5f5$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $e94f79f42775c5f5$var$S && $e94f79f42775c5f5$var$Re && ($e94f79f42775c5f5$var$Re = !1, $e94f79f42775c5f5$var$_e(this)), $e94f79f42775c5f5$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $e94f79f42775c5f5$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($e94f79f42775c5f5$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($e94f79f42775c5f5$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $e94f79f42775c5f5$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $e94f79f42775c5f5$var$S && $e94f79f42775c5f5$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $bdada218cd594db7$export$18ce0697a983be9b)((0, $bdada218cd594db7$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $e94f79f42775c5f5$var$De(n) : t ? new $e94f79f42775c5f5$var$Ae(n) : new $e94f79f42775c5f5$var$Oe(n);
        }(this.options), new $e94f79f42775c5f5$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($e94f79f42775c5f5$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($e94f79f42775c5f5$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($e94f79f42775c5f5$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $e94f79f42775c5f5$var$je = /&/g, $e94f79f42775c5f5$var$xe = /^\s*\/\/.*$/gm;
function $e94f79f42775c5f5$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $e94f79f42775c5f5$var$Ve(e.children, t)), e;
    });
}
function $e94f79f42775c5f5$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $e94f79f42775c5f5$var$C : e, s = r.options, i = void 0 === s ? $e94f79f42775c5f5$var$C : s, a = r.plugins, c = void 0 === a ? $e94f79f42775c5f5$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $55fca618e7164f46$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($e94f79f42775c5f5$var$je, n).replace(o, l));
    }), i.prefix && u.push($55fca618e7164f46$export$e08c7d021b829b7a), u.push($55fca618e7164f46$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($e94f79f42775c5f5$var$xe, ""), l = $55fca618e7164f46$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $e94f79f42775c5f5$var$Ve(l, i.namespace));
        var p = [];
        return $55fca618e7164f46$export$dfdc1655ccc5b9cb(l, $55fca618e7164f46$export$5a7767152ae0305f(u.concat($55fca618e7164f46$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $e94f79f42775c5f5$var$he(15), $e94f79f42775c5f5$var$M(e, t.name);
    }, $e94f79f42775c5f5$var$F).toString() : "", p;
}
var $e94f79f42775c5f5$var$Me = new $e94f79f42775c5f5$var$ke, $e94f79f42775c5f5$var$ze = $e94f79f42775c5f5$var$Fe(), $e94f79f42775c5f5$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $e94f79f42775c5f5$var$Me,
    stylis: $e94f79f42775c5f5$var$ze
}), $e94f79f42775c5f5$export$91317688fc694efa = $e94f79f42775c5f5$export$8c190ef828af4c86.Consumer, $e94f79f42775c5f5$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext(void 0);
function $e94f79f42775c5f5$var$Ge() {
    return (0, $6cds3.useContext)($e94f79f42775c5f5$export$8c190ef828af4c86);
}
function $e94f79f42775c5f5$export$a473771da2f0ff7c(e) {
    var t = (0, $6cds3.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $e94f79f42775c5f5$var$Ge().styleSheet, l = (0, $6cds3.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $6cds3.useMemo)(function() {
        return $e94f79f42775c5f5$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $6cds3.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($37b3ef32bfd5cb93$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $6cds3.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($e94f79f42775c5f5$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($e94f79f42775c5f5$var$Le.Provider, {
        value: u
    }, e.children));
}
var $e94f79f42775c5f5$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $e94f79f42775c5f5$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $e94f79f42775c5f5$var$ue(this, function() {
            throw $e94f79f42775c5f5$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $e94f79f42775c5f5$var$ze), this.name + e.hash;
    }, e;
}(), $e94f79f42775c5f5$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $e94f79f42775c5f5$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $e94f79f42775c5f5$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $e94f79f42775c5f5$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $e94f79f42775c5f5$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$e94f79f42775c5f5$var$Ue(i) && (Array.isArray(i) && i.isCss || $e94f79f42775c5f5$var$re(i) ? r.push("".concat($e94f79f42775c5f5$var$He(s), ":"), i, ";") : $e94f79f42775c5f5$var$ce(i) ? r.push.apply(r, (0, $bdada218cd594db7$export$1216008129fb82ed)((0, $bdada218cd594db7$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $e94f79f42775c5f5$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($e94f79f42775c5f5$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $b62f2dc75e2ff17e$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $e94f79f42775c5f5$var$Xe(e, t, n, o) {
    if ($e94f79f42775c5f5$var$Ue(e)) return [];
    if ($e94f79f42775c5f5$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($e94f79f42775c5f5$var$re(e)) {
        if (!$e94f79f42775c5f5$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $e94f79f42775c5f5$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $e94f79f42775c5f5$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $e94f79f42775c5f5$var$ce(e) ? $e94f79f42775c5f5$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($e94f79f42775c5f5$var$_, e.map(function(e) {
        return $e94f79f42775c5f5$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $e94f79f42775c5f5$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($e94f79f42775c5f5$var$re(n) && !$e94f79f42775c5f5$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $e94f79f42775c5f5$var$Ke = $e94f79f42775c5f5$var$z($e94f79f42775c5f5$export$83d89fbfd8236492), $e94f79f42775c5f5$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $e94f79f42775c5f5$var$Ze(e), this.componentId = t, this.baseHash = $e94f79f42775c5f5$var$M($e94f79f42775c5f5$var$Ke, t), this.baseStyle = n, $e94f79f42775c5f5$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $e94f79f42775c5f5$var$ie(o, this.staticRulesId);
            else {
                var r = $e94f79f42775c5f5$var$ae($e94f79f42775c5f5$var$Xe(this.rules, e, t, n)), s = $e94f79f42775c5f5$var$x($e94f79f42775c5f5$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $e94f79f42775c5f5$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $e94f79f42775c5f5$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $e94f79f42775c5f5$var$ae($e94f79f42775c5f5$var$Xe(u, e, t, n));
                    a = $e94f79f42775c5f5$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $e94f79f42775c5f5$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $e94f79f42775c5f5$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $e94f79f42775c5f5$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext(void 0), $e94f79f42775c5f5$export$b631efc24e9d5e2f = $e94f79f42775c5f5$export$2c657da244d00bd6.Consumer;
function $e94f79f42775c5f5$export$93d4e7f90805808f() {
    var e = (0, $6cds3.useContext)($e94f79f42775c5f5$export$2c657da244d00bd6);
    if (!e) throw $e94f79f42775c5f5$var$he(18);
    return e;
}
function $e94f79f42775c5f5$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($e94f79f42775c5f5$export$2c657da244d00bd6), r = (0, $6cds3.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $e94f79f42775c5f5$var$he(14);
            if ($e94f79f42775c5f5$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $e94f79f42775c5f5$var$he(8);
            return n ? (0, $bdada218cd594db7$export$18ce0697a983be9b)((0, $bdada218cd594db7$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($e94f79f42775c5f5$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $e94f79f42775c5f5$var$rt = {}, $e94f79f42775c5f5$var$st = new Set;
function $e94f79f42775c5f5$var$it(e, r, s) {
    var i = $e94f79f42775c5f5$export$7ba318d8d2f06c76(e), a = e, c = !$e94f79f42775c5f5$var$L(e), p = r.attrs, d = void 0 === p ? $e94f79f42775c5f5$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $e94f79f42775c5f5$var$R(e);
        $e94f79f42775c5f5$var$rt[n] = ($e94f79f42775c5f5$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($e94f79f42775c5f5$var$$($e94f79f42775c5f5$export$83d89fbfd8236492 + n + $e94f79f42775c5f5$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $e94f79f42775c5f5$var$L(e) ? "styled.".concat(e) : "Styled(".concat($e94f79f42775c5f5$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($e94f79f42775c5f5$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $e94f79f42775c5f5$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($e94f79f42775c5f5$export$2c657da244d00bd6), m = $e94f79f42775c5f5$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $e94f79f42775c5f5$var$I(r, f, c) || $e94f79f42775c5f5$var$C, g = function(e, n, o) {
                for(var r, s = (0, $bdada218cd594db7$export$18ce0697a983be9b)((0, $bdada218cd594db7$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $e94f79f42775c5f5$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $e94f79f42775c5f5$var$ie(s[c], a[c]) : "style" === c ? (0, $bdada218cd594db7$export$18ce0697a983be9b)((0, $bdada218cd594db7$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $e94f79f42775c5f5$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $e94f79f42775c5f5$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $e94f79f42775c5f5$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$e94f79f42775c5f5$var$L(S) && !$e94f79f42775c5f5$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $6cds3.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $e94f79f42775c5f5$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$e94f79f42775c5f5$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $e94f79f42775c5f5$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $e94f79f42775c5f5$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $e94f79f42775c5f5$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $e94f79f42775c5f5$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $e94f79f42775c5f5$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($e94f79f42775c5f5$var$re(t) || $e94f79f42775c5f5$var$ce(t)) return $e94f79f42775c5f5$var$ct($e94f79f42775c5f5$var$Xe($e94f79f42775c5f5$var$at($e94f79f42775c5f5$var$_, (0, $bdada218cd594db7$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $e94f79f42775c5f5$var$Xe(r) : $e94f79f42775c5f5$var$ct($e94f79f42775c5f5$var$Xe($e94f79f42775c5f5$var$at(r, n)));
}
function $e94f79f42775c5f5$var$ut(n, o, r) {
    if (void 0 === r && (r = $e94f79f42775c5f5$var$C), !o) throw $e94f79f42775c5f5$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $e94f79f42775c5f5$export$dbf350e5966cf602.apply(void 0, (0, $bdada218cd594db7$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $e94f79f42775c5f5$var$ut(n, o, (0, $bdada218cd594db7$export$18ce0697a983be9b)((0, $bdada218cd594db7$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $e94f79f42775c5f5$var$ut(n, o, (0, $bdada218cd594db7$export$18ce0697a983be9b)((0, $bdada218cd594db7$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $e94f79f42775c5f5$var$pt = function(e) {
    return $e94f79f42775c5f5$var$ut($e94f79f42775c5f5$var$it, e);
}, $e94f79f42775c5f5$export$2e2bcd8739ae039 = $e94f79f42775c5f5$var$pt;
$e94f79f42775c5f5$var$A.forEach(function(e) {
    $e94f79f42775c5f5$export$2e2bcd8739ae039[e] = $e94f79f42775c5f5$var$pt(e);
});
var $e94f79f42775c5f5$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $e94f79f42775c5f5$var$Ze(e), $e94f79f42775c5f5$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($e94f79f42775c5f5$var$ae($e94f79f42775c5f5$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $e94f79f42775c5f5$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $e94f79f42775c5f5$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $e94f79f42775c5f5$export$dbf350e5966cf602.apply(void 0, (0, $bdada218cd594db7$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($e94f79f42775c5f5$var$$(JSON.stringify(i))), c = new $e94f79f42775c5f5$var$ht(i, a);
    var l = function(e) {
        var t = $e94f79f42775c5f5$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($e94f79f42775c5f5$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $e94f79f42775c5f5$var$b, o, s);
        else {
            var i = (0, $bdada218cd594db7$export$18ce0697a983be9b)((0, $bdada218cd594db7$export$18ce0697a983be9b)({}, n), {
                theme: $e94f79f42775c5f5$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).memo(l);
}
function $e94f79f42775c5f5$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $e94f79f42775c5f5$var$ae($e94f79f42775c5f5$export$dbf350e5966cf602.apply(void 0, (0, $bdada218cd594db7$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $e94f79f42775c5f5$var$$(r);
    return new $e94f79f42775c5f5$var$We(s, r);
}
function $e94f79f42775c5f5$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef(function(n, r) {
        var s = $e94f79f42775c5f5$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($e94f79f42775c5f5$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(e, (0, $bdada218cd594db7$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($e94f79f42775c5f5$var$B(e), ")"), $e94f79f42775c5f5$var$oe(n, e);
}
var $e94f79f42775c5f5$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $e94f79f42775c5f5$var$Ce(), o = $e94f79f42775c5f5$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($e94f79f42775c5f5$var$f, '="true"'),
                "".concat($e94f79f42775c5f5$var$y, '="').concat($e94f79f42775c5f5$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $e94f79f42775c5f5$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $e94f79f42775c5f5$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$e94f79f42775c5f5$var$f] = "", n[$e94f79f42775c5f5$var$y] = $e94f79f42775c5f5$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $e94f79f42775c5f5$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("style", (0, $bdada218cd594db7$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $e94f79f42775c5f5$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $e94f79f42775c5f5$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($e94f79f42775c5f5$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $e94f79f42775c5f5$var$he(3);
    }, e;
}(), $e94f79f42775c5f5$export$5c87cfe6c475f500 = {
    StyleSheet: $e94f79f42775c5f5$var$ke,
    mainSheet: $e94f79f42775c5f5$var$Me
};
var $e94f79f42775c5f5$var$St = "__sc-".concat($e94f79f42775c5f5$var$f, "__");


/*
* Copyright 2015, Yahoo Inc.
* Copyrights licensed under the New BSD License.
* See the accompanying LICENSE file for terms.
*/ 
function $01df43c5309c7d2d$export$fc10aeed3a532e2a(fn, options) {
    const cache = options && options.cache ? options.cache : $01df43c5309c7d2d$var$cacheDefault;
    const serializer = options && options.serializer ? options.serializer : $01df43c5309c7d2d$var$serializerDefault;
    const strategy = options && options.strategy ? options.strategy : $01df43c5309c7d2d$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $01df43c5309c7d2d$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean";
}
function $01df43c5309c7d2d$var$monadic(fn, cache, serializer, arg) {
    const cacheKey = $01df43c5309c7d2d$var$isPrimitive(arg) ? arg : serializer(arg);
    let computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $01df43c5309c7d2d$var$variadic(fn, cache, serializer) {
    const args = Array.prototype.slice.call(arguments, 3);
    const cacheKey = serializer(args);
    let computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $01df43c5309c7d2d$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $01df43c5309c7d2d$var$strategyDefault(fn, options) {
    const strategy = fn.length === 1 ? $01df43c5309c7d2d$var$monadic : $01df43c5309c7d2d$var$variadic;
    return $01df43c5309c7d2d$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $01df43c5309c7d2d$var$strategyVariadic(fn, options) {
    return $01df43c5309c7d2d$var$assemble(fn, this, $01df43c5309c7d2d$var$variadic, options.cache.create(), options.serializer);
}
function $01df43c5309c7d2d$var$strategyMonadic(fn, options) {
    return $01df43c5309c7d2d$var$assemble(fn, this, $01df43c5309c7d2d$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
const $01df43c5309c7d2d$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
class $01df43c5309c7d2d$var$ObjectWithoutPrototypeCache {
    cache;
    constructor(){
        this.cache = Object.create(null);
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
}
const $01df43c5309c7d2d$var$cacheDefault = {
    create: function create() {
        return new $01df43c5309c7d2d$var$ObjectWithoutPrototypeCache();
    }
};
const $01df43c5309c7d2d$export$c5491a8691a23b9e = {
    variadic: $01df43c5309c7d2d$var$strategyVariadic,
    monadic: $01df43c5309c7d2d$var$strategyMonadic
};


var $c6afd59246e3278c$exports = {};

$parcel$defineInteropFlag($c6afd59246e3278c$exports);
$parcel$export($c6afd59246e3278c$exports, "ErrorCode", function () { return $e59bdda6a16f4fa3$export$d4e71bc0b80dc0fb; });
$parcel$export($c6afd59246e3278c$exports, "FormatError", function () { return $e59bdda6a16f4fa3$export$7369836851cc1329; });
$parcel$export($c6afd59246e3278c$exports, "isFormatXMLElementFn", function () { return $370978406261062d$export$df0c12a2d414a163; });

$parcel$export($c6afd59246e3278c$exports, "IntlMessageFormat", function () { return $33e616693c036183$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
/**
* https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
* Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
* with some tweaks
*/ const $96a4c0877753a8ad$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $96a4c0877753a8ad$export$f7b99fb377fe69fa(skeleton) {
    const result = {};
    skeleton.replace($96a4c0877753a8ad$var$DATE_TIME_REGEX, (match)=>{
        const len = match.length;
        switch(match[0]){
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}


// @generated from regex-gen.ts
const $310ed90d67e46dbb$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $19c5978fa60a1a6d$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    const stringTokens = skeleton.split((0, $310ed90d67e46dbb$export$2b8db14d8bcaece7)).filter((x)=>x.length > 0);
    const tokens = [];
    for (const stringToken of stringTokens){
        let stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        const [stem, ...options] = stemAndOptions;
        for (const option of options){
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $19c5978fa60a1a6d$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
const $19c5978fa60a1a6d$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
const $19c5978fa60a1a6d$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
const $19c5978fa60a1a6d$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
const $19c5978fa60a1a6d$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $19c5978fa60a1a6d$var$parseSignificantPrecision(str) {
    const result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($19c5978fa60a1a6d$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $19c5978fa60a1a6d$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $19c5978fa60a1a6d$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    let result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        const signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$19c5978fa60a1a6d$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $19c5978fa60a1a6d$var$parseNotationOptions(opt) {
    const result = {};
    const signOpts = $19c5978fa60a1a6d$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $19c5978fa60a1a6d$export$47c6f8480bda3e11(tokens) {
    let result = {};
    for (const token of tokens){
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $19c5978fa60a1a6d$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = {
                    ...result,
                    notation: "scientific",
                    ...token.options.reduce((all, opt)=>({
                            ...all,
                            ...$19c5978fa60a1a6d$var$parseNotationOptions(opt)
                        }), {})
                };
                continue;
            case "engineering":
                result = {
                    ...result,
                    notation: "engineering",
                    ...token.options.reduce((all, opt)=>({
                            ...all,
                            ...$19c5978fa60a1a6d$var$parseNotationOptions(opt)
                        }), {})
                };
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            case "rounding-mode-floor":
                result.roundingMode = "floor";
                continue;
            case "rounding-mode-ceiling":
                result.roundingMode = "ceil";
                continue;
            case "rounding-mode-down":
                result.roundingMode = "trunc";
                continue;
            case "rounding-mode-up":
                result.roundingMode = "expand";
                continue;
            case "rounding-mode-half-even":
                result.roundingMode = "halfEven";
                continue;
            case "rounding-mode-half-down":
                result.roundingMode = "halfTrunc";
                continue;
            case "rounding-mode-half-up":
                result.roundingMode = "halfExpand";
                continue;
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($19c5978fa60a1a6d$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($19c5978fa60a1a6d$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($19c5978fa60a1a6d$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($19c5978fa60a1a6d$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            const opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = {
                ...result,
                trailingZeroDisplay: "stripIfInteger"
            };
            else if (opt) result = {
                ...result,
                ...$19c5978fa60a1a6d$var$parseSignificantPrecision(opt)
            };
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($19c5978fa60a1a6d$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = {
                ...result,
                ...$19c5978fa60a1a6d$var$parseSignificantPrecision(token.stem)
            };
            continue;
        }
        const signOpts = $19c5978fa60a1a6d$var$parseSign(token.stem);
        if (signOpts) result = {
            ...result,
            ...signOpts
        };
        const conciseScientificAndEngineeringOpts = $19c5978fa60a1a6d$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = {
            ...result,
            ...conciseScientificAndEngineeringOpts
        };
    }
    return result;
}




let $4c42ef5197e1caf7$export$b87f371cbc396fcf = /* @__PURE__ */ function(TYPE) {
    /**
	* Raw text
	*/ TYPE[TYPE["literal"] = 0] = "literal";
    /**
	* Variable w/o any format, e.g `var` in `this is a {var}`
	*/ TYPE[TYPE["argument"] = 1] = "argument";
    /**
	* Variable w/ number format
	*/ TYPE[TYPE["number"] = 2] = "number";
    /**
	* Variable w/ date format
	*/ TYPE[TYPE["date"] = 3] = "date";
    /**
	* Variable w/ time format
	*/ TYPE[TYPE["time"] = 4] = "time";
    /**
	* Variable w/ select format
	*/ TYPE[TYPE["select"] = 5] = "select";
    /**
	* Variable w/ plural format
	*/ TYPE[TYPE["plural"] = 6] = "plural";
    /**
	* Only possible within plural argument.
	* This is the `#` symbol that will be substituted with the count.
	*/ TYPE[TYPE["pound"] = 7] = "pound";
    /**
	* XML-like tag
	*/ TYPE[TYPE["tag"] = 8] = "tag";
    return TYPE;
}({});
let $4c42ef5197e1caf7$export$906452485466fa53 = /* @__PURE__ */ function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
    return SKELETON_TYPE;
}({});
function $4c42ef5197e1caf7$export$cfa10c5697238752(el) {
    return el.type === $4c42ef5197e1caf7$export$b87f371cbc396fcf.literal;
}
function $4c42ef5197e1caf7$export$4f55724281bdfaf9(el) {
    return el.type === $4c42ef5197e1caf7$export$b87f371cbc396fcf.argument;
}
function $4c42ef5197e1caf7$export$e11187b219e191e1(el) {
    return el.type === $4c42ef5197e1caf7$export$b87f371cbc396fcf.number;
}
function $4c42ef5197e1caf7$export$32d811605da75f40(el) {
    return el.type === $4c42ef5197e1caf7$export$b87f371cbc396fcf.date;
}
function $4c42ef5197e1caf7$export$34ec46f596b1702f(el) {
    return el.type === $4c42ef5197e1caf7$export$b87f371cbc396fcf.time;
}
function $4c42ef5197e1caf7$export$dcfe1c11d168b5a1(el) {
    return el.type === $4c42ef5197e1caf7$export$b87f371cbc396fcf.select;
}
function $4c42ef5197e1caf7$export$6c796d116f0a4fbc(el) {
    return el.type === $4c42ef5197e1caf7$export$b87f371cbc396fcf.plural;
}
function $4c42ef5197e1caf7$export$c0ece297bdd0c082(el) {
    return el.type === $4c42ef5197e1caf7$export$b87f371cbc396fcf.pound;
}
function $4c42ef5197e1caf7$export$5c83de34745812b(el) {
    return el.type === $4c42ef5197e1caf7$export$b87f371cbc396fcf.tag;
}
function $4c42ef5197e1caf7$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $4c42ef5197e1caf7$export$906452485466fa53.number);
}
function $4c42ef5197e1caf7$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $4c42ef5197e1caf7$export$906452485466fa53.dateTime);
}
function $4c42ef5197e1caf7$export$f0ac572c1121c662(value) {
    return {
        type: $4c42ef5197e1caf7$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $4c42ef5197e1caf7$export$425e864b0ba114f1(value, style) {
    return {
        type: $4c42ef5197e1caf7$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


let $05294526b7a1a012$export$896afd8541959ee5 = /* @__PURE__ */ function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
	* Expecting a message fragment after the `plural` or `selectordinal` selector
	* (e.g. `{foo, plural, one}`)
	*/ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
	* Duplicate selectors in `plural` or `selectordinal` argument.
	* (e.g. {foo, plural, one {#} one {#}})
	*/ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
	* (e.g. {foo, select, apple {apple} apple {apple}})
	*/ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
    return ErrorKind;
}({});




// @generated from regex-gen.ts
const $ca163212bfd9b294$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
const $ca163212bfd9b294$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;



// @generated from time-data-gen.ts
// prettier-ignore
const $a25f148cad1bd5b6$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ku-SY": [
        "H",
        "hB"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};


function $38f694075452c506$export$29c5368be8904d27(skeleton, locale) {
    let skeletonCopy = "";
    for(let patternPos = 0; patternPos < skeleton.length; patternPos++){
        const patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            let extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            let hourLen = 1 + (extraLength & 1);
            let dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            let dayPeriodChar = "a";
            let hourChar = $38f694075452c506$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
* Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
* of the given `locale` to the corresponding time pattern.
* @param locale
*/ function $38f694075452c506$var$getDefaultHourSymbolFromLocale(locale) {
    let hourCycle = locale.hourCycle;
    if (hourCycle === undefined && locale.hourCycles && locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    const languageTag = locale.language;
    let regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    const hourCycles = (0, $a25f148cad1bd5b6$export$a8c9209db4084317)[regionTag || ""] || (0, $a25f148cad1bd5b6$export$a8c9209db4084317)[languageTag || ""] || (0, $a25f148cad1bd5b6$export$a8c9209db4084317)[`${languageTag}-001`] || (0, $a25f148cad1bd5b6$export$a8c9209db4084317)["001"];
    return hourCycles[0];
}


const $754141e0a837d8f4$var$SPACE_SEPARATOR_START_REGEX = new RegExp(`^${(0, $ca163212bfd9b294$export$523451f94304dd6c).source}*`);
const $754141e0a837d8f4$var$SPACE_SEPARATOR_END_REGEX = new RegExp(`${(0, $ca163212bfd9b294$export$523451f94304dd6c).source}*$`);
function $754141e0a837d8f4$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
const $754141e0a837d8f4$var$hasNativeFromEntries = !!Object.fromEntries;
const $754141e0a837d8f4$var$hasTrimStart = !!String.prototype.trimStart;
const $754141e0a837d8f4$var$hasTrimEnd = !!String.prototype.trimEnd;
const $754141e0a837d8f4$var$fromEntries = $754141e0a837d8f4$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    const obj = {};
    for (const [k, v] of entries)obj[k] = v;
    return obj;
};
const $754141e0a837d8f4$var$trimStart = $754141e0a837d8f4$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($754141e0a837d8f4$var$SPACE_SEPARATOR_START_REGEX, "");
};
const $754141e0a837d8f4$var$trimEnd = $754141e0a837d8f4$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($754141e0a837d8f4$var$SPACE_SEPARATOR_END_REGEX, "");
};
// #endregion
const $754141e0a837d8f4$var$IDENTIFIER_PREFIX_RE = new RegExp("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
function $754141e0a837d8f4$var$matchIdentifierAtIndex(s, index) {
    $754141e0a837d8f4$var$IDENTIFIER_PREFIX_RE.lastIndex = index;
    const match = $754141e0a837d8f4$var$IDENTIFIER_PREFIX_RE.exec(s);
    return match[1] ?? "";
}
class $754141e0a837d8f4$export$7acfa6ed01010e37 {
    message;
    position;
    locale;
    ignoreTag;
    requiresOtherClause;
    shouldParseSkeletons;
    constructor(message, options = {}){
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    parse() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    }
    parseMessage(nestingLevel, parentArgType, expectingCloseTag) {
        let elements = [];
        while(!this.isEOF()){
            const char = this.char();
            if (char === 123) {
                const result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 && nestingLevel > 0) break;
            else if (char === 35 && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                const position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).pound,
                    location: $754141e0a837d8f4$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 && !this.ignoreTag && this.peek() === 47) {
                if (expectingCloseTag) break;
                else return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $754141e0a837d8f4$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 && !this.ignoreTag && $754141e0a837d8f4$var$_isAlpha(this.peek() || 0)) {
                const result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                const result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    }
    /**
	* A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
	* [custom element name][] except that a dash is NOT always mandatory and uppercase letters
	* are accepted:
	*
	* ```
	* tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
	* tagName ::= [a-z] (PENChar)*
	* PENChar ::=
	*     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
	*     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
	*     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
	* ```
	*
	* [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
	* NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
	* since other tag-based engines like React allow it
	*/ parseTag(nestingLevel, parentArgType) {
        const startPosition = this.clonePosition();
        this.bump();
        const tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).literal,
                value: `<${tagName}/>`,
                location: $754141e0a837d8f4$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            const childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            const children = childrenResult.val;
            // Expecting a close tag
            const endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$754141e0a837d8f4$var$_isAlpha(this.char())) return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).INVALID_TAG, $754141e0a837d8f4$var$createLocation(endTagStartPosition, this.clonePosition()));
                const closingTagNameStartPosition = this.clonePosition();
                const closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $754141e0a837d8f4$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).INVALID_TAG, $754141e0a837d8f4$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $754141e0a837d8f4$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).UNCLOSED_TAG, $754141e0a837d8f4$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).INVALID_TAG, $754141e0a837d8f4$var$createLocation(startPosition, this.clonePosition()));
    }
    /**
	* This method assumes that the caller has peeked ahead for the first tag character.
	*/ parseTagName() {
        const startOffset = this.offset();
        this.bump();
        while(!this.isEOF() && $754141e0a837d8f4$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    }
    parseLiteral(nestingLevel, parentArgType) {
        const start = this.clonePosition();
        let value = "";
        while(true){
            const parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            const parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            const parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        const location = $754141e0a837d8f4$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    }
    tryParseLeftAngleBracket() {
        if (!this.isEOF() && this.char() === 60 && (this.ignoreTag || !$754141e0a837d8f4$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump();
            return "<";
        }
        return null;
    }
    /**
	* Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
	* a character that requires quoting (that is, "only where needed"), and works the same in
	* nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
	*/ tryParseQuote(parentArgType) {
        if (this.isEOF() || this.char() !== 39) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump();
        const codePoints = [
            this.char()
        ];
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            const ch = this.char();
            if (ch === 39) {
                if (this.peek() === 39) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return String.fromCodePoint(...codePoints);
    }
    tryParseUnquoted(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        const ch = this.char();
        if (ch === 60 || ch === 123 || ch === 35 && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 && nestingLevel > 0) return null;
        else {
            this.bump();
            return String.fromCodePoint(ch);
        }
    }
    parseArgument(nestingLevel, expectingCloseTag) {
        const openingBracePosition = this.clonePosition();
        this.bump();
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $754141e0a837d8f4$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125) {
            this.bump();
            return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).EMPTY_ARGUMENT, $754141e0a837d8f4$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        let value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).MALFORMED_ARGUMENT, $754141e0a837d8f4$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $754141e0a837d8f4$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            case 125:
                this.bump();
                return {
                    val: {
                        type: (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).argument,
                        value: value,
                        location: $754141e0a837d8f4$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            case 44:
                this.bump();
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $754141e0a837d8f4$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).MALFORMED_ARGUMENT, $754141e0a837d8f4$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    }
    /**
	* Advance the parser until the end of the identifier, if it is currently on
	* an identifier character. Return an empty string otherwise.
	*/ parseIdentifierIfPossible() {
        const startingPosition = this.clonePosition();
        const startOffset = this.offset();
        const value = $754141e0a837d8f4$var$matchIdentifierAtIndex(this.message, startOffset);
        const endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        const endPosition = this.clonePosition();
        const location = $754141e0a837d8f4$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    }
    parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        // Parse this range:
        // {name, type, style}
        //        ^---^
        let typeStartPosition = this.clonePosition();
        let argType = this.parseIdentifierIfPossible().value;
        let typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $754141e0a837d8f4$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                {
                    // Parse this range:
                    // {name, number, style}
                    //              ^-------^
                    this.bumpSpace();
                    let styleAndLocation = null;
                    if (this.bumpIf(",")) {
                        this.bumpSpace();
                        const styleStartPosition = this.clonePosition();
                        const result = this.parseSimpleArgStyleIfPossible();
                        if (result.err) return result;
                        const style = $754141e0a837d8f4$var$trimEnd(result.val);
                        if (style.length === 0) return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $754141e0a837d8f4$var$createLocation(this.clonePosition(), this.clonePosition()));
                        const styleLocation = $754141e0a837d8f4$var$createLocation(styleStartPosition, this.clonePosition());
                        styleAndLocation = {
                            style: style,
                            styleLocation: styleLocation
                        };
                    }
                    const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                    if (argCloseResult.err) return argCloseResult;
                    const location = $754141e0a837d8f4$var$createLocation(openingBracePosition, this.clonePosition());
                    // Extract style or skeleton
                    if (styleAndLocation && styleAndLocation.style.startsWith("::")) {
                        // Skeleton starts with `::`.
                        let skeleton = $754141e0a837d8f4$var$trimStart(styleAndLocation.style.slice(2));
                        if (argType === "number") {
                            const result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                            if (result.err) return result;
                            return {
                                val: {
                                    type: (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).number,
                                    value: value,
                                    location: location,
                                    style: result.val
                                },
                                err: null
                            };
                        } else {
                            if (skeleton.length === 0) return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location);
                            let dateTimePattern = skeleton;
                            // Get "best match" pattern only if locale is passed, if not, let it
                            // pass as-is where `parseDateTimeSkeleton()` will throw an error
                            // for unsupported patterns.
                            if (this.locale) dateTimePattern = (0, $38f694075452c506$export$29c5368be8904d27)(skeleton, this.locale);
                            const style = {
                                type: (0, $4c42ef5197e1caf7$export$906452485466fa53).dateTime,
                                pattern: dateTimePattern,
                                location: styleAndLocation.styleLocation,
                                parsedOptions: this.shouldParseSkeletons ? (0, $96a4c0877753a8ad$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                            };
                            const type = argType === "date" ? (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).date : (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).time;
                            return {
                                val: {
                                    type: type,
                                    value: value,
                                    location: location,
                                    style: style
                                },
                                err: null
                            };
                        }
                    }
                    // Regular style or no style.
                    return {
                        val: {
                            type: argType === "number" ? (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).number : argType === "date" ? (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).date : (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).time,
                            value: value,
                            location: location,
                            style: styleAndLocation?.style ?? null
                        },
                        err: null
                    };
                }
            case "plural":
            case "selectordinal":
            case "select":
                {
                    // Parse this range:
                    // {name, plural, options}
                    //              ^---------^
                    const typeEndPosition = this.clonePosition();
                    this.bumpSpace();
                    if (!this.bumpIf(",")) return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $754141e0a837d8f4$var$createLocation(typeEndPosition, {
                        ...typeEndPosition
                    }));
                    this.bumpSpace();
                    // Parse offset:
                    // {name, plural, offset:1, options}
                    //                ^-----^
                    //
                    // or the first option:
                    //
                    // {name, plural, one {...} other {...}}
                    //                ^--^
                    let identifierAndLocation = this.parseIdentifierIfPossible();
                    let pluralOffset = 0;
                    if (argType !== "select" && identifierAndLocation.value === "offset") {
                        if (!this.bumpIf(":")) return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $754141e0a837d8f4$var$createLocation(this.clonePosition(), this.clonePosition()));
                        this.bumpSpace();
                        const result = this.tryParseDecimalInteger((0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $05294526b7a1a012$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                        if (result.err) return result;
                        // Parse another identifier for option parsing
                        this.bumpSpace();
                        identifierAndLocation = this.parseIdentifierIfPossible();
                        pluralOffset = result.val;
                    }
                    const optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                    if (optionsResult.err) return optionsResult;
                    const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                    if (argCloseResult.err) return argCloseResult;
                    const location = $754141e0a837d8f4$var$createLocation(openingBracePosition, this.clonePosition());
                    if (argType === "select") return {
                        val: {
                            type: (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).select,
                            value: value,
                            options: $754141e0a837d8f4$var$fromEntries(optionsResult.val),
                            location: location
                        },
                        err: null
                    };
                    else return {
                        val: {
                            type: (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).plural,
                            value: value,
                            options: $754141e0a837d8f4$var$fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === "plural" ? "cardinal" : "ordinal",
                            location: location
                        },
                        err: null
                    };
                }
            default:
                return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $754141e0a837d8f4$var$createLocation(typeStartPosition, typeEndPosition));
        }
    }
    tryParseArgumentClose(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125) return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $754141e0a837d8f4$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump();
        return {
            val: true,
            err: null
        };
    }
    /**
	* See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
	*/ parseSimpleArgStyleIfPossible() {
        let nestedBraces = 0;
        const startPosition = this.clonePosition();
        while(!this.isEOF()){
            const ch = this.char();
            switch(ch){
                case 39:
                    {
                        // Treat apostrophe as quoting but include it in the style part.
                        // Find the end of the quoted literal text.
                        this.bump();
                        let apostrophePosition = this.clonePosition();
                        if (!this.bumpUntil("'")) return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $754141e0a837d8f4$var$createLocation(apostrophePosition, this.clonePosition()));
                        this.bump();
                        break;
                    }
                case 123:
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125:
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    }
    parseNumberSkeletonFromString(skeleton, location) {
        let tokens = [];
        try {
            tokens = (0, $19c5978fa60a1a6d$export$71cee2f16fba2480)(skeleton);
        } catch  {
            return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $4c42ef5197e1caf7$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $19c5978fa60a1a6d$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    }
    /**
	* @param nesting_level The current nesting level of messages.
	*     This can be positive when parsing message fragment in select or plural argument options.
	* @param parent_arg_type The parent argument's type.
	* @param parsed_first_identifier If provided, this is the first identifier-like selector of
	*     the argument. It is a by-product of a previous parsing attempt.
	* @param expecting_close_tag If true, this message is directly or indirectly nested inside
	*     between a pair of opening and closing tags. The nested message will not parse beyond
	*     the closing tag boundary.
	*/ tryParsePluralOrSelectOptions(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        let hasOtherClause = false;
        const options = [];
        const parsedSelectors = new Set();
        let { value: selector, location: selectorLocation } = parsedFirstIdentifier;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                const startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    const result = this.tryParseDecimalInteger((0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $05294526b7a1a012$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $754141e0a837d8f4$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $05294526b7a1a012$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $05294526b7a1a012$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            const openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $754141e0a837d8f4$var$createLocation(this.clonePosition(), this.clonePosition()));
            const fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $754141e0a837d8f4$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            ({ value: selector, location: selectorLocation } = this.parseIdentifierIfPossible());
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $05294526b7a1a012$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $754141e0a837d8f4$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $05294526b7a1a012$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $754141e0a837d8f4$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    }
    tryParseDecimalInteger(expectNumberError, invalidNumberError) {
        let sign = 1;
        const startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        let hasDigits = false;
        let decimal = 0;
        while(!this.isEOF()){
            const ch = this.char();
            if (ch >= 48 && ch <= 57) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        const location = $754141e0a837d8f4$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!Number.isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    }
    offset() {
        return this.position.offset;
    }
    isEOF() {
        return this.offset() === this.message.length;
    }
    clonePosition() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    }
    /**
	* Return the code point at the current position of the parser.
	* Throws if the index is out of bound.
	*/ char() {
        const offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        const code = this.message.codePointAt(offset);
        if (code === undefined) throw Error(`Offset ${offset} is at invalid UTF-16 code unit boundary`);
        return code;
    }
    error(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    }
    /** Bump the parser to the next UTF-16 code unit. */ bump() {
        if (this.isEOF()) return;
        const code = this.char();
        if (code === 10) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 65536 ? 1 : 2;
        }
    }
    /**
	* If the substring starting at the current position of the parser has
	* the given prefix, then bump the parser to the character immediately
	* following the prefix and return true. Otherwise, don't bump the parser
	* and return false.
	*/ bumpIf(prefix) {
        if (this.message.startsWith(prefix, this.offset())) {
            for(let i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    }
    /**
	* Bump the parser until the pattern character is found and return `true`.
	* Otherwise bump to the end of the file and return `false`.
	*/ bumpUntil(pattern) {
        const currentOffset = this.offset();
        const index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    }
    /**
	* Bump the parser to the target offset.
	* If target offset is beyond the end of the input, bump the parser to the end of the input.
	*/ bumpTo(targetOffset) {
        if (this.offset() > targetOffset) throw Error(`targetOffset ${targetOffset} must be greater than or equal to the current offset ${this.offset()}`);
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            const offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error(`targetOffset ${targetOffset} is at invalid UTF-16 code unit boundary`);
            this.bump();
            if (this.isEOF()) break;
        }
    }
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ bumpSpace() {
        while(!this.isEOF() && $754141e0a837d8f4$var$_isWhiteSpace(this.char()))this.bump();
    }
    /**
	* Peek at the *next* Unicode codepoint in the input without advancing the parser.
	* If the input has been exhausted, then this returns null.
	*/ peek() {
        if (this.isEOF()) return null;
        const code = this.char();
        const offset = this.offset();
        const nextCode = this.message.charCodeAt(offset + (code >= 65536 ? 2 : 1));
        return nextCode ?? null;
    }
}
/**
* This check if codepoint is alphabet (lower & uppercase)
* @param codepoint
* @returns
*/ function $754141e0a837d8f4$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $754141e0a837d8f4$var$_isAlphaOrSlash(codepoint) {
    return $754141e0a837d8f4$var$_isAlpha(codepoint) || codepoint === 47;
}
/** See `parseTag` function docs. */ function $754141e0a837d8f4$var$_isPotentialElementNameChar(c) {
    return c === 45 || c === 46 || c >= 48 && c <= 57 || c === 95 || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 183 || c >= 192 && c <= 214 || c >= 216 && c <= 246 || c >= 248 && c <= 893 || c >= 895 && c <= 8191 || c >= 8204 && c <= 8205 || c >= 8255 && c <= 8256 || c >= 8304 && c <= 8591 || c >= 11264 && c <= 12271 || c >= 12289 && c <= 55295 || c >= 63744 && c <= 64975 || c >= 65008 && c <= 65533 || c >= 65536 && c <= 983039;
}
/**
* Code point equivalent of regex `\p{White_Space}`.
* From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
*/ function $754141e0a837d8f4$var$_isWhiteSpace(c) {
    return c >= 9 && c <= 13 || c === 32 || c === 133 || c >= 8206 && c <= 8207 || c === 8232 || c === 8233;
}




function $aa499b3a9d04c458$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return obj.map($aa499b3a9d04c458$var$cloneDeep);
    if (obj !== null && typeof obj === "object") // @ts-expect-error meh
    return Object.keys(obj).reduce((cloned, k)=>{
        // @ts-expect-error meh
        cloned[k] = $aa499b3a9d04c458$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
/**
* Replace pound elements with number elements referencing the given variable.
* This is needed when nesting plurals - the # in the outer plural should become
* an explicit variable reference when nested inside another plural.
* GH #4202
*/ function $aa499b3a9d04c458$var$replacePoundWithArgument(ast, variableName) {
    return ast.map((el)=>{
        if ((0, $4c42ef5197e1caf7$export$c0ece297bdd0c082)(el)) // Replace # with {variableName, number}
        return {
            type: (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).number,
            value: variableName,
            style: null,
            location: el.location
        };
        if ((0, $4c42ef5197e1caf7$export$6c796d116f0a4fbc)(el) || (0, $4c42ef5197e1caf7$export$dcfe1c11d168b5a1)(el)) {
            // Recursively process options
            const newOptions = {};
            for (const key of Object.keys(el.options))newOptions[key] = {
                value: $aa499b3a9d04c458$var$replacePoundWithArgument(el.options[key].value, variableName)
            };
            return {
                ...el,
                options: newOptions
            };
        }
        if ((0, $4c42ef5197e1caf7$export$5c83de34745812b)(el)) return {
            ...el,
            children: $aa499b3a9d04c458$var$replacePoundWithArgument(el.children, variableName)
        };
        return el;
    });
}
function $aa499b3a9d04c458$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    const cloned = $aa499b3a9d04c458$var$cloneDeep(el);
    const { options: options } = cloned;
    // GH #4202: Check if there are other plural/select elements after this one
    const afterElements = ast.slice(positionToInject + 1);
    const hasSubsequentPluralOrSelect = afterElements.some($aa499b3a9d04c458$var$isPluralOrSelectElement);
    cloned.options = Object.keys(options).reduce((all, k)=>{
        let optionValue = options[k].value;
        // GH #4202: If there are subsequent plurals/selects and this is a plural,
        // replace # with explicit variable reference to avoid ambiguity
        if (hasSubsequentPluralOrSelect && (0, $4c42ef5197e1caf7$export$6c796d116f0a4fbc)(el)) optionValue = $aa499b3a9d04c458$var$replacePoundWithArgument(optionValue, el.value);
        const newValue = $aa499b3a9d04c458$export$be5687ba8bbdf416([
            ...ast.slice(0, positionToInject),
            ...optionValue,
            ...afterElements
        ]);
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $aa499b3a9d04c458$var$isPluralOrSelectElement(el) {
    return (0, $4c42ef5197e1caf7$export$6c796d116f0a4fbc)(el) || (0, $4c42ef5197e1caf7$export$dcfe1c11d168b5a1)(el);
}
function $aa499b3a9d04c458$var$findPluralOrSelectElement(ast) {
    return !!ast.find((el)=>{
        if ($aa499b3a9d04c458$var$isPluralOrSelectElement(el)) return true;
        if ((0, $4c42ef5197e1caf7$export$5c83de34745812b)(el)) return $aa499b3a9d04c458$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $aa499b3a9d04c458$export$be5687ba8bbdf416(ast) {
    for(let i = 0; i < ast.length; i++){
        const el = ast[i];
        if ($aa499b3a9d04c458$var$isPluralOrSelectElement(el)) return [
            $aa499b3a9d04c458$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $4c42ef5197e1caf7$export$5c83de34745812b)(el) && $aa499b3a9d04c458$var$findPluralOrSelectElement([
            el
        ])) throw new Error("Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option");
    }
    return ast;
}
/**
* Collect all variables in an AST to Record<string, TYPE>
* @param ast AST to collect variables from
* @param vars Record of variable name to variable type
*/ function $aa499b3a9d04c458$var$collectVariables(ast, vars = new Map()) {
    ast.forEach((el)=>{
        if ((0, $4c42ef5197e1caf7$export$4f55724281bdfaf9)(el) || (0, $4c42ef5197e1caf7$export$32d811605da75f40)(el) || (0, $4c42ef5197e1caf7$export$34ec46f596b1702f)(el) || (0, $4c42ef5197e1caf7$export$e11187b219e191e1)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error(`Variable ${el.value} has conflicting types`);
            vars.set(el.value, el.type);
        }
        if ((0, $4c42ef5197e1caf7$export$6c796d116f0a4fbc)(el) || (0, $4c42ef5197e1caf7$export$dcfe1c11d168b5a1)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach((k)=>{
                $aa499b3a9d04c458$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $4c42ef5197e1caf7$export$5c83de34745812b)(el)) {
            vars.set(el.value, el.type);
            $aa499b3a9d04c458$var$collectVariables(el.children, vars);
        }
    });
}
function $aa499b3a9d04c458$export$1edd9c892fdd9d27(a, b) {
    const aVars = new Map();
    const bVars = new Map();
    $aa499b3a9d04c458$var$collectVariables(a, aVars);
    $aa499b3a9d04c458$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error(`Different number of variables: [${Array.from(aVars.keys()).join(", ")}] vs [${Array.from(bVars.keys()).join(", ")}]`)
    };
    return Array.from(aVars.entries()).reduce((result, [key, type])=>{
        if (!result.success) return result;
        const bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error(`Missing variable ${key} in message`)
        };
        if (bType !== type) return {
            success: false,
            error: new Error(`Variable ${key} has conflicting types: ${(0, $4c42ef5197e1caf7$export$b87f371cbc396fcf)[type]} vs ${(0, $4c42ef5197e1caf7$export$b87f371cbc396fcf)[bType]}`)
        };
        return result;
    }, {
        success: true
    });
}


function $78a8e2e8fe5f5403$var$pruneLocation(els) {
    els.forEach((el)=>{
        delete el.location;
        if ((0, $4c42ef5197e1caf7$export$dcfe1c11d168b5a1)(el) || (0, $4c42ef5197e1caf7$export$6c796d116f0a4fbc)(el)) for(const k in el.options){
            delete el.options[k].location;
            $78a8e2e8fe5f5403$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $4c42ef5197e1caf7$export$e11187b219e191e1)(el) && (0, $4c42ef5197e1caf7$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $4c42ef5197e1caf7$export$32d811605da75f40)(el) || (0, $4c42ef5197e1caf7$export$34ec46f596b1702f)(el)) && (0, $4c42ef5197e1caf7$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $4c42ef5197e1caf7$export$5c83de34745812b)(el)) $78a8e2e8fe5f5403$var$pruneLocation(el.children);
    });
}
function $78a8e2e8fe5f5403$export$98e6a39c04603d36(message, opts = {}) {
    opts = {
        shouldParseSkeletons: true,
        requiresOtherClause: true,
        ...opts
    };
    const result = new (0, $754141e0a837d8f4$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        const error = SyntaxError((0, $05294526b7a1a012$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!opts?.captureLocation) $78a8e2e8fe5f5403$var$pruneLocation(result.val);
    return result.val;
}
const $78a8e2e8fe5f5403$export$d3c1bfa0f7d806e9 = (0, $754141e0a837d8f4$export$7acfa6ed01010e37);




let $e59bdda6a16f4fa3$export$d4e71bc0b80dc0fb = /* @__PURE__ */ function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
    return ErrorCode;
}({});
class $e59bdda6a16f4fa3$export$7369836851cc1329 extends Error {
    code;
    /**
	* Original message we're trying to format
	* `undefined` if we're only dealing w/ AST
	*
	* @type {(string | undefined)}
	* @memberof FormatError
	*/ originalMessage;
    constructor(msg, code, originalMessage){
        super(msg);
        this.code = code;
        this.originalMessage = originalMessage;
    }
    toString() {
        return `[formatjs Error: ${this.code}] ${this.message}`;
    }
}
class $e59bdda6a16f4fa3$export$565c3afc07dfa382 extends $e59bdda6a16f4fa3$export$7369836851cc1329 {
    constructor(variableId, value, options, originalMessage){
        super(`Invalid values for "${variableId}": "${value}". Options are "${Object.keys(options).join("\", \"")}"`, $e59bdda6a16f4fa3$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage);
    }
}
class $e59bdda6a16f4fa3$export$cbc0db47c750f7c9 extends $e59bdda6a16f4fa3$export$7369836851cc1329 {
    constructor(value, type, originalMessage){
        super(`Value for "${value}" must be of type ${type}`, $e59bdda6a16f4fa3$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage);
    }
}
class $e59bdda6a16f4fa3$export$8bfc137e4d23fdf0 extends $e59bdda6a16f4fa3$export$7369836851cc1329 {
    constructor(variableId, originalMessage){
        super(`The intl string context variable "${variableId}" was not provided to the string "${originalMessage}"`, $e59bdda6a16f4fa3$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage);
    }
}


let $370978406261062d$export$49694c2877b44c57 = /* @__PURE__ */ function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
    return PART_TYPE;
}({});
function $370978406261062d$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce((all, part)=>{
        const lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $370978406261062d$export$49694c2877b44c57.literal || part.type !== $370978406261062d$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $370978406261062d$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $370978406261062d$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $4c42ef5197e1caf7$export$cfa10c5697238752)(els[0])) return [
        {
            type: $370978406261062d$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    const result = [];
    for (const el of els){
        // Exit early for string parts.
        if ((0, $4c42ef5197e1caf7$export$cfa10c5697238752)(el)) {
            result.push({
                type: $370978406261062d$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $4c42ef5197e1caf7$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $370978406261062d$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        const { value: varName } = el;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $e59bdda6a16f4fa3$export$8bfc137e4d23fdf0)(varName, originalMessage);
        let value = values[varName];
        if ((0, $4c42ef5197e1caf7$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === "string" || typeof value === "number" || typeof value === "bigint") value = typeof value === "string" || typeof value === "number" || typeof value === "bigint" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $370978406261062d$export$49694c2877b44c57.literal : $370978406261062d$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $4c42ef5197e1caf7$export$32d811605da75f40)(el)) {
            const style = typeof el.style === "string" ? formats.date[el.style] : (0, $4c42ef5197e1caf7$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $370978406261062d$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4c42ef5197e1caf7$export$34ec46f596b1702f)(el)) {
            const style = typeof el.style === "string" ? formats.time[el.style] : (0, $4c42ef5197e1caf7$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $370978406261062d$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4c42ef5197e1caf7$export$e11187b219e191e1)(el)) {
            const style = typeof el.style === "string" ? formats.number[el.style] : (0, $4c42ef5197e1caf7$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) {
                const scale = style.scale || 1;
                // Handle bigint scale multiplication
                // BigInt can only be multiplied by BigInt
                if (typeof value === "bigint") {
                    // Check if scale is a safe integer that can be converted to BigInt
                    if (!Number.isInteger(scale)) throw new TypeError(`Cannot apply fractional scale ${scale} to bigint value. Scale must be an integer when formatting bigint.`);
                    value = value * BigInt(scale);
                } else value = value * scale;
            }
            result.push({
                type: $370978406261062d$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4c42ef5197e1caf7$export$5c83de34745812b)(el)) {
            const { children: children, value: value } = el;
            const formatFn = values[value];
            if (!$370978406261062d$export$df0c12a2d414a163(formatFn)) throw new (0, $e59bdda6a16f4fa3$export$cbc0db47c750f7c9)(value, "function", originalMessage);
            const parts = $370978406261062d$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            let chunks = formatFn(parts.map((p)=>p.value));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push(...chunks.map((c)=>{
                return {
                    type: typeof c === "string" ? $370978406261062d$export$49694c2877b44c57.literal : $370978406261062d$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $4c42ef5197e1caf7$export$dcfe1c11d168b5a1)(el)) {
            // GH #4490: Use hasOwnProperty to avoid prototype chain issues with keys like "constructor"
            const key = value;
            const opt = (Object.prototype.hasOwnProperty.call(el.options, key) ? el.options[key] : undefined) || el.options.other;
            if (!opt) throw new (0, $e59bdda6a16f4fa3$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push(...$370978406261062d$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $4c42ef5197e1caf7$export$6c796d116f0a4fbc)(el)) {
            // GH #4490: Use hasOwnProperty to avoid prototype chain issues
            const exactKey = `=${value}`;
            let opt = Object.prototype.hasOwnProperty.call(el.options, exactKey) ? el.options[exactKey] : undefined;
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $e59bdda6a16f4fa3$export$7369836851cc1329)(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, (0, $e59bdda6a16f4fa3$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                // Convert bigint to number for PluralRules (which only accepts number)
                const numericValue = typeof value === "bigint" ? Number(value) : value;
                const rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(numericValue - (el.offset || 0));
                opt = (Object.prototype.hasOwnProperty.call(el.options, rule) ? el.options[rule] : undefined) || el.options.other;
            }
            if (!opt) throw new (0, $e59bdda6a16f4fa3$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            // Convert bigint to number for currentPluralValue
            const numericValue = typeof value === "bigint" ? Number(value) : value;
            result.push(...$370978406261062d$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, numericValue - (el.offset || 0)));
            continue;
        }
    }
    return $370978406261062d$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $33e616693c036183$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return {
        ...c1,
        ...c2,
        ...Object.keys(c1).reduce((all, k)=>{
            all[k] = {
                ...c1[k],
                ...c2[k]
            };
            return all;
        }, {})
    };
}
function $33e616693c036183$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce((all, k)=>{
        all[k] = $33e616693c036183$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, {
        ...defaultConfig
    });
}
function $33e616693c036183$var$createFastMemoizeCache(store) {
    return {
        create () {
            return {
                get (key) {
                    return store[key];
                },
                set (key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $33e616693c036183$var$createDefaultFormatters(cache = {
    number: {},
    dateTime: {},
    pluralRules: {}
}) {
    return {
        getNumberFormat: (0, $01df43c5309c7d2d$export$fc10aeed3a532e2a)((...args)=>new Intl.NumberFormat(...args), {
            cache: $33e616693c036183$var$createFastMemoizeCache(cache.number),
            strategy: (0, $01df43c5309c7d2d$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $01df43c5309c7d2d$export$fc10aeed3a532e2a)((...args)=>new Intl.DateTimeFormat(...args), {
            cache: $33e616693c036183$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $01df43c5309c7d2d$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $01df43c5309c7d2d$export$fc10aeed3a532e2a)((...args)=>new Intl.PluralRules(...args), {
            cache: $33e616693c036183$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $01df43c5309c7d2d$export$c5491a8691a23b9e).variadic
        })
    };
}
class $33e616693c036183$export$d342343268debc40 {
    ast;
    locales;
    resolvedLocale;
    formatters;
    formats;
    message;
    formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    constructor(message, locales = $33e616693c036183$export$d342343268debc40.defaultLocale, overrideFormats, opts){
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = $33e616693c036183$export$d342343268debc40.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!$33e616693c036183$export$d342343268debc40.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            const { ...parseOpts } = opts || {};
            // Parse string messages into an AST.
            this.ast = $33e616693c036183$export$d342343268debc40.__parse(message, {
                ...parseOpts,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $33e616693c036183$var$mergeConfigs($33e616693c036183$export$d342343268debc40.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $33e616693c036183$var$createDefaultFormatters(this.formatterCache);
    }
    format = (values)=>{
        const parts = this.formatToParts(values);
        // Hot path for straight simple msg translations
        if (parts.length === 1) return parts[0].value;
        const result = parts.reduce((all, part)=>{
            if (!all.length || part.type !== (0, $370978406261062d$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
            else all[all.length - 1] += part.value;
            return all;
        }, []);
        if (result.length <= 1) return result[0] || "";
        return result;
    };
    formatToParts = (values)=>(0, $370978406261062d$export$275d4a3bb5f66fda)(this.ast, this.locales, this.formatters, this.formats, values, undefined, this.message);
    resolvedOptions = ()=>({
            locale: this.resolvedLocale?.toString() || Intl.NumberFormat.supportedLocalesOf(this.locales)[0]
        });
    getAst = ()=>this.ast;
    static memoizedDefaultLocale = null;
    static get defaultLocale() {
        if (!$33e616693c036183$export$d342343268debc40.memoizedDefaultLocale) $33e616693c036183$export$d342343268debc40.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
        return $33e616693c036183$export$d342343268debc40.memoizedDefaultLocale;
    }
    static resolveLocale = (locales)=>{
        if (typeof Intl.Locale === "undefined") return;
        const supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    static __parse = (0, $78a8e2e8fe5f5403$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    static formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
}




var $c6afd59246e3278c$export$2e2bcd8739ae039 = (0, $33e616693c036183$export$d342343268debc40);



let $ae1d6c463e36a6bc$export$557d6acb76e8a244 = /* @__PURE__ */ function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
    return IntlErrorCode;
}({});
class $ae1d6c463e36a6bc$export$c016d36112f6ddf8 extends Error {
    code;
    constructor(code, message, exception){
        const err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        super(`[@formatjs/intl Error ${code}] ${message}
${err ? `\n${err.message}\n${err.stack}` : ""}`);
        this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(this, $ae1d6c463e36a6bc$export$c016d36112f6ddf8);
    }
}
class $ae1d6c463e36a6bc$export$549f97e137a05c90 extends $ae1d6c463e36a6bc$export$c016d36112f6ddf8 {
    constructor(message, exception){
        super($ae1d6c463e36a6bc$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception);
    }
}
class $ae1d6c463e36a6bc$export$3ca04dd7fb305893 extends $ae1d6c463e36a6bc$export$c016d36112f6ddf8 {
    constructor(message, exception){
        super($ae1d6c463e36a6bc$export$557d6acb76e8a244.INVALID_CONFIG, message, exception);
    }
}
class $ae1d6c463e36a6bc$export$c1eaf877d81384b6 extends $ae1d6c463e36a6bc$export$c016d36112f6ddf8 {
    constructor(message, exception){
        super($ae1d6c463e36a6bc$export$557d6acb76e8a244.MISSING_DATA, message, exception);
    }
}
class $ae1d6c463e36a6bc$export$e3b7eee1dbc44895 extends $ae1d6c463e36a6bc$export$c016d36112f6ddf8 {
    descriptor;
    locale;
    constructor(message, locale, exception){
        super($ae1d6c463e36a6bc$export$557d6acb76e8a244.FORMAT_ERROR, `${message}
Locale: ${locale}
`, exception);
        this.locale = locale;
    }
}
class $ae1d6c463e36a6bc$export$74a601a3d3f31621 extends $ae1d6c463e36a6bc$export$e3b7eee1dbc44895 {
    descriptor;
    locale;
    constructor(message, locale, descriptor, exception){
        super(`${message}
MessageID: ${descriptor?.id}
Default Message: ${descriptor?.defaultMessage}
Description: ${descriptor?.description}
`, locale, exception);
        this.descriptor = descriptor;
        this.locale = locale;
    }
}
class $ae1d6c463e36a6bc$export$2ddcb436d0aa3688 extends $ae1d6c463e36a6bc$export$c016d36112f6ddf8 {
    descriptor;
    constructor(descriptor, locale){
        super($ae1d6c463e36a6bc$export$557d6acb76e8a244.MISSING_TRANSLATION, `Missing message: "${descriptor.id}" for locale "${locale}", using ${descriptor.defaultMessage ? `default message (${typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map((e)=>e.value ?? JSON.stringify(e)).join()})` : "id"} as fallback.`);
        this.descriptor = descriptor;
    }
}



function $1e6c0ef47c83542f$export$f5708dca728d7177(condition, message, Err = Error) {
    if (!condition) throw new Err(message);
}
function $1e6c0ef47c83542f$export$d697c39a2985a4c(props, allowlist, defaults = {}) {
    return allowlist.reduce((filtered, name)=>{
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
const $1e6c0ef47c83542f$var$defaultErrorHandler = (error)=>{};
const $1e6c0ef47c83542f$var$defaultWarnHandler = (warning)=>{};
const $1e6c0ef47c83542f$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $1e6c0ef47c83542f$var$defaultErrorHandler,
    onWarn: $1e6c0ef47c83542f$var$defaultWarnHandler
};
function $1e6c0ef47c83542f$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $1e6c0ef47c83542f$var$createFastMemoizeCache(store) {
    return {
        create () {
            return {
                get (key) {
                    return store[key];
                },
                set (key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $1e6c0ef47c83542f$export$c3f4cd5551df13fd(cache = $1e6c0ef47c83542f$export$51c4f4e973f2dc00()) {
    const RelativeTimeFormat = Intl.RelativeTimeFormat;
    const ListFormat = Intl.ListFormat;
    const DisplayNames = Intl.DisplayNames;
    const getDateTimeFormat = (0, $01df43c5309c7d2d$export$fc10aeed3a532e2a)((...args)=>new Intl.DateTimeFormat(...args), {
        cache: $1e6c0ef47c83542f$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $01df43c5309c7d2d$export$c5491a8691a23b9e).variadic
    });
    const getNumberFormat = (0, $01df43c5309c7d2d$export$fc10aeed3a532e2a)((...args)=>new Intl.NumberFormat(...args), {
        cache: $1e6c0ef47c83542f$var$createFastMemoizeCache(cache.number),
        strategy: (0, $01df43c5309c7d2d$export$c5491a8691a23b9e).variadic
    });
    const getPluralRules = (0, $01df43c5309c7d2d$export$fc10aeed3a532e2a)((...args)=>new Intl.PluralRules(...args), {
        cache: $1e6c0ef47c83542f$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $01df43c5309c7d2d$export$c5491a8691a23b9e).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $01df43c5309c7d2d$export$fc10aeed3a532e2a)((message, locales, overrideFormats, opts)=>new (0, $33e616693c036183$export$d342343268debc40)(message, locales, overrideFormats, {
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                },
                ...opts
            }), {
            cache: $1e6c0ef47c83542f$var$createFastMemoizeCache(cache.message),
            strategy: (0, $01df43c5309c7d2d$export$c5491a8691a23b9e).variadic
        }),
        getRelativeTimeFormat: (0, $01df43c5309c7d2d$export$fc10aeed3a532e2a)((...args)=>new RelativeTimeFormat(...args), {
            cache: $1e6c0ef47c83542f$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $01df43c5309c7d2d$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $01df43c5309c7d2d$export$fc10aeed3a532e2a)((...args)=>new ListFormat(...args), {
            cache: $1e6c0ef47c83542f$var$createFastMemoizeCache(cache.list),
            strategy: (0, $01df43c5309c7d2d$export$c5491a8691a23b9e).variadic
        }),
        getDisplayNames: (0, $01df43c5309c7d2d$export$fc10aeed3a532e2a)((...args)=>new DisplayNames(...args), {
            cache: $1e6c0ef47c83542f$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $01df43c5309c7d2d$export$c5491a8691a23b9e).variadic
        })
    };
}
function $1e6c0ef47c83542f$export$4ee1db8ce44a209b(formats, type, name, onError) {
    const formatType = formats && formats[type];
    let format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $ae1d6c463e36a6bc$export$549f97e137a05c90)(`No ${type} format named: ${name}`));
}



var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");



function $74d4eda268cdc720$export$f5708dca728d7177(condition, message, Err = Error) {
    if (!condition) throw new Err(message);
}
function $74d4eda268cdc720$export$45c4bbf6e55bba1f(intl) {
    $74d4eda268cdc720$export$f5708dca728d7177(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
const $74d4eda268cdc720$export$b52f8d6fc0d47415 = {
    ...(0, $1e6c0ef47c83542f$export$b52f8d6fc0d47415),
    textComponent: $6cds3.Fragment
};
const $74d4eda268cdc720$export$d2fd241e0b53c057 = (children)=>{
    const childrenArray = $6cds3.Children.toArray(children);
    return childrenArray.map((child, index)=>{
        // For React elements, wrap in a keyed Fragment
        // This creates a new element with a key rather than trying to add one after creation
        if ($6cds3.isValidElement(child)) return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($6cds3.Fragment, {
            children: child
        }, index);
        return child;
    });
};
function $74d4eda268cdc720$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($74d4eda268cdc720$export$d2fd241e0b53c057(parts));
    };
}
function $74d4eda268cdc720$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}


/*
* Copyright 2015, Yahoo Inc.
* Copyrights licensed under the New BSD License.
* See the accompanying LICENSE file for terms.
*/ 



const $7946835abcb4881d$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    "numberingSystem",
    "fractionalSecondDigits"
];
function $7946835abcb4881d$export$a7f9565e3c81cd54({ locale: locale, formats: formats, onError: onError, timeZone: timeZone }, type, getDateTimeFormat, options = {}) {
    const { format: format } = options;
    const defaults = {
        ...timeZone && {
            timeZone: timeZone
        },
        ...format && (0, $1e6c0ef47c83542f$export$4ee1db8ce44a209b)(formats, type, format, onError)
    };
    let filteredOptions = (0, $1e6c0ef47c83542f$export$d697c39a2985a4c)(options, $7946835abcb4881d$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = {
        ...filteredOptions,
        hour: "numeric",
        minute: "numeric"
    };
    return getDateTimeFormat(locale, filteredOptions);
}
function $7946835abcb4881d$export$3ae94a2503e890a1(config, getDateTimeFormat, value, options = {}) {
    const date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $7946835abcb4881d$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $ae1d6c463e36a6bc$export$e3b7eee1dbc44895)("Error formatting date.", config.locale, e));
    }
    return String(date);
}
function $7946835abcb4881d$export$3203edd9e5edd663(config, getDateTimeFormat, value, options = {}) {
    const date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $7946835abcb4881d$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $ae1d6c463e36a6bc$export$e3b7eee1dbc44895)("Error formatting time.", config.locale, e));
    }
    return String(date);
}
function $7946835abcb4881d$export$a7fc3a91cb2ec376(config, getDateTimeFormat, from, to, options = {}) {
    const fromDate = typeof from === "string" ? new Date(from || 0) : from;
    const toDate = typeof to === "string" ? new Date(to || 0) : to;
    try {
        return $7946835abcb4881d$export$a7f9565e3c81cd54(config, "dateTimeRange", getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $ae1d6c463e36a6bc$export$e3b7eee1dbc44895)("Error formatting date time range.", config.locale, e));
    }
    return String(fromDate);
}
function $7946835abcb4881d$export$dc1f059bce486b1(config, getDateTimeFormat, value, options = {}) {
    const date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $7946835abcb4881d$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $ae1d6c463e36a6bc$export$e3b7eee1dbc44895)("Error formatting date.", config.locale, e));
    }
    return [];
}
function $7946835abcb4881d$export$af6e5d7a5c73edeb(config, getDateTimeFormat, value, options = {}) {
    const date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $7946835abcb4881d$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $ae1d6c463e36a6bc$export$e3b7eee1dbc44895)("Error formatting time.", config.locale, e));
    }
    return [];
}






const $86b1d538bd23ca25$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $86b1d538bd23ca25$export$62fe1a4d9e891fa2({ locale: locale, onError: onError }, getDisplayNames, value, options) {
    const DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $e59bdda6a16f4fa3$export$7369836851cc1329)(`Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`, (0, $e59bdda6a16f4fa3$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    const filteredOptions = (0, $1e6c0ef47c83542f$export$d697c39a2985a4c)(options, $86b1d538bd23ca25$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $ae1d6c463e36a6bc$export$e3b7eee1dbc44895)("Error formatting display name.", locale, e));
    }
}







const $dd91cf8f0ebb3f64$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
const $dd91cf8f0ebb3f64$var$now = Date.now();
function $dd91cf8f0ebb3f64$var$generateToken(i) {
    return `${$dd91cf8f0ebb3f64$var$now}_${i}_${$dd91cf8f0ebb3f64$var$now}`;
}
function $dd91cf8f0ebb3f64$export$e8b8be48b45905bb(opts, getListFormat, values, options = {}) {
    const results = $dd91cf8f0ebb3f64$export$6f284aad1934db69(opts, getListFormat, values, options).reduce((all, el)=>{
        const val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
function $dd91cf8f0ebb3f64$export$6f284aad1934db69({ locale: locale, onError: onError }, getListFormat, values, options = {}) {
    const ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $e59bdda6a16f4fa3$export$7369836851cc1329)(`Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`, (0, $e59bdda6a16f4fa3$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    const filteredOptions = (0, $1e6c0ef47c83542f$export$d697c39a2985a4c)(options, $dd91cf8f0ebb3f64$var$LIST_FORMAT_OPTIONS);
    try {
        const richValues = {};
        const serializedValues = Array.from(values).map((v, i)=>{
            if (typeof v === "object" && v !== null) {
                const id = $dd91cf8f0ebb3f64$var$generateToken(i);
                richValues[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map((part)=>part.type === "literal" ? part : {
                ...part,
                value: richValues[part.value] || part.value
            });
    } catch (e) {
        onError(new (0, $ae1d6c463e36a6bc$export$e3b7eee1dbc44895)("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}







function $3f731ed15e364562$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce((all, k)=>{
        all[k] = {
            timeZone: timeZone,
            ...opts[k]
        };
        return all;
    }, {});
}
function $3f731ed15e364562$var$deepMergeOptions(opts1, opts2) {
    const keys = Object.keys({
        ...opts1,
        ...opts2
    });
    return keys.reduce((all, k)=>{
        all[k] = {
            ...opts1[k],
            ...opts2[k]
        };
        return all;
    }, {});
}
function $3f731ed15e364562$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    const mfFormats = (0, $33e616693c036183$export$d342343268debc40).formats;
    return {
        ...mfFormats,
        ...f1,
        date: $3f731ed15e364562$var$deepMergeOptions($3f731ed15e364562$var$setTimeZoneInOptions(mfFormats.date, timeZone), $3f731ed15e364562$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $3f731ed15e364562$var$deepMergeOptions($3f731ed15e364562$var$setTimeZoneInOptions(mfFormats.time, timeZone), $3f731ed15e364562$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    };
}
const $3f731ed15e364562$export$25868d1e8e76735f = ({ locale: locale, formats: formats, messages: messages, defaultLocale: defaultLocale, defaultFormats: defaultFormats, fallbackOnEmptyString: fallbackOnEmptyString, onError: onError, timeZone: timeZone, defaultRichTextElements: defaultRichTextElements }, state, messageDescriptor = {
    id: ""
}, values, opts)=>{
    const { id: msgId, defaultMessage: defaultMessage } = messageDescriptor;
    // `id` is a required field of a Message Descriptor.
    (0, $1e6c0ef47c83542f$export$f5708dca728d7177)(!!msgId, `[@formatjs/intl] An \`id\` must be provided to format a message. You can either:
1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)
or [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR
2. Configure your \`eslint\` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)
to autofix this issue`);
    const id = String(msgId);
    const message = messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $4c42ef5197e1caf7$export$b87f371cbc396fcf).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, `{$1}`);
    values = {
        ...defaultRichTextElements,
        ...values
    };
    formats = $3f731ed15e364562$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $3f731ed15e364562$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $ae1d6c463e36a6bc$export$2ddcb436d0aa3688)(messageDescriptor, locale));
        if (defaultMessage) try {
            const formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $ae1d6c463e36a6bc$export$74a601a3d3f31621)(`Error formatting default message for: "${id}", rendering default message verbatim`, locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        const formatter = state.getMessageFormat(message, locale, formats, {
            formatters: state,
            ...opts
        });
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $ae1d6c463e36a6bc$export$74a601a3d3f31621)(`Error formatting message: "${id}", using ${defaultMessage ? "default message" : "id"} as fallback.`, locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        const formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $ae1d6c463e36a6bc$export$74a601a3d3f31621)(`Error formatting the default message for: "${id}", rendering message verbatim`, locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};






const $dcb1b8d7076cf657$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem",
    "trailingZeroDisplay",
    "roundingPriority",
    "roundingIncrement",
    "roundingMode"
];
function $dcb1b8d7076cf657$export$a7f9565e3c81cd54({ locale: locale, formats: formats, onError: onError }, getNumberFormat, options = {}) {
    const { format: format } = options;
    const defaults = format && (0, $1e6c0ef47c83542f$export$4ee1db8ce44a209b)(formats, "number", format, onError) || {};
    const filteredOptions = (0, $1e6c0ef47c83542f$export$d697c39a2985a4c)(options, $dcb1b8d7076cf657$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $dcb1b8d7076cf657$export$f5dd818bff069720(config, getNumberFormat, value, options = {}) {
    try {
        return $dcb1b8d7076cf657$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $ae1d6c463e36a6bc$export$e3b7eee1dbc44895)("Error formatting number.", config.locale, e));
    }
    return String(value);
}
function $dcb1b8d7076cf657$export$6871080848f10b2f(config, getNumberFormat, value, options = {}) {
    try {
        return $dcb1b8d7076cf657$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $ae1d6c463e36a6bc$export$e3b7eee1dbc44895)("Error formatting number.", config.locale, e));
    }
    return [];
}






const $f1d8364a54a17c3a$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $f1d8364a54a17c3a$export$bbbd05c900f3568d({ locale: locale, onError: onError }, getPluralRules, value, options = {}) {
    if (!Intl.PluralRules) onError(new (0, $e59bdda6a16f4fa3$export$7369836851cc1329)(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, (0, $e59bdda6a16f4fa3$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    const filteredOptions = (0, $1e6c0ef47c83542f$export$d697c39a2985a4c)(options, $f1d8364a54a17c3a$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $ae1d6c463e36a6bc$export$e3b7eee1dbc44895)("Error formatting plural.", locale, e));
    }
    return "other";
}






const $da79daba3cab36e7$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $da79daba3cab36e7$var$getFormatter({ locale: locale, formats: formats, onError: onError }, getRelativeTimeFormat, options = {}) {
    const { format: format } = options;
    const defaults = !!format && (0, $1e6c0ef47c83542f$export$4ee1db8ce44a209b)(formats, "relative", format, onError) || {};
    const filteredOptions = (0, $1e6c0ef47c83542f$export$d697c39a2985a4c)(options, $da79daba3cab36e7$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $da79daba3cab36e7$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options = {}) {
    if (!unit) unit = "second";
    const RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $e59bdda6a16f4fa3$export$7369836851cc1329)(`Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`, (0, $e59bdda6a16f4fa3$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    try {
        return $da79daba3cab36e7$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $ae1d6c463e36a6bc$export$e3b7eee1dbc44895)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}




function $8c9294a9b60acaa0$var$messagesContainString(messages) {
    const firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $8c9294a9b60acaa0$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $8c9294a9b60acaa0$var$messagesContainString(config.messages || {})) config.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.github.io/docs/getting-started/message-distribution`);
}
function $8c9294a9b60acaa0$export$7e4cbedfdd7b4c0d(config, cache) {
    const formatters = (0, $1e6c0ef47c83542f$export$c3f4cd5551df13fd)(cache);
    const resolvedConfig = {
        ...(0, $1e6c0ef47c83542f$export$b52f8d6fc0d47415),
        ...config
    };
    const { locale: locale, defaultLocale: defaultLocale, onError: onError } = resolvedConfig;
    if (!locale) {
        if (onError) onError(new (0, $ae1d6c463e36a6bc$export$3ca04dd7fb305893)(`"locale" was not configured, using "${defaultLocale}" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details`));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $ae1d6c463e36a6bc$export$c1eaf877d81384b6)(`Missing locale data for locale: "${locale}" in Intl.NumberFormat. Using default locale: "${defaultLocale}" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details`));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $ae1d6c463e36a6bc$export$c1eaf877d81384b6)(`Missing locale data for locale: "${locale}" in Intl.DateTimeFormat. Using default locale: "${defaultLocale}" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details`));
    $8c9294a9b60acaa0$var$verifyConfigMessages(resolvedConfig);
    return {
        ...resolvedConfig,
        formatters: formatters,
        formatNumber: (0, $dcb1b8d7076cf657$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $dcb1b8d7076cf657$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $da79daba3cab36e7$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $7946835abcb4881d$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $7946835abcb4881d$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $7946835abcb4881d$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $7946835abcb4881d$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $7946835abcb4881d$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $f1d8364a54a17c3a$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $3f731ed15e364562$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        $t: (0, $3f731ed15e364562$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $dd91cf8f0ebb3f64$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $dd91cf8f0ebb3f64$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $86b1d538bd23ca25$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    };
}



parcelRequire("6cds3");

function $2a303b0717742c26$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce((acc, k)=>{
        const v = values[k];
        acc[k] = (0, $370978406261062d$export$df0c12a2d414a163)(v) ? (0, $74d4eda268cdc720$export$cfec03d26465fa63)(v) : v;
        return acc;
    }, {});
}
const $2a303b0717742c26$var$formatMessage = (config, formatters, descriptor, rawValues, ...rest)=>{
    const values = $2a303b0717742c26$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    const chunks = (0, $3f731ed15e364562$export$25868d1e8e76735f)(config, formatters, descriptor, values, ...rest);
    if (Array.isArray(chunks)) return (0, $74d4eda268cdc720$export$d2fd241e0b53c057)(chunks);
    return chunks;
};
const $2a303b0717742c26$export$7e4cbedfdd7b4c0d = ({ defaultRichTextElements: rawDefaultRichTextElements, ...config }, cache)=>{
    const defaultRichTextElements = $2a303b0717742c26$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    const coreIntl = (0, $8c9294a9b60acaa0$export$7e4cbedfdd7b4c0d)({
        ...(0, $74d4eda268cdc720$export$b52f8d6fc0d47415),
        ...config,
        defaultRichTextElements: defaultRichTextElements
    }, cache);
    const resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return {
        ...coreIntl,
        formatMessage: $2a303b0717742c26$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $2a303b0717742c26$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    };
};


var $af10e3f63daf3025$exports = {};
'use strict';
var $426c7baebabc049b$exports = {};
'use strict';

$426c7baebabc049b$exports = (parcelRequire("hFtc0"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $af10e3f63daf3025$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $af10e3f63daf3025$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $af10e3f63daf3025$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $af10e3f63daf3025$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $af10e3f63daf3025$var$TYPE_STATICS = {};
$af10e3f63daf3025$var$TYPE_STATICS[$426c7baebabc049b$exports.ForwardRef] = $af10e3f63daf3025$var$FORWARD_REF_STATICS;
$af10e3f63daf3025$var$TYPE_STATICS[$426c7baebabc049b$exports.Memo] = $af10e3f63daf3025$var$MEMO_STATICS;
function $af10e3f63daf3025$var$getStatics(component) {
    // React v16.11 and below
    if ($426c7baebabc049b$exports.isMemo(component)) return $af10e3f63daf3025$var$MEMO_STATICS;
     // React v16.12 and above
    return $af10e3f63daf3025$var$TYPE_STATICS[component['$$typeof']] || $af10e3f63daf3025$var$REACT_STATICS;
}
var $af10e3f63daf3025$var$defineProperty = Object.defineProperty;
var $af10e3f63daf3025$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $af10e3f63daf3025$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $af10e3f63daf3025$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $af10e3f63daf3025$var$getPrototypeOf = Object.getPrototypeOf;
var $af10e3f63daf3025$var$objectPrototype = Object.prototype;
function $af10e3f63daf3025$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($af10e3f63daf3025$var$objectPrototype) {
            var inheritedComponent = $af10e3f63daf3025$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $af10e3f63daf3025$var$objectPrototype) $af10e3f63daf3025$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $af10e3f63daf3025$var$getOwnPropertyNames(sourceComponent);
        if ($af10e3f63daf3025$var$getOwnPropertySymbols) keys = keys.concat($af10e3f63daf3025$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $af10e3f63daf3025$var$getStatics(targetComponent);
        var sourceStatics = $af10e3f63daf3025$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$af10e3f63daf3025$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $af10e3f63daf3025$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $af10e3f63daf3025$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$af10e3f63daf3025$exports = $af10e3f63daf3025$var$hoistNonReactStatics;



var $6cds3 = parcelRequire("6cds3");



const $1db963aedeff66d1$var$hoistNonReactStatics = $af10e3f63daf3025$exports.default ?? $af10e3f63daf3025$exports;
function $1db963aedeff66d1$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
const $1db963aedeff66d1$var$IntlContext = typeof window !== "undefined" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $6cds3.createContext(null)) : $6cds3.createContext(null);
const { Consumer: $1db963aedeff66d1$var$IntlConsumer, Provider: $1db963aedeff66d1$var$IntlProvider } = $1db963aedeff66d1$var$IntlContext;
const $1db963aedeff66d1$export$2881499e37b75b9a = $1db963aedeff66d1$var$IntlProvider;
const $1db963aedeff66d1$export$841858b892ce1f4c = $1db963aedeff66d1$var$IntlContext;
function $1db963aedeff66d1$export$2e2bcd8739ae039(WrappedComponent, options) {
    const { intlPropName: intlPropName = "intl", forwardRef: forwardRef = false, enforceContext: enforceContext = true } = options || {};
    const WithIntl = (props)=>/* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($1db963aedeff66d1$var$IntlConsumer, {
            children: (intl)=>{
                if (enforceContext) (0, $74d4eda268cdc720$export$45c4bbf6e55bba1f)(intl);
                const intlProp = {
                    [intlPropName]: intl
                };
                return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)(WrappedComponent, {
                    ...props,
                    ...intlProp,
                    ref: forwardRef ? props.forwardedRef : null
                });
            }
        });
    WithIntl.displayName = `injectIntl(${$1db963aedeff66d1$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return $1db963aedeff66d1$var$hoistNonReactStatics(// @ts-expect-error
    $6cds3.forwardRef((props, ref)=>/* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return $1db963aedeff66d1$var$hoistNonReactStatics(WithIntl, WrappedComponent);
}



function $b4e7e62a26e603c5$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
class $b4e7e62a26e603c5$export$2e2bcd8739ae039 extends $6cds3.PureComponent {
    static displayName = "IntlProvider";
    static defaultProps = (0, $74d4eda268cdc720$export$b52f8d6fc0d47415);
    cache = (0, $1e6c0ef47c83542f$export$51c4f4e973f2dc00)();
    state = {
        cache: this.cache,
        intl: (0, $2a303b0717742c26$export$7e4cbedfdd7b4c0d)($b4e7e62a26e603c5$var$processIntlConfig(this.props), this.cache),
        prevConfig: $b4e7e62a26e603c5$var$processIntlConfig(this.props)
    };
    static getDerivedStateFromProps(props, { prevConfig: prevConfig, cache: cache }) {
        const config = $b4e7e62a26e603c5$var$processIntlConfig(props);
        if (!(0, $74d4eda268cdc720$export$d36bdfa510afb180)(prevConfig, config)) return {
            intl: (0, $2a303b0717742c26$export$7e4cbedfdd7b4c0d)(config, cache),
            prevConfig: config
        };
        return null;
    }
    render() {
        (0, $74d4eda268cdc720$export$45c4bbf6e55bba1f)(this.state.intl);
        return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1db963aedeff66d1$export$2881499e37b75b9a), {
            value: this.state.intl,
            children: this.props.children
        });
    }
}


var $56504c099eb325fa$exports = {};

$56504c099eb325fa$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "close.1c084d12.svg";


var $8aec2a1635e84539$exports = {};

$8aec2a1635e84539$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "camera.7b7eb65e.svg";


var $32c6b5c5fd7dd3bc$exports = {};

$32c6b5c5fd7dd3bc$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "tooltip_circle.0abc46b4.svg";


var $d0e19fe54eb9ab73$exports = {};

$d0e19fe54eb9ab73$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "light_bulb.1081abef.svg";


var $6087a03b6104c632$exports = {};

$6087a03b6104c632$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "close_bubble.fa55c8f8.svg";


var $765730d6ee6096c4$exports = {};

$765730d6ee6096c4$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "01_LOGO_G.174ab27e.png";


var $fcc10e6e149e4b66$exports = {};

$fcc10e6e149e4b66$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "logo.fd1b9030.svg";


var $5e1627d52efebdb4$exports = {};

$5e1627d52efebdb4$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "fpt-logo-white.9c45b675.png";


var $a998666394294908$exports = {};

$a998666394294908$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "box.89fb2978.svg";


var $64780a1ba7cf54ab$exports = {};

$64780a1ba7cf54ab$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "boxDark.a94f06ef.svg";


var $fa807e3bfdf87653$exports = {};

$fa807e3bfdf87653$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "shoe.65ca96a5.png";


var $9939214ecd607d1c$exports = {};

$9939214ecd607d1c$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "spinner.0ceda41f.svg";


var $253dad2553f260f4$exports = {};

$253dad2553f260f4$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "scale.9b1eac7a.svg";


var $c9f95a5c07aa8797$exports = {};

$c9f95a5c07aa8797$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "teaser1.6d626856.png";


var $cf98c7439fa914df$exports = {};

$cf98c7439fa914df$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "teaser2.7643ca25.png";


var $a6ae98a35927690a$exports = {};

$a6ae98a35927690a$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "teaser3.522bcb65.png";


var $cd6f60b98d7d2b10$exports = {};

$cd6f60b98d7d2b10$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "ellipse.b77d5946.svg";


var $4876d8c085c517be$exports = {};

$4876d8c085c517be$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "progress1.7773e258.svg";


var $c1229ae6da7b6df0$exports = {};

$c1229ae6da7b6df0$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "progress2.80dc5960.svg";


var $59e255e2cb6d9d87$exports = {};

$59e255e2cb6d9d87$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "progress3.28cf7383.svg";


var $733755caf922f05a$exports = {};

$733755caf922f05a$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "underline.f0ed439f.png";


var $c3380c4433599824$exports = {};

$c3380c4433599824$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "long_underline.10ebb010.png";


var $1ef94df9102d1850$exports = {};

$1ef94df9102d1850$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "female.4acafb18.svg";


var $1963b1b221e468ef$exports = {};

$1963b1b221e468ef$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "female1.7f48eeca.svg";


var $e16e6a77cc4ce9f4$exports = {};

$e16e6a77cc4ce9f4$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "female2.3d93e181.svg";


var $a1bc0f1933661582$exports = {};

$a1bc0f1933661582$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "female3.06273bf5.svg";


var $621f7441a241b0cd$exports = {};

$621f7441a241b0cd$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "female4.139458ef.svg";


var $b5ce911afea36431$exports = {};

$b5ce911afea36431$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "female5.8f9a60ed.svg";


var $8396ca71f4aeb953$exports = {};

$8396ca71f4aeb953$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "female6.630bb5bb.svg";


var $b2c41069a15856d5$exports = {};

$b2c41069a15856d5$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "female7.c74a53b9.svg";


var $6aa121580c1fe3d6$exports = {};

$6aa121580c1fe3d6$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "female8.44cf9ff1.svg";


var $511c39a8c51a3719$exports = {};

$511c39a8c51a3719$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "female9.13e05822.svg";


var $108a7c7e2edc4fb1$exports = {};

$108a7c7e2edc4fb1$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "female10.b0ec6ea2.svg";


var $a6b9471643ad6827$exports = {};

$a6b9471643ad6827$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "female11.188562d3.svg";


var $01ca55afe4b38357$exports = {};

$01ca55afe4b38357$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "female12.7118baa7.svg";


var $ba12f78d085523af$exports = {};

$ba12f78d085523af$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "male.e94ed173.svg";


var $34ba97556ab4cff7$exports = {};

$34ba97556ab4cff7$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "male1.b3362ea1.svg";


var $e7e0840cb09978c6$exports = {};

$e7e0840cb09978c6$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "male2.3eccede1.svg";


var $3998d9398998212b$exports = {};

$3998d9398998212b$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "male3.eb50e737.svg";


var $1d8bfeb3869fa414$exports = {};

$1d8bfeb3869fa414$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "male4.abd18d50.svg";


var $fb9616ea1945c132$exports = {};

$fb9616ea1945c132$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "male5.bf938049.svg";


var $236f28844b87a01e$exports = {};

$236f28844b87a01e$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "male6.ce07ef37.svg";


var $2ce94c7e6178e6a4$exports = {};

$2ce94c7e6178e6a4$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "male7.8f301d9e.svg";


var $fb168e124d630392$exports = {};

$fb168e124d630392$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "male8.de003ba3.svg";


var $7b9f226cf94d0b61$exports = {};

$7b9f226cf94d0b61$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "male9.1a2a9490.svg";


var $9038acf36883b87a$exports = {};

$9038acf36883b87a$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "male10.eba6d705.svg";


var $b8b3d61c5384941b$exports = {};

$b8b3d61c5384941b$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "male11.267a0ebe.svg";


var $c20fc0ef87a97b7f$exports = {};

$c20fc0ef87a97b7f$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "save-earth@3x.7557f776.png";


var $ab435e67066794d1$exports = {};

$ab435e67066794d1$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "loader_three_dots.7c598ce9.svg";


var $596ef25256dfd65d$exports = {};

$596ef25256dfd65d$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "Yuri@3x.50b38a9a.png";


var $f3cfa6da19d5b124$exports = {};

$f3cfa6da19d5b124$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "fpt_logo_simple.dfd9049d.png";


var $6262d308aca0b729$exports = {};

$6262d308aca0b729$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "fpt_logo_light_blue.568f9680.png";


var $c1a570739b12c055$exports = {};

$c1a570739b12c055$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "arrow_right.fbcf2231.png";


var $d4a3e7faf0a2a0e5$exports = {};

$d4a3e7faf0a2a0e5$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "arrow_box.3b50ec99.svg";


var $70b840b6eb1509ac$exports = {};

$70b840b6eb1509ac$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "loader_three_dots_black.f408a43c.svg";


var $c39eb49915b9b2a6$exports = {};

$c39eb49915b9b2a6$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "shoes_spritesheet.11779f0b.png";


var $2223b2963c323142$exports = {};

$2223b2963c323142$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "ring_spinner.1dcaeae3.png";


var $0ce7e163ac0b3f26$exports = {};

$0ce7e163ac0b3f26$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "co2Icon.209a90a6.svg";


var $47a68e2bb6c34781$exports = {};

$47a68e2bb6c34781$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "shareIcon.bd875a6b.svg";


var $a50e59d7355bb9aa$exports = {};

$a50e59d7355bb9aa$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "icon_footwear.c00dc534.png";


var $abf7f8925197206e$exports = {};

$abf7f8925197206e$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "arrow_custom_select.dee6d95b.svg";


var $94b3f5bacabe218d$exports = {};

$94b3f5bacabe218d$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "icon-measure-minipod.d373e5ee.svg";


var $3413f86bdd2d229f$exports = {};

$3413f86bdd2d229f$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "icon-measure-manual.c3fa48f8.svg";


var $5a8ebe80e4449512$exports = {};

$5a8ebe80e4449512$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "icon-measure-minipod-page.d8bac61d.svg";


var $8273def840206282$exports = {};

$8273def840206282$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "tube-spinner.ca636e80.svg";


var $600ae0e314012ef9$exports = {};

$600ae0e314012ef9$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "icon-measurement-archetype.37a263b8.svg";


var $dc1f71575f63ff8b$exports = {};

$dc1f71575f63ff8b$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "icon-archetype-high-selected.122f0bb6.svg";


var $d04b9de496336dfb$exports = {};

$d04b9de496336dfb$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "icon-measurement-camera.532351aa.svg";


var $0e62b8f5f409238e$exports = {};

$0e62b8f5f409238e$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "icon-partner.44595664.svg";


var $3a68c0047535a5ee$exports = {};

$3a68c0047535a5ee$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "logo-footprint-horizontal.cae6764b.svg";


var $10c4411a2e218bc4$exports = {};

$10c4411a2e218bc4$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "icon-language@3x.184b776b.png";


var $f8f4e7453dd732e1$exports = {};

$f8f4e7453dd732e1$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "icon-info@3x.d2b61fe2.png";


var $fe549a73eeaa3a4c$exports = {};

$fe549a73eeaa3a4c$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "caret.64ef683b.svg";


var $53f1a82b9fd0191f$exports = {};

$53f1a82b9fd0191f$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "icon-size.064f0a72.svg";


var $8a13619c4dbe1f8a$exports = {};

$8a13619c4dbe1f8a$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "checkbox-active.447bec1f.svg";


var $048fc34eed151acf$exports = {};

$048fc34eed151acf$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "fasttrack-mode.ed887b57.svg";


const $17bf087df6a33d6e$export$ec7dcaac71d9599d = {
    arrowIcon: (/*@__PURE__*/$parcel$interopDefault($abf7f8925197206e$exports)),
    box: (/*@__PURE__*/$parcel$interopDefault($a998666394294908$exports)),
    boxDark: (/*@__PURE__*/$parcel$interopDefault($64780a1ba7cf54ab$exports)),
    camera: (/*@__PURE__*/$parcel$interopDefault($8aec2a1635e84539$exports)),
    close: (/*@__PURE__*/$parcel$interopDefault($56504c099eb325fa$exports)),
    closeBubble: (/*@__PURE__*/$parcel$interopDefault($6087a03b6104c632$exports)),
    co2Icon: (/*@__PURE__*/$parcel$interopDefault($0ce7e163ac0b3f26$exports)),
    fptLogo: (/*@__PURE__*/$parcel$interopDefault($765730d6ee6096c4$exports)),
    fptLogoBlack: (/*@__PURE__*/$parcel$interopDefault($fcc10e6e149e4b66$exports)),
    fptLogoWhite: (/*@__PURE__*/$parcel$interopDefault($5e1627d52efebdb4$exports)),
    fptLogoSimple: (/*@__PURE__*/$parcel$interopDefault($f3cfa6da19d5b124$exports)),
    fptLogoLightBlue: (/*@__PURE__*/$parcel$interopDefault($6262d308aca0b729$exports)),
    fptLogoHorizontal: (/*@__PURE__*/$parcel$interopDefault($3a68c0047535a5ee$exports)),
    lightBulb: (/*@__PURE__*/$parcel$interopDefault($d0e19fe54eb9ab73$exports)),
    manualIcon: (/*@__PURE__*/$parcel$interopDefault($3413f86bdd2d229f$exports)),
    minipodIcon: (/*@__PURE__*/$parcel$interopDefault($94b3f5bacabe218d$exports)),
    minipodIconPage: (/*@__PURE__*/$parcel$interopDefault($5a8ebe80e4449512$exports)),
    productSrcPlaceHolder: (/*@__PURE__*/$parcel$interopDefault($a50e59d7355bb9aa$exports)),
    shareIcon: (/*@__PURE__*/$parcel$interopDefault($47a68e2bb6c34781$exports)),
    tooltipCircle: (/*@__PURE__*/$parcel$interopDefault($32c6b5c5fd7dd3bc$exports)),
    tubeSpinner: (/*@__PURE__*/$parcel$interopDefault($8273def840206282$exports)),
    archTypeIcon: (/*@__PURE__*/$parcel$interopDefault($600ae0e314012ef9$exports)),
    cameraIcon: (/*@__PURE__*/$parcel$interopDefault($d04b9de496336dfb$exports)),
    iconPartner: (/*@__PURE__*/$parcel$interopDefault($0e62b8f5f409238e$exports))
};
const $17bf087df6a33d6e$export$6858609937c8bad7 = {
    bg1: (0, (/*@__PURE__*/$parcel$interopDefault($c9f95a5c07aa8797$exports))),
    bg2: (0, (/*@__PURE__*/$parcel$interopDefault($cf98c7439fa914df$exports))),
    bg3: (0, (/*@__PURE__*/$parcel$interopDefault($a6ae98a35927690a$exports))),
    ellipse: (/*@__PURE__*/$parcel$interopDefault($cd6f60b98d7d2b10$exports)),
    progress1: (/*@__PURE__*/$parcel$interopDefault($4876d8c085c517be$exports)),
    progress2: (/*@__PURE__*/$parcel$interopDefault($c1229ae6da7b6df0$exports)),
    progress3: (/*@__PURE__*/$parcel$interopDefault($59e255e2cb6d9d87$exports)),
    underline: (/*@__PURE__*/$parcel$interopDefault($733755caf922f05a$exports)),
    longUnderline: (/*@__PURE__*/$parcel$interopDefault($c3380c4433599824$exports))
};
const $17bf087df6a33d6e$var$male = [
    (0, (/*@__PURE__*/$parcel$interopDefault($ba12f78d085523af$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($34ba97556ab4cff7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e7e0840cb09978c6$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3998d9398998212b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1d8bfeb3869fa414$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fb9616ea1945c132$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($236f28844b87a01e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2ce94c7e6178e6a4$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fb168e124d630392$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7b9f226cf94d0b61$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9038acf36883b87a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b8b3d61c5384941b$exports)))
];
const $17bf087df6a33d6e$var$female = [
    (0, (/*@__PURE__*/$parcel$interopDefault($1ef94df9102d1850$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1963b1b221e468ef$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e16e6a77cc4ce9f4$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a1bc0f1933661582$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($621f7441a241b0cd$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5ce911afea36431$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($8396ca71f4aeb953$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b2c41069a15856d5$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6aa121580c1fe3d6$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($511c39a8c51a3719$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($108a7c7e2edc4fb1$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a6b9471643ad6827$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($01ca55afe4b38357$exports)))
];
const $17bf087df6a33d6e$export$e2255cf6045e8d47 = {
    MALE: $17bf087df6a33d6e$var$male,
    FEMALE: $17bf087df6a33d6e$var$female,
    UNDEFINED: $17bf087df6a33d6e$var$male
};


/* Define your translations */ const $31c680c31ce1361b$export$67d7e6220353b39d = {
    en: {
        locale: 'en',
        name: 'English',
        messages: {
            'drv.cta-button.label': 'Scan and find your size',
            'drv.cta-button.tooltip.text': 'Measure with your smartphone for your individual size recommendation.',
            'drv.cta-button.tooltip.action': 'Got it!'
        }
    },
    de: {
        locale: 'de',
        name: 'Deutsch',
        messages: {
            'drv.cta-button.label': "Scanne und finde deine Gr\xf6\xdfe",
            'drv.cta-button.tooltip.action': 'Verstanden',
            'drv.cta-button.tooltip.text': "Miss mit dem Smartphone f\xfcr deine individuelle Gr\xf6\xdfenempfehlung"
        }
    },
    es: {
        locale: 'es',
        name: "Espa\xf1ol",
        messages: {
            'drv.cta-button.label': 'Escanea y encuentra tu talla',
            'drv.cta-button.tooltip.text': "Mide con tu dispositivo m\xf3vil para obtener tu recomendaci\xf3n de talla individual.",
            'drv.cta-button.tooltip.action': "\xa1Entendido!"
        }
    },
    it: {
        locale: 'it',
        name: 'Italiano',
        messages: {
            'drv.cta-button.label': 'Scansiona e trova la tua taglia',
            'drv.cta-button.tooltip.text': 'Misura con il tuo smartphone per avere un suggerimento personalizzato sulla tua taglia',
            'drv.cta-button.tooltip.action': 'Capito!'
        }
    },
    ja: {
        locale: 'ja',
        name: "\u65E5\u672C\u8A9E",
        messages: {
            'drv.cta-button.label': "\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u81EA\u5206\u306E\u30B5\u30A4\u30BA\u3092\u898B\u3064\u3051\u308B",
            'drv.cta-button.tooltip.action': 'OK',
            'drv.cta-button.tooltip.text': "\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u3092\u7528\u3044\u3066\u8DB3\u3092\u6E2C\u5B9A\u3057\u3001\u6700\u9069\u306A\u30B7\u30E5\u30FC\u30BA\u306E\u30B5\u30A4\u30BA\u3092\u63D0\u6848\u3057\u307E\u3059\u3002"
        }
    },
    fr: {
        locale: 'fr',
        name: "Fran\xe7ais",
        messages: {
            'drv.cta-button.label': 'Trouvez la bonne pointure',
            'drv.cta-button.tooltip.action': 'Compris',
            'drv.cta-button.tooltip.text': "Mesure tes pieds avec ton smartphone pour obtenir une recommandation de pointure personnalis\xe9e."
        }
    },
    pl: {
        locale: 'pl',
        name: 'Polski',
        messages: {
            'drv.cta-button.label': "Skanuj i znajd\u017A sw\xf3j rozmiar",
            'drv.cta-button.tooltip.action': 'Rozumiem!',
            'drv.cta-button.tooltip.text': "Zmierz za pomoc\u0105 smartfonu dla indywidualnej rekomendacji rozmiaru."
        }
    },
    tr: {
        locale: 'tr',
        name: "T\xfcrk\xe7e",
        messages: {
            'drv.cta-button.label': "Taray\u0131n ve ayak \xf6l\xe7\xfcn\xfcz\xfc bulun",
            'drv.cta-button.tooltip.action': "Anlad\u0131m!",
            'drv.cta-button.tooltip.text': "Ki\u015Fisel boyut \xf6neriniz i\xe7in telefonunuzla \xf6l\xe7\xfcm yap\u0131n."
        }
    }
};




const $8ddc9fe4248467fa$export$f4c588f8926c7637 = {
    id: 'test',
    number: '',
    name: 'Test Article',
    image: '',
    price: 199.99,
    sizes: [
        '42'
    ]
};
const $8ddc9fe4248467fa$export$7dfd81af9fc545f2 = {
    domain: ''
};


'use strict';
function $b4293b0eb4c07151$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $a8i8g = parcelRequire("a8i8g");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $4457f145f4fd6a49$var$toString } = Object.prototype;
const { getPrototypeOf: $4457f145f4fd6a49$var$getPrototypeOf } = Object;
const $4457f145f4fd6a49$var$kindOf = ((cache)=>(thing)=>{
        const str = $4457f145f4fd6a49$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $4457f145f4fd6a49$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$4457f145f4fd6a49$var$kindOf(thing) === type;
};
const $4457f145f4fd6a49$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $4457f145f4fd6a49$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $4457f145f4fd6a49$var$isUndefined = $4457f145f4fd6a49$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4457f145f4fd6a49$var$isBuffer(val) {
    return val !== null && !$4457f145f4fd6a49$var$isUndefined(val) && val.constructor !== null && !$4457f145f4fd6a49$var$isUndefined(val.constructor) && $4457f145f4fd6a49$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $4457f145f4fd6a49$var$isArrayBuffer = $4457f145f4fd6a49$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4457f145f4fd6a49$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $4457f145f4fd6a49$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $4457f145f4fd6a49$var$isString = $4457f145f4fd6a49$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $4457f145f4fd6a49$var$isFunction = $4457f145f4fd6a49$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $4457f145f4fd6a49$var$isNumber = $4457f145f4fd6a49$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $4457f145f4fd6a49$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $4457f145f4fd6a49$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $4457f145f4fd6a49$var$isPlainObject = (val)=>{
    if ($4457f145f4fd6a49$var$kindOf(val) !== 'object') return false;
    const prototype = $4457f145f4fd6a49$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $4457f145f4fd6a49$var$isDate = $4457f145f4fd6a49$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4457f145f4fd6a49$var$isFile = $4457f145f4fd6a49$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $4457f145f4fd6a49$var$isBlob = $4457f145f4fd6a49$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4457f145f4fd6a49$var$isFileList = $4457f145f4fd6a49$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $4457f145f4fd6a49$var$isStream = (val)=>$4457f145f4fd6a49$var$isObject(val) && $4457f145f4fd6a49$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $4457f145f4fd6a49$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $4457f145f4fd6a49$var$isFunction(thing.append) && ((kind = $4457f145f4fd6a49$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $4457f145f4fd6a49$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $4457f145f4fd6a49$var$isURLSearchParams = $4457f145f4fd6a49$var$kindOfTest('URLSearchParams');
const [$4457f145f4fd6a49$var$isReadableStream, $4457f145f4fd6a49$var$isRequest, $4457f145f4fd6a49$var$isResponse, $4457f145f4fd6a49$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($4457f145f4fd6a49$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $4457f145f4fd6a49$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $4457f145f4fd6a49$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4457f145f4fd6a49$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $4457f145f4fd6a49$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $4457f145f4fd6a49$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $4457f145f4fd6a49$var$isContextDefined = (context)=>!$4457f145f4fd6a49$var$isUndefined(context) && context !== $4457f145f4fd6a49$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $4457f145f4fd6a49$var$merge() {
    const { caseless: caseless } = $4457f145f4fd6a49$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $4457f145f4fd6a49$var$findKey(result, key) || key;
        if ($4457f145f4fd6a49$var$isPlainObject(result[targetKey]) && $4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge(result[targetKey], val);
        else if ($4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge({}, val);
        else if ($4457f145f4fd6a49$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $4457f145f4fd6a49$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $4457f145f4fd6a49$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $4457f145f4fd6a49$var$forEach(b, (val, key)=>{
        if (thisArg && $4457f145f4fd6a49$var$isFunction(val)) a[key] = (0, $b4293b0eb4c07151$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $4457f145f4fd6a49$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $4457f145f4fd6a49$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $4457f145f4fd6a49$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $4457f145f4fd6a49$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $4457f145f4fd6a49$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $4457f145f4fd6a49$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($4457f145f4fd6a49$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$4457f145f4fd6a49$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $4457f145f4fd6a49$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $4457f145f4fd6a49$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $4457f145f4fd6a49$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $4457f145f4fd6a49$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $4457f145f4fd6a49$var$isHTMLForm = $4457f145f4fd6a49$var$kindOfTest('HTMLFormElement');
const $4457f145f4fd6a49$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $4457f145f4fd6a49$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $4457f145f4fd6a49$var$isRegExp = $4457f145f4fd6a49$var$kindOfTest('RegExp');
const $4457f145f4fd6a49$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $4457f145f4fd6a49$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $4457f145f4fd6a49$var$freezeMethods = (obj)=>{
    $4457f145f4fd6a49$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($4457f145f4fd6a49$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$4457f145f4fd6a49$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $4457f145f4fd6a49$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $4457f145f4fd6a49$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $4457f145f4fd6a49$var$noop = ()=>{};
const $4457f145f4fd6a49$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $4457f145f4fd6a49$var$ALPHA = 'abcdefghijklmnopqrstuvwxyz';
const $4457f145f4fd6a49$var$DIGIT = '0123456789';
const $4457f145f4fd6a49$var$ALPHABET = {
    DIGIT: $4457f145f4fd6a49$var$DIGIT,
    ALPHA: $4457f145f4fd6a49$var$ALPHA,
    ALPHA_DIGIT: $4457f145f4fd6a49$var$ALPHA + $4457f145f4fd6a49$var$ALPHA.toUpperCase() + $4457f145f4fd6a49$var$DIGIT
};
const $4457f145f4fd6a49$var$generateString = (size = 16, alphabet = $4457f145f4fd6a49$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = '';
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $4457f145f4fd6a49$var$isSpecCompliantForm(thing) {
    return !!(thing && $4457f145f4fd6a49$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $4457f145f4fd6a49$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($4457f145f4fd6a49$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $4457f145f4fd6a49$var$isArray(source) ? [] : {};
                $4457f145f4fd6a49$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$4457f145f4fd6a49$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $4457f145f4fd6a49$var$isAsyncFn = $4457f145f4fd6a49$var$kindOfTest('AsyncFunction');
const $4457f145f4fd6a49$var$isThenable = (thing)=>thing && ($4457f145f4fd6a49$var$isObject(thing) || $4457f145f4fd6a49$var$isFunction(thing)) && $4457f145f4fd6a49$var$isFunction(thing.then) && $4457f145f4fd6a49$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $4457f145f4fd6a49$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $4457f145f4fd6a49$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $4457f145f4fd6a49$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $4457f145f4fd6a49$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $4457f145f4fd6a49$var$isFunction($4457f145f4fd6a49$var$_global.postMessage));
const $4457f145f4fd6a49$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($4457f145f4fd6a49$var$_global) : typeof $a8i8g !== 'undefined' && $a8i8g.nextTick || $4457f145f4fd6a49$var$_setImmediate;
var // *********************
$4457f145f4fd6a49$export$2e2bcd8739ae039 = {
    isArray: $4457f145f4fd6a49$var$isArray,
    isArrayBuffer: $4457f145f4fd6a49$var$isArrayBuffer,
    isBuffer: $4457f145f4fd6a49$var$isBuffer,
    isFormData: $4457f145f4fd6a49$var$isFormData,
    isArrayBufferView: $4457f145f4fd6a49$var$isArrayBufferView,
    isString: $4457f145f4fd6a49$var$isString,
    isNumber: $4457f145f4fd6a49$var$isNumber,
    isBoolean: $4457f145f4fd6a49$var$isBoolean,
    isObject: $4457f145f4fd6a49$var$isObject,
    isPlainObject: $4457f145f4fd6a49$var$isPlainObject,
    isReadableStream: $4457f145f4fd6a49$var$isReadableStream,
    isRequest: $4457f145f4fd6a49$var$isRequest,
    isResponse: $4457f145f4fd6a49$var$isResponse,
    isHeaders: $4457f145f4fd6a49$var$isHeaders,
    isUndefined: $4457f145f4fd6a49$var$isUndefined,
    isDate: $4457f145f4fd6a49$var$isDate,
    isFile: $4457f145f4fd6a49$var$isFile,
    isBlob: $4457f145f4fd6a49$var$isBlob,
    isRegExp: $4457f145f4fd6a49$var$isRegExp,
    isFunction: $4457f145f4fd6a49$var$isFunction,
    isStream: $4457f145f4fd6a49$var$isStream,
    isURLSearchParams: $4457f145f4fd6a49$var$isURLSearchParams,
    isTypedArray: $4457f145f4fd6a49$var$isTypedArray,
    isFileList: $4457f145f4fd6a49$var$isFileList,
    forEach: $4457f145f4fd6a49$var$forEach,
    merge: $4457f145f4fd6a49$var$merge,
    extend: $4457f145f4fd6a49$var$extend,
    trim: $4457f145f4fd6a49$var$trim,
    stripBOM: $4457f145f4fd6a49$var$stripBOM,
    inherits: $4457f145f4fd6a49$var$inherits,
    toFlatObject: $4457f145f4fd6a49$var$toFlatObject,
    kindOf: $4457f145f4fd6a49$var$kindOf,
    kindOfTest: $4457f145f4fd6a49$var$kindOfTest,
    endsWith: $4457f145f4fd6a49$var$endsWith,
    toArray: $4457f145f4fd6a49$var$toArray,
    forEachEntry: $4457f145f4fd6a49$var$forEachEntry,
    matchAll: $4457f145f4fd6a49$var$matchAll,
    isHTMLForm: $4457f145f4fd6a49$var$isHTMLForm,
    hasOwnProperty: $4457f145f4fd6a49$var$hasOwnProperty,
    hasOwnProp: $4457f145f4fd6a49$var$hasOwnProperty,
    reduceDescriptors: $4457f145f4fd6a49$var$reduceDescriptors,
    freezeMethods: $4457f145f4fd6a49$var$freezeMethods,
    toObjectSet: $4457f145f4fd6a49$var$toObjectSet,
    toCamelCase: $4457f145f4fd6a49$var$toCamelCase,
    noop: $4457f145f4fd6a49$var$noop,
    toFiniteNumber: $4457f145f4fd6a49$var$toFiniteNumber,
    findKey: $4457f145f4fd6a49$var$findKey,
    global: $4457f145f4fd6a49$var$_global,
    isContextDefined: $4457f145f4fd6a49$var$isContextDefined,
    ALPHABET: $4457f145f4fd6a49$var$ALPHABET,
    generateString: $4457f145f4fd6a49$var$generateString,
    isSpecCompliantForm: $4457f145f4fd6a49$var$isSpecCompliantForm,
    toJSONObject: $4457f145f4fd6a49$var$toJSONObject,
    isAsyncFn: $4457f145f4fd6a49$var$isAsyncFn,
    isThenable: $4457f145f4fd6a49$var$isThenable,
    setImmediate: $4457f145f4fd6a49$var$_setImmediate,
    asap: $4457f145f4fd6a49$var$asap
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $ed5f7e2522a0b703$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).inherits($ed5f7e2522a0b703$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $ed5f7e2522a0b703$var$prototype = $ed5f7e2522a0b703$var$AxiosError.prototype;
const $ed5f7e2522a0b703$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $ed5f7e2522a0b703$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($ed5f7e2522a0b703$var$AxiosError, $ed5f7e2522a0b703$var$descriptors);
Object.defineProperty($ed5f7e2522a0b703$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$ed5f7e2522a0b703$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($ed5f7e2522a0b703$var$prototype);
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $ed5f7e2522a0b703$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $ed5f7e2522a0b703$export$2e2bcd8739ae039 = $ed5f7e2522a0b703$var$AxiosError;


// eslint-disable-next-line strict
var $1b5ae82d1edb0249$export$2e2bcd8739ae039 = null;



var $gzLuY = parcelRequire("gzLuY");
var $5dbdf283f7ef4044$require$Buffer = $gzLuY.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isVisitable(thing) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $5dbdf283f7ef4044$var$removeBrackets(key) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $5dbdf283f7ef4044$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $5dbdf283f7ef4044$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isFlatArray(arr) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(arr) && !arr.some($5dbdf283f7ef4044$var$isVisitable);
}
const $5dbdf283f7ef4044$var$predicates = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject((0, $4457f145f4fd6a49$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $5dbdf283f7ef4044$var$toFormData(obj, formData, options) {
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $1b5ae82d1edb0249$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $5dbdf283f7ef4044$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) && $5dbdf283f7ef4044$var$isFlatArray(value) || ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFileList(value) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $5dbdf283f7ef4044$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $5dbdf283f7ef4044$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($5dbdf283f7ef4044$var$isVisitable(value)) return true;
        formData.append($5dbdf283f7ef4044$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($5dbdf283f7ef4044$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $5dbdf283f7ef4044$var$isVisitable
    });
    function build(value, path) {
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $5dbdf283f7ef4044$export$2e2bcd8739ae039 = $5dbdf283f7ef4044$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $23a6a9f2f50fe381$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $23a6a9f2f50fe381$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(params, this, options);
}
const $23a6a9f2f50fe381$var$prototype = $23a6a9f2f50fe381$var$AxiosURLSearchParams.prototype;
$23a6a9f2f50fe381$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$23a6a9f2f50fe381$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $23a6a9f2f50fe381$var$encode);
    } : $23a6a9f2f50fe381$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $23a6a9f2f50fe381$export$2e2bcd8739ae039 = $23a6a9f2f50fe381$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $12c2c95c1ed3c980$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $12c2c95c1ed3c980$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $12c2c95c1ed3c980$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $23a6a9f2f50fe381$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $ca291930ae00924d$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $ca291930ae00924d$export$2e2bcd8739ae039 = $ca291930ae00924d$var$InterceptorManager;





'use strict';
var $796c18463ea25502$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $a084e346ccf1414e$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $23a6a9f2f50fe381$export$2e2bcd8739ae039);


'use strict';
var $4d02f3c5e9d23987$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $7320e56e0494b653$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $933095d2c2007f0e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $a084e346ccf1414e$export$2e2bcd8739ae039,
        FormData: $4d02f3c5e9d23987$export$2e2bcd8739ae039,
        Blob: $7320e56e0494b653$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $e7f6cfbce8ef57c2$exports = {};

$parcel$export($e7f6cfbce8ef57c2$exports, "hasBrowserEnv", function () { return $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf; });
$parcel$export($e7f6cfbce8ef57c2$exports, "navigator", function () { return $e7f6cfbce8ef57c2$export$ec7c8efa7f5790ae; });
$parcel$export($e7f6cfbce8ef57c2$exports, "hasStandardBrowserEnv", function () { return $e7f6cfbce8ef57c2$export$c0bcc9250309d66; });
$parcel$export($e7f6cfbce8ef57c2$exports, "hasStandardBrowserWebWorkerEnv", function () { return $e7f6cfbce8ef57c2$export$c81692cf5af97dac; });
$parcel$export($e7f6cfbce8ef57c2$exports, "origin", function () { return $e7f6cfbce8ef57c2$export$f710a83a91838a36; });
const $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $e7f6cfbce8ef57c2$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $e7f6cfbce8ef57c2$export$c0bcc9250309d66 = $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf && (!$e7f6cfbce8ef57c2$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($e7f6cfbce8ef57c2$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $e7f6cfbce8ef57c2$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $e7f6cfbce8ef57c2$export$f710a83a91838a36 = $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $7bb33b7264aaaf86$export$2e2bcd8739ae039 = {
    ...$e7f6cfbce8ef57c2$exports,
    ...(0, $933095d2c2007f0e$export$2e2bcd8739ae039)
};


'use strict';
function $c6537084d1761b1c$export$2e2bcd8739ae039(data, options) {
    return (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(data, new (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).isNode && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a91febb88049dece$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a91febb88049dece$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a91febb88049dece$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $a91febb88049dece$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(formData) && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($a91febb88049dece$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a91febb88049dece$export$2e2bcd8739ae039 = $a91febb88049dece$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $f671d6c34fc96548$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $f671d6c34fc96548$var$defaults = {
    transitional: (0, $796c18463ea25502$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $a91febb88049dece$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBuffer(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isStream(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFile(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBlob(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $c6537084d1761b1c$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $f671d6c34fc96548$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $f671d6c34fc96548$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isResponse(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).from(e, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $f671d6c34fc96548$var$defaults.headers[method] = {};
});
var $f671d6c34fc96548$export$2e2bcd8739ae039 = $f671d6c34fc96548$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $993ca9e2d6767cd4$var$ignoreDuplicateOf = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $993ca9e2d6767cd4$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $993ca9e2d6767cd4$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $97723c9940354b38$var$$internals = Symbol('internals');
function $97723c9940354b38$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $97723c9940354b38$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) ? value.map($97723c9940354b38$var$normalizeValue) : String(value);
}
function $97723c9940354b38$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $97723c9940354b38$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $97723c9940354b38$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $97723c9940354b38$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $97723c9940354b38$var$buildAccessors(obj, header) {
    const accessorName = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $97723c9940354b38$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $97723c9940354b38$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $97723c9940354b38$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$97723c9940354b38$var$isValidHeaderName(header)) setHeaders((0, $993ca9e2d6767cd4$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $97723c9940354b38$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $97723c9940354b38$var$parseTokens(value);
                if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $97723c9940354b38$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $97723c9940354b38$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $97723c9940354b38$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $97723c9940354b38$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $97723c9940354b38$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $97723c9940354b38$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$97723c9940354b38$var$$internals] = this[$97723c9940354b38$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $97723c9940354b38$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $97723c9940354b38$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$97723c9940354b38$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).reduceDescriptors($97723c9940354b38$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).freezeMethods($97723c9940354b38$var$AxiosHeaders);
var $97723c9940354b38$export$2e2bcd8739ae039 = $97723c9940354b38$var$AxiosHeaders;


'use strict';
function $2b2db412c73efddc$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $f671d6c34fc96548$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5f032fd5b915e863$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $844e24f044f60b67$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).inherits($844e24f044f60b67$var$CanceledError, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $844e24f044f60b67$export$2e2bcd8739ae039 = $844e24f044f60b67$var$CanceledError;







'use strict';
function $b1fb368c37c1823a$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $9a3acc13c385c3d9$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $3fe2722b85f27cc8$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $3fe2722b85f27cc8$export$2e2bcd8739ae039 = $3fe2722b85f27cc8$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $34d7348ceccb5142$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $34d7348ceccb5142$export$2e2bcd8739ae039 = $34d7348ceccb5142$var$throttle;



const $ab10a2828cd1e7bc$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $3fe2722b85f27cc8$export$2e2bcd8739ae039)(50, 250);
    return (0, $34d7348ceccb5142$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $ab10a2828cd1e7bc$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $ab10a2828cd1e7bc$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).asap(()=>fn(...args));






'use strict';
var $2d50534f56617a3d$export$2e2bcd8739ae039 = (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $8292dca2fe19e2c0$export$2e2bcd8739ae039 = (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $de0137e96012432b$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $4226547004fa4063$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $55a6f18683d9f888$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $de0137e96012432b$export$2e2bcd8739ae039)(requestedURL)) return (0, $4226547004fa4063$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $142febf2fa493ec7$var$headersToObject = (thing)=>thing instanceof (0, $97723c9940354b38$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $142febf2fa493ec7$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(target) && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($142febf2fa493ec7$var$headersToObject(a), $142febf2fa493ec7$var$headersToObject(b), true)
    };
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $c9220cd357bb9355$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $142febf2fa493ec7$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $12c2c95c1ed3c980$export$2e2bcd8739ae039)((0, $55a6f18683d9f888$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $2d50534f56617a3d$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $8292dca2fe19e2c0$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $089238041fc30567$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $089238041fc30567$export$2e2bcd8739ae039 = $089238041fc30567$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $c9220cd357bb9355$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $b1fb368c37c1823a$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Request aborted', (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Network Error', (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $796c18463ea25502$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ETIMEDOUT : (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $ab10a2828cd1e7bc$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $ab10a2828cd1e7bc$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $9a3acc13c385c3d9$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $365fec1ad2e63ba9$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039) ? err : new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $365fec1ad2e63ba9$export$2e2bcd8739ae039 = $365fec1ad2e63ba9$var$composeSignals;


const $01ca82fc0600dc5f$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $01ca82fc0600dc5f$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $01ca82fc0600dc5f$var$readStream(iterable))yield* $01ca82fc0600dc5f$export$71b051935044bd5d(chunk, chunkSize);
};
const $01ca82fc0600dc5f$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $01ca82fc0600dc5f$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $01ca82fc0600dc5f$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $349d2151eec20aad$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $349d2151eec20aad$var$isReadableStreamSupported = $349d2151eec20aad$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $349d2151eec20aad$var$encodeText = $349d2151eec20aad$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $349d2151eec20aad$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $349d2151eec20aad$var$supportsRequestStream = $349d2151eec20aad$var$isReadableStreamSupported && $349d2151eec20aad$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $349d2151eec20aad$var$DEFAULT_CHUNK_SIZE = 65536;
const $349d2151eec20aad$var$supportsResponseStream = $349d2151eec20aad$var$isReadableStreamSupported && $349d2151eec20aad$var$test(()=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $349d2151eec20aad$var$resolvers = {
    stream: $349d2151eec20aad$var$supportsResponseStream && ((res)=>res.body)
};
$349d2151eec20aad$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$349d2151eec20aad$var$resolvers[type] && ($349d2151eec20aad$var$resolvers[type] = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $349d2151eec20aad$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(body)) return (await $349d2151eec20aad$var$encodeText(body)).byteLength;
};
const $349d2151eec20aad$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $349d2151eec20aad$var$getBodyLength(body) : length;
};
var $349d2151eec20aad$export$2e2bcd8739ae039 = $349d2151eec20aad$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $c9220cd357bb9355$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $365fec1ad2e63ba9$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $349d2151eec20aad$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $349d2151eec20aad$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $ab10a2828cd1e7bc$export$d9fadd12586c18d6)(requestContentLength, (0, $ab10a2828cd1e7bc$export$c1b28109d46c3592)((0, $ab10a2828cd1e7bc$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $01ca82fc0600dc5f$export$b0119225647bd83)(_request.body, $349d2151eec20aad$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $349d2151eec20aad$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($349d2151eec20aad$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $ab10a2828cd1e7bc$export$d9fadd12586c18d6)(responseContentLength, (0, $ab10a2828cd1e7bc$export$c1b28109d46c3592)((0, $ab10a2828cd1e7bc$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $01ca82fc0600dc5f$export$b0119225647bd83)(response.body, $349d2151eec20aad$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $349d2151eec20aad$var$resolvers[(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey($349d2151eec20aad$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $b1fb368c37c1823a$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $97723c9940354b38$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Network Error', (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $f311d0388b14bc21$var$knownAdapters = {
    http: (0, $1b5ae82d1edb0249$export$2e2bcd8739ae039),
    xhr: (0, $089238041fc30567$export$2e2bcd8739ae039),
    fetch: (0, $349d2151eec20aad$export$2e2bcd8739ae039)
};
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach($f311d0388b14bc21$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $f311d0388b14bc21$var$renderReason = (reason)=>`- ${reason}`;
const $f311d0388b14bc21$var$isResolvedHandle = (adapter)=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $f311d0388b14bc21$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$f311d0388b14bc21$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $f311d0388b14bc21$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($f311d0388b14bc21$var$renderReason).join('\n') : ' ' + $f311d0388b14bc21$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $f311d0388b14bc21$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $1ba4fe270146b4e2$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(null, config);
}
function $1ba4fe270146b4e2$export$2e2bcd8739ae039(config) {
    $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
    config.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $f311d0388b14bc21$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $f671d6c34fc96548$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5f032fd5b915e863$export$2e2bcd8739ae039)(reason)) {
            $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $0c953052fb93d857$export$a4ad2735b021c132 = "1.7.7";



'use strict';
const $153d7c57f809624c$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $153d7c57f809624c$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $153d7c57f809624c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $153d7c57f809624c$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $0c953052fb93d857$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$153d7c57f809624c$var$deprecatedWarnings[opt]) {
            $153d7c57f809624c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $153d7c57f809624c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('options must be an object', (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $153d7c57f809624c$export$2e2bcd8739ae039 = {
    assertOptions: $153d7c57f809624c$var$assertOptions,
    validators: $153d7c57f809624c$var$validators
};



'use strict';
const $d31ac3bc8d454bec$var$validators = (0, $153d7c57f809624c$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $d31ac3bc8d454bec$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $ca291930ae00924d$export$2e2bcd8739ae039)(),
            response: new (0, $ca291930ae00924d$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $142febf2fa493ec7$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $153d7c57f809624c$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
            forcedJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
            clarifyTimeoutError: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $153d7c57f809624c$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $d31ac3bc8d454bec$var$validators.function,
                serialize: $d31ac3bc8d454bec$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $1ba4fe270146b4e2$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $1ba4fe270146b4e2$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $142febf2fa493ec7$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $55a6f18683d9f888$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $12c2c95c1ed3c980$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $d31ac3bc8d454bec$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $d31ac3bc8d454bec$var$Axios.prototype[method] = generateHTTPMethod();
    $d31ac3bc8d454bec$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $d31ac3bc8d454bec$export$2e2bcd8739ae039 = $d31ac3bc8d454bec$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $c9dbae5aa50ec7c7$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $c9dbae5aa50ec7c7$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $c9dbae5aa50ec7c7$export$2e2bcd8739ae039 = $c9dbae5aa50ec7c7$var$CancelToken;






'use strict';
function $cbed9dfdab194748$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $48132dea419dd2c0$export$2e2bcd8739ae039(payload) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $9f6607e590634381$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($9f6607e590634381$var$HttpStatusCode).forEach(([key, value])=>{
    $9f6607e590634381$var$HttpStatusCode[value] = key;
});
var $9f6607e590634381$export$2e2bcd8739ae039 = $9f6607e590634381$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $c9a85f19e57c70f8$var$createInstance(defaultConfig) {
    const context = new (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $b4293b0eb4c07151$export$2e2bcd8739ae039)((0, $d31ac3bc8d454bec$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).extend(instance, (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $c9a85f19e57c70f8$var$createInstance((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $c9a85f19e57c70f8$var$axios = $c9a85f19e57c70f8$var$createInstance((0, $f671d6c34fc96548$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$c9a85f19e57c70f8$var$axios.Axios = (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$c9a85f19e57c70f8$var$axios.CanceledError = (0, $844e24f044f60b67$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.CancelToken = (0, $c9dbae5aa50ec7c7$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.isCancel = (0, $5f032fd5b915e863$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.VERSION = (0, $0c953052fb93d857$export$a4ad2735b021c132);
$c9a85f19e57c70f8$var$axios.toFormData = (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039);
// Expose AxiosError class
$c9a85f19e57c70f8$var$axios.AxiosError = (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$c9a85f19e57c70f8$var$axios.Cancel = $c9a85f19e57c70f8$var$axios.CanceledError;
// Expose all/spread
$c9a85f19e57c70f8$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$c9a85f19e57c70f8$var$axios.spread = (0, $cbed9dfdab194748$export$2e2bcd8739ae039);
// Expose isAxiosError
$c9a85f19e57c70f8$var$axios.isAxiosError = (0, $48132dea419dd2c0$export$2e2bcd8739ae039);
// Expose mergeConfig
$c9a85f19e57c70f8$var$axios.mergeConfig = (0, $142febf2fa493ec7$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.AxiosHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.formToJSON = (thing)=>(0, $a91febb88049dece$export$2e2bcd8739ae039)((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$c9a85f19e57c70f8$var$axios.getAdapter = (0, $f311d0388b14bc21$export$2e2bcd8739ae039).getAdapter;
$c9a85f19e57c70f8$var$axios.HttpStatusCode = (0, $9f6607e590634381$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.default = $c9a85f19e57c70f8$var$axios;
var // this module should only have a default export
$c9a85f19e57c70f8$export$2e2bcd8739ae039 = $c9a85f19e57c70f8$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $18d826a12788a23d$export$1c00760e9e5a4e95, AxiosError: $18d826a12788a23d$export$c1fbed17c2f6a328, CanceledError: $18d826a12788a23d$export$1ab0c6b20d94fa14, isCancel: $18d826a12788a23d$export$3b22524397b493c6, CancelToken: $18d826a12788a23d$export$fd08e3cb425f0d61, VERSION: $18d826a12788a23d$export$a4ad2735b021c132, all: $18d826a12788a23d$export$84bf76cd7afc7469, Cancel: $18d826a12788a23d$export$848c9b7ead0df967, isAxiosError: $18d826a12788a23d$export$fbafdbe06a5b5a9a, spread: $18d826a12788a23d$export$3ae0fd4797ed47c8, toFormData: $18d826a12788a23d$export$10ae0d317ea97f8b, AxiosHeaders: $18d826a12788a23d$export$4e7d6ff0f3e6520, HttpStatusCode: $18d826a12788a23d$export$a972f69c851492b3, formToJSON: $18d826a12788a23d$export$86d7c59254d6a2c9, getAdapter: $18d826a12788a23d$export$17ddc20a97d669e2, mergeConfig: $18d826a12788a23d$export$7ec1ebcfa9d8bd6a } = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039);


var $c40fe7cebd3a81ae$export$770ef1da3280a8ee = /*#__PURE__*/ function(LogMode) {
    LogMode["SILENT"] = "SILENT";
    LogMode["VERBOSE"] = "VERBOSE";
    LogMode["DEFAULT"] = "DEFAULT";
    return LogMode;
}({});
class $c40fe7cebd3a81ae$var$LogService {
    constructor(){
        const params = new URLSearchParams(window.location.search);
        const consoleParam = params.get('fpt-console');
        this.mode = consoleParam || "DEFAULT";
    }
    setMode(consoleMode) {
        this.mode = consoleMode;
    }
    info(message, obj) {
        if (this.mode !== "VERBOSE") return;
        if (obj) return console.log(`[fpt] ${message}`, obj);
        console.log(`[fpt] ${message}`);
    }
    warn(message) {
        if (this.mode === "SILENT") return;
        console.warn(`[fpt] ${message}`);
    }
    error(message) {
        if (this.mode === "SILENT") return;
        console.error(`[fpt] ${message}`);
    }
}
var $c40fe7cebd3a81ae$export$2e2bcd8739ae039 = new $c40fe7cebd3a81ae$var$LogService();


class $f188c4e754268d8b$var$SessionService {
    constructor(){
        this.client = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app"
        });
        this.updateClient = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app"
        });
    }
    createSession(data) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('[SessionService] creating session');
        // TODO: If create session fails we can handle it here
        return this.client.post('sessions', data).then((result)=>result.data.session_id);
    }
    setSessionId(sessionId) {
        this.sessionId = sessionId;
        this.updateClient.defaults.headers.common.Authorization = `Bearer ${sessionId}`;
    }
    setApiKey(apiKey) {
        this.client.defaults.headers.common['X-API-KEY'] = apiKey;
    }
    getSession() {
        return this.updateClient.get(`sessions/${this.sessionId}`).then((result)=>result.data);
    }
    getSessionId() {
        return this.sessionId;
    }
    getSessionMeasurements() {
        return this.updateClient.get(`sessions/${this.sessionId}/measurements`).then((result)=>result.data);
    }
    getSessionEvents() {
        return this.client.get(`sessions/${this.sessionId}/events`).then((result)=>result.data);
    }
    updateExitCode(source, code) {
        if (!this.sessionId) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('update session failed, missing session');
            return;
        }
        return this.updateClient.patch(`sessions/${this.sessionId}`, {
            exit_code: `${source}.${code}`
        });
    }
    updateSession(sessionId, update) {
        return this.updateClient.patch(`sessions/${sessionId}`, update);
    }
}
var $f188c4e754268d8b$export$2e2bcd8739ae039 = new $f188c4e754268d8b$var$SessionService();


// Polyfill Object.hasOwn method for older brwsers
'hasOwn' in Object || (Object.hasOwn = Object.call.bind(Object.hasOwnProperty));
function $e3aa4ff3201c0ceb$var$arrayToUUIDString(array) {
    var hexValues = Array.from(array, function(byte) {
        return ('0' + (byte & 0xff).toString(16)).slice(-2);
    });
    return [
        hexValues.slice(0, 4).join(''),
        hexValues.slice(4, 6).join(''),
        hexValues.slice(6, 8).join(''),
        hexValues.slice(8, 10).join(''),
        hexValues.slice(10).join('')
    ].join('-');
}
function $e3aa4ff3201c0ceb$var$generateUUID() {
    var array = new Uint8Array(16);
    window.crypto.getRandomValues(array);
    array[6] = array[6] & 0x0f | 0x40; // Version 4
    array[8] = array[8] & 0x3f | 0x80; // Variant 10
    return $e3aa4ff3201c0ceb$var$arrayToUUIDString(array);
}
class $e3aa4ff3201c0ceb$var$StorageService {
    constructor(){
        const sessionStr = sessionStorage.getItem('fpt-session');
        const localStr = localStorage.getItem('fpt-local');
        const domain = window.location.hostname;
        if (!crypto.randomUUID) crypto.randomUUID = $e3aa4ff3201c0ceb$var$generateUUID;
        this.localState = localStr ? JSON.parse(localStr) : {
            measurementId: '',
            anonymousId: crypto.randomUUID(),
            themeName: ''
        };
        this.sessionState = sessionStr ? JSON.parse(sessionStr) : {
            sessionId: '',
            matchings: {},
            viewedTooltips: [],
            settings: {
                name: domain
            }
        };
        if (!sessionStr) sessionStorage.setItem('fpt-session', JSON.stringify(this.sessionState));
        if (!localStr) localStorage.setItem('fpt-local', JSON.stringify(this.localState));
    }
    update(key, value) {
        if (Object.hasOwn(this.localState, key) || key === 'measurementId') this.localState[key] = value;
        else this.sessionState[key] = value;
        this.persistState();
    }
    clearMatchings() {
        this.sessionState.matchings = {};
        this.persistState();
    }
    setMeasurementId(measurementId) {
        this.localState.measurementId = measurementId;
        this.persistState();
    }
    clearMeasurement() {
        this.localState.measurementId = '';
        this.persistState();
    }
    findMatching(id) {
        return this.sessionState.matchings[id] ? this.sessionState.matchings[id] : null;
    }
    getMeasurementId() {
        return this.localState.measurementId;
    }
    getSessionId() {
        return this.sessionState.sessionId;
    }
    getAnonymousId() {
        return this.localState.anonymousId;
    }
    addViewedTooltip(messageId) {
        if (this.isTooltipViewed(messageId)) return this.sessionState.viewedTooltips.length;
        if (this.sessionState.viewedTooltips) {
            const result = this.sessionState.viewedTooltips.push(messageId);
            this.persistState();
            return result;
        }
        this.sessionState.viewedTooltips = [
            messageId
        ];
        this.persistState();
        return this.sessionState.viewedTooltips.length;
    }
    findViewedTooltip(messageId) {
        if (!this.sessionState.viewedTooltips) return;
        return this.sessionState.viewedTooltips.find((item)=>item === messageId);
    }
    isTooltipViewed(messageId) {
        return !!this.findViewedTooltip(messageId);
    }
    addMatching(m, id) {
        this.sessionState.matchings[id] = m;
        this.persistState();
        return m;
    }
    persistState() {
        sessionStorage.setItem('fpt-session', JSON.stringify(this.sessionState));
        localStorage.setItem('fpt-local', JSON.stringify(this.localState));
    }
}
var $e3aa4ff3201c0ceb$export$2e2bcd8739ae039 = new $e3aa4ff3201c0ceb$var$StorageService();




const $eb35e4b56fe508da$export$94b076129cf5f782 = 'https://cdn.footprinttech.de/assets';
const $eb35e4b56fe508da$var$client = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
    baseURL: $eb35e4b56fe508da$export$94b076129cf5f782
});
function $eb35e4b56fe508da$var$mergeNamespaceIntoMessages(messages, options) {
    const { lang: lang, i18nNamespace: i18nNamespace } = options;
    return $eb35e4b56fe508da$var$client.get(`locales/${lang}/${i18nNamespace}.json`).then((result)=>{
        const nsTranslations = result.data;
        return Object.assign(messages, nsTranslations);
    });
}
const $eb35e4b56fe508da$export$42208c4599db7952 = {
    fetchLanguageFile (options) {
        const { lang: lang, i18nNamespace: i18nNamespace } = options;
        return $eb35e4b56fe508da$var$client.get(`locales/${lang}/messages.json`).then((result)=>{
            const messages = result.data;
            if (i18nNamespace) return $eb35e4b56fe508da$var$mergeNamespaceIntoMessages(messages, options);
            return messages;
        });
    },
    fetchTheme (themeName) {
        return $eb35e4b56fe508da$var$client.get(`themes/${themeName}.json`).then((result)=>result.data);
    }
};



class $2a55a88928dc0706$var$ShopSettingsService {
    constructor(){
        this.client = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app"
        });
    }
    setApiKey(apiKey) {
        this.client.defaults.headers.common['X-API-KEY'] = apiKey;
    }
    async getSettings() {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`ShopSettingsService using ${"https://staging-backend.myfootprint.app"} as API url`);
        let settings = null;
        const settingsEl = document.querySelector('#fpt-settings');
        if (settingsEl) // Shopware6 settings
        settings = JSON.parse(settingsEl.textContent);
        else {
            const domain = window.location.hostname;
            const result = await this.client.get(`shops/settings?domain=${domain}`);
            const { data: data } = result;
            settings = data.length > 0 ? data[0] : {
                domain: ''
            };
        }
        if (settings.theme && settings.theme !== 'default') {
            const theme = await (0, $eb35e4b56fe508da$export$42208c4599db7952).fetchTheme(settings.theme);
            settings.theme = theme;
        } else settings.theme = {};
        const { brandLogo: brandLogo } = settings;
        if (brandLogo) settings.theme.shopLogo = `${0, $eb35e4b56fe508da$export$94b076129cf5f782}/logos/${brandLogo}`;
        return settings;
    }
}
var $2a55a88928dc0706$export$2e2bcd8739ae039 = new $2a55a88928dc0706$var$ShopSettingsService();


parcelRequire("6cds3");
const $933ab13c7a65596b$var$Events = {
    onCloseModalPress: 'onCloseModalPress'
};
var $933ab13c7a65596b$export$2e2bcd8739ae039 = $933ab13c7a65596b$var$Events;



parcelRequire("6cds3");

const $7c8d586ac16018dc$var$Events = {
    onAddToCartPress: 'onAddToCartPress',
    onRecommendationBackToShopPress: 'onRecommendationBackToShopPress',
    onFeedbackConfirm: 'onFeedbackConfirm',
    onPiReconstructionRequest: 'onPiReconstructionRequest'
};
var $7c8d586ac16018dc$export$2e2bcd8739ae039 = $7c8d586ac16018dc$var$Events;




var $6cds3 = parcelRequire("6cds3");

parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");



function $c569e2e9ecfda3a0$export$2e2bcd8739ae039() {
    const intl = $6cds3.useContext((0, $1db963aedeff66d1$export$841858b892ce1f4c));
    (0, $74d4eda268cdc720$export$45c4bbf6e55bba1f)(intl);
    return intl;
}



function $93a170e0016205d7$var$areEqual(prevProps, nextProps) {
    const { values: values, ...otherProps } = prevProps;
    const { values: nextValues, ...nextOtherProps } = nextProps;
    return (0, $74d4eda268cdc720$export$d36bdfa510afb180)(nextValues, values) && (0, $74d4eda268cdc720$export$d36bdfa510afb180)(otherProps, nextOtherProps);
}
function $93a170e0016205d7$var$FormattedMessage(props) {
    const intl = (0, $c569e2e9ecfda3a0$export$2e2bcd8739ae039)();
    const { formatMessage: formatMessage, textComponent: Text = $6cds3.Fragment } = intl;
    const { id: id, description: description, defaultMessage: defaultMessage, values: values, children: children, tagName: Component = Text, ignoreTag: ignoreTag } = props;
    const descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    const nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        children: nodes
    });
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: nodes
    });
}
$93a170e0016205d7$var$FormattedMessage.displayName = "FormattedMessage";
const $93a170e0016205d7$var$MemoizedFormattedMessage = $6cds3.memo($93a170e0016205d7$var$FormattedMessage, $93a170e0016205d7$var$areEqual);
$93a170e0016205d7$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
var $93a170e0016205d7$export$2e2bcd8739ae039 = $93a170e0016205d7$var$MemoizedFormattedMessage;


const $4bd05a80e138995f$export$8f45430ccf837300 = {
    almond: '#fdf5ec',
    azure: '#f8fcfd',
    blackish: '#1a1919',
    'bluey-grey': '#8d99c4',
    'dark-slate-blue': '#1e4e5f',
    'eerie-black': '#242424',
    emerald: '#00da7c',
    golden: '#fabb00',
    grey1: '#F4F2F0',
    grey2: '#322F30',
    grey3: 'rgba(50, 47, 48, 0.125)',
    grey4: '#939190',
    grey5: '#e0dedd',
    grey6: 'rgba(50, 47, 48, 0.2)',
    grey7: '#929090',
    puertorico: '#4CA998',
    red1: '#D8021A',
    'reddish-pink': '#ff345e',
    white: '#FFFFFF',
    'inactive-blue': '#bbcad3'
};
const $4bd05a80e138995f$export$4df81b166a173749 = $4bd05a80e138995f$export$8f45430ccf837300.azure;
const $4bd05a80e138995f$export$e07b43e05432e0e3 = $4bd05a80e138995f$export$8f45430ccf837300['dark-slate-blue'];



const $7fb0feabf372b90f$var$Icon = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "ArticleInfo__Icon",
    componentId: "sc-j1d5tq-0"
})([
    "display:inline;width:140px;object-fit:contain;align-self:center;border-radius:10px;overflow:hidden;"
]);
const $7fb0feabf372b90f$var$ArticleData = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ArticleInfo__ArticleData",
    componentId: "sc-j1d5tq-1"
})([
    "display:flex;flex-direction:row;"
]);
const $7fb0feabf372b90f$var$TextFields = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ArticleInfo__TextFields",
    componentId: "sc-j1d5tq-2"
})([
    "display:flex;flex-direction:column;justify-content:flex-start;margin-left:20px;width:50%;gap:8px;@media (min-width:761px){width:auto;}"
]);
const $7fb0feabf372b90f$var$Field = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ArticleInfo__Field",
    componentId: "sc-j1d5tq-3"
})([
    "display:flex;flex-direction:column;text-align:left;"
]);
const $7fb0feabf372b90f$var$FieldName = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).span.withConfig({
    displayName: "ArticleInfo__FieldName",
    componentId: "sc-j1d5tq-4"
})([
    "display:inline-block;width:100%;color:",
    ";font-family:Inter,sans-serif;font-size:14px;font-weight:500;"
], (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue']);
const $7fb0feabf372b90f$var$FieldValue = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).span.withConfig({
    displayName: "ArticleInfo__FieldValue",
    componentId: "sc-j1d5tq-5"
})([
    "display:inline-block;width:100%;max-width:150px;color:#0d3240;font-family:Inter,sans-serif;font-size:16px;font-weight:bold;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;line-height:1.4;letter-spacing:normal;text-align:left;@media (min-width:761px){max-width:none;}"
]);
const $7fb0feabf372b90f$var$ImageContainer = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ArticleInfo__ImageContainer",
    componentId: "sc-j1d5tq-6"
})([
    "position:relative;display:inline-flex;align-self:center;border-radius:10px;padding:6px 5px 5px 6px;background-color:#f0f0f0;"
]);
const $7fb0feabf372b90f$var$ArticleInfo = (props)=>{
    const { articleName: articleName, manufacturer: manufacturer, productSrc: productSrc, matching: matching, sum: sum, emitter: emitter, recommendationPriceEnabled: recommendationPriceEnabled, recommendationMatchingCodeEnabled: recommendationMatchingCodeEnabled } = props;
    const matchId = matching.matching_id;
    const recommendationCode = matchId.substring(matchId.length - 4);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($7fb0feabf372b90f$var$ArticleData, {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7fb0feabf372b90f$var$ImageContainer, {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7fb0feabf372b90f$var$Icon, {
                    src: productSrc !== '' && productSrc !== undefined ? productSrc : (0, (/*@__PURE__*/$parcel$interopDefault($a50e59d7355bb9aa$exports)))
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($7fb0feabf372b90f$var$TextFields, {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($7fb0feabf372b90f$var$Field, {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7fb0feabf372b90f$var$FieldName, {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "drv.matching.article.label"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7fb0feabf372b90f$var$FieldValue, {
                                children: articleName
                            })
                        ]
                    }),
                    sum && recommendationPriceEnabled && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($7fb0feabf372b90f$var$Field, {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7fb0feabf372b90f$var$FieldName, {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "drv.matching.price.label"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7fb0feabf372b90f$var$FieldValue, {
                                children: sum
                            })
                        ]
                    }),
                    recommendationMatchingCodeEnabled && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($7fb0feabf372b90f$var$Field, {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7fb0feabf372b90f$var$FieldName, {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "drv.matching.code.label"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7fb0feabf372b90f$var$FieldValue, {
                                children: recommendationCode
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $7fb0feabf372b90f$export$2e2bcd8739ae039 = $7fb0feabf372b90f$var$ArticleInfo;






parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");

parcelRequire("6cds3");



const $a58a64c681e03a20$var$DefaultTheme = {
    name: 'default',
    color: {
        primary: (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue'],
        secondary: (0, $4bd05a80e138995f$export$8f45430ccf837300).blackish,
        success: (0, $4bd05a80e138995f$export$8f45430ccf837300).emerald,
        danger: (0, $4bd05a80e138995f$export$8f45430ccf837300)['reddish-pink']
    },
    ctaButton: {
        arrowDisplay: 'inline-block',
        background: (0, $4bd05a80e138995f$export$8f45430ccf837300).white,
        border: '0 none',
        borderRadius: '10px',
        boxShadow: '0 0 2px 0 rgba(30, 78, 95, 0.7)',
        color: (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue'],
        filter: 'invert(26%) sepia(14%) saturate(1718%) hue-rotate(150deg) brightness(97%) contrast(97%)',
        font: 'normal 400 14px Inter, sans-serif',
        icon: (0, $17bf087df6a33d6e$export$ec7dcaac71d9599d).fptLogoSimple,
        iconHeight: '13.7px',
        label: 'drv.cta-button.label',
        margin: '16px 0',
        minHeight: '45px',
        padding: '0px 8px',
        width: '100%',
        recommendationFont: '900 22px Inter, sans-serif'
    },
    ctaLink: {
        background: 'none',
        font: '1rem UniversalSans600',
        textDecoration: 'underline',
        color: '#5f7285',
        filter: 'none',
        padding: 0,
        margin: '1rem 0',
        hover_textDecoration: 'underline',
        iconHeight: '15px'
    },
    padding: '24px',
    'text-size-large': '25px',
    'text-size-medium': '16px',
    'text-size-small': '14px',
    'text-margin-bottom-large': '37px',
    'btn-bg-color-primary': (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue'],
    'btn-color-primary': '#fefffe',
    'btn-border-color-primary': '#322f30',
    'btn-bg-color-secondary': 'transparent',
    'btn-color-secondary': (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue'],
    'btn-color-danger': (0, $4bd05a80e138995f$export$8f45430ccf837300).almond,
    'btn-bg-color-danger': (0, $4bd05a80e138995f$export$8f45430ccf837300)['reddish-pink'],
    'btn-border-color-secondary': (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue'],
    // '#322f30'
    'btn-border-radius-primary': '50px',
    'btn-border-radius-secondary': '50px',
    'btn-color-link-primary': (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue'],
    'btn-bg-color-link-primary': 'transparent',
    'btn-color-link-danger': (0, $4bd05a80e138995f$export$8f45430ccf837300)['reddish-pink'],
    'btn-bg-color-link-danger': 'transparent',
    'btn-padding': '17px 50px',
    'btn-padding-top-bottom': '10px',
    'tooltip-z-index': 999,
    tooltip: {
        position: 'TOP'
    }
};
var $a58a64c681e03a20$export$2e2bcd8739ae039 = $a58a64c681e03a20$var$DefaultTheme;





const $1aead25b3bf4ef91$var$Button = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).button.withConfig({
    displayName: "Button",
    componentId: "sc-1itpa8u-0"
})([
    "padding:",
    ";border-width:2px;border-style:solid;font-size:16px;font-weight:700;font-family:Inter,sans-serif;cursor:pointer;text-transform:none;display:block;line-height:1.15;&.primary{background-color:",
    ";border-color:",
    ";color:",
    ";border-radius:",
    ";margin:20px auto;white-space:nowrap;line-height:1;&:disabled{opacity:0.2;}}&.secondary{background-color:",
    ";border-color:",
    ";color:",
    ";border-radius:",
    ";line-height:1;}&.danger{background-color:",
    ";color:",
    ";border-radius:",
    ";margin:",
    " auto;line-height:1;}&.link-primary{color:",
    ";text-decoration:none;padding:18px;font-weight:bold;border:none;background:none;box-shadow:none;display:inline-block;background-color:",
    ";line-height:1;}&.link-secondary{background-color:",
    ";border:none;color:",
    ";border-radius:",
    ";width:100%;padding-top:",
    ";padding-bottom:",
    ";transition:all 0.3s;&:active{filter:brightness(0.8);opacity:0.5;}}&.link-danger{color:",
    ";text-decoration:underline;border:none;background:none;box-shadow:none;display:inline-block;background-color:",
    ";}&.wide-primary{background-color:",
    ";border-color:",
    ";color:#fff;border-radius:",
    ";width:100%;padding:",
    ";margin:20px 0;transition:all 0.3s;border-width:1px;white-space:nowrap;line-height:1;&:hover{filter:brightness(1.2);}&:active{filter:brightness(0.8);}&:disabled{opacity:0.2;}}&.wide-secondary{background-color:",
    ";border-color:",
    ";color:",
    ";border-radius:",
    ";width:100%;padding:",
    ";margin:20px 0;transition:all 0.3s;line-height:1;font-weight:bold;&:active{filter:brightness(0.8);opacity:0.5;}}&.wide-danger{background-color:",
    ";color:",
    ";border-radius:",
    ";margin:",
    " auto;width:100%;line-height:1;}&.fpt-button--center{margin:auto;}"
], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-padding'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-color-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-radius-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['dark-slate-blue'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-radius-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-danger'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-danger'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-radius-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-padding'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-link-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-link-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-radius-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-padding-top-bottom'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-padding-top-bottom'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-link-danger'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-link-danger'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-color-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-radius-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-padding'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-color-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-radius-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-padding'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-danger'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-danger'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-radius-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-padding']);
const $1aead25b3bf4ef91$export$d5992c1fec905475 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).a.withConfig({
    displayName: "Button__ButtonLink",
    componentId: "sc-1itpa8u-1"
})([
    "display:inline-block;padding:",
    ";border-width:1px;border-style:solid;font-size:16px;font-weight:500;font-family:Inter,sans-serif;cursor:pointer;text-transform:none;display:block;line-height:1.15;&.primary{background-color:",
    ";border-color:",
    ";color:",
    ";border-radius:",
    ";margin:20px auto;white-space:nowrap;line-height:1;&:disabled{opacity:0.2;}}&.secondary{background-color:",
    ";border-color:",
    ";color:",
    ";border-radius:",
    ";line-height:1;}&.danger{background-color:",
    ";color:",
    ";border-radius:",
    ";margin:",
    " auto;line-height:1;}&.link-primary{color:",
    ";text-decoration:none;padding:18px;font-weight:bold;border:none;background:none;box-shadow:none;display:inline-block;background-color:",
    ";line-height:1;}&.link-secondary{background-color:",
    ";border:none;color:",
    ";border-radius:",
    ";width:100%;padding-top:",
    ";padding-bottom:",
    ";transition:all 0.3s;&:active{filter:brightness(0.8);opacity:0.5;}}&.link-danger{color:",
    ";text-decoration:underline;border:none;background:none;box-shadow:none;display:inline-block;background-color:",
    ";}&.wide-primary{background-color:",
    ";border-color:",
    ";color:#fff;border-radius:",
    ";width:100%;padding:17px 0;margin:20px 0;transition:all 0.3s;border-width:1px;white-space:nowrap;line-height:1;&:hover{filter:brightness(1.2);}&:active{filter:brightness(0.8);}&:disabled{opacity:0.2;}}&.wide-secondary{background-color:",
    ";border-color:",
    ";color:",
    ";border-radius:",
    ";width:100%;padding:",
    ";margin:20px 0;transition:all 0.3s;line-height:1;&:active{filter:brightness(0.8);opacity:0.5;}}&.wide-danger{background-color:",
    ";color:",
    ";border-radius:",
    ";margin:",
    " auto;width:100%;line-height:1;}&.fpt-button--center{margin:auto;}"
], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-padding'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-color-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-radius-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['dark-slate-blue'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-radius-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-danger'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-danger'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-radius-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-padding'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-link-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-link-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-radius-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-padding-top-bottom'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-padding-top-bottom'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-link-danger'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-link-danger'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-color-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-radius-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-color-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-radius-secondary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-padding'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-bg-color-danger'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-color-danger'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-border-radius-primary'], (0, $a58a64c681e03a20$export$2e2bcd8739ae039)['btn-padding']);
var $1aead25b3bf4ef91$export$2e2bcd8739ae039 = $1aead25b3bf4ef91$var$Button;






const $18571d7c3acedda0$export$e004b8b30ca31361 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "RecommendationOptions",
    componentId: "sc-1tpvvrd-0"
})([
    "margin-bottom:0;padding:0;"
]);





var $6cds3 = parcelRequire("6cds3");

var $gzLuY = parcelRequire("gzLuY");
var $3fe9119940fa16b8$require$Buffer = $gzLuY.Buffer;

var $a8i8g = parcelRequire("a8i8g");
function $3fe9119940fa16b8$var$_mergeNamespaces(n, m) {
    m.forEach(function(e) {
        e && typeof e !== 'string' && !Array.isArray(e) && Object.keys(e).forEach(function(k) {
            if (k !== 'default' && !(k in n)) {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
    });
    return Object.freeze(n);
}
const $3fe9119940fa16b8$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $3fe9119940fa16b8$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $3fe9119940fa16b8$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === 'string') args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $3fe9119940fa16b8$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $3fe9119940fa16b8$var$Logger(this.logger, options);
    }
}
var $3fe9119940fa16b8$var$baseLogger = new $3fe9119940fa16b8$var$Logger();
let $3fe9119940fa16b8$var$EventEmitter$1 = class EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
};
const $3fe9119940fa16b8$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $3fe9119940fa16b8$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $3fe9119940fa16b8$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $3fe9119940fa16b8$var$lastOfPathSeparatorRegExp = /###/g;
const $3fe9119940fa16b8$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($3fe9119940fa16b8$var$lastOfPathSeparatorRegExp, '.') : key;
const $3fe9119940fa16b8$var$canNotTraverseDeeper = (object)=>!object || typeof object === 'string';
const $3fe9119940fa16b8$var$getLastOfPath = (object, path, Empty)=>{
    const stack = typeof path !== 'string' ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($3fe9119940fa16b8$var$canNotTraverseDeeper(object)) return {};
        const key = $3fe9119940fa16b8$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($3fe9119940fa16b8$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $3fe9119940fa16b8$var$cleanKey(stack[stackIndex])
    };
};
const $3fe9119940fa16b8$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $3fe9119940fa16b8$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $3fe9119940fa16b8$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $3fe9119940fa16b8$var$getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $3fe9119940fa16b8$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $3fe9119940fa16b8$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $3fe9119940fa16b8$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $3fe9119940fa16b8$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
};
const $3fe9119940fa16b8$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $3fe9119940fa16b8$var$getPath(data, key);
    if (value !== undefined) return value;
    return $3fe9119940fa16b8$var$getPath(defaultData, key);
};
const $3fe9119940fa16b8$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $3fe9119940fa16b8$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $3fe9119940fa16b8$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $3fe9119940fa16b8$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $3fe9119940fa16b8$var$escape$1 = (data)=>{
    if (typeof data === 'string') return data.replace(/[&<>"'\/]/g, (s)=>$3fe9119940fa16b8$var$_entityMap[s]);
    return data;
};
class $3fe9119940fa16b8$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $3fe9119940fa16b8$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $3fe9119940fa16b8$var$looksLikeObjectPathRegExpCache = new $3fe9119940fa16b8$var$RegExpCache(20);
const $3fe9119940fa16b8$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $3fe9119940fa16b8$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $3fe9119940fa16b8$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $3fe9119940fa16b8$var$deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $3fe9119940fa16b8$var$getCleanedCode = (code)=>{
    if (code && code.indexOf('_') > 0) return code.replace('_', '-');
    return code;
};
class $3fe9119940fa16b8$var$ResourceStore extends $3fe9119940fa16b8$var$EventEmitter$1 {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if (typeof key === 'string' && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $3fe9119940fa16b8$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
        return $3fe9119940fa16b8$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $3fe9119940fa16b8$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === 'string' || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $3fe9119940fa16b8$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $3fe9119940fa16b8$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $3fe9119940fa16b8$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === 'v1') return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $3fe9119940fa16b8$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $3fe9119940fa16b8$var$checkedLoadedFor = {};
class $3fe9119940fa16b8$var$Translator extends $3fe9119940fa16b8$var$EventEmitter$1 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $3fe9119940fa16b8$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $3fe9119940fa16b8$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$3fe9119940fa16b8$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === 'string') namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && Array.isArray(res))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(res);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
            const hasDefaultValue = $3fe9119940fa16b8$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : '';
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === 'string' ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $3fe9119940fa16b8$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === 'string') keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$3fe9119940fa16b8$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $3fe9119940fa16b8$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && typeof options.replace !== 'string';
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
const $3fe9119940fa16b8$var$capitalize = (string)=>string.charAt(0).toUpperCase() + string.slice(1);
class $3fe9119940fa16b8$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $3fe9119940fa16b8$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $3fe9119940fa16b8$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $3fe9119940fa16b8$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === 'string' && code.indexOf('-') > -1) {
            const specialCases = [
                'hans',
                'hant',
                'latn',
                'cyrl',
                'cans',
                'mong',
                'arab'
            ];
            let p = code.split('-');
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $3fe9119940fa16b8$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $3fe9119940fa16b8$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $3fe9119940fa16b8$var$capitalize(p[2].toLowerCase());
            }
            return p.join('-');
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if (typeof fallbacks === 'string') fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === 'string' && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === 'string') addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $3fe9119940fa16b8$var$sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $3fe9119940fa16b8$var$_rulesPluralsTypes = {
    1: (n)=>Number(n > 1),
    2: (n)=>Number(n != 1),
    3: (n)=>0,
    4: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    5: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5),
    6: (n)=>Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2),
    7: (n)=>Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    8: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3),
    9: (n)=>Number(n >= 2),
    10: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4),
    11: (n)=>Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3),
    12: (n)=>Number(n % 10 != 1 || n % 100 == 11),
    13: (n)=>Number(n !== 0),
    14: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3),
    15: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    16: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2),
    17: (n)=>Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1),
    18: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : 2),
    19: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3),
    20: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2),
    21: (n)=>Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0),
    22: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3)
};
const $3fe9119940fa16b8$var$nonIntlVersions = [
    'v1',
    'v2',
    'v3'
];
const $3fe9119940fa16b8$var$intlVersions = [
    'v4'
];
const $3fe9119940fa16b8$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $3fe9119940fa16b8$var$createRules = ()=>{
    const rules = {};
    $3fe9119940fa16b8$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $3fe9119940fa16b8$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
};
class $3fe9119940fa16b8$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $3fe9119940fa16b8$var$baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || $3fe9119940fa16b8$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = $3fe9119940fa16b8$var$createRules();
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            const cleanedCode = $3fe9119940fa16b8$var$getCleanedCode(code === 'dev' ? 'en' : code);
            const type = options.ordinal ? 'ordinal' : 'cardinal';
            const cacheKey = JSON.stringify({
                cleanedCode: cleanedCode,
                type: type
            });
            if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
            const rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
            this.pluralRulesCache[cacheKey] = rule;
            return rule;
        } catch (err) {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$3fe9119940fa16b8$var$suffixesOrder[pluralCategory1] - $3fe9119940fa16b8$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return '';
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = 'plural';
            else if (suffix === 1) suffix = '';
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === 'v1') {
            if (suffix === 1) return '';
            if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$3fe9119940fa16b8$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
const $3fe9119940fa16b8$var$deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $3fe9119940fa16b8$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === 'string') {
        path = $3fe9119940fa16b8$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $3fe9119940fa16b8$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $3fe9119940fa16b8$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $3fe9119940fa16b8$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $3fe9119940fa16b8$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1$1 !== undefined ? escape$1$1 : $3fe9119940fa16b8$var$escape$1;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $3fe9119940fa16b8$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $3fe9119940fa16b8$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $3fe9119940fa16b8$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $3fe9119940fa16b8$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $3fe9119940fa16b8$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $3fe9119940fa16b8$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $3fe9119940fa16b8$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($3fe9119940fa16b8$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$3fe9119940fa16b8$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $3fe9119940fa16b8$var$regexSafe(this.escape(val)) : $3fe9119940fa16b8$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === 'string' ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (typeof value !== 'string' && !this.useRawValueToEscape) value = $3fe9119940fa16b8$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== 'string') return value;
            if (typeof value !== 'string') value = $3fe9119940fa16b8$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $3fe9119940fa16b8$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $3fe9119940fa16b8$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (val, lng, options)=>{
        let optForCache = options;
        if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) optForCache = {
            ...optForCache,
            [options.interpolationkey]: undefined
        };
        const key = lng + JSON.stringify(optForCache);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($3fe9119940fa16b8$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
class $3fe9119940fa16b8$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $3fe9119940fa16b8$var$baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: $3fe9119940fa16b8$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $3fe9119940fa16b8$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $3fe9119940fa16b8$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $3fe9119940fa16b8$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: $3fe9119940fa16b8$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $3fe9119940fa16b8$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $3fe9119940fa16b8$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $3fe9119940fa16b8$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $3fe9119940fa16b8$var$Connector extends $3fe9119940fa16b8$var$EventEmitter$1 {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $3fe9119940fa16b8$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $3fe9119940fa16b8$var$pushPath(q.loaded, [
                lng
            ], ns);
            $3fe9119940fa16b8$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === 'string') namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $3fe9119940fa16b8$var$get$2 = ()=>({
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if (typeof args[1] === 'string') ret.defaultValue = args[1];
            if (typeof args[2] === 'string') ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    });
const $3fe9119940fa16b8$var$transformOptions = (options)=>{
    if (typeof options.ns === 'string') options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
const $3fe9119940fa16b8$var$noop$1 = ()=>{};
const $3fe9119940fa16b8$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $3fe9119940fa16b8$var$I18n extends $3fe9119940fa16b8$var$EventEmitter$1 {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $3fe9119940fa16b8$var$transformOptions(options);
        this.services = {};
        this.logger = $3fe9119940fa16b8$var$baseLogger;
        this.modules = {
            external: []
        };
        $3fe9119940fa16b8$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === 'string') options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $3fe9119940fa16b8$var$get$2();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$3fe9119940fa16b8$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $3fe9119940fa16b8$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $3fe9119940fa16b8$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== 'undefined') formatter = $3fe9119940fa16b8$var$Formatter;
            const lu = new $3fe9119940fa16b8$var$LanguageUtil(this.options);
            this.store = new $3fe9119940fa16b8$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $3fe9119940fa16b8$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $3fe9119940fa16b8$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $3fe9119940fa16b8$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $3fe9119940fa16b8$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $3fe9119940fa16b8$var$Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $3fe9119940fa16b8$var$noop$1;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $3fe9119940fa16b8$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $3fe9119940fa16b8$var$noop$1;
        let usedCallback = callback;
        const usedLng = typeof language === 'string' ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $3fe9119940fa16b8$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $3fe9119940fa16b8$var$noop$1;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $3fe9119940fa16b8$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $3fe9119940fa16b8$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit('languageChanged', l);
                this.logger.log('languageChanged', l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === 'string' ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            if (options.keyPrefix !== '') options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === 'string') fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $3fe9119940fa16b8$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === 'string') ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $3fe9119940fa16b8$var$defer();
        if (typeof lngs === 'string') lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services && this.services.languageUtils || new $3fe9119940fa16b8$var$LanguageUtil($3fe9119940fa16b8$var$get$2());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $3fe9119940fa16b8$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $3fe9119940fa16b8$var$noop$1;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $3fe9119940fa16b8$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $3fe9119940fa16b8$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $3fe9119940fa16b8$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $3fe9119940fa16b8$export$a7357cdd1f0b0168 = $3fe9119940fa16b8$var$I18n.createInstance();
$3fe9119940fa16b8$export$a7357cdd1f0b0168.createInstance = $3fe9119940fa16b8$var$I18n.createInstance;
$3fe9119940fa16b8$export$a7357cdd1f0b0168.createInstance;
$3fe9119940fa16b8$export$a7357cdd1f0b0168.dir;
$3fe9119940fa16b8$export$a7357cdd1f0b0168.init;
$3fe9119940fa16b8$export$a7357cdd1f0b0168.loadResources;
$3fe9119940fa16b8$export$a7357cdd1f0b0168.reloadResources;
$3fe9119940fa16b8$export$a7357cdd1f0b0168.use;
$3fe9119940fa16b8$export$a7357cdd1f0b0168.changeLanguage;
$3fe9119940fa16b8$export$a7357cdd1f0b0168.getFixedT;
$3fe9119940fa16b8$export$a7357cdd1f0b0168.t;
$3fe9119940fa16b8$export$a7357cdd1f0b0168.exists;
$3fe9119940fa16b8$export$a7357cdd1f0b0168.setDefaultNamespace;
$3fe9119940fa16b8$export$a7357cdd1f0b0168.hasLoadedNamespace;
$3fe9119940fa16b8$export$a7357cdd1f0b0168.loadNamespaces;
$3fe9119940fa16b8$export$a7357cdd1f0b0168.loadLanguages;
function $3fe9119940fa16b8$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function $3fe9119940fa16b8$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var f = n.default;
    if (typeof f == "function") {
        var a = function a() {
            if (this instanceof a) return Reflect.construct(f, arguments, this.constructor);
            return f.apply(this, arguments);
        };
        a.prototype = f.prototype;
    } else a = {};
    Object.defineProperty(a, '__esModule', {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ var $3fe9119940fa16b8$var$voidElements = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};
var $3fe9119940fa16b8$var$e$1 = /*@__PURE__*/ $3fe9119940fa16b8$var$getDefaultExportFromCjs($3fe9119940fa16b8$var$voidElements);
var $3fe9119940fa16b8$var$t$1 = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $3fe9119940fa16b8$var$n$2(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ($3fe9119940fa16b8$var$e$1[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($3fe9119940fa16b8$var$t$1), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $3fe9119940fa16b8$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $3fe9119940fa16b8$var$i$1 = /^\s*$/, $3fe9119940fa16b8$var$s$1 = Object.create(null);
function $3fe9119940fa16b8$var$a$1(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($3fe9119940fa16b8$var$a$1, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $3fe9119940fa16b8$var$c$1 = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $3fe9119940fa16b8$var$s$1);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($3fe9119940fa16b8$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $3fe9119940fa16b8$var$n$2(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $3fe9119940fa16b8$var$n$2(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $3fe9119940fa16b8$var$i$1.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $3fe9119940fa16b8$var$a$1("", t);
        }, "");
    }
};
function $3fe9119940fa16b8$var$warn() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if ($3fe9119940fa16b8$var$isString$2(args[0])) args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $3fe9119940fa16b8$var$alreadyWarned = {};
function $3fe9119940fa16b8$var$warnOnce() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if ($3fe9119940fa16b8$var$isString$2(args[0]) && $3fe9119940fa16b8$var$alreadyWarned[args[0]]) return;
    if ($3fe9119940fa16b8$var$isString$2(args[0])) $3fe9119940fa16b8$var$alreadyWarned[args[0]] = new Date();
    $3fe9119940fa16b8$var$warn(...args);
}
const $3fe9119940fa16b8$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $3fe9119940fa16b8$var$loadNamespaces = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $3fe9119940fa16b8$var$loadedClb(i18n, cb));
};
const $3fe9119940fa16b8$var$loadLanguages = (i18n, lng, ns, cb)=>{
    if ($3fe9119940fa16b8$var$isString$2(ns)) ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $3fe9119940fa16b8$var$loadedClb(i18n, cb));
};
const $3fe9119940fa16b8$var$oldI18nextHasLoadedNamespace = function(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
};
const $3fe9119940fa16b8$var$hasLoadedNamespace = function(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $3fe9119940fa16b8$var$warnOnce('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $3fe9119940fa16b8$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $3fe9119940fa16b8$var$isString$2 = (obj)=>typeof obj === 'string';
const $3fe9119940fa16b8$var$isObject$1 = (obj)=>typeof obj === 'object' && obj !== null;
const $3fe9119940fa16b8$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $3fe9119940fa16b8$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $3fe9119940fa16b8$var$unescapeHtmlEntity = (m)=>$3fe9119940fa16b8$var$htmlEntities[m];
const $3fe9119940fa16b8$var$unescape = (text)=>text.replace($3fe9119940fa16b8$var$matchHtmlEntity, $3fe9119940fa16b8$var$unescapeHtmlEntity);
let $3fe9119940fa16b8$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $3fe9119940fa16b8$var$unescape
};
const $3fe9119940fa16b8$var$setDefaults = function() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $3fe9119940fa16b8$var$defaultOptions = {
        ...$3fe9119940fa16b8$var$defaultOptions,
        ...options
    };
};
const $3fe9119940fa16b8$var$getDefaults$1 = ()=>$3fe9119940fa16b8$var$defaultOptions;
let $3fe9119940fa16b8$var$i18nInstance;
const $3fe9119940fa16b8$var$setI18n = (instance)=>{
    $3fe9119940fa16b8$var$i18nInstance = instance;
};
const $3fe9119940fa16b8$var$getI18n = ()=>$3fe9119940fa16b8$var$i18nInstance;
const $3fe9119940fa16b8$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $3fe9119940fa16b8$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $3fe9119940fa16b8$var$getAsArray(children) : children;
};
const $3fe9119940fa16b8$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $6cds3.isValidElement));
const $3fe9119940fa16b8$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $3fe9119940fa16b8$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $3fe9119940fa16b8$var$nodesToString = (children, i18nOptions)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $3fe9119940fa16b8$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if ($3fe9119940fa16b8$var$isString$2(child)) stringNode += `${child}`;
        else if ((0, $6cds3.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) stringNode += `<${type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && $3fe9119940fa16b8$var$isString$2(childChildren)) stringNode += `<${type}>${childChildren}</${type}>`;
            else {
                const content = $3fe9119940fa16b8$var$nodesToString(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) $3fe9119940fa16b8$var$warn(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if ($3fe9119940fa16b8$var$isObject$1(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else $3fe9119940fa16b8$var$warn(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else $3fe9119940fa16b8$var$warn(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
};
const $3fe9119940fa16b8$var$renderNodes = (children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    const getData = (childs)=>{
        const childrenArray = $3fe9119940fa16b8$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ($3fe9119940fa16b8$var$isString$2(child)) return;
            if ($3fe9119940fa16b8$var$hasChildren(child)) getData($3fe9119940fa16b8$var$getChildren(child));
            else if ($3fe9119940fa16b8$var$isObject$1(child) && !(0, $6cds3.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const ast = $3fe9119940fa16b8$var$c$1.parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $3fe9119940fa16b8$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $3fe9119940fa16b8$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $6cds3.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $6cds3.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $6cds3.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.ref
            }, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $3fe9119940fa16b8$var$getAsArray(reactNode);
        const astNodes = $3fe9119940fa16b8$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $3fe9119940fa16b8$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $6cds3.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $3fe9119940fa16b8$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && $3fe9119940fa16b8$var$isObject$1(child) && child.dummy && !isElement;
                const isKnownComponent = $3fe9119940fa16b8$var$isObject$1(children) && Object.hasOwnProperty.call(children, node.name);
                if ($3fe9119940fa16b8$var$isString$2(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($3fe9119940fa16b8$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $6cds3.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $6cds3.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ($3fe9119940fa16b8$var$isObject$1(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $6cds3.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $3fe9119940fa16b8$var$getAsArray(children || []));
    return $3fe9119940fa16b8$var$getChildren(result[0]);
};
function $3fe9119940fa16b8$var$Trans$1(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || $3fe9119940fa16b8$var$getI18n();
    if (!i18n) {
        $3fe9119940fa16b8$var$warnOnce('You will need to pass in an i18next instance by using i18nextReactModule');
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...$3fe9119940fa16b8$var$getDefaults$1(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = $3fe9119940fa16b8$var$isString$2(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $3fe9119940fa16b8$var$nodesToString(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    if (components) Object.keys(components).forEach((c)=>{
        const comp = components[c];
        if (typeof comp.type === 'function' || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
        function Componentized() {
            return (0, $6cds3.createElement)((0, $6cds3.Fragment), null, comp);
        }
        components[c] = (0, $6cds3.createElement)(Componentized);
    });
    const content = $3fe9119940fa16b8$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $6cds3.createElement)(useAsParent, additionalProps, content) : content;
}
const $3fe9119940fa16b8$var$initReactI18next = {
    type: '3rdParty',
    init (instance) {
        $3fe9119940fa16b8$var$setDefaults(instance.options.react);
        $3fe9119940fa16b8$var$setI18n(instance);
    }
};
const $3fe9119940fa16b8$var$I18nContext = (0, $6cds3.createContext)();
class $3fe9119940fa16b8$var$ReportNamespaces {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces = ()=>Object.keys(this.usedNamespaces);
}
function $3fe9119940fa16b8$var$Trans(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $6cds3.useContext)($3fe9119940fa16b8$var$I18nContext) || {};
    const i18n = i18nFromProps || i18nFromContext || $3fe9119940fa16b8$var$getI18n();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return $3fe9119940fa16b8$var$Trans$1({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}
const $3fe9119940fa16b8$var$usePrevious = (value, ignore)=>{
    const ref = (0, $6cds3.useRef)();
    (0, $6cds3.useEffect)(()=>{
        ref.current = value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
const $3fe9119940fa16b8$var$alwaysNewT = (i18n, language, namespace, keyPrefix)=>i18n.getFixedT(language, namespace, keyPrefix);
const $3fe9119940fa16b8$var$useMemoizedT = (i18n, language, namespace, keyPrefix)=>(0, $6cds3.useCallback)($3fe9119940fa16b8$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
const $3fe9119940fa16b8$var$useTranslation = function(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $6cds3.useContext)($3fe9119940fa16b8$var$I18nContext) || {};
    const i18n = i18nFromProps || i18nFromContext || $3fe9119940fa16b8$var$getI18n();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new $3fe9119940fa16b8$var$ReportNamespaces();
    if (!i18n) {
        $3fe9119940fa16b8$var$warnOnce('You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if ($3fe9119940fa16b8$var$isString$2(optsOrDefaultValue)) return optsOrDefaultValue;
            if ($3fe9119940fa16b8$var$isObject$1(optsOrDefaultValue) && $3fe9119940fa16b8$var$isString$2(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) $3fe9119940fa16b8$var$warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...$3fe9119940fa16b8$var$getDefaults$1(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = $3fe9119940fa16b8$var$isString$2(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>$3fe9119940fa16b8$var$hasLoadedNamespace(n, i18n, i18nOptions));
    const memoGetT = $3fe9119940fa16b8$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$3fe9119940fa16b8$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $6cds3.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $3fe9119940fa16b8$var$usePrevious(joinedNS);
    const isMounted = (0, $6cds3.useRef)(true);
    (0, $6cds3.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) $3fe9119940fa16b8$var$loadLanguages(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else $3fe9119940fa16b8$var$loadNamespaces(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        const boundReset = ()=>{
            if (isMounted.current) setT(getNewT);
        };
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) $3fe9119940fa16b8$var$loadLanguages(i18n, props.lng, namespaces, ()=>resolve());
        else $3fe9119940fa16b8$var$loadNamespaces(i18n, namespaces, ()=>resolve());
    });
};
function $3fe9119940fa16b8$var$_typeof$2(o) {
    "@babel/helpers - typeof";
    return $3fe9119940fa16b8$var$_typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3fe9119940fa16b8$var$_typeof$2(o);
}
function $3fe9119940fa16b8$var$hasXMLHttpRequest() {
    return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : $3fe9119940fa16b8$var$_typeof$2(XMLHttpRequest)) === 'object';
}
function $3fe9119940fa16b8$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === 'function';
}
function $3fe9119940fa16b8$var$makePromise(maybePromise) {
    if ($3fe9119940fa16b8$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}
var $3fe9119940fa16b8$var$global$1 = typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
function $3fe9119940fa16b8$var$commonjsRequire(path) {
    throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var $3fe9119940fa16b8$var$getFetch$1 = {
    exports: {}
};
var $3fe9119940fa16b8$var$nodePonyfill = {
    exports: {}
};
var $3fe9119940fa16b8$var$domain;
// This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).
function $3fe9119940fa16b8$var$EventHandlers() {}
$3fe9119940fa16b8$var$EventHandlers.prototype = Object.create(null);
function $3fe9119940fa16b8$var$EventEmitter() {
    $3fe9119940fa16b8$var$EventEmitter.init.call(this);
}
// nodejs oddity
// require('events') === require('events').EventEmitter
$3fe9119940fa16b8$var$EventEmitter.EventEmitter = $3fe9119940fa16b8$var$EventEmitter;
$3fe9119940fa16b8$var$EventEmitter.usingDomains = false;
$3fe9119940fa16b8$var$EventEmitter.prototype.domain = undefined;
$3fe9119940fa16b8$var$EventEmitter.prototype._events = undefined;
$3fe9119940fa16b8$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$3fe9119940fa16b8$var$EventEmitter.defaultMaxListeners = 10;
$3fe9119940fa16b8$var$EventEmitter.init = function() {
    this.domain = null;
    if ($3fe9119940fa16b8$var$EventEmitter.usingDomains) // if there is an active domain, then attach to it.
    $3fe9119940fa16b8$var$domain.active;
    if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
        this._events = new $3fe9119940fa16b8$var$EventHandlers();
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$3fe9119940fa16b8$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || isNaN(n)) throw new TypeError('"n" argument must be a positive number');
    this._maxListeners = n;
    return this;
};
function $3fe9119940fa16b8$var$$getMaxListeners(that) {
    if (that._maxListeners === undefined) return $3fe9119940fa16b8$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$3fe9119940fa16b8$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $3fe9119940fa16b8$var$$getMaxListeners(this);
};
// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function $3fe9119940fa16b8$var$emitNone(handler, isFn, self1) {
    if (isFn) handler.call(self1);
    else {
        var len = handler.length;
        var listeners = $3fe9119940fa16b8$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1);
    }
}
function $3fe9119940fa16b8$var$emitOne(handler, isFn, self1, arg1) {
    if (isFn) handler.call(self1, arg1);
    else {
        var len = handler.length;
        var listeners = $3fe9119940fa16b8$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1);
    }
}
function $3fe9119940fa16b8$var$emitTwo(handler, isFn, self1, arg1, arg2) {
    if (isFn) handler.call(self1, arg1, arg2);
    else {
        var len = handler.length;
        var listeners = $3fe9119940fa16b8$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2);
    }
}
function $3fe9119940fa16b8$var$emitThree(handler, isFn, self1, arg1, arg2, arg3) {
    if (isFn) handler.call(self1, arg1, arg2, arg3);
    else {
        var len = handler.length;
        var listeners = $3fe9119940fa16b8$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2, arg3);
    }
}
function $3fe9119940fa16b8$var$emitMany(handler, isFn, self1, args) {
    if (isFn) handler.apply(self1, args);
    else {
        var len = handler.length;
        var listeners = $3fe9119940fa16b8$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].apply(self1, args);
    }
}
$3fe9119940fa16b8$var$EventEmitter.prototype.emit = function emit(type) {
    var er, handler, len, args, i, events, domain;
    var doError = type === 'error';
    events = this._events;
    if (events) doError = doError && events.error == null;
    else if (!doError) return false;
    domain = this.domain;
    // If there is no 'error' event listener then throw.
    if (doError) {
        er = arguments[1];
        if (domain) {
            if (!er) er = new Error('Uncaught, unspecified "error" event');
            er.domainEmitter = this;
            er.domain = domain;
            er.domainThrown = false;
            domain.emit('error', er);
        } else if (er instanceof Error) throw er; // Unhandled 'error' event
        else {
            // At least give some kind of context to the user
            var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
            err.context = er;
            throw err;
        }
        return false;
    }
    handler = events[type];
    if (!handler) return false;
    var isFn = typeof handler === 'function';
    len = arguments.length;
    switch(len){
        // fast cases
        case 1:
            $3fe9119940fa16b8$var$emitNone(handler, isFn, this);
            break;
        case 2:
            $3fe9119940fa16b8$var$emitOne(handler, isFn, this, arguments[1]);
            break;
        case 3:
            $3fe9119940fa16b8$var$emitTwo(handler, isFn, this, arguments[1], arguments[2]);
            break;
        case 4:
            $3fe9119940fa16b8$var$emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
            break;
        // slower
        default:
            args = new Array(len - 1);
            for(i = 1; i < len; i++)args[i - 1] = arguments[i];
            $3fe9119940fa16b8$var$emitMany(handler, isFn, this, args);
    }
    return true;
};
function $3fe9119940fa16b8$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    events = target._events;
    if (!events) {
        events = target._events = new $3fe9119940fa16b8$var$EventHandlers();
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (!existing) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else // If we've already got an array, just append.
        if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        if (!existing.warned) {
            m = $3fe9119940fa16b8$var$$getMaxListeners(target);
            if (m && m > 0 && existing.length > m) {
                existing.warned = true;
                var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + type + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit');
                w.name = 'MaxListenersExceededWarning';
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                $3fe9119940fa16b8$var$emitWarning(w);
            }
        }
    }
    return target;
}
function $3fe9119940fa16b8$var$emitWarning(e) {
    typeof console.warn === 'function' ? console.warn(e) : console.log(e);
}
$3fe9119940fa16b8$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $3fe9119940fa16b8$var$_addListener(this, type, listener, false);
};
$3fe9119940fa16b8$var$EventEmitter.prototype.on = $3fe9119940fa16b8$var$EventEmitter.prototype.addListener;
$3fe9119940fa16b8$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $3fe9119940fa16b8$var$_addListener(this, type, listener, true);
};
function $3fe9119940fa16b8$var$_onceWrap(target, type, listener) {
    var fired = false;
    function g() {
        target.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(target, arguments);
        }
    }
    g.listener = listener;
    return g;
}
$3fe9119940fa16b8$var$EventEmitter.prototype.once = function once(type, listener) {
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    this.on(type, $3fe9119940fa16b8$var$_onceWrap(this, type, listener));
    return this;
};
$3fe9119940fa16b8$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    this.prependListener(type, $3fe9119940fa16b8$var$_onceWrap(this, type, listener));
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$3fe9119940fa16b8$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    events = this._events;
    if (!events) return this;
    list = events[type];
    if (!list) return this;
    if (list === listener || list.listener && list.listener === listener) {
        if (--this._eventsCount === 0) this._events = new $3fe9119940fa16b8$var$EventHandlers();
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list[0] = undefined;
            if (--this._eventsCount === 0) {
                this._events = new $3fe9119940fa16b8$var$EventHandlers();
                return this;
            } else delete events[type];
        } else $3fe9119940fa16b8$var$spliceOne(list, position);
        if (events.removeListener) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
// Alias for removeListener added in NodeJS 10.0
// https://nodejs.org/api/events.html#events_emitter_off_eventname_listener
$3fe9119940fa16b8$var$EventEmitter.prototype.off = function(type, listener) {
    return this.removeListener(type, listener);
};
$3fe9119940fa16b8$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events;
    events = this._events;
    if (!events) return this;
    // not listening for removeListener, no need to emit
    if (!events.removeListener) {
        if (arguments.length === 0) {
            this._events = new $3fe9119940fa16b8$var$EventHandlers();
            this._eventsCount = 0;
        } else if (events[type]) {
            if (--this._eventsCount === 0) this._events = new $3fe9119940fa16b8$var$EventHandlers();
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        for(var i = 0, key; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = new $3fe9119940fa16b8$var$EventHandlers();
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    do this.removeListener(type, listeners[listeners.length - 1]);
    while (listeners[0]);
    return this;
};
$3fe9119940fa16b8$var$EventEmitter.prototype.listeners = function listeners(type) {
    var evlistener;
    var ret;
    var events = this._events;
    if (!events) ret = [];
    else {
        evlistener = events[type];
        if (!evlistener) ret = [];
        else if (typeof evlistener === 'function') ret = [
            evlistener.listener || evlistener
        ];
        else ret = $3fe9119940fa16b8$var$unwrapListeners(evlistener);
    }
    return ret;
};
$3fe9119940fa16b8$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $3fe9119940fa16b8$var$listenerCount$1.call(emitter, type);
};
$3fe9119940fa16b8$var$EventEmitter.prototype.listenerCount = $3fe9119940fa16b8$var$listenerCount$1;
function $3fe9119940fa16b8$var$listenerCount$1(type) {
    var events = this._events;
    if (events) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
}
$3fe9119940fa16b8$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
// About 1.5x faster than the two-arg version of Array#splice().
function $3fe9119940fa16b8$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
function $3fe9119940fa16b8$var$arrayClone(arr, i) {
    var copy = new Array(i);
    while(i--)copy[i] = arr[i];
    return copy;
}
function $3fe9119940fa16b8$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
var $3fe9119940fa16b8$var$lookup = [];
var $3fe9119940fa16b8$var$revLookup = [];
var $3fe9119940fa16b8$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $3fe9119940fa16b8$var$inited = false;
function $3fe9119940fa16b8$var$init() {
    $3fe9119940fa16b8$var$inited = true;
    var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    for(var i = 0, len = code.length; i < len; ++i){
        $3fe9119940fa16b8$var$lookup[i] = code[i];
        $3fe9119940fa16b8$var$revLookup[code.charCodeAt(i)] = i;
    }
    $3fe9119940fa16b8$var$revLookup['-'.charCodeAt(0)] = 62;
    $3fe9119940fa16b8$var$revLookup['_'.charCodeAt(0)] = 63;
}
function $3fe9119940fa16b8$var$toByteArray(b64) {
    if (!$3fe9119940fa16b8$var$inited) $3fe9119940fa16b8$var$init();
    var i, j, l, tmp, placeHolders, arr;
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // the number of equal signs (place holders)
    // if there are two placeholders, than the two characters before it
    // represent one byte
    // if there is only one, then the three characters before it represent 2 bytes
    // this is just a cheap hack to not do indexOf twice
    placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
    // base64 is 4/3 + up to two characters of the original data
    arr = new $3fe9119940fa16b8$var$Arr(len * 3 / 4 - placeHolders);
    // if there are placeholders, only get up to the last complete 4 chars
    l = placeHolders > 0 ? len - 4 : len;
    var L = 0;
    for(i = 0, j = 0; i < l; i += 4, j += 3){
        tmp = $3fe9119940fa16b8$var$revLookup[b64.charCodeAt(i)] << 18 | $3fe9119940fa16b8$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3fe9119940fa16b8$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3fe9119940fa16b8$var$revLookup[b64.charCodeAt(i + 3)];
        arr[L++] = tmp >> 16 & 0xFF;
        arr[L++] = tmp >> 8 & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    if (placeHolders === 2) {
        tmp = $3fe9119940fa16b8$var$revLookup[b64.charCodeAt(i)] << 2 | $3fe9119940fa16b8$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[L++] = tmp & 0xFF;
    } else if (placeHolders === 1) {
        tmp = $3fe9119940fa16b8$var$revLookup[b64.charCodeAt(i)] << 10 | $3fe9119940fa16b8$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3fe9119940fa16b8$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[L++] = tmp >> 8 & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    return arr;
}
function $3fe9119940fa16b8$var$tripletToBase64(num) {
    return $3fe9119940fa16b8$var$lookup[num >> 18 & 0x3F] + $3fe9119940fa16b8$var$lookup[num >> 12 & 0x3F] + $3fe9119940fa16b8$var$lookup[num >> 6 & 0x3F] + $3fe9119940fa16b8$var$lookup[num & 0x3F];
}
function $3fe9119940fa16b8$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
        output.push($3fe9119940fa16b8$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $3fe9119940fa16b8$var$fromByteArray(uint8) {
    if (!$3fe9119940fa16b8$var$inited) $3fe9119940fa16b8$var$init();
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var output = '';
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3fe9119940fa16b8$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        output += $3fe9119940fa16b8$var$lookup[tmp >> 2];
        output += $3fe9119940fa16b8$var$lookup[tmp << 4 & 0x3F];
        output += '==';
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        output += $3fe9119940fa16b8$var$lookup[tmp >> 10];
        output += $3fe9119940fa16b8$var$lookup[tmp >> 4 & 0x3F];
        output += $3fe9119940fa16b8$var$lookup[tmp << 2 & 0x3F];
        output += '=';
    }
    parts.push(output);
    return parts.join('');
}
function $3fe9119940fa16b8$var$read(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
}
function $3fe9119940fa16b8$var$write(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
}
var $3fe9119940fa16b8$var$toString = {}.toString;
var $3fe9119940fa16b8$var$isArray$2 = Array.isArray || function(arr) {
    return $3fe9119940fa16b8$var$toString.call(arr) == '[object Array]';
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $3fe9119940fa16b8$var$INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT = $3fe9119940fa16b8$var$global$1.TYPED_ARRAY_SUPPORT !== undefined ? $3fe9119940fa16b8$var$global$1.TYPED_ARRAY_SUPPORT : true;
/*
 * Export kMaxLength after typed array support is determined.
 */ $3fe9119940fa16b8$var$kMaxLength();
function $3fe9119940fa16b8$var$kMaxLength() {
    return $3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $3fe9119940fa16b8$var$createBuffer(that, length) {
    if ($3fe9119940fa16b8$var$kMaxLength() < length) throw new RangeError('Invalid typed array length');
    if ($3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $3fe9119940fa16b8$var$Buffer$1.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $3fe9119940fa16b8$var$Buffer$1(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $3fe9119940fa16b8$var$Buffer$1(arg, encodingOrOffset, length) {
    if (!$3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT && !(this instanceof $3fe9119940fa16b8$var$Buffer$1)) return new $3fe9119940fa16b8$var$Buffer$1(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new Error('If encoding is specified then the first argument must be a string');
        return $3fe9119940fa16b8$var$allocUnsafe(this, arg);
    }
    return $3fe9119940fa16b8$var$from(this, arg, encodingOrOffset, length);
}
$3fe9119940fa16b8$var$Buffer$1.poolSize = 8192; // not used by this implementation
// TODO: Legacy, not needed anymore. Remove in next major version.
$3fe9119940fa16b8$var$Buffer$1._augment = function(arr) {
    arr.__proto__ = $3fe9119940fa16b8$var$Buffer$1.prototype;
    return arr;
};
function $3fe9119940fa16b8$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) return $3fe9119940fa16b8$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === 'string') return $3fe9119940fa16b8$var$fromString(that, value, encodingOrOffset);
    return $3fe9119940fa16b8$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $3fe9119940fa16b8$var$Buffer$1.from = function(value, encodingOrOffset, length) {
    return $3fe9119940fa16b8$var$from(null, value, encodingOrOffset, length);
};
if ($3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) {
    $3fe9119940fa16b8$var$Buffer$1.prototype.__proto__ = Uint8Array.prototype;
    $3fe9119940fa16b8$var$Buffer$1.__proto__ = Uint8Array;
    typeof Symbol !== 'undefined' && Symbol.species && $3fe9119940fa16b8$var$Buffer$1[Symbol.species];
}
function $3fe9119940fa16b8$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $3fe9119940fa16b8$var$alloc(that, size, fill, encoding) {
    $3fe9119940fa16b8$var$assertSize(size);
    if (size <= 0) return $3fe9119940fa16b8$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? $3fe9119940fa16b8$var$createBuffer(that, size).fill(fill, encoding) : $3fe9119940fa16b8$var$createBuffer(that, size).fill(fill);
    return $3fe9119940fa16b8$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $3fe9119940fa16b8$var$Buffer$1.alloc = function(size, fill, encoding) {
    return $3fe9119940fa16b8$var$alloc(null, size, fill, encoding);
};
function $3fe9119940fa16b8$var$allocUnsafe(that, size) {
    $3fe9119940fa16b8$var$assertSize(size);
    that = $3fe9119940fa16b8$var$createBuffer(that, size < 0 ? 0 : $3fe9119940fa16b8$var$checked(size) | 0);
    if (!$3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $3fe9119940fa16b8$var$Buffer$1.allocUnsafe = function(size) {
    return $3fe9119940fa16b8$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $3fe9119940fa16b8$var$Buffer$1.allocUnsafeSlow = function(size) {
    return $3fe9119940fa16b8$var$allocUnsafe(null, size);
};
function $3fe9119940fa16b8$var$fromString(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$3fe9119940fa16b8$var$Buffer$1.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $3fe9119940fa16b8$var$byteLength(string, encoding) | 0;
    that = $3fe9119940fa16b8$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $3fe9119940fa16b8$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $3fe9119940fa16b8$var$checked(array.length) | 0;
    that = $3fe9119940fa16b8$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $3fe9119940fa16b8$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength; // this throws if `array` is not a valid ArrayBuffer
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('\'offset\' is out of bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('\'length\' is out of bounds');
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $3fe9119940fa16b8$var$Buffer$1.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $3fe9119940fa16b8$var$fromArrayLike(that, array);
    return that;
}
function $3fe9119940fa16b8$var$fromObject(that, obj) {
    if ($3fe9119940fa16b8$var$internalIsBuffer(obj)) {
        var len = $3fe9119940fa16b8$var$checked(obj.length) | 0;
        that = $3fe9119940fa16b8$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
            if (typeof obj.length !== 'number' || $3fe9119940fa16b8$var$isnan(obj.length)) return $3fe9119940fa16b8$var$createBuffer(that, 0);
            return $3fe9119940fa16b8$var$fromArrayLike(that, obj);
        }
        if (obj.type === 'Buffer' && $3fe9119940fa16b8$var$isArray$2(obj.data)) return $3fe9119940fa16b8$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}
function $3fe9119940fa16b8$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $3fe9119940fa16b8$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $3fe9119940fa16b8$var$kMaxLength().toString(16) + ' bytes');
    return length | 0;
}
$3fe9119940fa16b8$var$Buffer$1.isBuffer = $3fe9119940fa16b8$var$isBuffer;
function $3fe9119940fa16b8$var$internalIsBuffer(b) {
    return !!(b != null && b._isBuffer);
}
$3fe9119940fa16b8$var$Buffer$1.compare = function compare(a, b) {
    if (!$3fe9119940fa16b8$var$internalIsBuffer(a) || !$3fe9119940fa16b8$var$internalIsBuffer(b)) throw new TypeError('Arguments must be Buffers');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$3fe9119940fa16b8$var$Buffer$1.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$3fe9119940fa16b8$var$Buffer$1.concat = function concat(list, length) {
    if (!$3fe9119940fa16b8$var$isArray$2(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $3fe9119940fa16b8$var$Buffer$1.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $3fe9119940fa16b8$var$Buffer$1.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$3fe9119940fa16b8$var$internalIsBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $3fe9119940fa16b8$var$byteLength(string, encoding) {
    if ($3fe9119940fa16b8$var$internalIsBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') string = '' + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
        case undefined:
            return $3fe9119940fa16b8$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $3fe9119940fa16b8$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $3fe9119940fa16b8$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$3fe9119940fa16b8$var$Buffer$1.byteLength = $3fe9119940fa16b8$var$byteLength;
function $3fe9119940fa16b8$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $3fe9119940fa16b8$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $3fe9119940fa16b8$var$utf8Slice(this, start, end);
        case 'ascii':
            return $3fe9119940fa16b8$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $3fe9119940fa16b8$var$latin1Slice(this, start, end);
        case 'base64':
            return $3fe9119940fa16b8$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3fe9119940fa16b8$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$3fe9119940fa16b8$var$Buffer$1.prototype._isBuffer = true;
function $3fe9119940fa16b8$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$3fe9119940fa16b8$var$Buffer$1.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$3fe9119940fa16b8$var$swap(this, i, i + 1);
    return this;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $3fe9119940fa16b8$var$swap(this, i, i + 3);
        $3fe9119940fa16b8$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $3fe9119940fa16b8$var$swap(this, i, i + 7);
        $3fe9119940fa16b8$var$swap(this, i + 1, i + 6);
        $3fe9119940fa16b8$var$swap(this, i + 2, i + 5);
        $3fe9119940fa16b8$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return '';
    if (arguments.length === 0) return $3fe9119940fa16b8$var$utf8Slice(this, 0, length);
    return $3fe9119940fa16b8$var$slowToString.apply(this, arguments);
};
$3fe9119940fa16b8$var$Buffer$1.prototype.equals = function equals(b) {
    if (!$3fe9119940fa16b8$var$internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $3fe9119940fa16b8$var$Buffer$1.compare(this, b) === 0;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.inspect = function inspect() {
    var str = '';
    var max = $3fe9119940fa16b8$var$INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>';
};
$3fe9119940fa16b8$var$Buffer$1.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$3fe9119940fa16b8$var$internalIsBuffer(target)) throw new TypeError('Argument must be a Buffer');
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $3fe9119940fa16b8$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $3fe9119940fa16b8$var$Buffer$1.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($3fe9119940fa16b8$var$internalIsBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $3fe9119940fa16b8$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if ($3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $3fe9119940fa16b8$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $3fe9119940fa16b8$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$3fe9119940fa16b8$var$Buffer$1.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $3fe9119940fa16b8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$3fe9119940fa16b8$var$Buffer$1.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $3fe9119940fa16b8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $3fe9119940fa16b8$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $3fe9119940fa16b8$var$utf8Write(buf, string, offset, length) {
    return $3fe9119940fa16b8$var$blitBuffer($3fe9119940fa16b8$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $3fe9119940fa16b8$var$asciiWrite(buf, string, offset, length) {
    return $3fe9119940fa16b8$var$blitBuffer($3fe9119940fa16b8$var$asciiToBytes(string), buf, offset, length);
}
function $3fe9119940fa16b8$var$latin1Write(buf, string, offset, length) {
    return $3fe9119940fa16b8$var$asciiWrite(buf, string, offset, length);
}
function $3fe9119940fa16b8$var$base64Write(buf, string, offset, length) {
    return $3fe9119940fa16b8$var$blitBuffer($3fe9119940fa16b8$var$base64ToBytes(string), buf, offset, length);
}
function $3fe9119940fa16b8$var$ucs2Write(buf, string, offset, length) {
    return $3fe9119940fa16b8$var$blitBuffer($3fe9119940fa16b8$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$3fe9119940fa16b8$var$Buffer$1.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $3fe9119940fa16b8$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $3fe9119940fa16b8$var$utf8Write(this, string, offset, length);
        case 'ascii':
            return $3fe9119940fa16b8$var$asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return $3fe9119940fa16b8$var$latin1Write(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $3fe9119940fa16b8$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3fe9119940fa16b8$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$3fe9119940fa16b8$var$Buffer$1.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $3fe9119940fa16b8$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3fe9119940fa16b8$var$fromByteArray(buf);
    else return $3fe9119940fa16b8$var$fromByteArray(buf.slice(start, end));
}
function $3fe9119940fa16b8$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $3fe9119940fa16b8$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $3fe9119940fa16b8$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $3fe9119940fa16b8$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $3fe9119940fa16b8$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $3fe9119940fa16b8$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $3fe9119940fa16b8$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $3fe9119940fa16b8$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $3fe9119940fa16b8$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $3fe9119940fa16b8$var$toHex(buf[i]);
    return out;
}
function $3fe9119940fa16b8$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$3fe9119940fa16b8$var$Buffer$1.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $3fe9119940fa16b8$var$Buffer$1.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $3fe9119940fa16b8$var$Buffer$1(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $3fe9119940fa16b8$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$3fe9119940fa16b8$var$Buffer$1.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, 4, this.length);
    return $3fe9119940fa16b8$var$read(this, offset, true, 23, 4);
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, 4, this.length);
    return $3fe9119940fa16b8$var$read(this, offset, false, 23, 4);
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, 8, this.length);
    return $3fe9119940fa16b8$var$read(this, offset, true, 52, 8);
};
$3fe9119940fa16b8$var$Buffer$1.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkOffset(offset, 8, this.length);
    return $3fe9119940fa16b8$var$read(this, offset, false, 52, 8);
};
function $3fe9119940fa16b8$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$3fe9119940fa16b8$var$internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$3fe9119940fa16b8$var$Buffer$1.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3fe9119940fa16b8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3fe9119940fa16b8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3fe9119940fa16b8$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $3fe9119940fa16b8$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$3fe9119940fa16b8$var$Buffer$1.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3fe9119940fa16b8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $3fe9119940fa16b8$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3fe9119940fa16b8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $3fe9119940fa16b8$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $3fe9119940fa16b8$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$3fe9119940fa16b8$var$Buffer$1.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3fe9119940fa16b8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $3fe9119940fa16b8$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3fe9119940fa16b8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $3fe9119940fa16b8$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $3fe9119940fa16b8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $3fe9119940fa16b8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3fe9119940fa16b8$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3fe9119940fa16b8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $3fe9119940fa16b8$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3fe9119940fa16b8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $3fe9119940fa16b8$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3fe9119940fa16b8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $3fe9119940fa16b8$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$3fe9119940fa16b8$var$Buffer$1.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3fe9119940fa16b8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $3fe9119940fa16b8$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $3fe9119940fa16b8$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $3fe9119940fa16b8$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkIEEE754(buf, value, offset, 4);
    $3fe9119940fa16b8$var$write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$3fe9119940fa16b8$var$Buffer$1.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $3fe9119940fa16b8$var$writeFloat(this, value, offset, true, noAssert);
};
$3fe9119940fa16b8$var$Buffer$1.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $3fe9119940fa16b8$var$writeFloat(this, value, offset, false, noAssert);
};
function $3fe9119940fa16b8$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $3fe9119940fa16b8$var$checkIEEE754(buf, value, offset, 8);
    $3fe9119940fa16b8$var$write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$3fe9119940fa16b8$var$Buffer$1.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $3fe9119940fa16b8$var$writeDouble(this, value, offset, true, noAssert);
};
$3fe9119940fa16b8$var$Buffer$1.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $3fe9119940fa16b8$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$3fe9119940fa16b8$var$Buffer$1.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$3fe9119940fa16b8$var$Buffer$1.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$3fe9119940fa16b8$var$Buffer$1.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$3fe9119940fa16b8$var$Buffer$1.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    } else if (typeof val === 'number') val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $3fe9119940fa16b8$var$internalIsBuffer(val) ? val : $3fe9119940fa16b8$var$utf8ToBytes(new $3fe9119940fa16b8$var$Buffer$1(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $3fe9119940fa16b8$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $3fe9119940fa16b8$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $3fe9119940fa16b8$var$stringtrim(str).replace($3fe9119940fa16b8$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $3fe9119940fa16b8$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
}
function $3fe9119940fa16b8$var$toHex(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
}
function $3fe9119940fa16b8$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $3fe9119940fa16b8$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $3fe9119940fa16b8$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $3fe9119940fa16b8$var$base64ToBytes(str) {
    return $3fe9119940fa16b8$var$toByteArray($3fe9119940fa16b8$var$base64clean(str));
}
function $3fe9119940fa16b8$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $3fe9119940fa16b8$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}
// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
function $3fe9119940fa16b8$var$isBuffer(obj) {
    return obj != null && (!!obj._isBuffer || $3fe9119940fa16b8$var$isFastBuffer(obj) || $3fe9119940fa16b8$var$isSlowBuffer(obj));
}
function $3fe9119940fa16b8$var$isFastBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function $3fe9119940fa16b8$var$isSlowBuffer(obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && $3fe9119940fa16b8$var$isFastBuffer(obj.slice(0, 0));
}
// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js
function $3fe9119940fa16b8$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $3fe9119940fa16b8$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
var $3fe9119940fa16b8$var$cachedSetTimeout = $3fe9119940fa16b8$var$defaultSetTimout;
var $3fe9119940fa16b8$var$cachedClearTimeout = $3fe9119940fa16b8$var$defaultClearTimeout;
if (typeof $3fe9119940fa16b8$var$global$1.setTimeout === 'function') $3fe9119940fa16b8$var$cachedSetTimeout = setTimeout;
if (typeof $3fe9119940fa16b8$var$global$1.clearTimeout === 'function') $3fe9119940fa16b8$var$cachedClearTimeout = clearTimeout;
function $3fe9119940fa16b8$var$runTimeout(fun) {
    if ($3fe9119940fa16b8$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3fe9119940fa16b8$var$cachedSetTimeout === $3fe9119940fa16b8$var$defaultSetTimout || !$3fe9119940fa16b8$var$cachedSetTimeout) && setTimeout) {
        $3fe9119940fa16b8$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3fe9119940fa16b8$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3fe9119940fa16b8$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3fe9119940fa16b8$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3fe9119940fa16b8$var$runClearTimeout(marker) {
    if ($3fe9119940fa16b8$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3fe9119940fa16b8$var$cachedClearTimeout === $3fe9119940fa16b8$var$defaultClearTimeout || !$3fe9119940fa16b8$var$cachedClearTimeout) && clearTimeout) {
        $3fe9119940fa16b8$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3fe9119940fa16b8$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3fe9119940fa16b8$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3fe9119940fa16b8$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3fe9119940fa16b8$var$queue = [];
var $3fe9119940fa16b8$var$draining = false;
var $3fe9119940fa16b8$var$currentQueue;
var $3fe9119940fa16b8$var$queueIndex = -1;
function $3fe9119940fa16b8$var$cleanUpNextTick() {
    if (!$3fe9119940fa16b8$var$draining || !$3fe9119940fa16b8$var$currentQueue) return;
    $3fe9119940fa16b8$var$draining = false;
    if ($3fe9119940fa16b8$var$currentQueue.length) $3fe9119940fa16b8$var$queue = $3fe9119940fa16b8$var$currentQueue.concat($3fe9119940fa16b8$var$queue);
    else $3fe9119940fa16b8$var$queueIndex = -1;
    if ($3fe9119940fa16b8$var$queue.length) $3fe9119940fa16b8$var$drainQueue();
}
function $3fe9119940fa16b8$var$drainQueue() {
    if ($3fe9119940fa16b8$var$draining) return;
    var timeout = $3fe9119940fa16b8$var$runTimeout($3fe9119940fa16b8$var$cleanUpNextTick);
    $3fe9119940fa16b8$var$draining = true;
    var len = $3fe9119940fa16b8$var$queue.length;
    while(len){
        $3fe9119940fa16b8$var$currentQueue = $3fe9119940fa16b8$var$queue;
        $3fe9119940fa16b8$var$queue = [];
        while(++$3fe9119940fa16b8$var$queueIndex < len)if ($3fe9119940fa16b8$var$currentQueue) $3fe9119940fa16b8$var$currentQueue[$3fe9119940fa16b8$var$queueIndex].run();
        $3fe9119940fa16b8$var$queueIndex = -1;
        len = $3fe9119940fa16b8$var$queue.length;
    }
    $3fe9119940fa16b8$var$currentQueue = null;
    $3fe9119940fa16b8$var$draining = false;
    $3fe9119940fa16b8$var$runClearTimeout(timeout);
}
function $3fe9119940fa16b8$var$nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3fe9119940fa16b8$var$queue.push(new $3fe9119940fa16b8$var$Item(fun, args));
    if ($3fe9119940fa16b8$var$queue.length === 1 && !$3fe9119940fa16b8$var$draining) $3fe9119940fa16b8$var$runTimeout($3fe9119940fa16b8$var$drainQueue);
}
// v8 likes predictible objects
function $3fe9119940fa16b8$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3fe9119940fa16b8$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
var $3fe9119940fa16b8$var$title = 'browser';
var $3fe9119940fa16b8$var$platform = 'browser';
var $3fe9119940fa16b8$var$browser = true;
var $3fe9119940fa16b8$var$env = {};
var $3fe9119940fa16b8$var$argv = [];
var $3fe9119940fa16b8$var$version$1 = ''; // empty string to avoid regexp issues
var $3fe9119940fa16b8$var$versions = {};
var $3fe9119940fa16b8$var$release = {};
var $3fe9119940fa16b8$var$config = {};
function $3fe9119940fa16b8$var$noop() {}
var $3fe9119940fa16b8$var$on = $3fe9119940fa16b8$var$noop;
var $3fe9119940fa16b8$var$addListener = $3fe9119940fa16b8$var$noop;
var $3fe9119940fa16b8$var$once = $3fe9119940fa16b8$var$noop;
var $3fe9119940fa16b8$var$off = $3fe9119940fa16b8$var$noop;
var $3fe9119940fa16b8$var$removeListener = $3fe9119940fa16b8$var$noop;
var $3fe9119940fa16b8$var$removeAllListeners = $3fe9119940fa16b8$var$noop;
var $3fe9119940fa16b8$var$emit = $3fe9119940fa16b8$var$noop;
function $3fe9119940fa16b8$var$binding$1(name) {
    throw new Error('process.binding is not supported');
}
function $3fe9119940fa16b8$var$cwd() {
    return '/';
}
function $3fe9119940fa16b8$var$chdir(dir) {
    throw new Error('process.chdir is not supported');
}
function $3fe9119940fa16b8$var$umask() {
    return 0;
}
// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var $3fe9119940fa16b8$var$performance = $3fe9119940fa16b8$var$global$1.performance || {};
var $3fe9119940fa16b8$var$performanceNow = $3fe9119940fa16b8$var$performance.now || $3fe9119940fa16b8$var$performance.mozNow || $3fe9119940fa16b8$var$performance.msNow || $3fe9119940fa16b8$var$performance.oNow || $3fe9119940fa16b8$var$performance.webkitNow || function() {
    return new Date().getTime();
};
// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function $3fe9119940fa16b8$var$hrtime(previousTimestamp) {
    var clocktime = $3fe9119940fa16b8$var$performanceNow.call($3fe9119940fa16b8$var$performance) * 1e-3;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor(clocktime % 1 * 1e9);
    if (previousTimestamp) {
        seconds = seconds - previousTimestamp[0];
        nanoseconds = nanoseconds - previousTimestamp[1];
        if (nanoseconds < 0) {
            seconds--;
            nanoseconds += 1e9;
        }
    }
    return [
        seconds,
        nanoseconds
    ];
}
var $3fe9119940fa16b8$var$startTime = new Date();
function $3fe9119940fa16b8$var$uptime() {
    var currentTime = new Date();
    var dif = currentTime - $3fe9119940fa16b8$var$startTime;
    return dif / 1000;
}
var $3fe9119940fa16b8$var$browser$1 = {
    nextTick: $3fe9119940fa16b8$var$nextTick,
    title: $3fe9119940fa16b8$var$title,
    browser: $3fe9119940fa16b8$var$browser,
    env: $3fe9119940fa16b8$var$env,
    argv: $3fe9119940fa16b8$var$argv,
    version: $3fe9119940fa16b8$var$version$1,
    versions: $3fe9119940fa16b8$var$versions,
    on: $3fe9119940fa16b8$var$on,
    addListener: $3fe9119940fa16b8$var$addListener,
    once: $3fe9119940fa16b8$var$once,
    off: $3fe9119940fa16b8$var$off,
    removeListener: $3fe9119940fa16b8$var$removeListener,
    removeAllListeners: $3fe9119940fa16b8$var$removeAllListeners,
    emit: $3fe9119940fa16b8$var$emit,
    binding: $3fe9119940fa16b8$var$binding$1,
    cwd: $3fe9119940fa16b8$var$cwd,
    chdir: $3fe9119940fa16b8$var$chdir,
    umask: $3fe9119940fa16b8$var$umask,
    hrtime: $3fe9119940fa16b8$var$hrtime,
    platform: $3fe9119940fa16b8$var$platform,
    release: $3fe9119940fa16b8$var$release,
    config: $3fe9119940fa16b8$var$config,
    uptime: $3fe9119940fa16b8$var$uptime
};
var $3fe9119940fa16b8$var$inherits;
if (typeof Object.create === 'function') $3fe9119940fa16b8$var$inherits = function inherits(ctor, superCtor) {
    // implementation from standard node.js 'util' module
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
};
else $3fe9119940fa16b8$var$inherits = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
};
var $3fe9119940fa16b8$var$formatRegExp = /%[sdj%]/g;
function $3fe9119940fa16b8$var$format$1(f) {
    if (!$3fe9119940fa16b8$var$isString$1(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($3fe9119940fa16b8$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($3fe9119940fa16b8$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($3fe9119940fa16b8$var$isNull(x) || !$3fe9119940fa16b8$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $3fe9119940fa16b8$var$inspect(x);
    return str;
}
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
function $3fe9119940fa16b8$var$deprecate(fn, msg) {
    // Allow for deprecating things in the process of starting up.
    if ($3fe9119940fa16b8$var$isUndefined($3fe9119940fa16b8$var$global$1.process)) return function() {
        return $3fe9119940fa16b8$var$deprecate(fn, msg).apply(this, arguments);
    };
    if ($3fe9119940fa16b8$var$browser$1.noDeprecation === true) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($3fe9119940fa16b8$var$browser$1.throwDeprecation) throw new Error(msg);
            else if ($3fe9119940fa16b8$var$browser$1.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
var $3fe9119940fa16b8$var$debugs = {};
var $3fe9119940fa16b8$var$debugEnviron;
function $3fe9119940fa16b8$var$debuglog(set) {
    if ($3fe9119940fa16b8$var$isUndefined($3fe9119940fa16b8$var$debugEnviron)) $3fe9119940fa16b8$var$debugEnviron = $3fe9119940fa16b8$var$browser$1.env.NODE_DEBUG || '';
    set = set.toUpperCase();
    if (!$3fe9119940fa16b8$var$debugs[set]) {
        if (new RegExp('\\b' + set + '\\b', 'i').test($3fe9119940fa16b8$var$debugEnviron)) {
            var pid = 0;
            $3fe9119940fa16b8$var$debugs[set] = function() {
                var msg = $3fe9119940fa16b8$var$format$1.apply(null, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $3fe9119940fa16b8$var$debugs[set] = function() {};
    }
    return $3fe9119940fa16b8$var$debugs[set];
}
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $3fe9119940fa16b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $3fe9119940fa16b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($3fe9119940fa16b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    $3fe9119940fa16b8$var$_extend(ctx, opts);
    // set default options
    if ($3fe9119940fa16b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($3fe9119940fa16b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($3fe9119940fa16b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($3fe9119940fa16b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $3fe9119940fa16b8$var$stylizeWithColor;
    return $3fe9119940fa16b8$var$formatValue(ctx, obj, ctx.depth);
}
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$3fe9119940fa16b8$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$3fe9119940fa16b8$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $3fe9119940fa16b8$var$stylizeWithColor(str, styleType) {
    var style = $3fe9119940fa16b8$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $3fe9119940fa16b8$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $3fe9119940fa16b8$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $3fe9119940fa16b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $3fe9119940fa16b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $3fe9119940fa16b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $3fe9119940fa16b8$var$isFunction$1(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== $3fe9119940fa16b8$var$inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$3fe9119940fa16b8$var$isString$1(ret)) ret = $3fe9119940fa16b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $3fe9119940fa16b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $3fe9119940fa16b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($3fe9119940fa16b8$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $3fe9119940fa16b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($3fe9119940fa16b8$var$isFunction$1(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($3fe9119940fa16b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($3fe9119940fa16b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($3fe9119940fa16b8$var$isError(value)) return $3fe9119940fa16b8$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($3fe9119940fa16b8$var$isArray$1(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($3fe9119940fa16b8$var$isFunction$1(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($3fe9119940fa16b8$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($3fe9119940fa16b8$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($3fe9119940fa16b8$var$isError(value)) base = ' ' + $3fe9119940fa16b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($3fe9119940fa16b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $3fe9119940fa16b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $3fe9119940fa16b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $3fe9119940fa16b8$var$reduceToSingleString(output, base, braces);
}
function $3fe9119940fa16b8$var$formatPrimitive(ctx, value) {
    if ($3fe9119940fa16b8$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($3fe9119940fa16b8$var$isString$1(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($3fe9119940fa16b8$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($3fe9119940fa16b8$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($3fe9119940fa16b8$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $3fe9119940fa16b8$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $3fe9119940fa16b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($3fe9119940fa16b8$var$hasOwnProperty$1(value, String(i))) output.push($3fe9119940fa16b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($3fe9119940fa16b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $3fe9119940fa16b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$3fe9119940fa16b8$var$hasOwnProperty$1(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($3fe9119940fa16b8$var$isNull(recurseTimes)) str = $3fe9119940fa16b8$var$formatValue(ctx, desc.value, null);
            else str = $3fe9119940fa16b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').substr(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($3fe9119940fa16b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $3fe9119940fa16b8$var$reduceToSingleString(output, base, braces) {
    var length = output.reduce(function(prev, cur) {
        cur.indexOf('\n');
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function $3fe9119940fa16b8$var$isArray$1(ar) {
    return Array.isArray(ar);
}
function $3fe9119940fa16b8$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
function $3fe9119940fa16b8$var$isNull(arg) {
    return arg === null;
}
function $3fe9119940fa16b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
function $3fe9119940fa16b8$var$isNumber(arg) {
    return typeof arg === 'number';
}
function $3fe9119940fa16b8$var$isString$1(arg) {
    return typeof arg === 'string';
}
function $3fe9119940fa16b8$var$isUndefined(arg) {
    return arg === void 0;
}
function $3fe9119940fa16b8$var$isRegExp(re) {
    return $3fe9119940fa16b8$var$isObject(re) && $3fe9119940fa16b8$var$objectToString(re) === '[object RegExp]';
}
function $3fe9119940fa16b8$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function $3fe9119940fa16b8$var$isDate(d) {
    return $3fe9119940fa16b8$var$isObject(d) && $3fe9119940fa16b8$var$objectToString(d) === '[object Date]';
}
function $3fe9119940fa16b8$var$isError(e) {
    return $3fe9119940fa16b8$var$isObject(e) && ($3fe9119940fa16b8$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
function $3fe9119940fa16b8$var$isFunction$1(arg) {
    return typeof arg === 'function';
}
function $3fe9119940fa16b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $3fe9119940fa16b8$var$_extend(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$3fe9119940fa16b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
}
function $3fe9119940fa16b8$var$hasOwnProperty$1(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $3fe9119940fa16b8$var$BufferList() {
    this.head = null;
    this.tail = null;
    this.length = 0;
}
$3fe9119940fa16b8$var$BufferList.prototype.push = function(v) {
    var entry = {
        data: v,
        next: null
    };
    if (this.length > 0) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
    ++this.length;
};
$3fe9119940fa16b8$var$BufferList.prototype.unshift = function(v) {
    var entry = {
        data: v,
        next: this.head
    };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
};
$3fe9119940fa16b8$var$BufferList.prototype.shift = function() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;
    else this.head = this.head.next;
    --this.length;
    return ret;
};
$3fe9119940fa16b8$var$BufferList.prototype.clear = function() {
    this.head = this.tail = null;
    this.length = 0;
};
$3fe9119940fa16b8$var$BufferList.prototype.join = function(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while(p = p.next)ret += s + p.data;
    return ret;
};
$3fe9119940fa16b8$var$BufferList.prototype.concat = function(n) {
    if (this.length === 0) return $3fe9119940fa16b8$var$Buffer$1.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = $3fe9119940fa16b8$var$Buffer$1.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while(p){
        p.data.copy(ret, i);
        i += p.data.length;
        p = p.next;
    }
    return ret;
};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $3fe9119940fa16b8$var$isBufferEncoding = $3fe9119940fa16b8$var$Buffer$1.isEncoding || function(encoding) {
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $3fe9119940fa16b8$var$assertEncoding(encoding) {
    if (encoding && !$3fe9119940fa16b8$var$isBufferEncoding(encoding)) throw new Error('Unknown encoding: ' + encoding);
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters. CESU-8 is handled as part of the UTF-8 encoding.
//
// @TODO Handling all encodings inside a single object makes it very difficult
// to reason about this code, so it should be split up in the future.
// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
// points as used by CESU-8.
function $3fe9119940fa16b8$var$StringDecoder(encoding) {
    this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
    $3fe9119940fa16b8$var$assertEncoding(encoding);
    switch(this.encoding){
        case 'utf8':
            // CESU-8 represents each of Surrogate Pair by 3-bytes
            this.surrogateSize = 3;
            break;
        case 'ucs2':
        case 'utf16le':
            // UTF-16 represents each of Surrogate Pair by 2-bytes
            this.surrogateSize = 2;
            this.detectIncompleteChar = $3fe9119940fa16b8$var$utf16DetectIncompleteChar;
            break;
        case 'base64':
            // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
            this.surrogateSize = 3;
            this.detectIncompleteChar = $3fe9119940fa16b8$var$base64DetectIncompleteChar;
            break;
        default:
            this.write = $3fe9119940fa16b8$var$passThroughWrite;
            return;
    }
    // Enough space to store all bytes of a single character. UTF-8 needs 4
    // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
    this.charBuffer = new $3fe9119940fa16b8$var$Buffer$1(6);
    // Number of bytes received for the current incomplete multi-byte character.
    this.charReceived = 0;
    // Number of bytes expected for the current incomplete multi-byte character.
    this.charLength = 0;
}
// write decodes the given buffer and returns it as JS string that is
// guaranteed to not contain any partial multi-byte characters. Any partial
// character found at the end of the buffer is buffered up, and will be
// returned when calling write again with the remaining bytes.
//
// Note: Converting a Buffer containing an orphan surrogate to a String
// currently works, but converting a String to a Buffer (via `new Buffer`, or
// Buffer#write) will replace incomplete surrogates with the unicode
// replacement character. See https://codereview.chromium.org/121173009/ .
$3fe9119940fa16b8$var$StringDecoder.prototype.write = function(buffer) {
    var charStr = '';
    // if our last write ended with an incomplete multibyte character
    while(this.charLength){
        // determine how many remaining bytes this buffer has to offer for this char
        var available = buffer.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : buffer.length;
        // add the new bytes to the char buffer
        buffer.copy(this.charBuffer, this.charReceived, 0, available);
        this.charReceived += available;
        if (this.charReceived < this.charLength) // still not enough chars in this buffer? wait for more ...
        return '';
        // remove bytes belonging to the current character from the buffer
        buffer = buffer.slice(available, buffer.length);
        // get the character that was split
        charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
        // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
        var charCode = charStr.charCodeAt(charStr.length - 1);
        if (charCode >= 0xD800 && charCode <= 0xDBFF) {
            this.charLength += this.surrogateSize;
            charStr = '';
            continue;
        }
        this.charReceived = this.charLength = 0;
        // if there are no more bytes in this buffer, just emit our char
        if (buffer.length === 0) return charStr;
        break;
    }
    // determine and set charLength / charReceived
    this.detectIncompleteChar(buffer);
    var end = buffer.length;
    if (this.charLength) {
        // buffer the incomplete character bytes we got
        buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
        end -= this.charReceived;
    }
    charStr += buffer.toString(this.encoding, 0, end);
    var end = charStr.length - 1;
    var charCode = charStr.charCodeAt(end);
    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
        var size = this.surrogateSize;
        this.charLength += size;
        this.charReceived += size;
        this.charBuffer.copy(this.charBuffer, size, 0, size);
        buffer.copy(this.charBuffer, 0, 0, size);
        return charStr.substring(0, end);
    }
    // or just emit the charStr
    return charStr;
};
// detectIncompleteChar determines if there is an incomplete UTF-8 character at
// the end of the given buffer. If so, it sets this.charLength to the byte
// length that character, and sets this.charReceived to the number of bytes
// that are available for this character.
$3fe9119940fa16b8$var$StringDecoder.prototype.detectIncompleteChar = function(buffer) {
    // determine how many bytes we have to check at the end of this buffer
    var i = buffer.length >= 3 ? 3 : buffer.length;
    // Figure out if one of the last i bytes of our buffer announces an
    // incomplete char.
    for(; i > 0; i--){
        var c = buffer[buffer.length - i];
        // See http://en.wikipedia.org/wiki/UTF-8#Description
        // 110XXXXX
        if (i == 1 && c >> 5 == 0x06) {
            this.charLength = 2;
            break;
        }
        // 1110XXXX
        if (i <= 2 && c >> 4 == 0x0E) {
            this.charLength = 3;
            break;
        }
        // 11110XXX
        if (i <= 3 && c >> 3 == 0x1E) {
            this.charLength = 4;
            break;
        }
    }
    this.charReceived = i;
};
$3fe9119940fa16b8$var$StringDecoder.prototype.end = function(buffer) {
    var res = '';
    if (buffer && buffer.length) res = this.write(buffer);
    if (this.charReceived) {
        var cr = this.charReceived;
        var buf = this.charBuffer;
        var enc = this.encoding;
        res += buf.slice(0, cr).toString(enc);
    }
    return res;
};
function $3fe9119940fa16b8$var$passThroughWrite(buffer) {
    return buffer.toString(this.encoding);
}
function $3fe9119940fa16b8$var$utf16DetectIncompleteChar(buffer) {
    this.charReceived = buffer.length % 2;
    this.charLength = this.charReceived ? 2 : 0;
}
function $3fe9119940fa16b8$var$base64DetectIncompleteChar(buffer) {
    this.charReceived = buffer.length % 3;
    this.charLength = this.charReceived ? 3 : 0;
}
$3fe9119940fa16b8$var$Readable$1.ReadableState = $3fe9119940fa16b8$var$ReadableState;
var $3fe9119940fa16b8$var$debug = $3fe9119940fa16b8$var$debuglog('stream');
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$Readable$1, $3fe9119940fa16b8$var$EventEmitter);
function $3fe9119940fa16b8$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    else {
        // This is a hack to make sure that our error handler is attached before any
        // userland ones.  NEVER DO THIS. This is here only because this code needs
        // to continue to work with older versions of Node.js that do not include
        // the prependListener() method. The goal is to eventually remove this hack.
        if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
        else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
        else emitter._events[event] = [
            fn,
            emitter._events[event]
        ];
    }
}
function $3fe9119940fa16b8$var$listenerCount(emitter, type) {
    return emitter.listeners(type).length;
}
function $3fe9119940fa16b8$var$ReadableState(options, stream) {
    options = options || {};
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (stream instanceof $3fe9119940fa16b8$var$Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
    // cast to ints.
    this.highWaterMark = ~~this.highWaterMark;
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $3fe9119940fa16b8$var$BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // when piping, we only care about 'readable' events that happen
    // after read()ing all the bytes and not getting any pushback.
    this.ranOut = false;
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        this.decoder = new $3fe9119940fa16b8$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function $3fe9119940fa16b8$var$Readable$1(options) {
    if (!(this instanceof $3fe9119940fa16b8$var$Readable$1)) return new $3fe9119940fa16b8$var$Readable$1(options);
    this._readableState = new $3fe9119940fa16b8$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options && typeof options.read === 'function') this._read = options.read;
    $3fe9119940fa16b8$var$EventEmitter.call(this);
}
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$3fe9119940fa16b8$var$Readable$1.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    if (!state.objectMode && typeof chunk === 'string') {
        encoding = encoding || state.defaultEncoding;
        if (encoding !== state.encoding) {
            chunk = $3fe9119940fa16b8$var$Buffer$1.from(chunk, encoding);
            encoding = '';
        }
    }
    return $3fe9119940fa16b8$var$readableAddChunk(this, state, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read()
$3fe9119940fa16b8$var$Readable$1.prototype.unshift = function(chunk) {
    var state = this._readableState;
    return $3fe9119940fa16b8$var$readableAddChunk(this, state, chunk, '', true);
};
$3fe9119940fa16b8$var$Readable$1.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
function $3fe9119940fa16b8$var$readableAddChunk(stream, state, chunk, encoding, addToFront) {
    var er = $3fe9119940fa16b8$var$chunkInvalid(state, chunk);
    if (er) stream.emit('error', er);
    else if (chunk === null) {
        state.reading = false;
        $3fe9119940fa16b8$var$onEofChunk(stream, state);
    } else if (state.objectMode || chunk && chunk.length > 0) {
        if (state.ended && !addToFront) {
            var e = new Error('stream.push() after EOF');
            stream.emit('error', e);
        } else if (state.endEmitted && addToFront) {
            var _e = new Error('stream.unshift() after end event');
            stream.emit('error', _e);
        } else {
            var skipAdd;
            if (state.decoder && !addToFront && !encoding) {
                chunk = state.decoder.write(chunk);
                skipAdd = !state.objectMode && chunk.length === 0;
            }
            if (!addToFront) state.reading = false;
            // Don't add to the buffer if we've decoded to an empty string chunk and
            // we're not in object mode
            if (!skipAdd) {
                // if we want the data now, just emit it.
                if (state.flowing && state.length === 0 && !state.sync) {
                    stream.emit('data', chunk);
                    stream.read(0);
                } else {
                    // update the buffer info.
                    state.length += state.objectMode ? 1 : chunk.length;
                    if (addToFront) state.buffer.unshift(chunk);
                    else state.buffer.push(chunk);
                    if (state.needReadable) $3fe9119940fa16b8$var$emitReadable(stream);
                }
            }
            $3fe9119940fa16b8$var$maybeReadMore(stream, state);
        }
    } else if (!addToFront) state.reading = false;
    return $3fe9119940fa16b8$var$needMoreData(state);
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $3fe9119940fa16b8$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
// backwards compatibility.
$3fe9119940fa16b8$var$Readable$1.prototype.setEncoding = function(enc) {
    this._readableState.decoder = new $3fe9119940fa16b8$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $3fe9119940fa16b8$var$MAX_HWM = 0x800000;
function $3fe9119940fa16b8$var$computeNewHighWaterMark(n) {
    if (n >= $3fe9119940fa16b8$var$MAX_HWM) n = $3fe9119940fa16b8$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3fe9119940fa16b8$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $3fe9119940fa16b8$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$3fe9119940fa16b8$var$Readable$1.prototype.read = function(n) {
    $3fe9119940fa16b8$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $3fe9119940fa16b8$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $3fe9119940fa16b8$var$endReadable(this);
        else $3fe9119940fa16b8$var$emitReadable(this);
        return null;
    }
    n = $3fe9119940fa16b8$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $3fe9119940fa16b8$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $3fe9119940fa16b8$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $3fe9119940fa16b8$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $3fe9119940fa16b8$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $3fe9119940fa16b8$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $3fe9119940fa16b8$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $3fe9119940fa16b8$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $3fe9119940fa16b8$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $3fe9119940fa16b8$var$chunkInvalid(state, chunk) {
    var er = null;
    if (!$3fe9119940fa16b8$var$Buffer$1.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
function $3fe9119940fa16b8$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $3fe9119940fa16b8$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $3fe9119940fa16b8$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $3fe9119940fa16b8$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $3fe9119940fa16b8$var$nextTick($3fe9119940fa16b8$var$emitReadable_, stream);
        else $3fe9119940fa16b8$var$emitReadable_(stream);
    }
}
function $3fe9119940fa16b8$var$emitReadable_(stream) {
    $3fe9119940fa16b8$var$debug('emit readable');
    stream.emit('readable');
    $3fe9119940fa16b8$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $3fe9119940fa16b8$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $3fe9119940fa16b8$var$nextTick($3fe9119940fa16b8$var$maybeReadMore_, stream, state);
    }
}
function $3fe9119940fa16b8$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $3fe9119940fa16b8$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$3fe9119940fa16b8$var$Readable$1.prototype._read = function(n) {
    this.emit('error', new Error('not implemented'));
};
$3fe9119940fa16b8$var$Readable$1.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $3fe9119940fa16b8$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = !pipeOpts || pipeOpts.end !== false;
    var endFn = doEnd ? onend : cleanup;
    if (state.endEmitted) $3fe9119940fa16b8$var$nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable) {
        $3fe9119940fa16b8$var$debug('onunpipe');
        if (readable === src) cleanup();
    }
    function onend() {
        $3fe9119940fa16b8$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $3fe9119940fa16b8$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $3fe9119940fa16b8$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', cleanup);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $3fe9119940fa16b8$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $3fe9119940fa16b8$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $3fe9119940fa16b8$var$debug('false write response, pause', src._readableState.awaitDrain);
                src._readableState.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $3fe9119940fa16b8$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($3fe9119940fa16b8$var$listenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $3fe9119940fa16b8$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $3fe9119940fa16b8$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $3fe9119940fa16b8$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $3fe9119940fa16b8$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $3fe9119940fa16b8$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $3fe9119940fa16b8$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && src.listeners('data').length) {
            state.flowing = true;
            $3fe9119940fa16b8$var$flow(src);
        }
    };
}
$3fe9119940fa16b8$var$Readable$1.prototype.unpipe = function(dest) {
    var state = this._readableState;
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var _i = 0; _i < len; _i++)dests[_i].emit('unpipe', this);
        return this;
    }
    // try to find the right one.
    var i = $3fe9119940fa16b8$var$indexOf(state.pipes, dest);
    if (i === -1) return this;
    state.pipes.splice(i, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$3fe9119940fa16b8$var$Readable$1.prototype.on = function(ev, fn) {
    var res = $3fe9119940fa16b8$var$EventEmitter.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $3fe9119940fa16b8$var$nextTick($3fe9119940fa16b8$var$nReadingNextTick, this);
            else if (state.length) $3fe9119940fa16b8$var$emitReadable(this);
        }
    }
    return res;
};
$3fe9119940fa16b8$var$Readable$1.prototype.addListener = $3fe9119940fa16b8$var$Readable$1.prototype.on;
function $3fe9119940fa16b8$var$nReadingNextTick(self1) {
    $3fe9119940fa16b8$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$3fe9119940fa16b8$var$Readable$1.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $3fe9119940fa16b8$var$debug('resume');
        state.flowing = true;
        $3fe9119940fa16b8$var$resume(this, state);
    }
    return this;
};
function $3fe9119940fa16b8$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $3fe9119940fa16b8$var$nextTick($3fe9119940fa16b8$var$resume_, stream, state);
    }
}
function $3fe9119940fa16b8$var$resume_(stream, state) {
    if (!state.reading) {
        $3fe9119940fa16b8$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $3fe9119940fa16b8$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$3fe9119940fa16b8$var$Readable$1.prototype.pause = function() {
    $3fe9119940fa16b8$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $3fe9119940fa16b8$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $3fe9119940fa16b8$var$flow(stream) {
    var state = stream._readableState;
    $3fe9119940fa16b8$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$3fe9119940fa16b8$var$Readable$1.prototype.wrap = function(stream) {
    var state = this._readableState;
    var paused = false;
    var self1 = this;
    stream.on('end', function() {
        $3fe9119940fa16b8$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) self1.push(chunk);
        }
        self1.push(null);
    });
    stream.on('data', function(chunk) {
        $3fe9119940fa16b8$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = self1.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    var events = [
        'error',
        'close',
        'destroy',
        'pause',
        'resume'
    ];
    $3fe9119940fa16b8$var$forEach(events, function(ev) {
        stream.on(ev, self1.emit.bind(self1, ev));
    });
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    self1._read = function(n) {
        $3fe9119940fa16b8$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return self1;
};
// exposed for testing purposes only.
$3fe9119940fa16b8$var$Readable$1._fromList = $3fe9119940fa16b8$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3fe9119940fa16b8$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $3fe9119940fa16b8$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3fe9119940fa16b8$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $3fe9119940fa16b8$var$copyFromBufferString(n, list) : $3fe9119940fa16b8$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3fe9119940fa16b8$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3fe9119940fa16b8$var$copyFromBuffer(n, list) {
    var ret = $3fe9119940fa16b8$var$Buffer$1.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $3fe9119940fa16b8$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $3fe9119940fa16b8$var$nextTick($3fe9119940fa16b8$var$endReadableNT, state, stream);
    }
}
function $3fe9119940fa16b8$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $3fe9119940fa16b8$var$forEach(xs, f) {
    for(var i = 0, l = xs.length; i < l; i++)f(xs[i], i);
}
function $3fe9119940fa16b8$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
$3fe9119940fa16b8$var$Writable.WritableState = $3fe9119940fa16b8$var$WritableState;
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$Writable, $3fe9119940fa16b8$var$EventEmitter);
function $3fe9119940fa16b8$var$nop() {}
function $3fe9119940fa16b8$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
function $3fe9119940fa16b8$var$WritableState(options, stream) {
    Object.defineProperty(this, 'buffer', {
        get: $3fe9119940fa16b8$var$deprecate(function() {
            return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")
    });
    options = options || {};
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (stream instanceof $3fe9119940fa16b8$var$Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
    // cast to ints.
    this.highWaterMark = ~~this.highWaterMark;
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $3fe9119940fa16b8$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $3fe9119940fa16b8$var$CorkedRequest(this);
}
$3fe9119940fa16b8$var$WritableState.prototype.getBuffer = function writableStateGetBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
function $3fe9119940fa16b8$var$Writable(options) {
    // Writable ctor is applied to Duplexes, though they're not
    // instanceof Writable, they're instanceof Readable.
    if (!(this instanceof $3fe9119940fa16b8$var$Writable) && !(this instanceof $3fe9119940fa16b8$var$Duplex)) return new $3fe9119940fa16b8$var$Writable(options);
    this._writableState = new $3fe9119940fa16b8$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
    }
    $3fe9119940fa16b8$var$EventEmitter.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$3fe9119940fa16b8$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $3fe9119940fa16b8$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $3fe9119940fa16b8$var$nextTick(cb, er);
}
// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function $3fe9119940fa16b8$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    // Always throw error if a null is written
    // if we are not in object mode then throw
    // if it is not a buffer, string, or undefined.
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (!$3fe9119940fa16b8$var$Buffer$1.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $3fe9119940fa16b8$var$nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$3fe9119940fa16b8$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if ($3fe9119940fa16b8$var$Buffer$1.isBuffer(chunk)) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $3fe9119940fa16b8$var$nop;
    if (state.ended) $3fe9119940fa16b8$var$writeAfterEnd(this, cb);
    else if ($3fe9119940fa16b8$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $3fe9119940fa16b8$var$writeOrBuffer(this, state, chunk, encoding, cb);
    }
    return ret;
};
$3fe9119940fa16b8$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$3fe9119940fa16b8$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) $3fe9119940fa16b8$var$clearBuffer(this, state);
    }
};
$3fe9119940fa16b8$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $3fe9119940fa16b8$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $3fe9119940fa16b8$var$Buffer$1.from(chunk, encoding);
    return chunk;
}
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $3fe9119940fa16b8$var$writeOrBuffer(stream, state, chunk, encoding, cb) {
    chunk = $3fe9119940fa16b8$var$decodeChunk(state, chunk, encoding);
    if ($3fe9119940fa16b8$var$Buffer$1.isBuffer(chunk)) encoding = 'buffer';
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = new $3fe9119940fa16b8$var$WriteReq(chunk, encoding, cb);
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $3fe9119940fa16b8$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $3fe9119940fa16b8$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $3fe9119940fa16b8$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) $3fe9119940fa16b8$var$nextTick(cb, er);
    else cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
}
function $3fe9119940fa16b8$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $3fe9119940fa16b8$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $3fe9119940fa16b8$var$onwriteStateUpdate(state);
    if (er) $3fe9119940fa16b8$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $3fe9119940fa16b8$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $3fe9119940fa16b8$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $3fe9119940fa16b8$var$nextTick($3fe9119940fa16b8$var$afterWrite, stream, state, finished, cb);
        else $3fe9119940fa16b8$var$afterWrite(stream, state, finished, cb);
    }
}
function $3fe9119940fa16b8$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $3fe9119940fa16b8$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $3fe9119940fa16b8$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $3fe9119940fa16b8$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $3fe9119940fa16b8$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        while(entry){
            buffer[count] = entry;
            entry = entry.next;
            count += 1;
        }
        $3fe9119940fa16b8$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $3fe9119940fa16b8$var$CorkedRequest(state);
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $3fe9119940fa16b8$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequestCount = 0;
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$3fe9119940fa16b8$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('not implemented'));
};
$3fe9119940fa16b8$var$Writable.prototype._writev = null;
$3fe9119940fa16b8$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending && !state.finished) $3fe9119940fa16b8$var$endWritable(this, state, cb);
};
function $3fe9119940fa16b8$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $3fe9119940fa16b8$var$prefinish(stream, state) {
    if (!state.prefinished) {
        state.prefinished = true;
        stream.emit('prefinish');
    }
}
function $3fe9119940fa16b8$var$finishMaybe(stream, state) {
    var need = $3fe9119940fa16b8$var$needFinish(state);
    if (need) {
        if (state.pendingcb === 0) {
            $3fe9119940fa16b8$var$prefinish(stream, state);
            state.finished = true;
            stream.emit('finish');
        } else $3fe9119940fa16b8$var$prefinish(stream, state);
    }
    return need;
}
function $3fe9119940fa16b8$var$endWritable(stream, state, cb) {
    state.ending = true;
    $3fe9119940fa16b8$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $3fe9119940fa16b8$var$nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $3fe9119940fa16b8$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function(err) {
        var entry = _this.entry;
        _this.entry = null;
        while(entry){
            var cb = entry.callback;
            state.pendingcb--;
            cb(err);
            entry = entry.next;
        }
        if (state.corkedRequestsFree) state.corkedRequestsFree.next = _this;
        else state.corkedRequestsFree = _this;
    };
}
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$Duplex, $3fe9119940fa16b8$var$Readable$1);
var $3fe9119940fa16b8$var$keys = Object.keys($3fe9119940fa16b8$var$Writable.prototype);
for(var $3fe9119940fa16b8$var$v$1 = 0; $3fe9119940fa16b8$var$v$1 < $3fe9119940fa16b8$var$keys.length; $3fe9119940fa16b8$var$v$1++){
    var $3fe9119940fa16b8$var$method = $3fe9119940fa16b8$var$keys[$3fe9119940fa16b8$var$v$1];
    if (!$3fe9119940fa16b8$var$Duplex.prototype[$3fe9119940fa16b8$var$method]) $3fe9119940fa16b8$var$Duplex.prototype[$3fe9119940fa16b8$var$method] = $3fe9119940fa16b8$var$Writable.prototype[$3fe9119940fa16b8$var$method];
}
function $3fe9119940fa16b8$var$Duplex(options) {
    if (!(this instanceof $3fe9119940fa16b8$var$Duplex)) return new $3fe9119940fa16b8$var$Duplex(options);
    $3fe9119940fa16b8$var$Readable$1.call(this, options);
    $3fe9119940fa16b8$var$Writable.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $3fe9119940fa16b8$var$onend);
}
// the no-half-open enforcer
function $3fe9119940fa16b8$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $3fe9119940fa16b8$var$nextTick($3fe9119940fa16b8$var$onEndNT, this);
}
function $3fe9119940fa16b8$var$onEndNT(self1) {
    self1.end();
}
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$Transform, $3fe9119940fa16b8$var$Duplex);
function $3fe9119940fa16b8$var$TransformState(stream) {
    this.afterTransform = function(er, data) {
        return $3fe9119940fa16b8$var$afterTransform(stream, er, data);
    };
    this.needTransform = false;
    this.transforming = false;
    this.writecb = null;
    this.writechunk = null;
    this.writeencoding = null;
}
function $3fe9119940fa16b8$var$afterTransform(stream, er, data) {
    var ts = stream._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data !== null && data !== undefined) stream.push(data);
    cb(er);
    var rs = stream._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) stream._read(rs.highWaterMark);
}
function $3fe9119940fa16b8$var$Transform(options) {
    if (!(this instanceof $3fe9119940fa16b8$var$Transform)) return new $3fe9119940fa16b8$var$Transform(options);
    $3fe9119940fa16b8$var$Duplex.call(this, options);
    this._transformState = new $3fe9119940fa16b8$var$TransformState(this);
    // when the writable side finishes, then flush out anything remaining.
    var stream = this;
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    this.once('prefinish', function() {
        if (typeof this._flush === 'function') this._flush(function(er) {
            $3fe9119940fa16b8$var$done(stream, er);
        });
        else $3fe9119940fa16b8$var$done(stream);
    });
}
$3fe9119940fa16b8$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $3fe9119940fa16b8$var$Duplex.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$3fe9119940fa16b8$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('Not implemented');
};
$3fe9119940fa16b8$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$3fe9119940fa16b8$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
function $3fe9119940fa16b8$var$done(stream, er) {
    if (er) return stream.emit('error', er);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    var ws = stream._writableState;
    var ts = stream._transformState;
    if (ws.length) throw new Error('Calling transform done when ws.length != 0');
    if (ts.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$PassThrough$2, $3fe9119940fa16b8$var$Transform);
function $3fe9119940fa16b8$var$PassThrough$2(options) {
    if (!(this instanceof $3fe9119940fa16b8$var$PassThrough$2)) return new $3fe9119940fa16b8$var$PassThrough$2(options);
    $3fe9119940fa16b8$var$Transform.call(this, options);
}
$3fe9119940fa16b8$var$PassThrough$2.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$Stream, $3fe9119940fa16b8$var$EventEmitter);
$3fe9119940fa16b8$var$Stream.Readable = $3fe9119940fa16b8$var$Readable$1;
$3fe9119940fa16b8$var$Stream.Writable = $3fe9119940fa16b8$var$Writable;
$3fe9119940fa16b8$var$Stream.Duplex = $3fe9119940fa16b8$var$Duplex;
$3fe9119940fa16b8$var$Stream.Transform = $3fe9119940fa16b8$var$Transform;
$3fe9119940fa16b8$var$Stream.PassThrough = $3fe9119940fa16b8$var$PassThrough$2;
// Backwards-compat with node 0.4.x
$3fe9119940fa16b8$var$Stream.Stream = $3fe9119940fa16b8$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $3fe9119940fa16b8$var$Stream() {
    $3fe9119940fa16b8$var$EventEmitter.call(this);
}
$3fe9119940fa16b8$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($3fe9119940fa16b8$var$EventEmitter.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
var $3fe9119940fa16b8$var$hasFetch = $3fe9119940fa16b8$var$isFunction($3fe9119940fa16b8$var$global$1.fetch) && $3fe9119940fa16b8$var$isFunction($3fe9119940fa16b8$var$global$1.ReadableStream);
var $3fe9119940fa16b8$var$_blobConstructor;
function $3fe9119940fa16b8$var$blobConstructor() {
    if (typeof $3fe9119940fa16b8$var$_blobConstructor !== 'undefined') return $3fe9119940fa16b8$var$_blobConstructor;
    try {
        new $3fe9119940fa16b8$var$global$1.Blob([
            new ArrayBuffer(1)
        ]);
        $3fe9119940fa16b8$var$_blobConstructor = true;
    } catch (e) {
        $3fe9119940fa16b8$var$_blobConstructor = false;
    }
    return $3fe9119940fa16b8$var$_blobConstructor;
}
var $3fe9119940fa16b8$var$xhr;
function $3fe9119940fa16b8$var$checkTypeSupport(type) {
    if (!$3fe9119940fa16b8$var$xhr) {
        $3fe9119940fa16b8$var$xhr = new $3fe9119940fa16b8$var$global$1.XMLHttpRequest();
        // If location.host is empty, e.g. if this page/worker was loaded
        // from a Blob, then use example.com to avoid an error
        $3fe9119940fa16b8$var$xhr.open('GET', $3fe9119940fa16b8$var$global$1.location.host ? '/' : 'https://example.com');
    }
    try {
        $3fe9119940fa16b8$var$xhr.responseType = type;
        return $3fe9119940fa16b8$var$xhr.responseType === type;
    } catch (e) {
        return false;
    }
}
// For some strange reason, Safari 7.0 reports typeof global.ArrayBuffer === 'object'.
// Safari 7.1 appears to have fixed this bug.
var $3fe9119940fa16b8$var$haveArrayBuffer = typeof $3fe9119940fa16b8$var$global$1.ArrayBuffer !== 'undefined';
var $3fe9119940fa16b8$var$haveSlice = $3fe9119940fa16b8$var$haveArrayBuffer && $3fe9119940fa16b8$var$isFunction($3fe9119940fa16b8$var$global$1.ArrayBuffer.prototype.slice);
var $3fe9119940fa16b8$var$arraybuffer = $3fe9119940fa16b8$var$haveArrayBuffer && $3fe9119940fa16b8$var$checkTypeSupport('arraybuffer');
// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
var $3fe9119940fa16b8$var$msstream = !$3fe9119940fa16b8$var$hasFetch && $3fe9119940fa16b8$var$haveSlice && $3fe9119940fa16b8$var$checkTypeSupport('ms-stream');
var $3fe9119940fa16b8$var$mozchunkedarraybuffer = !$3fe9119940fa16b8$var$hasFetch && $3fe9119940fa16b8$var$haveArrayBuffer && $3fe9119940fa16b8$var$checkTypeSupport('moz-chunked-arraybuffer');
var $3fe9119940fa16b8$var$overrideMimeType = $3fe9119940fa16b8$var$isFunction($3fe9119940fa16b8$var$xhr.overrideMimeType);
var $3fe9119940fa16b8$var$vbArray = $3fe9119940fa16b8$var$isFunction($3fe9119940fa16b8$var$global$1.VBArray);
function $3fe9119940fa16b8$var$isFunction(value) {
    return typeof value === 'function';
}
$3fe9119940fa16b8$var$xhr = null; // Help gc
var $3fe9119940fa16b8$var$rStates = {
    UNSENT: 0,
    OPENED: 1,
    HEADERS_RECEIVED: 2,
    LOADING: 3,
    DONE: 4
};
function $3fe9119940fa16b8$var$IncomingMessage(xhr, response, mode) {
    var self1 = this;
    $3fe9119940fa16b8$var$Readable$1.call(self1);
    self1._mode = mode;
    self1.headers = {};
    self1.rawHeaders = [];
    self1.trailers = {};
    self1.rawTrailers = [];
    // Fake the 'close' event, but only once 'end' fires
    self1.on('end', function() {
        // The nextTick is necessary to prevent the 'request' module from causing an infinite loop
        $3fe9119940fa16b8$var$browser$1.nextTick(function() {
            self1.emit('close');
        });
    });
    var read;
    if (mode === 'fetch') {
        self1._fetchResponse = response;
        self1.url = response.url;
        self1.statusCode = response.status;
        self1.statusMessage = response.statusText;
        // backwards compatible version of for (<item> of <iterable>):
        // for (var <item>,_i,_it = <iterable>[Symbol.iterator](); <item> = (_i = _it.next()).value,!_i.done;)
        for(var header, _i, _it = response.headers[Symbol.iterator](); header = (_i = _it.next()).value, !_i.done;){
            self1.headers[header[0].toLowerCase()] = header[1];
            self1.rawHeaders.push(header[0], header[1]);
        }
        // TODO: this doesn't respect backpressure. Once WritableStream is available, this can be fixed
        var reader = response.body.getReader();
        read = function() {
            reader.read().then(function(result) {
                if (self1._destroyed) return;
                if (result.done) {
                    self1.push(null);
                    return;
                }
                self1.push(new $3fe9119940fa16b8$var$Buffer$1(result.value));
                read();
            });
        };
        read();
    } else {
        self1._xhr = xhr;
        self1._pos = 0;
        self1.url = xhr.responseURL;
        self1.statusCode = xhr.status;
        self1.statusMessage = xhr.statusText;
        var headers = xhr.getAllResponseHeaders().split(/\r?\n/);
        headers.forEach(function(header) {
            var matches = header.match(/^([^:]+):\s*(.*)/);
            if (matches) {
                var key = matches[1].toLowerCase();
                if (key === 'set-cookie') {
                    if (self1.headers[key] === undefined) self1.headers[key] = [];
                    self1.headers[key].push(matches[2]);
                } else if (self1.headers[key] !== undefined) self1.headers[key] += ', ' + matches[2];
                else self1.headers[key] = matches[2];
                self1.rawHeaders.push(matches[1], matches[2]);
            }
        });
        self1._charset = 'x-user-defined';
        if (!$3fe9119940fa16b8$var$overrideMimeType) {
            var mimeType = self1.rawHeaders['mime-type'];
            if (mimeType) {
                var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/);
                if (charsetMatch) self1._charset = charsetMatch[1].toLowerCase();
            }
            if (!self1._charset) self1._charset = 'utf-8'; // best guess
        }
    }
}
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$IncomingMessage, $3fe9119940fa16b8$var$Readable$1);
$3fe9119940fa16b8$var$IncomingMessage.prototype._read = function() {};
$3fe9119940fa16b8$var$IncomingMessage.prototype._onXHRProgress = function() {
    var self1 = this;
    var xhr = self1._xhr;
    var response = null;
    switch(self1._mode){
        case 'text:vbarray':
            if (xhr.readyState !== $3fe9119940fa16b8$var$rStates.DONE) break;
            try {
                // This fails in IE8
                response = new $3fe9119940fa16b8$var$global$1.VBArray(xhr.responseBody).toArray();
            } catch (e) {
            // pass
            }
            if (response !== null) {
                self1.push(new $3fe9119940fa16b8$var$Buffer$1(response));
                break;
            }
        // Falls through in IE8
        case 'text':
            try {
                response = xhr.responseText;
            } catch (e) {
                self1._mode = 'text:vbarray';
                break;
            }
            if (response.length > self1._pos) {
                var newData = response.substr(self1._pos);
                if (self1._charset === 'x-user-defined') {
                    var buffer = new $3fe9119940fa16b8$var$Buffer$1(newData.length);
                    for(var i = 0; i < newData.length; i++)buffer[i] = newData.charCodeAt(i) & 0xff;
                    self1.push(buffer);
                } else self1.push(newData, self1._charset);
                self1._pos = response.length;
            }
            break;
        case 'arraybuffer':
            if (xhr.readyState !== $3fe9119940fa16b8$var$rStates.DONE || !xhr.response) break;
            response = xhr.response;
            self1.push(new $3fe9119940fa16b8$var$Buffer$1(new Uint8Array(response)));
            break;
        case 'moz-chunked-arraybuffer':
            response = xhr.response;
            if (xhr.readyState !== $3fe9119940fa16b8$var$rStates.LOADING || !response) break;
            self1.push(new $3fe9119940fa16b8$var$Buffer$1(new Uint8Array(response)));
            break;
        case 'ms-stream':
            response = xhr.response;
            if (xhr.readyState !== $3fe9119940fa16b8$var$rStates.LOADING) break;
            var reader = new $3fe9119940fa16b8$var$global$1.MSStreamReader();
            reader.onprogress = function() {
                if (reader.result.byteLength > self1._pos) {
                    self1.push(new $3fe9119940fa16b8$var$Buffer$1(new Uint8Array(reader.result.slice(self1._pos))));
                    self1._pos = reader.result.byteLength;
                }
            };
            reader.onload = function() {
                self1.push(null);
            };
            // reader.onerror = ??? // TODO: this
            reader.readAsArrayBuffer(response);
            break;
    }
    // The ms-stream case handles end separately in reader.onload()
    if (self1._xhr.readyState === $3fe9119940fa16b8$var$rStates.DONE && self1._mode !== 'ms-stream') self1.push(null);
};
// from https://github.com/jhiesey/to-arraybuffer/blob/6502d9850e70ba7935a7df4ad86b358fc216f9f0/index.js
function $3fe9119940fa16b8$var$toArrayBuffer(buf) {
    // If the buffer is backed by a Uint8Array, a faster version will work
    if (buf instanceof Uint8Array) {
        // If the buffer isn't a subarray, return the underlying ArrayBuffer
        if (buf.byteOffset === 0 && buf.byteLength === buf.buffer.byteLength) return buf.buffer;
        else if (typeof buf.buffer.slice === 'function') // Otherwise we need to get a proper copy
        return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
    }
    if ($3fe9119940fa16b8$var$isBuffer(buf)) {
        // This is the slow version that will work with any Buffer
        // implementation (even in old browsers)
        var arrayCopy = new Uint8Array(buf.length);
        var len = buf.length;
        for(var i = 0; i < len; i++)arrayCopy[i] = buf[i];
        return arrayCopy.buffer;
    } else throw new Error('Argument must be a Buffer');
}
function $3fe9119940fa16b8$var$decideMode(preferBinary, useFetch) {
    if ($3fe9119940fa16b8$var$hasFetch && useFetch) return 'fetch';
    else if ($3fe9119940fa16b8$var$mozchunkedarraybuffer) return 'moz-chunked-arraybuffer';
    else if ($3fe9119940fa16b8$var$msstream) return 'ms-stream';
    else if ($3fe9119940fa16b8$var$arraybuffer && preferBinary) return 'arraybuffer';
    else if ($3fe9119940fa16b8$var$vbArray && preferBinary) return 'text:vbarray';
    else return 'text';
}
function $3fe9119940fa16b8$var$ClientRequest(opts) {
    var self1 = this;
    $3fe9119940fa16b8$var$Writable.call(self1);
    self1._opts = opts;
    self1._body = [];
    self1._headers = {};
    if (opts.auth) self1.setHeader('Authorization', 'Basic ' + new $3fe9119940fa16b8$var$Buffer$1(opts.auth).toString('base64'));
    Object.keys(opts.headers).forEach(function(name) {
        self1.setHeader(name, opts.headers[name]);
    });
    var preferBinary;
    var useFetch = true;
    if (opts.mode === 'disable-fetch') {
        // If the use of XHR should be preferred and includes preserving the 'content-type' header
        useFetch = false;
        preferBinary = true;
    } else if (opts.mode === 'prefer-streaming') // If streaming is a high priority but binary compatibility and
    // the accuracy of the 'content-type' header aren't
    preferBinary = false;
    else if (opts.mode === 'allow-wrong-content-type') // If streaming is more important than preserving the 'content-type' header
    preferBinary = !$3fe9119940fa16b8$var$overrideMimeType;
    else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') // Use binary if text streaming may corrupt data or the content-type header, or for speed
    preferBinary = true;
    else throw new Error('Invalid value for opts.mode');
    self1._mode = $3fe9119940fa16b8$var$decideMode(preferBinary, useFetch);
    self1.on('finish', function() {
        self1._onFinish();
    });
}
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$ClientRequest, $3fe9119940fa16b8$var$Writable);
// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var $3fe9119940fa16b8$var$unsafeHeaders = [
    'accept-charset',
    'accept-encoding',
    'access-control-request-headers',
    'access-control-request-method',
    'connection',
    'content-length',
    'cookie',
    'cookie2',
    'date',
    'dnt',
    'expect',
    'host',
    'keep-alive',
    'origin',
    'referer',
    'te',
    'trailer',
    'transfer-encoding',
    'upgrade',
    'user-agent',
    'via'
];
$3fe9119940fa16b8$var$ClientRequest.prototype.setHeader = function(name, value) {
    var self1 = this;
    var lowerName = name.toLowerCase();
    // This check is not necessary, but it prevents warnings from browsers about setting unsafe
    // headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
    // http-browserify did it, so I will too.
    if ($3fe9119940fa16b8$var$unsafeHeaders.indexOf(lowerName) !== -1) return;
    self1._headers[lowerName] = {
        name: name,
        value: value
    };
};
$3fe9119940fa16b8$var$ClientRequest.prototype.getHeader = function(name) {
    var self1 = this;
    return self1._headers[name.toLowerCase()].value;
};
$3fe9119940fa16b8$var$ClientRequest.prototype.removeHeader = function(name) {
    var self1 = this;
    delete self1._headers[name.toLowerCase()];
};
$3fe9119940fa16b8$var$ClientRequest.prototype._onFinish = function() {
    var self1 = this;
    if (self1._destroyed) return;
    var opts = self1._opts;
    var headersObj = self1._headers;
    var body;
    if (opts.method === 'POST' || opts.method === 'PUT' || opts.method === 'PATCH') {
        if ($3fe9119940fa16b8$var$blobConstructor()) body = new $3fe9119940fa16b8$var$global$1.Blob(self1._body.map(function(buffer) {
            return $3fe9119940fa16b8$var$toArrayBuffer(buffer);
        }), {
            type: (headersObj['content-type'] || {}).value || ''
        });
        else // get utf8 string
        body = $3fe9119940fa16b8$var$Buffer$1.concat(self1._body).toString();
    }
    if (self1._mode === 'fetch') {
        var headers = Object.keys(headersObj).map(function(name) {
            return [
                headersObj[name].name,
                headersObj[name].value
            ];
        });
        $3fe9119940fa16b8$var$global$1.fetch(self1._opts.url, {
            method: self1._opts.method,
            headers: headers,
            body: body,
            mode: 'cors',
            credentials: opts.withCredentials ? 'include' : 'same-origin'
        }).then(function(response) {
            self1._fetchResponse = response;
            self1._connect();
        }, function(reason) {
            self1.emit('error', reason);
        });
    } else {
        var xhr = self1._xhr = new $3fe9119940fa16b8$var$global$1.XMLHttpRequest();
        try {
            xhr.open(self1._opts.method, self1._opts.url, true);
        } catch (err) {
            $3fe9119940fa16b8$var$browser$1.nextTick(function() {
                self1.emit('error', err);
            });
            return;
        }
        // Can't set responseType on really old browsers
        if ('responseType' in xhr) xhr.responseType = self1._mode.split(':')[0];
        if ('withCredentials' in xhr) xhr.withCredentials = !!opts.withCredentials;
        if (self1._mode === 'text' && 'overrideMimeType' in xhr) xhr.overrideMimeType('text/plain; charset=x-user-defined');
        Object.keys(headersObj).forEach(function(name) {
            xhr.setRequestHeader(headersObj[name].name, headersObj[name].value);
        });
        self1._response = null;
        xhr.onreadystatechange = function() {
            switch(xhr.readyState){
                case $3fe9119940fa16b8$var$rStates.LOADING:
                case $3fe9119940fa16b8$var$rStates.DONE:
                    self1._onXHRProgress();
                    break;
            }
        };
        // Necessary for streaming in Firefox, since xhr.response is ONLY defined
        // in onprogress, not in onreadystatechange with xhr.readyState = 3
        if (self1._mode === 'moz-chunked-arraybuffer') xhr.onprogress = function() {
            self1._onXHRProgress();
        };
        xhr.onerror = function() {
            if (self1._destroyed) return;
            self1.emit('error', new Error('XHR error'));
        };
        try {
            xhr.send(body);
        } catch (err) {
            $3fe9119940fa16b8$var$browser$1.nextTick(function() {
                self1.emit('error', err);
            });
            return;
        }
    }
};
/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */ function $3fe9119940fa16b8$var$statusValid(xhr) {
    try {
        var status = xhr.status;
        return status !== null && status !== 0;
    } catch (e) {
        return false;
    }
}
$3fe9119940fa16b8$var$ClientRequest.prototype._onXHRProgress = function() {
    var self1 = this;
    if (!$3fe9119940fa16b8$var$statusValid(self1._xhr) || self1._destroyed) return;
    if (!self1._response) self1._connect();
    self1._response._onXHRProgress();
};
$3fe9119940fa16b8$var$ClientRequest.prototype._connect = function() {
    var self1 = this;
    if (self1._destroyed) return;
    self1._response = new $3fe9119940fa16b8$var$IncomingMessage(self1._xhr, self1._fetchResponse, self1._mode);
    self1.emit('response', self1._response);
};
$3fe9119940fa16b8$var$ClientRequest.prototype._write = function(chunk, encoding, cb) {
    var self1 = this;
    self1._body.push(chunk);
    cb();
};
$3fe9119940fa16b8$var$ClientRequest.prototype.abort = $3fe9119940fa16b8$var$ClientRequest.prototype.destroy = function() {
    var self1 = this;
    self1._destroyed = true;
    if (self1._response) self1._response._destroyed = true;
    if (self1._xhr) self1._xhr.abort();
// Currently, there isn't a way to truly abort a fetch.
// If you like bikeshedding, see https://github.com/whatwg/fetch/issues/27
};
$3fe9119940fa16b8$var$ClientRequest.prototype.end = function(data, encoding, cb) {
    var self1 = this;
    if (typeof data === 'function') {
        cb = data;
        data = undefined;
    }
    $3fe9119940fa16b8$var$Writable.prototype.end.call(self1, data, encoding, cb);
};
$3fe9119940fa16b8$var$ClientRequest.prototype.flushHeaders = function() {};
$3fe9119940fa16b8$var$ClientRequest.prototype.setTimeout = function() {};
$3fe9119940fa16b8$var$ClientRequest.prototype.setNoDelay = function() {};
$3fe9119940fa16b8$var$ClientRequest.prototype.setSocketKeepAlive = function() {};
/*! https://mths.be/punycode v1.4.1 by @mathias */ /** Highest positive signed 32-bit float value */ var $3fe9119940fa16b8$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ var $3fe9119940fa16b8$var$base = 36;
var $3fe9119940fa16b8$var$tMin = 1;
var $3fe9119940fa16b8$var$tMax = 26;
var $3fe9119940fa16b8$var$skew = 38;
var $3fe9119940fa16b8$var$damp = 700;
var $3fe9119940fa16b8$var$initialBias = 72;
var $3fe9119940fa16b8$var$initialN = 128; // 0x80
var $3fe9119940fa16b8$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ var $3fe9119940fa16b8$var$regexPunycode = /^xn--/;
var $3fe9119940fa16b8$var$regexNonASCII = /[^\x20-\x7E]/; // unprintable ASCII chars + non-ASCII chars
var $3fe9119940fa16b8$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ var $3fe9119940fa16b8$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ var $3fe9119940fa16b8$var$baseMinusTMin = $3fe9119940fa16b8$var$base - $3fe9119940fa16b8$var$tMin;
var $3fe9119940fa16b8$var$floor = Math.floor;
var $3fe9119940fa16b8$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $3fe9119940fa16b8$var$error(type) {
    throw new RangeError($3fe9119940fa16b8$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $3fe9119940fa16b8$var$map$1(array, fn) {
    var length = array.length;
    var result = [];
    while(length--)result[length] = fn(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */ function $3fe9119940fa16b8$var$mapDomain(string, fn) {
    var parts = string.split('@');
    var result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        string = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    string = string.replace($3fe9119940fa16b8$var$regexSeparators, '\x2E');
    var labels = string.split('.');
    var encoded = $3fe9119940fa16b8$var$map$1(labels, fn).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $3fe9119940fa16b8$var$ucs2decode(string) {
    var output = [], counter = 0, length = string.length, value, extra;
    while(counter < length){
        value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // high surrogate, and there is a next character
            extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // unmatched surrogate; only append this code unit, in case the next
                // code unit is the high surrogate of a surrogate pair
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ function $3fe9119940fa16b8$var$ucs2encode(array) {
    return $3fe9119940fa16b8$var$map$1(array, function(value) {
        var output = '';
        if (value > 0xFFFF) {
            value -= 0x10000;
            output += $3fe9119940fa16b8$var$stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
            value = 0xDC00 | value & 0x3FF;
        }
        output += $3fe9119940fa16b8$var$stringFromCharCode(value);
        return output;
    }).join('');
}
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ function $3fe9119940fa16b8$var$basicToDigit(codePoint) {
    if (codePoint - 48 < 10) return codePoint - 22;
    if (codePoint - 65 < 26) return codePoint - 65;
    if (codePoint - 97 < 26) return codePoint - 97;
    return $3fe9119940fa16b8$var$base;
}
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ function $3fe9119940fa16b8$var$digitToBasic(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
}
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ function $3fe9119940fa16b8$var$adapt(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? $3fe9119940fa16b8$var$floor(delta / $3fe9119940fa16b8$var$damp) : delta >> 1;
    delta += $3fe9119940fa16b8$var$floor(delta / numPoints);
    for(; delta > $3fe9119940fa16b8$var$baseMinusTMin * $3fe9119940fa16b8$var$tMax >> 1; k += $3fe9119940fa16b8$var$base)delta = $3fe9119940fa16b8$var$floor(delta / $3fe9119940fa16b8$var$baseMinusTMin);
    return $3fe9119940fa16b8$var$floor(k + ($3fe9119940fa16b8$var$baseMinusTMin + 1) * delta / (delta + $3fe9119940fa16b8$var$skew));
}
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ function $3fe9119940fa16b8$var$decode(input) {
    // Don't use UCS-2
    var output = [], inputLength = input.length, out, i = 0, n = $3fe9119940fa16b8$var$initialN, bias = $3fe9119940fa16b8$var$initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    basic = input.lastIndexOf($3fe9119940fa16b8$var$delimiter);
    if (basic < 0) basic = 0;
    for(j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $3fe9119940fa16b8$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        for(oldi = i, w = 1, k = $3fe9119940fa16b8$var$base;; k += $3fe9119940fa16b8$var$base){
            if (index >= inputLength) $3fe9119940fa16b8$var$error('invalid-input');
            digit = $3fe9119940fa16b8$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $3fe9119940fa16b8$var$base || digit > $3fe9119940fa16b8$var$floor(($3fe9119940fa16b8$var$maxInt - i) / w)) $3fe9119940fa16b8$var$error('overflow');
            i += digit * w;
            t = k <= bias ? $3fe9119940fa16b8$var$tMin : k >= bias + $3fe9119940fa16b8$var$tMax ? $3fe9119940fa16b8$var$tMax : k - bias;
            if (digit < t) break;
            baseMinusT = $3fe9119940fa16b8$var$base - t;
            if (w > $3fe9119940fa16b8$var$floor($3fe9119940fa16b8$var$maxInt / baseMinusT)) $3fe9119940fa16b8$var$error('overflow');
            w *= baseMinusT;
        }
        out = output.length + 1;
        bias = $3fe9119940fa16b8$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($3fe9119940fa16b8$var$floor(i / out) > $3fe9119940fa16b8$var$maxInt - n) $3fe9119940fa16b8$var$error('overflow');
        n += $3fe9119940fa16b8$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output
        output.splice(i++, 0, n);
    }
    return $3fe9119940fa16b8$var$ucs2encode(output);
}
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ function $3fe9119940fa16b8$var$encode(input) {
    var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
    // Convert the input in UCS-2 to Unicode
    input = $3fe9119940fa16b8$var$ucs2decode(input);
    // Cache the length
    inputLength = input.length;
    // Initialize the state
    n = $3fe9119940fa16b8$var$initialN;
    delta = 0;
    bias = $3fe9119940fa16b8$var$initialBias;
    // Handle the basic code points
    for(j = 0; j < inputLength; ++j){
        currentValue = input[j];
        if (currentValue < 0x80) output.push($3fe9119940fa16b8$var$stringFromCharCode(currentValue));
    }
    handledCPCount = basicLength = output.length;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string - if it is not empty - with a delimiter
    if (basicLength) output.push($3fe9119940fa16b8$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        for(m = $3fe9119940fa16b8$var$maxInt, j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue >= n && currentValue < m) m = currentValue;
        }
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow
        handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $3fe9119940fa16b8$var$floor(($3fe9119940fa16b8$var$maxInt - delta) / handledCPCountPlusOne)) $3fe9119940fa16b8$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < n && ++delta > $3fe9119940fa16b8$var$maxInt) $3fe9119940fa16b8$var$error('overflow');
            if (currentValue == n) {
                // Represent delta as a generalized variable-length integer
                for(q = delta, k = $3fe9119940fa16b8$var$base;; k += $3fe9119940fa16b8$var$base){
                    t = k <= bias ? $3fe9119940fa16b8$var$tMin : k >= bias + $3fe9119940fa16b8$var$tMax ? $3fe9119940fa16b8$var$tMax : k - bias;
                    if (q < t) break;
                    qMinusT = q - t;
                    baseMinusT = $3fe9119940fa16b8$var$base - t;
                    output.push($3fe9119940fa16b8$var$stringFromCharCode($3fe9119940fa16b8$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $3fe9119940fa16b8$var$floor(qMinusT / baseMinusT);
                }
                output.push($3fe9119940fa16b8$var$stringFromCharCode($3fe9119940fa16b8$var$digitToBasic(q, 0)));
                bias = $3fe9119940fa16b8$var$adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
}
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ function $3fe9119940fa16b8$var$toUnicode(input) {
    return $3fe9119940fa16b8$var$mapDomain(input, function(string) {
        return $3fe9119940fa16b8$var$regexPunycode.test(string) ? $3fe9119940fa16b8$var$decode(string.slice(4).toLowerCase()) : string;
    });
}
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ function $3fe9119940fa16b8$var$toASCII(input) {
    return $3fe9119940fa16b8$var$mapDomain(input, function(string) {
        return $3fe9119940fa16b8$var$regexNonASCII.test(string) ? 'xn--' + $3fe9119940fa16b8$var$encode(string) : string;
    });
}
var $3fe9119940fa16b8$var$version = '1.4.1';
/**
 * An object of methods to convert from JavaScript's internal character
 * representation (UCS-2) to Unicode code points, and back.
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode
 * @type Object
 */ var $3fe9119940fa16b8$var$ucs2 = {
    decode: $3fe9119940fa16b8$var$ucs2decode,
    encode: $3fe9119940fa16b8$var$ucs2encode
};
var $3fe9119940fa16b8$var$_polyfillNode_punycode = {
    version: $3fe9119940fa16b8$var$version,
    ucs2: $3fe9119940fa16b8$var$ucs2,
    toASCII: $3fe9119940fa16b8$var$toASCII,
    toUnicode: $3fe9119940fa16b8$var$toUnicode,
    encode: $3fe9119940fa16b8$var$encode,
    decode: $3fe9119940fa16b8$var$decode
};
var $3fe9119940fa16b8$var$_polyfillNode_punycode$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    decode: $3fe9119940fa16b8$var$decode,
    default: $3fe9119940fa16b8$var$_polyfillNode_punycode,
    encode: $3fe9119940fa16b8$var$encode,
    toASCII: $3fe9119940fa16b8$var$toASCII,
    toUnicode: $3fe9119940fa16b8$var$toUnicode,
    ucs2: $3fe9119940fa16b8$var$ucs2,
    version: $3fe9119940fa16b8$var$version
});
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $3fe9119940fa16b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $3fe9119940fa16b8$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $3fe9119940fa16b8$var$stringifyPrimitive(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
}
function $3fe9119940fa16b8$var$stringify(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $3fe9119940fa16b8$var$map($3fe9119940fa16b8$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($3fe9119940fa16b8$var$stringifyPrimitive(k)) + eq;
        if ($3fe9119940fa16b8$var$isArray(obj[k])) return $3fe9119940fa16b8$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($3fe9119940fa16b8$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($3fe9119940fa16b8$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($3fe9119940fa16b8$var$stringifyPrimitive(name)) + eq + encodeURIComponent($3fe9119940fa16b8$var$stringifyPrimitive(obj));
}
function $3fe9119940fa16b8$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $3fe9119940fa16b8$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};
function $3fe9119940fa16b8$var$parse$1(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$3fe9119940fa16b8$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($3fe9119940fa16b8$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
}
// WHATWG API
const $3fe9119940fa16b8$var$URL$3 = $3fe9119940fa16b8$var$global$1.URL;
const $3fe9119940fa16b8$var$URLSearchParams$1 = $3fe9119940fa16b8$var$global$1.URLSearchParams;
var $3fe9119940fa16b8$var$Url = {
    parse: $3fe9119940fa16b8$var$urlParse,
    resolve: $3fe9119940fa16b8$var$urlResolve,
    resolveObject: $3fe9119940fa16b8$var$urlResolveObject,
    fileURLToPath: $3fe9119940fa16b8$var$urlFileURLToPath,
    format: $3fe9119940fa16b8$var$urlFormat,
    Url: $3fe9119940fa16b8$var$Url$1,
    // WHATWG API
    URL: $3fe9119940fa16b8$var$URL$3,
    URLSearchParams: $3fe9119940fa16b8$var$URLSearchParams$1
};
function $3fe9119940fa16b8$var$Url$1() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $3fe9119940fa16b8$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $3fe9119940fa16b8$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$3fe9119940fa16b8$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$3fe9119940fa16b8$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
$3fe9119940fa16b8$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($3fe9119940fa16b8$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$3fe9119940fa16b8$var$autoEscape = [
    '\''
].concat($3fe9119940fa16b8$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$3fe9119940fa16b8$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($3fe9119940fa16b8$var$autoEscape), $3fe9119940fa16b8$var$hostEndingChars = [
    '/',
    '?',
    '#'
], $3fe9119940fa16b8$var$hostnameMaxLen = 255, $3fe9119940fa16b8$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $3fe9119940fa16b8$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
$3fe9119940fa16b8$var$unsafeProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that never have a hostname.
$3fe9119940fa16b8$var$hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
$3fe9119940fa16b8$var$slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
function $3fe9119940fa16b8$var$urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $3fe9119940fa16b8$var$isObject(url) && url instanceof $3fe9119940fa16b8$var$Url$1) return url;
    var u = new $3fe9119940fa16b8$var$Url$1;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
$3fe9119940fa16b8$var$Url$1.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    return $3fe9119940fa16b8$var$parse(this, url, parseQueryString, slashesDenoteHost);
};
function $3fe9119940fa16b8$var$parse(self1, url, parseQueryString, slashesDenoteHost) {
    if (!$3fe9119940fa16b8$var$isString$1(url)) throw new TypeError('Parameter \'url\' must be a string, not ' + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = $3fe9119940fa16b8$var$simplePathPattern.exec(rest);
        if (simplePath) {
            self1.path = rest;
            self1.href = rest;
            self1.pathname = simplePath[1];
            if (simplePath[2]) {
                self1.search = simplePath[2];
                if (parseQueryString) self1.query = $3fe9119940fa16b8$var$parse$1(self1.search.substr(1));
                else self1.query = self1.search.substr(1);
            } else if (parseQueryString) {
                self1.search = '';
                self1.query = {};
            }
            return self1;
        }
    }
    var proto = $3fe9119940fa16b8$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        self1.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $3fe9119940fa16b8$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            self1.slashes = true;
        }
    }
    var i, hec, l, p;
    if (!$3fe9119940fa16b8$var$hostlessProtocol[proto] && (slashes || proto && !$3fe9119940fa16b8$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $3fe9119940fa16b8$var$hostEndingChars.length; i++){
            hec = rest.indexOf($3fe9119940fa16b8$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            self1.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $3fe9119940fa16b8$var$nonHostChars.length; i++){
            hec = rest.indexOf($3fe9119940fa16b8$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        self1.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        $3fe9119940fa16b8$var$parseHost(self1);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        self1.hostname = self1.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = self1.hostname[0] === '[' && self1.hostname[self1.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = self1.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($3fe9119940fa16b8$var$hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($3fe9119940fa16b8$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($3fe9119940fa16b8$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        self1.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (self1.hostname.length > $3fe9119940fa16b8$var$hostnameMaxLen) self1.hostname = '';
        else // hostnames are always lower case.
        self1.hostname = self1.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        self1.hostname = $3fe9119940fa16b8$var$toASCII(self1.hostname);
        p = self1.port ? ':' + self1.port : '';
        var h = self1.hostname || '';
        self1.host = h + p;
        self1.href += self1.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            self1.hostname = self1.hostname.substr(1, self1.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!$3fe9119940fa16b8$var$unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(i = 0, l = $3fe9119940fa16b8$var$autoEscape.length; i < l; i++){
        var ae = $3fe9119940fa16b8$var$autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        self1.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        self1.search = rest.substr(qm);
        self1.query = rest.substr(qm + 1);
        if (parseQueryString) self1.query = $3fe9119940fa16b8$var$parse$1(self1.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        self1.search = '';
        self1.query = {};
    }
    if (rest) self1.pathname = rest;
    if ($3fe9119940fa16b8$var$slashedProtocol[lowerProto] && self1.hostname && !self1.pathname) self1.pathname = '/';
    //to support http.request
    if (self1.pathname || self1.search) {
        p = self1.pathname || '';
        var s = self1.search || '';
        self1.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    self1.href = $3fe9119940fa16b8$var$format(self1);
    return self1;
}
function $3fe9119940fa16b8$var$urlFileURLToPath(path) {
    if (typeof path === 'string') path = new $3fe9119940fa16b8$var$Url$1().parse(path);
    else if (!(path instanceof $3fe9119940fa16b8$var$Url$1)) throw new TypeError('The "path" argument must be of type string or an instance of URL. Received type ' + typeof path + String(path));
    if (path.protocol !== 'file:') throw new TypeError('The URL must be of scheme file');
    return $3fe9119940fa16b8$var$getPathFromURLPosix(path);
}
function $3fe9119940fa16b8$var$getPathFromURLPosix(url) {
    const pathname = url.pathname;
    for(let n = 0; n < pathname.length; n++)if (pathname[n] === '%') {
        const third = pathname.codePointAt(n + 2) | 0x20;
        if (pathname[n + 1] === '2' && third === 102) throw new TypeError('must not include encoded / characters');
    }
    return decodeURIComponent(pathname);
}
// format a parsed object into a url string
function $3fe9119940fa16b8$var$urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($3fe9119940fa16b8$var$isString$1(obj)) obj = $3fe9119940fa16b8$var$parse({}, obj);
    return $3fe9119940fa16b8$var$format(obj);
}
function $3fe9119940fa16b8$var$format(self1) {
    var auth = self1.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = self1.protocol || '', pathname = self1.pathname || '', hash = self1.hash || '', host = false, query = '';
    if (self1.host) host = auth + self1.host;
    else if (self1.hostname) {
        host = auth + (self1.hostname.indexOf(':') === -1 ? self1.hostname : '[' + this.hostname + ']');
        if (self1.port) host += ':' + self1.port;
    }
    if (self1.query && $3fe9119940fa16b8$var$isObject(self1.query) && Object.keys(self1.query).length) query = $3fe9119940fa16b8$var$stringify(self1.query);
    var search = self1.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (self1.slashes || (!protocol || $3fe9119940fa16b8$var$slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
}
$3fe9119940fa16b8$var$Url$1.prototype.format = function() {
    return $3fe9119940fa16b8$var$format(this);
};
function $3fe9119940fa16b8$var$urlResolve(source, relative) {
    return $3fe9119940fa16b8$var$urlParse(source, false, true).resolve(relative);
}
$3fe9119940fa16b8$var$Url$1.prototype.resolve = function(relative) {
    return this.resolveObject($3fe9119940fa16b8$var$urlParse(relative, false, true)).format();
};
function $3fe9119940fa16b8$var$urlResolveObject(source, relative) {
    if (!source) return relative;
    return $3fe9119940fa16b8$var$urlParse(source, false, true).resolveObject(relative);
}
$3fe9119940fa16b8$var$Url$1.prototype.resolveObject = function(relative) {
    if ($3fe9119940fa16b8$var$isString$1(relative)) {
        var rel = new $3fe9119940fa16b8$var$Url$1();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new $3fe9119940fa16b8$var$Url$1();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if ($3fe9119940fa16b8$var$slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = '/';
        result.href = result.format();
        return result;
    }
    var relPath;
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!$3fe9119940fa16b8$var$slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !$3fe9119940fa16b8$var$hostlessProtocol[relative.protocol]) {
            relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], psychotic = result.protocol && !$3fe9119940fa16b8$var$slashedProtocol[result.protocol];
    relPath = relative.pathname && relative.pathname.split('/') || [];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    var authInHost;
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$3fe9119940fa16b8$var$isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$3fe9119940fa16b8$var$isNull(result.pathname) || !$3fe9119940fa16b8$var$isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join('/');
    //to support request.http
    if (!$3fe9119940fa16b8$var$isNull(result.pathname) || !$3fe9119940fa16b8$var$isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
$3fe9119940fa16b8$var$Url$1.prototype.parseHost = function() {
    return $3fe9119940fa16b8$var$parseHost(this);
};
function $3fe9119940fa16b8$var$parseHost(self1) {
    var host = self1.host;
    var port = $3fe9119940fa16b8$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') self1.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) self1.hostname = host;
}
function $3fe9119940fa16b8$var$request$2(opts, cb) {
    if (typeof opts === 'string') opts = $3fe9119940fa16b8$var$urlParse(opts);
    // Normally, the page is loaded from http or https, so not specifying a protocol
    // will result in a (valid) protocol-relative url. However, this won't work if
    // the protocol is something else, like 'file:'
    var defaultProtocol = $3fe9119940fa16b8$var$global$1.location.protocol.search(/^https?:$/) === -1 ? 'http:' : '';
    var protocol = opts.protocol || defaultProtocol;
    var host = opts.hostname || opts.host;
    var port = opts.port;
    var path = opts.path || '/';
    // Necessary for IPv6 addresses
    if (host && host.indexOf(':') !== -1) host = '[' + host + ']';
    // This may be a relative url. The browser should always be able to interpret it correctly.
    opts.url = (host ? protocol + '//' + host : '') + (port ? ':' + port : '') + path;
    opts.method = (opts.method || 'GET').toUpperCase();
    opts.headers = opts.headers || {};
    // Also valid opts.auth, opts.mode
    var req = new $3fe9119940fa16b8$var$ClientRequest(opts);
    if (cb) req.on('response', cb);
    return req;
}
function $3fe9119940fa16b8$var$get$1(opts, cb) {
    var req = $3fe9119940fa16b8$var$request$2(opts, cb);
    req.end();
    return req;
}
function $3fe9119940fa16b8$var$Agent$1() {}
$3fe9119940fa16b8$var$Agent$1.defaultMaxSockets = 4;
var $3fe9119940fa16b8$var$METHODS$1 = [
    'CHECKOUT',
    'CONNECT',
    'COPY',
    'DELETE',
    'GET',
    'HEAD',
    'LOCK',
    'M-SEARCH',
    'MERGE',
    'MKACTIVITY',
    'MKCOL',
    'MOVE',
    'NOTIFY',
    'OPTIONS',
    'PATCH',
    'POST',
    'PROPFIND',
    'PROPPATCH',
    'PURGE',
    'PUT',
    'REPORT',
    'SEARCH',
    'SUBSCRIBE',
    'TRACE',
    'UNLOCK',
    'UNSUBSCRIBE'
];
var $3fe9119940fa16b8$var$STATUS_CODES$2 = {
    100: 'Continue',
    101: 'Switching Protocols',
    102: 'Processing',
    200: 'OK',
    201: 'Created',
    202: 'Accepted',
    203: 'Non-Authoritative Information',
    204: 'No Content',
    205: 'Reset Content',
    206: 'Partial Content',
    207: 'Multi-Status',
    300: 'Multiple Choices',
    301: 'Moved Permanently',
    302: 'Moved Temporarily',
    303: 'See Other',
    304: 'Not Modified',
    305: 'Use Proxy',
    307: 'Temporary Redirect',
    400: 'Bad Request',
    401: 'Unauthorized',
    402: 'Payment Required',
    403: 'Forbidden',
    404: 'Not Found',
    405: 'Method Not Allowed',
    406: 'Not Acceptable',
    407: 'Proxy Authentication Required',
    408: 'Request Time-out',
    409: 'Conflict',
    410: 'Gone',
    411: 'Length Required',
    412: 'Precondition Failed',
    413: 'Request Entity Too Large',
    414: 'Request-URI Too Large',
    415: 'Unsupported Media Type',
    416: 'Requested Range Not Satisfiable',
    417: 'Expectation Failed',
    418: 'I\'m a teapot',
    422: 'Unprocessable Entity',
    423: 'Locked',
    424: 'Failed Dependency',
    425: 'Unordered Collection',
    426: 'Upgrade Required',
    428: 'Precondition Required',
    429: 'Too Many Requests',
    431: 'Request Header Fields Too Large',
    500: 'Internal Server Error',
    501: 'Not Implemented',
    502: 'Bad Gateway',
    503: 'Service Unavailable',
    504: 'Gateway Time-out',
    505: 'HTTP Version Not Supported',
    506: 'Variant Also Negotiates',
    507: 'Insufficient Storage',
    509: 'Bandwidth Limit Exceeded',
    510: 'Not Extended',
    511: 'Network Authentication Required' // RFC 6585
};
var $3fe9119940fa16b8$var$http = {
    request: $3fe9119940fa16b8$var$request$2,
    get: $3fe9119940fa16b8$var$get$1,
    Agent: $3fe9119940fa16b8$var$Agent$1,
    METHODS: $3fe9119940fa16b8$var$METHODS$1,
    STATUS_CODES: $3fe9119940fa16b8$var$STATUS_CODES$2
};
var $3fe9119940fa16b8$var$publicApi = {};
var $3fe9119940fa16b8$var$URL$2 = {
    exports: {}
};
var $3fe9119940fa16b8$var$conversions = {};
var $3fe9119940fa16b8$var$lib$1 = $3fe9119940fa16b8$var$conversions;
function $3fe9119940fa16b8$var$sign(x) {
    return x < 0 ? -1 : 1;
}
function $3fe9119940fa16b8$var$evenRound(x) {
    // Round x to the nearest integer, choosing the even integer if it lies halfway between two.
    if (x % 1 === 0.5 && (x & 1) === 0) return Math.floor(x);
    else return Math.round(x);
}
function $3fe9119940fa16b8$var$createNumberConversion(bitLength, typeOpts) {
    if (!typeOpts.unsigned) --bitLength;
    const lowerBound = typeOpts.unsigned ? 0 : -Math.pow(2, bitLength);
    const upperBound = Math.pow(2, bitLength) - 1;
    const moduloVal = typeOpts.moduloBitLength ? Math.pow(2, typeOpts.moduloBitLength) : Math.pow(2, bitLength);
    const moduloBound = typeOpts.moduloBitLength ? Math.pow(2, typeOpts.moduloBitLength - 1) : Math.pow(2, bitLength - 1);
    return function(V, opts) {
        if (!opts) opts = {};
        let x = +V;
        if (opts.enforceRange) {
            if (!Number.isFinite(x)) throw new TypeError("Argument is not a finite number");
            x = $3fe9119940fa16b8$var$sign(x) * Math.floor(Math.abs(x));
            if (x < lowerBound || x > upperBound) throw new TypeError("Argument is not in byte range");
            return x;
        }
        if (!isNaN(x) && opts.clamp) {
            x = $3fe9119940fa16b8$var$evenRound(x);
            if (x < lowerBound) x = lowerBound;
            if (x > upperBound) x = upperBound;
            return x;
        }
        if (!Number.isFinite(x) || x === 0) return 0;
        x = $3fe9119940fa16b8$var$sign(x) * Math.floor(Math.abs(x));
        x = x % moduloVal;
        if (!typeOpts.unsigned && x >= moduloBound) return x - moduloVal;
        else if (typeOpts.unsigned) {
            if (x < 0) x += moduloVal;
            else if (x === -0) return 0;
        }
        return x;
    };
}
$3fe9119940fa16b8$var$conversions["void"] = function() {
    return undefined;
};
$3fe9119940fa16b8$var$conversions["boolean"] = function(val) {
    return !!val;
};
$3fe9119940fa16b8$var$conversions["byte"] = $3fe9119940fa16b8$var$createNumberConversion(8, {
    unsigned: false
});
$3fe9119940fa16b8$var$conversions["octet"] = $3fe9119940fa16b8$var$createNumberConversion(8, {
    unsigned: true
});
$3fe9119940fa16b8$var$conversions["short"] = $3fe9119940fa16b8$var$createNumberConversion(16, {
    unsigned: false
});
$3fe9119940fa16b8$var$conversions["unsigned short"] = $3fe9119940fa16b8$var$createNumberConversion(16, {
    unsigned: true
});
$3fe9119940fa16b8$var$conversions["long"] = $3fe9119940fa16b8$var$createNumberConversion(32, {
    unsigned: false
});
$3fe9119940fa16b8$var$conversions["unsigned long"] = $3fe9119940fa16b8$var$createNumberConversion(32, {
    unsigned: true
});
$3fe9119940fa16b8$var$conversions["long long"] = $3fe9119940fa16b8$var$createNumberConversion(32, {
    unsigned: false,
    moduloBitLength: 64
});
$3fe9119940fa16b8$var$conversions["unsigned long long"] = $3fe9119940fa16b8$var$createNumberConversion(32, {
    unsigned: true,
    moduloBitLength: 64
});
$3fe9119940fa16b8$var$conversions["double"] = function(V) {
    const x = +V;
    if (!Number.isFinite(x)) throw new TypeError("Argument is not a finite floating-point value");
    return x;
};
$3fe9119940fa16b8$var$conversions["unrestricted double"] = function(V) {
    const x = +V;
    if (isNaN(x)) throw new TypeError("Argument is NaN");
    return x;
};
// not quite valid, but good enough for JS
$3fe9119940fa16b8$var$conversions["float"] = $3fe9119940fa16b8$var$conversions["double"];
$3fe9119940fa16b8$var$conversions["unrestricted float"] = $3fe9119940fa16b8$var$conversions["unrestricted double"];
$3fe9119940fa16b8$var$conversions["DOMString"] = function(V, opts) {
    if (!opts) opts = {};
    if (opts.treatNullAsEmptyString && V === null) return "";
    return String(V);
};
$3fe9119940fa16b8$var$conversions["ByteString"] = function(V, opts) {
    const x = String(V);
    let c = undefined;
    for(let i = 0; (c = x.codePointAt(i)) !== undefined; ++i){
        if (c > 255) throw new TypeError("Argument is not a valid bytestring");
    }
    return x;
};
$3fe9119940fa16b8$var$conversions["USVString"] = function(V) {
    const S = String(V);
    const n = S.length;
    const U = [];
    for(let i = 0; i < n; ++i){
        const c = S.charCodeAt(i);
        if (c < 0xD800 || c > 0xDFFF) U.push(String.fromCodePoint(c));
        else if (0xDC00 <= c && c <= 0xDFFF) U.push(String.fromCodePoint(0xFFFD));
        else if (i === n - 1) U.push(String.fromCodePoint(0xFFFD));
        else {
            const d = S.charCodeAt(i + 1);
            if (0xDC00 <= d && d <= 0xDFFF) {
                const a = c & 0x3FF;
                const b = d & 0x3FF;
                U.push(String.fromCodePoint(65536 + 1024 * a + b));
                ++i;
            } else U.push(String.fromCodePoint(0xFFFD));
        }
    }
    return U.join('');
};
$3fe9119940fa16b8$var$conversions["Date"] = function(V, opts) {
    if (!(V instanceof Date)) throw new TypeError("Argument is not a Date object");
    if (isNaN(V)) return undefined;
    return V;
};
$3fe9119940fa16b8$var$conversions["RegExp"] = function(V, opts) {
    if (!(V instanceof RegExp)) V = new RegExp(V);
    return V;
};
var $3fe9119940fa16b8$var$utils = {
    exports: {}
};
(function(module) {
    module.exports.mixin = function mixin(target, source) {
        const keys = Object.getOwnPropertyNames(source);
        for(let i = 0; i < keys.length; ++i)Object.defineProperty(target, keys[i], Object.getOwnPropertyDescriptor(source, keys[i]));
    };
    module.exports.wrapperSymbol = Symbol("wrapper");
    module.exports.implSymbol = Symbol("impl");
    module.exports.wrapperForImpl = function(impl) {
        return impl[module.exports.wrapperSymbol];
    };
    module.exports.implForWrapper = function(wrapper) {
        return wrapper[module.exports.implSymbol];
    };
})($3fe9119940fa16b8$var$utils);
var $3fe9119940fa16b8$var$utilsExports = $3fe9119940fa16b8$var$utils.exports;
var $3fe9119940fa16b8$var$URLImpl = {};
var $3fe9119940fa16b8$var$urlStateMachine = {
    exports: {}
};
var $3fe9119940fa16b8$var$require$$0$1 = /*@__PURE__*/ $3fe9119940fa16b8$var$getAugmentedNamespace($3fe9119940fa16b8$var$_polyfillNode_punycode$1);
var $3fe9119940fa16b8$var$tr46 = {};
var $3fe9119940fa16b8$var$require$$1 = [
    [
        [
            0,
            44
        ],
        "disallowed_STD3_valid"
    ],
    [
        [
            45,
            46
        ],
        "valid"
    ],
    [
        [
            47,
            47
        ],
        "disallowed_STD3_valid"
    ],
    [
        [
            48,
            57
        ],
        "valid"
    ],
    [
        [
            58,
            64
        ],
        "disallowed_STD3_valid"
    ],
    [
        [
            65,
            65
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            66,
            66
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            67,
            67
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            68,
            68
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            69,
            69
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            70,
            70
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            71,
            71
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            72,
            72
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            73,
            73
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            74,
            74
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            75,
            75
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            76,
            76
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            77,
            77
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            78,
            78
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            79,
            79
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            80,
            80
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            81,
            81
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            82,
            82
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            83,
            83
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            84,
            84
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            85,
            85
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            86,
            86
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            87,
            87
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            88,
            88
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            89,
            89
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            90,
            90
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            91,
            96
        ],
        "disallowed_STD3_valid"
    ],
    [
        [
            97,
            122
        ],
        "valid"
    ],
    [
        [
            123,
            127
        ],
        "disallowed_STD3_valid"
    ],
    [
        [
            128,
            159
        ],
        "disallowed"
    ],
    [
        [
            160,
            160
        ],
        "disallowed_STD3_mapped",
        [
            32
        ]
    ],
    [
        [
            161,
            167
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            168,
            168
        ],
        "disallowed_STD3_mapped",
        [
            32,
            776
        ]
    ],
    [
        [
            169,
            169
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            170,
            170
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            171,
            172
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            173,
            173
        ],
        "ignored"
    ],
    [
        [
            174,
            174
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            175,
            175
        ],
        "disallowed_STD3_mapped",
        [
            32,
            772
        ]
    ],
    [
        [
            176,
            177
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            178,
            178
        ],
        "mapped",
        [
            50
        ]
    ],
    [
        [
            179,
            179
        ],
        "mapped",
        [
            51
        ]
    ],
    [
        [
            180,
            180
        ],
        "disallowed_STD3_mapped",
        [
            32,
            769
        ]
    ],
    [
        [
            181,
            181
        ],
        "mapped",
        [
            956
        ]
    ],
    [
        [
            182,
            182
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            183,
            183
        ],
        "valid"
    ],
    [
        [
            184,
            184
        ],
        "disallowed_STD3_mapped",
        [
            32,
            807
        ]
    ],
    [
        [
            185,
            185
        ],
        "mapped",
        [
            49
        ]
    ],
    [
        [
            186,
            186
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            187,
            187
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            188,
            188
        ],
        "mapped",
        [
            49,
            8260,
            52
        ]
    ],
    [
        [
            189,
            189
        ],
        "mapped",
        [
            49,
            8260,
            50
        ]
    ],
    [
        [
            190,
            190
        ],
        "mapped",
        [
            51,
            8260,
            52
        ]
    ],
    [
        [
            191,
            191
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            192,
            192
        ],
        "mapped",
        [
            224
        ]
    ],
    [
        [
            193,
            193
        ],
        "mapped",
        [
            225
        ]
    ],
    [
        [
            194,
            194
        ],
        "mapped",
        [
            226
        ]
    ],
    [
        [
            195,
            195
        ],
        "mapped",
        [
            227
        ]
    ],
    [
        [
            196,
            196
        ],
        "mapped",
        [
            228
        ]
    ],
    [
        [
            197,
            197
        ],
        "mapped",
        [
            229
        ]
    ],
    [
        [
            198,
            198
        ],
        "mapped",
        [
            230
        ]
    ],
    [
        [
            199,
            199
        ],
        "mapped",
        [
            231
        ]
    ],
    [
        [
            200,
            200
        ],
        "mapped",
        [
            232
        ]
    ],
    [
        [
            201,
            201
        ],
        "mapped",
        [
            233
        ]
    ],
    [
        [
            202,
            202
        ],
        "mapped",
        [
            234
        ]
    ],
    [
        [
            203,
            203
        ],
        "mapped",
        [
            235
        ]
    ],
    [
        [
            204,
            204
        ],
        "mapped",
        [
            236
        ]
    ],
    [
        [
            205,
            205
        ],
        "mapped",
        [
            237
        ]
    ],
    [
        [
            206,
            206
        ],
        "mapped",
        [
            238
        ]
    ],
    [
        [
            207,
            207
        ],
        "mapped",
        [
            239
        ]
    ],
    [
        [
            208,
            208
        ],
        "mapped",
        [
            240
        ]
    ],
    [
        [
            209,
            209
        ],
        "mapped",
        [
            241
        ]
    ],
    [
        [
            210,
            210
        ],
        "mapped",
        [
            242
        ]
    ],
    [
        [
            211,
            211
        ],
        "mapped",
        [
            243
        ]
    ],
    [
        [
            212,
            212
        ],
        "mapped",
        [
            244
        ]
    ],
    [
        [
            213,
            213
        ],
        "mapped",
        [
            245
        ]
    ],
    [
        [
            214,
            214
        ],
        "mapped",
        [
            246
        ]
    ],
    [
        [
            215,
            215
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            216,
            216
        ],
        "mapped",
        [
            248
        ]
    ],
    [
        [
            217,
            217
        ],
        "mapped",
        [
            249
        ]
    ],
    [
        [
            218,
            218
        ],
        "mapped",
        [
            250
        ]
    ],
    [
        [
            219,
            219
        ],
        "mapped",
        [
            251
        ]
    ],
    [
        [
            220,
            220
        ],
        "mapped",
        [
            252
        ]
    ],
    [
        [
            221,
            221
        ],
        "mapped",
        [
            253
        ]
    ],
    [
        [
            222,
            222
        ],
        "mapped",
        [
            254
        ]
    ],
    [
        [
            223,
            223
        ],
        "deviation",
        [
            115,
            115
        ]
    ],
    [
        [
            224,
            246
        ],
        "valid"
    ],
    [
        [
            247,
            247
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            248,
            255
        ],
        "valid"
    ],
    [
        [
            256,
            256
        ],
        "mapped",
        [
            257
        ]
    ],
    [
        [
            257,
            257
        ],
        "valid"
    ],
    [
        [
            258,
            258
        ],
        "mapped",
        [
            259
        ]
    ],
    [
        [
            259,
            259
        ],
        "valid"
    ],
    [
        [
            260,
            260
        ],
        "mapped",
        [
            261
        ]
    ],
    [
        [
            261,
            261
        ],
        "valid"
    ],
    [
        [
            262,
            262
        ],
        "mapped",
        [
            263
        ]
    ],
    [
        [
            263,
            263
        ],
        "valid"
    ],
    [
        [
            264,
            264
        ],
        "mapped",
        [
            265
        ]
    ],
    [
        [
            265,
            265
        ],
        "valid"
    ],
    [
        [
            266,
            266
        ],
        "mapped",
        [
            267
        ]
    ],
    [
        [
            267,
            267
        ],
        "valid"
    ],
    [
        [
            268,
            268
        ],
        "mapped",
        [
            269
        ]
    ],
    [
        [
            269,
            269
        ],
        "valid"
    ],
    [
        [
            270,
            270
        ],
        "mapped",
        [
            271
        ]
    ],
    [
        [
            271,
            271
        ],
        "valid"
    ],
    [
        [
            272,
            272
        ],
        "mapped",
        [
            273
        ]
    ],
    [
        [
            273,
            273
        ],
        "valid"
    ],
    [
        [
            274,
            274
        ],
        "mapped",
        [
            275
        ]
    ],
    [
        [
            275,
            275
        ],
        "valid"
    ],
    [
        [
            276,
            276
        ],
        "mapped",
        [
            277
        ]
    ],
    [
        [
            277,
            277
        ],
        "valid"
    ],
    [
        [
            278,
            278
        ],
        "mapped",
        [
            279
        ]
    ],
    [
        [
            279,
            279
        ],
        "valid"
    ],
    [
        [
            280,
            280
        ],
        "mapped",
        [
            281
        ]
    ],
    [
        [
            281,
            281
        ],
        "valid"
    ],
    [
        [
            282,
            282
        ],
        "mapped",
        [
            283
        ]
    ],
    [
        [
            283,
            283
        ],
        "valid"
    ],
    [
        [
            284,
            284
        ],
        "mapped",
        [
            285
        ]
    ],
    [
        [
            285,
            285
        ],
        "valid"
    ],
    [
        [
            286,
            286
        ],
        "mapped",
        [
            287
        ]
    ],
    [
        [
            287,
            287
        ],
        "valid"
    ],
    [
        [
            288,
            288
        ],
        "mapped",
        [
            289
        ]
    ],
    [
        [
            289,
            289
        ],
        "valid"
    ],
    [
        [
            290,
            290
        ],
        "mapped",
        [
            291
        ]
    ],
    [
        [
            291,
            291
        ],
        "valid"
    ],
    [
        [
            292,
            292
        ],
        "mapped",
        [
            293
        ]
    ],
    [
        [
            293,
            293
        ],
        "valid"
    ],
    [
        [
            294,
            294
        ],
        "mapped",
        [
            295
        ]
    ],
    [
        [
            295,
            295
        ],
        "valid"
    ],
    [
        [
            296,
            296
        ],
        "mapped",
        [
            297
        ]
    ],
    [
        [
            297,
            297
        ],
        "valid"
    ],
    [
        [
            298,
            298
        ],
        "mapped",
        [
            299
        ]
    ],
    [
        [
            299,
            299
        ],
        "valid"
    ],
    [
        [
            300,
            300
        ],
        "mapped",
        [
            301
        ]
    ],
    [
        [
            301,
            301
        ],
        "valid"
    ],
    [
        [
            302,
            302
        ],
        "mapped",
        [
            303
        ]
    ],
    [
        [
            303,
            303
        ],
        "valid"
    ],
    [
        [
            304,
            304
        ],
        "mapped",
        [
            105,
            775
        ]
    ],
    [
        [
            305,
            305
        ],
        "valid"
    ],
    [
        [
            306,
            307
        ],
        "mapped",
        [
            105,
            106
        ]
    ],
    [
        [
            308,
            308
        ],
        "mapped",
        [
            309
        ]
    ],
    [
        [
            309,
            309
        ],
        "valid"
    ],
    [
        [
            310,
            310
        ],
        "mapped",
        [
            311
        ]
    ],
    [
        [
            311,
            312
        ],
        "valid"
    ],
    [
        [
            313,
            313
        ],
        "mapped",
        [
            314
        ]
    ],
    [
        [
            314,
            314
        ],
        "valid"
    ],
    [
        [
            315,
            315
        ],
        "mapped",
        [
            316
        ]
    ],
    [
        [
            316,
            316
        ],
        "valid"
    ],
    [
        [
            317,
            317
        ],
        "mapped",
        [
            318
        ]
    ],
    [
        [
            318,
            318
        ],
        "valid"
    ],
    [
        [
            319,
            320
        ],
        "mapped",
        [
            108,
            183
        ]
    ],
    [
        [
            321,
            321
        ],
        "mapped",
        [
            322
        ]
    ],
    [
        [
            322,
            322
        ],
        "valid"
    ],
    [
        [
            323,
            323
        ],
        "mapped",
        [
            324
        ]
    ],
    [
        [
            324,
            324
        ],
        "valid"
    ],
    [
        [
            325,
            325
        ],
        "mapped",
        [
            326
        ]
    ],
    [
        [
            326,
            326
        ],
        "valid"
    ],
    [
        [
            327,
            327
        ],
        "mapped",
        [
            328
        ]
    ],
    [
        [
            328,
            328
        ],
        "valid"
    ],
    [
        [
            329,
            329
        ],
        "mapped",
        [
            700,
            110
        ]
    ],
    [
        [
            330,
            330
        ],
        "mapped",
        [
            331
        ]
    ],
    [
        [
            331,
            331
        ],
        "valid"
    ],
    [
        [
            332,
            332
        ],
        "mapped",
        [
            333
        ]
    ],
    [
        [
            333,
            333
        ],
        "valid"
    ],
    [
        [
            334,
            334
        ],
        "mapped",
        [
            335
        ]
    ],
    [
        [
            335,
            335
        ],
        "valid"
    ],
    [
        [
            336,
            336
        ],
        "mapped",
        [
            337
        ]
    ],
    [
        [
            337,
            337
        ],
        "valid"
    ],
    [
        [
            338,
            338
        ],
        "mapped",
        [
            339
        ]
    ],
    [
        [
            339,
            339
        ],
        "valid"
    ],
    [
        [
            340,
            340
        ],
        "mapped",
        [
            341
        ]
    ],
    [
        [
            341,
            341
        ],
        "valid"
    ],
    [
        [
            342,
            342
        ],
        "mapped",
        [
            343
        ]
    ],
    [
        [
            343,
            343
        ],
        "valid"
    ],
    [
        [
            344,
            344
        ],
        "mapped",
        [
            345
        ]
    ],
    [
        [
            345,
            345
        ],
        "valid"
    ],
    [
        [
            346,
            346
        ],
        "mapped",
        [
            347
        ]
    ],
    [
        [
            347,
            347
        ],
        "valid"
    ],
    [
        [
            348,
            348
        ],
        "mapped",
        [
            349
        ]
    ],
    [
        [
            349,
            349
        ],
        "valid"
    ],
    [
        [
            350,
            350
        ],
        "mapped",
        [
            351
        ]
    ],
    [
        [
            351,
            351
        ],
        "valid"
    ],
    [
        [
            352,
            352
        ],
        "mapped",
        [
            353
        ]
    ],
    [
        [
            353,
            353
        ],
        "valid"
    ],
    [
        [
            354,
            354
        ],
        "mapped",
        [
            355
        ]
    ],
    [
        [
            355,
            355
        ],
        "valid"
    ],
    [
        [
            356,
            356
        ],
        "mapped",
        [
            357
        ]
    ],
    [
        [
            357,
            357
        ],
        "valid"
    ],
    [
        [
            358,
            358
        ],
        "mapped",
        [
            359
        ]
    ],
    [
        [
            359,
            359
        ],
        "valid"
    ],
    [
        [
            360,
            360
        ],
        "mapped",
        [
            361
        ]
    ],
    [
        [
            361,
            361
        ],
        "valid"
    ],
    [
        [
            362,
            362
        ],
        "mapped",
        [
            363
        ]
    ],
    [
        [
            363,
            363
        ],
        "valid"
    ],
    [
        [
            364,
            364
        ],
        "mapped",
        [
            365
        ]
    ],
    [
        [
            365,
            365
        ],
        "valid"
    ],
    [
        [
            366,
            366
        ],
        "mapped",
        [
            367
        ]
    ],
    [
        [
            367,
            367
        ],
        "valid"
    ],
    [
        [
            368,
            368
        ],
        "mapped",
        [
            369
        ]
    ],
    [
        [
            369,
            369
        ],
        "valid"
    ],
    [
        [
            370,
            370
        ],
        "mapped",
        [
            371
        ]
    ],
    [
        [
            371,
            371
        ],
        "valid"
    ],
    [
        [
            372,
            372
        ],
        "mapped",
        [
            373
        ]
    ],
    [
        [
            373,
            373
        ],
        "valid"
    ],
    [
        [
            374,
            374
        ],
        "mapped",
        [
            375
        ]
    ],
    [
        [
            375,
            375
        ],
        "valid"
    ],
    [
        [
            376,
            376
        ],
        "mapped",
        [
            255
        ]
    ],
    [
        [
            377,
            377
        ],
        "mapped",
        [
            378
        ]
    ],
    [
        [
            378,
            378
        ],
        "valid"
    ],
    [
        [
            379,
            379
        ],
        "mapped",
        [
            380
        ]
    ],
    [
        [
            380,
            380
        ],
        "valid"
    ],
    [
        [
            381,
            381
        ],
        "mapped",
        [
            382
        ]
    ],
    [
        [
            382,
            382
        ],
        "valid"
    ],
    [
        [
            383,
            383
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            384,
            384
        ],
        "valid"
    ],
    [
        [
            385,
            385
        ],
        "mapped",
        [
            595
        ]
    ],
    [
        [
            386,
            386
        ],
        "mapped",
        [
            387
        ]
    ],
    [
        [
            387,
            387
        ],
        "valid"
    ],
    [
        [
            388,
            388
        ],
        "mapped",
        [
            389
        ]
    ],
    [
        [
            389,
            389
        ],
        "valid"
    ],
    [
        [
            390,
            390
        ],
        "mapped",
        [
            596
        ]
    ],
    [
        [
            391,
            391
        ],
        "mapped",
        [
            392
        ]
    ],
    [
        [
            392,
            392
        ],
        "valid"
    ],
    [
        [
            393,
            393
        ],
        "mapped",
        [
            598
        ]
    ],
    [
        [
            394,
            394
        ],
        "mapped",
        [
            599
        ]
    ],
    [
        [
            395,
            395
        ],
        "mapped",
        [
            396
        ]
    ],
    [
        [
            396,
            397
        ],
        "valid"
    ],
    [
        [
            398,
            398
        ],
        "mapped",
        [
            477
        ]
    ],
    [
        [
            399,
            399
        ],
        "mapped",
        [
            601
        ]
    ],
    [
        [
            400,
            400
        ],
        "mapped",
        [
            603
        ]
    ],
    [
        [
            401,
            401
        ],
        "mapped",
        [
            402
        ]
    ],
    [
        [
            402,
            402
        ],
        "valid"
    ],
    [
        [
            403,
            403
        ],
        "mapped",
        [
            608
        ]
    ],
    [
        [
            404,
            404
        ],
        "mapped",
        [
            611
        ]
    ],
    [
        [
            405,
            405
        ],
        "valid"
    ],
    [
        [
            406,
            406
        ],
        "mapped",
        [
            617
        ]
    ],
    [
        [
            407,
            407
        ],
        "mapped",
        [
            616
        ]
    ],
    [
        [
            408,
            408
        ],
        "mapped",
        [
            409
        ]
    ],
    [
        [
            409,
            411
        ],
        "valid"
    ],
    [
        [
            412,
            412
        ],
        "mapped",
        [
            623
        ]
    ],
    [
        [
            413,
            413
        ],
        "mapped",
        [
            626
        ]
    ],
    [
        [
            414,
            414
        ],
        "valid"
    ],
    [
        [
            415,
            415
        ],
        "mapped",
        [
            629
        ]
    ],
    [
        [
            416,
            416
        ],
        "mapped",
        [
            417
        ]
    ],
    [
        [
            417,
            417
        ],
        "valid"
    ],
    [
        [
            418,
            418
        ],
        "mapped",
        [
            419
        ]
    ],
    [
        [
            419,
            419
        ],
        "valid"
    ],
    [
        [
            420,
            420
        ],
        "mapped",
        [
            421
        ]
    ],
    [
        [
            421,
            421
        ],
        "valid"
    ],
    [
        [
            422,
            422
        ],
        "mapped",
        [
            640
        ]
    ],
    [
        [
            423,
            423
        ],
        "mapped",
        [
            424
        ]
    ],
    [
        [
            424,
            424
        ],
        "valid"
    ],
    [
        [
            425,
            425
        ],
        "mapped",
        [
            643
        ]
    ],
    [
        [
            426,
            427
        ],
        "valid"
    ],
    [
        [
            428,
            428
        ],
        "mapped",
        [
            429
        ]
    ],
    [
        [
            429,
            429
        ],
        "valid"
    ],
    [
        [
            430,
            430
        ],
        "mapped",
        [
            648
        ]
    ],
    [
        [
            431,
            431
        ],
        "mapped",
        [
            432
        ]
    ],
    [
        [
            432,
            432
        ],
        "valid"
    ],
    [
        [
            433,
            433
        ],
        "mapped",
        [
            650
        ]
    ],
    [
        [
            434,
            434
        ],
        "mapped",
        [
            651
        ]
    ],
    [
        [
            435,
            435
        ],
        "mapped",
        [
            436
        ]
    ],
    [
        [
            436,
            436
        ],
        "valid"
    ],
    [
        [
            437,
            437
        ],
        "mapped",
        [
            438
        ]
    ],
    [
        [
            438,
            438
        ],
        "valid"
    ],
    [
        [
            439,
            439
        ],
        "mapped",
        [
            658
        ]
    ],
    [
        [
            440,
            440
        ],
        "mapped",
        [
            441
        ]
    ],
    [
        [
            441,
            443
        ],
        "valid"
    ],
    [
        [
            444,
            444
        ],
        "mapped",
        [
            445
        ]
    ],
    [
        [
            445,
            451
        ],
        "valid"
    ],
    [
        [
            452,
            454
        ],
        "mapped",
        [
            100,
            382
        ]
    ],
    [
        [
            455,
            457
        ],
        "mapped",
        [
            108,
            106
        ]
    ],
    [
        [
            458,
            460
        ],
        "mapped",
        [
            110,
            106
        ]
    ],
    [
        [
            461,
            461
        ],
        "mapped",
        [
            462
        ]
    ],
    [
        [
            462,
            462
        ],
        "valid"
    ],
    [
        [
            463,
            463
        ],
        "mapped",
        [
            464
        ]
    ],
    [
        [
            464,
            464
        ],
        "valid"
    ],
    [
        [
            465,
            465
        ],
        "mapped",
        [
            466
        ]
    ],
    [
        [
            466,
            466
        ],
        "valid"
    ],
    [
        [
            467,
            467
        ],
        "mapped",
        [
            468
        ]
    ],
    [
        [
            468,
            468
        ],
        "valid"
    ],
    [
        [
            469,
            469
        ],
        "mapped",
        [
            470
        ]
    ],
    [
        [
            470,
            470
        ],
        "valid"
    ],
    [
        [
            471,
            471
        ],
        "mapped",
        [
            472
        ]
    ],
    [
        [
            472,
            472
        ],
        "valid"
    ],
    [
        [
            473,
            473
        ],
        "mapped",
        [
            474
        ]
    ],
    [
        [
            474,
            474
        ],
        "valid"
    ],
    [
        [
            475,
            475
        ],
        "mapped",
        [
            476
        ]
    ],
    [
        [
            476,
            477
        ],
        "valid"
    ],
    [
        [
            478,
            478
        ],
        "mapped",
        [
            479
        ]
    ],
    [
        [
            479,
            479
        ],
        "valid"
    ],
    [
        [
            480,
            480
        ],
        "mapped",
        [
            481
        ]
    ],
    [
        [
            481,
            481
        ],
        "valid"
    ],
    [
        [
            482,
            482
        ],
        "mapped",
        [
            483
        ]
    ],
    [
        [
            483,
            483
        ],
        "valid"
    ],
    [
        [
            484,
            484
        ],
        "mapped",
        [
            485
        ]
    ],
    [
        [
            485,
            485
        ],
        "valid"
    ],
    [
        [
            486,
            486
        ],
        "mapped",
        [
            487
        ]
    ],
    [
        [
            487,
            487
        ],
        "valid"
    ],
    [
        [
            488,
            488
        ],
        "mapped",
        [
            489
        ]
    ],
    [
        [
            489,
            489
        ],
        "valid"
    ],
    [
        [
            490,
            490
        ],
        "mapped",
        [
            491
        ]
    ],
    [
        [
            491,
            491
        ],
        "valid"
    ],
    [
        [
            492,
            492
        ],
        "mapped",
        [
            493
        ]
    ],
    [
        [
            493,
            493
        ],
        "valid"
    ],
    [
        [
            494,
            494
        ],
        "mapped",
        [
            495
        ]
    ],
    [
        [
            495,
            496
        ],
        "valid"
    ],
    [
        [
            497,
            499
        ],
        "mapped",
        [
            100,
            122
        ]
    ],
    [
        [
            500,
            500
        ],
        "mapped",
        [
            501
        ]
    ],
    [
        [
            501,
            501
        ],
        "valid"
    ],
    [
        [
            502,
            502
        ],
        "mapped",
        [
            405
        ]
    ],
    [
        [
            503,
            503
        ],
        "mapped",
        [
            447
        ]
    ],
    [
        [
            504,
            504
        ],
        "mapped",
        [
            505
        ]
    ],
    [
        [
            505,
            505
        ],
        "valid"
    ],
    [
        [
            506,
            506
        ],
        "mapped",
        [
            507
        ]
    ],
    [
        [
            507,
            507
        ],
        "valid"
    ],
    [
        [
            508,
            508
        ],
        "mapped",
        [
            509
        ]
    ],
    [
        [
            509,
            509
        ],
        "valid"
    ],
    [
        [
            510,
            510
        ],
        "mapped",
        [
            511
        ]
    ],
    [
        [
            511,
            511
        ],
        "valid"
    ],
    [
        [
            512,
            512
        ],
        "mapped",
        [
            513
        ]
    ],
    [
        [
            513,
            513
        ],
        "valid"
    ],
    [
        [
            514,
            514
        ],
        "mapped",
        [
            515
        ]
    ],
    [
        [
            515,
            515
        ],
        "valid"
    ],
    [
        [
            516,
            516
        ],
        "mapped",
        [
            517
        ]
    ],
    [
        [
            517,
            517
        ],
        "valid"
    ],
    [
        [
            518,
            518
        ],
        "mapped",
        [
            519
        ]
    ],
    [
        [
            519,
            519
        ],
        "valid"
    ],
    [
        [
            520,
            520
        ],
        "mapped",
        [
            521
        ]
    ],
    [
        [
            521,
            521
        ],
        "valid"
    ],
    [
        [
            522,
            522
        ],
        "mapped",
        [
            523
        ]
    ],
    [
        [
            523,
            523
        ],
        "valid"
    ],
    [
        [
            524,
            524
        ],
        "mapped",
        [
            525
        ]
    ],
    [
        [
            525,
            525
        ],
        "valid"
    ],
    [
        [
            526,
            526
        ],
        "mapped",
        [
            527
        ]
    ],
    [
        [
            527,
            527
        ],
        "valid"
    ],
    [
        [
            528,
            528
        ],
        "mapped",
        [
            529
        ]
    ],
    [
        [
            529,
            529
        ],
        "valid"
    ],
    [
        [
            530,
            530
        ],
        "mapped",
        [
            531
        ]
    ],
    [
        [
            531,
            531
        ],
        "valid"
    ],
    [
        [
            532,
            532
        ],
        "mapped",
        [
            533
        ]
    ],
    [
        [
            533,
            533
        ],
        "valid"
    ],
    [
        [
            534,
            534
        ],
        "mapped",
        [
            535
        ]
    ],
    [
        [
            535,
            535
        ],
        "valid"
    ],
    [
        [
            536,
            536
        ],
        "mapped",
        [
            537
        ]
    ],
    [
        [
            537,
            537
        ],
        "valid"
    ],
    [
        [
            538,
            538
        ],
        "mapped",
        [
            539
        ]
    ],
    [
        [
            539,
            539
        ],
        "valid"
    ],
    [
        [
            540,
            540
        ],
        "mapped",
        [
            541
        ]
    ],
    [
        [
            541,
            541
        ],
        "valid"
    ],
    [
        [
            542,
            542
        ],
        "mapped",
        [
            543
        ]
    ],
    [
        [
            543,
            543
        ],
        "valid"
    ],
    [
        [
            544,
            544
        ],
        "mapped",
        [
            414
        ]
    ],
    [
        [
            545,
            545
        ],
        "valid"
    ],
    [
        [
            546,
            546
        ],
        "mapped",
        [
            547
        ]
    ],
    [
        [
            547,
            547
        ],
        "valid"
    ],
    [
        [
            548,
            548
        ],
        "mapped",
        [
            549
        ]
    ],
    [
        [
            549,
            549
        ],
        "valid"
    ],
    [
        [
            550,
            550
        ],
        "mapped",
        [
            551
        ]
    ],
    [
        [
            551,
            551
        ],
        "valid"
    ],
    [
        [
            552,
            552
        ],
        "mapped",
        [
            553
        ]
    ],
    [
        [
            553,
            553
        ],
        "valid"
    ],
    [
        [
            554,
            554
        ],
        "mapped",
        [
            555
        ]
    ],
    [
        [
            555,
            555
        ],
        "valid"
    ],
    [
        [
            556,
            556
        ],
        "mapped",
        [
            557
        ]
    ],
    [
        [
            557,
            557
        ],
        "valid"
    ],
    [
        [
            558,
            558
        ],
        "mapped",
        [
            559
        ]
    ],
    [
        [
            559,
            559
        ],
        "valid"
    ],
    [
        [
            560,
            560
        ],
        "mapped",
        [
            561
        ]
    ],
    [
        [
            561,
            561
        ],
        "valid"
    ],
    [
        [
            562,
            562
        ],
        "mapped",
        [
            563
        ]
    ],
    [
        [
            563,
            563
        ],
        "valid"
    ],
    [
        [
            564,
            566
        ],
        "valid"
    ],
    [
        [
            567,
            569
        ],
        "valid"
    ],
    [
        [
            570,
            570
        ],
        "mapped",
        [
            11365
        ]
    ],
    [
        [
            571,
            571
        ],
        "mapped",
        [
            572
        ]
    ],
    [
        [
            572,
            572
        ],
        "valid"
    ],
    [
        [
            573,
            573
        ],
        "mapped",
        [
            410
        ]
    ],
    [
        [
            574,
            574
        ],
        "mapped",
        [
            11366
        ]
    ],
    [
        [
            575,
            576
        ],
        "valid"
    ],
    [
        [
            577,
            577
        ],
        "mapped",
        [
            578
        ]
    ],
    [
        [
            578,
            578
        ],
        "valid"
    ],
    [
        [
            579,
            579
        ],
        "mapped",
        [
            384
        ]
    ],
    [
        [
            580,
            580
        ],
        "mapped",
        [
            649
        ]
    ],
    [
        [
            581,
            581
        ],
        "mapped",
        [
            652
        ]
    ],
    [
        [
            582,
            582
        ],
        "mapped",
        [
            583
        ]
    ],
    [
        [
            583,
            583
        ],
        "valid"
    ],
    [
        [
            584,
            584
        ],
        "mapped",
        [
            585
        ]
    ],
    [
        [
            585,
            585
        ],
        "valid"
    ],
    [
        [
            586,
            586
        ],
        "mapped",
        [
            587
        ]
    ],
    [
        [
            587,
            587
        ],
        "valid"
    ],
    [
        [
            588,
            588
        ],
        "mapped",
        [
            589
        ]
    ],
    [
        [
            589,
            589
        ],
        "valid"
    ],
    [
        [
            590,
            590
        ],
        "mapped",
        [
            591
        ]
    ],
    [
        [
            591,
            591
        ],
        "valid"
    ],
    [
        [
            592,
            680
        ],
        "valid"
    ],
    [
        [
            681,
            685
        ],
        "valid"
    ],
    [
        [
            686,
            687
        ],
        "valid"
    ],
    [
        [
            688,
            688
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            689,
            689
        ],
        "mapped",
        [
            614
        ]
    ],
    [
        [
            690,
            690
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            691,
            691
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            692,
            692
        ],
        "mapped",
        [
            633
        ]
    ],
    [
        [
            693,
            693
        ],
        "mapped",
        [
            635
        ]
    ],
    [
        [
            694,
            694
        ],
        "mapped",
        [
            641
        ]
    ],
    [
        [
            695,
            695
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            696,
            696
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            697,
            705
        ],
        "valid"
    ],
    [
        [
            706,
            709
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            710,
            721
        ],
        "valid"
    ],
    [
        [
            722,
            727
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            728,
            728
        ],
        "disallowed_STD3_mapped",
        [
            32,
            774
        ]
    ],
    [
        [
            729,
            729
        ],
        "disallowed_STD3_mapped",
        [
            32,
            775
        ]
    ],
    [
        [
            730,
            730
        ],
        "disallowed_STD3_mapped",
        [
            32,
            778
        ]
    ],
    [
        [
            731,
            731
        ],
        "disallowed_STD3_mapped",
        [
            32,
            808
        ]
    ],
    [
        [
            732,
            732
        ],
        "disallowed_STD3_mapped",
        [
            32,
            771
        ]
    ],
    [
        [
            733,
            733
        ],
        "disallowed_STD3_mapped",
        [
            32,
            779
        ]
    ],
    [
        [
            734,
            734
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            735,
            735
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            736,
            736
        ],
        "mapped",
        [
            611
        ]
    ],
    [
        [
            737,
            737
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            738,
            738
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            739,
            739
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            740,
            740
        ],
        "mapped",
        [
            661
        ]
    ],
    [
        [
            741,
            745
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            746,
            747
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            748,
            748
        ],
        "valid"
    ],
    [
        [
            749,
            749
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            750,
            750
        ],
        "valid"
    ],
    [
        [
            751,
            767
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            768,
            831
        ],
        "valid"
    ],
    [
        [
            832,
            832
        ],
        "mapped",
        [
            768
        ]
    ],
    [
        [
            833,
            833
        ],
        "mapped",
        [
            769
        ]
    ],
    [
        [
            834,
            834
        ],
        "valid"
    ],
    [
        [
            835,
            835
        ],
        "mapped",
        [
            787
        ]
    ],
    [
        [
            836,
            836
        ],
        "mapped",
        [
            776,
            769
        ]
    ],
    [
        [
            837,
            837
        ],
        "mapped",
        [
            953
        ]
    ],
    [
        [
            838,
            846
        ],
        "valid"
    ],
    [
        [
            847,
            847
        ],
        "ignored"
    ],
    [
        [
            848,
            855
        ],
        "valid"
    ],
    [
        [
            856,
            860
        ],
        "valid"
    ],
    [
        [
            861,
            863
        ],
        "valid"
    ],
    [
        [
            864,
            865
        ],
        "valid"
    ],
    [
        [
            866,
            866
        ],
        "valid"
    ],
    [
        [
            867,
            879
        ],
        "valid"
    ],
    [
        [
            880,
            880
        ],
        "mapped",
        [
            881
        ]
    ],
    [
        [
            881,
            881
        ],
        "valid"
    ],
    [
        [
            882,
            882
        ],
        "mapped",
        [
            883
        ]
    ],
    [
        [
            883,
            883
        ],
        "valid"
    ],
    [
        [
            884,
            884
        ],
        "mapped",
        [
            697
        ]
    ],
    [
        [
            885,
            885
        ],
        "valid"
    ],
    [
        [
            886,
            886
        ],
        "mapped",
        [
            887
        ]
    ],
    [
        [
            887,
            887
        ],
        "valid"
    ],
    [
        [
            888,
            889
        ],
        "disallowed"
    ],
    [
        [
            890,
            890
        ],
        "disallowed_STD3_mapped",
        [
            32,
            953
        ]
    ],
    [
        [
            891,
            893
        ],
        "valid"
    ],
    [
        [
            894,
            894
        ],
        "disallowed_STD3_mapped",
        [
            59
        ]
    ],
    [
        [
            895,
            895
        ],
        "mapped",
        [
            1011
        ]
    ],
    [
        [
            896,
            899
        ],
        "disallowed"
    ],
    [
        [
            900,
            900
        ],
        "disallowed_STD3_mapped",
        [
            32,
            769
        ]
    ],
    [
        [
            901,
            901
        ],
        "disallowed_STD3_mapped",
        [
            32,
            776,
            769
        ]
    ],
    [
        [
            902,
            902
        ],
        "mapped",
        [
            940
        ]
    ],
    [
        [
            903,
            903
        ],
        "mapped",
        [
            183
        ]
    ],
    [
        [
            904,
            904
        ],
        "mapped",
        [
            941
        ]
    ],
    [
        [
            905,
            905
        ],
        "mapped",
        [
            942
        ]
    ],
    [
        [
            906,
            906
        ],
        "mapped",
        [
            943
        ]
    ],
    [
        [
            907,
            907
        ],
        "disallowed"
    ],
    [
        [
            908,
            908
        ],
        "mapped",
        [
            972
        ]
    ],
    [
        [
            909,
            909
        ],
        "disallowed"
    ],
    [
        [
            910,
            910
        ],
        "mapped",
        [
            973
        ]
    ],
    [
        [
            911,
            911
        ],
        "mapped",
        [
            974
        ]
    ],
    [
        [
            912,
            912
        ],
        "valid"
    ],
    [
        [
            913,
            913
        ],
        "mapped",
        [
            945
        ]
    ],
    [
        [
            914,
            914
        ],
        "mapped",
        [
            946
        ]
    ],
    [
        [
            915,
            915
        ],
        "mapped",
        [
            947
        ]
    ],
    [
        [
            916,
            916
        ],
        "mapped",
        [
            948
        ]
    ],
    [
        [
            917,
            917
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            918,
            918
        ],
        "mapped",
        [
            950
        ]
    ],
    [
        [
            919,
            919
        ],
        "mapped",
        [
            951
        ]
    ],
    [
        [
            920,
            920
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            921,
            921
        ],
        "mapped",
        [
            953
        ]
    ],
    [
        [
            922,
            922
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            923,
            923
        ],
        "mapped",
        [
            955
        ]
    ],
    [
        [
            924,
            924
        ],
        "mapped",
        [
            956
        ]
    ],
    [
        [
            925,
            925
        ],
        "mapped",
        [
            957
        ]
    ],
    [
        [
            926,
            926
        ],
        "mapped",
        [
            958
        ]
    ],
    [
        [
            927,
            927
        ],
        "mapped",
        [
            959
        ]
    ],
    [
        [
            928,
            928
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            929,
            929
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            930,
            930
        ],
        "disallowed"
    ],
    [
        [
            931,
            931
        ],
        "mapped",
        [
            963
        ]
    ],
    [
        [
            932,
            932
        ],
        "mapped",
        [
            964
        ]
    ],
    [
        [
            933,
            933
        ],
        "mapped",
        [
            965
        ]
    ],
    [
        [
            934,
            934
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            935,
            935
        ],
        "mapped",
        [
            967
        ]
    ],
    [
        [
            936,
            936
        ],
        "mapped",
        [
            968
        ]
    ],
    [
        [
            937,
            937
        ],
        "mapped",
        [
            969
        ]
    ],
    [
        [
            938,
            938
        ],
        "mapped",
        [
            970
        ]
    ],
    [
        [
            939,
            939
        ],
        "mapped",
        [
            971
        ]
    ],
    [
        [
            940,
            961
        ],
        "valid"
    ],
    [
        [
            962,
            962
        ],
        "deviation",
        [
            963
        ]
    ],
    [
        [
            963,
            974
        ],
        "valid"
    ],
    [
        [
            975,
            975
        ],
        "mapped",
        [
            983
        ]
    ],
    [
        [
            976,
            976
        ],
        "mapped",
        [
            946
        ]
    ],
    [
        [
            977,
            977
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            978,
            978
        ],
        "mapped",
        [
            965
        ]
    ],
    [
        [
            979,
            979
        ],
        "mapped",
        [
            973
        ]
    ],
    [
        [
            980,
            980
        ],
        "mapped",
        [
            971
        ]
    ],
    [
        [
            981,
            981
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            982,
            982
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            983,
            983
        ],
        "valid"
    ],
    [
        [
            984,
            984
        ],
        "mapped",
        [
            985
        ]
    ],
    [
        [
            985,
            985
        ],
        "valid"
    ],
    [
        [
            986,
            986
        ],
        "mapped",
        [
            987
        ]
    ],
    [
        [
            987,
            987
        ],
        "valid"
    ],
    [
        [
            988,
            988
        ],
        "mapped",
        [
            989
        ]
    ],
    [
        [
            989,
            989
        ],
        "valid"
    ],
    [
        [
            990,
            990
        ],
        "mapped",
        [
            991
        ]
    ],
    [
        [
            991,
            991
        ],
        "valid"
    ],
    [
        [
            992,
            992
        ],
        "mapped",
        [
            993
        ]
    ],
    [
        [
            993,
            993
        ],
        "valid"
    ],
    [
        [
            994,
            994
        ],
        "mapped",
        [
            995
        ]
    ],
    [
        [
            995,
            995
        ],
        "valid"
    ],
    [
        [
            996,
            996
        ],
        "mapped",
        [
            997
        ]
    ],
    [
        [
            997,
            997
        ],
        "valid"
    ],
    [
        [
            998,
            998
        ],
        "mapped",
        [
            999
        ]
    ],
    [
        [
            999,
            999
        ],
        "valid"
    ],
    [
        [
            1000,
            1000
        ],
        "mapped",
        [
            1001
        ]
    ],
    [
        [
            1001,
            1001
        ],
        "valid"
    ],
    [
        [
            1002,
            1002
        ],
        "mapped",
        [
            1003
        ]
    ],
    [
        [
            1003,
            1003
        ],
        "valid"
    ],
    [
        [
            1004,
            1004
        ],
        "mapped",
        [
            1005
        ]
    ],
    [
        [
            1005,
            1005
        ],
        "valid"
    ],
    [
        [
            1006,
            1006
        ],
        "mapped",
        [
            1007
        ]
    ],
    [
        [
            1007,
            1007
        ],
        "valid"
    ],
    [
        [
            1008,
            1008
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            1009,
            1009
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            1010,
            1010
        ],
        "mapped",
        [
            963
        ]
    ],
    [
        [
            1011,
            1011
        ],
        "valid"
    ],
    [
        [
            1012,
            1012
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            1013,
            1013
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            1014,
            1014
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1015,
            1015
        ],
        "mapped",
        [
            1016
        ]
    ],
    [
        [
            1016,
            1016
        ],
        "valid"
    ],
    [
        [
            1017,
            1017
        ],
        "mapped",
        [
            963
        ]
    ],
    [
        [
            1018,
            1018
        ],
        "mapped",
        [
            1019
        ]
    ],
    [
        [
            1019,
            1019
        ],
        "valid"
    ],
    [
        [
            1020,
            1020
        ],
        "valid"
    ],
    [
        [
            1021,
            1021
        ],
        "mapped",
        [
            891
        ]
    ],
    [
        [
            1022,
            1022
        ],
        "mapped",
        [
            892
        ]
    ],
    [
        [
            1023,
            1023
        ],
        "mapped",
        [
            893
        ]
    ],
    [
        [
            1024,
            1024
        ],
        "mapped",
        [
            1104
        ]
    ],
    [
        [
            1025,
            1025
        ],
        "mapped",
        [
            1105
        ]
    ],
    [
        [
            1026,
            1026
        ],
        "mapped",
        [
            1106
        ]
    ],
    [
        [
            1027,
            1027
        ],
        "mapped",
        [
            1107
        ]
    ],
    [
        [
            1028,
            1028
        ],
        "mapped",
        [
            1108
        ]
    ],
    [
        [
            1029,
            1029
        ],
        "mapped",
        [
            1109
        ]
    ],
    [
        [
            1030,
            1030
        ],
        "mapped",
        [
            1110
        ]
    ],
    [
        [
            1031,
            1031
        ],
        "mapped",
        [
            1111
        ]
    ],
    [
        [
            1032,
            1032
        ],
        "mapped",
        [
            1112
        ]
    ],
    [
        [
            1033,
            1033
        ],
        "mapped",
        [
            1113
        ]
    ],
    [
        [
            1034,
            1034
        ],
        "mapped",
        [
            1114
        ]
    ],
    [
        [
            1035,
            1035
        ],
        "mapped",
        [
            1115
        ]
    ],
    [
        [
            1036,
            1036
        ],
        "mapped",
        [
            1116
        ]
    ],
    [
        [
            1037,
            1037
        ],
        "mapped",
        [
            1117
        ]
    ],
    [
        [
            1038,
            1038
        ],
        "mapped",
        [
            1118
        ]
    ],
    [
        [
            1039,
            1039
        ],
        "mapped",
        [
            1119
        ]
    ],
    [
        [
            1040,
            1040
        ],
        "mapped",
        [
            1072
        ]
    ],
    [
        [
            1041,
            1041
        ],
        "mapped",
        [
            1073
        ]
    ],
    [
        [
            1042,
            1042
        ],
        "mapped",
        [
            1074
        ]
    ],
    [
        [
            1043,
            1043
        ],
        "mapped",
        [
            1075
        ]
    ],
    [
        [
            1044,
            1044
        ],
        "mapped",
        [
            1076
        ]
    ],
    [
        [
            1045,
            1045
        ],
        "mapped",
        [
            1077
        ]
    ],
    [
        [
            1046,
            1046
        ],
        "mapped",
        [
            1078
        ]
    ],
    [
        [
            1047,
            1047
        ],
        "mapped",
        [
            1079
        ]
    ],
    [
        [
            1048,
            1048
        ],
        "mapped",
        [
            1080
        ]
    ],
    [
        [
            1049,
            1049
        ],
        "mapped",
        [
            1081
        ]
    ],
    [
        [
            1050,
            1050
        ],
        "mapped",
        [
            1082
        ]
    ],
    [
        [
            1051,
            1051
        ],
        "mapped",
        [
            1083
        ]
    ],
    [
        [
            1052,
            1052
        ],
        "mapped",
        [
            1084
        ]
    ],
    [
        [
            1053,
            1053
        ],
        "mapped",
        [
            1085
        ]
    ],
    [
        [
            1054,
            1054
        ],
        "mapped",
        [
            1086
        ]
    ],
    [
        [
            1055,
            1055
        ],
        "mapped",
        [
            1087
        ]
    ],
    [
        [
            1056,
            1056
        ],
        "mapped",
        [
            1088
        ]
    ],
    [
        [
            1057,
            1057
        ],
        "mapped",
        [
            1089
        ]
    ],
    [
        [
            1058,
            1058
        ],
        "mapped",
        [
            1090
        ]
    ],
    [
        [
            1059,
            1059
        ],
        "mapped",
        [
            1091
        ]
    ],
    [
        [
            1060,
            1060
        ],
        "mapped",
        [
            1092
        ]
    ],
    [
        [
            1061,
            1061
        ],
        "mapped",
        [
            1093
        ]
    ],
    [
        [
            1062,
            1062
        ],
        "mapped",
        [
            1094
        ]
    ],
    [
        [
            1063,
            1063
        ],
        "mapped",
        [
            1095
        ]
    ],
    [
        [
            1064,
            1064
        ],
        "mapped",
        [
            1096
        ]
    ],
    [
        [
            1065,
            1065
        ],
        "mapped",
        [
            1097
        ]
    ],
    [
        [
            1066,
            1066
        ],
        "mapped",
        [
            1098
        ]
    ],
    [
        [
            1067,
            1067
        ],
        "mapped",
        [
            1099
        ]
    ],
    [
        [
            1068,
            1068
        ],
        "mapped",
        [
            1100
        ]
    ],
    [
        [
            1069,
            1069
        ],
        "mapped",
        [
            1101
        ]
    ],
    [
        [
            1070,
            1070
        ],
        "mapped",
        [
            1102
        ]
    ],
    [
        [
            1071,
            1071
        ],
        "mapped",
        [
            1103
        ]
    ],
    [
        [
            1072,
            1103
        ],
        "valid"
    ],
    [
        [
            1104,
            1104
        ],
        "valid"
    ],
    [
        [
            1105,
            1116
        ],
        "valid"
    ],
    [
        [
            1117,
            1117
        ],
        "valid"
    ],
    [
        [
            1118,
            1119
        ],
        "valid"
    ],
    [
        [
            1120,
            1120
        ],
        "mapped",
        [
            1121
        ]
    ],
    [
        [
            1121,
            1121
        ],
        "valid"
    ],
    [
        [
            1122,
            1122
        ],
        "mapped",
        [
            1123
        ]
    ],
    [
        [
            1123,
            1123
        ],
        "valid"
    ],
    [
        [
            1124,
            1124
        ],
        "mapped",
        [
            1125
        ]
    ],
    [
        [
            1125,
            1125
        ],
        "valid"
    ],
    [
        [
            1126,
            1126
        ],
        "mapped",
        [
            1127
        ]
    ],
    [
        [
            1127,
            1127
        ],
        "valid"
    ],
    [
        [
            1128,
            1128
        ],
        "mapped",
        [
            1129
        ]
    ],
    [
        [
            1129,
            1129
        ],
        "valid"
    ],
    [
        [
            1130,
            1130
        ],
        "mapped",
        [
            1131
        ]
    ],
    [
        [
            1131,
            1131
        ],
        "valid"
    ],
    [
        [
            1132,
            1132
        ],
        "mapped",
        [
            1133
        ]
    ],
    [
        [
            1133,
            1133
        ],
        "valid"
    ],
    [
        [
            1134,
            1134
        ],
        "mapped",
        [
            1135
        ]
    ],
    [
        [
            1135,
            1135
        ],
        "valid"
    ],
    [
        [
            1136,
            1136
        ],
        "mapped",
        [
            1137
        ]
    ],
    [
        [
            1137,
            1137
        ],
        "valid"
    ],
    [
        [
            1138,
            1138
        ],
        "mapped",
        [
            1139
        ]
    ],
    [
        [
            1139,
            1139
        ],
        "valid"
    ],
    [
        [
            1140,
            1140
        ],
        "mapped",
        [
            1141
        ]
    ],
    [
        [
            1141,
            1141
        ],
        "valid"
    ],
    [
        [
            1142,
            1142
        ],
        "mapped",
        [
            1143
        ]
    ],
    [
        [
            1143,
            1143
        ],
        "valid"
    ],
    [
        [
            1144,
            1144
        ],
        "mapped",
        [
            1145
        ]
    ],
    [
        [
            1145,
            1145
        ],
        "valid"
    ],
    [
        [
            1146,
            1146
        ],
        "mapped",
        [
            1147
        ]
    ],
    [
        [
            1147,
            1147
        ],
        "valid"
    ],
    [
        [
            1148,
            1148
        ],
        "mapped",
        [
            1149
        ]
    ],
    [
        [
            1149,
            1149
        ],
        "valid"
    ],
    [
        [
            1150,
            1150
        ],
        "mapped",
        [
            1151
        ]
    ],
    [
        [
            1151,
            1151
        ],
        "valid"
    ],
    [
        [
            1152,
            1152
        ],
        "mapped",
        [
            1153
        ]
    ],
    [
        [
            1153,
            1153
        ],
        "valid"
    ],
    [
        [
            1154,
            1154
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1155,
            1158
        ],
        "valid"
    ],
    [
        [
            1159,
            1159
        ],
        "valid"
    ],
    [
        [
            1160,
            1161
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1162,
            1162
        ],
        "mapped",
        [
            1163
        ]
    ],
    [
        [
            1163,
            1163
        ],
        "valid"
    ],
    [
        [
            1164,
            1164
        ],
        "mapped",
        [
            1165
        ]
    ],
    [
        [
            1165,
            1165
        ],
        "valid"
    ],
    [
        [
            1166,
            1166
        ],
        "mapped",
        [
            1167
        ]
    ],
    [
        [
            1167,
            1167
        ],
        "valid"
    ],
    [
        [
            1168,
            1168
        ],
        "mapped",
        [
            1169
        ]
    ],
    [
        [
            1169,
            1169
        ],
        "valid"
    ],
    [
        [
            1170,
            1170
        ],
        "mapped",
        [
            1171
        ]
    ],
    [
        [
            1171,
            1171
        ],
        "valid"
    ],
    [
        [
            1172,
            1172
        ],
        "mapped",
        [
            1173
        ]
    ],
    [
        [
            1173,
            1173
        ],
        "valid"
    ],
    [
        [
            1174,
            1174
        ],
        "mapped",
        [
            1175
        ]
    ],
    [
        [
            1175,
            1175
        ],
        "valid"
    ],
    [
        [
            1176,
            1176
        ],
        "mapped",
        [
            1177
        ]
    ],
    [
        [
            1177,
            1177
        ],
        "valid"
    ],
    [
        [
            1178,
            1178
        ],
        "mapped",
        [
            1179
        ]
    ],
    [
        [
            1179,
            1179
        ],
        "valid"
    ],
    [
        [
            1180,
            1180
        ],
        "mapped",
        [
            1181
        ]
    ],
    [
        [
            1181,
            1181
        ],
        "valid"
    ],
    [
        [
            1182,
            1182
        ],
        "mapped",
        [
            1183
        ]
    ],
    [
        [
            1183,
            1183
        ],
        "valid"
    ],
    [
        [
            1184,
            1184
        ],
        "mapped",
        [
            1185
        ]
    ],
    [
        [
            1185,
            1185
        ],
        "valid"
    ],
    [
        [
            1186,
            1186
        ],
        "mapped",
        [
            1187
        ]
    ],
    [
        [
            1187,
            1187
        ],
        "valid"
    ],
    [
        [
            1188,
            1188
        ],
        "mapped",
        [
            1189
        ]
    ],
    [
        [
            1189,
            1189
        ],
        "valid"
    ],
    [
        [
            1190,
            1190
        ],
        "mapped",
        [
            1191
        ]
    ],
    [
        [
            1191,
            1191
        ],
        "valid"
    ],
    [
        [
            1192,
            1192
        ],
        "mapped",
        [
            1193
        ]
    ],
    [
        [
            1193,
            1193
        ],
        "valid"
    ],
    [
        [
            1194,
            1194
        ],
        "mapped",
        [
            1195
        ]
    ],
    [
        [
            1195,
            1195
        ],
        "valid"
    ],
    [
        [
            1196,
            1196
        ],
        "mapped",
        [
            1197
        ]
    ],
    [
        [
            1197,
            1197
        ],
        "valid"
    ],
    [
        [
            1198,
            1198
        ],
        "mapped",
        [
            1199
        ]
    ],
    [
        [
            1199,
            1199
        ],
        "valid"
    ],
    [
        [
            1200,
            1200
        ],
        "mapped",
        [
            1201
        ]
    ],
    [
        [
            1201,
            1201
        ],
        "valid"
    ],
    [
        [
            1202,
            1202
        ],
        "mapped",
        [
            1203
        ]
    ],
    [
        [
            1203,
            1203
        ],
        "valid"
    ],
    [
        [
            1204,
            1204
        ],
        "mapped",
        [
            1205
        ]
    ],
    [
        [
            1205,
            1205
        ],
        "valid"
    ],
    [
        [
            1206,
            1206
        ],
        "mapped",
        [
            1207
        ]
    ],
    [
        [
            1207,
            1207
        ],
        "valid"
    ],
    [
        [
            1208,
            1208
        ],
        "mapped",
        [
            1209
        ]
    ],
    [
        [
            1209,
            1209
        ],
        "valid"
    ],
    [
        [
            1210,
            1210
        ],
        "mapped",
        [
            1211
        ]
    ],
    [
        [
            1211,
            1211
        ],
        "valid"
    ],
    [
        [
            1212,
            1212
        ],
        "mapped",
        [
            1213
        ]
    ],
    [
        [
            1213,
            1213
        ],
        "valid"
    ],
    [
        [
            1214,
            1214
        ],
        "mapped",
        [
            1215
        ]
    ],
    [
        [
            1215,
            1215
        ],
        "valid"
    ],
    [
        [
            1216,
            1216
        ],
        "disallowed"
    ],
    [
        [
            1217,
            1217
        ],
        "mapped",
        [
            1218
        ]
    ],
    [
        [
            1218,
            1218
        ],
        "valid"
    ],
    [
        [
            1219,
            1219
        ],
        "mapped",
        [
            1220
        ]
    ],
    [
        [
            1220,
            1220
        ],
        "valid"
    ],
    [
        [
            1221,
            1221
        ],
        "mapped",
        [
            1222
        ]
    ],
    [
        [
            1222,
            1222
        ],
        "valid"
    ],
    [
        [
            1223,
            1223
        ],
        "mapped",
        [
            1224
        ]
    ],
    [
        [
            1224,
            1224
        ],
        "valid"
    ],
    [
        [
            1225,
            1225
        ],
        "mapped",
        [
            1226
        ]
    ],
    [
        [
            1226,
            1226
        ],
        "valid"
    ],
    [
        [
            1227,
            1227
        ],
        "mapped",
        [
            1228
        ]
    ],
    [
        [
            1228,
            1228
        ],
        "valid"
    ],
    [
        [
            1229,
            1229
        ],
        "mapped",
        [
            1230
        ]
    ],
    [
        [
            1230,
            1230
        ],
        "valid"
    ],
    [
        [
            1231,
            1231
        ],
        "valid"
    ],
    [
        [
            1232,
            1232
        ],
        "mapped",
        [
            1233
        ]
    ],
    [
        [
            1233,
            1233
        ],
        "valid"
    ],
    [
        [
            1234,
            1234
        ],
        "mapped",
        [
            1235
        ]
    ],
    [
        [
            1235,
            1235
        ],
        "valid"
    ],
    [
        [
            1236,
            1236
        ],
        "mapped",
        [
            1237
        ]
    ],
    [
        [
            1237,
            1237
        ],
        "valid"
    ],
    [
        [
            1238,
            1238
        ],
        "mapped",
        [
            1239
        ]
    ],
    [
        [
            1239,
            1239
        ],
        "valid"
    ],
    [
        [
            1240,
            1240
        ],
        "mapped",
        [
            1241
        ]
    ],
    [
        [
            1241,
            1241
        ],
        "valid"
    ],
    [
        [
            1242,
            1242
        ],
        "mapped",
        [
            1243
        ]
    ],
    [
        [
            1243,
            1243
        ],
        "valid"
    ],
    [
        [
            1244,
            1244
        ],
        "mapped",
        [
            1245
        ]
    ],
    [
        [
            1245,
            1245
        ],
        "valid"
    ],
    [
        [
            1246,
            1246
        ],
        "mapped",
        [
            1247
        ]
    ],
    [
        [
            1247,
            1247
        ],
        "valid"
    ],
    [
        [
            1248,
            1248
        ],
        "mapped",
        [
            1249
        ]
    ],
    [
        [
            1249,
            1249
        ],
        "valid"
    ],
    [
        [
            1250,
            1250
        ],
        "mapped",
        [
            1251
        ]
    ],
    [
        [
            1251,
            1251
        ],
        "valid"
    ],
    [
        [
            1252,
            1252
        ],
        "mapped",
        [
            1253
        ]
    ],
    [
        [
            1253,
            1253
        ],
        "valid"
    ],
    [
        [
            1254,
            1254
        ],
        "mapped",
        [
            1255
        ]
    ],
    [
        [
            1255,
            1255
        ],
        "valid"
    ],
    [
        [
            1256,
            1256
        ],
        "mapped",
        [
            1257
        ]
    ],
    [
        [
            1257,
            1257
        ],
        "valid"
    ],
    [
        [
            1258,
            1258
        ],
        "mapped",
        [
            1259
        ]
    ],
    [
        [
            1259,
            1259
        ],
        "valid"
    ],
    [
        [
            1260,
            1260
        ],
        "mapped",
        [
            1261
        ]
    ],
    [
        [
            1261,
            1261
        ],
        "valid"
    ],
    [
        [
            1262,
            1262
        ],
        "mapped",
        [
            1263
        ]
    ],
    [
        [
            1263,
            1263
        ],
        "valid"
    ],
    [
        [
            1264,
            1264
        ],
        "mapped",
        [
            1265
        ]
    ],
    [
        [
            1265,
            1265
        ],
        "valid"
    ],
    [
        [
            1266,
            1266
        ],
        "mapped",
        [
            1267
        ]
    ],
    [
        [
            1267,
            1267
        ],
        "valid"
    ],
    [
        [
            1268,
            1268
        ],
        "mapped",
        [
            1269
        ]
    ],
    [
        [
            1269,
            1269
        ],
        "valid"
    ],
    [
        [
            1270,
            1270
        ],
        "mapped",
        [
            1271
        ]
    ],
    [
        [
            1271,
            1271
        ],
        "valid"
    ],
    [
        [
            1272,
            1272
        ],
        "mapped",
        [
            1273
        ]
    ],
    [
        [
            1273,
            1273
        ],
        "valid"
    ],
    [
        [
            1274,
            1274
        ],
        "mapped",
        [
            1275
        ]
    ],
    [
        [
            1275,
            1275
        ],
        "valid"
    ],
    [
        [
            1276,
            1276
        ],
        "mapped",
        [
            1277
        ]
    ],
    [
        [
            1277,
            1277
        ],
        "valid"
    ],
    [
        [
            1278,
            1278
        ],
        "mapped",
        [
            1279
        ]
    ],
    [
        [
            1279,
            1279
        ],
        "valid"
    ],
    [
        [
            1280,
            1280
        ],
        "mapped",
        [
            1281
        ]
    ],
    [
        [
            1281,
            1281
        ],
        "valid"
    ],
    [
        [
            1282,
            1282
        ],
        "mapped",
        [
            1283
        ]
    ],
    [
        [
            1283,
            1283
        ],
        "valid"
    ],
    [
        [
            1284,
            1284
        ],
        "mapped",
        [
            1285
        ]
    ],
    [
        [
            1285,
            1285
        ],
        "valid"
    ],
    [
        [
            1286,
            1286
        ],
        "mapped",
        [
            1287
        ]
    ],
    [
        [
            1287,
            1287
        ],
        "valid"
    ],
    [
        [
            1288,
            1288
        ],
        "mapped",
        [
            1289
        ]
    ],
    [
        [
            1289,
            1289
        ],
        "valid"
    ],
    [
        [
            1290,
            1290
        ],
        "mapped",
        [
            1291
        ]
    ],
    [
        [
            1291,
            1291
        ],
        "valid"
    ],
    [
        [
            1292,
            1292
        ],
        "mapped",
        [
            1293
        ]
    ],
    [
        [
            1293,
            1293
        ],
        "valid"
    ],
    [
        [
            1294,
            1294
        ],
        "mapped",
        [
            1295
        ]
    ],
    [
        [
            1295,
            1295
        ],
        "valid"
    ],
    [
        [
            1296,
            1296
        ],
        "mapped",
        [
            1297
        ]
    ],
    [
        [
            1297,
            1297
        ],
        "valid"
    ],
    [
        [
            1298,
            1298
        ],
        "mapped",
        [
            1299
        ]
    ],
    [
        [
            1299,
            1299
        ],
        "valid"
    ],
    [
        [
            1300,
            1300
        ],
        "mapped",
        [
            1301
        ]
    ],
    [
        [
            1301,
            1301
        ],
        "valid"
    ],
    [
        [
            1302,
            1302
        ],
        "mapped",
        [
            1303
        ]
    ],
    [
        [
            1303,
            1303
        ],
        "valid"
    ],
    [
        [
            1304,
            1304
        ],
        "mapped",
        [
            1305
        ]
    ],
    [
        [
            1305,
            1305
        ],
        "valid"
    ],
    [
        [
            1306,
            1306
        ],
        "mapped",
        [
            1307
        ]
    ],
    [
        [
            1307,
            1307
        ],
        "valid"
    ],
    [
        [
            1308,
            1308
        ],
        "mapped",
        [
            1309
        ]
    ],
    [
        [
            1309,
            1309
        ],
        "valid"
    ],
    [
        [
            1310,
            1310
        ],
        "mapped",
        [
            1311
        ]
    ],
    [
        [
            1311,
            1311
        ],
        "valid"
    ],
    [
        [
            1312,
            1312
        ],
        "mapped",
        [
            1313
        ]
    ],
    [
        [
            1313,
            1313
        ],
        "valid"
    ],
    [
        [
            1314,
            1314
        ],
        "mapped",
        [
            1315
        ]
    ],
    [
        [
            1315,
            1315
        ],
        "valid"
    ],
    [
        [
            1316,
            1316
        ],
        "mapped",
        [
            1317
        ]
    ],
    [
        [
            1317,
            1317
        ],
        "valid"
    ],
    [
        [
            1318,
            1318
        ],
        "mapped",
        [
            1319
        ]
    ],
    [
        [
            1319,
            1319
        ],
        "valid"
    ],
    [
        [
            1320,
            1320
        ],
        "mapped",
        [
            1321
        ]
    ],
    [
        [
            1321,
            1321
        ],
        "valid"
    ],
    [
        [
            1322,
            1322
        ],
        "mapped",
        [
            1323
        ]
    ],
    [
        [
            1323,
            1323
        ],
        "valid"
    ],
    [
        [
            1324,
            1324
        ],
        "mapped",
        [
            1325
        ]
    ],
    [
        [
            1325,
            1325
        ],
        "valid"
    ],
    [
        [
            1326,
            1326
        ],
        "mapped",
        [
            1327
        ]
    ],
    [
        [
            1327,
            1327
        ],
        "valid"
    ],
    [
        [
            1328,
            1328
        ],
        "disallowed"
    ],
    [
        [
            1329,
            1329
        ],
        "mapped",
        [
            1377
        ]
    ],
    [
        [
            1330,
            1330
        ],
        "mapped",
        [
            1378
        ]
    ],
    [
        [
            1331,
            1331
        ],
        "mapped",
        [
            1379
        ]
    ],
    [
        [
            1332,
            1332
        ],
        "mapped",
        [
            1380
        ]
    ],
    [
        [
            1333,
            1333
        ],
        "mapped",
        [
            1381
        ]
    ],
    [
        [
            1334,
            1334
        ],
        "mapped",
        [
            1382
        ]
    ],
    [
        [
            1335,
            1335
        ],
        "mapped",
        [
            1383
        ]
    ],
    [
        [
            1336,
            1336
        ],
        "mapped",
        [
            1384
        ]
    ],
    [
        [
            1337,
            1337
        ],
        "mapped",
        [
            1385
        ]
    ],
    [
        [
            1338,
            1338
        ],
        "mapped",
        [
            1386
        ]
    ],
    [
        [
            1339,
            1339
        ],
        "mapped",
        [
            1387
        ]
    ],
    [
        [
            1340,
            1340
        ],
        "mapped",
        [
            1388
        ]
    ],
    [
        [
            1341,
            1341
        ],
        "mapped",
        [
            1389
        ]
    ],
    [
        [
            1342,
            1342
        ],
        "mapped",
        [
            1390
        ]
    ],
    [
        [
            1343,
            1343
        ],
        "mapped",
        [
            1391
        ]
    ],
    [
        [
            1344,
            1344
        ],
        "mapped",
        [
            1392
        ]
    ],
    [
        [
            1345,
            1345
        ],
        "mapped",
        [
            1393
        ]
    ],
    [
        [
            1346,
            1346
        ],
        "mapped",
        [
            1394
        ]
    ],
    [
        [
            1347,
            1347
        ],
        "mapped",
        [
            1395
        ]
    ],
    [
        [
            1348,
            1348
        ],
        "mapped",
        [
            1396
        ]
    ],
    [
        [
            1349,
            1349
        ],
        "mapped",
        [
            1397
        ]
    ],
    [
        [
            1350,
            1350
        ],
        "mapped",
        [
            1398
        ]
    ],
    [
        [
            1351,
            1351
        ],
        "mapped",
        [
            1399
        ]
    ],
    [
        [
            1352,
            1352
        ],
        "mapped",
        [
            1400
        ]
    ],
    [
        [
            1353,
            1353
        ],
        "mapped",
        [
            1401
        ]
    ],
    [
        [
            1354,
            1354
        ],
        "mapped",
        [
            1402
        ]
    ],
    [
        [
            1355,
            1355
        ],
        "mapped",
        [
            1403
        ]
    ],
    [
        [
            1356,
            1356
        ],
        "mapped",
        [
            1404
        ]
    ],
    [
        [
            1357,
            1357
        ],
        "mapped",
        [
            1405
        ]
    ],
    [
        [
            1358,
            1358
        ],
        "mapped",
        [
            1406
        ]
    ],
    [
        [
            1359,
            1359
        ],
        "mapped",
        [
            1407
        ]
    ],
    [
        [
            1360,
            1360
        ],
        "mapped",
        [
            1408
        ]
    ],
    [
        [
            1361,
            1361
        ],
        "mapped",
        [
            1409
        ]
    ],
    [
        [
            1362,
            1362
        ],
        "mapped",
        [
            1410
        ]
    ],
    [
        [
            1363,
            1363
        ],
        "mapped",
        [
            1411
        ]
    ],
    [
        [
            1364,
            1364
        ],
        "mapped",
        [
            1412
        ]
    ],
    [
        [
            1365,
            1365
        ],
        "mapped",
        [
            1413
        ]
    ],
    [
        [
            1366,
            1366
        ],
        "mapped",
        [
            1414
        ]
    ],
    [
        [
            1367,
            1368
        ],
        "disallowed"
    ],
    [
        [
            1369,
            1369
        ],
        "valid"
    ],
    [
        [
            1370,
            1375
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1376,
            1376
        ],
        "disallowed"
    ],
    [
        [
            1377,
            1414
        ],
        "valid"
    ],
    [
        [
            1415,
            1415
        ],
        "mapped",
        [
            1381,
            1410
        ]
    ],
    [
        [
            1416,
            1416
        ],
        "disallowed"
    ],
    [
        [
            1417,
            1417
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1418,
            1418
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1419,
            1420
        ],
        "disallowed"
    ],
    [
        [
            1421,
            1422
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1423,
            1423
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1424,
            1424
        ],
        "disallowed"
    ],
    [
        [
            1425,
            1441
        ],
        "valid"
    ],
    [
        [
            1442,
            1442
        ],
        "valid"
    ],
    [
        [
            1443,
            1455
        ],
        "valid"
    ],
    [
        [
            1456,
            1465
        ],
        "valid"
    ],
    [
        [
            1466,
            1466
        ],
        "valid"
    ],
    [
        [
            1467,
            1469
        ],
        "valid"
    ],
    [
        [
            1470,
            1470
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1471,
            1471
        ],
        "valid"
    ],
    [
        [
            1472,
            1472
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1473,
            1474
        ],
        "valid"
    ],
    [
        [
            1475,
            1475
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1476,
            1476
        ],
        "valid"
    ],
    [
        [
            1477,
            1477
        ],
        "valid"
    ],
    [
        [
            1478,
            1478
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1479,
            1479
        ],
        "valid"
    ],
    [
        [
            1480,
            1487
        ],
        "disallowed"
    ],
    [
        [
            1488,
            1514
        ],
        "valid"
    ],
    [
        [
            1515,
            1519
        ],
        "disallowed"
    ],
    [
        [
            1520,
            1524
        ],
        "valid"
    ],
    [
        [
            1525,
            1535
        ],
        "disallowed"
    ],
    [
        [
            1536,
            1539
        ],
        "disallowed"
    ],
    [
        [
            1540,
            1540
        ],
        "disallowed"
    ],
    [
        [
            1541,
            1541
        ],
        "disallowed"
    ],
    [
        [
            1542,
            1546
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1547,
            1547
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1548,
            1548
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1549,
            1551
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1552,
            1557
        ],
        "valid"
    ],
    [
        [
            1558,
            1562
        ],
        "valid"
    ],
    [
        [
            1563,
            1563
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1564,
            1564
        ],
        "disallowed"
    ],
    [
        [
            1565,
            1565
        ],
        "disallowed"
    ],
    [
        [
            1566,
            1566
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1567,
            1567
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1568,
            1568
        ],
        "valid"
    ],
    [
        [
            1569,
            1594
        ],
        "valid"
    ],
    [
        [
            1595,
            1599
        ],
        "valid"
    ],
    [
        [
            1600,
            1600
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1601,
            1618
        ],
        "valid"
    ],
    [
        [
            1619,
            1621
        ],
        "valid"
    ],
    [
        [
            1622,
            1624
        ],
        "valid"
    ],
    [
        [
            1625,
            1630
        ],
        "valid"
    ],
    [
        [
            1631,
            1631
        ],
        "valid"
    ],
    [
        [
            1632,
            1641
        ],
        "valid"
    ],
    [
        [
            1642,
            1645
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1646,
            1647
        ],
        "valid"
    ],
    [
        [
            1648,
            1652
        ],
        "valid"
    ],
    [
        [
            1653,
            1653
        ],
        "mapped",
        [
            1575,
            1652
        ]
    ],
    [
        [
            1654,
            1654
        ],
        "mapped",
        [
            1608,
            1652
        ]
    ],
    [
        [
            1655,
            1655
        ],
        "mapped",
        [
            1735,
            1652
        ]
    ],
    [
        [
            1656,
            1656
        ],
        "mapped",
        [
            1610,
            1652
        ]
    ],
    [
        [
            1657,
            1719
        ],
        "valid"
    ],
    [
        [
            1720,
            1721
        ],
        "valid"
    ],
    [
        [
            1722,
            1726
        ],
        "valid"
    ],
    [
        [
            1727,
            1727
        ],
        "valid"
    ],
    [
        [
            1728,
            1742
        ],
        "valid"
    ],
    [
        [
            1743,
            1743
        ],
        "valid"
    ],
    [
        [
            1744,
            1747
        ],
        "valid"
    ],
    [
        [
            1748,
            1748
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1749,
            1756
        ],
        "valid"
    ],
    [
        [
            1757,
            1757
        ],
        "disallowed"
    ],
    [
        [
            1758,
            1758
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1759,
            1768
        ],
        "valid"
    ],
    [
        [
            1769,
            1769
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1770,
            1773
        ],
        "valid"
    ],
    [
        [
            1774,
            1775
        ],
        "valid"
    ],
    [
        [
            1776,
            1785
        ],
        "valid"
    ],
    [
        [
            1786,
            1790
        ],
        "valid"
    ],
    [
        [
            1791,
            1791
        ],
        "valid"
    ],
    [
        [
            1792,
            1805
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            1806,
            1806
        ],
        "disallowed"
    ],
    [
        [
            1807,
            1807
        ],
        "disallowed"
    ],
    [
        [
            1808,
            1836
        ],
        "valid"
    ],
    [
        [
            1837,
            1839
        ],
        "valid"
    ],
    [
        [
            1840,
            1866
        ],
        "valid"
    ],
    [
        [
            1867,
            1868
        ],
        "disallowed"
    ],
    [
        [
            1869,
            1871
        ],
        "valid"
    ],
    [
        [
            1872,
            1901
        ],
        "valid"
    ],
    [
        [
            1902,
            1919
        ],
        "valid"
    ],
    [
        [
            1920,
            1968
        ],
        "valid"
    ],
    [
        [
            1969,
            1969
        ],
        "valid"
    ],
    [
        [
            1970,
            1983
        ],
        "disallowed"
    ],
    [
        [
            1984,
            2037
        ],
        "valid"
    ],
    [
        [
            2038,
            2042
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            2043,
            2047
        ],
        "disallowed"
    ],
    [
        [
            2048,
            2093
        ],
        "valid"
    ],
    [
        [
            2094,
            2095
        ],
        "disallowed"
    ],
    [
        [
            2096,
            2110
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            2111,
            2111
        ],
        "disallowed"
    ],
    [
        [
            2112,
            2139
        ],
        "valid"
    ],
    [
        [
            2140,
            2141
        ],
        "disallowed"
    ],
    [
        [
            2142,
            2142
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            2143,
            2207
        ],
        "disallowed"
    ],
    [
        [
            2208,
            2208
        ],
        "valid"
    ],
    [
        [
            2209,
            2209
        ],
        "valid"
    ],
    [
        [
            2210,
            2220
        ],
        "valid"
    ],
    [
        [
            2221,
            2226
        ],
        "valid"
    ],
    [
        [
            2227,
            2228
        ],
        "valid"
    ],
    [
        [
            2229,
            2274
        ],
        "disallowed"
    ],
    [
        [
            2275,
            2275
        ],
        "valid"
    ],
    [
        [
            2276,
            2302
        ],
        "valid"
    ],
    [
        [
            2303,
            2303
        ],
        "valid"
    ],
    [
        [
            2304,
            2304
        ],
        "valid"
    ],
    [
        [
            2305,
            2307
        ],
        "valid"
    ],
    [
        [
            2308,
            2308
        ],
        "valid"
    ],
    [
        [
            2309,
            2361
        ],
        "valid"
    ],
    [
        [
            2362,
            2363
        ],
        "valid"
    ],
    [
        [
            2364,
            2381
        ],
        "valid"
    ],
    [
        [
            2382,
            2382
        ],
        "valid"
    ],
    [
        [
            2383,
            2383
        ],
        "valid"
    ],
    [
        [
            2384,
            2388
        ],
        "valid"
    ],
    [
        [
            2389,
            2389
        ],
        "valid"
    ],
    [
        [
            2390,
            2391
        ],
        "valid"
    ],
    [
        [
            2392,
            2392
        ],
        "mapped",
        [
            2325,
            2364
        ]
    ],
    [
        [
            2393,
            2393
        ],
        "mapped",
        [
            2326,
            2364
        ]
    ],
    [
        [
            2394,
            2394
        ],
        "mapped",
        [
            2327,
            2364
        ]
    ],
    [
        [
            2395,
            2395
        ],
        "mapped",
        [
            2332,
            2364
        ]
    ],
    [
        [
            2396,
            2396
        ],
        "mapped",
        [
            2337,
            2364
        ]
    ],
    [
        [
            2397,
            2397
        ],
        "mapped",
        [
            2338,
            2364
        ]
    ],
    [
        [
            2398,
            2398
        ],
        "mapped",
        [
            2347,
            2364
        ]
    ],
    [
        [
            2399,
            2399
        ],
        "mapped",
        [
            2351,
            2364
        ]
    ],
    [
        [
            2400,
            2403
        ],
        "valid"
    ],
    [
        [
            2404,
            2405
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            2406,
            2415
        ],
        "valid"
    ],
    [
        [
            2416,
            2416
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            2417,
            2418
        ],
        "valid"
    ],
    [
        [
            2419,
            2423
        ],
        "valid"
    ],
    [
        [
            2424,
            2424
        ],
        "valid"
    ],
    [
        [
            2425,
            2426
        ],
        "valid"
    ],
    [
        [
            2427,
            2428
        ],
        "valid"
    ],
    [
        [
            2429,
            2429
        ],
        "valid"
    ],
    [
        [
            2430,
            2431
        ],
        "valid"
    ],
    [
        [
            2432,
            2432
        ],
        "valid"
    ],
    [
        [
            2433,
            2435
        ],
        "valid"
    ],
    [
        [
            2436,
            2436
        ],
        "disallowed"
    ],
    [
        [
            2437,
            2444
        ],
        "valid"
    ],
    [
        [
            2445,
            2446
        ],
        "disallowed"
    ],
    [
        [
            2447,
            2448
        ],
        "valid"
    ],
    [
        [
            2449,
            2450
        ],
        "disallowed"
    ],
    [
        [
            2451,
            2472
        ],
        "valid"
    ],
    [
        [
            2473,
            2473
        ],
        "disallowed"
    ],
    [
        [
            2474,
            2480
        ],
        "valid"
    ],
    [
        [
            2481,
            2481
        ],
        "disallowed"
    ],
    [
        [
            2482,
            2482
        ],
        "valid"
    ],
    [
        [
            2483,
            2485
        ],
        "disallowed"
    ],
    [
        [
            2486,
            2489
        ],
        "valid"
    ],
    [
        [
            2490,
            2491
        ],
        "disallowed"
    ],
    [
        [
            2492,
            2492
        ],
        "valid"
    ],
    [
        [
            2493,
            2493
        ],
        "valid"
    ],
    [
        [
            2494,
            2500
        ],
        "valid"
    ],
    [
        [
            2501,
            2502
        ],
        "disallowed"
    ],
    [
        [
            2503,
            2504
        ],
        "valid"
    ],
    [
        [
            2505,
            2506
        ],
        "disallowed"
    ],
    [
        [
            2507,
            2509
        ],
        "valid"
    ],
    [
        [
            2510,
            2510
        ],
        "valid"
    ],
    [
        [
            2511,
            2518
        ],
        "disallowed"
    ],
    [
        [
            2519,
            2519
        ],
        "valid"
    ],
    [
        [
            2520,
            2523
        ],
        "disallowed"
    ],
    [
        [
            2524,
            2524
        ],
        "mapped",
        [
            2465,
            2492
        ]
    ],
    [
        [
            2525,
            2525
        ],
        "mapped",
        [
            2466,
            2492
        ]
    ],
    [
        [
            2526,
            2526
        ],
        "disallowed"
    ],
    [
        [
            2527,
            2527
        ],
        "mapped",
        [
            2479,
            2492
        ]
    ],
    [
        [
            2528,
            2531
        ],
        "valid"
    ],
    [
        [
            2532,
            2533
        ],
        "disallowed"
    ],
    [
        [
            2534,
            2545
        ],
        "valid"
    ],
    [
        [
            2546,
            2554
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            2555,
            2555
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            2556,
            2560
        ],
        "disallowed"
    ],
    [
        [
            2561,
            2561
        ],
        "valid"
    ],
    [
        [
            2562,
            2562
        ],
        "valid"
    ],
    [
        [
            2563,
            2563
        ],
        "valid"
    ],
    [
        [
            2564,
            2564
        ],
        "disallowed"
    ],
    [
        [
            2565,
            2570
        ],
        "valid"
    ],
    [
        [
            2571,
            2574
        ],
        "disallowed"
    ],
    [
        [
            2575,
            2576
        ],
        "valid"
    ],
    [
        [
            2577,
            2578
        ],
        "disallowed"
    ],
    [
        [
            2579,
            2600
        ],
        "valid"
    ],
    [
        [
            2601,
            2601
        ],
        "disallowed"
    ],
    [
        [
            2602,
            2608
        ],
        "valid"
    ],
    [
        [
            2609,
            2609
        ],
        "disallowed"
    ],
    [
        [
            2610,
            2610
        ],
        "valid"
    ],
    [
        [
            2611,
            2611
        ],
        "mapped",
        [
            2610,
            2620
        ]
    ],
    [
        [
            2612,
            2612
        ],
        "disallowed"
    ],
    [
        [
            2613,
            2613
        ],
        "valid"
    ],
    [
        [
            2614,
            2614
        ],
        "mapped",
        [
            2616,
            2620
        ]
    ],
    [
        [
            2615,
            2615
        ],
        "disallowed"
    ],
    [
        [
            2616,
            2617
        ],
        "valid"
    ],
    [
        [
            2618,
            2619
        ],
        "disallowed"
    ],
    [
        [
            2620,
            2620
        ],
        "valid"
    ],
    [
        [
            2621,
            2621
        ],
        "disallowed"
    ],
    [
        [
            2622,
            2626
        ],
        "valid"
    ],
    [
        [
            2627,
            2630
        ],
        "disallowed"
    ],
    [
        [
            2631,
            2632
        ],
        "valid"
    ],
    [
        [
            2633,
            2634
        ],
        "disallowed"
    ],
    [
        [
            2635,
            2637
        ],
        "valid"
    ],
    [
        [
            2638,
            2640
        ],
        "disallowed"
    ],
    [
        [
            2641,
            2641
        ],
        "valid"
    ],
    [
        [
            2642,
            2648
        ],
        "disallowed"
    ],
    [
        [
            2649,
            2649
        ],
        "mapped",
        [
            2582,
            2620
        ]
    ],
    [
        [
            2650,
            2650
        ],
        "mapped",
        [
            2583,
            2620
        ]
    ],
    [
        [
            2651,
            2651
        ],
        "mapped",
        [
            2588,
            2620
        ]
    ],
    [
        [
            2652,
            2652
        ],
        "valid"
    ],
    [
        [
            2653,
            2653
        ],
        "disallowed"
    ],
    [
        [
            2654,
            2654
        ],
        "mapped",
        [
            2603,
            2620
        ]
    ],
    [
        [
            2655,
            2661
        ],
        "disallowed"
    ],
    [
        [
            2662,
            2676
        ],
        "valid"
    ],
    [
        [
            2677,
            2677
        ],
        "valid"
    ],
    [
        [
            2678,
            2688
        ],
        "disallowed"
    ],
    [
        [
            2689,
            2691
        ],
        "valid"
    ],
    [
        [
            2692,
            2692
        ],
        "disallowed"
    ],
    [
        [
            2693,
            2699
        ],
        "valid"
    ],
    [
        [
            2700,
            2700
        ],
        "valid"
    ],
    [
        [
            2701,
            2701
        ],
        "valid"
    ],
    [
        [
            2702,
            2702
        ],
        "disallowed"
    ],
    [
        [
            2703,
            2705
        ],
        "valid"
    ],
    [
        [
            2706,
            2706
        ],
        "disallowed"
    ],
    [
        [
            2707,
            2728
        ],
        "valid"
    ],
    [
        [
            2729,
            2729
        ],
        "disallowed"
    ],
    [
        [
            2730,
            2736
        ],
        "valid"
    ],
    [
        [
            2737,
            2737
        ],
        "disallowed"
    ],
    [
        [
            2738,
            2739
        ],
        "valid"
    ],
    [
        [
            2740,
            2740
        ],
        "disallowed"
    ],
    [
        [
            2741,
            2745
        ],
        "valid"
    ],
    [
        [
            2746,
            2747
        ],
        "disallowed"
    ],
    [
        [
            2748,
            2757
        ],
        "valid"
    ],
    [
        [
            2758,
            2758
        ],
        "disallowed"
    ],
    [
        [
            2759,
            2761
        ],
        "valid"
    ],
    [
        [
            2762,
            2762
        ],
        "disallowed"
    ],
    [
        [
            2763,
            2765
        ],
        "valid"
    ],
    [
        [
            2766,
            2767
        ],
        "disallowed"
    ],
    [
        [
            2768,
            2768
        ],
        "valid"
    ],
    [
        [
            2769,
            2783
        ],
        "disallowed"
    ],
    [
        [
            2784,
            2784
        ],
        "valid"
    ],
    [
        [
            2785,
            2787
        ],
        "valid"
    ],
    [
        [
            2788,
            2789
        ],
        "disallowed"
    ],
    [
        [
            2790,
            2799
        ],
        "valid"
    ],
    [
        [
            2800,
            2800
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            2801,
            2801
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            2802,
            2808
        ],
        "disallowed"
    ],
    [
        [
            2809,
            2809
        ],
        "valid"
    ],
    [
        [
            2810,
            2816
        ],
        "disallowed"
    ],
    [
        [
            2817,
            2819
        ],
        "valid"
    ],
    [
        [
            2820,
            2820
        ],
        "disallowed"
    ],
    [
        [
            2821,
            2828
        ],
        "valid"
    ],
    [
        [
            2829,
            2830
        ],
        "disallowed"
    ],
    [
        [
            2831,
            2832
        ],
        "valid"
    ],
    [
        [
            2833,
            2834
        ],
        "disallowed"
    ],
    [
        [
            2835,
            2856
        ],
        "valid"
    ],
    [
        [
            2857,
            2857
        ],
        "disallowed"
    ],
    [
        [
            2858,
            2864
        ],
        "valid"
    ],
    [
        [
            2865,
            2865
        ],
        "disallowed"
    ],
    [
        [
            2866,
            2867
        ],
        "valid"
    ],
    [
        [
            2868,
            2868
        ],
        "disallowed"
    ],
    [
        [
            2869,
            2869
        ],
        "valid"
    ],
    [
        [
            2870,
            2873
        ],
        "valid"
    ],
    [
        [
            2874,
            2875
        ],
        "disallowed"
    ],
    [
        [
            2876,
            2883
        ],
        "valid"
    ],
    [
        [
            2884,
            2884
        ],
        "valid"
    ],
    [
        [
            2885,
            2886
        ],
        "disallowed"
    ],
    [
        [
            2887,
            2888
        ],
        "valid"
    ],
    [
        [
            2889,
            2890
        ],
        "disallowed"
    ],
    [
        [
            2891,
            2893
        ],
        "valid"
    ],
    [
        [
            2894,
            2901
        ],
        "disallowed"
    ],
    [
        [
            2902,
            2903
        ],
        "valid"
    ],
    [
        [
            2904,
            2907
        ],
        "disallowed"
    ],
    [
        [
            2908,
            2908
        ],
        "mapped",
        [
            2849,
            2876
        ]
    ],
    [
        [
            2909,
            2909
        ],
        "mapped",
        [
            2850,
            2876
        ]
    ],
    [
        [
            2910,
            2910
        ],
        "disallowed"
    ],
    [
        [
            2911,
            2913
        ],
        "valid"
    ],
    [
        [
            2914,
            2915
        ],
        "valid"
    ],
    [
        [
            2916,
            2917
        ],
        "disallowed"
    ],
    [
        [
            2918,
            2927
        ],
        "valid"
    ],
    [
        [
            2928,
            2928
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            2929,
            2929
        ],
        "valid"
    ],
    [
        [
            2930,
            2935
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            2936,
            2945
        ],
        "disallowed"
    ],
    [
        [
            2946,
            2947
        ],
        "valid"
    ],
    [
        [
            2948,
            2948
        ],
        "disallowed"
    ],
    [
        [
            2949,
            2954
        ],
        "valid"
    ],
    [
        [
            2955,
            2957
        ],
        "disallowed"
    ],
    [
        [
            2958,
            2960
        ],
        "valid"
    ],
    [
        [
            2961,
            2961
        ],
        "disallowed"
    ],
    [
        [
            2962,
            2965
        ],
        "valid"
    ],
    [
        [
            2966,
            2968
        ],
        "disallowed"
    ],
    [
        [
            2969,
            2970
        ],
        "valid"
    ],
    [
        [
            2971,
            2971
        ],
        "disallowed"
    ],
    [
        [
            2972,
            2972
        ],
        "valid"
    ],
    [
        [
            2973,
            2973
        ],
        "disallowed"
    ],
    [
        [
            2974,
            2975
        ],
        "valid"
    ],
    [
        [
            2976,
            2978
        ],
        "disallowed"
    ],
    [
        [
            2979,
            2980
        ],
        "valid"
    ],
    [
        [
            2981,
            2983
        ],
        "disallowed"
    ],
    [
        [
            2984,
            2986
        ],
        "valid"
    ],
    [
        [
            2987,
            2989
        ],
        "disallowed"
    ],
    [
        [
            2990,
            2997
        ],
        "valid"
    ],
    [
        [
            2998,
            2998
        ],
        "valid"
    ],
    [
        [
            2999,
            3001
        ],
        "valid"
    ],
    [
        [
            3002,
            3005
        ],
        "disallowed"
    ],
    [
        [
            3006,
            3010
        ],
        "valid"
    ],
    [
        [
            3011,
            3013
        ],
        "disallowed"
    ],
    [
        [
            3014,
            3016
        ],
        "valid"
    ],
    [
        [
            3017,
            3017
        ],
        "disallowed"
    ],
    [
        [
            3018,
            3021
        ],
        "valid"
    ],
    [
        [
            3022,
            3023
        ],
        "disallowed"
    ],
    [
        [
            3024,
            3024
        ],
        "valid"
    ],
    [
        [
            3025,
            3030
        ],
        "disallowed"
    ],
    [
        [
            3031,
            3031
        ],
        "valid"
    ],
    [
        [
            3032,
            3045
        ],
        "disallowed"
    ],
    [
        [
            3046,
            3046
        ],
        "valid"
    ],
    [
        [
            3047,
            3055
        ],
        "valid"
    ],
    [
        [
            3056,
            3058
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3059,
            3066
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3067,
            3071
        ],
        "disallowed"
    ],
    [
        [
            3072,
            3072
        ],
        "valid"
    ],
    [
        [
            3073,
            3075
        ],
        "valid"
    ],
    [
        [
            3076,
            3076
        ],
        "disallowed"
    ],
    [
        [
            3077,
            3084
        ],
        "valid"
    ],
    [
        [
            3085,
            3085
        ],
        "disallowed"
    ],
    [
        [
            3086,
            3088
        ],
        "valid"
    ],
    [
        [
            3089,
            3089
        ],
        "disallowed"
    ],
    [
        [
            3090,
            3112
        ],
        "valid"
    ],
    [
        [
            3113,
            3113
        ],
        "disallowed"
    ],
    [
        [
            3114,
            3123
        ],
        "valid"
    ],
    [
        [
            3124,
            3124
        ],
        "valid"
    ],
    [
        [
            3125,
            3129
        ],
        "valid"
    ],
    [
        [
            3130,
            3132
        ],
        "disallowed"
    ],
    [
        [
            3133,
            3133
        ],
        "valid"
    ],
    [
        [
            3134,
            3140
        ],
        "valid"
    ],
    [
        [
            3141,
            3141
        ],
        "disallowed"
    ],
    [
        [
            3142,
            3144
        ],
        "valid"
    ],
    [
        [
            3145,
            3145
        ],
        "disallowed"
    ],
    [
        [
            3146,
            3149
        ],
        "valid"
    ],
    [
        [
            3150,
            3156
        ],
        "disallowed"
    ],
    [
        [
            3157,
            3158
        ],
        "valid"
    ],
    [
        [
            3159,
            3159
        ],
        "disallowed"
    ],
    [
        [
            3160,
            3161
        ],
        "valid"
    ],
    [
        [
            3162,
            3162
        ],
        "valid"
    ],
    [
        [
            3163,
            3167
        ],
        "disallowed"
    ],
    [
        [
            3168,
            3169
        ],
        "valid"
    ],
    [
        [
            3170,
            3171
        ],
        "valid"
    ],
    [
        [
            3172,
            3173
        ],
        "disallowed"
    ],
    [
        [
            3174,
            3183
        ],
        "valid"
    ],
    [
        [
            3184,
            3191
        ],
        "disallowed"
    ],
    [
        [
            3192,
            3199
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3200,
            3200
        ],
        "disallowed"
    ],
    [
        [
            3201,
            3201
        ],
        "valid"
    ],
    [
        [
            3202,
            3203
        ],
        "valid"
    ],
    [
        [
            3204,
            3204
        ],
        "disallowed"
    ],
    [
        [
            3205,
            3212
        ],
        "valid"
    ],
    [
        [
            3213,
            3213
        ],
        "disallowed"
    ],
    [
        [
            3214,
            3216
        ],
        "valid"
    ],
    [
        [
            3217,
            3217
        ],
        "disallowed"
    ],
    [
        [
            3218,
            3240
        ],
        "valid"
    ],
    [
        [
            3241,
            3241
        ],
        "disallowed"
    ],
    [
        [
            3242,
            3251
        ],
        "valid"
    ],
    [
        [
            3252,
            3252
        ],
        "disallowed"
    ],
    [
        [
            3253,
            3257
        ],
        "valid"
    ],
    [
        [
            3258,
            3259
        ],
        "disallowed"
    ],
    [
        [
            3260,
            3261
        ],
        "valid"
    ],
    [
        [
            3262,
            3268
        ],
        "valid"
    ],
    [
        [
            3269,
            3269
        ],
        "disallowed"
    ],
    [
        [
            3270,
            3272
        ],
        "valid"
    ],
    [
        [
            3273,
            3273
        ],
        "disallowed"
    ],
    [
        [
            3274,
            3277
        ],
        "valid"
    ],
    [
        [
            3278,
            3284
        ],
        "disallowed"
    ],
    [
        [
            3285,
            3286
        ],
        "valid"
    ],
    [
        [
            3287,
            3293
        ],
        "disallowed"
    ],
    [
        [
            3294,
            3294
        ],
        "valid"
    ],
    [
        [
            3295,
            3295
        ],
        "disallowed"
    ],
    [
        [
            3296,
            3297
        ],
        "valid"
    ],
    [
        [
            3298,
            3299
        ],
        "valid"
    ],
    [
        [
            3300,
            3301
        ],
        "disallowed"
    ],
    [
        [
            3302,
            3311
        ],
        "valid"
    ],
    [
        [
            3312,
            3312
        ],
        "disallowed"
    ],
    [
        [
            3313,
            3314
        ],
        "valid"
    ],
    [
        [
            3315,
            3328
        ],
        "disallowed"
    ],
    [
        [
            3329,
            3329
        ],
        "valid"
    ],
    [
        [
            3330,
            3331
        ],
        "valid"
    ],
    [
        [
            3332,
            3332
        ],
        "disallowed"
    ],
    [
        [
            3333,
            3340
        ],
        "valid"
    ],
    [
        [
            3341,
            3341
        ],
        "disallowed"
    ],
    [
        [
            3342,
            3344
        ],
        "valid"
    ],
    [
        [
            3345,
            3345
        ],
        "disallowed"
    ],
    [
        [
            3346,
            3368
        ],
        "valid"
    ],
    [
        [
            3369,
            3369
        ],
        "valid"
    ],
    [
        [
            3370,
            3385
        ],
        "valid"
    ],
    [
        [
            3386,
            3386
        ],
        "valid"
    ],
    [
        [
            3387,
            3388
        ],
        "disallowed"
    ],
    [
        [
            3389,
            3389
        ],
        "valid"
    ],
    [
        [
            3390,
            3395
        ],
        "valid"
    ],
    [
        [
            3396,
            3396
        ],
        "valid"
    ],
    [
        [
            3397,
            3397
        ],
        "disallowed"
    ],
    [
        [
            3398,
            3400
        ],
        "valid"
    ],
    [
        [
            3401,
            3401
        ],
        "disallowed"
    ],
    [
        [
            3402,
            3405
        ],
        "valid"
    ],
    [
        [
            3406,
            3406
        ],
        "valid"
    ],
    [
        [
            3407,
            3414
        ],
        "disallowed"
    ],
    [
        [
            3415,
            3415
        ],
        "valid"
    ],
    [
        [
            3416,
            3422
        ],
        "disallowed"
    ],
    [
        [
            3423,
            3423
        ],
        "valid"
    ],
    [
        [
            3424,
            3425
        ],
        "valid"
    ],
    [
        [
            3426,
            3427
        ],
        "valid"
    ],
    [
        [
            3428,
            3429
        ],
        "disallowed"
    ],
    [
        [
            3430,
            3439
        ],
        "valid"
    ],
    [
        [
            3440,
            3445
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3446,
            3448
        ],
        "disallowed"
    ],
    [
        [
            3449,
            3449
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3450,
            3455
        ],
        "valid"
    ],
    [
        [
            3456,
            3457
        ],
        "disallowed"
    ],
    [
        [
            3458,
            3459
        ],
        "valid"
    ],
    [
        [
            3460,
            3460
        ],
        "disallowed"
    ],
    [
        [
            3461,
            3478
        ],
        "valid"
    ],
    [
        [
            3479,
            3481
        ],
        "disallowed"
    ],
    [
        [
            3482,
            3505
        ],
        "valid"
    ],
    [
        [
            3506,
            3506
        ],
        "disallowed"
    ],
    [
        [
            3507,
            3515
        ],
        "valid"
    ],
    [
        [
            3516,
            3516
        ],
        "disallowed"
    ],
    [
        [
            3517,
            3517
        ],
        "valid"
    ],
    [
        [
            3518,
            3519
        ],
        "disallowed"
    ],
    [
        [
            3520,
            3526
        ],
        "valid"
    ],
    [
        [
            3527,
            3529
        ],
        "disallowed"
    ],
    [
        [
            3530,
            3530
        ],
        "valid"
    ],
    [
        [
            3531,
            3534
        ],
        "disallowed"
    ],
    [
        [
            3535,
            3540
        ],
        "valid"
    ],
    [
        [
            3541,
            3541
        ],
        "disallowed"
    ],
    [
        [
            3542,
            3542
        ],
        "valid"
    ],
    [
        [
            3543,
            3543
        ],
        "disallowed"
    ],
    [
        [
            3544,
            3551
        ],
        "valid"
    ],
    [
        [
            3552,
            3557
        ],
        "disallowed"
    ],
    [
        [
            3558,
            3567
        ],
        "valid"
    ],
    [
        [
            3568,
            3569
        ],
        "disallowed"
    ],
    [
        [
            3570,
            3571
        ],
        "valid"
    ],
    [
        [
            3572,
            3572
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3573,
            3584
        ],
        "disallowed"
    ],
    [
        [
            3585,
            3634
        ],
        "valid"
    ],
    [
        [
            3635,
            3635
        ],
        "mapped",
        [
            3661,
            3634
        ]
    ],
    [
        [
            3636,
            3642
        ],
        "valid"
    ],
    [
        [
            3643,
            3646
        ],
        "disallowed"
    ],
    [
        [
            3647,
            3647
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3648,
            3662
        ],
        "valid"
    ],
    [
        [
            3663,
            3663
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3664,
            3673
        ],
        "valid"
    ],
    [
        [
            3674,
            3675
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3676,
            3712
        ],
        "disallowed"
    ],
    [
        [
            3713,
            3714
        ],
        "valid"
    ],
    [
        [
            3715,
            3715
        ],
        "disallowed"
    ],
    [
        [
            3716,
            3716
        ],
        "valid"
    ],
    [
        [
            3717,
            3718
        ],
        "disallowed"
    ],
    [
        [
            3719,
            3720
        ],
        "valid"
    ],
    [
        [
            3721,
            3721
        ],
        "disallowed"
    ],
    [
        [
            3722,
            3722
        ],
        "valid"
    ],
    [
        [
            3723,
            3724
        ],
        "disallowed"
    ],
    [
        [
            3725,
            3725
        ],
        "valid"
    ],
    [
        [
            3726,
            3731
        ],
        "disallowed"
    ],
    [
        [
            3732,
            3735
        ],
        "valid"
    ],
    [
        [
            3736,
            3736
        ],
        "disallowed"
    ],
    [
        [
            3737,
            3743
        ],
        "valid"
    ],
    [
        [
            3744,
            3744
        ],
        "disallowed"
    ],
    [
        [
            3745,
            3747
        ],
        "valid"
    ],
    [
        [
            3748,
            3748
        ],
        "disallowed"
    ],
    [
        [
            3749,
            3749
        ],
        "valid"
    ],
    [
        [
            3750,
            3750
        ],
        "disallowed"
    ],
    [
        [
            3751,
            3751
        ],
        "valid"
    ],
    [
        [
            3752,
            3753
        ],
        "disallowed"
    ],
    [
        [
            3754,
            3755
        ],
        "valid"
    ],
    [
        [
            3756,
            3756
        ],
        "disallowed"
    ],
    [
        [
            3757,
            3762
        ],
        "valid"
    ],
    [
        [
            3763,
            3763
        ],
        "mapped",
        [
            3789,
            3762
        ]
    ],
    [
        [
            3764,
            3769
        ],
        "valid"
    ],
    [
        [
            3770,
            3770
        ],
        "disallowed"
    ],
    [
        [
            3771,
            3773
        ],
        "valid"
    ],
    [
        [
            3774,
            3775
        ],
        "disallowed"
    ],
    [
        [
            3776,
            3780
        ],
        "valid"
    ],
    [
        [
            3781,
            3781
        ],
        "disallowed"
    ],
    [
        [
            3782,
            3782
        ],
        "valid"
    ],
    [
        [
            3783,
            3783
        ],
        "disallowed"
    ],
    [
        [
            3784,
            3789
        ],
        "valid"
    ],
    [
        [
            3790,
            3791
        ],
        "disallowed"
    ],
    [
        [
            3792,
            3801
        ],
        "valid"
    ],
    [
        [
            3802,
            3803
        ],
        "disallowed"
    ],
    [
        [
            3804,
            3804
        ],
        "mapped",
        [
            3755,
            3737
        ]
    ],
    [
        [
            3805,
            3805
        ],
        "mapped",
        [
            3755,
            3745
        ]
    ],
    [
        [
            3806,
            3807
        ],
        "valid"
    ],
    [
        [
            3808,
            3839
        ],
        "disallowed"
    ],
    [
        [
            3840,
            3840
        ],
        "valid"
    ],
    [
        [
            3841,
            3850
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3851,
            3851
        ],
        "valid"
    ],
    [
        [
            3852,
            3852
        ],
        "mapped",
        [
            3851
        ]
    ],
    [
        [
            3853,
            3863
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3864,
            3865
        ],
        "valid"
    ],
    [
        [
            3866,
            3871
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3872,
            3881
        ],
        "valid"
    ],
    [
        [
            3882,
            3892
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3893,
            3893
        ],
        "valid"
    ],
    [
        [
            3894,
            3894
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3895,
            3895
        ],
        "valid"
    ],
    [
        [
            3896,
            3896
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3897,
            3897
        ],
        "valid"
    ],
    [
        [
            3898,
            3901
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3902,
            3906
        ],
        "valid"
    ],
    [
        [
            3907,
            3907
        ],
        "mapped",
        [
            3906,
            4023
        ]
    ],
    [
        [
            3908,
            3911
        ],
        "valid"
    ],
    [
        [
            3912,
            3912
        ],
        "disallowed"
    ],
    [
        [
            3913,
            3916
        ],
        "valid"
    ],
    [
        [
            3917,
            3917
        ],
        "mapped",
        [
            3916,
            4023
        ]
    ],
    [
        [
            3918,
            3921
        ],
        "valid"
    ],
    [
        [
            3922,
            3922
        ],
        "mapped",
        [
            3921,
            4023
        ]
    ],
    [
        [
            3923,
            3926
        ],
        "valid"
    ],
    [
        [
            3927,
            3927
        ],
        "mapped",
        [
            3926,
            4023
        ]
    ],
    [
        [
            3928,
            3931
        ],
        "valid"
    ],
    [
        [
            3932,
            3932
        ],
        "mapped",
        [
            3931,
            4023
        ]
    ],
    [
        [
            3933,
            3944
        ],
        "valid"
    ],
    [
        [
            3945,
            3945
        ],
        "mapped",
        [
            3904,
            4021
        ]
    ],
    [
        [
            3946,
            3946
        ],
        "valid"
    ],
    [
        [
            3947,
            3948
        ],
        "valid"
    ],
    [
        [
            3949,
            3952
        ],
        "disallowed"
    ],
    [
        [
            3953,
            3954
        ],
        "valid"
    ],
    [
        [
            3955,
            3955
        ],
        "mapped",
        [
            3953,
            3954
        ]
    ],
    [
        [
            3956,
            3956
        ],
        "valid"
    ],
    [
        [
            3957,
            3957
        ],
        "mapped",
        [
            3953,
            3956
        ]
    ],
    [
        [
            3958,
            3958
        ],
        "mapped",
        [
            4018,
            3968
        ]
    ],
    [
        [
            3959,
            3959
        ],
        "mapped",
        [
            4018,
            3953,
            3968
        ]
    ],
    [
        [
            3960,
            3960
        ],
        "mapped",
        [
            4019,
            3968
        ]
    ],
    [
        [
            3961,
            3961
        ],
        "mapped",
        [
            4019,
            3953,
            3968
        ]
    ],
    [
        [
            3962,
            3968
        ],
        "valid"
    ],
    [
        [
            3969,
            3969
        ],
        "mapped",
        [
            3953,
            3968
        ]
    ],
    [
        [
            3970,
            3972
        ],
        "valid"
    ],
    [
        [
            3973,
            3973
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            3974,
            3979
        ],
        "valid"
    ],
    [
        [
            3980,
            3983
        ],
        "valid"
    ],
    [
        [
            3984,
            3986
        ],
        "valid"
    ],
    [
        [
            3987,
            3987
        ],
        "mapped",
        [
            3986,
            4023
        ]
    ],
    [
        [
            3988,
            3989
        ],
        "valid"
    ],
    [
        [
            3990,
            3990
        ],
        "valid"
    ],
    [
        [
            3991,
            3991
        ],
        "valid"
    ],
    [
        [
            3992,
            3992
        ],
        "disallowed"
    ],
    [
        [
            3993,
            3996
        ],
        "valid"
    ],
    [
        [
            3997,
            3997
        ],
        "mapped",
        [
            3996,
            4023
        ]
    ],
    [
        [
            3998,
            4001
        ],
        "valid"
    ],
    [
        [
            4002,
            4002
        ],
        "mapped",
        [
            4001,
            4023
        ]
    ],
    [
        [
            4003,
            4006
        ],
        "valid"
    ],
    [
        [
            4007,
            4007
        ],
        "mapped",
        [
            4006,
            4023
        ]
    ],
    [
        [
            4008,
            4011
        ],
        "valid"
    ],
    [
        [
            4012,
            4012
        ],
        "mapped",
        [
            4011,
            4023
        ]
    ],
    [
        [
            4013,
            4013
        ],
        "valid"
    ],
    [
        [
            4014,
            4016
        ],
        "valid"
    ],
    [
        [
            4017,
            4023
        ],
        "valid"
    ],
    [
        [
            4024,
            4024
        ],
        "valid"
    ],
    [
        [
            4025,
            4025
        ],
        "mapped",
        [
            3984,
            4021
        ]
    ],
    [
        [
            4026,
            4028
        ],
        "valid"
    ],
    [
        [
            4029,
            4029
        ],
        "disallowed"
    ],
    [
        [
            4030,
            4037
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4038,
            4038
        ],
        "valid"
    ],
    [
        [
            4039,
            4044
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4045,
            4045
        ],
        "disallowed"
    ],
    [
        [
            4046,
            4046
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4047,
            4047
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4048,
            4049
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4050,
            4052
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4053,
            4056
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4057,
            4058
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4059,
            4095
        ],
        "disallowed"
    ],
    [
        [
            4096,
            4129
        ],
        "valid"
    ],
    [
        [
            4130,
            4130
        ],
        "valid"
    ],
    [
        [
            4131,
            4135
        ],
        "valid"
    ],
    [
        [
            4136,
            4136
        ],
        "valid"
    ],
    [
        [
            4137,
            4138
        ],
        "valid"
    ],
    [
        [
            4139,
            4139
        ],
        "valid"
    ],
    [
        [
            4140,
            4146
        ],
        "valid"
    ],
    [
        [
            4147,
            4149
        ],
        "valid"
    ],
    [
        [
            4150,
            4153
        ],
        "valid"
    ],
    [
        [
            4154,
            4159
        ],
        "valid"
    ],
    [
        [
            4160,
            4169
        ],
        "valid"
    ],
    [
        [
            4170,
            4175
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4176,
            4185
        ],
        "valid"
    ],
    [
        [
            4186,
            4249
        ],
        "valid"
    ],
    [
        [
            4250,
            4253
        ],
        "valid"
    ],
    [
        [
            4254,
            4255
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4256,
            4293
        ],
        "disallowed"
    ],
    [
        [
            4294,
            4294
        ],
        "disallowed"
    ],
    [
        [
            4295,
            4295
        ],
        "mapped",
        [
            11559
        ]
    ],
    [
        [
            4296,
            4300
        ],
        "disallowed"
    ],
    [
        [
            4301,
            4301
        ],
        "mapped",
        [
            11565
        ]
    ],
    [
        [
            4302,
            4303
        ],
        "disallowed"
    ],
    [
        [
            4304,
            4342
        ],
        "valid"
    ],
    [
        [
            4343,
            4344
        ],
        "valid"
    ],
    [
        [
            4345,
            4346
        ],
        "valid"
    ],
    [
        [
            4347,
            4347
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4348,
            4348
        ],
        "mapped",
        [
            4316
        ]
    ],
    [
        [
            4349,
            4351
        ],
        "valid"
    ],
    [
        [
            4352,
            4441
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4442,
            4446
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4447,
            4448
        ],
        "disallowed"
    ],
    [
        [
            4449,
            4514
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4515,
            4519
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4520,
            4601
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4602,
            4607
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4608,
            4614
        ],
        "valid"
    ],
    [
        [
            4615,
            4615
        ],
        "valid"
    ],
    [
        [
            4616,
            4678
        ],
        "valid"
    ],
    [
        [
            4679,
            4679
        ],
        "valid"
    ],
    [
        [
            4680,
            4680
        ],
        "valid"
    ],
    [
        [
            4681,
            4681
        ],
        "disallowed"
    ],
    [
        [
            4682,
            4685
        ],
        "valid"
    ],
    [
        [
            4686,
            4687
        ],
        "disallowed"
    ],
    [
        [
            4688,
            4694
        ],
        "valid"
    ],
    [
        [
            4695,
            4695
        ],
        "disallowed"
    ],
    [
        [
            4696,
            4696
        ],
        "valid"
    ],
    [
        [
            4697,
            4697
        ],
        "disallowed"
    ],
    [
        [
            4698,
            4701
        ],
        "valid"
    ],
    [
        [
            4702,
            4703
        ],
        "disallowed"
    ],
    [
        [
            4704,
            4742
        ],
        "valid"
    ],
    [
        [
            4743,
            4743
        ],
        "valid"
    ],
    [
        [
            4744,
            4744
        ],
        "valid"
    ],
    [
        [
            4745,
            4745
        ],
        "disallowed"
    ],
    [
        [
            4746,
            4749
        ],
        "valid"
    ],
    [
        [
            4750,
            4751
        ],
        "disallowed"
    ],
    [
        [
            4752,
            4782
        ],
        "valid"
    ],
    [
        [
            4783,
            4783
        ],
        "valid"
    ],
    [
        [
            4784,
            4784
        ],
        "valid"
    ],
    [
        [
            4785,
            4785
        ],
        "disallowed"
    ],
    [
        [
            4786,
            4789
        ],
        "valid"
    ],
    [
        [
            4790,
            4791
        ],
        "disallowed"
    ],
    [
        [
            4792,
            4798
        ],
        "valid"
    ],
    [
        [
            4799,
            4799
        ],
        "disallowed"
    ],
    [
        [
            4800,
            4800
        ],
        "valid"
    ],
    [
        [
            4801,
            4801
        ],
        "disallowed"
    ],
    [
        [
            4802,
            4805
        ],
        "valid"
    ],
    [
        [
            4806,
            4807
        ],
        "disallowed"
    ],
    [
        [
            4808,
            4814
        ],
        "valid"
    ],
    [
        [
            4815,
            4815
        ],
        "valid"
    ],
    [
        [
            4816,
            4822
        ],
        "valid"
    ],
    [
        [
            4823,
            4823
        ],
        "disallowed"
    ],
    [
        [
            4824,
            4846
        ],
        "valid"
    ],
    [
        [
            4847,
            4847
        ],
        "valid"
    ],
    [
        [
            4848,
            4878
        ],
        "valid"
    ],
    [
        [
            4879,
            4879
        ],
        "valid"
    ],
    [
        [
            4880,
            4880
        ],
        "valid"
    ],
    [
        [
            4881,
            4881
        ],
        "disallowed"
    ],
    [
        [
            4882,
            4885
        ],
        "valid"
    ],
    [
        [
            4886,
            4887
        ],
        "disallowed"
    ],
    [
        [
            4888,
            4894
        ],
        "valid"
    ],
    [
        [
            4895,
            4895
        ],
        "valid"
    ],
    [
        [
            4896,
            4934
        ],
        "valid"
    ],
    [
        [
            4935,
            4935
        ],
        "valid"
    ],
    [
        [
            4936,
            4954
        ],
        "valid"
    ],
    [
        [
            4955,
            4956
        ],
        "disallowed"
    ],
    [
        [
            4957,
            4958
        ],
        "valid"
    ],
    [
        [
            4959,
            4959
        ],
        "valid"
    ],
    [
        [
            4960,
            4960
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4961,
            4988
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            4989,
            4991
        ],
        "disallowed"
    ],
    [
        [
            4992,
            5007
        ],
        "valid"
    ],
    [
        [
            5008,
            5017
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            5018,
            5023
        ],
        "disallowed"
    ],
    [
        [
            5024,
            5108
        ],
        "valid"
    ],
    [
        [
            5109,
            5109
        ],
        "valid"
    ],
    [
        [
            5110,
            5111
        ],
        "disallowed"
    ],
    [
        [
            5112,
            5112
        ],
        "mapped",
        [
            5104
        ]
    ],
    [
        [
            5113,
            5113
        ],
        "mapped",
        [
            5105
        ]
    ],
    [
        [
            5114,
            5114
        ],
        "mapped",
        [
            5106
        ]
    ],
    [
        [
            5115,
            5115
        ],
        "mapped",
        [
            5107
        ]
    ],
    [
        [
            5116,
            5116
        ],
        "mapped",
        [
            5108
        ]
    ],
    [
        [
            5117,
            5117
        ],
        "mapped",
        [
            5109
        ]
    ],
    [
        [
            5118,
            5119
        ],
        "disallowed"
    ],
    [
        [
            5120,
            5120
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            5121,
            5740
        ],
        "valid"
    ],
    [
        [
            5741,
            5742
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            5743,
            5750
        ],
        "valid"
    ],
    [
        [
            5751,
            5759
        ],
        "valid"
    ],
    [
        [
            5760,
            5760
        ],
        "disallowed"
    ],
    [
        [
            5761,
            5786
        ],
        "valid"
    ],
    [
        [
            5787,
            5788
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            5789,
            5791
        ],
        "disallowed"
    ],
    [
        [
            5792,
            5866
        ],
        "valid"
    ],
    [
        [
            5867,
            5872
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            5873,
            5880
        ],
        "valid"
    ],
    [
        [
            5881,
            5887
        ],
        "disallowed"
    ],
    [
        [
            5888,
            5900
        ],
        "valid"
    ],
    [
        [
            5901,
            5901
        ],
        "disallowed"
    ],
    [
        [
            5902,
            5908
        ],
        "valid"
    ],
    [
        [
            5909,
            5919
        ],
        "disallowed"
    ],
    [
        [
            5920,
            5940
        ],
        "valid"
    ],
    [
        [
            5941,
            5942
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            5943,
            5951
        ],
        "disallowed"
    ],
    [
        [
            5952,
            5971
        ],
        "valid"
    ],
    [
        [
            5972,
            5983
        ],
        "disallowed"
    ],
    [
        [
            5984,
            5996
        ],
        "valid"
    ],
    [
        [
            5997,
            5997
        ],
        "disallowed"
    ],
    [
        [
            5998,
            6000
        ],
        "valid"
    ],
    [
        [
            6001,
            6001
        ],
        "disallowed"
    ],
    [
        [
            6002,
            6003
        ],
        "valid"
    ],
    [
        [
            6004,
            6015
        ],
        "disallowed"
    ],
    [
        [
            6016,
            6067
        ],
        "valid"
    ],
    [
        [
            6068,
            6069
        ],
        "disallowed"
    ],
    [
        [
            6070,
            6099
        ],
        "valid"
    ],
    [
        [
            6100,
            6102
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            6103,
            6103
        ],
        "valid"
    ],
    [
        [
            6104,
            6107
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            6108,
            6108
        ],
        "valid"
    ],
    [
        [
            6109,
            6109
        ],
        "valid"
    ],
    [
        [
            6110,
            6111
        ],
        "disallowed"
    ],
    [
        [
            6112,
            6121
        ],
        "valid"
    ],
    [
        [
            6122,
            6127
        ],
        "disallowed"
    ],
    [
        [
            6128,
            6137
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            6138,
            6143
        ],
        "disallowed"
    ],
    [
        [
            6144,
            6149
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            6150,
            6150
        ],
        "disallowed"
    ],
    [
        [
            6151,
            6154
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            6155,
            6157
        ],
        "ignored"
    ],
    [
        [
            6158,
            6158
        ],
        "disallowed"
    ],
    [
        [
            6159,
            6159
        ],
        "disallowed"
    ],
    [
        [
            6160,
            6169
        ],
        "valid"
    ],
    [
        [
            6170,
            6175
        ],
        "disallowed"
    ],
    [
        [
            6176,
            6263
        ],
        "valid"
    ],
    [
        [
            6264,
            6271
        ],
        "disallowed"
    ],
    [
        [
            6272,
            6313
        ],
        "valid"
    ],
    [
        [
            6314,
            6314
        ],
        "valid"
    ],
    [
        [
            6315,
            6319
        ],
        "disallowed"
    ],
    [
        [
            6320,
            6389
        ],
        "valid"
    ],
    [
        [
            6390,
            6399
        ],
        "disallowed"
    ],
    [
        [
            6400,
            6428
        ],
        "valid"
    ],
    [
        [
            6429,
            6430
        ],
        "valid"
    ],
    [
        [
            6431,
            6431
        ],
        "disallowed"
    ],
    [
        [
            6432,
            6443
        ],
        "valid"
    ],
    [
        [
            6444,
            6447
        ],
        "disallowed"
    ],
    [
        [
            6448,
            6459
        ],
        "valid"
    ],
    [
        [
            6460,
            6463
        ],
        "disallowed"
    ],
    [
        [
            6464,
            6464
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            6465,
            6467
        ],
        "disallowed"
    ],
    [
        [
            6468,
            6469
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            6470,
            6509
        ],
        "valid"
    ],
    [
        [
            6510,
            6511
        ],
        "disallowed"
    ],
    [
        [
            6512,
            6516
        ],
        "valid"
    ],
    [
        [
            6517,
            6527
        ],
        "disallowed"
    ],
    [
        [
            6528,
            6569
        ],
        "valid"
    ],
    [
        [
            6570,
            6571
        ],
        "valid"
    ],
    [
        [
            6572,
            6575
        ],
        "disallowed"
    ],
    [
        [
            6576,
            6601
        ],
        "valid"
    ],
    [
        [
            6602,
            6607
        ],
        "disallowed"
    ],
    [
        [
            6608,
            6617
        ],
        "valid"
    ],
    [
        [
            6618,
            6618
        ],
        "valid",
        [],
        "XV8"
    ],
    [
        [
            6619,
            6621
        ],
        "disallowed"
    ],
    [
        [
            6622,
            6623
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            6624,
            6655
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            6656,
            6683
        ],
        "valid"
    ],
    [
        [
            6684,
            6685
        ],
        "disallowed"
    ],
    [
        [
            6686,
            6687
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            6688,
            6750
        ],
        "valid"
    ],
    [
        [
            6751,
            6751
        ],
        "disallowed"
    ],
    [
        [
            6752,
            6780
        ],
        "valid"
    ],
    [
        [
            6781,
            6782
        ],
        "disallowed"
    ],
    [
        [
            6783,
            6793
        ],
        "valid"
    ],
    [
        [
            6794,
            6799
        ],
        "disallowed"
    ],
    [
        [
            6800,
            6809
        ],
        "valid"
    ],
    [
        [
            6810,
            6815
        ],
        "disallowed"
    ],
    [
        [
            6816,
            6822
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            6823,
            6823
        ],
        "valid"
    ],
    [
        [
            6824,
            6829
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            6830,
            6831
        ],
        "disallowed"
    ],
    [
        [
            6832,
            6845
        ],
        "valid"
    ],
    [
        [
            6846,
            6846
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            6847,
            6911
        ],
        "disallowed"
    ],
    [
        [
            6912,
            6987
        ],
        "valid"
    ],
    [
        [
            6988,
            6991
        ],
        "disallowed"
    ],
    [
        [
            6992,
            7001
        ],
        "valid"
    ],
    [
        [
            7002,
            7018
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            7019,
            7027
        ],
        "valid"
    ],
    [
        [
            7028,
            7036
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            7037,
            7039
        ],
        "disallowed"
    ],
    [
        [
            7040,
            7082
        ],
        "valid"
    ],
    [
        [
            7083,
            7085
        ],
        "valid"
    ],
    [
        [
            7086,
            7097
        ],
        "valid"
    ],
    [
        [
            7098,
            7103
        ],
        "valid"
    ],
    [
        [
            7104,
            7155
        ],
        "valid"
    ],
    [
        [
            7156,
            7163
        ],
        "disallowed"
    ],
    [
        [
            7164,
            7167
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            7168,
            7223
        ],
        "valid"
    ],
    [
        [
            7224,
            7226
        ],
        "disallowed"
    ],
    [
        [
            7227,
            7231
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            7232,
            7241
        ],
        "valid"
    ],
    [
        [
            7242,
            7244
        ],
        "disallowed"
    ],
    [
        [
            7245,
            7293
        ],
        "valid"
    ],
    [
        [
            7294,
            7295
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            7296,
            7359
        ],
        "disallowed"
    ],
    [
        [
            7360,
            7367
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            7368,
            7375
        ],
        "disallowed"
    ],
    [
        [
            7376,
            7378
        ],
        "valid"
    ],
    [
        [
            7379,
            7379
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            7380,
            7410
        ],
        "valid"
    ],
    [
        [
            7411,
            7414
        ],
        "valid"
    ],
    [
        [
            7415,
            7415
        ],
        "disallowed"
    ],
    [
        [
            7416,
            7417
        ],
        "valid"
    ],
    [
        [
            7418,
            7423
        ],
        "disallowed"
    ],
    [
        [
            7424,
            7467
        ],
        "valid"
    ],
    [
        [
            7468,
            7468
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            7469,
            7469
        ],
        "mapped",
        [
            230
        ]
    ],
    [
        [
            7470,
            7470
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            7471,
            7471
        ],
        "valid"
    ],
    [
        [
            7472,
            7472
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            7473,
            7473
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            7474,
            7474
        ],
        "mapped",
        [
            477
        ]
    ],
    [
        [
            7475,
            7475
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            7476,
            7476
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            7477,
            7477
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            7478,
            7478
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            7479,
            7479
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            7480,
            7480
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            7481,
            7481
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            7482,
            7482
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            7483,
            7483
        ],
        "valid"
    ],
    [
        [
            7484,
            7484
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            7485,
            7485
        ],
        "mapped",
        [
            547
        ]
    ],
    [
        [
            7486,
            7486
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            7487,
            7487
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            7488,
            7488
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            7489,
            7489
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            7490,
            7490
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            7491,
            7491
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            7492,
            7492
        ],
        "mapped",
        [
            592
        ]
    ],
    [
        [
            7493,
            7493
        ],
        "mapped",
        [
            593
        ]
    ],
    [
        [
            7494,
            7494
        ],
        "mapped",
        [
            7426
        ]
    ],
    [
        [
            7495,
            7495
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            7496,
            7496
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            7497,
            7497
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            7498,
            7498
        ],
        "mapped",
        [
            601
        ]
    ],
    [
        [
            7499,
            7499
        ],
        "mapped",
        [
            603
        ]
    ],
    [
        [
            7500,
            7500
        ],
        "mapped",
        [
            604
        ]
    ],
    [
        [
            7501,
            7501
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            7502,
            7502
        ],
        "valid"
    ],
    [
        [
            7503,
            7503
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            7504,
            7504
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            7505,
            7505
        ],
        "mapped",
        [
            331
        ]
    ],
    [
        [
            7506,
            7506
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            7507,
            7507
        ],
        "mapped",
        [
            596
        ]
    ],
    [
        [
            7508,
            7508
        ],
        "mapped",
        [
            7446
        ]
    ],
    [
        [
            7509,
            7509
        ],
        "mapped",
        [
            7447
        ]
    ],
    [
        [
            7510,
            7510
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            7511,
            7511
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            7512,
            7512
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            7513,
            7513
        ],
        "mapped",
        [
            7453
        ]
    ],
    [
        [
            7514,
            7514
        ],
        "mapped",
        [
            623
        ]
    ],
    [
        [
            7515,
            7515
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            7516,
            7516
        ],
        "mapped",
        [
            7461
        ]
    ],
    [
        [
            7517,
            7517
        ],
        "mapped",
        [
            946
        ]
    ],
    [
        [
            7518,
            7518
        ],
        "mapped",
        [
            947
        ]
    ],
    [
        [
            7519,
            7519
        ],
        "mapped",
        [
            948
        ]
    ],
    [
        [
            7520,
            7520
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            7521,
            7521
        ],
        "mapped",
        [
            967
        ]
    ],
    [
        [
            7522,
            7522
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            7523,
            7523
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            7524,
            7524
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            7525,
            7525
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            7526,
            7526
        ],
        "mapped",
        [
            946
        ]
    ],
    [
        [
            7527,
            7527
        ],
        "mapped",
        [
            947
        ]
    ],
    [
        [
            7528,
            7528
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            7529,
            7529
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            7530,
            7530
        ],
        "mapped",
        [
            967
        ]
    ],
    [
        [
            7531,
            7531
        ],
        "valid"
    ],
    [
        [
            7532,
            7543
        ],
        "valid"
    ],
    [
        [
            7544,
            7544
        ],
        "mapped",
        [
            1085
        ]
    ],
    [
        [
            7545,
            7578
        ],
        "valid"
    ],
    [
        [
            7579,
            7579
        ],
        "mapped",
        [
            594
        ]
    ],
    [
        [
            7580,
            7580
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            7581,
            7581
        ],
        "mapped",
        [
            597
        ]
    ],
    [
        [
            7582,
            7582
        ],
        "mapped",
        [
            240
        ]
    ],
    [
        [
            7583,
            7583
        ],
        "mapped",
        [
            604
        ]
    ],
    [
        [
            7584,
            7584
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            7585,
            7585
        ],
        "mapped",
        [
            607
        ]
    ],
    [
        [
            7586,
            7586
        ],
        "mapped",
        [
            609
        ]
    ],
    [
        [
            7587,
            7587
        ],
        "mapped",
        [
            613
        ]
    ],
    [
        [
            7588,
            7588
        ],
        "mapped",
        [
            616
        ]
    ],
    [
        [
            7589,
            7589
        ],
        "mapped",
        [
            617
        ]
    ],
    [
        [
            7590,
            7590
        ],
        "mapped",
        [
            618
        ]
    ],
    [
        [
            7591,
            7591
        ],
        "mapped",
        [
            7547
        ]
    ],
    [
        [
            7592,
            7592
        ],
        "mapped",
        [
            669
        ]
    ],
    [
        [
            7593,
            7593
        ],
        "mapped",
        [
            621
        ]
    ],
    [
        [
            7594,
            7594
        ],
        "mapped",
        [
            7557
        ]
    ],
    [
        [
            7595,
            7595
        ],
        "mapped",
        [
            671
        ]
    ],
    [
        [
            7596,
            7596
        ],
        "mapped",
        [
            625
        ]
    ],
    [
        [
            7597,
            7597
        ],
        "mapped",
        [
            624
        ]
    ],
    [
        [
            7598,
            7598
        ],
        "mapped",
        [
            626
        ]
    ],
    [
        [
            7599,
            7599
        ],
        "mapped",
        [
            627
        ]
    ],
    [
        [
            7600,
            7600
        ],
        "mapped",
        [
            628
        ]
    ],
    [
        [
            7601,
            7601
        ],
        "mapped",
        [
            629
        ]
    ],
    [
        [
            7602,
            7602
        ],
        "mapped",
        [
            632
        ]
    ],
    [
        [
            7603,
            7603
        ],
        "mapped",
        [
            642
        ]
    ],
    [
        [
            7604,
            7604
        ],
        "mapped",
        [
            643
        ]
    ],
    [
        [
            7605,
            7605
        ],
        "mapped",
        [
            427
        ]
    ],
    [
        [
            7606,
            7606
        ],
        "mapped",
        [
            649
        ]
    ],
    [
        [
            7607,
            7607
        ],
        "mapped",
        [
            650
        ]
    ],
    [
        [
            7608,
            7608
        ],
        "mapped",
        [
            7452
        ]
    ],
    [
        [
            7609,
            7609
        ],
        "mapped",
        [
            651
        ]
    ],
    [
        [
            7610,
            7610
        ],
        "mapped",
        [
            652
        ]
    ],
    [
        [
            7611,
            7611
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            7612,
            7612
        ],
        "mapped",
        [
            656
        ]
    ],
    [
        [
            7613,
            7613
        ],
        "mapped",
        [
            657
        ]
    ],
    [
        [
            7614,
            7614
        ],
        "mapped",
        [
            658
        ]
    ],
    [
        [
            7615,
            7615
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            7616,
            7619
        ],
        "valid"
    ],
    [
        [
            7620,
            7626
        ],
        "valid"
    ],
    [
        [
            7627,
            7654
        ],
        "valid"
    ],
    [
        [
            7655,
            7669
        ],
        "valid"
    ],
    [
        [
            7670,
            7675
        ],
        "disallowed"
    ],
    [
        [
            7676,
            7676
        ],
        "valid"
    ],
    [
        [
            7677,
            7677
        ],
        "valid"
    ],
    [
        [
            7678,
            7679
        ],
        "valid"
    ],
    [
        [
            7680,
            7680
        ],
        "mapped",
        [
            7681
        ]
    ],
    [
        [
            7681,
            7681
        ],
        "valid"
    ],
    [
        [
            7682,
            7682
        ],
        "mapped",
        [
            7683
        ]
    ],
    [
        [
            7683,
            7683
        ],
        "valid"
    ],
    [
        [
            7684,
            7684
        ],
        "mapped",
        [
            7685
        ]
    ],
    [
        [
            7685,
            7685
        ],
        "valid"
    ],
    [
        [
            7686,
            7686
        ],
        "mapped",
        [
            7687
        ]
    ],
    [
        [
            7687,
            7687
        ],
        "valid"
    ],
    [
        [
            7688,
            7688
        ],
        "mapped",
        [
            7689
        ]
    ],
    [
        [
            7689,
            7689
        ],
        "valid"
    ],
    [
        [
            7690,
            7690
        ],
        "mapped",
        [
            7691
        ]
    ],
    [
        [
            7691,
            7691
        ],
        "valid"
    ],
    [
        [
            7692,
            7692
        ],
        "mapped",
        [
            7693
        ]
    ],
    [
        [
            7693,
            7693
        ],
        "valid"
    ],
    [
        [
            7694,
            7694
        ],
        "mapped",
        [
            7695
        ]
    ],
    [
        [
            7695,
            7695
        ],
        "valid"
    ],
    [
        [
            7696,
            7696
        ],
        "mapped",
        [
            7697
        ]
    ],
    [
        [
            7697,
            7697
        ],
        "valid"
    ],
    [
        [
            7698,
            7698
        ],
        "mapped",
        [
            7699
        ]
    ],
    [
        [
            7699,
            7699
        ],
        "valid"
    ],
    [
        [
            7700,
            7700
        ],
        "mapped",
        [
            7701
        ]
    ],
    [
        [
            7701,
            7701
        ],
        "valid"
    ],
    [
        [
            7702,
            7702
        ],
        "mapped",
        [
            7703
        ]
    ],
    [
        [
            7703,
            7703
        ],
        "valid"
    ],
    [
        [
            7704,
            7704
        ],
        "mapped",
        [
            7705
        ]
    ],
    [
        [
            7705,
            7705
        ],
        "valid"
    ],
    [
        [
            7706,
            7706
        ],
        "mapped",
        [
            7707
        ]
    ],
    [
        [
            7707,
            7707
        ],
        "valid"
    ],
    [
        [
            7708,
            7708
        ],
        "mapped",
        [
            7709
        ]
    ],
    [
        [
            7709,
            7709
        ],
        "valid"
    ],
    [
        [
            7710,
            7710
        ],
        "mapped",
        [
            7711
        ]
    ],
    [
        [
            7711,
            7711
        ],
        "valid"
    ],
    [
        [
            7712,
            7712
        ],
        "mapped",
        [
            7713
        ]
    ],
    [
        [
            7713,
            7713
        ],
        "valid"
    ],
    [
        [
            7714,
            7714
        ],
        "mapped",
        [
            7715
        ]
    ],
    [
        [
            7715,
            7715
        ],
        "valid"
    ],
    [
        [
            7716,
            7716
        ],
        "mapped",
        [
            7717
        ]
    ],
    [
        [
            7717,
            7717
        ],
        "valid"
    ],
    [
        [
            7718,
            7718
        ],
        "mapped",
        [
            7719
        ]
    ],
    [
        [
            7719,
            7719
        ],
        "valid"
    ],
    [
        [
            7720,
            7720
        ],
        "mapped",
        [
            7721
        ]
    ],
    [
        [
            7721,
            7721
        ],
        "valid"
    ],
    [
        [
            7722,
            7722
        ],
        "mapped",
        [
            7723
        ]
    ],
    [
        [
            7723,
            7723
        ],
        "valid"
    ],
    [
        [
            7724,
            7724
        ],
        "mapped",
        [
            7725
        ]
    ],
    [
        [
            7725,
            7725
        ],
        "valid"
    ],
    [
        [
            7726,
            7726
        ],
        "mapped",
        [
            7727
        ]
    ],
    [
        [
            7727,
            7727
        ],
        "valid"
    ],
    [
        [
            7728,
            7728
        ],
        "mapped",
        [
            7729
        ]
    ],
    [
        [
            7729,
            7729
        ],
        "valid"
    ],
    [
        [
            7730,
            7730
        ],
        "mapped",
        [
            7731
        ]
    ],
    [
        [
            7731,
            7731
        ],
        "valid"
    ],
    [
        [
            7732,
            7732
        ],
        "mapped",
        [
            7733
        ]
    ],
    [
        [
            7733,
            7733
        ],
        "valid"
    ],
    [
        [
            7734,
            7734
        ],
        "mapped",
        [
            7735
        ]
    ],
    [
        [
            7735,
            7735
        ],
        "valid"
    ],
    [
        [
            7736,
            7736
        ],
        "mapped",
        [
            7737
        ]
    ],
    [
        [
            7737,
            7737
        ],
        "valid"
    ],
    [
        [
            7738,
            7738
        ],
        "mapped",
        [
            7739
        ]
    ],
    [
        [
            7739,
            7739
        ],
        "valid"
    ],
    [
        [
            7740,
            7740
        ],
        "mapped",
        [
            7741
        ]
    ],
    [
        [
            7741,
            7741
        ],
        "valid"
    ],
    [
        [
            7742,
            7742
        ],
        "mapped",
        [
            7743
        ]
    ],
    [
        [
            7743,
            7743
        ],
        "valid"
    ],
    [
        [
            7744,
            7744
        ],
        "mapped",
        [
            7745
        ]
    ],
    [
        [
            7745,
            7745
        ],
        "valid"
    ],
    [
        [
            7746,
            7746
        ],
        "mapped",
        [
            7747
        ]
    ],
    [
        [
            7747,
            7747
        ],
        "valid"
    ],
    [
        [
            7748,
            7748
        ],
        "mapped",
        [
            7749
        ]
    ],
    [
        [
            7749,
            7749
        ],
        "valid"
    ],
    [
        [
            7750,
            7750
        ],
        "mapped",
        [
            7751
        ]
    ],
    [
        [
            7751,
            7751
        ],
        "valid"
    ],
    [
        [
            7752,
            7752
        ],
        "mapped",
        [
            7753
        ]
    ],
    [
        [
            7753,
            7753
        ],
        "valid"
    ],
    [
        [
            7754,
            7754
        ],
        "mapped",
        [
            7755
        ]
    ],
    [
        [
            7755,
            7755
        ],
        "valid"
    ],
    [
        [
            7756,
            7756
        ],
        "mapped",
        [
            7757
        ]
    ],
    [
        [
            7757,
            7757
        ],
        "valid"
    ],
    [
        [
            7758,
            7758
        ],
        "mapped",
        [
            7759
        ]
    ],
    [
        [
            7759,
            7759
        ],
        "valid"
    ],
    [
        [
            7760,
            7760
        ],
        "mapped",
        [
            7761
        ]
    ],
    [
        [
            7761,
            7761
        ],
        "valid"
    ],
    [
        [
            7762,
            7762
        ],
        "mapped",
        [
            7763
        ]
    ],
    [
        [
            7763,
            7763
        ],
        "valid"
    ],
    [
        [
            7764,
            7764
        ],
        "mapped",
        [
            7765
        ]
    ],
    [
        [
            7765,
            7765
        ],
        "valid"
    ],
    [
        [
            7766,
            7766
        ],
        "mapped",
        [
            7767
        ]
    ],
    [
        [
            7767,
            7767
        ],
        "valid"
    ],
    [
        [
            7768,
            7768
        ],
        "mapped",
        [
            7769
        ]
    ],
    [
        [
            7769,
            7769
        ],
        "valid"
    ],
    [
        [
            7770,
            7770
        ],
        "mapped",
        [
            7771
        ]
    ],
    [
        [
            7771,
            7771
        ],
        "valid"
    ],
    [
        [
            7772,
            7772
        ],
        "mapped",
        [
            7773
        ]
    ],
    [
        [
            7773,
            7773
        ],
        "valid"
    ],
    [
        [
            7774,
            7774
        ],
        "mapped",
        [
            7775
        ]
    ],
    [
        [
            7775,
            7775
        ],
        "valid"
    ],
    [
        [
            7776,
            7776
        ],
        "mapped",
        [
            7777
        ]
    ],
    [
        [
            7777,
            7777
        ],
        "valid"
    ],
    [
        [
            7778,
            7778
        ],
        "mapped",
        [
            7779
        ]
    ],
    [
        [
            7779,
            7779
        ],
        "valid"
    ],
    [
        [
            7780,
            7780
        ],
        "mapped",
        [
            7781
        ]
    ],
    [
        [
            7781,
            7781
        ],
        "valid"
    ],
    [
        [
            7782,
            7782
        ],
        "mapped",
        [
            7783
        ]
    ],
    [
        [
            7783,
            7783
        ],
        "valid"
    ],
    [
        [
            7784,
            7784
        ],
        "mapped",
        [
            7785
        ]
    ],
    [
        [
            7785,
            7785
        ],
        "valid"
    ],
    [
        [
            7786,
            7786
        ],
        "mapped",
        [
            7787
        ]
    ],
    [
        [
            7787,
            7787
        ],
        "valid"
    ],
    [
        [
            7788,
            7788
        ],
        "mapped",
        [
            7789
        ]
    ],
    [
        [
            7789,
            7789
        ],
        "valid"
    ],
    [
        [
            7790,
            7790
        ],
        "mapped",
        [
            7791
        ]
    ],
    [
        [
            7791,
            7791
        ],
        "valid"
    ],
    [
        [
            7792,
            7792
        ],
        "mapped",
        [
            7793
        ]
    ],
    [
        [
            7793,
            7793
        ],
        "valid"
    ],
    [
        [
            7794,
            7794
        ],
        "mapped",
        [
            7795
        ]
    ],
    [
        [
            7795,
            7795
        ],
        "valid"
    ],
    [
        [
            7796,
            7796
        ],
        "mapped",
        [
            7797
        ]
    ],
    [
        [
            7797,
            7797
        ],
        "valid"
    ],
    [
        [
            7798,
            7798
        ],
        "mapped",
        [
            7799
        ]
    ],
    [
        [
            7799,
            7799
        ],
        "valid"
    ],
    [
        [
            7800,
            7800
        ],
        "mapped",
        [
            7801
        ]
    ],
    [
        [
            7801,
            7801
        ],
        "valid"
    ],
    [
        [
            7802,
            7802
        ],
        "mapped",
        [
            7803
        ]
    ],
    [
        [
            7803,
            7803
        ],
        "valid"
    ],
    [
        [
            7804,
            7804
        ],
        "mapped",
        [
            7805
        ]
    ],
    [
        [
            7805,
            7805
        ],
        "valid"
    ],
    [
        [
            7806,
            7806
        ],
        "mapped",
        [
            7807
        ]
    ],
    [
        [
            7807,
            7807
        ],
        "valid"
    ],
    [
        [
            7808,
            7808
        ],
        "mapped",
        [
            7809
        ]
    ],
    [
        [
            7809,
            7809
        ],
        "valid"
    ],
    [
        [
            7810,
            7810
        ],
        "mapped",
        [
            7811
        ]
    ],
    [
        [
            7811,
            7811
        ],
        "valid"
    ],
    [
        [
            7812,
            7812
        ],
        "mapped",
        [
            7813
        ]
    ],
    [
        [
            7813,
            7813
        ],
        "valid"
    ],
    [
        [
            7814,
            7814
        ],
        "mapped",
        [
            7815
        ]
    ],
    [
        [
            7815,
            7815
        ],
        "valid"
    ],
    [
        [
            7816,
            7816
        ],
        "mapped",
        [
            7817
        ]
    ],
    [
        [
            7817,
            7817
        ],
        "valid"
    ],
    [
        [
            7818,
            7818
        ],
        "mapped",
        [
            7819
        ]
    ],
    [
        [
            7819,
            7819
        ],
        "valid"
    ],
    [
        [
            7820,
            7820
        ],
        "mapped",
        [
            7821
        ]
    ],
    [
        [
            7821,
            7821
        ],
        "valid"
    ],
    [
        [
            7822,
            7822
        ],
        "mapped",
        [
            7823
        ]
    ],
    [
        [
            7823,
            7823
        ],
        "valid"
    ],
    [
        [
            7824,
            7824
        ],
        "mapped",
        [
            7825
        ]
    ],
    [
        [
            7825,
            7825
        ],
        "valid"
    ],
    [
        [
            7826,
            7826
        ],
        "mapped",
        [
            7827
        ]
    ],
    [
        [
            7827,
            7827
        ],
        "valid"
    ],
    [
        [
            7828,
            7828
        ],
        "mapped",
        [
            7829
        ]
    ],
    [
        [
            7829,
            7833
        ],
        "valid"
    ],
    [
        [
            7834,
            7834
        ],
        "mapped",
        [
            97,
            702
        ]
    ],
    [
        [
            7835,
            7835
        ],
        "mapped",
        [
            7777
        ]
    ],
    [
        [
            7836,
            7837
        ],
        "valid"
    ],
    [
        [
            7838,
            7838
        ],
        "mapped",
        [
            115,
            115
        ]
    ],
    [
        [
            7839,
            7839
        ],
        "valid"
    ],
    [
        [
            7840,
            7840
        ],
        "mapped",
        [
            7841
        ]
    ],
    [
        [
            7841,
            7841
        ],
        "valid"
    ],
    [
        [
            7842,
            7842
        ],
        "mapped",
        [
            7843
        ]
    ],
    [
        [
            7843,
            7843
        ],
        "valid"
    ],
    [
        [
            7844,
            7844
        ],
        "mapped",
        [
            7845
        ]
    ],
    [
        [
            7845,
            7845
        ],
        "valid"
    ],
    [
        [
            7846,
            7846
        ],
        "mapped",
        [
            7847
        ]
    ],
    [
        [
            7847,
            7847
        ],
        "valid"
    ],
    [
        [
            7848,
            7848
        ],
        "mapped",
        [
            7849
        ]
    ],
    [
        [
            7849,
            7849
        ],
        "valid"
    ],
    [
        [
            7850,
            7850
        ],
        "mapped",
        [
            7851
        ]
    ],
    [
        [
            7851,
            7851
        ],
        "valid"
    ],
    [
        [
            7852,
            7852
        ],
        "mapped",
        [
            7853
        ]
    ],
    [
        [
            7853,
            7853
        ],
        "valid"
    ],
    [
        [
            7854,
            7854
        ],
        "mapped",
        [
            7855
        ]
    ],
    [
        [
            7855,
            7855
        ],
        "valid"
    ],
    [
        [
            7856,
            7856
        ],
        "mapped",
        [
            7857
        ]
    ],
    [
        [
            7857,
            7857
        ],
        "valid"
    ],
    [
        [
            7858,
            7858
        ],
        "mapped",
        [
            7859
        ]
    ],
    [
        [
            7859,
            7859
        ],
        "valid"
    ],
    [
        [
            7860,
            7860
        ],
        "mapped",
        [
            7861
        ]
    ],
    [
        [
            7861,
            7861
        ],
        "valid"
    ],
    [
        [
            7862,
            7862
        ],
        "mapped",
        [
            7863
        ]
    ],
    [
        [
            7863,
            7863
        ],
        "valid"
    ],
    [
        [
            7864,
            7864
        ],
        "mapped",
        [
            7865
        ]
    ],
    [
        [
            7865,
            7865
        ],
        "valid"
    ],
    [
        [
            7866,
            7866
        ],
        "mapped",
        [
            7867
        ]
    ],
    [
        [
            7867,
            7867
        ],
        "valid"
    ],
    [
        [
            7868,
            7868
        ],
        "mapped",
        [
            7869
        ]
    ],
    [
        [
            7869,
            7869
        ],
        "valid"
    ],
    [
        [
            7870,
            7870
        ],
        "mapped",
        [
            7871
        ]
    ],
    [
        [
            7871,
            7871
        ],
        "valid"
    ],
    [
        [
            7872,
            7872
        ],
        "mapped",
        [
            7873
        ]
    ],
    [
        [
            7873,
            7873
        ],
        "valid"
    ],
    [
        [
            7874,
            7874
        ],
        "mapped",
        [
            7875
        ]
    ],
    [
        [
            7875,
            7875
        ],
        "valid"
    ],
    [
        [
            7876,
            7876
        ],
        "mapped",
        [
            7877
        ]
    ],
    [
        [
            7877,
            7877
        ],
        "valid"
    ],
    [
        [
            7878,
            7878
        ],
        "mapped",
        [
            7879
        ]
    ],
    [
        [
            7879,
            7879
        ],
        "valid"
    ],
    [
        [
            7880,
            7880
        ],
        "mapped",
        [
            7881
        ]
    ],
    [
        [
            7881,
            7881
        ],
        "valid"
    ],
    [
        [
            7882,
            7882
        ],
        "mapped",
        [
            7883
        ]
    ],
    [
        [
            7883,
            7883
        ],
        "valid"
    ],
    [
        [
            7884,
            7884
        ],
        "mapped",
        [
            7885
        ]
    ],
    [
        [
            7885,
            7885
        ],
        "valid"
    ],
    [
        [
            7886,
            7886
        ],
        "mapped",
        [
            7887
        ]
    ],
    [
        [
            7887,
            7887
        ],
        "valid"
    ],
    [
        [
            7888,
            7888
        ],
        "mapped",
        [
            7889
        ]
    ],
    [
        [
            7889,
            7889
        ],
        "valid"
    ],
    [
        [
            7890,
            7890
        ],
        "mapped",
        [
            7891
        ]
    ],
    [
        [
            7891,
            7891
        ],
        "valid"
    ],
    [
        [
            7892,
            7892
        ],
        "mapped",
        [
            7893
        ]
    ],
    [
        [
            7893,
            7893
        ],
        "valid"
    ],
    [
        [
            7894,
            7894
        ],
        "mapped",
        [
            7895
        ]
    ],
    [
        [
            7895,
            7895
        ],
        "valid"
    ],
    [
        [
            7896,
            7896
        ],
        "mapped",
        [
            7897
        ]
    ],
    [
        [
            7897,
            7897
        ],
        "valid"
    ],
    [
        [
            7898,
            7898
        ],
        "mapped",
        [
            7899
        ]
    ],
    [
        [
            7899,
            7899
        ],
        "valid"
    ],
    [
        [
            7900,
            7900
        ],
        "mapped",
        [
            7901
        ]
    ],
    [
        [
            7901,
            7901
        ],
        "valid"
    ],
    [
        [
            7902,
            7902
        ],
        "mapped",
        [
            7903
        ]
    ],
    [
        [
            7903,
            7903
        ],
        "valid"
    ],
    [
        [
            7904,
            7904
        ],
        "mapped",
        [
            7905
        ]
    ],
    [
        [
            7905,
            7905
        ],
        "valid"
    ],
    [
        [
            7906,
            7906
        ],
        "mapped",
        [
            7907
        ]
    ],
    [
        [
            7907,
            7907
        ],
        "valid"
    ],
    [
        [
            7908,
            7908
        ],
        "mapped",
        [
            7909
        ]
    ],
    [
        [
            7909,
            7909
        ],
        "valid"
    ],
    [
        [
            7910,
            7910
        ],
        "mapped",
        [
            7911
        ]
    ],
    [
        [
            7911,
            7911
        ],
        "valid"
    ],
    [
        [
            7912,
            7912
        ],
        "mapped",
        [
            7913
        ]
    ],
    [
        [
            7913,
            7913
        ],
        "valid"
    ],
    [
        [
            7914,
            7914
        ],
        "mapped",
        [
            7915
        ]
    ],
    [
        [
            7915,
            7915
        ],
        "valid"
    ],
    [
        [
            7916,
            7916
        ],
        "mapped",
        [
            7917
        ]
    ],
    [
        [
            7917,
            7917
        ],
        "valid"
    ],
    [
        [
            7918,
            7918
        ],
        "mapped",
        [
            7919
        ]
    ],
    [
        [
            7919,
            7919
        ],
        "valid"
    ],
    [
        [
            7920,
            7920
        ],
        "mapped",
        [
            7921
        ]
    ],
    [
        [
            7921,
            7921
        ],
        "valid"
    ],
    [
        [
            7922,
            7922
        ],
        "mapped",
        [
            7923
        ]
    ],
    [
        [
            7923,
            7923
        ],
        "valid"
    ],
    [
        [
            7924,
            7924
        ],
        "mapped",
        [
            7925
        ]
    ],
    [
        [
            7925,
            7925
        ],
        "valid"
    ],
    [
        [
            7926,
            7926
        ],
        "mapped",
        [
            7927
        ]
    ],
    [
        [
            7927,
            7927
        ],
        "valid"
    ],
    [
        [
            7928,
            7928
        ],
        "mapped",
        [
            7929
        ]
    ],
    [
        [
            7929,
            7929
        ],
        "valid"
    ],
    [
        [
            7930,
            7930
        ],
        "mapped",
        [
            7931
        ]
    ],
    [
        [
            7931,
            7931
        ],
        "valid"
    ],
    [
        [
            7932,
            7932
        ],
        "mapped",
        [
            7933
        ]
    ],
    [
        [
            7933,
            7933
        ],
        "valid"
    ],
    [
        [
            7934,
            7934
        ],
        "mapped",
        [
            7935
        ]
    ],
    [
        [
            7935,
            7935
        ],
        "valid"
    ],
    [
        [
            7936,
            7943
        ],
        "valid"
    ],
    [
        [
            7944,
            7944
        ],
        "mapped",
        [
            7936
        ]
    ],
    [
        [
            7945,
            7945
        ],
        "mapped",
        [
            7937
        ]
    ],
    [
        [
            7946,
            7946
        ],
        "mapped",
        [
            7938
        ]
    ],
    [
        [
            7947,
            7947
        ],
        "mapped",
        [
            7939
        ]
    ],
    [
        [
            7948,
            7948
        ],
        "mapped",
        [
            7940
        ]
    ],
    [
        [
            7949,
            7949
        ],
        "mapped",
        [
            7941
        ]
    ],
    [
        [
            7950,
            7950
        ],
        "mapped",
        [
            7942
        ]
    ],
    [
        [
            7951,
            7951
        ],
        "mapped",
        [
            7943
        ]
    ],
    [
        [
            7952,
            7957
        ],
        "valid"
    ],
    [
        [
            7958,
            7959
        ],
        "disallowed"
    ],
    [
        [
            7960,
            7960
        ],
        "mapped",
        [
            7952
        ]
    ],
    [
        [
            7961,
            7961
        ],
        "mapped",
        [
            7953
        ]
    ],
    [
        [
            7962,
            7962
        ],
        "mapped",
        [
            7954
        ]
    ],
    [
        [
            7963,
            7963
        ],
        "mapped",
        [
            7955
        ]
    ],
    [
        [
            7964,
            7964
        ],
        "mapped",
        [
            7956
        ]
    ],
    [
        [
            7965,
            7965
        ],
        "mapped",
        [
            7957
        ]
    ],
    [
        [
            7966,
            7967
        ],
        "disallowed"
    ],
    [
        [
            7968,
            7975
        ],
        "valid"
    ],
    [
        [
            7976,
            7976
        ],
        "mapped",
        [
            7968
        ]
    ],
    [
        [
            7977,
            7977
        ],
        "mapped",
        [
            7969
        ]
    ],
    [
        [
            7978,
            7978
        ],
        "mapped",
        [
            7970
        ]
    ],
    [
        [
            7979,
            7979
        ],
        "mapped",
        [
            7971
        ]
    ],
    [
        [
            7980,
            7980
        ],
        "mapped",
        [
            7972
        ]
    ],
    [
        [
            7981,
            7981
        ],
        "mapped",
        [
            7973
        ]
    ],
    [
        [
            7982,
            7982
        ],
        "mapped",
        [
            7974
        ]
    ],
    [
        [
            7983,
            7983
        ],
        "mapped",
        [
            7975
        ]
    ],
    [
        [
            7984,
            7991
        ],
        "valid"
    ],
    [
        [
            7992,
            7992
        ],
        "mapped",
        [
            7984
        ]
    ],
    [
        [
            7993,
            7993
        ],
        "mapped",
        [
            7985
        ]
    ],
    [
        [
            7994,
            7994
        ],
        "mapped",
        [
            7986
        ]
    ],
    [
        [
            7995,
            7995
        ],
        "mapped",
        [
            7987
        ]
    ],
    [
        [
            7996,
            7996
        ],
        "mapped",
        [
            7988
        ]
    ],
    [
        [
            7997,
            7997
        ],
        "mapped",
        [
            7989
        ]
    ],
    [
        [
            7998,
            7998
        ],
        "mapped",
        [
            7990
        ]
    ],
    [
        [
            7999,
            7999
        ],
        "mapped",
        [
            7991
        ]
    ],
    [
        [
            8000,
            8005
        ],
        "valid"
    ],
    [
        [
            8006,
            8007
        ],
        "disallowed"
    ],
    [
        [
            8008,
            8008
        ],
        "mapped",
        [
            8000
        ]
    ],
    [
        [
            8009,
            8009
        ],
        "mapped",
        [
            8001
        ]
    ],
    [
        [
            8010,
            8010
        ],
        "mapped",
        [
            8002
        ]
    ],
    [
        [
            8011,
            8011
        ],
        "mapped",
        [
            8003
        ]
    ],
    [
        [
            8012,
            8012
        ],
        "mapped",
        [
            8004
        ]
    ],
    [
        [
            8013,
            8013
        ],
        "mapped",
        [
            8005
        ]
    ],
    [
        [
            8014,
            8015
        ],
        "disallowed"
    ],
    [
        [
            8016,
            8023
        ],
        "valid"
    ],
    [
        [
            8024,
            8024
        ],
        "disallowed"
    ],
    [
        [
            8025,
            8025
        ],
        "mapped",
        [
            8017
        ]
    ],
    [
        [
            8026,
            8026
        ],
        "disallowed"
    ],
    [
        [
            8027,
            8027
        ],
        "mapped",
        [
            8019
        ]
    ],
    [
        [
            8028,
            8028
        ],
        "disallowed"
    ],
    [
        [
            8029,
            8029
        ],
        "mapped",
        [
            8021
        ]
    ],
    [
        [
            8030,
            8030
        ],
        "disallowed"
    ],
    [
        [
            8031,
            8031
        ],
        "mapped",
        [
            8023
        ]
    ],
    [
        [
            8032,
            8039
        ],
        "valid"
    ],
    [
        [
            8040,
            8040
        ],
        "mapped",
        [
            8032
        ]
    ],
    [
        [
            8041,
            8041
        ],
        "mapped",
        [
            8033
        ]
    ],
    [
        [
            8042,
            8042
        ],
        "mapped",
        [
            8034
        ]
    ],
    [
        [
            8043,
            8043
        ],
        "mapped",
        [
            8035
        ]
    ],
    [
        [
            8044,
            8044
        ],
        "mapped",
        [
            8036
        ]
    ],
    [
        [
            8045,
            8045
        ],
        "mapped",
        [
            8037
        ]
    ],
    [
        [
            8046,
            8046
        ],
        "mapped",
        [
            8038
        ]
    ],
    [
        [
            8047,
            8047
        ],
        "mapped",
        [
            8039
        ]
    ],
    [
        [
            8048,
            8048
        ],
        "valid"
    ],
    [
        [
            8049,
            8049
        ],
        "mapped",
        [
            940
        ]
    ],
    [
        [
            8050,
            8050
        ],
        "valid"
    ],
    [
        [
            8051,
            8051
        ],
        "mapped",
        [
            941
        ]
    ],
    [
        [
            8052,
            8052
        ],
        "valid"
    ],
    [
        [
            8053,
            8053
        ],
        "mapped",
        [
            942
        ]
    ],
    [
        [
            8054,
            8054
        ],
        "valid"
    ],
    [
        [
            8055,
            8055
        ],
        "mapped",
        [
            943
        ]
    ],
    [
        [
            8056,
            8056
        ],
        "valid"
    ],
    [
        [
            8057,
            8057
        ],
        "mapped",
        [
            972
        ]
    ],
    [
        [
            8058,
            8058
        ],
        "valid"
    ],
    [
        [
            8059,
            8059
        ],
        "mapped",
        [
            973
        ]
    ],
    [
        [
            8060,
            8060
        ],
        "valid"
    ],
    [
        [
            8061,
            8061
        ],
        "mapped",
        [
            974
        ]
    ],
    [
        [
            8062,
            8063
        ],
        "disallowed"
    ],
    [
        [
            8064,
            8064
        ],
        "mapped",
        [
            7936,
            953
        ]
    ],
    [
        [
            8065,
            8065
        ],
        "mapped",
        [
            7937,
            953
        ]
    ],
    [
        [
            8066,
            8066
        ],
        "mapped",
        [
            7938,
            953
        ]
    ],
    [
        [
            8067,
            8067
        ],
        "mapped",
        [
            7939,
            953
        ]
    ],
    [
        [
            8068,
            8068
        ],
        "mapped",
        [
            7940,
            953
        ]
    ],
    [
        [
            8069,
            8069
        ],
        "mapped",
        [
            7941,
            953
        ]
    ],
    [
        [
            8070,
            8070
        ],
        "mapped",
        [
            7942,
            953
        ]
    ],
    [
        [
            8071,
            8071
        ],
        "mapped",
        [
            7943,
            953
        ]
    ],
    [
        [
            8072,
            8072
        ],
        "mapped",
        [
            7936,
            953
        ]
    ],
    [
        [
            8073,
            8073
        ],
        "mapped",
        [
            7937,
            953
        ]
    ],
    [
        [
            8074,
            8074
        ],
        "mapped",
        [
            7938,
            953
        ]
    ],
    [
        [
            8075,
            8075
        ],
        "mapped",
        [
            7939,
            953
        ]
    ],
    [
        [
            8076,
            8076
        ],
        "mapped",
        [
            7940,
            953
        ]
    ],
    [
        [
            8077,
            8077
        ],
        "mapped",
        [
            7941,
            953
        ]
    ],
    [
        [
            8078,
            8078
        ],
        "mapped",
        [
            7942,
            953
        ]
    ],
    [
        [
            8079,
            8079
        ],
        "mapped",
        [
            7943,
            953
        ]
    ],
    [
        [
            8080,
            8080
        ],
        "mapped",
        [
            7968,
            953
        ]
    ],
    [
        [
            8081,
            8081
        ],
        "mapped",
        [
            7969,
            953
        ]
    ],
    [
        [
            8082,
            8082
        ],
        "mapped",
        [
            7970,
            953
        ]
    ],
    [
        [
            8083,
            8083
        ],
        "mapped",
        [
            7971,
            953
        ]
    ],
    [
        [
            8084,
            8084
        ],
        "mapped",
        [
            7972,
            953
        ]
    ],
    [
        [
            8085,
            8085
        ],
        "mapped",
        [
            7973,
            953
        ]
    ],
    [
        [
            8086,
            8086
        ],
        "mapped",
        [
            7974,
            953
        ]
    ],
    [
        [
            8087,
            8087
        ],
        "mapped",
        [
            7975,
            953
        ]
    ],
    [
        [
            8088,
            8088
        ],
        "mapped",
        [
            7968,
            953
        ]
    ],
    [
        [
            8089,
            8089
        ],
        "mapped",
        [
            7969,
            953
        ]
    ],
    [
        [
            8090,
            8090
        ],
        "mapped",
        [
            7970,
            953
        ]
    ],
    [
        [
            8091,
            8091
        ],
        "mapped",
        [
            7971,
            953
        ]
    ],
    [
        [
            8092,
            8092
        ],
        "mapped",
        [
            7972,
            953
        ]
    ],
    [
        [
            8093,
            8093
        ],
        "mapped",
        [
            7973,
            953
        ]
    ],
    [
        [
            8094,
            8094
        ],
        "mapped",
        [
            7974,
            953
        ]
    ],
    [
        [
            8095,
            8095
        ],
        "mapped",
        [
            7975,
            953
        ]
    ],
    [
        [
            8096,
            8096
        ],
        "mapped",
        [
            8032,
            953
        ]
    ],
    [
        [
            8097,
            8097
        ],
        "mapped",
        [
            8033,
            953
        ]
    ],
    [
        [
            8098,
            8098
        ],
        "mapped",
        [
            8034,
            953
        ]
    ],
    [
        [
            8099,
            8099
        ],
        "mapped",
        [
            8035,
            953
        ]
    ],
    [
        [
            8100,
            8100
        ],
        "mapped",
        [
            8036,
            953
        ]
    ],
    [
        [
            8101,
            8101
        ],
        "mapped",
        [
            8037,
            953
        ]
    ],
    [
        [
            8102,
            8102
        ],
        "mapped",
        [
            8038,
            953
        ]
    ],
    [
        [
            8103,
            8103
        ],
        "mapped",
        [
            8039,
            953
        ]
    ],
    [
        [
            8104,
            8104
        ],
        "mapped",
        [
            8032,
            953
        ]
    ],
    [
        [
            8105,
            8105
        ],
        "mapped",
        [
            8033,
            953
        ]
    ],
    [
        [
            8106,
            8106
        ],
        "mapped",
        [
            8034,
            953
        ]
    ],
    [
        [
            8107,
            8107
        ],
        "mapped",
        [
            8035,
            953
        ]
    ],
    [
        [
            8108,
            8108
        ],
        "mapped",
        [
            8036,
            953
        ]
    ],
    [
        [
            8109,
            8109
        ],
        "mapped",
        [
            8037,
            953
        ]
    ],
    [
        [
            8110,
            8110
        ],
        "mapped",
        [
            8038,
            953
        ]
    ],
    [
        [
            8111,
            8111
        ],
        "mapped",
        [
            8039,
            953
        ]
    ],
    [
        [
            8112,
            8113
        ],
        "valid"
    ],
    [
        [
            8114,
            8114
        ],
        "mapped",
        [
            8048,
            953
        ]
    ],
    [
        [
            8115,
            8115
        ],
        "mapped",
        [
            945,
            953
        ]
    ],
    [
        [
            8116,
            8116
        ],
        "mapped",
        [
            940,
            953
        ]
    ],
    [
        [
            8117,
            8117
        ],
        "disallowed"
    ],
    [
        [
            8118,
            8118
        ],
        "valid"
    ],
    [
        [
            8119,
            8119
        ],
        "mapped",
        [
            8118,
            953
        ]
    ],
    [
        [
            8120,
            8120
        ],
        "mapped",
        [
            8112
        ]
    ],
    [
        [
            8121,
            8121
        ],
        "mapped",
        [
            8113
        ]
    ],
    [
        [
            8122,
            8122
        ],
        "mapped",
        [
            8048
        ]
    ],
    [
        [
            8123,
            8123
        ],
        "mapped",
        [
            940
        ]
    ],
    [
        [
            8124,
            8124
        ],
        "mapped",
        [
            945,
            953
        ]
    ],
    [
        [
            8125,
            8125
        ],
        "disallowed_STD3_mapped",
        [
            32,
            787
        ]
    ],
    [
        [
            8126,
            8126
        ],
        "mapped",
        [
            953
        ]
    ],
    [
        [
            8127,
            8127
        ],
        "disallowed_STD3_mapped",
        [
            32,
            787
        ]
    ],
    [
        [
            8128,
            8128
        ],
        "disallowed_STD3_mapped",
        [
            32,
            834
        ]
    ],
    [
        [
            8129,
            8129
        ],
        "disallowed_STD3_mapped",
        [
            32,
            776,
            834
        ]
    ],
    [
        [
            8130,
            8130
        ],
        "mapped",
        [
            8052,
            953
        ]
    ],
    [
        [
            8131,
            8131
        ],
        "mapped",
        [
            951,
            953
        ]
    ],
    [
        [
            8132,
            8132
        ],
        "mapped",
        [
            942,
            953
        ]
    ],
    [
        [
            8133,
            8133
        ],
        "disallowed"
    ],
    [
        [
            8134,
            8134
        ],
        "valid"
    ],
    [
        [
            8135,
            8135
        ],
        "mapped",
        [
            8134,
            953
        ]
    ],
    [
        [
            8136,
            8136
        ],
        "mapped",
        [
            8050
        ]
    ],
    [
        [
            8137,
            8137
        ],
        "mapped",
        [
            941
        ]
    ],
    [
        [
            8138,
            8138
        ],
        "mapped",
        [
            8052
        ]
    ],
    [
        [
            8139,
            8139
        ],
        "mapped",
        [
            942
        ]
    ],
    [
        [
            8140,
            8140
        ],
        "mapped",
        [
            951,
            953
        ]
    ],
    [
        [
            8141,
            8141
        ],
        "disallowed_STD3_mapped",
        [
            32,
            787,
            768
        ]
    ],
    [
        [
            8142,
            8142
        ],
        "disallowed_STD3_mapped",
        [
            32,
            787,
            769
        ]
    ],
    [
        [
            8143,
            8143
        ],
        "disallowed_STD3_mapped",
        [
            32,
            787,
            834
        ]
    ],
    [
        [
            8144,
            8146
        ],
        "valid"
    ],
    [
        [
            8147,
            8147
        ],
        "mapped",
        [
            912
        ]
    ],
    [
        [
            8148,
            8149
        ],
        "disallowed"
    ],
    [
        [
            8150,
            8151
        ],
        "valid"
    ],
    [
        [
            8152,
            8152
        ],
        "mapped",
        [
            8144
        ]
    ],
    [
        [
            8153,
            8153
        ],
        "mapped",
        [
            8145
        ]
    ],
    [
        [
            8154,
            8154
        ],
        "mapped",
        [
            8054
        ]
    ],
    [
        [
            8155,
            8155
        ],
        "mapped",
        [
            943
        ]
    ],
    [
        [
            8156,
            8156
        ],
        "disallowed"
    ],
    [
        [
            8157,
            8157
        ],
        "disallowed_STD3_mapped",
        [
            32,
            788,
            768
        ]
    ],
    [
        [
            8158,
            8158
        ],
        "disallowed_STD3_mapped",
        [
            32,
            788,
            769
        ]
    ],
    [
        [
            8159,
            8159
        ],
        "disallowed_STD3_mapped",
        [
            32,
            788,
            834
        ]
    ],
    [
        [
            8160,
            8162
        ],
        "valid"
    ],
    [
        [
            8163,
            8163
        ],
        "mapped",
        [
            944
        ]
    ],
    [
        [
            8164,
            8167
        ],
        "valid"
    ],
    [
        [
            8168,
            8168
        ],
        "mapped",
        [
            8160
        ]
    ],
    [
        [
            8169,
            8169
        ],
        "mapped",
        [
            8161
        ]
    ],
    [
        [
            8170,
            8170
        ],
        "mapped",
        [
            8058
        ]
    ],
    [
        [
            8171,
            8171
        ],
        "mapped",
        [
            973
        ]
    ],
    [
        [
            8172,
            8172
        ],
        "mapped",
        [
            8165
        ]
    ],
    [
        [
            8173,
            8173
        ],
        "disallowed_STD3_mapped",
        [
            32,
            776,
            768
        ]
    ],
    [
        [
            8174,
            8174
        ],
        "disallowed_STD3_mapped",
        [
            32,
            776,
            769
        ]
    ],
    [
        [
            8175,
            8175
        ],
        "disallowed_STD3_mapped",
        [
            96
        ]
    ],
    [
        [
            8176,
            8177
        ],
        "disallowed"
    ],
    [
        [
            8178,
            8178
        ],
        "mapped",
        [
            8060,
            953
        ]
    ],
    [
        [
            8179,
            8179
        ],
        "mapped",
        [
            969,
            953
        ]
    ],
    [
        [
            8180,
            8180
        ],
        "mapped",
        [
            974,
            953
        ]
    ],
    [
        [
            8181,
            8181
        ],
        "disallowed"
    ],
    [
        [
            8182,
            8182
        ],
        "valid"
    ],
    [
        [
            8183,
            8183
        ],
        "mapped",
        [
            8182,
            953
        ]
    ],
    [
        [
            8184,
            8184
        ],
        "mapped",
        [
            8056
        ]
    ],
    [
        [
            8185,
            8185
        ],
        "mapped",
        [
            972
        ]
    ],
    [
        [
            8186,
            8186
        ],
        "mapped",
        [
            8060
        ]
    ],
    [
        [
            8187,
            8187
        ],
        "mapped",
        [
            974
        ]
    ],
    [
        [
            8188,
            8188
        ],
        "mapped",
        [
            969,
            953
        ]
    ],
    [
        [
            8189,
            8189
        ],
        "disallowed_STD3_mapped",
        [
            32,
            769
        ]
    ],
    [
        [
            8190,
            8190
        ],
        "disallowed_STD3_mapped",
        [
            32,
            788
        ]
    ],
    [
        [
            8191,
            8191
        ],
        "disallowed"
    ],
    [
        [
            8192,
            8202
        ],
        "disallowed_STD3_mapped",
        [
            32
        ]
    ],
    [
        [
            8203,
            8203
        ],
        "ignored"
    ],
    [
        [
            8204,
            8205
        ],
        "deviation",
        []
    ],
    [
        [
            8206,
            8207
        ],
        "disallowed"
    ],
    [
        [
            8208,
            8208
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8209,
            8209
        ],
        "mapped",
        [
            8208
        ]
    ],
    [
        [
            8210,
            8214
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8215,
            8215
        ],
        "disallowed_STD3_mapped",
        [
            32,
            819
        ]
    ],
    [
        [
            8216,
            8227
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8228,
            8230
        ],
        "disallowed"
    ],
    [
        [
            8231,
            8231
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8232,
            8238
        ],
        "disallowed"
    ],
    [
        [
            8239,
            8239
        ],
        "disallowed_STD3_mapped",
        [
            32
        ]
    ],
    [
        [
            8240,
            8242
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8243,
            8243
        ],
        "mapped",
        [
            8242,
            8242
        ]
    ],
    [
        [
            8244,
            8244
        ],
        "mapped",
        [
            8242,
            8242,
            8242
        ]
    ],
    [
        [
            8245,
            8245
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8246,
            8246
        ],
        "mapped",
        [
            8245,
            8245
        ]
    ],
    [
        [
            8247,
            8247
        ],
        "mapped",
        [
            8245,
            8245,
            8245
        ]
    ],
    [
        [
            8248,
            8251
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8252,
            8252
        ],
        "disallowed_STD3_mapped",
        [
            33,
            33
        ]
    ],
    [
        [
            8253,
            8253
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8254,
            8254
        ],
        "disallowed_STD3_mapped",
        [
            32,
            773
        ]
    ],
    [
        [
            8255,
            8262
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8263,
            8263
        ],
        "disallowed_STD3_mapped",
        [
            63,
            63
        ]
    ],
    [
        [
            8264,
            8264
        ],
        "disallowed_STD3_mapped",
        [
            63,
            33
        ]
    ],
    [
        [
            8265,
            8265
        ],
        "disallowed_STD3_mapped",
        [
            33,
            63
        ]
    ],
    [
        [
            8266,
            8269
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8270,
            8274
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8275,
            8276
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8277,
            8278
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8279,
            8279
        ],
        "mapped",
        [
            8242,
            8242,
            8242,
            8242
        ]
    ],
    [
        [
            8280,
            8286
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8287,
            8287
        ],
        "disallowed_STD3_mapped",
        [
            32
        ]
    ],
    [
        [
            8288,
            8288
        ],
        "ignored"
    ],
    [
        [
            8289,
            8291
        ],
        "disallowed"
    ],
    [
        [
            8292,
            8292
        ],
        "ignored"
    ],
    [
        [
            8293,
            8293
        ],
        "disallowed"
    ],
    [
        [
            8294,
            8297
        ],
        "disallowed"
    ],
    [
        [
            8298,
            8303
        ],
        "disallowed"
    ],
    [
        [
            8304,
            8304
        ],
        "mapped",
        [
            48
        ]
    ],
    [
        [
            8305,
            8305
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            8306,
            8307
        ],
        "disallowed"
    ],
    [
        [
            8308,
            8308
        ],
        "mapped",
        [
            52
        ]
    ],
    [
        [
            8309,
            8309
        ],
        "mapped",
        [
            53
        ]
    ],
    [
        [
            8310,
            8310
        ],
        "mapped",
        [
            54
        ]
    ],
    [
        [
            8311,
            8311
        ],
        "mapped",
        [
            55
        ]
    ],
    [
        [
            8312,
            8312
        ],
        "mapped",
        [
            56
        ]
    ],
    [
        [
            8313,
            8313
        ],
        "mapped",
        [
            57
        ]
    ],
    [
        [
            8314,
            8314
        ],
        "disallowed_STD3_mapped",
        [
            43
        ]
    ],
    [
        [
            8315,
            8315
        ],
        "mapped",
        [
            8722
        ]
    ],
    [
        [
            8316,
            8316
        ],
        "disallowed_STD3_mapped",
        [
            61
        ]
    ],
    [
        [
            8317,
            8317
        ],
        "disallowed_STD3_mapped",
        [
            40
        ]
    ],
    [
        [
            8318,
            8318
        ],
        "disallowed_STD3_mapped",
        [
            41
        ]
    ],
    [
        [
            8319,
            8319
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            8320,
            8320
        ],
        "mapped",
        [
            48
        ]
    ],
    [
        [
            8321,
            8321
        ],
        "mapped",
        [
            49
        ]
    ],
    [
        [
            8322,
            8322
        ],
        "mapped",
        [
            50
        ]
    ],
    [
        [
            8323,
            8323
        ],
        "mapped",
        [
            51
        ]
    ],
    [
        [
            8324,
            8324
        ],
        "mapped",
        [
            52
        ]
    ],
    [
        [
            8325,
            8325
        ],
        "mapped",
        [
            53
        ]
    ],
    [
        [
            8326,
            8326
        ],
        "mapped",
        [
            54
        ]
    ],
    [
        [
            8327,
            8327
        ],
        "mapped",
        [
            55
        ]
    ],
    [
        [
            8328,
            8328
        ],
        "mapped",
        [
            56
        ]
    ],
    [
        [
            8329,
            8329
        ],
        "mapped",
        [
            57
        ]
    ],
    [
        [
            8330,
            8330
        ],
        "disallowed_STD3_mapped",
        [
            43
        ]
    ],
    [
        [
            8331,
            8331
        ],
        "mapped",
        [
            8722
        ]
    ],
    [
        [
            8332,
            8332
        ],
        "disallowed_STD3_mapped",
        [
            61
        ]
    ],
    [
        [
            8333,
            8333
        ],
        "disallowed_STD3_mapped",
        [
            40
        ]
    ],
    [
        [
            8334,
            8334
        ],
        "disallowed_STD3_mapped",
        [
            41
        ]
    ],
    [
        [
            8335,
            8335
        ],
        "disallowed"
    ],
    [
        [
            8336,
            8336
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            8337,
            8337
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            8338,
            8338
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            8339,
            8339
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            8340,
            8340
        ],
        "mapped",
        [
            601
        ]
    ],
    [
        [
            8341,
            8341
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            8342,
            8342
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            8343,
            8343
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            8344,
            8344
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            8345,
            8345
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            8346,
            8346
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            8347,
            8347
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            8348,
            8348
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            8349,
            8351
        ],
        "disallowed"
    ],
    [
        [
            8352,
            8359
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8360,
            8360
        ],
        "mapped",
        [
            114,
            115
        ]
    ],
    [
        [
            8361,
            8362
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8363,
            8363
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8364,
            8364
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8365,
            8367
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8368,
            8369
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8370,
            8373
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8374,
            8376
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8377,
            8377
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8378,
            8378
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8379,
            8381
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8382,
            8382
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8383,
            8399
        ],
        "disallowed"
    ],
    [
        [
            8400,
            8417
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8418,
            8419
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8420,
            8426
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8427,
            8427
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8428,
            8431
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8432,
            8432
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8433,
            8447
        ],
        "disallowed"
    ],
    [
        [
            8448,
            8448
        ],
        "disallowed_STD3_mapped",
        [
            97,
            47,
            99
        ]
    ],
    [
        [
            8449,
            8449
        ],
        "disallowed_STD3_mapped",
        [
            97,
            47,
            115
        ]
    ],
    [
        [
            8450,
            8450
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            8451,
            8451
        ],
        "mapped",
        [
            176,
            99
        ]
    ],
    [
        [
            8452,
            8452
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8453,
            8453
        ],
        "disallowed_STD3_mapped",
        [
            99,
            47,
            111
        ]
    ],
    [
        [
            8454,
            8454
        ],
        "disallowed_STD3_mapped",
        [
            99,
            47,
            117
        ]
    ],
    [
        [
            8455,
            8455
        ],
        "mapped",
        [
            603
        ]
    ],
    [
        [
            8456,
            8456
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8457,
            8457
        ],
        "mapped",
        [
            176,
            102
        ]
    ],
    [
        [
            8458,
            8458
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            8459,
            8462
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            8463,
            8463
        ],
        "mapped",
        [
            295
        ]
    ],
    [
        [
            8464,
            8465
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            8466,
            8467
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            8468,
            8468
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8469,
            8469
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            8470,
            8470
        ],
        "mapped",
        [
            110,
            111
        ]
    ],
    [
        [
            8471,
            8472
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8473,
            8473
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            8474,
            8474
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            8475,
            8477
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            8478,
            8479
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8480,
            8480
        ],
        "mapped",
        [
            115,
            109
        ]
    ],
    [
        [
            8481,
            8481
        ],
        "mapped",
        [
            116,
            101,
            108
        ]
    ],
    [
        [
            8482,
            8482
        ],
        "mapped",
        [
            116,
            109
        ]
    ],
    [
        [
            8483,
            8483
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8484,
            8484
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            8485,
            8485
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8486,
            8486
        ],
        "mapped",
        [
            969
        ]
    ],
    [
        [
            8487,
            8487
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8488,
            8488
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            8489,
            8489
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8490,
            8490
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            8491,
            8491
        ],
        "mapped",
        [
            229
        ]
    ],
    [
        [
            8492,
            8492
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            8493,
            8493
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            8494,
            8494
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8495,
            8496
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            8497,
            8497
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            8498,
            8498
        ],
        "disallowed"
    ],
    [
        [
            8499,
            8499
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            8500,
            8500
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            8501,
            8501
        ],
        "mapped",
        [
            1488
        ]
    ],
    [
        [
            8502,
            8502
        ],
        "mapped",
        [
            1489
        ]
    ],
    [
        [
            8503,
            8503
        ],
        "mapped",
        [
            1490
        ]
    ],
    [
        [
            8504,
            8504
        ],
        "mapped",
        [
            1491
        ]
    ],
    [
        [
            8505,
            8505
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            8506,
            8506
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8507,
            8507
        ],
        "mapped",
        [
            102,
            97,
            120
        ]
    ],
    [
        [
            8508,
            8508
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            8509,
            8510
        ],
        "mapped",
        [
            947
        ]
    ],
    [
        [
            8511,
            8511
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            8512,
            8512
        ],
        "mapped",
        [
            8721
        ]
    ],
    [
        [
            8513,
            8516
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8517,
            8518
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            8519,
            8519
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            8520,
            8520
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            8521,
            8521
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            8522,
            8523
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8524,
            8524
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8525,
            8525
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8526,
            8526
        ],
        "valid"
    ],
    [
        [
            8527,
            8527
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8528,
            8528
        ],
        "mapped",
        [
            49,
            8260,
            55
        ]
    ],
    [
        [
            8529,
            8529
        ],
        "mapped",
        [
            49,
            8260,
            57
        ]
    ],
    [
        [
            8530,
            8530
        ],
        "mapped",
        [
            49,
            8260,
            49,
            48
        ]
    ],
    [
        [
            8531,
            8531
        ],
        "mapped",
        [
            49,
            8260,
            51
        ]
    ],
    [
        [
            8532,
            8532
        ],
        "mapped",
        [
            50,
            8260,
            51
        ]
    ],
    [
        [
            8533,
            8533
        ],
        "mapped",
        [
            49,
            8260,
            53
        ]
    ],
    [
        [
            8534,
            8534
        ],
        "mapped",
        [
            50,
            8260,
            53
        ]
    ],
    [
        [
            8535,
            8535
        ],
        "mapped",
        [
            51,
            8260,
            53
        ]
    ],
    [
        [
            8536,
            8536
        ],
        "mapped",
        [
            52,
            8260,
            53
        ]
    ],
    [
        [
            8537,
            8537
        ],
        "mapped",
        [
            49,
            8260,
            54
        ]
    ],
    [
        [
            8538,
            8538
        ],
        "mapped",
        [
            53,
            8260,
            54
        ]
    ],
    [
        [
            8539,
            8539
        ],
        "mapped",
        [
            49,
            8260,
            56
        ]
    ],
    [
        [
            8540,
            8540
        ],
        "mapped",
        [
            51,
            8260,
            56
        ]
    ],
    [
        [
            8541,
            8541
        ],
        "mapped",
        [
            53,
            8260,
            56
        ]
    ],
    [
        [
            8542,
            8542
        ],
        "mapped",
        [
            55,
            8260,
            56
        ]
    ],
    [
        [
            8543,
            8543
        ],
        "mapped",
        [
            49,
            8260
        ]
    ],
    [
        [
            8544,
            8544
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            8545,
            8545
        ],
        "mapped",
        [
            105,
            105
        ]
    ],
    [
        [
            8546,
            8546
        ],
        "mapped",
        [
            105,
            105,
            105
        ]
    ],
    [
        [
            8547,
            8547
        ],
        "mapped",
        [
            105,
            118
        ]
    ],
    [
        [
            8548,
            8548
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            8549,
            8549
        ],
        "mapped",
        [
            118,
            105
        ]
    ],
    [
        [
            8550,
            8550
        ],
        "mapped",
        [
            118,
            105,
            105
        ]
    ],
    [
        [
            8551,
            8551
        ],
        "mapped",
        [
            118,
            105,
            105,
            105
        ]
    ],
    [
        [
            8552,
            8552
        ],
        "mapped",
        [
            105,
            120
        ]
    ],
    [
        [
            8553,
            8553
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            8554,
            8554
        ],
        "mapped",
        [
            120,
            105
        ]
    ],
    [
        [
            8555,
            8555
        ],
        "mapped",
        [
            120,
            105,
            105
        ]
    ],
    [
        [
            8556,
            8556
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            8557,
            8557
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            8558,
            8558
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            8559,
            8559
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            8560,
            8560
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            8561,
            8561
        ],
        "mapped",
        [
            105,
            105
        ]
    ],
    [
        [
            8562,
            8562
        ],
        "mapped",
        [
            105,
            105,
            105
        ]
    ],
    [
        [
            8563,
            8563
        ],
        "mapped",
        [
            105,
            118
        ]
    ],
    [
        [
            8564,
            8564
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            8565,
            8565
        ],
        "mapped",
        [
            118,
            105
        ]
    ],
    [
        [
            8566,
            8566
        ],
        "mapped",
        [
            118,
            105,
            105
        ]
    ],
    [
        [
            8567,
            8567
        ],
        "mapped",
        [
            118,
            105,
            105,
            105
        ]
    ],
    [
        [
            8568,
            8568
        ],
        "mapped",
        [
            105,
            120
        ]
    ],
    [
        [
            8569,
            8569
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            8570,
            8570
        ],
        "mapped",
        [
            120,
            105
        ]
    ],
    [
        [
            8571,
            8571
        ],
        "mapped",
        [
            120,
            105,
            105
        ]
    ],
    [
        [
            8572,
            8572
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            8573,
            8573
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            8574,
            8574
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            8575,
            8575
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            8576,
            8578
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8579,
            8579
        ],
        "disallowed"
    ],
    [
        [
            8580,
            8580
        ],
        "valid"
    ],
    [
        [
            8581,
            8584
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8585,
            8585
        ],
        "mapped",
        [
            48,
            8260,
            51
        ]
    ],
    [
        [
            8586,
            8587
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8588,
            8591
        ],
        "disallowed"
    ],
    [
        [
            8592,
            8682
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8683,
            8691
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8692,
            8703
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8704,
            8747
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8748,
            8748
        ],
        "mapped",
        [
            8747,
            8747
        ]
    ],
    [
        [
            8749,
            8749
        ],
        "mapped",
        [
            8747,
            8747,
            8747
        ]
    ],
    [
        [
            8750,
            8750
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8751,
            8751
        ],
        "mapped",
        [
            8750,
            8750
        ]
    ],
    [
        [
            8752,
            8752
        ],
        "mapped",
        [
            8750,
            8750,
            8750
        ]
    ],
    [
        [
            8753,
            8799
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8800,
            8800
        ],
        "disallowed_STD3_valid"
    ],
    [
        [
            8801,
            8813
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8814,
            8815
        ],
        "disallowed_STD3_valid"
    ],
    [
        [
            8816,
            8945
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8946,
            8959
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8960,
            8960
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8961,
            8961
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            8962,
            9000
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9001,
            9001
        ],
        "mapped",
        [
            12296
        ]
    ],
    [
        [
            9002,
            9002
        ],
        "mapped",
        [
            12297
        ]
    ],
    [
        [
            9003,
            9082
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9083,
            9083
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9084,
            9084
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9085,
            9114
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9115,
            9166
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9167,
            9168
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9169,
            9179
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9180,
            9191
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9192,
            9192
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9193,
            9203
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9204,
            9210
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9211,
            9215
        ],
        "disallowed"
    ],
    [
        [
            9216,
            9252
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9253,
            9254
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9255,
            9279
        ],
        "disallowed"
    ],
    [
        [
            9280,
            9290
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9291,
            9311
        ],
        "disallowed"
    ],
    [
        [
            9312,
            9312
        ],
        "mapped",
        [
            49
        ]
    ],
    [
        [
            9313,
            9313
        ],
        "mapped",
        [
            50
        ]
    ],
    [
        [
            9314,
            9314
        ],
        "mapped",
        [
            51
        ]
    ],
    [
        [
            9315,
            9315
        ],
        "mapped",
        [
            52
        ]
    ],
    [
        [
            9316,
            9316
        ],
        "mapped",
        [
            53
        ]
    ],
    [
        [
            9317,
            9317
        ],
        "mapped",
        [
            54
        ]
    ],
    [
        [
            9318,
            9318
        ],
        "mapped",
        [
            55
        ]
    ],
    [
        [
            9319,
            9319
        ],
        "mapped",
        [
            56
        ]
    ],
    [
        [
            9320,
            9320
        ],
        "mapped",
        [
            57
        ]
    ],
    [
        [
            9321,
            9321
        ],
        "mapped",
        [
            49,
            48
        ]
    ],
    [
        [
            9322,
            9322
        ],
        "mapped",
        [
            49,
            49
        ]
    ],
    [
        [
            9323,
            9323
        ],
        "mapped",
        [
            49,
            50
        ]
    ],
    [
        [
            9324,
            9324
        ],
        "mapped",
        [
            49,
            51
        ]
    ],
    [
        [
            9325,
            9325
        ],
        "mapped",
        [
            49,
            52
        ]
    ],
    [
        [
            9326,
            9326
        ],
        "mapped",
        [
            49,
            53
        ]
    ],
    [
        [
            9327,
            9327
        ],
        "mapped",
        [
            49,
            54
        ]
    ],
    [
        [
            9328,
            9328
        ],
        "mapped",
        [
            49,
            55
        ]
    ],
    [
        [
            9329,
            9329
        ],
        "mapped",
        [
            49,
            56
        ]
    ],
    [
        [
            9330,
            9330
        ],
        "mapped",
        [
            49,
            57
        ]
    ],
    [
        [
            9331,
            9331
        ],
        "mapped",
        [
            50,
            48
        ]
    ],
    [
        [
            9332,
            9332
        ],
        "disallowed_STD3_mapped",
        [
            40,
            49,
            41
        ]
    ],
    [
        [
            9333,
            9333
        ],
        "disallowed_STD3_mapped",
        [
            40,
            50,
            41
        ]
    ],
    [
        [
            9334,
            9334
        ],
        "disallowed_STD3_mapped",
        [
            40,
            51,
            41
        ]
    ],
    [
        [
            9335,
            9335
        ],
        "disallowed_STD3_mapped",
        [
            40,
            52,
            41
        ]
    ],
    [
        [
            9336,
            9336
        ],
        "disallowed_STD3_mapped",
        [
            40,
            53,
            41
        ]
    ],
    [
        [
            9337,
            9337
        ],
        "disallowed_STD3_mapped",
        [
            40,
            54,
            41
        ]
    ],
    [
        [
            9338,
            9338
        ],
        "disallowed_STD3_mapped",
        [
            40,
            55,
            41
        ]
    ],
    [
        [
            9339,
            9339
        ],
        "disallowed_STD3_mapped",
        [
            40,
            56,
            41
        ]
    ],
    [
        [
            9340,
            9340
        ],
        "disallowed_STD3_mapped",
        [
            40,
            57,
            41
        ]
    ],
    [
        [
            9341,
            9341
        ],
        "disallowed_STD3_mapped",
        [
            40,
            49,
            48,
            41
        ]
    ],
    [
        [
            9342,
            9342
        ],
        "disallowed_STD3_mapped",
        [
            40,
            49,
            49,
            41
        ]
    ],
    [
        [
            9343,
            9343
        ],
        "disallowed_STD3_mapped",
        [
            40,
            49,
            50,
            41
        ]
    ],
    [
        [
            9344,
            9344
        ],
        "disallowed_STD3_mapped",
        [
            40,
            49,
            51,
            41
        ]
    ],
    [
        [
            9345,
            9345
        ],
        "disallowed_STD3_mapped",
        [
            40,
            49,
            52,
            41
        ]
    ],
    [
        [
            9346,
            9346
        ],
        "disallowed_STD3_mapped",
        [
            40,
            49,
            53,
            41
        ]
    ],
    [
        [
            9347,
            9347
        ],
        "disallowed_STD3_mapped",
        [
            40,
            49,
            54,
            41
        ]
    ],
    [
        [
            9348,
            9348
        ],
        "disallowed_STD3_mapped",
        [
            40,
            49,
            55,
            41
        ]
    ],
    [
        [
            9349,
            9349
        ],
        "disallowed_STD3_mapped",
        [
            40,
            49,
            56,
            41
        ]
    ],
    [
        [
            9350,
            9350
        ],
        "disallowed_STD3_mapped",
        [
            40,
            49,
            57,
            41
        ]
    ],
    [
        [
            9351,
            9351
        ],
        "disallowed_STD3_mapped",
        [
            40,
            50,
            48,
            41
        ]
    ],
    [
        [
            9352,
            9371
        ],
        "disallowed"
    ],
    [
        [
            9372,
            9372
        ],
        "disallowed_STD3_mapped",
        [
            40,
            97,
            41
        ]
    ],
    [
        [
            9373,
            9373
        ],
        "disallowed_STD3_mapped",
        [
            40,
            98,
            41
        ]
    ],
    [
        [
            9374,
            9374
        ],
        "disallowed_STD3_mapped",
        [
            40,
            99,
            41
        ]
    ],
    [
        [
            9375,
            9375
        ],
        "disallowed_STD3_mapped",
        [
            40,
            100,
            41
        ]
    ],
    [
        [
            9376,
            9376
        ],
        "disallowed_STD3_mapped",
        [
            40,
            101,
            41
        ]
    ],
    [
        [
            9377,
            9377
        ],
        "disallowed_STD3_mapped",
        [
            40,
            102,
            41
        ]
    ],
    [
        [
            9378,
            9378
        ],
        "disallowed_STD3_mapped",
        [
            40,
            103,
            41
        ]
    ],
    [
        [
            9379,
            9379
        ],
        "disallowed_STD3_mapped",
        [
            40,
            104,
            41
        ]
    ],
    [
        [
            9380,
            9380
        ],
        "disallowed_STD3_mapped",
        [
            40,
            105,
            41
        ]
    ],
    [
        [
            9381,
            9381
        ],
        "disallowed_STD3_mapped",
        [
            40,
            106,
            41
        ]
    ],
    [
        [
            9382,
            9382
        ],
        "disallowed_STD3_mapped",
        [
            40,
            107,
            41
        ]
    ],
    [
        [
            9383,
            9383
        ],
        "disallowed_STD3_mapped",
        [
            40,
            108,
            41
        ]
    ],
    [
        [
            9384,
            9384
        ],
        "disallowed_STD3_mapped",
        [
            40,
            109,
            41
        ]
    ],
    [
        [
            9385,
            9385
        ],
        "disallowed_STD3_mapped",
        [
            40,
            110,
            41
        ]
    ],
    [
        [
            9386,
            9386
        ],
        "disallowed_STD3_mapped",
        [
            40,
            111,
            41
        ]
    ],
    [
        [
            9387,
            9387
        ],
        "disallowed_STD3_mapped",
        [
            40,
            112,
            41
        ]
    ],
    [
        [
            9388,
            9388
        ],
        "disallowed_STD3_mapped",
        [
            40,
            113,
            41
        ]
    ],
    [
        [
            9389,
            9389
        ],
        "disallowed_STD3_mapped",
        [
            40,
            114,
            41
        ]
    ],
    [
        [
            9390,
            9390
        ],
        "disallowed_STD3_mapped",
        [
            40,
            115,
            41
        ]
    ],
    [
        [
            9391,
            9391
        ],
        "disallowed_STD3_mapped",
        [
            40,
            116,
            41
        ]
    ],
    [
        [
            9392,
            9392
        ],
        "disallowed_STD3_mapped",
        [
            40,
            117,
            41
        ]
    ],
    [
        [
            9393,
            9393
        ],
        "disallowed_STD3_mapped",
        [
            40,
            118,
            41
        ]
    ],
    [
        [
            9394,
            9394
        ],
        "disallowed_STD3_mapped",
        [
            40,
            119,
            41
        ]
    ],
    [
        [
            9395,
            9395
        ],
        "disallowed_STD3_mapped",
        [
            40,
            120,
            41
        ]
    ],
    [
        [
            9396,
            9396
        ],
        "disallowed_STD3_mapped",
        [
            40,
            121,
            41
        ]
    ],
    [
        [
            9397,
            9397
        ],
        "disallowed_STD3_mapped",
        [
            40,
            122,
            41
        ]
    ],
    [
        [
            9398,
            9398
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            9399,
            9399
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            9400,
            9400
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            9401,
            9401
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            9402,
            9402
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            9403,
            9403
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            9404,
            9404
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            9405,
            9405
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            9406,
            9406
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            9407,
            9407
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            9408,
            9408
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            9409,
            9409
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            9410,
            9410
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            9411,
            9411
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            9412,
            9412
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            9413,
            9413
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            9414,
            9414
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            9415,
            9415
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            9416,
            9416
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            9417,
            9417
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            9418,
            9418
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            9419,
            9419
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            9420,
            9420
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            9421,
            9421
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            9422,
            9422
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            9423,
            9423
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            9424,
            9424
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            9425,
            9425
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            9426,
            9426
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            9427,
            9427
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            9428,
            9428
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            9429,
            9429
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            9430,
            9430
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            9431,
            9431
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            9432,
            9432
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            9433,
            9433
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            9434,
            9434
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            9435,
            9435
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            9436,
            9436
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            9437,
            9437
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            9438,
            9438
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            9439,
            9439
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            9440,
            9440
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            9441,
            9441
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            9442,
            9442
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            9443,
            9443
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            9444,
            9444
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            9445,
            9445
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            9446,
            9446
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            9447,
            9447
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            9448,
            9448
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            9449,
            9449
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            9450,
            9450
        ],
        "mapped",
        [
            48
        ]
    ],
    [
        [
            9451,
            9470
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9471,
            9471
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9472,
            9621
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9622,
            9631
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9632,
            9711
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9712,
            9719
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9720,
            9727
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9728,
            9747
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9748,
            9749
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9750,
            9751
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9752,
            9752
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9753,
            9753
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9754,
            9839
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9840,
            9841
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9842,
            9853
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9854,
            9855
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9856,
            9865
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9866,
            9873
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9874,
            9884
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9885,
            9885
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9886,
            9887
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9888,
            9889
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9890,
            9905
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9906,
            9906
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9907,
            9916
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9917,
            9919
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9920,
            9923
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9924,
            9933
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9934,
            9934
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9935,
            9953
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9954,
            9954
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9955,
            9955
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9956,
            9959
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9960,
            9983
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9984,
            9984
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9985,
            9988
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9989,
            9989
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9990,
            9993
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9994,
            9995
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            9996,
            10023
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10024,
            10024
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10025,
            10059
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10060,
            10060
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10061,
            10061
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10062,
            10062
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10063,
            10066
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10067,
            10069
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10070,
            10070
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10071,
            10071
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10072,
            10078
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10079,
            10080
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10081,
            10087
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10088,
            10101
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10102,
            10132
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10133,
            10135
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10136,
            10159
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10160,
            10160
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10161,
            10174
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10175,
            10175
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10176,
            10182
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10183,
            10186
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10187,
            10187
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10188,
            10188
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10189,
            10189
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10190,
            10191
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10192,
            10219
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10220,
            10223
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10224,
            10239
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10240,
            10495
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10496,
            10763
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10764,
            10764
        ],
        "mapped",
        [
            8747,
            8747,
            8747,
            8747
        ]
    ],
    [
        [
            10765,
            10867
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10868,
            10868
        ],
        "disallowed_STD3_mapped",
        [
            58,
            58,
            61
        ]
    ],
    [
        [
            10869,
            10869
        ],
        "disallowed_STD3_mapped",
        [
            61,
            61
        ]
    ],
    [
        [
            10870,
            10870
        ],
        "disallowed_STD3_mapped",
        [
            61,
            61,
            61
        ]
    ],
    [
        [
            10871,
            10971
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            10972,
            10972
        ],
        "mapped",
        [
            10973,
            824
        ]
    ],
    [
        [
            10973,
            11007
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11008,
            11021
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11022,
            11027
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11028,
            11034
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11035,
            11039
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11040,
            11043
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11044,
            11084
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11085,
            11087
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11088,
            11092
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11093,
            11097
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11098,
            11123
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11124,
            11125
        ],
        "disallowed"
    ],
    [
        [
            11126,
            11157
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11158,
            11159
        ],
        "disallowed"
    ],
    [
        [
            11160,
            11193
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11194,
            11196
        ],
        "disallowed"
    ],
    [
        [
            11197,
            11208
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11209,
            11209
        ],
        "disallowed"
    ],
    [
        [
            11210,
            11217
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11218,
            11243
        ],
        "disallowed"
    ],
    [
        [
            11244,
            11247
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11248,
            11263
        ],
        "disallowed"
    ],
    [
        [
            11264,
            11264
        ],
        "mapped",
        [
            11312
        ]
    ],
    [
        [
            11265,
            11265
        ],
        "mapped",
        [
            11313
        ]
    ],
    [
        [
            11266,
            11266
        ],
        "mapped",
        [
            11314
        ]
    ],
    [
        [
            11267,
            11267
        ],
        "mapped",
        [
            11315
        ]
    ],
    [
        [
            11268,
            11268
        ],
        "mapped",
        [
            11316
        ]
    ],
    [
        [
            11269,
            11269
        ],
        "mapped",
        [
            11317
        ]
    ],
    [
        [
            11270,
            11270
        ],
        "mapped",
        [
            11318
        ]
    ],
    [
        [
            11271,
            11271
        ],
        "mapped",
        [
            11319
        ]
    ],
    [
        [
            11272,
            11272
        ],
        "mapped",
        [
            11320
        ]
    ],
    [
        [
            11273,
            11273
        ],
        "mapped",
        [
            11321
        ]
    ],
    [
        [
            11274,
            11274
        ],
        "mapped",
        [
            11322
        ]
    ],
    [
        [
            11275,
            11275
        ],
        "mapped",
        [
            11323
        ]
    ],
    [
        [
            11276,
            11276
        ],
        "mapped",
        [
            11324
        ]
    ],
    [
        [
            11277,
            11277
        ],
        "mapped",
        [
            11325
        ]
    ],
    [
        [
            11278,
            11278
        ],
        "mapped",
        [
            11326
        ]
    ],
    [
        [
            11279,
            11279
        ],
        "mapped",
        [
            11327
        ]
    ],
    [
        [
            11280,
            11280
        ],
        "mapped",
        [
            11328
        ]
    ],
    [
        [
            11281,
            11281
        ],
        "mapped",
        [
            11329
        ]
    ],
    [
        [
            11282,
            11282
        ],
        "mapped",
        [
            11330
        ]
    ],
    [
        [
            11283,
            11283
        ],
        "mapped",
        [
            11331
        ]
    ],
    [
        [
            11284,
            11284
        ],
        "mapped",
        [
            11332
        ]
    ],
    [
        [
            11285,
            11285
        ],
        "mapped",
        [
            11333
        ]
    ],
    [
        [
            11286,
            11286
        ],
        "mapped",
        [
            11334
        ]
    ],
    [
        [
            11287,
            11287
        ],
        "mapped",
        [
            11335
        ]
    ],
    [
        [
            11288,
            11288
        ],
        "mapped",
        [
            11336
        ]
    ],
    [
        [
            11289,
            11289
        ],
        "mapped",
        [
            11337
        ]
    ],
    [
        [
            11290,
            11290
        ],
        "mapped",
        [
            11338
        ]
    ],
    [
        [
            11291,
            11291
        ],
        "mapped",
        [
            11339
        ]
    ],
    [
        [
            11292,
            11292
        ],
        "mapped",
        [
            11340
        ]
    ],
    [
        [
            11293,
            11293
        ],
        "mapped",
        [
            11341
        ]
    ],
    [
        [
            11294,
            11294
        ],
        "mapped",
        [
            11342
        ]
    ],
    [
        [
            11295,
            11295
        ],
        "mapped",
        [
            11343
        ]
    ],
    [
        [
            11296,
            11296
        ],
        "mapped",
        [
            11344
        ]
    ],
    [
        [
            11297,
            11297
        ],
        "mapped",
        [
            11345
        ]
    ],
    [
        [
            11298,
            11298
        ],
        "mapped",
        [
            11346
        ]
    ],
    [
        [
            11299,
            11299
        ],
        "mapped",
        [
            11347
        ]
    ],
    [
        [
            11300,
            11300
        ],
        "mapped",
        [
            11348
        ]
    ],
    [
        [
            11301,
            11301
        ],
        "mapped",
        [
            11349
        ]
    ],
    [
        [
            11302,
            11302
        ],
        "mapped",
        [
            11350
        ]
    ],
    [
        [
            11303,
            11303
        ],
        "mapped",
        [
            11351
        ]
    ],
    [
        [
            11304,
            11304
        ],
        "mapped",
        [
            11352
        ]
    ],
    [
        [
            11305,
            11305
        ],
        "mapped",
        [
            11353
        ]
    ],
    [
        [
            11306,
            11306
        ],
        "mapped",
        [
            11354
        ]
    ],
    [
        [
            11307,
            11307
        ],
        "mapped",
        [
            11355
        ]
    ],
    [
        [
            11308,
            11308
        ],
        "mapped",
        [
            11356
        ]
    ],
    [
        [
            11309,
            11309
        ],
        "mapped",
        [
            11357
        ]
    ],
    [
        [
            11310,
            11310
        ],
        "mapped",
        [
            11358
        ]
    ],
    [
        [
            11311,
            11311
        ],
        "disallowed"
    ],
    [
        [
            11312,
            11358
        ],
        "valid"
    ],
    [
        [
            11359,
            11359
        ],
        "disallowed"
    ],
    [
        [
            11360,
            11360
        ],
        "mapped",
        [
            11361
        ]
    ],
    [
        [
            11361,
            11361
        ],
        "valid"
    ],
    [
        [
            11362,
            11362
        ],
        "mapped",
        [
            619
        ]
    ],
    [
        [
            11363,
            11363
        ],
        "mapped",
        [
            7549
        ]
    ],
    [
        [
            11364,
            11364
        ],
        "mapped",
        [
            637
        ]
    ],
    [
        [
            11365,
            11366
        ],
        "valid"
    ],
    [
        [
            11367,
            11367
        ],
        "mapped",
        [
            11368
        ]
    ],
    [
        [
            11368,
            11368
        ],
        "valid"
    ],
    [
        [
            11369,
            11369
        ],
        "mapped",
        [
            11370
        ]
    ],
    [
        [
            11370,
            11370
        ],
        "valid"
    ],
    [
        [
            11371,
            11371
        ],
        "mapped",
        [
            11372
        ]
    ],
    [
        [
            11372,
            11372
        ],
        "valid"
    ],
    [
        [
            11373,
            11373
        ],
        "mapped",
        [
            593
        ]
    ],
    [
        [
            11374,
            11374
        ],
        "mapped",
        [
            625
        ]
    ],
    [
        [
            11375,
            11375
        ],
        "mapped",
        [
            592
        ]
    ],
    [
        [
            11376,
            11376
        ],
        "mapped",
        [
            594
        ]
    ],
    [
        [
            11377,
            11377
        ],
        "valid"
    ],
    [
        [
            11378,
            11378
        ],
        "mapped",
        [
            11379
        ]
    ],
    [
        [
            11379,
            11379
        ],
        "valid"
    ],
    [
        [
            11380,
            11380
        ],
        "valid"
    ],
    [
        [
            11381,
            11381
        ],
        "mapped",
        [
            11382
        ]
    ],
    [
        [
            11382,
            11383
        ],
        "valid"
    ],
    [
        [
            11384,
            11387
        ],
        "valid"
    ],
    [
        [
            11388,
            11388
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            11389,
            11389
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            11390,
            11390
        ],
        "mapped",
        [
            575
        ]
    ],
    [
        [
            11391,
            11391
        ],
        "mapped",
        [
            576
        ]
    ],
    [
        [
            11392,
            11392
        ],
        "mapped",
        [
            11393
        ]
    ],
    [
        [
            11393,
            11393
        ],
        "valid"
    ],
    [
        [
            11394,
            11394
        ],
        "mapped",
        [
            11395
        ]
    ],
    [
        [
            11395,
            11395
        ],
        "valid"
    ],
    [
        [
            11396,
            11396
        ],
        "mapped",
        [
            11397
        ]
    ],
    [
        [
            11397,
            11397
        ],
        "valid"
    ],
    [
        [
            11398,
            11398
        ],
        "mapped",
        [
            11399
        ]
    ],
    [
        [
            11399,
            11399
        ],
        "valid"
    ],
    [
        [
            11400,
            11400
        ],
        "mapped",
        [
            11401
        ]
    ],
    [
        [
            11401,
            11401
        ],
        "valid"
    ],
    [
        [
            11402,
            11402
        ],
        "mapped",
        [
            11403
        ]
    ],
    [
        [
            11403,
            11403
        ],
        "valid"
    ],
    [
        [
            11404,
            11404
        ],
        "mapped",
        [
            11405
        ]
    ],
    [
        [
            11405,
            11405
        ],
        "valid"
    ],
    [
        [
            11406,
            11406
        ],
        "mapped",
        [
            11407
        ]
    ],
    [
        [
            11407,
            11407
        ],
        "valid"
    ],
    [
        [
            11408,
            11408
        ],
        "mapped",
        [
            11409
        ]
    ],
    [
        [
            11409,
            11409
        ],
        "valid"
    ],
    [
        [
            11410,
            11410
        ],
        "mapped",
        [
            11411
        ]
    ],
    [
        [
            11411,
            11411
        ],
        "valid"
    ],
    [
        [
            11412,
            11412
        ],
        "mapped",
        [
            11413
        ]
    ],
    [
        [
            11413,
            11413
        ],
        "valid"
    ],
    [
        [
            11414,
            11414
        ],
        "mapped",
        [
            11415
        ]
    ],
    [
        [
            11415,
            11415
        ],
        "valid"
    ],
    [
        [
            11416,
            11416
        ],
        "mapped",
        [
            11417
        ]
    ],
    [
        [
            11417,
            11417
        ],
        "valid"
    ],
    [
        [
            11418,
            11418
        ],
        "mapped",
        [
            11419
        ]
    ],
    [
        [
            11419,
            11419
        ],
        "valid"
    ],
    [
        [
            11420,
            11420
        ],
        "mapped",
        [
            11421
        ]
    ],
    [
        [
            11421,
            11421
        ],
        "valid"
    ],
    [
        [
            11422,
            11422
        ],
        "mapped",
        [
            11423
        ]
    ],
    [
        [
            11423,
            11423
        ],
        "valid"
    ],
    [
        [
            11424,
            11424
        ],
        "mapped",
        [
            11425
        ]
    ],
    [
        [
            11425,
            11425
        ],
        "valid"
    ],
    [
        [
            11426,
            11426
        ],
        "mapped",
        [
            11427
        ]
    ],
    [
        [
            11427,
            11427
        ],
        "valid"
    ],
    [
        [
            11428,
            11428
        ],
        "mapped",
        [
            11429
        ]
    ],
    [
        [
            11429,
            11429
        ],
        "valid"
    ],
    [
        [
            11430,
            11430
        ],
        "mapped",
        [
            11431
        ]
    ],
    [
        [
            11431,
            11431
        ],
        "valid"
    ],
    [
        [
            11432,
            11432
        ],
        "mapped",
        [
            11433
        ]
    ],
    [
        [
            11433,
            11433
        ],
        "valid"
    ],
    [
        [
            11434,
            11434
        ],
        "mapped",
        [
            11435
        ]
    ],
    [
        [
            11435,
            11435
        ],
        "valid"
    ],
    [
        [
            11436,
            11436
        ],
        "mapped",
        [
            11437
        ]
    ],
    [
        [
            11437,
            11437
        ],
        "valid"
    ],
    [
        [
            11438,
            11438
        ],
        "mapped",
        [
            11439
        ]
    ],
    [
        [
            11439,
            11439
        ],
        "valid"
    ],
    [
        [
            11440,
            11440
        ],
        "mapped",
        [
            11441
        ]
    ],
    [
        [
            11441,
            11441
        ],
        "valid"
    ],
    [
        [
            11442,
            11442
        ],
        "mapped",
        [
            11443
        ]
    ],
    [
        [
            11443,
            11443
        ],
        "valid"
    ],
    [
        [
            11444,
            11444
        ],
        "mapped",
        [
            11445
        ]
    ],
    [
        [
            11445,
            11445
        ],
        "valid"
    ],
    [
        [
            11446,
            11446
        ],
        "mapped",
        [
            11447
        ]
    ],
    [
        [
            11447,
            11447
        ],
        "valid"
    ],
    [
        [
            11448,
            11448
        ],
        "mapped",
        [
            11449
        ]
    ],
    [
        [
            11449,
            11449
        ],
        "valid"
    ],
    [
        [
            11450,
            11450
        ],
        "mapped",
        [
            11451
        ]
    ],
    [
        [
            11451,
            11451
        ],
        "valid"
    ],
    [
        [
            11452,
            11452
        ],
        "mapped",
        [
            11453
        ]
    ],
    [
        [
            11453,
            11453
        ],
        "valid"
    ],
    [
        [
            11454,
            11454
        ],
        "mapped",
        [
            11455
        ]
    ],
    [
        [
            11455,
            11455
        ],
        "valid"
    ],
    [
        [
            11456,
            11456
        ],
        "mapped",
        [
            11457
        ]
    ],
    [
        [
            11457,
            11457
        ],
        "valid"
    ],
    [
        [
            11458,
            11458
        ],
        "mapped",
        [
            11459
        ]
    ],
    [
        [
            11459,
            11459
        ],
        "valid"
    ],
    [
        [
            11460,
            11460
        ],
        "mapped",
        [
            11461
        ]
    ],
    [
        [
            11461,
            11461
        ],
        "valid"
    ],
    [
        [
            11462,
            11462
        ],
        "mapped",
        [
            11463
        ]
    ],
    [
        [
            11463,
            11463
        ],
        "valid"
    ],
    [
        [
            11464,
            11464
        ],
        "mapped",
        [
            11465
        ]
    ],
    [
        [
            11465,
            11465
        ],
        "valid"
    ],
    [
        [
            11466,
            11466
        ],
        "mapped",
        [
            11467
        ]
    ],
    [
        [
            11467,
            11467
        ],
        "valid"
    ],
    [
        [
            11468,
            11468
        ],
        "mapped",
        [
            11469
        ]
    ],
    [
        [
            11469,
            11469
        ],
        "valid"
    ],
    [
        [
            11470,
            11470
        ],
        "mapped",
        [
            11471
        ]
    ],
    [
        [
            11471,
            11471
        ],
        "valid"
    ],
    [
        [
            11472,
            11472
        ],
        "mapped",
        [
            11473
        ]
    ],
    [
        [
            11473,
            11473
        ],
        "valid"
    ],
    [
        [
            11474,
            11474
        ],
        "mapped",
        [
            11475
        ]
    ],
    [
        [
            11475,
            11475
        ],
        "valid"
    ],
    [
        [
            11476,
            11476
        ],
        "mapped",
        [
            11477
        ]
    ],
    [
        [
            11477,
            11477
        ],
        "valid"
    ],
    [
        [
            11478,
            11478
        ],
        "mapped",
        [
            11479
        ]
    ],
    [
        [
            11479,
            11479
        ],
        "valid"
    ],
    [
        [
            11480,
            11480
        ],
        "mapped",
        [
            11481
        ]
    ],
    [
        [
            11481,
            11481
        ],
        "valid"
    ],
    [
        [
            11482,
            11482
        ],
        "mapped",
        [
            11483
        ]
    ],
    [
        [
            11483,
            11483
        ],
        "valid"
    ],
    [
        [
            11484,
            11484
        ],
        "mapped",
        [
            11485
        ]
    ],
    [
        [
            11485,
            11485
        ],
        "valid"
    ],
    [
        [
            11486,
            11486
        ],
        "mapped",
        [
            11487
        ]
    ],
    [
        [
            11487,
            11487
        ],
        "valid"
    ],
    [
        [
            11488,
            11488
        ],
        "mapped",
        [
            11489
        ]
    ],
    [
        [
            11489,
            11489
        ],
        "valid"
    ],
    [
        [
            11490,
            11490
        ],
        "mapped",
        [
            11491
        ]
    ],
    [
        [
            11491,
            11492
        ],
        "valid"
    ],
    [
        [
            11493,
            11498
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11499,
            11499
        ],
        "mapped",
        [
            11500
        ]
    ],
    [
        [
            11500,
            11500
        ],
        "valid"
    ],
    [
        [
            11501,
            11501
        ],
        "mapped",
        [
            11502
        ]
    ],
    [
        [
            11502,
            11505
        ],
        "valid"
    ],
    [
        [
            11506,
            11506
        ],
        "mapped",
        [
            11507
        ]
    ],
    [
        [
            11507,
            11507
        ],
        "valid"
    ],
    [
        [
            11508,
            11512
        ],
        "disallowed"
    ],
    [
        [
            11513,
            11519
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11520,
            11557
        ],
        "valid"
    ],
    [
        [
            11558,
            11558
        ],
        "disallowed"
    ],
    [
        [
            11559,
            11559
        ],
        "valid"
    ],
    [
        [
            11560,
            11564
        ],
        "disallowed"
    ],
    [
        [
            11565,
            11565
        ],
        "valid"
    ],
    [
        [
            11566,
            11567
        ],
        "disallowed"
    ],
    [
        [
            11568,
            11621
        ],
        "valid"
    ],
    [
        [
            11622,
            11623
        ],
        "valid"
    ],
    [
        [
            11624,
            11630
        ],
        "disallowed"
    ],
    [
        [
            11631,
            11631
        ],
        "mapped",
        [
            11617
        ]
    ],
    [
        [
            11632,
            11632
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11633,
            11646
        ],
        "disallowed"
    ],
    [
        [
            11647,
            11647
        ],
        "valid"
    ],
    [
        [
            11648,
            11670
        ],
        "valid"
    ],
    [
        [
            11671,
            11679
        ],
        "disallowed"
    ],
    [
        [
            11680,
            11686
        ],
        "valid"
    ],
    [
        [
            11687,
            11687
        ],
        "disallowed"
    ],
    [
        [
            11688,
            11694
        ],
        "valid"
    ],
    [
        [
            11695,
            11695
        ],
        "disallowed"
    ],
    [
        [
            11696,
            11702
        ],
        "valid"
    ],
    [
        [
            11703,
            11703
        ],
        "disallowed"
    ],
    [
        [
            11704,
            11710
        ],
        "valid"
    ],
    [
        [
            11711,
            11711
        ],
        "disallowed"
    ],
    [
        [
            11712,
            11718
        ],
        "valid"
    ],
    [
        [
            11719,
            11719
        ],
        "disallowed"
    ],
    [
        [
            11720,
            11726
        ],
        "valid"
    ],
    [
        [
            11727,
            11727
        ],
        "disallowed"
    ],
    [
        [
            11728,
            11734
        ],
        "valid"
    ],
    [
        [
            11735,
            11735
        ],
        "disallowed"
    ],
    [
        [
            11736,
            11742
        ],
        "valid"
    ],
    [
        [
            11743,
            11743
        ],
        "disallowed"
    ],
    [
        [
            11744,
            11775
        ],
        "valid"
    ],
    [
        [
            11776,
            11799
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11800,
            11803
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11804,
            11805
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11806,
            11822
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11823,
            11823
        ],
        "valid"
    ],
    [
        [
            11824,
            11824
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11825,
            11825
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11826,
            11835
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11836,
            11842
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11843,
            11903
        ],
        "disallowed"
    ],
    [
        [
            11904,
            11929
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11930,
            11930
        ],
        "disallowed"
    ],
    [
        [
            11931,
            11934
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            11935,
            11935
        ],
        "mapped",
        [
            27597
        ]
    ],
    [
        [
            11936,
            12018
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12019,
            12019
        ],
        "mapped",
        [
            40863
        ]
    ],
    [
        [
            12020,
            12031
        ],
        "disallowed"
    ],
    [
        [
            12032,
            12032
        ],
        "mapped",
        [
            19968
        ]
    ],
    [
        [
            12033,
            12033
        ],
        "mapped",
        [
            20008
        ]
    ],
    [
        [
            12034,
            12034
        ],
        "mapped",
        [
            20022
        ]
    ],
    [
        [
            12035,
            12035
        ],
        "mapped",
        [
            20031
        ]
    ],
    [
        [
            12036,
            12036
        ],
        "mapped",
        [
            20057
        ]
    ],
    [
        [
            12037,
            12037
        ],
        "mapped",
        [
            20101
        ]
    ],
    [
        [
            12038,
            12038
        ],
        "mapped",
        [
            20108
        ]
    ],
    [
        [
            12039,
            12039
        ],
        "mapped",
        [
            20128
        ]
    ],
    [
        [
            12040,
            12040
        ],
        "mapped",
        [
            20154
        ]
    ],
    [
        [
            12041,
            12041
        ],
        "mapped",
        [
            20799
        ]
    ],
    [
        [
            12042,
            12042
        ],
        "mapped",
        [
            20837
        ]
    ],
    [
        [
            12043,
            12043
        ],
        "mapped",
        [
            20843
        ]
    ],
    [
        [
            12044,
            12044
        ],
        "mapped",
        [
            20866
        ]
    ],
    [
        [
            12045,
            12045
        ],
        "mapped",
        [
            20886
        ]
    ],
    [
        [
            12046,
            12046
        ],
        "mapped",
        [
            20907
        ]
    ],
    [
        [
            12047,
            12047
        ],
        "mapped",
        [
            20960
        ]
    ],
    [
        [
            12048,
            12048
        ],
        "mapped",
        [
            20981
        ]
    ],
    [
        [
            12049,
            12049
        ],
        "mapped",
        [
            20992
        ]
    ],
    [
        [
            12050,
            12050
        ],
        "mapped",
        [
            21147
        ]
    ],
    [
        [
            12051,
            12051
        ],
        "mapped",
        [
            21241
        ]
    ],
    [
        [
            12052,
            12052
        ],
        "mapped",
        [
            21269
        ]
    ],
    [
        [
            12053,
            12053
        ],
        "mapped",
        [
            21274
        ]
    ],
    [
        [
            12054,
            12054
        ],
        "mapped",
        [
            21304
        ]
    ],
    [
        [
            12055,
            12055
        ],
        "mapped",
        [
            21313
        ]
    ],
    [
        [
            12056,
            12056
        ],
        "mapped",
        [
            21340
        ]
    ],
    [
        [
            12057,
            12057
        ],
        "mapped",
        [
            21353
        ]
    ],
    [
        [
            12058,
            12058
        ],
        "mapped",
        [
            21378
        ]
    ],
    [
        [
            12059,
            12059
        ],
        "mapped",
        [
            21430
        ]
    ],
    [
        [
            12060,
            12060
        ],
        "mapped",
        [
            21448
        ]
    ],
    [
        [
            12061,
            12061
        ],
        "mapped",
        [
            21475
        ]
    ],
    [
        [
            12062,
            12062
        ],
        "mapped",
        [
            22231
        ]
    ],
    [
        [
            12063,
            12063
        ],
        "mapped",
        [
            22303
        ]
    ],
    [
        [
            12064,
            12064
        ],
        "mapped",
        [
            22763
        ]
    ],
    [
        [
            12065,
            12065
        ],
        "mapped",
        [
            22786
        ]
    ],
    [
        [
            12066,
            12066
        ],
        "mapped",
        [
            22794
        ]
    ],
    [
        [
            12067,
            12067
        ],
        "mapped",
        [
            22805
        ]
    ],
    [
        [
            12068,
            12068
        ],
        "mapped",
        [
            22823
        ]
    ],
    [
        [
            12069,
            12069
        ],
        "mapped",
        [
            22899
        ]
    ],
    [
        [
            12070,
            12070
        ],
        "mapped",
        [
            23376
        ]
    ],
    [
        [
            12071,
            12071
        ],
        "mapped",
        [
            23424
        ]
    ],
    [
        [
            12072,
            12072
        ],
        "mapped",
        [
            23544
        ]
    ],
    [
        [
            12073,
            12073
        ],
        "mapped",
        [
            23567
        ]
    ],
    [
        [
            12074,
            12074
        ],
        "mapped",
        [
            23586
        ]
    ],
    [
        [
            12075,
            12075
        ],
        "mapped",
        [
            23608
        ]
    ],
    [
        [
            12076,
            12076
        ],
        "mapped",
        [
            23662
        ]
    ],
    [
        [
            12077,
            12077
        ],
        "mapped",
        [
            23665
        ]
    ],
    [
        [
            12078,
            12078
        ],
        "mapped",
        [
            24027
        ]
    ],
    [
        [
            12079,
            12079
        ],
        "mapped",
        [
            24037
        ]
    ],
    [
        [
            12080,
            12080
        ],
        "mapped",
        [
            24049
        ]
    ],
    [
        [
            12081,
            12081
        ],
        "mapped",
        [
            24062
        ]
    ],
    [
        [
            12082,
            12082
        ],
        "mapped",
        [
            24178
        ]
    ],
    [
        [
            12083,
            12083
        ],
        "mapped",
        [
            24186
        ]
    ],
    [
        [
            12084,
            12084
        ],
        "mapped",
        [
            24191
        ]
    ],
    [
        [
            12085,
            12085
        ],
        "mapped",
        [
            24308
        ]
    ],
    [
        [
            12086,
            12086
        ],
        "mapped",
        [
            24318
        ]
    ],
    [
        [
            12087,
            12087
        ],
        "mapped",
        [
            24331
        ]
    ],
    [
        [
            12088,
            12088
        ],
        "mapped",
        [
            24339
        ]
    ],
    [
        [
            12089,
            12089
        ],
        "mapped",
        [
            24400
        ]
    ],
    [
        [
            12090,
            12090
        ],
        "mapped",
        [
            24417
        ]
    ],
    [
        [
            12091,
            12091
        ],
        "mapped",
        [
            24435
        ]
    ],
    [
        [
            12092,
            12092
        ],
        "mapped",
        [
            24515
        ]
    ],
    [
        [
            12093,
            12093
        ],
        "mapped",
        [
            25096
        ]
    ],
    [
        [
            12094,
            12094
        ],
        "mapped",
        [
            25142
        ]
    ],
    [
        [
            12095,
            12095
        ],
        "mapped",
        [
            25163
        ]
    ],
    [
        [
            12096,
            12096
        ],
        "mapped",
        [
            25903
        ]
    ],
    [
        [
            12097,
            12097
        ],
        "mapped",
        [
            25908
        ]
    ],
    [
        [
            12098,
            12098
        ],
        "mapped",
        [
            25991
        ]
    ],
    [
        [
            12099,
            12099
        ],
        "mapped",
        [
            26007
        ]
    ],
    [
        [
            12100,
            12100
        ],
        "mapped",
        [
            26020
        ]
    ],
    [
        [
            12101,
            12101
        ],
        "mapped",
        [
            26041
        ]
    ],
    [
        [
            12102,
            12102
        ],
        "mapped",
        [
            26080
        ]
    ],
    [
        [
            12103,
            12103
        ],
        "mapped",
        [
            26085
        ]
    ],
    [
        [
            12104,
            12104
        ],
        "mapped",
        [
            26352
        ]
    ],
    [
        [
            12105,
            12105
        ],
        "mapped",
        [
            26376
        ]
    ],
    [
        [
            12106,
            12106
        ],
        "mapped",
        [
            26408
        ]
    ],
    [
        [
            12107,
            12107
        ],
        "mapped",
        [
            27424
        ]
    ],
    [
        [
            12108,
            12108
        ],
        "mapped",
        [
            27490
        ]
    ],
    [
        [
            12109,
            12109
        ],
        "mapped",
        [
            27513
        ]
    ],
    [
        [
            12110,
            12110
        ],
        "mapped",
        [
            27571
        ]
    ],
    [
        [
            12111,
            12111
        ],
        "mapped",
        [
            27595
        ]
    ],
    [
        [
            12112,
            12112
        ],
        "mapped",
        [
            27604
        ]
    ],
    [
        [
            12113,
            12113
        ],
        "mapped",
        [
            27611
        ]
    ],
    [
        [
            12114,
            12114
        ],
        "mapped",
        [
            27663
        ]
    ],
    [
        [
            12115,
            12115
        ],
        "mapped",
        [
            27668
        ]
    ],
    [
        [
            12116,
            12116
        ],
        "mapped",
        [
            27700
        ]
    ],
    [
        [
            12117,
            12117
        ],
        "mapped",
        [
            28779
        ]
    ],
    [
        [
            12118,
            12118
        ],
        "mapped",
        [
            29226
        ]
    ],
    [
        [
            12119,
            12119
        ],
        "mapped",
        [
            29238
        ]
    ],
    [
        [
            12120,
            12120
        ],
        "mapped",
        [
            29243
        ]
    ],
    [
        [
            12121,
            12121
        ],
        "mapped",
        [
            29247
        ]
    ],
    [
        [
            12122,
            12122
        ],
        "mapped",
        [
            29255
        ]
    ],
    [
        [
            12123,
            12123
        ],
        "mapped",
        [
            29273
        ]
    ],
    [
        [
            12124,
            12124
        ],
        "mapped",
        [
            29275
        ]
    ],
    [
        [
            12125,
            12125
        ],
        "mapped",
        [
            29356
        ]
    ],
    [
        [
            12126,
            12126
        ],
        "mapped",
        [
            29572
        ]
    ],
    [
        [
            12127,
            12127
        ],
        "mapped",
        [
            29577
        ]
    ],
    [
        [
            12128,
            12128
        ],
        "mapped",
        [
            29916
        ]
    ],
    [
        [
            12129,
            12129
        ],
        "mapped",
        [
            29926
        ]
    ],
    [
        [
            12130,
            12130
        ],
        "mapped",
        [
            29976
        ]
    ],
    [
        [
            12131,
            12131
        ],
        "mapped",
        [
            29983
        ]
    ],
    [
        [
            12132,
            12132
        ],
        "mapped",
        [
            29992
        ]
    ],
    [
        [
            12133,
            12133
        ],
        "mapped",
        [
            30000
        ]
    ],
    [
        [
            12134,
            12134
        ],
        "mapped",
        [
            30091
        ]
    ],
    [
        [
            12135,
            12135
        ],
        "mapped",
        [
            30098
        ]
    ],
    [
        [
            12136,
            12136
        ],
        "mapped",
        [
            30326
        ]
    ],
    [
        [
            12137,
            12137
        ],
        "mapped",
        [
            30333
        ]
    ],
    [
        [
            12138,
            12138
        ],
        "mapped",
        [
            30382
        ]
    ],
    [
        [
            12139,
            12139
        ],
        "mapped",
        [
            30399
        ]
    ],
    [
        [
            12140,
            12140
        ],
        "mapped",
        [
            30446
        ]
    ],
    [
        [
            12141,
            12141
        ],
        "mapped",
        [
            30683
        ]
    ],
    [
        [
            12142,
            12142
        ],
        "mapped",
        [
            30690
        ]
    ],
    [
        [
            12143,
            12143
        ],
        "mapped",
        [
            30707
        ]
    ],
    [
        [
            12144,
            12144
        ],
        "mapped",
        [
            31034
        ]
    ],
    [
        [
            12145,
            12145
        ],
        "mapped",
        [
            31160
        ]
    ],
    [
        [
            12146,
            12146
        ],
        "mapped",
        [
            31166
        ]
    ],
    [
        [
            12147,
            12147
        ],
        "mapped",
        [
            31348
        ]
    ],
    [
        [
            12148,
            12148
        ],
        "mapped",
        [
            31435
        ]
    ],
    [
        [
            12149,
            12149
        ],
        "mapped",
        [
            31481
        ]
    ],
    [
        [
            12150,
            12150
        ],
        "mapped",
        [
            31859
        ]
    ],
    [
        [
            12151,
            12151
        ],
        "mapped",
        [
            31992
        ]
    ],
    [
        [
            12152,
            12152
        ],
        "mapped",
        [
            32566
        ]
    ],
    [
        [
            12153,
            12153
        ],
        "mapped",
        [
            32593
        ]
    ],
    [
        [
            12154,
            12154
        ],
        "mapped",
        [
            32650
        ]
    ],
    [
        [
            12155,
            12155
        ],
        "mapped",
        [
            32701
        ]
    ],
    [
        [
            12156,
            12156
        ],
        "mapped",
        [
            32769
        ]
    ],
    [
        [
            12157,
            12157
        ],
        "mapped",
        [
            32780
        ]
    ],
    [
        [
            12158,
            12158
        ],
        "mapped",
        [
            32786
        ]
    ],
    [
        [
            12159,
            12159
        ],
        "mapped",
        [
            32819
        ]
    ],
    [
        [
            12160,
            12160
        ],
        "mapped",
        [
            32895
        ]
    ],
    [
        [
            12161,
            12161
        ],
        "mapped",
        [
            32905
        ]
    ],
    [
        [
            12162,
            12162
        ],
        "mapped",
        [
            33251
        ]
    ],
    [
        [
            12163,
            12163
        ],
        "mapped",
        [
            33258
        ]
    ],
    [
        [
            12164,
            12164
        ],
        "mapped",
        [
            33267
        ]
    ],
    [
        [
            12165,
            12165
        ],
        "mapped",
        [
            33276
        ]
    ],
    [
        [
            12166,
            12166
        ],
        "mapped",
        [
            33292
        ]
    ],
    [
        [
            12167,
            12167
        ],
        "mapped",
        [
            33307
        ]
    ],
    [
        [
            12168,
            12168
        ],
        "mapped",
        [
            33311
        ]
    ],
    [
        [
            12169,
            12169
        ],
        "mapped",
        [
            33390
        ]
    ],
    [
        [
            12170,
            12170
        ],
        "mapped",
        [
            33394
        ]
    ],
    [
        [
            12171,
            12171
        ],
        "mapped",
        [
            33400
        ]
    ],
    [
        [
            12172,
            12172
        ],
        "mapped",
        [
            34381
        ]
    ],
    [
        [
            12173,
            12173
        ],
        "mapped",
        [
            34411
        ]
    ],
    [
        [
            12174,
            12174
        ],
        "mapped",
        [
            34880
        ]
    ],
    [
        [
            12175,
            12175
        ],
        "mapped",
        [
            34892
        ]
    ],
    [
        [
            12176,
            12176
        ],
        "mapped",
        [
            34915
        ]
    ],
    [
        [
            12177,
            12177
        ],
        "mapped",
        [
            35198
        ]
    ],
    [
        [
            12178,
            12178
        ],
        "mapped",
        [
            35211
        ]
    ],
    [
        [
            12179,
            12179
        ],
        "mapped",
        [
            35282
        ]
    ],
    [
        [
            12180,
            12180
        ],
        "mapped",
        [
            35328
        ]
    ],
    [
        [
            12181,
            12181
        ],
        "mapped",
        [
            35895
        ]
    ],
    [
        [
            12182,
            12182
        ],
        "mapped",
        [
            35910
        ]
    ],
    [
        [
            12183,
            12183
        ],
        "mapped",
        [
            35925
        ]
    ],
    [
        [
            12184,
            12184
        ],
        "mapped",
        [
            35960
        ]
    ],
    [
        [
            12185,
            12185
        ],
        "mapped",
        [
            35997
        ]
    ],
    [
        [
            12186,
            12186
        ],
        "mapped",
        [
            36196
        ]
    ],
    [
        [
            12187,
            12187
        ],
        "mapped",
        [
            36208
        ]
    ],
    [
        [
            12188,
            12188
        ],
        "mapped",
        [
            36275
        ]
    ],
    [
        [
            12189,
            12189
        ],
        "mapped",
        [
            36523
        ]
    ],
    [
        [
            12190,
            12190
        ],
        "mapped",
        [
            36554
        ]
    ],
    [
        [
            12191,
            12191
        ],
        "mapped",
        [
            36763
        ]
    ],
    [
        [
            12192,
            12192
        ],
        "mapped",
        [
            36784
        ]
    ],
    [
        [
            12193,
            12193
        ],
        "mapped",
        [
            36789
        ]
    ],
    [
        [
            12194,
            12194
        ],
        "mapped",
        [
            37009
        ]
    ],
    [
        [
            12195,
            12195
        ],
        "mapped",
        [
            37193
        ]
    ],
    [
        [
            12196,
            12196
        ],
        "mapped",
        [
            37318
        ]
    ],
    [
        [
            12197,
            12197
        ],
        "mapped",
        [
            37324
        ]
    ],
    [
        [
            12198,
            12198
        ],
        "mapped",
        [
            37329
        ]
    ],
    [
        [
            12199,
            12199
        ],
        "mapped",
        [
            38263
        ]
    ],
    [
        [
            12200,
            12200
        ],
        "mapped",
        [
            38272
        ]
    ],
    [
        [
            12201,
            12201
        ],
        "mapped",
        [
            38428
        ]
    ],
    [
        [
            12202,
            12202
        ],
        "mapped",
        [
            38582
        ]
    ],
    [
        [
            12203,
            12203
        ],
        "mapped",
        [
            38585
        ]
    ],
    [
        [
            12204,
            12204
        ],
        "mapped",
        [
            38632
        ]
    ],
    [
        [
            12205,
            12205
        ],
        "mapped",
        [
            38737
        ]
    ],
    [
        [
            12206,
            12206
        ],
        "mapped",
        [
            38750
        ]
    ],
    [
        [
            12207,
            12207
        ],
        "mapped",
        [
            38754
        ]
    ],
    [
        [
            12208,
            12208
        ],
        "mapped",
        [
            38761
        ]
    ],
    [
        [
            12209,
            12209
        ],
        "mapped",
        [
            38859
        ]
    ],
    [
        [
            12210,
            12210
        ],
        "mapped",
        [
            38893
        ]
    ],
    [
        [
            12211,
            12211
        ],
        "mapped",
        [
            38899
        ]
    ],
    [
        [
            12212,
            12212
        ],
        "mapped",
        [
            38913
        ]
    ],
    [
        [
            12213,
            12213
        ],
        "mapped",
        [
            39080
        ]
    ],
    [
        [
            12214,
            12214
        ],
        "mapped",
        [
            39131
        ]
    ],
    [
        [
            12215,
            12215
        ],
        "mapped",
        [
            39135
        ]
    ],
    [
        [
            12216,
            12216
        ],
        "mapped",
        [
            39318
        ]
    ],
    [
        [
            12217,
            12217
        ],
        "mapped",
        [
            39321
        ]
    ],
    [
        [
            12218,
            12218
        ],
        "mapped",
        [
            39340
        ]
    ],
    [
        [
            12219,
            12219
        ],
        "mapped",
        [
            39592
        ]
    ],
    [
        [
            12220,
            12220
        ],
        "mapped",
        [
            39640
        ]
    ],
    [
        [
            12221,
            12221
        ],
        "mapped",
        [
            39647
        ]
    ],
    [
        [
            12222,
            12222
        ],
        "mapped",
        [
            39717
        ]
    ],
    [
        [
            12223,
            12223
        ],
        "mapped",
        [
            39727
        ]
    ],
    [
        [
            12224,
            12224
        ],
        "mapped",
        [
            39730
        ]
    ],
    [
        [
            12225,
            12225
        ],
        "mapped",
        [
            39740
        ]
    ],
    [
        [
            12226,
            12226
        ],
        "mapped",
        [
            39770
        ]
    ],
    [
        [
            12227,
            12227
        ],
        "mapped",
        [
            40165
        ]
    ],
    [
        [
            12228,
            12228
        ],
        "mapped",
        [
            40565
        ]
    ],
    [
        [
            12229,
            12229
        ],
        "mapped",
        [
            40575
        ]
    ],
    [
        [
            12230,
            12230
        ],
        "mapped",
        [
            40613
        ]
    ],
    [
        [
            12231,
            12231
        ],
        "mapped",
        [
            40635
        ]
    ],
    [
        [
            12232,
            12232
        ],
        "mapped",
        [
            40643
        ]
    ],
    [
        [
            12233,
            12233
        ],
        "mapped",
        [
            40653
        ]
    ],
    [
        [
            12234,
            12234
        ],
        "mapped",
        [
            40657
        ]
    ],
    [
        [
            12235,
            12235
        ],
        "mapped",
        [
            40697
        ]
    ],
    [
        [
            12236,
            12236
        ],
        "mapped",
        [
            40701
        ]
    ],
    [
        [
            12237,
            12237
        ],
        "mapped",
        [
            40718
        ]
    ],
    [
        [
            12238,
            12238
        ],
        "mapped",
        [
            40723
        ]
    ],
    [
        [
            12239,
            12239
        ],
        "mapped",
        [
            40736
        ]
    ],
    [
        [
            12240,
            12240
        ],
        "mapped",
        [
            40763
        ]
    ],
    [
        [
            12241,
            12241
        ],
        "mapped",
        [
            40778
        ]
    ],
    [
        [
            12242,
            12242
        ],
        "mapped",
        [
            40786
        ]
    ],
    [
        [
            12243,
            12243
        ],
        "mapped",
        [
            40845
        ]
    ],
    [
        [
            12244,
            12244
        ],
        "mapped",
        [
            40860
        ]
    ],
    [
        [
            12245,
            12245
        ],
        "mapped",
        [
            40864
        ]
    ],
    [
        [
            12246,
            12271
        ],
        "disallowed"
    ],
    [
        [
            12272,
            12283
        ],
        "disallowed"
    ],
    [
        [
            12284,
            12287
        ],
        "disallowed"
    ],
    [
        [
            12288,
            12288
        ],
        "disallowed_STD3_mapped",
        [
            32
        ]
    ],
    [
        [
            12289,
            12289
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12290,
            12290
        ],
        "mapped",
        [
            46
        ]
    ],
    [
        [
            12291,
            12292
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12293,
            12295
        ],
        "valid"
    ],
    [
        [
            12296,
            12329
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12330,
            12333
        ],
        "valid"
    ],
    [
        [
            12334,
            12341
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12342,
            12342
        ],
        "mapped",
        [
            12306
        ]
    ],
    [
        [
            12343,
            12343
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12344,
            12344
        ],
        "mapped",
        [
            21313
        ]
    ],
    [
        [
            12345,
            12345
        ],
        "mapped",
        [
            21316
        ]
    ],
    [
        [
            12346,
            12346
        ],
        "mapped",
        [
            21317
        ]
    ],
    [
        [
            12347,
            12347
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12348,
            12348
        ],
        "valid"
    ],
    [
        [
            12349,
            12349
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12350,
            12350
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12351,
            12351
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12352,
            12352
        ],
        "disallowed"
    ],
    [
        [
            12353,
            12436
        ],
        "valid"
    ],
    [
        [
            12437,
            12438
        ],
        "valid"
    ],
    [
        [
            12439,
            12440
        ],
        "disallowed"
    ],
    [
        [
            12441,
            12442
        ],
        "valid"
    ],
    [
        [
            12443,
            12443
        ],
        "disallowed_STD3_mapped",
        [
            32,
            12441
        ]
    ],
    [
        [
            12444,
            12444
        ],
        "disallowed_STD3_mapped",
        [
            32,
            12442
        ]
    ],
    [
        [
            12445,
            12446
        ],
        "valid"
    ],
    [
        [
            12447,
            12447
        ],
        "mapped",
        [
            12424,
            12426
        ]
    ],
    [
        [
            12448,
            12448
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12449,
            12542
        ],
        "valid"
    ],
    [
        [
            12543,
            12543
        ],
        "mapped",
        [
            12467,
            12488
        ]
    ],
    [
        [
            12544,
            12548
        ],
        "disallowed"
    ],
    [
        [
            12549,
            12588
        ],
        "valid"
    ],
    [
        [
            12589,
            12589
        ],
        "valid"
    ],
    [
        [
            12590,
            12592
        ],
        "disallowed"
    ],
    [
        [
            12593,
            12593
        ],
        "mapped",
        [
            4352
        ]
    ],
    [
        [
            12594,
            12594
        ],
        "mapped",
        [
            4353
        ]
    ],
    [
        [
            12595,
            12595
        ],
        "mapped",
        [
            4522
        ]
    ],
    [
        [
            12596,
            12596
        ],
        "mapped",
        [
            4354
        ]
    ],
    [
        [
            12597,
            12597
        ],
        "mapped",
        [
            4524
        ]
    ],
    [
        [
            12598,
            12598
        ],
        "mapped",
        [
            4525
        ]
    ],
    [
        [
            12599,
            12599
        ],
        "mapped",
        [
            4355
        ]
    ],
    [
        [
            12600,
            12600
        ],
        "mapped",
        [
            4356
        ]
    ],
    [
        [
            12601,
            12601
        ],
        "mapped",
        [
            4357
        ]
    ],
    [
        [
            12602,
            12602
        ],
        "mapped",
        [
            4528
        ]
    ],
    [
        [
            12603,
            12603
        ],
        "mapped",
        [
            4529
        ]
    ],
    [
        [
            12604,
            12604
        ],
        "mapped",
        [
            4530
        ]
    ],
    [
        [
            12605,
            12605
        ],
        "mapped",
        [
            4531
        ]
    ],
    [
        [
            12606,
            12606
        ],
        "mapped",
        [
            4532
        ]
    ],
    [
        [
            12607,
            12607
        ],
        "mapped",
        [
            4533
        ]
    ],
    [
        [
            12608,
            12608
        ],
        "mapped",
        [
            4378
        ]
    ],
    [
        [
            12609,
            12609
        ],
        "mapped",
        [
            4358
        ]
    ],
    [
        [
            12610,
            12610
        ],
        "mapped",
        [
            4359
        ]
    ],
    [
        [
            12611,
            12611
        ],
        "mapped",
        [
            4360
        ]
    ],
    [
        [
            12612,
            12612
        ],
        "mapped",
        [
            4385
        ]
    ],
    [
        [
            12613,
            12613
        ],
        "mapped",
        [
            4361
        ]
    ],
    [
        [
            12614,
            12614
        ],
        "mapped",
        [
            4362
        ]
    ],
    [
        [
            12615,
            12615
        ],
        "mapped",
        [
            4363
        ]
    ],
    [
        [
            12616,
            12616
        ],
        "mapped",
        [
            4364
        ]
    ],
    [
        [
            12617,
            12617
        ],
        "mapped",
        [
            4365
        ]
    ],
    [
        [
            12618,
            12618
        ],
        "mapped",
        [
            4366
        ]
    ],
    [
        [
            12619,
            12619
        ],
        "mapped",
        [
            4367
        ]
    ],
    [
        [
            12620,
            12620
        ],
        "mapped",
        [
            4368
        ]
    ],
    [
        [
            12621,
            12621
        ],
        "mapped",
        [
            4369
        ]
    ],
    [
        [
            12622,
            12622
        ],
        "mapped",
        [
            4370
        ]
    ],
    [
        [
            12623,
            12623
        ],
        "mapped",
        [
            4449
        ]
    ],
    [
        [
            12624,
            12624
        ],
        "mapped",
        [
            4450
        ]
    ],
    [
        [
            12625,
            12625
        ],
        "mapped",
        [
            4451
        ]
    ],
    [
        [
            12626,
            12626
        ],
        "mapped",
        [
            4452
        ]
    ],
    [
        [
            12627,
            12627
        ],
        "mapped",
        [
            4453
        ]
    ],
    [
        [
            12628,
            12628
        ],
        "mapped",
        [
            4454
        ]
    ],
    [
        [
            12629,
            12629
        ],
        "mapped",
        [
            4455
        ]
    ],
    [
        [
            12630,
            12630
        ],
        "mapped",
        [
            4456
        ]
    ],
    [
        [
            12631,
            12631
        ],
        "mapped",
        [
            4457
        ]
    ],
    [
        [
            12632,
            12632
        ],
        "mapped",
        [
            4458
        ]
    ],
    [
        [
            12633,
            12633
        ],
        "mapped",
        [
            4459
        ]
    ],
    [
        [
            12634,
            12634
        ],
        "mapped",
        [
            4460
        ]
    ],
    [
        [
            12635,
            12635
        ],
        "mapped",
        [
            4461
        ]
    ],
    [
        [
            12636,
            12636
        ],
        "mapped",
        [
            4462
        ]
    ],
    [
        [
            12637,
            12637
        ],
        "mapped",
        [
            4463
        ]
    ],
    [
        [
            12638,
            12638
        ],
        "mapped",
        [
            4464
        ]
    ],
    [
        [
            12639,
            12639
        ],
        "mapped",
        [
            4465
        ]
    ],
    [
        [
            12640,
            12640
        ],
        "mapped",
        [
            4466
        ]
    ],
    [
        [
            12641,
            12641
        ],
        "mapped",
        [
            4467
        ]
    ],
    [
        [
            12642,
            12642
        ],
        "mapped",
        [
            4468
        ]
    ],
    [
        [
            12643,
            12643
        ],
        "mapped",
        [
            4469
        ]
    ],
    [
        [
            12644,
            12644
        ],
        "disallowed"
    ],
    [
        [
            12645,
            12645
        ],
        "mapped",
        [
            4372
        ]
    ],
    [
        [
            12646,
            12646
        ],
        "mapped",
        [
            4373
        ]
    ],
    [
        [
            12647,
            12647
        ],
        "mapped",
        [
            4551
        ]
    ],
    [
        [
            12648,
            12648
        ],
        "mapped",
        [
            4552
        ]
    ],
    [
        [
            12649,
            12649
        ],
        "mapped",
        [
            4556
        ]
    ],
    [
        [
            12650,
            12650
        ],
        "mapped",
        [
            4558
        ]
    ],
    [
        [
            12651,
            12651
        ],
        "mapped",
        [
            4563
        ]
    ],
    [
        [
            12652,
            12652
        ],
        "mapped",
        [
            4567
        ]
    ],
    [
        [
            12653,
            12653
        ],
        "mapped",
        [
            4569
        ]
    ],
    [
        [
            12654,
            12654
        ],
        "mapped",
        [
            4380
        ]
    ],
    [
        [
            12655,
            12655
        ],
        "mapped",
        [
            4573
        ]
    ],
    [
        [
            12656,
            12656
        ],
        "mapped",
        [
            4575
        ]
    ],
    [
        [
            12657,
            12657
        ],
        "mapped",
        [
            4381
        ]
    ],
    [
        [
            12658,
            12658
        ],
        "mapped",
        [
            4382
        ]
    ],
    [
        [
            12659,
            12659
        ],
        "mapped",
        [
            4384
        ]
    ],
    [
        [
            12660,
            12660
        ],
        "mapped",
        [
            4386
        ]
    ],
    [
        [
            12661,
            12661
        ],
        "mapped",
        [
            4387
        ]
    ],
    [
        [
            12662,
            12662
        ],
        "mapped",
        [
            4391
        ]
    ],
    [
        [
            12663,
            12663
        ],
        "mapped",
        [
            4393
        ]
    ],
    [
        [
            12664,
            12664
        ],
        "mapped",
        [
            4395
        ]
    ],
    [
        [
            12665,
            12665
        ],
        "mapped",
        [
            4396
        ]
    ],
    [
        [
            12666,
            12666
        ],
        "mapped",
        [
            4397
        ]
    ],
    [
        [
            12667,
            12667
        ],
        "mapped",
        [
            4398
        ]
    ],
    [
        [
            12668,
            12668
        ],
        "mapped",
        [
            4399
        ]
    ],
    [
        [
            12669,
            12669
        ],
        "mapped",
        [
            4402
        ]
    ],
    [
        [
            12670,
            12670
        ],
        "mapped",
        [
            4406
        ]
    ],
    [
        [
            12671,
            12671
        ],
        "mapped",
        [
            4416
        ]
    ],
    [
        [
            12672,
            12672
        ],
        "mapped",
        [
            4423
        ]
    ],
    [
        [
            12673,
            12673
        ],
        "mapped",
        [
            4428
        ]
    ],
    [
        [
            12674,
            12674
        ],
        "mapped",
        [
            4593
        ]
    ],
    [
        [
            12675,
            12675
        ],
        "mapped",
        [
            4594
        ]
    ],
    [
        [
            12676,
            12676
        ],
        "mapped",
        [
            4439
        ]
    ],
    [
        [
            12677,
            12677
        ],
        "mapped",
        [
            4440
        ]
    ],
    [
        [
            12678,
            12678
        ],
        "mapped",
        [
            4441
        ]
    ],
    [
        [
            12679,
            12679
        ],
        "mapped",
        [
            4484
        ]
    ],
    [
        [
            12680,
            12680
        ],
        "mapped",
        [
            4485
        ]
    ],
    [
        [
            12681,
            12681
        ],
        "mapped",
        [
            4488
        ]
    ],
    [
        [
            12682,
            12682
        ],
        "mapped",
        [
            4497
        ]
    ],
    [
        [
            12683,
            12683
        ],
        "mapped",
        [
            4498
        ]
    ],
    [
        [
            12684,
            12684
        ],
        "mapped",
        [
            4500
        ]
    ],
    [
        [
            12685,
            12685
        ],
        "mapped",
        [
            4510
        ]
    ],
    [
        [
            12686,
            12686
        ],
        "mapped",
        [
            4513
        ]
    ],
    [
        [
            12687,
            12687
        ],
        "disallowed"
    ],
    [
        [
            12688,
            12689
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12690,
            12690
        ],
        "mapped",
        [
            19968
        ]
    ],
    [
        [
            12691,
            12691
        ],
        "mapped",
        [
            20108
        ]
    ],
    [
        [
            12692,
            12692
        ],
        "mapped",
        [
            19977
        ]
    ],
    [
        [
            12693,
            12693
        ],
        "mapped",
        [
            22235
        ]
    ],
    [
        [
            12694,
            12694
        ],
        "mapped",
        [
            19978
        ]
    ],
    [
        [
            12695,
            12695
        ],
        "mapped",
        [
            20013
        ]
    ],
    [
        [
            12696,
            12696
        ],
        "mapped",
        [
            19979
        ]
    ],
    [
        [
            12697,
            12697
        ],
        "mapped",
        [
            30002
        ]
    ],
    [
        [
            12698,
            12698
        ],
        "mapped",
        [
            20057
        ]
    ],
    [
        [
            12699,
            12699
        ],
        "mapped",
        [
            19993
        ]
    ],
    [
        [
            12700,
            12700
        ],
        "mapped",
        [
            19969
        ]
    ],
    [
        [
            12701,
            12701
        ],
        "mapped",
        [
            22825
        ]
    ],
    [
        [
            12702,
            12702
        ],
        "mapped",
        [
            22320
        ]
    ],
    [
        [
            12703,
            12703
        ],
        "mapped",
        [
            20154
        ]
    ],
    [
        [
            12704,
            12727
        ],
        "valid"
    ],
    [
        [
            12728,
            12730
        ],
        "valid"
    ],
    [
        [
            12731,
            12735
        ],
        "disallowed"
    ],
    [
        [
            12736,
            12751
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12752,
            12771
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12772,
            12783
        ],
        "disallowed"
    ],
    [
        [
            12784,
            12799
        ],
        "valid"
    ],
    [
        [
            12800,
            12800
        ],
        "disallowed_STD3_mapped",
        [
            40,
            4352,
            41
        ]
    ],
    [
        [
            12801,
            12801
        ],
        "disallowed_STD3_mapped",
        [
            40,
            4354,
            41
        ]
    ],
    [
        [
            12802,
            12802
        ],
        "disallowed_STD3_mapped",
        [
            40,
            4355,
            41
        ]
    ],
    [
        [
            12803,
            12803
        ],
        "disallowed_STD3_mapped",
        [
            40,
            4357,
            41
        ]
    ],
    [
        [
            12804,
            12804
        ],
        "disallowed_STD3_mapped",
        [
            40,
            4358,
            41
        ]
    ],
    [
        [
            12805,
            12805
        ],
        "disallowed_STD3_mapped",
        [
            40,
            4359,
            41
        ]
    ],
    [
        [
            12806,
            12806
        ],
        "disallowed_STD3_mapped",
        [
            40,
            4361,
            41
        ]
    ],
    [
        [
            12807,
            12807
        ],
        "disallowed_STD3_mapped",
        [
            40,
            4363,
            41
        ]
    ],
    [
        [
            12808,
            12808
        ],
        "disallowed_STD3_mapped",
        [
            40,
            4364,
            41
        ]
    ],
    [
        [
            12809,
            12809
        ],
        "disallowed_STD3_mapped",
        [
            40,
            4366,
            41
        ]
    ],
    [
        [
            12810,
            12810
        ],
        "disallowed_STD3_mapped",
        [
            40,
            4367,
            41
        ]
    ],
    [
        [
            12811,
            12811
        ],
        "disallowed_STD3_mapped",
        [
            40,
            4368,
            41
        ]
    ],
    [
        [
            12812,
            12812
        ],
        "disallowed_STD3_mapped",
        [
            40,
            4369,
            41
        ]
    ],
    [
        [
            12813,
            12813
        ],
        "disallowed_STD3_mapped",
        [
            40,
            4370,
            41
        ]
    ],
    [
        [
            12814,
            12814
        ],
        "disallowed_STD3_mapped",
        [
            40,
            44032,
            41
        ]
    ],
    [
        [
            12815,
            12815
        ],
        "disallowed_STD3_mapped",
        [
            40,
            45208,
            41
        ]
    ],
    [
        [
            12816,
            12816
        ],
        "disallowed_STD3_mapped",
        [
            40,
            45796,
            41
        ]
    ],
    [
        [
            12817,
            12817
        ],
        "disallowed_STD3_mapped",
        [
            40,
            46972,
            41
        ]
    ],
    [
        [
            12818,
            12818
        ],
        "disallowed_STD3_mapped",
        [
            40,
            47560,
            41
        ]
    ],
    [
        [
            12819,
            12819
        ],
        "disallowed_STD3_mapped",
        [
            40,
            48148,
            41
        ]
    ],
    [
        [
            12820,
            12820
        ],
        "disallowed_STD3_mapped",
        [
            40,
            49324,
            41
        ]
    ],
    [
        [
            12821,
            12821
        ],
        "disallowed_STD3_mapped",
        [
            40,
            50500,
            41
        ]
    ],
    [
        [
            12822,
            12822
        ],
        "disallowed_STD3_mapped",
        [
            40,
            51088,
            41
        ]
    ],
    [
        [
            12823,
            12823
        ],
        "disallowed_STD3_mapped",
        [
            40,
            52264,
            41
        ]
    ],
    [
        [
            12824,
            12824
        ],
        "disallowed_STD3_mapped",
        [
            40,
            52852,
            41
        ]
    ],
    [
        [
            12825,
            12825
        ],
        "disallowed_STD3_mapped",
        [
            40,
            53440,
            41
        ]
    ],
    [
        [
            12826,
            12826
        ],
        "disallowed_STD3_mapped",
        [
            40,
            54028,
            41
        ]
    ],
    [
        [
            12827,
            12827
        ],
        "disallowed_STD3_mapped",
        [
            40,
            54616,
            41
        ]
    ],
    [
        [
            12828,
            12828
        ],
        "disallowed_STD3_mapped",
        [
            40,
            51452,
            41
        ]
    ],
    [
        [
            12829,
            12829
        ],
        "disallowed_STD3_mapped",
        [
            40,
            50724,
            51204,
            41
        ]
    ],
    [
        [
            12830,
            12830
        ],
        "disallowed_STD3_mapped",
        [
            40,
            50724,
            54980,
            41
        ]
    ],
    [
        [
            12831,
            12831
        ],
        "disallowed"
    ],
    [
        [
            12832,
            12832
        ],
        "disallowed_STD3_mapped",
        [
            40,
            19968,
            41
        ]
    ],
    [
        [
            12833,
            12833
        ],
        "disallowed_STD3_mapped",
        [
            40,
            20108,
            41
        ]
    ],
    [
        [
            12834,
            12834
        ],
        "disallowed_STD3_mapped",
        [
            40,
            19977,
            41
        ]
    ],
    [
        [
            12835,
            12835
        ],
        "disallowed_STD3_mapped",
        [
            40,
            22235,
            41
        ]
    ],
    [
        [
            12836,
            12836
        ],
        "disallowed_STD3_mapped",
        [
            40,
            20116,
            41
        ]
    ],
    [
        [
            12837,
            12837
        ],
        "disallowed_STD3_mapped",
        [
            40,
            20845,
            41
        ]
    ],
    [
        [
            12838,
            12838
        ],
        "disallowed_STD3_mapped",
        [
            40,
            19971,
            41
        ]
    ],
    [
        [
            12839,
            12839
        ],
        "disallowed_STD3_mapped",
        [
            40,
            20843,
            41
        ]
    ],
    [
        [
            12840,
            12840
        ],
        "disallowed_STD3_mapped",
        [
            40,
            20061,
            41
        ]
    ],
    [
        [
            12841,
            12841
        ],
        "disallowed_STD3_mapped",
        [
            40,
            21313,
            41
        ]
    ],
    [
        [
            12842,
            12842
        ],
        "disallowed_STD3_mapped",
        [
            40,
            26376,
            41
        ]
    ],
    [
        [
            12843,
            12843
        ],
        "disallowed_STD3_mapped",
        [
            40,
            28779,
            41
        ]
    ],
    [
        [
            12844,
            12844
        ],
        "disallowed_STD3_mapped",
        [
            40,
            27700,
            41
        ]
    ],
    [
        [
            12845,
            12845
        ],
        "disallowed_STD3_mapped",
        [
            40,
            26408,
            41
        ]
    ],
    [
        [
            12846,
            12846
        ],
        "disallowed_STD3_mapped",
        [
            40,
            37329,
            41
        ]
    ],
    [
        [
            12847,
            12847
        ],
        "disallowed_STD3_mapped",
        [
            40,
            22303,
            41
        ]
    ],
    [
        [
            12848,
            12848
        ],
        "disallowed_STD3_mapped",
        [
            40,
            26085,
            41
        ]
    ],
    [
        [
            12849,
            12849
        ],
        "disallowed_STD3_mapped",
        [
            40,
            26666,
            41
        ]
    ],
    [
        [
            12850,
            12850
        ],
        "disallowed_STD3_mapped",
        [
            40,
            26377,
            41
        ]
    ],
    [
        [
            12851,
            12851
        ],
        "disallowed_STD3_mapped",
        [
            40,
            31038,
            41
        ]
    ],
    [
        [
            12852,
            12852
        ],
        "disallowed_STD3_mapped",
        [
            40,
            21517,
            41
        ]
    ],
    [
        [
            12853,
            12853
        ],
        "disallowed_STD3_mapped",
        [
            40,
            29305,
            41
        ]
    ],
    [
        [
            12854,
            12854
        ],
        "disallowed_STD3_mapped",
        [
            40,
            36001,
            41
        ]
    ],
    [
        [
            12855,
            12855
        ],
        "disallowed_STD3_mapped",
        [
            40,
            31069,
            41
        ]
    ],
    [
        [
            12856,
            12856
        ],
        "disallowed_STD3_mapped",
        [
            40,
            21172,
            41
        ]
    ],
    [
        [
            12857,
            12857
        ],
        "disallowed_STD3_mapped",
        [
            40,
            20195,
            41
        ]
    ],
    [
        [
            12858,
            12858
        ],
        "disallowed_STD3_mapped",
        [
            40,
            21628,
            41
        ]
    ],
    [
        [
            12859,
            12859
        ],
        "disallowed_STD3_mapped",
        [
            40,
            23398,
            41
        ]
    ],
    [
        [
            12860,
            12860
        ],
        "disallowed_STD3_mapped",
        [
            40,
            30435,
            41
        ]
    ],
    [
        [
            12861,
            12861
        ],
        "disallowed_STD3_mapped",
        [
            40,
            20225,
            41
        ]
    ],
    [
        [
            12862,
            12862
        ],
        "disallowed_STD3_mapped",
        [
            40,
            36039,
            41
        ]
    ],
    [
        [
            12863,
            12863
        ],
        "disallowed_STD3_mapped",
        [
            40,
            21332,
            41
        ]
    ],
    [
        [
            12864,
            12864
        ],
        "disallowed_STD3_mapped",
        [
            40,
            31085,
            41
        ]
    ],
    [
        [
            12865,
            12865
        ],
        "disallowed_STD3_mapped",
        [
            40,
            20241,
            41
        ]
    ],
    [
        [
            12866,
            12866
        ],
        "disallowed_STD3_mapped",
        [
            40,
            33258,
            41
        ]
    ],
    [
        [
            12867,
            12867
        ],
        "disallowed_STD3_mapped",
        [
            40,
            33267,
            41
        ]
    ],
    [
        [
            12868,
            12868
        ],
        "mapped",
        [
            21839
        ]
    ],
    [
        [
            12869,
            12869
        ],
        "mapped",
        [
            24188
        ]
    ],
    [
        [
            12870,
            12870
        ],
        "mapped",
        [
            25991
        ]
    ],
    [
        [
            12871,
            12871
        ],
        "mapped",
        [
            31631
        ]
    ],
    [
        [
            12872,
            12879
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12880,
            12880
        ],
        "mapped",
        [
            112,
            116,
            101
        ]
    ],
    [
        [
            12881,
            12881
        ],
        "mapped",
        [
            50,
            49
        ]
    ],
    [
        [
            12882,
            12882
        ],
        "mapped",
        [
            50,
            50
        ]
    ],
    [
        [
            12883,
            12883
        ],
        "mapped",
        [
            50,
            51
        ]
    ],
    [
        [
            12884,
            12884
        ],
        "mapped",
        [
            50,
            52
        ]
    ],
    [
        [
            12885,
            12885
        ],
        "mapped",
        [
            50,
            53
        ]
    ],
    [
        [
            12886,
            12886
        ],
        "mapped",
        [
            50,
            54
        ]
    ],
    [
        [
            12887,
            12887
        ],
        "mapped",
        [
            50,
            55
        ]
    ],
    [
        [
            12888,
            12888
        ],
        "mapped",
        [
            50,
            56
        ]
    ],
    [
        [
            12889,
            12889
        ],
        "mapped",
        [
            50,
            57
        ]
    ],
    [
        [
            12890,
            12890
        ],
        "mapped",
        [
            51,
            48
        ]
    ],
    [
        [
            12891,
            12891
        ],
        "mapped",
        [
            51,
            49
        ]
    ],
    [
        [
            12892,
            12892
        ],
        "mapped",
        [
            51,
            50
        ]
    ],
    [
        [
            12893,
            12893
        ],
        "mapped",
        [
            51,
            51
        ]
    ],
    [
        [
            12894,
            12894
        ],
        "mapped",
        [
            51,
            52
        ]
    ],
    [
        [
            12895,
            12895
        ],
        "mapped",
        [
            51,
            53
        ]
    ],
    [
        [
            12896,
            12896
        ],
        "mapped",
        [
            4352
        ]
    ],
    [
        [
            12897,
            12897
        ],
        "mapped",
        [
            4354
        ]
    ],
    [
        [
            12898,
            12898
        ],
        "mapped",
        [
            4355
        ]
    ],
    [
        [
            12899,
            12899
        ],
        "mapped",
        [
            4357
        ]
    ],
    [
        [
            12900,
            12900
        ],
        "mapped",
        [
            4358
        ]
    ],
    [
        [
            12901,
            12901
        ],
        "mapped",
        [
            4359
        ]
    ],
    [
        [
            12902,
            12902
        ],
        "mapped",
        [
            4361
        ]
    ],
    [
        [
            12903,
            12903
        ],
        "mapped",
        [
            4363
        ]
    ],
    [
        [
            12904,
            12904
        ],
        "mapped",
        [
            4364
        ]
    ],
    [
        [
            12905,
            12905
        ],
        "mapped",
        [
            4366
        ]
    ],
    [
        [
            12906,
            12906
        ],
        "mapped",
        [
            4367
        ]
    ],
    [
        [
            12907,
            12907
        ],
        "mapped",
        [
            4368
        ]
    ],
    [
        [
            12908,
            12908
        ],
        "mapped",
        [
            4369
        ]
    ],
    [
        [
            12909,
            12909
        ],
        "mapped",
        [
            4370
        ]
    ],
    [
        [
            12910,
            12910
        ],
        "mapped",
        [
            44032
        ]
    ],
    [
        [
            12911,
            12911
        ],
        "mapped",
        [
            45208
        ]
    ],
    [
        [
            12912,
            12912
        ],
        "mapped",
        [
            45796
        ]
    ],
    [
        [
            12913,
            12913
        ],
        "mapped",
        [
            46972
        ]
    ],
    [
        [
            12914,
            12914
        ],
        "mapped",
        [
            47560
        ]
    ],
    [
        [
            12915,
            12915
        ],
        "mapped",
        [
            48148
        ]
    ],
    [
        [
            12916,
            12916
        ],
        "mapped",
        [
            49324
        ]
    ],
    [
        [
            12917,
            12917
        ],
        "mapped",
        [
            50500
        ]
    ],
    [
        [
            12918,
            12918
        ],
        "mapped",
        [
            51088
        ]
    ],
    [
        [
            12919,
            12919
        ],
        "mapped",
        [
            52264
        ]
    ],
    [
        [
            12920,
            12920
        ],
        "mapped",
        [
            52852
        ]
    ],
    [
        [
            12921,
            12921
        ],
        "mapped",
        [
            53440
        ]
    ],
    [
        [
            12922,
            12922
        ],
        "mapped",
        [
            54028
        ]
    ],
    [
        [
            12923,
            12923
        ],
        "mapped",
        [
            54616
        ]
    ],
    [
        [
            12924,
            12924
        ],
        "mapped",
        [
            52280,
            44256
        ]
    ],
    [
        [
            12925,
            12925
        ],
        "mapped",
        [
            51452,
            51032
        ]
    ],
    [
        [
            12926,
            12926
        ],
        "mapped",
        [
            50864
        ]
    ],
    [
        [
            12927,
            12927
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            12928,
            12928
        ],
        "mapped",
        [
            19968
        ]
    ],
    [
        [
            12929,
            12929
        ],
        "mapped",
        [
            20108
        ]
    ],
    [
        [
            12930,
            12930
        ],
        "mapped",
        [
            19977
        ]
    ],
    [
        [
            12931,
            12931
        ],
        "mapped",
        [
            22235
        ]
    ],
    [
        [
            12932,
            12932
        ],
        "mapped",
        [
            20116
        ]
    ],
    [
        [
            12933,
            12933
        ],
        "mapped",
        [
            20845
        ]
    ],
    [
        [
            12934,
            12934
        ],
        "mapped",
        [
            19971
        ]
    ],
    [
        [
            12935,
            12935
        ],
        "mapped",
        [
            20843
        ]
    ],
    [
        [
            12936,
            12936
        ],
        "mapped",
        [
            20061
        ]
    ],
    [
        [
            12937,
            12937
        ],
        "mapped",
        [
            21313
        ]
    ],
    [
        [
            12938,
            12938
        ],
        "mapped",
        [
            26376
        ]
    ],
    [
        [
            12939,
            12939
        ],
        "mapped",
        [
            28779
        ]
    ],
    [
        [
            12940,
            12940
        ],
        "mapped",
        [
            27700
        ]
    ],
    [
        [
            12941,
            12941
        ],
        "mapped",
        [
            26408
        ]
    ],
    [
        [
            12942,
            12942
        ],
        "mapped",
        [
            37329
        ]
    ],
    [
        [
            12943,
            12943
        ],
        "mapped",
        [
            22303
        ]
    ],
    [
        [
            12944,
            12944
        ],
        "mapped",
        [
            26085
        ]
    ],
    [
        [
            12945,
            12945
        ],
        "mapped",
        [
            26666
        ]
    ],
    [
        [
            12946,
            12946
        ],
        "mapped",
        [
            26377
        ]
    ],
    [
        [
            12947,
            12947
        ],
        "mapped",
        [
            31038
        ]
    ],
    [
        [
            12948,
            12948
        ],
        "mapped",
        [
            21517
        ]
    ],
    [
        [
            12949,
            12949
        ],
        "mapped",
        [
            29305
        ]
    ],
    [
        [
            12950,
            12950
        ],
        "mapped",
        [
            36001
        ]
    ],
    [
        [
            12951,
            12951
        ],
        "mapped",
        [
            31069
        ]
    ],
    [
        [
            12952,
            12952
        ],
        "mapped",
        [
            21172
        ]
    ],
    [
        [
            12953,
            12953
        ],
        "mapped",
        [
            31192
        ]
    ],
    [
        [
            12954,
            12954
        ],
        "mapped",
        [
            30007
        ]
    ],
    [
        [
            12955,
            12955
        ],
        "mapped",
        [
            22899
        ]
    ],
    [
        [
            12956,
            12956
        ],
        "mapped",
        [
            36969
        ]
    ],
    [
        [
            12957,
            12957
        ],
        "mapped",
        [
            20778
        ]
    ],
    [
        [
            12958,
            12958
        ],
        "mapped",
        [
            21360
        ]
    ],
    [
        [
            12959,
            12959
        ],
        "mapped",
        [
            27880
        ]
    ],
    [
        [
            12960,
            12960
        ],
        "mapped",
        [
            38917
        ]
    ],
    [
        [
            12961,
            12961
        ],
        "mapped",
        [
            20241
        ]
    ],
    [
        [
            12962,
            12962
        ],
        "mapped",
        [
            20889
        ]
    ],
    [
        [
            12963,
            12963
        ],
        "mapped",
        [
            27491
        ]
    ],
    [
        [
            12964,
            12964
        ],
        "mapped",
        [
            19978
        ]
    ],
    [
        [
            12965,
            12965
        ],
        "mapped",
        [
            20013
        ]
    ],
    [
        [
            12966,
            12966
        ],
        "mapped",
        [
            19979
        ]
    ],
    [
        [
            12967,
            12967
        ],
        "mapped",
        [
            24038
        ]
    ],
    [
        [
            12968,
            12968
        ],
        "mapped",
        [
            21491
        ]
    ],
    [
        [
            12969,
            12969
        ],
        "mapped",
        [
            21307
        ]
    ],
    [
        [
            12970,
            12970
        ],
        "mapped",
        [
            23447
        ]
    ],
    [
        [
            12971,
            12971
        ],
        "mapped",
        [
            23398
        ]
    ],
    [
        [
            12972,
            12972
        ],
        "mapped",
        [
            30435
        ]
    ],
    [
        [
            12973,
            12973
        ],
        "mapped",
        [
            20225
        ]
    ],
    [
        [
            12974,
            12974
        ],
        "mapped",
        [
            36039
        ]
    ],
    [
        [
            12975,
            12975
        ],
        "mapped",
        [
            21332
        ]
    ],
    [
        [
            12976,
            12976
        ],
        "mapped",
        [
            22812
        ]
    ],
    [
        [
            12977,
            12977
        ],
        "mapped",
        [
            51,
            54
        ]
    ],
    [
        [
            12978,
            12978
        ],
        "mapped",
        [
            51,
            55
        ]
    ],
    [
        [
            12979,
            12979
        ],
        "mapped",
        [
            51,
            56
        ]
    ],
    [
        [
            12980,
            12980
        ],
        "mapped",
        [
            51,
            57
        ]
    ],
    [
        [
            12981,
            12981
        ],
        "mapped",
        [
            52,
            48
        ]
    ],
    [
        [
            12982,
            12982
        ],
        "mapped",
        [
            52,
            49
        ]
    ],
    [
        [
            12983,
            12983
        ],
        "mapped",
        [
            52,
            50
        ]
    ],
    [
        [
            12984,
            12984
        ],
        "mapped",
        [
            52,
            51
        ]
    ],
    [
        [
            12985,
            12985
        ],
        "mapped",
        [
            52,
            52
        ]
    ],
    [
        [
            12986,
            12986
        ],
        "mapped",
        [
            52,
            53
        ]
    ],
    [
        [
            12987,
            12987
        ],
        "mapped",
        [
            52,
            54
        ]
    ],
    [
        [
            12988,
            12988
        ],
        "mapped",
        [
            52,
            55
        ]
    ],
    [
        [
            12989,
            12989
        ],
        "mapped",
        [
            52,
            56
        ]
    ],
    [
        [
            12990,
            12990
        ],
        "mapped",
        [
            52,
            57
        ]
    ],
    [
        [
            12991,
            12991
        ],
        "mapped",
        [
            53,
            48
        ]
    ],
    [
        [
            12992,
            12992
        ],
        "mapped",
        [
            49,
            26376
        ]
    ],
    [
        [
            12993,
            12993
        ],
        "mapped",
        [
            50,
            26376
        ]
    ],
    [
        [
            12994,
            12994
        ],
        "mapped",
        [
            51,
            26376
        ]
    ],
    [
        [
            12995,
            12995
        ],
        "mapped",
        [
            52,
            26376
        ]
    ],
    [
        [
            12996,
            12996
        ],
        "mapped",
        [
            53,
            26376
        ]
    ],
    [
        [
            12997,
            12997
        ],
        "mapped",
        [
            54,
            26376
        ]
    ],
    [
        [
            12998,
            12998
        ],
        "mapped",
        [
            55,
            26376
        ]
    ],
    [
        [
            12999,
            12999
        ],
        "mapped",
        [
            56,
            26376
        ]
    ],
    [
        [
            13000,
            13000
        ],
        "mapped",
        [
            57,
            26376
        ]
    ],
    [
        [
            13001,
            13001
        ],
        "mapped",
        [
            49,
            48,
            26376
        ]
    ],
    [
        [
            13002,
            13002
        ],
        "mapped",
        [
            49,
            49,
            26376
        ]
    ],
    [
        [
            13003,
            13003
        ],
        "mapped",
        [
            49,
            50,
            26376
        ]
    ],
    [
        [
            13004,
            13004
        ],
        "mapped",
        [
            104,
            103
        ]
    ],
    [
        [
            13005,
            13005
        ],
        "mapped",
        [
            101,
            114,
            103
        ]
    ],
    [
        [
            13006,
            13006
        ],
        "mapped",
        [
            101,
            118
        ]
    ],
    [
        [
            13007,
            13007
        ],
        "mapped",
        [
            108,
            116,
            100
        ]
    ],
    [
        [
            13008,
            13008
        ],
        "mapped",
        [
            12450
        ]
    ],
    [
        [
            13009,
            13009
        ],
        "mapped",
        [
            12452
        ]
    ],
    [
        [
            13010,
            13010
        ],
        "mapped",
        [
            12454
        ]
    ],
    [
        [
            13011,
            13011
        ],
        "mapped",
        [
            12456
        ]
    ],
    [
        [
            13012,
            13012
        ],
        "mapped",
        [
            12458
        ]
    ],
    [
        [
            13013,
            13013
        ],
        "mapped",
        [
            12459
        ]
    ],
    [
        [
            13014,
            13014
        ],
        "mapped",
        [
            12461
        ]
    ],
    [
        [
            13015,
            13015
        ],
        "mapped",
        [
            12463
        ]
    ],
    [
        [
            13016,
            13016
        ],
        "mapped",
        [
            12465
        ]
    ],
    [
        [
            13017,
            13017
        ],
        "mapped",
        [
            12467
        ]
    ],
    [
        [
            13018,
            13018
        ],
        "mapped",
        [
            12469
        ]
    ],
    [
        [
            13019,
            13019
        ],
        "mapped",
        [
            12471
        ]
    ],
    [
        [
            13020,
            13020
        ],
        "mapped",
        [
            12473
        ]
    ],
    [
        [
            13021,
            13021
        ],
        "mapped",
        [
            12475
        ]
    ],
    [
        [
            13022,
            13022
        ],
        "mapped",
        [
            12477
        ]
    ],
    [
        [
            13023,
            13023
        ],
        "mapped",
        [
            12479
        ]
    ],
    [
        [
            13024,
            13024
        ],
        "mapped",
        [
            12481
        ]
    ],
    [
        [
            13025,
            13025
        ],
        "mapped",
        [
            12484
        ]
    ],
    [
        [
            13026,
            13026
        ],
        "mapped",
        [
            12486
        ]
    ],
    [
        [
            13027,
            13027
        ],
        "mapped",
        [
            12488
        ]
    ],
    [
        [
            13028,
            13028
        ],
        "mapped",
        [
            12490
        ]
    ],
    [
        [
            13029,
            13029
        ],
        "mapped",
        [
            12491
        ]
    ],
    [
        [
            13030,
            13030
        ],
        "mapped",
        [
            12492
        ]
    ],
    [
        [
            13031,
            13031
        ],
        "mapped",
        [
            12493
        ]
    ],
    [
        [
            13032,
            13032
        ],
        "mapped",
        [
            12494
        ]
    ],
    [
        [
            13033,
            13033
        ],
        "mapped",
        [
            12495
        ]
    ],
    [
        [
            13034,
            13034
        ],
        "mapped",
        [
            12498
        ]
    ],
    [
        [
            13035,
            13035
        ],
        "mapped",
        [
            12501
        ]
    ],
    [
        [
            13036,
            13036
        ],
        "mapped",
        [
            12504
        ]
    ],
    [
        [
            13037,
            13037
        ],
        "mapped",
        [
            12507
        ]
    ],
    [
        [
            13038,
            13038
        ],
        "mapped",
        [
            12510
        ]
    ],
    [
        [
            13039,
            13039
        ],
        "mapped",
        [
            12511
        ]
    ],
    [
        [
            13040,
            13040
        ],
        "mapped",
        [
            12512
        ]
    ],
    [
        [
            13041,
            13041
        ],
        "mapped",
        [
            12513
        ]
    ],
    [
        [
            13042,
            13042
        ],
        "mapped",
        [
            12514
        ]
    ],
    [
        [
            13043,
            13043
        ],
        "mapped",
        [
            12516
        ]
    ],
    [
        [
            13044,
            13044
        ],
        "mapped",
        [
            12518
        ]
    ],
    [
        [
            13045,
            13045
        ],
        "mapped",
        [
            12520
        ]
    ],
    [
        [
            13046,
            13046
        ],
        "mapped",
        [
            12521
        ]
    ],
    [
        [
            13047,
            13047
        ],
        "mapped",
        [
            12522
        ]
    ],
    [
        [
            13048,
            13048
        ],
        "mapped",
        [
            12523
        ]
    ],
    [
        [
            13049,
            13049
        ],
        "mapped",
        [
            12524
        ]
    ],
    [
        [
            13050,
            13050
        ],
        "mapped",
        [
            12525
        ]
    ],
    [
        [
            13051,
            13051
        ],
        "mapped",
        [
            12527
        ]
    ],
    [
        [
            13052,
            13052
        ],
        "mapped",
        [
            12528
        ]
    ],
    [
        [
            13053,
            13053
        ],
        "mapped",
        [
            12529
        ]
    ],
    [
        [
            13054,
            13054
        ],
        "mapped",
        [
            12530
        ]
    ],
    [
        [
            13055,
            13055
        ],
        "disallowed"
    ],
    [
        [
            13056,
            13056
        ],
        "mapped",
        [
            12450,
            12497,
            12540,
            12488
        ]
    ],
    [
        [
            13057,
            13057
        ],
        "mapped",
        [
            12450,
            12523,
            12501,
            12449
        ]
    ],
    [
        [
            13058,
            13058
        ],
        "mapped",
        [
            12450,
            12531,
            12506,
            12450
        ]
    ],
    [
        [
            13059,
            13059
        ],
        "mapped",
        [
            12450,
            12540,
            12523
        ]
    ],
    [
        [
            13060,
            13060
        ],
        "mapped",
        [
            12452,
            12491,
            12531,
            12464
        ]
    ],
    [
        [
            13061,
            13061
        ],
        "mapped",
        [
            12452,
            12531,
            12481
        ]
    ],
    [
        [
            13062,
            13062
        ],
        "mapped",
        [
            12454,
            12457,
            12531
        ]
    ],
    [
        [
            13063,
            13063
        ],
        "mapped",
        [
            12456,
            12473,
            12463,
            12540,
            12489
        ]
    ],
    [
        [
            13064,
            13064
        ],
        "mapped",
        [
            12456,
            12540,
            12459,
            12540
        ]
    ],
    [
        [
            13065,
            13065
        ],
        "mapped",
        [
            12458,
            12531,
            12473
        ]
    ],
    [
        [
            13066,
            13066
        ],
        "mapped",
        [
            12458,
            12540,
            12512
        ]
    ],
    [
        [
            13067,
            13067
        ],
        "mapped",
        [
            12459,
            12452,
            12522
        ]
    ],
    [
        [
            13068,
            13068
        ],
        "mapped",
        [
            12459,
            12521,
            12483,
            12488
        ]
    ],
    [
        [
            13069,
            13069
        ],
        "mapped",
        [
            12459,
            12525,
            12522,
            12540
        ]
    ],
    [
        [
            13070,
            13070
        ],
        "mapped",
        [
            12460,
            12525,
            12531
        ]
    ],
    [
        [
            13071,
            13071
        ],
        "mapped",
        [
            12460,
            12531,
            12510
        ]
    ],
    [
        [
            13072,
            13072
        ],
        "mapped",
        [
            12462,
            12460
        ]
    ],
    [
        [
            13073,
            13073
        ],
        "mapped",
        [
            12462,
            12491,
            12540
        ]
    ],
    [
        [
            13074,
            13074
        ],
        "mapped",
        [
            12461,
            12517,
            12522,
            12540
        ]
    ],
    [
        [
            13075,
            13075
        ],
        "mapped",
        [
            12462,
            12523,
            12480,
            12540
        ]
    ],
    [
        [
            13076,
            13076
        ],
        "mapped",
        [
            12461,
            12525
        ]
    ],
    [
        [
            13077,
            13077
        ],
        "mapped",
        [
            12461,
            12525,
            12464,
            12521,
            12512
        ]
    ],
    [
        [
            13078,
            13078
        ],
        "mapped",
        [
            12461,
            12525,
            12513,
            12540,
            12488,
            12523
        ]
    ],
    [
        [
            13079,
            13079
        ],
        "mapped",
        [
            12461,
            12525,
            12527,
            12483,
            12488
        ]
    ],
    [
        [
            13080,
            13080
        ],
        "mapped",
        [
            12464,
            12521,
            12512
        ]
    ],
    [
        [
            13081,
            13081
        ],
        "mapped",
        [
            12464,
            12521,
            12512,
            12488,
            12531
        ]
    ],
    [
        [
            13082,
            13082
        ],
        "mapped",
        [
            12463,
            12523,
            12476,
            12452,
            12525
        ]
    ],
    [
        [
            13083,
            13083
        ],
        "mapped",
        [
            12463,
            12525,
            12540,
            12493
        ]
    ],
    [
        [
            13084,
            13084
        ],
        "mapped",
        [
            12465,
            12540,
            12473
        ]
    ],
    [
        [
            13085,
            13085
        ],
        "mapped",
        [
            12467,
            12523,
            12490
        ]
    ],
    [
        [
            13086,
            13086
        ],
        "mapped",
        [
            12467,
            12540,
            12509
        ]
    ],
    [
        [
            13087,
            13087
        ],
        "mapped",
        [
            12469,
            12452,
            12463,
            12523
        ]
    ],
    [
        [
            13088,
            13088
        ],
        "mapped",
        [
            12469,
            12531,
            12481,
            12540,
            12512
        ]
    ],
    [
        [
            13089,
            13089
        ],
        "mapped",
        [
            12471,
            12522,
            12531,
            12464
        ]
    ],
    [
        [
            13090,
            13090
        ],
        "mapped",
        [
            12475,
            12531,
            12481
        ]
    ],
    [
        [
            13091,
            13091
        ],
        "mapped",
        [
            12475,
            12531,
            12488
        ]
    ],
    [
        [
            13092,
            13092
        ],
        "mapped",
        [
            12480,
            12540,
            12473
        ]
    ],
    [
        [
            13093,
            13093
        ],
        "mapped",
        [
            12487,
            12471
        ]
    ],
    [
        [
            13094,
            13094
        ],
        "mapped",
        [
            12489,
            12523
        ]
    ],
    [
        [
            13095,
            13095
        ],
        "mapped",
        [
            12488,
            12531
        ]
    ],
    [
        [
            13096,
            13096
        ],
        "mapped",
        [
            12490,
            12494
        ]
    ],
    [
        [
            13097,
            13097
        ],
        "mapped",
        [
            12494,
            12483,
            12488
        ]
    ],
    [
        [
            13098,
            13098
        ],
        "mapped",
        [
            12495,
            12452,
            12484
        ]
    ],
    [
        [
            13099,
            13099
        ],
        "mapped",
        [
            12497,
            12540,
            12475,
            12531,
            12488
        ]
    ],
    [
        [
            13100,
            13100
        ],
        "mapped",
        [
            12497,
            12540,
            12484
        ]
    ],
    [
        [
            13101,
            13101
        ],
        "mapped",
        [
            12496,
            12540,
            12524,
            12523
        ]
    ],
    [
        [
            13102,
            13102
        ],
        "mapped",
        [
            12500,
            12450,
            12473,
            12488,
            12523
        ]
    ],
    [
        [
            13103,
            13103
        ],
        "mapped",
        [
            12500,
            12463,
            12523
        ]
    ],
    [
        [
            13104,
            13104
        ],
        "mapped",
        [
            12500,
            12467
        ]
    ],
    [
        [
            13105,
            13105
        ],
        "mapped",
        [
            12499,
            12523
        ]
    ],
    [
        [
            13106,
            13106
        ],
        "mapped",
        [
            12501,
            12449,
            12521,
            12483,
            12489
        ]
    ],
    [
        [
            13107,
            13107
        ],
        "mapped",
        [
            12501,
            12451,
            12540,
            12488
        ]
    ],
    [
        [
            13108,
            13108
        ],
        "mapped",
        [
            12502,
            12483,
            12471,
            12455,
            12523
        ]
    ],
    [
        [
            13109,
            13109
        ],
        "mapped",
        [
            12501,
            12521,
            12531
        ]
    ],
    [
        [
            13110,
            13110
        ],
        "mapped",
        [
            12504,
            12463,
            12479,
            12540,
            12523
        ]
    ],
    [
        [
            13111,
            13111
        ],
        "mapped",
        [
            12506,
            12477
        ]
    ],
    [
        [
            13112,
            13112
        ],
        "mapped",
        [
            12506,
            12491,
            12498
        ]
    ],
    [
        [
            13113,
            13113
        ],
        "mapped",
        [
            12504,
            12523,
            12484
        ]
    ],
    [
        [
            13114,
            13114
        ],
        "mapped",
        [
            12506,
            12531,
            12473
        ]
    ],
    [
        [
            13115,
            13115
        ],
        "mapped",
        [
            12506,
            12540,
            12472
        ]
    ],
    [
        [
            13116,
            13116
        ],
        "mapped",
        [
            12505,
            12540,
            12479
        ]
    ],
    [
        [
            13117,
            13117
        ],
        "mapped",
        [
            12509,
            12452,
            12531,
            12488
        ]
    ],
    [
        [
            13118,
            13118
        ],
        "mapped",
        [
            12508,
            12523,
            12488
        ]
    ],
    [
        [
            13119,
            13119
        ],
        "mapped",
        [
            12507,
            12531
        ]
    ],
    [
        [
            13120,
            13120
        ],
        "mapped",
        [
            12509,
            12531,
            12489
        ]
    ],
    [
        [
            13121,
            13121
        ],
        "mapped",
        [
            12507,
            12540,
            12523
        ]
    ],
    [
        [
            13122,
            13122
        ],
        "mapped",
        [
            12507,
            12540,
            12531
        ]
    ],
    [
        [
            13123,
            13123
        ],
        "mapped",
        [
            12510,
            12452,
            12463,
            12525
        ]
    ],
    [
        [
            13124,
            13124
        ],
        "mapped",
        [
            12510,
            12452,
            12523
        ]
    ],
    [
        [
            13125,
            13125
        ],
        "mapped",
        [
            12510,
            12483,
            12495
        ]
    ],
    [
        [
            13126,
            13126
        ],
        "mapped",
        [
            12510,
            12523,
            12463
        ]
    ],
    [
        [
            13127,
            13127
        ],
        "mapped",
        [
            12510,
            12531,
            12471,
            12519,
            12531
        ]
    ],
    [
        [
            13128,
            13128
        ],
        "mapped",
        [
            12511,
            12463,
            12525,
            12531
        ]
    ],
    [
        [
            13129,
            13129
        ],
        "mapped",
        [
            12511,
            12522
        ]
    ],
    [
        [
            13130,
            13130
        ],
        "mapped",
        [
            12511,
            12522,
            12496,
            12540,
            12523
        ]
    ],
    [
        [
            13131,
            13131
        ],
        "mapped",
        [
            12513,
            12460
        ]
    ],
    [
        [
            13132,
            13132
        ],
        "mapped",
        [
            12513,
            12460,
            12488,
            12531
        ]
    ],
    [
        [
            13133,
            13133
        ],
        "mapped",
        [
            12513,
            12540,
            12488,
            12523
        ]
    ],
    [
        [
            13134,
            13134
        ],
        "mapped",
        [
            12516,
            12540,
            12489
        ]
    ],
    [
        [
            13135,
            13135
        ],
        "mapped",
        [
            12516,
            12540,
            12523
        ]
    ],
    [
        [
            13136,
            13136
        ],
        "mapped",
        [
            12518,
            12450,
            12531
        ]
    ],
    [
        [
            13137,
            13137
        ],
        "mapped",
        [
            12522,
            12483,
            12488,
            12523
        ]
    ],
    [
        [
            13138,
            13138
        ],
        "mapped",
        [
            12522,
            12521
        ]
    ],
    [
        [
            13139,
            13139
        ],
        "mapped",
        [
            12523,
            12500,
            12540
        ]
    ],
    [
        [
            13140,
            13140
        ],
        "mapped",
        [
            12523,
            12540,
            12502,
            12523
        ]
    ],
    [
        [
            13141,
            13141
        ],
        "mapped",
        [
            12524,
            12512
        ]
    ],
    [
        [
            13142,
            13142
        ],
        "mapped",
        [
            12524,
            12531,
            12488,
            12466,
            12531
        ]
    ],
    [
        [
            13143,
            13143
        ],
        "mapped",
        [
            12527,
            12483,
            12488
        ]
    ],
    [
        [
            13144,
            13144
        ],
        "mapped",
        [
            48,
            28857
        ]
    ],
    [
        [
            13145,
            13145
        ],
        "mapped",
        [
            49,
            28857
        ]
    ],
    [
        [
            13146,
            13146
        ],
        "mapped",
        [
            50,
            28857
        ]
    ],
    [
        [
            13147,
            13147
        ],
        "mapped",
        [
            51,
            28857
        ]
    ],
    [
        [
            13148,
            13148
        ],
        "mapped",
        [
            52,
            28857
        ]
    ],
    [
        [
            13149,
            13149
        ],
        "mapped",
        [
            53,
            28857
        ]
    ],
    [
        [
            13150,
            13150
        ],
        "mapped",
        [
            54,
            28857
        ]
    ],
    [
        [
            13151,
            13151
        ],
        "mapped",
        [
            55,
            28857
        ]
    ],
    [
        [
            13152,
            13152
        ],
        "mapped",
        [
            56,
            28857
        ]
    ],
    [
        [
            13153,
            13153
        ],
        "mapped",
        [
            57,
            28857
        ]
    ],
    [
        [
            13154,
            13154
        ],
        "mapped",
        [
            49,
            48,
            28857
        ]
    ],
    [
        [
            13155,
            13155
        ],
        "mapped",
        [
            49,
            49,
            28857
        ]
    ],
    [
        [
            13156,
            13156
        ],
        "mapped",
        [
            49,
            50,
            28857
        ]
    ],
    [
        [
            13157,
            13157
        ],
        "mapped",
        [
            49,
            51,
            28857
        ]
    ],
    [
        [
            13158,
            13158
        ],
        "mapped",
        [
            49,
            52,
            28857
        ]
    ],
    [
        [
            13159,
            13159
        ],
        "mapped",
        [
            49,
            53,
            28857
        ]
    ],
    [
        [
            13160,
            13160
        ],
        "mapped",
        [
            49,
            54,
            28857
        ]
    ],
    [
        [
            13161,
            13161
        ],
        "mapped",
        [
            49,
            55,
            28857
        ]
    ],
    [
        [
            13162,
            13162
        ],
        "mapped",
        [
            49,
            56,
            28857
        ]
    ],
    [
        [
            13163,
            13163
        ],
        "mapped",
        [
            49,
            57,
            28857
        ]
    ],
    [
        [
            13164,
            13164
        ],
        "mapped",
        [
            50,
            48,
            28857
        ]
    ],
    [
        [
            13165,
            13165
        ],
        "mapped",
        [
            50,
            49,
            28857
        ]
    ],
    [
        [
            13166,
            13166
        ],
        "mapped",
        [
            50,
            50,
            28857
        ]
    ],
    [
        [
            13167,
            13167
        ],
        "mapped",
        [
            50,
            51,
            28857
        ]
    ],
    [
        [
            13168,
            13168
        ],
        "mapped",
        [
            50,
            52,
            28857
        ]
    ],
    [
        [
            13169,
            13169
        ],
        "mapped",
        [
            104,
            112,
            97
        ]
    ],
    [
        [
            13170,
            13170
        ],
        "mapped",
        [
            100,
            97
        ]
    ],
    [
        [
            13171,
            13171
        ],
        "mapped",
        [
            97,
            117
        ]
    ],
    [
        [
            13172,
            13172
        ],
        "mapped",
        [
            98,
            97,
            114
        ]
    ],
    [
        [
            13173,
            13173
        ],
        "mapped",
        [
            111,
            118
        ]
    ],
    [
        [
            13174,
            13174
        ],
        "mapped",
        [
            112,
            99
        ]
    ],
    [
        [
            13175,
            13175
        ],
        "mapped",
        [
            100,
            109
        ]
    ],
    [
        [
            13176,
            13176
        ],
        "mapped",
        [
            100,
            109,
            50
        ]
    ],
    [
        [
            13177,
            13177
        ],
        "mapped",
        [
            100,
            109,
            51
        ]
    ],
    [
        [
            13178,
            13178
        ],
        "mapped",
        [
            105,
            117
        ]
    ],
    [
        [
            13179,
            13179
        ],
        "mapped",
        [
            24179,
            25104
        ]
    ],
    [
        [
            13180,
            13180
        ],
        "mapped",
        [
            26157,
            21644
        ]
    ],
    [
        [
            13181,
            13181
        ],
        "mapped",
        [
            22823,
            27491
        ]
    ],
    [
        [
            13182,
            13182
        ],
        "mapped",
        [
            26126,
            27835
        ]
    ],
    [
        [
            13183,
            13183
        ],
        "mapped",
        [
            26666,
            24335,
            20250,
            31038
        ]
    ],
    [
        [
            13184,
            13184
        ],
        "mapped",
        [
            112,
            97
        ]
    ],
    [
        [
            13185,
            13185
        ],
        "mapped",
        [
            110,
            97
        ]
    ],
    [
        [
            13186,
            13186
        ],
        "mapped",
        [
            956,
            97
        ]
    ],
    [
        [
            13187,
            13187
        ],
        "mapped",
        [
            109,
            97
        ]
    ],
    [
        [
            13188,
            13188
        ],
        "mapped",
        [
            107,
            97
        ]
    ],
    [
        [
            13189,
            13189
        ],
        "mapped",
        [
            107,
            98
        ]
    ],
    [
        [
            13190,
            13190
        ],
        "mapped",
        [
            109,
            98
        ]
    ],
    [
        [
            13191,
            13191
        ],
        "mapped",
        [
            103,
            98
        ]
    ],
    [
        [
            13192,
            13192
        ],
        "mapped",
        [
            99,
            97,
            108
        ]
    ],
    [
        [
            13193,
            13193
        ],
        "mapped",
        [
            107,
            99,
            97,
            108
        ]
    ],
    [
        [
            13194,
            13194
        ],
        "mapped",
        [
            112,
            102
        ]
    ],
    [
        [
            13195,
            13195
        ],
        "mapped",
        [
            110,
            102
        ]
    ],
    [
        [
            13196,
            13196
        ],
        "mapped",
        [
            956,
            102
        ]
    ],
    [
        [
            13197,
            13197
        ],
        "mapped",
        [
            956,
            103
        ]
    ],
    [
        [
            13198,
            13198
        ],
        "mapped",
        [
            109,
            103
        ]
    ],
    [
        [
            13199,
            13199
        ],
        "mapped",
        [
            107,
            103
        ]
    ],
    [
        [
            13200,
            13200
        ],
        "mapped",
        [
            104,
            122
        ]
    ],
    [
        [
            13201,
            13201
        ],
        "mapped",
        [
            107,
            104,
            122
        ]
    ],
    [
        [
            13202,
            13202
        ],
        "mapped",
        [
            109,
            104,
            122
        ]
    ],
    [
        [
            13203,
            13203
        ],
        "mapped",
        [
            103,
            104,
            122
        ]
    ],
    [
        [
            13204,
            13204
        ],
        "mapped",
        [
            116,
            104,
            122
        ]
    ],
    [
        [
            13205,
            13205
        ],
        "mapped",
        [
            956,
            108
        ]
    ],
    [
        [
            13206,
            13206
        ],
        "mapped",
        [
            109,
            108
        ]
    ],
    [
        [
            13207,
            13207
        ],
        "mapped",
        [
            100,
            108
        ]
    ],
    [
        [
            13208,
            13208
        ],
        "mapped",
        [
            107,
            108
        ]
    ],
    [
        [
            13209,
            13209
        ],
        "mapped",
        [
            102,
            109
        ]
    ],
    [
        [
            13210,
            13210
        ],
        "mapped",
        [
            110,
            109
        ]
    ],
    [
        [
            13211,
            13211
        ],
        "mapped",
        [
            956,
            109
        ]
    ],
    [
        [
            13212,
            13212
        ],
        "mapped",
        [
            109,
            109
        ]
    ],
    [
        [
            13213,
            13213
        ],
        "mapped",
        [
            99,
            109
        ]
    ],
    [
        [
            13214,
            13214
        ],
        "mapped",
        [
            107,
            109
        ]
    ],
    [
        [
            13215,
            13215
        ],
        "mapped",
        [
            109,
            109,
            50
        ]
    ],
    [
        [
            13216,
            13216
        ],
        "mapped",
        [
            99,
            109,
            50
        ]
    ],
    [
        [
            13217,
            13217
        ],
        "mapped",
        [
            109,
            50
        ]
    ],
    [
        [
            13218,
            13218
        ],
        "mapped",
        [
            107,
            109,
            50
        ]
    ],
    [
        [
            13219,
            13219
        ],
        "mapped",
        [
            109,
            109,
            51
        ]
    ],
    [
        [
            13220,
            13220
        ],
        "mapped",
        [
            99,
            109,
            51
        ]
    ],
    [
        [
            13221,
            13221
        ],
        "mapped",
        [
            109,
            51
        ]
    ],
    [
        [
            13222,
            13222
        ],
        "mapped",
        [
            107,
            109,
            51
        ]
    ],
    [
        [
            13223,
            13223
        ],
        "mapped",
        [
            109,
            8725,
            115
        ]
    ],
    [
        [
            13224,
            13224
        ],
        "mapped",
        [
            109,
            8725,
            115,
            50
        ]
    ],
    [
        [
            13225,
            13225
        ],
        "mapped",
        [
            112,
            97
        ]
    ],
    [
        [
            13226,
            13226
        ],
        "mapped",
        [
            107,
            112,
            97
        ]
    ],
    [
        [
            13227,
            13227
        ],
        "mapped",
        [
            109,
            112,
            97
        ]
    ],
    [
        [
            13228,
            13228
        ],
        "mapped",
        [
            103,
            112,
            97
        ]
    ],
    [
        [
            13229,
            13229
        ],
        "mapped",
        [
            114,
            97,
            100
        ]
    ],
    [
        [
            13230,
            13230
        ],
        "mapped",
        [
            114,
            97,
            100,
            8725,
            115
        ]
    ],
    [
        [
            13231,
            13231
        ],
        "mapped",
        [
            114,
            97,
            100,
            8725,
            115,
            50
        ]
    ],
    [
        [
            13232,
            13232
        ],
        "mapped",
        [
            112,
            115
        ]
    ],
    [
        [
            13233,
            13233
        ],
        "mapped",
        [
            110,
            115
        ]
    ],
    [
        [
            13234,
            13234
        ],
        "mapped",
        [
            956,
            115
        ]
    ],
    [
        [
            13235,
            13235
        ],
        "mapped",
        [
            109,
            115
        ]
    ],
    [
        [
            13236,
            13236
        ],
        "mapped",
        [
            112,
            118
        ]
    ],
    [
        [
            13237,
            13237
        ],
        "mapped",
        [
            110,
            118
        ]
    ],
    [
        [
            13238,
            13238
        ],
        "mapped",
        [
            956,
            118
        ]
    ],
    [
        [
            13239,
            13239
        ],
        "mapped",
        [
            109,
            118
        ]
    ],
    [
        [
            13240,
            13240
        ],
        "mapped",
        [
            107,
            118
        ]
    ],
    [
        [
            13241,
            13241
        ],
        "mapped",
        [
            109,
            118
        ]
    ],
    [
        [
            13242,
            13242
        ],
        "mapped",
        [
            112,
            119
        ]
    ],
    [
        [
            13243,
            13243
        ],
        "mapped",
        [
            110,
            119
        ]
    ],
    [
        [
            13244,
            13244
        ],
        "mapped",
        [
            956,
            119
        ]
    ],
    [
        [
            13245,
            13245
        ],
        "mapped",
        [
            109,
            119
        ]
    ],
    [
        [
            13246,
            13246
        ],
        "mapped",
        [
            107,
            119
        ]
    ],
    [
        [
            13247,
            13247
        ],
        "mapped",
        [
            109,
            119
        ]
    ],
    [
        [
            13248,
            13248
        ],
        "mapped",
        [
            107,
            969
        ]
    ],
    [
        [
            13249,
            13249
        ],
        "mapped",
        [
            109,
            969
        ]
    ],
    [
        [
            13250,
            13250
        ],
        "disallowed"
    ],
    [
        [
            13251,
            13251
        ],
        "mapped",
        [
            98,
            113
        ]
    ],
    [
        [
            13252,
            13252
        ],
        "mapped",
        [
            99,
            99
        ]
    ],
    [
        [
            13253,
            13253
        ],
        "mapped",
        [
            99,
            100
        ]
    ],
    [
        [
            13254,
            13254
        ],
        "mapped",
        [
            99,
            8725,
            107,
            103
        ]
    ],
    [
        [
            13255,
            13255
        ],
        "disallowed"
    ],
    [
        [
            13256,
            13256
        ],
        "mapped",
        [
            100,
            98
        ]
    ],
    [
        [
            13257,
            13257
        ],
        "mapped",
        [
            103,
            121
        ]
    ],
    [
        [
            13258,
            13258
        ],
        "mapped",
        [
            104,
            97
        ]
    ],
    [
        [
            13259,
            13259
        ],
        "mapped",
        [
            104,
            112
        ]
    ],
    [
        [
            13260,
            13260
        ],
        "mapped",
        [
            105,
            110
        ]
    ],
    [
        [
            13261,
            13261
        ],
        "mapped",
        [
            107,
            107
        ]
    ],
    [
        [
            13262,
            13262
        ],
        "mapped",
        [
            107,
            109
        ]
    ],
    [
        [
            13263,
            13263
        ],
        "mapped",
        [
            107,
            116
        ]
    ],
    [
        [
            13264,
            13264
        ],
        "mapped",
        [
            108,
            109
        ]
    ],
    [
        [
            13265,
            13265
        ],
        "mapped",
        [
            108,
            110
        ]
    ],
    [
        [
            13266,
            13266
        ],
        "mapped",
        [
            108,
            111,
            103
        ]
    ],
    [
        [
            13267,
            13267
        ],
        "mapped",
        [
            108,
            120
        ]
    ],
    [
        [
            13268,
            13268
        ],
        "mapped",
        [
            109,
            98
        ]
    ],
    [
        [
            13269,
            13269
        ],
        "mapped",
        [
            109,
            105,
            108
        ]
    ],
    [
        [
            13270,
            13270
        ],
        "mapped",
        [
            109,
            111,
            108
        ]
    ],
    [
        [
            13271,
            13271
        ],
        "mapped",
        [
            112,
            104
        ]
    ],
    [
        [
            13272,
            13272
        ],
        "disallowed"
    ],
    [
        [
            13273,
            13273
        ],
        "mapped",
        [
            112,
            112,
            109
        ]
    ],
    [
        [
            13274,
            13274
        ],
        "mapped",
        [
            112,
            114
        ]
    ],
    [
        [
            13275,
            13275
        ],
        "mapped",
        [
            115,
            114
        ]
    ],
    [
        [
            13276,
            13276
        ],
        "mapped",
        [
            115,
            118
        ]
    ],
    [
        [
            13277,
            13277
        ],
        "mapped",
        [
            119,
            98
        ]
    ],
    [
        [
            13278,
            13278
        ],
        "mapped",
        [
            118,
            8725,
            109
        ]
    ],
    [
        [
            13279,
            13279
        ],
        "mapped",
        [
            97,
            8725,
            109
        ]
    ],
    [
        [
            13280,
            13280
        ],
        "mapped",
        [
            49,
            26085
        ]
    ],
    [
        [
            13281,
            13281
        ],
        "mapped",
        [
            50,
            26085
        ]
    ],
    [
        [
            13282,
            13282
        ],
        "mapped",
        [
            51,
            26085
        ]
    ],
    [
        [
            13283,
            13283
        ],
        "mapped",
        [
            52,
            26085
        ]
    ],
    [
        [
            13284,
            13284
        ],
        "mapped",
        [
            53,
            26085
        ]
    ],
    [
        [
            13285,
            13285
        ],
        "mapped",
        [
            54,
            26085
        ]
    ],
    [
        [
            13286,
            13286
        ],
        "mapped",
        [
            55,
            26085
        ]
    ],
    [
        [
            13287,
            13287
        ],
        "mapped",
        [
            56,
            26085
        ]
    ],
    [
        [
            13288,
            13288
        ],
        "mapped",
        [
            57,
            26085
        ]
    ],
    [
        [
            13289,
            13289
        ],
        "mapped",
        [
            49,
            48,
            26085
        ]
    ],
    [
        [
            13290,
            13290
        ],
        "mapped",
        [
            49,
            49,
            26085
        ]
    ],
    [
        [
            13291,
            13291
        ],
        "mapped",
        [
            49,
            50,
            26085
        ]
    ],
    [
        [
            13292,
            13292
        ],
        "mapped",
        [
            49,
            51,
            26085
        ]
    ],
    [
        [
            13293,
            13293
        ],
        "mapped",
        [
            49,
            52,
            26085
        ]
    ],
    [
        [
            13294,
            13294
        ],
        "mapped",
        [
            49,
            53,
            26085
        ]
    ],
    [
        [
            13295,
            13295
        ],
        "mapped",
        [
            49,
            54,
            26085
        ]
    ],
    [
        [
            13296,
            13296
        ],
        "mapped",
        [
            49,
            55,
            26085
        ]
    ],
    [
        [
            13297,
            13297
        ],
        "mapped",
        [
            49,
            56,
            26085
        ]
    ],
    [
        [
            13298,
            13298
        ],
        "mapped",
        [
            49,
            57,
            26085
        ]
    ],
    [
        [
            13299,
            13299
        ],
        "mapped",
        [
            50,
            48,
            26085
        ]
    ],
    [
        [
            13300,
            13300
        ],
        "mapped",
        [
            50,
            49,
            26085
        ]
    ],
    [
        [
            13301,
            13301
        ],
        "mapped",
        [
            50,
            50,
            26085
        ]
    ],
    [
        [
            13302,
            13302
        ],
        "mapped",
        [
            50,
            51,
            26085
        ]
    ],
    [
        [
            13303,
            13303
        ],
        "mapped",
        [
            50,
            52,
            26085
        ]
    ],
    [
        [
            13304,
            13304
        ],
        "mapped",
        [
            50,
            53,
            26085
        ]
    ],
    [
        [
            13305,
            13305
        ],
        "mapped",
        [
            50,
            54,
            26085
        ]
    ],
    [
        [
            13306,
            13306
        ],
        "mapped",
        [
            50,
            55,
            26085
        ]
    ],
    [
        [
            13307,
            13307
        ],
        "mapped",
        [
            50,
            56,
            26085
        ]
    ],
    [
        [
            13308,
            13308
        ],
        "mapped",
        [
            50,
            57,
            26085
        ]
    ],
    [
        [
            13309,
            13309
        ],
        "mapped",
        [
            51,
            48,
            26085
        ]
    ],
    [
        [
            13310,
            13310
        ],
        "mapped",
        [
            51,
            49,
            26085
        ]
    ],
    [
        [
            13311,
            13311
        ],
        "mapped",
        [
            103,
            97,
            108
        ]
    ],
    [
        [
            13312,
            19893
        ],
        "valid"
    ],
    [
        [
            19894,
            19903
        ],
        "disallowed"
    ],
    [
        [
            19904,
            19967
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            19968,
            40869
        ],
        "valid"
    ],
    [
        [
            40870,
            40891
        ],
        "valid"
    ],
    [
        [
            40892,
            40899
        ],
        "valid"
    ],
    [
        [
            40900,
            40907
        ],
        "valid"
    ],
    [
        [
            40908,
            40908
        ],
        "valid"
    ],
    [
        [
            40909,
            40917
        ],
        "valid"
    ],
    [
        [
            40918,
            40959
        ],
        "disallowed"
    ],
    [
        [
            40960,
            42124
        ],
        "valid"
    ],
    [
        [
            42125,
            42127
        ],
        "disallowed"
    ],
    [
        [
            42128,
            42145
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42146,
            42147
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42148,
            42163
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42164,
            42164
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42165,
            42176
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42177,
            42177
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42178,
            42180
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42181,
            42181
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42182,
            42182
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42183,
            42191
        ],
        "disallowed"
    ],
    [
        [
            42192,
            42237
        ],
        "valid"
    ],
    [
        [
            42238,
            42239
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42240,
            42508
        ],
        "valid"
    ],
    [
        [
            42509,
            42511
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42512,
            42539
        ],
        "valid"
    ],
    [
        [
            42540,
            42559
        ],
        "disallowed"
    ],
    [
        [
            42560,
            42560
        ],
        "mapped",
        [
            42561
        ]
    ],
    [
        [
            42561,
            42561
        ],
        "valid"
    ],
    [
        [
            42562,
            42562
        ],
        "mapped",
        [
            42563
        ]
    ],
    [
        [
            42563,
            42563
        ],
        "valid"
    ],
    [
        [
            42564,
            42564
        ],
        "mapped",
        [
            42565
        ]
    ],
    [
        [
            42565,
            42565
        ],
        "valid"
    ],
    [
        [
            42566,
            42566
        ],
        "mapped",
        [
            42567
        ]
    ],
    [
        [
            42567,
            42567
        ],
        "valid"
    ],
    [
        [
            42568,
            42568
        ],
        "mapped",
        [
            42569
        ]
    ],
    [
        [
            42569,
            42569
        ],
        "valid"
    ],
    [
        [
            42570,
            42570
        ],
        "mapped",
        [
            42571
        ]
    ],
    [
        [
            42571,
            42571
        ],
        "valid"
    ],
    [
        [
            42572,
            42572
        ],
        "mapped",
        [
            42573
        ]
    ],
    [
        [
            42573,
            42573
        ],
        "valid"
    ],
    [
        [
            42574,
            42574
        ],
        "mapped",
        [
            42575
        ]
    ],
    [
        [
            42575,
            42575
        ],
        "valid"
    ],
    [
        [
            42576,
            42576
        ],
        "mapped",
        [
            42577
        ]
    ],
    [
        [
            42577,
            42577
        ],
        "valid"
    ],
    [
        [
            42578,
            42578
        ],
        "mapped",
        [
            42579
        ]
    ],
    [
        [
            42579,
            42579
        ],
        "valid"
    ],
    [
        [
            42580,
            42580
        ],
        "mapped",
        [
            42581
        ]
    ],
    [
        [
            42581,
            42581
        ],
        "valid"
    ],
    [
        [
            42582,
            42582
        ],
        "mapped",
        [
            42583
        ]
    ],
    [
        [
            42583,
            42583
        ],
        "valid"
    ],
    [
        [
            42584,
            42584
        ],
        "mapped",
        [
            42585
        ]
    ],
    [
        [
            42585,
            42585
        ],
        "valid"
    ],
    [
        [
            42586,
            42586
        ],
        "mapped",
        [
            42587
        ]
    ],
    [
        [
            42587,
            42587
        ],
        "valid"
    ],
    [
        [
            42588,
            42588
        ],
        "mapped",
        [
            42589
        ]
    ],
    [
        [
            42589,
            42589
        ],
        "valid"
    ],
    [
        [
            42590,
            42590
        ],
        "mapped",
        [
            42591
        ]
    ],
    [
        [
            42591,
            42591
        ],
        "valid"
    ],
    [
        [
            42592,
            42592
        ],
        "mapped",
        [
            42593
        ]
    ],
    [
        [
            42593,
            42593
        ],
        "valid"
    ],
    [
        [
            42594,
            42594
        ],
        "mapped",
        [
            42595
        ]
    ],
    [
        [
            42595,
            42595
        ],
        "valid"
    ],
    [
        [
            42596,
            42596
        ],
        "mapped",
        [
            42597
        ]
    ],
    [
        [
            42597,
            42597
        ],
        "valid"
    ],
    [
        [
            42598,
            42598
        ],
        "mapped",
        [
            42599
        ]
    ],
    [
        [
            42599,
            42599
        ],
        "valid"
    ],
    [
        [
            42600,
            42600
        ],
        "mapped",
        [
            42601
        ]
    ],
    [
        [
            42601,
            42601
        ],
        "valid"
    ],
    [
        [
            42602,
            42602
        ],
        "mapped",
        [
            42603
        ]
    ],
    [
        [
            42603,
            42603
        ],
        "valid"
    ],
    [
        [
            42604,
            42604
        ],
        "mapped",
        [
            42605
        ]
    ],
    [
        [
            42605,
            42607
        ],
        "valid"
    ],
    [
        [
            42608,
            42611
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42612,
            42619
        ],
        "valid"
    ],
    [
        [
            42620,
            42621
        ],
        "valid"
    ],
    [
        [
            42622,
            42622
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42623,
            42623
        ],
        "valid"
    ],
    [
        [
            42624,
            42624
        ],
        "mapped",
        [
            42625
        ]
    ],
    [
        [
            42625,
            42625
        ],
        "valid"
    ],
    [
        [
            42626,
            42626
        ],
        "mapped",
        [
            42627
        ]
    ],
    [
        [
            42627,
            42627
        ],
        "valid"
    ],
    [
        [
            42628,
            42628
        ],
        "mapped",
        [
            42629
        ]
    ],
    [
        [
            42629,
            42629
        ],
        "valid"
    ],
    [
        [
            42630,
            42630
        ],
        "mapped",
        [
            42631
        ]
    ],
    [
        [
            42631,
            42631
        ],
        "valid"
    ],
    [
        [
            42632,
            42632
        ],
        "mapped",
        [
            42633
        ]
    ],
    [
        [
            42633,
            42633
        ],
        "valid"
    ],
    [
        [
            42634,
            42634
        ],
        "mapped",
        [
            42635
        ]
    ],
    [
        [
            42635,
            42635
        ],
        "valid"
    ],
    [
        [
            42636,
            42636
        ],
        "mapped",
        [
            42637
        ]
    ],
    [
        [
            42637,
            42637
        ],
        "valid"
    ],
    [
        [
            42638,
            42638
        ],
        "mapped",
        [
            42639
        ]
    ],
    [
        [
            42639,
            42639
        ],
        "valid"
    ],
    [
        [
            42640,
            42640
        ],
        "mapped",
        [
            42641
        ]
    ],
    [
        [
            42641,
            42641
        ],
        "valid"
    ],
    [
        [
            42642,
            42642
        ],
        "mapped",
        [
            42643
        ]
    ],
    [
        [
            42643,
            42643
        ],
        "valid"
    ],
    [
        [
            42644,
            42644
        ],
        "mapped",
        [
            42645
        ]
    ],
    [
        [
            42645,
            42645
        ],
        "valid"
    ],
    [
        [
            42646,
            42646
        ],
        "mapped",
        [
            42647
        ]
    ],
    [
        [
            42647,
            42647
        ],
        "valid"
    ],
    [
        [
            42648,
            42648
        ],
        "mapped",
        [
            42649
        ]
    ],
    [
        [
            42649,
            42649
        ],
        "valid"
    ],
    [
        [
            42650,
            42650
        ],
        "mapped",
        [
            42651
        ]
    ],
    [
        [
            42651,
            42651
        ],
        "valid"
    ],
    [
        [
            42652,
            42652
        ],
        "mapped",
        [
            1098
        ]
    ],
    [
        [
            42653,
            42653
        ],
        "mapped",
        [
            1100
        ]
    ],
    [
        [
            42654,
            42654
        ],
        "valid"
    ],
    [
        [
            42655,
            42655
        ],
        "valid"
    ],
    [
        [
            42656,
            42725
        ],
        "valid"
    ],
    [
        [
            42726,
            42735
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42736,
            42737
        ],
        "valid"
    ],
    [
        [
            42738,
            42743
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42744,
            42751
        ],
        "disallowed"
    ],
    [
        [
            42752,
            42774
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42775,
            42778
        ],
        "valid"
    ],
    [
        [
            42779,
            42783
        ],
        "valid"
    ],
    [
        [
            42784,
            42785
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42786,
            42786
        ],
        "mapped",
        [
            42787
        ]
    ],
    [
        [
            42787,
            42787
        ],
        "valid"
    ],
    [
        [
            42788,
            42788
        ],
        "mapped",
        [
            42789
        ]
    ],
    [
        [
            42789,
            42789
        ],
        "valid"
    ],
    [
        [
            42790,
            42790
        ],
        "mapped",
        [
            42791
        ]
    ],
    [
        [
            42791,
            42791
        ],
        "valid"
    ],
    [
        [
            42792,
            42792
        ],
        "mapped",
        [
            42793
        ]
    ],
    [
        [
            42793,
            42793
        ],
        "valid"
    ],
    [
        [
            42794,
            42794
        ],
        "mapped",
        [
            42795
        ]
    ],
    [
        [
            42795,
            42795
        ],
        "valid"
    ],
    [
        [
            42796,
            42796
        ],
        "mapped",
        [
            42797
        ]
    ],
    [
        [
            42797,
            42797
        ],
        "valid"
    ],
    [
        [
            42798,
            42798
        ],
        "mapped",
        [
            42799
        ]
    ],
    [
        [
            42799,
            42801
        ],
        "valid"
    ],
    [
        [
            42802,
            42802
        ],
        "mapped",
        [
            42803
        ]
    ],
    [
        [
            42803,
            42803
        ],
        "valid"
    ],
    [
        [
            42804,
            42804
        ],
        "mapped",
        [
            42805
        ]
    ],
    [
        [
            42805,
            42805
        ],
        "valid"
    ],
    [
        [
            42806,
            42806
        ],
        "mapped",
        [
            42807
        ]
    ],
    [
        [
            42807,
            42807
        ],
        "valid"
    ],
    [
        [
            42808,
            42808
        ],
        "mapped",
        [
            42809
        ]
    ],
    [
        [
            42809,
            42809
        ],
        "valid"
    ],
    [
        [
            42810,
            42810
        ],
        "mapped",
        [
            42811
        ]
    ],
    [
        [
            42811,
            42811
        ],
        "valid"
    ],
    [
        [
            42812,
            42812
        ],
        "mapped",
        [
            42813
        ]
    ],
    [
        [
            42813,
            42813
        ],
        "valid"
    ],
    [
        [
            42814,
            42814
        ],
        "mapped",
        [
            42815
        ]
    ],
    [
        [
            42815,
            42815
        ],
        "valid"
    ],
    [
        [
            42816,
            42816
        ],
        "mapped",
        [
            42817
        ]
    ],
    [
        [
            42817,
            42817
        ],
        "valid"
    ],
    [
        [
            42818,
            42818
        ],
        "mapped",
        [
            42819
        ]
    ],
    [
        [
            42819,
            42819
        ],
        "valid"
    ],
    [
        [
            42820,
            42820
        ],
        "mapped",
        [
            42821
        ]
    ],
    [
        [
            42821,
            42821
        ],
        "valid"
    ],
    [
        [
            42822,
            42822
        ],
        "mapped",
        [
            42823
        ]
    ],
    [
        [
            42823,
            42823
        ],
        "valid"
    ],
    [
        [
            42824,
            42824
        ],
        "mapped",
        [
            42825
        ]
    ],
    [
        [
            42825,
            42825
        ],
        "valid"
    ],
    [
        [
            42826,
            42826
        ],
        "mapped",
        [
            42827
        ]
    ],
    [
        [
            42827,
            42827
        ],
        "valid"
    ],
    [
        [
            42828,
            42828
        ],
        "mapped",
        [
            42829
        ]
    ],
    [
        [
            42829,
            42829
        ],
        "valid"
    ],
    [
        [
            42830,
            42830
        ],
        "mapped",
        [
            42831
        ]
    ],
    [
        [
            42831,
            42831
        ],
        "valid"
    ],
    [
        [
            42832,
            42832
        ],
        "mapped",
        [
            42833
        ]
    ],
    [
        [
            42833,
            42833
        ],
        "valid"
    ],
    [
        [
            42834,
            42834
        ],
        "mapped",
        [
            42835
        ]
    ],
    [
        [
            42835,
            42835
        ],
        "valid"
    ],
    [
        [
            42836,
            42836
        ],
        "mapped",
        [
            42837
        ]
    ],
    [
        [
            42837,
            42837
        ],
        "valid"
    ],
    [
        [
            42838,
            42838
        ],
        "mapped",
        [
            42839
        ]
    ],
    [
        [
            42839,
            42839
        ],
        "valid"
    ],
    [
        [
            42840,
            42840
        ],
        "mapped",
        [
            42841
        ]
    ],
    [
        [
            42841,
            42841
        ],
        "valid"
    ],
    [
        [
            42842,
            42842
        ],
        "mapped",
        [
            42843
        ]
    ],
    [
        [
            42843,
            42843
        ],
        "valid"
    ],
    [
        [
            42844,
            42844
        ],
        "mapped",
        [
            42845
        ]
    ],
    [
        [
            42845,
            42845
        ],
        "valid"
    ],
    [
        [
            42846,
            42846
        ],
        "mapped",
        [
            42847
        ]
    ],
    [
        [
            42847,
            42847
        ],
        "valid"
    ],
    [
        [
            42848,
            42848
        ],
        "mapped",
        [
            42849
        ]
    ],
    [
        [
            42849,
            42849
        ],
        "valid"
    ],
    [
        [
            42850,
            42850
        ],
        "mapped",
        [
            42851
        ]
    ],
    [
        [
            42851,
            42851
        ],
        "valid"
    ],
    [
        [
            42852,
            42852
        ],
        "mapped",
        [
            42853
        ]
    ],
    [
        [
            42853,
            42853
        ],
        "valid"
    ],
    [
        [
            42854,
            42854
        ],
        "mapped",
        [
            42855
        ]
    ],
    [
        [
            42855,
            42855
        ],
        "valid"
    ],
    [
        [
            42856,
            42856
        ],
        "mapped",
        [
            42857
        ]
    ],
    [
        [
            42857,
            42857
        ],
        "valid"
    ],
    [
        [
            42858,
            42858
        ],
        "mapped",
        [
            42859
        ]
    ],
    [
        [
            42859,
            42859
        ],
        "valid"
    ],
    [
        [
            42860,
            42860
        ],
        "mapped",
        [
            42861
        ]
    ],
    [
        [
            42861,
            42861
        ],
        "valid"
    ],
    [
        [
            42862,
            42862
        ],
        "mapped",
        [
            42863
        ]
    ],
    [
        [
            42863,
            42863
        ],
        "valid"
    ],
    [
        [
            42864,
            42864
        ],
        "mapped",
        [
            42863
        ]
    ],
    [
        [
            42865,
            42872
        ],
        "valid"
    ],
    [
        [
            42873,
            42873
        ],
        "mapped",
        [
            42874
        ]
    ],
    [
        [
            42874,
            42874
        ],
        "valid"
    ],
    [
        [
            42875,
            42875
        ],
        "mapped",
        [
            42876
        ]
    ],
    [
        [
            42876,
            42876
        ],
        "valid"
    ],
    [
        [
            42877,
            42877
        ],
        "mapped",
        [
            7545
        ]
    ],
    [
        [
            42878,
            42878
        ],
        "mapped",
        [
            42879
        ]
    ],
    [
        [
            42879,
            42879
        ],
        "valid"
    ],
    [
        [
            42880,
            42880
        ],
        "mapped",
        [
            42881
        ]
    ],
    [
        [
            42881,
            42881
        ],
        "valid"
    ],
    [
        [
            42882,
            42882
        ],
        "mapped",
        [
            42883
        ]
    ],
    [
        [
            42883,
            42883
        ],
        "valid"
    ],
    [
        [
            42884,
            42884
        ],
        "mapped",
        [
            42885
        ]
    ],
    [
        [
            42885,
            42885
        ],
        "valid"
    ],
    [
        [
            42886,
            42886
        ],
        "mapped",
        [
            42887
        ]
    ],
    [
        [
            42887,
            42888
        ],
        "valid"
    ],
    [
        [
            42889,
            42890
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            42891,
            42891
        ],
        "mapped",
        [
            42892
        ]
    ],
    [
        [
            42892,
            42892
        ],
        "valid"
    ],
    [
        [
            42893,
            42893
        ],
        "mapped",
        [
            613
        ]
    ],
    [
        [
            42894,
            42894
        ],
        "valid"
    ],
    [
        [
            42895,
            42895
        ],
        "valid"
    ],
    [
        [
            42896,
            42896
        ],
        "mapped",
        [
            42897
        ]
    ],
    [
        [
            42897,
            42897
        ],
        "valid"
    ],
    [
        [
            42898,
            42898
        ],
        "mapped",
        [
            42899
        ]
    ],
    [
        [
            42899,
            42899
        ],
        "valid"
    ],
    [
        [
            42900,
            42901
        ],
        "valid"
    ],
    [
        [
            42902,
            42902
        ],
        "mapped",
        [
            42903
        ]
    ],
    [
        [
            42903,
            42903
        ],
        "valid"
    ],
    [
        [
            42904,
            42904
        ],
        "mapped",
        [
            42905
        ]
    ],
    [
        [
            42905,
            42905
        ],
        "valid"
    ],
    [
        [
            42906,
            42906
        ],
        "mapped",
        [
            42907
        ]
    ],
    [
        [
            42907,
            42907
        ],
        "valid"
    ],
    [
        [
            42908,
            42908
        ],
        "mapped",
        [
            42909
        ]
    ],
    [
        [
            42909,
            42909
        ],
        "valid"
    ],
    [
        [
            42910,
            42910
        ],
        "mapped",
        [
            42911
        ]
    ],
    [
        [
            42911,
            42911
        ],
        "valid"
    ],
    [
        [
            42912,
            42912
        ],
        "mapped",
        [
            42913
        ]
    ],
    [
        [
            42913,
            42913
        ],
        "valid"
    ],
    [
        [
            42914,
            42914
        ],
        "mapped",
        [
            42915
        ]
    ],
    [
        [
            42915,
            42915
        ],
        "valid"
    ],
    [
        [
            42916,
            42916
        ],
        "mapped",
        [
            42917
        ]
    ],
    [
        [
            42917,
            42917
        ],
        "valid"
    ],
    [
        [
            42918,
            42918
        ],
        "mapped",
        [
            42919
        ]
    ],
    [
        [
            42919,
            42919
        ],
        "valid"
    ],
    [
        [
            42920,
            42920
        ],
        "mapped",
        [
            42921
        ]
    ],
    [
        [
            42921,
            42921
        ],
        "valid"
    ],
    [
        [
            42922,
            42922
        ],
        "mapped",
        [
            614
        ]
    ],
    [
        [
            42923,
            42923
        ],
        "mapped",
        [
            604
        ]
    ],
    [
        [
            42924,
            42924
        ],
        "mapped",
        [
            609
        ]
    ],
    [
        [
            42925,
            42925
        ],
        "mapped",
        [
            620
        ]
    ],
    [
        [
            42926,
            42927
        ],
        "disallowed"
    ],
    [
        [
            42928,
            42928
        ],
        "mapped",
        [
            670
        ]
    ],
    [
        [
            42929,
            42929
        ],
        "mapped",
        [
            647
        ]
    ],
    [
        [
            42930,
            42930
        ],
        "mapped",
        [
            669
        ]
    ],
    [
        [
            42931,
            42931
        ],
        "mapped",
        [
            43859
        ]
    ],
    [
        [
            42932,
            42932
        ],
        "mapped",
        [
            42933
        ]
    ],
    [
        [
            42933,
            42933
        ],
        "valid"
    ],
    [
        [
            42934,
            42934
        ],
        "mapped",
        [
            42935
        ]
    ],
    [
        [
            42935,
            42935
        ],
        "valid"
    ],
    [
        [
            42936,
            42998
        ],
        "disallowed"
    ],
    [
        [
            42999,
            42999
        ],
        "valid"
    ],
    [
        [
            43000,
            43000
        ],
        "mapped",
        [
            295
        ]
    ],
    [
        [
            43001,
            43001
        ],
        "mapped",
        [
            339
        ]
    ],
    [
        [
            43002,
            43002
        ],
        "valid"
    ],
    [
        [
            43003,
            43007
        ],
        "valid"
    ],
    [
        [
            43008,
            43047
        ],
        "valid"
    ],
    [
        [
            43048,
            43051
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43052,
            43055
        ],
        "disallowed"
    ],
    [
        [
            43056,
            43065
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43066,
            43071
        ],
        "disallowed"
    ],
    [
        [
            43072,
            43123
        ],
        "valid"
    ],
    [
        [
            43124,
            43127
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43128,
            43135
        ],
        "disallowed"
    ],
    [
        [
            43136,
            43204
        ],
        "valid"
    ],
    [
        [
            43205,
            43213
        ],
        "disallowed"
    ],
    [
        [
            43214,
            43215
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43216,
            43225
        ],
        "valid"
    ],
    [
        [
            43226,
            43231
        ],
        "disallowed"
    ],
    [
        [
            43232,
            43255
        ],
        "valid"
    ],
    [
        [
            43256,
            43258
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43259,
            43259
        ],
        "valid"
    ],
    [
        [
            43260,
            43260
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43261,
            43261
        ],
        "valid"
    ],
    [
        [
            43262,
            43263
        ],
        "disallowed"
    ],
    [
        [
            43264,
            43309
        ],
        "valid"
    ],
    [
        [
            43310,
            43311
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43312,
            43347
        ],
        "valid"
    ],
    [
        [
            43348,
            43358
        ],
        "disallowed"
    ],
    [
        [
            43359,
            43359
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43360,
            43388
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43389,
            43391
        ],
        "disallowed"
    ],
    [
        [
            43392,
            43456
        ],
        "valid"
    ],
    [
        [
            43457,
            43469
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43470,
            43470
        ],
        "disallowed"
    ],
    [
        [
            43471,
            43481
        ],
        "valid"
    ],
    [
        [
            43482,
            43485
        ],
        "disallowed"
    ],
    [
        [
            43486,
            43487
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43488,
            43518
        ],
        "valid"
    ],
    [
        [
            43519,
            43519
        ],
        "disallowed"
    ],
    [
        [
            43520,
            43574
        ],
        "valid"
    ],
    [
        [
            43575,
            43583
        ],
        "disallowed"
    ],
    [
        [
            43584,
            43597
        ],
        "valid"
    ],
    [
        [
            43598,
            43599
        ],
        "disallowed"
    ],
    [
        [
            43600,
            43609
        ],
        "valid"
    ],
    [
        [
            43610,
            43611
        ],
        "disallowed"
    ],
    [
        [
            43612,
            43615
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43616,
            43638
        ],
        "valid"
    ],
    [
        [
            43639,
            43641
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43642,
            43643
        ],
        "valid"
    ],
    [
        [
            43644,
            43647
        ],
        "valid"
    ],
    [
        [
            43648,
            43714
        ],
        "valid"
    ],
    [
        [
            43715,
            43738
        ],
        "disallowed"
    ],
    [
        [
            43739,
            43741
        ],
        "valid"
    ],
    [
        [
            43742,
            43743
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43744,
            43759
        ],
        "valid"
    ],
    [
        [
            43760,
            43761
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43762,
            43766
        ],
        "valid"
    ],
    [
        [
            43767,
            43776
        ],
        "disallowed"
    ],
    [
        [
            43777,
            43782
        ],
        "valid"
    ],
    [
        [
            43783,
            43784
        ],
        "disallowed"
    ],
    [
        [
            43785,
            43790
        ],
        "valid"
    ],
    [
        [
            43791,
            43792
        ],
        "disallowed"
    ],
    [
        [
            43793,
            43798
        ],
        "valid"
    ],
    [
        [
            43799,
            43807
        ],
        "disallowed"
    ],
    [
        [
            43808,
            43814
        ],
        "valid"
    ],
    [
        [
            43815,
            43815
        ],
        "disallowed"
    ],
    [
        [
            43816,
            43822
        ],
        "valid"
    ],
    [
        [
            43823,
            43823
        ],
        "disallowed"
    ],
    [
        [
            43824,
            43866
        ],
        "valid"
    ],
    [
        [
            43867,
            43867
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            43868,
            43868
        ],
        "mapped",
        [
            42791
        ]
    ],
    [
        [
            43869,
            43869
        ],
        "mapped",
        [
            43831
        ]
    ],
    [
        [
            43870,
            43870
        ],
        "mapped",
        [
            619
        ]
    ],
    [
        [
            43871,
            43871
        ],
        "mapped",
        [
            43858
        ]
    ],
    [
        [
            43872,
            43875
        ],
        "valid"
    ],
    [
        [
            43876,
            43877
        ],
        "valid"
    ],
    [
        [
            43878,
            43887
        ],
        "disallowed"
    ],
    [
        [
            43888,
            43888
        ],
        "mapped",
        [
            5024
        ]
    ],
    [
        [
            43889,
            43889
        ],
        "mapped",
        [
            5025
        ]
    ],
    [
        [
            43890,
            43890
        ],
        "mapped",
        [
            5026
        ]
    ],
    [
        [
            43891,
            43891
        ],
        "mapped",
        [
            5027
        ]
    ],
    [
        [
            43892,
            43892
        ],
        "mapped",
        [
            5028
        ]
    ],
    [
        [
            43893,
            43893
        ],
        "mapped",
        [
            5029
        ]
    ],
    [
        [
            43894,
            43894
        ],
        "mapped",
        [
            5030
        ]
    ],
    [
        [
            43895,
            43895
        ],
        "mapped",
        [
            5031
        ]
    ],
    [
        [
            43896,
            43896
        ],
        "mapped",
        [
            5032
        ]
    ],
    [
        [
            43897,
            43897
        ],
        "mapped",
        [
            5033
        ]
    ],
    [
        [
            43898,
            43898
        ],
        "mapped",
        [
            5034
        ]
    ],
    [
        [
            43899,
            43899
        ],
        "mapped",
        [
            5035
        ]
    ],
    [
        [
            43900,
            43900
        ],
        "mapped",
        [
            5036
        ]
    ],
    [
        [
            43901,
            43901
        ],
        "mapped",
        [
            5037
        ]
    ],
    [
        [
            43902,
            43902
        ],
        "mapped",
        [
            5038
        ]
    ],
    [
        [
            43903,
            43903
        ],
        "mapped",
        [
            5039
        ]
    ],
    [
        [
            43904,
            43904
        ],
        "mapped",
        [
            5040
        ]
    ],
    [
        [
            43905,
            43905
        ],
        "mapped",
        [
            5041
        ]
    ],
    [
        [
            43906,
            43906
        ],
        "mapped",
        [
            5042
        ]
    ],
    [
        [
            43907,
            43907
        ],
        "mapped",
        [
            5043
        ]
    ],
    [
        [
            43908,
            43908
        ],
        "mapped",
        [
            5044
        ]
    ],
    [
        [
            43909,
            43909
        ],
        "mapped",
        [
            5045
        ]
    ],
    [
        [
            43910,
            43910
        ],
        "mapped",
        [
            5046
        ]
    ],
    [
        [
            43911,
            43911
        ],
        "mapped",
        [
            5047
        ]
    ],
    [
        [
            43912,
            43912
        ],
        "mapped",
        [
            5048
        ]
    ],
    [
        [
            43913,
            43913
        ],
        "mapped",
        [
            5049
        ]
    ],
    [
        [
            43914,
            43914
        ],
        "mapped",
        [
            5050
        ]
    ],
    [
        [
            43915,
            43915
        ],
        "mapped",
        [
            5051
        ]
    ],
    [
        [
            43916,
            43916
        ],
        "mapped",
        [
            5052
        ]
    ],
    [
        [
            43917,
            43917
        ],
        "mapped",
        [
            5053
        ]
    ],
    [
        [
            43918,
            43918
        ],
        "mapped",
        [
            5054
        ]
    ],
    [
        [
            43919,
            43919
        ],
        "mapped",
        [
            5055
        ]
    ],
    [
        [
            43920,
            43920
        ],
        "mapped",
        [
            5056
        ]
    ],
    [
        [
            43921,
            43921
        ],
        "mapped",
        [
            5057
        ]
    ],
    [
        [
            43922,
            43922
        ],
        "mapped",
        [
            5058
        ]
    ],
    [
        [
            43923,
            43923
        ],
        "mapped",
        [
            5059
        ]
    ],
    [
        [
            43924,
            43924
        ],
        "mapped",
        [
            5060
        ]
    ],
    [
        [
            43925,
            43925
        ],
        "mapped",
        [
            5061
        ]
    ],
    [
        [
            43926,
            43926
        ],
        "mapped",
        [
            5062
        ]
    ],
    [
        [
            43927,
            43927
        ],
        "mapped",
        [
            5063
        ]
    ],
    [
        [
            43928,
            43928
        ],
        "mapped",
        [
            5064
        ]
    ],
    [
        [
            43929,
            43929
        ],
        "mapped",
        [
            5065
        ]
    ],
    [
        [
            43930,
            43930
        ],
        "mapped",
        [
            5066
        ]
    ],
    [
        [
            43931,
            43931
        ],
        "mapped",
        [
            5067
        ]
    ],
    [
        [
            43932,
            43932
        ],
        "mapped",
        [
            5068
        ]
    ],
    [
        [
            43933,
            43933
        ],
        "mapped",
        [
            5069
        ]
    ],
    [
        [
            43934,
            43934
        ],
        "mapped",
        [
            5070
        ]
    ],
    [
        [
            43935,
            43935
        ],
        "mapped",
        [
            5071
        ]
    ],
    [
        [
            43936,
            43936
        ],
        "mapped",
        [
            5072
        ]
    ],
    [
        [
            43937,
            43937
        ],
        "mapped",
        [
            5073
        ]
    ],
    [
        [
            43938,
            43938
        ],
        "mapped",
        [
            5074
        ]
    ],
    [
        [
            43939,
            43939
        ],
        "mapped",
        [
            5075
        ]
    ],
    [
        [
            43940,
            43940
        ],
        "mapped",
        [
            5076
        ]
    ],
    [
        [
            43941,
            43941
        ],
        "mapped",
        [
            5077
        ]
    ],
    [
        [
            43942,
            43942
        ],
        "mapped",
        [
            5078
        ]
    ],
    [
        [
            43943,
            43943
        ],
        "mapped",
        [
            5079
        ]
    ],
    [
        [
            43944,
            43944
        ],
        "mapped",
        [
            5080
        ]
    ],
    [
        [
            43945,
            43945
        ],
        "mapped",
        [
            5081
        ]
    ],
    [
        [
            43946,
            43946
        ],
        "mapped",
        [
            5082
        ]
    ],
    [
        [
            43947,
            43947
        ],
        "mapped",
        [
            5083
        ]
    ],
    [
        [
            43948,
            43948
        ],
        "mapped",
        [
            5084
        ]
    ],
    [
        [
            43949,
            43949
        ],
        "mapped",
        [
            5085
        ]
    ],
    [
        [
            43950,
            43950
        ],
        "mapped",
        [
            5086
        ]
    ],
    [
        [
            43951,
            43951
        ],
        "mapped",
        [
            5087
        ]
    ],
    [
        [
            43952,
            43952
        ],
        "mapped",
        [
            5088
        ]
    ],
    [
        [
            43953,
            43953
        ],
        "mapped",
        [
            5089
        ]
    ],
    [
        [
            43954,
            43954
        ],
        "mapped",
        [
            5090
        ]
    ],
    [
        [
            43955,
            43955
        ],
        "mapped",
        [
            5091
        ]
    ],
    [
        [
            43956,
            43956
        ],
        "mapped",
        [
            5092
        ]
    ],
    [
        [
            43957,
            43957
        ],
        "mapped",
        [
            5093
        ]
    ],
    [
        [
            43958,
            43958
        ],
        "mapped",
        [
            5094
        ]
    ],
    [
        [
            43959,
            43959
        ],
        "mapped",
        [
            5095
        ]
    ],
    [
        [
            43960,
            43960
        ],
        "mapped",
        [
            5096
        ]
    ],
    [
        [
            43961,
            43961
        ],
        "mapped",
        [
            5097
        ]
    ],
    [
        [
            43962,
            43962
        ],
        "mapped",
        [
            5098
        ]
    ],
    [
        [
            43963,
            43963
        ],
        "mapped",
        [
            5099
        ]
    ],
    [
        [
            43964,
            43964
        ],
        "mapped",
        [
            5100
        ]
    ],
    [
        [
            43965,
            43965
        ],
        "mapped",
        [
            5101
        ]
    ],
    [
        [
            43966,
            43966
        ],
        "mapped",
        [
            5102
        ]
    ],
    [
        [
            43967,
            43967
        ],
        "mapped",
        [
            5103
        ]
    ],
    [
        [
            43968,
            44010
        ],
        "valid"
    ],
    [
        [
            44011,
            44011
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            44012,
            44013
        ],
        "valid"
    ],
    [
        [
            44014,
            44015
        ],
        "disallowed"
    ],
    [
        [
            44016,
            44025
        ],
        "valid"
    ],
    [
        [
            44026,
            44031
        ],
        "disallowed"
    ],
    [
        [
            44032,
            55203
        ],
        "valid"
    ],
    [
        [
            55204,
            55215
        ],
        "disallowed"
    ],
    [
        [
            55216,
            55238
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            55239,
            55242
        ],
        "disallowed"
    ],
    [
        [
            55243,
            55291
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            55292,
            55295
        ],
        "disallowed"
    ],
    [
        [
            55296,
            57343
        ],
        "disallowed"
    ],
    [
        [
            57344,
            63743
        ],
        "disallowed"
    ],
    [
        [
            63744,
            63744
        ],
        "mapped",
        [
            35912
        ]
    ],
    [
        [
            63745,
            63745
        ],
        "mapped",
        [
            26356
        ]
    ],
    [
        [
            63746,
            63746
        ],
        "mapped",
        [
            36554
        ]
    ],
    [
        [
            63747,
            63747
        ],
        "mapped",
        [
            36040
        ]
    ],
    [
        [
            63748,
            63748
        ],
        "mapped",
        [
            28369
        ]
    ],
    [
        [
            63749,
            63749
        ],
        "mapped",
        [
            20018
        ]
    ],
    [
        [
            63750,
            63750
        ],
        "mapped",
        [
            21477
        ]
    ],
    [
        [
            63751,
            63752
        ],
        "mapped",
        [
            40860
        ]
    ],
    [
        [
            63753,
            63753
        ],
        "mapped",
        [
            22865
        ]
    ],
    [
        [
            63754,
            63754
        ],
        "mapped",
        [
            37329
        ]
    ],
    [
        [
            63755,
            63755
        ],
        "mapped",
        [
            21895
        ]
    ],
    [
        [
            63756,
            63756
        ],
        "mapped",
        [
            22856
        ]
    ],
    [
        [
            63757,
            63757
        ],
        "mapped",
        [
            25078
        ]
    ],
    [
        [
            63758,
            63758
        ],
        "mapped",
        [
            30313
        ]
    ],
    [
        [
            63759,
            63759
        ],
        "mapped",
        [
            32645
        ]
    ],
    [
        [
            63760,
            63760
        ],
        "mapped",
        [
            34367
        ]
    ],
    [
        [
            63761,
            63761
        ],
        "mapped",
        [
            34746
        ]
    ],
    [
        [
            63762,
            63762
        ],
        "mapped",
        [
            35064
        ]
    ],
    [
        [
            63763,
            63763
        ],
        "mapped",
        [
            37007
        ]
    ],
    [
        [
            63764,
            63764
        ],
        "mapped",
        [
            27138
        ]
    ],
    [
        [
            63765,
            63765
        ],
        "mapped",
        [
            27931
        ]
    ],
    [
        [
            63766,
            63766
        ],
        "mapped",
        [
            28889
        ]
    ],
    [
        [
            63767,
            63767
        ],
        "mapped",
        [
            29662
        ]
    ],
    [
        [
            63768,
            63768
        ],
        "mapped",
        [
            33853
        ]
    ],
    [
        [
            63769,
            63769
        ],
        "mapped",
        [
            37226
        ]
    ],
    [
        [
            63770,
            63770
        ],
        "mapped",
        [
            39409
        ]
    ],
    [
        [
            63771,
            63771
        ],
        "mapped",
        [
            20098
        ]
    ],
    [
        [
            63772,
            63772
        ],
        "mapped",
        [
            21365
        ]
    ],
    [
        [
            63773,
            63773
        ],
        "mapped",
        [
            27396
        ]
    ],
    [
        [
            63774,
            63774
        ],
        "mapped",
        [
            29211
        ]
    ],
    [
        [
            63775,
            63775
        ],
        "mapped",
        [
            34349
        ]
    ],
    [
        [
            63776,
            63776
        ],
        "mapped",
        [
            40478
        ]
    ],
    [
        [
            63777,
            63777
        ],
        "mapped",
        [
            23888
        ]
    ],
    [
        [
            63778,
            63778
        ],
        "mapped",
        [
            28651
        ]
    ],
    [
        [
            63779,
            63779
        ],
        "mapped",
        [
            34253
        ]
    ],
    [
        [
            63780,
            63780
        ],
        "mapped",
        [
            35172
        ]
    ],
    [
        [
            63781,
            63781
        ],
        "mapped",
        [
            25289
        ]
    ],
    [
        [
            63782,
            63782
        ],
        "mapped",
        [
            33240
        ]
    ],
    [
        [
            63783,
            63783
        ],
        "mapped",
        [
            34847
        ]
    ],
    [
        [
            63784,
            63784
        ],
        "mapped",
        [
            24266
        ]
    ],
    [
        [
            63785,
            63785
        ],
        "mapped",
        [
            26391
        ]
    ],
    [
        [
            63786,
            63786
        ],
        "mapped",
        [
            28010
        ]
    ],
    [
        [
            63787,
            63787
        ],
        "mapped",
        [
            29436
        ]
    ],
    [
        [
            63788,
            63788
        ],
        "mapped",
        [
            37070
        ]
    ],
    [
        [
            63789,
            63789
        ],
        "mapped",
        [
            20358
        ]
    ],
    [
        [
            63790,
            63790
        ],
        "mapped",
        [
            20919
        ]
    ],
    [
        [
            63791,
            63791
        ],
        "mapped",
        [
            21214
        ]
    ],
    [
        [
            63792,
            63792
        ],
        "mapped",
        [
            25796
        ]
    ],
    [
        [
            63793,
            63793
        ],
        "mapped",
        [
            27347
        ]
    ],
    [
        [
            63794,
            63794
        ],
        "mapped",
        [
            29200
        ]
    ],
    [
        [
            63795,
            63795
        ],
        "mapped",
        [
            30439
        ]
    ],
    [
        [
            63796,
            63796
        ],
        "mapped",
        [
            32769
        ]
    ],
    [
        [
            63797,
            63797
        ],
        "mapped",
        [
            34310
        ]
    ],
    [
        [
            63798,
            63798
        ],
        "mapped",
        [
            34396
        ]
    ],
    [
        [
            63799,
            63799
        ],
        "mapped",
        [
            36335
        ]
    ],
    [
        [
            63800,
            63800
        ],
        "mapped",
        [
            38706
        ]
    ],
    [
        [
            63801,
            63801
        ],
        "mapped",
        [
            39791
        ]
    ],
    [
        [
            63802,
            63802
        ],
        "mapped",
        [
            40442
        ]
    ],
    [
        [
            63803,
            63803
        ],
        "mapped",
        [
            30860
        ]
    ],
    [
        [
            63804,
            63804
        ],
        "mapped",
        [
            31103
        ]
    ],
    [
        [
            63805,
            63805
        ],
        "mapped",
        [
            32160
        ]
    ],
    [
        [
            63806,
            63806
        ],
        "mapped",
        [
            33737
        ]
    ],
    [
        [
            63807,
            63807
        ],
        "mapped",
        [
            37636
        ]
    ],
    [
        [
            63808,
            63808
        ],
        "mapped",
        [
            40575
        ]
    ],
    [
        [
            63809,
            63809
        ],
        "mapped",
        [
            35542
        ]
    ],
    [
        [
            63810,
            63810
        ],
        "mapped",
        [
            22751
        ]
    ],
    [
        [
            63811,
            63811
        ],
        "mapped",
        [
            24324
        ]
    ],
    [
        [
            63812,
            63812
        ],
        "mapped",
        [
            31840
        ]
    ],
    [
        [
            63813,
            63813
        ],
        "mapped",
        [
            32894
        ]
    ],
    [
        [
            63814,
            63814
        ],
        "mapped",
        [
            29282
        ]
    ],
    [
        [
            63815,
            63815
        ],
        "mapped",
        [
            30922
        ]
    ],
    [
        [
            63816,
            63816
        ],
        "mapped",
        [
            36034
        ]
    ],
    [
        [
            63817,
            63817
        ],
        "mapped",
        [
            38647
        ]
    ],
    [
        [
            63818,
            63818
        ],
        "mapped",
        [
            22744
        ]
    ],
    [
        [
            63819,
            63819
        ],
        "mapped",
        [
            23650
        ]
    ],
    [
        [
            63820,
            63820
        ],
        "mapped",
        [
            27155
        ]
    ],
    [
        [
            63821,
            63821
        ],
        "mapped",
        [
            28122
        ]
    ],
    [
        [
            63822,
            63822
        ],
        "mapped",
        [
            28431
        ]
    ],
    [
        [
            63823,
            63823
        ],
        "mapped",
        [
            32047
        ]
    ],
    [
        [
            63824,
            63824
        ],
        "mapped",
        [
            32311
        ]
    ],
    [
        [
            63825,
            63825
        ],
        "mapped",
        [
            38475
        ]
    ],
    [
        [
            63826,
            63826
        ],
        "mapped",
        [
            21202
        ]
    ],
    [
        [
            63827,
            63827
        ],
        "mapped",
        [
            32907
        ]
    ],
    [
        [
            63828,
            63828
        ],
        "mapped",
        [
            20956
        ]
    ],
    [
        [
            63829,
            63829
        ],
        "mapped",
        [
            20940
        ]
    ],
    [
        [
            63830,
            63830
        ],
        "mapped",
        [
            31260
        ]
    ],
    [
        [
            63831,
            63831
        ],
        "mapped",
        [
            32190
        ]
    ],
    [
        [
            63832,
            63832
        ],
        "mapped",
        [
            33777
        ]
    ],
    [
        [
            63833,
            63833
        ],
        "mapped",
        [
            38517
        ]
    ],
    [
        [
            63834,
            63834
        ],
        "mapped",
        [
            35712
        ]
    ],
    [
        [
            63835,
            63835
        ],
        "mapped",
        [
            25295
        ]
    ],
    [
        [
            63836,
            63836
        ],
        "mapped",
        [
            27138
        ]
    ],
    [
        [
            63837,
            63837
        ],
        "mapped",
        [
            35582
        ]
    ],
    [
        [
            63838,
            63838
        ],
        "mapped",
        [
            20025
        ]
    ],
    [
        [
            63839,
            63839
        ],
        "mapped",
        [
            23527
        ]
    ],
    [
        [
            63840,
            63840
        ],
        "mapped",
        [
            24594
        ]
    ],
    [
        [
            63841,
            63841
        ],
        "mapped",
        [
            29575
        ]
    ],
    [
        [
            63842,
            63842
        ],
        "mapped",
        [
            30064
        ]
    ],
    [
        [
            63843,
            63843
        ],
        "mapped",
        [
            21271
        ]
    ],
    [
        [
            63844,
            63844
        ],
        "mapped",
        [
            30971
        ]
    ],
    [
        [
            63845,
            63845
        ],
        "mapped",
        [
            20415
        ]
    ],
    [
        [
            63846,
            63846
        ],
        "mapped",
        [
            24489
        ]
    ],
    [
        [
            63847,
            63847
        ],
        "mapped",
        [
            19981
        ]
    ],
    [
        [
            63848,
            63848
        ],
        "mapped",
        [
            27852
        ]
    ],
    [
        [
            63849,
            63849
        ],
        "mapped",
        [
            25976
        ]
    ],
    [
        [
            63850,
            63850
        ],
        "mapped",
        [
            32034
        ]
    ],
    [
        [
            63851,
            63851
        ],
        "mapped",
        [
            21443
        ]
    ],
    [
        [
            63852,
            63852
        ],
        "mapped",
        [
            22622
        ]
    ],
    [
        [
            63853,
            63853
        ],
        "mapped",
        [
            30465
        ]
    ],
    [
        [
            63854,
            63854
        ],
        "mapped",
        [
            33865
        ]
    ],
    [
        [
            63855,
            63855
        ],
        "mapped",
        [
            35498
        ]
    ],
    [
        [
            63856,
            63856
        ],
        "mapped",
        [
            27578
        ]
    ],
    [
        [
            63857,
            63857
        ],
        "mapped",
        [
            36784
        ]
    ],
    [
        [
            63858,
            63858
        ],
        "mapped",
        [
            27784
        ]
    ],
    [
        [
            63859,
            63859
        ],
        "mapped",
        [
            25342
        ]
    ],
    [
        [
            63860,
            63860
        ],
        "mapped",
        [
            33509
        ]
    ],
    [
        [
            63861,
            63861
        ],
        "mapped",
        [
            25504
        ]
    ],
    [
        [
            63862,
            63862
        ],
        "mapped",
        [
            30053
        ]
    ],
    [
        [
            63863,
            63863
        ],
        "mapped",
        [
            20142
        ]
    ],
    [
        [
            63864,
            63864
        ],
        "mapped",
        [
            20841
        ]
    ],
    [
        [
            63865,
            63865
        ],
        "mapped",
        [
            20937
        ]
    ],
    [
        [
            63866,
            63866
        ],
        "mapped",
        [
            26753
        ]
    ],
    [
        [
            63867,
            63867
        ],
        "mapped",
        [
            31975
        ]
    ],
    [
        [
            63868,
            63868
        ],
        "mapped",
        [
            33391
        ]
    ],
    [
        [
            63869,
            63869
        ],
        "mapped",
        [
            35538
        ]
    ],
    [
        [
            63870,
            63870
        ],
        "mapped",
        [
            37327
        ]
    ],
    [
        [
            63871,
            63871
        ],
        "mapped",
        [
            21237
        ]
    ],
    [
        [
            63872,
            63872
        ],
        "mapped",
        [
            21570
        ]
    ],
    [
        [
            63873,
            63873
        ],
        "mapped",
        [
            22899
        ]
    ],
    [
        [
            63874,
            63874
        ],
        "mapped",
        [
            24300
        ]
    ],
    [
        [
            63875,
            63875
        ],
        "mapped",
        [
            26053
        ]
    ],
    [
        [
            63876,
            63876
        ],
        "mapped",
        [
            28670
        ]
    ],
    [
        [
            63877,
            63877
        ],
        "mapped",
        [
            31018
        ]
    ],
    [
        [
            63878,
            63878
        ],
        "mapped",
        [
            38317
        ]
    ],
    [
        [
            63879,
            63879
        ],
        "mapped",
        [
            39530
        ]
    ],
    [
        [
            63880,
            63880
        ],
        "mapped",
        [
            40599
        ]
    ],
    [
        [
            63881,
            63881
        ],
        "mapped",
        [
            40654
        ]
    ],
    [
        [
            63882,
            63882
        ],
        "mapped",
        [
            21147
        ]
    ],
    [
        [
            63883,
            63883
        ],
        "mapped",
        [
            26310
        ]
    ],
    [
        [
            63884,
            63884
        ],
        "mapped",
        [
            27511
        ]
    ],
    [
        [
            63885,
            63885
        ],
        "mapped",
        [
            36706
        ]
    ],
    [
        [
            63886,
            63886
        ],
        "mapped",
        [
            24180
        ]
    ],
    [
        [
            63887,
            63887
        ],
        "mapped",
        [
            24976
        ]
    ],
    [
        [
            63888,
            63888
        ],
        "mapped",
        [
            25088
        ]
    ],
    [
        [
            63889,
            63889
        ],
        "mapped",
        [
            25754
        ]
    ],
    [
        [
            63890,
            63890
        ],
        "mapped",
        [
            28451
        ]
    ],
    [
        [
            63891,
            63891
        ],
        "mapped",
        [
            29001
        ]
    ],
    [
        [
            63892,
            63892
        ],
        "mapped",
        [
            29833
        ]
    ],
    [
        [
            63893,
            63893
        ],
        "mapped",
        [
            31178
        ]
    ],
    [
        [
            63894,
            63894
        ],
        "mapped",
        [
            32244
        ]
    ],
    [
        [
            63895,
            63895
        ],
        "mapped",
        [
            32879
        ]
    ],
    [
        [
            63896,
            63896
        ],
        "mapped",
        [
            36646
        ]
    ],
    [
        [
            63897,
            63897
        ],
        "mapped",
        [
            34030
        ]
    ],
    [
        [
            63898,
            63898
        ],
        "mapped",
        [
            36899
        ]
    ],
    [
        [
            63899,
            63899
        ],
        "mapped",
        [
            37706
        ]
    ],
    [
        [
            63900,
            63900
        ],
        "mapped",
        [
            21015
        ]
    ],
    [
        [
            63901,
            63901
        ],
        "mapped",
        [
            21155
        ]
    ],
    [
        [
            63902,
            63902
        ],
        "mapped",
        [
            21693
        ]
    ],
    [
        [
            63903,
            63903
        ],
        "mapped",
        [
            28872
        ]
    ],
    [
        [
            63904,
            63904
        ],
        "mapped",
        [
            35010
        ]
    ],
    [
        [
            63905,
            63905
        ],
        "mapped",
        [
            35498
        ]
    ],
    [
        [
            63906,
            63906
        ],
        "mapped",
        [
            24265
        ]
    ],
    [
        [
            63907,
            63907
        ],
        "mapped",
        [
            24565
        ]
    ],
    [
        [
            63908,
            63908
        ],
        "mapped",
        [
            25467
        ]
    ],
    [
        [
            63909,
            63909
        ],
        "mapped",
        [
            27566
        ]
    ],
    [
        [
            63910,
            63910
        ],
        "mapped",
        [
            31806
        ]
    ],
    [
        [
            63911,
            63911
        ],
        "mapped",
        [
            29557
        ]
    ],
    [
        [
            63912,
            63912
        ],
        "mapped",
        [
            20196
        ]
    ],
    [
        [
            63913,
            63913
        ],
        "mapped",
        [
            22265
        ]
    ],
    [
        [
            63914,
            63914
        ],
        "mapped",
        [
            23527
        ]
    ],
    [
        [
            63915,
            63915
        ],
        "mapped",
        [
            23994
        ]
    ],
    [
        [
            63916,
            63916
        ],
        "mapped",
        [
            24604
        ]
    ],
    [
        [
            63917,
            63917
        ],
        "mapped",
        [
            29618
        ]
    ],
    [
        [
            63918,
            63918
        ],
        "mapped",
        [
            29801
        ]
    ],
    [
        [
            63919,
            63919
        ],
        "mapped",
        [
            32666
        ]
    ],
    [
        [
            63920,
            63920
        ],
        "mapped",
        [
            32838
        ]
    ],
    [
        [
            63921,
            63921
        ],
        "mapped",
        [
            37428
        ]
    ],
    [
        [
            63922,
            63922
        ],
        "mapped",
        [
            38646
        ]
    ],
    [
        [
            63923,
            63923
        ],
        "mapped",
        [
            38728
        ]
    ],
    [
        [
            63924,
            63924
        ],
        "mapped",
        [
            38936
        ]
    ],
    [
        [
            63925,
            63925
        ],
        "mapped",
        [
            20363
        ]
    ],
    [
        [
            63926,
            63926
        ],
        "mapped",
        [
            31150
        ]
    ],
    [
        [
            63927,
            63927
        ],
        "mapped",
        [
            37300
        ]
    ],
    [
        [
            63928,
            63928
        ],
        "mapped",
        [
            38584
        ]
    ],
    [
        [
            63929,
            63929
        ],
        "mapped",
        [
            24801
        ]
    ],
    [
        [
            63930,
            63930
        ],
        "mapped",
        [
            20102
        ]
    ],
    [
        [
            63931,
            63931
        ],
        "mapped",
        [
            20698
        ]
    ],
    [
        [
            63932,
            63932
        ],
        "mapped",
        [
            23534
        ]
    ],
    [
        [
            63933,
            63933
        ],
        "mapped",
        [
            23615
        ]
    ],
    [
        [
            63934,
            63934
        ],
        "mapped",
        [
            26009
        ]
    ],
    [
        [
            63935,
            63935
        ],
        "mapped",
        [
            27138
        ]
    ],
    [
        [
            63936,
            63936
        ],
        "mapped",
        [
            29134
        ]
    ],
    [
        [
            63937,
            63937
        ],
        "mapped",
        [
            30274
        ]
    ],
    [
        [
            63938,
            63938
        ],
        "mapped",
        [
            34044
        ]
    ],
    [
        [
            63939,
            63939
        ],
        "mapped",
        [
            36988
        ]
    ],
    [
        [
            63940,
            63940
        ],
        "mapped",
        [
            40845
        ]
    ],
    [
        [
            63941,
            63941
        ],
        "mapped",
        [
            26248
        ]
    ],
    [
        [
            63942,
            63942
        ],
        "mapped",
        [
            38446
        ]
    ],
    [
        [
            63943,
            63943
        ],
        "mapped",
        [
            21129
        ]
    ],
    [
        [
            63944,
            63944
        ],
        "mapped",
        [
            26491
        ]
    ],
    [
        [
            63945,
            63945
        ],
        "mapped",
        [
            26611
        ]
    ],
    [
        [
            63946,
            63946
        ],
        "mapped",
        [
            27969
        ]
    ],
    [
        [
            63947,
            63947
        ],
        "mapped",
        [
            28316
        ]
    ],
    [
        [
            63948,
            63948
        ],
        "mapped",
        [
            29705
        ]
    ],
    [
        [
            63949,
            63949
        ],
        "mapped",
        [
            30041
        ]
    ],
    [
        [
            63950,
            63950
        ],
        "mapped",
        [
            30827
        ]
    ],
    [
        [
            63951,
            63951
        ],
        "mapped",
        [
            32016
        ]
    ],
    [
        [
            63952,
            63952
        ],
        "mapped",
        [
            39006
        ]
    ],
    [
        [
            63953,
            63953
        ],
        "mapped",
        [
            20845
        ]
    ],
    [
        [
            63954,
            63954
        ],
        "mapped",
        [
            25134
        ]
    ],
    [
        [
            63955,
            63955
        ],
        "mapped",
        [
            38520
        ]
    ],
    [
        [
            63956,
            63956
        ],
        "mapped",
        [
            20523
        ]
    ],
    [
        [
            63957,
            63957
        ],
        "mapped",
        [
            23833
        ]
    ],
    [
        [
            63958,
            63958
        ],
        "mapped",
        [
            28138
        ]
    ],
    [
        [
            63959,
            63959
        ],
        "mapped",
        [
            36650
        ]
    ],
    [
        [
            63960,
            63960
        ],
        "mapped",
        [
            24459
        ]
    ],
    [
        [
            63961,
            63961
        ],
        "mapped",
        [
            24900
        ]
    ],
    [
        [
            63962,
            63962
        ],
        "mapped",
        [
            26647
        ]
    ],
    [
        [
            63963,
            63963
        ],
        "mapped",
        [
            29575
        ]
    ],
    [
        [
            63964,
            63964
        ],
        "mapped",
        [
            38534
        ]
    ],
    [
        [
            63965,
            63965
        ],
        "mapped",
        [
            21033
        ]
    ],
    [
        [
            63966,
            63966
        ],
        "mapped",
        [
            21519
        ]
    ],
    [
        [
            63967,
            63967
        ],
        "mapped",
        [
            23653
        ]
    ],
    [
        [
            63968,
            63968
        ],
        "mapped",
        [
            26131
        ]
    ],
    [
        [
            63969,
            63969
        ],
        "mapped",
        [
            26446
        ]
    ],
    [
        [
            63970,
            63970
        ],
        "mapped",
        [
            26792
        ]
    ],
    [
        [
            63971,
            63971
        ],
        "mapped",
        [
            27877
        ]
    ],
    [
        [
            63972,
            63972
        ],
        "mapped",
        [
            29702
        ]
    ],
    [
        [
            63973,
            63973
        ],
        "mapped",
        [
            30178
        ]
    ],
    [
        [
            63974,
            63974
        ],
        "mapped",
        [
            32633
        ]
    ],
    [
        [
            63975,
            63975
        ],
        "mapped",
        [
            35023
        ]
    ],
    [
        [
            63976,
            63976
        ],
        "mapped",
        [
            35041
        ]
    ],
    [
        [
            63977,
            63977
        ],
        "mapped",
        [
            37324
        ]
    ],
    [
        [
            63978,
            63978
        ],
        "mapped",
        [
            38626
        ]
    ],
    [
        [
            63979,
            63979
        ],
        "mapped",
        [
            21311
        ]
    ],
    [
        [
            63980,
            63980
        ],
        "mapped",
        [
            28346
        ]
    ],
    [
        [
            63981,
            63981
        ],
        "mapped",
        [
            21533
        ]
    ],
    [
        [
            63982,
            63982
        ],
        "mapped",
        [
            29136
        ]
    ],
    [
        [
            63983,
            63983
        ],
        "mapped",
        [
            29848
        ]
    ],
    [
        [
            63984,
            63984
        ],
        "mapped",
        [
            34298
        ]
    ],
    [
        [
            63985,
            63985
        ],
        "mapped",
        [
            38563
        ]
    ],
    [
        [
            63986,
            63986
        ],
        "mapped",
        [
            40023
        ]
    ],
    [
        [
            63987,
            63987
        ],
        "mapped",
        [
            40607
        ]
    ],
    [
        [
            63988,
            63988
        ],
        "mapped",
        [
            26519
        ]
    ],
    [
        [
            63989,
            63989
        ],
        "mapped",
        [
            28107
        ]
    ],
    [
        [
            63990,
            63990
        ],
        "mapped",
        [
            33256
        ]
    ],
    [
        [
            63991,
            63991
        ],
        "mapped",
        [
            31435
        ]
    ],
    [
        [
            63992,
            63992
        ],
        "mapped",
        [
            31520
        ]
    ],
    [
        [
            63993,
            63993
        ],
        "mapped",
        [
            31890
        ]
    ],
    [
        [
            63994,
            63994
        ],
        "mapped",
        [
            29376
        ]
    ],
    [
        [
            63995,
            63995
        ],
        "mapped",
        [
            28825
        ]
    ],
    [
        [
            63996,
            63996
        ],
        "mapped",
        [
            35672
        ]
    ],
    [
        [
            63997,
            63997
        ],
        "mapped",
        [
            20160
        ]
    ],
    [
        [
            63998,
            63998
        ],
        "mapped",
        [
            33590
        ]
    ],
    [
        [
            63999,
            63999
        ],
        "mapped",
        [
            21050
        ]
    ],
    [
        [
            64000,
            64000
        ],
        "mapped",
        [
            20999
        ]
    ],
    [
        [
            64001,
            64001
        ],
        "mapped",
        [
            24230
        ]
    ],
    [
        [
            64002,
            64002
        ],
        "mapped",
        [
            25299
        ]
    ],
    [
        [
            64003,
            64003
        ],
        "mapped",
        [
            31958
        ]
    ],
    [
        [
            64004,
            64004
        ],
        "mapped",
        [
            23429
        ]
    ],
    [
        [
            64005,
            64005
        ],
        "mapped",
        [
            27934
        ]
    ],
    [
        [
            64006,
            64006
        ],
        "mapped",
        [
            26292
        ]
    ],
    [
        [
            64007,
            64007
        ],
        "mapped",
        [
            36667
        ]
    ],
    [
        [
            64008,
            64008
        ],
        "mapped",
        [
            34892
        ]
    ],
    [
        [
            64009,
            64009
        ],
        "mapped",
        [
            38477
        ]
    ],
    [
        [
            64010,
            64010
        ],
        "mapped",
        [
            35211
        ]
    ],
    [
        [
            64011,
            64011
        ],
        "mapped",
        [
            24275
        ]
    ],
    [
        [
            64012,
            64012
        ],
        "mapped",
        [
            20800
        ]
    ],
    [
        [
            64013,
            64013
        ],
        "mapped",
        [
            21952
        ]
    ],
    [
        [
            64014,
            64015
        ],
        "valid"
    ],
    [
        [
            64016,
            64016
        ],
        "mapped",
        [
            22618
        ]
    ],
    [
        [
            64017,
            64017
        ],
        "valid"
    ],
    [
        [
            64018,
            64018
        ],
        "mapped",
        [
            26228
        ]
    ],
    [
        [
            64019,
            64020
        ],
        "valid"
    ],
    [
        [
            64021,
            64021
        ],
        "mapped",
        [
            20958
        ]
    ],
    [
        [
            64022,
            64022
        ],
        "mapped",
        [
            29482
        ]
    ],
    [
        [
            64023,
            64023
        ],
        "mapped",
        [
            30410
        ]
    ],
    [
        [
            64024,
            64024
        ],
        "mapped",
        [
            31036
        ]
    ],
    [
        [
            64025,
            64025
        ],
        "mapped",
        [
            31070
        ]
    ],
    [
        [
            64026,
            64026
        ],
        "mapped",
        [
            31077
        ]
    ],
    [
        [
            64027,
            64027
        ],
        "mapped",
        [
            31119
        ]
    ],
    [
        [
            64028,
            64028
        ],
        "mapped",
        [
            38742
        ]
    ],
    [
        [
            64029,
            64029
        ],
        "mapped",
        [
            31934
        ]
    ],
    [
        [
            64030,
            64030
        ],
        "mapped",
        [
            32701
        ]
    ],
    [
        [
            64031,
            64031
        ],
        "valid"
    ],
    [
        [
            64032,
            64032
        ],
        "mapped",
        [
            34322
        ]
    ],
    [
        [
            64033,
            64033
        ],
        "valid"
    ],
    [
        [
            64034,
            64034
        ],
        "mapped",
        [
            35576
        ]
    ],
    [
        [
            64035,
            64036
        ],
        "valid"
    ],
    [
        [
            64037,
            64037
        ],
        "mapped",
        [
            36920
        ]
    ],
    [
        [
            64038,
            64038
        ],
        "mapped",
        [
            37117
        ]
    ],
    [
        [
            64039,
            64041
        ],
        "valid"
    ],
    [
        [
            64042,
            64042
        ],
        "mapped",
        [
            39151
        ]
    ],
    [
        [
            64043,
            64043
        ],
        "mapped",
        [
            39164
        ]
    ],
    [
        [
            64044,
            64044
        ],
        "mapped",
        [
            39208
        ]
    ],
    [
        [
            64045,
            64045
        ],
        "mapped",
        [
            40372
        ]
    ],
    [
        [
            64046,
            64046
        ],
        "mapped",
        [
            37086
        ]
    ],
    [
        [
            64047,
            64047
        ],
        "mapped",
        [
            38583
        ]
    ],
    [
        [
            64048,
            64048
        ],
        "mapped",
        [
            20398
        ]
    ],
    [
        [
            64049,
            64049
        ],
        "mapped",
        [
            20711
        ]
    ],
    [
        [
            64050,
            64050
        ],
        "mapped",
        [
            20813
        ]
    ],
    [
        [
            64051,
            64051
        ],
        "mapped",
        [
            21193
        ]
    ],
    [
        [
            64052,
            64052
        ],
        "mapped",
        [
            21220
        ]
    ],
    [
        [
            64053,
            64053
        ],
        "mapped",
        [
            21329
        ]
    ],
    [
        [
            64054,
            64054
        ],
        "mapped",
        [
            21917
        ]
    ],
    [
        [
            64055,
            64055
        ],
        "mapped",
        [
            22022
        ]
    ],
    [
        [
            64056,
            64056
        ],
        "mapped",
        [
            22120
        ]
    ],
    [
        [
            64057,
            64057
        ],
        "mapped",
        [
            22592
        ]
    ],
    [
        [
            64058,
            64058
        ],
        "mapped",
        [
            22696
        ]
    ],
    [
        [
            64059,
            64059
        ],
        "mapped",
        [
            23652
        ]
    ],
    [
        [
            64060,
            64060
        ],
        "mapped",
        [
            23662
        ]
    ],
    [
        [
            64061,
            64061
        ],
        "mapped",
        [
            24724
        ]
    ],
    [
        [
            64062,
            64062
        ],
        "mapped",
        [
            24936
        ]
    ],
    [
        [
            64063,
            64063
        ],
        "mapped",
        [
            24974
        ]
    ],
    [
        [
            64064,
            64064
        ],
        "mapped",
        [
            25074
        ]
    ],
    [
        [
            64065,
            64065
        ],
        "mapped",
        [
            25935
        ]
    ],
    [
        [
            64066,
            64066
        ],
        "mapped",
        [
            26082
        ]
    ],
    [
        [
            64067,
            64067
        ],
        "mapped",
        [
            26257
        ]
    ],
    [
        [
            64068,
            64068
        ],
        "mapped",
        [
            26757
        ]
    ],
    [
        [
            64069,
            64069
        ],
        "mapped",
        [
            28023
        ]
    ],
    [
        [
            64070,
            64070
        ],
        "mapped",
        [
            28186
        ]
    ],
    [
        [
            64071,
            64071
        ],
        "mapped",
        [
            28450
        ]
    ],
    [
        [
            64072,
            64072
        ],
        "mapped",
        [
            29038
        ]
    ],
    [
        [
            64073,
            64073
        ],
        "mapped",
        [
            29227
        ]
    ],
    [
        [
            64074,
            64074
        ],
        "mapped",
        [
            29730
        ]
    ],
    [
        [
            64075,
            64075
        ],
        "mapped",
        [
            30865
        ]
    ],
    [
        [
            64076,
            64076
        ],
        "mapped",
        [
            31038
        ]
    ],
    [
        [
            64077,
            64077
        ],
        "mapped",
        [
            31049
        ]
    ],
    [
        [
            64078,
            64078
        ],
        "mapped",
        [
            31048
        ]
    ],
    [
        [
            64079,
            64079
        ],
        "mapped",
        [
            31056
        ]
    ],
    [
        [
            64080,
            64080
        ],
        "mapped",
        [
            31062
        ]
    ],
    [
        [
            64081,
            64081
        ],
        "mapped",
        [
            31069
        ]
    ],
    [
        [
            64082,
            64082
        ],
        "mapped",
        [
            31117
        ]
    ],
    [
        [
            64083,
            64083
        ],
        "mapped",
        [
            31118
        ]
    ],
    [
        [
            64084,
            64084
        ],
        "mapped",
        [
            31296
        ]
    ],
    [
        [
            64085,
            64085
        ],
        "mapped",
        [
            31361
        ]
    ],
    [
        [
            64086,
            64086
        ],
        "mapped",
        [
            31680
        ]
    ],
    [
        [
            64087,
            64087
        ],
        "mapped",
        [
            32244
        ]
    ],
    [
        [
            64088,
            64088
        ],
        "mapped",
        [
            32265
        ]
    ],
    [
        [
            64089,
            64089
        ],
        "mapped",
        [
            32321
        ]
    ],
    [
        [
            64090,
            64090
        ],
        "mapped",
        [
            32626
        ]
    ],
    [
        [
            64091,
            64091
        ],
        "mapped",
        [
            32773
        ]
    ],
    [
        [
            64092,
            64092
        ],
        "mapped",
        [
            33261
        ]
    ],
    [
        [
            64093,
            64094
        ],
        "mapped",
        [
            33401
        ]
    ],
    [
        [
            64095,
            64095
        ],
        "mapped",
        [
            33879
        ]
    ],
    [
        [
            64096,
            64096
        ],
        "mapped",
        [
            35088
        ]
    ],
    [
        [
            64097,
            64097
        ],
        "mapped",
        [
            35222
        ]
    ],
    [
        [
            64098,
            64098
        ],
        "mapped",
        [
            35585
        ]
    ],
    [
        [
            64099,
            64099
        ],
        "mapped",
        [
            35641
        ]
    ],
    [
        [
            64100,
            64100
        ],
        "mapped",
        [
            36051
        ]
    ],
    [
        [
            64101,
            64101
        ],
        "mapped",
        [
            36104
        ]
    ],
    [
        [
            64102,
            64102
        ],
        "mapped",
        [
            36790
        ]
    ],
    [
        [
            64103,
            64103
        ],
        "mapped",
        [
            36920
        ]
    ],
    [
        [
            64104,
            64104
        ],
        "mapped",
        [
            38627
        ]
    ],
    [
        [
            64105,
            64105
        ],
        "mapped",
        [
            38911
        ]
    ],
    [
        [
            64106,
            64106
        ],
        "mapped",
        [
            38971
        ]
    ],
    [
        [
            64107,
            64107
        ],
        "mapped",
        [
            24693
        ]
    ],
    [
        [
            64108,
            64108
        ],
        "mapped",
        [
            148206
        ]
    ],
    [
        [
            64109,
            64109
        ],
        "mapped",
        [
            33304
        ]
    ],
    [
        [
            64110,
            64111
        ],
        "disallowed"
    ],
    [
        [
            64112,
            64112
        ],
        "mapped",
        [
            20006
        ]
    ],
    [
        [
            64113,
            64113
        ],
        "mapped",
        [
            20917
        ]
    ],
    [
        [
            64114,
            64114
        ],
        "mapped",
        [
            20840
        ]
    ],
    [
        [
            64115,
            64115
        ],
        "mapped",
        [
            20352
        ]
    ],
    [
        [
            64116,
            64116
        ],
        "mapped",
        [
            20805
        ]
    ],
    [
        [
            64117,
            64117
        ],
        "mapped",
        [
            20864
        ]
    ],
    [
        [
            64118,
            64118
        ],
        "mapped",
        [
            21191
        ]
    ],
    [
        [
            64119,
            64119
        ],
        "mapped",
        [
            21242
        ]
    ],
    [
        [
            64120,
            64120
        ],
        "mapped",
        [
            21917
        ]
    ],
    [
        [
            64121,
            64121
        ],
        "mapped",
        [
            21845
        ]
    ],
    [
        [
            64122,
            64122
        ],
        "mapped",
        [
            21913
        ]
    ],
    [
        [
            64123,
            64123
        ],
        "mapped",
        [
            21986
        ]
    ],
    [
        [
            64124,
            64124
        ],
        "mapped",
        [
            22618
        ]
    ],
    [
        [
            64125,
            64125
        ],
        "mapped",
        [
            22707
        ]
    ],
    [
        [
            64126,
            64126
        ],
        "mapped",
        [
            22852
        ]
    ],
    [
        [
            64127,
            64127
        ],
        "mapped",
        [
            22868
        ]
    ],
    [
        [
            64128,
            64128
        ],
        "mapped",
        [
            23138
        ]
    ],
    [
        [
            64129,
            64129
        ],
        "mapped",
        [
            23336
        ]
    ],
    [
        [
            64130,
            64130
        ],
        "mapped",
        [
            24274
        ]
    ],
    [
        [
            64131,
            64131
        ],
        "mapped",
        [
            24281
        ]
    ],
    [
        [
            64132,
            64132
        ],
        "mapped",
        [
            24425
        ]
    ],
    [
        [
            64133,
            64133
        ],
        "mapped",
        [
            24493
        ]
    ],
    [
        [
            64134,
            64134
        ],
        "mapped",
        [
            24792
        ]
    ],
    [
        [
            64135,
            64135
        ],
        "mapped",
        [
            24910
        ]
    ],
    [
        [
            64136,
            64136
        ],
        "mapped",
        [
            24840
        ]
    ],
    [
        [
            64137,
            64137
        ],
        "mapped",
        [
            24974
        ]
    ],
    [
        [
            64138,
            64138
        ],
        "mapped",
        [
            24928
        ]
    ],
    [
        [
            64139,
            64139
        ],
        "mapped",
        [
            25074
        ]
    ],
    [
        [
            64140,
            64140
        ],
        "mapped",
        [
            25140
        ]
    ],
    [
        [
            64141,
            64141
        ],
        "mapped",
        [
            25540
        ]
    ],
    [
        [
            64142,
            64142
        ],
        "mapped",
        [
            25628
        ]
    ],
    [
        [
            64143,
            64143
        ],
        "mapped",
        [
            25682
        ]
    ],
    [
        [
            64144,
            64144
        ],
        "mapped",
        [
            25942
        ]
    ],
    [
        [
            64145,
            64145
        ],
        "mapped",
        [
            26228
        ]
    ],
    [
        [
            64146,
            64146
        ],
        "mapped",
        [
            26391
        ]
    ],
    [
        [
            64147,
            64147
        ],
        "mapped",
        [
            26395
        ]
    ],
    [
        [
            64148,
            64148
        ],
        "mapped",
        [
            26454
        ]
    ],
    [
        [
            64149,
            64149
        ],
        "mapped",
        [
            27513
        ]
    ],
    [
        [
            64150,
            64150
        ],
        "mapped",
        [
            27578
        ]
    ],
    [
        [
            64151,
            64151
        ],
        "mapped",
        [
            27969
        ]
    ],
    [
        [
            64152,
            64152
        ],
        "mapped",
        [
            28379
        ]
    ],
    [
        [
            64153,
            64153
        ],
        "mapped",
        [
            28363
        ]
    ],
    [
        [
            64154,
            64154
        ],
        "mapped",
        [
            28450
        ]
    ],
    [
        [
            64155,
            64155
        ],
        "mapped",
        [
            28702
        ]
    ],
    [
        [
            64156,
            64156
        ],
        "mapped",
        [
            29038
        ]
    ],
    [
        [
            64157,
            64157
        ],
        "mapped",
        [
            30631
        ]
    ],
    [
        [
            64158,
            64158
        ],
        "mapped",
        [
            29237
        ]
    ],
    [
        [
            64159,
            64159
        ],
        "mapped",
        [
            29359
        ]
    ],
    [
        [
            64160,
            64160
        ],
        "mapped",
        [
            29482
        ]
    ],
    [
        [
            64161,
            64161
        ],
        "mapped",
        [
            29809
        ]
    ],
    [
        [
            64162,
            64162
        ],
        "mapped",
        [
            29958
        ]
    ],
    [
        [
            64163,
            64163
        ],
        "mapped",
        [
            30011
        ]
    ],
    [
        [
            64164,
            64164
        ],
        "mapped",
        [
            30237
        ]
    ],
    [
        [
            64165,
            64165
        ],
        "mapped",
        [
            30239
        ]
    ],
    [
        [
            64166,
            64166
        ],
        "mapped",
        [
            30410
        ]
    ],
    [
        [
            64167,
            64167
        ],
        "mapped",
        [
            30427
        ]
    ],
    [
        [
            64168,
            64168
        ],
        "mapped",
        [
            30452
        ]
    ],
    [
        [
            64169,
            64169
        ],
        "mapped",
        [
            30538
        ]
    ],
    [
        [
            64170,
            64170
        ],
        "mapped",
        [
            30528
        ]
    ],
    [
        [
            64171,
            64171
        ],
        "mapped",
        [
            30924
        ]
    ],
    [
        [
            64172,
            64172
        ],
        "mapped",
        [
            31409
        ]
    ],
    [
        [
            64173,
            64173
        ],
        "mapped",
        [
            31680
        ]
    ],
    [
        [
            64174,
            64174
        ],
        "mapped",
        [
            31867
        ]
    ],
    [
        [
            64175,
            64175
        ],
        "mapped",
        [
            32091
        ]
    ],
    [
        [
            64176,
            64176
        ],
        "mapped",
        [
            32244
        ]
    ],
    [
        [
            64177,
            64177
        ],
        "mapped",
        [
            32574
        ]
    ],
    [
        [
            64178,
            64178
        ],
        "mapped",
        [
            32773
        ]
    ],
    [
        [
            64179,
            64179
        ],
        "mapped",
        [
            33618
        ]
    ],
    [
        [
            64180,
            64180
        ],
        "mapped",
        [
            33775
        ]
    ],
    [
        [
            64181,
            64181
        ],
        "mapped",
        [
            34681
        ]
    ],
    [
        [
            64182,
            64182
        ],
        "mapped",
        [
            35137
        ]
    ],
    [
        [
            64183,
            64183
        ],
        "mapped",
        [
            35206
        ]
    ],
    [
        [
            64184,
            64184
        ],
        "mapped",
        [
            35222
        ]
    ],
    [
        [
            64185,
            64185
        ],
        "mapped",
        [
            35519
        ]
    ],
    [
        [
            64186,
            64186
        ],
        "mapped",
        [
            35576
        ]
    ],
    [
        [
            64187,
            64187
        ],
        "mapped",
        [
            35531
        ]
    ],
    [
        [
            64188,
            64188
        ],
        "mapped",
        [
            35585
        ]
    ],
    [
        [
            64189,
            64189
        ],
        "mapped",
        [
            35582
        ]
    ],
    [
        [
            64190,
            64190
        ],
        "mapped",
        [
            35565
        ]
    ],
    [
        [
            64191,
            64191
        ],
        "mapped",
        [
            35641
        ]
    ],
    [
        [
            64192,
            64192
        ],
        "mapped",
        [
            35722
        ]
    ],
    [
        [
            64193,
            64193
        ],
        "mapped",
        [
            36104
        ]
    ],
    [
        [
            64194,
            64194
        ],
        "mapped",
        [
            36664
        ]
    ],
    [
        [
            64195,
            64195
        ],
        "mapped",
        [
            36978
        ]
    ],
    [
        [
            64196,
            64196
        ],
        "mapped",
        [
            37273
        ]
    ],
    [
        [
            64197,
            64197
        ],
        "mapped",
        [
            37494
        ]
    ],
    [
        [
            64198,
            64198
        ],
        "mapped",
        [
            38524
        ]
    ],
    [
        [
            64199,
            64199
        ],
        "mapped",
        [
            38627
        ]
    ],
    [
        [
            64200,
            64200
        ],
        "mapped",
        [
            38742
        ]
    ],
    [
        [
            64201,
            64201
        ],
        "mapped",
        [
            38875
        ]
    ],
    [
        [
            64202,
            64202
        ],
        "mapped",
        [
            38911
        ]
    ],
    [
        [
            64203,
            64203
        ],
        "mapped",
        [
            38923
        ]
    ],
    [
        [
            64204,
            64204
        ],
        "mapped",
        [
            38971
        ]
    ],
    [
        [
            64205,
            64205
        ],
        "mapped",
        [
            39698
        ]
    ],
    [
        [
            64206,
            64206
        ],
        "mapped",
        [
            40860
        ]
    ],
    [
        [
            64207,
            64207
        ],
        "mapped",
        [
            141386
        ]
    ],
    [
        [
            64208,
            64208
        ],
        "mapped",
        [
            141380
        ]
    ],
    [
        [
            64209,
            64209
        ],
        "mapped",
        [
            144341
        ]
    ],
    [
        [
            64210,
            64210
        ],
        "mapped",
        [
            15261
        ]
    ],
    [
        [
            64211,
            64211
        ],
        "mapped",
        [
            16408
        ]
    ],
    [
        [
            64212,
            64212
        ],
        "mapped",
        [
            16441
        ]
    ],
    [
        [
            64213,
            64213
        ],
        "mapped",
        [
            152137
        ]
    ],
    [
        [
            64214,
            64214
        ],
        "mapped",
        [
            154832
        ]
    ],
    [
        [
            64215,
            64215
        ],
        "mapped",
        [
            163539
        ]
    ],
    [
        [
            64216,
            64216
        ],
        "mapped",
        [
            40771
        ]
    ],
    [
        [
            64217,
            64217
        ],
        "mapped",
        [
            40846
        ]
    ],
    [
        [
            64218,
            64255
        ],
        "disallowed"
    ],
    [
        [
            64256,
            64256
        ],
        "mapped",
        [
            102,
            102
        ]
    ],
    [
        [
            64257,
            64257
        ],
        "mapped",
        [
            102,
            105
        ]
    ],
    [
        [
            64258,
            64258
        ],
        "mapped",
        [
            102,
            108
        ]
    ],
    [
        [
            64259,
            64259
        ],
        "mapped",
        [
            102,
            102,
            105
        ]
    ],
    [
        [
            64260,
            64260
        ],
        "mapped",
        [
            102,
            102,
            108
        ]
    ],
    [
        [
            64261,
            64262
        ],
        "mapped",
        [
            115,
            116
        ]
    ],
    [
        [
            64263,
            64274
        ],
        "disallowed"
    ],
    [
        [
            64275,
            64275
        ],
        "mapped",
        [
            1396,
            1398
        ]
    ],
    [
        [
            64276,
            64276
        ],
        "mapped",
        [
            1396,
            1381
        ]
    ],
    [
        [
            64277,
            64277
        ],
        "mapped",
        [
            1396,
            1387
        ]
    ],
    [
        [
            64278,
            64278
        ],
        "mapped",
        [
            1406,
            1398
        ]
    ],
    [
        [
            64279,
            64279
        ],
        "mapped",
        [
            1396,
            1389
        ]
    ],
    [
        [
            64280,
            64284
        ],
        "disallowed"
    ],
    [
        [
            64285,
            64285
        ],
        "mapped",
        [
            1497,
            1460
        ]
    ],
    [
        [
            64286,
            64286
        ],
        "valid"
    ],
    [
        [
            64287,
            64287
        ],
        "mapped",
        [
            1522,
            1463
        ]
    ],
    [
        [
            64288,
            64288
        ],
        "mapped",
        [
            1506
        ]
    ],
    [
        [
            64289,
            64289
        ],
        "mapped",
        [
            1488
        ]
    ],
    [
        [
            64290,
            64290
        ],
        "mapped",
        [
            1491
        ]
    ],
    [
        [
            64291,
            64291
        ],
        "mapped",
        [
            1492
        ]
    ],
    [
        [
            64292,
            64292
        ],
        "mapped",
        [
            1499
        ]
    ],
    [
        [
            64293,
            64293
        ],
        "mapped",
        [
            1500
        ]
    ],
    [
        [
            64294,
            64294
        ],
        "mapped",
        [
            1501
        ]
    ],
    [
        [
            64295,
            64295
        ],
        "mapped",
        [
            1512
        ]
    ],
    [
        [
            64296,
            64296
        ],
        "mapped",
        [
            1514
        ]
    ],
    [
        [
            64297,
            64297
        ],
        "disallowed_STD3_mapped",
        [
            43
        ]
    ],
    [
        [
            64298,
            64298
        ],
        "mapped",
        [
            1513,
            1473
        ]
    ],
    [
        [
            64299,
            64299
        ],
        "mapped",
        [
            1513,
            1474
        ]
    ],
    [
        [
            64300,
            64300
        ],
        "mapped",
        [
            1513,
            1468,
            1473
        ]
    ],
    [
        [
            64301,
            64301
        ],
        "mapped",
        [
            1513,
            1468,
            1474
        ]
    ],
    [
        [
            64302,
            64302
        ],
        "mapped",
        [
            1488,
            1463
        ]
    ],
    [
        [
            64303,
            64303
        ],
        "mapped",
        [
            1488,
            1464
        ]
    ],
    [
        [
            64304,
            64304
        ],
        "mapped",
        [
            1488,
            1468
        ]
    ],
    [
        [
            64305,
            64305
        ],
        "mapped",
        [
            1489,
            1468
        ]
    ],
    [
        [
            64306,
            64306
        ],
        "mapped",
        [
            1490,
            1468
        ]
    ],
    [
        [
            64307,
            64307
        ],
        "mapped",
        [
            1491,
            1468
        ]
    ],
    [
        [
            64308,
            64308
        ],
        "mapped",
        [
            1492,
            1468
        ]
    ],
    [
        [
            64309,
            64309
        ],
        "mapped",
        [
            1493,
            1468
        ]
    ],
    [
        [
            64310,
            64310
        ],
        "mapped",
        [
            1494,
            1468
        ]
    ],
    [
        [
            64311,
            64311
        ],
        "disallowed"
    ],
    [
        [
            64312,
            64312
        ],
        "mapped",
        [
            1496,
            1468
        ]
    ],
    [
        [
            64313,
            64313
        ],
        "mapped",
        [
            1497,
            1468
        ]
    ],
    [
        [
            64314,
            64314
        ],
        "mapped",
        [
            1498,
            1468
        ]
    ],
    [
        [
            64315,
            64315
        ],
        "mapped",
        [
            1499,
            1468
        ]
    ],
    [
        [
            64316,
            64316
        ],
        "mapped",
        [
            1500,
            1468
        ]
    ],
    [
        [
            64317,
            64317
        ],
        "disallowed"
    ],
    [
        [
            64318,
            64318
        ],
        "mapped",
        [
            1502,
            1468
        ]
    ],
    [
        [
            64319,
            64319
        ],
        "disallowed"
    ],
    [
        [
            64320,
            64320
        ],
        "mapped",
        [
            1504,
            1468
        ]
    ],
    [
        [
            64321,
            64321
        ],
        "mapped",
        [
            1505,
            1468
        ]
    ],
    [
        [
            64322,
            64322
        ],
        "disallowed"
    ],
    [
        [
            64323,
            64323
        ],
        "mapped",
        [
            1507,
            1468
        ]
    ],
    [
        [
            64324,
            64324
        ],
        "mapped",
        [
            1508,
            1468
        ]
    ],
    [
        [
            64325,
            64325
        ],
        "disallowed"
    ],
    [
        [
            64326,
            64326
        ],
        "mapped",
        [
            1510,
            1468
        ]
    ],
    [
        [
            64327,
            64327
        ],
        "mapped",
        [
            1511,
            1468
        ]
    ],
    [
        [
            64328,
            64328
        ],
        "mapped",
        [
            1512,
            1468
        ]
    ],
    [
        [
            64329,
            64329
        ],
        "mapped",
        [
            1513,
            1468
        ]
    ],
    [
        [
            64330,
            64330
        ],
        "mapped",
        [
            1514,
            1468
        ]
    ],
    [
        [
            64331,
            64331
        ],
        "mapped",
        [
            1493,
            1465
        ]
    ],
    [
        [
            64332,
            64332
        ],
        "mapped",
        [
            1489,
            1471
        ]
    ],
    [
        [
            64333,
            64333
        ],
        "mapped",
        [
            1499,
            1471
        ]
    ],
    [
        [
            64334,
            64334
        ],
        "mapped",
        [
            1508,
            1471
        ]
    ],
    [
        [
            64335,
            64335
        ],
        "mapped",
        [
            1488,
            1500
        ]
    ],
    [
        [
            64336,
            64337
        ],
        "mapped",
        [
            1649
        ]
    ],
    [
        [
            64338,
            64341
        ],
        "mapped",
        [
            1659
        ]
    ],
    [
        [
            64342,
            64345
        ],
        "mapped",
        [
            1662
        ]
    ],
    [
        [
            64346,
            64349
        ],
        "mapped",
        [
            1664
        ]
    ],
    [
        [
            64350,
            64353
        ],
        "mapped",
        [
            1658
        ]
    ],
    [
        [
            64354,
            64357
        ],
        "mapped",
        [
            1663
        ]
    ],
    [
        [
            64358,
            64361
        ],
        "mapped",
        [
            1657
        ]
    ],
    [
        [
            64362,
            64365
        ],
        "mapped",
        [
            1700
        ]
    ],
    [
        [
            64366,
            64369
        ],
        "mapped",
        [
            1702
        ]
    ],
    [
        [
            64370,
            64373
        ],
        "mapped",
        [
            1668
        ]
    ],
    [
        [
            64374,
            64377
        ],
        "mapped",
        [
            1667
        ]
    ],
    [
        [
            64378,
            64381
        ],
        "mapped",
        [
            1670
        ]
    ],
    [
        [
            64382,
            64385
        ],
        "mapped",
        [
            1671
        ]
    ],
    [
        [
            64386,
            64387
        ],
        "mapped",
        [
            1677
        ]
    ],
    [
        [
            64388,
            64389
        ],
        "mapped",
        [
            1676
        ]
    ],
    [
        [
            64390,
            64391
        ],
        "mapped",
        [
            1678
        ]
    ],
    [
        [
            64392,
            64393
        ],
        "mapped",
        [
            1672
        ]
    ],
    [
        [
            64394,
            64395
        ],
        "mapped",
        [
            1688
        ]
    ],
    [
        [
            64396,
            64397
        ],
        "mapped",
        [
            1681
        ]
    ],
    [
        [
            64398,
            64401
        ],
        "mapped",
        [
            1705
        ]
    ],
    [
        [
            64402,
            64405
        ],
        "mapped",
        [
            1711
        ]
    ],
    [
        [
            64406,
            64409
        ],
        "mapped",
        [
            1715
        ]
    ],
    [
        [
            64410,
            64413
        ],
        "mapped",
        [
            1713
        ]
    ],
    [
        [
            64414,
            64415
        ],
        "mapped",
        [
            1722
        ]
    ],
    [
        [
            64416,
            64419
        ],
        "mapped",
        [
            1723
        ]
    ],
    [
        [
            64420,
            64421
        ],
        "mapped",
        [
            1728
        ]
    ],
    [
        [
            64422,
            64425
        ],
        "mapped",
        [
            1729
        ]
    ],
    [
        [
            64426,
            64429
        ],
        "mapped",
        [
            1726
        ]
    ],
    [
        [
            64430,
            64431
        ],
        "mapped",
        [
            1746
        ]
    ],
    [
        [
            64432,
            64433
        ],
        "mapped",
        [
            1747
        ]
    ],
    [
        [
            64434,
            64449
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            64450,
            64466
        ],
        "disallowed"
    ],
    [
        [
            64467,
            64470
        ],
        "mapped",
        [
            1709
        ]
    ],
    [
        [
            64471,
            64472
        ],
        "mapped",
        [
            1735
        ]
    ],
    [
        [
            64473,
            64474
        ],
        "mapped",
        [
            1734
        ]
    ],
    [
        [
            64475,
            64476
        ],
        "mapped",
        [
            1736
        ]
    ],
    [
        [
            64477,
            64477
        ],
        "mapped",
        [
            1735,
            1652
        ]
    ],
    [
        [
            64478,
            64479
        ],
        "mapped",
        [
            1739
        ]
    ],
    [
        [
            64480,
            64481
        ],
        "mapped",
        [
            1733
        ]
    ],
    [
        [
            64482,
            64483
        ],
        "mapped",
        [
            1737
        ]
    ],
    [
        [
            64484,
            64487
        ],
        "mapped",
        [
            1744
        ]
    ],
    [
        [
            64488,
            64489
        ],
        "mapped",
        [
            1609
        ]
    ],
    [
        [
            64490,
            64491
        ],
        "mapped",
        [
            1574,
            1575
        ]
    ],
    [
        [
            64492,
            64493
        ],
        "mapped",
        [
            1574,
            1749
        ]
    ],
    [
        [
            64494,
            64495
        ],
        "mapped",
        [
            1574,
            1608
        ]
    ],
    [
        [
            64496,
            64497
        ],
        "mapped",
        [
            1574,
            1735
        ]
    ],
    [
        [
            64498,
            64499
        ],
        "mapped",
        [
            1574,
            1734
        ]
    ],
    [
        [
            64500,
            64501
        ],
        "mapped",
        [
            1574,
            1736
        ]
    ],
    [
        [
            64502,
            64504
        ],
        "mapped",
        [
            1574,
            1744
        ]
    ],
    [
        [
            64505,
            64507
        ],
        "mapped",
        [
            1574,
            1609
        ]
    ],
    [
        [
            64508,
            64511
        ],
        "mapped",
        [
            1740
        ]
    ],
    [
        [
            64512,
            64512
        ],
        "mapped",
        [
            1574,
            1580
        ]
    ],
    [
        [
            64513,
            64513
        ],
        "mapped",
        [
            1574,
            1581
        ]
    ],
    [
        [
            64514,
            64514
        ],
        "mapped",
        [
            1574,
            1605
        ]
    ],
    [
        [
            64515,
            64515
        ],
        "mapped",
        [
            1574,
            1609
        ]
    ],
    [
        [
            64516,
            64516
        ],
        "mapped",
        [
            1574,
            1610
        ]
    ],
    [
        [
            64517,
            64517
        ],
        "mapped",
        [
            1576,
            1580
        ]
    ],
    [
        [
            64518,
            64518
        ],
        "mapped",
        [
            1576,
            1581
        ]
    ],
    [
        [
            64519,
            64519
        ],
        "mapped",
        [
            1576,
            1582
        ]
    ],
    [
        [
            64520,
            64520
        ],
        "mapped",
        [
            1576,
            1605
        ]
    ],
    [
        [
            64521,
            64521
        ],
        "mapped",
        [
            1576,
            1609
        ]
    ],
    [
        [
            64522,
            64522
        ],
        "mapped",
        [
            1576,
            1610
        ]
    ],
    [
        [
            64523,
            64523
        ],
        "mapped",
        [
            1578,
            1580
        ]
    ],
    [
        [
            64524,
            64524
        ],
        "mapped",
        [
            1578,
            1581
        ]
    ],
    [
        [
            64525,
            64525
        ],
        "mapped",
        [
            1578,
            1582
        ]
    ],
    [
        [
            64526,
            64526
        ],
        "mapped",
        [
            1578,
            1605
        ]
    ],
    [
        [
            64527,
            64527
        ],
        "mapped",
        [
            1578,
            1609
        ]
    ],
    [
        [
            64528,
            64528
        ],
        "mapped",
        [
            1578,
            1610
        ]
    ],
    [
        [
            64529,
            64529
        ],
        "mapped",
        [
            1579,
            1580
        ]
    ],
    [
        [
            64530,
            64530
        ],
        "mapped",
        [
            1579,
            1605
        ]
    ],
    [
        [
            64531,
            64531
        ],
        "mapped",
        [
            1579,
            1609
        ]
    ],
    [
        [
            64532,
            64532
        ],
        "mapped",
        [
            1579,
            1610
        ]
    ],
    [
        [
            64533,
            64533
        ],
        "mapped",
        [
            1580,
            1581
        ]
    ],
    [
        [
            64534,
            64534
        ],
        "mapped",
        [
            1580,
            1605
        ]
    ],
    [
        [
            64535,
            64535
        ],
        "mapped",
        [
            1581,
            1580
        ]
    ],
    [
        [
            64536,
            64536
        ],
        "mapped",
        [
            1581,
            1605
        ]
    ],
    [
        [
            64537,
            64537
        ],
        "mapped",
        [
            1582,
            1580
        ]
    ],
    [
        [
            64538,
            64538
        ],
        "mapped",
        [
            1582,
            1581
        ]
    ],
    [
        [
            64539,
            64539
        ],
        "mapped",
        [
            1582,
            1605
        ]
    ],
    [
        [
            64540,
            64540
        ],
        "mapped",
        [
            1587,
            1580
        ]
    ],
    [
        [
            64541,
            64541
        ],
        "mapped",
        [
            1587,
            1581
        ]
    ],
    [
        [
            64542,
            64542
        ],
        "mapped",
        [
            1587,
            1582
        ]
    ],
    [
        [
            64543,
            64543
        ],
        "mapped",
        [
            1587,
            1605
        ]
    ],
    [
        [
            64544,
            64544
        ],
        "mapped",
        [
            1589,
            1581
        ]
    ],
    [
        [
            64545,
            64545
        ],
        "mapped",
        [
            1589,
            1605
        ]
    ],
    [
        [
            64546,
            64546
        ],
        "mapped",
        [
            1590,
            1580
        ]
    ],
    [
        [
            64547,
            64547
        ],
        "mapped",
        [
            1590,
            1581
        ]
    ],
    [
        [
            64548,
            64548
        ],
        "mapped",
        [
            1590,
            1582
        ]
    ],
    [
        [
            64549,
            64549
        ],
        "mapped",
        [
            1590,
            1605
        ]
    ],
    [
        [
            64550,
            64550
        ],
        "mapped",
        [
            1591,
            1581
        ]
    ],
    [
        [
            64551,
            64551
        ],
        "mapped",
        [
            1591,
            1605
        ]
    ],
    [
        [
            64552,
            64552
        ],
        "mapped",
        [
            1592,
            1605
        ]
    ],
    [
        [
            64553,
            64553
        ],
        "mapped",
        [
            1593,
            1580
        ]
    ],
    [
        [
            64554,
            64554
        ],
        "mapped",
        [
            1593,
            1605
        ]
    ],
    [
        [
            64555,
            64555
        ],
        "mapped",
        [
            1594,
            1580
        ]
    ],
    [
        [
            64556,
            64556
        ],
        "mapped",
        [
            1594,
            1605
        ]
    ],
    [
        [
            64557,
            64557
        ],
        "mapped",
        [
            1601,
            1580
        ]
    ],
    [
        [
            64558,
            64558
        ],
        "mapped",
        [
            1601,
            1581
        ]
    ],
    [
        [
            64559,
            64559
        ],
        "mapped",
        [
            1601,
            1582
        ]
    ],
    [
        [
            64560,
            64560
        ],
        "mapped",
        [
            1601,
            1605
        ]
    ],
    [
        [
            64561,
            64561
        ],
        "mapped",
        [
            1601,
            1609
        ]
    ],
    [
        [
            64562,
            64562
        ],
        "mapped",
        [
            1601,
            1610
        ]
    ],
    [
        [
            64563,
            64563
        ],
        "mapped",
        [
            1602,
            1581
        ]
    ],
    [
        [
            64564,
            64564
        ],
        "mapped",
        [
            1602,
            1605
        ]
    ],
    [
        [
            64565,
            64565
        ],
        "mapped",
        [
            1602,
            1609
        ]
    ],
    [
        [
            64566,
            64566
        ],
        "mapped",
        [
            1602,
            1610
        ]
    ],
    [
        [
            64567,
            64567
        ],
        "mapped",
        [
            1603,
            1575
        ]
    ],
    [
        [
            64568,
            64568
        ],
        "mapped",
        [
            1603,
            1580
        ]
    ],
    [
        [
            64569,
            64569
        ],
        "mapped",
        [
            1603,
            1581
        ]
    ],
    [
        [
            64570,
            64570
        ],
        "mapped",
        [
            1603,
            1582
        ]
    ],
    [
        [
            64571,
            64571
        ],
        "mapped",
        [
            1603,
            1604
        ]
    ],
    [
        [
            64572,
            64572
        ],
        "mapped",
        [
            1603,
            1605
        ]
    ],
    [
        [
            64573,
            64573
        ],
        "mapped",
        [
            1603,
            1609
        ]
    ],
    [
        [
            64574,
            64574
        ],
        "mapped",
        [
            1603,
            1610
        ]
    ],
    [
        [
            64575,
            64575
        ],
        "mapped",
        [
            1604,
            1580
        ]
    ],
    [
        [
            64576,
            64576
        ],
        "mapped",
        [
            1604,
            1581
        ]
    ],
    [
        [
            64577,
            64577
        ],
        "mapped",
        [
            1604,
            1582
        ]
    ],
    [
        [
            64578,
            64578
        ],
        "mapped",
        [
            1604,
            1605
        ]
    ],
    [
        [
            64579,
            64579
        ],
        "mapped",
        [
            1604,
            1609
        ]
    ],
    [
        [
            64580,
            64580
        ],
        "mapped",
        [
            1604,
            1610
        ]
    ],
    [
        [
            64581,
            64581
        ],
        "mapped",
        [
            1605,
            1580
        ]
    ],
    [
        [
            64582,
            64582
        ],
        "mapped",
        [
            1605,
            1581
        ]
    ],
    [
        [
            64583,
            64583
        ],
        "mapped",
        [
            1605,
            1582
        ]
    ],
    [
        [
            64584,
            64584
        ],
        "mapped",
        [
            1605,
            1605
        ]
    ],
    [
        [
            64585,
            64585
        ],
        "mapped",
        [
            1605,
            1609
        ]
    ],
    [
        [
            64586,
            64586
        ],
        "mapped",
        [
            1605,
            1610
        ]
    ],
    [
        [
            64587,
            64587
        ],
        "mapped",
        [
            1606,
            1580
        ]
    ],
    [
        [
            64588,
            64588
        ],
        "mapped",
        [
            1606,
            1581
        ]
    ],
    [
        [
            64589,
            64589
        ],
        "mapped",
        [
            1606,
            1582
        ]
    ],
    [
        [
            64590,
            64590
        ],
        "mapped",
        [
            1606,
            1605
        ]
    ],
    [
        [
            64591,
            64591
        ],
        "mapped",
        [
            1606,
            1609
        ]
    ],
    [
        [
            64592,
            64592
        ],
        "mapped",
        [
            1606,
            1610
        ]
    ],
    [
        [
            64593,
            64593
        ],
        "mapped",
        [
            1607,
            1580
        ]
    ],
    [
        [
            64594,
            64594
        ],
        "mapped",
        [
            1607,
            1605
        ]
    ],
    [
        [
            64595,
            64595
        ],
        "mapped",
        [
            1607,
            1609
        ]
    ],
    [
        [
            64596,
            64596
        ],
        "mapped",
        [
            1607,
            1610
        ]
    ],
    [
        [
            64597,
            64597
        ],
        "mapped",
        [
            1610,
            1580
        ]
    ],
    [
        [
            64598,
            64598
        ],
        "mapped",
        [
            1610,
            1581
        ]
    ],
    [
        [
            64599,
            64599
        ],
        "mapped",
        [
            1610,
            1582
        ]
    ],
    [
        [
            64600,
            64600
        ],
        "mapped",
        [
            1610,
            1605
        ]
    ],
    [
        [
            64601,
            64601
        ],
        "mapped",
        [
            1610,
            1609
        ]
    ],
    [
        [
            64602,
            64602
        ],
        "mapped",
        [
            1610,
            1610
        ]
    ],
    [
        [
            64603,
            64603
        ],
        "mapped",
        [
            1584,
            1648
        ]
    ],
    [
        [
            64604,
            64604
        ],
        "mapped",
        [
            1585,
            1648
        ]
    ],
    [
        [
            64605,
            64605
        ],
        "mapped",
        [
            1609,
            1648
        ]
    ],
    [
        [
            64606,
            64606
        ],
        "disallowed_STD3_mapped",
        [
            32,
            1612,
            1617
        ]
    ],
    [
        [
            64607,
            64607
        ],
        "disallowed_STD3_mapped",
        [
            32,
            1613,
            1617
        ]
    ],
    [
        [
            64608,
            64608
        ],
        "disallowed_STD3_mapped",
        [
            32,
            1614,
            1617
        ]
    ],
    [
        [
            64609,
            64609
        ],
        "disallowed_STD3_mapped",
        [
            32,
            1615,
            1617
        ]
    ],
    [
        [
            64610,
            64610
        ],
        "disallowed_STD3_mapped",
        [
            32,
            1616,
            1617
        ]
    ],
    [
        [
            64611,
            64611
        ],
        "disallowed_STD3_mapped",
        [
            32,
            1617,
            1648
        ]
    ],
    [
        [
            64612,
            64612
        ],
        "mapped",
        [
            1574,
            1585
        ]
    ],
    [
        [
            64613,
            64613
        ],
        "mapped",
        [
            1574,
            1586
        ]
    ],
    [
        [
            64614,
            64614
        ],
        "mapped",
        [
            1574,
            1605
        ]
    ],
    [
        [
            64615,
            64615
        ],
        "mapped",
        [
            1574,
            1606
        ]
    ],
    [
        [
            64616,
            64616
        ],
        "mapped",
        [
            1574,
            1609
        ]
    ],
    [
        [
            64617,
            64617
        ],
        "mapped",
        [
            1574,
            1610
        ]
    ],
    [
        [
            64618,
            64618
        ],
        "mapped",
        [
            1576,
            1585
        ]
    ],
    [
        [
            64619,
            64619
        ],
        "mapped",
        [
            1576,
            1586
        ]
    ],
    [
        [
            64620,
            64620
        ],
        "mapped",
        [
            1576,
            1605
        ]
    ],
    [
        [
            64621,
            64621
        ],
        "mapped",
        [
            1576,
            1606
        ]
    ],
    [
        [
            64622,
            64622
        ],
        "mapped",
        [
            1576,
            1609
        ]
    ],
    [
        [
            64623,
            64623
        ],
        "mapped",
        [
            1576,
            1610
        ]
    ],
    [
        [
            64624,
            64624
        ],
        "mapped",
        [
            1578,
            1585
        ]
    ],
    [
        [
            64625,
            64625
        ],
        "mapped",
        [
            1578,
            1586
        ]
    ],
    [
        [
            64626,
            64626
        ],
        "mapped",
        [
            1578,
            1605
        ]
    ],
    [
        [
            64627,
            64627
        ],
        "mapped",
        [
            1578,
            1606
        ]
    ],
    [
        [
            64628,
            64628
        ],
        "mapped",
        [
            1578,
            1609
        ]
    ],
    [
        [
            64629,
            64629
        ],
        "mapped",
        [
            1578,
            1610
        ]
    ],
    [
        [
            64630,
            64630
        ],
        "mapped",
        [
            1579,
            1585
        ]
    ],
    [
        [
            64631,
            64631
        ],
        "mapped",
        [
            1579,
            1586
        ]
    ],
    [
        [
            64632,
            64632
        ],
        "mapped",
        [
            1579,
            1605
        ]
    ],
    [
        [
            64633,
            64633
        ],
        "mapped",
        [
            1579,
            1606
        ]
    ],
    [
        [
            64634,
            64634
        ],
        "mapped",
        [
            1579,
            1609
        ]
    ],
    [
        [
            64635,
            64635
        ],
        "mapped",
        [
            1579,
            1610
        ]
    ],
    [
        [
            64636,
            64636
        ],
        "mapped",
        [
            1601,
            1609
        ]
    ],
    [
        [
            64637,
            64637
        ],
        "mapped",
        [
            1601,
            1610
        ]
    ],
    [
        [
            64638,
            64638
        ],
        "mapped",
        [
            1602,
            1609
        ]
    ],
    [
        [
            64639,
            64639
        ],
        "mapped",
        [
            1602,
            1610
        ]
    ],
    [
        [
            64640,
            64640
        ],
        "mapped",
        [
            1603,
            1575
        ]
    ],
    [
        [
            64641,
            64641
        ],
        "mapped",
        [
            1603,
            1604
        ]
    ],
    [
        [
            64642,
            64642
        ],
        "mapped",
        [
            1603,
            1605
        ]
    ],
    [
        [
            64643,
            64643
        ],
        "mapped",
        [
            1603,
            1609
        ]
    ],
    [
        [
            64644,
            64644
        ],
        "mapped",
        [
            1603,
            1610
        ]
    ],
    [
        [
            64645,
            64645
        ],
        "mapped",
        [
            1604,
            1605
        ]
    ],
    [
        [
            64646,
            64646
        ],
        "mapped",
        [
            1604,
            1609
        ]
    ],
    [
        [
            64647,
            64647
        ],
        "mapped",
        [
            1604,
            1610
        ]
    ],
    [
        [
            64648,
            64648
        ],
        "mapped",
        [
            1605,
            1575
        ]
    ],
    [
        [
            64649,
            64649
        ],
        "mapped",
        [
            1605,
            1605
        ]
    ],
    [
        [
            64650,
            64650
        ],
        "mapped",
        [
            1606,
            1585
        ]
    ],
    [
        [
            64651,
            64651
        ],
        "mapped",
        [
            1606,
            1586
        ]
    ],
    [
        [
            64652,
            64652
        ],
        "mapped",
        [
            1606,
            1605
        ]
    ],
    [
        [
            64653,
            64653
        ],
        "mapped",
        [
            1606,
            1606
        ]
    ],
    [
        [
            64654,
            64654
        ],
        "mapped",
        [
            1606,
            1609
        ]
    ],
    [
        [
            64655,
            64655
        ],
        "mapped",
        [
            1606,
            1610
        ]
    ],
    [
        [
            64656,
            64656
        ],
        "mapped",
        [
            1609,
            1648
        ]
    ],
    [
        [
            64657,
            64657
        ],
        "mapped",
        [
            1610,
            1585
        ]
    ],
    [
        [
            64658,
            64658
        ],
        "mapped",
        [
            1610,
            1586
        ]
    ],
    [
        [
            64659,
            64659
        ],
        "mapped",
        [
            1610,
            1605
        ]
    ],
    [
        [
            64660,
            64660
        ],
        "mapped",
        [
            1610,
            1606
        ]
    ],
    [
        [
            64661,
            64661
        ],
        "mapped",
        [
            1610,
            1609
        ]
    ],
    [
        [
            64662,
            64662
        ],
        "mapped",
        [
            1610,
            1610
        ]
    ],
    [
        [
            64663,
            64663
        ],
        "mapped",
        [
            1574,
            1580
        ]
    ],
    [
        [
            64664,
            64664
        ],
        "mapped",
        [
            1574,
            1581
        ]
    ],
    [
        [
            64665,
            64665
        ],
        "mapped",
        [
            1574,
            1582
        ]
    ],
    [
        [
            64666,
            64666
        ],
        "mapped",
        [
            1574,
            1605
        ]
    ],
    [
        [
            64667,
            64667
        ],
        "mapped",
        [
            1574,
            1607
        ]
    ],
    [
        [
            64668,
            64668
        ],
        "mapped",
        [
            1576,
            1580
        ]
    ],
    [
        [
            64669,
            64669
        ],
        "mapped",
        [
            1576,
            1581
        ]
    ],
    [
        [
            64670,
            64670
        ],
        "mapped",
        [
            1576,
            1582
        ]
    ],
    [
        [
            64671,
            64671
        ],
        "mapped",
        [
            1576,
            1605
        ]
    ],
    [
        [
            64672,
            64672
        ],
        "mapped",
        [
            1576,
            1607
        ]
    ],
    [
        [
            64673,
            64673
        ],
        "mapped",
        [
            1578,
            1580
        ]
    ],
    [
        [
            64674,
            64674
        ],
        "mapped",
        [
            1578,
            1581
        ]
    ],
    [
        [
            64675,
            64675
        ],
        "mapped",
        [
            1578,
            1582
        ]
    ],
    [
        [
            64676,
            64676
        ],
        "mapped",
        [
            1578,
            1605
        ]
    ],
    [
        [
            64677,
            64677
        ],
        "mapped",
        [
            1578,
            1607
        ]
    ],
    [
        [
            64678,
            64678
        ],
        "mapped",
        [
            1579,
            1605
        ]
    ],
    [
        [
            64679,
            64679
        ],
        "mapped",
        [
            1580,
            1581
        ]
    ],
    [
        [
            64680,
            64680
        ],
        "mapped",
        [
            1580,
            1605
        ]
    ],
    [
        [
            64681,
            64681
        ],
        "mapped",
        [
            1581,
            1580
        ]
    ],
    [
        [
            64682,
            64682
        ],
        "mapped",
        [
            1581,
            1605
        ]
    ],
    [
        [
            64683,
            64683
        ],
        "mapped",
        [
            1582,
            1580
        ]
    ],
    [
        [
            64684,
            64684
        ],
        "mapped",
        [
            1582,
            1605
        ]
    ],
    [
        [
            64685,
            64685
        ],
        "mapped",
        [
            1587,
            1580
        ]
    ],
    [
        [
            64686,
            64686
        ],
        "mapped",
        [
            1587,
            1581
        ]
    ],
    [
        [
            64687,
            64687
        ],
        "mapped",
        [
            1587,
            1582
        ]
    ],
    [
        [
            64688,
            64688
        ],
        "mapped",
        [
            1587,
            1605
        ]
    ],
    [
        [
            64689,
            64689
        ],
        "mapped",
        [
            1589,
            1581
        ]
    ],
    [
        [
            64690,
            64690
        ],
        "mapped",
        [
            1589,
            1582
        ]
    ],
    [
        [
            64691,
            64691
        ],
        "mapped",
        [
            1589,
            1605
        ]
    ],
    [
        [
            64692,
            64692
        ],
        "mapped",
        [
            1590,
            1580
        ]
    ],
    [
        [
            64693,
            64693
        ],
        "mapped",
        [
            1590,
            1581
        ]
    ],
    [
        [
            64694,
            64694
        ],
        "mapped",
        [
            1590,
            1582
        ]
    ],
    [
        [
            64695,
            64695
        ],
        "mapped",
        [
            1590,
            1605
        ]
    ],
    [
        [
            64696,
            64696
        ],
        "mapped",
        [
            1591,
            1581
        ]
    ],
    [
        [
            64697,
            64697
        ],
        "mapped",
        [
            1592,
            1605
        ]
    ],
    [
        [
            64698,
            64698
        ],
        "mapped",
        [
            1593,
            1580
        ]
    ],
    [
        [
            64699,
            64699
        ],
        "mapped",
        [
            1593,
            1605
        ]
    ],
    [
        [
            64700,
            64700
        ],
        "mapped",
        [
            1594,
            1580
        ]
    ],
    [
        [
            64701,
            64701
        ],
        "mapped",
        [
            1594,
            1605
        ]
    ],
    [
        [
            64702,
            64702
        ],
        "mapped",
        [
            1601,
            1580
        ]
    ],
    [
        [
            64703,
            64703
        ],
        "mapped",
        [
            1601,
            1581
        ]
    ],
    [
        [
            64704,
            64704
        ],
        "mapped",
        [
            1601,
            1582
        ]
    ],
    [
        [
            64705,
            64705
        ],
        "mapped",
        [
            1601,
            1605
        ]
    ],
    [
        [
            64706,
            64706
        ],
        "mapped",
        [
            1602,
            1581
        ]
    ],
    [
        [
            64707,
            64707
        ],
        "mapped",
        [
            1602,
            1605
        ]
    ],
    [
        [
            64708,
            64708
        ],
        "mapped",
        [
            1603,
            1580
        ]
    ],
    [
        [
            64709,
            64709
        ],
        "mapped",
        [
            1603,
            1581
        ]
    ],
    [
        [
            64710,
            64710
        ],
        "mapped",
        [
            1603,
            1582
        ]
    ],
    [
        [
            64711,
            64711
        ],
        "mapped",
        [
            1603,
            1604
        ]
    ],
    [
        [
            64712,
            64712
        ],
        "mapped",
        [
            1603,
            1605
        ]
    ],
    [
        [
            64713,
            64713
        ],
        "mapped",
        [
            1604,
            1580
        ]
    ],
    [
        [
            64714,
            64714
        ],
        "mapped",
        [
            1604,
            1581
        ]
    ],
    [
        [
            64715,
            64715
        ],
        "mapped",
        [
            1604,
            1582
        ]
    ],
    [
        [
            64716,
            64716
        ],
        "mapped",
        [
            1604,
            1605
        ]
    ],
    [
        [
            64717,
            64717
        ],
        "mapped",
        [
            1604,
            1607
        ]
    ],
    [
        [
            64718,
            64718
        ],
        "mapped",
        [
            1605,
            1580
        ]
    ],
    [
        [
            64719,
            64719
        ],
        "mapped",
        [
            1605,
            1581
        ]
    ],
    [
        [
            64720,
            64720
        ],
        "mapped",
        [
            1605,
            1582
        ]
    ],
    [
        [
            64721,
            64721
        ],
        "mapped",
        [
            1605,
            1605
        ]
    ],
    [
        [
            64722,
            64722
        ],
        "mapped",
        [
            1606,
            1580
        ]
    ],
    [
        [
            64723,
            64723
        ],
        "mapped",
        [
            1606,
            1581
        ]
    ],
    [
        [
            64724,
            64724
        ],
        "mapped",
        [
            1606,
            1582
        ]
    ],
    [
        [
            64725,
            64725
        ],
        "mapped",
        [
            1606,
            1605
        ]
    ],
    [
        [
            64726,
            64726
        ],
        "mapped",
        [
            1606,
            1607
        ]
    ],
    [
        [
            64727,
            64727
        ],
        "mapped",
        [
            1607,
            1580
        ]
    ],
    [
        [
            64728,
            64728
        ],
        "mapped",
        [
            1607,
            1605
        ]
    ],
    [
        [
            64729,
            64729
        ],
        "mapped",
        [
            1607,
            1648
        ]
    ],
    [
        [
            64730,
            64730
        ],
        "mapped",
        [
            1610,
            1580
        ]
    ],
    [
        [
            64731,
            64731
        ],
        "mapped",
        [
            1610,
            1581
        ]
    ],
    [
        [
            64732,
            64732
        ],
        "mapped",
        [
            1610,
            1582
        ]
    ],
    [
        [
            64733,
            64733
        ],
        "mapped",
        [
            1610,
            1605
        ]
    ],
    [
        [
            64734,
            64734
        ],
        "mapped",
        [
            1610,
            1607
        ]
    ],
    [
        [
            64735,
            64735
        ],
        "mapped",
        [
            1574,
            1605
        ]
    ],
    [
        [
            64736,
            64736
        ],
        "mapped",
        [
            1574,
            1607
        ]
    ],
    [
        [
            64737,
            64737
        ],
        "mapped",
        [
            1576,
            1605
        ]
    ],
    [
        [
            64738,
            64738
        ],
        "mapped",
        [
            1576,
            1607
        ]
    ],
    [
        [
            64739,
            64739
        ],
        "mapped",
        [
            1578,
            1605
        ]
    ],
    [
        [
            64740,
            64740
        ],
        "mapped",
        [
            1578,
            1607
        ]
    ],
    [
        [
            64741,
            64741
        ],
        "mapped",
        [
            1579,
            1605
        ]
    ],
    [
        [
            64742,
            64742
        ],
        "mapped",
        [
            1579,
            1607
        ]
    ],
    [
        [
            64743,
            64743
        ],
        "mapped",
        [
            1587,
            1605
        ]
    ],
    [
        [
            64744,
            64744
        ],
        "mapped",
        [
            1587,
            1607
        ]
    ],
    [
        [
            64745,
            64745
        ],
        "mapped",
        [
            1588,
            1605
        ]
    ],
    [
        [
            64746,
            64746
        ],
        "mapped",
        [
            1588,
            1607
        ]
    ],
    [
        [
            64747,
            64747
        ],
        "mapped",
        [
            1603,
            1604
        ]
    ],
    [
        [
            64748,
            64748
        ],
        "mapped",
        [
            1603,
            1605
        ]
    ],
    [
        [
            64749,
            64749
        ],
        "mapped",
        [
            1604,
            1605
        ]
    ],
    [
        [
            64750,
            64750
        ],
        "mapped",
        [
            1606,
            1605
        ]
    ],
    [
        [
            64751,
            64751
        ],
        "mapped",
        [
            1606,
            1607
        ]
    ],
    [
        [
            64752,
            64752
        ],
        "mapped",
        [
            1610,
            1605
        ]
    ],
    [
        [
            64753,
            64753
        ],
        "mapped",
        [
            1610,
            1607
        ]
    ],
    [
        [
            64754,
            64754
        ],
        "mapped",
        [
            1600,
            1614,
            1617
        ]
    ],
    [
        [
            64755,
            64755
        ],
        "mapped",
        [
            1600,
            1615,
            1617
        ]
    ],
    [
        [
            64756,
            64756
        ],
        "mapped",
        [
            1600,
            1616,
            1617
        ]
    ],
    [
        [
            64757,
            64757
        ],
        "mapped",
        [
            1591,
            1609
        ]
    ],
    [
        [
            64758,
            64758
        ],
        "mapped",
        [
            1591,
            1610
        ]
    ],
    [
        [
            64759,
            64759
        ],
        "mapped",
        [
            1593,
            1609
        ]
    ],
    [
        [
            64760,
            64760
        ],
        "mapped",
        [
            1593,
            1610
        ]
    ],
    [
        [
            64761,
            64761
        ],
        "mapped",
        [
            1594,
            1609
        ]
    ],
    [
        [
            64762,
            64762
        ],
        "mapped",
        [
            1594,
            1610
        ]
    ],
    [
        [
            64763,
            64763
        ],
        "mapped",
        [
            1587,
            1609
        ]
    ],
    [
        [
            64764,
            64764
        ],
        "mapped",
        [
            1587,
            1610
        ]
    ],
    [
        [
            64765,
            64765
        ],
        "mapped",
        [
            1588,
            1609
        ]
    ],
    [
        [
            64766,
            64766
        ],
        "mapped",
        [
            1588,
            1610
        ]
    ],
    [
        [
            64767,
            64767
        ],
        "mapped",
        [
            1581,
            1609
        ]
    ],
    [
        [
            64768,
            64768
        ],
        "mapped",
        [
            1581,
            1610
        ]
    ],
    [
        [
            64769,
            64769
        ],
        "mapped",
        [
            1580,
            1609
        ]
    ],
    [
        [
            64770,
            64770
        ],
        "mapped",
        [
            1580,
            1610
        ]
    ],
    [
        [
            64771,
            64771
        ],
        "mapped",
        [
            1582,
            1609
        ]
    ],
    [
        [
            64772,
            64772
        ],
        "mapped",
        [
            1582,
            1610
        ]
    ],
    [
        [
            64773,
            64773
        ],
        "mapped",
        [
            1589,
            1609
        ]
    ],
    [
        [
            64774,
            64774
        ],
        "mapped",
        [
            1589,
            1610
        ]
    ],
    [
        [
            64775,
            64775
        ],
        "mapped",
        [
            1590,
            1609
        ]
    ],
    [
        [
            64776,
            64776
        ],
        "mapped",
        [
            1590,
            1610
        ]
    ],
    [
        [
            64777,
            64777
        ],
        "mapped",
        [
            1588,
            1580
        ]
    ],
    [
        [
            64778,
            64778
        ],
        "mapped",
        [
            1588,
            1581
        ]
    ],
    [
        [
            64779,
            64779
        ],
        "mapped",
        [
            1588,
            1582
        ]
    ],
    [
        [
            64780,
            64780
        ],
        "mapped",
        [
            1588,
            1605
        ]
    ],
    [
        [
            64781,
            64781
        ],
        "mapped",
        [
            1588,
            1585
        ]
    ],
    [
        [
            64782,
            64782
        ],
        "mapped",
        [
            1587,
            1585
        ]
    ],
    [
        [
            64783,
            64783
        ],
        "mapped",
        [
            1589,
            1585
        ]
    ],
    [
        [
            64784,
            64784
        ],
        "mapped",
        [
            1590,
            1585
        ]
    ],
    [
        [
            64785,
            64785
        ],
        "mapped",
        [
            1591,
            1609
        ]
    ],
    [
        [
            64786,
            64786
        ],
        "mapped",
        [
            1591,
            1610
        ]
    ],
    [
        [
            64787,
            64787
        ],
        "mapped",
        [
            1593,
            1609
        ]
    ],
    [
        [
            64788,
            64788
        ],
        "mapped",
        [
            1593,
            1610
        ]
    ],
    [
        [
            64789,
            64789
        ],
        "mapped",
        [
            1594,
            1609
        ]
    ],
    [
        [
            64790,
            64790
        ],
        "mapped",
        [
            1594,
            1610
        ]
    ],
    [
        [
            64791,
            64791
        ],
        "mapped",
        [
            1587,
            1609
        ]
    ],
    [
        [
            64792,
            64792
        ],
        "mapped",
        [
            1587,
            1610
        ]
    ],
    [
        [
            64793,
            64793
        ],
        "mapped",
        [
            1588,
            1609
        ]
    ],
    [
        [
            64794,
            64794
        ],
        "mapped",
        [
            1588,
            1610
        ]
    ],
    [
        [
            64795,
            64795
        ],
        "mapped",
        [
            1581,
            1609
        ]
    ],
    [
        [
            64796,
            64796
        ],
        "mapped",
        [
            1581,
            1610
        ]
    ],
    [
        [
            64797,
            64797
        ],
        "mapped",
        [
            1580,
            1609
        ]
    ],
    [
        [
            64798,
            64798
        ],
        "mapped",
        [
            1580,
            1610
        ]
    ],
    [
        [
            64799,
            64799
        ],
        "mapped",
        [
            1582,
            1609
        ]
    ],
    [
        [
            64800,
            64800
        ],
        "mapped",
        [
            1582,
            1610
        ]
    ],
    [
        [
            64801,
            64801
        ],
        "mapped",
        [
            1589,
            1609
        ]
    ],
    [
        [
            64802,
            64802
        ],
        "mapped",
        [
            1589,
            1610
        ]
    ],
    [
        [
            64803,
            64803
        ],
        "mapped",
        [
            1590,
            1609
        ]
    ],
    [
        [
            64804,
            64804
        ],
        "mapped",
        [
            1590,
            1610
        ]
    ],
    [
        [
            64805,
            64805
        ],
        "mapped",
        [
            1588,
            1580
        ]
    ],
    [
        [
            64806,
            64806
        ],
        "mapped",
        [
            1588,
            1581
        ]
    ],
    [
        [
            64807,
            64807
        ],
        "mapped",
        [
            1588,
            1582
        ]
    ],
    [
        [
            64808,
            64808
        ],
        "mapped",
        [
            1588,
            1605
        ]
    ],
    [
        [
            64809,
            64809
        ],
        "mapped",
        [
            1588,
            1585
        ]
    ],
    [
        [
            64810,
            64810
        ],
        "mapped",
        [
            1587,
            1585
        ]
    ],
    [
        [
            64811,
            64811
        ],
        "mapped",
        [
            1589,
            1585
        ]
    ],
    [
        [
            64812,
            64812
        ],
        "mapped",
        [
            1590,
            1585
        ]
    ],
    [
        [
            64813,
            64813
        ],
        "mapped",
        [
            1588,
            1580
        ]
    ],
    [
        [
            64814,
            64814
        ],
        "mapped",
        [
            1588,
            1581
        ]
    ],
    [
        [
            64815,
            64815
        ],
        "mapped",
        [
            1588,
            1582
        ]
    ],
    [
        [
            64816,
            64816
        ],
        "mapped",
        [
            1588,
            1605
        ]
    ],
    [
        [
            64817,
            64817
        ],
        "mapped",
        [
            1587,
            1607
        ]
    ],
    [
        [
            64818,
            64818
        ],
        "mapped",
        [
            1588,
            1607
        ]
    ],
    [
        [
            64819,
            64819
        ],
        "mapped",
        [
            1591,
            1605
        ]
    ],
    [
        [
            64820,
            64820
        ],
        "mapped",
        [
            1587,
            1580
        ]
    ],
    [
        [
            64821,
            64821
        ],
        "mapped",
        [
            1587,
            1581
        ]
    ],
    [
        [
            64822,
            64822
        ],
        "mapped",
        [
            1587,
            1582
        ]
    ],
    [
        [
            64823,
            64823
        ],
        "mapped",
        [
            1588,
            1580
        ]
    ],
    [
        [
            64824,
            64824
        ],
        "mapped",
        [
            1588,
            1581
        ]
    ],
    [
        [
            64825,
            64825
        ],
        "mapped",
        [
            1588,
            1582
        ]
    ],
    [
        [
            64826,
            64826
        ],
        "mapped",
        [
            1591,
            1605
        ]
    ],
    [
        [
            64827,
            64827
        ],
        "mapped",
        [
            1592,
            1605
        ]
    ],
    [
        [
            64828,
            64829
        ],
        "mapped",
        [
            1575,
            1611
        ]
    ],
    [
        [
            64830,
            64831
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            64832,
            64847
        ],
        "disallowed"
    ],
    [
        [
            64848,
            64848
        ],
        "mapped",
        [
            1578,
            1580,
            1605
        ]
    ],
    [
        [
            64849,
            64850
        ],
        "mapped",
        [
            1578,
            1581,
            1580
        ]
    ],
    [
        [
            64851,
            64851
        ],
        "mapped",
        [
            1578,
            1581,
            1605
        ]
    ],
    [
        [
            64852,
            64852
        ],
        "mapped",
        [
            1578,
            1582,
            1605
        ]
    ],
    [
        [
            64853,
            64853
        ],
        "mapped",
        [
            1578,
            1605,
            1580
        ]
    ],
    [
        [
            64854,
            64854
        ],
        "mapped",
        [
            1578,
            1605,
            1581
        ]
    ],
    [
        [
            64855,
            64855
        ],
        "mapped",
        [
            1578,
            1605,
            1582
        ]
    ],
    [
        [
            64856,
            64857
        ],
        "mapped",
        [
            1580,
            1605,
            1581
        ]
    ],
    [
        [
            64858,
            64858
        ],
        "mapped",
        [
            1581,
            1605,
            1610
        ]
    ],
    [
        [
            64859,
            64859
        ],
        "mapped",
        [
            1581,
            1605,
            1609
        ]
    ],
    [
        [
            64860,
            64860
        ],
        "mapped",
        [
            1587,
            1581,
            1580
        ]
    ],
    [
        [
            64861,
            64861
        ],
        "mapped",
        [
            1587,
            1580,
            1581
        ]
    ],
    [
        [
            64862,
            64862
        ],
        "mapped",
        [
            1587,
            1580,
            1609
        ]
    ],
    [
        [
            64863,
            64864
        ],
        "mapped",
        [
            1587,
            1605,
            1581
        ]
    ],
    [
        [
            64865,
            64865
        ],
        "mapped",
        [
            1587,
            1605,
            1580
        ]
    ],
    [
        [
            64866,
            64867
        ],
        "mapped",
        [
            1587,
            1605,
            1605
        ]
    ],
    [
        [
            64868,
            64869
        ],
        "mapped",
        [
            1589,
            1581,
            1581
        ]
    ],
    [
        [
            64870,
            64870
        ],
        "mapped",
        [
            1589,
            1605,
            1605
        ]
    ],
    [
        [
            64871,
            64872
        ],
        "mapped",
        [
            1588,
            1581,
            1605
        ]
    ],
    [
        [
            64873,
            64873
        ],
        "mapped",
        [
            1588,
            1580,
            1610
        ]
    ],
    [
        [
            64874,
            64875
        ],
        "mapped",
        [
            1588,
            1605,
            1582
        ]
    ],
    [
        [
            64876,
            64877
        ],
        "mapped",
        [
            1588,
            1605,
            1605
        ]
    ],
    [
        [
            64878,
            64878
        ],
        "mapped",
        [
            1590,
            1581,
            1609
        ]
    ],
    [
        [
            64879,
            64880
        ],
        "mapped",
        [
            1590,
            1582,
            1605
        ]
    ],
    [
        [
            64881,
            64882
        ],
        "mapped",
        [
            1591,
            1605,
            1581
        ]
    ],
    [
        [
            64883,
            64883
        ],
        "mapped",
        [
            1591,
            1605,
            1605
        ]
    ],
    [
        [
            64884,
            64884
        ],
        "mapped",
        [
            1591,
            1605,
            1610
        ]
    ],
    [
        [
            64885,
            64885
        ],
        "mapped",
        [
            1593,
            1580,
            1605
        ]
    ],
    [
        [
            64886,
            64887
        ],
        "mapped",
        [
            1593,
            1605,
            1605
        ]
    ],
    [
        [
            64888,
            64888
        ],
        "mapped",
        [
            1593,
            1605,
            1609
        ]
    ],
    [
        [
            64889,
            64889
        ],
        "mapped",
        [
            1594,
            1605,
            1605
        ]
    ],
    [
        [
            64890,
            64890
        ],
        "mapped",
        [
            1594,
            1605,
            1610
        ]
    ],
    [
        [
            64891,
            64891
        ],
        "mapped",
        [
            1594,
            1605,
            1609
        ]
    ],
    [
        [
            64892,
            64893
        ],
        "mapped",
        [
            1601,
            1582,
            1605
        ]
    ],
    [
        [
            64894,
            64894
        ],
        "mapped",
        [
            1602,
            1605,
            1581
        ]
    ],
    [
        [
            64895,
            64895
        ],
        "mapped",
        [
            1602,
            1605,
            1605
        ]
    ],
    [
        [
            64896,
            64896
        ],
        "mapped",
        [
            1604,
            1581,
            1605
        ]
    ],
    [
        [
            64897,
            64897
        ],
        "mapped",
        [
            1604,
            1581,
            1610
        ]
    ],
    [
        [
            64898,
            64898
        ],
        "mapped",
        [
            1604,
            1581,
            1609
        ]
    ],
    [
        [
            64899,
            64900
        ],
        "mapped",
        [
            1604,
            1580,
            1580
        ]
    ],
    [
        [
            64901,
            64902
        ],
        "mapped",
        [
            1604,
            1582,
            1605
        ]
    ],
    [
        [
            64903,
            64904
        ],
        "mapped",
        [
            1604,
            1605,
            1581
        ]
    ],
    [
        [
            64905,
            64905
        ],
        "mapped",
        [
            1605,
            1581,
            1580
        ]
    ],
    [
        [
            64906,
            64906
        ],
        "mapped",
        [
            1605,
            1581,
            1605
        ]
    ],
    [
        [
            64907,
            64907
        ],
        "mapped",
        [
            1605,
            1581,
            1610
        ]
    ],
    [
        [
            64908,
            64908
        ],
        "mapped",
        [
            1605,
            1580,
            1581
        ]
    ],
    [
        [
            64909,
            64909
        ],
        "mapped",
        [
            1605,
            1580,
            1605
        ]
    ],
    [
        [
            64910,
            64910
        ],
        "mapped",
        [
            1605,
            1582,
            1580
        ]
    ],
    [
        [
            64911,
            64911
        ],
        "mapped",
        [
            1605,
            1582,
            1605
        ]
    ],
    [
        [
            64912,
            64913
        ],
        "disallowed"
    ],
    [
        [
            64914,
            64914
        ],
        "mapped",
        [
            1605,
            1580,
            1582
        ]
    ],
    [
        [
            64915,
            64915
        ],
        "mapped",
        [
            1607,
            1605,
            1580
        ]
    ],
    [
        [
            64916,
            64916
        ],
        "mapped",
        [
            1607,
            1605,
            1605
        ]
    ],
    [
        [
            64917,
            64917
        ],
        "mapped",
        [
            1606,
            1581,
            1605
        ]
    ],
    [
        [
            64918,
            64918
        ],
        "mapped",
        [
            1606,
            1581,
            1609
        ]
    ],
    [
        [
            64919,
            64920
        ],
        "mapped",
        [
            1606,
            1580,
            1605
        ]
    ],
    [
        [
            64921,
            64921
        ],
        "mapped",
        [
            1606,
            1580,
            1609
        ]
    ],
    [
        [
            64922,
            64922
        ],
        "mapped",
        [
            1606,
            1605,
            1610
        ]
    ],
    [
        [
            64923,
            64923
        ],
        "mapped",
        [
            1606,
            1605,
            1609
        ]
    ],
    [
        [
            64924,
            64925
        ],
        "mapped",
        [
            1610,
            1605,
            1605
        ]
    ],
    [
        [
            64926,
            64926
        ],
        "mapped",
        [
            1576,
            1582,
            1610
        ]
    ],
    [
        [
            64927,
            64927
        ],
        "mapped",
        [
            1578,
            1580,
            1610
        ]
    ],
    [
        [
            64928,
            64928
        ],
        "mapped",
        [
            1578,
            1580,
            1609
        ]
    ],
    [
        [
            64929,
            64929
        ],
        "mapped",
        [
            1578,
            1582,
            1610
        ]
    ],
    [
        [
            64930,
            64930
        ],
        "mapped",
        [
            1578,
            1582,
            1609
        ]
    ],
    [
        [
            64931,
            64931
        ],
        "mapped",
        [
            1578,
            1605,
            1610
        ]
    ],
    [
        [
            64932,
            64932
        ],
        "mapped",
        [
            1578,
            1605,
            1609
        ]
    ],
    [
        [
            64933,
            64933
        ],
        "mapped",
        [
            1580,
            1605,
            1610
        ]
    ],
    [
        [
            64934,
            64934
        ],
        "mapped",
        [
            1580,
            1581,
            1609
        ]
    ],
    [
        [
            64935,
            64935
        ],
        "mapped",
        [
            1580,
            1605,
            1609
        ]
    ],
    [
        [
            64936,
            64936
        ],
        "mapped",
        [
            1587,
            1582,
            1609
        ]
    ],
    [
        [
            64937,
            64937
        ],
        "mapped",
        [
            1589,
            1581,
            1610
        ]
    ],
    [
        [
            64938,
            64938
        ],
        "mapped",
        [
            1588,
            1581,
            1610
        ]
    ],
    [
        [
            64939,
            64939
        ],
        "mapped",
        [
            1590,
            1581,
            1610
        ]
    ],
    [
        [
            64940,
            64940
        ],
        "mapped",
        [
            1604,
            1580,
            1610
        ]
    ],
    [
        [
            64941,
            64941
        ],
        "mapped",
        [
            1604,
            1605,
            1610
        ]
    ],
    [
        [
            64942,
            64942
        ],
        "mapped",
        [
            1610,
            1581,
            1610
        ]
    ],
    [
        [
            64943,
            64943
        ],
        "mapped",
        [
            1610,
            1580,
            1610
        ]
    ],
    [
        [
            64944,
            64944
        ],
        "mapped",
        [
            1610,
            1605,
            1610
        ]
    ],
    [
        [
            64945,
            64945
        ],
        "mapped",
        [
            1605,
            1605,
            1610
        ]
    ],
    [
        [
            64946,
            64946
        ],
        "mapped",
        [
            1602,
            1605,
            1610
        ]
    ],
    [
        [
            64947,
            64947
        ],
        "mapped",
        [
            1606,
            1581,
            1610
        ]
    ],
    [
        [
            64948,
            64948
        ],
        "mapped",
        [
            1602,
            1605,
            1581
        ]
    ],
    [
        [
            64949,
            64949
        ],
        "mapped",
        [
            1604,
            1581,
            1605
        ]
    ],
    [
        [
            64950,
            64950
        ],
        "mapped",
        [
            1593,
            1605,
            1610
        ]
    ],
    [
        [
            64951,
            64951
        ],
        "mapped",
        [
            1603,
            1605,
            1610
        ]
    ],
    [
        [
            64952,
            64952
        ],
        "mapped",
        [
            1606,
            1580,
            1581
        ]
    ],
    [
        [
            64953,
            64953
        ],
        "mapped",
        [
            1605,
            1582,
            1610
        ]
    ],
    [
        [
            64954,
            64954
        ],
        "mapped",
        [
            1604,
            1580,
            1605
        ]
    ],
    [
        [
            64955,
            64955
        ],
        "mapped",
        [
            1603,
            1605,
            1605
        ]
    ],
    [
        [
            64956,
            64956
        ],
        "mapped",
        [
            1604,
            1580,
            1605
        ]
    ],
    [
        [
            64957,
            64957
        ],
        "mapped",
        [
            1606,
            1580,
            1581
        ]
    ],
    [
        [
            64958,
            64958
        ],
        "mapped",
        [
            1580,
            1581,
            1610
        ]
    ],
    [
        [
            64959,
            64959
        ],
        "mapped",
        [
            1581,
            1580,
            1610
        ]
    ],
    [
        [
            64960,
            64960
        ],
        "mapped",
        [
            1605,
            1580,
            1610
        ]
    ],
    [
        [
            64961,
            64961
        ],
        "mapped",
        [
            1601,
            1605,
            1610
        ]
    ],
    [
        [
            64962,
            64962
        ],
        "mapped",
        [
            1576,
            1581,
            1610
        ]
    ],
    [
        [
            64963,
            64963
        ],
        "mapped",
        [
            1603,
            1605,
            1605
        ]
    ],
    [
        [
            64964,
            64964
        ],
        "mapped",
        [
            1593,
            1580,
            1605
        ]
    ],
    [
        [
            64965,
            64965
        ],
        "mapped",
        [
            1589,
            1605,
            1605
        ]
    ],
    [
        [
            64966,
            64966
        ],
        "mapped",
        [
            1587,
            1582,
            1610
        ]
    ],
    [
        [
            64967,
            64967
        ],
        "mapped",
        [
            1606,
            1580,
            1610
        ]
    ],
    [
        [
            64968,
            64975
        ],
        "disallowed"
    ],
    [
        [
            64976,
            65007
        ],
        "disallowed"
    ],
    [
        [
            65008,
            65008
        ],
        "mapped",
        [
            1589,
            1604,
            1746
        ]
    ],
    [
        [
            65009,
            65009
        ],
        "mapped",
        [
            1602,
            1604,
            1746
        ]
    ],
    [
        [
            65010,
            65010
        ],
        "mapped",
        [
            1575,
            1604,
            1604,
            1607
        ]
    ],
    [
        [
            65011,
            65011
        ],
        "mapped",
        [
            1575,
            1603,
            1576,
            1585
        ]
    ],
    [
        [
            65012,
            65012
        ],
        "mapped",
        [
            1605,
            1581,
            1605,
            1583
        ]
    ],
    [
        [
            65013,
            65013
        ],
        "mapped",
        [
            1589,
            1604,
            1593,
            1605
        ]
    ],
    [
        [
            65014,
            65014
        ],
        "mapped",
        [
            1585,
            1587,
            1608,
            1604
        ]
    ],
    [
        [
            65015,
            65015
        ],
        "mapped",
        [
            1593,
            1604,
            1610,
            1607
        ]
    ],
    [
        [
            65016,
            65016
        ],
        "mapped",
        [
            1608,
            1587,
            1604,
            1605
        ]
    ],
    [
        [
            65017,
            65017
        ],
        "mapped",
        [
            1589,
            1604,
            1609
        ]
    ],
    [
        [
            65018,
            65018
        ],
        "disallowed_STD3_mapped",
        [
            1589,
            1604,
            1609,
            32,
            1575,
            1604,
            1604,
            1607,
            32,
            1593,
            1604,
            1610,
            1607,
            32,
            1608,
            1587,
            1604,
            1605
        ]
    ],
    [
        [
            65019,
            65019
        ],
        "disallowed_STD3_mapped",
        [
            1580,
            1604,
            32,
            1580,
            1604,
            1575,
            1604,
            1607
        ]
    ],
    [
        [
            65020,
            65020
        ],
        "mapped",
        [
            1585,
            1740,
            1575,
            1604
        ]
    ],
    [
        [
            65021,
            65021
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            65022,
            65023
        ],
        "disallowed"
    ],
    [
        [
            65024,
            65039
        ],
        "ignored"
    ],
    [
        [
            65040,
            65040
        ],
        "disallowed_STD3_mapped",
        [
            44
        ]
    ],
    [
        [
            65041,
            65041
        ],
        "mapped",
        [
            12289
        ]
    ],
    [
        [
            65042,
            65042
        ],
        "disallowed"
    ],
    [
        [
            65043,
            65043
        ],
        "disallowed_STD3_mapped",
        [
            58
        ]
    ],
    [
        [
            65044,
            65044
        ],
        "disallowed_STD3_mapped",
        [
            59
        ]
    ],
    [
        [
            65045,
            65045
        ],
        "disallowed_STD3_mapped",
        [
            33
        ]
    ],
    [
        [
            65046,
            65046
        ],
        "disallowed_STD3_mapped",
        [
            63
        ]
    ],
    [
        [
            65047,
            65047
        ],
        "mapped",
        [
            12310
        ]
    ],
    [
        [
            65048,
            65048
        ],
        "mapped",
        [
            12311
        ]
    ],
    [
        [
            65049,
            65049
        ],
        "disallowed"
    ],
    [
        [
            65050,
            65055
        ],
        "disallowed"
    ],
    [
        [
            65056,
            65059
        ],
        "valid"
    ],
    [
        [
            65060,
            65062
        ],
        "valid"
    ],
    [
        [
            65063,
            65069
        ],
        "valid"
    ],
    [
        [
            65070,
            65071
        ],
        "valid"
    ],
    [
        [
            65072,
            65072
        ],
        "disallowed"
    ],
    [
        [
            65073,
            65073
        ],
        "mapped",
        [
            8212
        ]
    ],
    [
        [
            65074,
            65074
        ],
        "mapped",
        [
            8211
        ]
    ],
    [
        [
            65075,
            65076
        ],
        "disallowed_STD3_mapped",
        [
            95
        ]
    ],
    [
        [
            65077,
            65077
        ],
        "disallowed_STD3_mapped",
        [
            40
        ]
    ],
    [
        [
            65078,
            65078
        ],
        "disallowed_STD3_mapped",
        [
            41
        ]
    ],
    [
        [
            65079,
            65079
        ],
        "disallowed_STD3_mapped",
        [
            123
        ]
    ],
    [
        [
            65080,
            65080
        ],
        "disallowed_STD3_mapped",
        [
            125
        ]
    ],
    [
        [
            65081,
            65081
        ],
        "mapped",
        [
            12308
        ]
    ],
    [
        [
            65082,
            65082
        ],
        "mapped",
        [
            12309
        ]
    ],
    [
        [
            65083,
            65083
        ],
        "mapped",
        [
            12304
        ]
    ],
    [
        [
            65084,
            65084
        ],
        "mapped",
        [
            12305
        ]
    ],
    [
        [
            65085,
            65085
        ],
        "mapped",
        [
            12298
        ]
    ],
    [
        [
            65086,
            65086
        ],
        "mapped",
        [
            12299
        ]
    ],
    [
        [
            65087,
            65087
        ],
        "mapped",
        [
            12296
        ]
    ],
    [
        [
            65088,
            65088
        ],
        "mapped",
        [
            12297
        ]
    ],
    [
        [
            65089,
            65089
        ],
        "mapped",
        [
            12300
        ]
    ],
    [
        [
            65090,
            65090
        ],
        "mapped",
        [
            12301
        ]
    ],
    [
        [
            65091,
            65091
        ],
        "mapped",
        [
            12302
        ]
    ],
    [
        [
            65092,
            65092
        ],
        "mapped",
        [
            12303
        ]
    ],
    [
        [
            65093,
            65094
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            65095,
            65095
        ],
        "disallowed_STD3_mapped",
        [
            91
        ]
    ],
    [
        [
            65096,
            65096
        ],
        "disallowed_STD3_mapped",
        [
            93
        ]
    ],
    [
        [
            65097,
            65100
        ],
        "disallowed_STD3_mapped",
        [
            32,
            773
        ]
    ],
    [
        [
            65101,
            65103
        ],
        "disallowed_STD3_mapped",
        [
            95
        ]
    ],
    [
        [
            65104,
            65104
        ],
        "disallowed_STD3_mapped",
        [
            44
        ]
    ],
    [
        [
            65105,
            65105
        ],
        "mapped",
        [
            12289
        ]
    ],
    [
        [
            65106,
            65106
        ],
        "disallowed"
    ],
    [
        [
            65107,
            65107
        ],
        "disallowed"
    ],
    [
        [
            65108,
            65108
        ],
        "disallowed_STD3_mapped",
        [
            59
        ]
    ],
    [
        [
            65109,
            65109
        ],
        "disallowed_STD3_mapped",
        [
            58
        ]
    ],
    [
        [
            65110,
            65110
        ],
        "disallowed_STD3_mapped",
        [
            63
        ]
    ],
    [
        [
            65111,
            65111
        ],
        "disallowed_STD3_mapped",
        [
            33
        ]
    ],
    [
        [
            65112,
            65112
        ],
        "mapped",
        [
            8212
        ]
    ],
    [
        [
            65113,
            65113
        ],
        "disallowed_STD3_mapped",
        [
            40
        ]
    ],
    [
        [
            65114,
            65114
        ],
        "disallowed_STD3_mapped",
        [
            41
        ]
    ],
    [
        [
            65115,
            65115
        ],
        "disallowed_STD3_mapped",
        [
            123
        ]
    ],
    [
        [
            65116,
            65116
        ],
        "disallowed_STD3_mapped",
        [
            125
        ]
    ],
    [
        [
            65117,
            65117
        ],
        "mapped",
        [
            12308
        ]
    ],
    [
        [
            65118,
            65118
        ],
        "mapped",
        [
            12309
        ]
    ],
    [
        [
            65119,
            65119
        ],
        "disallowed_STD3_mapped",
        [
            35
        ]
    ],
    [
        [
            65120,
            65120
        ],
        "disallowed_STD3_mapped",
        [
            38
        ]
    ],
    [
        [
            65121,
            65121
        ],
        "disallowed_STD3_mapped",
        [
            42
        ]
    ],
    [
        [
            65122,
            65122
        ],
        "disallowed_STD3_mapped",
        [
            43
        ]
    ],
    [
        [
            65123,
            65123
        ],
        "mapped",
        [
            45
        ]
    ],
    [
        [
            65124,
            65124
        ],
        "disallowed_STD3_mapped",
        [
            60
        ]
    ],
    [
        [
            65125,
            65125
        ],
        "disallowed_STD3_mapped",
        [
            62
        ]
    ],
    [
        [
            65126,
            65126
        ],
        "disallowed_STD3_mapped",
        [
            61
        ]
    ],
    [
        [
            65127,
            65127
        ],
        "disallowed"
    ],
    [
        [
            65128,
            65128
        ],
        "disallowed_STD3_mapped",
        [
            92
        ]
    ],
    [
        [
            65129,
            65129
        ],
        "disallowed_STD3_mapped",
        [
            36
        ]
    ],
    [
        [
            65130,
            65130
        ],
        "disallowed_STD3_mapped",
        [
            37
        ]
    ],
    [
        [
            65131,
            65131
        ],
        "disallowed_STD3_mapped",
        [
            64
        ]
    ],
    [
        [
            65132,
            65135
        ],
        "disallowed"
    ],
    [
        [
            65136,
            65136
        ],
        "disallowed_STD3_mapped",
        [
            32,
            1611
        ]
    ],
    [
        [
            65137,
            65137
        ],
        "mapped",
        [
            1600,
            1611
        ]
    ],
    [
        [
            65138,
            65138
        ],
        "disallowed_STD3_mapped",
        [
            32,
            1612
        ]
    ],
    [
        [
            65139,
            65139
        ],
        "valid"
    ],
    [
        [
            65140,
            65140
        ],
        "disallowed_STD3_mapped",
        [
            32,
            1613
        ]
    ],
    [
        [
            65141,
            65141
        ],
        "disallowed"
    ],
    [
        [
            65142,
            65142
        ],
        "disallowed_STD3_mapped",
        [
            32,
            1614
        ]
    ],
    [
        [
            65143,
            65143
        ],
        "mapped",
        [
            1600,
            1614
        ]
    ],
    [
        [
            65144,
            65144
        ],
        "disallowed_STD3_mapped",
        [
            32,
            1615
        ]
    ],
    [
        [
            65145,
            65145
        ],
        "mapped",
        [
            1600,
            1615
        ]
    ],
    [
        [
            65146,
            65146
        ],
        "disallowed_STD3_mapped",
        [
            32,
            1616
        ]
    ],
    [
        [
            65147,
            65147
        ],
        "mapped",
        [
            1600,
            1616
        ]
    ],
    [
        [
            65148,
            65148
        ],
        "disallowed_STD3_mapped",
        [
            32,
            1617
        ]
    ],
    [
        [
            65149,
            65149
        ],
        "mapped",
        [
            1600,
            1617
        ]
    ],
    [
        [
            65150,
            65150
        ],
        "disallowed_STD3_mapped",
        [
            32,
            1618
        ]
    ],
    [
        [
            65151,
            65151
        ],
        "mapped",
        [
            1600,
            1618
        ]
    ],
    [
        [
            65152,
            65152
        ],
        "mapped",
        [
            1569
        ]
    ],
    [
        [
            65153,
            65154
        ],
        "mapped",
        [
            1570
        ]
    ],
    [
        [
            65155,
            65156
        ],
        "mapped",
        [
            1571
        ]
    ],
    [
        [
            65157,
            65158
        ],
        "mapped",
        [
            1572
        ]
    ],
    [
        [
            65159,
            65160
        ],
        "mapped",
        [
            1573
        ]
    ],
    [
        [
            65161,
            65164
        ],
        "mapped",
        [
            1574
        ]
    ],
    [
        [
            65165,
            65166
        ],
        "mapped",
        [
            1575
        ]
    ],
    [
        [
            65167,
            65170
        ],
        "mapped",
        [
            1576
        ]
    ],
    [
        [
            65171,
            65172
        ],
        "mapped",
        [
            1577
        ]
    ],
    [
        [
            65173,
            65176
        ],
        "mapped",
        [
            1578
        ]
    ],
    [
        [
            65177,
            65180
        ],
        "mapped",
        [
            1579
        ]
    ],
    [
        [
            65181,
            65184
        ],
        "mapped",
        [
            1580
        ]
    ],
    [
        [
            65185,
            65188
        ],
        "mapped",
        [
            1581
        ]
    ],
    [
        [
            65189,
            65192
        ],
        "mapped",
        [
            1582
        ]
    ],
    [
        [
            65193,
            65194
        ],
        "mapped",
        [
            1583
        ]
    ],
    [
        [
            65195,
            65196
        ],
        "mapped",
        [
            1584
        ]
    ],
    [
        [
            65197,
            65198
        ],
        "mapped",
        [
            1585
        ]
    ],
    [
        [
            65199,
            65200
        ],
        "mapped",
        [
            1586
        ]
    ],
    [
        [
            65201,
            65204
        ],
        "mapped",
        [
            1587
        ]
    ],
    [
        [
            65205,
            65208
        ],
        "mapped",
        [
            1588
        ]
    ],
    [
        [
            65209,
            65212
        ],
        "mapped",
        [
            1589
        ]
    ],
    [
        [
            65213,
            65216
        ],
        "mapped",
        [
            1590
        ]
    ],
    [
        [
            65217,
            65220
        ],
        "mapped",
        [
            1591
        ]
    ],
    [
        [
            65221,
            65224
        ],
        "mapped",
        [
            1592
        ]
    ],
    [
        [
            65225,
            65228
        ],
        "mapped",
        [
            1593
        ]
    ],
    [
        [
            65229,
            65232
        ],
        "mapped",
        [
            1594
        ]
    ],
    [
        [
            65233,
            65236
        ],
        "mapped",
        [
            1601
        ]
    ],
    [
        [
            65237,
            65240
        ],
        "mapped",
        [
            1602
        ]
    ],
    [
        [
            65241,
            65244
        ],
        "mapped",
        [
            1603
        ]
    ],
    [
        [
            65245,
            65248
        ],
        "mapped",
        [
            1604
        ]
    ],
    [
        [
            65249,
            65252
        ],
        "mapped",
        [
            1605
        ]
    ],
    [
        [
            65253,
            65256
        ],
        "mapped",
        [
            1606
        ]
    ],
    [
        [
            65257,
            65260
        ],
        "mapped",
        [
            1607
        ]
    ],
    [
        [
            65261,
            65262
        ],
        "mapped",
        [
            1608
        ]
    ],
    [
        [
            65263,
            65264
        ],
        "mapped",
        [
            1609
        ]
    ],
    [
        [
            65265,
            65268
        ],
        "mapped",
        [
            1610
        ]
    ],
    [
        [
            65269,
            65270
        ],
        "mapped",
        [
            1604,
            1570
        ]
    ],
    [
        [
            65271,
            65272
        ],
        "mapped",
        [
            1604,
            1571
        ]
    ],
    [
        [
            65273,
            65274
        ],
        "mapped",
        [
            1604,
            1573
        ]
    ],
    [
        [
            65275,
            65276
        ],
        "mapped",
        [
            1604,
            1575
        ]
    ],
    [
        [
            65277,
            65278
        ],
        "disallowed"
    ],
    [
        [
            65279,
            65279
        ],
        "ignored"
    ],
    [
        [
            65280,
            65280
        ],
        "disallowed"
    ],
    [
        [
            65281,
            65281
        ],
        "disallowed_STD3_mapped",
        [
            33
        ]
    ],
    [
        [
            65282,
            65282
        ],
        "disallowed_STD3_mapped",
        [
            34
        ]
    ],
    [
        [
            65283,
            65283
        ],
        "disallowed_STD3_mapped",
        [
            35
        ]
    ],
    [
        [
            65284,
            65284
        ],
        "disallowed_STD3_mapped",
        [
            36
        ]
    ],
    [
        [
            65285,
            65285
        ],
        "disallowed_STD3_mapped",
        [
            37
        ]
    ],
    [
        [
            65286,
            65286
        ],
        "disallowed_STD3_mapped",
        [
            38
        ]
    ],
    [
        [
            65287,
            65287
        ],
        "disallowed_STD3_mapped",
        [
            39
        ]
    ],
    [
        [
            65288,
            65288
        ],
        "disallowed_STD3_mapped",
        [
            40
        ]
    ],
    [
        [
            65289,
            65289
        ],
        "disallowed_STD3_mapped",
        [
            41
        ]
    ],
    [
        [
            65290,
            65290
        ],
        "disallowed_STD3_mapped",
        [
            42
        ]
    ],
    [
        [
            65291,
            65291
        ],
        "disallowed_STD3_mapped",
        [
            43
        ]
    ],
    [
        [
            65292,
            65292
        ],
        "disallowed_STD3_mapped",
        [
            44
        ]
    ],
    [
        [
            65293,
            65293
        ],
        "mapped",
        [
            45
        ]
    ],
    [
        [
            65294,
            65294
        ],
        "mapped",
        [
            46
        ]
    ],
    [
        [
            65295,
            65295
        ],
        "disallowed_STD3_mapped",
        [
            47
        ]
    ],
    [
        [
            65296,
            65296
        ],
        "mapped",
        [
            48
        ]
    ],
    [
        [
            65297,
            65297
        ],
        "mapped",
        [
            49
        ]
    ],
    [
        [
            65298,
            65298
        ],
        "mapped",
        [
            50
        ]
    ],
    [
        [
            65299,
            65299
        ],
        "mapped",
        [
            51
        ]
    ],
    [
        [
            65300,
            65300
        ],
        "mapped",
        [
            52
        ]
    ],
    [
        [
            65301,
            65301
        ],
        "mapped",
        [
            53
        ]
    ],
    [
        [
            65302,
            65302
        ],
        "mapped",
        [
            54
        ]
    ],
    [
        [
            65303,
            65303
        ],
        "mapped",
        [
            55
        ]
    ],
    [
        [
            65304,
            65304
        ],
        "mapped",
        [
            56
        ]
    ],
    [
        [
            65305,
            65305
        ],
        "mapped",
        [
            57
        ]
    ],
    [
        [
            65306,
            65306
        ],
        "disallowed_STD3_mapped",
        [
            58
        ]
    ],
    [
        [
            65307,
            65307
        ],
        "disallowed_STD3_mapped",
        [
            59
        ]
    ],
    [
        [
            65308,
            65308
        ],
        "disallowed_STD3_mapped",
        [
            60
        ]
    ],
    [
        [
            65309,
            65309
        ],
        "disallowed_STD3_mapped",
        [
            61
        ]
    ],
    [
        [
            65310,
            65310
        ],
        "disallowed_STD3_mapped",
        [
            62
        ]
    ],
    [
        [
            65311,
            65311
        ],
        "disallowed_STD3_mapped",
        [
            63
        ]
    ],
    [
        [
            65312,
            65312
        ],
        "disallowed_STD3_mapped",
        [
            64
        ]
    ],
    [
        [
            65313,
            65313
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            65314,
            65314
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            65315,
            65315
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            65316,
            65316
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            65317,
            65317
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            65318,
            65318
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            65319,
            65319
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            65320,
            65320
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            65321,
            65321
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            65322,
            65322
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            65323,
            65323
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            65324,
            65324
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            65325,
            65325
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            65326,
            65326
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            65327,
            65327
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            65328,
            65328
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            65329,
            65329
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            65330,
            65330
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            65331,
            65331
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            65332,
            65332
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            65333,
            65333
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            65334,
            65334
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            65335,
            65335
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            65336,
            65336
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            65337,
            65337
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            65338,
            65338
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            65339,
            65339
        ],
        "disallowed_STD3_mapped",
        [
            91
        ]
    ],
    [
        [
            65340,
            65340
        ],
        "disallowed_STD3_mapped",
        [
            92
        ]
    ],
    [
        [
            65341,
            65341
        ],
        "disallowed_STD3_mapped",
        [
            93
        ]
    ],
    [
        [
            65342,
            65342
        ],
        "disallowed_STD3_mapped",
        [
            94
        ]
    ],
    [
        [
            65343,
            65343
        ],
        "disallowed_STD3_mapped",
        [
            95
        ]
    ],
    [
        [
            65344,
            65344
        ],
        "disallowed_STD3_mapped",
        [
            96
        ]
    ],
    [
        [
            65345,
            65345
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            65346,
            65346
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            65347,
            65347
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            65348,
            65348
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            65349,
            65349
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            65350,
            65350
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            65351,
            65351
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            65352,
            65352
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            65353,
            65353
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            65354,
            65354
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            65355,
            65355
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            65356,
            65356
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            65357,
            65357
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            65358,
            65358
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            65359,
            65359
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            65360,
            65360
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            65361,
            65361
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            65362,
            65362
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            65363,
            65363
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            65364,
            65364
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            65365,
            65365
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            65366,
            65366
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            65367,
            65367
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            65368,
            65368
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            65369,
            65369
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            65370,
            65370
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            65371,
            65371
        ],
        "disallowed_STD3_mapped",
        [
            123
        ]
    ],
    [
        [
            65372,
            65372
        ],
        "disallowed_STD3_mapped",
        [
            124
        ]
    ],
    [
        [
            65373,
            65373
        ],
        "disallowed_STD3_mapped",
        [
            125
        ]
    ],
    [
        [
            65374,
            65374
        ],
        "disallowed_STD3_mapped",
        [
            126
        ]
    ],
    [
        [
            65375,
            65375
        ],
        "mapped",
        [
            10629
        ]
    ],
    [
        [
            65376,
            65376
        ],
        "mapped",
        [
            10630
        ]
    ],
    [
        [
            65377,
            65377
        ],
        "mapped",
        [
            46
        ]
    ],
    [
        [
            65378,
            65378
        ],
        "mapped",
        [
            12300
        ]
    ],
    [
        [
            65379,
            65379
        ],
        "mapped",
        [
            12301
        ]
    ],
    [
        [
            65380,
            65380
        ],
        "mapped",
        [
            12289
        ]
    ],
    [
        [
            65381,
            65381
        ],
        "mapped",
        [
            12539
        ]
    ],
    [
        [
            65382,
            65382
        ],
        "mapped",
        [
            12530
        ]
    ],
    [
        [
            65383,
            65383
        ],
        "mapped",
        [
            12449
        ]
    ],
    [
        [
            65384,
            65384
        ],
        "mapped",
        [
            12451
        ]
    ],
    [
        [
            65385,
            65385
        ],
        "mapped",
        [
            12453
        ]
    ],
    [
        [
            65386,
            65386
        ],
        "mapped",
        [
            12455
        ]
    ],
    [
        [
            65387,
            65387
        ],
        "mapped",
        [
            12457
        ]
    ],
    [
        [
            65388,
            65388
        ],
        "mapped",
        [
            12515
        ]
    ],
    [
        [
            65389,
            65389
        ],
        "mapped",
        [
            12517
        ]
    ],
    [
        [
            65390,
            65390
        ],
        "mapped",
        [
            12519
        ]
    ],
    [
        [
            65391,
            65391
        ],
        "mapped",
        [
            12483
        ]
    ],
    [
        [
            65392,
            65392
        ],
        "mapped",
        [
            12540
        ]
    ],
    [
        [
            65393,
            65393
        ],
        "mapped",
        [
            12450
        ]
    ],
    [
        [
            65394,
            65394
        ],
        "mapped",
        [
            12452
        ]
    ],
    [
        [
            65395,
            65395
        ],
        "mapped",
        [
            12454
        ]
    ],
    [
        [
            65396,
            65396
        ],
        "mapped",
        [
            12456
        ]
    ],
    [
        [
            65397,
            65397
        ],
        "mapped",
        [
            12458
        ]
    ],
    [
        [
            65398,
            65398
        ],
        "mapped",
        [
            12459
        ]
    ],
    [
        [
            65399,
            65399
        ],
        "mapped",
        [
            12461
        ]
    ],
    [
        [
            65400,
            65400
        ],
        "mapped",
        [
            12463
        ]
    ],
    [
        [
            65401,
            65401
        ],
        "mapped",
        [
            12465
        ]
    ],
    [
        [
            65402,
            65402
        ],
        "mapped",
        [
            12467
        ]
    ],
    [
        [
            65403,
            65403
        ],
        "mapped",
        [
            12469
        ]
    ],
    [
        [
            65404,
            65404
        ],
        "mapped",
        [
            12471
        ]
    ],
    [
        [
            65405,
            65405
        ],
        "mapped",
        [
            12473
        ]
    ],
    [
        [
            65406,
            65406
        ],
        "mapped",
        [
            12475
        ]
    ],
    [
        [
            65407,
            65407
        ],
        "mapped",
        [
            12477
        ]
    ],
    [
        [
            65408,
            65408
        ],
        "mapped",
        [
            12479
        ]
    ],
    [
        [
            65409,
            65409
        ],
        "mapped",
        [
            12481
        ]
    ],
    [
        [
            65410,
            65410
        ],
        "mapped",
        [
            12484
        ]
    ],
    [
        [
            65411,
            65411
        ],
        "mapped",
        [
            12486
        ]
    ],
    [
        [
            65412,
            65412
        ],
        "mapped",
        [
            12488
        ]
    ],
    [
        [
            65413,
            65413
        ],
        "mapped",
        [
            12490
        ]
    ],
    [
        [
            65414,
            65414
        ],
        "mapped",
        [
            12491
        ]
    ],
    [
        [
            65415,
            65415
        ],
        "mapped",
        [
            12492
        ]
    ],
    [
        [
            65416,
            65416
        ],
        "mapped",
        [
            12493
        ]
    ],
    [
        [
            65417,
            65417
        ],
        "mapped",
        [
            12494
        ]
    ],
    [
        [
            65418,
            65418
        ],
        "mapped",
        [
            12495
        ]
    ],
    [
        [
            65419,
            65419
        ],
        "mapped",
        [
            12498
        ]
    ],
    [
        [
            65420,
            65420
        ],
        "mapped",
        [
            12501
        ]
    ],
    [
        [
            65421,
            65421
        ],
        "mapped",
        [
            12504
        ]
    ],
    [
        [
            65422,
            65422
        ],
        "mapped",
        [
            12507
        ]
    ],
    [
        [
            65423,
            65423
        ],
        "mapped",
        [
            12510
        ]
    ],
    [
        [
            65424,
            65424
        ],
        "mapped",
        [
            12511
        ]
    ],
    [
        [
            65425,
            65425
        ],
        "mapped",
        [
            12512
        ]
    ],
    [
        [
            65426,
            65426
        ],
        "mapped",
        [
            12513
        ]
    ],
    [
        [
            65427,
            65427
        ],
        "mapped",
        [
            12514
        ]
    ],
    [
        [
            65428,
            65428
        ],
        "mapped",
        [
            12516
        ]
    ],
    [
        [
            65429,
            65429
        ],
        "mapped",
        [
            12518
        ]
    ],
    [
        [
            65430,
            65430
        ],
        "mapped",
        [
            12520
        ]
    ],
    [
        [
            65431,
            65431
        ],
        "mapped",
        [
            12521
        ]
    ],
    [
        [
            65432,
            65432
        ],
        "mapped",
        [
            12522
        ]
    ],
    [
        [
            65433,
            65433
        ],
        "mapped",
        [
            12523
        ]
    ],
    [
        [
            65434,
            65434
        ],
        "mapped",
        [
            12524
        ]
    ],
    [
        [
            65435,
            65435
        ],
        "mapped",
        [
            12525
        ]
    ],
    [
        [
            65436,
            65436
        ],
        "mapped",
        [
            12527
        ]
    ],
    [
        [
            65437,
            65437
        ],
        "mapped",
        [
            12531
        ]
    ],
    [
        [
            65438,
            65438
        ],
        "mapped",
        [
            12441
        ]
    ],
    [
        [
            65439,
            65439
        ],
        "mapped",
        [
            12442
        ]
    ],
    [
        [
            65440,
            65440
        ],
        "disallowed"
    ],
    [
        [
            65441,
            65441
        ],
        "mapped",
        [
            4352
        ]
    ],
    [
        [
            65442,
            65442
        ],
        "mapped",
        [
            4353
        ]
    ],
    [
        [
            65443,
            65443
        ],
        "mapped",
        [
            4522
        ]
    ],
    [
        [
            65444,
            65444
        ],
        "mapped",
        [
            4354
        ]
    ],
    [
        [
            65445,
            65445
        ],
        "mapped",
        [
            4524
        ]
    ],
    [
        [
            65446,
            65446
        ],
        "mapped",
        [
            4525
        ]
    ],
    [
        [
            65447,
            65447
        ],
        "mapped",
        [
            4355
        ]
    ],
    [
        [
            65448,
            65448
        ],
        "mapped",
        [
            4356
        ]
    ],
    [
        [
            65449,
            65449
        ],
        "mapped",
        [
            4357
        ]
    ],
    [
        [
            65450,
            65450
        ],
        "mapped",
        [
            4528
        ]
    ],
    [
        [
            65451,
            65451
        ],
        "mapped",
        [
            4529
        ]
    ],
    [
        [
            65452,
            65452
        ],
        "mapped",
        [
            4530
        ]
    ],
    [
        [
            65453,
            65453
        ],
        "mapped",
        [
            4531
        ]
    ],
    [
        [
            65454,
            65454
        ],
        "mapped",
        [
            4532
        ]
    ],
    [
        [
            65455,
            65455
        ],
        "mapped",
        [
            4533
        ]
    ],
    [
        [
            65456,
            65456
        ],
        "mapped",
        [
            4378
        ]
    ],
    [
        [
            65457,
            65457
        ],
        "mapped",
        [
            4358
        ]
    ],
    [
        [
            65458,
            65458
        ],
        "mapped",
        [
            4359
        ]
    ],
    [
        [
            65459,
            65459
        ],
        "mapped",
        [
            4360
        ]
    ],
    [
        [
            65460,
            65460
        ],
        "mapped",
        [
            4385
        ]
    ],
    [
        [
            65461,
            65461
        ],
        "mapped",
        [
            4361
        ]
    ],
    [
        [
            65462,
            65462
        ],
        "mapped",
        [
            4362
        ]
    ],
    [
        [
            65463,
            65463
        ],
        "mapped",
        [
            4363
        ]
    ],
    [
        [
            65464,
            65464
        ],
        "mapped",
        [
            4364
        ]
    ],
    [
        [
            65465,
            65465
        ],
        "mapped",
        [
            4365
        ]
    ],
    [
        [
            65466,
            65466
        ],
        "mapped",
        [
            4366
        ]
    ],
    [
        [
            65467,
            65467
        ],
        "mapped",
        [
            4367
        ]
    ],
    [
        [
            65468,
            65468
        ],
        "mapped",
        [
            4368
        ]
    ],
    [
        [
            65469,
            65469
        ],
        "mapped",
        [
            4369
        ]
    ],
    [
        [
            65470,
            65470
        ],
        "mapped",
        [
            4370
        ]
    ],
    [
        [
            65471,
            65473
        ],
        "disallowed"
    ],
    [
        [
            65474,
            65474
        ],
        "mapped",
        [
            4449
        ]
    ],
    [
        [
            65475,
            65475
        ],
        "mapped",
        [
            4450
        ]
    ],
    [
        [
            65476,
            65476
        ],
        "mapped",
        [
            4451
        ]
    ],
    [
        [
            65477,
            65477
        ],
        "mapped",
        [
            4452
        ]
    ],
    [
        [
            65478,
            65478
        ],
        "mapped",
        [
            4453
        ]
    ],
    [
        [
            65479,
            65479
        ],
        "mapped",
        [
            4454
        ]
    ],
    [
        [
            65480,
            65481
        ],
        "disallowed"
    ],
    [
        [
            65482,
            65482
        ],
        "mapped",
        [
            4455
        ]
    ],
    [
        [
            65483,
            65483
        ],
        "mapped",
        [
            4456
        ]
    ],
    [
        [
            65484,
            65484
        ],
        "mapped",
        [
            4457
        ]
    ],
    [
        [
            65485,
            65485
        ],
        "mapped",
        [
            4458
        ]
    ],
    [
        [
            65486,
            65486
        ],
        "mapped",
        [
            4459
        ]
    ],
    [
        [
            65487,
            65487
        ],
        "mapped",
        [
            4460
        ]
    ],
    [
        [
            65488,
            65489
        ],
        "disallowed"
    ],
    [
        [
            65490,
            65490
        ],
        "mapped",
        [
            4461
        ]
    ],
    [
        [
            65491,
            65491
        ],
        "mapped",
        [
            4462
        ]
    ],
    [
        [
            65492,
            65492
        ],
        "mapped",
        [
            4463
        ]
    ],
    [
        [
            65493,
            65493
        ],
        "mapped",
        [
            4464
        ]
    ],
    [
        [
            65494,
            65494
        ],
        "mapped",
        [
            4465
        ]
    ],
    [
        [
            65495,
            65495
        ],
        "mapped",
        [
            4466
        ]
    ],
    [
        [
            65496,
            65497
        ],
        "disallowed"
    ],
    [
        [
            65498,
            65498
        ],
        "mapped",
        [
            4467
        ]
    ],
    [
        [
            65499,
            65499
        ],
        "mapped",
        [
            4468
        ]
    ],
    [
        [
            65500,
            65500
        ],
        "mapped",
        [
            4469
        ]
    ],
    [
        [
            65501,
            65503
        ],
        "disallowed"
    ],
    [
        [
            65504,
            65504
        ],
        "mapped",
        [
            162
        ]
    ],
    [
        [
            65505,
            65505
        ],
        "mapped",
        [
            163
        ]
    ],
    [
        [
            65506,
            65506
        ],
        "mapped",
        [
            172
        ]
    ],
    [
        [
            65507,
            65507
        ],
        "disallowed_STD3_mapped",
        [
            32,
            772
        ]
    ],
    [
        [
            65508,
            65508
        ],
        "mapped",
        [
            166
        ]
    ],
    [
        [
            65509,
            65509
        ],
        "mapped",
        [
            165
        ]
    ],
    [
        [
            65510,
            65510
        ],
        "mapped",
        [
            8361
        ]
    ],
    [
        [
            65511,
            65511
        ],
        "disallowed"
    ],
    [
        [
            65512,
            65512
        ],
        "mapped",
        [
            9474
        ]
    ],
    [
        [
            65513,
            65513
        ],
        "mapped",
        [
            8592
        ]
    ],
    [
        [
            65514,
            65514
        ],
        "mapped",
        [
            8593
        ]
    ],
    [
        [
            65515,
            65515
        ],
        "mapped",
        [
            8594
        ]
    ],
    [
        [
            65516,
            65516
        ],
        "mapped",
        [
            8595
        ]
    ],
    [
        [
            65517,
            65517
        ],
        "mapped",
        [
            9632
        ]
    ],
    [
        [
            65518,
            65518
        ],
        "mapped",
        [
            9675
        ]
    ],
    [
        [
            65519,
            65528
        ],
        "disallowed"
    ],
    [
        [
            65529,
            65531
        ],
        "disallowed"
    ],
    [
        [
            65532,
            65532
        ],
        "disallowed"
    ],
    [
        [
            65533,
            65533
        ],
        "disallowed"
    ],
    [
        [
            65534,
            65535
        ],
        "disallowed"
    ],
    [
        [
            65536,
            65547
        ],
        "valid"
    ],
    [
        [
            65548,
            65548
        ],
        "disallowed"
    ],
    [
        [
            65549,
            65574
        ],
        "valid"
    ],
    [
        [
            65575,
            65575
        ],
        "disallowed"
    ],
    [
        [
            65576,
            65594
        ],
        "valid"
    ],
    [
        [
            65595,
            65595
        ],
        "disallowed"
    ],
    [
        [
            65596,
            65597
        ],
        "valid"
    ],
    [
        [
            65598,
            65598
        ],
        "disallowed"
    ],
    [
        [
            65599,
            65613
        ],
        "valid"
    ],
    [
        [
            65614,
            65615
        ],
        "disallowed"
    ],
    [
        [
            65616,
            65629
        ],
        "valid"
    ],
    [
        [
            65630,
            65663
        ],
        "disallowed"
    ],
    [
        [
            65664,
            65786
        ],
        "valid"
    ],
    [
        [
            65787,
            65791
        ],
        "disallowed"
    ],
    [
        [
            65792,
            65794
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            65795,
            65798
        ],
        "disallowed"
    ],
    [
        [
            65799,
            65843
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            65844,
            65846
        ],
        "disallowed"
    ],
    [
        [
            65847,
            65855
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            65856,
            65930
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            65931,
            65932
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            65933,
            65935
        ],
        "disallowed"
    ],
    [
        [
            65936,
            65947
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            65948,
            65951
        ],
        "disallowed"
    ],
    [
        [
            65952,
            65952
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            65953,
            65999
        ],
        "disallowed"
    ],
    [
        [
            66000,
            66044
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            66045,
            66045
        ],
        "valid"
    ],
    [
        [
            66046,
            66175
        ],
        "disallowed"
    ],
    [
        [
            66176,
            66204
        ],
        "valid"
    ],
    [
        [
            66205,
            66207
        ],
        "disallowed"
    ],
    [
        [
            66208,
            66256
        ],
        "valid"
    ],
    [
        [
            66257,
            66271
        ],
        "disallowed"
    ],
    [
        [
            66272,
            66272
        ],
        "valid"
    ],
    [
        [
            66273,
            66299
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            66300,
            66303
        ],
        "disallowed"
    ],
    [
        [
            66304,
            66334
        ],
        "valid"
    ],
    [
        [
            66335,
            66335
        ],
        "valid"
    ],
    [
        [
            66336,
            66339
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            66340,
            66351
        ],
        "disallowed"
    ],
    [
        [
            66352,
            66368
        ],
        "valid"
    ],
    [
        [
            66369,
            66369
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            66370,
            66377
        ],
        "valid"
    ],
    [
        [
            66378,
            66378
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            66379,
            66383
        ],
        "disallowed"
    ],
    [
        [
            66384,
            66426
        ],
        "valid"
    ],
    [
        [
            66427,
            66431
        ],
        "disallowed"
    ],
    [
        [
            66432,
            66461
        ],
        "valid"
    ],
    [
        [
            66462,
            66462
        ],
        "disallowed"
    ],
    [
        [
            66463,
            66463
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            66464,
            66499
        ],
        "valid"
    ],
    [
        [
            66500,
            66503
        ],
        "disallowed"
    ],
    [
        [
            66504,
            66511
        ],
        "valid"
    ],
    [
        [
            66512,
            66517
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            66518,
            66559
        ],
        "disallowed"
    ],
    [
        [
            66560,
            66560
        ],
        "mapped",
        [
            66600
        ]
    ],
    [
        [
            66561,
            66561
        ],
        "mapped",
        [
            66601
        ]
    ],
    [
        [
            66562,
            66562
        ],
        "mapped",
        [
            66602
        ]
    ],
    [
        [
            66563,
            66563
        ],
        "mapped",
        [
            66603
        ]
    ],
    [
        [
            66564,
            66564
        ],
        "mapped",
        [
            66604
        ]
    ],
    [
        [
            66565,
            66565
        ],
        "mapped",
        [
            66605
        ]
    ],
    [
        [
            66566,
            66566
        ],
        "mapped",
        [
            66606
        ]
    ],
    [
        [
            66567,
            66567
        ],
        "mapped",
        [
            66607
        ]
    ],
    [
        [
            66568,
            66568
        ],
        "mapped",
        [
            66608
        ]
    ],
    [
        [
            66569,
            66569
        ],
        "mapped",
        [
            66609
        ]
    ],
    [
        [
            66570,
            66570
        ],
        "mapped",
        [
            66610
        ]
    ],
    [
        [
            66571,
            66571
        ],
        "mapped",
        [
            66611
        ]
    ],
    [
        [
            66572,
            66572
        ],
        "mapped",
        [
            66612
        ]
    ],
    [
        [
            66573,
            66573
        ],
        "mapped",
        [
            66613
        ]
    ],
    [
        [
            66574,
            66574
        ],
        "mapped",
        [
            66614
        ]
    ],
    [
        [
            66575,
            66575
        ],
        "mapped",
        [
            66615
        ]
    ],
    [
        [
            66576,
            66576
        ],
        "mapped",
        [
            66616
        ]
    ],
    [
        [
            66577,
            66577
        ],
        "mapped",
        [
            66617
        ]
    ],
    [
        [
            66578,
            66578
        ],
        "mapped",
        [
            66618
        ]
    ],
    [
        [
            66579,
            66579
        ],
        "mapped",
        [
            66619
        ]
    ],
    [
        [
            66580,
            66580
        ],
        "mapped",
        [
            66620
        ]
    ],
    [
        [
            66581,
            66581
        ],
        "mapped",
        [
            66621
        ]
    ],
    [
        [
            66582,
            66582
        ],
        "mapped",
        [
            66622
        ]
    ],
    [
        [
            66583,
            66583
        ],
        "mapped",
        [
            66623
        ]
    ],
    [
        [
            66584,
            66584
        ],
        "mapped",
        [
            66624
        ]
    ],
    [
        [
            66585,
            66585
        ],
        "mapped",
        [
            66625
        ]
    ],
    [
        [
            66586,
            66586
        ],
        "mapped",
        [
            66626
        ]
    ],
    [
        [
            66587,
            66587
        ],
        "mapped",
        [
            66627
        ]
    ],
    [
        [
            66588,
            66588
        ],
        "mapped",
        [
            66628
        ]
    ],
    [
        [
            66589,
            66589
        ],
        "mapped",
        [
            66629
        ]
    ],
    [
        [
            66590,
            66590
        ],
        "mapped",
        [
            66630
        ]
    ],
    [
        [
            66591,
            66591
        ],
        "mapped",
        [
            66631
        ]
    ],
    [
        [
            66592,
            66592
        ],
        "mapped",
        [
            66632
        ]
    ],
    [
        [
            66593,
            66593
        ],
        "mapped",
        [
            66633
        ]
    ],
    [
        [
            66594,
            66594
        ],
        "mapped",
        [
            66634
        ]
    ],
    [
        [
            66595,
            66595
        ],
        "mapped",
        [
            66635
        ]
    ],
    [
        [
            66596,
            66596
        ],
        "mapped",
        [
            66636
        ]
    ],
    [
        [
            66597,
            66597
        ],
        "mapped",
        [
            66637
        ]
    ],
    [
        [
            66598,
            66598
        ],
        "mapped",
        [
            66638
        ]
    ],
    [
        [
            66599,
            66599
        ],
        "mapped",
        [
            66639
        ]
    ],
    [
        [
            66600,
            66637
        ],
        "valid"
    ],
    [
        [
            66638,
            66717
        ],
        "valid"
    ],
    [
        [
            66718,
            66719
        ],
        "disallowed"
    ],
    [
        [
            66720,
            66729
        ],
        "valid"
    ],
    [
        [
            66730,
            66815
        ],
        "disallowed"
    ],
    [
        [
            66816,
            66855
        ],
        "valid"
    ],
    [
        [
            66856,
            66863
        ],
        "disallowed"
    ],
    [
        [
            66864,
            66915
        ],
        "valid"
    ],
    [
        [
            66916,
            66926
        ],
        "disallowed"
    ],
    [
        [
            66927,
            66927
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            66928,
            67071
        ],
        "disallowed"
    ],
    [
        [
            67072,
            67382
        ],
        "valid"
    ],
    [
        [
            67383,
            67391
        ],
        "disallowed"
    ],
    [
        [
            67392,
            67413
        ],
        "valid"
    ],
    [
        [
            67414,
            67423
        ],
        "disallowed"
    ],
    [
        [
            67424,
            67431
        ],
        "valid"
    ],
    [
        [
            67432,
            67583
        ],
        "disallowed"
    ],
    [
        [
            67584,
            67589
        ],
        "valid"
    ],
    [
        [
            67590,
            67591
        ],
        "disallowed"
    ],
    [
        [
            67592,
            67592
        ],
        "valid"
    ],
    [
        [
            67593,
            67593
        ],
        "disallowed"
    ],
    [
        [
            67594,
            67637
        ],
        "valid"
    ],
    [
        [
            67638,
            67638
        ],
        "disallowed"
    ],
    [
        [
            67639,
            67640
        ],
        "valid"
    ],
    [
        [
            67641,
            67643
        ],
        "disallowed"
    ],
    [
        [
            67644,
            67644
        ],
        "valid"
    ],
    [
        [
            67645,
            67646
        ],
        "disallowed"
    ],
    [
        [
            67647,
            67647
        ],
        "valid"
    ],
    [
        [
            67648,
            67669
        ],
        "valid"
    ],
    [
        [
            67670,
            67670
        ],
        "disallowed"
    ],
    [
        [
            67671,
            67679
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            67680,
            67702
        ],
        "valid"
    ],
    [
        [
            67703,
            67711
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            67712,
            67742
        ],
        "valid"
    ],
    [
        [
            67743,
            67750
        ],
        "disallowed"
    ],
    [
        [
            67751,
            67759
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            67760,
            67807
        ],
        "disallowed"
    ],
    [
        [
            67808,
            67826
        ],
        "valid"
    ],
    [
        [
            67827,
            67827
        ],
        "disallowed"
    ],
    [
        [
            67828,
            67829
        ],
        "valid"
    ],
    [
        [
            67830,
            67834
        ],
        "disallowed"
    ],
    [
        [
            67835,
            67839
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            67840,
            67861
        ],
        "valid"
    ],
    [
        [
            67862,
            67865
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            67866,
            67867
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            67868,
            67870
        ],
        "disallowed"
    ],
    [
        [
            67871,
            67871
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            67872,
            67897
        ],
        "valid"
    ],
    [
        [
            67898,
            67902
        ],
        "disallowed"
    ],
    [
        [
            67903,
            67903
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            67904,
            67967
        ],
        "disallowed"
    ],
    [
        [
            67968,
            68023
        ],
        "valid"
    ],
    [
        [
            68024,
            68027
        ],
        "disallowed"
    ],
    [
        [
            68028,
            68029
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68030,
            68031
        ],
        "valid"
    ],
    [
        [
            68032,
            68047
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68048,
            68049
        ],
        "disallowed"
    ],
    [
        [
            68050,
            68095
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68096,
            68099
        ],
        "valid"
    ],
    [
        [
            68100,
            68100
        ],
        "disallowed"
    ],
    [
        [
            68101,
            68102
        ],
        "valid"
    ],
    [
        [
            68103,
            68107
        ],
        "disallowed"
    ],
    [
        [
            68108,
            68115
        ],
        "valid"
    ],
    [
        [
            68116,
            68116
        ],
        "disallowed"
    ],
    [
        [
            68117,
            68119
        ],
        "valid"
    ],
    [
        [
            68120,
            68120
        ],
        "disallowed"
    ],
    [
        [
            68121,
            68147
        ],
        "valid"
    ],
    [
        [
            68148,
            68151
        ],
        "disallowed"
    ],
    [
        [
            68152,
            68154
        ],
        "valid"
    ],
    [
        [
            68155,
            68158
        ],
        "disallowed"
    ],
    [
        [
            68159,
            68159
        ],
        "valid"
    ],
    [
        [
            68160,
            68167
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68168,
            68175
        ],
        "disallowed"
    ],
    [
        [
            68176,
            68184
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68185,
            68191
        ],
        "disallowed"
    ],
    [
        [
            68192,
            68220
        ],
        "valid"
    ],
    [
        [
            68221,
            68223
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68224,
            68252
        ],
        "valid"
    ],
    [
        [
            68253,
            68255
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68256,
            68287
        ],
        "disallowed"
    ],
    [
        [
            68288,
            68295
        ],
        "valid"
    ],
    [
        [
            68296,
            68296
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68297,
            68326
        ],
        "valid"
    ],
    [
        [
            68327,
            68330
        ],
        "disallowed"
    ],
    [
        [
            68331,
            68342
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68343,
            68351
        ],
        "disallowed"
    ],
    [
        [
            68352,
            68405
        ],
        "valid"
    ],
    [
        [
            68406,
            68408
        ],
        "disallowed"
    ],
    [
        [
            68409,
            68415
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68416,
            68437
        ],
        "valid"
    ],
    [
        [
            68438,
            68439
        ],
        "disallowed"
    ],
    [
        [
            68440,
            68447
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68448,
            68466
        ],
        "valid"
    ],
    [
        [
            68467,
            68471
        ],
        "disallowed"
    ],
    [
        [
            68472,
            68479
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68480,
            68497
        ],
        "valid"
    ],
    [
        [
            68498,
            68504
        ],
        "disallowed"
    ],
    [
        [
            68505,
            68508
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68509,
            68520
        ],
        "disallowed"
    ],
    [
        [
            68521,
            68527
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68528,
            68607
        ],
        "disallowed"
    ],
    [
        [
            68608,
            68680
        ],
        "valid"
    ],
    [
        [
            68681,
            68735
        ],
        "disallowed"
    ],
    [
        [
            68736,
            68736
        ],
        "mapped",
        [
            68800
        ]
    ],
    [
        [
            68737,
            68737
        ],
        "mapped",
        [
            68801
        ]
    ],
    [
        [
            68738,
            68738
        ],
        "mapped",
        [
            68802
        ]
    ],
    [
        [
            68739,
            68739
        ],
        "mapped",
        [
            68803
        ]
    ],
    [
        [
            68740,
            68740
        ],
        "mapped",
        [
            68804
        ]
    ],
    [
        [
            68741,
            68741
        ],
        "mapped",
        [
            68805
        ]
    ],
    [
        [
            68742,
            68742
        ],
        "mapped",
        [
            68806
        ]
    ],
    [
        [
            68743,
            68743
        ],
        "mapped",
        [
            68807
        ]
    ],
    [
        [
            68744,
            68744
        ],
        "mapped",
        [
            68808
        ]
    ],
    [
        [
            68745,
            68745
        ],
        "mapped",
        [
            68809
        ]
    ],
    [
        [
            68746,
            68746
        ],
        "mapped",
        [
            68810
        ]
    ],
    [
        [
            68747,
            68747
        ],
        "mapped",
        [
            68811
        ]
    ],
    [
        [
            68748,
            68748
        ],
        "mapped",
        [
            68812
        ]
    ],
    [
        [
            68749,
            68749
        ],
        "mapped",
        [
            68813
        ]
    ],
    [
        [
            68750,
            68750
        ],
        "mapped",
        [
            68814
        ]
    ],
    [
        [
            68751,
            68751
        ],
        "mapped",
        [
            68815
        ]
    ],
    [
        [
            68752,
            68752
        ],
        "mapped",
        [
            68816
        ]
    ],
    [
        [
            68753,
            68753
        ],
        "mapped",
        [
            68817
        ]
    ],
    [
        [
            68754,
            68754
        ],
        "mapped",
        [
            68818
        ]
    ],
    [
        [
            68755,
            68755
        ],
        "mapped",
        [
            68819
        ]
    ],
    [
        [
            68756,
            68756
        ],
        "mapped",
        [
            68820
        ]
    ],
    [
        [
            68757,
            68757
        ],
        "mapped",
        [
            68821
        ]
    ],
    [
        [
            68758,
            68758
        ],
        "mapped",
        [
            68822
        ]
    ],
    [
        [
            68759,
            68759
        ],
        "mapped",
        [
            68823
        ]
    ],
    [
        [
            68760,
            68760
        ],
        "mapped",
        [
            68824
        ]
    ],
    [
        [
            68761,
            68761
        ],
        "mapped",
        [
            68825
        ]
    ],
    [
        [
            68762,
            68762
        ],
        "mapped",
        [
            68826
        ]
    ],
    [
        [
            68763,
            68763
        ],
        "mapped",
        [
            68827
        ]
    ],
    [
        [
            68764,
            68764
        ],
        "mapped",
        [
            68828
        ]
    ],
    [
        [
            68765,
            68765
        ],
        "mapped",
        [
            68829
        ]
    ],
    [
        [
            68766,
            68766
        ],
        "mapped",
        [
            68830
        ]
    ],
    [
        [
            68767,
            68767
        ],
        "mapped",
        [
            68831
        ]
    ],
    [
        [
            68768,
            68768
        ],
        "mapped",
        [
            68832
        ]
    ],
    [
        [
            68769,
            68769
        ],
        "mapped",
        [
            68833
        ]
    ],
    [
        [
            68770,
            68770
        ],
        "mapped",
        [
            68834
        ]
    ],
    [
        [
            68771,
            68771
        ],
        "mapped",
        [
            68835
        ]
    ],
    [
        [
            68772,
            68772
        ],
        "mapped",
        [
            68836
        ]
    ],
    [
        [
            68773,
            68773
        ],
        "mapped",
        [
            68837
        ]
    ],
    [
        [
            68774,
            68774
        ],
        "mapped",
        [
            68838
        ]
    ],
    [
        [
            68775,
            68775
        ],
        "mapped",
        [
            68839
        ]
    ],
    [
        [
            68776,
            68776
        ],
        "mapped",
        [
            68840
        ]
    ],
    [
        [
            68777,
            68777
        ],
        "mapped",
        [
            68841
        ]
    ],
    [
        [
            68778,
            68778
        ],
        "mapped",
        [
            68842
        ]
    ],
    [
        [
            68779,
            68779
        ],
        "mapped",
        [
            68843
        ]
    ],
    [
        [
            68780,
            68780
        ],
        "mapped",
        [
            68844
        ]
    ],
    [
        [
            68781,
            68781
        ],
        "mapped",
        [
            68845
        ]
    ],
    [
        [
            68782,
            68782
        ],
        "mapped",
        [
            68846
        ]
    ],
    [
        [
            68783,
            68783
        ],
        "mapped",
        [
            68847
        ]
    ],
    [
        [
            68784,
            68784
        ],
        "mapped",
        [
            68848
        ]
    ],
    [
        [
            68785,
            68785
        ],
        "mapped",
        [
            68849
        ]
    ],
    [
        [
            68786,
            68786
        ],
        "mapped",
        [
            68850
        ]
    ],
    [
        [
            68787,
            68799
        ],
        "disallowed"
    ],
    [
        [
            68800,
            68850
        ],
        "valid"
    ],
    [
        [
            68851,
            68857
        ],
        "disallowed"
    ],
    [
        [
            68858,
            68863
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            68864,
            69215
        ],
        "disallowed"
    ],
    [
        [
            69216,
            69246
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            69247,
            69631
        ],
        "disallowed"
    ],
    [
        [
            69632,
            69702
        ],
        "valid"
    ],
    [
        [
            69703,
            69709
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            69710,
            69713
        ],
        "disallowed"
    ],
    [
        [
            69714,
            69733
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            69734,
            69743
        ],
        "valid"
    ],
    [
        [
            69744,
            69758
        ],
        "disallowed"
    ],
    [
        [
            69759,
            69759
        ],
        "valid"
    ],
    [
        [
            69760,
            69818
        ],
        "valid"
    ],
    [
        [
            69819,
            69820
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            69821,
            69821
        ],
        "disallowed"
    ],
    [
        [
            69822,
            69825
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            69826,
            69839
        ],
        "disallowed"
    ],
    [
        [
            69840,
            69864
        ],
        "valid"
    ],
    [
        [
            69865,
            69871
        ],
        "disallowed"
    ],
    [
        [
            69872,
            69881
        ],
        "valid"
    ],
    [
        [
            69882,
            69887
        ],
        "disallowed"
    ],
    [
        [
            69888,
            69940
        ],
        "valid"
    ],
    [
        [
            69941,
            69941
        ],
        "disallowed"
    ],
    [
        [
            69942,
            69951
        ],
        "valid"
    ],
    [
        [
            69952,
            69955
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            69956,
            69967
        ],
        "disallowed"
    ],
    [
        [
            69968,
            70003
        ],
        "valid"
    ],
    [
        [
            70004,
            70005
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            70006,
            70006
        ],
        "valid"
    ],
    [
        [
            70007,
            70015
        ],
        "disallowed"
    ],
    [
        [
            70016,
            70084
        ],
        "valid"
    ],
    [
        [
            70085,
            70088
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            70089,
            70089
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            70090,
            70092
        ],
        "valid"
    ],
    [
        [
            70093,
            70093
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            70094,
            70095
        ],
        "disallowed"
    ],
    [
        [
            70096,
            70105
        ],
        "valid"
    ],
    [
        [
            70106,
            70106
        ],
        "valid"
    ],
    [
        [
            70107,
            70107
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            70108,
            70108
        ],
        "valid"
    ],
    [
        [
            70109,
            70111
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            70112,
            70112
        ],
        "disallowed"
    ],
    [
        [
            70113,
            70132
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            70133,
            70143
        ],
        "disallowed"
    ],
    [
        [
            70144,
            70161
        ],
        "valid"
    ],
    [
        [
            70162,
            70162
        ],
        "disallowed"
    ],
    [
        [
            70163,
            70199
        ],
        "valid"
    ],
    [
        [
            70200,
            70205
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            70206,
            70271
        ],
        "disallowed"
    ],
    [
        [
            70272,
            70278
        ],
        "valid"
    ],
    [
        [
            70279,
            70279
        ],
        "disallowed"
    ],
    [
        [
            70280,
            70280
        ],
        "valid"
    ],
    [
        [
            70281,
            70281
        ],
        "disallowed"
    ],
    [
        [
            70282,
            70285
        ],
        "valid"
    ],
    [
        [
            70286,
            70286
        ],
        "disallowed"
    ],
    [
        [
            70287,
            70301
        ],
        "valid"
    ],
    [
        [
            70302,
            70302
        ],
        "disallowed"
    ],
    [
        [
            70303,
            70312
        ],
        "valid"
    ],
    [
        [
            70313,
            70313
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            70314,
            70319
        ],
        "disallowed"
    ],
    [
        [
            70320,
            70378
        ],
        "valid"
    ],
    [
        [
            70379,
            70383
        ],
        "disallowed"
    ],
    [
        [
            70384,
            70393
        ],
        "valid"
    ],
    [
        [
            70394,
            70399
        ],
        "disallowed"
    ],
    [
        [
            70400,
            70400
        ],
        "valid"
    ],
    [
        [
            70401,
            70403
        ],
        "valid"
    ],
    [
        [
            70404,
            70404
        ],
        "disallowed"
    ],
    [
        [
            70405,
            70412
        ],
        "valid"
    ],
    [
        [
            70413,
            70414
        ],
        "disallowed"
    ],
    [
        [
            70415,
            70416
        ],
        "valid"
    ],
    [
        [
            70417,
            70418
        ],
        "disallowed"
    ],
    [
        [
            70419,
            70440
        ],
        "valid"
    ],
    [
        [
            70441,
            70441
        ],
        "disallowed"
    ],
    [
        [
            70442,
            70448
        ],
        "valid"
    ],
    [
        [
            70449,
            70449
        ],
        "disallowed"
    ],
    [
        [
            70450,
            70451
        ],
        "valid"
    ],
    [
        [
            70452,
            70452
        ],
        "disallowed"
    ],
    [
        [
            70453,
            70457
        ],
        "valid"
    ],
    [
        [
            70458,
            70459
        ],
        "disallowed"
    ],
    [
        [
            70460,
            70468
        ],
        "valid"
    ],
    [
        [
            70469,
            70470
        ],
        "disallowed"
    ],
    [
        [
            70471,
            70472
        ],
        "valid"
    ],
    [
        [
            70473,
            70474
        ],
        "disallowed"
    ],
    [
        [
            70475,
            70477
        ],
        "valid"
    ],
    [
        [
            70478,
            70479
        ],
        "disallowed"
    ],
    [
        [
            70480,
            70480
        ],
        "valid"
    ],
    [
        [
            70481,
            70486
        ],
        "disallowed"
    ],
    [
        [
            70487,
            70487
        ],
        "valid"
    ],
    [
        [
            70488,
            70492
        ],
        "disallowed"
    ],
    [
        [
            70493,
            70499
        ],
        "valid"
    ],
    [
        [
            70500,
            70501
        ],
        "disallowed"
    ],
    [
        [
            70502,
            70508
        ],
        "valid"
    ],
    [
        [
            70509,
            70511
        ],
        "disallowed"
    ],
    [
        [
            70512,
            70516
        ],
        "valid"
    ],
    [
        [
            70517,
            70783
        ],
        "disallowed"
    ],
    [
        [
            70784,
            70853
        ],
        "valid"
    ],
    [
        [
            70854,
            70854
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            70855,
            70855
        ],
        "valid"
    ],
    [
        [
            70856,
            70863
        ],
        "disallowed"
    ],
    [
        [
            70864,
            70873
        ],
        "valid"
    ],
    [
        [
            70874,
            71039
        ],
        "disallowed"
    ],
    [
        [
            71040,
            71093
        ],
        "valid"
    ],
    [
        [
            71094,
            71095
        ],
        "disallowed"
    ],
    [
        [
            71096,
            71104
        ],
        "valid"
    ],
    [
        [
            71105,
            71113
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            71114,
            71127
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            71128,
            71133
        ],
        "valid"
    ],
    [
        [
            71134,
            71167
        ],
        "disallowed"
    ],
    [
        [
            71168,
            71232
        ],
        "valid"
    ],
    [
        [
            71233,
            71235
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            71236,
            71236
        ],
        "valid"
    ],
    [
        [
            71237,
            71247
        ],
        "disallowed"
    ],
    [
        [
            71248,
            71257
        ],
        "valid"
    ],
    [
        [
            71258,
            71295
        ],
        "disallowed"
    ],
    [
        [
            71296,
            71351
        ],
        "valid"
    ],
    [
        [
            71352,
            71359
        ],
        "disallowed"
    ],
    [
        [
            71360,
            71369
        ],
        "valid"
    ],
    [
        [
            71370,
            71423
        ],
        "disallowed"
    ],
    [
        [
            71424,
            71449
        ],
        "valid"
    ],
    [
        [
            71450,
            71452
        ],
        "disallowed"
    ],
    [
        [
            71453,
            71467
        ],
        "valid"
    ],
    [
        [
            71468,
            71471
        ],
        "disallowed"
    ],
    [
        [
            71472,
            71481
        ],
        "valid"
    ],
    [
        [
            71482,
            71487
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            71488,
            71839
        ],
        "disallowed"
    ],
    [
        [
            71840,
            71840
        ],
        "mapped",
        [
            71872
        ]
    ],
    [
        [
            71841,
            71841
        ],
        "mapped",
        [
            71873
        ]
    ],
    [
        [
            71842,
            71842
        ],
        "mapped",
        [
            71874
        ]
    ],
    [
        [
            71843,
            71843
        ],
        "mapped",
        [
            71875
        ]
    ],
    [
        [
            71844,
            71844
        ],
        "mapped",
        [
            71876
        ]
    ],
    [
        [
            71845,
            71845
        ],
        "mapped",
        [
            71877
        ]
    ],
    [
        [
            71846,
            71846
        ],
        "mapped",
        [
            71878
        ]
    ],
    [
        [
            71847,
            71847
        ],
        "mapped",
        [
            71879
        ]
    ],
    [
        [
            71848,
            71848
        ],
        "mapped",
        [
            71880
        ]
    ],
    [
        [
            71849,
            71849
        ],
        "mapped",
        [
            71881
        ]
    ],
    [
        [
            71850,
            71850
        ],
        "mapped",
        [
            71882
        ]
    ],
    [
        [
            71851,
            71851
        ],
        "mapped",
        [
            71883
        ]
    ],
    [
        [
            71852,
            71852
        ],
        "mapped",
        [
            71884
        ]
    ],
    [
        [
            71853,
            71853
        ],
        "mapped",
        [
            71885
        ]
    ],
    [
        [
            71854,
            71854
        ],
        "mapped",
        [
            71886
        ]
    ],
    [
        [
            71855,
            71855
        ],
        "mapped",
        [
            71887
        ]
    ],
    [
        [
            71856,
            71856
        ],
        "mapped",
        [
            71888
        ]
    ],
    [
        [
            71857,
            71857
        ],
        "mapped",
        [
            71889
        ]
    ],
    [
        [
            71858,
            71858
        ],
        "mapped",
        [
            71890
        ]
    ],
    [
        [
            71859,
            71859
        ],
        "mapped",
        [
            71891
        ]
    ],
    [
        [
            71860,
            71860
        ],
        "mapped",
        [
            71892
        ]
    ],
    [
        [
            71861,
            71861
        ],
        "mapped",
        [
            71893
        ]
    ],
    [
        [
            71862,
            71862
        ],
        "mapped",
        [
            71894
        ]
    ],
    [
        [
            71863,
            71863
        ],
        "mapped",
        [
            71895
        ]
    ],
    [
        [
            71864,
            71864
        ],
        "mapped",
        [
            71896
        ]
    ],
    [
        [
            71865,
            71865
        ],
        "mapped",
        [
            71897
        ]
    ],
    [
        [
            71866,
            71866
        ],
        "mapped",
        [
            71898
        ]
    ],
    [
        [
            71867,
            71867
        ],
        "mapped",
        [
            71899
        ]
    ],
    [
        [
            71868,
            71868
        ],
        "mapped",
        [
            71900
        ]
    ],
    [
        [
            71869,
            71869
        ],
        "mapped",
        [
            71901
        ]
    ],
    [
        [
            71870,
            71870
        ],
        "mapped",
        [
            71902
        ]
    ],
    [
        [
            71871,
            71871
        ],
        "mapped",
        [
            71903
        ]
    ],
    [
        [
            71872,
            71913
        ],
        "valid"
    ],
    [
        [
            71914,
            71922
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            71923,
            71934
        ],
        "disallowed"
    ],
    [
        [
            71935,
            71935
        ],
        "valid"
    ],
    [
        [
            71936,
            72383
        ],
        "disallowed"
    ],
    [
        [
            72384,
            72440
        ],
        "valid"
    ],
    [
        [
            72441,
            73727
        ],
        "disallowed"
    ],
    [
        [
            73728,
            74606
        ],
        "valid"
    ],
    [
        [
            74607,
            74648
        ],
        "valid"
    ],
    [
        [
            74649,
            74649
        ],
        "valid"
    ],
    [
        [
            74650,
            74751
        ],
        "disallowed"
    ],
    [
        [
            74752,
            74850
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            74851,
            74862
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            74863,
            74863
        ],
        "disallowed"
    ],
    [
        [
            74864,
            74867
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            74868,
            74868
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            74869,
            74879
        ],
        "disallowed"
    ],
    [
        [
            74880,
            75075
        ],
        "valid"
    ],
    [
        [
            75076,
            77823
        ],
        "disallowed"
    ],
    [
        [
            77824,
            78894
        ],
        "valid"
    ],
    [
        [
            78895,
            82943
        ],
        "disallowed"
    ],
    [
        [
            82944,
            83526
        ],
        "valid"
    ],
    [
        [
            83527,
            92159
        ],
        "disallowed"
    ],
    [
        [
            92160,
            92728
        ],
        "valid"
    ],
    [
        [
            92729,
            92735
        ],
        "disallowed"
    ],
    [
        [
            92736,
            92766
        ],
        "valid"
    ],
    [
        [
            92767,
            92767
        ],
        "disallowed"
    ],
    [
        [
            92768,
            92777
        ],
        "valid"
    ],
    [
        [
            92778,
            92781
        ],
        "disallowed"
    ],
    [
        [
            92782,
            92783
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            92784,
            92879
        ],
        "disallowed"
    ],
    [
        [
            92880,
            92909
        ],
        "valid"
    ],
    [
        [
            92910,
            92911
        ],
        "disallowed"
    ],
    [
        [
            92912,
            92916
        ],
        "valid"
    ],
    [
        [
            92917,
            92917
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            92918,
            92927
        ],
        "disallowed"
    ],
    [
        [
            92928,
            92982
        ],
        "valid"
    ],
    [
        [
            92983,
            92991
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            92992,
            92995
        ],
        "valid"
    ],
    [
        [
            92996,
            92997
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            92998,
            93007
        ],
        "disallowed"
    ],
    [
        [
            93008,
            93017
        ],
        "valid"
    ],
    [
        [
            93018,
            93018
        ],
        "disallowed"
    ],
    [
        [
            93019,
            93025
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            93026,
            93026
        ],
        "disallowed"
    ],
    [
        [
            93027,
            93047
        ],
        "valid"
    ],
    [
        [
            93048,
            93052
        ],
        "disallowed"
    ],
    [
        [
            93053,
            93071
        ],
        "valid"
    ],
    [
        [
            93072,
            93951
        ],
        "disallowed"
    ],
    [
        [
            93952,
            94020
        ],
        "valid"
    ],
    [
        [
            94021,
            94031
        ],
        "disallowed"
    ],
    [
        [
            94032,
            94078
        ],
        "valid"
    ],
    [
        [
            94079,
            94094
        ],
        "disallowed"
    ],
    [
        [
            94095,
            94111
        ],
        "valid"
    ],
    [
        [
            94112,
            110591
        ],
        "disallowed"
    ],
    [
        [
            110592,
            110593
        ],
        "valid"
    ],
    [
        [
            110594,
            113663
        ],
        "disallowed"
    ],
    [
        [
            113664,
            113770
        ],
        "valid"
    ],
    [
        [
            113771,
            113775
        ],
        "disallowed"
    ],
    [
        [
            113776,
            113788
        ],
        "valid"
    ],
    [
        [
            113789,
            113791
        ],
        "disallowed"
    ],
    [
        [
            113792,
            113800
        ],
        "valid"
    ],
    [
        [
            113801,
            113807
        ],
        "disallowed"
    ],
    [
        [
            113808,
            113817
        ],
        "valid"
    ],
    [
        [
            113818,
            113819
        ],
        "disallowed"
    ],
    [
        [
            113820,
            113820
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            113821,
            113822
        ],
        "valid"
    ],
    [
        [
            113823,
            113823
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            113824,
            113827
        ],
        "ignored"
    ],
    [
        [
            113828,
            118783
        ],
        "disallowed"
    ],
    [
        [
            118784,
            119029
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            119030,
            119039
        ],
        "disallowed"
    ],
    [
        [
            119040,
            119078
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            119079,
            119080
        ],
        "disallowed"
    ],
    [
        [
            119081,
            119081
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            119082,
            119133
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            119134,
            119134
        ],
        "mapped",
        [
            119127,
            119141
        ]
    ],
    [
        [
            119135,
            119135
        ],
        "mapped",
        [
            119128,
            119141
        ]
    ],
    [
        [
            119136,
            119136
        ],
        "mapped",
        [
            119128,
            119141,
            119150
        ]
    ],
    [
        [
            119137,
            119137
        ],
        "mapped",
        [
            119128,
            119141,
            119151
        ]
    ],
    [
        [
            119138,
            119138
        ],
        "mapped",
        [
            119128,
            119141,
            119152
        ]
    ],
    [
        [
            119139,
            119139
        ],
        "mapped",
        [
            119128,
            119141,
            119153
        ]
    ],
    [
        [
            119140,
            119140
        ],
        "mapped",
        [
            119128,
            119141,
            119154
        ]
    ],
    [
        [
            119141,
            119154
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            119155,
            119162
        ],
        "disallowed"
    ],
    [
        [
            119163,
            119226
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            119227,
            119227
        ],
        "mapped",
        [
            119225,
            119141
        ]
    ],
    [
        [
            119228,
            119228
        ],
        "mapped",
        [
            119226,
            119141
        ]
    ],
    [
        [
            119229,
            119229
        ],
        "mapped",
        [
            119225,
            119141,
            119150
        ]
    ],
    [
        [
            119230,
            119230
        ],
        "mapped",
        [
            119226,
            119141,
            119150
        ]
    ],
    [
        [
            119231,
            119231
        ],
        "mapped",
        [
            119225,
            119141,
            119151
        ]
    ],
    [
        [
            119232,
            119232
        ],
        "mapped",
        [
            119226,
            119141,
            119151
        ]
    ],
    [
        [
            119233,
            119261
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            119262,
            119272
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            119273,
            119295
        ],
        "disallowed"
    ],
    [
        [
            119296,
            119365
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            119366,
            119551
        ],
        "disallowed"
    ],
    [
        [
            119552,
            119638
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            119639,
            119647
        ],
        "disallowed"
    ],
    [
        [
            119648,
            119665
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            119666,
            119807
        ],
        "disallowed"
    ],
    [
        [
            119808,
            119808
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            119809,
            119809
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            119810,
            119810
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            119811,
            119811
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            119812,
            119812
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            119813,
            119813
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            119814,
            119814
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            119815,
            119815
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            119816,
            119816
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            119817,
            119817
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            119818,
            119818
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            119819,
            119819
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            119820,
            119820
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            119821,
            119821
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            119822,
            119822
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            119823,
            119823
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            119824,
            119824
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            119825,
            119825
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            119826,
            119826
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            119827,
            119827
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            119828,
            119828
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            119829,
            119829
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            119830,
            119830
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            119831,
            119831
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            119832,
            119832
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            119833,
            119833
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            119834,
            119834
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            119835,
            119835
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            119836,
            119836
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            119837,
            119837
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            119838,
            119838
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            119839,
            119839
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            119840,
            119840
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            119841,
            119841
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            119842,
            119842
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            119843,
            119843
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            119844,
            119844
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            119845,
            119845
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            119846,
            119846
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            119847,
            119847
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            119848,
            119848
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            119849,
            119849
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            119850,
            119850
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            119851,
            119851
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            119852,
            119852
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            119853,
            119853
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            119854,
            119854
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            119855,
            119855
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            119856,
            119856
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            119857,
            119857
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            119858,
            119858
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            119859,
            119859
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            119860,
            119860
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            119861,
            119861
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            119862,
            119862
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            119863,
            119863
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            119864,
            119864
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            119865,
            119865
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            119866,
            119866
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            119867,
            119867
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            119868,
            119868
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            119869,
            119869
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            119870,
            119870
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            119871,
            119871
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            119872,
            119872
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            119873,
            119873
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            119874,
            119874
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            119875,
            119875
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            119876,
            119876
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            119877,
            119877
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            119878,
            119878
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            119879,
            119879
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            119880,
            119880
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            119881,
            119881
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            119882,
            119882
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            119883,
            119883
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            119884,
            119884
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            119885,
            119885
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            119886,
            119886
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            119887,
            119887
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            119888,
            119888
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            119889,
            119889
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            119890,
            119890
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            119891,
            119891
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            119892,
            119892
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            119893,
            119893
        ],
        "disallowed"
    ],
    [
        [
            119894,
            119894
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            119895,
            119895
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            119896,
            119896
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            119897,
            119897
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            119898,
            119898
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            119899,
            119899
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            119900,
            119900
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            119901,
            119901
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            119902,
            119902
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            119903,
            119903
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            119904,
            119904
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            119905,
            119905
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            119906,
            119906
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            119907,
            119907
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            119908,
            119908
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            119909,
            119909
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            119910,
            119910
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            119911,
            119911
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            119912,
            119912
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            119913,
            119913
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            119914,
            119914
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            119915,
            119915
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            119916,
            119916
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            119917,
            119917
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            119918,
            119918
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            119919,
            119919
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            119920,
            119920
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            119921,
            119921
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            119922,
            119922
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            119923,
            119923
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            119924,
            119924
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            119925,
            119925
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            119926,
            119926
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            119927,
            119927
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            119928,
            119928
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            119929,
            119929
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            119930,
            119930
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            119931,
            119931
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            119932,
            119932
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            119933,
            119933
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            119934,
            119934
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            119935,
            119935
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            119936,
            119936
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            119937,
            119937
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            119938,
            119938
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            119939,
            119939
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            119940,
            119940
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            119941,
            119941
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            119942,
            119942
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            119943,
            119943
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            119944,
            119944
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            119945,
            119945
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            119946,
            119946
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            119947,
            119947
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            119948,
            119948
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            119949,
            119949
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            119950,
            119950
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            119951,
            119951
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            119952,
            119952
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            119953,
            119953
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            119954,
            119954
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            119955,
            119955
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            119956,
            119956
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            119957,
            119957
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            119958,
            119958
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            119959,
            119959
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            119960,
            119960
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            119961,
            119961
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            119962,
            119962
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            119963,
            119963
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            119964,
            119964
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            119965,
            119965
        ],
        "disallowed"
    ],
    [
        [
            119966,
            119966
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            119967,
            119967
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            119968,
            119969
        ],
        "disallowed"
    ],
    [
        [
            119970,
            119970
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            119971,
            119972
        ],
        "disallowed"
    ],
    [
        [
            119973,
            119973
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            119974,
            119974
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            119975,
            119976
        ],
        "disallowed"
    ],
    [
        [
            119977,
            119977
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            119978,
            119978
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            119979,
            119979
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            119980,
            119980
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            119981,
            119981
        ],
        "disallowed"
    ],
    [
        [
            119982,
            119982
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            119983,
            119983
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            119984,
            119984
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            119985,
            119985
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            119986,
            119986
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            119987,
            119987
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            119988,
            119988
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            119989,
            119989
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            119990,
            119990
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            119991,
            119991
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            119992,
            119992
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            119993,
            119993
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            119994,
            119994
        ],
        "disallowed"
    ],
    [
        [
            119995,
            119995
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            119996,
            119996
        ],
        "disallowed"
    ],
    [
        [
            119997,
            119997
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            119998,
            119998
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            119999,
            119999
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120000,
            120000
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120001,
            120001
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120002,
            120002
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120003,
            120003
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120004,
            120004
        ],
        "disallowed"
    ],
    [
        [
            120005,
            120005
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120006,
            120006
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120007,
            120007
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120008,
            120008
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120009,
            120009
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120010,
            120010
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120011,
            120011
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120012,
            120012
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120013,
            120013
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120014,
            120014
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120015,
            120015
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120016,
            120016
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120017,
            120017
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120018,
            120018
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120019,
            120019
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120020,
            120020
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120021,
            120021
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120022,
            120022
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120023,
            120023
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120024,
            120024
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120025,
            120025
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120026,
            120026
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120027,
            120027
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120028,
            120028
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120029,
            120029
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120030,
            120030
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120031,
            120031
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120032,
            120032
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120033,
            120033
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120034,
            120034
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120035,
            120035
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120036,
            120036
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120037,
            120037
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120038,
            120038
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120039,
            120039
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120040,
            120040
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120041,
            120041
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120042,
            120042
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120043,
            120043
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120044,
            120044
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120045,
            120045
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120046,
            120046
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120047,
            120047
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120048,
            120048
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120049,
            120049
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120050,
            120050
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120051,
            120051
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120052,
            120052
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120053,
            120053
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120054,
            120054
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120055,
            120055
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120056,
            120056
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120057,
            120057
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120058,
            120058
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120059,
            120059
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120060,
            120060
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120061,
            120061
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120062,
            120062
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120063,
            120063
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120064,
            120064
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120065,
            120065
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120066,
            120066
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120067,
            120067
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120068,
            120068
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120069,
            120069
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120070,
            120070
        ],
        "disallowed"
    ],
    [
        [
            120071,
            120071
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120072,
            120072
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120073,
            120073
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120074,
            120074
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120075,
            120076
        ],
        "disallowed"
    ],
    [
        [
            120077,
            120077
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120078,
            120078
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120079,
            120079
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120080,
            120080
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120081,
            120081
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120082,
            120082
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120083,
            120083
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120084,
            120084
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120085,
            120085
        ],
        "disallowed"
    ],
    [
        [
            120086,
            120086
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120087,
            120087
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120088,
            120088
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120089,
            120089
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120090,
            120090
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120091,
            120091
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120092,
            120092
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120093,
            120093
        ],
        "disallowed"
    ],
    [
        [
            120094,
            120094
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120095,
            120095
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120096,
            120096
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120097,
            120097
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120098,
            120098
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120099,
            120099
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120100,
            120100
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120101,
            120101
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120102,
            120102
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120103,
            120103
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120104,
            120104
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120105,
            120105
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120106,
            120106
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120107,
            120107
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120108,
            120108
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120109,
            120109
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120110,
            120110
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120111,
            120111
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120112,
            120112
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120113,
            120113
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120114,
            120114
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120115,
            120115
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120116,
            120116
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120117,
            120117
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120118,
            120118
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120119,
            120119
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120120,
            120120
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120121,
            120121
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120122,
            120122
        ],
        "disallowed"
    ],
    [
        [
            120123,
            120123
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120124,
            120124
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120125,
            120125
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120126,
            120126
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120127,
            120127
        ],
        "disallowed"
    ],
    [
        [
            120128,
            120128
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120129,
            120129
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120130,
            120130
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120131,
            120131
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120132,
            120132
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120133,
            120133
        ],
        "disallowed"
    ],
    [
        [
            120134,
            120134
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120135,
            120137
        ],
        "disallowed"
    ],
    [
        [
            120138,
            120138
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120139,
            120139
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120140,
            120140
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120141,
            120141
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120142,
            120142
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120143,
            120143
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120144,
            120144
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120145,
            120145
        ],
        "disallowed"
    ],
    [
        [
            120146,
            120146
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120147,
            120147
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120148,
            120148
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120149,
            120149
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120150,
            120150
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120151,
            120151
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120152,
            120152
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120153,
            120153
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120154,
            120154
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120155,
            120155
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120156,
            120156
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120157,
            120157
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120158,
            120158
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120159,
            120159
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120160,
            120160
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120161,
            120161
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120162,
            120162
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120163,
            120163
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120164,
            120164
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120165,
            120165
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120166,
            120166
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120167,
            120167
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120168,
            120168
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120169,
            120169
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120170,
            120170
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120171,
            120171
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120172,
            120172
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120173,
            120173
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120174,
            120174
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120175,
            120175
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120176,
            120176
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120177,
            120177
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120178,
            120178
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120179,
            120179
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120180,
            120180
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120181,
            120181
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120182,
            120182
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120183,
            120183
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120184,
            120184
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120185,
            120185
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120186,
            120186
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120187,
            120187
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120188,
            120188
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120189,
            120189
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120190,
            120190
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120191,
            120191
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120192,
            120192
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120193,
            120193
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120194,
            120194
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120195,
            120195
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120196,
            120196
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120197,
            120197
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120198,
            120198
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120199,
            120199
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120200,
            120200
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120201,
            120201
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120202,
            120202
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120203,
            120203
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120204,
            120204
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120205,
            120205
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120206,
            120206
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120207,
            120207
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120208,
            120208
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120209,
            120209
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120210,
            120210
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120211,
            120211
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120212,
            120212
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120213,
            120213
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120214,
            120214
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120215,
            120215
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120216,
            120216
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120217,
            120217
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120218,
            120218
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120219,
            120219
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120220,
            120220
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120221,
            120221
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120222,
            120222
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120223,
            120223
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120224,
            120224
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120225,
            120225
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120226,
            120226
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120227,
            120227
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120228,
            120228
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120229,
            120229
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120230,
            120230
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120231,
            120231
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120232,
            120232
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120233,
            120233
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120234,
            120234
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120235,
            120235
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120236,
            120236
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120237,
            120237
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120238,
            120238
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120239,
            120239
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120240,
            120240
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120241,
            120241
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120242,
            120242
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120243,
            120243
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120244,
            120244
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120245,
            120245
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120246,
            120246
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120247,
            120247
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120248,
            120248
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120249,
            120249
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120250,
            120250
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120251,
            120251
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120252,
            120252
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120253,
            120253
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120254,
            120254
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120255,
            120255
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120256,
            120256
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120257,
            120257
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120258,
            120258
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120259,
            120259
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120260,
            120260
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120261,
            120261
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120262,
            120262
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120263,
            120263
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120264,
            120264
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120265,
            120265
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120266,
            120266
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120267,
            120267
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120268,
            120268
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120269,
            120269
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120270,
            120270
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120271,
            120271
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120272,
            120272
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120273,
            120273
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120274,
            120274
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120275,
            120275
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120276,
            120276
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120277,
            120277
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120278,
            120278
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120279,
            120279
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120280,
            120280
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120281,
            120281
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120282,
            120282
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120283,
            120283
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120284,
            120284
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120285,
            120285
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120286,
            120286
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120287,
            120287
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120288,
            120288
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120289,
            120289
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120290,
            120290
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120291,
            120291
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120292,
            120292
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120293,
            120293
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120294,
            120294
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120295,
            120295
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120296,
            120296
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120297,
            120297
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120298,
            120298
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120299,
            120299
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120300,
            120300
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120301,
            120301
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120302,
            120302
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120303,
            120303
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120304,
            120304
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120305,
            120305
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120306,
            120306
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120307,
            120307
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120308,
            120308
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120309,
            120309
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120310,
            120310
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120311,
            120311
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120312,
            120312
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120313,
            120313
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120314,
            120314
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120315,
            120315
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120316,
            120316
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120317,
            120317
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120318,
            120318
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120319,
            120319
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120320,
            120320
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120321,
            120321
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120322,
            120322
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120323,
            120323
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120324,
            120324
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120325,
            120325
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120326,
            120326
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120327,
            120327
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120328,
            120328
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120329,
            120329
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120330,
            120330
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120331,
            120331
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120332,
            120332
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120333,
            120333
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120334,
            120334
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120335,
            120335
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120336,
            120336
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120337,
            120337
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120338,
            120338
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120339,
            120339
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120340,
            120340
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120341,
            120341
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120342,
            120342
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120343,
            120343
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120344,
            120344
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120345,
            120345
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120346,
            120346
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120347,
            120347
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120348,
            120348
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120349,
            120349
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120350,
            120350
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120351,
            120351
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120352,
            120352
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120353,
            120353
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120354,
            120354
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120355,
            120355
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120356,
            120356
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120357,
            120357
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120358,
            120358
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120359,
            120359
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120360,
            120360
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120361,
            120361
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120362,
            120362
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120363,
            120363
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120364,
            120364
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120365,
            120365
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120366,
            120366
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120367,
            120367
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120368,
            120368
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120369,
            120369
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120370,
            120370
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120371,
            120371
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120372,
            120372
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120373,
            120373
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120374,
            120374
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120375,
            120375
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120376,
            120376
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120377,
            120377
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120378,
            120378
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120379,
            120379
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120380,
            120380
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120381,
            120381
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120382,
            120382
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120383,
            120383
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120384,
            120384
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120385,
            120385
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120386,
            120386
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120387,
            120387
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120388,
            120388
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120389,
            120389
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120390,
            120390
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120391,
            120391
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120392,
            120392
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120393,
            120393
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120394,
            120394
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120395,
            120395
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120396,
            120396
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120397,
            120397
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120398,
            120398
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120399,
            120399
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120400,
            120400
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120401,
            120401
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120402,
            120402
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120403,
            120403
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120404,
            120404
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120405,
            120405
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120406,
            120406
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120407,
            120407
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120408,
            120408
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120409,
            120409
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120410,
            120410
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120411,
            120411
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120412,
            120412
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120413,
            120413
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120414,
            120414
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120415,
            120415
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120416,
            120416
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120417,
            120417
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120418,
            120418
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120419,
            120419
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120420,
            120420
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120421,
            120421
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120422,
            120422
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120423,
            120423
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120424,
            120424
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120425,
            120425
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120426,
            120426
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120427,
            120427
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120428,
            120428
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120429,
            120429
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120430,
            120430
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120431,
            120431
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120432,
            120432
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120433,
            120433
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120434,
            120434
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120435,
            120435
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120436,
            120436
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120437,
            120437
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120438,
            120438
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120439,
            120439
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120440,
            120440
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120441,
            120441
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120442,
            120442
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120443,
            120443
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120444,
            120444
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120445,
            120445
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120446,
            120446
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120447,
            120447
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120448,
            120448
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120449,
            120449
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120450,
            120450
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120451,
            120451
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120452,
            120452
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120453,
            120453
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120454,
            120454
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120455,
            120455
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120456,
            120456
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120457,
            120457
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120458,
            120458
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            120459,
            120459
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            120460,
            120460
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            120461,
            120461
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            120462,
            120462
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            120463,
            120463
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            120464,
            120464
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            120465,
            120465
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            120466,
            120466
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            120467,
            120467
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            120468,
            120468
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            120469,
            120469
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            120470,
            120470
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            120471,
            120471
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            120472,
            120472
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            120473,
            120473
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            120474,
            120474
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            120475,
            120475
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            120476,
            120476
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            120477,
            120477
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            120478,
            120478
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            120479,
            120479
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            120480,
            120480
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            120481,
            120481
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            120482,
            120482
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            120483,
            120483
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            120484,
            120484
        ],
        "mapped",
        [
            305
        ]
    ],
    [
        [
            120485,
            120485
        ],
        "mapped",
        [
            567
        ]
    ],
    [
        [
            120486,
            120487
        ],
        "disallowed"
    ],
    [
        [
            120488,
            120488
        ],
        "mapped",
        [
            945
        ]
    ],
    [
        [
            120489,
            120489
        ],
        "mapped",
        [
            946
        ]
    ],
    [
        [
            120490,
            120490
        ],
        "mapped",
        [
            947
        ]
    ],
    [
        [
            120491,
            120491
        ],
        "mapped",
        [
            948
        ]
    ],
    [
        [
            120492,
            120492
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120493,
            120493
        ],
        "mapped",
        [
            950
        ]
    ],
    [
        [
            120494,
            120494
        ],
        "mapped",
        [
            951
        ]
    ],
    [
        [
            120495,
            120495
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120496,
            120496
        ],
        "mapped",
        [
            953
        ]
    ],
    [
        [
            120497,
            120497
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120498,
            120498
        ],
        "mapped",
        [
            955
        ]
    ],
    [
        [
            120499,
            120499
        ],
        "mapped",
        [
            956
        ]
    ],
    [
        [
            120500,
            120500
        ],
        "mapped",
        [
            957
        ]
    ],
    [
        [
            120501,
            120501
        ],
        "mapped",
        [
            958
        ]
    ],
    [
        [
            120502,
            120502
        ],
        "mapped",
        [
            959
        ]
    ],
    [
        [
            120503,
            120503
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120504,
            120504
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120505,
            120505
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120506,
            120506
        ],
        "mapped",
        [
            963
        ]
    ],
    [
        [
            120507,
            120507
        ],
        "mapped",
        [
            964
        ]
    ],
    [
        [
            120508,
            120508
        ],
        "mapped",
        [
            965
        ]
    ],
    [
        [
            120509,
            120509
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120510,
            120510
        ],
        "mapped",
        [
            967
        ]
    ],
    [
        [
            120511,
            120511
        ],
        "mapped",
        [
            968
        ]
    ],
    [
        [
            120512,
            120512
        ],
        "mapped",
        [
            969
        ]
    ],
    [
        [
            120513,
            120513
        ],
        "mapped",
        [
            8711
        ]
    ],
    [
        [
            120514,
            120514
        ],
        "mapped",
        [
            945
        ]
    ],
    [
        [
            120515,
            120515
        ],
        "mapped",
        [
            946
        ]
    ],
    [
        [
            120516,
            120516
        ],
        "mapped",
        [
            947
        ]
    ],
    [
        [
            120517,
            120517
        ],
        "mapped",
        [
            948
        ]
    ],
    [
        [
            120518,
            120518
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120519,
            120519
        ],
        "mapped",
        [
            950
        ]
    ],
    [
        [
            120520,
            120520
        ],
        "mapped",
        [
            951
        ]
    ],
    [
        [
            120521,
            120521
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120522,
            120522
        ],
        "mapped",
        [
            953
        ]
    ],
    [
        [
            120523,
            120523
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120524,
            120524
        ],
        "mapped",
        [
            955
        ]
    ],
    [
        [
            120525,
            120525
        ],
        "mapped",
        [
            956
        ]
    ],
    [
        [
            120526,
            120526
        ],
        "mapped",
        [
            957
        ]
    ],
    [
        [
            120527,
            120527
        ],
        "mapped",
        [
            958
        ]
    ],
    [
        [
            120528,
            120528
        ],
        "mapped",
        [
            959
        ]
    ],
    [
        [
            120529,
            120529
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120530,
            120530
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120531,
            120532
        ],
        "mapped",
        [
            963
        ]
    ],
    [
        [
            120533,
            120533
        ],
        "mapped",
        [
            964
        ]
    ],
    [
        [
            120534,
            120534
        ],
        "mapped",
        [
            965
        ]
    ],
    [
        [
            120535,
            120535
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120536,
            120536
        ],
        "mapped",
        [
            967
        ]
    ],
    [
        [
            120537,
            120537
        ],
        "mapped",
        [
            968
        ]
    ],
    [
        [
            120538,
            120538
        ],
        "mapped",
        [
            969
        ]
    ],
    [
        [
            120539,
            120539
        ],
        "mapped",
        [
            8706
        ]
    ],
    [
        [
            120540,
            120540
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120541,
            120541
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120542,
            120542
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120543,
            120543
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120544,
            120544
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120545,
            120545
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120546,
            120546
        ],
        "mapped",
        [
            945
        ]
    ],
    [
        [
            120547,
            120547
        ],
        "mapped",
        [
            946
        ]
    ],
    [
        [
            120548,
            120548
        ],
        "mapped",
        [
            947
        ]
    ],
    [
        [
            120549,
            120549
        ],
        "mapped",
        [
            948
        ]
    ],
    [
        [
            120550,
            120550
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120551,
            120551
        ],
        "mapped",
        [
            950
        ]
    ],
    [
        [
            120552,
            120552
        ],
        "mapped",
        [
            951
        ]
    ],
    [
        [
            120553,
            120553
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120554,
            120554
        ],
        "mapped",
        [
            953
        ]
    ],
    [
        [
            120555,
            120555
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120556,
            120556
        ],
        "mapped",
        [
            955
        ]
    ],
    [
        [
            120557,
            120557
        ],
        "mapped",
        [
            956
        ]
    ],
    [
        [
            120558,
            120558
        ],
        "mapped",
        [
            957
        ]
    ],
    [
        [
            120559,
            120559
        ],
        "mapped",
        [
            958
        ]
    ],
    [
        [
            120560,
            120560
        ],
        "mapped",
        [
            959
        ]
    ],
    [
        [
            120561,
            120561
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120562,
            120562
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120563,
            120563
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120564,
            120564
        ],
        "mapped",
        [
            963
        ]
    ],
    [
        [
            120565,
            120565
        ],
        "mapped",
        [
            964
        ]
    ],
    [
        [
            120566,
            120566
        ],
        "mapped",
        [
            965
        ]
    ],
    [
        [
            120567,
            120567
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120568,
            120568
        ],
        "mapped",
        [
            967
        ]
    ],
    [
        [
            120569,
            120569
        ],
        "mapped",
        [
            968
        ]
    ],
    [
        [
            120570,
            120570
        ],
        "mapped",
        [
            969
        ]
    ],
    [
        [
            120571,
            120571
        ],
        "mapped",
        [
            8711
        ]
    ],
    [
        [
            120572,
            120572
        ],
        "mapped",
        [
            945
        ]
    ],
    [
        [
            120573,
            120573
        ],
        "mapped",
        [
            946
        ]
    ],
    [
        [
            120574,
            120574
        ],
        "mapped",
        [
            947
        ]
    ],
    [
        [
            120575,
            120575
        ],
        "mapped",
        [
            948
        ]
    ],
    [
        [
            120576,
            120576
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120577,
            120577
        ],
        "mapped",
        [
            950
        ]
    ],
    [
        [
            120578,
            120578
        ],
        "mapped",
        [
            951
        ]
    ],
    [
        [
            120579,
            120579
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120580,
            120580
        ],
        "mapped",
        [
            953
        ]
    ],
    [
        [
            120581,
            120581
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120582,
            120582
        ],
        "mapped",
        [
            955
        ]
    ],
    [
        [
            120583,
            120583
        ],
        "mapped",
        [
            956
        ]
    ],
    [
        [
            120584,
            120584
        ],
        "mapped",
        [
            957
        ]
    ],
    [
        [
            120585,
            120585
        ],
        "mapped",
        [
            958
        ]
    ],
    [
        [
            120586,
            120586
        ],
        "mapped",
        [
            959
        ]
    ],
    [
        [
            120587,
            120587
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120588,
            120588
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120589,
            120590
        ],
        "mapped",
        [
            963
        ]
    ],
    [
        [
            120591,
            120591
        ],
        "mapped",
        [
            964
        ]
    ],
    [
        [
            120592,
            120592
        ],
        "mapped",
        [
            965
        ]
    ],
    [
        [
            120593,
            120593
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120594,
            120594
        ],
        "mapped",
        [
            967
        ]
    ],
    [
        [
            120595,
            120595
        ],
        "mapped",
        [
            968
        ]
    ],
    [
        [
            120596,
            120596
        ],
        "mapped",
        [
            969
        ]
    ],
    [
        [
            120597,
            120597
        ],
        "mapped",
        [
            8706
        ]
    ],
    [
        [
            120598,
            120598
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120599,
            120599
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120600,
            120600
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120601,
            120601
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120602,
            120602
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120603,
            120603
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120604,
            120604
        ],
        "mapped",
        [
            945
        ]
    ],
    [
        [
            120605,
            120605
        ],
        "mapped",
        [
            946
        ]
    ],
    [
        [
            120606,
            120606
        ],
        "mapped",
        [
            947
        ]
    ],
    [
        [
            120607,
            120607
        ],
        "mapped",
        [
            948
        ]
    ],
    [
        [
            120608,
            120608
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120609,
            120609
        ],
        "mapped",
        [
            950
        ]
    ],
    [
        [
            120610,
            120610
        ],
        "mapped",
        [
            951
        ]
    ],
    [
        [
            120611,
            120611
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120612,
            120612
        ],
        "mapped",
        [
            953
        ]
    ],
    [
        [
            120613,
            120613
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120614,
            120614
        ],
        "mapped",
        [
            955
        ]
    ],
    [
        [
            120615,
            120615
        ],
        "mapped",
        [
            956
        ]
    ],
    [
        [
            120616,
            120616
        ],
        "mapped",
        [
            957
        ]
    ],
    [
        [
            120617,
            120617
        ],
        "mapped",
        [
            958
        ]
    ],
    [
        [
            120618,
            120618
        ],
        "mapped",
        [
            959
        ]
    ],
    [
        [
            120619,
            120619
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120620,
            120620
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120621,
            120621
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120622,
            120622
        ],
        "mapped",
        [
            963
        ]
    ],
    [
        [
            120623,
            120623
        ],
        "mapped",
        [
            964
        ]
    ],
    [
        [
            120624,
            120624
        ],
        "mapped",
        [
            965
        ]
    ],
    [
        [
            120625,
            120625
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120626,
            120626
        ],
        "mapped",
        [
            967
        ]
    ],
    [
        [
            120627,
            120627
        ],
        "mapped",
        [
            968
        ]
    ],
    [
        [
            120628,
            120628
        ],
        "mapped",
        [
            969
        ]
    ],
    [
        [
            120629,
            120629
        ],
        "mapped",
        [
            8711
        ]
    ],
    [
        [
            120630,
            120630
        ],
        "mapped",
        [
            945
        ]
    ],
    [
        [
            120631,
            120631
        ],
        "mapped",
        [
            946
        ]
    ],
    [
        [
            120632,
            120632
        ],
        "mapped",
        [
            947
        ]
    ],
    [
        [
            120633,
            120633
        ],
        "mapped",
        [
            948
        ]
    ],
    [
        [
            120634,
            120634
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120635,
            120635
        ],
        "mapped",
        [
            950
        ]
    ],
    [
        [
            120636,
            120636
        ],
        "mapped",
        [
            951
        ]
    ],
    [
        [
            120637,
            120637
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120638,
            120638
        ],
        "mapped",
        [
            953
        ]
    ],
    [
        [
            120639,
            120639
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120640,
            120640
        ],
        "mapped",
        [
            955
        ]
    ],
    [
        [
            120641,
            120641
        ],
        "mapped",
        [
            956
        ]
    ],
    [
        [
            120642,
            120642
        ],
        "mapped",
        [
            957
        ]
    ],
    [
        [
            120643,
            120643
        ],
        "mapped",
        [
            958
        ]
    ],
    [
        [
            120644,
            120644
        ],
        "mapped",
        [
            959
        ]
    ],
    [
        [
            120645,
            120645
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120646,
            120646
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120647,
            120648
        ],
        "mapped",
        [
            963
        ]
    ],
    [
        [
            120649,
            120649
        ],
        "mapped",
        [
            964
        ]
    ],
    [
        [
            120650,
            120650
        ],
        "mapped",
        [
            965
        ]
    ],
    [
        [
            120651,
            120651
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120652,
            120652
        ],
        "mapped",
        [
            967
        ]
    ],
    [
        [
            120653,
            120653
        ],
        "mapped",
        [
            968
        ]
    ],
    [
        [
            120654,
            120654
        ],
        "mapped",
        [
            969
        ]
    ],
    [
        [
            120655,
            120655
        ],
        "mapped",
        [
            8706
        ]
    ],
    [
        [
            120656,
            120656
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120657,
            120657
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120658,
            120658
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120659,
            120659
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120660,
            120660
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120661,
            120661
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120662,
            120662
        ],
        "mapped",
        [
            945
        ]
    ],
    [
        [
            120663,
            120663
        ],
        "mapped",
        [
            946
        ]
    ],
    [
        [
            120664,
            120664
        ],
        "mapped",
        [
            947
        ]
    ],
    [
        [
            120665,
            120665
        ],
        "mapped",
        [
            948
        ]
    ],
    [
        [
            120666,
            120666
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120667,
            120667
        ],
        "mapped",
        [
            950
        ]
    ],
    [
        [
            120668,
            120668
        ],
        "mapped",
        [
            951
        ]
    ],
    [
        [
            120669,
            120669
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120670,
            120670
        ],
        "mapped",
        [
            953
        ]
    ],
    [
        [
            120671,
            120671
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120672,
            120672
        ],
        "mapped",
        [
            955
        ]
    ],
    [
        [
            120673,
            120673
        ],
        "mapped",
        [
            956
        ]
    ],
    [
        [
            120674,
            120674
        ],
        "mapped",
        [
            957
        ]
    ],
    [
        [
            120675,
            120675
        ],
        "mapped",
        [
            958
        ]
    ],
    [
        [
            120676,
            120676
        ],
        "mapped",
        [
            959
        ]
    ],
    [
        [
            120677,
            120677
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120678,
            120678
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120679,
            120679
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120680,
            120680
        ],
        "mapped",
        [
            963
        ]
    ],
    [
        [
            120681,
            120681
        ],
        "mapped",
        [
            964
        ]
    ],
    [
        [
            120682,
            120682
        ],
        "mapped",
        [
            965
        ]
    ],
    [
        [
            120683,
            120683
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120684,
            120684
        ],
        "mapped",
        [
            967
        ]
    ],
    [
        [
            120685,
            120685
        ],
        "mapped",
        [
            968
        ]
    ],
    [
        [
            120686,
            120686
        ],
        "mapped",
        [
            969
        ]
    ],
    [
        [
            120687,
            120687
        ],
        "mapped",
        [
            8711
        ]
    ],
    [
        [
            120688,
            120688
        ],
        "mapped",
        [
            945
        ]
    ],
    [
        [
            120689,
            120689
        ],
        "mapped",
        [
            946
        ]
    ],
    [
        [
            120690,
            120690
        ],
        "mapped",
        [
            947
        ]
    ],
    [
        [
            120691,
            120691
        ],
        "mapped",
        [
            948
        ]
    ],
    [
        [
            120692,
            120692
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120693,
            120693
        ],
        "mapped",
        [
            950
        ]
    ],
    [
        [
            120694,
            120694
        ],
        "mapped",
        [
            951
        ]
    ],
    [
        [
            120695,
            120695
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120696,
            120696
        ],
        "mapped",
        [
            953
        ]
    ],
    [
        [
            120697,
            120697
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120698,
            120698
        ],
        "mapped",
        [
            955
        ]
    ],
    [
        [
            120699,
            120699
        ],
        "mapped",
        [
            956
        ]
    ],
    [
        [
            120700,
            120700
        ],
        "mapped",
        [
            957
        ]
    ],
    [
        [
            120701,
            120701
        ],
        "mapped",
        [
            958
        ]
    ],
    [
        [
            120702,
            120702
        ],
        "mapped",
        [
            959
        ]
    ],
    [
        [
            120703,
            120703
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120704,
            120704
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120705,
            120706
        ],
        "mapped",
        [
            963
        ]
    ],
    [
        [
            120707,
            120707
        ],
        "mapped",
        [
            964
        ]
    ],
    [
        [
            120708,
            120708
        ],
        "mapped",
        [
            965
        ]
    ],
    [
        [
            120709,
            120709
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120710,
            120710
        ],
        "mapped",
        [
            967
        ]
    ],
    [
        [
            120711,
            120711
        ],
        "mapped",
        [
            968
        ]
    ],
    [
        [
            120712,
            120712
        ],
        "mapped",
        [
            969
        ]
    ],
    [
        [
            120713,
            120713
        ],
        "mapped",
        [
            8706
        ]
    ],
    [
        [
            120714,
            120714
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120715,
            120715
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120716,
            120716
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120717,
            120717
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120718,
            120718
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120719,
            120719
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120720,
            120720
        ],
        "mapped",
        [
            945
        ]
    ],
    [
        [
            120721,
            120721
        ],
        "mapped",
        [
            946
        ]
    ],
    [
        [
            120722,
            120722
        ],
        "mapped",
        [
            947
        ]
    ],
    [
        [
            120723,
            120723
        ],
        "mapped",
        [
            948
        ]
    ],
    [
        [
            120724,
            120724
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120725,
            120725
        ],
        "mapped",
        [
            950
        ]
    ],
    [
        [
            120726,
            120726
        ],
        "mapped",
        [
            951
        ]
    ],
    [
        [
            120727,
            120727
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120728,
            120728
        ],
        "mapped",
        [
            953
        ]
    ],
    [
        [
            120729,
            120729
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120730,
            120730
        ],
        "mapped",
        [
            955
        ]
    ],
    [
        [
            120731,
            120731
        ],
        "mapped",
        [
            956
        ]
    ],
    [
        [
            120732,
            120732
        ],
        "mapped",
        [
            957
        ]
    ],
    [
        [
            120733,
            120733
        ],
        "mapped",
        [
            958
        ]
    ],
    [
        [
            120734,
            120734
        ],
        "mapped",
        [
            959
        ]
    ],
    [
        [
            120735,
            120735
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120736,
            120736
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120737,
            120737
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120738,
            120738
        ],
        "mapped",
        [
            963
        ]
    ],
    [
        [
            120739,
            120739
        ],
        "mapped",
        [
            964
        ]
    ],
    [
        [
            120740,
            120740
        ],
        "mapped",
        [
            965
        ]
    ],
    [
        [
            120741,
            120741
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120742,
            120742
        ],
        "mapped",
        [
            967
        ]
    ],
    [
        [
            120743,
            120743
        ],
        "mapped",
        [
            968
        ]
    ],
    [
        [
            120744,
            120744
        ],
        "mapped",
        [
            969
        ]
    ],
    [
        [
            120745,
            120745
        ],
        "mapped",
        [
            8711
        ]
    ],
    [
        [
            120746,
            120746
        ],
        "mapped",
        [
            945
        ]
    ],
    [
        [
            120747,
            120747
        ],
        "mapped",
        [
            946
        ]
    ],
    [
        [
            120748,
            120748
        ],
        "mapped",
        [
            947
        ]
    ],
    [
        [
            120749,
            120749
        ],
        "mapped",
        [
            948
        ]
    ],
    [
        [
            120750,
            120750
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120751,
            120751
        ],
        "mapped",
        [
            950
        ]
    ],
    [
        [
            120752,
            120752
        ],
        "mapped",
        [
            951
        ]
    ],
    [
        [
            120753,
            120753
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120754,
            120754
        ],
        "mapped",
        [
            953
        ]
    ],
    [
        [
            120755,
            120755
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120756,
            120756
        ],
        "mapped",
        [
            955
        ]
    ],
    [
        [
            120757,
            120757
        ],
        "mapped",
        [
            956
        ]
    ],
    [
        [
            120758,
            120758
        ],
        "mapped",
        [
            957
        ]
    ],
    [
        [
            120759,
            120759
        ],
        "mapped",
        [
            958
        ]
    ],
    [
        [
            120760,
            120760
        ],
        "mapped",
        [
            959
        ]
    ],
    [
        [
            120761,
            120761
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120762,
            120762
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120763,
            120764
        ],
        "mapped",
        [
            963
        ]
    ],
    [
        [
            120765,
            120765
        ],
        "mapped",
        [
            964
        ]
    ],
    [
        [
            120766,
            120766
        ],
        "mapped",
        [
            965
        ]
    ],
    [
        [
            120767,
            120767
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120768,
            120768
        ],
        "mapped",
        [
            967
        ]
    ],
    [
        [
            120769,
            120769
        ],
        "mapped",
        [
            968
        ]
    ],
    [
        [
            120770,
            120770
        ],
        "mapped",
        [
            969
        ]
    ],
    [
        [
            120771,
            120771
        ],
        "mapped",
        [
            8706
        ]
    ],
    [
        [
            120772,
            120772
        ],
        "mapped",
        [
            949
        ]
    ],
    [
        [
            120773,
            120773
        ],
        "mapped",
        [
            952
        ]
    ],
    [
        [
            120774,
            120774
        ],
        "mapped",
        [
            954
        ]
    ],
    [
        [
            120775,
            120775
        ],
        "mapped",
        [
            966
        ]
    ],
    [
        [
            120776,
            120776
        ],
        "mapped",
        [
            961
        ]
    ],
    [
        [
            120777,
            120777
        ],
        "mapped",
        [
            960
        ]
    ],
    [
        [
            120778,
            120779
        ],
        "mapped",
        [
            989
        ]
    ],
    [
        [
            120780,
            120781
        ],
        "disallowed"
    ],
    [
        [
            120782,
            120782
        ],
        "mapped",
        [
            48
        ]
    ],
    [
        [
            120783,
            120783
        ],
        "mapped",
        [
            49
        ]
    ],
    [
        [
            120784,
            120784
        ],
        "mapped",
        [
            50
        ]
    ],
    [
        [
            120785,
            120785
        ],
        "mapped",
        [
            51
        ]
    ],
    [
        [
            120786,
            120786
        ],
        "mapped",
        [
            52
        ]
    ],
    [
        [
            120787,
            120787
        ],
        "mapped",
        [
            53
        ]
    ],
    [
        [
            120788,
            120788
        ],
        "mapped",
        [
            54
        ]
    ],
    [
        [
            120789,
            120789
        ],
        "mapped",
        [
            55
        ]
    ],
    [
        [
            120790,
            120790
        ],
        "mapped",
        [
            56
        ]
    ],
    [
        [
            120791,
            120791
        ],
        "mapped",
        [
            57
        ]
    ],
    [
        [
            120792,
            120792
        ],
        "mapped",
        [
            48
        ]
    ],
    [
        [
            120793,
            120793
        ],
        "mapped",
        [
            49
        ]
    ],
    [
        [
            120794,
            120794
        ],
        "mapped",
        [
            50
        ]
    ],
    [
        [
            120795,
            120795
        ],
        "mapped",
        [
            51
        ]
    ],
    [
        [
            120796,
            120796
        ],
        "mapped",
        [
            52
        ]
    ],
    [
        [
            120797,
            120797
        ],
        "mapped",
        [
            53
        ]
    ],
    [
        [
            120798,
            120798
        ],
        "mapped",
        [
            54
        ]
    ],
    [
        [
            120799,
            120799
        ],
        "mapped",
        [
            55
        ]
    ],
    [
        [
            120800,
            120800
        ],
        "mapped",
        [
            56
        ]
    ],
    [
        [
            120801,
            120801
        ],
        "mapped",
        [
            57
        ]
    ],
    [
        [
            120802,
            120802
        ],
        "mapped",
        [
            48
        ]
    ],
    [
        [
            120803,
            120803
        ],
        "mapped",
        [
            49
        ]
    ],
    [
        [
            120804,
            120804
        ],
        "mapped",
        [
            50
        ]
    ],
    [
        [
            120805,
            120805
        ],
        "mapped",
        [
            51
        ]
    ],
    [
        [
            120806,
            120806
        ],
        "mapped",
        [
            52
        ]
    ],
    [
        [
            120807,
            120807
        ],
        "mapped",
        [
            53
        ]
    ],
    [
        [
            120808,
            120808
        ],
        "mapped",
        [
            54
        ]
    ],
    [
        [
            120809,
            120809
        ],
        "mapped",
        [
            55
        ]
    ],
    [
        [
            120810,
            120810
        ],
        "mapped",
        [
            56
        ]
    ],
    [
        [
            120811,
            120811
        ],
        "mapped",
        [
            57
        ]
    ],
    [
        [
            120812,
            120812
        ],
        "mapped",
        [
            48
        ]
    ],
    [
        [
            120813,
            120813
        ],
        "mapped",
        [
            49
        ]
    ],
    [
        [
            120814,
            120814
        ],
        "mapped",
        [
            50
        ]
    ],
    [
        [
            120815,
            120815
        ],
        "mapped",
        [
            51
        ]
    ],
    [
        [
            120816,
            120816
        ],
        "mapped",
        [
            52
        ]
    ],
    [
        [
            120817,
            120817
        ],
        "mapped",
        [
            53
        ]
    ],
    [
        [
            120818,
            120818
        ],
        "mapped",
        [
            54
        ]
    ],
    [
        [
            120819,
            120819
        ],
        "mapped",
        [
            55
        ]
    ],
    [
        [
            120820,
            120820
        ],
        "mapped",
        [
            56
        ]
    ],
    [
        [
            120821,
            120821
        ],
        "mapped",
        [
            57
        ]
    ],
    [
        [
            120822,
            120822
        ],
        "mapped",
        [
            48
        ]
    ],
    [
        [
            120823,
            120823
        ],
        "mapped",
        [
            49
        ]
    ],
    [
        [
            120824,
            120824
        ],
        "mapped",
        [
            50
        ]
    ],
    [
        [
            120825,
            120825
        ],
        "mapped",
        [
            51
        ]
    ],
    [
        [
            120826,
            120826
        ],
        "mapped",
        [
            52
        ]
    ],
    [
        [
            120827,
            120827
        ],
        "mapped",
        [
            53
        ]
    ],
    [
        [
            120828,
            120828
        ],
        "mapped",
        [
            54
        ]
    ],
    [
        [
            120829,
            120829
        ],
        "mapped",
        [
            55
        ]
    ],
    [
        [
            120830,
            120830
        ],
        "mapped",
        [
            56
        ]
    ],
    [
        [
            120831,
            120831
        ],
        "mapped",
        [
            57
        ]
    ],
    [
        [
            120832,
            121343
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            121344,
            121398
        ],
        "valid"
    ],
    [
        [
            121399,
            121402
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            121403,
            121452
        ],
        "valid"
    ],
    [
        [
            121453,
            121460
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            121461,
            121461
        ],
        "valid"
    ],
    [
        [
            121462,
            121475
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            121476,
            121476
        ],
        "valid"
    ],
    [
        [
            121477,
            121483
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            121484,
            121498
        ],
        "disallowed"
    ],
    [
        [
            121499,
            121503
        ],
        "valid"
    ],
    [
        [
            121504,
            121504
        ],
        "disallowed"
    ],
    [
        [
            121505,
            121519
        ],
        "valid"
    ],
    [
        [
            121520,
            124927
        ],
        "disallowed"
    ],
    [
        [
            124928,
            125124
        ],
        "valid"
    ],
    [
        [
            125125,
            125126
        ],
        "disallowed"
    ],
    [
        [
            125127,
            125135
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            125136,
            125142
        ],
        "valid"
    ],
    [
        [
            125143,
            126463
        ],
        "disallowed"
    ],
    [
        [
            126464,
            126464
        ],
        "mapped",
        [
            1575
        ]
    ],
    [
        [
            126465,
            126465
        ],
        "mapped",
        [
            1576
        ]
    ],
    [
        [
            126466,
            126466
        ],
        "mapped",
        [
            1580
        ]
    ],
    [
        [
            126467,
            126467
        ],
        "mapped",
        [
            1583
        ]
    ],
    [
        [
            126468,
            126468
        ],
        "disallowed"
    ],
    [
        [
            126469,
            126469
        ],
        "mapped",
        [
            1608
        ]
    ],
    [
        [
            126470,
            126470
        ],
        "mapped",
        [
            1586
        ]
    ],
    [
        [
            126471,
            126471
        ],
        "mapped",
        [
            1581
        ]
    ],
    [
        [
            126472,
            126472
        ],
        "mapped",
        [
            1591
        ]
    ],
    [
        [
            126473,
            126473
        ],
        "mapped",
        [
            1610
        ]
    ],
    [
        [
            126474,
            126474
        ],
        "mapped",
        [
            1603
        ]
    ],
    [
        [
            126475,
            126475
        ],
        "mapped",
        [
            1604
        ]
    ],
    [
        [
            126476,
            126476
        ],
        "mapped",
        [
            1605
        ]
    ],
    [
        [
            126477,
            126477
        ],
        "mapped",
        [
            1606
        ]
    ],
    [
        [
            126478,
            126478
        ],
        "mapped",
        [
            1587
        ]
    ],
    [
        [
            126479,
            126479
        ],
        "mapped",
        [
            1593
        ]
    ],
    [
        [
            126480,
            126480
        ],
        "mapped",
        [
            1601
        ]
    ],
    [
        [
            126481,
            126481
        ],
        "mapped",
        [
            1589
        ]
    ],
    [
        [
            126482,
            126482
        ],
        "mapped",
        [
            1602
        ]
    ],
    [
        [
            126483,
            126483
        ],
        "mapped",
        [
            1585
        ]
    ],
    [
        [
            126484,
            126484
        ],
        "mapped",
        [
            1588
        ]
    ],
    [
        [
            126485,
            126485
        ],
        "mapped",
        [
            1578
        ]
    ],
    [
        [
            126486,
            126486
        ],
        "mapped",
        [
            1579
        ]
    ],
    [
        [
            126487,
            126487
        ],
        "mapped",
        [
            1582
        ]
    ],
    [
        [
            126488,
            126488
        ],
        "mapped",
        [
            1584
        ]
    ],
    [
        [
            126489,
            126489
        ],
        "mapped",
        [
            1590
        ]
    ],
    [
        [
            126490,
            126490
        ],
        "mapped",
        [
            1592
        ]
    ],
    [
        [
            126491,
            126491
        ],
        "mapped",
        [
            1594
        ]
    ],
    [
        [
            126492,
            126492
        ],
        "mapped",
        [
            1646
        ]
    ],
    [
        [
            126493,
            126493
        ],
        "mapped",
        [
            1722
        ]
    ],
    [
        [
            126494,
            126494
        ],
        "mapped",
        [
            1697
        ]
    ],
    [
        [
            126495,
            126495
        ],
        "mapped",
        [
            1647
        ]
    ],
    [
        [
            126496,
            126496
        ],
        "disallowed"
    ],
    [
        [
            126497,
            126497
        ],
        "mapped",
        [
            1576
        ]
    ],
    [
        [
            126498,
            126498
        ],
        "mapped",
        [
            1580
        ]
    ],
    [
        [
            126499,
            126499
        ],
        "disallowed"
    ],
    [
        [
            126500,
            126500
        ],
        "mapped",
        [
            1607
        ]
    ],
    [
        [
            126501,
            126502
        ],
        "disallowed"
    ],
    [
        [
            126503,
            126503
        ],
        "mapped",
        [
            1581
        ]
    ],
    [
        [
            126504,
            126504
        ],
        "disallowed"
    ],
    [
        [
            126505,
            126505
        ],
        "mapped",
        [
            1610
        ]
    ],
    [
        [
            126506,
            126506
        ],
        "mapped",
        [
            1603
        ]
    ],
    [
        [
            126507,
            126507
        ],
        "mapped",
        [
            1604
        ]
    ],
    [
        [
            126508,
            126508
        ],
        "mapped",
        [
            1605
        ]
    ],
    [
        [
            126509,
            126509
        ],
        "mapped",
        [
            1606
        ]
    ],
    [
        [
            126510,
            126510
        ],
        "mapped",
        [
            1587
        ]
    ],
    [
        [
            126511,
            126511
        ],
        "mapped",
        [
            1593
        ]
    ],
    [
        [
            126512,
            126512
        ],
        "mapped",
        [
            1601
        ]
    ],
    [
        [
            126513,
            126513
        ],
        "mapped",
        [
            1589
        ]
    ],
    [
        [
            126514,
            126514
        ],
        "mapped",
        [
            1602
        ]
    ],
    [
        [
            126515,
            126515
        ],
        "disallowed"
    ],
    [
        [
            126516,
            126516
        ],
        "mapped",
        [
            1588
        ]
    ],
    [
        [
            126517,
            126517
        ],
        "mapped",
        [
            1578
        ]
    ],
    [
        [
            126518,
            126518
        ],
        "mapped",
        [
            1579
        ]
    ],
    [
        [
            126519,
            126519
        ],
        "mapped",
        [
            1582
        ]
    ],
    [
        [
            126520,
            126520
        ],
        "disallowed"
    ],
    [
        [
            126521,
            126521
        ],
        "mapped",
        [
            1590
        ]
    ],
    [
        [
            126522,
            126522
        ],
        "disallowed"
    ],
    [
        [
            126523,
            126523
        ],
        "mapped",
        [
            1594
        ]
    ],
    [
        [
            126524,
            126529
        ],
        "disallowed"
    ],
    [
        [
            126530,
            126530
        ],
        "mapped",
        [
            1580
        ]
    ],
    [
        [
            126531,
            126534
        ],
        "disallowed"
    ],
    [
        [
            126535,
            126535
        ],
        "mapped",
        [
            1581
        ]
    ],
    [
        [
            126536,
            126536
        ],
        "disallowed"
    ],
    [
        [
            126537,
            126537
        ],
        "mapped",
        [
            1610
        ]
    ],
    [
        [
            126538,
            126538
        ],
        "disallowed"
    ],
    [
        [
            126539,
            126539
        ],
        "mapped",
        [
            1604
        ]
    ],
    [
        [
            126540,
            126540
        ],
        "disallowed"
    ],
    [
        [
            126541,
            126541
        ],
        "mapped",
        [
            1606
        ]
    ],
    [
        [
            126542,
            126542
        ],
        "mapped",
        [
            1587
        ]
    ],
    [
        [
            126543,
            126543
        ],
        "mapped",
        [
            1593
        ]
    ],
    [
        [
            126544,
            126544
        ],
        "disallowed"
    ],
    [
        [
            126545,
            126545
        ],
        "mapped",
        [
            1589
        ]
    ],
    [
        [
            126546,
            126546
        ],
        "mapped",
        [
            1602
        ]
    ],
    [
        [
            126547,
            126547
        ],
        "disallowed"
    ],
    [
        [
            126548,
            126548
        ],
        "mapped",
        [
            1588
        ]
    ],
    [
        [
            126549,
            126550
        ],
        "disallowed"
    ],
    [
        [
            126551,
            126551
        ],
        "mapped",
        [
            1582
        ]
    ],
    [
        [
            126552,
            126552
        ],
        "disallowed"
    ],
    [
        [
            126553,
            126553
        ],
        "mapped",
        [
            1590
        ]
    ],
    [
        [
            126554,
            126554
        ],
        "disallowed"
    ],
    [
        [
            126555,
            126555
        ],
        "mapped",
        [
            1594
        ]
    ],
    [
        [
            126556,
            126556
        ],
        "disallowed"
    ],
    [
        [
            126557,
            126557
        ],
        "mapped",
        [
            1722
        ]
    ],
    [
        [
            126558,
            126558
        ],
        "disallowed"
    ],
    [
        [
            126559,
            126559
        ],
        "mapped",
        [
            1647
        ]
    ],
    [
        [
            126560,
            126560
        ],
        "disallowed"
    ],
    [
        [
            126561,
            126561
        ],
        "mapped",
        [
            1576
        ]
    ],
    [
        [
            126562,
            126562
        ],
        "mapped",
        [
            1580
        ]
    ],
    [
        [
            126563,
            126563
        ],
        "disallowed"
    ],
    [
        [
            126564,
            126564
        ],
        "mapped",
        [
            1607
        ]
    ],
    [
        [
            126565,
            126566
        ],
        "disallowed"
    ],
    [
        [
            126567,
            126567
        ],
        "mapped",
        [
            1581
        ]
    ],
    [
        [
            126568,
            126568
        ],
        "mapped",
        [
            1591
        ]
    ],
    [
        [
            126569,
            126569
        ],
        "mapped",
        [
            1610
        ]
    ],
    [
        [
            126570,
            126570
        ],
        "mapped",
        [
            1603
        ]
    ],
    [
        [
            126571,
            126571
        ],
        "disallowed"
    ],
    [
        [
            126572,
            126572
        ],
        "mapped",
        [
            1605
        ]
    ],
    [
        [
            126573,
            126573
        ],
        "mapped",
        [
            1606
        ]
    ],
    [
        [
            126574,
            126574
        ],
        "mapped",
        [
            1587
        ]
    ],
    [
        [
            126575,
            126575
        ],
        "mapped",
        [
            1593
        ]
    ],
    [
        [
            126576,
            126576
        ],
        "mapped",
        [
            1601
        ]
    ],
    [
        [
            126577,
            126577
        ],
        "mapped",
        [
            1589
        ]
    ],
    [
        [
            126578,
            126578
        ],
        "mapped",
        [
            1602
        ]
    ],
    [
        [
            126579,
            126579
        ],
        "disallowed"
    ],
    [
        [
            126580,
            126580
        ],
        "mapped",
        [
            1588
        ]
    ],
    [
        [
            126581,
            126581
        ],
        "mapped",
        [
            1578
        ]
    ],
    [
        [
            126582,
            126582
        ],
        "mapped",
        [
            1579
        ]
    ],
    [
        [
            126583,
            126583
        ],
        "mapped",
        [
            1582
        ]
    ],
    [
        [
            126584,
            126584
        ],
        "disallowed"
    ],
    [
        [
            126585,
            126585
        ],
        "mapped",
        [
            1590
        ]
    ],
    [
        [
            126586,
            126586
        ],
        "mapped",
        [
            1592
        ]
    ],
    [
        [
            126587,
            126587
        ],
        "mapped",
        [
            1594
        ]
    ],
    [
        [
            126588,
            126588
        ],
        "mapped",
        [
            1646
        ]
    ],
    [
        [
            126589,
            126589
        ],
        "disallowed"
    ],
    [
        [
            126590,
            126590
        ],
        "mapped",
        [
            1697
        ]
    ],
    [
        [
            126591,
            126591
        ],
        "disallowed"
    ],
    [
        [
            126592,
            126592
        ],
        "mapped",
        [
            1575
        ]
    ],
    [
        [
            126593,
            126593
        ],
        "mapped",
        [
            1576
        ]
    ],
    [
        [
            126594,
            126594
        ],
        "mapped",
        [
            1580
        ]
    ],
    [
        [
            126595,
            126595
        ],
        "mapped",
        [
            1583
        ]
    ],
    [
        [
            126596,
            126596
        ],
        "mapped",
        [
            1607
        ]
    ],
    [
        [
            126597,
            126597
        ],
        "mapped",
        [
            1608
        ]
    ],
    [
        [
            126598,
            126598
        ],
        "mapped",
        [
            1586
        ]
    ],
    [
        [
            126599,
            126599
        ],
        "mapped",
        [
            1581
        ]
    ],
    [
        [
            126600,
            126600
        ],
        "mapped",
        [
            1591
        ]
    ],
    [
        [
            126601,
            126601
        ],
        "mapped",
        [
            1610
        ]
    ],
    [
        [
            126602,
            126602
        ],
        "disallowed"
    ],
    [
        [
            126603,
            126603
        ],
        "mapped",
        [
            1604
        ]
    ],
    [
        [
            126604,
            126604
        ],
        "mapped",
        [
            1605
        ]
    ],
    [
        [
            126605,
            126605
        ],
        "mapped",
        [
            1606
        ]
    ],
    [
        [
            126606,
            126606
        ],
        "mapped",
        [
            1587
        ]
    ],
    [
        [
            126607,
            126607
        ],
        "mapped",
        [
            1593
        ]
    ],
    [
        [
            126608,
            126608
        ],
        "mapped",
        [
            1601
        ]
    ],
    [
        [
            126609,
            126609
        ],
        "mapped",
        [
            1589
        ]
    ],
    [
        [
            126610,
            126610
        ],
        "mapped",
        [
            1602
        ]
    ],
    [
        [
            126611,
            126611
        ],
        "mapped",
        [
            1585
        ]
    ],
    [
        [
            126612,
            126612
        ],
        "mapped",
        [
            1588
        ]
    ],
    [
        [
            126613,
            126613
        ],
        "mapped",
        [
            1578
        ]
    ],
    [
        [
            126614,
            126614
        ],
        "mapped",
        [
            1579
        ]
    ],
    [
        [
            126615,
            126615
        ],
        "mapped",
        [
            1582
        ]
    ],
    [
        [
            126616,
            126616
        ],
        "mapped",
        [
            1584
        ]
    ],
    [
        [
            126617,
            126617
        ],
        "mapped",
        [
            1590
        ]
    ],
    [
        [
            126618,
            126618
        ],
        "mapped",
        [
            1592
        ]
    ],
    [
        [
            126619,
            126619
        ],
        "mapped",
        [
            1594
        ]
    ],
    [
        [
            126620,
            126624
        ],
        "disallowed"
    ],
    [
        [
            126625,
            126625
        ],
        "mapped",
        [
            1576
        ]
    ],
    [
        [
            126626,
            126626
        ],
        "mapped",
        [
            1580
        ]
    ],
    [
        [
            126627,
            126627
        ],
        "mapped",
        [
            1583
        ]
    ],
    [
        [
            126628,
            126628
        ],
        "disallowed"
    ],
    [
        [
            126629,
            126629
        ],
        "mapped",
        [
            1608
        ]
    ],
    [
        [
            126630,
            126630
        ],
        "mapped",
        [
            1586
        ]
    ],
    [
        [
            126631,
            126631
        ],
        "mapped",
        [
            1581
        ]
    ],
    [
        [
            126632,
            126632
        ],
        "mapped",
        [
            1591
        ]
    ],
    [
        [
            126633,
            126633
        ],
        "mapped",
        [
            1610
        ]
    ],
    [
        [
            126634,
            126634
        ],
        "disallowed"
    ],
    [
        [
            126635,
            126635
        ],
        "mapped",
        [
            1604
        ]
    ],
    [
        [
            126636,
            126636
        ],
        "mapped",
        [
            1605
        ]
    ],
    [
        [
            126637,
            126637
        ],
        "mapped",
        [
            1606
        ]
    ],
    [
        [
            126638,
            126638
        ],
        "mapped",
        [
            1587
        ]
    ],
    [
        [
            126639,
            126639
        ],
        "mapped",
        [
            1593
        ]
    ],
    [
        [
            126640,
            126640
        ],
        "mapped",
        [
            1601
        ]
    ],
    [
        [
            126641,
            126641
        ],
        "mapped",
        [
            1589
        ]
    ],
    [
        [
            126642,
            126642
        ],
        "mapped",
        [
            1602
        ]
    ],
    [
        [
            126643,
            126643
        ],
        "mapped",
        [
            1585
        ]
    ],
    [
        [
            126644,
            126644
        ],
        "mapped",
        [
            1588
        ]
    ],
    [
        [
            126645,
            126645
        ],
        "mapped",
        [
            1578
        ]
    ],
    [
        [
            126646,
            126646
        ],
        "mapped",
        [
            1579
        ]
    ],
    [
        [
            126647,
            126647
        ],
        "mapped",
        [
            1582
        ]
    ],
    [
        [
            126648,
            126648
        ],
        "mapped",
        [
            1584
        ]
    ],
    [
        [
            126649,
            126649
        ],
        "mapped",
        [
            1590
        ]
    ],
    [
        [
            126650,
            126650
        ],
        "mapped",
        [
            1592
        ]
    ],
    [
        [
            126651,
            126651
        ],
        "mapped",
        [
            1594
        ]
    ],
    [
        [
            126652,
            126703
        ],
        "disallowed"
    ],
    [
        [
            126704,
            126705
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            126706,
            126975
        ],
        "disallowed"
    ],
    [
        [
            126976,
            127019
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127020,
            127023
        ],
        "disallowed"
    ],
    [
        [
            127024,
            127123
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127124,
            127135
        ],
        "disallowed"
    ],
    [
        [
            127136,
            127150
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127151,
            127152
        ],
        "disallowed"
    ],
    [
        [
            127153,
            127166
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127167,
            127167
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127168,
            127168
        ],
        "disallowed"
    ],
    [
        [
            127169,
            127183
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127184,
            127184
        ],
        "disallowed"
    ],
    [
        [
            127185,
            127199
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127200,
            127221
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127222,
            127231
        ],
        "disallowed"
    ],
    [
        [
            127232,
            127232
        ],
        "disallowed"
    ],
    [
        [
            127233,
            127233
        ],
        "disallowed_STD3_mapped",
        [
            48,
            44
        ]
    ],
    [
        [
            127234,
            127234
        ],
        "disallowed_STD3_mapped",
        [
            49,
            44
        ]
    ],
    [
        [
            127235,
            127235
        ],
        "disallowed_STD3_mapped",
        [
            50,
            44
        ]
    ],
    [
        [
            127236,
            127236
        ],
        "disallowed_STD3_mapped",
        [
            51,
            44
        ]
    ],
    [
        [
            127237,
            127237
        ],
        "disallowed_STD3_mapped",
        [
            52,
            44
        ]
    ],
    [
        [
            127238,
            127238
        ],
        "disallowed_STD3_mapped",
        [
            53,
            44
        ]
    ],
    [
        [
            127239,
            127239
        ],
        "disallowed_STD3_mapped",
        [
            54,
            44
        ]
    ],
    [
        [
            127240,
            127240
        ],
        "disallowed_STD3_mapped",
        [
            55,
            44
        ]
    ],
    [
        [
            127241,
            127241
        ],
        "disallowed_STD3_mapped",
        [
            56,
            44
        ]
    ],
    [
        [
            127242,
            127242
        ],
        "disallowed_STD3_mapped",
        [
            57,
            44
        ]
    ],
    [
        [
            127243,
            127244
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127245,
            127247
        ],
        "disallowed"
    ],
    [
        [
            127248,
            127248
        ],
        "disallowed_STD3_mapped",
        [
            40,
            97,
            41
        ]
    ],
    [
        [
            127249,
            127249
        ],
        "disallowed_STD3_mapped",
        [
            40,
            98,
            41
        ]
    ],
    [
        [
            127250,
            127250
        ],
        "disallowed_STD3_mapped",
        [
            40,
            99,
            41
        ]
    ],
    [
        [
            127251,
            127251
        ],
        "disallowed_STD3_mapped",
        [
            40,
            100,
            41
        ]
    ],
    [
        [
            127252,
            127252
        ],
        "disallowed_STD3_mapped",
        [
            40,
            101,
            41
        ]
    ],
    [
        [
            127253,
            127253
        ],
        "disallowed_STD3_mapped",
        [
            40,
            102,
            41
        ]
    ],
    [
        [
            127254,
            127254
        ],
        "disallowed_STD3_mapped",
        [
            40,
            103,
            41
        ]
    ],
    [
        [
            127255,
            127255
        ],
        "disallowed_STD3_mapped",
        [
            40,
            104,
            41
        ]
    ],
    [
        [
            127256,
            127256
        ],
        "disallowed_STD3_mapped",
        [
            40,
            105,
            41
        ]
    ],
    [
        [
            127257,
            127257
        ],
        "disallowed_STD3_mapped",
        [
            40,
            106,
            41
        ]
    ],
    [
        [
            127258,
            127258
        ],
        "disallowed_STD3_mapped",
        [
            40,
            107,
            41
        ]
    ],
    [
        [
            127259,
            127259
        ],
        "disallowed_STD3_mapped",
        [
            40,
            108,
            41
        ]
    ],
    [
        [
            127260,
            127260
        ],
        "disallowed_STD3_mapped",
        [
            40,
            109,
            41
        ]
    ],
    [
        [
            127261,
            127261
        ],
        "disallowed_STD3_mapped",
        [
            40,
            110,
            41
        ]
    ],
    [
        [
            127262,
            127262
        ],
        "disallowed_STD3_mapped",
        [
            40,
            111,
            41
        ]
    ],
    [
        [
            127263,
            127263
        ],
        "disallowed_STD3_mapped",
        [
            40,
            112,
            41
        ]
    ],
    [
        [
            127264,
            127264
        ],
        "disallowed_STD3_mapped",
        [
            40,
            113,
            41
        ]
    ],
    [
        [
            127265,
            127265
        ],
        "disallowed_STD3_mapped",
        [
            40,
            114,
            41
        ]
    ],
    [
        [
            127266,
            127266
        ],
        "disallowed_STD3_mapped",
        [
            40,
            115,
            41
        ]
    ],
    [
        [
            127267,
            127267
        ],
        "disallowed_STD3_mapped",
        [
            40,
            116,
            41
        ]
    ],
    [
        [
            127268,
            127268
        ],
        "disallowed_STD3_mapped",
        [
            40,
            117,
            41
        ]
    ],
    [
        [
            127269,
            127269
        ],
        "disallowed_STD3_mapped",
        [
            40,
            118,
            41
        ]
    ],
    [
        [
            127270,
            127270
        ],
        "disallowed_STD3_mapped",
        [
            40,
            119,
            41
        ]
    ],
    [
        [
            127271,
            127271
        ],
        "disallowed_STD3_mapped",
        [
            40,
            120,
            41
        ]
    ],
    [
        [
            127272,
            127272
        ],
        "disallowed_STD3_mapped",
        [
            40,
            121,
            41
        ]
    ],
    [
        [
            127273,
            127273
        ],
        "disallowed_STD3_mapped",
        [
            40,
            122,
            41
        ]
    ],
    [
        [
            127274,
            127274
        ],
        "mapped",
        [
            12308,
            115,
            12309
        ]
    ],
    [
        [
            127275,
            127275
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            127276,
            127276
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            127277,
            127277
        ],
        "mapped",
        [
            99,
            100
        ]
    ],
    [
        [
            127278,
            127278
        ],
        "mapped",
        [
            119,
            122
        ]
    ],
    [
        [
            127279,
            127279
        ],
        "disallowed"
    ],
    [
        [
            127280,
            127280
        ],
        "mapped",
        [
            97
        ]
    ],
    [
        [
            127281,
            127281
        ],
        "mapped",
        [
            98
        ]
    ],
    [
        [
            127282,
            127282
        ],
        "mapped",
        [
            99
        ]
    ],
    [
        [
            127283,
            127283
        ],
        "mapped",
        [
            100
        ]
    ],
    [
        [
            127284,
            127284
        ],
        "mapped",
        [
            101
        ]
    ],
    [
        [
            127285,
            127285
        ],
        "mapped",
        [
            102
        ]
    ],
    [
        [
            127286,
            127286
        ],
        "mapped",
        [
            103
        ]
    ],
    [
        [
            127287,
            127287
        ],
        "mapped",
        [
            104
        ]
    ],
    [
        [
            127288,
            127288
        ],
        "mapped",
        [
            105
        ]
    ],
    [
        [
            127289,
            127289
        ],
        "mapped",
        [
            106
        ]
    ],
    [
        [
            127290,
            127290
        ],
        "mapped",
        [
            107
        ]
    ],
    [
        [
            127291,
            127291
        ],
        "mapped",
        [
            108
        ]
    ],
    [
        [
            127292,
            127292
        ],
        "mapped",
        [
            109
        ]
    ],
    [
        [
            127293,
            127293
        ],
        "mapped",
        [
            110
        ]
    ],
    [
        [
            127294,
            127294
        ],
        "mapped",
        [
            111
        ]
    ],
    [
        [
            127295,
            127295
        ],
        "mapped",
        [
            112
        ]
    ],
    [
        [
            127296,
            127296
        ],
        "mapped",
        [
            113
        ]
    ],
    [
        [
            127297,
            127297
        ],
        "mapped",
        [
            114
        ]
    ],
    [
        [
            127298,
            127298
        ],
        "mapped",
        [
            115
        ]
    ],
    [
        [
            127299,
            127299
        ],
        "mapped",
        [
            116
        ]
    ],
    [
        [
            127300,
            127300
        ],
        "mapped",
        [
            117
        ]
    ],
    [
        [
            127301,
            127301
        ],
        "mapped",
        [
            118
        ]
    ],
    [
        [
            127302,
            127302
        ],
        "mapped",
        [
            119
        ]
    ],
    [
        [
            127303,
            127303
        ],
        "mapped",
        [
            120
        ]
    ],
    [
        [
            127304,
            127304
        ],
        "mapped",
        [
            121
        ]
    ],
    [
        [
            127305,
            127305
        ],
        "mapped",
        [
            122
        ]
    ],
    [
        [
            127306,
            127306
        ],
        "mapped",
        [
            104,
            118
        ]
    ],
    [
        [
            127307,
            127307
        ],
        "mapped",
        [
            109,
            118
        ]
    ],
    [
        [
            127308,
            127308
        ],
        "mapped",
        [
            115,
            100
        ]
    ],
    [
        [
            127309,
            127309
        ],
        "mapped",
        [
            115,
            115
        ]
    ],
    [
        [
            127310,
            127310
        ],
        "mapped",
        [
            112,
            112,
            118
        ]
    ],
    [
        [
            127311,
            127311
        ],
        "mapped",
        [
            119,
            99
        ]
    ],
    [
        [
            127312,
            127318
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127319,
            127319
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127320,
            127326
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127327,
            127327
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127328,
            127337
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127338,
            127338
        ],
        "mapped",
        [
            109,
            99
        ]
    ],
    [
        [
            127339,
            127339
        ],
        "mapped",
        [
            109,
            100
        ]
    ],
    [
        [
            127340,
            127343
        ],
        "disallowed"
    ],
    [
        [
            127344,
            127352
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127353,
            127353
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127354,
            127354
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127355,
            127356
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127357,
            127358
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127359,
            127359
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127360,
            127369
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127370,
            127373
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127374,
            127375
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127376,
            127376
        ],
        "mapped",
        [
            100,
            106
        ]
    ],
    [
        [
            127377,
            127386
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127387,
            127461
        ],
        "disallowed"
    ],
    [
        [
            127462,
            127487
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127488,
            127488
        ],
        "mapped",
        [
            12411,
            12363
        ]
    ],
    [
        [
            127489,
            127489
        ],
        "mapped",
        [
            12467,
            12467
        ]
    ],
    [
        [
            127490,
            127490
        ],
        "mapped",
        [
            12469
        ]
    ],
    [
        [
            127491,
            127503
        ],
        "disallowed"
    ],
    [
        [
            127504,
            127504
        ],
        "mapped",
        [
            25163
        ]
    ],
    [
        [
            127505,
            127505
        ],
        "mapped",
        [
            23383
        ]
    ],
    [
        [
            127506,
            127506
        ],
        "mapped",
        [
            21452
        ]
    ],
    [
        [
            127507,
            127507
        ],
        "mapped",
        [
            12487
        ]
    ],
    [
        [
            127508,
            127508
        ],
        "mapped",
        [
            20108
        ]
    ],
    [
        [
            127509,
            127509
        ],
        "mapped",
        [
            22810
        ]
    ],
    [
        [
            127510,
            127510
        ],
        "mapped",
        [
            35299
        ]
    ],
    [
        [
            127511,
            127511
        ],
        "mapped",
        [
            22825
        ]
    ],
    [
        [
            127512,
            127512
        ],
        "mapped",
        [
            20132
        ]
    ],
    [
        [
            127513,
            127513
        ],
        "mapped",
        [
            26144
        ]
    ],
    [
        [
            127514,
            127514
        ],
        "mapped",
        [
            28961
        ]
    ],
    [
        [
            127515,
            127515
        ],
        "mapped",
        [
            26009
        ]
    ],
    [
        [
            127516,
            127516
        ],
        "mapped",
        [
            21069
        ]
    ],
    [
        [
            127517,
            127517
        ],
        "mapped",
        [
            24460
        ]
    ],
    [
        [
            127518,
            127518
        ],
        "mapped",
        [
            20877
        ]
    ],
    [
        [
            127519,
            127519
        ],
        "mapped",
        [
            26032
        ]
    ],
    [
        [
            127520,
            127520
        ],
        "mapped",
        [
            21021
        ]
    ],
    [
        [
            127521,
            127521
        ],
        "mapped",
        [
            32066
        ]
    ],
    [
        [
            127522,
            127522
        ],
        "mapped",
        [
            29983
        ]
    ],
    [
        [
            127523,
            127523
        ],
        "mapped",
        [
            36009
        ]
    ],
    [
        [
            127524,
            127524
        ],
        "mapped",
        [
            22768
        ]
    ],
    [
        [
            127525,
            127525
        ],
        "mapped",
        [
            21561
        ]
    ],
    [
        [
            127526,
            127526
        ],
        "mapped",
        [
            28436
        ]
    ],
    [
        [
            127527,
            127527
        ],
        "mapped",
        [
            25237
        ]
    ],
    [
        [
            127528,
            127528
        ],
        "mapped",
        [
            25429
        ]
    ],
    [
        [
            127529,
            127529
        ],
        "mapped",
        [
            19968
        ]
    ],
    [
        [
            127530,
            127530
        ],
        "mapped",
        [
            19977
        ]
    ],
    [
        [
            127531,
            127531
        ],
        "mapped",
        [
            36938
        ]
    ],
    [
        [
            127532,
            127532
        ],
        "mapped",
        [
            24038
        ]
    ],
    [
        [
            127533,
            127533
        ],
        "mapped",
        [
            20013
        ]
    ],
    [
        [
            127534,
            127534
        ],
        "mapped",
        [
            21491
        ]
    ],
    [
        [
            127535,
            127535
        ],
        "mapped",
        [
            25351
        ]
    ],
    [
        [
            127536,
            127536
        ],
        "mapped",
        [
            36208
        ]
    ],
    [
        [
            127537,
            127537
        ],
        "mapped",
        [
            25171
        ]
    ],
    [
        [
            127538,
            127538
        ],
        "mapped",
        [
            31105
        ]
    ],
    [
        [
            127539,
            127539
        ],
        "mapped",
        [
            31354
        ]
    ],
    [
        [
            127540,
            127540
        ],
        "mapped",
        [
            21512
        ]
    ],
    [
        [
            127541,
            127541
        ],
        "mapped",
        [
            28288
        ]
    ],
    [
        [
            127542,
            127542
        ],
        "mapped",
        [
            26377
        ]
    ],
    [
        [
            127543,
            127543
        ],
        "mapped",
        [
            26376
        ]
    ],
    [
        [
            127544,
            127544
        ],
        "mapped",
        [
            30003
        ]
    ],
    [
        [
            127545,
            127545
        ],
        "mapped",
        [
            21106
        ]
    ],
    [
        [
            127546,
            127546
        ],
        "mapped",
        [
            21942
        ]
    ],
    [
        [
            127547,
            127551
        ],
        "disallowed"
    ],
    [
        [
            127552,
            127552
        ],
        "mapped",
        [
            12308,
            26412,
            12309
        ]
    ],
    [
        [
            127553,
            127553
        ],
        "mapped",
        [
            12308,
            19977,
            12309
        ]
    ],
    [
        [
            127554,
            127554
        ],
        "mapped",
        [
            12308,
            20108,
            12309
        ]
    ],
    [
        [
            127555,
            127555
        ],
        "mapped",
        [
            12308,
            23433,
            12309
        ]
    ],
    [
        [
            127556,
            127556
        ],
        "mapped",
        [
            12308,
            28857,
            12309
        ]
    ],
    [
        [
            127557,
            127557
        ],
        "mapped",
        [
            12308,
            25171,
            12309
        ]
    ],
    [
        [
            127558,
            127558
        ],
        "mapped",
        [
            12308,
            30423,
            12309
        ]
    ],
    [
        [
            127559,
            127559
        ],
        "mapped",
        [
            12308,
            21213,
            12309
        ]
    ],
    [
        [
            127560,
            127560
        ],
        "mapped",
        [
            12308,
            25943,
            12309
        ]
    ],
    [
        [
            127561,
            127567
        ],
        "disallowed"
    ],
    [
        [
            127568,
            127568
        ],
        "mapped",
        [
            24471
        ]
    ],
    [
        [
            127569,
            127569
        ],
        "mapped",
        [
            21487
        ]
    ],
    [
        [
            127570,
            127743
        ],
        "disallowed"
    ],
    [
        [
            127744,
            127776
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127777,
            127788
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127789,
            127791
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127792,
            127797
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127798,
            127798
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127799,
            127868
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127869,
            127869
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127870,
            127871
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127872,
            127891
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127892,
            127903
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127904,
            127940
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127941,
            127941
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127942,
            127946
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127947,
            127950
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127951,
            127955
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127956,
            127967
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127968,
            127984
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127985,
            127991
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            127992,
            127999
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128000,
            128062
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128063,
            128063
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128064,
            128064
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128065,
            128065
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128066,
            128247
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128248,
            128248
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128249,
            128252
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128253,
            128254
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128255,
            128255
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128256,
            128317
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128318,
            128319
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128320,
            128323
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128324,
            128330
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128331,
            128335
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128336,
            128359
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128360,
            128377
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128378,
            128378
        ],
        "disallowed"
    ],
    [
        [
            128379,
            128419
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128420,
            128420
        ],
        "disallowed"
    ],
    [
        [
            128421,
            128506
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128507,
            128511
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128512,
            128512
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128513,
            128528
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128529,
            128529
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128530,
            128532
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128533,
            128533
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128534,
            128534
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128535,
            128535
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128536,
            128536
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128537,
            128537
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128538,
            128538
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128539,
            128539
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128540,
            128542
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128543,
            128543
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128544,
            128549
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128550,
            128551
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128552,
            128555
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128556,
            128556
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128557,
            128557
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128558,
            128559
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128560,
            128563
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128564,
            128564
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128565,
            128576
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128577,
            128578
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128579,
            128580
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128581,
            128591
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128592,
            128639
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128640,
            128709
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128710,
            128719
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128720,
            128720
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128721,
            128735
        ],
        "disallowed"
    ],
    [
        [
            128736,
            128748
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128749,
            128751
        ],
        "disallowed"
    ],
    [
        [
            128752,
            128755
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128756,
            128767
        ],
        "disallowed"
    ],
    [
        [
            128768,
            128883
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128884,
            128895
        ],
        "disallowed"
    ],
    [
        [
            128896,
            128980
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            128981,
            129023
        ],
        "disallowed"
    ],
    [
        [
            129024,
            129035
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            129036,
            129039
        ],
        "disallowed"
    ],
    [
        [
            129040,
            129095
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            129096,
            129103
        ],
        "disallowed"
    ],
    [
        [
            129104,
            129113
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            129114,
            129119
        ],
        "disallowed"
    ],
    [
        [
            129120,
            129159
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            129160,
            129167
        ],
        "disallowed"
    ],
    [
        [
            129168,
            129197
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            129198,
            129295
        ],
        "disallowed"
    ],
    [
        [
            129296,
            129304
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            129305,
            129407
        ],
        "disallowed"
    ],
    [
        [
            129408,
            129412
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            129413,
            129471
        ],
        "disallowed"
    ],
    [
        [
            129472,
            129472
        ],
        "valid",
        [],
        "NV8"
    ],
    [
        [
            129473,
            131069
        ],
        "disallowed"
    ],
    [
        [
            131070,
            131071
        ],
        "disallowed"
    ],
    [
        [
            131072,
            173782
        ],
        "valid"
    ],
    [
        [
            173783,
            173823
        ],
        "disallowed"
    ],
    [
        [
            173824,
            177972
        ],
        "valid"
    ],
    [
        [
            177973,
            177983
        ],
        "disallowed"
    ],
    [
        [
            177984,
            178205
        ],
        "valid"
    ],
    [
        [
            178206,
            178207
        ],
        "disallowed"
    ],
    [
        [
            178208,
            183969
        ],
        "valid"
    ],
    [
        [
            183970,
            194559
        ],
        "disallowed"
    ],
    [
        [
            194560,
            194560
        ],
        "mapped",
        [
            20029
        ]
    ],
    [
        [
            194561,
            194561
        ],
        "mapped",
        [
            20024
        ]
    ],
    [
        [
            194562,
            194562
        ],
        "mapped",
        [
            20033
        ]
    ],
    [
        [
            194563,
            194563
        ],
        "mapped",
        [
            131362
        ]
    ],
    [
        [
            194564,
            194564
        ],
        "mapped",
        [
            20320
        ]
    ],
    [
        [
            194565,
            194565
        ],
        "mapped",
        [
            20398
        ]
    ],
    [
        [
            194566,
            194566
        ],
        "mapped",
        [
            20411
        ]
    ],
    [
        [
            194567,
            194567
        ],
        "mapped",
        [
            20482
        ]
    ],
    [
        [
            194568,
            194568
        ],
        "mapped",
        [
            20602
        ]
    ],
    [
        [
            194569,
            194569
        ],
        "mapped",
        [
            20633
        ]
    ],
    [
        [
            194570,
            194570
        ],
        "mapped",
        [
            20711
        ]
    ],
    [
        [
            194571,
            194571
        ],
        "mapped",
        [
            20687
        ]
    ],
    [
        [
            194572,
            194572
        ],
        "mapped",
        [
            13470
        ]
    ],
    [
        [
            194573,
            194573
        ],
        "mapped",
        [
            132666
        ]
    ],
    [
        [
            194574,
            194574
        ],
        "mapped",
        [
            20813
        ]
    ],
    [
        [
            194575,
            194575
        ],
        "mapped",
        [
            20820
        ]
    ],
    [
        [
            194576,
            194576
        ],
        "mapped",
        [
            20836
        ]
    ],
    [
        [
            194577,
            194577
        ],
        "mapped",
        [
            20855
        ]
    ],
    [
        [
            194578,
            194578
        ],
        "mapped",
        [
            132380
        ]
    ],
    [
        [
            194579,
            194579
        ],
        "mapped",
        [
            13497
        ]
    ],
    [
        [
            194580,
            194580
        ],
        "mapped",
        [
            20839
        ]
    ],
    [
        [
            194581,
            194581
        ],
        "mapped",
        [
            20877
        ]
    ],
    [
        [
            194582,
            194582
        ],
        "mapped",
        [
            132427
        ]
    ],
    [
        [
            194583,
            194583
        ],
        "mapped",
        [
            20887
        ]
    ],
    [
        [
            194584,
            194584
        ],
        "mapped",
        [
            20900
        ]
    ],
    [
        [
            194585,
            194585
        ],
        "mapped",
        [
            20172
        ]
    ],
    [
        [
            194586,
            194586
        ],
        "mapped",
        [
            20908
        ]
    ],
    [
        [
            194587,
            194587
        ],
        "mapped",
        [
            20917
        ]
    ],
    [
        [
            194588,
            194588
        ],
        "mapped",
        [
            168415
        ]
    ],
    [
        [
            194589,
            194589
        ],
        "mapped",
        [
            20981
        ]
    ],
    [
        [
            194590,
            194590
        ],
        "mapped",
        [
            20995
        ]
    ],
    [
        [
            194591,
            194591
        ],
        "mapped",
        [
            13535
        ]
    ],
    [
        [
            194592,
            194592
        ],
        "mapped",
        [
            21051
        ]
    ],
    [
        [
            194593,
            194593
        ],
        "mapped",
        [
            21062
        ]
    ],
    [
        [
            194594,
            194594
        ],
        "mapped",
        [
            21106
        ]
    ],
    [
        [
            194595,
            194595
        ],
        "mapped",
        [
            21111
        ]
    ],
    [
        [
            194596,
            194596
        ],
        "mapped",
        [
            13589
        ]
    ],
    [
        [
            194597,
            194597
        ],
        "mapped",
        [
            21191
        ]
    ],
    [
        [
            194598,
            194598
        ],
        "mapped",
        [
            21193
        ]
    ],
    [
        [
            194599,
            194599
        ],
        "mapped",
        [
            21220
        ]
    ],
    [
        [
            194600,
            194600
        ],
        "mapped",
        [
            21242
        ]
    ],
    [
        [
            194601,
            194601
        ],
        "mapped",
        [
            21253
        ]
    ],
    [
        [
            194602,
            194602
        ],
        "mapped",
        [
            21254
        ]
    ],
    [
        [
            194603,
            194603
        ],
        "mapped",
        [
            21271
        ]
    ],
    [
        [
            194604,
            194604
        ],
        "mapped",
        [
            21321
        ]
    ],
    [
        [
            194605,
            194605
        ],
        "mapped",
        [
            21329
        ]
    ],
    [
        [
            194606,
            194606
        ],
        "mapped",
        [
            21338
        ]
    ],
    [
        [
            194607,
            194607
        ],
        "mapped",
        [
            21363
        ]
    ],
    [
        [
            194608,
            194608
        ],
        "mapped",
        [
            21373
        ]
    ],
    [
        [
            194609,
            194611
        ],
        "mapped",
        [
            21375
        ]
    ],
    [
        [
            194612,
            194612
        ],
        "mapped",
        [
            133676
        ]
    ],
    [
        [
            194613,
            194613
        ],
        "mapped",
        [
            28784
        ]
    ],
    [
        [
            194614,
            194614
        ],
        "mapped",
        [
            21450
        ]
    ],
    [
        [
            194615,
            194615
        ],
        "mapped",
        [
            21471
        ]
    ],
    [
        [
            194616,
            194616
        ],
        "mapped",
        [
            133987
        ]
    ],
    [
        [
            194617,
            194617
        ],
        "mapped",
        [
            21483
        ]
    ],
    [
        [
            194618,
            194618
        ],
        "mapped",
        [
            21489
        ]
    ],
    [
        [
            194619,
            194619
        ],
        "mapped",
        [
            21510
        ]
    ],
    [
        [
            194620,
            194620
        ],
        "mapped",
        [
            21662
        ]
    ],
    [
        [
            194621,
            194621
        ],
        "mapped",
        [
            21560
        ]
    ],
    [
        [
            194622,
            194622
        ],
        "mapped",
        [
            21576
        ]
    ],
    [
        [
            194623,
            194623
        ],
        "mapped",
        [
            21608
        ]
    ],
    [
        [
            194624,
            194624
        ],
        "mapped",
        [
            21666
        ]
    ],
    [
        [
            194625,
            194625
        ],
        "mapped",
        [
            21750
        ]
    ],
    [
        [
            194626,
            194626
        ],
        "mapped",
        [
            21776
        ]
    ],
    [
        [
            194627,
            194627
        ],
        "mapped",
        [
            21843
        ]
    ],
    [
        [
            194628,
            194628
        ],
        "mapped",
        [
            21859
        ]
    ],
    [
        [
            194629,
            194630
        ],
        "mapped",
        [
            21892
        ]
    ],
    [
        [
            194631,
            194631
        ],
        "mapped",
        [
            21913
        ]
    ],
    [
        [
            194632,
            194632
        ],
        "mapped",
        [
            21931
        ]
    ],
    [
        [
            194633,
            194633
        ],
        "mapped",
        [
            21939
        ]
    ],
    [
        [
            194634,
            194634
        ],
        "mapped",
        [
            21954
        ]
    ],
    [
        [
            194635,
            194635
        ],
        "mapped",
        [
            22294
        ]
    ],
    [
        [
            194636,
            194636
        ],
        "mapped",
        [
            22022
        ]
    ],
    [
        [
            194637,
            194637
        ],
        "mapped",
        [
            22295
        ]
    ],
    [
        [
            194638,
            194638
        ],
        "mapped",
        [
            22097
        ]
    ],
    [
        [
            194639,
            194639
        ],
        "mapped",
        [
            22132
        ]
    ],
    [
        [
            194640,
            194640
        ],
        "mapped",
        [
            20999
        ]
    ],
    [
        [
            194641,
            194641
        ],
        "mapped",
        [
            22766
        ]
    ],
    [
        [
            194642,
            194642
        ],
        "mapped",
        [
            22478
        ]
    ],
    [
        [
            194643,
            194643
        ],
        "mapped",
        [
            22516
        ]
    ],
    [
        [
            194644,
            194644
        ],
        "mapped",
        [
            22541
        ]
    ],
    [
        [
            194645,
            194645
        ],
        "mapped",
        [
            22411
        ]
    ],
    [
        [
            194646,
            194646
        ],
        "mapped",
        [
            22578
        ]
    ],
    [
        [
            194647,
            194647
        ],
        "mapped",
        [
            22577
        ]
    ],
    [
        [
            194648,
            194648
        ],
        "mapped",
        [
            22700
        ]
    ],
    [
        [
            194649,
            194649
        ],
        "mapped",
        [
            136420
        ]
    ],
    [
        [
            194650,
            194650
        ],
        "mapped",
        [
            22770
        ]
    ],
    [
        [
            194651,
            194651
        ],
        "mapped",
        [
            22775
        ]
    ],
    [
        [
            194652,
            194652
        ],
        "mapped",
        [
            22790
        ]
    ],
    [
        [
            194653,
            194653
        ],
        "mapped",
        [
            22810
        ]
    ],
    [
        [
            194654,
            194654
        ],
        "mapped",
        [
            22818
        ]
    ],
    [
        [
            194655,
            194655
        ],
        "mapped",
        [
            22882
        ]
    ],
    [
        [
            194656,
            194656
        ],
        "mapped",
        [
            136872
        ]
    ],
    [
        [
            194657,
            194657
        ],
        "mapped",
        [
            136938
        ]
    ],
    [
        [
            194658,
            194658
        ],
        "mapped",
        [
            23020
        ]
    ],
    [
        [
            194659,
            194659
        ],
        "mapped",
        [
            23067
        ]
    ],
    [
        [
            194660,
            194660
        ],
        "mapped",
        [
            23079
        ]
    ],
    [
        [
            194661,
            194661
        ],
        "mapped",
        [
            23000
        ]
    ],
    [
        [
            194662,
            194662
        ],
        "mapped",
        [
            23142
        ]
    ],
    [
        [
            194663,
            194663
        ],
        "mapped",
        [
            14062
        ]
    ],
    [
        [
            194664,
            194664
        ],
        "disallowed"
    ],
    [
        [
            194665,
            194665
        ],
        "mapped",
        [
            23304
        ]
    ],
    [
        [
            194666,
            194667
        ],
        "mapped",
        [
            23358
        ]
    ],
    [
        [
            194668,
            194668
        ],
        "mapped",
        [
            137672
        ]
    ],
    [
        [
            194669,
            194669
        ],
        "mapped",
        [
            23491
        ]
    ],
    [
        [
            194670,
            194670
        ],
        "mapped",
        [
            23512
        ]
    ],
    [
        [
            194671,
            194671
        ],
        "mapped",
        [
            23527
        ]
    ],
    [
        [
            194672,
            194672
        ],
        "mapped",
        [
            23539
        ]
    ],
    [
        [
            194673,
            194673
        ],
        "mapped",
        [
            138008
        ]
    ],
    [
        [
            194674,
            194674
        ],
        "mapped",
        [
            23551
        ]
    ],
    [
        [
            194675,
            194675
        ],
        "mapped",
        [
            23558
        ]
    ],
    [
        [
            194676,
            194676
        ],
        "disallowed"
    ],
    [
        [
            194677,
            194677
        ],
        "mapped",
        [
            23586
        ]
    ],
    [
        [
            194678,
            194678
        ],
        "mapped",
        [
            14209
        ]
    ],
    [
        [
            194679,
            194679
        ],
        "mapped",
        [
            23648
        ]
    ],
    [
        [
            194680,
            194680
        ],
        "mapped",
        [
            23662
        ]
    ],
    [
        [
            194681,
            194681
        ],
        "mapped",
        [
            23744
        ]
    ],
    [
        [
            194682,
            194682
        ],
        "mapped",
        [
            23693
        ]
    ],
    [
        [
            194683,
            194683
        ],
        "mapped",
        [
            138724
        ]
    ],
    [
        [
            194684,
            194684
        ],
        "mapped",
        [
            23875
        ]
    ],
    [
        [
            194685,
            194685
        ],
        "mapped",
        [
            138726
        ]
    ],
    [
        [
            194686,
            194686
        ],
        "mapped",
        [
            23918
        ]
    ],
    [
        [
            194687,
            194687
        ],
        "mapped",
        [
            23915
        ]
    ],
    [
        [
            194688,
            194688
        ],
        "mapped",
        [
            23932
        ]
    ],
    [
        [
            194689,
            194689
        ],
        "mapped",
        [
            24033
        ]
    ],
    [
        [
            194690,
            194690
        ],
        "mapped",
        [
            24034
        ]
    ],
    [
        [
            194691,
            194691
        ],
        "mapped",
        [
            14383
        ]
    ],
    [
        [
            194692,
            194692
        ],
        "mapped",
        [
            24061
        ]
    ],
    [
        [
            194693,
            194693
        ],
        "mapped",
        [
            24104
        ]
    ],
    [
        [
            194694,
            194694
        ],
        "mapped",
        [
            24125
        ]
    ],
    [
        [
            194695,
            194695
        ],
        "mapped",
        [
            24169
        ]
    ],
    [
        [
            194696,
            194696
        ],
        "mapped",
        [
            14434
        ]
    ],
    [
        [
            194697,
            194697
        ],
        "mapped",
        [
            139651
        ]
    ],
    [
        [
            194698,
            194698
        ],
        "mapped",
        [
            14460
        ]
    ],
    [
        [
            194699,
            194699
        ],
        "mapped",
        [
            24240
        ]
    ],
    [
        [
            194700,
            194700
        ],
        "mapped",
        [
            24243
        ]
    ],
    [
        [
            194701,
            194701
        ],
        "mapped",
        [
            24246
        ]
    ],
    [
        [
            194702,
            194702
        ],
        "mapped",
        [
            24266
        ]
    ],
    [
        [
            194703,
            194703
        ],
        "mapped",
        [
            172946
        ]
    ],
    [
        [
            194704,
            194704
        ],
        "mapped",
        [
            24318
        ]
    ],
    [
        [
            194705,
            194706
        ],
        "mapped",
        [
            140081
        ]
    ],
    [
        [
            194707,
            194707
        ],
        "mapped",
        [
            33281
        ]
    ],
    [
        [
            194708,
            194709
        ],
        "mapped",
        [
            24354
        ]
    ],
    [
        [
            194710,
            194710
        ],
        "mapped",
        [
            14535
        ]
    ],
    [
        [
            194711,
            194711
        ],
        "mapped",
        [
            144056
        ]
    ],
    [
        [
            194712,
            194712
        ],
        "mapped",
        [
            156122
        ]
    ],
    [
        [
            194713,
            194713
        ],
        "mapped",
        [
            24418
        ]
    ],
    [
        [
            194714,
            194714
        ],
        "mapped",
        [
            24427
        ]
    ],
    [
        [
            194715,
            194715
        ],
        "mapped",
        [
            14563
        ]
    ],
    [
        [
            194716,
            194716
        ],
        "mapped",
        [
            24474
        ]
    ],
    [
        [
            194717,
            194717
        ],
        "mapped",
        [
            24525
        ]
    ],
    [
        [
            194718,
            194718
        ],
        "mapped",
        [
            24535
        ]
    ],
    [
        [
            194719,
            194719
        ],
        "mapped",
        [
            24569
        ]
    ],
    [
        [
            194720,
            194720
        ],
        "mapped",
        [
            24705
        ]
    ],
    [
        [
            194721,
            194721
        ],
        "mapped",
        [
            14650
        ]
    ],
    [
        [
            194722,
            194722
        ],
        "mapped",
        [
            14620
        ]
    ],
    [
        [
            194723,
            194723
        ],
        "mapped",
        [
            24724
        ]
    ],
    [
        [
            194724,
            194724
        ],
        "mapped",
        [
            141012
        ]
    ],
    [
        [
            194725,
            194725
        ],
        "mapped",
        [
            24775
        ]
    ],
    [
        [
            194726,
            194726
        ],
        "mapped",
        [
            24904
        ]
    ],
    [
        [
            194727,
            194727
        ],
        "mapped",
        [
            24908
        ]
    ],
    [
        [
            194728,
            194728
        ],
        "mapped",
        [
            24910
        ]
    ],
    [
        [
            194729,
            194729
        ],
        "mapped",
        [
            24908
        ]
    ],
    [
        [
            194730,
            194730
        ],
        "mapped",
        [
            24954
        ]
    ],
    [
        [
            194731,
            194731
        ],
        "mapped",
        [
            24974
        ]
    ],
    [
        [
            194732,
            194732
        ],
        "mapped",
        [
            25010
        ]
    ],
    [
        [
            194733,
            194733
        ],
        "mapped",
        [
            24996
        ]
    ],
    [
        [
            194734,
            194734
        ],
        "mapped",
        [
            25007
        ]
    ],
    [
        [
            194735,
            194735
        ],
        "mapped",
        [
            25054
        ]
    ],
    [
        [
            194736,
            194736
        ],
        "mapped",
        [
            25074
        ]
    ],
    [
        [
            194737,
            194737
        ],
        "mapped",
        [
            25078
        ]
    ],
    [
        [
            194738,
            194738
        ],
        "mapped",
        [
            25104
        ]
    ],
    [
        [
            194739,
            194739
        ],
        "mapped",
        [
            25115
        ]
    ],
    [
        [
            194740,
            194740
        ],
        "mapped",
        [
            25181
        ]
    ],
    [
        [
            194741,
            194741
        ],
        "mapped",
        [
            25265
        ]
    ],
    [
        [
            194742,
            194742
        ],
        "mapped",
        [
            25300
        ]
    ],
    [
        [
            194743,
            194743
        ],
        "mapped",
        [
            25424
        ]
    ],
    [
        [
            194744,
            194744
        ],
        "mapped",
        [
            142092
        ]
    ],
    [
        [
            194745,
            194745
        ],
        "mapped",
        [
            25405
        ]
    ],
    [
        [
            194746,
            194746
        ],
        "mapped",
        [
            25340
        ]
    ],
    [
        [
            194747,
            194747
        ],
        "mapped",
        [
            25448
        ]
    ],
    [
        [
            194748,
            194748
        ],
        "mapped",
        [
            25475
        ]
    ],
    [
        [
            194749,
            194749
        ],
        "mapped",
        [
            25572
        ]
    ],
    [
        [
            194750,
            194750
        ],
        "mapped",
        [
            142321
        ]
    ],
    [
        [
            194751,
            194751
        ],
        "mapped",
        [
            25634
        ]
    ],
    [
        [
            194752,
            194752
        ],
        "mapped",
        [
            25541
        ]
    ],
    [
        [
            194753,
            194753
        ],
        "mapped",
        [
            25513
        ]
    ],
    [
        [
            194754,
            194754
        ],
        "mapped",
        [
            14894
        ]
    ],
    [
        [
            194755,
            194755
        ],
        "mapped",
        [
            25705
        ]
    ],
    [
        [
            194756,
            194756
        ],
        "mapped",
        [
            25726
        ]
    ],
    [
        [
            194757,
            194757
        ],
        "mapped",
        [
            25757
        ]
    ],
    [
        [
            194758,
            194758
        ],
        "mapped",
        [
            25719
        ]
    ],
    [
        [
            194759,
            194759
        ],
        "mapped",
        [
            14956
        ]
    ],
    [
        [
            194760,
            194760
        ],
        "mapped",
        [
            25935
        ]
    ],
    [
        [
            194761,
            194761
        ],
        "mapped",
        [
            25964
        ]
    ],
    [
        [
            194762,
            194762
        ],
        "mapped",
        [
            143370
        ]
    ],
    [
        [
            194763,
            194763
        ],
        "mapped",
        [
            26083
        ]
    ],
    [
        [
            194764,
            194764
        ],
        "mapped",
        [
            26360
        ]
    ],
    [
        [
            194765,
            194765
        ],
        "mapped",
        [
            26185
        ]
    ],
    [
        [
            194766,
            194766
        ],
        "mapped",
        [
            15129
        ]
    ],
    [
        [
            194767,
            194767
        ],
        "mapped",
        [
            26257
        ]
    ],
    [
        [
            194768,
            194768
        ],
        "mapped",
        [
            15112
        ]
    ],
    [
        [
            194769,
            194769
        ],
        "mapped",
        [
            15076
        ]
    ],
    [
        [
            194770,
            194770
        ],
        "mapped",
        [
            20882
        ]
    ],
    [
        [
            194771,
            194771
        ],
        "mapped",
        [
            20885
        ]
    ],
    [
        [
            194772,
            194772
        ],
        "mapped",
        [
            26368
        ]
    ],
    [
        [
            194773,
            194773
        ],
        "mapped",
        [
            26268
        ]
    ],
    [
        [
            194774,
            194774
        ],
        "mapped",
        [
            32941
        ]
    ],
    [
        [
            194775,
            194775
        ],
        "mapped",
        [
            17369
        ]
    ],
    [
        [
            194776,
            194776
        ],
        "mapped",
        [
            26391
        ]
    ],
    [
        [
            194777,
            194777
        ],
        "mapped",
        [
            26395
        ]
    ],
    [
        [
            194778,
            194778
        ],
        "mapped",
        [
            26401
        ]
    ],
    [
        [
            194779,
            194779
        ],
        "mapped",
        [
            26462
        ]
    ],
    [
        [
            194780,
            194780
        ],
        "mapped",
        [
            26451
        ]
    ],
    [
        [
            194781,
            194781
        ],
        "mapped",
        [
            144323
        ]
    ],
    [
        [
            194782,
            194782
        ],
        "mapped",
        [
            15177
        ]
    ],
    [
        [
            194783,
            194783
        ],
        "mapped",
        [
            26618
        ]
    ],
    [
        [
            194784,
            194784
        ],
        "mapped",
        [
            26501
        ]
    ],
    [
        [
            194785,
            194785
        ],
        "mapped",
        [
            26706
        ]
    ],
    [
        [
            194786,
            194786
        ],
        "mapped",
        [
            26757
        ]
    ],
    [
        [
            194787,
            194787
        ],
        "mapped",
        [
            144493
        ]
    ],
    [
        [
            194788,
            194788
        ],
        "mapped",
        [
            26766
        ]
    ],
    [
        [
            194789,
            194789
        ],
        "mapped",
        [
            26655
        ]
    ],
    [
        [
            194790,
            194790
        ],
        "mapped",
        [
            26900
        ]
    ],
    [
        [
            194791,
            194791
        ],
        "mapped",
        [
            15261
        ]
    ],
    [
        [
            194792,
            194792
        ],
        "mapped",
        [
            26946
        ]
    ],
    [
        [
            194793,
            194793
        ],
        "mapped",
        [
            27043
        ]
    ],
    [
        [
            194794,
            194794
        ],
        "mapped",
        [
            27114
        ]
    ],
    [
        [
            194795,
            194795
        ],
        "mapped",
        [
            27304
        ]
    ],
    [
        [
            194796,
            194796
        ],
        "mapped",
        [
            145059
        ]
    ],
    [
        [
            194797,
            194797
        ],
        "mapped",
        [
            27355
        ]
    ],
    [
        [
            194798,
            194798
        ],
        "mapped",
        [
            15384
        ]
    ],
    [
        [
            194799,
            194799
        ],
        "mapped",
        [
            27425
        ]
    ],
    [
        [
            194800,
            194800
        ],
        "mapped",
        [
            145575
        ]
    ],
    [
        [
            194801,
            194801
        ],
        "mapped",
        [
            27476
        ]
    ],
    [
        [
            194802,
            194802
        ],
        "mapped",
        [
            15438
        ]
    ],
    [
        [
            194803,
            194803
        ],
        "mapped",
        [
            27506
        ]
    ],
    [
        [
            194804,
            194804
        ],
        "mapped",
        [
            27551
        ]
    ],
    [
        [
            194805,
            194805
        ],
        "mapped",
        [
            27578
        ]
    ],
    [
        [
            194806,
            194806
        ],
        "mapped",
        [
            27579
        ]
    ],
    [
        [
            194807,
            194807
        ],
        "mapped",
        [
            146061
        ]
    ],
    [
        [
            194808,
            194808
        ],
        "mapped",
        [
            138507
        ]
    ],
    [
        [
            194809,
            194809
        ],
        "mapped",
        [
            146170
        ]
    ],
    [
        [
            194810,
            194810
        ],
        "mapped",
        [
            27726
        ]
    ],
    [
        [
            194811,
            194811
        ],
        "mapped",
        [
            146620
        ]
    ],
    [
        [
            194812,
            194812
        ],
        "mapped",
        [
            27839
        ]
    ],
    [
        [
            194813,
            194813
        ],
        "mapped",
        [
            27853
        ]
    ],
    [
        [
            194814,
            194814
        ],
        "mapped",
        [
            27751
        ]
    ],
    [
        [
            194815,
            194815
        ],
        "mapped",
        [
            27926
        ]
    ],
    [
        [
            194816,
            194816
        ],
        "mapped",
        [
            27966
        ]
    ],
    [
        [
            194817,
            194817
        ],
        "mapped",
        [
            28023
        ]
    ],
    [
        [
            194818,
            194818
        ],
        "mapped",
        [
            27969
        ]
    ],
    [
        [
            194819,
            194819
        ],
        "mapped",
        [
            28009
        ]
    ],
    [
        [
            194820,
            194820
        ],
        "mapped",
        [
            28024
        ]
    ],
    [
        [
            194821,
            194821
        ],
        "mapped",
        [
            28037
        ]
    ],
    [
        [
            194822,
            194822
        ],
        "mapped",
        [
            146718
        ]
    ],
    [
        [
            194823,
            194823
        ],
        "mapped",
        [
            27956
        ]
    ],
    [
        [
            194824,
            194824
        ],
        "mapped",
        [
            28207
        ]
    ],
    [
        [
            194825,
            194825
        ],
        "mapped",
        [
            28270
        ]
    ],
    [
        [
            194826,
            194826
        ],
        "mapped",
        [
            15667
        ]
    ],
    [
        [
            194827,
            194827
        ],
        "mapped",
        [
            28363
        ]
    ],
    [
        [
            194828,
            194828
        ],
        "mapped",
        [
            28359
        ]
    ],
    [
        [
            194829,
            194829
        ],
        "mapped",
        [
            147153
        ]
    ],
    [
        [
            194830,
            194830
        ],
        "mapped",
        [
            28153
        ]
    ],
    [
        [
            194831,
            194831
        ],
        "mapped",
        [
            28526
        ]
    ],
    [
        [
            194832,
            194832
        ],
        "mapped",
        [
            147294
        ]
    ],
    [
        [
            194833,
            194833
        ],
        "mapped",
        [
            147342
        ]
    ],
    [
        [
            194834,
            194834
        ],
        "mapped",
        [
            28614
        ]
    ],
    [
        [
            194835,
            194835
        ],
        "mapped",
        [
            28729
        ]
    ],
    [
        [
            194836,
            194836
        ],
        "mapped",
        [
            28702
        ]
    ],
    [
        [
            194837,
            194837
        ],
        "mapped",
        [
            28699
        ]
    ],
    [
        [
            194838,
            194838
        ],
        "mapped",
        [
            15766
        ]
    ],
    [
        [
            194839,
            194839
        ],
        "mapped",
        [
            28746
        ]
    ],
    [
        [
            194840,
            194840
        ],
        "mapped",
        [
            28797
        ]
    ],
    [
        [
            194841,
            194841
        ],
        "mapped",
        [
            28791
        ]
    ],
    [
        [
            194842,
            194842
        ],
        "mapped",
        [
            28845
        ]
    ],
    [
        [
            194843,
            194843
        ],
        "mapped",
        [
            132389
        ]
    ],
    [
        [
            194844,
            194844
        ],
        "mapped",
        [
            28997
        ]
    ],
    [
        [
            194845,
            194845
        ],
        "mapped",
        [
            148067
        ]
    ],
    [
        [
            194846,
            194846
        ],
        "mapped",
        [
            29084
        ]
    ],
    [
        [
            194847,
            194847
        ],
        "disallowed"
    ],
    [
        [
            194848,
            194848
        ],
        "mapped",
        [
            29224
        ]
    ],
    [
        [
            194849,
            194849
        ],
        "mapped",
        [
            29237
        ]
    ],
    [
        [
            194850,
            194850
        ],
        "mapped",
        [
            29264
        ]
    ],
    [
        [
            194851,
            194851
        ],
        "mapped",
        [
            149000
        ]
    ],
    [
        [
            194852,
            194852
        ],
        "mapped",
        [
            29312
        ]
    ],
    [
        [
            194853,
            194853
        ],
        "mapped",
        [
            29333
        ]
    ],
    [
        [
            194854,
            194854
        ],
        "mapped",
        [
            149301
        ]
    ],
    [
        [
            194855,
            194855
        ],
        "mapped",
        [
            149524
        ]
    ],
    [
        [
            194856,
            194856
        ],
        "mapped",
        [
            29562
        ]
    ],
    [
        [
            194857,
            194857
        ],
        "mapped",
        [
            29579
        ]
    ],
    [
        [
            194858,
            194858
        ],
        "mapped",
        [
            16044
        ]
    ],
    [
        [
            194859,
            194859
        ],
        "mapped",
        [
            29605
        ]
    ],
    [
        [
            194860,
            194861
        ],
        "mapped",
        [
            16056
        ]
    ],
    [
        [
            194862,
            194862
        ],
        "mapped",
        [
            29767
        ]
    ],
    [
        [
            194863,
            194863
        ],
        "mapped",
        [
            29788
        ]
    ],
    [
        [
            194864,
            194864
        ],
        "mapped",
        [
            29809
        ]
    ],
    [
        [
            194865,
            194865
        ],
        "mapped",
        [
            29829
        ]
    ],
    [
        [
            194866,
            194866
        ],
        "mapped",
        [
            29898
        ]
    ],
    [
        [
            194867,
            194867
        ],
        "mapped",
        [
            16155
        ]
    ],
    [
        [
            194868,
            194868
        ],
        "mapped",
        [
            29988
        ]
    ],
    [
        [
            194869,
            194869
        ],
        "mapped",
        [
            150582
        ]
    ],
    [
        [
            194870,
            194870
        ],
        "mapped",
        [
            30014
        ]
    ],
    [
        [
            194871,
            194871
        ],
        "mapped",
        [
            150674
        ]
    ],
    [
        [
            194872,
            194872
        ],
        "mapped",
        [
            30064
        ]
    ],
    [
        [
            194873,
            194873
        ],
        "mapped",
        [
            139679
        ]
    ],
    [
        [
            194874,
            194874
        ],
        "mapped",
        [
            30224
        ]
    ],
    [
        [
            194875,
            194875
        ],
        "mapped",
        [
            151457
        ]
    ],
    [
        [
            194876,
            194876
        ],
        "mapped",
        [
            151480
        ]
    ],
    [
        [
            194877,
            194877
        ],
        "mapped",
        [
            151620
        ]
    ],
    [
        [
            194878,
            194878
        ],
        "mapped",
        [
            16380
        ]
    ],
    [
        [
            194879,
            194879
        ],
        "mapped",
        [
            16392
        ]
    ],
    [
        [
            194880,
            194880
        ],
        "mapped",
        [
            30452
        ]
    ],
    [
        [
            194881,
            194881
        ],
        "mapped",
        [
            151795
        ]
    ],
    [
        [
            194882,
            194882
        ],
        "mapped",
        [
            151794
        ]
    ],
    [
        [
            194883,
            194883
        ],
        "mapped",
        [
            151833
        ]
    ],
    [
        [
            194884,
            194884
        ],
        "mapped",
        [
            151859
        ]
    ],
    [
        [
            194885,
            194885
        ],
        "mapped",
        [
            30494
        ]
    ],
    [
        [
            194886,
            194887
        ],
        "mapped",
        [
            30495
        ]
    ],
    [
        [
            194888,
            194888
        ],
        "mapped",
        [
            30538
        ]
    ],
    [
        [
            194889,
            194889
        ],
        "mapped",
        [
            16441
        ]
    ],
    [
        [
            194890,
            194890
        ],
        "mapped",
        [
            30603
        ]
    ],
    [
        [
            194891,
            194891
        ],
        "mapped",
        [
            16454
        ]
    ],
    [
        [
            194892,
            194892
        ],
        "mapped",
        [
            16534
        ]
    ],
    [
        [
            194893,
            194893
        ],
        "mapped",
        [
            152605
        ]
    ],
    [
        [
            194894,
            194894
        ],
        "mapped",
        [
            30798
        ]
    ],
    [
        [
            194895,
            194895
        ],
        "mapped",
        [
            30860
        ]
    ],
    [
        [
            194896,
            194896
        ],
        "mapped",
        [
            30924
        ]
    ],
    [
        [
            194897,
            194897
        ],
        "mapped",
        [
            16611
        ]
    ],
    [
        [
            194898,
            194898
        ],
        "mapped",
        [
            153126
        ]
    ],
    [
        [
            194899,
            194899
        ],
        "mapped",
        [
            31062
        ]
    ],
    [
        [
            194900,
            194900
        ],
        "mapped",
        [
            153242
        ]
    ],
    [
        [
            194901,
            194901
        ],
        "mapped",
        [
            153285
        ]
    ],
    [
        [
            194902,
            194902
        ],
        "mapped",
        [
            31119
        ]
    ],
    [
        [
            194903,
            194903
        ],
        "mapped",
        [
            31211
        ]
    ],
    [
        [
            194904,
            194904
        ],
        "mapped",
        [
            16687
        ]
    ],
    [
        [
            194905,
            194905
        ],
        "mapped",
        [
            31296
        ]
    ],
    [
        [
            194906,
            194906
        ],
        "mapped",
        [
            31306
        ]
    ],
    [
        [
            194907,
            194907
        ],
        "mapped",
        [
            31311
        ]
    ],
    [
        [
            194908,
            194908
        ],
        "mapped",
        [
            153980
        ]
    ],
    [
        [
            194909,
            194910
        ],
        "mapped",
        [
            154279
        ]
    ],
    [
        [
            194911,
            194911
        ],
        "disallowed"
    ],
    [
        [
            194912,
            194912
        ],
        "mapped",
        [
            16898
        ]
    ],
    [
        [
            194913,
            194913
        ],
        "mapped",
        [
            154539
        ]
    ],
    [
        [
            194914,
            194914
        ],
        "mapped",
        [
            31686
        ]
    ],
    [
        [
            194915,
            194915
        ],
        "mapped",
        [
            31689
        ]
    ],
    [
        [
            194916,
            194916
        ],
        "mapped",
        [
            16935
        ]
    ],
    [
        [
            194917,
            194917
        ],
        "mapped",
        [
            154752
        ]
    ],
    [
        [
            194918,
            194918
        ],
        "mapped",
        [
            31954
        ]
    ],
    [
        [
            194919,
            194919
        ],
        "mapped",
        [
            17056
        ]
    ],
    [
        [
            194920,
            194920
        ],
        "mapped",
        [
            31976
        ]
    ],
    [
        [
            194921,
            194921
        ],
        "mapped",
        [
            31971
        ]
    ],
    [
        [
            194922,
            194922
        ],
        "mapped",
        [
            32000
        ]
    ],
    [
        [
            194923,
            194923
        ],
        "mapped",
        [
            155526
        ]
    ],
    [
        [
            194924,
            194924
        ],
        "mapped",
        [
            32099
        ]
    ],
    [
        [
            194925,
            194925
        ],
        "mapped",
        [
            17153
        ]
    ],
    [
        [
            194926,
            194926
        ],
        "mapped",
        [
            32199
        ]
    ],
    [
        [
            194927,
            194927
        ],
        "mapped",
        [
            32258
        ]
    ],
    [
        [
            194928,
            194928
        ],
        "mapped",
        [
            32325
        ]
    ],
    [
        [
            194929,
            194929
        ],
        "mapped",
        [
            17204
        ]
    ],
    [
        [
            194930,
            194930
        ],
        "mapped",
        [
            156200
        ]
    ],
    [
        [
            194931,
            194931
        ],
        "mapped",
        [
            156231
        ]
    ],
    [
        [
            194932,
            194932
        ],
        "mapped",
        [
            17241
        ]
    ],
    [
        [
            194933,
            194933
        ],
        "mapped",
        [
            156377
        ]
    ],
    [
        [
            194934,
            194934
        ],
        "mapped",
        [
            32634
        ]
    ],
    [
        [
            194935,
            194935
        ],
        "mapped",
        [
            156478
        ]
    ],
    [
        [
            194936,
            194936
        ],
        "mapped",
        [
            32661
        ]
    ],
    [
        [
            194937,
            194937
        ],
        "mapped",
        [
            32762
        ]
    ],
    [
        [
            194938,
            194938
        ],
        "mapped",
        [
            32773
        ]
    ],
    [
        [
            194939,
            194939
        ],
        "mapped",
        [
            156890
        ]
    ],
    [
        [
            194940,
            194940
        ],
        "mapped",
        [
            156963
        ]
    ],
    [
        [
            194941,
            194941
        ],
        "mapped",
        [
            32864
        ]
    ],
    [
        [
            194942,
            194942
        ],
        "mapped",
        [
            157096
        ]
    ],
    [
        [
            194943,
            194943
        ],
        "mapped",
        [
            32880
        ]
    ],
    [
        [
            194944,
            194944
        ],
        "mapped",
        [
            144223
        ]
    ],
    [
        [
            194945,
            194945
        ],
        "mapped",
        [
            17365
        ]
    ],
    [
        [
            194946,
            194946
        ],
        "mapped",
        [
            32946
        ]
    ],
    [
        [
            194947,
            194947
        ],
        "mapped",
        [
            33027
        ]
    ],
    [
        [
            194948,
            194948
        ],
        "mapped",
        [
            17419
        ]
    ],
    [
        [
            194949,
            194949
        ],
        "mapped",
        [
            33086
        ]
    ],
    [
        [
            194950,
            194950
        ],
        "mapped",
        [
            23221
        ]
    ],
    [
        [
            194951,
            194951
        ],
        "mapped",
        [
            157607
        ]
    ],
    [
        [
            194952,
            194952
        ],
        "mapped",
        [
            157621
        ]
    ],
    [
        [
            194953,
            194953
        ],
        "mapped",
        [
            144275
        ]
    ],
    [
        [
            194954,
            194954
        ],
        "mapped",
        [
            144284
        ]
    ],
    [
        [
            194955,
            194955
        ],
        "mapped",
        [
            33281
        ]
    ],
    [
        [
            194956,
            194956
        ],
        "mapped",
        [
            33284
        ]
    ],
    [
        [
            194957,
            194957
        ],
        "mapped",
        [
            36766
        ]
    ],
    [
        [
            194958,
            194958
        ],
        "mapped",
        [
            17515
        ]
    ],
    [
        [
            194959,
            194959
        ],
        "mapped",
        [
            33425
        ]
    ],
    [
        [
            194960,
            194960
        ],
        "mapped",
        [
            33419
        ]
    ],
    [
        [
            194961,
            194961
        ],
        "mapped",
        [
            33437
        ]
    ],
    [
        [
            194962,
            194962
        ],
        "mapped",
        [
            21171
        ]
    ],
    [
        [
            194963,
            194963
        ],
        "mapped",
        [
            33457
        ]
    ],
    [
        [
            194964,
            194964
        ],
        "mapped",
        [
            33459
        ]
    ],
    [
        [
            194965,
            194965
        ],
        "mapped",
        [
            33469
        ]
    ],
    [
        [
            194966,
            194966
        ],
        "mapped",
        [
            33510
        ]
    ],
    [
        [
            194967,
            194967
        ],
        "mapped",
        [
            158524
        ]
    ],
    [
        [
            194968,
            194968
        ],
        "mapped",
        [
            33509
        ]
    ],
    [
        [
            194969,
            194969
        ],
        "mapped",
        [
            33565
        ]
    ],
    [
        [
            194970,
            194970
        ],
        "mapped",
        [
            33635
        ]
    ],
    [
        [
            194971,
            194971
        ],
        "mapped",
        [
            33709
        ]
    ],
    [
        [
            194972,
            194972
        ],
        "mapped",
        [
            33571
        ]
    ],
    [
        [
            194973,
            194973
        ],
        "mapped",
        [
            33725
        ]
    ],
    [
        [
            194974,
            194974
        ],
        "mapped",
        [
            33767
        ]
    ],
    [
        [
            194975,
            194975
        ],
        "mapped",
        [
            33879
        ]
    ],
    [
        [
            194976,
            194976
        ],
        "mapped",
        [
            33619
        ]
    ],
    [
        [
            194977,
            194977
        ],
        "mapped",
        [
            33738
        ]
    ],
    [
        [
            194978,
            194978
        ],
        "mapped",
        [
            33740
        ]
    ],
    [
        [
            194979,
            194979
        ],
        "mapped",
        [
            33756
        ]
    ],
    [
        [
            194980,
            194980
        ],
        "mapped",
        [
            158774
        ]
    ],
    [
        [
            194981,
            194981
        ],
        "mapped",
        [
            159083
        ]
    ],
    [
        [
            194982,
            194982
        ],
        "mapped",
        [
            158933
        ]
    ],
    [
        [
            194983,
            194983
        ],
        "mapped",
        [
            17707
        ]
    ],
    [
        [
            194984,
            194984
        ],
        "mapped",
        [
            34033
        ]
    ],
    [
        [
            194985,
            194985
        ],
        "mapped",
        [
            34035
        ]
    ],
    [
        [
            194986,
            194986
        ],
        "mapped",
        [
            34070
        ]
    ],
    [
        [
            194987,
            194987
        ],
        "mapped",
        [
            160714
        ]
    ],
    [
        [
            194988,
            194988
        ],
        "mapped",
        [
            34148
        ]
    ],
    [
        [
            194989,
            194989
        ],
        "mapped",
        [
            159532
        ]
    ],
    [
        [
            194990,
            194990
        ],
        "mapped",
        [
            17757
        ]
    ],
    [
        [
            194991,
            194991
        ],
        "mapped",
        [
            17761
        ]
    ],
    [
        [
            194992,
            194992
        ],
        "mapped",
        [
            159665
        ]
    ],
    [
        [
            194993,
            194993
        ],
        "mapped",
        [
            159954
        ]
    ],
    [
        [
            194994,
            194994
        ],
        "mapped",
        [
            17771
        ]
    ],
    [
        [
            194995,
            194995
        ],
        "mapped",
        [
            34384
        ]
    ],
    [
        [
            194996,
            194996
        ],
        "mapped",
        [
            34396
        ]
    ],
    [
        [
            194997,
            194997
        ],
        "mapped",
        [
            34407
        ]
    ],
    [
        [
            194998,
            194998
        ],
        "mapped",
        [
            34409
        ]
    ],
    [
        [
            194999,
            194999
        ],
        "mapped",
        [
            34473
        ]
    ],
    [
        [
            195000,
            195000
        ],
        "mapped",
        [
            34440
        ]
    ],
    [
        [
            195001,
            195001
        ],
        "mapped",
        [
            34574
        ]
    ],
    [
        [
            195002,
            195002
        ],
        "mapped",
        [
            34530
        ]
    ],
    [
        [
            195003,
            195003
        ],
        "mapped",
        [
            34681
        ]
    ],
    [
        [
            195004,
            195004
        ],
        "mapped",
        [
            34600
        ]
    ],
    [
        [
            195005,
            195005
        ],
        "mapped",
        [
            34667
        ]
    ],
    [
        [
            195006,
            195006
        ],
        "mapped",
        [
            34694
        ]
    ],
    [
        [
            195007,
            195007
        ],
        "disallowed"
    ],
    [
        [
            195008,
            195008
        ],
        "mapped",
        [
            34785
        ]
    ],
    [
        [
            195009,
            195009
        ],
        "mapped",
        [
            34817
        ]
    ],
    [
        [
            195010,
            195010
        ],
        "mapped",
        [
            17913
        ]
    ],
    [
        [
            195011,
            195011
        ],
        "mapped",
        [
            34912
        ]
    ],
    [
        [
            195012,
            195012
        ],
        "mapped",
        [
            34915
        ]
    ],
    [
        [
            195013,
            195013
        ],
        "mapped",
        [
            161383
        ]
    ],
    [
        [
            195014,
            195014
        ],
        "mapped",
        [
            35031
        ]
    ],
    [
        [
            195015,
            195015
        ],
        "mapped",
        [
            35038
        ]
    ],
    [
        [
            195016,
            195016
        ],
        "mapped",
        [
            17973
        ]
    ],
    [
        [
            195017,
            195017
        ],
        "mapped",
        [
            35066
        ]
    ],
    [
        [
            195018,
            195018
        ],
        "mapped",
        [
            13499
        ]
    ],
    [
        [
            195019,
            195019
        ],
        "mapped",
        [
            161966
        ]
    ],
    [
        [
            195020,
            195020
        ],
        "mapped",
        [
            162150
        ]
    ],
    [
        [
            195021,
            195021
        ],
        "mapped",
        [
            18110
        ]
    ],
    [
        [
            195022,
            195022
        ],
        "mapped",
        [
            18119
        ]
    ],
    [
        [
            195023,
            195023
        ],
        "mapped",
        [
            35488
        ]
    ],
    [
        [
            195024,
            195024
        ],
        "mapped",
        [
            35565
        ]
    ],
    [
        [
            195025,
            195025
        ],
        "mapped",
        [
            35722
        ]
    ],
    [
        [
            195026,
            195026
        ],
        "mapped",
        [
            35925
        ]
    ],
    [
        [
            195027,
            195027
        ],
        "mapped",
        [
            162984
        ]
    ],
    [
        [
            195028,
            195028
        ],
        "mapped",
        [
            36011
        ]
    ],
    [
        [
            195029,
            195029
        ],
        "mapped",
        [
            36033
        ]
    ],
    [
        [
            195030,
            195030
        ],
        "mapped",
        [
            36123
        ]
    ],
    [
        [
            195031,
            195031
        ],
        "mapped",
        [
            36215
        ]
    ],
    [
        [
            195032,
            195032
        ],
        "mapped",
        [
            163631
        ]
    ],
    [
        [
            195033,
            195033
        ],
        "mapped",
        [
            133124
        ]
    ],
    [
        [
            195034,
            195034
        ],
        "mapped",
        [
            36299
        ]
    ],
    [
        [
            195035,
            195035
        ],
        "mapped",
        [
            36284
        ]
    ],
    [
        [
            195036,
            195036
        ],
        "mapped",
        [
            36336
        ]
    ],
    [
        [
            195037,
            195037
        ],
        "mapped",
        [
            133342
        ]
    ],
    [
        [
            195038,
            195038
        ],
        "mapped",
        [
            36564
        ]
    ],
    [
        [
            195039,
            195039
        ],
        "mapped",
        [
            36664
        ]
    ],
    [
        [
            195040,
            195040
        ],
        "mapped",
        [
            165330
        ]
    ],
    [
        [
            195041,
            195041
        ],
        "mapped",
        [
            165357
        ]
    ],
    [
        [
            195042,
            195042
        ],
        "mapped",
        [
            37012
        ]
    ],
    [
        [
            195043,
            195043
        ],
        "mapped",
        [
            37105
        ]
    ],
    [
        [
            195044,
            195044
        ],
        "mapped",
        [
            37137
        ]
    ],
    [
        [
            195045,
            195045
        ],
        "mapped",
        [
            165678
        ]
    ],
    [
        [
            195046,
            195046
        ],
        "mapped",
        [
            37147
        ]
    ],
    [
        [
            195047,
            195047
        ],
        "mapped",
        [
            37432
        ]
    ],
    [
        [
            195048,
            195048
        ],
        "mapped",
        [
            37591
        ]
    ],
    [
        [
            195049,
            195049
        ],
        "mapped",
        [
            37592
        ]
    ],
    [
        [
            195050,
            195050
        ],
        "mapped",
        [
            37500
        ]
    ],
    [
        [
            195051,
            195051
        ],
        "mapped",
        [
            37881
        ]
    ],
    [
        [
            195052,
            195052
        ],
        "mapped",
        [
            37909
        ]
    ],
    [
        [
            195053,
            195053
        ],
        "mapped",
        [
            166906
        ]
    ],
    [
        [
            195054,
            195054
        ],
        "mapped",
        [
            38283
        ]
    ],
    [
        [
            195055,
            195055
        ],
        "mapped",
        [
            18837
        ]
    ],
    [
        [
            195056,
            195056
        ],
        "mapped",
        [
            38327
        ]
    ],
    [
        [
            195057,
            195057
        ],
        "mapped",
        [
            167287
        ]
    ],
    [
        [
            195058,
            195058
        ],
        "mapped",
        [
            18918
        ]
    ],
    [
        [
            195059,
            195059
        ],
        "mapped",
        [
            38595
        ]
    ],
    [
        [
            195060,
            195060
        ],
        "mapped",
        [
            23986
        ]
    ],
    [
        [
            195061,
            195061
        ],
        "mapped",
        [
            38691
        ]
    ],
    [
        [
            195062,
            195062
        ],
        "mapped",
        [
            168261
        ]
    ],
    [
        [
            195063,
            195063
        ],
        "mapped",
        [
            168474
        ]
    ],
    [
        [
            195064,
            195064
        ],
        "mapped",
        [
            19054
        ]
    ],
    [
        [
            195065,
            195065
        ],
        "mapped",
        [
            19062
        ]
    ],
    [
        [
            195066,
            195066
        ],
        "mapped",
        [
            38880
        ]
    ],
    [
        [
            195067,
            195067
        ],
        "mapped",
        [
            168970
        ]
    ],
    [
        [
            195068,
            195068
        ],
        "mapped",
        [
            19122
        ]
    ],
    [
        [
            195069,
            195069
        ],
        "mapped",
        [
            169110
        ]
    ],
    [
        [
            195070,
            195071
        ],
        "mapped",
        [
            38923
        ]
    ],
    [
        [
            195072,
            195072
        ],
        "mapped",
        [
            38953
        ]
    ],
    [
        [
            195073,
            195073
        ],
        "mapped",
        [
            169398
        ]
    ],
    [
        [
            195074,
            195074
        ],
        "mapped",
        [
            39138
        ]
    ],
    [
        [
            195075,
            195075
        ],
        "mapped",
        [
            19251
        ]
    ],
    [
        [
            195076,
            195076
        ],
        "mapped",
        [
            39209
        ]
    ],
    [
        [
            195077,
            195077
        ],
        "mapped",
        [
            39335
        ]
    ],
    [
        [
            195078,
            195078
        ],
        "mapped",
        [
            39362
        ]
    ],
    [
        [
            195079,
            195079
        ],
        "mapped",
        [
            39422
        ]
    ],
    [
        [
            195080,
            195080
        ],
        "mapped",
        [
            19406
        ]
    ],
    [
        [
            195081,
            195081
        ],
        "mapped",
        [
            170800
        ]
    ],
    [
        [
            195082,
            195082
        ],
        "mapped",
        [
            39698
        ]
    ],
    [
        [
            195083,
            195083
        ],
        "mapped",
        [
            40000
        ]
    ],
    [
        [
            195084,
            195084
        ],
        "mapped",
        [
            40189
        ]
    ],
    [
        [
            195085,
            195085
        ],
        "mapped",
        [
            19662
        ]
    ],
    [
        [
            195086,
            195086
        ],
        "mapped",
        [
            19693
        ]
    ],
    [
        [
            195087,
            195087
        ],
        "mapped",
        [
            40295
        ]
    ],
    [
        [
            195088,
            195088
        ],
        "mapped",
        [
            172238
        ]
    ],
    [
        [
            195089,
            195089
        ],
        "mapped",
        [
            19704
        ]
    ],
    [
        [
            195090,
            195090
        ],
        "mapped",
        [
            172293
        ]
    ],
    [
        [
            195091,
            195091
        ],
        "mapped",
        [
            172558
        ]
    ],
    [
        [
            195092,
            195092
        ],
        "mapped",
        [
            172689
        ]
    ],
    [
        [
            195093,
            195093
        ],
        "mapped",
        [
            40635
        ]
    ],
    [
        [
            195094,
            195094
        ],
        "mapped",
        [
            19798
        ]
    ],
    [
        [
            195095,
            195095
        ],
        "mapped",
        [
            40697
        ]
    ],
    [
        [
            195096,
            195096
        ],
        "mapped",
        [
            40702
        ]
    ],
    [
        [
            195097,
            195097
        ],
        "mapped",
        [
            40709
        ]
    ],
    [
        [
            195098,
            195098
        ],
        "mapped",
        [
            40719
        ]
    ],
    [
        [
            195099,
            195099
        ],
        "mapped",
        [
            40726
        ]
    ],
    [
        [
            195100,
            195100
        ],
        "mapped",
        [
            40763
        ]
    ],
    [
        [
            195101,
            195101
        ],
        "mapped",
        [
            173568
        ]
    ],
    [
        [
            195102,
            196605
        ],
        "disallowed"
    ],
    [
        [
            196606,
            196607
        ],
        "disallowed"
    ],
    [
        [
            196608,
            262141
        ],
        "disallowed"
    ],
    [
        [
            262142,
            262143
        ],
        "disallowed"
    ],
    [
        [
            262144,
            327677
        ],
        "disallowed"
    ],
    [
        [
            327678,
            327679
        ],
        "disallowed"
    ],
    [
        [
            327680,
            393213
        ],
        "disallowed"
    ],
    [
        [
            393214,
            393215
        ],
        "disallowed"
    ],
    [
        [
            393216,
            458749
        ],
        "disallowed"
    ],
    [
        [
            458750,
            458751
        ],
        "disallowed"
    ],
    [
        [
            458752,
            524285
        ],
        "disallowed"
    ],
    [
        [
            524286,
            524287
        ],
        "disallowed"
    ],
    [
        [
            524288,
            589821
        ],
        "disallowed"
    ],
    [
        [
            589822,
            589823
        ],
        "disallowed"
    ],
    [
        [
            589824,
            655357
        ],
        "disallowed"
    ],
    [
        [
            655358,
            655359
        ],
        "disallowed"
    ],
    [
        [
            655360,
            720893
        ],
        "disallowed"
    ],
    [
        [
            720894,
            720895
        ],
        "disallowed"
    ],
    [
        [
            720896,
            786429
        ],
        "disallowed"
    ],
    [
        [
            786430,
            786431
        ],
        "disallowed"
    ],
    [
        [
            786432,
            851965
        ],
        "disallowed"
    ],
    [
        [
            851966,
            851967
        ],
        "disallowed"
    ],
    [
        [
            851968,
            917501
        ],
        "disallowed"
    ],
    [
        [
            917502,
            917503
        ],
        "disallowed"
    ],
    [
        [
            917504,
            917504
        ],
        "disallowed"
    ],
    [
        [
            917505,
            917505
        ],
        "disallowed"
    ],
    [
        [
            917506,
            917535
        ],
        "disallowed"
    ],
    [
        [
            917536,
            917631
        ],
        "disallowed"
    ],
    [
        [
            917632,
            917759
        ],
        "disallowed"
    ],
    [
        [
            917760,
            917999
        ],
        "ignored"
    ],
    [
        [
            918000,
            983037
        ],
        "disallowed"
    ],
    [
        [
            983038,
            983039
        ],
        "disallowed"
    ],
    [
        [
            983040,
            1048573
        ],
        "disallowed"
    ],
    [
        [
            1048574,
            1048575
        ],
        "disallowed"
    ],
    [
        [
            1048576,
            1114109
        ],
        "disallowed"
    ],
    [
        [
            1114110,
            1114111
        ],
        "disallowed"
    ]
];
var $3fe9119940fa16b8$var$punycode = $3fe9119940fa16b8$var$require$$0$1;
var $3fe9119940fa16b8$var$mappingTable = $3fe9119940fa16b8$var$require$$1;
var $3fe9119940fa16b8$var$PROCESSING_OPTIONS = {
    TRANSITIONAL: 0,
    NONTRANSITIONAL: 1
};
function $3fe9119940fa16b8$var$normalize(str) {
    return str.split('\u0000').map(function(s) {
        return s.normalize('NFC');
    }).join('\u0000');
}
function $3fe9119940fa16b8$var$findStatus(val) {
    var start = 0;
    var end = $3fe9119940fa16b8$var$mappingTable.length - 1;
    while(start <= end){
        var mid = Math.floor((start + end) / 2);
        var target = $3fe9119940fa16b8$var$mappingTable[mid];
        if (target[0][0] <= val && target[0][1] >= val) return target;
        else if (target[0][0] > val) end = mid - 1;
        else start = mid + 1;
    }
    return null;
}
var $3fe9119940fa16b8$var$regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
function $3fe9119940fa16b8$var$countSymbols(string) {
    return string// replace every surrogate pair with a BMP symbol
    .replace($3fe9119940fa16b8$var$regexAstralSymbols, '_')// then get the length
    .length;
}
function $3fe9119940fa16b8$var$mapChars(domain_name, useSTD3, processing_option) {
    var hasError = false;
    var processed = "";
    var len = $3fe9119940fa16b8$var$countSymbols(domain_name);
    for(var i = 0; i < len; ++i){
        var codePoint = domain_name.codePointAt(i);
        var status = $3fe9119940fa16b8$var$findStatus(codePoint);
        switch(status[1]){
            case "disallowed":
                hasError = true;
                processed += String.fromCodePoint(codePoint);
                break;
            case "ignored":
                break;
            case "mapped":
                processed += String.fromCodePoint.apply(String, status[2]);
                break;
            case "deviation":
                if (processing_option === $3fe9119940fa16b8$var$PROCESSING_OPTIONS.TRANSITIONAL) processed += String.fromCodePoint.apply(String, status[2]);
                else processed += String.fromCodePoint(codePoint);
                break;
            case "valid":
                processed += String.fromCodePoint(codePoint);
                break;
            case "disallowed_STD3_mapped":
                if (useSTD3) {
                    hasError = true;
                    processed += String.fromCodePoint(codePoint);
                } else processed += String.fromCodePoint.apply(String, status[2]);
                break;
            case "disallowed_STD3_valid":
                if (useSTD3) hasError = true;
                processed += String.fromCodePoint(codePoint);
                break;
        }
    }
    return {
        string: processed,
        error: hasError
    };
}
var $3fe9119940fa16b8$var$combiningMarksRegex = /[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E4-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D01-\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u192B\u1930-\u193B\u19B0-\u19C0\u19C8\u19C9\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFC-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2D]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC7F-\uDC82\uDCB0-\uDCBA\uDD00-\uDD02\uDD27-\uDD34\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDE2C-\uDE37\uDEDF-\uDEEA\uDF01-\uDF03\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDE30-\uDE40\uDEAB-\uDEB7]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF51-\uDF7E\uDF8F-\uDF92]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD83A[\uDCD0-\uDCD6]|\uDB40[\uDD00-\uDDEF]/;
function $3fe9119940fa16b8$var$validateLabel(label, processing_option) {
    if (label.substr(0, 4) === "xn--") {
        label = $3fe9119940fa16b8$var$punycode.toUnicode(label);
        $3fe9119940fa16b8$var$PROCESSING_OPTIONS.NONTRANSITIONAL;
    }
    var error = false;
    if ($3fe9119940fa16b8$var$normalize(label) !== label || label[3] === "-" && label[4] === "-" || label[0] === "-" || label[label.length - 1] === "-" || label.indexOf(".") !== -1 || label.search($3fe9119940fa16b8$var$combiningMarksRegex) === 0) error = true;
    var len = $3fe9119940fa16b8$var$countSymbols(label);
    for(var i = 0; i < len; ++i){
        var status = $3fe9119940fa16b8$var$findStatus(label.codePointAt(i));
        if ($3fe9119940fa16b8$var$processing === $3fe9119940fa16b8$var$PROCESSING_OPTIONS.TRANSITIONAL && status[1] !== "valid" || $3fe9119940fa16b8$var$processing === $3fe9119940fa16b8$var$PROCESSING_OPTIONS.NONTRANSITIONAL && status[1] !== "valid" && status[1] !== "deviation") {
            error = true;
            break;
        }
    }
    return {
        label: label,
        error: error
    };
}
function $3fe9119940fa16b8$var$processing(domain_name, useSTD3, processing_option) {
    var result = $3fe9119940fa16b8$var$mapChars(domain_name, useSTD3, processing_option);
    result.string = $3fe9119940fa16b8$var$normalize(result.string);
    var labels = result.string.split(".");
    for(var i = 0; i < labels.length; ++i)try {
        var validation = $3fe9119940fa16b8$var$validateLabel(labels[i]);
        labels[i] = validation.label;
        result.error = result.error || validation.error;
    } catch (e) {
        result.error = true;
    }
    return {
        string: labels.join("."),
        error: result.error
    };
}
$3fe9119940fa16b8$var$tr46.toASCII = function(domain_name, useSTD3, processing_option, verifyDnsLength) {
    var result = $3fe9119940fa16b8$var$processing(domain_name, useSTD3, processing_option);
    var labels = result.string.split(".");
    labels = labels.map(function(l) {
        try {
            return $3fe9119940fa16b8$var$punycode.toASCII(l);
        } catch (e) {
            result.error = true;
            return l;
        }
    });
    if (verifyDnsLength) {
        var total = labels.slice(0, labels.length - 1).join(".").length;
        if (total.length > 253 || total.length === 0) result.error = true;
        for(var i = 0; i < labels.length; ++i)if (labels.length > 63 || labels.length === 0) {
            result.error = true;
            break;
        }
    }
    if (result.error) return null;
    return labels.join(".");
};
$3fe9119940fa16b8$var$tr46.toUnicode = function(domain_name, useSTD3) {
    var result = $3fe9119940fa16b8$var$processing(domain_name, useSTD3, $3fe9119940fa16b8$var$PROCESSING_OPTIONS.NONTRANSITIONAL);
    return {
        domain: result.string,
        error: result.error
    };
};
$3fe9119940fa16b8$var$tr46.PROCESSING_OPTIONS = $3fe9119940fa16b8$var$PROCESSING_OPTIONS;
(function(module) {
    const punycode = $3fe9119940fa16b8$var$require$$0$1;
    const tr46$1 = $3fe9119940fa16b8$var$tr46;
    const specialSchemes = {
        ftp: 21,
        file: null,
        gopher: 70,
        http: 80,
        https: 443,
        ws: 80,
        wss: 443
    };
    const failure = Symbol("failure");
    function countSymbols(str) {
        return punycode.ucs2.decode(str).length;
    }
    function at(input, idx) {
        const c = input[idx];
        return isNaN(c) ? undefined : String.fromCodePoint(c);
    }
    function isASCIIDigit(c) {
        return c >= 0x30 && c <= 0x39;
    }
    function isASCIIAlpha(c) {
        return c >= 0x41 && c <= 0x5A || c >= 0x61 && c <= 0x7A;
    }
    function isASCIIAlphanumeric(c) {
        return isASCIIAlpha(c) || isASCIIDigit(c);
    }
    function isASCIIHex(c) {
        return isASCIIDigit(c) || c >= 0x41 && c <= 0x46 || c >= 0x61 && c <= 0x66;
    }
    function isSingleDot(buffer) {
        return buffer === "." || buffer.toLowerCase() === "%2e";
    }
    function isDoubleDot(buffer) {
        buffer = buffer.toLowerCase();
        return buffer === ".." || buffer === "%2e." || buffer === ".%2e" || buffer === "%2e%2e";
    }
    function isWindowsDriveLetterCodePoints(cp1, cp2) {
        return isASCIIAlpha(cp1) && (cp2 === 58 || cp2 === 124);
    }
    function isWindowsDriveLetterString(string) {
        return string.length === 2 && isASCIIAlpha(string.codePointAt(0)) && (string[1] === ":" || string[1] === "|");
    }
    function isNormalizedWindowsDriveLetterString(string) {
        return string.length === 2 && isASCIIAlpha(string.codePointAt(0)) && string[1] === ":";
    }
    function containsForbiddenHostCodePoint(string) {
        return string.search(/\u0000|\u0009|\u000A|\u000D|\u0020|#|%|\/|:|\?|@|\[|\\|\]/) !== -1;
    }
    function containsForbiddenHostCodePointExcludingPercent(string) {
        return string.search(/\u0000|\u0009|\u000A|\u000D|\u0020|#|\/|:|\?|@|\[|\\|\]/) !== -1;
    }
    function isSpecialScheme(scheme) {
        return specialSchemes[scheme] !== undefined;
    }
    function isSpecial(url) {
        return isSpecialScheme(url.scheme);
    }
    function defaultPort(scheme) {
        return specialSchemes[scheme];
    }
    function percentEncode(c) {
        let hex = c.toString(16).toUpperCase();
        if (hex.length === 1) hex = "0" + hex;
        return "%" + hex;
    }
    function utf8PercentEncode(c) {
        const buf = new $3fe9119940fa16b8$var$Buffer$1(c);
        let str = "";
        for(let i = 0; i < buf.length; ++i)str += percentEncode(buf[i]);
        return str;
    }
    function utf8PercentDecode(str) {
        const input = new $3fe9119940fa16b8$var$Buffer$1(str);
        const output = [];
        for(let i = 0; i < input.length; ++i){
            if (input[i] !== 37) output.push(input[i]);
            else if (input[i] === 37 && isASCIIHex(input[i + 1]) && isASCIIHex(input[i + 2])) {
                output.push(parseInt(input.slice(i + 1, i + 3).toString(), 16));
                i += 2;
            } else output.push(input[i]);
        }
        return new $3fe9119940fa16b8$var$Buffer$1(output).toString();
    }
    function isC0ControlPercentEncode(c) {
        return c <= 0x1F || c > 0x7E;
    }
    const extraPathPercentEncodeSet = new Set([
        32,
        34,
        35,
        60,
        62,
        63,
        96,
        123,
        125
    ]);
    function isPathPercentEncode(c) {
        return isC0ControlPercentEncode(c) || extraPathPercentEncodeSet.has(c);
    }
    const extraUserinfoPercentEncodeSet = new Set([
        47,
        58,
        59,
        61,
        64,
        91,
        92,
        93,
        94,
        124
    ]);
    function isUserinfoPercentEncode(c) {
        return isPathPercentEncode(c) || extraUserinfoPercentEncodeSet.has(c);
    }
    function percentEncodeChar(c, encodeSetPredicate) {
        const cStr = String.fromCodePoint(c);
        if (encodeSetPredicate(c)) return utf8PercentEncode(cStr);
        return cStr;
    }
    function parseIPv4Number(input) {
        let R = 10;
        if (input.length >= 2 && input.charAt(0) === "0" && input.charAt(1).toLowerCase() === "x") {
            input = input.substring(2);
            R = 16;
        } else if (input.length >= 2 && input.charAt(0) === "0") {
            input = input.substring(1);
            R = 8;
        }
        if (input === "") return 0;
        const regex = R === 10 ? /[^0-9]/ : R === 16 ? /[^0-9A-Fa-f]/ : /[^0-7]/;
        if (regex.test(input)) return failure;
        return parseInt(input, R);
    }
    function parseIPv4(input) {
        const parts = input.split(".");
        if (parts[parts.length - 1] === "") {
            if (parts.length > 1) parts.pop();
        }
        if (parts.length > 4) return input;
        const numbers = [];
        for (const part of parts){
            if (part === "") return input;
            const n = parseIPv4Number(part);
            if (n === failure) return input;
            numbers.push(n);
        }
        for(let i = 0; i < numbers.length - 1; ++i){
            if (numbers[i] > 255) return failure;
        }
        if (numbers[numbers.length - 1] >= Math.pow(256, 5 - numbers.length)) return failure;
        let ipv4 = numbers.pop();
        let counter = 0;
        for (const n of numbers){
            ipv4 += n * Math.pow(256, 3 - counter);
            ++counter;
        }
        return ipv4;
    }
    function serializeIPv4(address) {
        let output = "";
        let n = address;
        for(let i = 1; i <= 4; ++i){
            output = String(n % 256) + output;
            if (i !== 4) output = "." + output;
            n = Math.floor(n / 256);
        }
        return output;
    }
    function parseIPv6(input) {
        const address = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        let pieceIndex = 0;
        let compress = null;
        let pointer = 0;
        input = punycode.ucs2.decode(input);
        if (input[pointer] === 58) {
            if (input[pointer + 1] !== 58) return failure;
            pointer += 2;
            ++pieceIndex;
            compress = pieceIndex;
        }
        while(pointer < input.length){
            if (pieceIndex === 8) return failure;
            if (input[pointer] === 58) {
                if (compress !== null) return failure;
                ++pointer;
                ++pieceIndex;
                compress = pieceIndex;
                continue;
            }
            let value = 0;
            let length = 0;
            while(length < 4 && isASCIIHex(input[pointer])){
                value = value * 0x10 + parseInt(at(input, pointer), 16);
                ++pointer;
                ++length;
            }
            if (input[pointer] === 46) {
                if (length === 0) return failure;
                pointer -= length;
                if (pieceIndex > 6) return failure;
                let numbersSeen = 0;
                while(input[pointer] !== undefined){
                    let ipv4Piece = null;
                    if (numbersSeen > 0) {
                        if (input[pointer] === 46 && numbersSeen < 4) ++pointer;
                        else return failure;
                    }
                    if (!isASCIIDigit(input[pointer])) return failure;
                    while(isASCIIDigit(input[pointer])){
                        const number = parseInt(at(input, pointer));
                        if (ipv4Piece === null) ipv4Piece = number;
                        else if (ipv4Piece === 0) return failure;
                        else ipv4Piece = ipv4Piece * 10 + number;
                        if (ipv4Piece > 255) return failure;
                        ++pointer;
                    }
                    address[pieceIndex] = address[pieceIndex] * 0x100 + ipv4Piece;
                    ++numbersSeen;
                    if (numbersSeen === 2 || numbersSeen === 4) ++pieceIndex;
                }
                if (numbersSeen !== 4) return failure;
                break;
            } else if (input[pointer] === 58) {
                ++pointer;
                if (input[pointer] === undefined) return failure;
            } else if (input[pointer] !== undefined) return failure;
            address[pieceIndex] = value;
            ++pieceIndex;
        }
        if (compress !== null) {
            let swaps = pieceIndex - compress;
            pieceIndex = 7;
            while(pieceIndex !== 0 && swaps > 0){
                const temp = address[compress + swaps - 1];
                address[compress + swaps - 1] = address[pieceIndex];
                address[pieceIndex] = temp;
                --pieceIndex;
                --swaps;
            }
        } else if (compress === null && pieceIndex !== 8) return failure;
        return address;
    }
    function serializeIPv6(address) {
        let output = "";
        const seqResult = findLongestZeroSequence(address);
        const compress = seqResult.idx;
        let ignore0 = false;
        for(let pieceIndex = 0; pieceIndex <= 7; ++pieceIndex){
            if (ignore0 && address[pieceIndex] === 0) continue;
            else if (ignore0) ignore0 = false;
            if (compress === pieceIndex) {
                const separator = pieceIndex === 0 ? "::" : ":";
                output += separator;
                ignore0 = true;
                continue;
            }
            output += address[pieceIndex].toString(16);
            if (pieceIndex !== 7) output += ":";
        }
        return output;
    }
    function parseHost(input, isSpecialArg) {
        if (input[0] === "[") {
            if (input[input.length - 1] !== "]") return failure;
            return parseIPv6(input.substring(1, input.length - 1));
        }
        if (!isSpecialArg) return parseOpaqueHost(input);
        const domain = utf8PercentDecode(input);
        const asciiDomain = tr46$1.toASCII(domain, false, tr46$1.PROCESSING_OPTIONS.NONTRANSITIONAL, false);
        if (asciiDomain === null) return failure;
        if (containsForbiddenHostCodePoint(asciiDomain)) return failure;
        const ipv4Host = parseIPv4(asciiDomain);
        if (typeof ipv4Host === "number" || ipv4Host === failure) return ipv4Host;
        return asciiDomain;
    }
    function parseOpaqueHost(input) {
        if (containsForbiddenHostCodePointExcludingPercent(input)) return failure;
        let output = "";
        const decoded = punycode.ucs2.decode(input);
        for(let i = 0; i < decoded.length; ++i)output += percentEncodeChar(decoded[i], isC0ControlPercentEncode);
        return output;
    }
    function findLongestZeroSequence(arr) {
        let maxIdx = null;
        let maxLen = 1; // only find elements > 1
        let currStart = null;
        let currLen = 0;
        for(let i = 0; i < arr.length; ++i)if (arr[i] !== 0) {
            if (currLen > maxLen) {
                maxIdx = currStart;
                maxLen = currLen;
            }
            currStart = null;
            currLen = 0;
        } else {
            if (currStart === null) currStart = i;
            ++currLen;
        }
        // if trailing zeros
        if (currLen > maxLen) {
            maxIdx = currStart;
            maxLen = currLen;
        }
        return {
            idx: maxIdx,
            len: maxLen
        };
    }
    function serializeHost(host) {
        if (typeof host === "number") return serializeIPv4(host);
        // IPv6 serializer
        if (host instanceof Array) return "[" + serializeIPv6(host) + "]";
        return host;
    }
    function trimControlChars(url) {
        return url.replace(/^[\u0000-\u001F\u0020]+|[\u0000-\u001F\u0020]+$/g, "");
    }
    function trimTabAndNewline(url) {
        return url.replace(/\u0009|\u000A|\u000D/g, "");
    }
    function shortenPath(url) {
        const path = url.path;
        if (path.length === 0) return;
        if (url.scheme === "file" && path.length === 1 && isNormalizedWindowsDriveLetter(path[0])) return;
        path.pop();
    }
    function includesCredentials(url) {
        return url.username !== "" || url.password !== "";
    }
    function cannotHaveAUsernamePasswordPort(url) {
        return url.host === null || url.host === "" || url.cannotBeABaseURL || url.scheme === "file";
    }
    function isNormalizedWindowsDriveLetter(string) {
        return /^[A-Za-z]:$/.test(string);
    }
    function URLStateMachine(input, base, encodingOverride, url, stateOverride) {
        this.pointer = 0;
        this.input = input;
        this.base = base || null;
        this.encodingOverride = encodingOverride || "utf-8";
        this.stateOverride = stateOverride;
        this.url = url;
        this.failure = false;
        this.parseError = false;
        if (!this.url) {
            this.url = {
                scheme: "",
                username: "",
                password: "",
                host: null,
                port: null,
                path: [],
                query: null,
                fragment: null,
                cannotBeABaseURL: false
            };
            const res = trimControlChars(this.input);
            if (res !== this.input) this.parseError = true;
            this.input = res;
        }
        const res = trimTabAndNewline(this.input);
        if (res !== this.input) this.parseError = true;
        this.input = res;
        this.state = stateOverride || "scheme start";
        this.buffer = "";
        this.atFlag = false;
        this.arrFlag = false;
        this.passwordTokenSeenFlag = false;
        this.input = punycode.ucs2.decode(this.input);
        for(; this.pointer <= this.input.length; ++this.pointer){
            const c = this.input[this.pointer];
            const cStr = isNaN(c) ? undefined : String.fromCodePoint(c);
            // exec state machine
            const ret = this["parse " + this.state](c, cStr);
            if (!ret) break; // terminate algorithm
            else if (ret === failure) {
                this.failure = true;
                break;
            }
        }
    }
    URLStateMachine.prototype["parse scheme start"] = function parseSchemeStart(c, cStr) {
        if (isASCIIAlpha(c)) {
            this.buffer += cStr.toLowerCase();
            this.state = "scheme";
        } else if (!this.stateOverride) {
            this.state = "no scheme";
            --this.pointer;
        } else {
            this.parseError = true;
            return failure;
        }
        return true;
    };
    URLStateMachine.prototype["parse scheme"] = function parseScheme(c, cStr) {
        if (isASCIIAlphanumeric(c) || c === 43 || c === 45 || c === 46) this.buffer += cStr.toLowerCase();
        else if (c === 58) {
            if (this.stateOverride) {
                if (isSpecial(this.url) && !isSpecialScheme(this.buffer)) return false;
                if (!isSpecial(this.url) && isSpecialScheme(this.buffer)) return false;
                if ((includesCredentials(this.url) || this.url.port !== null) && this.buffer === "file") return false;
                if (this.url.scheme === "file" && (this.url.host === "" || this.url.host === null)) return false;
            }
            this.url.scheme = this.buffer;
            this.buffer = "";
            if (this.stateOverride) return false;
            if (this.url.scheme === "file") {
                if (this.input[this.pointer + 1] !== 47 || this.input[this.pointer + 2] !== 47) this.parseError = true;
                this.state = "file";
            } else if (isSpecial(this.url) && this.base !== null && this.base.scheme === this.url.scheme) this.state = "special relative or authority";
            else if (isSpecial(this.url)) this.state = "special authority slashes";
            else if (this.input[this.pointer + 1] === 47) {
                this.state = "path or authority";
                ++this.pointer;
            } else {
                this.url.cannotBeABaseURL = true;
                this.url.path.push("");
                this.state = "cannot-be-a-base-URL path";
            }
        } else if (!this.stateOverride) {
            this.buffer = "";
            this.state = "no scheme";
            this.pointer = -1;
        } else {
            this.parseError = true;
            return failure;
        }
        return true;
    };
    URLStateMachine.prototype["parse no scheme"] = function parseNoScheme(c) {
        if (this.base === null || this.base.cannotBeABaseURL && c !== 35) return failure;
        else if (this.base.cannotBeABaseURL && c === 35) {
            this.url.scheme = this.base.scheme;
            this.url.path = this.base.path.slice();
            this.url.query = this.base.query;
            this.url.fragment = "";
            this.url.cannotBeABaseURL = true;
            this.state = "fragment";
        } else if (this.base.scheme === "file") {
            this.state = "file";
            --this.pointer;
        } else {
            this.state = "relative";
            --this.pointer;
        }
        return true;
    };
    URLStateMachine.prototype["parse special relative or authority"] = function parseSpecialRelativeOrAuthority(c) {
        if (c === 47 && this.input[this.pointer + 1] === 47) {
            this.state = "special authority ignore slashes";
            ++this.pointer;
        } else {
            this.parseError = true;
            this.state = "relative";
            --this.pointer;
        }
        return true;
    };
    URLStateMachine.prototype["parse path or authority"] = function parsePathOrAuthority(c) {
        if (c === 47) this.state = "authority";
        else {
            this.state = "path";
            --this.pointer;
        }
        return true;
    };
    URLStateMachine.prototype["parse relative"] = function parseRelative(c) {
        this.url.scheme = this.base.scheme;
        if (isNaN(c)) {
            this.url.username = this.base.username;
            this.url.password = this.base.password;
            this.url.host = this.base.host;
            this.url.port = this.base.port;
            this.url.path = this.base.path.slice();
            this.url.query = this.base.query;
        } else if (c === 47) this.state = "relative slash";
        else if (c === 63) {
            this.url.username = this.base.username;
            this.url.password = this.base.password;
            this.url.host = this.base.host;
            this.url.port = this.base.port;
            this.url.path = this.base.path.slice();
            this.url.query = "";
            this.state = "query";
        } else if (c === 35) {
            this.url.username = this.base.username;
            this.url.password = this.base.password;
            this.url.host = this.base.host;
            this.url.port = this.base.port;
            this.url.path = this.base.path.slice();
            this.url.query = this.base.query;
            this.url.fragment = "";
            this.state = "fragment";
        } else if (isSpecial(this.url) && c === 92) {
            this.parseError = true;
            this.state = "relative slash";
        } else {
            this.url.username = this.base.username;
            this.url.password = this.base.password;
            this.url.host = this.base.host;
            this.url.port = this.base.port;
            this.url.path = this.base.path.slice(0, this.base.path.length - 1);
            this.state = "path";
            --this.pointer;
        }
        return true;
    };
    URLStateMachine.prototype["parse relative slash"] = function parseRelativeSlash(c) {
        if (isSpecial(this.url) && (c === 47 || c === 92)) {
            if (c === 92) this.parseError = true;
            this.state = "special authority ignore slashes";
        } else if (c === 47) this.state = "authority";
        else {
            this.url.username = this.base.username;
            this.url.password = this.base.password;
            this.url.host = this.base.host;
            this.url.port = this.base.port;
            this.state = "path";
            --this.pointer;
        }
        return true;
    };
    URLStateMachine.prototype["parse special authority slashes"] = function parseSpecialAuthoritySlashes(c) {
        if (c === 47 && this.input[this.pointer + 1] === 47) {
            this.state = "special authority ignore slashes";
            ++this.pointer;
        } else {
            this.parseError = true;
            this.state = "special authority ignore slashes";
            --this.pointer;
        }
        return true;
    };
    URLStateMachine.prototype["parse special authority ignore slashes"] = function parseSpecialAuthorityIgnoreSlashes(c) {
        if (c !== 47 && c !== 92) {
            this.state = "authority";
            --this.pointer;
        } else this.parseError = true;
        return true;
    };
    URLStateMachine.prototype["parse authority"] = function parseAuthority(c, cStr) {
        if (c === 64) {
            this.parseError = true;
            if (this.atFlag) this.buffer = "%40" + this.buffer;
            this.atFlag = true;
            // careful, this is based on buffer and has its own pointer (this.pointer != pointer) and inner chars
            const len = countSymbols(this.buffer);
            for(let pointer = 0; pointer < len; ++pointer){
                const codePoint = this.buffer.codePointAt(pointer);
                if (codePoint === 58 && !this.passwordTokenSeenFlag) {
                    this.passwordTokenSeenFlag = true;
                    continue;
                }
                const encodedCodePoints = percentEncodeChar(codePoint, isUserinfoPercentEncode);
                if (this.passwordTokenSeenFlag) this.url.password += encodedCodePoints;
                else this.url.username += encodedCodePoints;
            }
            this.buffer = "";
        } else if (isNaN(c) || c === 47 || c === 63 || c === 35 || isSpecial(this.url) && c === 92) {
            if (this.atFlag && this.buffer === "") {
                this.parseError = true;
                return failure;
            }
            this.pointer -= countSymbols(this.buffer) + 1;
            this.buffer = "";
            this.state = "host";
        } else this.buffer += cStr;
        return true;
    };
    URLStateMachine.prototype["parse hostname"] = URLStateMachine.prototype["parse host"] = function parseHostName(c, cStr) {
        if (this.stateOverride && this.url.scheme === "file") {
            --this.pointer;
            this.state = "file host";
        } else if (c === 58 && !this.arrFlag) {
            if (this.buffer === "") {
                this.parseError = true;
                return failure;
            }
            const host = parseHost(this.buffer, isSpecial(this.url));
            if (host === failure) return failure;
            this.url.host = host;
            this.buffer = "";
            this.state = "port";
            if (this.stateOverride === "hostname") return false;
        } else if (isNaN(c) || c === 47 || c === 63 || c === 35 || isSpecial(this.url) && c === 92) {
            --this.pointer;
            if (isSpecial(this.url) && this.buffer === "") {
                this.parseError = true;
                return failure;
            } else if (this.stateOverride && this.buffer === "" && (includesCredentials(this.url) || this.url.port !== null)) {
                this.parseError = true;
                return false;
            }
            const host = parseHost(this.buffer, isSpecial(this.url));
            if (host === failure) return failure;
            this.url.host = host;
            this.buffer = "";
            this.state = "path start";
            if (this.stateOverride) return false;
        } else {
            if (c === 91) this.arrFlag = true;
            else if (c === 93) this.arrFlag = false;
            this.buffer += cStr;
        }
        return true;
    };
    URLStateMachine.prototype["parse port"] = function parsePort(c, cStr) {
        if (isASCIIDigit(c)) this.buffer += cStr;
        else if (isNaN(c) || c === 47 || c === 63 || c === 35 || isSpecial(this.url) && c === 92 || this.stateOverride) {
            if (this.buffer !== "") {
                const port = parseInt(this.buffer);
                if (port > Math.pow(2, 16) - 1) {
                    this.parseError = true;
                    return failure;
                }
                this.url.port = port === defaultPort(this.url.scheme) ? null : port;
                this.buffer = "";
            }
            if (this.stateOverride) return false;
            this.state = "path start";
            --this.pointer;
        } else {
            this.parseError = true;
            return failure;
        }
        return true;
    };
    const fileOtherwiseCodePoints = new Set([
        47,
        92,
        63,
        35
    ]);
    URLStateMachine.prototype["parse file"] = function parseFile(c) {
        this.url.scheme = "file";
        if (c === 47 || c === 92) {
            if (c === 92) this.parseError = true;
            this.state = "file slash";
        } else if (this.base !== null && this.base.scheme === "file") {
            if (isNaN(c)) {
                this.url.host = this.base.host;
                this.url.path = this.base.path.slice();
                this.url.query = this.base.query;
            } else if (c === 63) {
                this.url.host = this.base.host;
                this.url.path = this.base.path.slice();
                this.url.query = "";
                this.state = "query";
            } else if (c === 35) {
                this.url.host = this.base.host;
                this.url.path = this.base.path.slice();
                this.url.query = this.base.query;
                this.url.fragment = "";
                this.state = "fragment";
            } else {
                if (this.input.length - this.pointer - 1 === 0 || // remaining consists of 0 code points
                !isWindowsDriveLetterCodePoints(c, this.input[this.pointer + 1]) || this.input.length - this.pointer - 1 >= 2 && // remaining has at least 2 code points
                !fileOtherwiseCodePoints.has(this.input[this.pointer + 2])) {
                    this.url.host = this.base.host;
                    this.url.path = this.base.path.slice();
                    shortenPath(this.url);
                } else this.parseError = true;
                this.state = "path";
                --this.pointer;
            }
        } else {
            this.state = "path";
            --this.pointer;
        }
        return true;
    };
    URLStateMachine.prototype["parse file slash"] = function parseFileSlash(c) {
        if (c === 47 || c === 92) {
            if (c === 92) this.parseError = true;
            this.state = "file host";
        } else {
            if (this.base !== null && this.base.scheme === "file") {
                if (isNormalizedWindowsDriveLetterString(this.base.path[0])) this.url.path.push(this.base.path[0]);
                else this.url.host = this.base.host;
            }
            this.state = "path";
            --this.pointer;
        }
        return true;
    };
    URLStateMachine.prototype["parse file host"] = function parseFileHost(c, cStr) {
        if (isNaN(c) || c === 47 || c === 92 || c === 63 || c === 35) {
            --this.pointer;
            if (!this.stateOverride && isWindowsDriveLetterString(this.buffer)) {
                this.parseError = true;
                this.state = "path";
            } else if (this.buffer === "") {
                this.url.host = "";
                if (this.stateOverride) return false;
                this.state = "path start";
            } else {
                let host = parseHost(this.buffer, isSpecial(this.url));
                if (host === failure) return failure;
                if (host === "localhost") host = "";
                this.url.host = host;
                if (this.stateOverride) return false;
                this.buffer = "";
                this.state = "path start";
            }
        } else this.buffer += cStr;
        return true;
    };
    URLStateMachine.prototype["parse path start"] = function parsePathStart(c) {
        if (isSpecial(this.url)) {
            if (c === 92) this.parseError = true;
            this.state = "path";
            if (c !== 47 && c !== 92) --this.pointer;
        } else if (!this.stateOverride && c === 63) {
            this.url.query = "";
            this.state = "query";
        } else if (!this.stateOverride && c === 35) {
            this.url.fragment = "";
            this.state = "fragment";
        } else if (c !== undefined) {
            this.state = "path";
            if (c !== 47) --this.pointer;
        }
        return true;
    };
    URLStateMachine.prototype["parse path"] = function parsePath(c) {
        if (isNaN(c) || c === 47 || isSpecial(this.url) && c === 92 || !this.stateOverride && (c === 63 || c === 35)) {
            if (isSpecial(this.url) && c === 92) this.parseError = true;
            if (isDoubleDot(this.buffer)) {
                shortenPath(this.url);
                if (c !== 47 && !(isSpecial(this.url) && c === 92)) this.url.path.push("");
            } else if (isSingleDot(this.buffer) && c !== 47 && !(isSpecial(this.url) && c === 92)) this.url.path.push("");
            else if (!isSingleDot(this.buffer)) {
                if (this.url.scheme === "file" && this.url.path.length === 0 && isWindowsDriveLetterString(this.buffer)) {
                    if (this.url.host !== "" && this.url.host !== null) {
                        this.parseError = true;
                        this.url.host = "";
                    }
                    this.buffer = this.buffer[0] + ":";
                }
                this.url.path.push(this.buffer);
            }
            this.buffer = "";
            if (this.url.scheme === "file" && (c === undefined || c === 63 || c === 35)) while(this.url.path.length > 1 && this.url.path[0] === ""){
                this.parseError = true;
                this.url.path.shift();
            }
            if (c === 63) {
                this.url.query = "";
                this.state = "query";
            }
            if (c === 35) {
                this.url.fragment = "";
                this.state = "fragment";
            }
        } else {
            // TODO: If c is not a URL code point and not "%", parse error.
            if (c === 37 && (!isASCIIHex(this.input[this.pointer + 1]) || !isASCIIHex(this.input[this.pointer + 2]))) this.parseError = true;
            this.buffer += percentEncodeChar(c, isPathPercentEncode);
        }
        return true;
    };
    URLStateMachine.prototype["parse cannot-be-a-base-URL path"] = function parseCannotBeABaseURLPath(c) {
        if (c === 63) {
            this.url.query = "";
            this.state = "query";
        } else if (c === 35) {
            this.url.fragment = "";
            this.state = "fragment";
        } else {
            // TODO: Add: not a URL code point
            if (!isNaN(c) && c !== 37) this.parseError = true;
            if (c === 37 && (!isASCIIHex(this.input[this.pointer + 1]) || !isASCIIHex(this.input[this.pointer + 2]))) this.parseError = true;
            if (!isNaN(c)) this.url.path[0] = this.url.path[0] + percentEncodeChar(c, isC0ControlPercentEncode);
        }
        return true;
    };
    URLStateMachine.prototype["parse query"] = function parseQuery(c, cStr) {
        if (isNaN(c) || !this.stateOverride && c === 35) {
            if (!isSpecial(this.url) || this.url.scheme === "ws" || this.url.scheme === "wss") this.encodingOverride = "utf-8";
            const buffer = new $3fe9119940fa16b8$var$Buffer$1(this.buffer); // TODO: Use encoding override instead
            for(let i = 0; i < buffer.length; ++i)if (buffer[i] < 0x21 || buffer[i] > 0x7E || buffer[i] === 0x22 || buffer[i] === 0x23 || buffer[i] === 0x3C || buffer[i] === 0x3E) this.url.query += percentEncode(buffer[i]);
            else this.url.query += String.fromCodePoint(buffer[i]);
            this.buffer = "";
            if (c === 35) {
                this.url.fragment = "";
                this.state = "fragment";
            }
        } else {
            // TODO: If c is not a URL code point and not "%", parse error.
            if (c === 37 && (!isASCIIHex(this.input[this.pointer + 1]) || !isASCIIHex(this.input[this.pointer + 2]))) this.parseError = true;
            this.buffer += cStr;
        }
        return true;
    };
    URLStateMachine.prototype["parse fragment"] = function parseFragment(c) {
        if (isNaN(c)) ;
        else if (c === 0x0) this.parseError = true;
        else {
            // TODO: If c is not a URL code point and not "%", parse error.
            if (c === 37 && (!isASCIIHex(this.input[this.pointer + 1]) || !isASCIIHex(this.input[this.pointer + 2]))) this.parseError = true;
            this.url.fragment += percentEncodeChar(c, isC0ControlPercentEncode);
        }
        return true;
    };
    function serializeURL(url, excludeFragment) {
        let output = url.scheme + ":";
        if (url.host !== null) {
            output += "//";
            if (url.username !== "" || url.password !== "") {
                output += url.username;
                if (url.password !== "") output += ":" + url.password;
                output += "@";
            }
            output += serializeHost(url.host);
            if (url.port !== null) output += ":" + url.port;
        } else if (url.host === null && url.scheme === "file") output += "//";
        if (url.cannotBeABaseURL) output += url.path[0];
        else for (const string of url.path)output += "/" + string;
        if (url.query !== null) output += "?" + url.query;
        if (!excludeFragment && url.fragment !== null) output += "#" + url.fragment;
        return output;
    }
    function serializeOrigin(tuple) {
        let result = tuple.scheme + "://";
        result += serializeHost(tuple.host);
        if (tuple.port !== null) result += ":" + tuple.port;
        return result;
    }
    module.exports.serializeURL = serializeURL;
    module.exports.serializeURLOrigin = function(url) {
        // https://url.spec.whatwg.org/#concept-url-origin
        switch(url.scheme){
            case "blob":
                try {
                    return module.exports.serializeURLOrigin(module.exports.parseURL(url.path[0]));
                } catch (e) {
                    // serializing an opaque origin returns "null"
                    return "null";
                }
            case "ftp":
            case "gopher":
            case "http":
            case "https":
            case "ws":
            case "wss":
                return serializeOrigin({
                    scheme: url.scheme,
                    host: url.host,
                    port: url.port
                });
            case "file":
                // spec says "exercise to the reader", chrome says "file://"
                return "file://";
            default:
                // serializing an opaque origin returns "null"
                return "null";
        }
    };
    module.exports.basicURLParse = function(input, options) {
        if (options === undefined) options = {};
        const usm = new URLStateMachine(input, options.baseURL, options.encodingOverride, options.url, options.stateOverride);
        if (usm.failure) return "failure";
        return usm.url;
    };
    module.exports.setTheUsername = function(url, username) {
        url.username = "";
        const decoded = punycode.ucs2.decode(username);
        for(let i = 0; i < decoded.length; ++i)url.username += percentEncodeChar(decoded[i], isUserinfoPercentEncode);
    };
    module.exports.setThePassword = function(url, password) {
        url.password = "";
        const decoded = punycode.ucs2.decode(password);
        for(let i = 0; i < decoded.length; ++i)url.password += percentEncodeChar(decoded[i], isUserinfoPercentEncode);
    };
    module.exports.serializeHost = serializeHost;
    module.exports.cannotHaveAUsernamePasswordPort = cannotHaveAUsernamePasswordPort;
    module.exports.serializeInteger = function(integer) {
        return String(integer);
    };
    module.exports.parseURL = function(input, options) {
        if (options === undefined) options = {};
        // We don't handle blobs, so this just delegates:
        return module.exports.basicURLParse(input, {
            baseURL: options.baseURL,
            encodingOverride: options.encodingOverride
        });
    };
})($3fe9119940fa16b8$var$urlStateMachine);
var $3fe9119940fa16b8$var$urlStateMachineExports = $3fe9119940fa16b8$var$urlStateMachine.exports;
const $3fe9119940fa16b8$var$usm = $3fe9119940fa16b8$var$urlStateMachineExports;
$3fe9119940fa16b8$var$URLImpl.implementation = class URLImpl {
    constructor(constructorArgs){
        const url = constructorArgs[0];
        const base = constructorArgs[1];
        let parsedBase = null;
        if (base !== undefined) {
            parsedBase = $3fe9119940fa16b8$var$usm.basicURLParse(base);
            if (parsedBase === "failure") throw new TypeError("Invalid base URL");
        }
        const parsedURL = $3fe9119940fa16b8$var$usm.basicURLParse(url, {
            baseURL: parsedBase
        });
        if (parsedURL === "failure") throw new TypeError("Invalid URL");
        this._url = parsedURL;
    // TODO: query stuff
    }
    get href() {
        return $3fe9119940fa16b8$var$usm.serializeURL(this._url);
    }
    set href(v) {
        const parsedURL = $3fe9119940fa16b8$var$usm.basicURLParse(v);
        if (parsedURL === "failure") throw new TypeError("Invalid URL");
        this._url = parsedURL;
    }
    get origin() {
        return $3fe9119940fa16b8$var$usm.serializeURLOrigin(this._url);
    }
    get protocol() {
        return this._url.scheme + ":";
    }
    set protocol(v) {
        $3fe9119940fa16b8$var$usm.basicURLParse(v + ":", {
            url: this._url,
            stateOverride: "scheme start"
        });
    }
    get username() {
        return this._url.username;
    }
    set username(v) {
        if ($3fe9119940fa16b8$var$usm.cannotHaveAUsernamePasswordPort(this._url)) return;
        $3fe9119940fa16b8$var$usm.setTheUsername(this._url, v);
    }
    get password() {
        return this._url.password;
    }
    set password(v) {
        if ($3fe9119940fa16b8$var$usm.cannotHaveAUsernamePasswordPort(this._url)) return;
        $3fe9119940fa16b8$var$usm.setThePassword(this._url, v);
    }
    get host() {
        const url = this._url;
        if (url.host === null) return "";
        if (url.port === null) return $3fe9119940fa16b8$var$usm.serializeHost(url.host);
        return $3fe9119940fa16b8$var$usm.serializeHost(url.host) + ":" + $3fe9119940fa16b8$var$usm.serializeInteger(url.port);
    }
    set host(v) {
        if (this._url.cannotBeABaseURL) return;
        $3fe9119940fa16b8$var$usm.basicURLParse(v, {
            url: this._url,
            stateOverride: "host"
        });
    }
    get hostname() {
        if (this._url.host === null) return "";
        return $3fe9119940fa16b8$var$usm.serializeHost(this._url.host);
    }
    set hostname(v) {
        if (this._url.cannotBeABaseURL) return;
        $3fe9119940fa16b8$var$usm.basicURLParse(v, {
            url: this._url,
            stateOverride: "hostname"
        });
    }
    get port() {
        if (this._url.port === null) return "";
        return $3fe9119940fa16b8$var$usm.serializeInteger(this._url.port);
    }
    set port(v) {
        if ($3fe9119940fa16b8$var$usm.cannotHaveAUsernamePasswordPort(this._url)) return;
        if (v === "") this._url.port = null;
        else $3fe9119940fa16b8$var$usm.basicURLParse(v, {
            url: this._url,
            stateOverride: "port"
        });
    }
    get pathname() {
        if (this._url.cannotBeABaseURL) return this._url.path[0];
        if (this._url.path.length === 0) return "";
        return "/" + this._url.path.join("/");
    }
    set pathname(v) {
        if (this._url.cannotBeABaseURL) return;
        this._url.path = [];
        $3fe9119940fa16b8$var$usm.basicURLParse(v, {
            url: this._url,
            stateOverride: "path start"
        });
    }
    get search() {
        if (this._url.query === null || this._url.query === "") return "";
        return "?" + this._url.query;
    }
    set search(v) {
        // TODO: query stuff
        const url = this._url;
        if (v === "") {
            url.query = null;
            return;
        }
        const input = v[0] === "?" ? v.substring(1) : v;
        url.query = "";
        $3fe9119940fa16b8$var$usm.basicURLParse(input, {
            url: url,
            stateOverride: "query"
        });
    }
    get hash() {
        if (this._url.fragment === null || this._url.fragment === "") return "";
        return "#" + this._url.fragment;
    }
    set hash(v) {
        if (v === "") {
            this._url.fragment = null;
            return;
        }
        const input = v[0] === "#" ? v.substring(1) : v;
        this._url.fragment = "";
        $3fe9119940fa16b8$var$usm.basicURLParse(input, {
            url: this._url,
            stateOverride: "fragment"
        });
    }
    toJSON() {
        return this.href;
    }
};
(function(module) {
    const conversions = $3fe9119940fa16b8$var$lib$1;
    const utils = $3fe9119940fa16b8$var$utilsExports;
    const Impl = $3fe9119940fa16b8$var$URLImpl;
    const impl = utils.implSymbol;
    function URL(url) {
        if (!this || this[impl] || !(this instanceof URL)) throw new TypeError("Failed to construct 'URL': Please use the 'new' operator, this DOM object constructor cannot be called as a function.");
        if (arguments.length < 1) throw new TypeError("Failed to construct 'URL': 1 argument required, but only " + arguments.length + " present.");
        const args = [];
        for(let i = 0; i < arguments.length && i < 2; ++i)args[i] = arguments[i];
        args[0] = conversions["USVString"](args[0]);
        if (args[1] !== undefined) args[1] = conversions["USVString"](args[1]);
        module.exports.setup(this, args);
    }
    URL.prototype.toJSON = function toJSON() {
        if (!this || !module.exports.is(this)) throw new TypeError("Illegal invocation");
        const args = [];
        for(let i = 0; i < arguments.length && i < 0; ++i)args[i] = arguments[i];
        return this[impl].toJSON.apply(this[impl], args);
    };
    Object.defineProperty(URL.prototype, "href", {
        get () {
            return this[impl].href;
        },
        set (V) {
            V = conversions["USVString"](V);
            this[impl].href = V;
        },
        enumerable: true,
        configurable: true
    });
    URL.prototype.toString = function() {
        if (!this || !module.exports.is(this)) throw new TypeError("Illegal invocation");
        return this.href;
    };
    Object.defineProperty(URL.prototype, "origin", {
        get () {
            return this[impl].origin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "protocol", {
        get () {
            return this[impl].protocol;
        },
        set (V) {
            V = conversions["USVString"](V);
            this[impl].protocol = V;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "username", {
        get () {
            return this[impl].username;
        },
        set (V) {
            V = conversions["USVString"](V);
            this[impl].username = V;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "password", {
        get () {
            return this[impl].password;
        },
        set (V) {
            V = conversions["USVString"](V);
            this[impl].password = V;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "host", {
        get () {
            return this[impl].host;
        },
        set (V) {
            V = conversions["USVString"](V);
            this[impl].host = V;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "hostname", {
        get () {
            return this[impl].hostname;
        },
        set (V) {
            V = conversions["USVString"](V);
            this[impl].hostname = V;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "port", {
        get () {
            return this[impl].port;
        },
        set (V) {
            V = conversions["USVString"](V);
            this[impl].port = V;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "pathname", {
        get () {
            return this[impl].pathname;
        },
        set (V) {
            V = conversions["USVString"](V);
            this[impl].pathname = V;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "search", {
        get () {
            return this[impl].search;
        },
        set (V) {
            V = conversions["USVString"](V);
            this[impl].search = V;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URL.prototype, "hash", {
        get () {
            return this[impl].hash;
        },
        set (V) {
            V = conversions["USVString"](V);
            this[impl].hash = V;
        },
        enumerable: true,
        configurable: true
    });
    module.exports = {
        is (obj) {
            return !!obj && obj[impl] instanceof Impl.implementation;
        },
        create (constructorArgs, privateData) {
            let obj = Object.create(URL.prototype);
            this.setup(obj, constructorArgs, privateData);
            return obj;
        },
        setup (obj, constructorArgs, privateData) {
            if (!privateData) privateData = {};
            privateData.wrapper = obj;
            obj[impl] = new Impl.implementation(constructorArgs, privateData);
            obj[impl][utils.wrapperSymbol] = obj;
        },
        interface: URL,
        expose: {
            Window: {
                URL: URL
            },
            Worker: {
                URL: URL
            }
        }
    };
})($3fe9119940fa16b8$var$URL$2);
var $3fe9119940fa16b8$var$URLExports = $3fe9119940fa16b8$var$URL$2.exports;
$3fe9119940fa16b8$var$publicApi.URL = $3fe9119940fa16b8$var$URLExports.interface;
$3fe9119940fa16b8$var$publicApi.serializeURL = $3fe9119940fa16b8$var$urlStateMachineExports.serializeURL;
$3fe9119940fa16b8$var$publicApi.serializeURLOrigin = $3fe9119940fa16b8$var$urlStateMachineExports.serializeURLOrigin;
$3fe9119940fa16b8$var$publicApi.basicURLParse = $3fe9119940fa16b8$var$urlStateMachineExports.basicURLParse;
$3fe9119940fa16b8$var$publicApi.setTheUsername = $3fe9119940fa16b8$var$urlStateMachineExports.setTheUsername;
$3fe9119940fa16b8$var$publicApi.setThePassword = $3fe9119940fa16b8$var$urlStateMachineExports.setThePassword;
$3fe9119940fa16b8$var$publicApi.serializeHost = $3fe9119940fa16b8$var$urlStateMachineExports.serializeHost;
$3fe9119940fa16b8$var$publicApi.serializeInteger = $3fe9119940fa16b8$var$urlStateMachineExports.serializeInteger;
$3fe9119940fa16b8$var$publicApi.parseURL = $3fe9119940fa16b8$var$urlStateMachineExports.parseURL;
function $3fe9119940fa16b8$var$request$1(opts, cb) {
    if (typeof opts === 'string') opts = $3fe9119940fa16b8$var$urlParse(opts);
    // Normally, the page is loaded from http or https, so not specifying a protocol
    // will result in a (valid) protocol-relative url. However, this won't work if
    // the protocol is something else, like 'file:'
    var defaultProtocol = $3fe9119940fa16b8$var$global$1.location.protocol.search(/^https?:$/) === -1 ? 'http:' : '';
    var protocol = opts.protocol || defaultProtocol;
    var host = opts.hostname || opts.host;
    var port = opts.port;
    var path = opts.path || '/';
    // Necessary for IPv6 addresses
    if (host && host.indexOf(':') !== -1) host = '[' + host + ']';
    // This may be a relative url. The browser should always be able to interpret it correctly.
    opts.url = (host ? protocol + '//' + host : '') + (port ? ':' + port : '') + path;
    opts.method = (opts.method || 'GET').toUpperCase();
    opts.headers = opts.headers || {};
    // Also valid opts.auth, opts.mode
    var req = new $3fe9119940fa16b8$var$ClientRequest(opts);
    if (cb) req.on('response', cb);
    return req;
}
function $3fe9119940fa16b8$var$get(opts, cb) {
    var req = $3fe9119940fa16b8$var$request$1(opts, cb);
    req.end();
    return req;
}
function $3fe9119940fa16b8$var$Agent() {}
$3fe9119940fa16b8$var$Agent.defaultMaxSockets = 4;
var $3fe9119940fa16b8$var$METHODS = [
    'CHECKOUT',
    'CONNECT',
    'COPY',
    'DELETE',
    'GET',
    'HEAD',
    'LOCK',
    'M-SEARCH',
    'MERGE',
    'MKACTIVITY',
    'MKCOL',
    'MOVE',
    'NOTIFY',
    'OPTIONS',
    'PATCH',
    'POST',
    'PROPFIND',
    'PROPPATCH',
    'PURGE',
    'PUT',
    'REPORT',
    'SEARCH',
    'SUBSCRIBE',
    'TRACE',
    'UNLOCK',
    'UNSUBSCRIBE'
];
var $3fe9119940fa16b8$var$STATUS_CODES$1 = {
    100: 'Continue',
    101: 'Switching Protocols',
    102: 'Processing',
    200: 'OK',
    201: 'Created',
    202: 'Accepted',
    203: 'Non-Authoritative Information',
    204: 'No Content',
    205: 'Reset Content',
    206: 'Partial Content',
    207: 'Multi-Status',
    300: 'Multiple Choices',
    301: 'Moved Permanently',
    302: 'Moved Temporarily',
    303: 'See Other',
    304: 'Not Modified',
    305: 'Use Proxy',
    307: 'Temporary Redirect',
    400: 'Bad Request',
    401: 'Unauthorized',
    402: 'Payment Required',
    403: 'Forbidden',
    404: 'Not Found',
    405: 'Method Not Allowed',
    406: 'Not Acceptable',
    407: 'Proxy Authentication Required',
    408: 'Request Time-out',
    409: 'Conflict',
    410: 'Gone',
    411: 'Length Required',
    412: 'Precondition Failed',
    413: 'Request Entity Too Large',
    414: 'Request-URI Too Large',
    415: 'Unsupported Media Type',
    416: 'Requested Range Not Satisfiable',
    417: 'Expectation Failed',
    418: 'I\'m a teapot',
    422: 'Unprocessable Entity',
    423: 'Locked',
    424: 'Failed Dependency',
    425: 'Unordered Collection',
    426: 'Upgrade Required',
    428: 'Precondition Required',
    429: 'Too Many Requests',
    431: 'Request Header Fields Too Large',
    500: 'Internal Server Error',
    501: 'Not Implemented',
    502: 'Bad Gateway',
    503: 'Service Unavailable',
    504: 'Gateway Time-out',
    505: 'HTTP Version Not Supported',
    506: 'Variant Also Negotiates',
    507: 'Insufficient Storage',
    509: 'Bandwidth Limit Exceeded',
    510: 'Not Extended',
    511: 'Network Authentication Required' // RFC 6585
};
var $3fe9119940fa16b8$var$https = {
    request: $3fe9119940fa16b8$var$request$1,
    get: $3fe9119940fa16b8$var$get,
    Agent: $3fe9119940fa16b8$var$Agent,
    METHODS: $3fe9119940fa16b8$var$METHODS,
    STATUS_CODES: $3fe9119940fa16b8$var$STATUS_CODES$1
};
var $3fe9119940fa16b8$var$msg = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};
function $3fe9119940fa16b8$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
function $3fe9119940fa16b8$var$arraySet(dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
        dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
        return;
    }
    // Fallback to ordinary array
    for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
}
var $3fe9119940fa16b8$var$Buf8 = Uint8Array;
var $3fe9119940fa16b8$var$Buf16 = Uint16Array;
var $3fe9119940fa16b8$var$Buf32 = Int32Array;
// Enable/Disable typed arrays use, for testing
//
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $3fe9119940fa16b8$var$Z_FIXED$2 = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $3fe9119940fa16b8$var$Z_BINARY$1 = 0;
var $3fe9119940fa16b8$var$Z_TEXT$1 = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $3fe9119940fa16b8$var$Z_UNKNOWN$2 = 2;
/*============================================================================*/ function $3fe9119940fa16b8$var$zero$1(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $3fe9119940fa16b8$var$STORED_BLOCK = 0;
var $3fe9119940fa16b8$var$STATIC_TREES = 1;
var $3fe9119940fa16b8$var$DYN_TREES = 2;
/* The three kinds of block type */ var $3fe9119940fa16b8$var$MIN_MATCH$1 = 3;
var $3fe9119940fa16b8$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $3fe9119940fa16b8$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $3fe9119940fa16b8$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ var $3fe9119940fa16b8$var$L_CODES$1 = $3fe9119940fa16b8$var$LITERALS$1 + 1 + $3fe9119940fa16b8$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ var $3fe9119940fa16b8$var$D_CODES$1 = 30;
/* number of distance codes */ var $3fe9119940fa16b8$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ var $3fe9119940fa16b8$var$HEAP_SIZE$1 = 2 * $3fe9119940fa16b8$var$L_CODES$1 + 1;
/* maximum heap size */ var $3fe9119940fa16b8$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ var $3fe9119940fa16b8$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $3fe9119940fa16b8$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $3fe9119940fa16b8$var$END_BLOCK = 256;
/* end of block literal code */ var $3fe9119940fa16b8$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $3fe9119940fa16b8$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $3fe9119940fa16b8$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $3fe9119940fa16b8$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $3fe9119940fa16b8$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $3fe9119940fa16b8$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $3fe9119940fa16b8$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $3fe9119940fa16b8$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
var $3fe9119940fa16b8$var$static_ltree = new Array(($3fe9119940fa16b8$var$L_CODES$1 + 2) * 2);
$3fe9119940fa16b8$var$zero$1($3fe9119940fa16b8$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $3fe9119940fa16b8$var$static_dtree = new Array($3fe9119940fa16b8$var$D_CODES$1 * 2);
$3fe9119940fa16b8$var$zero$1($3fe9119940fa16b8$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $3fe9119940fa16b8$var$_dist_code = new Array($3fe9119940fa16b8$var$DIST_CODE_LEN);
$3fe9119940fa16b8$var$zero$1($3fe9119940fa16b8$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $3fe9119940fa16b8$var$_length_code = new Array($3fe9119940fa16b8$var$MAX_MATCH$1 - $3fe9119940fa16b8$var$MIN_MATCH$1 + 1);
$3fe9119940fa16b8$var$zero$1($3fe9119940fa16b8$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $3fe9119940fa16b8$var$base_length = new Array($3fe9119940fa16b8$var$LENGTH_CODES$1);
$3fe9119940fa16b8$var$zero$1($3fe9119940fa16b8$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $3fe9119940fa16b8$var$base_dist = new Array($3fe9119940fa16b8$var$D_CODES$1);
$3fe9119940fa16b8$var$zero$1($3fe9119940fa16b8$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $3fe9119940fa16b8$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $3fe9119940fa16b8$var$static_l_desc;
var $3fe9119940fa16b8$var$static_d_desc;
var $3fe9119940fa16b8$var$static_bl_desc;
function $3fe9119940fa16b8$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $3fe9119940fa16b8$var$d_code(dist) {
    return dist < 256 ? $3fe9119940fa16b8$var$_dist_code[dist] : $3fe9119940fa16b8$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $3fe9119940fa16b8$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $3fe9119940fa16b8$var$send_bits(s, value, length) {
    if (s.bi_valid > $3fe9119940fa16b8$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $3fe9119940fa16b8$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $3fe9119940fa16b8$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $3fe9119940fa16b8$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $3fe9119940fa16b8$var$send_code(s, c, tree) {
    $3fe9119940fa16b8$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $3fe9119940fa16b8$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $3fe9119940fa16b8$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $3fe9119940fa16b8$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $3fe9119940fa16b8$var$gen_bitlen(s, desc) {
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $3fe9119940fa16b8$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $3fe9119940fa16b8$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $3fe9119940fa16b8$var$gen_codes(tree, max_code, bl_count) {
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    var next_code = new Array($3fe9119940fa16b8$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $3fe9119940fa16b8$var$MAX_BITS$1; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $3fe9119940fa16b8$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $3fe9119940fa16b8$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($3fe9119940fa16b8$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
    static_l_desc.static_tree = static_ltree;
    static_l_desc.extra_bits = extra_lbits;
    static_d_desc.static_tree = static_dtree;
    static_d_desc.extra_bits = extra_dbits;
    static_bl_desc.extra_bits = extra_blbits;
  #endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $3fe9119940fa16b8$var$LENGTH_CODES$1 - 1; code++){
        $3fe9119940fa16b8$var$base_length[code] = length;
        for(n = 0; n < 1 << $3fe9119940fa16b8$var$extra_lbits[code]; n++)$3fe9119940fa16b8$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $3fe9119940fa16b8$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $3fe9119940fa16b8$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $3fe9119940fa16b8$var$extra_dbits[code]; n++)$3fe9119940fa16b8$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $3fe9119940fa16b8$var$D_CODES$1; code++){
        $3fe9119940fa16b8$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $3fe9119940fa16b8$var$extra_dbits[code] - 7; n++)$3fe9119940fa16b8$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $3fe9119940fa16b8$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $3fe9119940fa16b8$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $3fe9119940fa16b8$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $3fe9119940fa16b8$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $3fe9119940fa16b8$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $3fe9119940fa16b8$var$gen_codes($3fe9119940fa16b8$var$static_ltree, $3fe9119940fa16b8$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $3fe9119940fa16b8$var$D_CODES$1; n++){
        $3fe9119940fa16b8$var$static_dtree[n * 2 + 1] = 5;
        $3fe9119940fa16b8$var$static_dtree[n * 2] = $3fe9119940fa16b8$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $3fe9119940fa16b8$var$static_l_desc = new $3fe9119940fa16b8$var$StaticTreeDesc($3fe9119940fa16b8$var$static_ltree, $3fe9119940fa16b8$var$extra_lbits, $3fe9119940fa16b8$var$LITERALS$1 + 1, $3fe9119940fa16b8$var$L_CODES$1, $3fe9119940fa16b8$var$MAX_BITS$1);
    $3fe9119940fa16b8$var$static_d_desc = new $3fe9119940fa16b8$var$StaticTreeDesc($3fe9119940fa16b8$var$static_dtree, $3fe9119940fa16b8$var$extra_dbits, 0, $3fe9119940fa16b8$var$D_CODES$1, $3fe9119940fa16b8$var$MAX_BITS$1);
    $3fe9119940fa16b8$var$static_bl_desc = new $3fe9119940fa16b8$var$StaticTreeDesc(new Array(0), $3fe9119940fa16b8$var$extra_blbits, 0, $3fe9119940fa16b8$var$BL_CODES$1, $3fe9119940fa16b8$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $3fe9119940fa16b8$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $3fe9119940fa16b8$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $3fe9119940fa16b8$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $3fe9119940fa16b8$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$3fe9119940fa16b8$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $3fe9119940fa16b8$var$bi_windup(s) {
    if (s.bi_valid > 8) $3fe9119940fa16b8$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $3fe9119940fa16b8$var$copy_block(s, buf, len, header) {
    //DeflateState *s;
    //charf    *buf;    /* the input data */
    //unsigned len;     /* its length */
    //int      header;  /* true if block header must be written */
    $3fe9119940fa16b8$var$bi_windup(s); /* align on byte boundary */ 
    $3fe9119940fa16b8$var$put_short(s, len);
    $3fe9119940fa16b8$var$put_short(s, ~len);
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $3fe9119940fa16b8$var$arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $3fe9119940fa16b8$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $3fe9119940fa16b8$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $3fe9119940fa16b8$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($3fe9119940fa16b8$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $3fe9119940fa16b8$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $3fe9119940fa16b8$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $3fe9119940fa16b8$var$_length_code[lc];
            $3fe9119940fa16b8$var$send_code(s, code + $3fe9119940fa16b8$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $3fe9119940fa16b8$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $3fe9119940fa16b8$var$base_length[code];
                $3fe9119940fa16b8$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $3fe9119940fa16b8$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $3fe9119940fa16b8$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $3fe9119940fa16b8$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $3fe9119940fa16b8$var$base_dist[code];
                $3fe9119940fa16b8$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $3fe9119940fa16b8$var$send_code(s, $3fe9119940fa16b8$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $3fe9119940fa16b8$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $3fe9119940fa16b8$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$3fe9119940fa16b8$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $3fe9119940fa16b8$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $3fe9119940fa16b8$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $3fe9119940fa16b8$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $3fe9119940fa16b8$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $3fe9119940fa16b8$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$3fe9119940fa16b8$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$3fe9119940fa16b8$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$3fe9119940fa16b8$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $3fe9119940fa16b8$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $3fe9119940fa16b8$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $3fe9119940fa16b8$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $3fe9119940fa16b8$var$send_code(s, $3fe9119940fa16b8$var$REP_3_6, s.bl_tree);
            $3fe9119940fa16b8$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $3fe9119940fa16b8$var$send_code(s, $3fe9119940fa16b8$var$REPZ_3_10, s.bl_tree);
            $3fe9119940fa16b8$var$send_bits(s, count - 3, 3);
        } else {
            $3fe9119940fa16b8$var$send_code(s, $3fe9119940fa16b8$var$REPZ_11_138, s.bl_tree);
            $3fe9119940fa16b8$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $3fe9119940fa16b8$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $3fe9119940fa16b8$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $3fe9119940fa16b8$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $3fe9119940fa16b8$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $3fe9119940fa16b8$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$3fe9119940fa16b8$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $3fe9119940fa16b8$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $3fe9119940fa16b8$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $3fe9119940fa16b8$var$send_bits(s, dcodes - 1, 5);
    $3fe9119940fa16b8$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $3fe9119940fa16b8$var$send_bits(s, s.bl_tree[$3fe9119940fa16b8$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $3fe9119940fa16b8$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $3fe9119940fa16b8$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $3fe9119940fa16b8$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $3fe9119940fa16b8$var$Z_BINARY$1;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $3fe9119940fa16b8$var$Z_TEXT$1;
    for(n = 32; n < $3fe9119940fa16b8$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $3fe9119940fa16b8$var$Z_TEXT$1;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $3fe9119940fa16b8$var$Z_BINARY$1;
}
var $3fe9119940fa16b8$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $3fe9119940fa16b8$var$_tr_init(s) {
    if (!$3fe9119940fa16b8$var$static_init_done) {
        $3fe9119940fa16b8$var$tr_static_init();
        $3fe9119940fa16b8$var$static_init_done = true;
    }
    s.l_desc = new $3fe9119940fa16b8$var$TreeDesc(s.dyn_ltree, $3fe9119940fa16b8$var$static_l_desc);
    s.d_desc = new $3fe9119940fa16b8$var$TreeDesc(s.dyn_dtree, $3fe9119940fa16b8$var$static_d_desc);
    s.bl_desc = new $3fe9119940fa16b8$var$TreeDesc(s.bl_tree, $3fe9119940fa16b8$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $3fe9119940fa16b8$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $3fe9119940fa16b8$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $3fe9119940fa16b8$var$send_bits(s, ($3fe9119940fa16b8$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $3fe9119940fa16b8$var$copy_block(s, buf, stored_len); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $3fe9119940fa16b8$var$_tr_align(s) {
    $3fe9119940fa16b8$var$send_bits(s, $3fe9119940fa16b8$var$STATIC_TREES << 1, 3);
    $3fe9119940fa16b8$var$send_code(s, $3fe9119940fa16b8$var$END_BLOCK, $3fe9119940fa16b8$var$static_ltree);
    $3fe9119940fa16b8$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $3fe9119940fa16b8$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $3fe9119940fa16b8$var$Z_UNKNOWN$2) s.strm.data_type = $3fe9119940fa16b8$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $3fe9119940fa16b8$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $3fe9119940fa16b8$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $3fe9119940fa16b8$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $3fe9119940fa16b8$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $3fe9119940fa16b8$var$Z_FIXED$2 || static_lenb === opt_lenb) {
        $3fe9119940fa16b8$var$send_bits(s, ($3fe9119940fa16b8$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $3fe9119940fa16b8$var$compress_block(s, $3fe9119940fa16b8$var$static_ltree, $3fe9119940fa16b8$var$static_dtree);
    } else {
        $3fe9119940fa16b8$var$send_bits(s, ($3fe9119940fa16b8$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $3fe9119940fa16b8$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $3fe9119940fa16b8$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $3fe9119940fa16b8$var$init_block(s);
    if (last) $3fe9119940fa16b8$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $3fe9119940fa16b8$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($3fe9119940fa16b8$var$_length_code[lc] + $3fe9119940fa16b8$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$3fe9119940fa16b8$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defailts,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It doesn't worth to make additional optimizationa as in original.
// Small size is preferable.
function $3fe9119940fa16b8$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// Use ordinary array, since untyped makes no boost here
function $3fe9119940fa16b8$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $3fe9119940fa16b8$var$crcTable = $3fe9119940fa16b8$var$makeTable();
function $3fe9119940fa16b8$var$crc32(crc, buf, len, pos) {
    var t = $3fe9119940fa16b8$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $3fe9119940fa16b8$var$Z_NO_FLUSH$1 = 0;
var $3fe9119940fa16b8$var$Z_PARTIAL_FLUSH$1 = 1;
//var Z_SYNC_FLUSH    = 2;
var $3fe9119940fa16b8$var$Z_FULL_FLUSH$1 = 3;
var $3fe9119940fa16b8$var$Z_FINISH$2 = 4;
var $3fe9119940fa16b8$var$Z_BLOCK$2 = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $3fe9119940fa16b8$var$Z_OK$2 = 0;
var $3fe9119940fa16b8$var$Z_STREAM_END$2 = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $3fe9119940fa16b8$var$Z_STREAM_ERROR$2 = -2;
var $3fe9119940fa16b8$var$Z_DATA_ERROR$2 = -3;
//var Z_MEM_ERROR     = -4;
var $3fe9119940fa16b8$var$Z_BUF_ERROR$2 = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $3fe9119940fa16b8$var$Z_DEFAULT_COMPRESSION$1 = -1;
var $3fe9119940fa16b8$var$Z_FILTERED$1 = 1;
var $3fe9119940fa16b8$var$Z_HUFFMAN_ONLY$1 = 2;
var $3fe9119940fa16b8$var$Z_RLE$1 = 3;
var $3fe9119940fa16b8$var$Z_FIXED$1 = 4;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $3fe9119940fa16b8$var$Z_UNKNOWN$1 = 2;
/* The deflate compression method */ var $3fe9119940fa16b8$var$Z_DEFLATED$2 = 8;
/*============================================================================*/ var $3fe9119940fa16b8$var$MAX_MEM_LEVEL = 9;
var $3fe9119940fa16b8$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $3fe9119940fa16b8$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $3fe9119940fa16b8$var$L_CODES = $3fe9119940fa16b8$var$LITERALS + 1 + $3fe9119940fa16b8$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $3fe9119940fa16b8$var$D_CODES = 30;
/* number of distance codes */ var $3fe9119940fa16b8$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $3fe9119940fa16b8$var$HEAP_SIZE = 2 * $3fe9119940fa16b8$var$L_CODES + 1;
/* maximum heap size */ var $3fe9119940fa16b8$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $3fe9119940fa16b8$var$MIN_MATCH = 3;
var $3fe9119940fa16b8$var$MAX_MATCH = 258;
var $3fe9119940fa16b8$var$MIN_LOOKAHEAD = $3fe9119940fa16b8$var$MAX_MATCH + $3fe9119940fa16b8$var$MIN_MATCH + 1;
var $3fe9119940fa16b8$var$PRESET_DICT = 0x20;
var $3fe9119940fa16b8$var$INIT_STATE = 42;
var $3fe9119940fa16b8$var$EXTRA_STATE = 69;
var $3fe9119940fa16b8$var$NAME_STATE = 73;
var $3fe9119940fa16b8$var$COMMENT_STATE = 91;
var $3fe9119940fa16b8$var$HCRC_STATE = 103;
var $3fe9119940fa16b8$var$BUSY_STATE = 113;
var $3fe9119940fa16b8$var$FINISH_STATE = 666;
var $3fe9119940fa16b8$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $3fe9119940fa16b8$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $3fe9119940fa16b8$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $3fe9119940fa16b8$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $3fe9119940fa16b8$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $3fe9119940fa16b8$var$err(strm, errorCode) {
    strm.msg = $3fe9119940fa16b8$var$msg[errorCode];
    return errorCode;
}
function $3fe9119940fa16b8$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $3fe9119940fa16b8$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $3fe9119940fa16b8$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $3fe9119940fa16b8$var$arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $3fe9119940fa16b8$var$flush_block_only(s, last) {
    $3fe9119940fa16b8$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $3fe9119940fa16b8$var$flush_pending(s.strm);
}
function $3fe9119940fa16b8$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $3fe9119940fa16b8$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $3fe9119940fa16b8$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $3fe9119940fa16b8$var$arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $3fe9119940fa16b8$var$adler32(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $3fe9119940fa16b8$var$crc32(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $3fe9119940fa16b8$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $3fe9119940fa16b8$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $3fe9119940fa16b8$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $3fe9119940fa16b8$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $3fe9119940fa16b8$var$MAX_MATCH - (strend - scan);
        scan = strend - $3fe9119940fa16b8$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $3fe9119940fa16b8$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $3fe9119940fa16b8$var$MIN_LOOKAHEAD)) {
            $3fe9119940fa16b8$var$arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $3fe9119940fa16b8$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $3fe9119940fa16b8$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $3fe9119940fa16b8$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $3fe9119940fa16b8$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $3fe9119940fa16b8$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $3fe9119940fa16b8$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $3fe9119940fa16b8$var$fill_window(s);
            if (s.lookahead === 0 && flush === $3fe9119940fa16b8$var$Z_NO_FLUSH$1) return $3fe9119940fa16b8$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $3fe9119940fa16b8$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $3fe9119940fa16b8$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $3fe9119940fa16b8$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $3fe9119940fa16b8$var$Z_FINISH$2) {
        /*** FLUSH_BLOCK(s, 1); ***/ $3fe9119940fa16b8$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_FINISH_STARTED;
        /***/ return $3fe9119940fa16b8$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $3fe9119940fa16b8$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_NEED_MORE;
    /***/ }
    return $3fe9119940fa16b8$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $3fe9119940fa16b8$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $3fe9119940fa16b8$var$MIN_LOOKAHEAD) {
            $3fe9119940fa16b8$var$fill_window(s);
            if (s.lookahead < $3fe9119940fa16b8$var$MIN_LOOKAHEAD && flush === $3fe9119940fa16b8$var$Z_NO_FLUSH$1) return $3fe9119940fa16b8$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $3fe9119940fa16b8$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $3fe9119940fa16b8$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $3fe9119940fa16b8$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $3fe9119940fa16b8$var$longest_match(s, hash_head);
        if (s.match_length >= $3fe9119940fa16b8$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $3fe9119940fa16b8$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $3fe9119940fa16b8$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $3fe9119940fa16b8$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $3fe9119940fa16b8$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $3fe9119940fa16b8$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $3fe9119940fa16b8$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $3fe9119940fa16b8$var$MIN_MATCH - 1 ? s.strstart : $3fe9119940fa16b8$var$MIN_MATCH - 1;
    if (flush === $3fe9119940fa16b8$var$Z_FINISH$2) {
        /*** FLUSH_BLOCK(s, 1); ***/ $3fe9119940fa16b8$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_FINISH_STARTED;
        /***/ return $3fe9119940fa16b8$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $3fe9119940fa16b8$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_NEED_MORE;
    /***/ }
    return $3fe9119940fa16b8$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $3fe9119940fa16b8$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $3fe9119940fa16b8$var$MIN_LOOKAHEAD) {
            $3fe9119940fa16b8$var$fill_window(s);
            if (s.lookahead < $3fe9119940fa16b8$var$MIN_LOOKAHEAD && flush === $3fe9119940fa16b8$var$Z_NO_FLUSH$1) return $3fe9119940fa16b8$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $3fe9119940fa16b8$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $3fe9119940fa16b8$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $3fe9119940fa16b8$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $3fe9119940fa16b8$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $3fe9119940fa16b8$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $3fe9119940fa16b8$var$Z_FILTERED$1 || s.match_length === $3fe9119940fa16b8$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $3fe9119940fa16b8$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $3fe9119940fa16b8$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $3fe9119940fa16b8$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $3fe9119940fa16b8$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $3fe9119940fa16b8$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $3fe9119940fa16b8$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $3fe9119940fa16b8$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $3fe9119940fa16b8$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $3fe9119940fa16b8$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $3fe9119940fa16b8$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $3fe9119940fa16b8$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $3fe9119940fa16b8$var$MIN_MATCH - 1 ? s.strstart : $3fe9119940fa16b8$var$MIN_MATCH - 1;
    if (flush === $3fe9119940fa16b8$var$Z_FINISH$2) {
        /*** FLUSH_BLOCK(s, 1); ***/ $3fe9119940fa16b8$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_FINISH_STARTED;
        /***/ return $3fe9119940fa16b8$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $3fe9119940fa16b8$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_NEED_MORE;
    /***/ }
    return $3fe9119940fa16b8$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $3fe9119940fa16b8$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $3fe9119940fa16b8$var$MAX_MATCH) {
            $3fe9119940fa16b8$var$fill_window(s);
            if (s.lookahead <= $3fe9119940fa16b8$var$MAX_MATCH && flush === $3fe9119940fa16b8$var$Z_NO_FLUSH$1) return $3fe9119940fa16b8$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $3fe9119940fa16b8$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $3fe9119940fa16b8$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $3fe9119940fa16b8$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $3fe9119940fa16b8$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $3fe9119940fa16b8$var$_tr_tally(s, 1, s.match_length - $3fe9119940fa16b8$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $3fe9119940fa16b8$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $3fe9119940fa16b8$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $3fe9119940fa16b8$var$Z_FINISH$2) {
        /*** FLUSH_BLOCK(s, 1); ***/ $3fe9119940fa16b8$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_FINISH_STARTED;
        /***/ return $3fe9119940fa16b8$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $3fe9119940fa16b8$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_NEED_MORE;
    /***/ }
    return $3fe9119940fa16b8$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $3fe9119940fa16b8$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $3fe9119940fa16b8$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $3fe9119940fa16b8$var$Z_NO_FLUSH$1) return $3fe9119940fa16b8$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $3fe9119940fa16b8$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $3fe9119940fa16b8$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $3fe9119940fa16b8$var$Z_FINISH$2) {
        /*** FLUSH_BLOCK(s, 1); ***/ $3fe9119940fa16b8$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_FINISH_STARTED;
        /***/ return $3fe9119940fa16b8$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $3fe9119940fa16b8$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $3fe9119940fa16b8$var$BS_NEED_MORE;
    /***/ }
    return $3fe9119940fa16b8$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $3fe9119940fa16b8$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $3fe9119940fa16b8$var$configuration_table;
$3fe9119940fa16b8$var$configuration_table = [
    /*      good lazy nice chain */ new $3fe9119940fa16b8$var$Config(0, 0, 0, 0, $3fe9119940fa16b8$var$deflate_stored),
    /* 0 store only */ new $3fe9119940fa16b8$var$Config(4, 4, 8, 4, $3fe9119940fa16b8$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $3fe9119940fa16b8$var$Config(4, 5, 16, 8, $3fe9119940fa16b8$var$deflate_fast),
    /* 2 */ new $3fe9119940fa16b8$var$Config(4, 6, 32, 32, $3fe9119940fa16b8$var$deflate_fast),
    /* 3 */ new $3fe9119940fa16b8$var$Config(4, 4, 16, 16, $3fe9119940fa16b8$var$deflate_slow),
    /* 4 lazy matches */ new $3fe9119940fa16b8$var$Config(8, 16, 32, 32, $3fe9119940fa16b8$var$deflate_slow),
    /* 5 */ new $3fe9119940fa16b8$var$Config(8, 16, 128, 128, $3fe9119940fa16b8$var$deflate_slow),
    /* 6 */ new $3fe9119940fa16b8$var$Config(8, 32, 128, 256, $3fe9119940fa16b8$var$deflate_slow),
    /* 7 */ new $3fe9119940fa16b8$var$Config(32, 128, 258, 1024, $3fe9119940fa16b8$var$deflate_slow),
    /* 8 */ new $3fe9119940fa16b8$var$Config(32, 258, 258, 4096, $3fe9119940fa16b8$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $3fe9119940fa16b8$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $3fe9119940fa16b8$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $3fe9119940fa16b8$var$configuration_table[s.level].max_lazy;
    s.good_match = $3fe9119940fa16b8$var$configuration_table[s.level].good_length;
    s.nice_match = $3fe9119940fa16b8$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $3fe9119940fa16b8$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $3fe9119940fa16b8$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $3fe9119940fa16b8$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $3fe9119940fa16b8$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $3fe9119940fa16b8$var$Buf16($3fe9119940fa16b8$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $3fe9119940fa16b8$var$Buf16((2 * $3fe9119940fa16b8$var$D_CODES + 1) * 2);
    this.bl_tree = new $3fe9119940fa16b8$var$Buf16((2 * $3fe9119940fa16b8$var$BL_CODES + 1) * 2);
    $3fe9119940fa16b8$var$zero(this.dyn_ltree);
    $3fe9119940fa16b8$var$zero(this.dyn_dtree);
    $3fe9119940fa16b8$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $3fe9119940fa16b8$var$Buf16($3fe9119940fa16b8$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $3fe9119940fa16b8$var$Buf16(2 * $3fe9119940fa16b8$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $3fe9119940fa16b8$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all
   */ this.depth = new $3fe9119940fa16b8$var$Buf16(2 * $3fe9119940fa16b8$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $3fe9119940fa16b8$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $3fe9119940fa16b8$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $3fe9119940fa16b8$var$err(strm, $3fe9119940fa16b8$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $3fe9119940fa16b8$var$Z_UNKNOWN$1;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $3fe9119940fa16b8$var$INIT_STATE : $3fe9119940fa16b8$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $3fe9119940fa16b8$var$Z_NO_FLUSH$1;
    $3fe9119940fa16b8$var$_tr_init(s);
    return $3fe9119940fa16b8$var$Z_OK$2;
}
function $3fe9119940fa16b8$var$deflateReset(strm) {
    var ret = $3fe9119940fa16b8$var$deflateResetKeep(strm);
    if (ret === $3fe9119940fa16b8$var$Z_OK$2) $3fe9119940fa16b8$var$lm_init(strm.state);
    return ret;
}
function $3fe9119940fa16b8$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $3fe9119940fa16b8$var$Z_STREAM_ERROR$2;
    var wrap = 1;
    if (level === $3fe9119940fa16b8$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $3fe9119940fa16b8$var$MAX_MEM_LEVEL || method !== $3fe9119940fa16b8$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $3fe9119940fa16b8$var$Z_FIXED$1) return $3fe9119940fa16b8$var$err(strm, $3fe9119940fa16b8$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $3fe9119940fa16b8$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $3fe9119940fa16b8$var$MIN_MATCH - 1) / $3fe9119940fa16b8$var$MIN_MATCH);
    s.window = new $3fe9119940fa16b8$var$Buf8(s.w_size * 2);
    s.head = new $3fe9119940fa16b8$var$Buf16(s.hash_size);
    s.prev = new $3fe9119940fa16b8$var$Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $3fe9119940fa16b8$var$Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $3fe9119940fa16b8$var$deflateReset(strm);
}
function $3fe9119940fa16b8$var$deflate$1(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $3fe9119940fa16b8$var$Z_BLOCK$2 || flush < 0) return strm ? $3fe9119940fa16b8$var$err(strm, $3fe9119940fa16b8$var$Z_STREAM_ERROR$2) : $3fe9119940fa16b8$var$Z_STREAM_ERROR$2;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $3fe9119940fa16b8$var$FINISH_STATE && flush !== $3fe9119940fa16b8$var$Z_FINISH$2) return $3fe9119940fa16b8$var$err(strm, strm.avail_out === 0 ? $3fe9119940fa16b8$var$Z_BUF_ERROR$2 : $3fe9119940fa16b8$var$Z_STREAM_ERROR$2);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $3fe9119940fa16b8$var$INIT_STATE) {
        if (s.wrap === 2) {
            // GZIP header
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $3fe9119940fa16b8$var$put_byte(s, 31);
            $3fe9119940fa16b8$var$put_byte(s, 139);
            $3fe9119940fa16b8$var$put_byte(s, 8);
            if (!s.gzhead) {
                $3fe9119940fa16b8$var$put_byte(s, 0);
                $3fe9119940fa16b8$var$put_byte(s, 0);
                $3fe9119940fa16b8$var$put_byte(s, 0);
                $3fe9119940fa16b8$var$put_byte(s, 0);
                $3fe9119940fa16b8$var$put_byte(s, 0);
                $3fe9119940fa16b8$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $3fe9119940fa16b8$var$Z_HUFFMAN_ONLY$1 || s.level < 2 ? 4 : 0);
                $3fe9119940fa16b8$var$put_byte(s, $3fe9119940fa16b8$var$OS_CODE);
                s.status = $3fe9119940fa16b8$var$BUSY_STATE;
            } else {
                $3fe9119940fa16b8$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $3fe9119940fa16b8$var$put_byte(s, s.gzhead.time & 0xff);
                $3fe9119940fa16b8$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $3fe9119940fa16b8$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $3fe9119940fa16b8$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $3fe9119940fa16b8$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $3fe9119940fa16b8$var$Z_HUFFMAN_ONLY$1 || s.level < 2 ? 4 : 0);
                $3fe9119940fa16b8$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $3fe9119940fa16b8$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $3fe9119940fa16b8$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $3fe9119940fa16b8$var$crc32(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $3fe9119940fa16b8$var$EXTRA_STATE;
            }
        } else {
            var header = $3fe9119940fa16b8$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $3fe9119940fa16b8$var$Z_HUFFMAN_ONLY$1 || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $3fe9119940fa16b8$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $3fe9119940fa16b8$var$BUSY_STATE;
            $3fe9119940fa16b8$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $3fe9119940fa16b8$var$putShortMSB(s, strm.adler >>> 16);
                $3fe9119940fa16b8$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $3fe9119940fa16b8$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $3fe9119940fa16b8$var$crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $3fe9119940fa16b8$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $3fe9119940fa16b8$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $3fe9119940fa16b8$var$crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $3fe9119940fa16b8$var$NAME_STATE;
            }
        } else s.status = $3fe9119940fa16b8$var$NAME_STATE;
    }
    if (s.status === $3fe9119940fa16b8$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $3fe9119940fa16b8$var$crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $3fe9119940fa16b8$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $3fe9119940fa16b8$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $3fe9119940fa16b8$var$crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $3fe9119940fa16b8$var$COMMENT_STATE;
            }
        } else s.status = $3fe9119940fa16b8$var$COMMENT_STATE;
    }
    if (s.status === $3fe9119940fa16b8$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $3fe9119940fa16b8$var$crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $3fe9119940fa16b8$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $3fe9119940fa16b8$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $3fe9119940fa16b8$var$crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $3fe9119940fa16b8$var$HCRC_STATE;
        } else s.status = $3fe9119940fa16b8$var$HCRC_STATE;
    }
    if (s.status === $3fe9119940fa16b8$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $3fe9119940fa16b8$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $3fe9119940fa16b8$var$put_byte(s, strm.adler & 0xff);
                $3fe9119940fa16b8$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $3fe9119940fa16b8$var$BUSY_STATE;
            }
        } else s.status = $3fe9119940fa16b8$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $3fe9119940fa16b8$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $3fe9119940fa16b8$var$Z_OK$2;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $3fe9119940fa16b8$var$rank(flush) <= $3fe9119940fa16b8$var$rank(old_flush) && flush !== $3fe9119940fa16b8$var$Z_FINISH$2) return $3fe9119940fa16b8$var$err(strm, $3fe9119940fa16b8$var$Z_BUF_ERROR$2);
    /* User must not provide more input after the first FINISH: */ if (s.status === $3fe9119940fa16b8$var$FINISH_STATE && strm.avail_in !== 0) return $3fe9119940fa16b8$var$err(strm, $3fe9119940fa16b8$var$Z_BUF_ERROR$2);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $3fe9119940fa16b8$var$Z_NO_FLUSH$1 && s.status !== $3fe9119940fa16b8$var$FINISH_STATE) {
        var bstate = s.strategy === $3fe9119940fa16b8$var$Z_HUFFMAN_ONLY$1 ? $3fe9119940fa16b8$var$deflate_huff(s, flush) : s.strategy === $3fe9119940fa16b8$var$Z_RLE$1 ? $3fe9119940fa16b8$var$deflate_rle(s, flush) : $3fe9119940fa16b8$var$configuration_table[s.level].func(s, flush);
        if (bstate === $3fe9119940fa16b8$var$BS_FINISH_STARTED || bstate === $3fe9119940fa16b8$var$BS_FINISH_DONE) s.status = $3fe9119940fa16b8$var$FINISH_STATE;
        if (bstate === $3fe9119940fa16b8$var$BS_NEED_MORE || bstate === $3fe9119940fa16b8$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $3fe9119940fa16b8$var$Z_OK$2;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $3fe9119940fa16b8$var$BS_BLOCK_DONE) {
            if (flush === $3fe9119940fa16b8$var$Z_PARTIAL_FLUSH$1) $3fe9119940fa16b8$var$_tr_align(s);
            else if (flush !== $3fe9119940fa16b8$var$Z_BLOCK$2) {
                $3fe9119940fa16b8$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $3fe9119940fa16b8$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $3fe9119940fa16b8$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $3fe9119940fa16b8$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $3fe9119940fa16b8$var$Z_OK$2;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $3fe9119940fa16b8$var$Z_FINISH$2) return $3fe9119940fa16b8$var$Z_OK$2;
    if (s.wrap <= 0) return $3fe9119940fa16b8$var$Z_STREAM_END$2;
    /* Write the trailer */ if (s.wrap === 2) {
        $3fe9119940fa16b8$var$put_byte(s, strm.adler & 0xff);
        $3fe9119940fa16b8$var$put_byte(s, strm.adler >> 8 & 0xff);
        $3fe9119940fa16b8$var$put_byte(s, strm.adler >> 16 & 0xff);
        $3fe9119940fa16b8$var$put_byte(s, strm.adler >> 24 & 0xff);
        $3fe9119940fa16b8$var$put_byte(s, strm.total_in & 0xff);
        $3fe9119940fa16b8$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $3fe9119940fa16b8$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $3fe9119940fa16b8$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $3fe9119940fa16b8$var$putShortMSB(s, strm.adler >>> 16);
        $3fe9119940fa16b8$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $3fe9119940fa16b8$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $3fe9119940fa16b8$var$Z_OK$2 : $3fe9119940fa16b8$var$Z_STREAM_END$2;
}
function $3fe9119940fa16b8$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $3fe9119940fa16b8$var$Z_STREAM_ERROR$2;
    status = strm.state.status;
    if (status !== $3fe9119940fa16b8$var$INIT_STATE && status !== $3fe9119940fa16b8$var$EXTRA_STATE && status !== $3fe9119940fa16b8$var$NAME_STATE && status !== $3fe9119940fa16b8$var$COMMENT_STATE && status !== $3fe9119940fa16b8$var$HCRC_STATE && status !== $3fe9119940fa16b8$var$BUSY_STATE && status !== $3fe9119940fa16b8$var$FINISH_STATE) return $3fe9119940fa16b8$var$err(strm, $3fe9119940fa16b8$var$Z_STREAM_ERROR$2);
    strm.state = null;
    return status === $3fe9119940fa16b8$var$BUSY_STATE ? $3fe9119940fa16b8$var$err(strm, $3fe9119940fa16b8$var$Z_DATA_ERROR$2) : $3fe9119940fa16b8$var$Z_OK$2;
}
/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ // See state defs from inflate.js
var $3fe9119940fa16b8$var$BAD$1 = 30; /* got a data error -- remain here until reset */ 
var $3fe9119940fa16b8$var$TYPE$2 = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ function $3fe9119940fa16b8$var$inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $3fe9119940fa16b8$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $3fe9119940fa16b8$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $3fe9119940fa16b8$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $3fe9119940fa16b8$var$TYPE$2;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $3fe9119940fa16b8$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
}
var $3fe9119940fa16b8$var$MAXBITS = 15;
var $3fe9119940fa16b8$var$ENOUGH_LENS$1 = 852;
var $3fe9119940fa16b8$var$ENOUGH_DISTS$1 = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $3fe9119940fa16b8$var$CODES$1 = 0;
var $3fe9119940fa16b8$var$LENS$1 = 1;
var $3fe9119940fa16b8$var$DISTS$1 = 2;
var $3fe9119940fa16b8$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $3fe9119940fa16b8$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $3fe9119940fa16b8$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $3fe9119940fa16b8$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
function $3fe9119940fa16b8$var$inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $3fe9119940fa16b8$var$Buf16($3fe9119940fa16b8$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $3fe9119940fa16b8$var$Buf16($3fe9119940fa16b8$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $3fe9119940fa16b8$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $3fe9119940fa16b8$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $3fe9119940fa16b8$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $3fe9119940fa16b8$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $3fe9119940fa16b8$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $3fe9119940fa16b8$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $3fe9119940fa16b8$var$LENS$1) {
        base = $3fe9119940fa16b8$var$lbase;
        base_index -= 257;
        extra = $3fe9119940fa16b8$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $3fe9119940fa16b8$var$dbase;
        extra = $3fe9119940fa16b8$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $3fe9119940fa16b8$var$LENS$1 && used > $3fe9119940fa16b8$var$ENOUGH_LENS$1 || type === $3fe9119940fa16b8$var$DISTS$1 && used > $3fe9119940fa16b8$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $3fe9119940fa16b8$var$LENS$1 && used > $3fe9119940fa16b8$var$ENOUGH_LENS$1 || type === $3fe9119940fa16b8$var$DISTS$1 && used > $3fe9119940fa16b8$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
}
var $3fe9119940fa16b8$var$CODES = 0;
var $3fe9119940fa16b8$var$LENS = 1;
var $3fe9119940fa16b8$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $3fe9119940fa16b8$var$Z_FINISH$1 = 4;
var $3fe9119940fa16b8$var$Z_BLOCK$1 = 5;
var $3fe9119940fa16b8$var$Z_TREES$1 = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $3fe9119940fa16b8$var$Z_OK$1 = 0;
var $3fe9119940fa16b8$var$Z_STREAM_END$1 = 1;
var $3fe9119940fa16b8$var$Z_NEED_DICT$1 = 2;
//var Z_ERRNO         = -1;
var $3fe9119940fa16b8$var$Z_STREAM_ERROR$1 = -2;
var $3fe9119940fa16b8$var$Z_DATA_ERROR$1 = -3;
var $3fe9119940fa16b8$var$Z_MEM_ERROR = -4;
var $3fe9119940fa16b8$var$Z_BUF_ERROR$1 = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $3fe9119940fa16b8$var$Z_DEFLATED$1 = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $3fe9119940fa16b8$var$HEAD = 1; /* i: waiting for magic header */ 
var $3fe9119940fa16b8$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $3fe9119940fa16b8$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $3fe9119940fa16b8$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $3fe9119940fa16b8$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $3fe9119940fa16b8$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $3fe9119940fa16b8$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $3fe9119940fa16b8$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $3fe9119940fa16b8$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $3fe9119940fa16b8$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $3fe9119940fa16b8$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $3fe9119940fa16b8$var$TYPE$1 = 12; /* i: waiting for type bits, including last-flag bit */ 
var $3fe9119940fa16b8$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $3fe9119940fa16b8$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $3fe9119940fa16b8$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $3fe9119940fa16b8$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $3fe9119940fa16b8$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $3fe9119940fa16b8$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $3fe9119940fa16b8$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $3fe9119940fa16b8$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $3fe9119940fa16b8$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $3fe9119940fa16b8$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $3fe9119940fa16b8$var$DIST = 23; /* i: waiting for distance code */ 
var $3fe9119940fa16b8$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $3fe9119940fa16b8$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $3fe9119940fa16b8$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $3fe9119940fa16b8$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $3fe9119940fa16b8$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $3fe9119940fa16b8$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $3fe9119940fa16b8$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $3fe9119940fa16b8$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $3fe9119940fa16b8$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $3fe9119940fa16b8$var$ENOUGH_LENS = 852;
var $3fe9119940fa16b8$var$ENOUGH_DISTS = 592;
function $3fe9119940fa16b8$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $3fe9119940fa16b8$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $3fe9119940fa16b8$var$Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $3fe9119940fa16b8$var$Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $3fe9119940fa16b8$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $3fe9119940fa16b8$var$Z_STREAM_ERROR$1;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $3fe9119940fa16b8$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $3fe9119940fa16b8$var$Buf32($3fe9119940fa16b8$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $3fe9119940fa16b8$var$Buf32($3fe9119940fa16b8$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $3fe9119940fa16b8$var$Z_OK$1;
}
function $3fe9119940fa16b8$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $3fe9119940fa16b8$var$Z_STREAM_ERROR$1;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $3fe9119940fa16b8$var$inflateResetKeep(strm);
}
function $3fe9119940fa16b8$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $3fe9119940fa16b8$var$Z_STREAM_ERROR$1;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $3fe9119940fa16b8$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $3fe9119940fa16b8$var$inflateReset(strm);
}
function $3fe9119940fa16b8$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $3fe9119940fa16b8$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $3fe9119940fa16b8$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $3fe9119940fa16b8$var$inflateReset2(strm, windowBits);
    if (ret !== $3fe9119940fa16b8$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $3fe9119940fa16b8$var$virgin = true;
var $3fe9119940fa16b8$var$lenfix, $3fe9119940fa16b8$var$distfix; // We have no pointers in JS, so keep tables separate
function $3fe9119940fa16b8$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($3fe9119940fa16b8$var$virgin) {
        var sym;
        $3fe9119940fa16b8$var$lenfix = new $3fe9119940fa16b8$var$Buf32(512);
        $3fe9119940fa16b8$var$distfix = new $3fe9119940fa16b8$var$Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $3fe9119940fa16b8$var$inflate_table($3fe9119940fa16b8$var$LENS, state.lens, 0, 288, $3fe9119940fa16b8$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $3fe9119940fa16b8$var$inflate_table($3fe9119940fa16b8$var$DISTS, state.lens, 0, 32, $3fe9119940fa16b8$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $3fe9119940fa16b8$var$virgin = false;
    }
    state.lencode = $3fe9119940fa16b8$var$lenfix;
    state.lenbits = 9;
    state.distcode = $3fe9119940fa16b8$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $3fe9119940fa16b8$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $3fe9119940fa16b8$var$Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $3fe9119940fa16b8$var$arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $3fe9119940fa16b8$var$arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $3fe9119940fa16b8$var$arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $3fe9119940fa16b8$var$inflate$1(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $3fe9119940fa16b8$var$Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $3fe9119940fa16b8$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $3fe9119940fa16b8$var$TYPE$1) state.mode = $3fe9119940fa16b8$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $3fe9119940fa16b8$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $3fe9119940fa16b8$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $3fe9119940fa16b8$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $3fe9119940fa16b8$var$crc32(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $3fe9119940fa16b8$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $3fe9119940fa16b8$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $3fe9119940fa16b8$var$Z_DEFLATED$1) {
                strm.msg = 'unknown compression method';
                state.mode = $3fe9119940fa16b8$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $3fe9119940fa16b8$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $3fe9119940fa16b8$var$DICTID : $3fe9119940fa16b8$var$TYPE$1;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $3fe9119940fa16b8$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $3fe9119940fa16b8$var$Z_DEFLATED$1) {
                strm.msg = 'unknown compression method';
                state.mode = $3fe9119940fa16b8$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $3fe9119940fa16b8$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $3fe9119940fa16b8$var$crc32(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $3fe9119940fa16b8$var$TIME;
        /* falls through */ case $3fe9119940fa16b8$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $3fe9119940fa16b8$var$crc32(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $3fe9119940fa16b8$var$OS;
        /* falls through */ case $3fe9119940fa16b8$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $3fe9119940fa16b8$var$crc32(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $3fe9119940fa16b8$var$EXLEN;
        /* falls through */ case $3fe9119940fa16b8$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $3fe9119940fa16b8$var$crc32(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $3fe9119940fa16b8$var$EXTRA;
        /* falls through */ case $3fe9119940fa16b8$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more conveniend processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $3fe9119940fa16b8$var$arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $3fe9119940fa16b8$var$crc32(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $3fe9119940fa16b8$var$NAME;
        /* falls through */ case $3fe9119940fa16b8$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $3fe9119940fa16b8$var$crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $3fe9119940fa16b8$var$COMMENT;
        /* falls through */ case $3fe9119940fa16b8$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $3fe9119940fa16b8$var$crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $3fe9119940fa16b8$var$HCRC;
        /* falls through */ case $3fe9119940fa16b8$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $3fe9119940fa16b8$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $3fe9119940fa16b8$var$TYPE$1;
            break;
        case $3fe9119940fa16b8$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $3fe9119940fa16b8$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $3fe9119940fa16b8$var$DICT;
        /* falls through */ case $3fe9119940fa16b8$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $3fe9119940fa16b8$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $3fe9119940fa16b8$var$TYPE$1;
        /* falls through */ case $3fe9119940fa16b8$var$TYPE$1:
            if (flush === $3fe9119940fa16b8$var$Z_BLOCK$1 || flush === $3fe9119940fa16b8$var$Z_TREES$1) break inf_leave;
        /* falls through */ case $3fe9119940fa16b8$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $3fe9119940fa16b8$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $3fe9119940fa16b8$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $3fe9119940fa16b8$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $3fe9119940fa16b8$var$LEN_; /* decode codes */ 
                    if (flush === $3fe9119940fa16b8$var$Z_TREES$1) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $3fe9119940fa16b8$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $3fe9119940fa16b8$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $3fe9119940fa16b8$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $3fe9119940fa16b8$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $3fe9119940fa16b8$var$COPY_;
            if (flush === $3fe9119940fa16b8$var$Z_TREES$1) break inf_leave;
        /* falls through */ case $3fe9119940fa16b8$var$COPY_:
            state.mode = $3fe9119940fa16b8$var$COPY;
        /* falls through */ case $3fe9119940fa16b8$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $3fe9119940fa16b8$var$arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $3fe9119940fa16b8$var$TYPE$1;
            break;
        case $3fe9119940fa16b8$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $3fe9119940fa16b8$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $3fe9119940fa16b8$var$LENLENS;
        /* falls through */ case $3fe9119940fa16b8$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $3fe9119940fa16b8$var$inflate_table($3fe9119940fa16b8$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $3fe9119940fa16b8$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $3fe9119940fa16b8$var$CODELENS;
        /* falls through */ case $3fe9119940fa16b8$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $3fe9119940fa16b8$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $3fe9119940fa16b8$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $3fe9119940fa16b8$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $3fe9119940fa16b8$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $3fe9119940fa16b8$var$inflate_table($3fe9119940fa16b8$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $3fe9119940fa16b8$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $3fe9119940fa16b8$var$inflate_table($3fe9119940fa16b8$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $3fe9119940fa16b8$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $3fe9119940fa16b8$var$LEN_;
            if (flush === $3fe9119940fa16b8$var$Z_TREES$1) break inf_leave;
        /* falls through */ case $3fe9119940fa16b8$var$LEN_:
            state.mode = $3fe9119940fa16b8$var$LEN;
        /* falls through */ case $3fe9119940fa16b8$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $3fe9119940fa16b8$var$inflate_fast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $3fe9119940fa16b8$var$TYPE$1) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $3fe9119940fa16b8$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $3fe9119940fa16b8$var$TYPE$1;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $3fe9119940fa16b8$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $3fe9119940fa16b8$var$LENEXT;
        /* falls through */ case $3fe9119940fa16b8$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $3fe9119940fa16b8$var$DIST;
        /* falls through */ case $3fe9119940fa16b8$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $3fe9119940fa16b8$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $3fe9119940fa16b8$var$DISTEXT;
        /* falls through */ case $3fe9119940fa16b8$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $3fe9119940fa16b8$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $3fe9119940fa16b8$var$MATCH;
        /* falls through */ case $3fe9119940fa16b8$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $3fe9119940fa16b8$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $3fe9119940fa16b8$var$LEN;
            break;
        case $3fe9119940fa16b8$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $3fe9119940fa16b8$var$LEN;
            break;
        case $3fe9119940fa16b8$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' insdead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $3fe9119940fa16b8$var$crc32(state.check, output, _out, put - _out) : $3fe9119940fa16b8$var$adler32(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $3fe9119940fa16b8$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $3fe9119940fa16b8$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $3fe9119940fa16b8$var$LENGTH;
        /* falls through */ case $3fe9119940fa16b8$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $3fe9119940fa16b8$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $3fe9119940fa16b8$var$DONE;
        /* falls through */ case $3fe9119940fa16b8$var$DONE:
            ret = $3fe9119940fa16b8$var$Z_STREAM_END$1;
            break inf_leave;
        case $3fe9119940fa16b8$var$BAD:
            ret = $3fe9119940fa16b8$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $3fe9119940fa16b8$var$MEM:
            return $3fe9119940fa16b8$var$Z_MEM_ERROR;
        case $3fe9119940fa16b8$var$SYNC:
        /* falls through */ default:
            return $3fe9119940fa16b8$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $3fe9119940fa16b8$var$BAD && (state.mode < $3fe9119940fa16b8$var$CHECK || flush !== $3fe9119940fa16b8$var$Z_FINISH$1)) $3fe9119940fa16b8$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $3fe9119940fa16b8$var$crc32(state.check, output, _out, strm.next_out - _out) : $3fe9119940fa16b8$var$adler32(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $3fe9119940fa16b8$var$TYPE$1 ? 128 : 0) + (state.mode === $3fe9119940fa16b8$var$LEN_ || state.mode === $3fe9119940fa16b8$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $3fe9119940fa16b8$var$Z_FINISH$1) && ret === $3fe9119940fa16b8$var$Z_OK$1) ret = $3fe9119940fa16b8$var$Z_BUF_ERROR$1;
    return ret;
}
function $3fe9119940fa16b8$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $3fe9119940fa16b8$var$Z_STREAM_ERROR$1;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $3fe9119940fa16b8$var$Z_OK$1;
}
/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ // import constants from './constants';
// zlib modes
var $3fe9119940fa16b8$var$NONE = 0;
var $3fe9119940fa16b8$var$DEFLATE = 1;
var $3fe9119940fa16b8$var$INFLATE = 2;
var $3fe9119940fa16b8$var$GZIP = 3;
var $3fe9119940fa16b8$var$GUNZIP = 4;
var $3fe9119940fa16b8$var$DEFLATERAW = 5;
var $3fe9119940fa16b8$var$INFLATERAW = 6;
var $3fe9119940fa16b8$var$UNZIP = 7;
var $3fe9119940fa16b8$var$Z_NO_FLUSH = 0, $3fe9119940fa16b8$var$Z_PARTIAL_FLUSH = 1, $3fe9119940fa16b8$var$Z_SYNC_FLUSH = 2, $3fe9119940fa16b8$var$Z_FULL_FLUSH = 3, $3fe9119940fa16b8$var$Z_FINISH = 4, $3fe9119940fa16b8$var$Z_BLOCK = 5, $3fe9119940fa16b8$var$Z_TREES = 6, /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ $3fe9119940fa16b8$var$Z_OK = 0, $3fe9119940fa16b8$var$Z_STREAM_END = 1, $3fe9119940fa16b8$var$Z_NEED_DICT = 2, $3fe9119940fa16b8$var$Z_ERRNO = -1, $3fe9119940fa16b8$var$Z_STREAM_ERROR = -2, $3fe9119940fa16b8$var$Z_DATA_ERROR = -3, //Z_MEM_ERROR:     -4,
$3fe9119940fa16b8$var$Z_BUF_ERROR = -5, //Z_VERSION_ERROR: -6,
/* compression levels */ $3fe9119940fa16b8$var$Z_NO_COMPRESSION = 0, $3fe9119940fa16b8$var$Z_BEST_SPEED = 1, $3fe9119940fa16b8$var$Z_BEST_COMPRESSION = 9, $3fe9119940fa16b8$var$Z_DEFAULT_COMPRESSION = -1, $3fe9119940fa16b8$var$Z_FILTERED = 1, $3fe9119940fa16b8$var$Z_HUFFMAN_ONLY = 2, $3fe9119940fa16b8$var$Z_RLE = 3, $3fe9119940fa16b8$var$Z_FIXED = 4, $3fe9119940fa16b8$var$Z_DEFAULT_STRATEGY = 0, /* Possible values of the data_type field (though see inflate()) */ $3fe9119940fa16b8$var$Z_BINARY = 0, $3fe9119940fa16b8$var$Z_TEXT = 1, //Z_ASCII:                1, // = Z_TEXT (deprecated)
$3fe9119940fa16b8$var$Z_UNKNOWN = 2, /* The deflate compression method */ $3fe9119940fa16b8$var$Z_DEFLATED = 8;
function $3fe9119940fa16b8$var$Zlib$1(mode) {
    if (mode < $3fe9119940fa16b8$var$DEFLATE || mode > $3fe9119940fa16b8$var$UNZIP) throw new TypeError('Bad argument');
    this.mode = mode;
    this.init_done = false;
    this.write_in_progress = false;
    this.pending_close = false;
    this.windowBits = 0;
    this.level = 0;
    this.memLevel = 0;
    this.strategy = 0;
    this.dictionary = null;
}
$3fe9119940fa16b8$var$Zlib$1.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
    this.windowBits = windowBits;
    this.level = level;
    this.memLevel = memLevel;
    this.strategy = strategy;
    // dictionary not supported.
    if (this.mode === $3fe9119940fa16b8$var$GZIP || this.mode === $3fe9119940fa16b8$var$GUNZIP) this.windowBits += 16;
    if (this.mode === $3fe9119940fa16b8$var$UNZIP) this.windowBits += 32;
    if (this.mode === $3fe9119940fa16b8$var$DEFLATERAW || this.mode === $3fe9119940fa16b8$var$INFLATERAW) this.windowBits = -this.windowBits;
    this.strm = new $3fe9119940fa16b8$var$ZStream();
    var status;
    switch(this.mode){
        case $3fe9119940fa16b8$var$DEFLATE:
        case $3fe9119940fa16b8$var$GZIP:
        case $3fe9119940fa16b8$var$DEFLATERAW:
            status = $3fe9119940fa16b8$var$deflateInit2(this.strm, this.level, $3fe9119940fa16b8$var$Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
            break;
        case $3fe9119940fa16b8$var$INFLATE:
        case $3fe9119940fa16b8$var$GUNZIP:
        case $3fe9119940fa16b8$var$INFLATERAW:
        case $3fe9119940fa16b8$var$UNZIP:
            status = $3fe9119940fa16b8$var$inflateInit2(this.strm, this.windowBits);
            break;
        default:
            throw new Error('Unknown mode ' + this.mode);
    }
    if (status !== $3fe9119940fa16b8$var$Z_OK) {
        this._error(status);
        return;
    }
    this.write_in_progress = false;
    this.init_done = true;
};
$3fe9119940fa16b8$var$Zlib$1.prototype.params = function() {
    throw new Error('deflateParams Not supported');
};
$3fe9119940fa16b8$var$Zlib$1.prototype._writeCheck = function() {
    if (!this.init_done) throw new Error('write before init');
    if (this.mode === $3fe9119940fa16b8$var$NONE) throw new Error('already finalized');
    if (this.write_in_progress) throw new Error('write already in progress');
    if (this.pending_close) throw new Error('close is pending');
};
$3fe9119940fa16b8$var$Zlib$1.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
    this._writeCheck();
    this.write_in_progress = true;
    var self1 = this;
    $3fe9119940fa16b8$var$browser$1.nextTick(function() {
        self1.write_in_progress = false;
        var res = self1._write(flush, input, in_off, in_len, out, out_off, out_len);
        self1.callback(res[0], res[1]);
        if (self1.pending_close) self1.close();
    });
    return this;
};
// set method for Node buffers, used by pako
function $3fe9119940fa16b8$var$bufferSet(data, offset) {
    for(var i = 0; i < data.length; i++)this[offset + i] = data[i];
}
$3fe9119940fa16b8$var$Zlib$1.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
    this._writeCheck();
    return this._write(flush, input, in_off, in_len, out, out_off, out_len);
};
$3fe9119940fa16b8$var$Zlib$1.prototype._write = function(flush, input, in_off, in_len, out, out_off, out_len) {
    this.write_in_progress = true;
    if (flush !== $3fe9119940fa16b8$var$Z_NO_FLUSH && flush !== $3fe9119940fa16b8$var$Z_PARTIAL_FLUSH && flush !== $3fe9119940fa16b8$var$Z_SYNC_FLUSH && flush !== $3fe9119940fa16b8$var$Z_FULL_FLUSH && flush !== $3fe9119940fa16b8$var$Z_FINISH && flush !== $3fe9119940fa16b8$var$Z_BLOCK) throw new Error('Invalid flush value');
    if (input == null) {
        input = new $3fe9119940fa16b8$var$Buffer$1(0);
        in_len = 0;
        in_off = 0;
    }
    if (out._set) out.set = out._set;
    else out.set = $3fe9119940fa16b8$var$bufferSet;
    var strm = this.strm;
    strm.avail_in = in_len;
    strm.input = input;
    strm.next_in = in_off;
    strm.avail_out = out_len;
    strm.output = out;
    strm.next_out = out_off;
    var status;
    switch(this.mode){
        case $3fe9119940fa16b8$var$DEFLATE:
        case $3fe9119940fa16b8$var$GZIP:
        case $3fe9119940fa16b8$var$DEFLATERAW:
            status = $3fe9119940fa16b8$var$deflate$1(strm, flush);
            break;
        case $3fe9119940fa16b8$var$UNZIP:
        case $3fe9119940fa16b8$var$INFLATE:
        case $3fe9119940fa16b8$var$GUNZIP:
        case $3fe9119940fa16b8$var$INFLATERAW:
            status = $3fe9119940fa16b8$var$inflate$1(strm, flush);
            break;
        default:
            throw new Error('Unknown mode ' + this.mode);
    }
    if (!this._checkError(status, strm, flush)) this._error(status);
    this.write_in_progress = false;
    return [
        strm.avail_in,
        strm.avail_out
    ];
};
$3fe9119940fa16b8$var$Zlib$1.prototype._checkError = function(status, strm, flush) {
    // Acceptable error states depend on the type of zlib stream.
    switch(status){
        case $3fe9119940fa16b8$var$Z_OK:
        case $3fe9119940fa16b8$var$Z_BUF_ERROR:
            if (strm.avail_out !== 0 && flush === $3fe9119940fa16b8$var$Z_FINISH) return false;
            break;
        case $3fe9119940fa16b8$var$Z_STREAM_END:
            break;
        case $3fe9119940fa16b8$var$Z_NEED_DICT:
            return false;
        default:
            return false;
    }
    return true;
};
$3fe9119940fa16b8$var$Zlib$1.prototype.close = function() {
    if (this.write_in_progress) {
        this.pending_close = true;
        return;
    }
    this.pending_close = false;
    if (this.mode === $3fe9119940fa16b8$var$DEFLATE || this.mode === $3fe9119940fa16b8$var$GZIP || this.mode === $3fe9119940fa16b8$var$DEFLATERAW) $3fe9119940fa16b8$var$deflateEnd(this.strm);
    else $3fe9119940fa16b8$var$inflateEnd(this.strm);
    this.mode = $3fe9119940fa16b8$var$NONE;
};
var $3fe9119940fa16b8$var$status;
$3fe9119940fa16b8$var$Zlib$1.prototype.reset = function() {
    switch(this.mode){
        case $3fe9119940fa16b8$var$DEFLATE:
        case $3fe9119940fa16b8$var$DEFLATERAW:
            $3fe9119940fa16b8$var$status = $3fe9119940fa16b8$var$deflateReset(this.strm);
            break;
        case $3fe9119940fa16b8$var$INFLATE:
        case $3fe9119940fa16b8$var$INFLATERAW:
            $3fe9119940fa16b8$var$status = $3fe9119940fa16b8$var$inflateReset(this.strm);
            break;
    }
    if ($3fe9119940fa16b8$var$status !== $3fe9119940fa16b8$var$Z_OK) this._error($3fe9119940fa16b8$var$status);
};
$3fe9119940fa16b8$var$Zlib$1.prototype._error = function(status) {
    this.onerror($3fe9119940fa16b8$var$msg[status] + ': ' + this.strm.msg, status);
    this.write_in_progress = false;
    if (this.pending_close) this.close();
};
var $3fe9119940fa16b8$var$_binding = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DEFLATE: $3fe9119940fa16b8$var$DEFLATE,
    DEFLATERAW: $3fe9119940fa16b8$var$DEFLATERAW,
    GUNZIP: $3fe9119940fa16b8$var$GUNZIP,
    GZIP: $3fe9119940fa16b8$var$GZIP,
    INFLATE: $3fe9119940fa16b8$var$INFLATE,
    INFLATERAW: $3fe9119940fa16b8$var$INFLATERAW,
    NONE: $3fe9119940fa16b8$var$NONE,
    UNZIP: $3fe9119940fa16b8$var$UNZIP,
    Z_BEST_COMPRESSION: $3fe9119940fa16b8$var$Z_BEST_COMPRESSION,
    Z_BEST_SPEED: $3fe9119940fa16b8$var$Z_BEST_SPEED,
    Z_BINARY: $3fe9119940fa16b8$var$Z_BINARY,
    Z_BLOCK: $3fe9119940fa16b8$var$Z_BLOCK,
    Z_BUF_ERROR: $3fe9119940fa16b8$var$Z_BUF_ERROR,
    Z_DATA_ERROR: $3fe9119940fa16b8$var$Z_DATA_ERROR,
    Z_DEFAULT_COMPRESSION: $3fe9119940fa16b8$var$Z_DEFAULT_COMPRESSION,
    Z_DEFAULT_STRATEGY: $3fe9119940fa16b8$var$Z_DEFAULT_STRATEGY,
    Z_DEFLATED: $3fe9119940fa16b8$var$Z_DEFLATED,
    Z_ERRNO: $3fe9119940fa16b8$var$Z_ERRNO,
    Z_FILTERED: $3fe9119940fa16b8$var$Z_FILTERED,
    Z_FINISH: $3fe9119940fa16b8$var$Z_FINISH,
    Z_FIXED: $3fe9119940fa16b8$var$Z_FIXED,
    Z_FULL_FLUSH: $3fe9119940fa16b8$var$Z_FULL_FLUSH,
    Z_HUFFMAN_ONLY: $3fe9119940fa16b8$var$Z_HUFFMAN_ONLY,
    Z_NEED_DICT: $3fe9119940fa16b8$var$Z_NEED_DICT,
    Z_NO_COMPRESSION: $3fe9119940fa16b8$var$Z_NO_COMPRESSION,
    Z_NO_FLUSH: $3fe9119940fa16b8$var$Z_NO_FLUSH,
    Z_OK: $3fe9119940fa16b8$var$Z_OK,
    Z_PARTIAL_FLUSH: $3fe9119940fa16b8$var$Z_PARTIAL_FLUSH,
    Z_RLE: $3fe9119940fa16b8$var$Z_RLE,
    Z_STREAM_END: $3fe9119940fa16b8$var$Z_STREAM_END,
    Z_STREAM_ERROR: $3fe9119940fa16b8$var$Z_STREAM_ERROR,
    Z_SYNC_FLUSH: $3fe9119940fa16b8$var$Z_SYNC_FLUSH,
    Z_TEXT: $3fe9119940fa16b8$var$Z_TEXT,
    Z_TREES: $3fe9119940fa16b8$var$Z_TREES,
    Z_UNKNOWN: $3fe9119940fa16b8$var$Z_UNKNOWN,
    Zlib: $3fe9119940fa16b8$var$Zlib$1
});
function $3fe9119940fa16b8$var$assert(a, msg) {
    if (!a) throw new Error(msg);
}
var $3fe9119940fa16b8$var$binding = {};
Object.keys($3fe9119940fa16b8$var$_binding).forEach(function(key) {
    $3fe9119940fa16b8$var$binding[key] = $3fe9119940fa16b8$var$_binding[key];
});
// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
$3fe9119940fa16b8$var$binding.Z_MIN_WINDOWBITS = 8;
$3fe9119940fa16b8$var$binding.Z_MAX_WINDOWBITS = 15;
$3fe9119940fa16b8$var$binding.Z_DEFAULT_WINDOWBITS = 15;
// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
$3fe9119940fa16b8$var$binding.Z_MIN_CHUNK = 64;
$3fe9119940fa16b8$var$binding.Z_MAX_CHUNK = Infinity;
$3fe9119940fa16b8$var$binding.Z_DEFAULT_CHUNK = 16384;
$3fe9119940fa16b8$var$binding.Z_MIN_MEMLEVEL = 1;
$3fe9119940fa16b8$var$binding.Z_MAX_MEMLEVEL = 9;
$3fe9119940fa16b8$var$binding.Z_DEFAULT_MEMLEVEL = 8;
$3fe9119940fa16b8$var$binding.Z_MIN_LEVEL = -1;
$3fe9119940fa16b8$var$binding.Z_MAX_LEVEL = 9;
$3fe9119940fa16b8$var$binding.Z_DEFAULT_LEVEL = $3fe9119940fa16b8$var$binding.Z_DEFAULT_COMPRESSION;
// translation table for return codes.
var $3fe9119940fa16b8$var$codes = {
    Z_OK: $3fe9119940fa16b8$var$binding.Z_OK,
    Z_STREAM_END: $3fe9119940fa16b8$var$binding.Z_STREAM_END,
    Z_NEED_DICT: $3fe9119940fa16b8$var$binding.Z_NEED_DICT,
    Z_ERRNO: $3fe9119940fa16b8$var$binding.Z_ERRNO,
    Z_STREAM_ERROR: $3fe9119940fa16b8$var$binding.Z_STREAM_ERROR,
    Z_DATA_ERROR: $3fe9119940fa16b8$var$binding.Z_DATA_ERROR,
    Z_MEM_ERROR: $3fe9119940fa16b8$var$binding.Z_MEM_ERROR,
    Z_BUF_ERROR: $3fe9119940fa16b8$var$binding.Z_BUF_ERROR,
    Z_VERSION_ERROR: $3fe9119940fa16b8$var$binding.Z_VERSION_ERROR
};
Object.keys($3fe9119940fa16b8$var$codes).forEach(function(k) {
    $3fe9119940fa16b8$var$codes[$3fe9119940fa16b8$var$codes[k]] = k;
});
function $3fe9119940fa16b8$var$createDeflate(o) {
    return new $3fe9119940fa16b8$var$Deflate(o);
}
function $3fe9119940fa16b8$var$createInflate(o) {
    return new $3fe9119940fa16b8$var$Inflate(o);
}
function $3fe9119940fa16b8$var$createDeflateRaw(o) {
    return new $3fe9119940fa16b8$var$DeflateRaw(o);
}
function $3fe9119940fa16b8$var$createInflateRaw(o) {
    return new $3fe9119940fa16b8$var$InflateRaw(o);
}
function $3fe9119940fa16b8$var$createGzip(o) {
    return new $3fe9119940fa16b8$var$Gzip(o);
}
function $3fe9119940fa16b8$var$createGunzip(o) {
    return new $3fe9119940fa16b8$var$Gunzip(o);
}
function $3fe9119940fa16b8$var$createUnzip(o) {
    return new $3fe9119940fa16b8$var$Unzip(o);
}
// Convenience methods.
// compress/decompress a string or buffer in one step.
function $3fe9119940fa16b8$var$deflate(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $3fe9119940fa16b8$var$zlibBuffer(new $3fe9119940fa16b8$var$Deflate(opts), buffer, callback);
}
function $3fe9119940fa16b8$var$deflateSync(buffer, opts) {
    return $3fe9119940fa16b8$var$zlibBufferSync(new $3fe9119940fa16b8$var$Deflate(opts), buffer);
}
function $3fe9119940fa16b8$var$gzip(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $3fe9119940fa16b8$var$zlibBuffer(new $3fe9119940fa16b8$var$Gzip(opts), buffer, callback);
}
function $3fe9119940fa16b8$var$gzipSync(buffer, opts) {
    return $3fe9119940fa16b8$var$zlibBufferSync(new $3fe9119940fa16b8$var$Gzip(opts), buffer);
}
function $3fe9119940fa16b8$var$deflateRaw(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $3fe9119940fa16b8$var$zlibBuffer(new $3fe9119940fa16b8$var$DeflateRaw(opts), buffer, callback);
}
function $3fe9119940fa16b8$var$deflateRawSync(buffer, opts) {
    return $3fe9119940fa16b8$var$zlibBufferSync(new $3fe9119940fa16b8$var$DeflateRaw(opts), buffer);
}
function $3fe9119940fa16b8$var$unzip(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $3fe9119940fa16b8$var$zlibBuffer(new $3fe9119940fa16b8$var$Unzip(opts), buffer, callback);
}
function $3fe9119940fa16b8$var$unzipSync(buffer, opts) {
    return $3fe9119940fa16b8$var$zlibBufferSync(new $3fe9119940fa16b8$var$Unzip(opts), buffer);
}
function $3fe9119940fa16b8$var$inflate(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $3fe9119940fa16b8$var$zlibBuffer(new $3fe9119940fa16b8$var$Inflate(opts), buffer, callback);
}
function $3fe9119940fa16b8$var$inflateSync(buffer, opts) {
    return $3fe9119940fa16b8$var$zlibBufferSync(new $3fe9119940fa16b8$var$Inflate(opts), buffer);
}
function $3fe9119940fa16b8$var$gunzip(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $3fe9119940fa16b8$var$zlibBuffer(new $3fe9119940fa16b8$var$Gunzip(opts), buffer, callback);
}
function $3fe9119940fa16b8$var$gunzipSync(buffer, opts) {
    return $3fe9119940fa16b8$var$zlibBufferSync(new $3fe9119940fa16b8$var$Gunzip(opts), buffer);
}
function $3fe9119940fa16b8$var$inflateRaw(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $3fe9119940fa16b8$var$zlibBuffer(new $3fe9119940fa16b8$var$InflateRaw(opts), buffer, callback);
}
function $3fe9119940fa16b8$var$inflateRawSync(buffer, opts) {
    return $3fe9119940fa16b8$var$zlibBufferSync(new $3fe9119940fa16b8$var$InflateRaw(opts), buffer);
}
function $3fe9119940fa16b8$var$zlibBuffer(engine, buffer, callback) {
    var buffers = [];
    var nread = 0;
    engine.on('error', onError);
    engine.on('end', onEnd);
    engine.end(buffer);
    flow();
    function flow() {
        var chunk;
        while(null !== (chunk = engine.read())){
            buffers.push(chunk);
            nread += chunk.length;
        }
        engine.once('readable', flow);
    }
    function onError(err) {
        engine.removeListener('end', onEnd);
        engine.removeListener('readable', flow);
        callback(err);
    }
    function onEnd() {
        var buf = $3fe9119940fa16b8$var$Buffer$1.concat(buffers, nread);
        buffers = [];
        callback(null, buf);
        engine.close();
    }
}
function $3fe9119940fa16b8$var$zlibBufferSync(engine, buffer) {
    if (typeof buffer === 'string') buffer = new $3fe9119940fa16b8$var$Buffer$1(buffer);
    if (!$3fe9119940fa16b8$var$Buffer$1.isBuffer(buffer)) throw new TypeError('Not a string or buffer');
    var flushFlag = $3fe9119940fa16b8$var$binding.Z_FINISH;
    return engine._processChunk(buffer, flushFlag);
}
// generic zlib
// minimal 2-byte header
function $3fe9119940fa16b8$var$Deflate(opts) {
    if (!(this instanceof $3fe9119940fa16b8$var$Deflate)) return new $3fe9119940fa16b8$var$Deflate(opts);
    $3fe9119940fa16b8$var$Zlib.call(this, opts, $3fe9119940fa16b8$var$binding.DEFLATE);
}
function $3fe9119940fa16b8$var$Inflate(opts) {
    if (!(this instanceof $3fe9119940fa16b8$var$Inflate)) return new $3fe9119940fa16b8$var$Inflate(opts);
    $3fe9119940fa16b8$var$Zlib.call(this, opts, $3fe9119940fa16b8$var$binding.INFLATE);
}
// gzip - bigger header, same deflate compression
function $3fe9119940fa16b8$var$Gzip(opts) {
    if (!(this instanceof $3fe9119940fa16b8$var$Gzip)) return new $3fe9119940fa16b8$var$Gzip(opts);
    $3fe9119940fa16b8$var$Zlib.call(this, opts, $3fe9119940fa16b8$var$binding.GZIP);
}
function $3fe9119940fa16b8$var$Gunzip(opts) {
    if (!(this instanceof $3fe9119940fa16b8$var$Gunzip)) return new $3fe9119940fa16b8$var$Gunzip(opts);
    $3fe9119940fa16b8$var$Zlib.call(this, opts, $3fe9119940fa16b8$var$binding.GUNZIP);
}
// raw - no header
function $3fe9119940fa16b8$var$DeflateRaw(opts) {
    if (!(this instanceof $3fe9119940fa16b8$var$DeflateRaw)) return new $3fe9119940fa16b8$var$DeflateRaw(opts);
    $3fe9119940fa16b8$var$Zlib.call(this, opts, $3fe9119940fa16b8$var$binding.DEFLATERAW);
}
function $3fe9119940fa16b8$var$InflateRaw(opts) {
    if (!(this instanceof $3fe9119940fa16b8$var$InflateRaw)) return new $3fe9119940fa16b8$var$InflateRaw(opts);
    $3fe9119940fa16b8$var$Zlib.call(this, opts, $3fe9119940fa16b8$var$binding.INFLATERAW);
}
// auto-detect header.
function $3fe9119940fa16b8$var$Unzip(opts) {
    if (!(this instanceof $3fe9119940fa16b8$var$Unzip)) return new $3fe9119940fa16b8$var$Unzip(opts);
    $3fe9119940fa16b8$var$Zlib.call(this, opts, $3fe9119940fa16b8$var$binding.UNZIP);
}
// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.
function $3fe9119940fa16b8$var$Zlib(opts, mode) {
    this._opts = opts = opts || {};
    this._chunkSize = opts.chunkSize || $3fe9119940fa16b8$var$binding.Z_DEFAULT_CHUNK;
    $3fe9119940fa16b8$var$Transform.call(this, opts);
    if (opts.flush) {
        if (opts.flush !== $3fe9119940fa16b8$var$binding.Z_NO_FLUSH && opts.flush !== $3fe9119940fa16b8$var$binding.Z_PARTIAL_FLUSH && opts.flush !== $3fe9119940fa16b8$var$binding.Z_SYNC_FLUSH && opts.flush !== $3fe9119940fa16b8$var$binding.Z_FULL_FLUSH && opts.flush !== $3fe9119940fa16b8$var$binding.Z_FINISH && opts.flush !== $3fe9119940fa16b8$var$binding.Z_BLOCK) throw new Error('Invalid flush flag: ' + opts.flush);
    }
    this._flushFlag = opts.flush || $3fe9119940fa16b8$var$binding.Z_NO_FLUSH;
    if (opts.chunkSize) {
        if (opts.chunkSize < $3fe9119940fa16b8$var$binding.Z_MIN_CHUNK || opts.chunkSize > $3fe9119940fa16b8$var$binding.Z_MAX_CHUNK) throw new Error('Invalid chunk size: ' + opts.chunkSize);
    }
    if (opts.windowBits) {
        if (opts.windowBits < $3fe9119940fa16b8$var$binding.Z_MIN_WINDOWBITS || opts.windowBits > $3fe9119940fa16b8$var$binding.Z_MAX_WINDOWBITS) throw new Error('Invalid windowBits: ' + opts.windowBits);
    }
    if (opts.level) {
        if (opts.level < $3fe9119940fa16b8$var$binding.Z_MIN_LEVEL || opts.level > $3fe9119940fa16b8$var$binding.Z_MAX_LEVEL) throw new Error('Invalid compression level: ' + opts.level);
    }
    if (opts.memLevel) {
        if (opts.memLevel < $3fe9119940fa16b8$var$binding.Z_MIN_MEMLEVEL || opts.memLevel > $3fe9119940fa16b8$var$binding.Z_MAX_MEMLEVEL) throw new Error('Invalid memLevel: ' + opts.memLevel);
    }
    if (opts.strategy) {
        if (opts.strategy != $3fe9119940fa16b8$var$binding.Z_FILTERED && opts.strategy != $3fe9119940fa16b8$var$binding.Z_HUFFMAN_ONLY && opts.strategy != $3fe9119940fa16b8$var$binding.Z_RLE && opts.strategy != $3fe9119940fa16b8$var$binding.Z_FIXED && opts.strategy != $3fe9119940fa16b8$var$binding.Z_DEFAULT_STRATEGY) throw new Error('Invalid strategy: ' + opts.strategy);
    }
    if (opts.dictionary) {
        if (!$3fe9119940fa16b8$var$Buffer$1.isBuffer(opts.dictionary)) throw new Error('Invalid dictionary: it should be a Buffer instance');
    }
    this._binding = new $3fe9119940fa16b8$var$binding.Zlib(mode);
    var self1 = this;
    this._hadError = false;
    this._binding.onerror = function(message, errno) {
        // there is no way to cleanly recover.
        // continuing only obscures problems.
        self1._binding = null;
        self1._hadError = true;
        var error = new Error(message);
        error.errno = errno;
        error.code = $3fe9119940fa16b8$var$codes[errno];
        self1.emit('error', error);
    };
    var level = $3fe9119940fa16b8$var$binding.Z_DEFAULT_COMPRESSION;
    if (typeof opts.level === 'number') level = opts.level;
    var strategy = $3fe9119940fa16b8$var$binding.Z_DEFAULT_STRATEGY;
    if (typeof opts.strategy === 'number') strategy = opts.strategy;
    this._binding.init(opts.windowBits || $3fe9119940fa16b8$var$binding.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || $3fe9119940fa16b8$var$binding.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
    this._buffer = new $3fe9119940fa16b8$var$Buffer$1(this._chunkSize);
    this._offset = 0;
    this._closed = false;
    this._level = level;
    this._strategy = strategy;
    this.once('end', this.close);
}
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$Zlib, $3fe9119940fa16b8$var$Transform);
$3fe9119940fa16b8$var$Zlib.prototype.params = function(level, strategy, callback) {
    if (level < $3fe9119940fa16b8$var$binding.Z_MIN_LEVEL || level > $3fe9119940fa16b8$var$binding.Z_MAX_LEVEL) throw new RangeError('Invalid compression level: ' + level);
    if (strategy != $3fe9119940fa16b8$var$binding.Z_FILTERED && strategy != $3fe9119940fa16b8$var$binding.Z_HUFFMAN_ONLY && strategy != $3fe9119940fa16b8$var$binding.Z_RLE && strategy != $3fe9119940fa16b8$var$binding.Z_FIXED && strategy != $3fe9119940fa16b8$var$binding.Z_DEFAULT_STRATEGY) throw new TypeError('Invalid strategy: ' + strategy);
    if (this._level !== level || this._strategy !== strategy) {
        var self1 = this;
        this.flush($3fe9119940fa16b8$var$binding.Z_SYNC_FLUSH, function() {
            self1._binding.params(level, strategy);
            if (!self1._hadError) {
                self1._level = level;
                self1._strategy = strategy;
                if (callback) callback();
            }
        });
    } else $3fe9119940fa16b8$var$browser$1.nextTick(callback);
};
$3fe9119940fa16b8$var$Zlib.prototype.reset = function() {
    return this._binding.reset();
};
// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
$3fe9119940fa16b8$var$Zlib.prototype._flush = function(callback) {
    this._transform(new $3fe9119940fa16b8$var$Buffer$1(0), '', callback);
};
$3fe9119940fa16b8$var$Zlib.prototype.flush = function(kind, callback) {
    var ws = this._writableState;
    if (typeof kind === 'function' || kind === void 0 && !callback) {
        callback = kind;
        kind = $3fe9119940fa16b8$var$binding.Z_FULL_FLUSH;
    }
    if (ws.ended) {
        if (callback) $3fe9119940fa16b8$var$browser$1.nextTick(callback);
    } else if (ws.ending) {
        if (callback) this.once('end', callback);
    } else if (ws.needDrain) {
        var self1 = this;
        this.once('drain', function() {
            self1.flush(callback);
        });
    } else {
        this._flushFlag = kind;
        this.write(new $3fe9119940fa16b8$var$Buffer$1(0), '', callback);
    }
};
$3fe9119940fa16b8$var$Zlib.prototype.close = function(callback) {
    if (callback) $3fe9119940fa16b8$var$browser$1.nextTick(callback);
    if (this._closed) return;
    this._closed = true;
    this._binding.close();
    var self1 = this;
    $3fe9119940fa16b8$var$browser$1.nextTick(function() {
        self1.emit('close');
    });
};
$3fe9119940fa16b8$var$Zlib.prototype._transform = function(chunk, encoding, cb) {
    var flushFlag;
    var ws = this._writableState;
    var ending = ws.ending || ws.ended;
    var last = ending && (!chunk || ws.length === chunk.length);
    // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag.
    // If it's explicitly flushing at some other time, then we use
    // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
    // goodness.
    if (last) flushFlag = $3fe9119940fa16b8$var$binding.Z_FINISH;
    else {
        flushFlag = this._flushFlag;
        // once we've flushed the last of the queue, stop flushing and
        // go back to the normal behavior.
        if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || $3fe9119940fa16b8$var$binding.Z_NO_FLUSH;
    }
    this._processChunk(chunk, flushFlag, cb);
};
$3fe9119940fa16b8$var$Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
    var availInBefore = chunk && chunk.length;
    var availOutBefore = this._chunkSize - this._offset;
    var inOff = 0;
    var self1 = this;
    var async = typeof cb === 'function';
    if (!async) {
        var buffers = [];
        var nread = 0;
        var error;
        this.on('error', function(er) {
            error = er;
        });
        do var res = this._binding.writeSync(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
        while (!this._hadError && callback(res[0], res[1]));
        if (this._hadError) throw error;
        var buf = $3fe9119940fa16b8$var$Buffer$1.concat(buffers, nread);
        this.close();
        return buf;
    }
    var req = this._binding.write(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
    req.buffer = chunk;
    req.callback = callback;
    function callback(availInAfter, availOutAfter) {
        if (self1._hadError) return;
        var have = availOutBefore - availOutAfter;
        $3fe9119940fa16b8$var$assert(have >= 0, 'have should not go down');
        if (have > 0) {
            var out = self1._buffer.slice(self1._offset, self1._offset + have);
            self1._offset += have;
            // serve some output to the consumer.
            if (async) self1.push(out);
            else {
                buffers.push(out);
                nread += out.length;
            }
        }
        // exhausted the output buffer, or used all the input create a new one.
        if (availOutAfter === 0 || self1._offset >= self1._chunkSize) {
            availOutBefore = self1._chunkSize;
            self1._offset = 0;
            self1._buffer = new $3fe9119940fa16b8$var$Buffer$1(self1._chunkSize);
        }
        if (availOutAfter === 0) {
            // Not actually done.  Need to reprocess.
            // Also, update the availInBefore to the availInAfter value,
            // so that if we have to hit it a third (fourth, etc.) time,
            // it'll have the correct byte counts.
            inOff += availInBefore - availInAfter;
            availInBefore = availInAfter;
            if (!async) return true;
            var newReq = self1._binding.write(flushFlag, chunk, inOff, availInBefore, self1._buffer, self1._offset, self1._chunkSize);
            newReq.callback = callback; // this same function
            newReq.buffer = chunk;
            return;
        }
        if (!async) return false;
        // finished with the chunk.
        cb();
    }
};
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$Deflate, $3fe9119940fa16b8$var$Zlib);
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$Inflate, $3fe9119940fa16b8$var$Zlib);
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$Gzip, $3fe9119940fa16b8$var$Zlib);
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$Gunzip, $3fe9119940fa16b8$var$Zlib);
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$DeflateRaw, $3fe9119940fa16b8$var$Zlib);
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$InflateRaw, $3fe9119940fa16b8$var$Zlib);
$3fe9119940fa16b8$var$inherits($3fe9119940fa16b8$var$Unzip, $3fe9119940fa16b8$var$Zlib);
var $3fe9119940fa16b8$var$zlib = {
    codes: $3fe9119940fa16b8$var$codes,
    createDeflate: $3fe9119940fa16b8$var$createDeflate,
    createInflate: $3fe9119940fa16b8$var$createInflate,
    createDeflateRaw: $3fe9119940fa16b8$var$createDeflateRaw,
    createInflateRaw: $3fe9119940fa16b8$var$createInflateRaw,
    createGzip: $3fe9119940fa16b8$var$createGzip,
    createGunzip: $3fe9119940fa16b8$var$createGunzip,
    createUnzip: $3fe9119940fa16b8$var$createUnzip,
    deflate: $3fe9119940fa16b8$var$deflate,
    deflateSync: $3fe9119940fa16b8$var$deflateSync,
    gzip: $3fe9119940fa16b8$var$gzip,
    gzipSync: $3fe9119940fa16b8$var$gzipSync,
    deflateRaw: $3fe9119940fa16b8$var$deflateRaw,
    deflateRawSync: $3fe9119940fa16b8$var$deflateRawSync,
    unzip: $3fe9119940fa16b8$var$unzip,
    unzipSync: $3fe9119940fa16b8$var$unzipSync,
    inflate: $3fe9119940fa16b8$var$inflate,
    inflateSync: $3fe9119940fa16b8$var$inflateSync,
    gunzip: $3fe9119940fa16b8$var$gunzip,
    gunzipSync: $3fe9119940fa16b8$var$gunzipSync,
    inflateRaw: $3fe9119940fa16b8$var$inflateRaw,
    inflateRawSync: $3fe9119940fa16b8$var$inflateRawSync,
    Deflate: $3fe9119940fa16b8$var$Deflate,
    Inflate: $3fe9119940fa16b8$var$Inflate,
    Gzip: $3fe9119940fa16b8$var$Gzip,
    Gunzip: $3fe9119940fa16b8$var$Gunzip,
    DeflateRaw: $3fe9119940fa16b8$var$DeflateRaw,
    InflateRaw: $3fe9119940fa16b8$var$InflateRaw,
    Unzip: $3fe9119940fa16b8$var$Unzip,
    Zlib: $3fe9119940fa16b8$var$Zlib
};
// Based on https://github.com/tmpvar/jsdom/blob/aa85b2abf07766ff7bf5c1f6daafb3726f2f2db5/lib/jsdom/living/blob.js
// fix for "Readable" isn't a named export issue
const $3fe9119940fa16b8$var$Readable = $3fe9119940fa16b8$var$Stream.Readable;
const $3fe9119940fa16b8$var$BUFFER = Symbol('buffer');
const $3fe9119940fa16b8$var$TYPE = Symbol('type');
class $3fe9119940fa16b8$var$Blob {
    constructor(){
        this[$3fe9119940fa16b8$var$TYPE] = '';
        const blobParts = arguments[0];
        const options = arguments[1];
        const buffers = [];
        let size = 0;
        if (blobParts) {
            const a = blobParts;
            const length = Number(a.length);
            for(let i = 0; i < length; i++){
                const element = a[i];
                let buffer;
                if (element instanceof $3fe9119940fa16b8$require$Buffer) buffer = element;
                else if (ArrayBuffer.isView(element)) buffer = $3fe9119940fa16b8$require$Buffer.from(element.buffer, element.byteOffset, element.byteLength);
                else if (element instanceof ArrayBuffer) buffer = $3fe9119940fa16b8$require$Buffer.from(element);
                else if (element instanceof $3fe9119940fa16b8$var$Blob) buffer = element[$3fe9119940fa16b8$var$BUFFER];
                else buffer = $3fe9119940fa16b8$require$Buffer.from(typeof element === 'string' ? element : String(element));
                size += buffer.length;
                buffers.push(buffer);
            }
        }
        this[$3fe9119940fa16b8$var$BUFFER] = $3fe9119940fa16b8$require$Buffer.concat(buffers);
        let type = options && options.type !== undefined && String(options.type).toLowerCase();
        if (type && !/[^\u0020-\u007E]/.test(type)) this[$3fe9119940fa16b8$var$TYPE] = type;
    }
    get size() {
        return this[$3fe9119940fa16b8$var$BUFFER].length;
    }
    get type() {
        return this[$3fe9119940fa16b8$var$TYPE];
    }
    text() {
        return Promise.resolve(this[$3fe9119940fa16b8$var$BUFFER].toString());
    }
    arrayBuffer() {
        const buf = this[$3fe9119940fa16b8$var$BUFFER];
        const ab = buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
        return Promise.resolve(ab);
    }
    stream() {
        const readable = new $3fe9119940fa16b8$var$Readable();
        readable._read = function() {};
        readable.push(this[$3fe9119940fa16b8$var$BUFFER]);
        readable.push(null);
        return readable;
    }
    toString() {
        return '[object Blob]';
    }
    slice() {
        const size = this.size;
        const start = arguments[0];
        const end = arguments[1];
        let relativeStart, relativeEnd;
        if (start === undefined) relativeStart = 0;
        else if (start < 0) relativeStart = Math.max(size + start, 0);
        else relativeStart = Math.min(start, size);
        if (end === undefined) relativeEnd = size;
        else if (end < 0) relativeEnd = Math.max(size + end, 0);
        else relativeEnd = Math.min(end, size);
        const span = Math.max(relativeEnd - relativeStart, 0);
        const buffer = this[$3fe9119940fa16b8$var$BUFFER];
        const slicedBuffer = buffer.slice(relativeStart, relativeStart + span);
        const blob = new $3fe9119940fa16b8$var$Blob([], {
            type: arguments[2]
        });
        blob[$3fe9119940fa16b8$var$BUFFER] = slicedBuffer;
        return blob;
    }
}
Object.defineProperties($3fe9119940fa16b8$var$Blob.prototype, {
    size: {
        enumerable: true
    },
    type: {
        enumerable: true
    },
    slice: {
        enumerable: true
    }
});
Object.defineProperty($3fe9119940fa16b8$var$Blob.prototype, Symbol.toStringTag, {
    value: 'Blob',
    writable: false,
    enumerable: false,
    configurable: true
});
/**
 * fetch-error.js
 *
 * FetchError interface for operational errors
 */ /**
 * Create FetchError instance
 *
 * @param   String      message      Error message for human
 * @param   String      type         Error type for machine
 * @param   String      systemError  For Node.js system error
 * @return  FetchError
 */ function $3fe9119940fa16b8$var$FetchError(message, type, systemError) {
    Error.call(this, message);
    this.message = message;
    this.type = type;
    // when err.type is `system`, err.code contains system error code
    if (systemError) this.code = this.errno = systemError.code;
    // hide custom error implementation details from end-users
    Error.captureStackTrace(this, this.constructor);
}
$3fe9119940fa16b8$var$FetchError.prototype = Object.create(Error.prototype);
$3fe9119940fa16b8$var$FetchError.prototype.constructor = $3fe9119940fa16b8$var$FetchError;
$3fe9119940fa16b8$var$FetchError.prototype.name = 'FetchError';
let $3fe9119940fa16b8$var$convert;

try {
    $3fe9119940fa16b8$var$convert = (parcelRequire("hK0WK")).convert;
} catch (e) {}
const $3fe9119940fa16b8$var$INTERNALS = Symbol('Body internals');
// fix an issue where "PassThrough" isn't a named export for node <10
const $3fe9119940fa16b8$var$PassThrough = $3fe9119940fa16b8$var$Stream.PassThrough;
/**
 * Body mixin
 *
 * Ref: https://fetch.spec.whatwg.org/#body
 *
 * @param   Stream  body  Readable stream
 * @param   Object  opts  Response options
 * @return  Void
 */ function $3fe9119940fa16b8$var$Body(body) {
    var _this = this;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$size = _ref.size;
    let size = _ref$size === undefined ? 0 : _ref$size;
    var _ref$timeout = _ref.timeout;
    let timeout = _ref$timeout === undefined ? 0 : _ref$timeout;
    if (body == null) // body is undefined or null
    body = null;
    else if ($3fe9119940fa16b8$var$isURLSearchParams(body)) // body is a URLSearchParams
    body = $3fe9119940fa16b8$require$Buffer.from(body.toString());
    else if ($3fe9119940fa16b8$var$isBlob(body)) ;
    else if ($3fe9119940fa16b8$require$Buffer.isBuffer(body)) ;
    else if (Object.prototype.toString.call(body) === '[object ArrayBuffer]') // body is ArrayBuffer
    body = $3fe9119940fa16b8$require$Buffer.from(body);
    else if (ArrayBuffer.isView(body)) // body is ArrayBufferView
    body = $3fe9119940fa16b8$require$Buffer.from(body.buffer, body.byteOffset, body.byteLength);
    else if (body instanceof $3fe9119940fa16b8$var$Stream) ;
    else // none of the above
    // coerce to string then buffer
    body = $3fe9119940fa16b8$require$Buffer.from(String(body));
    this[$3fe9119940fa16b8$var$INTERNALS] = {
        body: body,
        disturbed: false,
        error: null
    };
    this.size = size;
    this.timeout = timeout;
    if (body instanceof $3fe9119940fa16b8$var$Stream) body.on('error', function(err) {
        const error = err.name === 'AbortError' ? err : new $3fe9119940fa16b8$var$FetchError(`Invalid response body while trying to fetch ${_this.url}: ${err.message}`, 'system', err);
        _this[$3fe9119940fa16b8$var$INTERNALS].error = error;
    });
}
$3fe9119940fa16b8$var$Body.prototype = {
    get body () {
        return this[$3fe9119940fa16b8$var$INTERNALS].body;
    },
    get bodyUsed () {
        return this[$3fe9119940fa16b8$var$INTERNALS].disturbed;
    },
    /**
  * Decode response as ArrayBuffer
  *
  * @return  Promise
  */ arrayBuffer () {
        return $3fe9119940fa16b8$var$consumeBody.call(this).then(function(buf) {
            return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
        });
    },
    /**
  * Return raw response as Blob
  *
  * @return Promise
  */ blob () {
        let ct = this.headers && this.headers.get('content-type') || '';
        return $3fe9119940fa16b8$var$consumeBody.call(this).then(function(buf) {
            return Object.assign(// Prevent copying
            new $3fe9119940fa16b8$var$Blob([], {
                type: ct.toLowerCase()
            }), {
                [$3fe9119940fa16b8$var$BUFFER]: buf
            });
        });
    },
    /**
  * Decode response as json
  *
  * @return  Promise
  */ json () {
        var _this2 = this;
        return $3fe9119940fa16b8$var$consumeBody.call(this).then(function(buffer) {
            try {
                return JSON.parse(buffer.toString());
            } catch (err) {
                return $3fe9119940fa16b8$var$Body.Promise.reject(new $3fe9119940fa16b8$var$FetchError(`invalid json response body at ${_this2.url} reason: ${err.message}`, 'invalid-json'));
            }
        });
    },
    /**
  * Decode response as text
  *
  * @return  Promise
  */ text () {
        return $3fe9119940fa16b8$var$consumeBody.call(this).then(function(buffer) {
            return buffer.toString();
        });
    },
    /**
  * Decode response as buffer (non-spec api)
  *
  * @return  Promise
  */ buffer () {
        return $3fe9119940fa16b8$var$consumeBody.call(this);
    },
    /**
  * Decode response as text, while automatically detecting the encoding and
  * trying to decode to UTF-8 (non-spec api)
  *
  * @return  Promise
  */ textConverted () {
        var _this3 = this;
        return $3fe9119940fa16b8$var$consumeBody.call(this).then(function(buffer) {
            return $3fe9119940fa16b8$var$convertBody(buffer, _this3.headers);
        });
    }
};
// In browsers, all properties are enumerable.
Object.defineProperties($3fe9119940fa16b8$var$Body.prototype, {
    body: {
        enumerable: true
    },
    bodyUsed: {
        enumerable: true
    },
    arrayBuffer: {
        enumerable: true
    },
    blob: {
        enumerable: true
    },
    json: {
        enumerable: true
    },
    text: {
        enumerable: true
    }
});
$3fe9119940fa16b8$var$Body.mixIn = function(proto) {
    for (const name of Object.getOwnPropertyNames($3fe9119940fa16b8$var$Body.prototype))// istanbul ignore else: future proof
    if (!(name in proto)) {
        const desc = Object.getOwnPropertyDescriptor($3fe9119940fa16b8$var$Body.prototype, name);
        Object.defineProperty(proto, name, desc);
    }
};
/**
 * Consume and convert an entire Body to a Buffer.
 *
 * Ref: https://fetch.spec.whatwg.org/#concept-body-consume-body
 *
 * @return  Promise
 */ function $3fe9119940fa16b8$var$consumeBody() {
    var _this4 = this;
    if (this[$3fe9119940fa16b8$var$INTERNALS].disturbed) return $3fe9119940fa16b8$var$Body.Promise.reject(new TypeError(`body used already for: ${this.url}`));
    this[$3fe9119940fa16b8$var$INTERNALS].disturbed = true;
    if (this[$3fe9119940fa16b8$var$INTERNALS].error) return $3fe9119940fa16b8$var$Body.Promise.reject(this[$3fe9119940fa16b8$var$INTERNALS].error);
    let body = this.body;
    // body is null
    if (body === null) return $3fe9119940fa16b8$var$Body.Promise.resolve($3fe9119940fa16b8$require$Buffer.alloc(0));
    // body is blob
    if ($3fe9119940fa16b8$var$isBlob(body)) body = body.stream();
    // body is buffer
    if ($3fe9119940fa16b8$require$Buffer.isBuffer(body)) return $3fe9119940fa16b8$var$Body.Promise.resolve(body);
    // istanbul ignore if: should never happen
    if (!(body instanceof $3fe9119940fa16b8$var$Stream)) return $3fe9119940fa16b8$var$Body.Promise.resolve($3fe9119940fa16b8$require$Buffer.alloc(0));
    // body is stream
    // get ready to actually consume the body
    let accum = [];
    let accumBytes = 0;
    let abort = false;
    return new $3fe9119940fa16b8$var$Body.Promise(function(resolve, reject) {
        let resTimeout;
        // allow timeout on slow response body
        if (_this4.timeout) resTimeout = setTimeout(function() {
            abort = true;
            reject(new $3fe9119940fa16b8$var$FetchError(`Response timeout while trying to fetch ${_this4.url} (over ${_this4.timeout}ms)`, 'body-timeout'));
        }, _this4.timeout);
        // handle stream errors
        body.on('error', function(err) {
            if (err.name === 'AbortError') {
                // if the request was aborted, reject with this Error
                abort = true;
                reject(err);
            } else // other errors, such as incorrect content-encoding
            reject(new $3fe9119940fa16b8$var$FetchError(`Invalid response body while trying to fetch ${_this4.url}: ${err.message}`, 'system', err));
        });
        body.on('data', function(chunk) {
            if (abort || chunk === null) return;
            if (_this4.size && accumBytes + chunk.length > _this4.size) {
                abort = true;
                reject(new $3fe9119940fa16b8$var$FetchError(`content size at ${_this4.url} over limit: ${_this4.size}`, 'max-size'));
                return;
            }
            accumBytes += chunk.length;
            accum.push(chunk);
        });
        body.on('end', function() {
            if (abort) return;
            clearTimeout(resTimeout);
            try {
                resolve($3fe9119940fa16b8$require$Buffer.concat(accum, accumBytes));
            } catch (err) {
                // handle streams that have accumulated too much data (issue #414)
                reject(new $3fe9119940fa16b8$var$FetchError(`Could not create Buffer from response body for ${_this4.url}: ${err.message}`, 'system', err));
            }
        });
    });
}
/**
 * Detect buffer encoding and convert to target encoding
 * ref: http://www.w3.org/TR/2011/WD-html5-20110113/parsing.html#determining-the-character-encoding
 *
 * @param   Buffer  buffer    Incoming buffer
 * @param   String  encoding  Target encoding
 * @return  String
 */ function $3fe9119940fa16b8$var$convertBody(buffer, headers) {
    if (typeof $3fe9119940fa16b8$var$convert !== 'function') throw new Error('The package `encoding` must be installed to use the textConverted() function');
    const ct = headers.get('content-type');
    let charset = 'utf-8';
    let res, str;
    // header
    if (ct) res = /charset=([^;]*)/i.exec(ct);
    // no charset in content type, peek at response body for at most 1024 bytes
    str = buffer.slice(0, 1024).toString();
    // html5
    if (!res && str) res = /<meta.+?charset=(['"])(.+?)\1/i.exec(str);
    // html4
    if (!res && str) {
        res = /<meta[\s]+?http-equiv=(['"])content-type\1[\s]+?content=(['"])(.+?)\2/i.exec(str);
        if (!res) {
            res = /<meta[\s]+?content=(['"])(.+?)\1[\s]+?http-equiv=(['"])content-type\3/i.exec(str);
            if (res) res.pop(); // drop last quote
        }
        if (res) res = /charset=(.*)/i.exec(res.pop());
    }
    // xml
    if (!res && str) res = /<\?xml.+?encoding=(['"])(.+?)\1/i.exec(str);
    // found charset
    if (res) {
        charset = res.pop();
        // prevent decode issues when sites use incorrect encoding
        // ref: https://hsivonen.fi/encoding-menu/
        if (charset === 'gb2312' || charset === 'gbk') charset = 'gb18030';
    }
    // turn raw buffers into a single utf-8 buffer
    return $3fe9119940fa16b8$var$convert(buffer, 'UTF-8', charset).toString();
}
/**
 * Detect a URLSearchParams object
 * ref: https://github.com/bitinn/node-fetch/issues/296#issuecomment-307598143
 *
 * @param   Object  obj     Object to detect by type or brand
 * @return  String
 */ function $3fe9119940fa16b8$var$isURLSearchParams(obj) {
    // Duck-typing as a necessary condition.
    if (typeof obj !== 'object' || typeof obj.append !== 'function' || typeof obj.delete !== 'function' || typeof obj.get !== 'function' || typeof obj.getAll !== 'function' || typeof obj.has !== 'function' || typeof obj.set !== 'function') return false;
    // Brand-checking and more duck-typing as optional condition.
    return obj.constructor.name === 'URLSearchParams' || Object.prototype.toString.call(obj) === '[object URLSearchParams]' || typeof obj.sort === 'function';
}
/**
 * Check if `obj` is a W3C `Blob` object (which `File` inherits from)
 * @param  {*} obj
 * @return {boolean}
 */ function $3fe9119940fa16b8$var$isBlob(obj) {
    return typeof obj === 'object' && typeof obj.arrayBuffer === 'function' && typeof obj.type === 'string' && typeof obj.stream === 'function' && typeof obj.constructor === 'function' && typeof obj.constructor.name === 'string' && /^(Blob|File)$/.test(obj.constructor.name) && /^(Blob|File)$/.test(obj[Symbol.toStringTag]);
}
/**
 * Clone body given Res/Req instance
 *
 * @param   Mixed  instance  Response or Request instance
 * @return  Mixed
 */ function $3fe9119940fa16b8$var$clone(instance) {
    let p1, p2;
    let body = instance.body;
    // don't allow cloning a used body
    if (instance.bodyUsed) throw new Error('cannot clone body after it is used');
    // check that body is a stream and not form-data object
    // note: we can't clone the form-data object without having it as a dependency
    if (body instanceof $3fe9119940fa16b8$var$Stream && typeof body.getBoundary !== 'function') {
        // tee instance body
        p1 = new $3fe9119940fa16b8$var$PassThrough();
        p2 = new $3fe9119940fa16b8$var$PassThrough();
        body.pipe(p1);
        body.pipe(p2);
        // set instance body to teed body and return the other teed body
        instance[$3fe9119940fa16b8$var$INTERNALS].body = p1;
        body = p2;
    }
    return body;
}
/**
 * Performs the operation "extract a `Content-Type` value from |object|" as
 * specified in the specification:
 * https://fetch.spec.whatwg.org/#concept-bodyinit-extract
 *
 * This function assumes that instance.body is present.
 *
 * @param   Mixed  instance  Any options.body input
 */ function $3fe9119940fa16b8$var$extractContentType(body) {
    if (body === null) // body is null
    return null;
    else if (typeof body === 'string') // body is string
    return 'text/plain;charset=UTF-8';
    else if ($3fe9119940fa16b8$var$isURLSearchParams(body)) // body is a URLSearchParams
    return 'application/x-www-form-urlencoded;charset=UTF-8';
    else if ($3fe9119940fa16b8$var$isBlob(body)) // body is blob
    return body.type || null;
    else if ($3fe9119940fa16b8$require$Buffer.isBuffer(body)) // body is buffer
    return null;
    else if (Object.prototype.toString.call(body) === '[object ArrayBuffer]') // body is ArrayBuffer
    return null;
    else if (ArrayBuffer.isView(body)) // body is ArrayBufferView
    return null;
    else if (typeof body.getBoundary === 'function') // detect form data input from form-data module
    return `multipart/form-data;boundary=${body.getBoundary()}`;
    else if (body instanceof $3fe9119940fa16b8$var$Stream) // body is stream
    // can't really do much about this
    return null;
    else // Body constructor defaults other things to string
    return 'text/plain;charset=UTF-8';
}
/**
 * The Fetch Standard treats this as if "total bytes" is a property on the body.
 * For us, we have to explicitly get it with a function.
 *
 * ref: https://fetch.spec.whatwg.org/#concept-body-total-bytes
 *
 * @param   Body    instance   Instance of Body
 * @return  Number?            Number of bytes, or null if not possible
 */ function $3fe9119940fa16b8$var$getTotalBytes(instance) {
    const body = instance.body;
    if (body === null) // body is null
    return 0;
    else if ($3fe9119940fa16b8$var$isBlob(body)) return body.size;
    else if ($3fe9119940fa16b8$require$Buffer.isBuffer(body)) // body is buffer
    return body.length;
    else if (body && typeof body.getLengthSync === 'function') {
        // detect form data input from form-data module
        if (body._lengthRetrievers && body._lengthRetrievers.length == 0 || // 1.x
        body.hasKnownLength && body.hasKnownLength()) // 2.x
        return body.getLengthSync();
        return null;
    } else // body is stream
    return null;
}
/**
 * Write a Body to a Node.js WritableStream (e.g. http.Request) object.
 *
 * @param   Body    instance   Instance of Body
 * @return  Void
 */ function $3fe9119940fa16b8$var$writeToStream(dest, instance) {
    const body = instance.body;
    if (body === null) // body is null
    dest.end();
    else if ($3fe9119940fa16b8$var$isBlob(body)) body.stream().pipe(dest);
    else if ($3fe9119940fa16b8$require$Buffer.isBuffer(body)) {
        // body is buffer
        dest.write(body);
        dest.end();
    } else // body is stream
    body.pipe(dest);
}
// expose Promise
$3fe9119940fa16b8$var$Body.Promise = $parcel$global.Promise;
/**
 * headers.js
 *
 * Headers class offers convenient helpers
 */ const $3fe9119940fa16b8$var$invalidTokenRegex = /[^\^_`a-zA-Z\-0-9!#$%&'*+.|~]/;
const $3fe9119940fa16b8$var$invalidHeaderCharRegex = /[^\t\x20-\x7e\x80-\xff]/;
function $3fe9119940fa16b8$var$validateName(name) {
    name = `${name}`;
    if ($3fe9119940fa16b8$var$invalidTokenRegex.test(name) || name === '') throw new TypeError(`${name} is not a legal HTTP header name`);
}
function $3fe9119940fa16b8$var$validateValue(value) {
    value = `${value}`;
    if ($3fe9119940fa16b8$var$invalidHeaderCharRegex.test(value)) throw new TypeError(`${value} is not a legal HTTP header value`);
}
/**
 * Find the key in the map object given a header name.
 *
 * Returns undefined if not found.
 *
 * @param   String  name  Header name
 * @return  String|Undefined
 */ function $3fe9119940fa16b8$var$find(map, name) {
    name = name.toLowerCase();
    for(const key in map){
        if (key.toLowerCase() === name) return key;
    }
    return undefined;
}
const $3fe9119940fa16b8$var$MAP = Symbol('map');
class $3fe9119940fa16b8$var$Headers {
    /**
  * Headers class
  *
  * @param   Object  headers  Response headers
  * @return  Void
  */ constructor(){
        let init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
        this[$3fe9119940fa16b8$var$MAP] = Object.create(null);
        if (init instanceof $3fe9119940fa16b8$var$Headers) {
            const rawHeaders = init.raw();
            const headerNames = Object.keys(rawHeaders);
            for (const headerName of headerNames)for (const value of rawHeaders[headerName])this.append(headerName, value);
            return;
        }
        // We don't worry about converting prop to ByteString here as append()
        // will handle it.
        if (init == null) ;
        else if (typeof init === 'object') {
            const method = init[Symbol.iterator];
            if (method != null) {
                if (typeof method !== 'function') throw new TypeError('Header pairs must be iterable');
                // sequence<sequence<ByteString>>
                // Note: per spec we have to first exhaust the lists then process them
                const pairs = [];
                for (const pair of init){
                    if (typeof pair !== 'object' || typeof pair[Symbol.iterator] !== 'function') throw new TypeError('Each header pair must be iterable');
                    pairs.push(Array.from(pair));
                }
                for (const pair of pairs){
                    if (pair.length !== 2) throw new TypeError('Each header pair must be a name/value tuple');
                    this.append(pair[0], pair[1]);
                }
            } else // record<ByteString, ByteString>
            for (const key of Object.keys(init)){
                const value = init[key];
                this.append(key, value);
            }
        } else throw new TypeError('Provided initializer must be an object');
    }
    /**
  * Return combined header value given name
  *
  * @param   String  name  Header name
  * @return  Mixed
  */ get(name) {
        name = `${name}`;
        $3fe9119940fa16b8$var$validateName(name);
        const key = $3fe9119940fa16b8$var$find(this[$3fe9119940fa16b8$var$MAP], name);
        if (key === undefined) return null;
        return this[$3fe9119940fa16b8$var$MAP][key].join(', ');
    }
    /**
  * Iterate over all headers
  *
  * @param   Function  callback  Executed for each item with parameters (value, name, thisArg)
  * @param   Boolean   thisArg   `this` context for callback function
  * @return  Void
  */ forEach(callback) {
        let thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
        let pairs = $3fe9119940fa16b8$var$getHeaders(this);
        let i = 0;
        while(i < pairs.length){
            var _pairs$i = pairs[i];
            const name = _pairs$i[0], value = _pairs$i[1];
            callback.call(thisArg, value, name, this);
            pairs = $3fe9119940fa16b8$var$getHeaders(this);
            i++;
        }
    }
    /**
  * Overwrite header values given name
  *
  * @param   String  name   Header name
  * @param   String  value  Header value
  * @return  Void
  */ set(name, value) {
        name = `${name}`;
        value = `${value}`;
        $3fe9119940fa16b8$var$validateName(name);
        $3fe9119940fa16b8$var$validateValue(value);
        const key = $3fe9119940fa16b8$var$find(this[$3fe9119940fa16b8$var$MAP], name);
        this[$3fe9119940fa16b8$var$MAP][key !== undefined ? key : name] = [
            value
        ];
    }
    /**
  * Append a value onto existing header
  *
  * @param   String  name   Header name
  * @param   String  value  Header value
  * @return  Void
  */ append(name, value) {
        name = `${name}`;
        value = `${value}`;
        $3fe9119940fa16b8$var$validateName(name);
        $3fe9119940fa16b8$var$validateValue(value);
        const key = $3fe9119940fa16b8$var$find(this[$3fe9119940fa16b8$var$MAP], name);
        if (key !== undefined) this[$3fe9119940fa16b8$var$MAP][key].push(value);
        else this[$3fe9119940fa16b8$var$MAP][name] = [
            value
        ];
    }
    /**
  * Check for header name existence
  *
  * @param   String   name  Header name
  * @return  Boolean
  */ has(name) {
        name = `${name}`;
        $3fe9119940fa16b8$var$validateName(name);
        return $3fe9119940fa16b8$var$find(this[$3fe9119940fa16b8$var$MAP], name) !== undefined;
    }
    /**
  * Delete all header values given name
  *
  * @param   String  name  Header name
  * @return  Void
  */ delete(name) {
        name = `${name}`;
        $3fe9119940fa16b8$var$validateName(name);
        const key = $3fe9119940fa16b8$var$find(this[$3fe9119940fa16b8$var$MAP], name);
        if (key !== undefined) delete this[$3fe9119940fa16b8$var$MAP][key];
    }
    /**
  * Return raw headers (non-spec api)
  *
  * @return  Object
  */ raw() {
        return this[$3fe9119940fa16b8$var$MAP];
    }
    /**
  * Get an iterator on keys.
  *
  * @return  Iterator
  */ keys() {
        return $3fe9119940fa16b8$var$createHeadersIterator(this, 'key');
    }
    /**
  * Get an iterator on values.
  *
  * @return  Iterator
  */ values() {
        return $3fe9119940fa16b8$var$createHeadersIterator(this, 'value');
    }
    /**
  * Get an iterator on entries.
  *
  * This is the default iterator of the Headers object.
  *
  * @return  Iterator
  */ [Symbol.iterator]() {
        return $3fe9119940fa16b8$var$createHeadersIterator(this, 'key+value');
    }
}
$3fe9119940fa16b8$var$Headers.prototype.entries = $3fe9119940fa16b8$var$Headers.prototype[Symbol.iterator];
Object.defineProperty($3fe9119940fa16b8$var$Headers.prototype, Symbol.toStringTag, {
    value: 'Headers',
    writable: false,
    enumerable: false,
    configurable: true
});
Object.defineProperties($3fe9119940fa16b8$var$Headers.prototype, {
    get: {
        enumerable: true
    },
    forEach: {
        enumerable: true
    },
    set: {
        enumerable: true
    },
    append: {
        enumerable: true
    },
    has: {
        enumerable: true
    },
    delete: {
        enumerable: true
    },
    keys: {
        enumerable: true
    },
    values: {
        enumerable: true
    },
    entries: {
        enumerable: true
    }
});
function $3fe9119940fa16b8$var$getHeaders(headers) {
    let kind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'key+value';
    const keys = Object.keys(headers[$3fe9119940fa16b8$var$MAP]).sort();
    return keys.map(kind === 'key' ? function(k) {
        return k.toLowerCase();
    } : kind === 'value' ? function(k) {
        return headers[$3fe9119940fa16b8$var$MAP][k].join(', ');
    } : function(k) {
        return [
            k.toLowerCase(),
            headers[$3fe9119940fa16b8$var$MAP][k].join(', ')
        ];
    });
}
const $3fe9119940fa16b8$var$INTERNAL = Symbol('internal');
function $3fe9119940fa16b8$var$createHeadersIterator(target, kind) {
    const iterator = Object.create($3fe9119940fa16b8$var$HeadersIteratorPrototype);
    iterator[$3fe9119940fa16b8$var$INTERNAL] = {
        target: target,
        kind: kind,
        index: 0
    };
    return iterator;
}
const $3fe9119940fa16b8$var$HeadersIteratorPrototype = Object.setPrototypeOf({
    next () {
        // istanbul ignore if
        if (!this || Object.getPrototypeOf(this) !== $3fe9119940fa16b8$var$HeadersIteratorPrototype) throw new TypeError('Value of `this` is not a HeadersIterator');
        var _INTERNAL = this[$3fe9119940fa16b8$var$INTERNAL];
        const target = _INTERNAL.target, kind = _INTERNAL.kind, index = _INTERNAL.index;
        const values = $3fe9119940fa16b8$var$getHeaders(target, kind);
        const len = values.length;
        if (index >= len) return {
            value: undefined,
            done: true
        };
        this[$3fe9119940fa16b8$var$INTERNAL].index = index + 1;
        return {
            value: values[index],
            done: false
        };
    }
}, Object.getPrototypeOf(Object.getPrototypeOf([][Symbol.iterator]())));
Object.defineProperty($3fe9119940fa16b8$var$HeadersIteratorPrototype, Symbol.toStringTag, {
    value: 'HeadersIterator',
    writable: false,
    enumerable: false,
    configurable: true
});
/**
 * Export the Headers object in a form that Node.js can consume.
 *
 * @param   Headers  headers
 * @return  Object
 */ function $3fe9119940fa16b8$var$exportNodeCompatibleHeaders(headers) {
    const obj = Object.assign({
        __proto__: null
    }, headers[$3fe9119940fa16b8$var$MAP]);
    // http.request() only supports string as Host header. This hack makes
    // specifying custom Host header possible.
    const hostHeaderKey = $3fe9119940fa16b8$var$find(headers[$3fe9119940fa16b8$var$MAP], 'Host');
    if (hostHeaderKey !== undefined) obj[hostHeaderKey] = obj[hostHeaderKey][0];
    return obj;
}
/**
 * Create a Headers object from an object of headers, ignoring those that do
 * not conform to HTTP grammar productions.
 *
 * @param   Object  obj  Object of headers
 * @return  Headers
 */ function $3fe9119940fa16b8$var$createHeadersLenient(obj) {
    const headers = new $3fe9119940fa16b8$var$Headers();
    for (const name of Object.keys(obj)){
        if ($3fe9119940fa16b8$var$invalidTokenRegex.test(name)) continue;
        if (Array.isArray(obj[name])) for (const val of obj[name]){
            if ($3fe9119940fa16b8$var$invalidHeaderCharRegex.test(val)) continue;
            if (headers[$3fe9119940fa16b8$var$MAP][name] === undefined) headers[$3fe9119940fa16b8$var$MAP][name] = [
                val
            ];
            else headers[$3fe9119940fa16b8$var$MAP][name].push(val);
        }
        else if (!$3fe9119940fa16b8$var$invalidHeaderCharRegex.test(obj[name])) headers[$3fe9119940fa16b8$var$MAP][name] = [
            obj[name]
        ];
    }
    return headers;
}
const $3fe9119940fa16b8$var$INTERNALS$1 = Symbol('Response internals');
// fix an issue where "STATUS_CODES" aren't a named export for node <10
const $3fe9119940fa16b8$var$STATUS_CODES = $3fe9119940fa16b8$var$http.STATUS_CODES;
/**
 * Response class
 *
 * @param   Stream  body  Readable stream
 * @param   Object  opts  Response options
 * @return  Void
 */ class $3fe9119940fa16b8$var$Response {
    constructor(){
        let body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $3fe9119940fa16b8$var$Body.call(this, body, opts);
        const status = opts.status || 200;
        const headers = new $3fe9119940fa16b8$var$Headers(opts.headers);
        if (body != null && !headers.has('Content-Type')) {
            const contentType = $3fe9119940fa16b8$var$extractContentType(body);
            if (contentType) headers.append('Content-Type', contentType);
        }
        this[$3fe9119940fa16b8$var$INTERNALS$1] = {
            url: opts.url,
            status: status,
            statusText: opts.statusText || $3fe9119940fa16b8$var$STATUS_CODES[status],
            headers: headers,
            counter: opts.counter
        };
    }
    get url() {
        return this[$3fe9119940fa16b8$var$INTERNALS$1].url || '';
    }
    get status() {
        return this[$3fe9119940fa16b8$var$INTERNALS$1].status;
    }
    /**
  * Convenience property representing if the request ended normally
  */ get ok() {
        return this[$3fe9119940fa16b8$var$INTERNALS$1].status >= 200 && this[$3fe9119940fa16b8$var$INTERNALS$1].status < 300;
    }
    get redirected() {
        return this[$3fe9119940fa16b8$var$INTERNALS$1].counter > 0;
    }
    get statusText() {
        return this[$3fe9119940fa16b8$var$INTERNALS$1].statusText;
    }
    get headers() {
        return this[$3fe9119940fa16b8$var$INTERNALS$1].headers;
    }
    /**
  * Clone this response
  *
  * @return  Response
  */ clone() {
        return new $3fe9119940fa16b8$var$Response($3fe9119940fa16b8$var$clone(this), {
            url: this.url,
            status: this.status,
            statusText: this.statusText,
            headers: this.headers,
            ok: this.ok,
            redirected: this.redirected
        });
    }
}
$3fe9119940fa16b8$var$Body.mixIn($3fe9119940fa16b8$var$Response.prototype);
Object.defineProperties($3fe9119940fa16b8$var$Response.prototype, {
    url: {
        enumerable: true
    },
    status: {
        enumerable: true
    },
    ok: {
        enumerable: true
    },
    redirected: {
        enumerable: true
    },
    statusText: {
        enumerable: true
    },
    headers: {
        enumerable: true
    },
    clone: {
        enumerable: true
    }
});
Object.defineProperty($3fe9119940fa16b8$var$Response.prototype, Symbol.toStringTag, {
    value: 'Response',
    writable: false,
    enumerable: false,
    configurable: true
});
const $3fe9119940fa16b8$var$INTERNALS$2 = Symbol('Request internals');
const $3fe9119940fa16b8$var$URL = $3fe9119940fa16b8$var$Url.URL || $3fe9119940fa16b8$var$publicApi.URL;
// fix an issue where "format", "parse" aren't a named export for node <10
const $3fe9119940fa16b8$var$parse_url = $3fe9119940fa16b8$var$Url.parse;
const $3fe9119940fa16b8$var$format_url = $3fe9119940fa16b8$var$Url.format;
/**
 * Wrapper around `new URL` to handle arbitrary URLs
 *
 * @param  {string} urlStr
 * @return {void}
 */ function $3fe9119940fa16b8$var$parseURL(urlStr) {
    /*
 	Check whether the URL is absolute or not
 		Scheme: https://tools.ietf.org/html/rfc3986#section-3.1
 	Absolute URL: https://tools.ietf.org/html/rfc3986#section-4.3
 */ if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.exec(urlStr)) urlStr = new $3fe9119940fa16b8$var$URL(urlStr).toString();
    // Fallback to old implementation for arbitrary URLs
    return $3fe9119940fa16b8$var$parse_url(urlStr);
}
const $3fe9119940fa16b8$var$streamDestructionSupported = 'destroy' in $3fe9119940fa16b8$var$Stream.Readable.prototype;
/**
 * Check if a value is an instance of Request.
 *
 * @param   Mixed   input
 * @return  Boolean
 */ function $3fe9119940fa16b8$var$isRequest(input) {
    return typeof input === 'object' && typeof input[$3fe9119940fa16b8$var$INTERNALS$2] === 'object';
}
function $3fe9119940fa16b8$var$isAbortSignal(signal) {
    const proto = signal && typeof signal === 'object' && Object.getPrototypeOf(signal);
    return !!(proto && proto.constructor.name === 'AbortSignal');
}
/**
 * Request class
 *
 * @param   Mixed   input  Url or Request instance
 * @param   Object  init   Custom options
 * @return  Void
 */ class $3fe9119940fa16b8$var$Request {
    constructor(input){
        let init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let parsedURL;
        // normalize input
        if (!$3fe9119940fa16b8$var$isRequest(input)) {
            if (input && input.href) // in order to support Node.js' Url objects; though WHATWG's URL objects
            // will fall into this branch also (since their `toString()` will return
            // `href` property anyway)
            parsedURL = $3fe9119940fa16b8$var$parseURL(input.href);
            else // coerce input to a string before attempting to parse
            parsedURL = $3fe9119940fa16b8$var$parseURL(`${input}`);
            input = {};
        } else parsedURL = $3fe9119940fa16b8$var$parseURL(input.url);
        let method = init.method || input.method || 'GET';
        method = method.toUpperCase();
        if ((init.body != null || $3fe9119940fa16b8$var$isRequest(input) && input.body !== null) && (method === 'GET' || method === 'HEAD')) throw new TypeError('Request with GET/HEAD method cannot have body');
        let inputBody = init.body != null ? init.body : $3fe9119940fa16b8$var$isRequest(input) && input.body !== null ? $3fe9119940fa16b8$var$clone(input) : null;
        $3fe9119940fa16b8$var$Body.call(this, inputBody, {
            timeout: init.timeout || input.timeout || 0,
            size: init.size || input.size || 0
        });
        const headers = new $3fe9119940fa16b8$var$Headers(init.headers || input.headers || {});
        if (inputBody != null && !headers.has('Content-Type')) {
            const contentType = $3fe9119940fa16b8$var$extractContentType(inputBody);
            if (contentType) headers.append('Content-Type', contentType);
        }
        let signal = $3fe9119940fa16b8$var$isRequest(input) ? input.signal : null;
        if ('signal' in init) signal = init.signal;
        if (signal != null && !$3fe9119940fa16b8$var$isAbortSignal(signal)) throw new TypeError('Expected signal to be an instanceof AbortSignal');
        this[$3fe9119940fa16b8$var$INTERNALS$2] = {
            method: method,
            redirect: init.redirect || input.redirect || 'follow',
            headers: headers,
            parsedURL: parsedURL,
            signal: signal
        };
        // node-fetch-only options
        this.follow = init.follow !== undefined ? init.follow : input.follow !== undefined ? input.follow : 20;
        this.compress = init.compress !== undefined ? init.compress : input.compress !== undefined ? input.compress : true;
        this.counter = init.counter || input.counter || 0;
        this.agent = init.agent || input.agent;
    }
    get method() {
        return this[$3fe9119940fa16b8$var$INTERNALS$2].method;
    }
    get url() {
        return $3fe9119940fa16b8$var$format_url(this[$3fe9119940fa16b8$var$INTERNALS$2].parsedURL);
    }
    get headers() {
        return this[$3fe9119940fa16b8$var$INTERNALS$2].headers;
    }
    get redirect() {
        return this[$3fe9119940fa16b8$var$INTERNALS$2].redirect;
    }
    get signal() {
        return this[$3fe9119940fa16b8$var$INTERNALS$2].signal;
    }
    /**
  * Clone this request
  *
  * @return  Request
  */ clone() {
        return new $3fe9119940fa16b8$var$Request(this);
    }
}
$3fe9119940fa16b8$var$Body.mixIn($3fe9119940fa16b8$var$Request.prototype);
Object.defineProperty($3fe9119940fa16b8$var$Request.prototype, Symbol.toStringTag, {
    value: 'Request',
    writable: false,
    enumerable: false,
    configurable: true
});
Object.defineProperties($3fe9119940fa16b8$var$Request.prototype, {
    method: {
        enumerable: true
    },
    url: {
        enumerable: true
    },
    headers: {
        enumerable: true
    },
    redirect: {
        enumerable: true
    },
    clone: {
        enumerable: true
    },
    signal: {
        enumerable: true
    }
});
/**
 * Convert a Request to Node.js http request options.
 *
 * @param   Request  A Request instance
 * @return  Object   The options object to be passed to http.request
 */ function $3fe9119940fa16b8$var$getNodeRequestOptions(request) {
    const parsedURL = request[$3fe9119940fa16b8$var$INTERNALS$2].parsedURL;
    const headers = new $3fe9119940fa16b8$var$Headers(request[$3fe9119940fa16b8$var$INTERNALS$2].headers);
    // fetch step 1.3
    if (!headers.has('Accept')) headers.set('Accept', '*/*');
    // Basic fetch
    if (!parsedURL.protocol || !parsedURL.hostname) throw new TypeError('Only absolute URLs are supported');
    if (!/^https?:$/.test(parsedURL.protocol)) throw new TypeError('Only HTTP(S) protocols are supported');
    if (request.signal && request.body instanceof $3fe9119940fa16b8$var$Stream.Readable && !$3fe9119940fa16b8$var$streamDestructionSupported) throw new Error('Cancellation of streamed requests with AbortSignal is not supported in node < 8');
    // HTTP-network-or-cache fetch steps 2.4-2.7
    let contentLengthValue = null;
    if (request.body == null && /^(POST|PUT)$/i.test(request.method)) contentLengthValue = '0';
    if (request.body != null) {
        const totalBytes = $3fe9119940fa16b8$var$getTotalBytes(request);
        if (typeof totalBytes === 'number') contentLengthValue = String(totalBytes);
    }
    if (contentLengthValue) headers.set('Content-Length', contentLengthValue);
    // HTTP-network-or-cache fetch step 2.11
    if (!headers.has('User-Agent')) headers.set('User-Agent', 'node-fetch/1.0 (+https://github.com/bitinn/node-fetch)');
    // HTTP-network-or-cache fetch step 2.15
    if (request.compress && !headers.has('Accept-Encoding')) headers.set('Accept-Encoding', 'gzip,deflate');
    let agent = request.agent;
    if (typeof agent === 'function') agent = agent(parsedURL);
    // HTTP-network fetch step 4.2
    // chunked encoding is handled by Node.js
    return Object.assign({}, parsedURL, {
        method: request.method,
        headers: $3fe9119940fa16b8$var$exportNodeCompatibleHeaders(headers),
        agent: agent
    });
}
/**
 * abort-error.js
 *
 * AbortError interface for cancelled requests
 */ /**
 * Create AbortError instance
 *
 * @param   String      message      Error message for human
 * @return  AbortError
 */ function $3fe9119940fa16b8$var$AbortError(message) {
    Error.call(this, message);
    this.type = 'aborted';
    this.message = message;
    // hide custom error implementation details from end-users
    Error.captureStackTrace(this, this.constructor);
}
$3fe9119940fa16b8$var$AbortError.prototype = Object.create(Error.prototype);
$3fe9119940fa16b8$var$AbortError.prototype.constructor = $3fe9119940fa16b8$var$AbortError;
$3fe9119940fa16b8$var$AbortError.prototype.name = 'AbortError';
const $3fe9119940fa16b8$var$URL$1 = $3fe9119940fa16b8$var$Url.URL || $3fe9119940fa16b8$var$publicApi.URL;
// fix an issue where "PassThrough", "resolve" aren't a named export for node <10
const $3fe9119940fa16b8$var$PassThrough$1 = $3fe9119940fa16b8$var$Stream.PassThrough;
const $3fe9119940fa16b8$var$isDomainOrSubdomain = function isDomainOrSubdomain(destination, original) {
    const orig = new $3fe9119940fa16b8$var$URL$1(original).hostname;
    const dest = new $3fe9119940fa16b8$var$URL$1(destination).hostname;
    return orig === dest || orig[orig.length - dest.length - 1] === '.' && orig.endsWith(dest);
};
/**
 * isSameProtocol reports whether the two provided URLs use the same protocol.
 *
 * Both domains must already be in canonical form.
 * @param {string|URL} original
 * @param {string|URL} destination
 */ const $3fe9119940fa16b8$var$isSameProtocol = function isSameProtocol(destination, original) {
    const orig = new $3fe9119940fa16b8$var$URL$1(original).protocol;
    const dest = new $3fe9119940fa16b8$var$URL$1(destination).protocol;
    return orig === dest;
};
/**
 * Fetch function
 *
 * @param   Mixed    url   Absolute url or Request instance
 * @param   Object   opts  Fetch options
 * @return  Promise
 */ function $3fe9119940fa16b8$var$fetch$1(url, opts) {
    // allow custom promise
    if (!$3fe9119940fa16b8$var$fetch$1.Promise) throw new Error('native promise missing, set fetch.Promise to your favorite alternative');
    $3fe9119940fa16b8$var$Body.Promise = $3fe9119940fa16b8$var$fetch$1.Promise;
    // wrap http.request into fetch
    return new $3fe9119940fa16b8$var$fetch$1.Promise(function(resolve, reject) {
        // build request object
        const request = new $3fe9119940fa16b8$var$Request(url, opts);
        const options = $3fe9119940fa16b8$var$getNodeRequestOptions(request);
        const send = (options.protocol === 'https:' ? $3fe9119940fa16b8$var$https : $3fe9119940fa16b8$var$http).request;
        const signal = request.signal;
        let response = null;
        const abort = function abort() {
            let error = new $3fe9119940fa16b8$var$AbortError('The user aborted a request.');
            reject(error);
            if (request.body && request.body instanceof $3fe9119940fa16b8$var$Stream.Readable) $3fe9119940fa16b8$var$destroyStream(request.body, error);
            if (!response || !response.body) return;
            response.body.emit('error', error);
        };
        if (signal && signal.aborted) {
            abort();
            return;
        }
        const abortAndFinalize = function abortAndFinalize() {
            abort();
            finalize();
        };
        // send request
        const req = send(options);
        let reqTimeout;
        if (signal) signal.addEventListener('abort', abortAndFinalize);
        function finalize() {
            req.abort();
            if (signal) signal.removeEventListener('abort', abortAndFinalize);
            clearTimeout(reqTimeout);
        }
        if (request.timeout) req.once('socket', function(socket) {
            reqTimeout = setTimeout(function() {
                reject(new $3fe9119940fa16b8$var$FetchError(`network timeout at: ${request.url}`, 'request-timeout'));
                finalize();
            }, request.timeout);
        });
        req.on('error', function(err) {
            reject(new $3fe9119940fa16b8$var$FetchError(`request to ${request.url} failed, reason: ${err.message}`, 'system', err));
            if (response && response.body) $3fe9119940fa16b8$var$destroyStream(response.body, err);
            finalize();
        });
        $3fe9119940fa16b8$var$fixResponseChunkedTransferBadEnding(req, function(err) {
            if (signal && signal.aborted) return;
            if (response && response.body) $3fe9119940fa16b8$var$destroyStream(response.body, err);
        });
        /* c8 ignore next 18 */ if (parseInt($a8i8g.version.substring(1)) < 14) // Before Node.js 14, pipeline() does not fully support async iterators and does not always
        // properly handle when the socket close/end events are out of order.
        req.on('socket', function(s) {
            s.addListener('close', function(hadError) {
                // if a data listener is still present we didn't end cleanly
                const hasDataListener = s.listenerCount('data') > 0;
                // if end happened before close but the socket didn't emit an error, do it now
                if (response && hasDataListener && !hadError && !(signal && signal.aborted)) {
                    const err = new Error('Premature close');
                    err.code = 'ERR_STREAM_PREMATURE_CLOSE';
                    response.body.emit('error', err);
                }
            });
        });
        req.on('response', function(res) {
            clearTimeout(reqTimeout);
            const headers = $3fe9119940fa16b8$var$createHeadersLenient(res.headers);
            // HTTP fetch step 5
            if ($3fe9119940fa16b8$var$fetch$1.isRedirect(res.statusCode)) {
                // HTTP fetch step 5.2
                const location = headers.get('Location');
                // HTTP fetch step 5.3
                let locationURL = null;
                try {
                    locationURL = location === null ? null : new $3fe9119940fa16b8$var$URL$1(location, request.url).toString();
                } catch (err) {
                    // error here can only be invalid URL in Location: header
                    // do not throw when options.redirect == manual
                    // let the user extract the errorneous redirect URL
                    if (request.redirect !== 'manual') {
                        reject(new $3fe9119940fa16b8$var$FetchError(`uri requested responds with an invalid redirect URL: ${location}`, 'invalid-redirect'));
                        finalize();
                        return;
                    }
                }
                // HTTP fetch step 5.5
                switch(request.redirect){
                    case 'error':
                        reject(new $3fe9119940fa16b8$var$FetchError(`uri requested responds with a redirect, redirect mode is set to error: ${request.url}`, 'no-redirect'));
                        finalize();
                        return;
                    case 'manual':
                        // node-fetch-specific step: make manual redirect a bit easier to use by setting the Location header value to the resolved URL.
                        if (locationURL !== null) // handle corrupted header
                        try {
                            headers.set('Location', locationURL);
                        } catch (err) {
                            // istanbul ignore next: nodejs server prevent invalid response headers, we can't test this through normal request
                            reject(err);
                        }
                        break;
                    case 'follow':
                        // HTTP-redirect fetch step 2
                        if (locationURL === null) break;
                        // HTTP-redirect fetch step 5
                        if (request.counter >= request.follow) {
                            reject(new $3fe9119940fa16b8$var$FetchError(`maximum redirect reached at: ${request.url}`, 'max-redirect'));
                            finalize();
                            return;
                        }
                        // HTTP-redirect fetch step 6 (counter increment)
                        // Create a new Request object.
                        const requestOpts = {
                            headers: new $3fe9119940fa16b8$var$Headers(request.headers),
                            follow: request.follow,
                            counter: request.counter + 1,
                            agent: request.agent,
                            compress: request.compress,
                            method: request.method,
                            body: request.body,
                            signal: request.signal,
                            timeout: request.timeout,
                            size: request.size
                        };
                        if (!$3fe9119940fa16b8$var$isDomainOrSubdomain(request.url, locationURL) || !$3fe9119940fa16b8$var$isSameProtocol(request.url, locationURL)) for (const name of [
                            'authorization',
                            'www-authenticate',
                            'cookie',
                            'cookie2'
                        ])requestOpts.headers.delete(name);
                        // HTTP-redirect fetch step 9
                        if (res.statusCode !== 303 && request.body && $3fe9119940fa16b8$var$getTotalBytes(request) === null) {
                            reject(new $3fe9119940fa16b8$var$FetchError('Cannot follow redirect with body being a readable stream', 'unsupported-redirect'));
                            finalize();
                            return;
                        }
                        // HTTP-redirect fetch step 11
                        if (res.statusCode === 303 || (res.statusCode === 301 || res.statusCode === 302) && request.method === 'POST') {
                            requestOpts.method = 'GET';
                            requestOpts.body = undefined;
                            requestOpts.headers.delete('content-length');
                        }
                        // HTTP-redirect fetch step 15
                        resolve($3fe9119940fa16b8$var$fetch$1(new $3fe9119940fa16b8$var$Request(locationURL, requestOpts)));
                        finalize();
                        return;
                }
            }
            // prepare response
            res.once('end', function() {
                if (signal) signal.removeEventListener('abort', abortAndFinalize);
            });
            let body = res.pipe(new $3fe9119940fa16b8$var$PassThrough$1());
            const response_options = {
                url: request.url,
                status: res.statusCode,
                statusText: res.statusMessage,
                headers: headers,
                size: request.size,
                timeout: request.timeout,
                counter: request.counter
            };
            // HTTP-network fetch step 12.1.1.3
            const codings = headers.get('Content-Encoding');
            // HTTP-network fetch step 12.1.1.4: handle content codings
            // in following scenarios we ignore compression support
            // 1. compression support is disabled
            // 2. HEAD request
            // 3. no Content-Encoding header
            // 4. no content response (204)
            // 5. content not modified response (304)
            if (!request.compress || request.method === 'HEAD' || codings === null || res.statusCode === 204 || res.statusCode === 304) {
                response = new $3fe9119940fa16b8$var$Response(body, response_options);
                resolve(response);
                return;
            }
            // For Node v6+
            // Be less strict when decoding compressed responses, since sometimes
            // servers send slightly invalid responses that are still accepted
            // by common browsers.
            // Always using Z_SYNC_FLUSH is what cURL does.
            const zlibOptions = {
                flush: $3fe9119940fa16b8$var$zlib.Z_SYNC_FLUSH,
                finishFlush: $3fe9119940fa16b8$var$zlib.Z_SYNC_FLUSH
            };
            // for gzip
            if (codings == 'gzip' || codings == 'x-gzip') {
                body = body.pipe($3fe9119940fa16b8$var$zlib.createGunzip(zlibOptions));
                response = new $3fe9119940fa16b8$var$Response(body, response_options);
                resolve(response);
                return;
            }
            // for deflate
            if (codings == 'deflate' || codings == 'x-deflate') {
                // handle the infamous raw deflate response from old servers
                // a hack for old IIS and Apache servers
                const raw = res.pipe(new $3fe9119940fa16b8$var$PassThrough$1());
                raw.once('data', function(chunk) {
                    // see http://stackoverflow.com/questions/37519828
                    if ((chunk[0] & 0x0F) === 0x08) body = body.pipe($3fe9119940fa16b8$var$zlib.createInflate());
                    else body = body.pipe($3fe9119940fa16b8$var$zlib.createInflateRaw());
                    response = new $3fe9119940fa16b8$var$Response(body, response_options);
                    resolve(response);
                });
                raw.on('end', function() {
                    // some old IIS servers return zero-length OK deflate responses, so 'data' is never emitted.
                    if (!response) {
                        response = new $3fe9119940fa16b8$var$Response(body, response_options);
                        resolve(response);
                    }
                });
                return;
            }
            // for br
            if (codings == 'br' && typeof $3fe9119940fa16b8$var$zlib.createBrotliDecompress === 'function') {
                body = body.pipe($3fe9119940fa16b8$var$zlib.createBrotliDecompress());
                response = new $3fe9119940fa16b8$var$Response(body, response_options);
                resolve(response);
                return;
            }
            // otherwise, use response as-is
            response = new $3fe9119940fa16b8$var$Response(body, response_options);
            resolve(response);
        });
        $3fe9119940fa16b8$var$writeToStream(req, request);
    });
}
function $3fe9119940fa16b8$var$fixResponseChunkedTransferBadEnding(request, errorCallback) {
    let socket;
    request.on('socket', function(s) {
        socket = s;
    });
    request.on('response', function(response) {
        const headers = response.headers;
        if (headers['transfer-encoding'] === 'chunked' && !headers['content-length']) response.once('close', function(hadError) {
            // tests for socket presence, as in some situations the
            // the 'socket' event is not triggered for the request
            // (happens in deno), avoids `TypeError`
            // if a data listener is still present we didn't end cleanly
            const hasDataListener = socket && socket.listenerCount('data') > 0;
            if (hasDataListener && !hadError) {
                const err = new Error('Premature close');
                err.code = 'ERR_STREAM_PREMATURE_CLOSE';
                errorCallback(err);
            }
        });
    });
}
function $3fe9119940fa16b8$var$destroyStream(stream, err) {
    if (stream.destroy) stream.destroy(err);
    else {
        // node < 8
        stream.emit('error', err);
        stream.end();
    }
}
/**
 * Redirect code matching
 *
 * @param   Number   code  Status code
 * @return  Boolean
 */ $3fe9119940fa16b8$var$fetch$1.isRedirect = function(code) {
    return code === 301 || code === 302 || code === 303 || code === 307 || code === 308;
};
// expose Promise
$3fe9119940fa16b8$var$fetch$1.Promise = $parcel$global.Promise;
var $3fe9119940fa16b8$var$lib = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AbortError: $3fe9119940fa16b8$var$AbortError,
    FetchError: $3fe9119940fa16b8$var$FetchError,
    Headers: $3fe9119940fa16b8$var$Headers,
    Request: $3fe9119940fa16b8$var$Request,
    Response: $3fe9119940fa16b8$var$Response,
    default: $3fe9119940fa16b8$var$fetch$1
});
var $3fe9119940fa16b8$var$require$$0 = /*@__PURE__*/ $3fe9119940fa16b8$var$getAugmentedNamespace($3fe9119940fa16b8$var$lib);
var $3fe9119940fa16b8$var$hasRequiredNodePonyfill;
function $3fe9119940fa16b8$var$requireNodePonyfill() {
    if ($3fe9119940fa16b8$var$hasRequiredNodePonyfill) return $3fe9119940fa16b8$var$nodePonyfill.exports;
    $3fe9119940fa16b8$var$hasRequiredNodePonyfill = 1;
    (function(module, exports) {
        const nodeFetch = $3fe9119940fa16b8$var$require$$0;
        const realFetch = nodeFetch.default || nodeFetch;
        const fetch1 = function(url, options) {
            // Support schemaless URIs on the server for parity with the browser.
            // Ex: //github.com/ -> https://github.com/
            if (/^\/\//.test(url)) url = 'https:' + url;
            return realFetch.call(this, url, options);
        };
        fetch1.ponyfill = true;
        module.exports = exports = fetch1;
        exports.fetch = fetch1;
        exports.Headers = nodeFetch.Headers;
        exports.Request = nodeFetch.Request;
        exports.Response = nodeFetch.Response;
        // Needed for TypeScript consumers without esModuleInterop.
        exports.default = fetch1;
    })($3fe9119940fa16b8$var$nodePonyfill, $3fe9119940fa16b8$var$nodePonyfill.exports);
    return $3fe9119940fa16b8$var$nodePonyfill.exports;
}
(function(module, exports) {
    var fetchApi;
    if (typeof fetch === 'function') {
        if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) fetchApi = $parcel$global.fetch;
        else if (typeof window !== 'undefined' && window.fetch) fetchApi = window.fetch;
        else fetchApi = fetch;
    }
    if (typeof $3fe9119940fa16b8$var$commonjsRequire !== 'undefined' && typeof window === 'undefined') {
        var f = fetchApi || $3fe9119940fa16b8$var$requireNodePonyfill();
        if (f.default) f = f.default;
        exports.default = f;
        module.exports = exports.default;
    }
})($3fe9119940fa16b8$var$getFetch$1, $3fe9119940fa16b8$var$getFetch$1.exports);
var $3fe9119940fa16b8$var$getFetchExports = $3fe9119940fa16b8$var$getFetch$1.exports;
var $3fe9119940fa16b8$var$getFetch = /*@__PURE__*/ $3fe9119940fa16b8$var$getDefaultExportFromCjs($3fe9119940fa16b8$var$getFetchExports);
var $3fe9119940fa16b8$var$fetchNode = /*#__PURE__*/ $3fe9119940fa16b8$var$_mergeNamespaces({
    __proto__: null,
    default: $3fe9119940fa16b8$var$getFetch
}, [
    $3fe9119940fa16b8$var$getFetchExports
]);
function $3fe9119940fa16b8$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3fe9119940fa16b8$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3fe9119940fa16b8$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $3fe9119940fa16b8$var$_defineProperty$1(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3fe9119940fa16b8$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3fe9119940fa16b8$var$_defineProperty$1(e, r, t) {
    return (r = $3fe9119940fa16b8$var$_toPropertyKey$1(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3fe9119940fa16b8$var$_toPropertyKey$1(t) {
    var i = $3fe9119940fa16b8$var$_toPrimitive$1(t, "string");
    return "symbol" == $3fe9119940fa16b8$var$_typeof$1(i) ? i : i + "";
}
function $3fe9119940fa16b8$var$_toPrimitive$1(t, r) {
    if ("object" != $3fe9119940fa16b8$var$_typeof$1(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3fe9119940fa16b8$var$_typeof$1(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3fe9119940fa16b8$var$_typeof$1(o) {
    "@babel/helpers - typeof";
    return $3fe9119940fa16b8$var$_typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3fe9119940fa16b8$var$_typeof$1(o);
}
var $3fe9119940fa16b8$var$fetchApi;
if (typeof fetch === 'function') {
    if (typeof $3fe9119940fa16b8$var$global$1 !== 'undefined' && $3fe9119940fa16b8$var$global$1.fetch) $3fe9119940fa16b8$var$fetchApi = $3fe9119940fa16b8$var$global$1.fetch;
    else if (typeof window !== 'undefined' && window.fetch) $3fe9119940fa16b8$var$fetchApi = window.fetch;
    else $3fe9119940fa16b8$var$fetchApi = fetch;
}
var $3fe9119940fa16b8$var$XmlHttpRequestApi;
if ($3fe9119940fa16b8$var$hasXMLHttpRequest()) {
    if (typeof $3fe9119940fa16b8$var$global$1 !== 'undefined' && $3fe9119940fa16b8$var$global$1.XMLHttpRequest) $3fe9119940fa16b8$var$XmlHttpRequestApi = $3fe9119940fa16b8$var$global$1.XMLHttpRequest;
    else if (typeof window !== 'undefined' && window.XMLHttpRequest) $3fe9119940fa16b8$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $3fe9119940fa16b8$var$ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
    if (typeof $3fe9119940fa16b8$var$global$1 !== 'undefined' && $3fe9119940fa16b8$var$global$1.ActiveXObject) $3fe9119940fa16b8$var$ActiveXObjectApi = $3fe9119940fa16b8$var$global$1.ActiveXObject;
    else if (typeof window !== 'undefined' && window.ActiveXObject) $3fe9119940fa16b8$var$ActiveXObjectApi = window.ActiveXObject;
}
if (!$3fe9119940fa16b8$var$fetchApi && $3fe9119940fa16b8$var$fetchNode && !$3fe9119940fa16b8$var$XmlHttpRequestApi && !$3fe9119940fa16b8$var$ActiveXObjectApi) $3fe9119940fa16b8$var$fetchApi = $3fe9119940fa16b8$var$getFetch || $3fe9119940fa16b8$var$fetchNode;
if (typeof $3fe9119940fa16b8$var$fetchApi !== 'function') $3fe9119940fa16b8$var$fetchApi = undefined;
var $3fe9119940fa16b8$var$addQueryString = function addQueryString(url, params) {
    if (params && $3fe9119940fa16b8$var$_typeof$1(params) === 'object') {
        var queryString = '';
        for(var paramName in params)queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
    }
    return url;
};
var $3fe9119940fa16b8$var$fetchIt = function fetchIt(url, fetchOptions, callback, altFetch) {
    var resolver = function resolver(response) {
        if (!response.ok) return callback(response.statusText || 'Error', {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (altFetch) {
        var altResponse = altFetch(url, fetchOptions);
        if (altResponse instanceof Promise) {
            altResponse.then(resolver).catch(callback);
            return;
        }
    }
    if (typeof fetch === 'function') fetch(url, fetchOptions).then(resolver).catch(callback);
    else $3fe9119940fa16b8$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
var $3fe9119940fa16b8$var$omitFetchOptions = false;
var $3fe9119940fa16b8$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $3fe9119940fa16b8$var$addQueryString(url, options.queryStringParams);
    var headers = $3fe9119940fa16b8$var$_objectSpread$1({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
    if (typeof window === 'undefined' && typeof $3fe9119940fa16b8$var$global$1 !== 'undefined' && typeof $3fe9119940fa16b8$var$global$1.process !== 'undefined' && $3fe9119940fa16b8$var$global$1.process.versions && $3fe9119940fa16b8$var$global$1.process.versions.node) headers['User-Agent'] = "i18next-http-backend (node/".concat($3fe9119940fa16b8$var$global$1.process.version, "; ").concat($3fe9119940fa16b8$var$global$1.process.platform, " ").concat($3fe9119940fa16b8$var$global$1.process.arch, ")");
    if (payload) headers['Content-Type'] = 'application/json';
    var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = $3fe9119940fa16b8$var$_objectSpread$1({
        method: payload ? 'POST' : 'GET',
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $3fe9119940fa16b8$var$omitFetchOptions ? {} : reqOptions);
    var altFetch = typeof options.alternateFetch === 'function' && options.alternateFetch.length >= 1 ? options.alternateFetch : undefined;
    try {
        $3fe9119940fa16b8$var$fetchIt(url, fetchOptions, callback, altFetch);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $3fe9119940fa16b8$var$fetchIt(url, fetchOptions, callback, altFetch);
            $3fe9119940fa16b8$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $3fe9119940fa16b8$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $3fe9119940fa16b8$var$_typeof$1(payload) === 'object') payload = $3fe9119940fa16b8$var$addQueryString('', payload).slice(1);
    if (options.queryStringParams) url = $3fe9119940fa16b8$var$addQueryString(url, options.queryStringParams);
    try {
        var x;
        if ($3fe9119940fa16b8$var$XmlHttpRequestApi) x = new $3fe9119940fa16b8$var$XmlHttpRequestApi();
        else x = new $3fe9119940fa16b8$var$ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
        x.open(payload ? 'POST' : 'GET', url, 1);
        if (!options.crossDomain) x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        if (x.overrideMimeType) x.overrideMimeType('application/json');
        var h = options.customHeaders;
        h = typeof h === 'function' ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $3fe9119940fa16b8$var$request = function request(options, url, payload, callback) {
    if (typeof payload === 'function') {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($3fe9119940fa16b8$var$fetchApi && url.indexOf('file:') !== 0) return $3fe9119940fa16b8$var$requestWithFetch(options, url, payload, callback);
    if ($3fe9119940fa16b8$var$hasXMLHttpRequest() || typeof ActiveXObject === 'function') return $3fe9119940fa16b8$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error('No fetch and no xhr implementation found!'));
};
function $3fe9119940fa16b8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3fe9119940fa16b8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3fe9119940fa16b8$var$_typeof(o);
}
function $3fe9119940fa16b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3fe9119940fa16b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3fe9119940fa16b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3fe9119940fa16b8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3fe9119940fa16b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3fe9119940fa16b8$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $3fe9119940fa16b8$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $3fe9119940fa16b8$var$_toPropertyKey(o.key), o);
    }
}
function $3fe9119940fa16b8$var$_createClass(e, r, t) {
    return r && $3fe9119940fa16b8$var$_defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $3fe9119940fa16b8$var$_defineProperty(e, r, t) {
    return (r = $3fe9119940fa16b8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3fe9119940fa16b8$var$_toPropertyKey(t) {
    var i = $3fe9119940fa16b8$var$_toPrimitive(t, "string");
    return "symbol" == $3fe9119940fa16b8$var$_typeof(i) ? i : i + "";
}
function $3fe9119940fa16b8$var$_toPrimitive(t, r) {
    if ("object" != $3fe9119940fa16b8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3fe9119940fa16b8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3fe9119940fa16b8$var$getDefaults = function getDefaults() {
    return {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        addPath: '/locales/add/{{lng}}/{{ns}}',
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $3fe9119940fa16b8$var$_defineProperty({}, key, fallbackValue || '');
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: $3fe9119940fa16b8$var$request,
        reloadInterval: typeof window !== 'undefined' ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: 'cors',
            credentials: 'same-origin',
            cache: 'default'
        }
    };
};
var $3fe9119940fa16b8$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $3fe9119940fa16b8$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = 'backend';
        this.init(services, options, allOptions);
    }
    return $3fe9119940fa16b8$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $3fe9119940fa16b8$var$_objectSpread($3fe9119940fa16b8$var$_objectSpread($3fe9119940fa16b8$var$_objectSpread({}, $3fe9119940fa16b8$var$getDefaults()), this.options || {}), options);
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) {
                    var timer = setInterval(function() {
                        return _this.reload();
                    }, this.options.reloadInterval);
                    if ($3fe9119940fa16b8$var$_typeof(timer) === 'object' && typeof timer.unref === 'function') timer.unref();
                }
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === 'function') loadPath = this.options.loadPath(languages, namespaces);
                loadPath = $3fe9119940fa16b8$var$makePromise(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join('+'),
                        ns: namespaces.join('+')
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === 'string' ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === 'string' ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
                    if (!res && err && err.message && err.message.toLowerCase().indexOf('failed') > -1 && (err.message.indexOf('fetch') > -1 || err.message.toLowerCase().indexOf('network') > -1)) return callback('failed loading ' + url + ': ' + err.message, true);
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === 'string') ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = 'failed parsing ' + url + ' to json';
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === 'string') languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === 'function') addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === 'function') callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, 'read', null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
}();
$3fe9119940fa16b8$var$Backend.type = 'backend';
const $3fe9119940fa16b8$var$copyProperty = (to, from, property, ignoreNonConfigurable)=>{
    // `Function#length` should reflect the parameters of `to` not `from` since we keep its body.
    // `Function#prototype` is non-writable and non-configurable so can never be modified.
    if (property === 'length' || property === 'prototype') return;
    // `Function#arguments` and `Function#caller` should not be copied. They were reported to be present in `Reflect.ownKeys` for some devices in React Native (#41), so we explicitly ignore them here.
    if (property === 'arguments' || property === 'caller') return;
    const toDescriptor = Object.getOwnPropertyDescriptor(to, property);
    const fromDescriptor = Object.getOwnPropertyDescriptor(from, property);
    if (!$3fe9119940fa16b8$var$canCopyProperty(toDescriptor, fromDescriptor) && ignoreNonConfigurable) return;
    Object.defineProperty(to, property, fromDescriptor);
};
// `Object.defineProperty()` throws if the property exists, is not configurable and either:
//  - one its descriptors is changed
//  - it is non-writable and its value is changed
const $3fe9119940fa16b8$var$canCopyProperty = function(toDescriptor, fromDescriptor) {
    return toDescriptor === undefined || toDescriptor.configurable || toDescriptor.writable === fromDescriptor.writable && toDescriptor.enumerable === fromDescriptor.enumerable && toDescriptor.configurable === fromDescriptor.configurable && (toDescriptor.writable || toDescriptor.value === fromDescriptor.value);
};
const $3fe9119940fa16b8$var$changePrototype = (to, from)=>{
    const fromPrototype = Object.getPrototypeOf(from);
    if (fromPrototype === Object.getPrototypeOf(to)) return;
    Object.setPrototypeOf(to, fromPrototype);
};
const $3fe9119940fa16b8$var$wrappedToString = (withName, fromBody)=>`/* Wrapped ${withName}*/\n${fromBody}`;
const $3fe9119940fa16b8$var$toStringDescriptor = Object.getOwnPropertyDescriptor(Function.prototype, 'toString');
const $3fe9119940fa16b8$var$toStringName = Object.getOwnPropertyDescriptor(Function.prototype.toString, 'name');
// We call `from.toString()` early (not lazily) to ensure `from` can be garbage collected.
// We use `bind()` instead of a closure for the same reason.
// Calling `from.toString()` early also allows caching it in case `to.toString()` is called several times.
const $3fe9119940fa16b8$var$changeToString = (to, from, name)=>{
    const withName = name === '' ? '' : `with ${name.trim()}() `;
    const newToString = $3fe9119940fa16b8$var$wrappedToString.bind(null, withName, from.toString());
    // Ensure `to.toString.toString` is non-enumerable and has the same `same`
    Object.defineProperty(newToString, 'name', $3fe9119940fa16b8$var$toStringName);
    Object.defineProperty(to, 'toString', {
        ...$3fe9119940fa16b8$var$toStringDescriptor,
        value: newToString
    });
};
const $3fe9119940fa16b8$var$mimicFn$1 = (to, from, { ignoreNonConfigurable: ignoreNonConfigurable = false } = {})=>{
    const { name: name } = to;
    for (const property of Reflect.ownKeys(from))$3fe9119940fa16b8$var$copyProperty(to, from, property, ignoreNonConfigurable);
    $3fe9119940fa16b8$var$changePrototype(to, from);
    $3fe9119940fa16b8$var$changeToString(to, from, name);
    return to;
};
var $3fe9119940fa16b8$var$mimicFn_1 = $3fe9119940fa16b8$var$mimicFn$1;
var $3fe9119940fa16b8$var$dist$1 = {
    exports: {}
};
var $3fe9119940fa16b8$var$pDefer = ()=>{
    const ret = {};
    ret.promise = new Promise((resolve, reject)=>{
        ret.resolve = resolve;
        ret.reject = reject;
    });
    return ret;
};
(function(module, exports) {
    var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : new P(function(resolve) {
                    resolve(result.value);
                }).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var __importDefault = this && this.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
            "default": mod
        };
    };
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    const p_defer_1 = __importDefault($3fe9119940fa16b8$var$pDefer);
    function mapAgeCleaner(map, property = 'maxAge') {
        let processingKey;
        let processingTimer;
        let processingDeferred;
        const cleanup = ()=>__awaiter(this, void 0, void 0, function*() {
                if (processingKey !== undefined) // If we are already processing an item, we can safely exit
                return;
                const setupTimer = (item)=>__awaiter(this, void 0, void 0, function*() {
                        processingDeferred = p_defer_1.default();
                        const delay = item[1][property] - Date.now();
                        if (delay <= 0) {
                            // Remove the item immediately if the delay is equal to or below 0
                            map.delete(item[0]);
                            processingDeferred.resolve();
                            return;
                        }
                        // Keep track of the current processed key
                        processingKey = item[0];
                        processingTimer = setTimeout(()=>{
                            // Remove the item when the timeout fires
                            map.delete(item[0]);
                            if (processingDeferred) processingDeferred.resolve();
                        }, delay);
                        // tslint:disable-next-line:strict-type-predicates
                        if (typeof processingTimer.unref === 'function') // Don't hold up the process from exiting
                        processingTimer.unref();
                        return processingDeferred.promise;
                    });
                try {
                    for (const entry of map)yield setupTimer(entry);
                } catch (_a) {
                // Do nothing if an error occurs, this means the timer was cleaned up and we should stop processing
                }
                processingKey = undefined;
            });
        const reset = ()=>{
            processingKey = undefined;
            if (processingTimer !== undefined) {
                clearTimeout(processingTimer);
                processingTimer = undefined;
            }
            if (processingDeferred !== undefined) {
                processingDeferred.reject(undefined);
                processingDeferred = undefined;
            }
        };
        const originalSet = map.set.bind(map);
        map.set = (key, value)=>{
            if (map.has(key)) // If the key already exist, remove it so we can add it back at the end of the map.
            map.delete(key);
            // Call the original `map.set`
            const result = originalSet(key, value);
            // If we are already processing a key and the key added is the current processed key, stop processing it
            if (processingKey && processingKey === key) reset();
            // Always run the cleanup method in case it wasn't started yet
            cleanup(); // tslint:disable-line:no-floating-promises
            return result;
        };
        cleanup(); // tslint:disable-line:no-floating-promises
        return map;
    }
    exports.default = mapAgeCleaner;
    // Add support for CJS
    module.exports = mapAgeCleaner;
    module.exports.default = mapAgeCleaner;
})($3fe9119940fa16b8$var$dist$1, $3fe9119940fa16b8$var$dist$1.exports);
var $3fe9119940fa16b8$var$distExports = $3fe9119940fa16b8$var$dist$1.exports;
const $3fe9119940fa16b8$var$mimicFn = $3fe9119940fa16b8$var$mimicFn_1;
const $3fe9119940fa16b8$var$mapAgeCleaner = $3fe9119940fa16b8$var$distExports;
const $3fe9119940fa16b8$var$decoratorInstanceMap = new WeakMap();
const $3fe9119940fa16b8$var$cacheStore = new WeakMap();
/**
[Memoize](https://en.wikipedia.org/wiki/Memoization) functions - An optimization used to speed up consecutive function calls by caching the result of calls with identical input.

@param fn - Function to be memoized.

@example
```
import mem = require('mem');

let i = 0;
const counter = () => ++i;
const memoized = mem(counter);

memoized('foo');
//=> 1

// Cached as it's the same arguments
memoized('foo');
//=> 1

// Not cached anymore as the arguments changed
memoized('bar');
//=> 2

memoized('bar');
//=> 2
```
*/ const $3fe9119940fa16b8$var$mem = (fn, { cacheKey: cacheKey, cache: cache = new Map(), maxAge: maxAge } = {})=>{
    if (typeof maxAge === 'number') // TODO: Drop after https://github.com/SamVerschueren/map-age-cleaner/issues/5
    // @ts-expect-error
    $3fe9119940fa16b8$var$mapAgeCleaner(cache);
    const memoized = function(...arguments_) {
        const key = cacheKey ? cacheKey(arguments_) : arguments_[0];
        const cacheItem = cache.get(key);
        if (cacheItem) return cacheItem.data;
        const result = fn.apply(this, arguments_);
        cache.set(key, {
            data: result,
            maxAge: maxAge ? Date.now() + maxAge : Number.POSITIVE_INFINITY
        });
        return result;
    };
    $3fe9119940fa16b8$var$mimicFn(memoized, fn, {
        ignoreNonConfigurable: true
    });
    $3fe9119940fa16b8$var$cacheStore.set(memoized, cache);
    return memoized;
};
/**
@returns A [decorator](https://github.com/tc39/proposal-decorators) to memoize class methods or static class methods.

@example
```
import mem = require('mem');

class Example {
    index = 0

    @mem.decorator()
    counter() {
        return ++this.index;
    }
}

class ExampleWithOptions {
    index = 0

    @mem.decorator({maxAge: 1000})
    counter() {
        return ++this.index;
    }
}
```
*/ $3fe9119940fa16b8$var$mem.decorator = (options = {})=>(target, propertyKey, descriptor)=>{
        const input = target[propertyKey];
        if (typeof input !== 'function') throw new TypeError('The decorated value must be a function');
        delete descriptor.value;
        delete descriptor.writable;
        descriptor.get = function() {
            if (!$3fe9119940fa16b8$var$decoratorInstanceMap.has(this)) {
                const value = $3fe9119940fa16b8$var$mem(input, options);
                $3fe9119940fa16b8$var$decoratorInstanceMap.set(this, value);
                return value;
            }
            return $3fe9119940fa16b8$var$decoratorInstanceMap.get(this);
        };
    };
/**
Clear all cached data of a memoized function.

@param fn - Memoized function.
*/ $3fe9119940fa16b8$var$mem.clear = (fn)=>{
    const cache = $3fe9119940fa16b8$var$cacheStore.get(fn);
    if (!cache) throw new TypeError('Can\'t clear a function that was not memoized!');
    if (typeof cache.clear !== 'function') throw new TypeError('The cache Map can\'t be cleared!');
    cache.clear();
};
var $3fe9119940fa16b8$var$dist = $3fe9119940fa16b8$var$mem;
var $3fe9119940fa16b8$var$mem$1 = /*@__PURE__*/ $3fe9119940fa16b8$var$getDefaultExportFromCjs($3fe9119940fa16b8$var$dist);
function $3fe9119940fa16b8$var$isString(el) {
    return typeof el === 'string';
}
function $3fe9119940fa16b8$var$isUnique(el, index, arr) {
    return arr.indexOf(el) === index;
}
function $3fe9119940fa16b8$var$isAllLowerCase(el) {
    return el.toLowerCase() === el;
}
function $3fe9119940fa16b8$var$fixCommas(el) {
    return el.indexOf(',') === -1 ? el : el.split(',');
}
function $3fe9119940fa16b8$var$normalizeLocale(locale) {
    if (!locale) return locale;
    if (locale === 'C' || locale === 'posix' || locale === 'POSIX') return 'en-US';
    // If there's a dot (.) in the locale, it's likely in the format of "en-US.UTF-8", so we only take the first part
    if (locale.indexOf('.') !== -1) {
        var _a = locale.split('.')[0], actualLocale = _a === void 0 ? '' : _a;
        return $3fe9119940fa16b8$var$normalizeLocale(actualLocale);
    }
    // If there's an at sign (@) in the locale, it's likely in the format of "en-US@posix", so we only take the first part
    if (locale.indexOf('@') !== -1) {
        var _b = locale.split('@')[0], actualLocale = _b === void 0 ? '' : _b;
        return $3fe9119940fa16b8$var$normalizeLocale(actualLocale);
    }
    // If there's a dash (-) in the locale and it's not all lower case, it's already in the format of "en-US", so we return it
    if (locale.indexOf('-') === -1 || !$3fe9119940fa16b8$var$isAllLowerCase(locale)) return locale;
    var _c = locale.split('-'), splitEl1 = _c[0], _d = _c[1], splitEl2 = _d === void 0 ? '' : _d;
    return "".concat(splitEl1, "-").concat(splitEl2.toUpperCase());
}
function $3fe9119940fa16b8$var$getUserLocalesInternal(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.useFallbackLocale, useFallbackLocale = _c === void 0 ? true : _c, _d = _b.fallbackLocale, fallbackLocale = _d === void 0 ? 'en-US' : _d;
    var languageList = [];
    if (typeof navigator !== 'undefined') {
        var rawLanguages = navigator.languages || [];
        var languages = [];
        for(var _i = 0, rawLanguages_1 = rawLanguages; _i < rawLanguages_1.length; _i++){
            var rawLanguagesItem = rawLanguages_1[_i];
            languages = languages.concat($3fe9119940fa16b8$var$fixCommas(rawLanguagesItem));
        }
        var rawLanguage = navigator.language;
        var language = rawLanguage ? $3fe9119940fa16b8$var$fixCommas(rawLanguage) : rawLanguage;
        languageList = languageList.concat(languages, language);
    }
    if (useFallbackLocale) languageList.push(fallbackLocale);
    return languageList.filter($3fe9119940fa16b8$var$isString).map($3fe9119940fa16b8$var$normalizeLocale).filter($3fe9119940fa16b8$var$isUnique);
}
var $3fe9119940fa16b8$var$getUserLocales = $3fe9119940fa16b8$var$mem$1($3fe9119940fa16b8$var$getUserLocalesInternal, {
    cacheKey: JSON.stringify
});
function $3fe9119940fa16b8$var$getUserLocaleInternal(options) {
    return $3fe9119940fa16b8$var$getUserLocales(options)[0] || null;
}
var $3fe9119940fa16b8$var$getUserLocale = $3fe9119940fa16b8$var$mem$1($3fe9119940fa16b8$var$getUserLocaleInternal, {
    cacheKey: JSON.stringify
});
var $3fe9119940fa16b8$export$36df6eadd61c72e4 = /** @class */ function() {
    function LanguageDetector(defaultLang, key) {
        if (defaultLang === void 0) defaultLang = 'en';
        if (key === void 0) key = 'lang';
        this.langKey = key;
        this.defaultLang = defaultLang;
        console.log("[LanguageDetector] v1.0.0");
    }
    LanguageDetector.prototype.Detect = function() {
        var langFromUrl = this.checkUrl();
        if (langFromUrl) {
            console.log("[LanguageDetector] found ".concat(langFromUrl, " from URL"));
            return langFromUrl;
        }
        var langFromStorage = this.checkLocalStorage();
        if (langFromStorage) {
            console.log("[LanguageDetector] found ".concat(langFromStorage, " from storage"));
            return langFromStorage;
        }
        var langFromNavigator = this.checkNavigator();
        if (langFromNavigator) {
            console.log("[LanguageDetector] found ".concat(langFromNavigator, " from navigator locale"));
            return langFromNavigator;
        }
        console.log("[LanguageDetector] using fallback default ".concat(this.defaultLang));
        return this.defaultLang;
    };
    LanguageDetector.prototype.checkNavigator = function() {
        var _a;
        var locale = (_a = $3fe9119940fa16b8$var$getUserLocale()) !== null && _a !== void 0 ? _a : "";
        return this.clear(locale);
    };
    LanguageDetector.prototype.checkUrl = function() {
        var _a;
        var urlParams = new URLSearchParams(window.location.search);
        var lang = (_a = urlParams.get(this.langKey)) !== null && _a !== void 0 ? _a : "";
        return this.clear(lang);
    };
    LanguageDetector.prototype.checkLocalStorage = function() {
        var _a;
        var localStorage = window.localStorage;
        var lang = (_a = localStorage.getItem(this.langKey)) !== null && _a !== void 0 ? _a : "";
        return this.clear(lang);
    };
    LanguageDetector.prototype.clear = function(language) {
        language = language.replace('\\', '');
        language = language.replace('"', '');
        language = language.trim();
        if (language.length > 2) language = language.substring(0, 2);
        return language;
    };
    return LanguageDetector;
}();
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $3fe9119940fa16b8$var$__assign = function() {
    $3fe9119940fa16b8$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3fe9119940fa16b8$var$__assign.apply(this, arguments);
};
typeof SuppressedError === "function" && SuppressedError;
var $3fe9119940fa16b8$var$fptBtnStyle = {
    padding: "1.32rem",
    borderWidth: "1px",
    borderStyle: "solid",
    fontSize: "0.9rem",
    fontWeight: 500,
    cursor: "pointer",
    display: "block"
};
var $3fe9119940fa16b8$var$fptBtnPrimaryStyle = {
    backgroundColor: "#1e4e5f",
    borderColor: "#322f30",
    color: "#fefffe",
    borderRadius: "0.66rem",
    margin: "1.32rem auto" // --btn-padding
};
var $3fe9119940fa16b8$var$fptBtnPrimaryRoundedStyle = {
    backgroundColor: "#1e4e5f",
    borderColor: "#322f30",
    color: "#fefffe",
    borderRadius: "2.66rem",
    margin: "1.32rem auto",
    paddingLeft: "3.5rem",
    paddingRight: "3.5rem"
};
var $3fe9119940fa16b8$var$fptBtnDisabledStyle = {
    opacity: 0.1
};
var $3fe9119940fa16b8$var$fptBtnWidePrimaryStyle = {
    backgroundColor: "#1e4e5f",
    borderColor: "#322f30",
    color: "#fff",
    borderRadius: "0.66rem",
    width: "100%",
    padding: "1.32rem",
    margin: "1.32rem 0",
    transition: "all 0.3s"
};
var $3fe9119940fa16b8$var$fptBtnWidePrimaryRoundStyle = {
    backgroundColor: "#1e4e5f",
    borderColor: "#322f30",
    color: "#fff",
    borderRadius: "100px",
    transition: "all 0.3s",
    paddingLeft: "3.125rem",
    paddingTop: "1.062rem",
    paddingRight: "3.125rem",
    paddingBottom: "1.062rem",
    border: "none"
};
var $3fe9119940fa16b8$var$fptBtnSecondaryStyle = {
    backgroundColor: "transparent",
    borderColor: "#1e4e5f",
    color: "#1e4e5f",
    borderRadius: "0.66rem"
};
var $3fe9119940fa16b8$var$fptBtnWideSecondaryStyle = {
    backgroundColor: "transparent",
    borderColor: "#1e4e5f",
    color: "#1e4e5f",
    borderRadius: "0.66rem",
    width: "100%",
    fontWeight: "bold",
    padding: "1.32rem",
    margin: "1.32rem 0",
    transition: "all 0.3s"
};
var $3fe9119940fa16b8$var$fptBtnWideSecondaryNoMarginStyle = {
    backgroundColor: "transparent",
    borderColor: "#1e4e5f",
    color: "#1e4e5f",
    borderRadius: "0.66rem",
    width: "100%",
    fontWeight: "bold",
    padding: "1.32rem 0",
    transition: "all 0.3s"
};
var $3fe9119940fa16b8$var$fptBtnDangerStyle = {
    backgroundColor: "#ff345e",
    color: "#fdf5ec",
    borderRadius: "0.66rem",
    margin: "1.32rem auto" // --btn-padding
};
var $3fe9119940fa16b8$var$fptBtnWideDangerStyle = {
    backgroundColor: "#ff345e",
    color: "#fdf5ec",
    borderRadius: "0.66rem",
    margin: "1.32rem auto",
    width: "100%"
};
var $3fe9119940fa16b8$var$fptBtnLinkPrimaryStyle = {
    color: "#1e4e5f",
    textDecoration: "none",
    padding: "1.12rem",
    fontWeight: "bold",
    border: "none",
    background: "none",
    boxShadow: "none",
    display: "inline-block",
    backgroundColor: "transparent" // --btn-bg-color-link-primary
};
var $3fe9119940fa16b8$var$fptBtnLinkPrimaryBlueStyle = {
    color: "#00a5e2",
    textDecoration: "none",
    padding: "1.12rem",
    border: "none",
    background: "none",
    boxShadow: "none",
    display: "inline-block",
    backgroundColor: "transparent" // --btn-bg-color-link-primary
};
var $3fe9119940fa16b8$var$fptBtnLinkDangerStyle = {
    color: "#ff345e",
    textDecoration: "underline",
    border: "none",
    background: "none",
    boxShadow: "none",
    display: "inline-block",
    backgroundColor: "transparent" // --btn-bg-color-link-danger
};
var $3fe9119940fa16b8$var$getButtonStyle = function(variant, disabled) {
    var style = $3fe9119940fa16b8$var$fptBtnStyle;
    switch(variant){
        case 'primary':
            style = $3fe9119940fa16b8$var$__assign($3fe9119940fa16b8$var$__assign({}, style), $3fe9119940fa16b8$var$fptBtnPrimaryStyle);
            break;
        case 'primary-rounded':
            style = $3fe9119940fa16b8$var$__assign($3fe9119940fa16b8$var$__assign({}, style), $3fe9119940fa16b8$var$fptBtnPrimaryRoundedStyle);
            break;
        case 'secondary':
            style = $3fe9119940fa16b8$var$__assign($3fe9119940fa16b8$var$__assign({}, style), $3fe9119940fa16b8$var$fptBtnSecondaryStyle);
            break;
        case 'danger':
            style = $3fe9119940fa16b8$var$__assign($3fe9119940fa16b8$var$__assign({}, style), $3fe9119940fa16b8$var$fptBtnDangerStyle);
            break;
        case 'link-primary':
            style = $3fe9119940fa16b8$var$__assign($3fe9119940fa16b8$var$__assign({}, style), $3fe9119940fa16b8$var$fptBtnLinkPrimaryStyle);
            break;
        case 'link-primary-blue':
            style = $3fe9119940fa16b8$var$__assign($3fe9119940fa16b8$var$__assign({}, style), $3fe9119940fa16b8$var$fptBtnLinkPrimaryBlueStyle);
            break;
        case 'link-danger':
            style = $3fe9119940fa16b8$var$__assign($3fe9119940fa16b8$var$__assign({}, style), $3fe9119940fa16b8$var$fptBtnLinkDangerStyle);
            break;
        case 'wide-primary':
            style = $3fe9119940fa16b8$var$__assign($3fe9119940fa16b8$var$__assign({}, style), $3fe9119940fa16b8$var$fptBtnWidePrimaryStyle);
            break;
        case 'wide-primary-round':
            style = $3fe9119940fa16b8$var$__assign($3fe9119940fa16b8$var$__assign({}, style), $3fe9119940fa16b8$var$fptBtnWidePrimaryRoundStyle);
            break;
        case 'wide-secondary':
            style = $3fe9119940fa16b8$var$__assign($3fe9119940fa16b8$var$__assign({}, style), $3fe9119940fa16b8$var$fptBtnWideSecondaryStyle);
            break;
        case 'wide-secondary-no-margin':
            style = $3fe9119940fa16b8$var$__assign($3fe9119940fa16b8$var$__assign({}, style), $3fe9119940fa16b8$var$fptBtnWideSecondaryNoMarginStyle);
            break;
        case 'wide-danger':
            style = $3fe9119940fa16b8$var$__assign($3fe9119940fa16b8$var$__assign({}, style), $3fe9119940fa16b8$var$fptBtnWideDangerStyle);
            break;
    }
    if (disabled) style = $3fe9119940fa16b8$var$__assign($3fe9119940fa16b8$var$__assign({}, style), $3fe9119940fa16b8$var$fptBtnDisabledStyle);
    return style;
};
var $3fe9119940fa16b8$export$353f5b6fc5456de1 = function(props) {
    var children = props.children, onClick = props.onClick, _a = props.variant, variant = _a === void 0 ? 'primary' : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b;
    var buttonStyle = $3fe9119940fa16b8$var$getButtonStyle(variant, disabled);
    return !disabled ? (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("button", {
        type: "button",
        style: buttonStyle,
        className: "fpt-btn fpt-btn--".concat(variant),
        onClick: onClick
    }, children) : (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("button", {
        type: "button",
        style: buttonStyle,
        className: "fpt-btn fpt-btn--".concat(variant, " fpt-btn-disabled")
    }, children);
};
var $3fe9119940fa16b8$var$fptCErrorContainerStyle = {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "100%",
    "zIndex": "2",
    "marginBottom": "0rem"
};
var $3fe9119940fa16b8$var$fptCErrorImageContainerStyle = {
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
};
var $3fe9119940fa16b8$var$fptCErrorHeaderTitleStyle = {
    "fontSize": "1.5rem",
    "marginTop": "1vh",
    "marginBottom": "0",
    "fontWeight": "500",
    "color": "#1e4e5f",
    "letterSpacing": "normal"
};
var $3fe9119940fa16b8$var$fptCErrorHeaderSubtitleStyle = {
    "fontFamily": "Inter500",
    "fontSize": "1rem",
    "fontWeight": "500",
    "fontStretch": "normal",
    "fontStyle": "normal",
    "lineHeight": "1.5rem",
    "letterSpacing": "normal",
    "color": "#1e4e5f"
};
// Directly calculate style inside render method
var $3fe9119940fa16b8$var$windowWidth = window.innerWidth;
var $3fe9119940fa16b8$var$titleContainerStyle = $3fe9119940fa16b8$var$windowWidth > 760 ? {
    width: "70%",
    marginTop: "4vh",
    marginBottom: "4vh",
    gap: "1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
} : {
    width: "100%",
    marginTop: "4vh",
    gap: "3rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
};
function $3fe9119940fa16b8$var$ErrorHeader(props) {
    var dynamicImageStyle = $3fe9119940fa16b8$var$__assign({}, (props === null || props === void 0 ? void 0 : props.isFullSizeIcon) ? {
        width: '100%',
        height: 'auto'
    } : {
        maxWidth: '80px'
    });
    // Define a dynamic style for the title container based on pageAlignment
    var dynamicTitleContainerStyle = $3fe9119940fa16b8$var$__assign({}, (props === null || props === void 0 ? void 0 : props.pageAlignment) === 'fpt-c-error-centered' ? {
        textAlign: 'center',
        alignItems: 'center'
    } : {});
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        style: $3fe9119940fa16b8$var$fptCErrorContainerStyle,
        className: "fpt-c-error-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        style: $3fe9119940fa16b8$var$__assign($3fe9119940fa16b8$var$__assign({}, $3fe9119940fa16b8$var$titleContainerStyle), dynamicTitleContainerStyle),
        className: "".concat(props === null || props === void 0 ? void 0 : props.pageAlignment)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        style: $3fe9119940fa16b8$var$fptCErrorImageContainerStyle,
        className: "fpt-c-error-image-container"
    }, " ", (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("img", {
        src: props === null || props === void 0 ? void 0 : props.errorIcon,
        style: dynamicImageStyle
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("h1", {
        style: $3fe9119940fa16b8$var$fptCErrorHeaderTitleStyle,
        className: "fpt-c-error-header-title"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($3fe9119940fa16b8$var$Trans, {
        i18nKey: props === null || props === void 0 ? void 0 : props.titleTransId
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        style: $3fe9119940fa16b8$var$fptCErrorHeaderSubtitleStyle,
        className: "fpt-c-error-header-subtitle"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($3fe9119940fa16b8$var$Trans, {
        i18nKey: props === null || props === void 0 ? void 0 : props.subTitleTransId,
        values: {
            errorCode: props === null || props === void 0 ? void 0 : props.errorCode
        }
    }))));
}
var $3fe9119940fa16b8$var$img$i = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3e %3cg id='icon_GU_CA3' transform='translate(-779 18589)'%3e %3cg id='Rectangle_1000' data-name='Rectangle 1000' transform='translate(779 -18589)' fill='white' stroke='%23707070' stroke-width='1' opacity='0'%3e %3crect width='80' height='80' stroke='none'/%3e %3crect x='0.5' y='0.5' width='79' height='79' fill='none'/%3e %3c/g%3e %3cg id='icon_GU_CA3-2' data-name='icon_GU_CA3' transform='translate(796.174 -18584)'%3e %3cpath id='Line_1' data-name='Line 1' d='M45.652%2c0H0' transform='translate(0 58.281)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_558' data-name='Path 558' d='M69.274%2c123.958a.733.733%2c0%2c0%2c1%2c.733.732h0a.733.733%2c0%2c0%2c1-.733.733h0a.733.733%2c0%2c0%2c1-.732-.733h0a.733.733%2c0%2c0%2c1%2c.732-.732' transform='translate(-46.448 -60.551)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Line_2' data-name='Line 2' d='M0%2c0H0' transform='translate(22.826 63.406)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3crect id='Rectangle_83' data-name='Rectangle 83' width='45.652' height='70' rx='8' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Line_3' data-name='Line 3' d='M0%2c0V2.637' transform='translate(10.652 27.586)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Line_4' data-name='Line 4' d='M0%2c0V2.637' transform='translate(35 27.586)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_559' data-name='Path 559' d='M53.486%2c76.329a9.156%2c9.156%2c0%2c0%2c0%2c8.295%2c4.146%2c9.156%2c9.156%2c0%2c0%2c0%2c8.295-4.146' transform='translate(84.606 118.892) rotate(180)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$var$img$h = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3e %3cg id='icon_GU_CA2' transform='translate(-660 18592)'%3e %3cg id='Rectangle_999' data-name='Rectangle 999' transform='translate(660 -18592)' fill='white' stroke='%23707070' stroke-width='1' opacity='0.004'%3e %3crect width='80' height='80' stroke='none'/%3e %3crect x='0.5' y='0.5' width='79' height='79' fill='none'/%3e %3c/g%3e %3cg id='icon_GU_CA2-2' data-name='icon_GU_CA2' transform='translate(660.111 -18588)'%3e %3cpath id='Path_2889' data-name='Path 2889' d='M10.435%2c12.648h4.518a5.185%2c5.185%2c0%2c0%2c0%2c4.387-2.421L21.186%2c7.3a5.185%2c5.185%2c0%2c0%2c1%2c4.387-2.42H31.6A5.185%2c5.185%2c0%2c0%2c1%2c35.981%2c7.3l1.846%2c2.931a5.185%2c5.185%2c0%2c0%2c0%2c4.387%2c2.42h4.518a5.185%2c5.185%2c0%2c0%2c1%2c5.185%2c5.185v23.13a5.4%2c5.4%2c0%2c0%2c1-5.386%2c5.386h-35.9A5.4%2c5.4%2c0%2c0%2c1%2c5.25%2c40.966V17.833a5.185%2c5.185%2c0%2c0%2c1%2c5.185-5.185Z' transform='translate(11.306 6.5)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2890' data-name='Path 2890' d='M9.75%2c17.153a7.778%2c7.778%2c0%2c1%2c0%2c7.778-7.778A7.778%2c7.778%2c0%2c0%2c0%2c9.75%2c17.153Z' transform='translate(22.361 17.551)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2891' data-name='Path 2891' d='M.75%2c12.021A10.146%2c10.146%2c0%2c0%2c1%2c10.9%2c1.875' transform='translate(0.25 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2892' data-name='Path 2892' d='M.75%2c19.19A10.146%2c10.146%2c0%2c0%2c0%2c10.9%2c29.336' transform='translate(0.25 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2893' data-name='Path 2893' d='M30.461%2c12.021A10.146%2c10.146%2c0%2c0%2c0%2c20.315%2c1.875' transform='translate(48.317 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2894' data-name='Path 2894' d='M30.461%2c19.19A10.146%2c10.146%2c0%2c0%2c1%2c20.315%2c29.336' transform='translate(48.317 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$var$img$g = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3e %3cg id='icon_GU_CA3' transform='translate(-779 18589)'%3e %3cg id='Rectangle_1000' data-name='Rectangle 1000' transform='translate(779 -18589)' fill='white' stroke='%23707070' stroke-width='1' opacity='0'%3e %3crect width='80' height='80' stroke='none'/%3e %3crect x='0.5' y='0.5' width='79' height='79' fill='none'/%3e %3c/g%3e %3cg id='icon_GU_CA3-2' data-name='icon_GU_CA3' transform='translate(796.174 -18584)'%3e %3cpath id='Line_1' data-name='Line 1' d='M45.652%2c0H0' transform='translate(0 58.281)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_558' data-name='Path 558' d='M69.274%2c123.958a.733.733%2c0%2c0%2c1%2c.733.732h0a.733.733%2c0%2c0%2c1-.733.733h0a.733.733%2c0%2c0%2c1-.732-.733h0a.733.733%2c0%2c0%2c1%2c.732-.732' transform='translate(-46.448 -60.551)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Line_2' data-name='Line 2' d='M0%2c0H0' transform='translate(22.826 63.406)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3crect id='Rectangle_83' data-name='Rectangle 83' width='45.652' height='70' rx='8' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Line_3' data-name='Line 3' d='M0%2c0V2.637' transform='translate(10.652 27.586)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Line_4' data-name='Line 4' d='M0%2c0V2.637' transform='translate(35 27.586)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_559' data-name='Path 559' d='M53.486%2c76.329a9.156%2c9.156%2c0%2c0%2c0%2c8.295%2c4.146%2c9.156%2c9.156%2c0%2c0%2c0%2c8.295-4.146' transform='translate(84.606 118.892) rotate(180)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$var$img$f = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3e %3cg id='icon_MA_DB1' transform='translate(-903 18589)'%3e %3cg id='Rectangle_1001' data-name='Rectangle 1001' transform='translate(903 -18589)' fill='white' stroke='%23707070' stroke-width='1' opacity='0'%3e %3crect width='80' height='80' stroke='none'/%3e %3crect x='0.5' y='0.5' width='79' height='79' fill='none'/%3e %3c/g%3e %3cg id='icon_MA_DB1-2' data-name='icon_MA_DB1' transform='translate(903.111 -18585)'%3e %3cpath id='Path_2891' data-name='Path 2891' d='M.75%2c12.021A10.146%2c10.146%2c0%2c0%2c1%2c10.9%2c1.875' transform='translate(0.25 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2892' data-name='Path 2892' d='M.75%2c19.19A10.146%2c10.146%2c0%2c0%2c0%2c10.9%2c29.336' transform='translate(0.25 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2893' data-name='Path 2893' d='M30.461%2c12.021A10.146%2c10.146%2c0%2c0%2c0%2c20.315%2c1.875' transform='translate(48.317 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2894' data-name='Path 2894' d='M30.461%2c19.19A10.146%2c10.146%2c0%2c0%2c1%2c20.315%2c29.336' transform='translate(48.317 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cg id='Icons_Footwear' data-name='Icons / Footwear'%3e %3cg id='Group_108' data-name='Group 108'%3e %3cg id='Regular_108' data-name='Regular 108'%3e %3cpath id='Shape_471' data-name='Shape 471' d='M197.062%2c1394.75a6.66%2c6.66%2c0%2c0%2c1-13.123%2c1.6%2c2.1%2c2.1%2c0%2c0%2c0-2.042-1.6%2c2.146%2c2.146%2c0%2c0%2c0-2.147%2c2.147v13.834a2.664%2c2.664%2c0%2c0%2c0%2c2.663%2c2.663h34.624a2.664%2c2.664%2c0%2c0%2c0%2c2.663-2.663v-2.28a5.329%2c5.329%2c0%2c0%2c0-2.625-4.592Z' transform='translate(1433.307 -162.949) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_472' data-name='Shape 472' d='M179.75%2c1402.25H219.7' transform='translate(1427.49 -162.95) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_473' data-name='Shape 473' d='M191.75%2c1399.956l3.326-3.326' transform='translate(1431.849 -153.641) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_474' data-name='Shape 474' d='M194.75%2c1401.521l3.491-3.491' transform='translate(1430.763 -151.315) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_475' data-name='Shape 475' d='M202.389%2c1401.394a6.66%2c6.66%2c0%2c0%2c1%2c13.123-1.6%2c2.1%2c2.1%2c0%2c0%2c0%2c2.042%2c1.6%2c2.146%2c2.146%2c0%2c0%2c0%2c2.147-2.147v-13.834a2.665%2c2.665%2c0%2c0%2c0-2.663-2.663H182.413a2.665%2c2.665%2c0%2c0%2c0-2.663%2c2.663v2.28a5.327%2c5.327%2c0%2c0%2c0%2c2.625%2c4.59Z' transform='translate(1442.615 -162.949) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_476' data-name='Shape 476' d='M219.7%2c1385.75H179.75' transform='translate(1440.287 -162.949) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_477' data-name='Shape 477' d='M191.7%2c1389.5l-3.326%2c3.326' transform='translate(1437.378 -156.258) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_478' data-name='Shape 478' d='M188.775%2c1388l-3.491%2c3.491' transform='translate(1438.543 -158.657) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$var$img$e = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3e %3cg id='icon_MA_DB2' transform='translate(-1061 18589)'%3e %3cg id='Rectangle_1002' data-name='Rectangle 1002' transform='translate(1061 -18589)' fill='white' stroke='%23707070' stroke-width='1' opacity='0.004'%3e %3crect width='80' height='80' stroke='none'/%3e %3crect x='0.5' y='0.5' width='79' height='79' fill='none'/%3e %3c/g%3e %3cg id='icon_MA_DB2-2' data-name='icon_MA_DB2' transform='translate(1061.111 -18585)'%3e %3cpath id='Path_2891' data-name='Path 2891' d='M.75%2c12.021A10.146%2c10.146%2c0%2c0%2c1%2c10.9%2c1.875' transform='translate(0.25 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2892' data-name='Path 2892' d='M.75%2c19.19A10.146%2c10.146%2c0%2c0%2c0%2c10.9%2c29.336' transform='translate(0.25 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2893' data-name='Path 2893' d='M30.461%2c12.021A10.146%2c10.146%2c0%2c0%2c0%2c20.315%2c1.875' transform='translate(48.317 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2894' data-name='Path 2894' d='M30.461%2c19.19A10.146%2c10.146%2c0%2c0%2c1%2c20.315%2c29.336' transform='translate(48.317 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cg id='Icons_Footwear' data-name='Icons / Footwear'%3e %3cg id='Group_108' data-name='Group 108'%3e %3cg id='Regular_108' data-name='Regular 108'%3e %3cpath id='Shape_471' data-name='Shape 471' d='M197.062%2c1394.75a6.66%2c6.66%2c0%2c0%2c1-13.123%2c1.6%2c2.1%2c2.1%2c0%2c0%2c0-2.042-1.6%2c2.146%2c2.146%2c0%2c0%2c0-2.147%2c2.147v13.834a2.664%2c2.664%2c0%2c0%2c0%2c2.663%2c2.663h34.624a2.664%2c2.664%2c0%2c0%2c0%2c2.663-2.663v-2.28a5.329%2c5.329%2c0%2c0%2c0-2.625-4.592Z' transform='translate(1433.307 -162.949) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_472' data-name='Shape 472' d='M179.75%2c1402.25H219.7' transform='translate(1427.49 -162.95) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_473' data-name='Shape 473' d='M191.75%2c1399.956l3.326-3.326' transform='translate(1431.849 -153.641) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_474' data-name='Shape 474' d='M194.75%2c1401.521l3.491-3.491' transform='translate(1430.763 -151.315) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_475' data-name='Shape 475' d='M202.389%2c1401.394a6.66%2c6.66%2c0%2c0%2c1%2c13.123-1.6%2c2.1%2c2.1%2c0%2c0%2c0%2c2.042%2c1.6%2c2.146%2c2.146%2c0%2c0%2c0%2c2.147-2.147v-13.834a2.665%2c2.665%2c0%2c0%2c0-2.663-2.663H182.413a2.665%2c2.665%2c0%2c0%2c0-2.663%2c2.663v2.28a5.327%2c5.327%2c0%2c0%2c0%2c2.625%2c4.59Z' transform='translate(1442.615 -162.949) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_476' data-name='Shape 476' d='M219.7%2c1385.75H179.75' transform='translate(1440.287 -162.949) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_477' data-name='Shape 477' d='M191.7%2c1389.5l-3.326%2c3.326' transform='translate(1437.378 -156.258) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_478' data-name='Shape 478' d='M188.775%2c1388l-3.491%2c3.491' transform='translate(1438.543 -158.657) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$var$img$d = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3e %3cg id='icon_ME_CO1' transform='translate(-1495 18589)'%3e %3cg id='Rectangle_1005' data-name='Rectangle 1005' transform='translate(1495 -18589)' fill='white' stroke='%23707070' stroke-width='1' opacity='0.001'%3e %3crect width='80' height='80' stroke='none'/%3e %3crect x='0.5' y='0.5' width='79' height='79' fill='none'/%3e %3c/g%3e %3cg id='icon_ME_CO1-2' data-name='icon_ME_CO1' transform='translate(1495.111 -18585)'%3e %3cpath id='Path_2891' data-name='Path 2891' d='M.75%2c12.021A10.146%2c10.146%2c0%2c0%2c1%2c10.9%2c1.875' transform='translate(0.25 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2892' data-name='Path 2892' d='M.75%2c19.19A10.146%2c10.146%2c0%2c0%2c0%2c10.9%2c29.336' transform='translate(0.25 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2893' data-name='Path 2893' d='M30.461%2c12.021A10.146%2c10.146%2c0%2c0%2c0%2c20.315%2c1.875' transform='translate(48.317 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2894' data-name='Path 2894' d='M30.461%2c19.19A10.146%2c10.146%2c0%2c0%2c1%2c20.315%2c29.336' transform='translate(48.317 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cg id='A4_page' data-name='A4 page' opacity='0.95'%3e %3cg id='Group_6541' data-name='Group 6541'%3e %3cg id='Rectangle_170' data-name='Rectangle 170' transform='translate(21.889 14.751)' fill='none' stroke='%231e4e5f' stroke-width='2'%3e %3crect width='37' height='42' rx='4' stroke='none'/%3e %3crect x='1' y='1' width='35' height='40' rx='3' fill='none'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3cg id='Group_8177' data-name='Group 8177'%3e %3cpath id='Path_2896' data-name='Path 2896' d='M9%2c9a3%2c3%2c0%2c1%2c1%2c4%2c2.829%2c1.5%2c1.5%2c0%2c0%2c0-1%2c1.415V14.25' transform='translate(27.889 24)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5'/%3e %3cpath id='Path_2897' data-name='Path 2897' d='M12%2c18a.375.375%2c0%2c0%2c1%2c0-.75' transform='translate(27.889 24)' fill='none' stroke='%231e4e5f' stroke-width='1.5'/%3e %3cpath id='Path_2898' data-name='Path 2898' d='M12%2c18a.375.375%2c0%2c0%2c0%2c0-.75' transform='translate(27.889 24)' fill='none' stroke='%231e4e5f' stroke-width='1.5'/%3e %3cpath id='Path_2899' data-name='Path 2899' d='M12%2c23.25A11.25%2c11.25%2c0%2c1%2c0%2c.75%2c12%2c11.25%2c11.25%2c0%2c0%2c0%2c12%2c23.25Z' transform='translate(27.889 24)' fill='none' stroke='%231e4e5f' stroke-miterlimit='10' stroke-width='1.5'/%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$var$img$c = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3e %3cg id='icon_ME_CO2' transform='translate(-1634 18589)'%3e %3cg id='Rectangle_1006' data-name='Rectangle 1006' transform='translate(1634 -18589)' fill='white' stroke='%23707070' stroke-width='1' opacity='0.002'%3e %3crect width='80' height='80' stroke='none'/%3e %3crect x='0.5' y='0.5' width='79' height='79' fill='none'/%3e %3c/g%3e %3cg id='icon_ME_CO2-2' data-name='icon_ME_CO2' transform='translate(1634.111 -18585)'%3e %3cpath id='Path_2891' data-name='Path 2891' d='M.75%2c12.021A10.146%2c10.146%2c0%2c0%2c1%2c10.9%2c1.875' transform='translate(0.25 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2892' data-name='Path 2892' d='M.75%2c19.19A10.146%2c10.146%2c0%2c0%2c0%2c10.9%2c29.336' transform='translate(0.25 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2893' data-name='Path 2893' d='M30.461%2c12.021A10.146%2c10.146%2c0%2c0%2c0%2c20.315%2c1.875' transform='translate(48.317 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2894' data-name='Path 2894' d='M30.461%2c19.19A10.146%2c10.146%2c0%2c0%2c1%2c20.315%2c29.336' transform='translate(48.317 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cg id='A4_page' data-name='A4 page' opacity='0.95'%3e %3cg id='Group_6541' data-name='Group 6541'%3e %3cg id='Rectangle_170' data-name='Rectangle 170'%3e %3cpath id='Path_2881' data-name='Path 2881' d='M25%2c0h8a4%2c4%2c0%2c0%2c1%2c4%2c4V38a4%2c4%2c0%2c0%2c1-4%2c4H4a4%2c4%2c0%2c0%2c1-4-4V25A25%2c25%2c0%2c0%2c1%2c25%2c0Z' transform='translate(21.889 14.751)' fill='none'/%3e %3cpath id='Path_2882' data-name='Path 2882' d='M25%2c1h8a3%2c3%2c0%2c0%2c1%2c3%2c3V38a3%2c3%2c0%2c0%2c1-3%2c3H4a3%2c3%2c0%2c0%2c1-3-3V25A24%2c24%2c0%2c0%2c1%2c25%2c1Z' transform='translate(21.889 14.751)' fill='none' stroke='%231e4e5f' stroke-width='2'/%3e %3c/g%3e %3cpath id='Path_1253' data-name='Path 1253' d='M-8.44-.8h-3.174l3.576-10.832h4.02L-.443-.8H-3.616l-2.37-7.849h-.085Zm-.592-4.274h5.966v2.2H-9.033ZM.509-2.5V-4.782l4.358-6.855H6.941V-8.59H5.756L3.408-4.866v.085H9.839V-2.5ZM5.777-.8V-3.195l.063-.994v-7.447H8.59V-.8Z' transform='translate(41.52 41.925)' fill='%231e4e5f'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$var$img$b = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3e %3cg id='icon_ME_FR0' transform='translate(-1764 18589)'%3e %3cg id='Rectangle_1007' data-name='Rectangle 1007' transform='translate(1764 -18589)' fill='white' stroke='%23707070' stroke-width='1' opacity='0.002'%3e %3crect width='80' height='80' stroke='none'/%3e %3crect x='0.5' y='0.5' width='79' height='79' fill='none'/%3e %3c/g%3e %3cg id='icon_ME_FR0-2' data-name='icon_ME_FR0' transform='translate(1765.111 -18584)'%3e %3cpath id='Path_2891' data-name='Path 2891' d='M.75%2c12.021A10.146%2c10.146%2c0%2c0%2c1%2c10.9%2c1.875' transform='translate(-0.75 -1.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2892' data-name='Path 2892' d='M.75%2c19.19A10.146%2c10.146%2c0%2c0%2c0%2c10.9%2c29.336' transform='translate(-0.75 40.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2893' data-name='Path 2893' d='M30.461%2c12.021A10.146%2c10.146%2c0%2c0%2c0%2c20.315%2c1.875' transform='translate(47.317 -1.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2894' data-name='Path 2894' d='M30.461%2c19.19A10.146%2c10.146%2c0%2c0%2c1%2c20.315%2c29.336' transform='translate(47.317 40.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cg id='Group_8175' data-name='Group 8175' transform='translate(17535.889 -16490.23)'%3e %3cg id='Path_2895' data-name='Path 2895' transform='translate(-17512 16505)'%3e %3cpath id='Path_2883' data-name='Path 2883' d='M4%2c0H26a4%2c4%2c0%2c0%2c1%2c4%2c4V30a4%2c4%2c0%2c0%2c1-4%2c4H4a4%2c4%2c0%2c0%2c1-4-4V4A4%2c4%2c0%2c0%2c1%2c4%2c0Z' fill='none'/%3e %3cpath id='Path_2884' data-name='Path 2884' d='M4%2c2A2%2c2%2c0%2c0%2c0%2c2%2c4V30a2%2c2%2c0%2c0%2c0%2c2%2c2H26a2%2c2%2c0%2c0%2c0%2c2-2V4a2%2c2%2c0%2c0%2c0-2-2H4M4%2c0H26a4%2c4%2c0%2c0%2c1%2c4%2c4V30a4%2c4%2c0%2c0%2c1-4%2c4H4a4%2c4%2c0%2c0%2c1-4-4V4A4%2c4%2c0%2c0%2c1%2c4%2c0Z' fill='%23597a86'/%3e %3c/g%3e %3cg id='Group_8176' data-name='Group 8176' transform='matrix(0.883%2c -0.469%2c 0.469%2c 0.883%2c -17511.443%2c 16526.943)'%3e %3cpath id='Path_2877' data-name='Path 2877' d='M6.937%2c11.118c0-2.412%2c2.737-4.368%2c6.115-4.368s6.114%2c1.956%2c6.114%2c4.368V22.287a3.625%2c3.625%2c0%2c0%2c1-2.912%2c3.634%2c3.494%2c3.494%2c0%2c0%2c1-4.077-3.446v-1.7a8%2c8%2c0%2c0%2c0-1.6-4.8h0A8.49%2c8.49%2c0%2c0%2c0%2c8.715%2c14.2a3.844%2c3.844%2c0%2c0%2c1-1.777-3.08Z' transform='translate(-3.443 0.238)' fill='%231e4e5f' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2878' data-name='Path 2878' d='M18.558%2c5.991A2.621%2c2.621%2c0%2c1%2c1%2c21.179%2c3.37a2.621%2c2.621%2c0%2c0%2c1-2.621%2c2.621Z' transform='translate(-15.937 -0.75)' fill='%231e4e5f' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2879' data-name='Path 2879' d='M11.685%2c4.244A1.747%2c1.747%2c0%2c1%2c1%2c13.432%2c2.5a1.747%2c1.747%2c0%2c0%2c1-1.747%2c1.744Z' transform='translate(-1.204 -0.75)' fill='%231e4e5f' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2880' data-name='Path 2880' d='M4.313%2c6.5a.437.437%2c0%2c0%2c0%2c0-.874' transform='translate(14.031 0.053)' fill='none' stroke='%231e4e5f' stroke-width='2'/%3e %3cpath id='Path_2881' data-name='Path 2881' d='M5.125%2c6.5a.437.437%2c0%2c0%2c1%2c0-.874' transform='translate(13.219 0.053)' fill='none' stroke='%231e4e5f' stroke-width='2'/%3e %3cg id='Group_8159' data-name='Group 8159' transform='translate(15.286 3.057)'%3e %3cpath id='Path_2882' data-name='Path 2882' d='M6.563%2c4.249a.437.437%2c0%2c1%2c0%2c0-.874' transform='translate(-6.126 -3.375)' fill='none' stroke='%231e4e5f' stroke-width='2'/%3e %3cpath id='Path_2883-2' data-name='Path 2883' d='M7.375%2c4.249a.437.437%2c0%2c0%2c1%2c0-.874' transform='translate(-6.938 -3.375)' fill='none' stroke='%231e4e5f' stroke-width='2'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$var$img$a = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3e %3cg id='icon_ME_ST1' transform='translate(-1894 18589)'%3e %3cg id='Rectangle_1008' data-name='Rectangle 1008' transform='translate(1894 -18589)' fill='white' stroke='%23707070' stroke-width='1' opacity='0'%3e %3crect width='80' height='80' stroke='none'/%3e %3crect x='0.5' y='0.5' width='79' height='79' fill='none'/%3e %3c/g%3e %3cg id='icon_ME_ST1-2' data-name='icon_ME_ST1' transform='translate(1911.174 -18584)'%3e %3cpath id='Line_1' data-name='Line 1' d='M45.652%2c0H0' transform='translate(0 58.281)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_558' data-name='Path 558' d='M69.274%2c123.958a.733.733%2c0%2c0%2c1%2c.733.732h0a.733.733%2c0%2c0%2c1-.733.733h0a.733.733%2c0%2c0%2c1-.732-.733h0a.733.733%2c0%2c0%2c1%2c.732-.732' transform='translate(-46.448 -60.551)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Line_2' data-name='Line 2' d='M0%2c0H0' transform='translate(22.826 63.406)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3crect id='Rectangle_83' data-name='Rectangle 83' width='45.652' height='70' rx='8' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Line_3' data-name='Line 3' d='M0%2c0V2.637' transform='translate(10.652 27.586)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Line_4' data-name='Line 4' d='M0%2c0V2.637' transform='translate(35 27.586)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_559' data-name='Path 559' d='M53.486%2c76.329a9.156%2c9.156%2c0%2c0%2c0%2c8.295%2c4.146%2c9.156%2c9.156%2c0%2c0%2c0%2c8.295-4.146' transform='translate(84.606 118.892) rotate(180)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$var$img$9 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3e %3cg id='icon_ME_ST1' transform='translate(-1894 18589)'%3e %3cg id='Rectangle_1008' data-name='Rectangle 1008' transform='translate(1894 -18589)' fill='white' stroke='%23707070' stroke-width='1' opacity='0'%3e %3crect width='80' height='80' stroke='none'/%3e %3crect x='0.5' y='0.5' width='79' height='79' fill='none'/%3e %3c/g%3e %3cg id='icon_ME_ST1-2' data-name='icon_ME_ST1' transform='translate(1911.174 -18584)'%3e %3cpath id='Line_1' data-name='Line 1' d='M45.652%2c0H0' transform='translate(0 58.281)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_558' data-name='Path 558' d='M69.274%2c123.958a.733.733%2c0%2c0%2c1%2c.733.732h0a.733.733%2c0%2c0%2c1-.733.733h0a.733.733%2c0%2c0%2c1-.732-.733h0a.733.733%2c0%2c0%2c1%2c.732-.732' transform='translate(-46.448 -60.551)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Line_2' data-name='Line 2' d='M0%2c0H0' transform='translate(22.826 63.406)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3crect id='Rectangle_83' data-name='Rectangle 83' width='45.652' height='70' rx='8' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Line_3' data-name='Line 3' d='M0%2c0V2.637' transform='translate(10.652 27.586)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Line_4' data-name='Line 4' d='M0%2c0V2.637' transform='translate(35 27.586)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_559' data-name='Path 559' d='M53.486%2c76.329a9.156%2c9.156%2c0%2c0%2c0%2c8.295%2c4.146%2c9.156%2c9.156%2c0%2c0%2c0%2c8.295-4.146' transform='translate(84.606 118.892) rotate(180)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$var$img$8 = "data:image/svg+xml,%3cns0:svg xmlns:ns0='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 61 79'%3e %3cns0:defs%3e %3cns0:clipPath id='tqn6lk0cka'%3e %3cns0:path data-name='Rechteck 190' style='fill:white' d='M0 0h49v66H0z' /%3e %3c/ns0:clipPath%3e %3c/ns0:defs%3e %3cns0:g data-name='Gruppe maskieren 35' transform='translate(6 7)' style='clip-path:url(%23tqn6lk0cka)'%3e %3cns0:g data-name='Gruppe 6567'%3e %3cns0:g data-name='Gruppe 6552'%3e %3cns0:g data-name='Gruppe 6547'%3e %3cns0:path data-name='Pfad 564' d='M29.99 32.774a40.877 40.877 0 0 1-.667-6.965c.1-3.054 1.037-5.659.594-8.785A122.342 122.342 0 0 1 28.288.152c0-.394.643.066.645.352a92.836 92.836 0 0 0 1.277 14.774 26.015 26.015 0 0 1 .548 5.854c-.137 2.368-.869 4.566-.789 6.978.074 2.289.726 4.518.832 6.8s-.961 4.689-1.276 6.913a48.926 48.926 0 0 0 .6 15.546c.82 4.256 2.071 8.244 2.073 12.616 0 4.744.243 9.594-.219 14.319a32.715 32.715 0 0 1-.567 3.416 22.758 22.758 0 0 0-1 5.927l-.55-.072c.008-.257.019-.514.036-.771.2-3 1.042-5.882 1.439-8.852a56.678 56.678 0 0 0 .171-8.506c-.051-2.908.143-5.815-.037-8.72-.177-2.88-1.128-5.771-1.762-8.574a52.6 52.6 0 0 1-.953-7.784 48.529 48.529 0 0 1 .131-8.9c.327-2.971 1.531-5.658 1.111-8.7' transform='translate(-11.017 -50.523)' style='stroke-width:.5px%3bstroke:%231e4e5f%3bfill:%231e4e5f' /%3e %3cns0:path data-name='Pfad 565' d='M4.249 50.341c.528-8.071-2.439-15.882-1.324-23.956a108.706 108.706 0 0 1 2.624-12.223C6.7 9.709 8.457 4.96 8.257.321c-.017-.388.634.067.645.351.159 3.692-1 7.372-1.928 10.91-1.23 4.676-2.444 9.346-3.245 14.118-1.357 8.1 1.289 15.954 1.2 24.056-.087 8.159-3.093 16.086-3.967 24.165a38.941 38.941 0 0 0 .668 13.846 60.882 60.882 0 0 1 2 7.771l-.62-.577c-.783-2.9-1.5-5.454-2.232-8.255C-.233 82.836-.069 78.54.222 74.6c.608-8.212 3.489-16.047 4.027-24.259' transform='translate(27.816 -50.601)' style='stroke-width:.5px%3bstroke:%231e4e5f%3bfill:%231e4e5f' /%3e %3cns0:path data-name='Pfad 2289' d='M18.214 95.461s-.049-.818 0-.4.2 2.07.2 2.07-.1 3.351-1.486 4.385c-1.934 1.442-4.793 2.741-7.455 2.165a5.676 5.676 0 0 1-4.057-3.044c-.253-.612.681-6.795.7-6.864' transform='translate(12.951 -50.524)' style='fill:none%3bstroke:%231e4e5f' /%3e %3c/ns0:g%3e %3cns0:path data-name='Pfad 566' d='M527.373 1482.237h-4.917l-8.312 25.654h32.647l-5.647-25.654h-5.9' transform='translate(-506.85 -1449.934)' style='fill:none%3bstroke:%231e4e5f' /%3e %3c/ns0:g%3e %3cns0:g data-name='Gruppe 6547'%3e %3cns0:path data-name='Pfad 559' d='M16.98 181.535a1.359 1.359 0 0 1-.192-.014 1.994 1.994 0 0 1-1.384-1.1 1.02 1.02 0 0 1-1.895-.253.993.993 0 0 1-.828.213 1.47 1.47 0 0 1-.986-.973.9.9 0 0 1-1 .035c-1.359-.847-1.387-5.858-.912-7.36a.274.274 0 0 1 .522.165c-.5 1.57-.278 6.135.68 6.731.064.04.26.161.673-.234l.368-.352.091.5a1.138 1.138 0 0 0 .676.952c.272.059.5-.194.652-.416l.45-.676.051.811c.031.5.235.83.52.849.256.02.56-.224.673-.795l.238-1.194.3 1.181a1.727 1.727 0 0 0 1.2 1.374.819.819 0 0 0 .829-.474 2.693 2.693 0 0 0 .069-1.706 2.95 2.95 0 0 1 .252-2.3.274.274 0 0 1 .438.329 2.538 2.538 0 0 0-.148 1.894 3.092 3.092 0 0 1-.141 2.07 1.391 1.391 0 0 1-1.187.748' transform='translate(-25.911 -128.277)' style='fill:%23fdf5ec%3bstroke-width:.5px%3bstroke:%231e4e5f' /%3e %3cns0:path data-name='Pfad 560' d='M27.451 180.451h-.091c-1.116-.043-1.909-.907-2.175-2.37a4.384 4.384 0 0 1 .045-1.506 3.739 3.739 0 0 0 .046-1.274c-.012-.053-.035-.16-.058-.239a.275.275 0 0 1-.235-.15.271.271 0 0 1 .119-.366.415.415 0 0 1 .376-.02c.208.1.264.348.333.662a4.209 4.209 0 0 1-.041 1.467 3.915 3.915 0 0 0-.049 1.325c.1.565.468 1.877 1.658 1.923a1.63 1.63 0 0 0 1.587-1.746 14.1 14.1 0 0 0-.185-2.547 16.321 16.321 0 0 1-.2-2.632l.028-.832a29.573 29.573 0 0 0-.039-3.993.274.274 0 1 1 .546-.04 30.015 30.015 0 0 1 .04 4.052l-.028.832a15.923 15.923 0 0 0 .2 2.542 14.69 14.69 0 0 1 .188 2.645 2.173 2.173 0 0 1-2.064 2.268' transform='translate(-32.9 -126.453)' style='fill:%23fdf5ec%3bstroke-width:.5px%3bstroke:%231e4e5f' /%3e %3cns0:path data-name='Pfad 561' d='M13.5 183.626a.274.274 0 0 1-.273-.261l-.068-1.438a.274.274 0 1 1 .547-.025l.068 1.438a.273.273 0 0 1-.261.286H13.5' transform='translate(-27.564 -132.687)' style='fill:%23fdf5ec%3bstroke-width:.5px%3bstroke:%231e4e5f' /%3e %3cns0:path data-name='Pfad 562' d='M16.944 184.506a.274.274 0 0 1-.274-.274v-2.318a.274.274 0 0 1 .548 0v2.318a.274.274 0 0 1-.274.274' transform='translate(-29.152 -132.687)' style='fill:%23fdf5ec%3bstroke-width:.5px%3bstroke:%231e4e5f' /%3e %3cns0:path data-name='Pfad 563' d='M20.121 184.689a.274.274 0 0 1-.266-.209 10.408 10.408 0 0 1-.139-2.967.28.28 0 0 1 .3-.245.274.274 0 0 1 .245.3 10.057 10.057 0 0 0 .127 2.783.274.274 0 0 1-.2.331.263.263 0 0 1-.065.008' transform='translate(-30.508 -132.518)' style='fill:%23fdf5ec%3bstroke-width:.5px%3bstroke:%231e4e5f' /%3e %3cns0:path data-name='Pfad 564' d='M30.556 32.774a40.876 40.876 0 0 0 .667-6.965c-.1-3.054-1.037-5.659-.594-8.785A122.343 122.343 0 0 0 32.259.152c0-.394-.644.066-.645.352a92.836 92.836 0 0 1-1.278 14.774 26.016 26.016 0 0 0-.548 5.854c.137 2.368.869 4.566.789 6.978-.074 2.289-.726 4.518-.832 6.8s.961 4.689 1.276 6.913a48.926 48.926 0 0 1-.6 15.546c-.82 4.256-2.071 8.244-2.073 12.616 0 4.744-.243 9.594.219 14.319a32.714 32.714 0 0 0 .567 3.416 22.758 22.758 0 0 1 1 5.927l.55-.072a22.09 22.09 0 0 0-.036-.771c-.2-3-1.042-5.882-1.439-8.852a56.679 56.679 0 0 1-.171-8.506c.051-2.908-.143-5.815.037-8.72.177-2.88 1.128-5.771 1.762-8.574a52.6 52.6 0 0 0 .953-7.784 48.529 48.529 0 0 0-.131-8.9c-.327-2.971-1.531-5.658-1.111-8.7' transform='translate(-34.408 -50.523)' style='fill:%23fdf5ec%3bstroke-width:.5px%3bstroke:%231e4e5f' /%3e %3cns0:path data-name='Pfad 565' d='M4.669 50.341c-.528-8.071 2.439-15.882 1.323-23.956a108.706 108.706 0 0 0-2.624-12.223C2.219 9.709.46 4.96.66.321.677-.067.026.388.015.672c-.159 3.692 1 7.372 1.928 10.91 1.231 4.676 2.445 9.346 3.245 14.118 1.357 8.1-1.289 15.954-1.2 24.056.089 8.158 3.094 16.086 3.969 24.165a38.941 38.941 0 0 1-.668 13.846 60.881 60.881 0 0 0-2 7.771l.62-.577c.783-2.9 1.5-5.454 2.232-8.255 1.009-3.87.845-8.166.554-12.109-.607-8.209-3.489-16.044-4.026-24.256' transform='translate(-21.612 -50.601)' style='fill:%23fdf5ec%3bstroke-width:.5px%3bstroke:%231e4e5f' /%3e %3c/ns0:g%3e %3c/ns0:g%3e %3c/ns0:g%3e %3cns0:g data-name='Rechteck 189' style='fill:none%3bstroke:%231e4e5f'%3e %3cns0:rect width='61' height='79' rx='10' style='stroke:none' /%3e %3cns0:rect x='.5' y='.5' width='60' height='78' rx='9.5' style='fill:none' /%3e %3c/ns0:g%3e%3c/ns0:svg%3e";
var $3fe9119940fa16b8$var$img$7 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3e %3cg data-name='Rechteck 1006' style='fill:white%3bstroke:%23707070%3bopacity:.002'%3e %3cpath style='stroke:none' d='M0 0h80v80H0z'/%3e %3cpath style='fill:none' d='M.5.5h79v79H.5z'/%3e %3c/g%3e %3cg data-name='icon_ME_CO2'%3e %3cpath data-name='Path 2891' d='M.75 12.021A10.146 10.146 0 0 1 10.9 1.875' transform='translate(.361 3.125)' style='stroke-linecap:round%3bstroke-linejoin:round%3bstroke:%231e4e5f%3bstroke-width:2px%3bfill:none'/%3e %3cpath data-name='Path 2892' d='M.75 19.19A10.146 10.146 0 0 0 10.9 29.336' transform='translate(.361 45.664)' style='stroke-linecap:round%3bstroke-linejoin:round%3bstroke:%231e4e5f%3bstroke-width:2px%3bfill:none'/%3e %3cpath data-name='Path 2893' d='M30.461 12.021A10.146 10.146 0 0 0 20.315 1.875' transform='translate(48.428 3.125)' style='stroke-linecap:round%3bstroke-linejoin:round%3bstroke:%231e4e5f%3bstroke-width:2px%3bfill:none'/%3e %3cpath data-name='Path 2894' d='M30.461 19.19a10.146 10.146 0 0 1-10.146 10.146' transform='translate(48.428 45.664)' style='stroke-linecap:round%3bstroke-linejoin:round%3bstroke:%231e4e5f%3bstroke-width:2px%3bfill:none'/%3e %3cg data-name='A4 page' style='opacity:.95'%3e %3cg data-name='Group 6541'%3e %3cg data-name='Rectangle 170'%3e %3cpath data-name='Pfad 2881' d='M25 0h8a4 4 0 0 1 4 4v34a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V25A25 25 0 0 1 25 0z' transform='translate(22 18.751)' style='fill:none'/%3e %3cpath data-name='Pfad 2882' d='M25 1h8a3 3 0 0 1 3 3v34a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V25A24 24 0 0 1 25 1z' transform='translate(22 18.751)' style='stroke:%231e4e5f%3bstroke-width:2px%3bfill:none'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$var$img$6 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3e %3cg id='icon_MA_ST1' transform='translate(-1200 18589)'%3e %3cg id='Rectangle_1003' data-name='Rectangle 1003' transform='translate(1200 -18589)' fill='white' stroke='%23707070' stroke-width='1' opacity='0'%3e %3crect width='80' height='80' stroke='none'/%3e %3crect x='0.5' y='0.5' width='79' height='79' fill='none'/%3e %3c/g%3e %3cg id='icon_MA_ST1-2' data-name='icon_MA_ST1' transform='translate(1200.111 -18585)'%3e %3cpath id='Path_2891' data-name='Path 2891' d='M.75%2c12.021A10.146%2c10.146%2c0%2c0%2c1%2c10.9%2c1.875' transform='translate(0.25 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2892' data-name='Path 2892' d='M.75%2c19.19A10.146%2c10.146%2c0%2c0%2c0%2c10.9%2c29.336' transform='translate(0.25 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2893' data-name='Path 2893' d='M30.461%2c12.021A10.146%2c10.146%2c0%2c0%2c0%2c20.315%2c1.875' transform='translate(48.317 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2894' data-name='Path 2894' d='M30.461%2c19.19A10.146%2c10.146%2c0%2c0%2c1%2c20.315%2c29.336' transform='translate(48.317 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cg id='Icons_Footwear' data-name='Icons / Footwear'%3e %3cg id='Group_108' data-name='Group 108'%3e %3cg id='Regular_108' data-name='Regular 108'%3e %3cpath id='Shape_471' data-name='Shape 471' d='M197.062%2c1394.75a6.66%2c6.66%2c0%2c0%2c1-13.123%2c1.6%2c2.1%2c2.1%2c0%2c0%2c0-2.042-1.6%2c2.146%2c2.146%2c0%2c0%2c0-2.147%2c2.147v13.834a2.664%2c2.664%2c0%2c0%2c0%2c2.663%2c2.663h34.624a2.664%2c2.664%2c0%2c0%2c0%2c2.663-2.663v-2.28a5.329%2c5.329%2c0%2c0%2c0-2.625-4.592Z' transform='translate(1433.307 -162.949) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_472' data-name='Shape 472' d='M179.75%2c1402.25H219.7' transform='translate(1427.49 -162.95) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_473' data-name='Shape 473' d='M191.75%2c1399.956l3.326-3.326' transform='translate(1431.849 -153.641) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_474' data-name='Shape 474' d='M194.75%2c1401.521l3.491-3.491' transform='translate(1430.763 -151.315) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_475' data-name='Shape 475' d='M202.389%2c1401.394a6.66%2c6.66%2c0%2c0%2c1%2c13.123-1.6%2c2.1%2c2.1%2c0%2c0%2c0%2c2.042%2c1.6%2c2.146%2c2.146%2c0%2c0%2c0%2c2.147-2.147v-13.834a2.665%2c2.665%2c0%2c0%2c0-2.663-2.663H182.413a2.665%2c2.665%2c0%2c0%2c0-2.663%2c2.663v2.28a5.327%2c5.327%2c0%2c0%2c0%2c2.625%2c4.59Z' transform='translate(1442.615 -162.949) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_476' data-name='Shape 476' d='M219.7%2c1385.75H179.75' transform='translate(1440.287 -162.949) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_477' data-name='Shape 477' d='M191.7%2c1389.5l-3.326%2c3.326' transform='translate(1437.378 -156.258) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_478' data-name='Shape 478' d='M188.775%2c1388l-3.491%2c3.491' transform='translate(1438.543 -158.657) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$var$img$5 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3e %3cg id='icon_MA_ST2' transform='translate(-1365 18589)'%3e %3cg id='Rectangle_1004' data-name='Rectangle 1004' transform='translate(1365 -18589)' fill='white' stroke='%23707070' stroke-width='1' opacity='0.004'%3e %3crect width='80' height='80' stroke='none'/%3e %3crect x='0.5' y='0.5' width='79' height='79' fill='none'/%3e %3c/g%3e %3cg id='icon_MA_ST2-2' data-name='icon_MA_ST2' transform='translate(1365.111 -18585)'%3e %3cpath id='Path_2891' data-name='Path 2891' d='M.75%2c12.021A10.146%2c10.146%2c0%2c0%2c1%2c10.9%2c1.875' transform='translate(0.25 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2892' data-name='Path 2892' d='M.75%2c19.19A10.146%2c10.146%2c0%2c0%2c0%2c10.9%2c29.336' transform='translate(0.25 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2893' data-name='Path 2893' d='M30.461%2c12.021A10.146%2c10.146%2c0%2c0%2c0%2c20.315%2c1.875' transform='translate(48.317 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2894' data-name='Path 2894' d='M30.461%2c19.19A10.146%2c10.146%2c0%2c0%2c1%2c20.315%2c29.336' transform='translate(48.317 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cg id='Icons_Footwear' data-name='Icons / Footwear'%3e %3cg id='Group_108' data-name='Group 108'%3e %3cg id='Regular_108' data-name='Regular 108'%3e %3cpath id='Shape_471' data-name='Shape 471' d='M197.062%2c1394.75a6.66%2c6.66%2c0%2c0%2c1-13.123%2c1.6%2c2.1%2c2.1%2c0%2c0%2c0-2.042-1.6%2c2.146%2c2.146%2c0%2c0%2c0-2.147%2c2.147v13.834a2.664%2c2.664%2c0%2c0%2c0%2c2.663%2c2.663h34.624a2.664%2c2.664%2c0%2c0%2c0%2c2.663-2.663v-2.28a5.329%2c5.329%2c0%2c0%2c0-2.625-4.592Z' transform='translate(1433.307 -162.949) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_472' data-name='Shape 472' d='M179.75%2c1402.25H219.7' transform='translate(1427.49 -162.95) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_473' data-name='Shape 473' d='M191.75%2c1399.956l3.326-3.326' transform='translate(1431.849 -153.641) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_474' data-name='Shape 474' d='M194.75%2c1401.521l3.491-3.491' transform='translate(1430.763 -151.315) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_475' data-name='Shape 475' d='M202.389%2c1401.394a6.66%2c6.66%2c0%2c0%2c1%2c13.123-1.6%2c2.1%2c2.1%2c0%2c0%2c0%2c2.042%2c1.6%2c2.146%2c2.146%2c0%2c0%2c0%2c2.147-2.147v-13.834a2.665%2c2.665%2c0%2c0%2c0-2.663-2.663H182.413a2.665%2c2.665%2c0%2c0%2c0-2.663%2c2.663v2.28a5.327%2c5.327%2c0%2c0%2c0%2c2.625%2c4.59Z' transform='translate(1442.615 -162.949) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_476' data-name='Shape 476' d='M219.7%2c1385.75H179.75' transform='translate(1440.287 -162.949) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_477' data-name='Shape 477' d='M191.7%2c1389.5l-3.326%2c3.326' transform='translate(1437.378 -156.258) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Shape_478' data-name='Shape 478' d='M188.775%2c1388l-3.491%2c3.491' transform='translate(1438.543 -158.657) rotate(90)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$var$img$4 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3e %3cg id='icon_ME_CO1' transform='translate(-1495 18589)'%3e %3cg id='Rectangle_1005' data-name='Rectangle 1005' transform='translate(1495 -18589)' fill='white' stroke='%23707070' stroke-width='1' opacity='0.001'%3e %3crect width='80' height='80' stroke='none'/%3e %3crect x='0.5' y='0.5' width='79' height='79' fill='none'/%3e %3c/g%3e %3cg id='icon_ME_CO1-2' data-name='icon_ME_CO1' transform='translate(1495.111 -18585)'%3e %3cpath id='Path_2891' data-name='Path 2891' d='M.75%2c12.021A10.146%2c10.146%2c0%2c0%2c1%2c10.9%2c1.875' transform='translate(0.25 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2892' data-name='Path 2892' d='M.75%2c19.19A10.146%2c10.146%2c0%2c0%2c0%2c10.9%2c29.336' transform='translate(0.25 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2893' data-name='Path 2893' d='M30.461%2c12.021A10.146%2c10.146%2c0%2c0%2c0%2c20.315%2c1.875' transform='translate(48.317 -0.875)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cpath id='Path_2894' data-name='Path 2894' d='M30.461%2c19.19A10.146%2c10.146%2c0%2c0%2c1%2c20.315%2c29.336' transform='translate(48.317 41.664)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cg id='A4_page' data-name='A4 page' opacity='0.95'%3e %3cg id='Group_6541' data-name='Group 6541'%3e %3cg id='Rectangle_170' data-name='Rectangle 170' transform='translate(21.889 14.751)' fill='none' stroke='%231e4e5f' stroke-width='2'%3e %3crect width='37' height='42' rx='4' stroke='none'/%3e %3crect x='1' y='1' width='35' height='40' rx='3' fill='none'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3cg id='Group_8177' data-name='Group 8177'%3e %3cpath id='Path_2896' data-name='Path 2896' d='M9%2c9a3%2c3%2c0%2c1%2c1%2c4%2c2.829%2c1.5%2c1.5%2c0%2c0%2c0-1%2c1.415V14.25' transform='translate(27.889 24)' fill='none' stroke='%231e4e5f' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5'/%3e %3cpath id='Path_2897' data-name='Path 2897' d='M12%2c18a.375.375%2c0%2c0%2c1%2c0-.75' transform='translate(27.889 24)' fill='none' stroke='%231e4e5f' stroke-width='1.5'/%3e %3cpath id='Path_2898' data-name='Path 2898' d='M12%2c18a.375.375%2c0%2c0%2c0%2c0-.75' transform='translate(27.889 24)' fill='none' stroke='%231e4e5f' stroke-width='1.5'/%3e %3cpath id='Path_2899' data-name='Path 2899' d='M12%2c23.25A11.25%2c11.25%2c0%2c1%2c0%2c.75%2c12%2c11.25%2c11.25%2c0%2c0%2c0%2c12%2c23.25Z' transform='translate(27.889 24)' fill='none' stroke='%231e4e5f' stroke-miterlimit='10' stroke-width='1.5'/%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$var$img$3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAABXCAMAAABGFileAAAAS1BMVEVHcEwTUGAeTl8eTl4dTWAbS2AcTV4eTV4dTV4dTV0dTV7///8eTl+tv8XG0teOpq4rWGhVeYbw9PVHbnza4uVykJtjhJA5Y3KdsrnDokXYAAAAC3RSTlMAFPCAUDma3sJlsGbN4aQAAAJoSURBVFjD7VnbloMgDFyvgAgoqO3/f+nuqWjbXZIALU/beVXn5CSTIcSvrw8+SEPXNk3PeT3WnPdN01bvIG17Nv4G69uXOCsx1GMY9SCywxZsxMBEXgJw1htzl14rPsaAJzL3T187Y5TWVlqtlTHu6VmfUq+HYKdNWfkMq7bpIeTo+nX3zM5KhqHm5Cy3p7YuEOuN+XJqLkrN4swAxnpjPrMhEmhXKynYNZq4Pd40MgbmeJ1IRVdH5uB3Lmq0eJVXwrTIWCyemGFy87qdrIyH9cSc7LKEaB8jBjuv8zVQMg3Kf9fhWQCU8OMLzqCq4KjE1vC3u9u48MMVC5hhNTOorH3tGNJoCgsXDFiBbeelewFqc7oX8PwCiRgPl4oXDnjY/ZYyAtA2dj8e/vDWhHRRPZwB12GRTZh1wfq9YQpKbW/hTeZjCzYzy+rgv4lgQWuwL/AuO0UVSK+Tr8AFDo4m4ezBpdik8S5mnuf1ahN5e6Jsh3fPZOH6gPVq+txFjhIdMOFoXp3Gi3rVD64RvDbQyRSvnGle76VpvFK7nHg5GYyPWL+3brm8A207JG9IvxF9TPJm9XEmr6D9jOQN+VlF+y/FG/TfiPOC4g2eFxHnG8UbPt/o85jiBUY/an6geIH5gZp3SF5o3hHUrI7zgvMZMU8evA64LoLzJBnw4cAb4vsieV6/846J8zpxv0B50fsFcR+6wpM1fh8i7m92byi3JN/fSt03j9K9/X5c7D5fav9QbF9SbL+Tso+6puyjiu3Piu377nID9pNL5n6y2D613P632L663H693P+AYv8vjrBL/G/54F/hGzfsx9hIPQG6AAAAAElFTkSuQmCC";
var $3fe9119940fa16b8$var$img$2 = "data:image/png;base64,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";
var $3fe9119940fa16b8$var$img$1 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='156.718' height='224.56' viewBox='0 0 156.718 224.56'%3e %3cg data-name='Group 8180'%3e %3cpath data-name='Path 2900' d='M-16.415-42.578s6.339 80.21 30.752 119.036 77.345 76.5 77.345 76.5' transform='rotate(13 -185.52 260.323)' style='fill:none%3bstroke:%231e4e5f%3bstroke-linecap:round%3bstroke-width:5px'/%3e %3cg data-name='Group 8179'%3e %3cpath data-name='Line 55' transform='translate(112.849 167.06)' style='fill:none%3bstroke:%231e4e5f%3bstroke-linecap:round%3bstroke-width:5px' d='M0 0v55'/%3e %3cpath data-name='Line 56' transform='translate(57.849 222.06)' style='fill:none%3bstroke:%231e4e5f%3bstroke-linecap:round%3bstroke-width:5px' d='M0 0h55'/%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$export$ada873a34909da65 = {
    onCancelPress: 'onCancelPress',
    onMeasureAgainPress: 'onMeasureAgainPress',
    onCameraPermissionRequest: 'onCameraPermissionRequest',
    onLetUsKnowPress: 'onLetUsKnowPress',
    onTellMePress: 'onTellMePress',
    onBackToShopPress: 'onBackToShopPress',
    onHelpCenterPress: 'onHelpCenterPress',
    onBackToFootprintPress: 'onBackToFootprintPress',
    onStartAgainPress: 'onStartAgainPress',
    onMeasurementPress: 'onMeasurementPress'
};
var $3fe9119940fa16b8$var$Module;
(function(Module) {
    Module["BE"] = "Backend API";
    Module["ME"] = "Measurement API";
    Module["MA"] = "Matching API";
    Module["GU"] = "Guidance";
    Module["YU"] = "404 Not Found";
    Module["GE"] = "General Error";
})($3fe9119940fa16b8$var$Module || ($3fe9119940fa16b8$var$Module = {}));
var $3fe9119940fa16b8$var$ErrorType;
(function(ErrorType) {
    ErrorType["ST"] = "Status Error";
    ErrorType["FR"] = "Incorrect frame";
    ErrorType["CO"] = "Corners not found";
    ErrorType["DB"] = "Database Error";
    ErrorType["CA"] = "Camera Error";
    ErrorType["R0"] = "404 Not Found";
    ErrorType["VA"] = "Measured Twice";
    ErrorType["NA"] = "Not Available";
})($3fe9119940fa16b8$var$ErrorType || ($3fe9119940fa16b8$var$ErrorType = {}));
var $3fe9119940fa16b8$var$Foot;
(function(Foot) {
    Foot["RIGHT"] = "Right";
    Foot["LEFT"] = "Left";
    Foot["NA"] = "NA";
})($3fe9119940fa16b8$var$Foot || ($3fe9119940fa16b8$var$Foot = {}));
var $3fe9119940fa16b8$var$AgeGroup;
(function(AgeGroup) {
    AgeGroup["ADULT"] = "Adult";
    AgeGroup["CHILD"] = "Child";
    AgeGroup["NA"] = "NA";
})($3fe9119940fa16b8$var$AgeGroup || ($3fe9119940fa16b8$var$AgeGroup = {}));
// export enum Actions {
//   MeasureAgain = 'Measure Again',
//   RequestCameraPermission = 'Request Camera Permission',
//   LetUsKnow = 'Let us know',
//   TellMe = 'Tell Me',
//   BackToPartnerShop = 'Back to partner shop',
//   HelpCenter = 'Help Center',
//   BackToFootprint = 'Back to Footprint',
//   StartAgain = 'StartAgain',
//   NA = 'NA',
// }
var $3fe9119940fa16b8$var$InfoBox;
(function(InfoBox) {
    InfoBox["WithVideo"] = "With Video";
    InfoBox["WithoutVideo"] = "Without Video";
    InfoBox["NA"] = "NA";
})($3fe9119940fa16b8$var$InfoBox || ($3fe9119940fa16b8$var$InfoBox = {}));
var $3fe9119940fa16b8$var$ErrorObject = /** @class */ function() {
    function ErrorObject(module, errorType, errorCode, foot, ageGroup, shortCode, fullErrorCode) {
        this.action1 = '';
        this.action2 = '';
        this.infoBox = $3fe9119940fa16b8$var$InfoBox.NA;
        this.module = module;
        this.errorType = errorType;
        this.errorCode = errorCode;
        this.foot = foot;
        this.ageGroup = ageGroup;
        this.shortCode = shortCode;
        this.labelAction1 = '';
        this.labelAction2 = '';
        this.videoUrl = '';
        this.messageInfoboxTransId = '';
        this.isFooterVisible = false;
        this.isTryToVisible = false;
        this.isLongArrowVisible = false;
        this.isFullSizeIcon = false;
        this.centeredDesign = true;
        this.fullErrorCode = fullErrorCode;
        this.hasFooterActionMessage = true;
        this.icon = '';
        var t = $3fe9119940fa16b8$var$useTranslation().t;
        this.messageTitle = "cc.error.page-".concat(shortCode, "-00-title");
        this.messageBodyTransId = "cc.error.page-".concat(shortCode, "-00-body");
        this.messageFooter = t("cc.error.page-".concat(shortCode, "-00-footer"));
    }
    return ErrorObject;
}();
var $3fe9119940fa16b8$var$ErrorCodeParser = /** @class */ function() {
    function ErrorCodeParser() {}
    ErrorCodeParser.parseErrorCode = function(errorCode) {
        if (errorCode === undefined) throw new Error('Invalid error code');
        var t = $3fe9119940fa16b8$var$useTranslation().t;
        errorCode = errorCode.replace('-', '').replace('.', '');
        var code2 = '';
        var code4 = '';
        if (errorCode.length < 4) {
            code2 = 'GE';
            code4 = 'NA';
        } else {
            code2 = errorCode.substring(0, 2);
            code4 = errorCode.substring(2, 4);
        }
        var moduleString = code2;
        var module = this.parseModule(moduleString);
        var errorTypeString = code4;
        var errorType = this.parseErrorType(errorTypeString);
        //handle 404 not found error
        if (module === $3fe9119940fa16b8$var$Module.YU && errorType === $3fe9119940fa16b8$var$ErrorType.R0) {
            var errorObject404 = new $3fe9119940fa16b8$var$ErrorObject(module, errorType, 404, $3fe9119940fa16b8$var$Foot.NA, $3fe9119940fa16b8$var$AgeGroup.NA, errorCode.substring(0, 5), errorCode);
            errorObject404.labelAction1 = t("cc.error.page-action-go-to-footprint");
            errorObject404.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onBackToFootprintPress;
            errorObject404.icon = $3fe9119940fa16b8$var$img$2;
            errorObject404.isFullSizeIcon = true;
            return errorObject404;
        }
        var errorCodeString = errorCode.substring(4, 5);
        var errorCodeNumber = Number(errorCodeString);
        var footString = errorCode.substring(5, 6);
        var foot = this.parseFoot(footString);
        var ageString = errorCode.substring(6, 7);
        var ageGroup = this.parseAge(ageString);
        var errorObject = new $3fe9119940fa16b8$var$ErrorObject(module, errorType, errorCodeNumber, foot, ageGroup, errorCode.substring(0, 5), errorCode);
        switch(errorObject.shortCode){
            case 'GUCA1':
                errorObject.icon = $3fe9119940fa16b8$var$img$i;
                errorObject.isFooterVisible = true;
                errorObject.action1 = '';
                errorObject.action2 = $3fe9119940fa16b8$export$ada873a34909da65.onHelpCenterPress;
                errorObject.labelAction2 = t("cc.error.page-action-help-center");
                errorObject.messageFooter = t("cc.error.page-".concat(errorObject.shortCode, "-00-footer"));
                break;
            case 'GUCA2':
                errorObject.icon = $3fe9119940fa16b8$var$img$h;
                errorObject.isFooterVisible = true;
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onCameraPermissionRequest;
                errorObject.labelAction1 = t("cc.error.page-action-start-again");
                errorObject.action2 = $3fe9119940fa16b8$export$ada873a34909da65.onBackToShopPress;
                errorObject.labelAction2 = t("cc.error.page-action-back-to-partnershop");
                errorObject.hasFooterActionMessage = false;
                break;
            case 'GUCA3':
                errorObject.icon = $3fe9119940fa16b8$var$img$g;
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onCameraPermissionRequest;
                errorObject.labelAction1 = t("cc.error.page-action-start-again");
                errorObject.action2 = $3fe9119940fa16b8$export$ada873a34909da65.onBackToShopPress;
                errorObject.labelAction2 = t("cc.error.page-action-back-to-partnershop");
                errorObject.hasFooterActionMessage = false;
                break;
            case 'MEST1':
                errorObject.icon = $3fe9119940fa16b8$var$img$a;
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onMeasureAgainPress;
                errorObject.labelAction1 = t("cc.error.page-action-measure-again");
                break;
            case 'MEST2':
                errorObject.icon = $3fe9119940fa16b8$var$img$9;
                errorObject.centeredDesign = true;
                errorObject.isLongArrowVisible = true;
                errorObject.infoBox = $3fe9119940fa16b8$var$InfoBox.WithoutVideo;
                errorObject.messageInfoboxTransId = 'cc.error.page-MEST2-00-infobox';
                break;
            case 'MEST3':
                errorObject.icon = $3fe9119940fa16b8$var$img$b;
                errorObject.centeredDesign = true;
                errorObject.isTryToVisible = false;
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onMeasureAgainPress;
                errorObject.labelAction1 = t("cc.error.page-action-measure-again");
                break;
            case 'MEST4':
                errorObject.icon = $3fe9119940fa16b8$var$img$8;
                errorObject.centeredDesign = true;
                errorObject.isTryToVisible = false;
                errorObject.isFullSizeIcon = false;
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onMeasureAgainPress;
                errorObject.labelAction1 = t("cc.error.page-action-measure-again");
                break;
            case 'MEST5':
                errorObject.icon = $3fe9119940fa16b8$var$img$7;
                errorObject.centeredDesign = true;
                errorObject.isTryToVisible = false;
                errorObject.isFullSizeIcon = false;
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onMeasureAgainPress;
                errorObject.labelAction1 = t("cc.error.page-action-measure-again");
                break;
            case 'MECO1':
                errorObject.messageTitle = t("cc.error.page-".concat(errorObject.shortCode, "-").concat(foot == $3fe9119940fa16b8$var$Foot.LEFT ? 'left' : 'right', "-title"));
                errorObject.icon = $3fe9119940fa16b8$var$img$d;
                errorObject.centeredDesign = false;
                errorObject.isTryToVisible = true;
                errorObject.infoBox = $3fe9119940fa16b8$var$InfoBox.WithoutVideo;
                errorObject.messageInfoboxTransId = 'cc.error.page-MECO1-00-infobox';
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onMeasureAgainPress;
                errorObject.labelAction1 = t("cc.error.page-action-measure-again");
                break;
            case 'MECO2':
                errorObject.icon = $3fe9119940fa16b8$var$img$c;
                errorObject.centeredDesign = false;
                errorObject.isTryToVisible = true;
                errorObject.infoBox = $3fe9119940fa16b8$var$InfoBox.WithoutVideo;
                errorObject.messageInfoboxTransId = 'cc.error.page-MECO2-00-infobox';
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onMeasureAgainPress;
                errorObject.labelAction1 = t("cc.error.page-action-measure-again");
                break;
            case 'MEFR0':
                errorObject.messageTitle = t("cc.error.page-".concat(errorObject.shortCode, "-").concat(foot == $3fe9119940fa16b8$var$Foot.LEFT ? 'left' : 'right', "-title"));
                errorObject.videoUrl = "tut_for_error_page_".concat(ageGroup == $3fe9119940fa16b8$var$AgeGroup.ADULT ? 'adult' : 'child', "_").concat(foot == $3fe9119940fa16b8$var$Foot.LEFT ? 'left' : 'right', ".mp4");
                errorObject.icon = $3fe9119940fa16b8$var$img$b;
                errorObject.centeredDesign = false;
                errorObject.isTryToVisible = true;
                errorObject.infoBox = $3fe9119940fa16b8$var$InfoBox.WithVideo;
                errorObject.messageInfoboxTransId = 'cc.error.page-MEFR0-00-infobox';
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onMeasureAgainPress;
                errorObject.labelAction1 = t("cc.error.page-action-measure-again");
                break;
            case 'MAST1':
                errorObject.icon = $3fe9119940fa16b8$var$img$6;
                errorObject.centeredDesign = false;
                errorObject.infoBox = $3fe9119940fa16b8$var$InfoBox.WithoutVideo;
                errorObject.messageInfoboxTransId = 'cc.error.page-MAST1-00-infobox';
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onLetUsKnowPress;
                errorObject.labelAction1 = t("cc.error.page-action-let-us-know");
                errorObject.isFooterVisible = true;
                errorObject.action2 = $3fe9119940fa16b8$export$ada873a34909da65.onBackToShopPress;
                errorObject.labelAction2 = t("cc.error.page-action-back-to-partnershop");
                errorObject.messageFooter = t("cc.error.page-".concat(errorObject.shortCode, "-00-footer"));
                break;
            case 'MAST2':
                errorObject.icon = $3fe9119940fa16b8$var$img$5;
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onMeasureAgainPress;
                errorObject.labelAction1 = t("cc.error.page-action-measure-again");
                errorObject.isFooterVisible = true;
                errorObject.action2 = $3fe9119940fa16b8$export$ada873a34909da65.onBackToShopPress;
                errorObject.labelAction2 = t("cc.error.page-action-back-to-partnershop");
                errorObject.messageFooter = t("cc.error.page-".concat(errorObject.shortCode, "-00-footer"));
                break;
            case 'MADB1':
                errorObject.icon = $3fe9119940fa16b8$var$img$f;
                errorObject.isFooterVisible = true;
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onBackToShopPress;
                errorObject.labelAction1 = t("cc.error.page-action-back-to-partnershop");
                errorObject.action2 = $3fe9119940fa16b8$export$ada873a34909da65.onMeasureAgainPress;
                errorObject.labelAction2 = t("cc.error.page-action-measure-again");
                errorObject.hasFooterActionMessage = false;
                break;
            case 'MADB2':
                errorObject.icon = $3fe9119940fa16b8$var$img$e;
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onBackToShopPress;
                errorObject.infoBox = $3fe9119940fa16b8$var$InfoBox.NA;
                errorObject.labelAction1 = t("cc.error.page-action-back-to-partnershop");
                break;
            case 'MAVA1':
                errorObject.icon = $3fe9119940fa16b8$var$img$4;
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onMeasureAgainPress;
                errorObject.labelAction1 = t("cc.error.page-action-measure-again");
                errorObject.isFooterVisible = false;
                errorObject.messageFooter = t("cc.error.page-".concat(errorObject.shortCode, "-00-footer"));
                break;
            case 'WDAR1':
                errorObject.icon = $3fe9119940fa16b8$var$img$e;
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onBackToShopPress;
                errorObject.labelAction1 = t("cc.error.page-action-back-to-partnershop");
                errorObject.infoBox = $3fe9119940fa16b8$var$InfoBox.NA;
                errorObject.hasFooterActionMessage = false;
                errorObject.isFooterVisible = false;
                break;
            case 'BEDB1':
                errorObject.icon = $3fe9119940fa16b8$var$img$e;
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onBackToShopPress;
                errorObject.labelAction1 = t("cc.error.page-action-back-to-partnershop");
                errorObject.infoBox = $3fe9119940fa16b8$var$InfoBox.NA;
                errorObject.hasFooterActionMessage = false;
                errorObject.isFooterVisible = false;
                break;
            default:
                errorObject.messageTitle = "cc.error.page-GEN01-00-title";
                errorObject.messageBodyTransId = "cc.error.page-GEN01-00-body";
                errorObject.icon = $3fe9119940fa16b8$var$img$g;
                errorObject.action1 = $3fe9119940fa16b8$export$ada873a34909da65.onStartAgainPress;
                errorObject.labelAction1 = t("cc.error.page-action-start-again");
                errorObject.action2 = $3fe9119940fa16b8$export$ada873a34909da65.onBackToShopPress;
                errorObject.infoBox = $3fe9119940fa16b8$var$InfoBox.NA;
                errorObject.fullErrorCode = errorCode;
                errorObject.isFooterVisible = false;
        }
        return errorObject;
    };
    ErrorCodeParser.parseModule = function(moduleString) {
        switch(moduleString){
            case 'BE':
                return $3fe9119940fa16b8$var$Module.BE;
            case 'ME':
                return $3fe9119940fa16b8$var$Module.ME;
            case 'MA':
                return $3fe9119940fa16b8$var$Module.MA;
            case 'GU':
                return $3fe9119940fa16b8$var$Module.GU;
            case 'YU':
                return $3fe9119940fa16b8$var$Module.YU;
            default:
                return $3fe9119940fa16b8$var$Module.GE;
        }
    };
    ErrorCodeParser.parseErrorType = function(errorTypeString) {
        switch(errorTypeString){
            case 'ST':
                return $3fe9119940fa16b8$var$ErrorType.ST;
            case 'FR':
                return $3fe9119940fa16b8$var$ErrorType.FR;
            case 'CO':
                return $3fe9119940fa16b8$var$ErrorType.CO;
            case 'DB':
                return $3fe9119940fa16b8$var$ErrorType.DB;
            case 'CA':
                return $3fe9119940fa16b8$var$ErrorType.CA;
            case 'CA':
                return $3fe9119940fa16b8$var$ErrorType.CA;
            case 'R0':
                return $3fe9119940fa16b8$var$ErrorType.R0;
            default:
                return $3fe9119940fa16b8$var$ErrorType.NA;
        }
    };
    ErrorCodeParser.parseFoot = function(footString) {
        switch(footString){
            case 'R':
                return $3fe9119940fa16b8$var$Foot.RIGHT;
            case 'L':
                return $3fe9119940fa16b8$var$Foot.LEFT;
            default:
                return $3fe9119940fa16b8$var$Foot.NA;
        }
    };
    ErrorCodeParser.parseAge = function(ageString) {
        switch(ageString){
            case 'A':
                return $3fe9119940fa16b8$var$AgeGroup.ADULT;
            case 'C':
                return $3fe9119940fa16b8$var$AgeGroup.CHILD;
            default:
                return $3fe9119940fa16b8$var$AgeGroup.NA;
        }
    };
    return ErrorCodeParser;
}();
function $3fe9119940fa16b8$var$ErrorInfoBox(props) {
    var CDNurl = "https://cdn.footprinttech.de/assets/videos/".concat(props === null || props === void 0 ? void 0 : props.videoUrl);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "fpt-c-error-tooltip-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "fpt-c-error-message-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "fpt-c-error-tooltip-info-button-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("img", {
        className: "fpt-c-error-tooltip-info-button",
        src: $3fe9119940fa16b8$var$img$3
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "fpt-c-error-tooltip-message-container"
    }, (props === null || props === void 0 ? void 0 : props.isTryToVisible) && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "fpt-c-error-tooltip-message"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("b", null, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($3fe9119940fa16b8$var$Trans, {
        i18nKey: "cc.error.page-action-try-to"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "fpt-c-error-tooltip-message"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($3fe9119940fa16b8$var$Trans, {
        i18nKey: props === null || props === void 0 ? void 0 : props.message,
        components: [
            (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("b", null),
            (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("br", null)
        ]
    })), (props === null || props === void 0 ? void 0 : props.variant) == $3fe9119940fa16b8$var$InfoBox.WithVideo && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "fpt-c-error-wrappper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("video", {
        id: "tutVideo",
        autoPlay: true,
        loop: true,
        playsInline: true,
        muted: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("source", {
        src: CDNurl,
        type: "video/mp4"
    })))))), (props === null || props === void 0 ? void 0 : props.isLongArrowVisible) && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("img", {
        className: "fpt-c-error-tooltip-long-arrow",
        src: $3fe9119940fa16b8$var$img$1
    }));
}
let $3fe9119940fa16b8$var$e = {
    data: ""
}, $3fe9119940fa16b8$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $3fe9119940fa16b8$var$e, $3fe9119940fa16b8$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $3fe9119940fa16b8$var$a = /\/\*[^]*?\*\/|  +/g, $3fe9119940fa16b8$var$n$1 = /\n+/g, $3fe9119940fa16b8$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $3fe9119940fa16b8$var$o(c, n) : n + "{" + $3fe9119940fa16b8$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $3fe9119940fa16b8$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $3fe9119940fa16b8$var$o.p ? $3fe9119940fa16b8$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $3fe9119940fa16b8$var$c = {}, $3fe9119940fa16b8$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $3fe9119940fa16b8$var$s(e[r]);
        return t;
    }
    return e;
}, $3fe9119940fa16b8$var$i = (e, t, r, i, p)=>{
    let u = $3fe9119940fa16b8$var$s(e), d = $3fe9119940fa16b8$var$c[u] || ($3fe9119940fa16b8$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$3fe9119940fa16b8$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $3fe9119940fa16b8$var$l.exec(e.replace($3fe9119940fa16b8$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($3fe9119940fa16b8$var$n$1, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($3fe9119940fa16b8$var$n$1, " ").trim();
            return o[0];
        })(e);
        $3fe9119940fa16b8$var$c[d] = $3fe9119940fa16b8$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $3fe9119940fa16b8$var$c.g ? $3fe9119940fa16b8$var$c.g : null;
    return r && ($3fe9119940fa16b8$var$c.g = $3fe9119940fa16b8$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($3fe9119940fa16b8$var$c[d], t, i, f), d;
}, $3fe9119940fa16b8$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $3fe9119940fa16b8$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $3fe9119940fa16b8$var$u$1(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $3fe9119940fa16b8$var$i(l.unshift ? l.raw ? $3fe9119940fa16b8$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $3fe9119940fa16b8$var$t(r.target), r.g, r.o, r.k);
}
let $3fe9119940fa16b8$var$d, $3fe9119940fa16b8$var$f, $3fe9119940fa16b8$var$g;
$3fe9119940fa16b8$var$u$1.bind({
    g: 1
});
let $3fe9119940fa16b8$var$h$1 = $3fe9119940fa16b8$var$u$1.bind({
    k: 1
});
function $3fe9119940fa16b8$var$m(e, t, r, l) {
    $3fe9119940fa16b8$var$o.p = t, $3fe9119940fa16b8$var$d = e, $3fe9119940fa16b8$var$f = r, $3fe9119940fa16b8$var$g = l;
}
function $3fe9119940fa16b8$var$j(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $3fe9119940fa16b8$var$f && $3fe9119940fa16b8$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $3fe9119940fa16b8$var$u$1.apply(r, l) + (s ? " " + s : "");
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $3fe9119940fa16b8$var$g && i[0] && $3fe9119940fa16b8$var$g(c), $3fe9119940fa16b8$var$d(i, c);
        }
        return a;
    };
}
var $3fe9119940fa16b8$var$W = (e)=>typeof e == "function", $3fe9119940fa16b8$var$T = (e, t)=>$3fe9119940fa16b8$var$W(e) ? e(t) : e;
var $3fe9119940fa16b8$var$U = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $3fe9119940fa16b8$var$b = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();
var $3fe9119940fa16b8$var$Q = 20;
var $3fe9119940fa16b8$var$S = new Map, $3fe9119940fa16b8$var$X = 1e3, $3fe9119940fa16b8$var$$ = (e)=>{
    if ($3fe9119940fa16b8$var$S.has(e)) return;
    let t = setTimeout(()=>{
        $3fe9119940fa16b8$var$S.delete(e), $3fe9119940fa16b8$var$u({
            type: 4,
            toastId: e
        });
    }, $3fe9119940fa16b8$var$X);
    $3fe9119940fa16b8$var$S.set(e, t);
}, $3fe9119940fa16b8$var$J = (e)=>{
    let t = $3fe9119940fa16b8$var$S.get(e);
    t && clearTimeout(t);
}, $3fe9119940fa16b8$var$v = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, $3fe9119940fa16b8$var$Q)
            };
        case 1:
            return t.toast.id && $3fe9119940fa16b8$var$J(t.toast.id), {
                ...e,
                toasts: e.toasts.map((r)=>r.id === t.toast.id ? {
                        ...r,
                        ...t.toast
                    } : r)
            };
        case 2:
            let { toast: o } = t;
            return e.toasts.find((r)=>r.id === o.id) ? $3fe9119940fa16b8$var$v(e, {
                type: 1,
                toast: o
            }) : $3fe9119940fa16b8$var$v(e, {
                type: 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return s ? $3fe9119940fa16b8$var$$(s) : e.toasts.forEach((r)=>{
                $3fe9119940fa16b8$var$$(r.id);
            }), {
                ...e,
                toasts: e.toasts.map((r)=>r.id === s || s === void 0 ? {
                        ...r,
                        visible: !1
                    } : r)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((r)=>r.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let a = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((r)=>({
                        ...r,
                        pauseDuration: r.pauseDuration + a
                    }))
            };
    }
}, $3fe9119940fa16b8$var$A = [], $3fe9119940fa16b8$var$P = {
    toasts: [],
    pausedAt: void 0
}, $3fe9119940fa16b8$var$u = (e)=>{
    $3fe9119940fa16b8$var$P = $3fe9119940fa16b8$var$v($3fe9119940fa16b8$var$P, e), $3fe9119940fa16b8$var$A.forEach((t)=>{
        t($3fe9119940fa16b8$var$P);
    });
}, $3fe9119940fa16b8$var$Y = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $3fe9119940fa16b8$var$I = (e = {})=>{
    let [t, o] = (0, $6cds3.useState)($3fe9119940fa16b8$var$P);
    (0, $6cds3.useEffect)(()=>($3fe9119940fa16b8$var$A.push(o), ()=>{
            let a = $3fe9119940fa16b8$var$A.indexOf(o);
            a > -1 && $3fe9119940fa16b8$var$A.splice(a, 1);
        }), [
        t
    ]);
    let s = t.toasts.map((a)=>{
        var r, c;
        return {
            ...e,
            ...e[a.type],
            ...a,
            duration: a.duration || ((r = e[a.type]) == null ? void 0 : r.duration) || (e == null ? void 0 : e.duration) || $3fe9119940fa16b8$var$Y[a.type],
            style: {
                ...e.style,
                ...(c = e[a.type]) == null ? void 0 : c.style,
                ...a.style
            }
        };
    });
    return {
        ...t,
        toasts: s
    };
};
var $3fe9119940fa16b8$var$G = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $3fe9119940fa16b8$var$U()
    }), $3fe9119940fa16b8$var$h = (e)=>(t, o)=>{
        let s = $3fe9119940fa16b8$var$G(t, e, o);
        return $3fe9119940fa16b8$var$u({
            type: 2,
            toast: s
        }), s.id;
    }, $3fe9119940fa16b8$var$n = (e, t)=>$3fe9119940fa16b8$var$h("blank")(e, t);
$3fe9119940fa16b8$var$n.error = $3fe9119940fa16b8$var$h("error");
$3fe9119940fa16b8$var$n.success = $3fe9119940fa16b8$var$h("success");
$3fe9119940fa16b8$var$n.loading = $3fe9119940fa16b8$var$h("loading");
$3fe9119940fa16b8$var$n.custom = $3fe9119940fa16b8$var$h("custom");
$3fe9119940fa16b8$var$n.dismiss = (e)=>{
    $3fe9119940fa16b8$var$u({
        type: 3,
        toastId: e
    });
};
$3fe9119940fa16b8$var$n.remove = (e)=>$3fe9119940fa16b8$var$u({
        type: 4,
        toastId: e
    });
$3fe9119940fa16b8$var$n.promise = (e, t, o)=>{
    let s = $3fe9119940fa16b8$var$n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return e.then((a)=>($3fe9119940fa16b8$var$n.success($3fe9119940fa16b8$var$T(t.success, a), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }), a)).catch((a)=>{
        $3fe9119940fa16b8$var$n.error($3fe9119940fa16b8$var$T(t.error, a), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        });
    }), e;
};
var $3fe9119940fa16b8$var$Z = (e, t)=>{
    $3fe9119940fa16b8$var$u({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, $3fe9119940fa16b8$var$ee = ()=>{
    $3fe9119940fa16b8$var$u({
        type: 5,
        time: Date.now()
    });
}, $3fe9119940fa16b8$var$D = (e)=>{
    let { toasts: t, pausedAt: o } = $3fe9119940fa16b8$var$I(e);
    (0, $6cds3.useEffect)(()=>{
        if (o) return;
        let r = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let d = (i.duration || 0) + i.pauseDuration - (r - i.createdAt);
            if (d < 0) {
                i.visible && $3fe9119940fa16b8$var$n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>$3fe9119940fa16b8$var$n.dismiss(i.id), d);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, $6cds3.useCallback)(()=>{
        o && $3fe9119940fa16b8$var$u({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), a = (0, $6cds3.useCallback)((r, c)=>{
        let { reverseOrder: i = !1, gutter: d = 8, defaultPosition: p } = c || {}, g = t.filter((m)=>(m.position || p) === (r.position || p) && m.height), E = g.findIndex((m)=>m.id === r.id), x = g.filter((m, R)=>R < E && m.visible).length;
        return g.filter((m)=>m.visible).slice(...i ? [
            x + 1
        ] : [
            0,
            x
        ]).reduce((m, R)=>m + (R.height || 0) + d, 0);
    }, [
        t
    ]);
    return {
        toasts: t,
        handlers: {
            updateHeight: $3fe9119940fa16b8$var$Z,
            startPause: $3fe9119940fa16b8$var$ee,
            endPause: s,
            calculateOffset: a
        }
    };
};
var $3fe9119940fa16b8$var$oe = $3fe9119940fa16b8$var$h$1`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $3fe9119940fa16b8$var$re = $3fe9119940fa16b8$var$h$1`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $3fe9119940fa16b8$var$se = $3fe9119940fa16b8$var$h$1`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $3fe9119940fa16b8$var$_ = $3fe9119940fa16b8$var$j("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$3fe9119940fa16b8$var$oe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$3fe9119940fa16b8$var$re} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$3fe9119940fa16b8$var$se} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;
var $3fe9119940fa16b8$var$ne = $3fe9119940fa16b8$var$h$1`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $3fe9119940fa16b8$var$V = $3fe9119940fa16b8$var$j("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$3fe9119940fa16b8$var$ne} 1s linear infinite;
`;
var $3fe9119940fa16b8$var$pe = $3fe9119940fa16b8$var$h$1`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $3fe9119940fa16b8$var$de = $3fe9119940fa16b8$var$h$1`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $3fe9119940fa16b8$var$w = $3fe9119940fa16b8$var$j("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$3fe9119940fa16b8$var$pe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$3fe9119940fa16b8$var$de} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $3fe9119940fa16b8$var$ue = $3fe9119940fa16b8$var$j("div")`
  position: absolute;
`, $3fe9119940fa16b8$var$le = $3fe9119940fa16b8$var$j("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $3fe9119940fa16b8$var$Te = $3fe9119940fa16b8$var$h$1`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $3fe9119940fa16b8$var$fe = $3fe9119940fa16b8$var$j("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$3fe9119940fa16b8$var$Te} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $3fe9119940fa16b8$var$M = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $6cds3.createElement($3fe9119940fa16b8$var$fe, null, t) : t : o === "blank" ? null : $6cds3.createElement($3fe9119940fa16b8$var$le, null, $6cds3.createElement($3fe9119940fa16b8$var$V, {
        ...s
    }), o !== "loading" && $6cds3.createElement($3fe9119940fa16b8$var$ue, null, o === "error" ? $6cds3.createElement($3fe9119940fa16b8$var$_, {
        ...s
    }) : $6cds3.createElement($3fe9119940fa16b8$var$w, {
        ...s
    })));
};
var $3fe9119940fa16b8$var$ye = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $3fe9119940fa16b8$var$ge = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $3fe9119940fa16b8$var$he = "0%{opacity:0;} 100%{opacity:1;}", $3fe9119940fa16b8$var$xe = "0%{opacity:1;} 100%{opacity:0;}", $3fe9119940fa16b8$var$be = $3fe9119940fa16b8$var$j("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $3fe9119940fa16b8$var$Se = $3fe9119940fa16b8$var$j("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $3fe9119940fa16b8$var$Ae = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [a, r] = $3fe9119940fa16b8$var$b() ? [
        $3fe9119940fa16b8$var$he,
        $3fe9119940fa16b8$var$xe
    ] : [
        $3fe9119940fa16b8$var$ye(s),
        $3fe9119940fa16b8$var$ge(s)
    ];
    return {
        animation: t ? `${$3fe9119940fa16b8$var$h$1(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${$3fe9119940fa16b8$var$h$1(r)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $3fe9119940fa16b8$var$F = $6cds3.memo(({ toast: e, position: t, style: o, children: s })=>{
    let a = e.height ? $3fe9119940fa16b8$var$Ae(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, r = $6cds3.createElement($3fe9119940fa16b8$var$M, {
        toast: e
    }), c = $6cds3.createElement($3fe9119940fa16b8$var$Se, {
        ...e.ariaProps
    }, $3fe9119940fa16b8$var$T(e.message, e));
    return $6cds3.createElement($3fe9119940fa16b8$var$be, {
        className: e.className,
        style: {
            ...a,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: r,
        message: c
    }) : $6cds3.createElement($6cds3.Fragment, null, r, c));
});
$3fe9119940fa16b8$var$m($6cds3.createElement);
var $3fe9119940fa16b8$var$Ee = ({ id: e, className: t, style: o, onHeightUpdate: s, children: a })=>{
    let r = $6cds3.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let d = c.getBoundingClientRect().height;
                s(e, d);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $6cds3.createElement("div", {
        ref: r,
        className: t,
        style: o
    }, a);
}, $3fe9119940fa16b8$var$Re = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, a = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $3fe9119940fa16b8$var$b() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...a
    };
}, $3fe9119940fa16b8$var$ve = $3fe9119940fa16b8$var$u$1`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $3fe9119940fa16b8$var$O = 16, $3fe9119940fa16b8$var$Ie = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: a, containerStyle: r, containerClassName: c })=>{
    let { toasts: i, handlers: d } = $3fe9119940fa16b8$var$D(o);
    return $6cds3.createElement("div", {
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $3fe9119940fa16b8$var$O,
            left: $3fe9119940fa16b8$var$O,
            right: $3fe9119940fa16b8$var$O,
            bottom: $3fe9119940fa16b8$var$O,
            pointerEvents: "none",
            ...r
        },
        className: c,
        onMouseEnter: d.startPause,
        onMouseLeave: d.endPause
    }, i.map((p)=>{
        let g = p.position || t, E = d.calculateOffset(p, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), x = $3fe9119940fa16b8$var$Re(g, E);
        return $6cds3.createElement($3fe9119940fa16b8$var$Ee, {
            id: p.id,
            key: p.id,
            onHeightUpdate: d.updateHeight,
            className: p.visible ? $3fe9119940fa16b8$var$ve : "",
            style: x
        }, p.type === "custom" ? $3fe9119940fa16b8$var$T(p.message, p) : a ? a(p) : $6cds3.createElement($3fe9119940fa16b8$var$F, {
            toast: p,
            position: g
        }));
    }));
};
var $3fe9119940fa16b8$var$fptCActionsButtonContainerStyle = {
    fontFamily: 'Inter500',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    width: '100%',
    alignItems: 'center',
    height: '25%'
};
var $3fe9119940fa16b8$var$ErrorActions = function(_a) {
    var actionOrder = _a.actionOrder, action = _a.action, actionText = _a.actionText, emitter = _a.emitter;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($3fe9119940fa16b8$var$Ie, null)), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        style: $3fe9119940fa16b8$var$fptCActionsButtonContainerStyle,
        className: "fpt-c-actions-button-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($3fe9119940fa16b8$export$353f5b6fc5456de1, {
        variant: actionOrder == 1 ? 'wide-primary-round' : 'link-primary',
        onClick: function() {
            return emitter.emit(action);
        }
    }, actionText)));
};
var $3fe9119940fa16b8$var$img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='47.397' height='33.322' viewBox='0 0 47.397 33.322'%3e %3cdefs%3e %3cstyle%3e .cls-1 %7b fill: %231e4e5f%3b %7d %3c/style%3e %3c/defs%3e %3cg id='Gruppe_6332' data-name='Gruppe 6332' transform='translate(-255.715 -174.865)'%3e %3cpath id='Pfad_520' data-name='Pfad 520' class='cls-1' d='M269.374%2c190.752l4.112%2c4.112-1.888%2c1.888a5.784%2c5.784%2c0%2c0%2c1-8.182%2c0l-6.006-6a5.787%2c5.787%2c0%2c0%2c1%2c0-8.182l6.006-6.006a5.787%2c5.787%2c0%2c0%2c1%2c8.182%2c0l1.894%2c1.894-4.118%2c4.116A5.787%2c5.787%2c0%2c0%2c0%2c269.374%2c190.752Z' transform='translate(0 0)'/%3e %3cpath id='Pfad_521' data-name='Pfad 521' class='cls-1' d='M480.6%2c190.868l-6.006%2c6.006a5.787%2c5.787%2c0%2c0%2c1-8.182%2c0l-1.84-1.841%2c4.177-4.177a5.784%2c5.784%2c0%2c0%2c0%2c0-8.182l-4.164-4.164%2c1.827-1.829a5.787%2c5.787%2c0%2c0%2c1%2c8.182%2c0l6.006%2c6.006A5.787%2c5.787%2c0%2c0%2c1%2c480.6%2c190.868Z' transform='translate(-179.181 -0.103)'/%3e %3cg id='Gruppe_6288' data-name='Gruppe 6288' transform='translate(255.933 202.969)'%3e %3cg id='Gruppe_6287' data-name='Gruppe 6287' transform='translate(0 0)'%3e %3cpath id='Pfad_522' data-name='Pfad 522' class='cls-1' d='M257.446%2c378.244a.19.19%2c0%2c0%2c1-.138-.058.188.188%2c0%2c0%2c1-.058-.138v-4.682a.19.19%2c0%2c0%2c1%2c.058-.138.188.188%2c0%2c0%2c1%2c.138-.058H261.1a.2.2%2c0%2c0%2c1%2c.2.2v1.1a.188.188%2c0%2c0%2c1-.058.138.19.19%2c0%2c0%2c1-.138.058h-2.073v.536h1.928a.19.19%2c0%2c0%2c1%2c.138.058.188.188%2c0%2c0%2c1%2c.058.138v1.094a.2.2%2c0%2c0%2c1-.2.2h-1.928v1.363a.2.2%2c0%2c0%2c1-.2.2Z' transform='translate(-257.25 -373.099)'/%3e %3cpath id='Pfad_523' data-name='Pfad 523' class='cls-1' d='M296.748%2c377.887a3.277%2c3.277%2c0%2c0%2c1-1.243-.217%2c1.86%2c1.86%2c0%2c0%2c1-.841-.656%2c1.988%2c1.988%2c0%2c0%2c1-.337-1.083c0-.2-.007-.408-.007-.631s0-.438.007-.645a2.032%2c2.032%2c0%2c0%2c1%2c.334-1.08%2c1.921%2c1.921%2c0%2c0%2c1%2c.841-.673%2c3.468%2c3.468%2c0%2c0%2c1%2c2.492%2c0%2c1.938%2c1.938%2c0%2c0%2c1%2c.844.673%2c1.967%2c1.967%2c0%2c0%2c1%2c.33%2c1.08c.01.207.014.423.014.645s0%2c.432-.014.631a2%2c2%2c0%2c0%2c1-.337%2c1.083%2c1.86%2c1.86%2c0%2c0%2c1-.841.656A3.264%2c3.264%2c0%2c0%2c1%2c296.748%2c377.887Zm0-1.412a.522.522%2c0%2c0%2c0%2c.384-.142.619.619%2c0%2c0%2c0%2c.152-.446c.01-.207.014-.413.014-.615s0-.4-.014-.6a.757.757%2c0%2c0%2c0-.077-.334.447.447%2c0%2c0%2c0-.185-.192.576.576%2c0%2c0%2c0-.276-.061.582.582%2c0%2c0%2c0-.271.061.448.448%2c0%2c0%2c0-.189.192.787.787%2c0%2c0%2c0-.077.334c0%2c.2-.007.4-.007.6s0%2c.408.007.615a.655.655%2c0%2c0%2c0%2c.156.446A.517.517%2c0%2c0%2c0%2c296.748%2c376.475Z' transform='translate(-289.053 -372.67)'/%3e %3cpath id='Pfad_524' data-name='Pfad 524' class='cls-1' d='M339.688%2c377.887a3.277%2c3.277%2c0%2c0%2c1-1.243-.217%2c1.86%2c1.86%2c0%2c0%2c1-.841-.656%2c1.988%2c1.988%2c0%2c0%2c1-.337-1.083c0-.2-.007-.408-.007-.631s0-.438.007-.645a2.032%2c2.032%2c0%2c0%2c1%2c.334-1.08%2c1.921%2c1.921%2c0%2c0%2c1%2c.841-.673%2c3.468%2c3.468%2c0%2c0%2c1%2c2.492%2c0%2c1.937%2c1.937%2c0%2c0%2c1%2c.844.673%2c1.967%2c1.967%2c0%2c0%2c1%2c.33%2c1.08c.01.207.014.423.014.645s0%2c.432-.014.631a2%2c2%2c0%2c0%2c1-.337%2c1.083%2c1.86%2c1.86%2c0%2c0%2c1-.841.656A3.26%2c3.26%2c0%2c0%2c1%2c339.688%2c377.887Zm0-1.412a.522.522%2c0%2c0%2c0%2c.384-.142.619.619%2c0%2c0%2c0%2c.152-.446c.01-.207.014-.413.014-.615s0-.4-.014-.6a.757.757%2c0%2c0%2c0-.077-.334.447.447%2c0%2c0%2c0-.185-.192.576.576%2c0%2c0%2c0-.276-.061.582.582%2c0%2c0%2c0-.271.061.448.448%2c0%2c0%2c0-.189.192.788.788%2c0%2c0%2c0-.077.334c0%2c.2-.007.4-.007.6s0%2c.408.007.615a.655.655%2c0%2c0%2c0%2c.156.446A.517.517%2c0%2c0%2c0%2c339.688%2c376.475Z' transform='translate(-325.892 -372.67)'/%3e %3cpath id='Pfad_525' data-name='Pfad 525' class='cls-1' d='M380.826%2c378.244a.19.19%2c0%2c0%2c1-.138-.058.188.188%2c0%2c0%2c1-.058-.138v-3.319h-1.2a.185.185%2c0%2c0%2c1-.138-.058.188.188%2c0%2c0%2c1-.058-.138v-1.166a.19.19%2c0%2c0%2c1%2c.058-.138.188.188%2c0%2c0%2c1%2c.138-.058h4.247a.2.2%2c0%2c0%2c1%2c.2.2v1.166a.188.188%2c0%2c0%2c1-.058.138.19.19%2c0%2c0%2c1-.138.058h-1.2v3.319a.2.2%2c0%2c0%2c1-.2.2Z' transform='translate(-361.899 -373.099)'/%3e %3cpath id='Pfad_526' data-name='Pfad 526' class='cls-1' d='M421.995%2c378.244a.175.175%2c0%2c0%2c1-.175-.175v-4.717a.178.178%2c0%2c0%2c1%2c.051-.131.168.168%2c0%2c0%2c1%2c.124-.051h1.942a2.535%2c2.535%2c0%2c0%2c1%2c.986.178%2c1.407%2c1.407%2c0%2c0%2c1%2c.652.536%2c1.613%2c1.613%2c0%2c0%2c1%2c.232.9%2c1.593%2c1.593%2c0%2c0%2c1-.232.9%2c1.405%2c1.405%2c0%2c0%2c1-.652.526%2c2.553%2c2.553%2c0%2c0%2c1-.986.173h-1.08v1.7a.176.176%2c0%2c0%2c1-.047.124.164.164%2c0%2c0%2c1-.126.051h-.689Zm.848-2.674H423.9a.947.947%2c0%2c0%2c0%2c.645-.2.749.749%2c0%2c0%2c0%2c.224-.591.811.811%2c0%2c0%2c0-.21-.584.871.871%2c0%2c0%2c0-.659-.222h-1.059v1.6Z' transform='translate(-398.438 -373.099)'/%3e %3cpath id='Pfad_527' data-name='Pfad 527' class='cls-1' d='M460.7%2c378.244a.175.175%2c0%2c0%2c1-.175-.175v-4.717a.178.178%2c0%2c0%2c1%2c.051-.131.169.169%2c0%2c0%2c1%2c.124-.051h1.877a2.152%2c2.152%2c0%2c0%2c1%2c1.384.406%2c1.423%2c1.423%2c0%2c0%2c1%2c.507%2c1.181%2c1.447%2c1.447%2c0%2c0%2c1-.264.891%2c1.485%2c1.485%2c0%2c0%2c1-.706.514l1.059%2c1.847a.181.181%2c0%2c0%2c1%2c.021.08.144.144%2c0%2c0%2c1-.047.109.155.155%2c0%2c0%2c1-.105.044h-.659a.255.255%2c0%2c0%2c1-.189-.065.58.58%2c0%2c0%2c1-.1-.131l-.935-1.718h-1.007v1.739a.177.177%2c0%2c0%2c1-.047.124.164.164%2c0%2c0%2c1-.126.051H460.7Zm.833-2.731h1.022a.953.953%2c0%2c0%2c0%2c.659-.2.722.722%2c0%2c0%2c0%2c.217-.561.754.754%2c0%2c0%2c0-.213-.568.924.924%2c0%2c0%2c0-.664-.206h-1.022Z' transform='translate(-431.648 -373.099)'/%3e %3cpath id='Pfad_528' data-name='Pfad 528' class='cls-1' d='M500.125%2c378.244a.175.175%2c0%2c0%2c1-.175-.175v-4.724a.175.175%2c0%2c0%2c1%2c.175-.175h.681a.164.164%2c0%2c0%2c1%2c.126.051.176.176%2c0%2c0%2c1%2c.047.124v4.724a.176.176%2c0%2c0%2c1-.047.124.164.164%2c0%2c0%2c1-.126.051Z' transform='translate(-465.467 -373.099)'/%3e %3cpath id='Pfad_529' data-name='Pfad 529' class='cls-1' d='M520.475%2c378.235a.175.175%2c0%2c0%2c1-.175-.175v-4.717a.178.178%2c0%2c0%2c1%2c.051-.131.169.169%2c0%2c0%2c1%2c.124-.051h.558a.207.207%2c0%2c0%2c1%2c.149.047.483.483%2c0%2c0%2c1%2c.061.068l2.087%2c3.247v-3.181a.187.187%2c0%2c0%2c1%2c.047-.131.164.164%2c0%2c0%2c1%2c.126-.051h.608a.178.178%2c0%2c0%2c1%2c.131.051.175.175%2c0%2c0%2c1%2c.051.131v4.71a.175.175%2c0%2c0%2c1-.051.131.168.168%2c0%2c0%2c1-.124.051h-.565a.179.179%2c0%2c0%2c1-.145-.051.387.387%2c0%2c0%2c0-.065-.065l-2.08-3.174v3.116a.168.168%2c0%2c0%2c1-.051.124.176.176%2c0%2c0%2c1-.131.051h-.607Z' transform='translate(-482.925 -373.09)'/%3e %3cpath id='Pfad_530' data-name='Pfad 530' class='cls-1' d='M560.339%2c378.244a.175.175%2c0%2c0%2c1-.175-.175v-4.007h-1.34a.175.175%2c0%2c0%2c1-.175-.175v-.536a.178.178%2c0%2c0%2c1%2c.051-.131.168.168%2c0%2c0%2c1%2c.124-.051h3.7a.178.178%2c0%2c0%2c1%2c.131.051.176.176%2c0%2c0%2c1%2c.051.131v.536a.168.168%2c0%2c0%2c1-.051.124.175.175%2c0%2c0%2c1-.131.051h-1.333v4.007a.168.168%2c0%2c0%2c1-.051.124.175.175%2c0%2c0%2c1-.131.051Z' transform='translate(-515.827 -373.099)'/%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var $3fe9119940fa16b8$export$a06f1c675e846f6f = function(_a) {
    var showLogo = _a.showLogo, showLinks = _a.showLinks;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "fpt-c-footer-container"
    }, showLogo && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("p", null, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("img", {
        src: $3fe9119940fa16b8$var$img,
        alt: "logo"
    })), showLinks && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("p", {
        className: "fpt-c-link-p"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("a", {
        href: "https://footprinttech.de/privacy-policy-webapp/",
        target: "_blank",
        className: "fpt-c-link-text"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($3fe9119940fa16b8$var$Trans, {
        i18nKey: "common.privacyPolicy"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("p", {
        className: "fpt-c-link-p"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("a", {
        href: "https://footprinttech.de/imprint-webapp/",
        target: "_blank",
        className: "fpt-c-link-text"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($3fe9119940fa16b8$var$Trans, {
        i18nKey: "common.imprint"
    })))));
};
var $3fe9119940fa16b8$export$9f3dc18e1adf5d8f = function(props) {
    var errorObject = $3fe9119940fa16b8$var$ErrorCodeParser.parseErrorCode((props === null || props === void 0 ? void 0 : props.code) !== undefined ? props.code : 'YUR04-00');
    var emitter = props.emitter, showFooter = props.showFooter;
    var hide = {
        display: 'none'
    };
    var show = {
        display: 'block',
        textAlign: 'center'
    };
    var footerStyle = (props === null || props === void 0 ? void 0 : props.code) === 'A404' ? hide : show;
    var fptCErrorEmptySpaceStyle = {
        "height": "100%"
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($3fe9119940fa16b8$var$ErrorHeader, {
        titleTransId: errorObject.messageTitle,
        subTitleTransId: errorObject.messageBodyTransId,
        pageAlignment: errorObject.centeredDesign ? 'fpt-c-error-centered' : '',
        errorIcon: errorObject.icon,
        errorCode: errorObject.fullErrorCode,
        isFullSizeIcon: errorObject.isFullSizeIcon
    }), errorObject.infoBox != $3fe9119940fa16b8$var$InfoBox.NA && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($3fe9119940fa16b8$var$ErrorInfoBox, {
        message: errorObject.messageInfoboxTransId,
        isLongArrowVisible: errorObject.isLongArrowVisible,
        videoUrl: errorObject.videoUrl,
        isTryToVisible: errorObject.isTryToVisible,
        variant: errorObject.infoBox
    }), errorObject.infoBox == $3fe9119940fa16b8$var$InfoBox.NA && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "fpt-c-error-empty-space"
    }), errorObject.action1 && !props.hideAction && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($3fe9119940fa16b8$var$ErrorActions, {
        source: props === null || props === void 0 ? void 0 : props.source,
        code: props === null || props === void 0 ? void 0 : props.code,
        actionOrder: 1,
        actionText: errorObject.labelAction1,
        action: errorObject.action1,
        constr: {
            width: 1920,
            ratio: 1.5
        },
        emitter: emitter
    }), errorObject.isFooterVisible && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "fpt-c-error-footer-message",
        style: footerStyle
    }, errorObject.hasFooterActionMessage && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("p", null, errorObject.messageFooter), errorObject.action2 && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($3fe9119940fa16b8$var$ErrorActions, {
        source: props === null || props === void 0 ? void 0 : props.source,
        code: props === null || props === void 0 ? void 0 : props.code,
        actionOrder: 2,
        actionText: errorObject.labelAction2,
        action: errorObject.action2,
        constr: {
            width: 1920,
            ratio: 1.5
        },
        emitter: emitter
    })), showFooter && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        style: fptCErrorEmptySpaceStyle,
        className: "fpt-c-error-empty-space"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($3fe9119940fa16b8$export$a06f1c675e846f6f, {
        showLinks: true,
        showLogo: true
    })));
};
var $3fe9119940fa16b8$export$65db35c377fab04b = function(props) {
    var emitter = props.emitter;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "fpt-c-error-page-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "fpt-c-error-page"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($3fe9119940fa16b8$export$9f3dc18e1adf5d8f, {
        code: props === null || props === void 0 ? void 0 : props.code,
        emitter: emitter,
        source: props === null || props === void 0 ? void 0 : props.source,
        hideAction: props === null || props === void 0 ? void 0 : props.hideAction,
        showFooter: true
    })));
};
var $3fe9119940fa16b8$var$languageDetector = new $3fe9119940fa16b8$export$36df6eadd61c72e4();
var $3fe9119940fa16b8$var$lang = $3fe9119940fa16b8$var$languageDetector.Detect();
var $3fe9119940fa16b8$var$convertedLang = $3fe9119940fa16b8$var$lang === null || $3fe9119940fa16b8$var$lang === void 0 ? void 0 : $3fe9119940fa16b8$var$lang.toLowerCase().split('-')[0];
var $3fe9119940fa16b8$var$i18nOptions = {
    fallbackLng: $3fe9119940fa16b8$var$convertedLang === 'de' || $3fe9119940fa16b8$var$convertedLang === 'en' || $3fe9119940fa16b8$var$convertedLang === 'ja' || $3fe9119940fa16b8$var$convertedLang === 'fr' || $3fe9119940fa16b8$var$convertedLang === 'tr' || $3fe9119940fa16b8$var$convertedLang === 'pl' ? $3fe9119940fa16b8$var$convertedLang : 'en',
    backend: {
        loadPath: 'https://cdn.footprinttech.de/assets/locales/{{lng}}/messages.json'
    },
    react: {
        bindI18n: 'languageChanged',
        bindI18nStore: '',
        transEmptyNodeValue: '',
        transSupportBasicHtmlNodes: true,
        transKeepBasicHtmlNodesFor: [
            'br',
            'strong',
            'i'
        ],
        useSuspense: true
    }
};
$3fe9119940fa16b8$export$a7357cdd1f0b0168.use($3fe9119940fa16b8$var$Backend).use($3fe9119940fa16b8$var$initReactI18next).init($3fe9119940fa16b8$var$i18nOptions);





const $0b11f2d6029c41cf$var$Text = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).p.withConfig({
    displayName: "AvailableOptions__Text",
    componentId: "sc-fiaabr-0"
})([
    "line-height:1.82;font-size:11px;font-family:Inter,sans-serif;font-weight:500;margin-top:20px;color:",
    " !important & a{color:",
    " !important;font-size:10px;font-family:SourceSans3,sans-serif;text-decoration:underline;}& a:any-link{color:",
    ";font-size:10px;font-family:SourceSans3,sans-serif;text-decoration:underline;}& a:-webkit-any-link{color:",
    ";font-size:10px;font-family:SourceSans3,sans-serif;text-decoration:underline;}"
], (0, $4bd05a80e138995f$export$e07b43e05432e0e3), (0, $4bd05a80e138995f$export$e07b43e05432e0e3), (0, $4bd05a80e138995f$export$e07b43e05432e0e3), (0, $4bd05a80e138995f$export$e07b43e05432e0e3));
function $0b11f2d6029c41cf$export$979339cc64681521(props) {
    const { matching: matching, emitter: emitter, hasPiFrames: hasPiFrames } = props;
    const handleMatching = (e)=>{
        e.nativeEvent.stopImmediatePropagation();
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Handle Matching called ${matching}`);
        (0, $2bf83c5cdc6d49ab$export$de3e1d2ea3b4fd9b).close();
        emitter.emit((0, $7c8d586ac16018dc$export$2e2bcd8739ae039).onAddToCartPress, matching);
    };
    const handleNewMeasurement = (e)=>{
        e.nativeEvent.stopImmediatePropagation();
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Handle New Measurement called');
        (0, $2bf83c5cdc6d49ab$export$de3e1d2ea3b4fd9b).close();
        emitter.emit((0, $3fe9119940fa16b8$export$ada873a34909da65).onMeasureAgainPress);
    };
    const handlePiReconstructionRequest = (e)=>{
        e.nativeEvent.stopImmediatePropagation();
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Handle Pi Reconstruction called');
        (0, $2bf83c5cdc6d49ab$export$de3e1d2ea3b4fd9b).close();
        emitter.emit((0, $7c8d586ac16018dc$export$2e2bcd8739ae039).onPiReconstructionRequest);
    };
    (0, $6cds3.useEffect)(()=>{
        (0, $f188c4e754268d8b$export$2e2bcd8739ae039).updateExitCode('recommendation', 'add-to-cart-option');
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $18571d7c3acedda0$export$e004b8b30ca31361), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                type: "button",
                className: "wide-primary",
                onClick: handleMatching,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "drv.matching.available.action"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                type: "button",
                className: "link-secondary",
                onClick: handleNewMeasurement,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "drv.matching.available.action2"
                })
            }),
            hasPiFrames && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                type: "button",
                className: "link-secondary",
                onClick: handlePiReconstructionRequest,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "drv.matching.pi-reconstruction.action"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($0b11f2d6029c41cf$var$Text, {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                        id: "drv.matching.available.message"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                        id: "drv.splashscreen.imprint",
                        values: {
                            imp: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                    href: "https://footprinttech.de/imprint-webapp/",
                                    target: "_blank",
                                    children: chunks
                                })
                        }
                    })
                ]
            })
        ]
    });
}




var $6cds3 = parcelRequire("6cds3");










function $fc668c87cb0feaf9$export$bd24a8a3d66ee714(props) {
    const { matching: matching, emitter: emitter } = props;
    const shopSettings = (0, $6cds3.useContext)((0, $f686bfa33774dad2$export$d990cc5f51685546));
    // Default is true for backToShopEnabled
    const hasBackToShop = shopSettings.backToShopEnabled === false ? false : true;
    const handleBackToShop = (e)=>{
        e.nativeEvent.stopImmediatePropagation();
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Back to the shop called ${matching}`);
        emitter.emit((0, $7c8d586ac16018dc$export$2e2bcd8739ae039).onRecommendationBackToShopPress, matching);
    };
    const handleNewMeasurement = (e)=>{
        e.nativeEvent.stopImmediatePropagation();
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Handle New Measurement called`);
        emitter.emit((0, $3fe9119940fa16b8$export$ada873a34909da65).onMeasureAgainPress);
    };
    (0, $6cds3.useEffect)(()=>{
        (0, $f188c4e754268d8b$export$2e2bcd8739ae039).updateExitCode('recommendation', 'back-to-shop-option');
    }, []);
    const Text = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).p.withConfig({
        displayName: "UnavailableOptions__Text",
        componentId: "sc-1ah7zwd-0"
    })([
        "line-height:12px !important;font-size:10px;font-family:SourceSans3,sans-serif;margin-top:20px;& a{color:",
        " !important;font-size:10px;font-family:SourceSans3,sans-serif;text-decoration:underline;}& a:any-link{color:",
        ";font-size:10px;font-family:SourceSans3,sans-serif;text-decoration:underline;}& a:-webkit-any-link{color:",
        ";font-size:10px;font-family:SourceSans3,sans-serif;text-decoration:underline;}"
    ], (0, $4bd05a80e138995f$export$e07b43e05432e0e3), (0, $4bd05a80e138995f$export$e07b43e05432e0e3), (0, $4bd05a80e138995f$export$e07b43e05432e0e3));
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $18571d7c3acedda0$export$e004b8b30ca31361), {
        children: [
            hasBackToShop && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                type: "button",
                className: "wide-primary",
                onClick: handleBackToShop,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "drv.matching.unavailable.action"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                type: "button",
                className: "link-secondary",
                onClick: handleNewMeasurement,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "drv.matching.available.action2"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Text, {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "drv.splashscreen.imprint",
                    values: {
                        imp: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                href: "https://footprinttech.de/imprint-webapp/",
                                target: "_blank",
                                children: chunks
                            })
                    }
                })
            })
        ]
    });
}


const $d93f59797cb870aa$var$options = [
    (0, $0b11f2d6029c41cf$export$979339cc64681521),
    (0, $fc668c87cb0feaf9$export$bd24a8a3d66ee714)
];
function $d93f59797cb870aa$export$1bda0ec6a3bf5da0(props) {
    const { availability: availability, matching: matching, emitter: emitter, hasPiFrames: hasPiFrames } = props;
    const OptionsComponent = $d93f59797cb870aa$var$options[availability];
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(OptionsComponent, {
        matching: matching,
        emitter: emitter,
        hasPiFrames: hasPiFrames
    });
}



const $34a9b42a47fff3e7$export$a6dbe1033096e1fc = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "RecommendationPanel",
    componentId: "sc-blx0jp-0"
})([
    "position:relative;padding:24px;margin:193px 26px;object-fit:contain;text-align:center;color:var(--dark-slate-blue);background-size:cover;display:flex;flex-direction:column;justify-content:center;border-radius:20px;background-color:#fff;width:100%;max-width:633px !important;gap:24px;@media (min-width:601px){width:633px;}"
]);



parcelRequire("6cds3");




const $8e41fd03655895fc$var$HeaderContainer = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "CheckoutHeader__HeaderContainer",
    componentId: "sc-d4rsex-0"
})([
    "color:white;display:flex;font-size:1.25rem;font-weight:bold;justify-content:space-between;align-items:center;"
]);
const $8e41fd03655895fc$var$Headline = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "CheckoutHeader__Headline",
    componentId: "sc-d4rsex-1"
})([
    "font-size:20px;font-family:Inter,sans-serif;font-weight:700;color:#1e4e5f;margin-left:10px;flex-grow:1;"
]);
const $8e41fd03655895fc$var$CloseIcon = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "CheckoutHeader__CloseIcon",
    componentId: "sc-d4rsex-2"
})([
    "width:auto;"
]);
const $8e41fd03655895fc$var$CheckoutHeader = (props)=>{
    const { emitter: emitter, matching: matching } = props;
    (0, $c569e2e9ecfda3a0$export$2e2bcd8739ae039)();
    const handleClose = (e)=>{
        e.nativeEvent.stopImmediatePropagation();
        emitter.emit((0, $3fe9119940fa16b8$export$ada873a34909da65).onCancelPress, matching);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($8e41fd03655895fc$var$HeaderContainer, {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($8e41fd03655895fc$var$Headline, {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "drv.header.shoebox"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($8e41fd03655895fc$var$CloseIcon, {
                src: (0, $17bf087df6a33d6e$export$ec7dcaac71d9599d).close,
                onClick: handleClose
            })
        ]
    });
};
var $8e41fd03655895fc$export$2e2bcd8739ae039 = $8e41fd03655895fc$var$CheckoutHeader;







parcelRequire("6cds3");

parcelRequire("6cds3");



parcelRequire("6cds3");

const $9044e5e8db7bfabd$export$2ddb90ad54e5f587 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "SizePanelElements__Panel",
    componentId: "sc-2fcw0x-0"
})([
    "align-self:stretch;flex-grow:0;display:flex;flex-direction:row;justify-content:center;align-items:center;gap:16px;padding:12px 16px;border-radius:10px;background-color:rgba(0,141,65,0.15);"
]);
const $9044e5e8db7bfabd$export$472452cf732965c3 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "SizePanelElements__RecommendationIcon",
    componentId: "sc-2fcw0x-1"
})([
    "width:auto;height:5vw;opacity:0.8;@media screen and (min-width:601px){height:30px;}"
]);
const $9044e5e8db7bfabd$export$ff563649ab15814b = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).span.withConfig({
    displayName: "SizePanelElements__RecommendationLabel",
    componentId: "sc-2fcw0x-2"
})([
    "display:inline-block;font-family:Inter,sans-serif;font-size:4vw;font-weight:bold;font-stretch:normal;font-style:normal;line-height:1.4;letter-spacing:normal;color:var(--dark-slate-blue);opacity:0.8;white-space:nowrap;@media screen and (min-width:601px){font-size:25px;}&.arch-type-panel{margin:auto;}"
]);
const $9044e5e8db7bfabd$export$608a72b5b79d73d1 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).span.withConfig({
    displayName: "SizePanelElements__RecommendationValue",
    componentId: "sc-2fcw0x-3"
})([
    "display:inline-block;font-family:Inter,sans-serif;font-size:8vw;font-weight:bold;font-stretch:normal;font-style:normal;line-height:1;letter-spacing:-0.8px;color:var(--dark-slate-blue);&.arch-type-panel{flex:2;margin-top:10px;}@media screen and (min-width:601px){font-size:40px;}"
]);



const $701e4cbd9a595577$var$SubPanel = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "SizeArchPanel__SubPanel",
    componentId: "sc-149vffj-0"
})([
    "display:flex;flex-flow:wrap;flex-direction:column;justify-content:center;align-items:center;flex:1;"
]);
const $701e4cbd9a595577$var$LabelPanel = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "SizeArchPanel__LabelPanel",
    componentId: "sc-149vffj-1"
})([
    "display:flex;"
]);
const $701e4cbd9a595577$var$Separator = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "SizeArchPanel__Separator",
    componentId: "sc-149vffj-2"
})([
    "border-left:1px solid ",
    ";height:80px;"
], (0, $4bd05a80e138995f$export$e07b43e05432e0e3));
const $701e4cbd9a595577$var$SizeArchPanel = (props)=>{
    const { matching: matching } = props;
    const { size: size, arch_type: arch_type } = matching;
    const sizeNumber = size.value;
    const sizeDescription = size.description;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $9044e5e8db7bfabd$export$2ddb90ad54e5f587), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($701e4cbd9a595577$var$SubPanel, {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($701e4cbd9a595577$var$LabelPanel, {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9044e5e8db7bfabd$export$472452cf732965c3), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($53f1a82b9fd0191f$exports)))
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9044e5e8db7bfabd$export$ff563649ab15814b), {
                                className: "arch-type-panel",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "drv.matching.size.label"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $9044e5e8db7bfabd$export$608a72b5b79d73d1), {
                        className: "arch-type-panel",
                        children: [
                            sizeNumber,
                            " ",
                            sizeDescription
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($701e4cbd9a595577$var$Separator, {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($701e4cbd9a595577$var$SubPanel, {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($701e4cbd9a595577$var$LabelPanel, {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9044e5e8db7bfabd$export$472452cf732965c3), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($dc1f71575f63ff8b$exports)))
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9044e5e8db7bfabd$export$ff563649ab15814b), {
                                className: "arch-type-panel",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "drv.matching.arch-type.label"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9044e5e8db7bfabd$export$608a72b5b79d73d1), {
                        className: "arch-type-panel",
                        children: arch_type
                    })
                ]
            })
        ]
    });
};
var $701e4cbd9a595577$export$2e2bcd8739ae039 = $701e4cbd9a595577$var$SizeArchPanel;



parcelRequire("6cds3");



const $be7774e5f7e5ed61$var$SizeOnlyPanel = (props)=>{
    const { matching: matching } = props;
    const { size: size } = matching;
    const sizeNumber = size.value;
    const sizeDescription = size.description;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $9044e5e8db7bfabd$export$2ddb90ad54e5f587), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9044e5e8db7bfabd$export$472452cf732965c3), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($53f1a82b9fd0191f$exports)))
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9044e5e8db7bfabd$export$ff563649ab15814b), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "drv.matching.size.label"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $9044e5e8db7bfabd$export$608a72b5b79d73d1), {
                children: [
                    sizeNumber,
                    " ",
                    sizeDescription
                ]
            })
        ]
    });
};
var $be7774e5f7e5ed61$export$2e2bcd8739ae039 = $be7774e5f7e5ed61$var$SizeOnlyPanel;


const $594caeab840c787f$var$variants = [
    (0, $701e4cbd9a595577$export$2e2bcd8739ae039),
    (0, $be7774e5f7e5ed61$export$2e2bcd8739ae039)
];
function $594caeab840c787f$export$e66e3075aee81708(props) {
    const { matching: matching } = props;
    const panel = matching.arch_type ? 0 : 1;
    const PanelVariant = $594caeab840c787f$var$variants[panel];
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(PanelVariant, {
        matching: matching
    });
}


const $42d971b032ffee03$var$ParentContainer = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "RecommendationComponent__ParentContainer",
    componentId: "sc-di5v7n-0"
})([
    "display:flex;align-items:center;justify-content:center;height:100%;"
]);
const $42d971b032ffee03$var$HalluxPanel = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "RecommendationComponent__HalluxPanel",
    componentId: "sc-di5v7n-1"
})([
    "font-size:18px;line-height:1.4;margin-top:-20px;"
]);
function $42d971b032ffee03$export$68457e08ad68c9ad(props) {
    const { matching: matching, emitter: emitter, recommendationPriceEnabled: recommendationPriceEnabled, recommendationMatchingCodeEnabled: recommendationMatchingCodeEnabled, hasPiFrames: hasPiFrames } = props;
    const shopSettings = (0, $6cds3.useContext)((0, $f686bfa33774dad2$export$d990cc5f51685546));
    const article = (0, $6cds3.useContext)((0, $f686bfa33774dad2$export$9ed0816deade4fed));
    const hasHallux = !!(matching.hallux_right || matching.hallux_left);
    let ra, la;
    if (hasHallux) {
        ra = matching.hallux_right || 0;
        la = matching.hallux_left || 0;
    }
    const hasArchType = !!matching.arch_type;
    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`article sizes ${article.sizes}`);
    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`article sum ${article.sum}`);
    const availability = shopSettings.addToCartEnabled ? 0 : 1;
    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Availability: ${availability}`);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($42d971b032ffee03$var$ParentContainer, {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $34a9b42a47fff3e7$export$a6dbe1033096e1fc), {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8e41fd03655895fc$export$2e2bcd8739ae039), {
                    matching: matching,
                    emitter: emitter
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fb0feabf372b90f$export$2e2bcd8739ae039), {
                    articleName: article.name,
                    manufacturer: article.manufacturer,
                    productSrc: article.image,
                    matching: matching,
                    sum: article.sum,
                    emitter: emitter,
                    recommendationPriceEnabled: recommendationPriceEnabled,
                    recommendationMatchingCodeEnabled: recommendationMatchingCodeEnabled
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $594caeab840c787f$export$e66e3075aee81708), {
                    matching: matching
                }),
                hasHallux && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($42d971b032ffee03$var$HalluxPanel, {
                    children: [
                        "Hallux Winkel: L ",
                        la.toPrecision(2),
                        "\xb0 / R ",
                        ra.toPrecision(2),
                        "\xb0"
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d93f59797cb870aa$export$1bda0ec6a3bf5da0), {
                    availability: availability,
                    matching: matching,
                    emitter: emitter,
                    hasPiFrames: hasPiFrames
                })
            ]
        })
    });
}




var $6cds3 = parcelRequire("6cds3");



const $7640e19a46a718c5$var$ParentContainer = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "MultiRecommendationComponent__ParentContainer",
    componentId: "sc-1ezbpbc-0"
})([
    "display:flex;align-items:center;justify-content:center;height:100%;"
]);
function $7640e19a46a718c5$export$626a03d25025d09e(props) {
    const { recommendation: recommendation, emitter: emitter } = props;
    const shopSettings = (0, $6cds3.useContext)((0, $f686bfa33774dad2$export$d990cc5f51685546));
    const listItems = recommendation.variants.map((item)=>{
        const sizeNumber = item.size.value;
        const sizeDescription = item.size.description;
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("h2", {
                    children: [
                        item.variant_name,
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    children: sizeNumber + ' ' + sizeDescription
                })
            ]
        });
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7640e19a46a718c5$var$ParentContainer, {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $34a9b42a47fff3e7$export$a6dbe1033096e1fc), {
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("ul", {
                children: listItems
            })
        })
    });
}



parcelRequire("6cds3");





const $21080e4e90210997$var$ParentContainer = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ConfirmDialogComponent__ParentContainer",
    componentId: "sc-8ub95t-0"
})([
    "display:flex;align-items:center;justify-content:center;height:100%;"
]);
const $21080e4e90210997$export$2ddb90ad54e5f587 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ConfirmDialogComponent__Panel",
    componentId: "sc-8ub95t-1"
})([
    "position:relative;padding:20px;margin:193px 26px;object-fit:contain;text-align:center;color:var(--dark-slate-blue);background-size:cover;display:flex;flex-direction:column;justify-content:center;border-radius:20px;background-color:#f8fcfd;width:100%;"
]);
const $21080e4e90210997$var$Text = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).p.withConfig({
    displayName: "ConfirmDialogComponent__Text",
    componentId: "sc-8ub95t-2"
})([
    "line-height:16px;font-size:14px;font-family:Inter,sans-serif;font-weight:500;color:",
    ";"
], (0, $4bd05a80e138995f$export$e07b43e05432e0e3));
function $21080e4e90210997$export$620e493c7f3710e5(props) {
    const { recommendation: recommendation, emitter: emitter } = props;
    const handleConfirm = ()=>emitter.emit((0, $7c8d586ac16018dc$export$2e2bcd8739ae039).onFeedbackConfirm, {
            confirm: true,
            recommendation: recommendation
        });
    const handleCancel = ()=>emitter.emit((0, $7c8d586ac16018dc$export$2e2bcd8739ae039).onFeedbackConfirm, {
            confirm: false,
            recommendation: recommendation
        });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($21080e4e90210997$var$ParentContainer, {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($21080e4e90210997$export$2ddb90ad54e5f587, {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($21080e4e90210997$var$Text, {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                        id: "drv.feedback-confirm-dialog.text"
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                    type: "button",
                    className: "wide-primary",
                    onClick: handleConfirm,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                        id: "drv.feedback-confirm-dialog.confirm"
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                    type: "button",
                    className: "wide-secondary",
                    onClick: handleCancel,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                        id: "drv.feedback-confirm-dialog.cancel"
                    })
                })
            ]
        })
    });
}






var $6cds3 = parcelRequire("6cds3");



parcelRequire("6cds3");
var $4af26b2c823cf44b$exports = {};
"use strict";
Object.defineProperty($4af26b2c823cf44b$exports, "__esModule", {
    value: true
});
$4af26b2c823cf44b$exports.QRCode = undefined;
var $4af26b2c823cf44b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7da1d47045483a0e$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7da1d47045483a0e$var$ReactIs, $7da1d47045483a0e$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$7da1d47045483a0e$exports = (parcelRequire("lrct3"))();


var $4af26b2c823cf44b$var$_propTypes2 = $4af26b2c823cf44b$var$_interopRequireDefault($7da1d47045483a0e$exports);
var $92251849fb960cba$exports = {};
$92251849fb960cba$exports = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};


var $4af26b2c823cf44b$var$_ErrorCorrectLevel2 = $4af26b2c823cf44b$var$_interopRequireDefault($92251849fb960cba$exports);
var $41a07944ca50bf1b$exports = {};
var $c25885262161e4b5$exports = {};
var $8df3d3e44e1511b2$exports = {};
$8df3d3e44e1511b2$exports = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
};


function $c25885262161e4b5$var$QR8bitByte(data) {
    this.mode = $8df3d3e44e1511b2$exports.MODE_8BIT_BYTE;
    this.data = data;
}
$c25885262161e4b5$var$QR8bitByte.prototype = {
    getLength: function(buffer) {
        return this.data.length;
    },
    write: function(buffer) {
        for(var i = 0; i < this.data.length; i++)// not JIS ...
        buffer.put(this.data.charCodeAt(i), 8);
    }
};
$c25885262161e4b5$exports = $c25885262161e4b5$var$QR8bitByte;


var $9b2ee90f12ff4ee6$exports = {};
// ErrorCorrectLevel

function $9b2ee90f12ff4ee6$var$QRRSBlock(totalCount, dataCount) {
    this.totalCount = totalCount;
    this.dataCount = dataCount;
}
$9b2ee90f12ff4ee6$var$QRRSBlock.RS_BLOCK_TABLE = [
    // L
    // M
    // Q
    // H
    // 1
    [
        1,
        26,
        19
    ],
    [
        1,
        26,
        16
    ],
    [
        1,
        26,
        13
    ],
    [
        1,
        26,
        9
    ],
    // 2
    [
        1,
        44,
        34
    ],
    [
        1,
        44,
        28
    ],
    [
        1,
        44,
        22
    ],
    [
        1,
        44,
        16
    ],
    // 3
    [
        1,
        70,
        55
    ],
    [
        1,
        70,
        44
    ],
    [
        2,
        35,
        17
    ],
    [
        2,
        35,
        13
    ],
    // 4		
    [
        1,
        100,
        80
    ],
    [
        2,
        50,
        32
    ],
    [
        2,
        50,
        24
    ],
    [
        4,
        25,
        9
    ],
    // 5
    [
        1,
        134,
        108
    ],
    [
        2,
        67,
        43
    ],
    [
        2,
        33,
        15,
        2,
        34,
        16
    ],
    [
        2,
        33,
        11,
        2,
        34,
        12
    ],
    // 6
    [
        2,
        86,
        68
    ],
    [
        4,
        43,
        27
    ],
    [
        4,
        43,
        19
    ],
    [
        4,
        43,
        15
    ],
    // 7		
    [
        2,
        98,
        78
    ],
    [
        4,
        49,
        31
    ],
    [
        2,
        32,
        14,
        4,
        33,
        15
    ],
    [
        4,
        39,
        13,
        1,
        40,
        14
    ],
    // 8
    [
        2,
        121,
        97
    ],
    [
        2,
        60,
        38,
        2,
        61,
        39
    ],
    [
        4,
        40,
        18,
        2,
        41,
        19
    ],
    [
        4,
        40,
        14,
        2,
        41,
        15
    ],
    // 9
    [
        2,
        146,
        116
    ],
    [
        3,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        36,
        16,
        4,
        37,
        17
    ],
    [
        4,
        36,
        12,
        4,
        37,
        13
    ],
    // 10		
    [
        2,
        86,
        68,
        2,
        87,
        69
    ],
    [
        4,
        69,
        43,
        1,
        70,
        44
    ],
    [
        6,
        43,
        19,
        2,
        44,
        20
    ],
    [
        6,
        43,
        15,
        2,
        44,
        16
    ],
    // 11
    [
        4,
        101,
        81
    ],
    [
        1,
        80,
        50,
        4,
        81,
        51
    ],
    [
        4,
        50,
        22,
        4,
        51,
        23
    ],
    [
        3,
        36,
        12,
        8,
        37,
        13
    ],
    // 12
    [
        2,
        116,
        92,
        2,
        117,
        93
    ],
    [
        6,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        46,
        20,
        6,
        47,
        21
    ],
    [
        7,
        42,
        14,
        4,
        43,
        15
    ],
    // 13
    [
        4,
        133,
        107
    ],
    [
        8,
        59,
        37,
        1,
        60,
        38
    ],
    [
        8,
        44,
        20,
        4,
        45,
        21
    ],
    [
        12,
        33,
        11,
        4,
        34,
        12
    ],
    // 14
    [
        3,
        145,
        115,
        1,
        146,
        116
    ],
    [
        4,
        64,
        40,
        5,
        65,
        41
    ],
    [
        11,
        36,
        16,
        5,
        37,
        17
    ],
    [
        11,
        36,
        12,
        5,
        37,
        13
    ],
    // 15
    [
        5,
        109,
        87,
        1,
        110,
        88
    ],
    [
        5,
        65,
        41,
        5,
        66,
        42
    ],
    [
        5,
        54,
        24,
        7,
        55,
        25
    ],
    [
        11,
        36,
        12
    ],
    // 16
    [
        5,
        122,
        98,
        1,
        123,
        99
    ],
    [
        7,
        73,
        45,
        3,
        74,
        46
    ],
    [
        15,
        43,
        19,
        2,
        44,
        20
    ],
    [
        3,
        45,
        15,
        13,
        46,
        16
    ],
    // 17
    [
        1,
        135,
        107,
        5,
        136,
        108
    ],
    [
        10,
        74,
        46,
        1,
        75,
        47
    ],
    [
        1,
        50,
        22,
        15,
        51,
        23
    ],
    [
        2,
        42,
        14,
        17,
        43,
        15
    ],
    // 18
    [
        5,
        150,
        120,
        1,
        151,
        121
    ],
    [
        9,
        69,
        43,
        4,
        70,
        44
    ],
    [
        17,
        50,
        22,
        1,
        51,
        23
    ],
    [
        2,
        42,
        14,
        19,
        43,
        15
    ],
    // 19
    [
        3,
        141,
        113,
        4,
        142,
        114
    ],
    [
        3,
        70,
        44,
        11,
        71,
        45
    ],
    [
        17,
        47,
        21,
        4,
        48,
        22
    ],
    [
        9,
        39,
        13,
        16,
        40,
        14
    ],
    // 20
    [
        3,
        135,
        107,
        5,
        136,
        108
    ],
    [
        3,
        67,
        41,
        13,
        68,
        42
    ],
    [
        15,
        54,
        24,
        5,
        55,
        25
    ],
    [
        15,
        43,
        15,
        10,
        44,
        16
    ],
    // 21
    [
        4,
        144,
        116,
        4,
        145,
        117
    ],
    [
        17,
        68,
        42
    ],
    [
        17,
        50,
        22,
        6,
        51,
        23
    ],
    [
        19,
        46,
        16,
        6,
        47,
        17
    ],
    // 22
    [
        2,
        139,
        111,
        7,
        140,
        112
    ],
    [
        17,
        74,
        46
    ],
    [
        7,
        54,
        24,
        16,
        55,
        25
    ],
    [
        34,
        37,
        13
    ],
    // 23
    [
        4,
        151,
        121,
        5,
        152,
        122
    ],
    [
        4,
        75,
        47,
        14,
        76,
        48
    ],
    [
        11,
        54,
        24,
        14,
        55,
        25
    ],
    [
        16,
        45,
        15,
        14,
        46,
        16
    ],
    // 24
    [
        6,
        147,
        117,
        4,
        148,
        118
    ],
    [
        6,
        73,
        45,
        14,
        74,
        46
    ],
    [
        11,
        54,
        24,
        16,
        55,
        25
    ],
    [
        30,
        46,
        16,
        2,
        47,
        17
    ],
    // 25
    [
        8,
        132,
        106,
        4,
        133,
        107
    ],
    [
        8,
        75,
        47,
        13,
        76,
        48
    ],
    [
        7,
        54,
        24,
        22,
        55,
        25
    ],
    [
        22,
        45,
        15,
        13,
        46,
        16
    ],
    // 26
    [
        10,
        142,
        114,
        2,
        143,
        115
    ],
    [
        19,
        74,
        46,
        4,
        75,
        47
    ],
    [
        28,
        50,
        22,
        6,
        51,
        23
    ],
    [
        33,
        46,
        16,
        4,
        47,
        17
    ],
    // 27
    [
        8,
        152,
        122,
        4,
        153,
        123
    ],
    [
        22,
        73,
        45,
        3,
        74,
        46
    ],
    [
        8,
        53,
        23,
        26,
        54,
        24
    ],
    [
        12,
        45,
        15,
        28,
        46,
        16
    ],
    // 28
    [
        3,
        147,
        117,
        10,
        148,
        118
    ],
    [
        3,
        73,
        45,
        23,
        74,
        46
    ],
    [
        4,
        54,
        24,
        31,
        55,
        25
    ],
    [
        11,
        45,
        15,
        31,
        46,
        16
    ],
    // 29
    [
        7,
        146,
        116,
        7,
        147,
        117
    ],
    [
        21,
        73,
        45,
        7,
        74,
        46
    ],
    [
        1,
        53,
        23,
        37,
        54,
        24
    ],
    [
        19,
        45,
        15,
        26,
        46,
        16
    ],
    // 30
    [
        5,
        145,
        115,
        10,
        146,
        116
    ],
    [
        19,
        75,
        47,
        10,
        76,
        48
    ],
    [
        15,
        54,
        24,
        25,
        55,
        25
    ],
    [
        23,
        45,
        15,
        25,
        46,
        16
    ],
    // 31
    [
        13,
        145,
        115,
        3,
        146,
        116
    ],
    [
        2,
        74,
        46,
        29,
        75,
        47
    ],
    [
        42,
        54,
        24,
        1,
        55,
        25
    ],
    [
        23,
        45,
        15,
        28,
        46,
        16
    ],
    // 32
    [
        17,
        145,
        115
    ],
    [
        10,
        74,
        46,
        23,
        75,
        47
    ],
    [
        10,
        54,
        24,
        35,
        55,
        25
    ],
    [
        19,
        45,
        15,
        35,
        46,
        16
    ],
    // 33
    [
        17,
        145,
        115,
        1,
        146,
        116
    ],
    [
        14,
        74,
        46,
        21,
        75,
        47
    ],
    [
        29,
        54,
        24,
        19,
        55,
        25
    ],
    [
        11,
        45,
        15,
        46,
        46,
        16
    ],
    // 34
    [
        13,
        145,
        115,
        6,
        146,
        116
    ],
    [
        14,
        74,
        46,
        23,
        75,
        47
    ],
    [
        44,
        54,
        24,
        7,
        55,
        25
    ],
    [
        59,
        46,
        16,
        1,
        47,
        17
    ],
    // 35
    [
        12,
        151,
        121,
        7,
        152,
        122
    ],
    [
        12,
        75,
        47,
        26,
        76,
        48
    ],
    [
        39,
        54,
        24,
        14,
        55,
        25
    ],
    [
        22,
        45,
        15,
        41,
        46,
        16
    ],
    // 36
    [
        6,
        151,
        121,
        14,
        152,
        122
    ],
    [
        6,
        75,
        47,
        34,
        76,
        48
    ],
    [
        46,
        54,
        24,
        10,
        55,
        25
    ],
    [
        2,
        45,
        15,
        64,
        46,
        16
    ],
    // 37
    [
        17,
        152,
        122,
        4,
        153,
        123
    ],
    [
        29,
        74,
        46,
        14,
        75,
        47
    ],
    [
        49,
        54,
        24,
        10,
        55,
        25
    ],
    [
        24,
        45,
        15,
        46,
        46,
        16
    ],
    // 38
    [
        4,
        152,
        122,
        18,
        153,
        123
    ],
    [
        13,
        74,
        46,
        32,
        75,
        47
    ],
    [
        48,
        54,
        24,
        14,
        55,
        25
    ],
    [
        42,
        45,
        15,
        32,
        46,
        16
    ],
    // 39
    [
        20,
        147,
        117,
        4,
        148,
        118
    ],
    [
        40,
        75,
        47,
        7,
        76,
        48
    ],
    [
        43,
        54,
        24,
        22,
        55,
        25
    ],
    [
        10,
        45,
        15,
        67,
        46,
        16
    ],
    // 40
    [
        19,
        148,
        118,
        6,
        149,
        119
    ],
    [
        18,
        75,
        47,
        31,
        76,
        48
    ],
    [
        34,
        54,
        24,
        34,
        55,
        25
    ],
    [
        20,
        45,
        15,
        61,
        46,
        16
    ]
];
$9b2ee90f12ff4ee6$var$QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
    var rsBlock = $9b2ee90f12ff4ee6$var$QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
    if (rsBlock == undefined) throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
    var length = rsBlock.length / 3;
    var list = new Array();
    for(var i = 0; i < length; i++){
        var count = rsBlock[i * 3 + 0];
        var totalCount = rsBlock[i * 3 + 1];
        var dataCount = rsBlock[i * 3 + 2];
        for(var j = 0; j < count; j++)list.push(new $9b2ee90f12ff4ee6$var$QRRSBlock(totalCount, dataCount));
    }
    return list;
};
$9b2ee90f12ff4ee6$var$QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
    switch(errorCorrectLevel){
        case $92251849fb960cba$exports.L:
            return $9b2ee90f12ff4ee6$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
        case $92251849fb960cba$exports.M:
            return $9b2ee90f12ff4ee6$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
        case $92251849fb960cba$exports.Q:
            return $9b2ee90f12ff4ee6$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
        case $92251849fb960cba$exports.H:
            return $9b2ee90f12ff4ee6$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$9b2ee90f12ff4ee6$exports = $9b2ee90f12ff4ee6$var$QRRSBlock;


var $85771b4b5b8c13bc$exports = {};
function $85771b4b5b8c13bc$var$QRBitBuffer() {
    this.buffer = new Array();
    this.length = 0;
}
$85771b4b5b8c13bc$var$QRBitBuffer.prototype = {
    get: function(index) {
        var bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
    },
    put: function(num, length) {
        for(var i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) == 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        var bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$85771b4b5b8c13bc$exports = $85771b4b5b8c13bc$var$QRBitBuffer;


var $693203ac281a058a$exports = {};

var $e6d65f61cfff01a7$exports = {};
var $d1a21e322e6a8d8e$exports = {};
var $d1a21e322e6a8d8e$var$QRMath = {
    glog: function(n) {
        if (n < 1) throw new Error("glog(" + n + ")");
        return $d1a21e322e6a8d8e$var$QRMath.LOG_TABLE[n];
    },
    gexp: function(n) {
        while(n < 0)n += 255;
        while(n >= 256)n -= 255;
        return $d1a21e322e6a8d8e$var$QRMath.EXP_TABLE[n];
    },
    EXP_TABLE: new Array(256),
    LOG_TABLE: new Array(256)
};
for(var $d1a21e322e6a8d8e$var$i = 0; $d1a21e322e6a8d8e$var$i < 8; $d1a21e322e6a8d8e$var$i++)$d1a21e322e6a8d8e$var$QRMath.EXP_TABLE[$d1a21e322e6a8d8e$var$i] = 1 << $d1a21e322e6a8d8e$var$i;
for(var $d1a21e322e6a8d8e$var$i = 8; $d1a21e322e6a8d8e$var$i < 256; $d1a21e322e6a8d8e$var$i++)$d1a21e322e6a8d8e$var$QRMath.EXP_TABLE[$d1a21e322e6a8d8e$var$i] = $d1a21e322e6a8d8e$var$QRMath.EXP_TABLE[$d1a21e322e6a8d8e$var$i - 4] ^ $d1a21e322e6a8d8e$var$QRMath.EXP_TABLE[$d1a21e322e6a8d8e$var$i - 5] ^ $d1a21e322e6a8d8e$var$QRMath.EXP_TABLE[$d1a21e322e6a8d8e$var$i - 6] ^ $d1a21e322e6a8d8e$var$QRMath.EXP_TABLE[$d1a21e322e6a8d8e$var$i - 8];
for(var $d1a21e322e6a8d8e$var$i = 0; $d1a21e322e6a8d8e$var$i < 255; $d1a21e322e6a8d8e$var$i++)$d1a21e322e6a8d8e$var$QRMath.LOG_TABLE[$d1a21e322e6a8d8e$var$QRMath.EXP_TABLE[$d1a21e322e6a8d8e$var$i]] = $d1a21e322e6a8d8e$var$i;
$d1a21e322e6a8d8e$exports = $d1a21e322e6a8d8e$var$QRMath;


function $e6d65f61cfff01a7$var$QRPolynomial(num, shift) {
    if (num.length == undefined) throw new Error(num.length + "/" + shift);
    var offset = 0;
    while(offset < num.length && num[offset] == 0)offset++;
    this.num = new Array(num.length - offset + shift);
    for(var i = 0; i < num.length - offset; i++)this.num[i] = num[i + offset];
}
$e6d65f61cfff01a7$var$QRPolynomial.prototype = {
    get: function(index) {
        return this.num[index];
    },
    getLength: function() {
        return this.num.length;
    },
    multiply: function(e) {
        var num = new Array(this.getLength() + e.getLength() - 1);
        for(var i = 0; i < this.getLength(); i++)for(var j = 0; j < e.getLength(); j++)num[i + j] ^= $d1a21e322e6a8d8e$exports.gexp($d1a21e322e6a8d8e$exports.glog(this.get(i)) + $d1a21e322e6a8d8e$exports.glog(e.get(j)));
        return new $e6d65f61cfff01a7$var$QRPolynomial(num, 0);
    },
    mod: function(e) {
        if (this.getLength() - e.getLength() < 0) return this;
        var ratio = $d1a21e322e6a8d8e$exports.glog(this.get(0)) - $d1a21e322e6a8d8e$exports.glog(e.get(0));
        var num = new Array(this.getLength());
        for(var i = 0; i < this.getLength(); i++)num[i] = this.get(i);
        for(var i = 0; i < e.getLength(); i++)num[i] ^= $d1a21e322e6a8d8e$exports.gexp($d1a21e322e6a8d8e$exports.glog(e.get(i)) + ratio);
        // recursive call
        return new $e6d65f61cfff01a7$var$QRPolynomial(num, 0).mod(e);
    }
};
$e6d65f61cfff01a7$exports = $e6d65f61cfff01a7$var$QRPolynomial;



var $693203ac281a058a$var$QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
var $693203ac281a058a$var$QRUtil = {
    PATTERN_POSITION_TABLE: [
        [],
        [
            6,
            18
        ],
        [
            6,
            22
        ],
        [
            6,
            26
        ],
        [
            6,
            30
        ],
        [
            6,
            34
        ],
        [
            6,
            22,
            38
        ],
        [
            6,
            24,
            42
        ],
        [
            6,
            26,
            46
        ],
        [
            6,
            28,
            50
        ],
        [
            6,
            30,
            54
        ],
        [
            6,
            32,
            58
        ],
        [
            6,
            34,
            62
        ],
        [
            6,
            26,
            46,
            66
        ],
        [
            6,
            26,
            48,
            70
        ],
        [
            6,
            26,
            50,
            74
        ],
        [
            6,
            30,
            54,
            78
        ],
        [
            6,
            30,
            56,
            82
        ],
        [
            6,
            30,
            58,
            86
        ],
        [
            6,
            34,
            62,
            90
        ],
        [
            6,
            28,
            50,
            72,
            94
        ],
        [
            6,
            26,
            50,
            74,
            98
        ],
        [
            6,
            30,
            54,
            78,
            102
        ],
        [
            6,
            28,
            54,
            80,
            106
        ],
        [
            6,
            32,
            58,
            84,
            110
        ],
        [
            6,
            30,
            58,
            86,
            114
        ],
        [
            6,
            34,
            62,
            90,
            118
        ],
        [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]
    ],
    G15: 1335,
    G18: 7973,
    G15_MASK: 21522,
    getBCHTypeInfo: function(data) {
        var d = data << 10;
        while($693203ac281a058a$var$QRUtil.getBCHDigit(d) - $693203ac281a058a$var$QRUtil.getBCHDigit($693203ac281a058a$var$QRUtil.G15) >= 0)d ^= $693203ac281a058a$var$QRUtil.G15 << $693203ac281a058a$var$QRUtil.getBCHDigit(d) - $693203ac281a058a$var$QRUtil.getBCHDigit($693203ac281a058a$var$QRUtil.G15);
        return (data << 10 | d) ^ $693203ac281a058a$var$QRUtil.G15_MASK;
    },
    getBCHTypeNumber: function(data) {
        var d = data << 12;
        while($693203ac281a058a$var$QRUtil.getBCHDigit(d) - $693203ac281a058a$var$QRUtil.getBCHDigit($693203ac281a058a$var$QRUtil.G18) >= 0)d ^= $693203ac281a058a$var$QRUtil.G18 << $693203ac281a058a$var$QRUtil.getBCHDigit(d) - $693203ac281a058a$var$QRUtil.getBCHDigit($693203ac281a058a$var$QRUtil.G18);
        return data << 12 | d;
    },
    getBCHDigit: function(data) {
        var digit = 0;
        while(data != 0){
            digit++;
            data >>>= 1;
        }
        return digit;
    },
    getPatternPosition: function(typeNumber) {
        return $693203ac281a058a$var$QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },
    getMask: function(maskPattern, i, j) {
        switch(maskPattern){
            case $693203ac281a058a$var$QRMaskPattern.PATTERN000:
                return (i + j) % 2 == 0;
            case $693203ac281a058a$var$QRMaskPattern.PATTERN001:
                return i % 2 == 0;
            case $693203ac281a058a$var$QRMaskPattern.PATTERN010:
                return j % 3 == 0;
            case $693203ac281a058a$var$QRMaskPattern.PATTERN011:
                return (i + j) % 3 == 0;
            case $693203ac281a058a$var$QRMaskPattern.PATTERN100:
                return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
            case $693203ac281a058a$var$QRMaskPattern.PATTERN101:
                return i * j % 2 + i * j % 3 == 0;
            case $693203ac281a058a$var$QRMaskPattern.PATTERN110:
                return (i * j % 2 + i * j % 3) % 2 == 0;
            case $693203ac281a058a$var$QRMaskPattern.PATTERN111:
                return (i * j % 3 + (i + j) % 2) % 2 == 0;
            default:
                throw new Error("bad maskPattern:" + maskPattern);
        }
    },
    getErrorCorrectPolynomial: function(errorCorrectLength) {
        var a = new $e6d65f61cfff01a7$exports([
            1
        ], 0);
        for(var i = 0; i < errorCorrectLength; i++)a = a.multiply(new $e6d65f61cfff01a7$exports([
            1,
            $d1a21e322e6a8d8e$exports.gexp(i)
        ], 0));
        return a;
    },
    getLengthInBits: function(mode, type) {
        if (1 <= type && type < 10) // 1 - 9
        switch(mode){
            case $8df3d3e44e1511b2$exports.MODE_NUMBER:
                return 10;
            case $8df3d3e44e1511b2$exports.MODE_ALPHA_NUM:
                return 9;
            case $8df3d3e44e1511b2$exports.MODE_8BIT_BYTE:
                return 8;
            case $8df3d3e44e1511b2$exports.MODE_KANJI:
                return 8;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 27) // 10 - 26
        switch(mode){
            case $8df3d3e44e1511b2$exports.MODE_NUMBER:
                return 12;
            case $8df3d3e44e1511b2$exports.MODE_ALPHA_NUM:
                return 11;
            case $8df3d3e44e1511b2$exports.MODE_8BIT_BYTE:
                return 16;
            case $8df3d3e44e1511b2$exports.MODE_KANJI:
                return 10;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 41) // 27 - 40
        switch(mode){
            case $8df3d3e44e1511b2$exports.MODE_NUMBER:
                return 14;
            case $8df3d3e44e1511b2$exports.MODE_ALPHA_NUM:
                return 13;
            case $8df3d3e44e1511b2$exports.MODE_8BIT_BYTE:
                return 16;
            case $8df3d3e44e1511b2$exports.MODE_KANJI:
                return 12;
            default:
                throw new Error("mode:" + mode);
        }
        else throw new Error("type:" + type);
    },
    getLostPoint: function(qrCode) {
        var moduleCount = qrCode.getModuleCount();
        var lostPoint = 0;
        // LEVEL1
        for(var row = 0; row < moduleCount; row++)for(var col = 0; col < moduleCount; col++){
            var sameCount = 0;
            var dark = qrCode.isDark(row, col);
            for(var r = -1; r <= 1; r++){
                if (row + r < 0 || moduleCount <= row + r) continue;
                for(var c = -1; c <= 1; c++){
                    if (col + c < 0 || moduleCount <= col + c) continue;
                    if (r == 0 && c == 0) continue;
                    if (dark == qrCode.isDark(row + r, col + c)) sameCount++;
                }
            }
            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
        }
        // LEVEL2
        for(var row = 0; row < moduleCount - 1; row++)for(var col = 0; col < moduleCount - 1; col++){
            var count = 0;
            if (qrCode.isDark(row, col)) count++;
            if (qrCode.isDark(row + 1, col)) count++;
            if (qrCode.isDark(row, col + 1)) count++;
            if (qrCode.isDark(row + 1, col + 1)) count++;
            if (count == 0 || count == 4) lostPoint += 3;
        }
        // LEVEL3
        for(var row = 0; row < moduleCount; row++){
            for(var col = 0; col < moduleCount - 6; col++)if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) lostPoint += 40;
        }
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount - 6; row++)if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) lostPoint += 40;
        }
        // LEVEL4
        var darkCount = 0;
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount; row++)if (qrCode.isDark(row, col)) darkCount++;
        }
        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    }
};
$693203ac281a058a$exports = $693203ac281a058a$var$QRUtil;



function $41a07944ca50bf1b$var$QRCode(typeNumber, errorCorrectLevel) {
    this.typeNumber = typeNumber;
    this.errorCorrectLevel = errorCorrectLevel;
    this.modules = null;
    this.moduleCount = 0;
    this.dataCache = null;
    this.dataList = [];
}
// for client side minification
var $41a07944ca50bf1b$var$proto = $41a07944ca50bf1b$var$QRCode.prototype;
$41a07944ca50bf1b$var$proto.addData = function(data) {
    var newData = new $c25885262161e4b5$exports(data);
    this.dataList.push(newData);
    this.dataCache = null;
};
$41a07944ca50bf1b$var$proto.isDark = function(row, col) {
    if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) throw new Error(row + "," + col);
    return this.modules[row][col];
};
$41a07944ca50bf1b$var$proto.getModuleCount = function() {
    return this.moduleCount;
};
$41a07944ca50bf1b$var$proto.make = function() {
    // Calculate automatically typeNumber if provided is < 1
    if (this.typeNumber < 1) {
        var typeNumber = 1;
        for(typeNumber = 1; typeNumber < 40; typeNumber++){
            var rsBlocks = $9b2ee90f12ff4ee6$exports.getRSBlocks(typeNumber, this.errorCorrectLevel);
            var buffer = new $85771b4b5b8c13bc$exports();
            var totalDataCount = 0;
            for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
            for(var i = 0; i < this.dataList.length; i++){
                var data = this.dataList[i];
                buffer.put(data.mode, 4);
                buffer.put(data.getLength(), $693203ac281a058a$exports.getLengthInBits(data.mode, typeNumber));
                data.write(buffer);
            }
            if (buffer.getLengthInBits() <= totalDataCount * 8) break;
        }
        this.typeNumber = typeNumber;
    }
    this.makeImpl(false, this.getBestMaskPattern());
};
$41a07944ca50bf1b$var$proto.makeImpl = function(test, maskPattern) {
    this.moduleCount = this.typeNumber * 4 + 17;
    this.modules = new Array(this.moduleCount);
    for(var row = 0; row < this.moduleCount; row++){
        this.modules[row] = new Array(this.moduleCount);
        for(var col = 0; col < this.moduleCount; col++)this.modules[row][col] = null; //(col + row) % 3;
    }
    this.setupPositionProbePattern(0, 0);
    this.setupPositionProbePattern(this.moduleCount - 7, 0);
    this.setupPositionProbePattern(0, this.moduleCount - 7);
    this.setupPositionAdjustPattern();
    this.setupTimingPattern();
    this.setupTypeInfo(test, maskPattern);
    if (this.typeNumber >= 7) this.setupTypeNumber(test);
    if (this.dataCache == null) this.dataCache = $41a07944ca50bf1b$var$QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
    this.mapData(this.dataCache, maskPattern);
};
$41a07944ca50bf1b$var$proto.setupPositionProbePattern = function(row, col) {
    for(var r = -1; r <= 7; r++){
        if (row + r <= -1 || this.moduleCount <= row + r) continue;
        for(var c = -1; c <= 7; c++){
            if (col + c <= -1 || this.moduleCount <= col + c) continue;
            if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) this.modules[row + r][col + c] = true;
            else this.modules[row + r][col + c] = false;
        }
    }
};
$41a07944ca50bf1b$var$proto.getBestMaskPattern = function() {
    var minLostPoint = 0;
    var pattern = 0;
    for(var i = 0; i < 8; i++){
        this.makeImpl(true, i);
        var lostPoint = $693203ac281a058a$exports.getLostPoint(this);
        if (i == 0 || minLostPoint > lostPoint) {
            minLostPoint = lostPoint;
            pattern = i;
        }
    }
    return pattern;
};
$41a07944ca50bf1b$var$proto.createMovieClip = function(target_mc, instance_name, depth) {
    var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
    var cs = 1;
    this.make();
    for(var row = 0; row < this.modules.length; row++){
        var y = row * cs;
        for(var col = 0; col < this.modules[row].length; col++){
            var x = col * cs;
            var dark = this.modules[row][col];
            if (dark) {
                qr_mc.beginFill(0, 100);
                qr_mc.moveTo(x, y);
                qr_mc.lineTo(x + cs, y);
                qr_mc.lineTo(x + cs, y + cs);
                qr_mc.lineTo(x, y + cs);
                qr_mc.endFill();
            }
        }
    }
    return qr_mc;
};
$41a07944ca50bf1b$var$proto.setupTimingPattern = function() {
    for(var r = 8; r < this.moduleCount - 8; r++){
        if (this.modules[r][6] != null) continue;
        this.modules[r][6] = r % 2 == 0;
    }
    for(var c = 8; c < this.moduleCount - 8; c++){
        if (this.modules[6][c] != null) continue;
        this.modules[6][c] = c % 2 == 0;
    }
};
$41a07944ca50bf1b$var$proto.setupPositionAdjustPattern = function() {
    var pos = $693203ac281a058a$exports.getPatternPosition(this.typeNumber);
    for(var i = 0; i < pos.length; i++)for(var j = 0; j < pos.length; j++){
        var row = pos[i];
        var col = pos[j];
        if (this.modules[row][col] != null) continue;
        for(var r = -2; r <= 2; r++){
            for(var c = -2; c <= 2; c++)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) this.modules[row + r][col + c] = true;
            else this.modules[row + r][col + c] = false;
        }
    }
};
$41a07944ca50bf1b$var$proto.setupTypeNumber = function(test) {
    var bits = $693203ac281a058a$exports.getBCHTypeNumber(this.typeNumber);
    for(var i = 0; i < 18; i++){
        var mod = !test && (bits >> i & 1) == 1;
        this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
    }
    for(var i = 0; i < 18; i++){
        var mod = !test && (bits >> i & 1) == 1;
        this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
    }
};
$41a07944ca50bf1b$var$proto.setupTypeInfo = function(test, maskPattern) {
    var data = this.errorCorrectLevel << 3 | maskPattern;
    var bits = $693203ac281a058a$exports.getBCHTypeInfo(data);
    // vertical		
    for(var i = 0; i < 15; i++){
        var mod = !test && (bits >> i & 1) == 1;
        if (i < 6) this.modules[i][8] = mod;
        else if (i < 8) this.modules[i + 1][8] = mod;
        else this.modules[this.moduleCount - 15 + i][8] = mod;
    }
    // horizontal
    for(var i = 0; i < 15; i++){
        var mod = !test && (bits >> i & 1) == 1;
        if (i < 8) this.modules[8][this.moduleCount - i - 1] = mod;
        else if (i < 9) this.modules[8][15 - i - 1 + 1] = mod;
        else this.modules[8][15 - i - 1] = mod;
    }
    // fixed module
    this.modules[this.moduleCount - 8][8] = !test;
};
$41a07944ca50bf1b$var$proto.mapData = function(data, maskPattern) {
    var inc = -1;
    var row = this.moduleCount - 1;
    var bitIndex = 7;
    var byteIndex = 0;
    for(var col = this.moduleCount - 1; col > 0; col -= 2){
        if (col == 6) col--;
        while(true){
            for(var c = 0; c < 2; c++)if (this.modules[row][col - c] == null) {
                var dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                var mask = $693203ac281a058a$exports.getMask(maskPattern, row, col - c);
                if (mask) dark = !dark;
                this.modules[row][col - c] = dark;
                bitIndex--;
                if (bitIndex == -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || this.moduleCount <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
};
$41a07944ca50bf1b$var$QRCode.PAD0 = 0xEC;
$41a07944ca50bf1b$var$QRCode.PAD1 = 0x11;
$41a07944ca50bf1b$var$QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
    var rsBlocks = $9b2ee90f12ff4ee6$exports.getRSBlocks(typeNumber, errorCorrectLevel);
    var buffer = new $85771b4b5b8c13bc$exports();
    for(var i = 0; i < dataList.length; i++){
        var data = dataList[i];
        buffer.put(data.mode, 4);
        buffer.put(data.getLength(), $693203ac281a058a$exports.getLengthInBits(data.mode, typeNumber));
        data.write(buffer);
    }
    // calc num max data.
    var totalDataCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
    if (buffer.getLengthInBits() > totalDataCount * 8) throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
    // end code
    if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
    // padding
    while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
    // padding
    while(true){
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put($41a07944ca50bf1b$var$QRCode.PAD0, 8);
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put($41a07944ca50bf1b$var$QRCode.PAD1, 8);
    }
    return $41a07944ca50bf1b$var$QRCode.createBytes(buffer, rsBlocks);
};
$41a07944ca50bf1b$var$QRCode.createBytes = function(buffer, rsBlocks) {
    var offset = 0;
    var maxDcCount = 0;
    var maxEcCount = 0;
    var dcdata = new Array(rsBlocks.length);
    var ecdata = new Array(rsBlocks.length);
    for(var r = 0; r < rsBlocks.length; r++){
        var dcCount = rsBlocks[r].dataCount;
        var ecCount = rsBlocks[r].totalCount - dcCount;
        maxDcCount = Math.max(maxDcCount, dcCount);
        maxEcCount = Math.max(maxEcCount, ecCount);
        dcdata[r] = new Array(dcCount);
        for(var i = 0; i < dcdata[r].length; i++)dcdata[r][i] = 0xff & buffer.buffer[i + offset];
        offset += dcCount;
        var rsPoly = $693203ac281a058a$exports.getErrorCorrectPolynomial(ecCount);
        var rawPoly = new $e6d65f61cfff01a7$exports(dcdata[r], rsPoly.getLength() - 1);
        var modPoly = rawPoly.mod(rsPoly);
        ecdata[r] = new Array(rsPoly.getLength() - 1);
        for(var i = 0; i < ecdata[r].length; i++){
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
            ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
        }
    }
    var totalCodeCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalCodeCount += rsBlocks[i].totalCount;
    var data = new Array(totalCodeCount);
    var index = 0;
    for(var i = 0; i < maxDcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < dcdata[r].length) data[index++] = dcdata[r][i];
    }
    for(var i = 0; i < maxEcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < ecdata[r].length) data[index++] = ecdata[r][i];
    }
    return data;
};
$41a07944ca50bf1b$exports = $41a07944ca50bf1b$var$QRCode;


var $4af26b2c823cf44b$var$_QRCode2 = $4af26b2c823cf44b$var$_interopRequireDefault($41a07944ca50bf1b$exports);

var $6cds3 = parcelRequire("6cds3");
var $4af26b2c823cf44b$var$_react2 = $4af26b2c823cf44b$var$_interopRequireDefault($6cds3);
var $8f26c4e0ef54fc5d$exports = {};
"use strict";
Object.defineProperty($8f26c4e0ef54fc5d$exports, "__esModule", {
    value: true
});
var $8f26c4e0ef54fc5d$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $8f26c4e0ef54fc5d$var$_propTypes2 = $8f26c4e0ef54fc5d$var$_interopRequireDefault($7da1d47045483a0e$exports);

var $6cds3 = parcelRequire("6cds3");
var $8f26c4e0ef54fc5d$var$_react2 = $8f26c4e0ef54fc5d$var$_interopRequireDefault($6cds3);
function $8f26c4e0ef54fc5d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8f26c4e0ef54fc5d$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $8f26c4e0ef54fc5d$var$propTypes = {
    bgColor: $8f26c4e0ef54fc5d$var$_propTypes2.default.oneOfType([
        $8f26c4e0ef54fc5d$var$_propTypes2.default.object,
        $8f26c4e0ef54fc5d$var$_propTypes2.default.string
    ]).isRequired,
    bgD: $8f26c4e0ef54fc5d$var$_propTypes2.default.string.isRequired,
    fgColor: $8f26c4e0ef54fc5d$var$_propTypes2.default.oneOfType([
        $8f26c4e0ef54fc5d$var$_propTypes2.default.object,
        $8f26c4e0ef54fc5d$var$_propTypes2.default.string
    ]).isRequired,
    fgD: $8f26c4e0ef54fc5d$var$_propTypes2.default.string.isRequired,
    size: $8f26c4e0ef54fc5d$var$_propTypes2.default.number.isRequired,
    title: $8f26c4e0ef54fc5d$var$_propTypes2.default.string,
    viewBoxSize: $8f26c4e0ef54fc5d$var$_propTypes2.default.number.isRequired,
    xmlns: $8f26c4e0ef54fc5d$var$_propTypes2.default.string
};
var $8f26c4e0ef54fc5d$var$QRCodeSvg = (0, $6cds3.forwardRef)(function(_ref, ref) {
    var bgColor = _ref.bgColor, bgD = _ref.bgD, fgD = _ref.fgD, fgColor = _ref.fgColor, size = _ref.size, title = _ref.title, viewBoxSize = _ref.viewBoxSize, _ref$xmlns = _ref.xmlns, xmlns = _ref$xmlns === undefined ? "http://www.w3.org/2000/svg" : _ref$xmlns, props = $8f26c4e0ef54fc5d$var$_objectWithoutProperties(_ref, [
        "bgColor",
        "bgD",
        "fgD",
        "fgColor",
        "size",
        "title",
        "viewBoxSize",
        "xmlns"
    ]);
    return $8f26c4e0ef54fc5d$var$_react2.default.createElement("svg", $8f26c4e0ef54fc5d$var$_extends({}, props, {
        height: size,
        ref: ref,
        viewBox: "0 0 " + viewBoxSize + " " + viewBoxSize,
        width: size,
        xmlns: xmlns
    }), title ? $8f26c4e0ef54fc5d$var$_react2.default.createElement("title", null, title) : null, $8f26c4e0ef54fc5d$var$_react2.default.createElement("path", {
        d: bgD,
        fill: bgColor
    }), $8f26c4e0ef54fc5d$var$_react2.default.createElement("path", {
        d: fgD,
        fill: fgColor
    }));
});
$8f26c4e0ef54fc5d$var$QRCodeSvg.displayName = "QRCodeSvg";
$8f26c4e0ef54fc5d$var$QRCodeSvg.propTypes = $8f26c4e0ef54fc5d$var$propTypes;
$8f26c4e0ef54fc5d$exports.default = $8f26c4e0ef54fc5d$var$QRCodeSvg;


var $4af26b2c823cf44b$var$_QRCodeSvg2 = $4af26b2c823cf44b$var$_interopRequireDefault($8f26c4e0ef54fc5d$exports);
function $4af26b2c823cf44b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4af26b2c823cf44b$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
// A `qr.js` doesn't handle error level of zero (M) so we need to do it right, thus the deep require.
var $4af26b2c823cf44b$var$propTypes = {
    bgColor: $4af26b2c823cf44b$var$_propTypes2.default.oneOfType([
        $4af26b2c823cf44b$var$_propTypes2.default.object,
        $4af26b2c823cf44b$var$_propTypes2.default.string
    ]),
    fgColor: $4af26b2c823cf44b$var$_propTypes2.default.oneOfType([
        $4af26b2c823cf44b$var$_propTypes2.default.object,
        $4af26b2c823cf44b$var$_propTypes2.default.string
    ]),
    level: $4af26b2c823cf44b$var$_propTypes2.default.string,
    size: $4af26b2c823cf44b$var$_propTypes2.default.number,
    value: $4af26b2c823cf44b$var$_propTypes2.default.string.isRequired
};
var $4af26b2c823cf44b$var$QRCode = (0, $6cds3.forwardRef)(function(_ref, ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === undefined ? "#FFFFFF" : _ref$bgColor, _ref$fgColor = _ref.fgColor, fgColor = _ref$fgColor === undefined ? "#000000" : _ref$fgColor, _ref$level = _ref.level, level = _ref$level === undefined ? "L" : _ref$level, _ref$size = _ref.size, size = _ref$size === undefined ? 256 : _ref$size, value = _ref.value, props = $4af26b2c823cf44b$var$_objectWithoutProperties(_ref, [
        "bgColor",
        "fgColor",
        "level",
        "size",
        "value"
    ]);
    // Use type === -1 to automatically pick the best type.
    var qrcode = new $4af26b2c823cf44b$var$_QRCode2.default(-1, $4af26b2c823cf44b$var$_ErrorCorrectLevel2.default[level]);
    qrcode.addData(value);
    qrcode.make();
    var cells = qrcode.modules;
    return $4af26b2c823cf44b$var$_react2.default.createElement($4af26b2c823cf44b$var$_QRCodeSvg2.default, $4af26b2c823cf44b$var$_extends({}, props, {
        bgColor: bgColor,
        bgD: cells.map(function(row, rowIndex) {
            return row.map(function(cell, cellIndex) {
                return !cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
            }).join(" ");
        }).join(" "),
        fgColor: fgColor,
        fgD: cells.map(function(row, rowIndex) {
            return row.map(function(cell, cellIndex) {
                return cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
            }).join(" ");
        }).join(" "),
        ref: ref,
        size: size,
        viewBoxSize: cells.length
    }));
});
$4af26b2c823cf44b$exports.QRCode = $4af26b2c823cf44b$var$QRCode;
$4af26b2c823cf44b$var$QRCode.displayName = "QRCode";
$4af26b2c823cf44b$var$QRCode.propTypes = $4af26b2c823cf44b$var$propTypes;
$4af26b2c823cf44b$exports.default = $4af26b2c823cf44b$var$QRCode;





const $b2599f7806531024$export$8b251419efc915eb = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__Header",
    componentId: "sc-1lkd0xe-0"
})([
    "font-family:Rubik,sans-serif !important;font-weight:600;font-stretch:normal;font-style:normal;margin-top:40px;line-height:1.67;letter-spacing:normal;text-align:center;font-size:18px;line-height:1.25;color:#1e4e5f;"
]);
const $b2599f7806531024$export$5f1af8db9871e1d6 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).p.withConfig({
    displayName: "Elements__Text",
    componentId: "sc-1lkd0xe-1"
})([
    "font-family:Inter,sans-serif;font-weight:400;font-size:12px;font-stretch:normal;font-style:normal;margin-top:20px;padding-left:40px;padding-right:40px;line-height:1.67;letter-spacing:normal;text-align:center;color:var(--dark-slate-blue);"
]);
const $b2599f7806531024$export$d9736db17dce3652 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__QRCodeContainer",
    componentId: "sc-1lkd0xe-2"
})([
    "display:flex;margin-top:40px;justify-content:center;align-items:center;"
]);
const $b2599f7806531024$export$c580b558418aa961 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__QRCodeSpinnerContainer",
    componentId: "sc-1lkd0xe-3"
})([
    "display:flex;margin-top:40px;justify-content:center;align-items:center;padding:40px;padding-bottom:41px;"
]);


const $b1355d02ae4f79a0$var$CodePanelContainer = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "QRCodePanel__CodePanelContainer",
    componentId: "sc-k83ls-0"
})([
    "margin-bottom:25px;"
]);
const $b1355d02ae4f79a0$var$QRCodePanel = function(props) {
    const { target: target } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($b1355d02ae4f79a0$var$CodePanelContainer, {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b2599f7806531024$export$8b251419efc915eb), {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                        id: "drv.qr-gateway-title"
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b2599f7806531024$export$5f1af8db9871e1d6), {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                        id: "drv.qr-gateway-message",
                        values: {
                            b: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                    children: chunks
                                })
                        }
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b2599f7806531024$export$5f1af8db9871e1d6), {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                        id: "drv.qr-gateway-hint",
                        values: {
                            b: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                    children: chunks
                                })
                        }
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b2599f7806531024$export$d9736db17dce3652), {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4af26b2c823cf44b$exports))), {
                        value: target.toString(),
                        size: 108
                    })
                })
            ]
        })
    });
};
var $b1355d02ae4f79a0$export$2e2bcd8739ae039 = $b1355d02ae4f79a0$var$QRCodePanel;



parcelRequire("6cds3");





const $4bcd374aec1dcbc0$var$spin = (0, $e94f79f42775c5f5$export$d25ddfdf17c3ad3e)([
    "from{transform:rotate(0deg);}to{transform:rotate(360deg);}"
]);
const $4bcd374aec1dcbc0$var$Spinner = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.attrs((props)=>({
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2223b2963c323142$exports))),
        alt: 'Loading',
        className: 'fpt-cta-button__spinner'
    })).withConfig({
    displayName: "Spinner",
    componentId: "sc-a5qm47-0"
})([
    "animation:",
    " 1s infinite linear;height:32px;filter:",
    ";"
], $4bcd374aec1dcbc0$var$spin, (props)=>props.theme.ctaButton.filter);
var $4bcd374aec1dcbc0$export$2e2bcd8739ae039 = $4bcd374aec1dcbc0$var$Spinner;


const $c4b249a7086d555a$var$RedColor = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "PollingPanel__RedColor",
    componentId: "sc-1t3rf6q-0"
})([
    "color:red;bottom:1px;position:absolute;"
]);
const $c4b249a7086d555a$var$PollingPanel = function(props) {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b2599f7806531024$export$8b251419efc915eb), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "drv.qr-gateway-title"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b2599f7806531024$export$5f1af8db9871e1d6), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "drv.qr-gateway-message",
                    values: {
                        b: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                children: chunks
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b2599f7806531024$export$5f1af8db9871e1d6), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "drv.qr-gateway-hint",
                    values: {
                        b: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                children: chunks
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b2599f7806531024$export$c580b558418aa961), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4bcd374aec1dcbc0$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b2599f7806531024$export$5f1af8db9871e1d6), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c4b249a7086d555a$var$RedColor, {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                        id: "drv.qr-gateway-polling"
                    })
                })
            })
        ]
    });
};
var $c4b249a7086d555a$export$2e2bcd8739ae039 = $c4b249a7086d555a$var$PollingPanel;


var $386c10f0156f9896$export$50f695ee7ce4b786 = /*#__PURE__*/ function(PollingState) {
    PollingState[PollingState["UNDEFINED"] = 0] = "UNDEFINED";
    PollingState[PollingState["MEASURING"] = 1] = "MEASURING";
    PollingState[PollingState["DONE"] = 2] = "DONE";
    PollingState[PollingState["CANCELLED"] = 3] = "CANCELLED";
    PollingState[PollingState["TIMEOUT"] = 4] = "TIMEOUT";
    return PollingState;
}({});
const $386c10f0156f9896$export$8775979036f9ffa = {
    onMeasurementDone: 'onMeasurementDone',
    onQRPanelClose: 'onQRPanelClose',
    onTimeout: 'onTimeout'
};



const $e23b56ff19157479$var$OuterContainer = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "QRGateway__OuterContainer",
    componentId: "sc-5csita-0"
})([
    "width:633px;padding:25px;border-radius:30px;background-color:#f8fcfd;margin:auto;"
]);
const $e23b56ff19157479$var$InnerContainer = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "QRGateway__InnerContainer",
    componentId: "sc-5csita-1"
})([
    "padding-bottom:10px;border-radius:20px;box-shadow:0 0 8px 0 rgba(0,0,0,0.13);background-color:#fff;margin:auto;"
]);
const $e23b56ff19157479$var$CloseButton = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).button.withConfig({
    displayName: "QRGateway__CloseButton",
    componentId: "sc-5csita-2"
})([
    "position:absolute;top:10px;right:10px;background:none;border:none;font-size:18px;color:var(--dark-slate-blue);cursor:pointer;width:46px;"
]);
const $e23b56ff19157479$var$CloseBut = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "QRGateway__CloseBut",
    componentId: "sc-5csita-3"
})([
    ""
]);
const $e23b56ff19157479$var$ContentContainer = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "QRGateway__ContentContainer",
    componentId: "sc-5csita-4"
})([
    "padding:10px;text-align:left;position:relative;"
]);
const $e23b56ff19157479$var$outcome = [
    (0, $b1355d02ae4f79a0$export$2e2bcd8739ae039),
    (0, $c4b249a7086d555a$export$2e2bcd8739ae039),
    (0, $c4b249a7086d555a$export$2e2bcd8739ae039)
];
const $e23b56ff19157479$var$QRGateway = function(props) {
    const { target: target, emitter: emitter, polling: polling } = props;
    const OutcomeComponent = $e23b56ff19157479$var$outcome[polling];
    (0, $6cds3.useEffect)(()=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`initializing QRGateway ${(0, $386c10f0156f9896$export$50f695ee7ce4b786)[polling].toString()}`);
    }, [
        polling
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($e23b56ff19157479$var$OuterContainer, {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($e23b56ff19157479$var$InnerContainer, {
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($e23b56ff19157479$var$ContentContainer, {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($e23b56ff19157479$var$CloseButton, {
                        type: "button",
                        onClick: (ev)=>{
                            ev.nativeEvent.stopImmediatePropagation();
                            emitter.emit((0, $386c10f0156f9896$export$8775979036f9ffa).onQRPanelClose);
                        },
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($e23b56ff19157479$var$CloseBut, {
                            src: (0, $17bf087df6a33d6e$export$ec7dcaac71d9599d).close,
                            width: 34
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(OutcomeComponent, {
                        target: target
                    })
                ]
            })
        })
    });
};
var $e23b56ff19157479$export$2e2bcd8739ae039 = $e23b56ff19157479$var$QRGateway;







var $6cds3 = parcelRequire("6cds3");




const $965f5d735ba6d674$var$Events = {
    onFunnelSelect: 'onFunnelSelect',
    onLanguageSelect: 'onLanguageSelect'
};
var $965f5d735ba6d674$export$2e2bcd8739ae039 = $965f5d735ba6d674$var$Events;



var $412cbdbe683b6639$exports = {};

$412cbdbe683b6639$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "driver-small-logo.2b40bbc6.svg";




var $6cds3 = parcelRequire("6cds3");





parcelRequire("6cds3");

const $5449eb762065d7b8$var$css = `

  body {
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-y: hidden;
    display: block;
  }

  body::-webkit-scrollbar {
    display: none;
  }

  #shopify-section-announcement-bar {
    display: none;
  }

  #shopify-section-custom-announcement-bar {
    display: none;
  }

  .header-wrapper {
    display: none;
  }

  .site-box {
    display: block;
  }

  .hide-lt-600 {
    @media(height < 600px) {
      display: none;
    }
  }

  .hide-lt-700 {
    @media(height < 700px) {
      display: none;
    }
  }

  .disclaimer {
    font: 400 13px/1.67 Inter, sans-serif;
    color: ${(0, $4bd05a80e138995f$export$e07b43e05432e0e3)};
    text-align: center;

    & a {
      font: 400 12px/1.67 Inter, sans-serif;
      display:inline;
    }

    & a:any-link {
      color: ${(0, $4bd05a80e138995f$export$e07b43e05432e0e3)};
      text-decoration: underline;
      display:inline;
    }

    & a:-webkit-any-link {
      color: ${(0, $4bd05a80e138995f$export$e07b43e05432e0e3)};
      text-decoration: underline;
      display:inline;
    }

    & a.wide-primary {
      color: #ffffff;
      text-decoration: none;
      display:inline-block;
      font: 500 16px Inter, sans-serif;
    }
  }

`;
function $5449eb762065d7b8$var$GlobalStyle() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("style", {
        children: $5449eb762065d7b8$var$css
    });
}
var $5449eb762065d7b8$export$2e2bcd8739ae039 = $5449eb762065d7b8$var$GlobalStyle;




const $b19fd48583540509$var$Screen = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Screen",
    componentId: "sc-1hnxaxv-0"
})([
    "display:flex;flex-direction:column;height:100vh;height:calc(var(--vh,1vh) * 100);color:",
    ";background-color:#fff;align-items:center;justify-content:center;&.fpt-error{justify-content:start;padding-top:30%;@media (max-width:380px){padding-top:10%;}}&.fpt-gradient{background-image:linear-gradient(to bottom,#e0ecf8,#fdf5ec);}"
], (0, $4bd05a80e138995f$export$e07b43e05432e0e3));
const $b19fd48583540509$var$CloseIcon = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "Screen__CloseIcon",
    componentId: "sc-1hnxaxv-1"
})([
    "width:auto;position:absolute;top:16px;right:24px;"
]);
const $b19fd48583540509$var$Wrapper = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Screen__Wrapper",
    componentId: "sc-1hnxaxv-2"
})([
    "height:100%;position:absolute;top:16px;transform:translate3d(0,0,0);display:flex;flex-direction:column;padding:0 24px;"
]);
const $b19fd48583540509$export$159cd03be7087f39 = (props)=>{
    const { emitter: emitter, children: children, className: className, isClosable: isClosable } = props;
    const renderCloseButton = !(isClosable === false) && !(0, $2fd26587fc2957b4$export$2e2bcd8739ae039).isEmbeddedMode();
    const handleResize = ()=>{
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        const vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`resize ${vh}`);
    };
    const handleClose = (e)=>{
        e.nativeEvent.stopImmediatePropagation();
        emitter.emit((0, $933ab13c7a65596b$export$2e2bcd8739ae039).onCloseModalPress);
    };
    (0, $6cds3.useEffect)(()=>{
        // We listen to the resize event
        window.addEventListener('resize', handleResize);
        // The cleanup function
        return ()=>{
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($b19fd48583540509$var$Screen, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5449eb762065d7b8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($b19fd48583540509$var$Wrapper, {
                children: [
                    children,
                    renderCloseButton && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($b19fd48583540509$var$CloseIcon, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($56504c099eb325fa$exports))),
                        onClick: handleClose
                    })
                ]
            })
        ]
    });
};


const $327caa885e3be523$export$25c607d6a337a384 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Fullscreen__ContentPanel",
    componentId: "sc-bvqwwz-0"
})([
    "flex:auto;text-align:center;padding:0 0 140px;&.fpt-show{display:block;}&.fpt-hide{display:none;}"
]);
const $327caa885e3be523$export$a06f1c675e846f6f = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Fullscreen__Footer",
    componentId: "sc-bvqwwz-1"
})([
    "position:absolute;bottom:0;left:0;padding:30px 0;width:100%;"
]);
const $327caa885e3be523$export$6e2c8f0811a474ce = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Fullscreen__Section",
    componentId: "sc-bvqwwz-2"
})([
    "margin:16px 50px 0;&.fpt-hide{display:none;}"
]);
const $327caa885e3be523$export$468752b4280b39f2 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.attrs((props)=>({
        ...props,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($412cbdbe683b6639$exports))),
        alt: 'Footprint',
        className: ''
    })).withConfig({
    displayName: "Fullscreen__FptLogo",
    componentId: "sc-bvqwwz-3"
})([
    "margin:0 auto;width:40px;vertical-align:middle;"
]);



parcelRequire("6cds3");


const $dc2d1ec7e7cbe723$var$Panel = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "LogoPanel__Panel",
    componentId: "sc-14gh3al-0"
})([
    "flex:initial;display:flex;flex-direction:column;padding:0;justify-content:flex-start;align-items:center;gap:12px;margin:0 0 32px;& img{text-align:center;}"
]);
const $dc2d1ec7e7cbe723$var$ShopLogo = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.attrs((props)=>({
        src: props.theme.shopLogo
    })).withConfig({
    displayName: "LogoPanel__ShopLogo",
    componentId: "sc-14gh3al-1"
})([
    "display:block;width:auto;max-height:9vh;min-height:25px;max-width:100%;"
]);
const $dc2d1ec7e7cbe723$var$FPTLogo = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "LogoPanel__FPTLogo",
    componentId: "sc-14gh3al-2"
})([
    "display:block;width:auto;max-height:3vh;min-height:25px;"
]);
const $dc2d1ec7e7cbe723$var$AND = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "LogoPanel__AND",
    componentId: "sc-14gh3al-3"
})([
    "display:",
    ";width:auto;height:3vh;opacity:1;"
], (props)=>props.theme.shopLogo ? 'block' : 'none');
const $dc2d1ec7e7cbe723$var$LogoPanel = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($dc2d1ec7e7cbe723$var$Panel, {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($dc2d1ec7e7cbe723$var$ShopLogo, {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($dc2d1ec7e7cbe723$var$AND, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($0e62b8f5f409238e$exports)))
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($dc2d1ec7e7cbe723$var$FPTLogo, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3a68c0047535a5ee$exports)))
            })
        ]
    });
};
var $dc2d1ec7e7cbe723$export$2e2bcd8739ae039 = $dc2d1ec7e7cbe723$var$LogoPanel;


var $be61b9cfe3f63cb1$export$e059618c1faa2ae1 = /*#__PURE__*/ function(FUNNEL) {
    FUNNEL["UNDEFINED"] = "UNDEFINED";
    // Will need user input in conversion
    FUNNEL["SELF"] = "SELF";
    // Previously known as Adults
    FUNNEL["OTHER"] = "OTHER";
    return FUNNEL;
}({});
var $be61b9cfe3f63cb1$export$2cc08e8cf4a6f791 = /*#__PURE__*/ function(DESKTOP_FLOW_END) {
    DESKTOP_FLOW_END["mobile"] = "mobile";
    // Process redirects to PDP in mobile coming from QR code
    DESKTOP_FLOW_END["desktop"] = "desktop";
    return DESKTOP_FLOW_END;
}({});
var $be61b9cfe3f63cb1$export$c54e410b5d8ae915 = /*#__PURE__*/ function(MEASUREMENT_END) {
    MEASUREMENT_END["PDP"] = "PDP";
    // Process redirects to PDP in mobile coming from QR code
    MEASUREMENT_END["EXT"] = "EXT";
    return MEASUREMENT_END;
}({});
const $be61b9cfe3f63cb1$export$8c57c6eb67fc5a85 = {
    mobile: "PDP",
    desktop: "EXT"
};
var $be61b9cfe3f63cb1$export$84ee76a85290f693 = /*#__PURE__*/ function(CONVERSION_ACTION) {
    CONVERSION_ACTION["MATCHING"] = "MATCHING";
    CONVERSION_ACTION["MATCHING_PRIMARY"] = "MATCHING_PRIMARY";
    CONVERSION_ACTION["MATCHING_SECONDARY"] = "MATCHING_SECONDARY";
    CONVERSION_ACTION["ADDITEM"] = "ADDITEM";
    CONVERSION_ACTION["CHECKOUT"] = "CHECKOUT";
    return CONVERSION_ACTION;
}({});
var $be61b9cfe3f63cb1$export$380708aba139d470 = /*#__PURE__*/ function(SHOP_PLATFORM) {
    SHOP_PLATFORM["CUSTOM"] = "CUSTOM";
    SHOP_PLATFORM["SHOPIFY"] = "SHOPIFY";
    SHOP_PLATFORM["SHOPWARE"] = "SHOPWARE";
    SHOP_PLATFORM["SHOPWARE6"] = "SHOPWARE6";
    return SHOP_PLATFORM;
}({});
var $be61b9cfe3f63cb1$export$6c866809fdbd0d53 = /*#__PURE__*/ function(TOOLTIP_ENABLED) {
    TOOLTIP_ENABLED["INITIAL"] = "INITIAL";
    TOOLTIP_ENABLED["RECOMMENDATION"] = "RECOMMENDATION";
    TOOLTIP_ENABLED["BOTH"] = "BOTH";
    TOOLTIP_ENABLED["NONE"] = "NONE";
    return TOOLTIP_ENABLED;
}({});
var $be61b9cfe3f63cb1$export$e84115ab4a1f1c5b = /*#__PURE__*/ function(TAGS_QUERY_TYPE) {
    TAGS_QUERY_TYPE["AND"] = "AND";
    TAGS_QUERY_TYPE["OR"] = "OR";
    return TAGS_QUERY_TYPE;
}({});
var $be61b9cfe3f63cb1$export$84adad34d27dc394 = /*#__PURE__*/ function(POWER_MODE) {
    POWER_MODE["MANDATORY"] = "MANDATORY";
    POWER_MODE["OPTIONAL"] = "OPTIONAL";
    POWER_MODE["NONE"] = "NONE";
    return POWER_MODE;
}({});
var $be61b9cfe3f63cb1$export$ea7340d08bbb5cf8 = /*#__PURE__*/ function(FrameSource) {
    FrameSource["FA"] = "FA";
    // Foot Arch
    FrameSource["PI"] = "PI";
    // Plantar Image
    FrameSource["MC"] = "MC";
    // MiniPod (Medicapteurs)
    FrameSource["LEN"] = "LEN";
    return FrameSource;
}({});
var $be61b9cfe3f63cb1$export$8bbed17cf90fe422 = /*#__PURE__*/ function(CurrencyISO4217) {
    CurrencyISO4217["CHF"] = "CHF";
    CurrencyISO4217["GBP"] = "GBP";
    CurrencyISO4217["EUR"] = "EUR";
    CurrencyISO4217["JPY"] = "JPY";
    CurrencyISO4217["USD"] = "USD";
    return CurrencyISO4217;
}({});
var $be61b9cfe3f63cb1$export$c726bcddb8d44055 = /*#__PURE__*/ function(FOOT_ARCH_OPTION) {
    FOOT_ARCH_OPTION["MC"] = "MC";
    FOOT_ARCH_OPTION["PI"] = "PI";
    FOOT_ARCH_OPTION["FPT"] = "FPT";
    FOOT_ARCH_OPTION["NONE"] = "NONE";
    return FOOT_ARCH_OPTION;
}({});







var $df6536fbed69acd1$exports = {};
$df6536fbed69acd1$exports = JSON.parse("{\"name\":\"webshop-driver\",\"version\":\"1.9.0\",\"private\":true,\"app\":\"dist/index.js\",\"source\":\"src/index.ts\",\"dependencies\":{\"@footprint/common-components\":\"latest\",\"axios\":\"^1.2.1\",\"env-cmd\":\"^10.1.0\",\"eventemitter3\":\"^5.0.0\",\"jsx\":\"^0.9.89\",\"promise-window\":\"^1.2.1\",\"react\":\"19.1.0\",\"react-dom\":\"19.1.0\",\"react-intl\":\"8.0.x\",\"react-is\":\"19.1.0\",\"react-qr-code\":\"^2.0.7\",\"react-test-renderer\":\"19.1.0\",\"resize-observer-polyfill\":\"^1.5.1\",\"styled-components\":\"^6.1.11\",\"webpack\":\"5.96.1\"},\"license\":\"ISC\",\"scripts\":{\"lint\":\"eslint \\\"{src,apps,libs,test}/**/*.ts\\\" --fix\",\"tsc\":\"tsc --noEmit\",\"start\":\"parcel --no-autoinstall -p 3000 watch index.html --no-hmr\",\"start:host\":\"NODE_ENV=development parcel --no-autoinstall -p 3000 --host $npm_config_host watch src/index.ts --no-hmr\",\"watch\":\"npm run build:local && http-server ./dist -p 3000 --cors\",\"build\":\"env-cmd -f ./.env parcel build src/index.ts\",\"build:testing\":\"NODE_ENV=development parcel build src/index.ts --public-url \\\"https://testing-frontend.footprinttech.de\\\"\",\"build:production\":\"NODE_ENV=production parcel build src/index.ts --public-url \\\"https://production-frontend.footprinttech.de\\\"\",\"build:azure\":\"NODE_ENV=production parcel build src/index.ts --public-url \\\"https://podolino-frontend.azurewebsites.net\\\"\",\"build:local\":\"NODE_ENV=development parcel build --target app --public-url \\\"http://localhost:3000\\\"\",\"build:local-win\":\"set NODE_ENV=development && env-cmd -f ./.env parcel build --target app --public-url \\\"http://localhost:3000\\\"\",\"build:host\":\"NODE_ENV=development parcel build --target app --public-url \\\"http://192.168.178.72:3000\\\"\",\"build:azure:static\":\"NODE_ENV=production parcel build --target app --public-url \\\"https://swfootprintwebdrivergwc.blob.core.windows.net/static\\\"\",\"serve-dist:host\":\"npm run build:host && http-server ./dist -p 3000 -a 192.168.178.72 --cors\",\"serve-dist\":\"npm run build:local && http-server ./dist -p 3000 --cors\",\"serve-dist-win\":\"env-cmd -f ./.env npm run build:local-win && http-server ./dist -p 3000 --cors\",\"deploy:testing\":\"npm run build:testing && aws s3 sync --acl private --sse --delete ./dist s3://website-testing-frontend.podolino.de && aws cloudfront create-invalidation --distribution-id E1Z1EIKC8NAPW1 --paths '/*'\",\"deploy:testing-win\":\"npm run build:testing-win && aws s3 sync --acl private --sse --delete ./dist s3://website-testing-frontend.podolino.de && aws cloudfront create-invalidation --distribution-id E1Z1EIKC8NAPW1 --paths '/*'\",\"deploy:production\":\"npm run build:production && aws s3 sync --acl private --sse --delete ./dist s3://website-production-frontend.footprinttech.de && aws cloudfront create-invalidation --distribution-id E3IN41JHU3TKUJ --paths '/*'\"},\"browserslist\":{\"production\":[\">0.2%\",\"not dead\",\"not op_mini all\"],\"development\":[\"last 1 chrome version\",\"last 1 firefox version\",\"last 1 safari version\"]},\"devDependencies\":{\"@babel/core\":\"^7.24.6\",\"@babel/preset-env\":\"^7.12.1\",\"@babel/preset-react\":\"^7.12.5\",\"@babel/preset-typescript\":\"^7.12.1\",\"@parcel/config-default\":\"2.13.0\",\"@parcel/core\":\"2.13.0\",\"@parcel/transformer-raw\":\"2.13.0\",\"@parcel/transformer-typescript-tsc\":\"2.13.0\",\"@types/node\":\"22.9.x\",\"@types/react\":\"19.2.x\",\"@types/react-dom\":\"19.2.x\",\"@types/styled-components\":\"^5.1.4\",\"@typescript-eslint/eslint-plugin\":\"8.14.x\",\"@typescript-eslint/parser\":\"8.14.0\",\"autoprefixer\":\"^10.4.16\",\"babel-loader\":\"^9.1.0\",\"babel-plugin-styled-components\":\"^2.0.2\",\"buffer\":\"^6.0.3\",\"eslint\":\"9.15.x\",\"eslint-plugin-import\":\"^2.25.2\",\"eslint-plugin-jest\":\"^28.9.0\",\"eslint-plugin-react\":\"^7.37.2\",\"http-server\":\"^14.1.0\",\"parcel\":\"2.13.0\",\"postcss\":\"^8.0.0\",\"process\":\"^0.11.10\",\"rollup\":\"4.x.x\",\"source-map\":\"^0.7.4\",\"svgo\":\"2.x.x\",\"typescript\":\"5.6.x\"},\"targets\":{\"app\":{}},\"@parcel/transformer-css\":{\"cssModules\":true},\"jest\":{\"moduleNameMapper\":{\".+\\\\.(css|scss)$\":\"identity-obj-proxy\",\"^.+\\\\.(jpg|jpeg|png|gif|eot|otf|webp|svg|ttf|woff|woff2|mp4|webm|wav|mp3|m4a|aac|oga)$\":\"<rootDir>/__mocks__/fileMock.js\"}},\"packageManager\":\"yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e\"}");


const $c9c2269a089314a3$var$Welcome = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Splashscreen__Welcome",
    componentId: "sc-f52qtb-0"
})([
    "font:600 14px Inter,sans-serif;margin-bottom:18px;margin-top:3vh;"
]);
const $c9c2269a089314a3$var$Text = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Splashscreen__Text",
    componentId: "sc-f52qtb-1"
})([
    "font:normal 600 18px Inter,sans-serif;margin-bottom:25px;color:#000;"
]);
const $c9c2269a089314a3$var$CustomSelect = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).select.withConfig({
    displayName: "Splashscreen__CustomSelect",
    componentId: "sc-f52qtb-2"
})([
    "font-family:Inter,sans-serif;font-weight:500;font-size:16px !important;padding:12px 40px 12px 40px !important;background-color:rgba(255,255,255,0.01) !important;background-image:url(",
    ") !important;background-repeat:no-repeat;background-position:left 12px center;background-size:24px 24px;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:solid 2px ",
    ";border-radius:12px;width:auto;text-align:center;color:#000;&>option{font-family:Inter,sans-serif;font-weight:500;}"
], (0, (/*@__PURE__*/$parcel$interopDefault($10c4411a2e218bc4$exports))), (0, $4bd05a80e138995f$export$8f45430ccf837300)['inactive-blue']);
const $c9c2269a089314a3$var$Info = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Splashscreen__Info",
    componentId: "sc-f52qtb-3"
})([
    "display:flex;flex-direction:row;color:#000;gap:10px;"
]);
const $c9c2269a089314a3$var$InfoIcon = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "Splashscreen__InfoIcon",
    componentId: "sc-f52qtb-4"
})([
    "width:18px;height:18px;margin:auto;"
]);
const $c9c2269a089314a3$var$InfoMessage = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Splashscreen__InfoMessage",
    componentId: "sc-f52qtb-5"
})([
    "display:flex;flex-direction:column;gap:10px;"
]);
const $c9c2269a089314a3$var$InfoLine = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Splashscreen__InfoLine",
    componentId: "sc-f52qtb-6"
})([
    "font-family:Inter,sans-serif;font-weight:500;font-size:13px;text-align:left;"
]);
const $c9c2269a089314a3$var$LangSelect = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Splashscreen__LangSelect",
    componentId: "sc-f52qtb-7"
})([
    "display:flex;flex-direction:row;justify-content:center;min-height:47px;margin:0 0 24px;"
]);
const $c9c2269a089314a3$var$Caret = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "Splashscreen__Caret",
    componentId: "sc-f52qtb-8"
})([
    "display:block;width:16px;margin:0 0 0 -30px;pointer-events:none;"
]);
const $c9c2269a089314a3$var$Disclaimer = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Splashscreen__Disclaimer",
    componentId: "sc-f52qtb-9"
})([
    "@media(height > 600px){display:none;}"
]);
const $c9c2269a089314a3$var$DisclaimerSection = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Splashscreen__DisclaimerSection",
    componentId: "sc-f52qtb-10"
})([
    "margin:0 auto 16px;"
]);
const $c9c2269a089314a3$var$handleCaretClick = ()=>{
    console.log('caret clicked');
    document.querySelector('select').click();
};
const $c9c2269a089314a3$var$Splashscreen = (props)=>{
    const { emitter: emitter, funnel: funnel } = props;
    const intl = (0, $c569e2e9ecfda3a0$export$2e2bcd8739ae039)();
    const shopSettings = (0, $6cds3.useContext)((0, $f686bfa33774dad2$export$d990cc5f51685546));
    const [aknowledged, setAknowledged] = (0, $6cds3.useState)(false);
    const handlePrimary = (ev)=>{
        // This is to prevent banner from handling click event
        ev.nativeEvent.stopImmediatePropagation();
        if (funnel === (0, $be61b9cfe3f63cb1$export$e059618c1faa2ae1).UNDEFINED || funnel === (0, $be61b9cfe3f63cb1$export$e059618c1faa2ae1).SELF) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`SELF funnel selected`);
            return emitter.emit((0, $965f5d735ba6d674$export$2e2bcd8739ae039).onFunnelSelect, 'SELF');
        }
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('OTHER funnel selected');
        emitter.emit((0, $965f5d735ba6d674$export$2e2bcd8739ae039).onFunnelSelect, 'OTHER');
    };
    const handleSecondary = (ev)=>{
        // This is to prevent banner from handling click event
        ev.nativeEvent.stopImmediatePropagation();
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Handle secondary');
        emitter.emit((0, $965f5d735ba6d674$export$2e2bcd8739ae039).onFunnelSelect, 'OTHER');
    };
    const handleResize = ()=>{
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        const vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`resize ${vh}`);
    };
    const handleLanguageSelect = (ev)=>{
        ev.nativeEvent.stopImmediatePropagation();
        const selectedLang = ev.target.value;
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Language ${selectedLang} selected in Splashscreen ${ev.target}`);
        emitter.emit((0, $965f5d735ba6d674$export$2e2bcd8739ae039).onLanguageSelect, selectedLang);
    };
    const handleAknowledged = (ev)=>{
        setAknowledged(true);
        document.querySelectorAll('button.hide-lt-600').forEach((el)=>el.classList.remove('hide-lt-600'));
    };
    (0, $6cds3.useEffect)(()=>{
        (0, $f188c4e754268d8b$export$2e2bcd8739ae039).updateExitCode('PDP', 'splashscreen.displayed');
        // We listen to the resize event
        window.addEventListener('resize', handleResize);
        // The cleanup function
        return ()=>{
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $b19fd48583540509$export$159cd03be7087f39), {
        emitter: emitter,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c9c2269a089314a3$var$LangSelect, {
                children: shopSettings.languageSelectEnabled && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c9c2269a089314a3$var$CustomSelect, {
                            onChange: handleLanguageSelect,
                            value: intl.locale,
                            children: Object.keys((0, $31c680c31ce1361b$export$67d7e6220353b39d)).map((key)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                    value: key,
                                    children: (0, $31c680c31ce1361b$export$67d7e6220353b39d)[key].name
                                }, key))
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c9c2269a089314a3$var$Caret, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fe549a73eeaa3a4c$exports)))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc2d1ec7e7cbe723$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $327caa885e3be523$export$25c607d6a337a384), {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c9c2269a089314a3$var$Text, {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                            id: "drv.splashscreen.text"
                        })
                    }),
                    !aknowledged && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($c9c2269a089314a3$var$Disclaimer, {
                        className: "disclaimer",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c9c2269a089314a3$var$DisclaimerSection, {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "drv.splashscreen.footer",
                                    values: {
                                        policy: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                                href: "https://footprinttech.de/privacy-policy-webapp/",
                                                target: "_blank",
                                                children: chunks
                                            }),
                                        tos: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                                href: "https://footprinttech.de/terms-of-use-webapp/",
                                                target: "_blank",
                                                children: chunks
                                            })
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c9c2269a089314a3$var$DisclaimerSection, {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "drv.splashscreen.imprint",
                                    values: {
                                        imp: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                                href: "https://footprinttech.de/imprint-webapp/",
                                                target: "_blank",
                                                children: chunks
                                            })
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c9c2269a089314a3$var$DisclaimerSection, {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                                    onClick: handleAknowledged,
                                    type: "button",
                                    className: "wide-primary",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                        id: "common.next"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                        onClick: handlePrimary,
                        type: "button",
                        className: "wide-primary hide-lt-600",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                            id: "drv.splashscreen.option.adult"
                        })
                    }),
                    funnel === (0, $be61b9cfe3f63cb1$export$e059618c1faa2ae1).UNDEFINED && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                        onClick: handleSecondary,
                        type: "button",
                        className: "wide-secondary hide-lt-600",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                            id: "drv.splashscreen.option.child"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($c9c2269a089314a3$var$Info, {
                        className: "hide-lt-700",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c9c2269a089314a3$var$InfoIcon, {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f8f4e7453dd732e1$exports)))
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($c9c2269a089314a3$var$InfoMessage, {
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c9c2269a089314a3$var$InfoLine, {
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                            id: "drv.splashscreen.instructions.paper",
                                            values: {
                                                b: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                                        children: chunks
                                                    })
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c9c2269a089314a3$var$InfoLine, {
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                            id: "drv.splashscreen.instructions.time",
                                            values: {
                                                b: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                                        children: chunks
                                                    })
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $327caa885e3be523$export$a06f1c675e846f6f), {
                className: "hide-lt-600 disclaimer",
                children: [
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).mode === (0, $c40fe7cebd3a81ae$export$770ef1da3280a8ee).VERBOSE && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $327caa885e3be523$export$6e2c8f0811a474ce), {
                        children: [
                            "Driver version: ",
                            (0, $df6536fbed69acd1$exports.version)
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $327caa885e3be523$export$6e2c8f0811a474ce), {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                            id: "drv.splashscreen.footer",
                            values: {
                                policy: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                        href: "https://footprinttech.de/privacy-policy-webapp/",
                                        target: "_blank",
                                        children: chunks
                                    }),
                                tos: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                        href: "https://footprinttech.de/terms-of-use-webapp/",
                                        target: "_blank",
                                        children: chunks
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $327caa885e3be523$export$6e2c8f0811a474ce), {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                            id: "drv.splashscreen.imprint",
                            values: {
                                imp: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                        href: "https://footprinttech.de/imprint-webapp/",
                                        target: "_blank",
                                        children: chunks
                                    })
                            }
                        })
                    })
                ]
            })
        ]
    });
};
var $c9c2269a089314a3$export$2e2bcd8739ae039 = $c9c2269a089314a3$var$Splashscreen;






var $6cds3 = parcelRequire("6cds3");









// High-specificity CSS to override host site styles (e.g., Shopware)
// Using .fpt-modal as parent for increased specificity (works for both mobile and desktop)
const $a7ebcf7a9a77bb69$var$ErrorStyleOverrides = (0, $e94f79f42775c5f5$export$f0f03736edb61697)([
    ".fpt-modal{box-sizing:border-box !important;font-family:'Inter',sans-serif !important;.fpt-c-error-page-container{align-items:center !important;top:0 !important;left:0 !important;width:100% !important;display:flex !important;flex-direction:column !important;height:100% !important;box-sizing:border-box !important;}.fpt-c-error-page{padding-top:0 !important;padding-left:0.5rem !important;padding-right:0.5rem !important;display:flex !important;flex-direction:column !important;align-items:center !important;height:100% !important;min-height:100% !important;width:100% !important;box-sizing:border-box !important;}.fpt-c-error-blue-box-layout{display:flex !important;flex-direction:column !important;justify-content:space-between !important;align-items:center !important;width:100% !important;min-height:calc(100vh - 116px) !important;padding:64px 12px 12px 12px !important;box-sizing:border-box !important;}@media (min-width:601px){.fpt-c-error-blue-box-layout{min-height:auto !important;padding:20px 12px 20px 12px !important;gap:24px !important;}.fpt-c-error-content{align-items:center !important;text-align:center !important;}.fpt-c-error-title{text-align:center !important;}.fpt-c-error-body{text-align:center !important;}}.fpt-c-error-top-section{display:flex !important;flex-direction:column !important;align-items:center !important;gap:32px !important;width:100% !important;}.fpt-c-error-blue-box{position:relative !important;width:345px !important;height:240px !important;padding:0 !important;background:#E0ECF8 !important;border-radius:30px !important;display:flex !important;align-items:center !important;justify-content:center !important;box-sizing:border-box !important;}.fpt-c-error-blue-box-illustration{max-width:128px !important;max-height:128px !important;width:100% !important;height:auto !important;display:block !important;margin:0 auto !important;object-fit:contain !important;}.fpt-c-error-blue-box-exclamation{position:absolute !important;top:20px !important;left:20px !important;width:48px !important;height:48px !important;}.fpt-c-error-content{display:flex !important;flex-direction:column !important;align-items:flex-start !important;text-align:left !important;max-width:345px !important;width:100% !important;gap:12px !important;padding:0 !important;box-sizing:border-box !important;}.fpt-c-error-title{font-family:'Inter',sans-serif !important;font-size:20px !important;font-weight:700 !important;color:#000000 !important;margin:0 !important;line-height:28px !important;text-align:left !important;}.fpt-c-error-body{font-family:'Inter',sans-serif !important;font-size:16px !important;font-weight:500 !important;color:#000000 !important;margin:0 !important;line-height:24px !important;text-align:left !important;}.fpt-c-error-infobox-text{font-family:'Inter',sans-serif !important;font-size:16px !important;font-weight:500 !important;color:#000000 !important;margin:0 !important;line-height:24px !important;text-align:left !important;}.fpt-c-error-actions-bottom{display:flex !important;flex-direction:column !important;align-items:center !important;width:100% !important;max-width:345px !important;gap:12px !important;margin-top:0 !important;padding:0 !important;box-sizing:border-box !important;}.fpt-c-actions-button-container{display:flex !important;align-content:center !important;justify-content:center !important;width:100% !important;margin:0 !important;}.fpt-c-error-actions-bottom .fpt-btn{font-family:'Inter',sans-serif !important;font-size:16px !important;font-weight:500 !important;width:345px !important;height:56px !important;border-radius:100px !important;padding:0 !important;display:inline-flex !important;align-items:center !important;justify-content:center !important;text-align:center !important;line-height:1 !important;cursor:pointer !important;box-sizing:border-box !important;margin:0 !important;text-decoration:none !important;}.fpt-c-error-actions-bottom .fpt-btn--wide-primary-round{background-color:rgb(30,78,95) !important;color:#ffffff !important;border:none !important;}.fpt-c-error-actions-bottom .fpt-btn--link-primary{background-color:transparent !important;color:rgb(30,78,95) !important;border:1px solid rgb(30,78,95) !important;text-decoration:none !important;}@media (max-width:375px){.fpt-c-error-blue-box-layout{padding:40px 24px 16px 24px !important;justify-content:flex-start !important;gap:20px !important;}.fpt-c-error-top-section{gap:20px !important;}.fpt-c-error-blue-box{height:200px !important;width:100% !important;max-width:345px !important;}.fpt-c-error-blue-box-illustration{max-width:110px !important;max-height:110px !important;}.fpt-c-error-title{font-size:18px !important;line-height:26px !important;}.fpt-c-error-body,.fpt-c-error-infobox-text{font-size:14px !important;line-height:22px !important;}.fpt-c-error-actions-bottom{margin-top:auto !important;padding-bottom:8px !important;}}}"
]);
// Styled components defined outside the component to avoid recreation on each render
// Mobile fullscreen container
const $a7ebcf7a9a77bb69$var$ErrorContainer = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ErrorPanelStandalone__ErrorContainer",
    componentId: "sc-cu2m3l-0"
})([
    "display:flex;flex-direction:column;width:100%;min-height:100vh;min-height:calc(var(--vh,1vh) * 100);background-color:#fff;position:relative;"
]);
// Desktop modal container
const $a7ebcf7a9a77bb69$var$DesktopOuterContainer = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ErrorPanelStandalone__DesktopOuterContainer",
    componentId: "sc-cu2m3l-1"
})([
    "width:633px;padding:25px;border-radius:30px;background-color:#f8fcfd;margin:auto;"
]);
const $a7ebcf7a9a77bb69$var$DesktopInnerContainer = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ErrorPanelStandalone__DesktopInnerContainer",
    componentId: "sc-cu2m3l-2"
})([
    "padding-bottom:10px;border-radius:20px;box-shadow:0 0 8px 0 rgba(0,0,0,0.13);background-color:#fff;position:relative;"
]);
const $a7ebcf7a9a77bb69$var$CloseButton = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).button.withConfig({
    displayName: "ErrorPanelStandalone__CloseButton",
    componentId: "sc-cu2m3l-3"
})([
    "position:absolute;top:16px;right:24px;background:none;border:none;font-size:18px;color:var(--dark-slate-blue);cursor:pointer;width:46px;z-index:101;"
]);
const $a7ebcf7a9a77bb69$var$DesktopCloseButton = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).button.withConfig({
    displayName: "ErrorPanelStandalone__DesktopCloseButton",
    componentId: "sc-cu2m3l-4"
})([
    "position:absolute;top:10px;right:10px;background:none;border:none;font-size:18px;color:var(--dark-slate-blue);cursor:pointer;width:46px;z-index:3;"
]);
const $a7ebcf7a9a77bb69$var$CloseIcon = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "ErrorPanelStandalone__CloseIcon",
    componentId: "sc-cu2m3l-5"
})([
    ""
]);
const $a7ebcf7a9a77bb69$var$SpinnerContainer = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ErrorPanelStandalone__SpinnerContainer",
    componentId: "sc-cu2m3l-6"
})([
    "display:flex;justify-content:center;align-items:center;padding:40px;height:100%;&.fpt-show{display:flex;}&.fpt-hide{display:none;}"
]);
const $a7ebcf7a9a77bb69$var$ErrorContent = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ErrorPanelStandalone__ErrorContent",
    componentId: "sc-cu2m3l-7"
})([
    "flex:1;display:flex;flex-direction:column;&.fpt-show{display:flex;}&.fpt-hide{display:none;}"
]);
const $a7ebcf7a9a77bb69$export$1e2b370e05744247 = (props)=>{
    const { error: error, emitter: emitter } = props;
    const shopSettings = (0, $6cds3.useContext)((0, $f686bfa33774dad2$export$d990cc5f51685546));
    const i18nNamespace = shopSettings.theme?.i18nNamespace;
    const initialLoadingState = !!i18nNamespace;
    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('custom translation detected:', initialLoadingState);
    const [isLoading, setLoading] = (0, $6cds3.useState)(initialLoadingState);
    const lang = shopSettings.lang || (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getLang();
    // Handle viewport height for mobile browsers
    (0, $6cds3.useEffect)(()=>{
        const handleResize = ()=>{
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        handleResize(); // Set initial value
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    (0, $6cds3.useEffect)(()=>{
        (0, $3fe9119940fa16b8$export$a7357cdd1f0b0168).changeLanguage(lang);
        if (isLoading) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Loading custom translation', i18nNamespace);
            (0, $3fe9119940fa16b8$export$a7357cdd1f0b0168).loadNamespaces(i18nNamespace).then(()=>{
                (0, $3fe9119940fa16b8$export$a7357cdd1f0b0168).setDefaultNamespace(i18nNamespace);
                setLoading(false);
            }).catch((err)=>{
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).error(err.message);
                setLoading(false);
            });
        }
    }, [
        isLoading
    ]);
    const isMobile = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).isMobile();
    // Mobile: fullscreen layout with CSS injection for host site override
    if (isMobile) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a7ebcf7a9a77bb69$var$ErrorStyleOverrides, {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($a7ebcf7a9a77bb69$var$ErrorContainer, {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a7ebcf7a9a77bb69$var$CloseButton, {
                        type: "button",
                        onClick: (ev)=>{
                            ev.nativeEvent.stopImmediatePropagation();
                            emitter.emit((0, $933ab13c7a65596b$export$2e2bcd8739ae039).onCloseModalPress);
                        },
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a7ebcf7a9a77bb69$var$CloseIcon, {
                            src: (0, $17bf087df6a33d6e$export$ec7dcaac71d9599d).close,
                            width: 34
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a7ebcf7a9a77bb69$var$SpinnerContainer, {
                        className: isLoading ? 'fpt-show' : 'fpt-hide',
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4bcd374aec1dcbc0$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a7ebcf7a9a77bb69$var$ErrorContent, {
                        className: isLoading ? 'fpt-hide' : 'fpt-show',
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3fe9119940fa16b8$export$65db35c377fab04b), {
                            code: error.errorCode,
                            source: "PDP",
                            hideAction: false,
                            emitter: emitter,
                            showFeedbackLink: false
                        })
                    })
                ]
            })
        ]
    });
    // Desktop: modal container layout
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a7ebcf7a9a77bb69$var$ErrorStyleOverrides, {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a7ebcf7a9a77bb69$var$DesktopOuterContainer, {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($a7ebcf7a9a77bb69$var$DesktopInnerContainer, {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a7ebcf7a9a77bb69$var$DesktopCloseButton, {
                            type: "button",
                            onClick: (ev)=>{
                                ev.nativeEvent.stopImmediatePropagation();
                                emitter.emit((0, $933ab13c7a65596b$export$2e2bcd8739ae039).onCloseModalPress);
                            },
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a7ebcf7a9a77bb69$var$CloseIcon, {
                                src: (0, $17bf087df6a33d6e$export$ec7dcaac71d9599d).close,
                                width: 34
                            })
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a7ebcf7a9a77bb69$var$SpinnerContainer, {
                            className: isLoading ? 'fpt-show' : 'fpt-hide',
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4bcd374aec1dcbc0$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a7ebcf7a9a77bb69$var$ErrorContent, {
                            className: isLoading ? 'fpt-hide' : 'fpt-show',
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3fe9119940fa16b8$export$65db35c377fab04b), {
                                code: error.errorCode,
                                source: "PDP",
                                hideAction: true,
                                emitter: emitter,
                                showFeedbackLink: false
                            })
                        })
                    ]
                })
            })
        ]
    });
};





parcelRequire("6cds3");



const $0ad581e3fe992b71$var$rotation = (0, $e94f79f42775c5f5$export$d25ddfdf17c3ad3e)([
    "from{transform:rotate(0deg);}to{transform:rotate(359deg);}"
]);
const $0ad581e3fe992b71$export$7f7cbe89f1eacd2 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "Elements__Spinner",
    componentId: "sc-v8j0vg-0"
})([
    "animation:",
    " 2s infinite linear;"
], $0ad581e3fe992b71$var$rotation);
const $0ad581e3fe992b71$export$2ddb90ad54e5f587 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__Panel",
    componentId: "sc-v8j0vg-1"
})([
    "display:flex;flex-direction:column;justify-content:space-around;align-items:center;text-align:center;padding:5rem;"
]);
const $0ad581e3fe992b71$export$f69c19e57285b83a = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__Message",
    componentId: "sc-v8j0vg-2"
})([
    "margin-bottom:5rem;width:19.688rem;color:#1e4e5f;"
]);


const $eec98fae97f21498$var$cssGradientBG = `

  .fpt-modal-gradient {
    background: rgb(253, 245, 236);
    background: linear-gradient(180deg, rgba(224, 236, 248, 1) 0%, rgba(253, 245, 236, 1) 100%);
  }
`;
var $eec98fae97f21498$export$2e2bcd8739ae039 = $eec98fae97f21498$var$cssGradientBG;


function $b334d33ba2ab3cb9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $0ad581e3fe992b71$export$2ddb90ad54e5f587), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("style", {
                children: (0, $eec98fae97f21498$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $0ad581e3fe992b71$export$f69c19e57285b83a), {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                            id: "drv.processing.title"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                            id: "drv.processing.message"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0ad581e3fe992b71$export$7f7cbe89f1eacd2), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9939214ecd607d1c$exports)))
                })
            })
        ]
    });
}




var $09c49347251b405e$exports = {};

$09c49347251b405e$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "UniversalSans-v1-2-50-100-0-713112212111-01-600.21f24dfd.woff";


var $a3076f649fc38fea$exports = {};

$a3076f649fc38fea$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "UniversalSans-v1-2-50-100-0-713112212111-01-890.e1f0a0d5.woff";


var $67fe385d435fedb1$exports = {};

$67fe385d435fedb1$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "SourceSans3-Regular.c0531453.ttf";


var $4c692eed97643bec$exports = {};

$4c692eed97643bec$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "Inter-Regular.21ee491a.ttf";


var $8eea8ff4d5a19a60$exports = {};

$8eea8ff4d5a19a60$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "Inter-Medium.d81b2b8e.ttf";


var $0493a9d9b0c6785a$exports = {};

$0493a9d9b0c6785a$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "Inter-SemiBold.9d533a97.ttf";


var $6cdfb849a0b2425e$exports = {};

$6cdfb849a0b2425e$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "Inter-Bold.2a398d70.ttf";


var $b20b7ee71e821bf8$exports = {};

$b20b7ee71e821bf8$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "Inter-900.4c50ba1d.ttf";


var $02e3aa54fac6a445$exports = {};

$02e3aa54fac6a445$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "Rubik-Regular.9c6c8506.ttf";


var $7b9676bef19fefec$exports = {};

$7b9676bef19fefec$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "Rubik-SemiBold.b8efe26a.ttf";


var $f5ea8ad318f62ae7$exports = {};

$f5ea8ad318f62ae7$exports = (parcelRequire("17QCl")).getBundleURL('cTKOQ') + "Rubik-Bold.9884cdc5.ttf";



const $3a69ac4f592126f9$export$5f251580d3bb9e3b = (0, $e94f79f42775c5f5$export$f0f03736edb61697)([
    "@font-face{font-family:\"UniversalSans600\";font-weight:600;font-style:normal;src:url(",
    ") format(\"woff\");font-display:swap;}@font-face{font-family:\"UniversalSans900\";font-weight:900;font-style:normal;src:url(",
    ") format(\"woff\");font-display:swap;}@font-face{font-family:\"SourceSans3\";font-weight:400;font-style:normal;src:url(",
    ") format(\"truetype\");font-display:swap;}@font-face{font-family:\"Inter\";font-weight:400;font-style:normal;src:url(",
    ") format(\"truetype\");font-display:swap;}@font-face{font-family:\"Inter\";font-weight:500;font-style:normal;src:url(",
    ") format(\"truetype\");font-display:swap;}@font-face{font-family:\"Inter\";font-weight:600;font-style:normal;src:url(",
    ") format(\"truetype\");font-display:swap;}@font-face{font-family:\"Inter\";font-weight:700;font-style:normal;src:url(",
    ") format(\"truetype\");font-display:swap;}@font-face{font-family:\"Inter\";font-weight:900;font-style:normal;src:url(",
    ") format(\"truetype\");font-display:swap;}@font-face{font-family:\"Rubik\";font-weight:700;font-style:normal;src:url(",
    ") format(\"truetype\");font-display:swap;}@font-face{font-family:\"Rubik\";font-weight:600;font-style:normal;src:url(",
    ") format(\"truetype\");font-display:swap;}@font-face{font-family:\"Rubik\";font-weight:400;font-style:normal;src:url(",
    ") format(\"truetype\");font-display:swap;}"
], (0, (/*@__PURE__*/$parcel$interopDefault($09c49347251b405e$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($a3076f649fc38fea$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($67fe385d435fedb1$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($4c692eed97643bec$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($8eea8ff4d5a19a60$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($0493a9d9b0c6785a$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($6cdfb849a0b2425e$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($b20b7ee71e821bf8$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($f5ea8ad318f62ae7$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($7b9676bef19fefec$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($02e3aa54fac6a445$exports))));



parcelRequire("6cds3");
const $2cb108e2a7aeb9da$export$4e07085c8feeec9 = (props)=>{
    const { src: src } = props;
    const host = window.location.host;
    const fptAppUrl = new URL(src);
    const params = fptAppUrl.search;
    const measurementUrl = `https://${host}/measurement/${params}`;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("style", {
                children: `
      html {
        overflow: auto;
      }

      html, body, div, iframe {
        margin: 0px;
        padding: 0px;
        height: 100%;
        border: none;
      }

      iframe {
       display: block;
       width: 100%;
       border: none;
       overflow-y: auto;
       overflow-x: hidden;
      }
      `
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("iframe", {
                id: "FPT-MEA-FRAME",
                name: "MeasurementFrame",
                src: measurementUrl,
                width: "100%",
                height: "100%",
                scrolling: "auto",
                allow: "fullscreen;camera;accelerometer;gyroscope;autoplay;"
            })
        ]
    });
};






var $6cds3 = parcelRequire("6cds3");




const $8212cbecc74d50b4$var$Events = {
    onLanguageSelect: 'onLanguageSelect',
    onMeasureOptionSelect: 'onMeasureOptionSelect',
    onMeasureOptionConfirm: 'onMeasureOptionConfirm',
    onSpeedOptionSelect: 'onSpeedOptionSelect',
    onSpeedOptionConfirm: 'onSpeedOptionConfirm',
    onContinuePress: 'onContinuePress'
};
var $8212cbecc74d50b4$export$2e2bcd8739ae039 = $8212cbecc74d50b4$var$Events;




parcelRequire("6cds3");


const $f05930f741b5220d$var$FPTLogo = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "LogoPanel__FPTLogo",
    componentId: "sc-zvliiy-0"
})([
    "display:block;max-height:5vh;min-height:25px;margin:4vh auto 12px;"
]);
const $f05930f741b5220d$var$LogoPanel = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($f05930f741b5220d$var$FPTLogo, {
        src: (0, $eb35e4b56fe508da$export$94b076129cf5f782) + '/logos/fpt_logo_splashscreen.png'
    });
};
var $f05930f741b5220d$export$2e2bcd8739ae039 = $f05930f741b5220d$var$LogoPanel;



const $26ab366f71d6d646$export$8b251419efc915eb = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Common__Header",
    componentId: "sc-1ynnq08-0"
})([
    "font-family:Rubik,sans-serif !important;font-weight:600;font-stretch:normal;font-style:normal;margin-top:40px;line-height:1.67;letter-spacing:normal;text-align:center;font-size:18px;line-height:1.25;color:#1e4e5f;"
]);
const $26ab366f71d6d646$export$5f1af8db9871e1d6 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).p.withConfig({
    displayName: "Common__Text",
    componentId: "sc-1ynnq08-1"
})([
    "font-family:Inter,sans-serif;font-weight:400;font-size:12px;font-stretch:normal;font-style:normal;margin-top:20px;padding-left:40px;padding-right:40px;line-height:1.67;letter-spacing:normal;text-align:center;color:var(--dark-slate-blue);"
]);







parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");


const $dc8fd55e10c13ecd$export$23191e4434a9e834 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__Welcome",
    componentId: "sc-n4a2go-0"
})([
    "font-family:Inter,sans-serif;font-size:16px;font-weight:600;font-stretch:normal;font-style:normal;line-height:1.4;letter-spacing:normal;text-align:center;color:#000;margin-bottom:30px;"
]);
const $dc8fd55e10c13ecd$export$ed2cd9eb2d1973f0 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__InfoText",
    componentId: "sc-n4a2go-1"
})([
    "font-family:Inter,sans-serif;font-size:16px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:normal;text-align:left;color:#000;margin-bottom:16px;"
]);
const $dc8fd55e10c13ecd$export$57787c74aad1300f = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__OptionCard",
    componentId: "sc-n4a2go-2"
})([
    "display:flex;gap:16px;background:white;border:1px solid #bbcad3;border-radius:15px;padding:24px;margin-bottom:12px;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:none !important;overflow:hidden;flex-shrink:0;&.selected{border:1px solid ",
    ";box-shadow:0 0 0 1px ",
    ";}&.selected>.radio-circle{border-color:",
    ";background-color:",
    ";transition:none !important;}&.selected>.radio-circle::after{content:\"\";position:absolute;top:50%;left:50%;width:12px;height:12px;background-color:white;border-radius:50%;transform:translate(-50%,-50%);}"
], (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue'], (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue'], (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue'], (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue']);
const $dc8fd55e10c13ecd$export$b381d9a2f3b4390b = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__OptionContent",
    componentId: "sc-n4a2go-3"
})([
    "flex:1;"
]);
const $dc8fd55e10c13ecd$export$cbe66ba5a24d87ce = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "Elements__OptionIcon",
    componentId: "sc-n4a2go-4"
})([
    "width:48px;height:48px;"
]);
const $dc8fd55e10c13ecd$export$58781199e4cf5b3b = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__RadioCircle",
    componentId: "sc-n4a2go-5"
})([
    "width:22px;height:22px;border:2px solid #bbcad3;border-radius:50%;margin-left:16px;position:relative;transition:none !important;"
]);
const $dc8fd55e10c13ecd$export$41ac0950c7d0e9ed = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).h2.withConfig({
    displayName: "Elements__OptionTitle",
    componentId: "sc-n4a2go-6"
})([
    "color:",
    ";font-family:Inter,sans-serif;font-weight:500;font-size:18px;margin:0 0 4px;text-align:left;"
], (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue']);
const $dc8fd55e10c13ecd$export$bc8a2c0cb86bc4e4 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).p.withConfig({
    displayName: "Elements__OptionDescription",
    componentId: "sc-n4a2go-7"
})([
    "opacity:0.8;font-family:Inter,sans-serif;font-size:14px;font-weight:500;font-stretch:normal;font-style:normal;letter-spacing:normal;line-height:1.4 !important;margin:0;text-align:left;color:",
    ";&.height-auto{height:auto;}"
], (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue']);
const $dc8fd55e10c13ecd$export$ef1326a87b3d056d = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__OptionInfo",
    componentId: "sc-n4a2go-8"
})([
    "display:flex;gap:10px;font-family:Inter,sans-serif;font-size:12px;font-weight:500;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:normal;text-align:left;color:#000;margin-bottom:0;"
]);
const $dc8fd55e10c13ecd$export$2957fc44b3d2481 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "Elements__InfoIcon",
    componentId: "sc-n4a2go-9"
})([
    "display:block;width:18px;height:18px;"
]);








function $dc97d93a511d9f60$export$c29b0b29d6d8b2d(props) {
    const { emitter: emitter } = props;
    const shopSettings = (0, $6cds3.useContext)((0, $f686bfa33774dad2$export$d990cc5f51685546));
    const [selectedOption, setSelectedOption] = (0, $6cds3.useState)('');
    const [continueEnabled, setContinueEnabled] = (0, $6cds3.useState)(false);
    const handleMinipodSelect = (ev)=>{
        ev.nativeEvent.stopImmediatePropagation();
        setSelectedOption((0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).MC);
        emitter.emit((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onMeasureOptionSelect, (0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).MC);
        setContinueEnabled(true);
    };
    const handlePiSelect = (ev)=>{
        ev.nativeEvent.stopImmediatePropagation();
        setSelectedOption((0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).PI);
        emitter.emit((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onMeasureOptionSelect, (0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).PI);
        setContinueEnabled(true);
    };
    const handleManualSelect = (ev)=>{
        ev.nativeEvent.stopImmediatePropagation();
        setSelectedOption((0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).NONE);
        emitter.emit((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onMeasureOptionSelect, (0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).NONE);
        setContinueEnabled(true);
    };
    const handleMobileSelect = (ev)=>{
        ev.nativeEvent.stopImmediatePropagation();
        setSelectedOption((0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).FPT);
        emitter.emit((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onMeasureOptionSelect, (0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).FPT);
        setContinueEnabled(true);
    };
    const handleContinue = (ev)=>{
        ev.nativeEvent.stopImmediatePropagation();
        console.log('continue clicked');
        emitter.emit((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onMeasureOptionConfirm, selectedOption);
        emitter.emit((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onContinuePress);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$23191e4434a9e834), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "lp.hartmann.input-selection.title",
                    values: {
                        br: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {})
                    }
                })
            }),
            shopSettings.mcEnabled && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc8fd55e10c13ecd$export$57787c74aad1300f), {
                id: "option-minipod",
                onClick: handleMinipodSelect,
                className: selectedOption === (0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).MC ? 'selected' : '',
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$cbe66ba5a24d87ce), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($94b3f5bacabe218d$exports))),
                        alt: "Minipod"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc8fd55e10c13ecd$export$b381d9a2f3b4390b), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$41ac0950c7d0e9ed), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "lp.hartmann.input-selection.option.minipod.title"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$bc8a2c0cb86bc4e4), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "lp.hartmann.input-selection.option.minipod.description"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$58781199e4cf5b3b), {
                        className: "radio-circle"
                    })
                ]
            }),
            shopSettings.insoleAvailable && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc8fd55e10c13ecd$export$57787c74aad1300f), {
                id: "option-pi",
                onClick: handlePiSelect,
                className: selectedOption === (0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).PI ? 'selected' : '',
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$cbe66ba5a24d87ce), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($94b3f5bacabe218d$exports))),
                        alt: "Plantar Image"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc8fd55e10c13ecd$export$b381d9a2f3b4390b), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$41ac0950c7d0e9ed), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "drv.input-selection.option.pi.title"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$bc8a2c0cb86bc4e4), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "drv.input-selection.option.pi.description"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$58781199e4cf5b3b), {
                        className: "radio-circle"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc8fd55e10c13ecd$export$57787c74aad1300f), {
                id: "option-mobile",
                onClick: handleMobileSelect,
                className: selectedOption === (0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).FPT ? 'selected' : '',
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$cbe66ba5a24d87ce), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($600ae0e314012ef9$exports))),
                        alt: "Mobile"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc8fd55e10c13ecd$export$b381d9a2f3b4390b), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$41ac0950c7d0e9ed), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "lp.hartmann.input-selection.option.mobile.title"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$bc8a2c0cb86bc4e4), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "lp.hartmann.input-selection.option.mobile.description"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$58781199e4cf5b3b), {
                        className: "radio-circle"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc8fd55e10c13ecd$export$57787c74aad1300f), {
                id: "option-manual",
                onClick: handleManualSelect,
                className: selectedOption === (0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).NONE ? 'selected' : '',
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$cbe66ba5a24d87ce), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d04b9de496336dfb$exports))),
                        alt: "Minipod"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc8fd55e10c13ecd$export$b381d9a2f3b4390b), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$41ac0950c7d0e9ed), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "lp.hartmann.input-selection.option.skip-arch-measurement.title"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$bc8a2c0cb86bc4e4), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "lp.hartmann.input-selection.option.skip-arch-measurement.description"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$58781199e4cf5b3b), {
                        className: "radio-circle"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                disabled: continueEnabled ? false : true,
                onClick: handleContinue,
                type: "button",
                className: "wide-primary",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "lp.hartmann.input-selection.continue"
                })
            })
        ]
    });
}




var $6cds3 = parcelRequire("6cds3");
var $c423b76e7a9af3b2$export$4104c4f351fcab7a = /*#__PURE__*/ function(SPEED_OPTION) {
    SPEED_OPTION["STANDARD"] = "STANDARD";
    SPEED_OPTION["FAST_TRACK"] = "FAST_TRACK";
    return SPEED_OPTION;
}({});







function $93af4a56942b3f7a$export$b8b0235f29fe3978(props) {
    const { emitter: emitter } = props;
    // const shopSettings = useContext(ShopSettingsContext);
    const [selectedOption, setSelectedOption] = (0, $6cds3.useState)('');
    const [continueEnabled, setContinueEnabled] = (0, $6cds3.useState)(false);
    const handleContinue = (ev)=>{
        ev.nativeEvent.stopImmediatePropagation();
        console.log('continue clicked');
        // setContinueEnabled(false);
        // setCurrentOptions(measureOptions);
        emitter.emit((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onSpeedOptionConfirm, selectedOption);
        emitter.emit((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onContinuePress);
    };
    const handleStandardSelect = (ev)=>{
        ev.nativeEvent.stopImmediatePropagation();
        setSelectedOption((0, $c423b76e7a9af3b2$export$4104c4f351fcab7a).STANDARD);
        emitter.emit((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onSpeedOptionSelect, (0, $c423b76e7a9af3b2$export$4104c4f351fcab7a).STANDARD);
        setContinueEnabled(true);
    };
    const handleFastTrackSelect = (ev)=>{
        ev.nativeEvent.stopImmediatePropagation();
        setSelectedOption((0, $c423b76e7a9af3b2$export$4104c4f351fcab7a).FAST_TRACK);
        emitter.emit((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onSpeedOptionSelect, (0, $c423b76e7a9af3b2$export$4104c4f351fcab7a).FAST_TRACK);
        setContinueEnabled(true);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$23191e4434a9e834), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "drv.input-selection.speed-options.title",
                    values: {
                        br: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {})
                    }
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$ed2cd9eb2d1973f0), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "drv.input-selection.speed-options.info1",
                    values: {
                        br: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {})
                    }
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc8fd55e10c13ecd$export$57787c74aad1300f), {
                id: "option-mobile",
                onClick: handleStandardSelect,
                className: selectedOption === (0, $c423b76e7a9af3b2$export$4104c4f351fcab7a).STANDARD ? 'selected' : '',
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$cbe66ba5a24d87ce), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d04b9de496336dfb$exports))),
                        alt: "Mobile"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc8fd55e10c13ecd$export$b381d9a2f3b4390b), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$41ac0950c7d0e9ed), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "drv.input-selection.option.standard-track.title"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$bc8a2c0cb86bc4e4), {
                                className: "height-auto",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "drv.input-selection.option.standard-track.description"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$58781199e4cf5b3b), {
                        className: "radio-circle"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc8fd55e10c13ecd$export$57787c74aad1300f), {
                id: "option-mobile",
                onClick: handleFastTrackSelect,
                className: selectedOption === (0, $c423b76e7a9af3b2$export$4104c4f351fcab7a).FAST_TRACK ? 'selected' : '',
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$cbe66ba5a24d87ce), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($048fc34eed151acf$exports))),
                        alt: "Mobile"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc8fd55e10c13ecd$export$b381d9a2f3b4390b), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$41ac0950c7d0e9ed), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "drv.input-selection.option.fast-track.title"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$bc8a2c0cb86bc4e4), {
                                className: "height-auto",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "drv.input-selection.option.fast-track.description"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc8fd55e10c13ecd$export$ef1326a87b3d056d), {
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$2957fc44b3d2481), {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f8f4e7453dd732e1$exports))),
                                        alt: "Mobile"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                        id: "drv.input-selection.option.fast-track.info"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$58781199e4cf5b3b), {
                        className: "radio-circle"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc8fd55e10c13ecd$export$ed2cd9eb2d1973f0), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "drv.input-selection.speed-options.info2",
                    values: {
                        br: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {})
                    }
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                disabled: continueEnabled ? false : true,
                onClick: handleContinue,
                type: "button",
                className: "wide-primary",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: "lp.hartmann.input-selection.continue"
                })
            })
        ]
    });
}


const $d75d07de4e00e4b6$var$OptionsComponent = (props)=>{
    const { emitter: emitter, currentOptions: currentOptions } = props;
    const AvailableOptions = [
        (0, $93af4a56942b3f7a$export$b8b0235f29fe3978),
        (0, $dc97d93a511d9f60$export$c29b0b29d6d8b2d)
    ];
    const Options = AvailableOptions[currentOptions];
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Options, {
        emitter: emitter
    });
};
var $d75d07de4e00e4b6$export$2e2bcd8739ae039 = $d75d07de4e00e4b6$var$OptionsComponent;



// Define CSS variables
const $c8bf5bcfe2efd4a1$var$Variables = {
    polly: '#e0ecf8',
    almond: '#fdf5ec'
};
const $c8bf5bcfe2efd4a1$var$Text = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "InputSelection__Text",
    componentId: "sc-eird80-0"
})([
    "font:700 3vh/1.36 Inter,sans-serif;margin-bottom:25px;"
]);
const $c8bf5bcfe2efd4a1$var$Blank = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "InputSelection__Blank",
    componentId: "sc-eird80-1"
})([
    "height:250px;"
]);
const $c8bf5bcfe2efd4a1$var$customCss = `

.fpt-modal {
  position: relative;
  overflow: auto;
}

.disclaimer {
  display: none;
}

`;
const $c8bf5bcfe2efd4a1$var$InputSelection = (props)=>{
    const { emitter: emitter } = props;
    const intl = (0, $c569e2e9ecfda3a0$export$2e2bcd8739ae039)();
    const speedOptions = 0, measureOptions = 1;
    const shopSettings = (0, $6cds3.useContext)((0, $f686bfa33774dad2$export$d990cc5f51685546));
    const { powerMode: powerMode } = shopSettings;
    const [selectedMeasureOption, setSelectedMeasureOption] = (0, $6cds3.useState)('');
    const [selectedSpeedOption, setSelectedSpeedOption] = (0, $6cds3.useState)('');
    const [currentOptions, setCurrentOptions] = (0, $6cds3.useState)(powerMode === (0, $be61b9cfe3f63cb1$export$84adad34d27dc394).OPTIONAL ? speedOptions : measureOptions);
    const [continueEnabled, setContinueEnabled] = (0, $6cds3.useState)(false);
    const handleMeasureOptionSelect = (option)=>{
        setSelectedMeasureOption(option);
        setContinueEnabled(true);
    };
    const handleSpeedOptionSelect = (option)=>{
        setSelectedSpeedOption(option);
        setContinueEnabled(true);
    };
    const handleContinue = (ev)=>{
        console.log('continue clicked');
        if (currentOptions === speedOptions) {
            setContinueEnabled(false);
            setCurrentOptions(measureOptions);
            emitter.emit((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onSpeedOptionConfirm, selectedSpeedOption);
        } else if (powerMode === (0, $be61b9cfe3f63cb1$export$84adad34d27dc394).NONE) {
            setCurrentOptions(measureOptions);
            emitter.emit((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onSpeedOptionConfirm, selectedSpeedOption);
        } else emitter.emit((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onMeasureOptionConfirm, selectedMeasureOption);
    };
    (0, $6cds3.useEffect)(()=>{
        (0, $f188c4e754268d8b$export$2e2bcd8739ae039).updateExitCode('PDP', 'input-selection.displayed');
        emitter.addListener((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onMeasureOptionSelect, handleMeasureOptionSelect);
        emitter.addListener((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onSpeedOptionSelect, handleSpeedOptionSelect);
        emitter.addListener((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onContinuePress, handleContinue);
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Power mode: ${powerMode}`);
        if (powerMode === (0, $be61b9cfe3f63cb1$export$84adad34d27dc394).MANDATORY) {
            setSelectedSpeedOption((0, $c423b76e7a9af3b2$export$4104c4f351fcab7a).FAST_TRACK);
            emitter.emit((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onSpeedOptionConfirm, (0, $c423b76e7a9af3b2$export$4104c4f351fcab7a).FAST_TRACK);
        }
    }, []);
    (0, $6cds3.useEffect)(()=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Switching current options to ${currentOptions}`);
    }, [
        currentOptions
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $b19fd48583540509$export$159cd03be7087f39), {
        emitter: emitter,
        isClosable: false,
        style: {
            backgroundImage: `linear-gradient(to bottom, ${$c8bf5bcfe2efd4a1$var$Variables.polly}, ${$c8bf5bcfe2efd4a1$var$Variables.almond})`
        },
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("style", {
                children: $c8bf5bcfe2efd4a1$var$customCss
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f05930f741b5220d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $327caa885e3be523$export$25c607d6a337a384), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d75d07de4e00e4b6$export$2e2bcd8739ae039), {
                    emitter: emitter,
                    currentOptions: currentOptions
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $327caa885e3be523$export$a06f1c675e846f6f), {
                className: "disclaimer",
                children: [
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).mode === (0, $c40fe7cebd3a81ae$export$770ef1da3280a8ee).VERBOSE && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $327caa885e3be523$export$6e2c8f0811a474ce), {
                        children: [
                            "Driver version: ",
                            (0, $df6536fbed69acd1$exports.version)
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $327caa885e3be523$export$6e2c8f0811a474ce), {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                            disabled: continueEnabled ? false : true,
                            onClick: handleContinue,
                            type: "button",
                            className: "wide-primary",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                id: "lp.hartmann.input-selection.continue"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $c8bf5bcfe2efd4a1$export$2e2bcd8739ae039 = $c8bf5bcfe2efd4a1$var$InputSelection;






var $6cds3 = parcelRequire("6cds3");





const $dc9ac8f3a95fc864$export$9891425d2ed93dbf = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "Elements__FPTLogo",
    componentId: "sc-1d5akza-0"
})([
    "display:block;max-height:5vh;min-height:25px;margin:4vh auto 20px;"
]);
const $dc9ac8f3a95fc864$export$7f7cbe89f1eacd2 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "Elements__Spinner",
    componentId: "sc-1d5akza-1"
})([
    "width:50px;height:50px;margin:0 auto;"
]);
const $dc9ac8f3a95fc864$export$25c607d6a337a384 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__ContentPanel",
    componentId: "sc-1d5akza-2"
})([
    "flex:auto;text-align:center;display:flex;flex-direction:column;width:100%;gap:34px;"
]);
const $dc9ac8f3a95fc864$export$f330f2aa9e6816a5 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__HeaderPanel",
    componentId: "sc-1d5akza-3"
})([
    "display:flex;flex-direction:column;gap:12px;"
]);
const $dc9ac8f3a95fc864$export$7177f7f0cf0ed109 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__PollingCard",
    componentId: "sc-1d5akza-4"
})([
    "display:flex;flex-direction:column;gap:24px;background-color:white;font-family:Inter,sans-serif;font-weight:500;border-radius:15px;padding:30px 20px;text-align:center;box-shadow:0 4px 10px rgba(0,0,0,0.05);margin-top:0;width:100%;"
]);
const $dc9ac8f3a95fc864$export$821e3a9e0cedf4ac = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__OptionsPanel",
    componentId: "sc-1d5akza-5"
})([
    "display:flex;flex-direction:column;gap:12px;"
]);
const $dc9ac8f3a95fc864$export$80f3d8a515d3f7b = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__McOption",
    componentId: "sc-1d5akza-6"
})([
    "flex-grow:0;display:flex;flex-direction:row;justify-content:space-between;align-items:center;gap:12px;padding:16px;border-radius:16px;border:solid 2px #bbcad3;background-color:#fff;font-family:Inter,sans-serif;font-weight:500;font-size:16px;color:#000;"
]);
const $dc9ac8f3a95fc864$export$2cf7ef1e2dd6c6b1 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__OptionLabel",
    componentId: "sc-1d5akza-7"
})([
    "text-align:left;"
]);
const $dc9ac8f3a95fc864$export$5ffcbcb683112a5b = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__McCheckbox",
    componentId: "sc-1d5akza-8"
})([
    "width:28px;height:28px;flex-grow:0;flex-shrink:0;object-fit:contain;border-radius:8px;border:solid 2px #718490;background-color:#fff;&.active{width:32px;height:32px;border:none;background:no-repeat url(",
    ");}"
], (0, (/*@__PURE__*/$parcel$interopDefault($8a13619c4dbe1f8a$exports))));
const $dc9ac8f3a95fc864$export$3a4bb31ac4bd7451 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "Elements__HeaderIcon",
    componentId: "sc-1d5akza-9"
})([
    "width:72px;margin:0 auto;"
]);
const $dc9ac8f3a95fc864$export$f99233281efd08a0 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__Title",
    componentId: "sc-1d5akza-10"
})([
    "font-size:20px;font-weight:bold;font-stretch:normal;font-family:Inter,sans-serif;color:#1e4e5f;"
]);
const $dc9ac8f3a95fc864$export$f69c19e57285b83a = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__Message",
    componentId: "sc-1d5akza-11"
})([
    "opacity:0.8;align-self:stretch;font-family:Inter,sans-serif;font-size:14px;font-weight:500;font-stretch:normal;font-style:normal;line-height:1.4;letter-spacing:normal;text-align:center;color:#1e4e5f;"
]);
const $dc9ac8f3a95fc864$export$fd9000017733fabf = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Elements__FooterWrapper",
    componentId: "sc-1d5akza-12"
})([
    "width:100%;max-width:500px;margin:0 auto;"
]);





class $f96dfa98136185cc$var$MeasurementService {
    constructor(){
        this.measurementId = '';
        this.client = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app"
        });
    }
    setSessionId(sessionId) {
        this.client.defaults.headers.common.Authorization = `Bearer ${sessionId}`;
    }
    setMeasurementId(measurementId) {
        this.measurementId = measurementId;
    }
    getMeasurementFrames() {
        const measurementId = this.measurementId;
        return this.client.get(`/measurements/${measurementId}/frames`);
    }
    createPiReconstruction(email) {
        const measurementId = this.measurementId;
        return this.client.post(`/measurements/${measurementId}/pi-reconstructions`, {
            email: email
        });
    }
}
var $f96dfa98136185cc$export$2e2bcd8739ae039 = new $f96dfa98136185cc$var$MeasurementService();



const $1e2fa5f4612e89db$export$50f695ee7ce4b786 = {
    UNDEFINED: 'UNDEFINED',
    MEASURING: 'MEASURING',
    DONE: 'DONE',
    CANCELLED: 'CANCELLED',
    TIMEOUT: 'TIMEOT'
};
let $1e2fa5f4612e89db$var$pollingState = $1e2fa5f4612e89db$export$50f695ee7ce4b786.UNDEFINED;
function $1e2fa5f4612e89db$var$findArchTypeFrame(frames) {
    return frames.find((item)=>!!item.arch_type);
}
function $1e2fa5f4612e89db$var$checkFrames(frames) {
    if ($1e2fa5f4612e89db$var$pollingState === $1e2fa5f4612e89db$export$50f695ee7ce4b786.CANCELLED) return $1e2fa5f4612e89db$var$pollingState;
    const hasFrames = frames && frames.length;
    if (!hasFrames) return $1e2fa5f4612e89db$export$50f695ee7ce4b786.MEASURING;
    const minipodFrame = $1e2fa5f4612e89db$var$findArchTypeFrame(frames);
    if (minipodFrame) return $1e2fa5f4612e89db$export$50f695ee7ce4b786.DONE;
    return $1e2fa5f4612e89db$export$50f695ee7ce4b786.MEASURING;
}
function $1e2fa5f4612e89db$var$waitForPollingOutcome(expected, measurementId, sessionId) {
    (0, $f96dfa98136185cc$export$2e2bcd8739ae039).setSessionId(sessionId);
    (0, $f96dfa98136185cc$export$2e2bcd8739ae039).setMeasurementId(measurementId);
    return new Promise((fulfill, reject)=>{
        let toId = null;
        const poll = ()=>{
            console.log('[minipod] polling . . .');
            (0, $f96dfa98136185cc$export$2e2bcd8739ae039).getMeasurementFrames().then((response)=>{
                const { data: data } = response;
                const outcome = $1e2fa5f4612e89db$var$checkFrames(data);
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Polling: ', outcome);
                // setPollingState(outcome);
                const isFinalOutcome = outcome === $1e2fa5f4612e89db$export$50f695ee7ce4b786.DONE || outcome === $1e2fa5f4612e89db$export$50f695ee7ce4b786.CANCELLED || outcome === $1e2fa5f4612e89db$export$50f695ee7ce4b786.TIMEOUT;
                const continuePolling = !isFinalOutcome;
                if (outcome === expected) {
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('stopped polling');
                    clearTimeout(toId);
                    const frame = $1e2fa5f4612e89db$var$findArchTypeFrame(data);
                    fulfill(frame);
                }
                if (continuePolling) {
                    console.log('[minipod] waiting for user measurement');
                    toId = setTimeout(poll, 1000);
                } else if (outcome === $1e2fa5f4612e89db$export$50f695ee7ce4b786.DONE) {
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('stopped polling');
                    clearTimeout(toId);
                    const frame = $1e2fa5f4612e89db$var$findArchTypeFrame(data);
                    fulfill(frame);
                } else {
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('stopped polling');
                    clearTimeout(toId);
                    reject(outcome);
                }
            }).catch((err)=>{
                reject(err);
            });
        };
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('start polling');
        poll();
    });
}
var $1e2fa5f4612e89db$export$2e2bcd8739ae039 = {
    poll: (measurementId, sessionId)=>{
        return $1e2fa5f4612e89db$var$waitForPollingOutcome($1e2fa5f4612e89db$export$50f695ee7ce4b786.DONE, measurementId, sessionId);
    },
    stop: ()=>{
        $1e2fa5f4612e89db$var$pollingState = $1e2fa5f4612e89db$export$50f695ee7ce4b786.CANCELLED;
    }
};


const $d40d94705ea86638$var$Events = {
    onMcPollingStart: 'onMcPollingStart',
    onMcPollingDone: 'onMcPollingDone',
    onMcPollingCancelled: 'onMcPollingCancelled',
    onMcPollingError: 'onMcPollingError'
};
var $d40d94705ea86638$export$2e2bcd8739ae039 = $d40d94705ea86638$var$Events;



let $79dda203ed14888b$var$target;
let $79dda203ed14888b$var$state;
// Source - https://stackoverflow.com/a/73896246
// Posted by Tschallacka
// Retrieved 2026-05-07, License - CC BY-SA 4.0
if ('wasDiscarded' in document) // document.getElementById('wasDiscarded').innerText = document.wasDiscarded.toString();
(0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Document was discarded`);
function $79dda203ed14888b$var$getState() {
    if (document.visibilityState === 'hidden') return 'hidden';
    if (document.hasFocus()) return 'focused';
    return 'not focused';
}
function $79dda203ed14888b$var$logStateChange(nextState) {
    var prevState = $79dda203ed14888b$var$state;
    if (nextState !== prevState) {
        var timeBadge = new Date().toTimeString().split(' ')[0];
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`${timeBadge} State changed from ${prevState} to ${nextState}`);
        $79dda203ed14888b$var$state = nextState;
    }
}
function $79dda203ed14888b$var$onFreeze() {
    $79dda203ed14888b$var$logStateChange('frozen');
}
function $79dda203ed14888b$var$onPageHide(event) {
    if (event.persisted) // If the event's persisted property is `true` the page is about
    // to enter the page navigation cache, which is also in the frozen state.
    $79dda203ed14888b$var$logStateChange('frozen');
    else // If the event's persisted property is not `true` the page is about to be unloaded.
    $79dda203ed14888b$var$logStateChange('terminated');
}
window.addEventListener('pagehide', $79dda203ed14888b$var$onPageHide, {
    capture: true
});
class $79dda203ed14888b$export$c209ea36d8caa85d {
    constructor(){
        $79dda203ed14888b$var$target = document.getElementById('fpt-modal');
        $79dda203ed14888b$var$state = $79dda203ed14888b$var$getState();
        window.addEventListener('freeze', $79dda203ed14888b$var$onFreeze, {
            capture: true
        });
    }
    waitForPageStateChange() {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Waiting for Page status change . . .`);
        return new Promise((fulfill, reject)=>{
            const onPageStateChange = ()=>{
                const newState = $79dda203ed14888b$var$getState();
                const returningToTab = newState != $79dda203ed14888b$var$state && ($79dda203ed14888b$var$state === 'hidden' && (newState === 'not focused' || newState === 'focused') || $79dda203ed14888b$var$state === 'frozen' && (newState === 'not focused' || newState === 'focused'));
                if (returningToTab) {
                    [
                        'pageshow',
                        'focus',
                        'blur',
                        'visibilitychange',
                        'resume'
                    ].forEach(function(type) {
                        window.removeEventListener(type, onPageStateChange);
                    });
                    fulfill();
                }
                $79dda203ed14888b$var$logStateChange(newState);
            };
            [
                'pageshow',
                'focus',
                'blur',
                'visibilitychange',
                'resume'
            ].forEach(function(type) {
                window.addEventListener(type, onPageStateChange, {
                    capture: true
                });
            });
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Listening to page state change events`);
        });
    }
}



function $8946f4adfda51015$export$2e2bcd8739ae039(props) {
    const { emitter: emitter, measurementId: measurementId, sessionId: sessionId } = props;
    const [isPolling, setPolling] = (0, $6cds3.useState)(false);
    const [donePolling, setDonePolling] = (0, $6cds3.useState)(null);
    const [hasOrthopedicsOrPain, setOrthopedicsOrPain] = (0, $6cds3.useState)(false);
    const params = new URLSearchParams();
    params.append('fpt-measurement', measurementId);
    params.append('fpt-session', sessionId);
    params.append('fpt-measuretype', 'STATIC');
    params.append('hasOrthopedicsOrPain', String(hasOrthopedicsOrPain));
    const [mcParams, setMcParams] = (0, $6cds3.useState)(params.toString());
    const handleStartMinipod = ()=>{
        console.log('start minipod clicked');
    };
    const handleCancelPolling = ()=>{
        console.log('cancel polling clicked');
        (0, $1e2fa5f4612e89db$export$2e2bcd8739ae039).stop();
        setPolling(false);
        emitter.emit((0, $d40d94705ea86638$export$2e2bcd8739ae039).onMcPollingCancelled);
    };
    const handleOrthopedicsOrPainSelect = ()=>{
        const newVal = !hasOrthopedicsOrPain;
        setOrthopedicsOrPain(newVal);
        console.log('has orthopedics or pain', newVal);
        const meaType = newVal ? 'DYNAMIC' : 'STATIC';
        params.set('fpt-measuretype', meaType);
        params.set('hasOrthopedicsOrPain', String(newVal));
        setMcParams(params.toString());
    };
    const startPolling = ()=>{
        setPolling(true);
        return (0, $1e2fa5f4612e89db$export$2e2bcd8739ae039).poll(measurementId, sessionId);
    };
    (0, $6cds3.useEffect)(()=>{
        const obs = new (0, $79dda203ed14888b$export$c209ea36d8caa85d)();
        const promise = obs.waitForPageStateChange().then(()=>startPolling());
        setDonePolling(promise);
    }, []);
    (0, $6cds3.useEffect)(()=>{
        if (isPolling && donePolling) {
            console.log('Polling started');
            emitter.emit((0, $d40d94705ea86638$export$2e2bcd8739ae039).onMcPollingStart, mcParams);
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`on polling end`, donePolling);
            donePolling.then((outcome)=>emitter.emit((0, $d40d94705ea86638$export$2e2bcd8739ae039).onMcPollingDone, {
                    frame: outcome,
                    params: mcParams
                })).catch((err)=>{
                if (err === (0, $1e2fa5f4612e89db$export$50f695ee7ce4b786).CANCELLED) {
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`Polling cancelled`);
                    return;
                }
                emitter.emit((0, $d40d94705ea86638$export$2e2bcd8739ae039).onMcPollingError, err);
            });
        }
    }, [
        isPolling,
        donePolling
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $b19fd48583540509$export$159cd03be7087f39), {
        emitter: emitter,
        isClosable: false,
        className: "fpt-gradient",
        children: [
            !isPolling && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc9ac8f3a95fc864$export$25c607d6a337a384), {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc9ac8f3a95fc864$export$9891425d2ed93dbf), {
                        src: (0, $eb35e4b56fe508da$export$94b076129cf5f782) + '/logos/fpt_logo_splashscreen.png'
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc9ac8f3a95fc864$export$f330f2aa9e6816a5), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc9ac8f3a95fc864$export$3a4bb31ac4bd7451), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($5a8ebe80e4449512$exports)))
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc9ac8f3a95fc864$export$f99233281efd08a0), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "lp.hartmann.minipod.title"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc9ac8f3a95fc864$export$f69c19e57285b83a), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "lp.hartmann.minipod.subtitle"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc9ac8f3a95fc864$export$821e3a9e0cedf4ac), {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc9ac8f3a95fc864$export$80f3d8a515d3f7b), {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc9ac8f3a95fc864$export$2cf7ef1e2dd6c6b1), {
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                        id: "lp.hartmann.minipod.option.orthopedics-or-pain"
                                    })
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc9ac8f3a95fc864$export$5ffcbcb683112a5b), {
                                    className: hasOrthopedicsOrPain ? 'active' : '',
                                    onClick: handleOrthopedicsOrPainSelect
                                })
                            ]
                        })
                    })
                ]
            }),
            isPolling && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc9ac8f3a95fc864$export$25c607d6a337a384), {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc9ac8f3a95fc864$export$9891425d2ed93dbf), {
                        src: (0, $eb35e4b56fe508da$export$94b076129cf5f782) + '/logos/fpt_logo_splashscreen.png'
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dc9ac8f3a95fc864$export$f330f2aa9e6816a5), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc9ac8f3a95fc864$export$3a4bb31ac4bd7451), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($5a8ebe80e4449512$exports)))
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc9ac8f3a95fc864$export$f99233281efd08a0), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "lp.hartmann.minipod.polling.title"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc9ac8f3a95fc864$export$f69c19e57285b83a), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                    id: "lp.hartmann.minipod.polling.subtitle"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc9ac8f3a95fc864$export$7f7cbe89f1eacd2), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8273def840206282$exports)))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc9ac8f3a95fc864$export$fd9000017733fabf), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $327caa885e3be523$export$a06f1c675e846f6f), {
                    className: "disclaimer",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $327caa885e3be523$export$6e2c8f0811a474ce), {
                            children: [
                                !isPolling && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$d5992c1fec905475), {
                                    href: `unitydl://mylink?${mcParams}`,
                                    onClick: handleStartMinipod,
                                    type: "button",
                                    className: "wide-primary",
                                    children: "Start"
                                }),
                                isPolling && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                                    onClick: handleCancelPolling,
                                    type: "button",
                                    className: "wide-secondary",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                        id: "lp.hartmann.minipod.cancel"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $327caa885e3be523$export$6e2c8f0811a474ce), {
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                id: "drv.splashscreen.footer",
                                values: {
                                    policy: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                            href: "https://footprinttech.de/privacy-policy-webapp/",
                                            target: "_blank",
                                            children: chunks
                                        }),
                                    tos: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                            href: "https://footprinttech.de/terms-of-use-webapp/",
                                            target: "_blank",
                                            children: chunks
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $327caa885e3be523$export$6e2c8f0811a474ce), {
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                id: "drv.splashscreen.imprint",
                                values: {
                                    imp: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                            href: "https://footprinttech.de/imprint-webapp/",
                                            target: "_blank",
                                            children: chunks
                                        })
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
}







var $6cds3 = parcelRequire("6cds3");




var $6cds3 = parcelRequire("6cds3");



const $fda50474fa26fa26$var$Wrapper = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Input__Wrapper",
    componentId: "sc-o5xddd-0"
})([
    "width:100%;position:relative;& > label{font-family:Rubik,sans-serif;font-size:0.875rem;color:#1e4e5f;line-height:2.5rem;}"
]);
const $fda50474fa26fa26$export$afb06d959b3fda3b = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).input.withConfig({
    displayName: "Input__InputEl",
    componentId: "sc-o5xddd-1"
})([
    "margin:0;padding:0.85rem 0.85rem 0.85rem 2rem;font-family:Rubik;font-size:1rem;font-weight:300;background-color:transparent;border-color:#1e4e5f;border-radius:10px;border-width:1px;text-align:left;color:#1a1919;outline:0;width:100%;box-sizing:border-box;line-height:2rem;&[type='password']{letter-spacing:5px;font-size:1rem;margin:0;padding-top:0.75rem;line-height:2rem;}&[type='email'],&[type='email']:focus,&[type='email']:-webkit-autofill,&[type='email']:-webkit-autofill:hover,&[type='email']:-webkit-autofill:focus,&[type='email']:-webkit-autofill:active{margin:0;padding:0.85rem 0.85rem 0.85rem 2rem;font-family:Rubik,sans-serif;font-size:1rem;font-weight:300;background-color:transparent;border-color:#1e4e5f;border-radius:10px;border-width:1px;text-align:left;color:#1a1919;outline:0;width:calc(100% - 1.7rem);box-sizing:border-box;line-height:2rem;transition:background-color 600000s 0s,color 600000s 0s;}&[type='email']:invalid{border-color:red;border-width:2px;}"
]);
const $fda50474fa26fa26$var$ShowPassword = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Input__ShowPassword",
    componentId: "sc-o5xddd-2"
})([
    "text-decoration:underline;user-select:none;position:absolute;right:0;bottom:0;line-height:1rem;font-weight:600;font-size:var(--text-size-small);padding-bottom:1.2rem;z-index:6;"
]);
const $fda50474fa26fa26$var$Input = (props)=>{
    const { initialValue: initialValue, onChange: onChange, title: title, type: type = 'text', maxLength: maxLength = 21, placeholder: placeholder, label: label, minLength: minLength = 0 } = props;
    const [inputValue, setInputValue] = (0, $6cds3.useState)(initialValue);
    const [showPassword, setShowPassword] = (0, $6cds3.useState)(false);
    const [isInputFocused, setIsInputFocused] = (0, $6cds3.useState)(false);
    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`minLength: ${minLength}`);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($fda50474fa26fa26$var$Wrapper, {
        children: [
            label && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                htmlFor: type,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                    id: label
                })
            }),
            type !== 'password' && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($fda50474fa26fa26$export$afb06d959b3fda3b, {
                defaultValue: inputValue,
                placeholder: placeholder,
                onFocus: ()=>setIsInputFocused(true),
                onBlur: ()=>setIsInputFocused(false),
                className: "fpt-input",
                type: type,
                name: type,
                maxLength: maxLength,
                minLength: minLength,
                onChange: onChange
            }),
            type === 'password' && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($fda50474fa26fa26$export$afb06d959b3fda3b, {
                        defaultValue: inputValue,
                        onFocus: ()=>setIsInputFocused(true),
                        onBlur: ()=>setIsInputFocused(false),
                        className: "fpt-c-input",
                        type: !showPassword ? 'password' : 'text',
                        name: type,
                        maxLength: maxLength,
                        minLength: minLength,
                        onChange: onChange
                    }),
                    inputValue != '' && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($fda50474fa26fa26$var$ShowPassword, {
                        onClick: ()=>setShowPassword((prev)=>!prev),
                        children: [
                            !showPassword && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                id: "input.component.show-password"
                            }),
                            showPassword && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                id: "input.component.hide-password"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $fda50474fa26fa26$export$2e2bcd8739ae039 = $fda50474fa26fa26$var$Input;










const $a680cfe6f1bd8e79$var$Events = {
    onEmailSubmit: 'onEmailSubmit'
};
var $a680cfe6f1bd8e79$export$2e2bcd8739ae039 = $a680cfe6f1bd8e79$var$Events;


// Define CSS variables
const $fe1cf40d53b40fab$var$Variables = {
    polly: '#e0ecf8',
    almond: '#fdf5ec'
};
// const Text = styled.div`
//   font: 700 3vh/1.36 Inter, sans-serif;
//   margin-bottom: 25px;
// `;
const $fe1cf40d53b40fab$var$Blank = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "EmailFormComponent__Blank",
    componentId: "sc-1meltp0-0"
})([
    "margin-top:40px;"
]);
const $fe1cf40d53b40fab$var$customCss = `

.fpt-modal {
  position: relative;
  overflow: auto;
}

.disclaimer {
  display: block;
}

`;
const $fe1cf40d53b40fab$var$EmailForm = (props)=>{
    const { emitter: emitter } = props;
    const intl = (0, $c569e2e9ecfda3a0$export$2e2bcd8739ae039)();
    const shopSettings = (0, $6cds3.useContext)((0, $f686bfa33774dad2$export$d990cc5f51685546));
    const [continueEnabled, setContinueEnabled] = (0, $6cds3.useState)(false);
    const [isEmailValid, setIsEmailValid] = (0, $6cds3.useState)(true);
    const [email, setEmail] = (0, $6cds3.useState)('');
    const minLength = 6;
    const maxLength = 256; // see https://errata.rfc-editor.org/search/?rfc_number=3696
    const placeholder = intl.formatMessage({
        id: 'drv.email-form.input.placeholder',
        defaultMessage: 'Confirm Password',
        description: 'placeholder text'
    }); // "email address";
    let userInput = '';
    const onChange = (ev)=>{
        ev.nativeEvent.stopImmediatePropagation();
        userInput = ev.target.value;
        const emailIsValid = !!validateEmail(userInput);
        if (emailIsValid) setEmail(userInput);
        setContinueEnabled(emailIsValid);
    // log.info(`Email changed: ${userInput}`);
    };
    // Source - https://stackoverflow.com/a/46181
    // Posted by John Rutherford, modified by community. See post 'Timeline' for change history
    // Retrieved 2026-10-21, License - CC BY-SA 4.0
    const validateEmail = (email)=>{
        return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    };
    const handleContinue = (ev)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('continue clicked', email);
        const emailIsValid = !!validateEmail(email);
        setIsEmailValid(emailIsValid);
        if (isEmailValid) return emitter.emit((0, $a680cfe6f1bd8e79$export$2e2bcd8739ae039).onEmailSubmit, email);
    // if (currentOptions === speedOptions) {
    //   setContinueEnabled(false);
    //   setCurrentOptions(measureOptions);
    //   emitter.emit(Events.onSpeedOptionConfirm, selectedSpeedOption);
    // } else if(powerMode === POWER_MODE.NONE) {
    //   setCurrentOptions(measureOptions);
    //   emitter.emit(Events.onSpeedOptionConfirm, selectedSpeedOption);
    // } else {
    //   emitter.emit(Events.onMeasureOptionConfirm, selectedMeasureOption);
    // }
    };
    (0, $6cds3.useEffect)(()=>{
    // sessionService.updateExitCode('PDP', 'input-selection.displayed');
    // emitter.addListener(Events.onMeasureOptionSelect, handleMeasureOptionSelect);
    // emitter.addListener(Events.onSpeedOptionSelect, handleSpeedOptionSelect);
    // emitter.addListener(Events.onContinuePress, handleContinue);
    //
    // log.info(`Power mode: ${powerMode}`);
    //
    // if (powerMode === POWER_MODE.MANDATORY) {
    //   setSelectedSpeedOption(SPEED_OPTION.FAST_TRACK);
    //   emitter.emit(Events.onSpeedOptionConfirm, SPEED_OPTION.FAST_TRACK);
    // }
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $b19fd48583540509$export$159cd03be7087f39), {
        emitter: emitter,
        isClosable: false,
        style: {
            backgroundImage: `linear-gradient(to bottom, ${$fe1cf40d53b40fab$var$Variables.polly}, ${$fe1cf40d53b40fab$var$Variables.almond})`
        },
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f05930f741b5220d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $327caa885e3be523$export$25c607d6a337a384), {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $26ab366f71d6d646$export$8b251419efc915eb), {
                        className: "fpt--bottom-margin",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                            id: "drv.email-form.title"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($fe1cf40d53b40fab$var$Blank, {}),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fda50474fa26fa26$export$2e2bcd8739ae039), {
                        placeholder: placeholder,
                        type: "email",
                        maxLength: maxLength,
                        minLength: minLength,
                        onChange: onChange
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $26ab366f71d6d646$export$5f1af8db9871e1d6), {
                        style: {
                            display: isEmailValid ? 'none' : 'block'
                        },
                        children: "Invalid Email Address"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $327caa885e3be523$export$a06f1c675e846f6f), {
                className: "disclaimer",
                children: [
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).mode === (0, $c40fe7cebd3a81ae$export$770ef1da3280a8ee).VERBOSE && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $327caa885e3be523$export$6e2c8f0811a474ce), {
                        children: [
                            "Driver version: ",
                            (0, $df6536fbed69acd1$exports.version)
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $327caa885e3be523$export$6e2c8f0811a474ce), {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                            disabled: continueEnabled ? false : true,
                            onClick: handleContinue,
                            type: "button",
                            className: "wide-primary",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                id: "common.submit"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $fe1cf40d53b40fab$export$2e2bcd8739ae039 = $fe1cf40d53b40fab$var$EmailForm;




var $6cds3 = parcelRequire("6cds3");









// Define CSS variables
const $c8097d645a5af399$var$Variables = {
    polly: '#e0ecf8',
    almond: '#fdf5ec'
};
const $c8097d645a5af399$var$Blank = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "SuccessOutcomeComponent__Blank",
    componentId: "sc-68y26g-0"
})([
    "margin-top:40px;"
]);
const $c8097d645a5af399$var$Icon = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "SuccessOutcomeComponent__Icon",
    componentId: "sc-68y26g-1"
})([
    "display:block;width:32px;height:32px;margin:40px auto;"
]);
const $c8097d645a5af399$var$SuccessOutcomeComponent = (props)=>{
    const { emitter: emitter } = props;
    const intl = (0, $c569e2e9ecfda3a0$export$2e2bcd8739ae039)();
    const handleClose = (e)=>{
        e.nativeEvent.stopImmediatePropagation();
        emitter.emit((0, $933ab13c7a65596b$export$2e2bcd8739ae039).onCloseModalPress);
    };
    (0, $6cds3.useEffect)(()=>{}, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $b19fd48583540509$export$159cd03be7087f39), {
        emitter: emitter,
        isClosable: false,
        style: {
            backgroundImage: `linear-gradient(to bottom, ${$c8097d645a5af399$var$Variables.polly}, ${$c8097d645a5af399$var$Variables.almond})`
        },
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f05930f741b5220d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $327caa885e3be523$export$25c607d6a337a384), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $26ab366f71d6d646$export$8b251419efc915eb), {
                    className: "fpt--bottom-margin",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                            id: "drv.email-form.success.message"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c8097d645a5af399$var$Icon, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8a13619c4dbe1f8a$exports)))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $327caa885e3be523$export$a06f1c675e846f6f), {
                className: "disclaimer",
                children: [
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).mode === (0, $c40fe7cebd3a81ae$export$770ef1da3280a8ee).VERBOSE && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $327caa885e3be523$export$6e2c8f0811a474ce), {
                        children: [
                            "Driver version: ",
                            (0, $df6536fbed69acd1$exports.version)
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $327caa885e3be523$export$6e2c8f0811a474ce), {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1aead25b3bf4ef91$export$2e2bcd8739ae039), {
                            onClick: handleClose,
                            type: "button",
                            className: "wide-primary",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                                id: "common.acknowledge"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $c8097d645a5af399$export$2e2bcd8739ae039 = $c8097d645a5af399$var$SuccessOutcomeComponent;





const $e92b2a56d86c597c$var$ModalRoot = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Modal__ModalRoot",
    componentId: "sc-ho2wti-0"
})([
    "display:none;position:fixed;z-index:10000;left:0;top:0;width:100%;height:100%;overflow:hidden;background-color:rgba(34,34,34,0.75);justify-content:center;align-items:center;letter-spacing:normal;font-family:Inter,sans-serif;@media (pointer:fine),(pointer:none){height:100%;}@media (pointer:fine) and (any-pointer:coarse){height:100%;}&.fpt-modal--show{display:flex;}&.fpt-modal--hide{display:none;}&.fpt-modal--error{background-color:#fff;align-items:flex-start;}& h1{font-family:Inter,sans-serif;font-size:30px;font-weight:500;line-height:normal;}& p{line-height:24px;}"
]);
const $e92b2a56d86c597c$var$ModalContent = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Modal__ModalContent",
    componentId: "sc-ho2wti-1"
})([
    "color:#1e4e5f;text-align:center;width:100%;@media (max-width:600px){max-width:550px;box-shadow:none;border:none;}&.fpt-modal__content--error{max-width:100%;width:100%;height:100%;}"
]);
const $e92b2a56d86c597c$var$UndefinedView = ()=>{
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {});
};
var $e92b2a56d86c597c$export$9b51165ab6e1c0c1 = /*#__PURE__*/ function(ModalView) {
    ModalView[ModalView["UNDEFINED"] = 0] = "UNDEFINED";
    ModalView[ModalView["PROCESSING"] = 1] = "PROCESSING";
    ModalView[ModalView["SPLASHSCREEN"] = 2] = "SPLASHSCREEN";
    ModalView[ModalView["QR"] = 3] = "QR";
    ModalView[ModalView["RECOMMENDATION"] = 4] = "RECOMMENDATION";
    ModalView[ModalView["ERROR"] = 5] = "ERROR";
    ModalView[ModalView["MULTI_RECOMMENDATION"] = 6] = "MULTI_RECOMMENDATION";
    ModalView[ModalView["FEEDBACK_CONFIRM"] = 7] = "FEEDBACK_CONFIRM";
    ModalView[ModalView["MEASUREMENT"] = 8] = "MEASUREMENT";
    ModalView[ModalView["INPUT_SELECTION"] = 9] = "INPUT_SELECTION";
    ModalView[ModalView["MC_GATEWAY"] = 10] = "MC_GATEWAY";
    ModalView[ModalView["EMAIL_FORM"] = 11] = "EMAIL_FORM";
    ModalView[ModalView["SUCCESS_OUTCOME"] = 12] = "SUCCESS_OUTCOME";
    return ModalView;
}({});
const $e92b2a56d86c597c$var$display = [
    $e92b2a56d86c597c$var$UndefinedView,
    (0, $b334d33ba2ab3cb9$export$2e2bcd8739ae039),
    (0, $c9c2269a089314a3$export$2e2bcd8739ae039),
    (0, $e23b56ff19157479$export$2e2bcd8739ae039),
    (0, $42d971b032ffee03$export$68457e08ad68c9ad),
    (0, $a7ebcf7a9a77bb69$export$1e2b370e05744247),
    (0, $7640e19a46a718c5$export$626a03d25025d09e),
    (0, $21080e4e90210997$export$620e493c7f3710e5),
    (0, $2cb108e2a7aeb9da$export$4e07085c8feeec9),
    (0, $c8bf5bcfe2efd4a1$export$2e2bcd8739ae039),
    (0, $8946f4adfda51015$export$2e2bcd8739ae039),
    (0, $fe1cf40d53b40fab$export$2e2bcd8739ae039),
    (0, $c8097d645a5af399$export$2e2bcd8739ae039)
];
function $e92b2a56d86c597c$export$2b77a92f1a5ad772(props) {
    const { view: view, emitter: emitter, data: data, visible: visible } = props;
    const isVisible = visible ? 'fpt-modal--show' : 'fpt-modal--hide';
    const DisplayComponent = $e92b2a56d86c597c$var$display[view];
    const isMobile = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).isMobile();
    // Add specific class for different views to target styling
    const getViewSpecificClass = ()=>{
        switch(view){
            case 4:
                return 'fpt-modal__content--recommendation';
            case 5:
                // Only apply fullscreen error styling on mobile
                return isMobile ? 'fpt-modal__content--error' : '';
            default:
                return '';
        }
    };
    const viewSpecificClass = getViewSpecificClass();
    // Error fullscreen styling only on mobile
    const isErrorViewMobile = view === 5 && isMobile;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($e92b2a56d86c597c$var$ModalRoot, {
        className: `fpt-modal fpt-modal-gradient ${isVisible} ${isErrorViewMobile ? 'fpt-modal--error' : ''}`,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3a69ac4f592126f9$export$5f251580d3bb9e3b), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($e92b2a56d86c597c$var$ModalContent, {
                className: `fpt-modal__content ${viewSpecificClass}`,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(DisplayComponent, {
                    emitter: emitter,
                    ...data
                })
            })
        ]
    });
}




let $2bf83c5cdc6d49ab$var$instance;
function $2bf83c5cdc6d49ab$var$getModal() {
    return document.querySelector('.fpt-modal') || (()=>{
        throw new Error('modal dom element not found');
    })();
}
function $2bf83c5cdc6d49ab$var$getModalContentWrapper() {
    return document.querySelector('.fpt-modal__content') || (()=>{
        throw new Error('modal dom element not found');
    })();
}
function $2bf83c5cdc6d49ab$var$getRootInstance() {
    if (!$2bf83c5cdc6d49ab$var$instance) {
        const wrapper = $2bf83c5cdc6d49ab$var$getModalContentWrapper();
        $2bf83c5cdc6d49ab$var$instance = (0, $64d0b1ebdd6bcffe$exports.createRoot)(wrapper);
    }
    return $2bf83c5cdc6d49ab$var$instance;
}
const $2bf83c5cdc6d49ab$export$de3e1d2ea3b4fd9b = {
    open: ()=>{
        $2bf83c5cdc6d49ab$var$getModal().style.display = 'flex';
    },
    close: ()=>{
        $2bf83c5cdc6d49ab$var$getModal().style.display = 'none';
    },
    setContent: (content)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('setting content');
        const root = $2bf83c5cdc6d49ab$var$getRootInstance();
        root.render(content);
    },
    isOpen: ()=>{
        return $2bf83c5cdc6d49ab$var$getModal().style.display === 'flex';
    }
};





var $1ac3f8068240dc93$exports = {};
/**
 * PromiseWindow
 * https://github.com/amercier/promise-window
 * @ignore
 */ (function() {
    'use strict';
    var root = window, prototype, html = root.document.documentElement;
    /**
   * Merge the contents of two or more objects together into the first object.
   *
   *     merge( target [, object1 ] [, objectN ] )
   *
   * @param {Object} target  An object that will receive the new properties if
   *                         additional objects are passed in.
   * @param {Object} object1 An object containing additional properties to merge in.
   * @param {Object} objectN An object containing additional properties to merge in.
   * @return {Object} Returns the first object.
   * @ignore
   */ function extend() {
        var extended = arguments[0], key, i;
        for(i = 1; i < arguments.length; i++){
            for(key in arguments[i])if (arguments[i].hasOwnProperty(key)) extended[key] = arguments[i][key];
        }
        return extended;
    }
    /**
   * Generates a pseudo-unique String
   *
   * @param  {String} prefix Optional.
   * @return {String} Returns a pseudo-unique string prefixed with the given prefix, if any.
   * @ignore
   */ function generateUniqueString(prefix) {
        return prefix + new Date().getTime() + "-" + Math.floor(10e12 * Math.random());
    }
    /**
   * Create a new PromiseWindow object
   *
   * During the lifecycle of this object, popup windows can be opened, closed,
   * and reopened again. However, it'
   *
   * Instanciating this prototype does not immediately opens a new popup window.
   * To open the window, use `open()` on the created object.
   *
   * @param {String}   uri                    Destination URI
   * @param {Object}   config                 Configuration object. See description below.
   * @param {Number}   config.width           Width of the popup window. Defaults to the current document width.
   * @param {Number}   config.height          Height of the popup window. Defaults to the current document height.
   * @param {Function} config.promiseProvider Promise provider. Should return a plain object containing 3 fields:
   *                                          - `promise` {Promise}  a new Promise object
   *                                          - `resolve` {Function} the method to resolve the given Promise
   *                                          - `reject`  {Function} the method to reject the given Promise
   * @param {Function} config.onPostMessage   Handler for receiving a postMessage from the opened window. Default
   *                                          implementation resolves the promise with the data passed in the post
   *                                          message, except if this data contains an `error` field. In this case,
   *                                          it rejects the Promise with the value of that field. In all cases, closes
   *                                          the popup window.
   * @param {Function} config.onPostMessage.event Event The postMessage event
   * @param {Number}   config.watcherDelay    There is no programmatic way of knowing when a popup window is closed
   *                                          (either manually or programatically). For this reason, every time
   *                                          PromiseWindow opens a popup, a new watcher is created. The watcher checks
   *                                          regularly if the window is still open. This value defines at which
   *                                          interval this check is done. Defaults to 100ms.
   * @param {String}   config.windowName      Name to be ginven to the popup window. See `window.open` references for
   *                                          details. If `null`, a random name is generated.
   * @param {Object}   config.window          Object containing window configuration settings. Scrollbars are enabled
   *                                          by default. All `window.open` ptions are accepted, but please note that
   *                                          many of them have no effect in most modern browsers. See
   *                                          https://developer.mozilla.org/en-US/docs/Web/API/Window/open for more
   *                                          details.
   * @param {Function} config.onClose         Function being called whenever the popup is being closed (either after a
   *                                          post message has been received, or window has been closed by user, or
   *                                          `.close()` method has been called. Default implementation closes the
   *                                          popup window by calling `this._window.close()`).
   * @param {RegExp} config.originRegexp      Regular expression that matches the origin part of an URI. Defaults to
   *                                          `new RegExp('^[^:/?]+://[^/]*')`. If doesn't match (ex: relative URIs),
   *                                          use `location.origin`.
   * @constructor
   */ function PromiseWindow(uri, config) {
        this.uri = uri;
        this.config = extend({}, this.constructor.defaultConfig, config);
        this.config.windowName = this.config.windowName || generateUniqueString('promise-window-');
        this._onPostMessage = this._onPostMessage.bind(this);
    }
    /**
   * Create a Promise provider from a Promise/A+ constructor to be used with
   * `config.promiseProvider`.
   *
   *     new PromiseWindow(..., {
   *       ...,
   *       promiseProvider: PromiseWindow.getAPlusPromiseProvider(MyCustomPromise)
   *     });
   *
   * @param  {Function} CustomPromise Promise/A+ contructor
   * @return {Function} Returns a promise provider
   * @static
   */ PromiseWindow.getAPlusPromiseProvider = function getAPlusPromiseProvider(CustomPromise) {
        return function promiseProvider() {
            var module1 = {};
            module1.promise = new CustomPromise(function(resolve, reject) {
                module1.resolve = resolve;
                module1.reject = reject;
            });
            return module1;
        };
    };
    /**
   * Convenience method for:
   *
   *     new PromiseWindow(uri, config).open()
   *
   * Use this method only if you never need to close the window programatically.
   * If you do, please consider using the classic way:
   *
   *     var w = new PromiseWindow(uri, config)
   *     w.open();
   *     // ...
   *     w.close();
   *
   * @return {Promise} Returns a Promise equivalent to the one returned by `open()`
   * @static
   */ PromiseWindow.open = function open(uri, config) {
        return new PromiseWindow(uri, config).open();
    };
    /**
   * Default configuration
   * @type {Object}
   */ PromiseWindow.defaultConfig = {
        width: html.clientWidth,
        height: html.clientHeight,
        window: {
            scrollbars: true
        },
        watcherDelay: 100,
        promiseProvider: null,
        onPostMessage: function onPostMessage(event) {
            if (event.data.error) this._reject(event.data.error);
            else this._resolve(event.data);
            this.close();
        },
        windowName: null,
        onClose: function() {
            this._window.close();
        },
        originRegexp: new RegExp('^[^:/?]+://[^/]*')
    };
    // Configure default Promise provider from current invironment
    if (root.Promise) PromiseWindow.defaultConfig.promiseProvider = PromiseWindow.getAPlusPromiseProvider(root.Promise);
    else if (root.RSVP) PromiseWindow.defaultConfig.promiseProvider = PromiseWindow.getAPlusPromiseProvider(root.RSVP.Promise);
    else if (root.Q) PromiseWindow.defaultConfig.promiseProvider = PromiseWindow.getAPlusPromiseProvider(root.Q.Promise);
    else if (root.jQuery) PromiseWindow.defaultConfig.promiseProvider = function promiseProvider() {
        var deferred = root.jQuery.Deferred();
        return {
            promise: deferred.promise(),
            resolve: deferred.resolve,
            reject: deferred.reject
        };
    };
    else PromiseWindow.defaultConfig.promiseProvider = function() {
        throw new Error('Missing promiseProvider in PromiseWindow configuration');
    };
    prototype = PromiseWindow.prototype;
    /**
   * Checks whether a value is a boolean
   * @param {*} value The value to check
   * @return {boolean} `true` if value is a boolean, `false` otherwise
   * @protected
   */ prototype._isBoolean = function _isBoolean(value) {
        return value === true || value === false;
    };
    /**
   * Converts a config value into a value compatible with `window.open`.
   * If value is a boolean, convert it to 'yes' or 'no', otherwise simply
   * casts it into a string.
   * @param {*} value The value to convert
   * @return {string} The converted value
   * @protected
   */ prototype._serializeFeatureValue = function _serializeFeatureValue(key, value) {
        if (this._isBoolean(value)) return value ? 'yes' : 'no';
        return '' + value;
    };
    /**
   * Get the left and top position in the screen for a rectangle, taking
   * dual-screen position into account
   * @param {Number} width Width of the rectangle
   * @param {Number} height Height of the rectangle
   * @return {Object} position A new object representing the position of the rectangle, centered
   * @return {Number} position.left The X coordinate of the centered rectangle
   * @return {Number} position.top The Y coordinate of the centered rectangle
   * @return {Number} position.width The width of the centered rectangle
   * @return {Number} position.height The height of the centered rectangle
   * @protected
   */ prototype._getCenteredPosition = function _getCenteredPosition(width, height) {
        var dualScreenLeft = root.screenLeft !== undefined ? root.screenLeft : screen.left, dualScreenTop = root.screenTop !== undefined ? root.screenTop : screen.top, w = root.innerWidth || html.clientWidth || screen.width, h = root.innerHeight || html.clientHeight || screen.height;
        return {
            left: w / 2 - width / 2 + dualScreenLeft,
            top: h / 2 - height / 2 + dualScreenTop,
            width: width,
            height: height
        };
    };
    /**
   * Generates window features based on the current configuration
   * @return {String} Returns window features compatible with `window.open`
   * @protected
   */ prototype._getFeatures = function _getFeatures() {
        var config = this._getCenteredPosition(this.config.width, this.config.height);
        for(var key in this.config.window)if (this.config.window.hasOwnProperty(key)) config[key] = this.config.window[key];
        return Object.keys(config).map((function(key) {
            return key + '=' + this._serializeFeatureValue(key, config[key]);
        }).bind(this)).join(',');
    };
    /**
   * Creates a new Promise, using `config.promiseProvider`, and save reject and
   * resolve methods for later.
   *
   * @return {Promise} Returns the new Promise object created by the configured
   *                   Promise Provider.
   * @protected
   */ prototype._createPromise = function _createPromise() {
        var module1 = this.config.promiseProvider();
        this._resolve = module1.resolve;
        this._reject = module1.reject;
        return module1.promise;
    };
    /**
   * Checks whether the window is alive or not
   * @return {Boolean} Returns `true` if the window is alive, `false` otherwise
   * @protected
   */ prototype._isWindowAlive = function _isWindowAlive() {
        return this._window && !this._window.closed;
    };
    /**
   * Starts the popup window watcher.
   * @return {void}
   * @protected
   */ prototype._startWatcher = function _startWatcher() {
        if (this._watcherRunning) throw new Error('Watcher is already started');
        this._watcher = root.setInterval((function() {
            if (this._watcherRunning && !this._isWindowAlive()) this.close();
        }).bind(this), this.config.watcherDelay);
        this._watcherRunning = true;
    };
    /**
   * Stops the popup window watcher.
   * @return {void}
   * @protected
   */ prototype._stopWatcher = function _stopWatcher() {
        if (!this._watcherRunning) throw new Error('Watcher is already stopped');
        this._watcherRunning = false;
        root.clearInterval(this._watcher);
    };
    /**
   * Callback for post message events. If and only of the event has been
   * generated from the opened popup window, it propagates it to the configured
   * post message handler (`config.onPostMessage`).
   *
   * @param {Event} event The postMessage event
   * @return {void}
   * @protected
   */ prototype._onPostMessage = function _onPostMessage(event) {
        var expectedOriginMatches = this.config.originRegexp.exec(this.uri);
        var expectedOrigin = expectedOriginMatches && expectedOriginMatches[0] || location.origin;
        if (this._window === event.source && event.origin === expectedOrigin) this.config.onPostMessage.call(this, event);
    };
    /**
   * Changes the URI
   * @param {String} uri The new URI
   * @throws {Error} If the window is open
   * @return {PromiseWindow} Returns this object to allow chaining
   */ prototype.setURI = function setURI(uri) {
        if (this.isOpen()) throw new Error('Cannot change the URI while the window is open');
        this.uri = uri;
        return this;
    };
    /**
   * Opens a new popup window.
   *
   * @return {Promise} Returns a new `Promise` object. This promise will be:
   *                   - rejected with `"blocked"` message if the popup window
   *                     does not open for any reason (popup blocker, etc...)
   *                   - rejected with `"closed"` if closed either manually by
   *                     the user, or programatically
   *                   - rejected with the given error if the web page opened in
   *                     the popup sends a post message with a `error` data field.
   *                   - resolved with the given data if the web page opened in
   *                     the popup sends a post message without a `error` data
   *                     field.
   */ prototype.open = function open() {
        if (this.isOpen()) throw new Error('Window is already open');
        this._windowOpen = true;
        var promise = this._createPromise();
        this._window = root.open(this.uri, this.config.windowName, this._getFeatures());
        if (!this._window) this._reject("blocked");
        else {
            root.addEventListener("message", this._onPostMessage, true);
            this._startWatcher();
        }
        return promise;
    };
    /**
   * Closes the popup window.
   *
   * @return {void}
   */ prototype.close = function close() {
        if (!this.isOpen()) throw new Error('Window is already closed');
        this._stopWatcher();
        root.removeEventListener("message", this._onPostMessage);
        if (this._isWindowAlive()) this.config.onClose.call(this);
        this._reject("closed");
        this._window = null;
        this._windowOpen = false;
    };
    /**
   * Checks whether the window is open or not
   * @return {Boolean} Returns `true` if the window is opened, `false` otherwise.
   */ prototype.isOpen = function isOpen() {
        return this._windowOpen;
    };
    // Exports PromiseWindow to the global scope
    /* jshint ignore:start */ if (typeof define === 'function' && define.amd) define('promise-window', [], function() {
        return PromiseWindow;
    });
    else $1ac3f8068240dc93$exports = PromiseWindow;
/* jshint ignore:end */ })();



class $d988e4d2e0bb4394$export$c73ca302efeda3b4 extends Error {
    constructor(errorCode = "GEN01-00", ...params){
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(...params);
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $d988e4d2e0bb4394$export$c73ca302efeda3b4);
        this.name = "DefaultError";
        // Custom debugging information
        this.errorCode = errorCode;
        this.createdAt = new Date();
    }
}



const $553cb74d80b27513$var$Events = {
    onSettingsLoaded: 'onSettingsLoaded',
    onMatching: 'onMatching',
    onProfileMeasurementSet: 'onProfileMeasurementSet',
    onCustomerReferenceChange: 'onCustomerReferenceChange'
};
var $553cb74d80b27513$export$2e2bcd8739ae039 = $553cb74d80b27513$var$Events;


const $2fd26587fc2957b4$var$SUPPORTED_LANGUAGES = [
    'en',
    'es',
    'de',
    'it',
    'ja',
    'fr',
    'pl',
    'tr'
];
function $2fd26587fc2957b4$var$isMobile() {
    return window.matchMedia('only screen and (max-width: 760px)').matches;
}
function $2fd26587fc2957b4$var$isStagingRicosta() {
    const url = new URL(window.location.href);
    return url.hostname === 'staging.ricosta.de';
}
function $2fd26587fc2957b4$var$isRicosta() {
    const url = new URL(window.location.href);
    return url.hostname.includes('ricosta.de');
}
function $2fd26587fc2957b4$var$isSpartacus() {
    return window.location.hostname.includes('fashion-spa');
}
function $2fd26587fc2957b4$var$applyRicostaBanner() {
    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('applying banner');
    const el = document.querySelector(`#footprinttech-button`);
    const shoesizePanel = el.previousElementSibling;
    shoesizePanel.style.setProperty('background-color', '#ffda85');
    shoesizePanel.style.setProperty('padding', '0.5rem 1.5rem 0 1.5rem');
    shoesizePanel.style.setProperty('border-radius', '0.625rem 0.625rem 0 0');
    shoesizePanel.style.setProperty('margin-top', '2.25rem');
    shoesizePanel.style.setProperty('position', 'relative');
    const baseInfo = shoesizePanel.querySelector('.base-info--entry');
    baseInfo.style.setProperty('position', 'absolute');
    baseInfo.style.setProperty('top', '-1.5rem');
    baseInfo.style.setProperty('left', '0');
    const desc = shoesizePanel.querySelector('.configurator--description');
    desc.style.setProperty('color', '#00202a');
    desc.style.setProperty('font-size', '0.875rem');
    desc.style.setProperty('text-align', 'center');
    desc.innerHTML = "Selbst die Gr\xf6\xdfe w\xe4hlen";
    const selectFields = shoesizePanel.querySelectorAll('.field--select');
    selectFields.forEach((item)=>item.style.setProperty('max-width', '100%'));
    el.style.setProperty('background-color', '#ffda85');
    el.style.setProperty('padding', '0 1.5rem 1rem');
    el.style.setProperty('border-radius', '0 0 0.625rem 0.625rem');
    el.style.setProperty('text-align', 'center');
    el.style.setProperty('color', '#00202a');
    el.style.setProperty('font-size', '0.875rem');
    el.style.setProperty('margin-bottom', '0.625rem');
    el.style.setProperty('overflow', 'hidden');
}
function $2fd26587fc2957b4$var$getParentForm() {
    return document.getElementById('footprinttech-button').closest('form');
}
function $2fd26587fc2957b4$var$preventFormSubmitOnEnterKeyPress() {
    const form = $2fd26587fc2957b4$var$getParentForm();
    if (!form) return;
    form.addEventListener('keydown', (e)=>{
        const key = e.key;
        if (key == 'Enter') {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('prevented enter sumbit');
            e.preventDefault();
        }
    });
}
function $2fd26587fc2957b4$var$getButtonEl() {
    return document.querySelector(`#footprinttech-button button`);
}
function $2fd26587fc2957b4$var$getFPTTag() {
    const buttonParent = document.getElementById('footprinttech-button');
    const banner = document.getElementById('footprinttech-banner');
    if (buttonParent) return buttonParent;
    if (banner) return banner;
    return null;
}
function $2fd26587fc2957b4$var$parseTheme(customTheme) {
    const ctaTheme = Object.assign((0, $a58a64c681e03a20$export$2e2bcd8739ae039).ctaButton, customTheme.ctaButton);
    const ctaLinkTheme = Object.assign((0, $a58a64c681e03a20$export$2e2bcd8739ae039).ctaLink, customTheme.ctaLink);
    const theme = Object.assign((0, $a58a64c681e03a20$export$2e2bcd8739ae039), customTheme);
    theme.ctaButton = ctaTheme;
    theme.ctaLink = ctaLinkTheme;
    return theme;
}
function $2fd26587fc2957b4$var$clearUndefinedData(data) {
    Object.getOwnPropertyNames(data).forEach((key)=>{
        if (data[key] === '' || data[key] === undefined) delete data[key];
    });
    return data;
}
function $2fd26587fc2957b4$var$getFptUrl(target, data) {
    $2fd26587fc2957b4$var$clearUndefinedData(data);
    const params = new URLSearchParams(data);
    return target + '?' + params.toString();
}
function $2fd26587fc2957b4$var$getWidgetEl() {
    // TODO: add banner widget
    return document.querySelector('[data-widget=fpt-button]') || document.querySelector('[data-widget=fpt-modal]');
}
function $2fd26587fc2957b4$var$getWidgetLang() {
    // Language set in widget scenario
    const widget = $2fd26587fc2957b4$var$getWidgetEl();
    if (widget && widget.dataset.lang) return widget.dataset.lang;
    return null;
}
function $2fd26587fc2957b4$var$observeForCustomerReferenceChange(emitter) {
    // Select the node that will be observed for mutations
    const targetNode = $2fd26587fc2957b4$var$getWidgetEl();
    // for legacy integrations of the button that lack data-widget attr
    if (!targetNode) return;
    // Options for the observer (which mutations to observe)
    const config = {
        attributes: true,
        childList: false,
        subtree: false
    };
    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer)=>{
        for (const mutation of mutationList)if (mutation.type === "attributes" && mutation.attributeName === 'data-customer-reference') {
            console.log(`The ${mutation.attributeName} attribute was modified.`);
            emitter.emit((0, $553cb74d80b27513$export$2e2bcd8739ae039).onCustomerReferenceChange, targetNode.dataset.customerReference);
        }
    };
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
// Later, you can stop observing
// observer.disconnect();
}
const $2fd26587fc2957b4$var$RenderUtil = {
    isButtonRendered: ()=>{
        const el = $2fd26587fc2957b4$var$getButtonEl();
        return !!(el && el.children.length > 1);
    },
    hasBannerVariant: ()=>{
        return $2fd26587fc2957b4$var$isRicosta();
    },
    isSpartacus: $2fd26587fc2957b4$var$isSpartacus,
    isButtonVisible: ()=>{
        return true;
    },
    isMobile: $2fd26587fc2957b4$var$isMobile,
    isDesktop: ()=>!$2fd26587fc2957b4$var$isMobile(),
    isRicosta: $2fd26587fc2957b4$var$isRicosta,
    isStagingRicosta: $2fd26587fc2957b4$var$isStagingRicosta,
    isEmbeddedMode: ()=>{
        return !!document.querySelector('[data-widget=fpt-modal][data-mode=embedded], [data-widget=fpt-button][data-mode=embedded]');
    },
    applyBanner: ()=>{
        if ($2fd26587fc2957b4$var$isMobile() || $2fd26587fc2957b4$var$isRicosta()) $2fd26587fc2957b4$var$applyRicostaBanner();
    },
    getFptUrl: $2fd26587fc2957b4$var$getFptUrl,
    openFptApp: (target, data)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('opening FPT App with params', data);
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('opening target', target);
        // this as any: using only "this" shows an error in the IDE
        // stating that "this is possibly undefined"
        const url = $2fd26587fc2957b4$var$getFptUrl(target, data);
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`open FPT app with URL ${url}`);
        let promiseWindow = new (0, (/*@__PURE__*/$parcel$interopDefault($1ac3f8068240dc93$exports)))(url, {
            originRegexp: new RegExp(target)
        });
        return promiseWindow.open().catch((err)=>{
            if (err === 'closed') throw new (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)('WDCNV1', 'App closed by user');
            throw new (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)('GEN01-00', 'Something went wrong with promise window', {
                cause: err
            });
        });
    },
    openModal: ()=>(0, $2bf83c5cdc6d49ab$export$de3e1d2ea3b4fd9b).open(),
    closeModal: ()=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Closing modal');
        (0, $2bf83c5cdc6d49ab$export$de3e1d2ea3b4fd9b).close();
    },
    getWidgetEl: $2fd26587fc2957b4$var$getWidgetEl,
    getWidgetLang: $2fd26587fc2957b4$var$getWidgetLang,
    getLang: ()=>{
        if (navigator.languages && navigator.languages.length > 0) {
            const preferredLang = navigator.languages[0].toLowerCase().split('-')[0];
            const result = $2fd26587fc2957b4$var$SUPPORTED_LANGUAGES.includes(preferredLang) ? preferredLang : 'en';
            return result;
        }
        return navigator.language;
    },
    parseTheme: $2fd26587fc2957b4$var$parseTheme,
    getButtonEl: ()=>{
        return $2fd26587fc2957b4$var$getButtonEl();
    },
    getFPTTag: ()=>{
        return $2fd26587fc2957b4$var$getFPTTag();
    },
    setCtaButtonState: (state)=>{
        const button = $2fd26587fc2957b4$var$getButtonEl();
        if (!button) return;
        if (state == 'LOADING') button.classList.add('fpt-loading');
        else button.classList.remove('fpt-loading');
    },
    getTranslationMessages: (lang, i18nConfig)=>{
        const messages = i18nConfig[lang].messages;
        // check for missing keys
        if (lang !== 'en') {
            const masterKeys = Object.keys(i18nConfig['en'].messages);
            const currentKeys = Object.keys(messages);
            const difference = masterKeys.filter((x)=>!currentKeys.includes(x));
            difference.forEach((item)=>{
                messages[item] = i18nConfig['en'].messages[item];
            });
        }
        return messages;
    },
    hasFptBanner: ()=>{
        return !!document.getElementById('footprinttech-banner');
    },
    parseArticlePrice: (price, settings)=>{
        const { pricePattern: pricePattern } = settings;
        if (!pricePattern) return price;
        const pattern = new RegExp(pricePattern);
        const priceStr = '' + price;
        const parsedPrice = pattern.test(priceStr) ? priceStr.replace(pattern, (match, p1, p2)=>`${p1}.${p2}`) : price;
        return Number(parsedPrice);
    },
    appendModalEl: ()=>{
        let modalEl = document.querySelector('#fpt-modal');
        if (modalEl) (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('FPT modal already exists . . .');
        else {
            modalEl = document.createElement('div');
            modalEl.setAttribute('id', 'fpt-modal');
            document.body.appendChild(modalEl);
        }
        return modalEl;
    },
    appendHeadlessModalEl: ()=>{
        let modalEl = document.querySelector('#fpt-modal');
        const modalRoot = document.querySelector('[data-widget=fpt-modal]');
        if (modalEl) (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('FPT modal already exists . . .');
        else {
            modalEl = document.createElement('div');
            modalEl.setAttribute('id', 'fpt-modal');
            modalRoot.appendChild(modalEl);
        }
        return modalEl;
    },
    getArticleDataFromModal: ()=>{
        const el = document.querySelector('[data-widget=fpt-modal]');
        let result = {
            id: '',
            number: '',
            sizes: []
        };
        if (!el) return result;
        if (el.dataset.articleNumber) result.number = el.dataset.articleNumber;
        if (el.dataset.sku) result.sku = el.dataset.sku;
        if (el.dataset.gtin) result.gtin = el.dataset.gtin;
        if (el.dataset.articleName) result.name = el.dataset.articleName;
        if (el.dataset.articlePrice) {
            const str = el.dataset.articlePrice;
            const price = Number(str);
            result.price = Number.isNaN(price) || str === '' ? null : price;
        }
        if (el.dataset.articleImage) result.image = el.dataset.articleImage;
        if (el.dataset.returnUrl) result.returnUrl = el.dataset.returnUrl;
        if (el.dataset.mode) result.mode = el.dataset.mode;
        return result;
    },
    getMeaFrame: ()=>{
        return document.getElementById("FPT-MEA-FRAME");
    },
    getArticleTagsFromUrlParams: ()=>{
        const currentUrl = new URL(window.location.href);
        const params = currentUrl.searchParams;
        return params.getAll('fpt-tag').join(',');
    },
    isFootArchEnabled: (settings)=>{
        return settings.steps && settings.steps.includes('-FA');
    },
    isArticleInsole (article) {
        if (!article.shopArticles) return false;
        const { shopArticles: shopArticles } = article;
        const tags = shopArticles.map((art)=>{
            const t = art.tags.split(',');
            return t.map((tag)=>tag.trim());
        }).flat();
        return tags.includes('insole');
    },
    observeForCustomerReferenceChange: $2fd26587fc2957b4$var$observeForCustomerReferenceChange,
    getRandomInt (max) {
        return Math.floor(Math.random() * max);
    }
};
var $2fd26587fc2957b4$export$2e2bcd8739ae039 = $2fd26587fc2957b4$var$RenderUtil;





const $e2cdb6d8b920f1a3$var$Events = {
    onCtaPress: 'onCtaPress',
    onRecommendationPress: 'onRecommendation',
    onCtaPanelReload: 'onCtaPanelReload'
};
var $e2cdb6d8b920f1a3$export$2e2bcd8739ae039 = $e2cdb6d8b920f1a3$var$Events;




var $6cds3 = parcelRequire("6cds3");

/* eslint-disable @typescript-eslint/no-unused-vars */ 
const $289432bb95b0c99a$var$Button = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).button.withConfig({
    displayName: "Button",
    componentId: "sc-msmmv7-0"
})([
    "align-items:center;background:",
    ";border:",
    ";border-radius:",
    ";box-sizing:border-box;box-shadow:",
    ";color:",
    ";cursor:pointer;display:flex;min-height:",
    ";font:",
    ";justify-content:space-evenly;padding:",
    ";width:",
    ";&:focus{border:0;border-width:0;outline:none;}&:active{border:0;border-width:0;outline:none;}&:visited{border:0;border-width:0;outline:none;}& img.fpt-cta-button__logo{filter:",
    ";height:",
    ";margin:0 20px 0 0;}& img.fpt-cta-button__arrow{display:",
    ";}& > img.fpt-cta-button__spinner{display:none;}&.fpt-loading > img.fpt-cta-button__spinner{display:inline-block;}&.fpt-loading .fpt-cta-button__logo{display:none;}&.fpt-loading .fpt-cta-button__label{display:none;}&.fpt-loading .fpt-cta-button__arrow{display:none;}&.fpt-btn-link{background:",
    ";color:",
    ";padding:",
    ";margin:",
    ";font:",
    ";text-decoration:",
    ";box-shadow:none;}&.fpt-btn-link:hover{text-decoration:",
    ";}&.fpt-btn-link img.fpt-cta-button__logo{filter:",
    ";height:",
    ";margin:0 10px 0 0;}&.fpt-btn-link img.fpt-cta-button__arrow{display:none;}margin:",
    ";"
], (props)=>props.theme.ctaButton.background, (props)=>props.theme.ctaButton.border, (props)=>props.theme.ctaButton.borderRadius, (props)=>props.theme.ctaButton.boxShadow, (props)=>props.theme.ctaButton.color, (props)=>props.theme.ctaButton.minHeight, (props)=>props.theme.ctaButton.font, (props)=>props.theme.ctaButton.padding, (props)=>props.theme.ctaButton.width, (props)=>props.theme.ctaButton.filter, (props)=>props.theme.ctaButton.iconHeight, (props)=>props.theme.ctaButton.arrowDisplay, (props)=>props.theme.ctaLink.background, (props)=>props.theme.ctaLink.color, (props)=>props.theme.ctaLink.padding, (props)=>props.theme.ctaLink.paddingmargin, (props)=>props.theme.ctaLink.font, (props)=>props.theme.ctaLink.textDecoration, (props)=>props.theme.ctaLink.hover_textDecoration, (props)=>props.theme.ctaLink.filter, (props)=>props.theme.ctaLink.iconHeight, (props)=>props.theme.ctaButton.margin);
var $289432bb95b0c99a$export$2e2bcd8739ae039 = $289432bb95b0c99a$var$Button;



parcelRequire("6cds3");


function $220677e2b6051406$export$2e2bcd8739ae039(props) {
    const { children: children, state: state, onClick: onClick } = props;
    const btn = document.querySelector('#footprinttech-button');
    const parentClass = btn && btn.className ? btn.className : '';
    const className = state && state === 'LOADING' ? 'fpt-cta-button fpt-loading' : `fpt-cta-button ${parentClass}`;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $289432bb95b0c99a$export$2e2bcd8739ae039), {
        className: className,
        type: "button",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4bcd374aec1dcbc0$export$2e2bcd8739ae039), {}),
            children
        ]
    });
}






parcelRequire("6cds3");

const $c11ea7edc054d133$export$8461ee21d3d564d1 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.attrs((props)=>({
        src: props.theme.ctaButton.icon,
        alt: 'Footprint Logo',
        className: 'fpt-cta-button__logo'
    })).withConfig({
    displayName: "CtaIcon",
    componentId: "sc-vjzvan-0"
})([
    "vertical-align:middle;display:inline-block;filter:",
    ";"
], (props)=>props.theme.ctaButton.filter);



const $a5dd497f5c480503$var$Arrow = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "CtaButton__Arrow",
    componentId: "sc-fmff9g-0"
})([
    "margin:0 0 0 1.25rem;height:1.25rem;vertical-align:middle;"
]);
const $a5dd497f5c480503$var$Label = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).span.withConfig({
    displayName: "CtaButton__Label",
    componentId: "sc-fmff9g-1"
})([
    "text-align:center;flex-grow:2;display:flex;align-items:center;justify-content:center;"
]);
const $a5dd497f5c480503$export$87cbfb14b50d331c = (props)=>{
    const { article: article, emitter: emitter } = props;
    const theme = (0, $6cds3.useContext)((0, $e94f79f42775c5f5$export$2c657da244d00bd6));
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3a69ac4f592126f9$export$5f251580d3bb9e3b), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $220677e2b6051406$export$2e2bcd8739ae039), {
                type: "button",
                ...props,
                style: {
                    padding: theme.ctaButton.padding
                },
                onClick: ()=>emitter.emit((0, $e2cdb6d8b920f1a3$export$2e2bcd8739ae039).onCtaPress, article),
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($a5dd497f5c480503$var$Label, {
                    className: "fpt-cta-button__label",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c11ea7edc054d133$export$8461ee21d3d564d1), {}),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                            id: theme.ctaButton.label
                        })
                    ]
                })
            })
        ]
    });
};



parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $b0a728cdb470811b$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $b0a728cdb470811b$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $b0a728cdb470811b$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $b0a728cdb470811b$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($b0a728cdb470811b$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $b0a728cdb470811b$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $b0a728cdb470811b$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $b0a728cdb470811b$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $b0a728cdb470811b$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $b0a728cdb470811b$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $b0a728cdb470811b$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $b0a728cdb470811b$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $b0a728cdb470811b$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $b0a728cdb470811b$var$throttle(this.refresh.bind(this), $b0a728cdb470811b$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$b0a728cdb470811b$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($b0a728cdb470811b$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$b0a728cdb470811b$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $b0a728cdb470811b$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $b0a728cdb470811b$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $b0a728cdb470811b$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $b0a728cdb470811b$var$global$1;
};
// Placeholder of an empty content rectangle.
var $b0a728cdb470811b$var$emptyRect = $b0a728cdb470811b$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $b0a728cdb470811b$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $b0a728cdb470811b$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $b0a728cdb470811b$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $b0a728cdb470811b$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $b0a728cdb470811b$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $b0a728cdb470811b$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $b0a728cdb470811b$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $b0a728cdb470811b$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $b0a728cdb470811b$var$emptyRect;
    var styles = $b0a728cdb470811b$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $b0a728cdb470811b$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $b0a728cdb470811b$var$toFloat(styles.width), height = $b0a728cdb470811b$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $b0a728cdb470811b$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $b0a728cdb470811b$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$b0a728cdb470811b$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $b0a728cdb470811b$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $b0a728cdb470811b$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $b0a728cdb470811b$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $b0a728cdb470811b$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $b0a728cdb470811b$var$isDocumentElement(target) {
    return target === $b0a728cdb470811b$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $b0a728cdb470811b$var$getContentRect(target) {
    if (!$b0a728cdb470811b$var$isBrowser) return $b0a728cdb470811b$var$emptyRect;
    if ($b0a728cdb470811b$var$isSVGGraphicsElement(target)) return $b0a728cdb470811b$var$getSVGContentRect(target);
    return $b0a728cdb470811b$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $b0a728cdb470811b$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $b0a728cdb470811b$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $b0a728cdb470811b$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $b0a728cdb470811b$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $b0a728cdb470811b$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $b0a728cdb470811b$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $b0a728cdb470811b$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $b0a728cdb470811b$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $b0a728cdb470811b$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $b0a728cdb470811b$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $b0a728cdb470811b$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $b0a728cdb470811b$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $b0a728cdb470811b$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $b0a728cdb470811b$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $b0a728cdb470811b$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $b0a728cdb470811b$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $b0a728cdb470811b$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $b0a728cdb470811b$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $b0a728cdb470811b$var$ResizeObserverController.getInstance();
        var observer = new $b0a728cdb470811b$var$ResizeObserverSPI(callback, controller, this);
        $b0a728cdb470811b$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $b0a728cdb470811b$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $b0a728cdb470811b$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $b0a728cdb470811b$var$index = function() {
    // Export existing implementation if available.
    if (typeof $b0a728cdb470811b$var$global$1.ResizeObserver !== 'undefined') return $b0a728cdb470811b$var$global$1.ResizeObserver;
    return $b0a728cdb470811b$var$ResizeObserver;
}();
var $b0a728cdb470811b$export$2e2bcd8739ae039 = $b0a728cdb470811b$var$index;


const $1bd9d858118cd8df$export$e295b0c537d32d7d = ()=>{
    const ref = (0, $6cds3.useRef)(null);
    const [bounds, set] = (0, $6cds3.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0
    });
    const ro = new (0, $b0a728cdb470811b$export$2e2bcd8739ae039)(([entry])=>set(entry.contentRect));
    (0, $6cds3.useEffect)(()=>{
        if (ref && ref.current) {
            ro.observe(ref.current);
            return ()=>ro.disconnect();
        }
        return ()=>ro.disconnect();
    }, [
        ref.current
    ]);
    return {
        bounds: bounds,
        ref: ref
    };
};






const $ab1464ef16c2e998$var$Container = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Tooltip__Container",
    componentId: "sc-158odyi-0"
})([
    "position:relative;"
]);
const $ab1464ef16c2e998$var$Bubble = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Tooltip__Bubble",
    componentId: "sc-158odyi-1"
})([
    "right:0;width:232px;height:auto;padding:12px;box-shadow:0 0 2px 0 rgba(30,78,95,0.7);background-color:#f8fdff;position:absolute;z-index:",
    ";border-radius:10px;"
], (props)=>props.theme['tooltip-z-index']);
const $ab1464ef16c2e998$var$CloseBubble = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Tooltip__CloseBubble",
    componentId: "sc-158odyi-2"
})([
    "color:#ffffff;width:fit-content;padding:7px 26px;border-radius:15.5px;background-color:",
    ";font-family:Inter,sans-serif;font-weight:500;font-size:14px;float:right;margin-top:17px;cursor:pointer;"
], (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue']);
const $ab1464ef16c2e998$var$TooltipTriangle = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.withConfig({
    displayName: "Tooltip__TooltipTriangle",
    componentId: "sc-158odyi-3"
})([
    "left:0;right:0;margin:auto;position:absolute;z-index:2147483643;transform:",
    ";"
], (props)=>props.theme.tooltip.position === 'TOP' ? 'rotate(0)' : 'rotate(180deg)');
const $ab1464ef16c2e998$var$Text = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).span.withConfig({
    displayName: "Tooltip__Text",
    componentId: "sc-158odyi-4"
})([
    "display:inline-block;color:",
    ";font-family:Inter,sans-serif;font-weight:500;font-size:12px;font-stretch:normal;font-style:normal;line-height:1.67;letter-spacing:normal;"
], (0, $4bd05a80e138995f$export$8f45430ccf837300)['dark-slate-blue']);
const $ab1464ef16c2e998$export$28c660c63b792dea = ({ children: children, offset: offset = 0, onCloseClick: onCloseClick, containerStyle: containerStyle, visible: visible = true, messageId: messageId })=>{
    const { bounds: bounds, ref: ref } = (0, $1bd9d858118cd8df$export$e295b0c537d32d7d)();
    const theme = (0, $6cds3.useContext)((0, $e94f79f42775c5f5$export$2c657da244d00bd6));
    const CIRCLE_HEIGHT = 10;
    const relPos = bounds.height + CIRCLE_HEIGHT + offset;
    const btn = document.querySelector('[data-widget=fpt-button]');
    const btnHeight = btn ? btn.offsetHeight : 45;
    const absPos = theme.tooltip.position === 'TOP' ? -1 * relPos : btnHeight + 20;
    const triPos = theme.tooltip.position === 'TOP' ? -10 : bounds.bottom + 12;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($ab1464ef16c2e998$var$Container, {
        style: containerStyle,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($ab1464ef16c2e998$var$Bubble, {
                ref: ref,
                style: {
                    top: `${absPos}px`,
                    display: visible ? 'inline' : 'none'
                },
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($ab1464ef16c2e998$var$Text, {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                            id: messageId,
                            values: {
                                b: (chunks)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                        children: chunks
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($ab1464ef16c2e998$var$CloseBubble, {
                        onClick: onCloseClick,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                            id: "drv.cta-button.tooltip.action"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($ab1464ef16c2e998$var$TooltipTriangle, {
                        src: (0, $17bf087df6a33d6e$export$ec7dcaac71d9599d).tooltipCircle,
                        style: {
                            bottom: `${triPos}px`
                        }
                    })
                ]
            }),
            children
        ]
    });
};








const $737e0ea92ec91c7b$var$Link = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).a.withConfig({
    displayName: "TooltipContainer__Link",
    componentId: "sc-xaqvpw-0"
})([
    "color:#81bcbb;text-decoration:underline;"
]);
const $737e0ea92ec91c7b$var$Hint = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "TooltipContainer__Hint",
    componentId: "sc-xaqvpw-1"
})([
    "font-family:'Open Sans','Helvetica Neue',Helvetica,Arial,'Lucida Grande',sans-serif;font-size:0.875rem;line-height:20px;color:#5f7285;opacity:1;margin-top:10px;text-align:center;"
]);
const $737e0ea92ec91c7b$var$TOOLTIP_MAP = {
    INITIAL: 'drv.cta-button.tooltip.text',
    RECOMMENDATION: 'drv.matching-result.tooltip.text'
};
const $737e0ea92ec91c7b$export$44ec04c6081e3a25 = (props)=>{
    const { children: children, messageId: messageId, settings: settings } = props;
    const isTooltipVisible = ()=>{
        const setting = settings.tooltipEnabled;
        if (!setting || setting === (0, $be61b9cfe3f63cb1$export$6c866809fdbd0d53).NONE) return false;
        if (setting === (0, $be61b9cfe3f63cb1$export$6c866809fdbd0d53).INITIAL && messageId !== $737e0ea92ec91c7b$var$TOOLTIP_MAP.INITIAL) return false;
        if (setting === (0, $be61b9cfe3f63cb1$export$6c866809fdbd0d53).RECOMMENDATION && messageId !== $737e0ea92ec91c7b$var$TOOLTIP_MAP.RECOMMENDATION) return false;
        const result = !(0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).isTooltipViewed(messageId);
        const duration = settings.theme?.tooltip?.duration;
        if (result && duration) setTimeout(()=>setTootipVisible(false), duration);
        return result;
    };
    const [tooltipVisible, setTootipVisible] = (0, $6cds3.useState)(isTooltipVisible());
    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`tooltip visible ${tooltipVisible}`);
    const closeTooltip = ()=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('close called');
        setTootipVisible(false);
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).addViewedTooltip(messageId);
    };
    const refreshTooltip = ()=>{
        setTootipVisible(isTooltipVisible());
    };
    const buttonId = 'footprinttech-button';
    let options = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0
    };
    let observer = new IntersectionObserver((entries)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('observer callback called');
        entries.forEach((item)=>{
            if (!isTooltipVisible()) return;
            setTootipVisible(item.isIntersecting);
        });
    }, options);
    const btn = document.querySelector(`#${buttonId}`);
    if (btn) observer.observe(btn);
    if (!(0, $2fd26587fc2957b4$export$2e2bcd8739ae039).isButtonVisible()) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('device is not mobile, hiding');
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {});
    }
    (0, $6cds3.useEffect)(()=>{
        window.addEventListener('fpt-reload', refreshTooltip);
        return ()=>{
            window.removeEventListener('fpt-reload', refreshTooltip);
        };
    }, []);
    // I am not sure why  FormattedMessage is not used here before, i hope this wont cause an issue here. But For multi-lang support I needed.
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ab1464ef16c2e998$export$28c660c63b792dea), {
        onCloseClick: closeTooltip,
        offset: 30,
        visible: tooltipVisible,
        containerStyle: {
            marginBottom: '0'
        },
        messageId: messageId,
        children: children
    });
};


const $db6ede5b6a185e90$export$52c528fe8b6796c6 = (props)=>{
    const { article: article, matching: matching, emitter: emitter, settings: settings } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $737e0ea92ec91c7b$export$44ec04c6081e3a25), {
        messageId: "drv.cta-button.tooltip.text",
        settings: settings,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a5dd497f5c480503$export$87cbfb14b50d331c), {
            article: article,
            matching: matching,
            emitter: emitter
        })
    });
};




var $6cds3 = parcelRequire("6cds3");
var $945f73d98602e05e$export$e68287b325983edd = /*#__PURE__*/ function(MatchingState) {
    MatchingState[MatchingState["UNDEFINED"] = 0] = "UNDEFINED";
    MatchingState[MatchingState["SUCCESS"] = 1] = "SUCCESS";
    MatchingState[MatchingState["ERROR"] = 2] = "ERROR";
    MatchingState[MatchingState["PROCESSING"] = 3] = "PROCESSING";
    MatchingState[MatchingState["UNAVAILABLE"] = 4] = "UNAVAILABLE";
    return MatchingState;
}({});
var $945f73d98602e05e$export$95f9e03d0eda1b09 = /*#__PURE__*/ function(Availability) {
    Availability[Availability["AVAILABLE"] = 0] = "AVAILABLE";
    Availability[Availability["UNAVAILABLE"] = 1] = "UNAVAILABLE";
    Availability[Availability["ALTERNATIVES"] = 2] = "ALTERNATIVES";
    return Availability;
}({});



parcelRequire("6cds3");


parcelRequire("6cds3");


const $b049bf24c815e09b$var$Arrow = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).img.attrs((props)=>({
        ...props,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d4a3e7faf0a2a0e5$exports))),
        alt: 'Arrow Icon',
        className: 'fpt-cta-button__arrow'
    })).withConfig({
    displayName: "ArrowIcon__Arrow",
    componentId: "sc-ojj9ra-0"
})([
    "margin:0 0 0 30px;width:40px;vertical-align:middle;"
]);
const $b049bf24c815e09b$var$ArrowItem = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($b049bf24c815e09b$var$Arrow, {});
var $b049bf24c815e09b$export$2e2bcd8739ae039 = $b049bf24c815e09b$var$ArrowItem;







parcelRequire("6cds3");


const $ec1b52d65f16361c$var$Panel = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Processing__Panel",
    componentId: "sc-icfbqi-0"
})([
    "background:",
    ";width:",
    ";"
], (props)=>props.theme.ctaButton.background, (props)=>props.theme.ctaButton.width);
const $ec1b52d65f16361c$var$Processing = ()=>{
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($ec1b52d65f16361c$var$Panel, {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4bcd374aec1dcbc0$export$2e2bcd8739ae039), {})
    });
};
var $ec1b52d65f16361c$export$2e2bcd8739ae039 = $ec1b52d65f16361c$var$Processing;


const $90f159364850b434$var$LabelResult = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).span.withConfig({
    displayName: "MatchingResult__LabelResult",
    componentId: "sc-tln7ce-0"
})([
    "display:inline-block;text-align:center;font-weight:bold;flex-grow:2;white-space:nowrap;"
]);
const $90f159364850b434$var$SizeBlock = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "MatchingResult__SizeBlock",
    componentId: "sc-tln7ce-1"
})([
    "display:flex;flex-direction:row;white-space:nowrap;& .fpt-sizeblock-value{font:normal 900 14px Inter,sans-serif}& .fpt-sizeblock-description{font-size:10px;}"
]);
const $90f159364850b434$var$SizeSection = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "MatchingResult__SizeSection",
    componentId: "sc-tln7ce-2"
})([
    "margin:auto 2px;"
]);
const $90f159364850b434$var$MatchingResult = (props)=>{
    const { article: article, emitter: emitter, matching: matching, settings: settings } = props;
    if (!matching) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ec1b52d65f16361c$export$2e2bcd8739ae039), {});
    const size = matching.size ? matching.size.value : '-';
    const description = matching.size ? matching.size.description : '';
    const handlePress = ()=>{
        emitter.emit((0, $e2cdb6d8b920f1a3$export$2e2bcd8739ae039).onRecommendationPress, {
            article: article,
            matching: matching
        });
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $737e0ea92ec91c7b$export$44ec04c6081e3a25), {
        messageId: "drv.matching-result.tooltip.text",
        settings: settings,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $289432bb95b0c99a$export$2e2bcd8739ae039), {
            type: "button",
            ...props,
            onClick: handlePress,
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($90f159364850b434$var$LabelResult, {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $93a170e0016205d7$export$2e2bcd8739ae039), {
                        id: "drv.matching-result.message",
                        values: {
                            size: ``
                        }
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($90f159364850b434$var$SizeBlock, {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($90f159364850b434$var$SizeSection, {
                            className: "fpt-sizeblock-value",
                            children: size
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($90f159364850b434$var$SizeSection, {
                            className: "fpt-sizeblock-description",
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b049bf24c815e09b$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $90f159364850b434$export$2e2bcd8739ae039 = $90f159364850b434$var$MatchingResult;




parcelRequire("6cds3");


const $1f604fcbfc2fef8f$var$gradient = (0, $e94f79f42775c5f5$export$d25ddfdf17c3ad3e)([
    "0%{background-position:0% 50%;}50%{background-position:100% 50%;}100%{background-position:0% 50%;}"
]);
const $1f604fcbfc2fef8f$var$Spinner = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div.withConfig({
    displayName: "GradientSpinner__Spinner",
    componentId: "sc-9j46a9-0"
})([
    "background:linear-gradient(90deg,#e4e4e4,#ffffff);background-size:200% 200%;animation:",
    " 3s linear infinite;width:50%;height:15px;border-radius:5px;"
], $1f604fcbfc2fef8f$var$gradient);
function $1f604fcbfc2fef8f$var$GradientSpinner() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $289432bb95b0c99a$export$2e2bcd8739ae039), {
        type: "button",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($1f604fcbfc2fef8f$var$Spinner, {})
    });
}
var $1f604fcbfc2fef8f$export$2e2bcd8739ae039 = $1f604fcbfc2fef8f$var$GradientSpinner;



const $5f07f3a5d24bdbec$var$outcome = [
    (0, $db6ede5b6a185e90$export$52c528fe8b6796c6),
    (0, $90f159364850b434$export$2e2bcd8739ae039),
    (0, $90f159364850b434$export$2e2bcd8739ae039),
    (0, $1f604fcbfc2fef8f$export$2e2bcd8739ae039)
];
const $5f07f3a5d24bdbec$export$2acd7357333dbaa1 = (props)=>{
    const { emitter: emitter, matching: matching, settings: settings, article: article } = props;
    const [status, setStatus] = (0, $6cds3.useState)((0, $945f73d98602e05e$export$e68287b325983edd).UNDEFINED);
    const OutcomeComponent = $5f07f3a5d24bdbec$var$outcome[status];
    (0, $6cds3.useEffect)(()=>{
        if (!settings.reloadEnabled) {
            setStatus((0, $945f73d98602e05e$export$e68287b325983edd).UNDEFINED);
            return;
        }
        if (!matching) {
            setStatus((0, $945f73d98602e05e$export$e68287b325983edd).UNDEFINED);
            return;
        }
        const code = matching.error_code;
        const isKnownError = code == 'MADB1-00' || code == 'MADB2-00' || code == 'BEDB1-00';
        if (code == 'MAST0-00') setStatus((0, $945f73d98602e05e$export$e68287b325983edd).SUCCESS);
        else if (code == 'pending') setStatus((0, $945f73d98602e05e$export$e68287b325983edd).PROCESSING);
        else if (isKnownError) setStatus((0, $945f73d98602e05e$export$e68287b325983edd).ERROR);
        else setStatus((0, $945f73d98602e05e$export$e68287b325983edd).UNDEFINED);
    }, [
        matching
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3a69ac4f592126f9$export$5f251580d3bb9e3b), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(OutcomeComponent, {
                matching: matching,
                emitter: emitter,
                settings: settings,
                article: article
            })
        ]
    });
};








class $1cb4b7f8102a5c96$var$ArticleService {
    constructor(){
        this.client = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app"
        });
    }
    setSessionId(sessionId) {
        this.client.defaults.headers.common.Authorization = `Bearer ${sessionId}`;
    }
    lookupArticle(data) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('looking for article', data);
        const params = {};
        if (data.articleNumber) params.number = data.articleNumber;
        else if (data.gtin) params.gtin = data.gtin;
        else if (data.sku) params.sku = data.sku;
        return this.client.get('/articles', {
            params: params
        });
    }
}
var $1cb4b7f8102a5c96$export$2e2bcd8739ae039 = new $1cb4b7f8102a5c96$var$ArticleService();






class $0b9a73fbfdf98b28$export$1424597384d1ce2b {
    constructor(config){
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`instantianting conversion service for ${window.location.hostname}`);
        this.client = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: config.baseUrl
        });
        if (config.apiKey) this.client.defaults.headers.common['X-API-KEY'] = config.apiKey;
    }
    setApiKey(apiKey) {
        this.client.defaults.headers.common['X-API-KEY'] = apiKey;
    }
    findPurchase() {
        let result = null;
        if (window.dataLayer && window.dataLayer.length > 0) result = window.dataLayer.find((item)=>item.page_type == 'purchase' && item.event == 'sm_purchase');
        if (result) {
            // purchase
            // order_number
            const purchase_event = window.purchase_event;
            result.transaction_id = purchase_event ? purchase_event.transaction_id : result.transaction_id;
        }
        return result;
    }
    hasPurchase(match, purchase) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('looking for purchase in matches', match);
        const index = purchase.productId.findIndex((id)=>id == match.article_id);
        const result = index > -1;
        if (result) (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('found purchase!');
        else (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('no purchase found!');
        return result;
    }
    getConversionData(match, purchase) {
        const index = purchase.productId.findIndex((id)=>id == match.article_id);
        return {
            matching_id: match.matching_id,
            price: Number(purchase.productPrice[index]),
            quantity: Number(purchase.productQuantity[index]),
            tax: Number(purchase.tax),
            total: Number(purchase.totalValue),
            currency: purchase.currency,
            client_session_id: purchase.transaction_id
        };
    }
    postConversion(payload) {
        return this.client.post('conversions', payload).then(()=>(0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('conversion posted', payload)).catch((err)=>{
            if ((0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).mode === (0, $c40fe7cebd3a81ae$export$770ef1da3280a8ee).VERBOSE) alert(`something went wrong posting conversion ${err.toString()}`);
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).error(`something went wrong posting conversion ${err}`);
        });
    }
    handleConversion(purchase) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('processing purchase', purchase);
        const fptSession = sessionStorage.getItem('fpt-session');
        const sessionData = JSON.parse(fptSession);
        const promises = sessionData.matchings.filter((match)=>this.hasPurchase(match, purchase)).map((match)=>{
            const data = this.getConversionData(match, purchase);
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('posting conversion data', data);
            return this.postConversion(data);
        });
        return Promise.all(promises).then(()=>(0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('conversions completed')).catch((err)=>(0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Something went wrong persisting conversions', err));
    }
}
var $0b9a73fbfdf98b28$export$2e2bcd8739ae039 = new $0b9a73fbfdf98b28$export$1424597384d1ce2b({
    baseUrl: "https://staging-backend.myfootprint.app",
    apiKey: ''
});




class $3f99cf0d3ca33baa$var$MatchingService {
    constructor(){
        this.params = {
            measurement_id: '',
            session_id: '',
            article_number: ''
        };
        this.client = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app"
        });
    }
    setSessionId(sessionId) {
        this.params.session_id = sessionId;
        this.client.defaults.headers.common.Authorization = `Bearer ${sessionId}`;
    }
    setMeasurementId(measurementId) {
        this.params.measurement_id = measurementId;
    }
    setArticleNumber(artNum) {
        this.params.article_number = artNum;
    }
    createMatching() {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('create Matching called', this.params);
        return this.client.post('/matchings', this.params).then((result)=>{
            const matching = result.data;
            if (!matching.size || !matching.sizes || matching.sizes.length === 0) return matching;
            const { size: size } = matching;
            const foundSize = matching.sizes.find((item)=>item.value === size.value);
            if (!foundSize) return matching;
            matching.size.description = foundSize.description;
            return matching;
        });
    }
}
var $3f99cf0d3ca33baa$export$2e2bcd8739ae039 = new $3f99cf0d3ca33baa$var$MatchingService();





class $6e9ca0b1c188a3d7$var$RecommendationService {
    constructor(){
        this.params = {
            measurement_id: '',
            session_id: '',
            query_type: (0, $be61b9cfe3f63cb1$export$e84115ab4a1f1c5b).OR
        };
        this.client = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app"
        });
    }
    setSessionId(sessionId) {
        this.params.session_id = sessionId;
        this.client.defaults.headers.common.Authorization = `Bearer ${sessionId}`;
    }
    setMeasurementId(measurementId) {
        this.params.measurement_id = measurementId;
    }
    setGtin(gtin) {
        this.params.gtin = gtin;
    }
    setSku(sku) {
        this.params.sku = sku;
    }
    setTags(tags) {
        this.params.tags = tags;
    }
    setTagsQueryType(queryType) {
        this.params.query_type = queryType;
    }
    createRecommendation() {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('create Recommendation called', this.params);
        return this.client.post('/recommendations', this.params);
    }
}
var $6e9ca0b1c188a3d7$export$2e2bcd8739ae039 = new $6e9ca0b1c188a3d7$var$RecommendationService();







class $1720c1513557e4d7$var$ClientEventsService {
    constructor(){
        this.client = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app"
        });
    }
    setSessionId(sessionId) {
        this.client.defaults.headers.common.Authorization = `Bearer ${sessionId}`;
    }
    setExternalReference(ref) {
        this.reference = ref;
    }
    createEvent(eventName, eventDetails) {
        const payload = {
            event_name: eventName
        };
        if (eventDetails) payload.event_details = eventDetails;
        if (this.reference) payload.ext_reference = this.reference;
        return this.client.post(`client-events`, payload).catch((err)=>(0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`something wnet wrong trying to persist client event ${err.message}`));
    }
    createEventBatch(events) {
        return this.client.post(`client-events`, {
            events: events
        }).catch((err)=>(0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`something wnet wrong trying to persist client event ${err.message}`));
    }
}
var $1720c1513557e4d7$export$2e2bcd8739ae039 = new $1720c1513557e4d7$var$ClientEventsService();






const $a72bd1709f6bb736$var$defaultSizePattern = /^EU (\d+[.]?\d+?) \/ US (\d+[.]?\d+?)$/;
// Baabuk /^(\d{2})/
function $a72bd1709f6bb736$var$getVariantSize(variant, settings) {
    const title = variant.public_title;
    const pattern = new RegExp(settings.sizePattern);
    if (!pattern.test(title)) return title;
    const match = pattern.exec(title);
    const euSize = match[1];
    // const usSize = match[2];
    return euSize;
}
const $a72bd1709f6bb736$export$3b3e78f1ce6a8956 = {
    handleAddToCart (matching, settings) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('handle matching Shopify');
        const variants = this.getArticleVariants(settings);
        const variant = variants.find((item)=>item.size == matching.size.value && item.available);
        if (!variant) {
            alert('ERROR: Shoe Size not found');
            return Promise.reject();
        }
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).addMatching(matching, this.articleId);
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).update('measurementId', matching.measurement_id);
        const form = new FormData();
        form.append('Size', variant.size);
        form.append('form_type', 'product');
        form.append('utf8', "\u2713");
        // form.append('return_to', '/checkout');
        form.append('id', '' + variant.id);
        form.append('footprint_id', matching.matching_id);
        // const options = { headers: {} };
        // options.headers['X-CSRF-Token'] = csrfToken;
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post('/cart/add', form).then((response)=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Add To cart response', response);
            window.location.href = '/cart';
        });
    },
    getArticlePriceFromVariant (variant) {
        const { price: price } = variant;
        if (!price || Number.isNaN(price) || Number.isNaN(Number.parseInt(price))) return null;
        return price / 100;
    },
    isCheckout () {
        return window.location.pathname.includes('checkouts');
    },
    getArticleVariants (settings) {
        const productData = window.meta?.product;
        return productData.variants.map((item)=>{
            return {
                id: item.id,
                available: true,
                size: $a72bd1709f6bb736$var$getVariantSize(item, settings)
            };
        });
    },
    processPurchase (purchaseData) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('processing purchase', purchaseData);
        const { matching: matching, purchase: purchase, article: article, service: service } = purchaseData;
        const data = {
            matching_id: matching.matching_id,
            price: Number(article.price),
            quantity: Number(article.quantity),
            tax: Number(purchase.tax),
            total: Number(purchase.value),
            currency: purchase.currency,
            client_session_id: '' + purchase.transaction_id
        };
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('posting conversion', data);
        return service.postConversion(data);
    },
    isPurchase () {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('Abstract isPurchase called');
        return false;
    },
    getPurchase () {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('Abstract getPurchase called');
        return null;
    },
    getApiKey () {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('Abstract getApiKey called');
        return '';
    },
    findArticlePurchaseData (id, purchase) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Looking for purchase with id', id);
        return purchase.items.find((item)=>item.id == id);
    },
    handleCheckout () {
        const isPurchase = this.isPurchase();
        if (!isPurchase) {
            const err = new Error('No data found for FPT purchase');
            return Promise.reject(err);
        }
        const fptSessionStr = sessionStorage.getItem('fpt-session');
        if (!fptSessionStr) {
            const err = new Error('No purchase data found');
            return Promise.reject(err);
        }
        const fptSession = JSON.parse(fptSessionStr);
        const articles = Object.getOwnPropertyNames(fptSession.matchings);
        if (articles.length == 0) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('No matchings found', fptSession.matchings);
            return Promise.resolve(null);
        }
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('searching for purchase');
        const purchase = this.getPurchase();
        if (!purchase) {
            const err = new Error('unable to identify purchase object');
            return Promise.reject(err);
        }
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('found purchase', purchase);
        const conversionsService = new (0, $0b9a73fbfdf98b28$export$1424597384d1ce2b)({
            apiKey: this.getApiKey(),
            baseUrl: "https://staging-backend.myfootprint.app"
        });
        const filteredArticles = articles.filter((articleId)=>this.findArticlePurchaseData(articleId, purchase));
        if (!filteredArticles.length) (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('no FPT matchings found');
        const promises = filteredArticles.map((articleId)=>this.findArticlePurchaseData(articleId, purchase)).map((item)=>this.processPurchase({
                purchase: purchase,
                article: item,
                matching: fptSession.matchings['' + item.id],
                service: conversionsService
            }));
        return Promise.all(promises);
    }
};




let $90d2b26344f90169$var$customShopService;
function $90d2b26344f90169$var$hasArticle(data) {
    return data && data.length > 0;
}
function $90d2b26344f90169$var$getSessionLastMeasurement() {
    return (0, $f188c4e754268d8b$export$2e2bcd8739ae039).getSessionMeasurements().then((result)=>{
        if (result && result.length > 0) return result[0];
        return null;
    });
}
function $90d2b26344f90169$var$checkMeasurementState() {
    return (0, $f188c4e754268d8b$export$2e2bcd8739ae039).getSessionEvents().then((events)=>{
        // Check if session CreatedAt is older than 30 minutes
        const session = events.pop();
        const createdAt = new Date(session.createdAt);
        const now = new Date();
        const diff = now.getTime() - createdAt.getTime();
        const minutes = Math.floor(diff / 1000 / 60);
        if (minutes > 5) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('polling session expired');
            return (0, $386c10f0156f9896$export$50f695ee7ce4b786).TIMEOUT;
        }
        if (events.length === 0 || events.length > 0 && events[0].event_name === 'shop.qr.displayed') return (0, $386c10f0156f9896$export$50f695ee7ce4b786).UNDEFINED;
        const initialValue = (0, $386c10f0156f9896$export$50f695ee7ce4b786).MEASURING;
        return events.reduce((accumulator, currentValue)=>{
            if (accumulator === (0, $386c10f0156f9896$export$50f695ee7ce4b786).DONE || accumulator === (0, $386c10f0156f9896$export$50f695ee7ce4b786).CANCELLED) return accumulator;
            if (currentValue.event_name === 'con.measurement.success') return (0, $386c10f0156f9896$export$50f695ee7ce4b786).DONE;
            if (currentValue.event_name === 'shop.qr.closed') return (0, $386c10f0156f9896$export$50f695ee7ce4b786).CANCELLED;
            return accumulator;
        }, initialValue);
    });
}
function $90d2b26344f90169$var$waitForPollingOutcome(expected) {
    return new Promise((fulfill, reject)=>{
        let toId;
        const poll = ()=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('polling . . .');
            $90d2b26344f90169$var$checkMeasurementState().then((outcome)=>{
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Polling: ', outcome);
                // setPollingState(outcome);
                const isFinalOutcome = outcome === (0, $386c10f0156f9896$export$50f695ee7ce4b786).DONE || outcome === (0, $386c10f0156f9896$export$50f695ee7ce4b786).CANCELLED || outcome === (0, $386c10f0156f9896$export$50f695ee7ce4b786).TIMEOUT;
                const continuePolling = !isFinalOutcome;
                if (outcome === expected) {
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('stopped polling');
                    clearTimeout(toId);
                    fulfill(outcome);
                }
                if (continuePolling) {
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('waiting for user measurement');
                    toId = setTimeout(poll, 1000);
                } else if (outcome === (0, $386c10f0156f9896$export$50f695ee7ce4b786).DONE) {
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('stopped polling');
                    clearTimeout(toId);
                    fulfill(outcome);
                } else {
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('stopped polling');
                    clearTimeout(toId);
                    reject(outcome);
                }
            }).catch((err)=>{
                reject(err);
            });
        };
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('start polling');
        poll();
    });
}
let $90d2b26344f90169$var$shopSettings = null;
let $90d2b26344f90169$var$loginReference = null;
const $90d2b26344f90169$var$ShopService = {
    // FIXME: Temporary support for legacy custom service
    setCustomService (service) {
        $90d2b26344f90169$var$customShopService = service;
    },
    setApiKey (apiKey) {
        (0, $f188c4e754268d8b$export$2e2bcd8739ae039).setApiKey(apiKey);
        (0, $0b9a73fbfdf98b28$export$2e2bcd8739ae039).setApiKey(apiKey);
        (0, $2a55a88928dc0706$export$2e2bcd8739ae039).setApiKey(apiKey);
    },
    setShopSettings (settings) {
        $90d2b26344f90169$var$shopSettings = settings;
    },
    setLoginReference (ref) {
        $90d2b26344f90169$var$loginReference = ref;
    },
    hasShopSetting () {
        return !!$90d2b26344f90169$var$shopSettings;
    },
    getArticleData (fptEl) {
        const article = {
            id: '',
            gtin: '',
            ean: '',
            sku: '',
            number: '',
            sizes: []
        };
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('getting article data', fptEl.dataset);
        if ('articleNumber' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got article number', fptEl.dataset.articleNumber);
            article.number = fptEl.dataset.articleNumber;
            article.id = article.number;
        } else if ('gtin' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got article gtin', fptEl.dataset.gtin);
            article.gtin = fptEl.dataset.gtin;
        } else if ('ean' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got article ean', fptEl.dataset.ean);
            article.ean = fptEl.dataset.ean;
        } else if ('sku' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got article sku', fptEl.dataset.sku);
            article.sku = fptEl.dataset.sku;
        } else if ($90d2b26344f90169$var$customShopService) return $90d2b26344f90169$var$customShopService.getArticleData();
        if ('articleName' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got article name', fptEl.dataset.articleName);
            article.name = fptEl.dataset.articleName;
        }
        if ('articleImage' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got article image', fptEl.dataset.articleImage);
            article.image = fptEl.dataset.articleImage;
        }
        if ('articlePrice' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got article price', fptEl.dataset.articlePrice);
            const str = fptEl.dataset.articlePrice;
            const price = Number(str);
            article.price = Number.isNaN(price) || str === '' ? null : price;
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`parsed article price ${article.price}`);
        }
        if ('currency' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got currency', fptEl.dataset.currency);
            article.currency = fptEl.dataset.currency;
        }
        if ('returnUrl' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got return URL', fptEl.dataset.returnUrl);
            article.returnUrl = fptEl.dataset.returnUrl;
        }
        if ('mode' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got return URL', fptEl.dataset.mode);
            article.mode = fptEl.dataset.mode;
        }
        if ($90d2b26344f90169$var$customShopService) {
            const customArticle = $90d2b26344f90169$var$customShopService.getArticleData();
            article.sizes = customArticle.sizes || [];
        }
        return article;
    },
    getApiKey (config) {
        if (config.apiKey) return config.apiKey;
        const fptEl = document.querySelector('#footprinttech-button');
        if (fptEl && 'apiKey' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got API key', fptEl.dataset.apiKey);
            return fptEl.dataset.apiKey;
        } else if ($90d2b26344f90169$var$customShopService) return $90d2b26344f90169$var$customShopService.getApiKey();
        return '';
    },
    getClientSessionId () {
        const fptEl = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getFPTTag();
        if (fptEl && 'sessionId' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got client session id', fptEl.dataset.sessionId);
            return fptEl.dataset.sessionId;
        } else if ($90d2b26344f90169$var$customShopService) return $90d2b26344f90169$var$customShopService.getClientSessionId();
        return '';
    },
    parseReturnUrl (baseUrl, measurementData, article, customerReference) {
        const { sessionId: sessionId, measurementId: measurementId } = measurementData;
        const { number: number } = article;
        let url = `${baseUrl}?fpt-measurement=${measurementId}&fpt-session=${sessionId}`;
        url = number ? `${url}&fpt-article-number=${number}` : url;
        if (customerReference) url = `${url}&fpt-customer-reference=${customerReference}`;
        return url;
    },
    parseReturnUrlWithRecommendation (baseUrl, matching, additionalParams) {
        const measurementId = matching.measurement_id;
        const sessionId = (0, $f188c4e754268d8b$export$2e2bcd8739ae039).getSessionId();
        const articleNumber = matching.article_number;
        const lengthRight = matching.length_right;
        const lengthLeft = matching.length_left;
        const widthRight = matching.width_right;
        const widthLeft = matching.width_left;
        const halluxRight = matching.hallux_right;
        const halluxLeft = matching.hallux_left;
        const size = matching.size ? matching.size.value : 'NA';
        let url = `${baseUrl}?fpt-measurement=${measurementId}&fpt-session=${sessionId}&fpt-lengthr=${lengthRight}&fpt-lengthl=${lengthLeft}&fpt-widthr=${widthRight}&fpt-widthl=${widthLeft}&fpt-size=${size}`;
        if (halluxRight || halluxLeft) url += `&fpt-halluxl=${halluxLeft}&fpt-halluxr=${halluxRight}`;
        url = articleNumber ? `${url}&fpt-article-number=${articleNumber}` : url;
        url = additionalParams ? `${url}&${additionalParams}` : url;
        return url;
    },
    updateSessionId (sessionId) {
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).update('sessionId', sessionId);
        (0, $1cb4b7f8102a5c96$export$2e2bcd8739ae039).setSessionId(sessionId);
        (0, $f188c4e754268d8b$export$2e2bcd8739ae039).setSessionId(sessionId);
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).setSessionId(sessionId);
        (0, $3f99cf0d3ca33baa$export$2e2bcd8739ae039).setSessionId(sessionId);
        (0, $f96dfa98136185cc$export$2e2bcd8739ae039).setSessionId(sessionId);
        return sessionId;
    },
    createSession () {
        const anonymousId = (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).getAnonymousId();
        const sessionData = {
            screen_height: window.innerHeight,
            screen_width: window.innerWidth,
            analytics_accepted: true,
            client_session_id: this.getClientSessionId(),
            anonymous_id: anonymousId,
            referrer: window.location.href
        };
        return (0, $f188c4e754268d8b$export$2e2bcd8739ae039).createSession(sessionData);
    },
    getTarget () {
        return "https://staging-app.myfootprint.app";
    },
    handleCtaButtonClick (article) {
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).addViewedTooltip('drv.cta-button.tooltip.text');
        return this.createSession().then((result)=>{
            this.updateSessionId(result);
            return this.checkIfArticleExists(article);
        });
    },
    handleExistingSession (sessionId, article) {
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).addViewedTooltip('drv.cta-button.tooltip.text');
        this.updateSessionId(sessionId);
        return this.checkIfArticleExists(article);
    },
    checkIfArticleExists (article) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('checking if article exists');
        const articleData = {
            articleNumber: article.number,
            articleName: article.name,
            gtin: article.gtin || article.ean,
            sku: article.sku
        };
        return (0, $1cb4b7f8102a5c96$export$2e2bcd8739ae039).lookupArticle(articleData).then((result)=>{
            const { data: data } = result;
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('lookup article response', result);
            if ($90d2b26344f90169$var$hasArticle(data)) return data[0];
            throw new (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)('WDAR1', 'Article not found');
        });
    },
    getQRData () {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('displaying desktop widget with settings', $90d2b26344f90169$var$shopSettings);
        const { funnel: funnel, lang: lang, theme: theme, steps: steps, desktopFlowEnd: desktopFlowEnd, languageSelectEnabled: languageSelectEnabled } = $90d2b26344f90169$var$shopSettings;
        const themeName = theme ? theme.name : 'default';
        const selectedFunnel = funnel || 'UNDEFINED';
        const intermediateSteps = steps || 'DEFAULT';
        const end = desktopFlowEnd && (0, $be61b9cfe3f63cb1$export$8c57c6eb67fc5a85)[desktopFlowEnd] ? (0, $be61b9cfe3f63cb1$export$8c57c6eb67fc5a85)[desktopFlowEnd] : 'PDP';
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('displaying desktop widget with end', end);
        const params = {
            theme: themeName,
            flow: `${selectedFunnel}-${intermediateSteps}-${end}`,
            session: (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).getSessionId(),
            end: end,
            gdpr: 1
        };
        const widget = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getWidgetEl();
        if (lang) params.lang = lang;
        if (languageSelectEnabled) params['lang-select'] = 1;
        if (widget && 'archType' in widget.dataset) params.footArch = true;
        const currentUrl = new URL(window.location.href);
        const query = new URLSearchParams(currentUrl.search);
        if (query.has('r') || query.has('ref') || query.has('referrer')) params.ref = query.get('r') || query.get('ref') || query.get('referrer');
        return params;
    },
    isSuccessfulMatching (m) {
        return m.error_code === 'MAST0-00';
    },
    getFptAppParams (funnel, article) {
        const { steps: steps, lang: lang, theme: theme, languageSelectEnabled: languageSelectEnabled } = $90d2b26344f90169$var$shopSettings;
        const sp = new URL(window.location.href).searchParams;
        const FlowPat = /^\w+-(.*)-(\w+)$/;
        const flowParam = sp.get('fpt-flow');
        const themeName = theme ? theme.name : 'default';
        const selectedTheme = sp.get('fpt-theme') ? sp.get('fpt-theme') : themeName;
        const flow = sp.get('fpt-flow') ? sp.get('fpt-flow') : '';
        let match = null;
        let intermediateSteps = steps || 'DEFAULT';
        let end = 'PDP';
        if (flowParam && FlowPat.test(flowParam)) {
            match = /^\w+-(.*)-(\w+)$/.exec(flowParam);
            intermediateSteps = match[1];
            end = match[2];
        }
        const params = {
            articleNumber: article?.number,
            theme: selectedTheme,
            flow: flow,
            steps: intermediateSteps,
            session: (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).getSessionId(),
            funnel: funnel,
            gdpr: 1,
            end: end
        };
        if (lang) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`[ShopService] Settings lang ${lang}`);
            params.lang = lang;
        }
        const widget = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getWidgetEl();
        if (languageSelectEnabled) params['lang-select'] = 1;
        if (widget && 'archType' in widget.dataset) params.footArch = true;
        return params;
    },
    openFptAppForFunnel (funnel, article) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`handling guest with funnel ${funnel}`);
        const target = this.getTarget();
        const params = this.getFptAppParams(funnel, article);
        return this.openFptApp(target, params);
    },
    handleFunnelSelect (funnel, article) {
        return this.openFptAppForFunnel(funnel, article);
    },
    handleFunnelSelectEmbeddedMode () {
        const target = window.location.origin;
        // const meaFrame: HTMLElement = RenderUtil.getMeaFrame();
        return new Promise((fulfill, reject)=>{
            window.addEventListener("message", (event)=>{
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got post message', event);
                const senderUrl = new URL(event.origin);
                const expectedUrl = new URL(target);
                // Do we trust the sender of this message? (might be
                // different from what we originally opened, for example).
                if (senderUrl.hostname !== expectedUrl.hostname) return;
                fulfill(event.data);
            }, false);
        // meaFrame.setAttribute('src', url.toString());
        });
    },
    getFptAppUrl (funnel, article) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`handling guest with funnel ${funnel}`);
        const target = this.getTarget();
        const params = this.getFptAppParams(funnel, article);
        return this.buildFptAppUrl(target, params);
    },
    processMeasurement (measurementId, article) {
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).update('measurementId', measurementId);
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).clearMatchings();
        return this.handleExistingMeasurement(measurementId, article);
    },
    handleMeasuringResult (data, article) {
        window.focus();
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('received data', data);
        return new Promise((fulfill, reject)=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('handle measuring result callback called', data.result);
            if (data.result && data.result.error && data.result.error === 'app-closed') {
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('App closed by user');
                // FIXME: We need a new error code for this scenario
                reject(new (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)('WDCNV1', 'App closed by user'));
                return;
            }
            if (data.result && data.result.measurementId) {
                const { sessionId: sessionId, measurementId: measurementId } = data.result;
                this.updateSessionId(sessionId);
                const result = this.processMeasurement(measurementId, article);
                fulfill(result);
                return;
            }
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('Could not retrieve measurement data');
        // reject(new DefaultError('GEN01-00', 'Could not retrieve measurement data'));
        });
    },
    buildFptAppUrl (target, processData) {
        const { funnel: funnel, steps: steps, end: end } = processData;
        const intermediateSteps = steps || 'DEFAULT';
        const data = {
            theme: processData.theme,
            flow: `${funnel}-${intermediateSteps}-${end}`,
            session: (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).getSessionId(),
            lang: processData.lang,
            gdpr: processData.gdpr,
            'lang-select': processData['lang-select'],
            footArch: processData.footArch
        };
        if ($90d2b26344f90169$var$loginReference) data.ext_reference = $90d2b26344f90169$var$loginReference;
        return (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getFptUrl(target, data);
    },
    openFptApp (target, processData) {
        const { funnel: funnel, steps: steps, end: end } = processData;
        const intermediateSteps = steps || 'DEFAULT';
        const data = {
            theme: processData.theme,
            flow: `${funnel}-${intermediateSteps}-${end}`,
            session: (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).getSessionId(),
            lang: processData.lang,
            gdpr: processData.gdpr,
            'lang-select': processData['lang-select'],
            footArch: processData.footArch
        };
        if ($90d2b26344f90169$var$loginReference) data.ext_reference = $90d2b26344f90169$var$loginReference;
        return (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openFptApp(target, data);
    },
    createConversion (matching, article, action, reference) {
        if (matching.error_code !== 'MAST0-00') return;
        const price = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).parseArticlePrice(article.price, $90d2b26344f90169$var$shopSettings);
        const data = {
            matching_id: matching.matching_id,
            price: price,
            quantity: 1,
            tax: 0,
            total: price,
            currency: article.currency,
            action: action
        };
        const clientSessionId = this.getClientSessionId();
        if (clientSessionId) data.client_session_id = clientSessionId;
        if (reference) data.customer_reference = reference;
        return (0, $0b9a73fbfdf98b28$export$2e2bcd8739ae039).postConversion(data);
    },
    createRecommendationConversions (recommendation, reference) {
        const { recommendation_id: recommendation_id } = recommendation;
        const payload = {
            session_id: recommendation.session_id,
            customer_reference: reference,
            action: (0, $be61b9cfe3f63cb1$export$84ee76a85290f693).MATCHING_PRIMARY,
            recommendation_id: recommendation_id
        };
        return (0, $0b9a73fbfdf98b28$export$2e2bcd8739ae039).postConversion(payload);
    },
    readClientCookie (key) {
        let cookie = document.cookie.split(';').find((item)=>item.includes(key));
        if (cookie?.indexOf('=') > -1) return cookie.split('=')[1];
        return null;
    },
    handleMeasurementDone (article) {
        return $90d2b26344f90169$var$getSessionLastMeasurement().then((result)=>{
            if (!result) // FIXME: We need a new error code for this scenario
            throw new (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)('GEN01-00', 'Current session has no measurement');
            const resultData = {
                result: {
                    measurementId: result.measurement_id,
                    sessionId: result.session_id
                }
            };
            return this.handleMeasuringResult(resultData, article);
        });
    },
    async handleExistingMeasurement (measurementId, article) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('[ShopService] handling existing measurement');
        const params = new URLSearchParams(window.location.search);
        // create session if it does notexist
        let sessionId = (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).getSessionId();
        if (!sessionId && !params.has('fpt-session')) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('[ShopService] could not find sessions id for current measurement');
            sessionId = await this.createSession();
            this.updateSessionId(sessionId);
        } else if (params.has('fpt-session')) {
            sessionId = params.get('fpt-session');
            this.updateSessionId(sessionId);
        }
        const { multiRecommendationsEnabled: multiRecommendationsEnabled, articleTags: articleTags } = $90d2b26344f90169$var$shopSettings;
        const tags = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getArticleTagsFromUrlParams() || articleTags;
        if (multiRecommendationsEnabled && tags) {
            (0, $6e9ca0b1c188a3d7$export$2e2bcd8739ae039).setSessionId(sessionId);
            (0, $6e9ca0b1c188a3d7$export$2e2bcd8739ae039).setMeasurementId(measurementId);
            (0, $6e9ca0b1c188a3d7$export$2e2bcd8739ae039).setTags(tags);
            const queryType = $90d2b26344f90169$var$shopSettings.tagsQueryType ? $90d2b26344f90169$var$shopSettings.tagsQueryType : (0, $be61b9cfe3f63cb1$export$e84115ab4a1f1c5b).OR;
            (0, $6e9ca0b1c188a3d7$export$2e2bcd8739ae039).setTagsQueryType(queryType);
            return (0, $6e9ca0b1c188a3d7$export$2e2bcd8739ae039).createRecommendation().then((result)=>result.data);
        }
        const previousMatch = (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).findMatching(article.number);
        if (previousMatch) {
            previousMatch.isStoredInSession = true;
            return Promise.resolve(previousMatch);
        }
        (0, $3f99cf0d3ca33baa$export$2e2bcd8739ae039).setSessionId(sessionId);
        (0, $3f99cf0d3ca33baa$export$2e2bcd8739ae039).setMeasurementId(measurementId);
        (0, $3f99cf0d3ca33baa$export$2e2bcd8739ae039).setArticleNumber(article.number);
        // create matching
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Creating matching for existing existing measurement');
        return (0, $3f99cf0d3ca33baa$export$2e2bcd8739ae039).createMatching().then((data)=>{
            (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).addMatching(data, article.number);
            return data;
        }).catch((err)=>{
            if (err instanceof (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)) throw err;
            if (err.response && err.response.status == '401') {
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`soemething went wrong with getting a match ${err.response.statusText}`);
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('Seems like Session has expired, creating new session');
                return this.createSession().then((result)=>this.updateSessionId(result)).then(()=>{
                    return (0, $3f99cf0d3ca33baa$export$2e2bcd8739ae039).createMatching();
                }).then((result)=>{
                    const { data: data } = result;
                    (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).addMatching(data, article.number);
                    return data;
                }).catch((err)=>{
                    throw new (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)('GEN01-00', 'Create new session or matching failed', {
                        cause: err
                    });
                });
            } else if (err.response && err.response.status == '409' && err.response.data && err.response.data.error_code == 'BEDB1-00') throw new (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)('BEDB1-00', 'Article not found', {
                cause: err
            });
            throw new (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)('GEN01-00', 'Soemething went wrong', {
                cause: err
            });
        });
    },
    handleAddToCart (matching, article) {
        if ($90d2b26344f90169$var$customShopService) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('custom service handling add to cart');
            $90d2b26344f90169$var$customShopService.handleMatching(matching);
        } else if ($90d2b26344f90169$var$shopSettings.platform === (0, $be61b9cfe3f63cb1$export$380708aba139d470).SHOPIFY) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Shopify generic service handling add to cart');
            (0, $a72bd1709f6bb736$export$3b3e78f1ce6a8956).handleAddToCart(matching, $90d2b26344f90169$var$shopSettings);
        } else (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('Add to cart called but feature is not supported');
        this.createConversion(matching, article, (0, $be61b9cfe3f63cb1$export$84ee76a85290f693).ADDITEM);
    },
    waitForUserToStartMeasuring () {
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).clearMeasurement();
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).clearMatchings();
        return $90d2b26344f90169$var$waitForPollingOutcome((0, $386c10f0156f9896$export$50f695ee7ce4b786).MEASURING);
    },
    waitForUserToFinishMeasuring () {
        return $90d2b26344f90169$var$waitForPollingOutcome((0, $386c10f0156f9896$export$50f695ee7ce4b786).DONE);
    },
    logError (err, article) {
        let cause = 'cause' in err ? err.cause.message : '';
        if (err.errorCode === 'WDAR1' || err.errorCode === 'MADB2-00') cause = article.number;
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent(`shop.error.${err.errorCode}`, cause);
    },
    logRecommendationFeedback (recommendation) {
        const gender = [];
        const fits = [];
        if (recommendation.gender) gender.push({
            event_name: "shop.recommendation-feedback",
            event_details: `gender:${recommendation.gender}`
        });
        const sizeFeedback = recommendation.variants.filter((item)=>item.error_code === 'MAST0-00').map((item)=>{
            if (item.best_fit) fits.push({
                event_name: "shop.recommendation-feedback",
                event_details: `bestFit:${item.article_number}`,
                matching_id: item.matching_id
            });
            return {
                event_name: "shop.recommendation-feedback",
                event_details: item.size?.feedback,
                matching_id: item.matching_id
            };
        });
        const clientEvents = gender.concat(fits, sizeFeedback);
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEventBatch(clientEvents);
    }
};
var $90d2b26344f90169$export$2e2bcd8739ae039 = $90d2b26344f90169$var$ShopService;



const $9c09acafd0d22f3e$var$checkoutService = {
    getAvailability: function(available, matching) {
        let found = false;
        if (matching && matching.size) found = available.find((item)=>item == matching.size.value);
        return found ? (0, $945f73d98602e05e$export$95f9e03d0eda1b09).AVAILABLE : (0, $945f73d98602e05e$export$95f9e03d0eda1b09).UNAVAILABLE;
    },
    formatCurrency: function(value, lang = 'de-DE', currency = 'EUR') {
        const intl = new Intl.NumberFormat(lang, {
            style: 'currency',
            currency: currency
        });
        return value ? intl.format(value) : '';
    }
};
var $9c09acafd0d22f3e$export$2e2bcd8739ae039 = $9c09acafd0d22f3e$var$checkoutService;

















const $f686bfa33774dad2$export$d990cc5f51685546 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext((0, $8ddc9fe4248467fa$export$7dfd81af9fc545f2));
const $f686bfa33774dad2$export$9ed0816deade4fed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext((0, $8ddc9fe4248467fa$export$f4c588f8926c7637));
const $f686bfa33774dad2$export$bd63dc5a00fdc201 = (props)=>{
    const { articleList: articleList, emitter: emitter, bannerId: bannerId, headlessEnabled: headlessEnabled } = props;
    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('initializing appcontext');
    let currentArticle = null;
    let customerReference = null;
    const initLang = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getLang();
    const initMessages = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getTranslationMessages(initLang, (0, $31c680c31ce1361b$export$67d7e6220353b39d));
    const [shopSettings, setShopSettings] = (0, $6cds3.useState)((0, $8ddc9fe4248467fa$export$7dfd81af9fc545f2));
    const [article, setArticle] = (0, $6cds3.useState)((0, $8ddc9fe4248467fa$export$f4c588f8926c7637));
    const [locale, setLocale] = (0, $6cds3.useState)((0, $31c680c31ce1361b$export$67d7e6220353b39d)[initLang].locale);
    const [messages, setMessages] = (0, $6cds3.useState)(initMessages);
    const [customTheme, setCustomTheme] = (0, $6cds3.useState)((0, $a58a64c681e03a20$export$2e2bcd8739ae039));
    const [language, setLanguage] = (0, $6cds3.useState)(initLang);
    const [modalView, setModalView] = (0, $6cds3.useState)((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).UNDEFINED);
    const [modalData, setModalData] = (0, $6cds3.useState)({});
    let sessionId = (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).getSessionId();
    if (sessionId) (0, $90d2b26344f90169$export$2e2bcd8739ae039).updateSessionId(sessionId);
    const clearModal = ()=>{
        (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).closeModal();
        setModalData({});
        setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).UNDEFINED);
    };
    const handleTimeout = ()=>{
        (0, $f188c4e754268d8b$export$2e2bcd8739ae039).updateExitCode('PDP', 'qr.timeout');
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.qr.timeout');
    };
    const resetMeasurement = ()=>{
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).clearMatchings();
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).clearMeasurement();
    };
    const displaySplashscreen = ()=>{
        const funnel = shopSettings.funnel || (0, $be61b9cfe3f63cb1$export$e059618c1faa2ae1).UNDEFINED;
        setModalData({
            funnel: funnel
        });
        setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).SPLASHSCREEN);
        (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openModal();
    };
    const displayInputSelection = ()=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Displaying Input Selection');
        const funnel = shopSettings.funnel || (0, $be61b9cfe3f63cb1$export$e059618c1faa2ae1).UNDEFINED;
        setModalData({
            funnel: funnel
        });
        setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).INPUT_SELECTION);
        (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openModal();
    };
    const displayEmbeddedMeasurementScreen = (fptAppUrl)=>{
        setModalData({
            src: fptAppUrl
        });
        setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).MEASUREMENT);
        (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openModal();
    };
    const displayRecommendation = async (matching)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('displaying recommendation');
        const recommendationPriceEnabled = shopSettings.recommendationPriceEnabled !== false;
        const recommendationMatchingCodeEnabled = !!shopSettings.recommendationMatchingCodeEnabled;
        const { data: data } = await (0, $f96dfa98136185cc$export$2e2bcd8739ae039).getMeasurementFrames();
        const hasPiFrames = !!data.find((frame)=>frame.source === (0, $be61b9cfe3f63cb1$export$ea7340d08bbb5cf8).PI);
        setModalData({
            matching: matching,
            recommendationPriceEnabled: recommendationPriceEnabled,
            recommendationMatchingCodeEnabled: recommendationMatchingCodeEnabled,
            hasPiFrames: hasPiFrames
        });
        setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).RECOMMENDATION);
        (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openModal();
    };
    const displayMultiRecommendation = (recommendation)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('displaying multi recommendation');
        setModalData({
            recommendation: recommendation
        });
        setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).MULTI_RECOMMENDATION);
        (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openModal();
    };
    const displayEmailForm = ()=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Displaying Email Form');
        setModalData({});
        setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).EMAIL_FORM);
        (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openModal();
    };
    const displaySuccessOutcome = ()=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Displaying Email Form');
        setModalData({});
        setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).SUCCESS_OUTCOME);
        (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openModal();
    };
    const displayError = (err)=>{
        if (!(err instanceof (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4))) err = new (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)('GEN01-00', 'Something went wrong', {
            cause: err
        });
        setModalData({
            error: err
        });
        setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).ERROR);
        (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openModal();
        (0, $90d2b26344f90169$export$2e2bcd8739ae039).logError(err, currentArticle);
    };
    const displayDesktopWidget = ()=>{
        (0, $f188c4e754268d8b$export$2e2bcd8739ae039).updateExitCode('PDP', 'qr.displayed');
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.qr.displayed').then(()=>{
            const target = window.location.origin + window.location.pathname; // process.env.FPT_APP_URL;
            const data = (0, $90d2b26344f90169$export$2e2bcd8739ae039).getQRData();
            const params = new URLSearchParams(window.location.search);
            params.append('fpt-article-number', currentArticle.number);
            params.append('fpt-session', data.session);
            params.append('fpt-flow', data.flow);
            if (data.theme) params.append('fpt-theme', data.theme);
            const flowParts = data.flow.split('-');
            const lastPart = flowParts.length - 1;
            const pollingEnabled = flowParts[lastPart] == (0, $be61b9cfe3f63cb1$export$c54e410b5d8ae915).EXT;
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`opening QRGateway: ${target}?${params.toString()}`);
            const url = new URL(`${target}?${params.toString()}`);
            setModalData({
                target: url,
                polling: (0, $386c10f0156f9896$export$50f695ee7ce4b786).UNDEFINED
            });
            setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).QR);
            (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openModal();
            if (pollingEnabled) return (0, $90d2b26344f90169$export$2e2bcd8739ae039).waitForUserToStartMeasuring().then((outcome)=>{
                setModalData({
                    target: url,
                    polling: outcome
                });
                return (0, $90d2b26344f90169$export$2e2bcd8739ae039).waitForUserToFinishMeasuring();
            });
            return (0, $386c10f0156f9896$export$50f695ee7ce4b786).UNDEFINED;
        }).then((outcome)=>{
            if (outcome === (0, $386c10f0156f9896$export$50f695ee7ce4b786).UNDEFINED) // Nothing to do since polling was not enabled
            return;
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('finished measuring');
            (0, $90d2b26344f90169$export$2e2bcd8739ae039).handleMeasurementDone(currentArticle).then((result)=>{
                emitter.emit((0, $553cb74d80b27513$export$2e2bcd8739ae039).onMatching, result);
                const event = new CustomEvent("fpt-matching", {
                    detail: result
                });
                window.dispatchEvent(event);
                if ((0, $90d2b26344f90169$export$2e2bcd8739ae039).isSuccessfulMatching(result)) {
                    displayRecommendation(result);
                    (0, $90d2b26344f90169$export$2e2bcd8739ae039).createConversion(result, currentArticle, (0, $be61b9cfe3f63cb1$export$84ee76a85290f693).MATCHING_PRIMARY);
                    return;
                }
                throw new (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)(result.error_code, 'Matching failed');
            }).catch((err)=>{
                displayError(err);
            });
        }).catch((outcome)=>{
            if (outcome === (0, $386c10f0156f9896$export$50f695ee7ce4b786).CANCELLED) {
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('polling cancelled');
                clearModal();
                return;
            }
            if (outcome === (0, $386c10f0156f9896$export$50f695ee7ce4b786).TIMEOUT) {
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('polling timeout');
                handleTimeout();
                clearModal();
                return;
            }
            displayError(outcome);
        });
    };
    const displayStartScreen = ()=>{
        const isFootArchEnabled = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).isFootArchEnabled(shopSettings);
        console.log('is Mobile:', (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).isMobile());
        if (shopSettings.desktopFlowEnabled && !(0, $2fd26587fc2957b4$export$2e2bcd8739ae039).isMobile()) displayDesktopWidget();
        else if (isFootArchEnabled) displayInputSelection();
        else displaySplashscreen();
    };
    const handleFptStart = (data)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('fpt start called with payload', data);
        if (data && data.detail) {
            customerReference = data.detail.customer_reference;
            const loginReference = data.detail.login_reference || null;
            (0, $90d2b26344f90169$export$2e2bcd8739ae039).setLoginReference(loginReference);
            (0, $1720c1513557e4d7$export$2e2bcd8739ae039).setExternalReference(loginReference);
        }
        if (headlessEnabled) {
            currentArticle = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getArticleDataFromModal();
            const price = currentArticle.price;
            const priceNum = price ? (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).parseArticlePrice(price, shopSettings) : null;
            const currency = currentArticle.currency || shopSettings.currency || (0, $be61b9cfe3f63cb1$export$8bbed17cf90fe422).EUR;
            currentArticle.sum = price ? (0, $9c09acafd0d22f3e$export$2e2bcd8739ae039).formatCurrency(priceNum, locale, currency) : null;
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Headless enabled,setting article data', currentArticle);
        }
        if (data && data.detail && data.detail.articleNumber) currentArticle.number = data.detail.articleNumber;
        const params = new URLSearchParams(window.location.search);
        let onArticleCheck;
        if (params.has('fpt-session')) onArticleCheck = (0, $90d2b26344f90169$export$2e2bcd8739ae039).checkIfArticleExists(currentArticle);
        else onArticleCheck = (0, $90d2b26344f90169$export$2e2bcd8739ae039).createSession().then((result)=>{
            (0, $90d2b26344f90169$export$2e2bcd8739ae039).updateSessionId(result);
            return (0, $90d2b26344f90169$export$2e2bcd8739ae039).checkIfArticleExists(currentArticle);
        });
        onArticleCheck.then((result)=>{
            currentArticle.number = result.article_number;
            setArticle(currentArticle);
            displayStartScreen();
        }).catch((error)=>{
            if (error.errorCode === 'WDAR1' && shopSettings.hasDefaultArticle) return displayStartScreen();
            displayError(error);
            let code = 'GEN01-00';
            if (error instanceof (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)) code = error.errorCode;
            (0, $f188c4e754268d8b$export$2e2bcd8739ae039).updateExitCode('error', code);
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).error(`something went wrong: ${error}`);
        });
    };
    const processArticleDataAndDisplaySplashscreen = (result)=>{
        const OptionalPlantarImagePat = /.*-(PIOPT)/;
        const MandatoryPlantarImagePat = /.*-PI$/;
        if (currentArticle.gtin || currentArticle.ean || currentArticle.sku) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`setting article number ${result.article_number}`);
            currentArticle.number = result.article_number;
            setArticle(currentArticle);
        }
        if (shopSettings.insoleAvailable && (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).isArticleInsole(result)) {
            const { steps: steps } = shopSettings;
            shopSettings.steps = OptionalPlantarImagePat.test(steps) ? steps.replace('PIOPT', 'PI') : MandatoryPlantarImagePat.test(steps) ? steps : `${steps}-PI`;
            setShopSettings(shopSettings);
            (0, $90d2b26344f90169$export$2e2bcd8739ae039).setShopSettings(shopSettings);
        }
        displayStartScreen();
    };
    const handleProcessArticleDataError = (error)=>{
        if (error.errorCode === 'WDAR1' && shopSettings.hasDefaultArticle) return displayStartScreen();
        displayError(error);
        let code = 'GEN01-00';
        if (error instanceof (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)) code = error.errorCode;
        (0, $f188c4e754268d8b$export$2e2bcd8739ae039).updateExitCode('error', code);
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).error(`something went wrong: ${error.message}`);
    };
    const handleCtaButtonPress = (articleData)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`CTA Button clicked ${articleData.number}`, articleData);
        setArticle(articleData);
        currentArticle = articleData;
        setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).PROCESSING);
        (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openModal();
        (0, $90d2b26344f90169$export$2e2bcd8739ae039).handleCtaButtonClick(articleData).then(processArticleDataAndDisplaySplashscreen).catch(handleProcessArticleDataError);
    };
    const handleSingleMatch = (matching)=>{
        emitter.emit((0, $553cb74d80b27513$export$2e2bcd8739ae039).onMatching, matching);
        const event = new CustomEvent("fpt-matching", {
            detail: matching
        });
        window.dispatchEvent(event);
        const { measurement_id: measurement_id } = matching;
        (0, $f96dfa98136185cc$export$2e2bcd8739ae039).setMeasurementId(measurement_id);
        if ((0, $90d2b26344f90169$export$2e2bcd8739ae039).isSuccessfulMatching(matching)) {
            displayRecommendation(matching);
            (0, $90d2b26344f90169$export$2e2bcd8739ae039).createConversion(matching, currentArticle, (0, $be61b9cfe3f63cb1$export$84ee76a85290f693).MATCHING_PRIMARY);
            return;
        }
        throw new (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)(matching.error_code, 'Matching failed');
    };
    const prepareNewMeasurement = ()=>{
        clearModal();
        resetMeasurement();
    };
    const handleMeasurementProcessError = (err)=>{
        const errData = {
            code: err.errorCode,
            message: err.message
        };
        const event = new CustomEvent("fpt-error", {
            detail: errData
        });
        window.dispatchEvent(event);
        if (err instanceof (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4) && err.errorCode === 'WDCNV1') {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('App closed by the user');
            return;
        }
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).error(`something went wrong ${err.message}`);
        displayError(err);
    };
    const handleMatchingResult = (result, additionalParams)=>{
        if (!result) return;
        const returnUrl = currentArticle?.returnUrl || shopSettings.returnUrl;
        if (returnUrl && result.error_code && result.error_code === "MAST0-00") return (0, $90d2b26344f90169$export$2e2bcd8739ae039).createConversion(result, currentArticle, (0, $be61b9cfe3f63cb1$export$84ee76a85290f693).MATCHING_PRIMARY, customerReference).then(()=>{
            window.location.href = (0, $90d2b26344f90169$export$2e2bcd8739ae039).parseReturnUrlWithRecommendation(returnUrl, result, additionalParams);
        });
        if (headlessEnabled && result.variants) {
            if (additionalParams) {
                const p = new URLSearchParams(additionalParams);
                p.forEach((value, key)=>result[key] = value);
            }
            return (0, $90d2b26344f90169$export$2e2bcd8739ae039).createRecommendationConversions(result, customerReference).then(()=>{
                const recommendationEvent = new CustomEvent('fpt-recommendation', {
                    detail: result
                });
                window.dispatchEvent(recommendationEvent);
            }).catch((err)=>{
                (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.multi-recommendation.conversion-error', err.toString()).then(()=>{
                    const recommendationEvent = new CustomEvent('fpt-recommendation', {
                        detail: result
                    });
                    window.dispatchEvent(recommendationEvent);
                });
            });
        }
        if (result.variants) return displayMultiRecommendation(result);
        handleSingleMatch(result);
    };
    const handleFunnelSelect = (funnel)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`${funnel} funnel selected`);
        const option = funnel.toLowerCase();
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent(`shop.splashscreen.${option}-press`);
        prepareNewMeasurement();
        const returnUrl = currentArticle?.returnUrl || shopSettings.returnUrl;
        let waitForResult;
        const isEmbeddedMode = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).isEmbeddedMode();
        if (isEmbeddedMode) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`handling funnel select in embeded mode ${funnel}`);
            const fptAppUrl = (0, $90d2b26344f90169$export$2e2bcd8739ae039).getFptAppUrl(funnel, currentArticle);
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`[AppController] opening conversion at ${fptAppUrl}`);
            displayEmbeddedMeasurementScreen(fptAppUrl);
            waitForResult = (0, $90d2b26344f90169$export$2e2bcd8739ae039).handleFunnelSelectEmbeddedMode().then((data)=>{
                clearModal();
                return data;
            });
        } else waitForResult = (0, $90d2b26344f90169$export$2e2bcd8739ae039).handleFunnelSelect(funnel, currentArticle);
        waitForResult.then((data)=>{
            if (returnUrl && shopSettings.recommendationEnabled == false && data.result && data.result.measurementId) {
                window.location.href = (0, $90d2b26344f90169$export$2e2bcd8739ae039).parseReturnUrl(returnUrl, data.result, currentArticle, customerReference);
                return;
            }
            const event = new CustomEvent("fpt-measurement", {
                detail: data ? data.result : null
            });
            window.dispatchEvent(event);
            return (0, $90d2b26344f90169$export$2e2bcd8739ae039).handleMeasuringResult(data, currentArticle);
        }).then(handleMatchingResult).catch(handleMeasurementProcessError);
    };
    const getInterstepsForFootArchOptions = ()=>{
        shopSettings.steps = shopSettings.steps.replace('-PIOPT', '');
        const match = /(.*)-FA$/.exec(shopSettings.steps);
        if (!match) throw new Error(`Invalid steps configuration for Foot Arch flow: ${shopSettings.steps}`);
        const interSteps = match[1];
        const updated = Object.assign({}, shopSettings);
        updated.steps = interSteps;
        setShopSettings(updated);
        return interSteps;
    };
    const displayMcGateway = (data)=>{
        setModalData(data);
        setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).MC_GATEWAY);
        (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openModal();
    };
    const handleMcOptionSelect = ()=>{
        prepareNewMeasurement();
        // setModalData({ sessionId: 'test', measurementId: 'test' });
        // setModalView(ModalView.MC_GATEWAY);
        // RenderUtil.openModal();
        let waitForResult = Promise.resolve();
        const funnel = (0, $be61b9cfe3f63cb1$export$e059618c1faa2ae1).OTHER;
        const isEmbeddedMode = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).isEmbeddedMode();
        if (isEmbeddedMode) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`handling funnel select in embeded mode ${funnel}`);
            const fptAppUrl = (0, $90d2b26344f90169$export$2e2bcd8739ae039).getFptAppUrl(funnel, currentArticle);
            displayEmbeddedMeasurementScreen(fptAppUrl);
            waitForResult = (0, $90d2b26344f90169$export$2e2bcd8739ae039).handleFunnelSelectEmbeddedMode();
        } else waitForResult = (0, $90d2b26344f90169$export$2e2bcd8739ae039).openFptAppForFunnel(funnel, currentArticle);
        waitForResult.then((data)=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`displaying MC Gateway . . .`);
            if (!data.result || !data.result.measurementId) throw new Error('Fpt App returned with no measurement');
            const { sessionId: sessionId, measurementId: measurementId } = data.result;
            (0, $90d2b26344f90169$export$2e2bcd8739ae039).updateSessionId(sessionId);
            (0, $f96dfa98136185cc$export$2e2bcd8739ae039).setMeasurementId(measurementId);
            displayMcGateway({
                sessionId: sessionId,
                measurementId: measurementId
            });
        });
    };
    const handleSpeedOptionConfirm = (selectedOption)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Speed Option confirmed:', selectedOption);
        const { steps: steps } = shopSettings;
        if (selectedOption === (0, $c423b76e7a9af3b2$export$4104c4f351fcab7a).FAST_TRACK) {
            shopSettings.steps = steps.replace(/^(\w+)/, 'POWER');
            setShopSettings(shopSettings);
            (0, $90d2b26344f90169$export$2e2bcd8739ae039).setShopSettings(shopSettings);
        }
        const OPTION_MAP = {};
        OPTION_MAP[(0, $c423b76e7a9af3b2$export$4104c4f351fcab7a).FAST_TRACK] = 'Fast Track mode';
        OPTION_MAP[(0, $c423b76e7a9af3b2$export$4104c4f351fcab7a).STANDARD] = 'Standard mode';
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.input-selection.select', OPTION_MAP[selectedOption]);
    };
    const handleMeasureOptionConfirm = (selectedOption)=>{
        const { steps: steps } = shopSettings;
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Hanlde Foot Arch Option Select', selectedOption);
        const OPTION_MAP = {};
        OPTION_MAP[(0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).MC] = 'minipod';
        OPTION_MAP[(0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).PI] = 'plantar image';
        OPTION_MAP[(0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).FPT] = 'mobile arch';
        OPTION_MAP[(0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).NONE] = 'LP foot only';
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.input-selection.select', OPTION_MAP[selectedOption]);
        if (selectedOption === (0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).MC || selectedOption === (0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).PI || selectedOption === (0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).NONE) shopSettings.steps = getInterstepsForFootArchOptions();
        if (selectedOption === (0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).PI) shopSettings.steps = `${shopSettings.steps}-PI`;
        if (selectedOption === (0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).FPT) shopSettings.steps = steps.replace('-PIOPT', '');
        setShopSettings(shopSettings);
        (0, $90d2b26344f90169$export$2e2bcd8739ae039).setShopSettings(shopSettings);
        if (selectedOption === (0, $be61b9cfe3f63cb1$export$c726bcddb8d44055).MC) return handleMcOptionSelect();
        return handleFunnelSelect((0, $be61b9cfe3f63cb1$export$e059618c1faa2ae1).OTHER);
    };
    const handleMcPollingStart = (params)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Polling started with params`, params);
        const sparams = new URLSearchParams(params);
        const mtype = sparams.get('hasOrthopedicsOrPain') ? 'dynamic' : 'static';
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.mc-gateway.polling-start', mtype);
    };
    const handleMcPollingDone = (outcome)=>{
        const { frame: frame, params: params } = outcome;
        const sparams = new URLSearchParams(params);
        const mtype = sparams.get('hasOrthopedicsOrPain') ? 'dynamic' : 'static';
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.mc-gateway.polling-done', `${frame.arch_type}, ${mtype}`);
        (0, $90d2b26344f90169$export$2e2bcd8739ae039).processMeasurement(frame.measurement_id, currentArticle).then((matching)=>handleMatchingResult(matching, params)).catch(handleMeasurementProcessError);
    };
    const handleProfileMeasurementSet = (data)=>{
        const { articleNumber: articleNumber, measurementId: measurementId } = data;
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Handling profile measurement set for measurement ${measurementId}`);
        const articleData = articleList.find((item)=>item.number === articleNumber);
        (0, $90d2b26344f90169$export$2e2bcd8739ae039).processMeasurement(measurementId, articleData).then((matching)=>{
            emitter.emit((0, $553cb74d80b27513$export$2e2bcd8739ae039).onMatching, matching);
            const event = new CustomEvent("fpt-matching", {
                detail: matching
            });
            window.dispatchEvent(event);
        }).catch(handleMeasurementProcessError);
    };
    const handleMcPollingCancelled = ()=>{
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.mc-gateway.polling-cancelled');
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Polling cancelled');
        prepareNewMeasurement();
        displayInputSelection();
    };
    const handleMcPollingError = (err)=>{
        const event = new CustomEvent("fpt-error", {
            detail: err
        });
        window.dispatchEvent(event);
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).error(`something went wrong ${err.message}`);
        displayError(err);
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.mc-gateway.polling-error', err.message);
    };
    const handleLanguageSetting = (selectedLanguage, settings = shopSettings)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Handling Language ${selectedLanguage} selected`);
        setLanguage(selectedLanguage);
        const { lang: lang } = settings;
        if (lang !== selectedLanguage) settings.lang = selectedLanguage;
        const langOptions = {
            lang: selectedLanguage,
            i18nNamespace: settings.theme?.i18nNamespace
        };
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`handleLanguageSetting using i18nNamespace ${langOptions.i18nNamespace}`);
        return (0, $eb35e4b56fe508da$export$42208c4599db7952).fetchLanguageFile(langOptions).then((result)=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`setting language ${selectedLanguage}`);
            (0, $31c680c31ce1361b$export$67d7e6220353b39d)[selectedLanguage].messages = result;
            setLocale((0, $31c680c31ce1361b$export$67d7e6220353b39d)[selectedLanguage].locale);
            const m = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getTranslationMessages(selectedLanguage, (0, $31c680c31ce1361b$export$67d7e6220353b39d));
            setMessages(m);
        });
    };
    const handleLanguageSelect = (selectedLanguage)=>{
        handleLanguageSetting(selectedLanguage);
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.splashscreen.language-select', selectedLanguage);
    };
    const handleRecommendationPress = (data)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Recommendation pressedS`, data);
        setArticle(data.article);
        currentArticle = data.article;
        const { matching: matching } = data;
        if (matching.error_code === 'MAST0-00') {
            const { measurement_id: measurement_id } = matching;
            (0, $f96dfa98136185cc$export$2e2bcd8739ae039).setMeasurementId(measurement_id);
            return displayRecommendation(matching);
        }
        (0, $f188c4e754268d8b$export$2e2bcd8739ae039).updateExitCode('error', matching.error_code);
        // let errorCode = matching.error_code;
        //
        // if (matching.error_code == 'BEDB1-00') {
        //   errorCode = 'BEDB1';
        // }
        displayError(new (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)(matching.error_code));
    };
    const handleAddToCartPress = (recommendation)=>{
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.recommendation.add-to-cart-press', currentArticle.number);
        recommendation.session_id = (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).getSessionId();
        const event = new CustomEvent('fpt-add-to-cart', {
            detail: recommendation
        });
        window.dispatchEvent(event);
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('dispatched event', event);
        (0, $90d2b26344f90169$export$2e2bcd8739ae039).handleAddToCart(recommendation, currentArticle);
        clearModal();
    };
    const handleBackToShopPress = (matching)=>{
        clearModal();
    };
    const handleRecommendationBackToShopPress = (recommendation)=>{
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.recommendation.back-to-shop-press');
        clearModal();
        recommendation.session_id = (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).getSessionId();
        const event = new CustomEvent('fpt-back-to-shop', {
            detail: recommendation
        });
        window.dispatchEvent(event);
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`dispatched event`, event);
    };
    const handleCancelPress = (recommendation)=>{
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.recommendation.cancel-press');
        clearModal();
        recommendation.session_id = (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).getSessionId();
        const event = new CustomEvent('fpt-cancel', {
            detail: recommendation
        });
        window.dispatchEvent(event);
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('dispatched event', event);
    };
    const handlePiReconstructionRequest = ()=>{
        // clientEventsService.createEvent('shop.recommendation.cancel-press');
        // clearModal();
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('displaying Email Form');
        displayEmailForm();
    };
    const handleQRPanelClose = ()=>{
        clearModal();
        (0, $f188c4e754268d8b$export$2e2bcd8739ae039).updateExitCode('PDP', 'qr.closed');
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.qr.closed');
    };
    const handleMeasureAgainPress = ()=>{
        (0, $1720c1513557e4d7$export$2e2bcd8739ae039).createEvent('shop.recommendation.measure-again-press');
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('New Measurement Press');
        resetMeasurement();
        (0, $90d2b26344f90169$export$2e2bcd8739ae039).createSession().then((result)=>{
            (0, $90d2b26344f90169$export$2e2bcd8739ae039).updateSessionId(result);
            const pageUrl = new URL(window.location.href);
            const { searchParams: searchParams } = pageUrl;
            if ((0, $2fd26587fc2957b4$export$2e2bcd8739ae039).isMobile() && searchParams.get('fpt-session')) {
                searchParams.set('fpt-session', result);
                searchParams.delete('fpt-measurement');
                window.location.replace(pageUrl);
                return;
            }
            if ((0, $2fd26587fc2957b4$export$2e2bcd8739ae039).isMobile()) {
                displaySplashscreen();
                return;
            }
            displayDesktopWidget();
        });
    };
    const displayFeedbackConfirmDialog = (recommendation)=>{
        setModalData({
            recommendation: recommendation
        });
        setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).FEEDBACK_CONFIRM);
        (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openModal();
    };
    const handleFeedbackConfirm = (outcome)=>{
        const confirmation = new CustomEvent('fpt-feedback-confirm', {
            detail: outcome
        });
        window.dispatchEvent(confirmation);
        clearModal();
        if (outcome.confirm) (0, $90d2b26344f90169$export$2e2bcd8739ae039).logRecommendationFeedback(outcome.recommendation);
    };
    const processArticleData = (articleData, settings)=>{
        const { currency: currency, lang: lang, pricePattern: pricePattern } = settings;
        if (!articleData.currency) articleData.currency = currency || 'EUR';
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`using article price pattern ${pricePattern}`);
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`processing article price ${articleData.price}`);
        const priceNum = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).parseArticlePrice(articleData.price, settings);
        const selectedLanguage = lang || language;
        articleData.sum = (0, $9c09acafd0d22f3e$export$2e2bcd8739ae039).formatCurrency(priceNum, selectedLanguage, articleData.currency);
    };
    const params = new URL(window.location.href).searchParams;
    const handleMeasurementUrlParam = (settings)=>{
        const measurementId = params.get('fpt-measurement');
        sessionId = params.get('fpt-session');
        (0, $90d2b26344f90169$export$2e2bcd8739ae039).updateSessionId(sessionId);
        const articleNumber = params.get('fpt-article-number');
        if (!articleList || articleList.length === 0) (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('article list is empty!');
        const returnUrl = currentArticle?.returnUrl || settings.returnUrl;
        if (returnUrl && settings.recommendationEnabled == false && measurementId) {
            window.location.href = (0, $90d2b26344f90169$export$2e2bcd8739ae039).parseReturnUrl(returnUrl, {
                sessionId: sessionId,
                measurementId: measurementId
            }, {
                id: '',
                number: articleNumber,
                sizes: []
            });
            return;
        }
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`looking for ${articleNumber} in article list:`, articleList);
        const articleData = articleList.find((item)=>item.number === articleNumber);
        if (articleData) {
            processArticleData(articleData, settings);
            setArticle(articleData);
            currentArticle = articleData;
        } else if (articleList.length === 1) {
            // FIXME: when coming back to shop from polling
            // in mobile if article number in the url is different
            // than the article number in data attribute then
            // an error was thrown. this was due to article variants
            // being different, but the article was the same. Since
            // the article list was implemented for multiwidget support
            // when there is only one article in the list we skip the
            // article number check to avoid the error. A more ideal
            // solution would be to handle different variants properly
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`Discrepancy between article number in url and article number in data attribute detected`);
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`PDP article: ${articleList[0].number} external article: ${articleNumber}`);
            // Found another Scenario where if sku data attribute is used instead
            // of article number. The algorithm falls into this block
            // beacause article number is an empty string and article number is
            // defined in the url
            if (!articleList[0].number && articleNumber) articleList[0].number = articleNumber;
            processArticleData(articleList[0], settings);
            setArticle(articleList[0]);
            currentArticle = articleList[0];
        } else {
            const err = new Error(`unable to identify article ${articleNumber} on user redirect to shop`);
            displayError(err);
        }
    };
    const handleCustomerReferenceChange = (newRef)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`[AppController] data attribute changed to ${newRef}`);
        customerReference = newRef;
    };
    const handleEmailFormSubmit = (email)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`[AppController] Received email submit event`, email);
        clearModal();
        setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).PROCESSING);
        (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openModal();
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`[AppController] creating PI Reconstruction`);
        (0, $f96dfa98136185cc$export$2e2bcd8739ae039).createPiReconstruction(email).then((result)=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`[AppController] Got PI Reconstruction response`, result);
            displaySuccessOutcome();
        }).catch((err)=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).error(`something went wrong ${err.message}`);
            displayError(err);
        });
    };
    (0, $6cds3.useEffect)(()=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Loading shop settings . . .');
        window.addEventListener("fpt-secondary-matching", (e)=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Received secondary matching event', e);
        });
        (0, $2a55a88928dc0706$export$2e2bcd8739ae039).getSettings().then((settings)=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Got shop settings: ${settings}`);
            settings = settings || {
                domain: ''
            };
            settings.desktopFlowEnabled = 'desktopFlowEnabled' in settings ? settings.desktopFlowEnabled : true;
            const { lang: lang, theme: theme } = settings;
            const widgetLang = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getWidgetLang();
            if (widgetLang && widgetLang in (0, $31c680c31ce1361b$export$67d7e6220353b39d)) // lang specified in data attribute and supported
            return handleLanguageSetting(widgetLang, settings).then(()=>settings);
            else if (lang && lang in (0, $31c680c31ce1361b$export$67d7e6220353b39d)) // lang specified in settings and supported
            return handleLanguageSetting(lang, settings).then(()=>settings);
            else if (lang) {
                // lang specified in settings but not supported
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`unsupported shop language setting: ${lang}`);
                const langOptions = {
                    lang: language,
                    i18nNamespace: settings.theme?.i18nNamespace
                };
                return (0, $eb35e4b56fe508da$export$42208c4599db7952).fetchLanguageFile(langOptions).then((result)=>{
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('setting language', language);
                    (0, $31c680c31ce1361b$export$67d7e6220353b39d)[language].messages = result;
                    setLocale((0, $31c680c31ce1361b$export$67d7e6220353b39d)[language].locale);
                    const m = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getTranslationMessages(language, (0, $31c680c31ce1361b$export$67d7e6220353b39d));
                    setMessages(m);
                }).then(()=>settings);
            } else {
                // lang not specified in settings
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`setting browser language: ${language}`);
                const langOptions = {
                    lang: language,
                    i18nNamespace: settings.theme?.i18nNamespace
                };
                return (0, $eb35e4b56fe508da$export$42208c4599db7952).fetchLanguageFile(langOptions).then((result)=>{
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('setting language', language);
                    (0, $31c680c31ce1361b$export$67d7e6220353b39d)[language].messages = result;
                    setLocale((0, $31c680c31ce1361b$export$67d7e6220353b39d)[language].locale);
                    const m = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getTranslationMessages(language, (0, $31c680c31ce1361b$export$67d7e6220353b39d));
                    setMessages(m);
                }).then(()=>settings);
            }
        }).then((settings)=>{
            const { theme: theme, steps: steps } = settings;
            if (theme) {
                const parsedTheme = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).parseTheme(theme);
                setCustomTheme(parsedTheme);
                (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).update('themeName', parsedTheme.name);
            }
            if (settings.insoleAvailable) settings.steps = steps ? `${steps}-PIOPT` : `DEFAULT-PIOPT`;
            if (settings.abTesting) {
                const testFlows = settings.abTesting.split(',').map((item)=>item.trim());
                const optCount = testFlows.length;
                const idx = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getRandomInt(optCount);
                const test = testFlows[idx];
                settings.steps = settings.steps.replace(/^(\w+)/, test);
            }
            setShopSettings(settings);
            (0, $90d2b26344f90169$export$2e2bcd8739ae039).setShopSettings(settings);
            emitter.emit((0, $553cb74d80b27513$export$2e2bcd8739ae039).onSettingsLoaded, settings);
            if (params.has('fpt-measurement') && params.has('fpt-session') && params.has('fpt-article-number')) handleMeasurementUrlParam(settings);
            else if (params.has('fpt-session') && params.has('fpt-article-number')) {
                sessionId = params.get('fpt-session');
                (0, $90d2b26344f90169$export$2e2bcd8739ae039).updateSessionId(sessionId);
                setModalView((0, $e92b2a56d86c597c$export$9b51165ab6e1c0c1).PROCESSING);
                (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).openModal();
            }
        });
    }, []);
    (0, $6cds3.useEffect)(()=>{
        if (!shopSettings.domain) return;
        if (emitter.listeners((0, $e2cdb6d8b920f1a3$export$2e2bcd8739ae039).onCtaPress).length > 0) return;
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`adding event listeners with shop Settings: ${shopSettings.domain}`);
        emitter.addListener((0, $e2cdb6d8b920f1a3$export$2e2bcd8739ae039).onCtaPress, handleCtaButtonPress);
        emitter.addListener((0, $965f5d735ba6d674$export$2e2bcd8739ae039).onFunnelSelect, handleFunnelSelect);
        emitter.addListener((0, $965f5d735ba6d674$export$2e2bcd8739ae039).onLanguageSelect, handleLanguageSelect);
        emitter.addListener((0, $3fe9119940fa16b8$export$ada873a34909da65).onCancelPress, handleCancelPress);
        emitter.addListener((0, $3fe9119940fa16b8$export$ada873a34909da65).onBackToShopPress, handleBackToShopPress);
        emitter.addListener((0, $7c8d586ac16018dc$export$2e2bcd8739ae039).onRecommendationBackToShopPress, handleRecommendationBackToShopPress);
        emitter.addListener((0, $3fe9119940fa16b8$export$ada873a34909da65).onMeasureAgainPress, handleMeasureAgainPress);
        emitter.addListener((0, $3fe9119940fa16b8$export$ada873a34909da65).onStartAgainPress, handleMeasureAgainPress);
        emitter.addListener((0, $386c10f0156f9896$export$8775979036f9ffa).onQRPanelClose, handleQRPanelClose);
        emitter.addListener((0, $e2cdb6d8b920f1a3$export$2e2bcd8739ae039).onRecommendationPress, handleRecommendationPress);
        emitter.addListener((0, $7c8d586ac16018dc$export$2e2bcd8739ae039).onAddToCartPress, handleAddToCartPress);
        emitter.addListener((0, $7c8d586ac16018dc$export$2e2bcd8739ae039).onPiReconstructionRequest, handlePiReconstructionRequest);
        emitter.addListener((0, $933ab13c7a65596b$export$2e2bcd8739ae039).onCloseModalPress, clearModal);
        emitter.addListener((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onSpeedOptionConfirm, handleSpeedOptionConfirm);
        emitter.addListener((0, $8212cbecc74d50b4$export$2e2bcd8739ae039).onMeasureOptionConfirm, handleMeasureOptionConfirm);
        emitter.addListener((0, $d40d94705ea86638$export$2e2bcd8739ae039).onMcPollingStart, handleMcPollingStart);
        emitter.addListener((0, $d40d94705ea86638$export$2e2bcd8739ae039).onMcPollingDone, handleMcPollingDone);
        emitter.addListener((0, $d40d94705ea86638$export$2e2bcd8739ae039).onMcPollingCancelled, handleMcPollingCancelled);
        emitter.addListener((0, $d40d94705ea86638$export$2e2bcd8739ae039).onMcPollingError, handleMcPollingError);
        emitter.addListener((0, $553cb74d80b27513$export$2e2bcd8739ae039).onProfileMeasurementSet, handleProfileMeasurementSet);
        emitter.addListener((0, $553cb74d80b27513$export$2e2bcd8739ae039).onCustomerReferenceChange, handleCustomerReferenceChange);
        emitter.addListener((0, $a680cfe6f1bd8e79$export$2e2bcd8739ae039).onEmailSubmit, handleEmailFormSubmit);
        (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).observeForCustomerReferenceChange(emitter);
        if (headlessEnabled) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Hooking to fpt start event');
            window.addEventListener('fpt-start', handleFptStart);
            emitter.addListener((0, $7c8d586ac16018dc$export$2e2bcd8739ae039).onFeedbackConfirm, handleFeedbackConfirm);
            window.addEventListener('fpt-feedback-submit', (data)=>displayFeedbackConfirmDialog(data.detail));
        }
        const initEvent = new Event('fpt-initialized');
        window.dispatchEvent(initEvent);
        if (params.has('fpt-measurement') && params.has('fpt-session') && params.has('fpt-article-number')) {
            const measurementId = params.get('fpt-measurement');
            sessionId = params.get('fpt-session');
            if (article && article.id === 'test') return;
            const event = new CustomEvent("fpt-measurement", {
                detail: {
                    measurementId: measurementId,
                    sessionId: sessionId
                }
            });
            window.dispatchEvent(event);
            (0, $90d2b26344f90169$export$2e2bcd8739ae039).handleMeasuringResult({
                result: {
                    measurementId: measurementId,
                    sessionId: sessionId
                }
            }, article).then((result)=>{
                emitter.emit((0, $553cb74d80b27513$export$2e2bcd8739ae039).onMatching, result);
                const event = new CustomEvent("fpt-matching", {
                    detail: result
                });
                window.dispatchEvent(event);
                if ((0, $90d2b26344f90169$export$2e2bcd8739ae039).isSuccessfulMatching(result)) {
                    displayRecommendation(result);
                    (0, $90d2b26344f90169$export$2e2bcd8739ae039).createConversion(result, article, (0, $be61b9cfe3f63cb1$export$84ee76a85290f693).MATCHING_PRIMARY);
                    return;
                }
                throw new (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4)(result.error_code, 'Matching failed');
            }).catch((err)=>{
                displayError(err);
            });
        } else if (// Desktop flow scenario
        params.has('fpt-session') && params.has('fpt-article-number')) {
            console.warn(`[AppController] got session from url, should we display splash screen?`);
            sessionId = params.get('fpt-session');
            const articleNumber = params.get('fpt-article-number');
            if (!articleList || articleList.length === 0) (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('article list is empty!');
            let articleData = articleList.find((item)=>item.number === articleNumber);
            if (!articleData && articleList.length === 1 && !articleList[0].number) {
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('article number in URL does not match articles in PDP!');
                articleData = articleList[0];
            }
            // When the article number from QR code
            // Does not match with article number in PDP
            if (!articleData && articleList.length > 0 && articleList[0].number) articleData = {
                number: articleNumber
            };
            currentArticle = articleData;
            setArticle(articleData);
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Checking current article . . .', article);
            (0, $90d2b26344f90169$export$2e2bcd8739ae039).handleExistingSession(sessionId, articleData).then((result)=>{
                // For unknown reason art
                if (result.article_number !== articleNumber) {
                    const message = 'Could not reconcile article number in url with PDP';
                    throw new Error(message);
                }
                // When the article data comes from QR code
                if (!articleData.name) {
                    articleData.name = result.article_name;
                    articleData.manufacturer = result.manufacturer;
                    currentArticle = articleData;
                    setArticle(articleData);
                }
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('article number in URL reconciled with PDP article');
                return result;
            }).then(processArticleDataAndDisplaySplashscreen).catch(handleProcessArticleDataError);
        }
        if (bannerId) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`has banner id: ${bannerId}`);
            const banner = document.querySelector(`#${bannerId}`);
            const art = (0, $90d2b26344f90169$export$2e2bcd8739ae039).getArticleData(banner);
            banner.addEventListener('click', ()=>handleCtaButtonPress(art));
        }
    }, [
        article,
        shopSettings,
        language,
        customTheme
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b4e7e62a26e603c5$export$2e2bcd8739ae039), {
        locale: locale,
        defaultLocale: (0, $31c680c31ce1361b$export$67d7e6220353b39d).en.locale,
        messages: messages,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($f686bfa33774dad2$export$d990cc5f51685546.Provider, {
            value: shopSettings,
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($f686bfa33774dad2$export$9ed0816deade4fed.Provider, {
                value: article,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e94f79f42775c5f5$export$d8964aec282183a3), {
                    theme: customTheme,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e92b2a56d86c597c$export$2b77a92f1a5ad772), {
                        view: modalView,
                        emitter: emitter,
                        data: modalData
                    })
                })
            })
        })
    });
};




var $6cds3 = parcelRequire("6cds3");

















const $5df3dca97dbd0da5$var$findMatching = (article, matching)=>{
    if (matching.article_number == article.number) return Promise.resolve(matching);
    return (0, $90d2b26344f90169$export$2e2bcd8739ae039).processMeasurement(matching.measurement_id, article);
};
const $5df3dca97dbd0da5$var$createConversion = (matching, article, settings)=>{
    return (0, $90d2b26344f90169$export$2e2bcd8739ae039).createConversion(matching, article, (0, $be61b9cfe3f63cb1$export$84ee76a85290f693).MATCHING_SECONDARY);
};
class $5df3dca97dbd0da5$export$23afa136eb7e1eed {
    constructor(article){
        this.gtin = article.gtin;
        this.ean = article.ean;
        this.sku = article.sku;
        this.articleNumber = article.number;
        this.articleName = article.name;
        this.articlePrice = article.price;
        this.articleImage = article.image;
        this.currency = article.currency ? (0, $be61b9cfe3f63cb1$export$8bbed17cf90fe422)[article.currency] : (0, $be61b9cfe3f63cb1$export$8bbed17cf90fe422).EUR;
    }
    getArticleData() {
        return {
            id: this.articleNumber,
            gtin: this.gtin,
            ean: this.ean,
            sku: this.sku,
            number: this.articleNumber,
            name: this.articleName,
            price: this.articlePrice,
            image: this.articleImage,
            currency: this.currency,
            sizes: []
        };
    }
    handleMatching(matching, settings) {
        const article = this.getArticleData();
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Widget handling matching', article);
        let outcome = Promise.resolve();
        if (this.gtin && !this.articleNumber) outcome = this.findArticleByGtin().then((result)=>{
            article.number = result.article_number;
        });
        else if (this.sku && !this.articleNumber) outcome = this.findArticleBySku().then((result)=>{
            article.number = result.article_number;
        });
        return outcome.then(()=>$5df3dca97dbd0da5$var$findMatching(article, matching)).then((result)=>{
            // multiwidget support
            // When we receive a match event from another widget
            // a secondary match is created for every widget present in
            // the page
            if (matching.article_number !== article.number) $5df3dca97dbd0da5$var$createConversion(result, article, settings);
            return result;
        });
    }
    findArticleByGtin() {
        return (0, $1cb4b7f8102a5c96$export$2e2bcd8739ae039).lookupArticle({
            gtin: this.gtin,
            sku: '',
            articleName: '',
            articleNumber: ''
        }).then((result)=>{
            if (!result.data || result.data.length === 0) {
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`Article with gtin ${this.gtin} not found`);
                return null;
            }
            return result.data[0];
        });
    }
    findArticleBySku() {
        return (0, $1cb4b7f8102a5c96$export$2e2bcd8739ae039).lookupArticle({
            gtin: '',
            sku: this.sku,
            articleName: '',
            articleNumber: ''
        }).then((result)=>{
            if (!result.data || result.data.length === 0) {
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`Article with sku ${this.sku} not found`);
                return null;
            }
            return result.data[0];
        });
    }
    setArticleNumber(artNum) {
        this.articleNumber = artNum;
    }
}






const $3f8185a6b87e2fb4$export$ca3218b7861b9cb0 = (props)=>{
    const { articleData: articleData, emitter: emitter } = props;
    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('initializing widget . . .');
    const widgetService = new (0, $5df3dca97dbd0da5$export$23afa136eb7e1eed)(articleData);
    const initLang = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getLang();
    const initMessages = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getTranslationMessages(initLang, (0, $31c680c31ce1361b$export$67d7e6220353b39d));
    const [shopSettings, setShopSettings] = (0, $6cds3.useState)((0, $8ddc9fe4248467fa$export$7dfd81af9fc545f2));
    const [locale, setLocale] = (0, $6cds3.useState)((0, $31c680c31ce1361b$export$67d7e6220353b39d)[initLang].locale);
    const [messages, setMessages] = (0, $6cds3.useState)(initMessages);
    const [customTheme, setCustomTheme] = (0, $6cds3.useState)((0, $a58a64c681e03a20$export$2e2bcd8739ae039));
    const [language, setLanguage] = (0, $6cds3.useState)(initLang);
    let currentShopSettings = (0, $8ddc9fe4248467fa$export$7dfd81af9fc545f2);
    const [currentMatch, setCurrentMatch] = (0, $6cds3.useState)(null);
    const handleMeasureAgainPress = ()=>{
        setCurrentMatch(null);
    };
    const handleLanguageSelect = (selectedLanguage)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Handling Language ${selectedLanguage} selected`);
        setLanguage(selectedLanguage);
        if (shopSettings.lang !== selectedLanguage) {
            shopSettings.lang = selectedLanguage;
            // setShopSettings(shopSettings);
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`shop settings in Button Controller`, shopSettings);
        }
        const langOptions = {
            lang: selectedLanguage,
            i18nNamespace: shopSettings.theme?.i18nNamespace
        };
        (0, $eb35e4b56fe508da$export$42208c4599db7952).fetchLanguageFile(langOptions).then((result)=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('setting language', selectedLanguage);
            (0, $31c680c31ce1361b$export$67d7e6220353b39d)[selectedLanguage].messages = result;
            setLocale((0, $31c680c31ce1361b$export$67d7e6220353b39d)[selectedLanguage].locale);
            const m = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getTranslationMessages(selectedLanguage, (0, $31c680c31ce1361b$export$67d7e6220353b39d));
            setMessages(m);
        });
    };
    const processExistingMeasurement = ()=>{
        const measurementId = (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).getMeasurementId();
        const hasExistingMeasurement = !!measurementId;
        if (!hasExistingMeasurement) return;
        // Profile measurement scenario
        let outcome = Promise.resolve();
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Found measurement, looking for a match', measurementId);
        if (articleData.gtin && !articleData.number) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Article number missing, looking for article number for gtin ${articleData.gtin}`);
            outcome = widgetService.findArticleByGtin().then((result)=>{
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got article from gtin', result);
                articleData.number = result.article_number;
                widgetService.setArticleNumber(result.article_number);
            });
        } else if (articleData.sku && !articleData.number) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`Article number missing, looking for article number for sku ${articleData.sku}`);
            outcome = widgetService.findArticleBySku().then((result)=>{
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got article from sku', result);
                articleData.number = result.article_number;
                widgetService.setArticleNumber(result.article_number);
            });
        }
        outcome.then(()=>(0, $90d2b26344f90169$export$2e2bcd8739ae039).handleExistingMeasurement(measurementId, articleData)).then((result)=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('setting current match', result);
            setCurrentMatch(result);
            if (!result.isStoredInSession) {
                (0, $90d2b26344f90169$export$2e2bcd8739ae039).createConversion(result, articleData, (0, $be61b9cfe3f63cb1$export$84ee76a85290f693).MATCHING_SECONDARY);
                result.session_id = (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).getSessionId();
                const event = new CustomEvent('fpt-secondary-matching', {
                    detail: result
                });
                window.dispatchEvent(event);
            }
        }).catch((err)=>{
            if (err instanceof (0, $d988e4d2e0bb4394$export$c73ca302efeda3b4) && (err.errorCode === 'MADB1-00' || err.errorCode == 'MADB2-00' || err.errorCode == 'BEDB1-00')) setCurrentMatch({
                article_number: articleData.number,
                error_code: err.errorCode,
                measurement_id: measurementId,
                size: null,
                sizes: []
            });
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).error(`something went wrong while processing measurement ${err.message}`);
        });
    };
    (0, $6cds3.useEffect)(()=>{
        emitter.addListener((0, $553cb74d80b27513$export$2e2bcd8739ae039).onSettingsLoaded, (data)=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('setting shop settings in widget', data);
            setShopSettings(data);
            currentShopSettings = data;
            processExistingMeasurement();
        });
        emitter.addListener((0, $3fe9119940fa16b8$export$ada873a34909da65).onMeasureAgainPress, handleMeasureAgainPress);
        emitter.addListener((0, $965f5d735ba6d674$export$2e2bcd8739ae039).onLanguageSelect, handleLanguageSelect);
        emitter.addListener((0, $553cb74d80b27513$export$2e2bcd8739ae039).onMatching, (data)=>{
            if (currentShopSettings.multiRecommendationsEnabled) return;
            widgetService.handleMatching(data, currentShopSettings).then((result)=>{
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Setting current match in widget', result);
                setCurrentMatch(result);
            });
        });
    }, []);
    (0, $6cds3.useEffect)(()=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Got shop settings:', shopSettings);
        if (!shopSettings.domain) return;
        const { lang: lang, theme: theme, pricePattern: pricePattern, currency: currency } = shopSettings;
        if (lang && lang in (0, $31c680c31ce1361b$export$67d7e6220353b39d)) {
            setLanguage(lang);
            const langOptions = {
                lang: lang,
                i18nNamespace: theme?.i18nNamespace
            };
            (0, $eb35e4b56fe508da$export$42208c4599db7952).fetchLanguageFile(langOptions).then((result)=>{
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('setting language', lang);
                (0, $31c680c31ce1361b$export$67d7e6220353b39d)[lang].messages = result;
                setLocale((0, $31c680c31ce1361b$export$67d7e6220353b39d)[lang].locale);
                const m = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getTranslationMessages(lang, (0, $31c680c31ce1361b$export$67d7e6220353b39d));
                setMessages(m);
            });
        } else if (lang) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`unsupported shop language setting: ${lang}`);
            const langOptions = {
                lang: language,
                i18nNamespace: theme?.i18nNamespace
            };
            (0, $eb35e4b56fe508da$export$42208c4599db7952).fetchLanguageFile(langOptions).then((result)=>{
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('setting language', language);
                (0, $31c680c31ce1361b$export$67d7e6220353b39d)[language].messages = result;
                setLocale((0, $31c680c31ce1361b$export$67d7e6220353b39d)[language].locale);
                const m = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getTranslationMessages(language, (0, $31c680c31ce1361b$export$67d7e6220353b39d));
                setMessages(m);
            });
        } else {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`setting browser language: ${language}`);
            const langOptions = {
                lang: language,
                i18nNamespace: theme?.i18nNamespace
            };
            (0, $eb35e4b56fe508da$export$42208c4599db7952).fetchLanguageFile(langOptions).then((result)=>{
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('setting language', language);
                (0, $31c680c31ce1361b$export$67d7e6220353b39d)[language].messages = result;
                setLocale((0, $31c680c31ce1361b$export$67d7e6220353b39d)[language].locale);
                const m = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getTranslationMessages(language, (0, $31c680c31ce1361b$export$67d7e6220353b39d));
                setMessages(m);
            });
        }
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`using article price pattern ${pricePattern}`);
        const priceNum = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).parseArticlePrice(articleData.price, shopSettings);
        if (!articleData.currency) articleData.currency = currency || (0, $be61b9cfe3f63cb1$export$8bbed17cf90fe422).EUR;
        const selectedLanguage = lang || language;
        articleData.sum = (0, $9c09acafd0d22f3e$export$2e2bcd8739ae039).formatCurrency(priceNum, selectedLanguage, articleData.currency);
        if (theme) {
            const parsedTheme = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).parseTheme(theme);
            setCustomTheme(parsedTheme);
        }
    }, [
        shopSettings,
        language
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: shopSettings.domain && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b4e7e62a26e603c5$export$2e2bcd8739ae039), {
            locale: locale,
            defaultLocale: (0, $31c680c31ce1361b$export$67d7e6220353b39d)['en'].locale,
            messages: messages,
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e94f79f42775c5f5$export$d8964aec282183a3), {
                theme: customTheme,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5f07f3a5d24bdbec$export$2acd7357333dbaa1), {
                    emitter: emitter,
                    matching: currentMatch,
                    settings: shopSettings,
                    article: articleData
                })
            })
        })
    });
};


/* eslint-disable @typescript-eslint/lines-between-class-members */ /* eslint-disable @typescript-eslint/lines-between-class-members */ 
parcelRequire("6cds3");

class $9c25b55508618332$export$63d9b5d863e3bd7c {
    constructor(domain, user, key, shoesize){
        this.SHOPWARE_DOMAIN = domain;
        this.SHOPWARE_USER = user;
        this.SHOPWARE_KEY = key;
        this.SHOESIZE_GROUP = shoesize;
    }
    isArticleAvailable(article) {
        return article.active && article.inStock > 0;
    }
    getShoeSizeFromArticle(article, groupId) {
        const option = article.configuratorOptions.find((item)=>{
            return item.groupId == groupId;
        });
        return option.name;
    }
    getCurrentArticleShoeSize(article, groupId) {
        const found = article.mainDetail.configuratorOptions.find((item)=>item.groupId == groupId);
        return found.name;
    }
    findArticleByShoesize(article, size, groupId) {
        return article.details.filter((item)=>this.isArticleAvailable(item)).find((articleDetails)=>{
            const articleSize = this.getShoeSizeFromArticle(articleDetails, groupId);
            return articleSize == size;
        });
    }
    openBasketInventory() {
        const basketButton = document.querySelector('a[title="Warenkorb"]');
        if (!basketButton) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).error('button a[title="Warenkorb"] not found');
            return;
        }
        basketButton.click();
    }
    getArticleById(articleId) {
        const domainName = this.SHOPWARE_DOMAIN.replace('https://', '');
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).get(`https://${this.SHOPWARE_USER}:${this.SHOPWARE_KEY}@${domainName}api/articles/${articleId}`, {
            auth: {
                username: this.SHOPWARE_USER,
                password: this.SHOPWARE_KEY
            }
        }).then((response)=>response.data.data);
    }
    addToCart(article, size, token) {
        const csrfToken = token ? token : document.querySelector("input[name='__csrf_token']").getAttribute('value');
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Shoe Size group', this.SHOESIZE_GROUP);
        const group = article.configuratorSet.groups.find((item)=>item.name === this.SHOESIZE_GROUP);
        const currentSize = this.getCurrentArticleShoeSize(article, group.id);
        const articleBySize = size == currentSize ? {
            number: article.mainDetail.number
        } : this.findArticleByShoesize(article, size, group.id);
        if (!articleBySize) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).error(`Shoe size ${size} not available in shopware API`);
            alert(`Schuhgr\xf6\xdfe ${size} nicht verf\xfcgbar`);
            return Promise.reject(new Error(`Schuhgr\xf6\xdfe ${size} nicht verf\xfcgbar`));
        }
        const form = new FormData();
        form.append('sAdd', articleBySize.number);
        // form.append('sAdd', size);
        form.append('sQuantity', '1');
        form.append('isXHR', '1');
        form.append('__csrf_token', csrfToken);
        form.append('sActionIdentifier', '');
        form.append('sAddAccessories', '');
        const options = {
            headers: {}
        };
        options.headers['X-CSRF-Token'] = csrfToken;
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post(this.SHOPWARE_DOMAIN + 'checkout/ajaxAddArticleCart', form, options).then((response)=>(0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Add To cart response', response)).then(()=>this.openBasketInventory());
    }
    submitAddToCart(articleNumber) {
        const csrfToken = document.querySelector("input[name='__csrf_token']").getAttribute('value');
        const form = new FormData();
        form.append('sAdd', articleNumber);
        form.append('sQuantity', '1');
        form.append('isXHR', '1');
        form.append('__csrf_token', csrfToken);
        form.append('sActionIdentifier', '');
        form.append('sAddAccessories', '');
        const options = {
            headers: {}
        };
        options.headers['X-CSRF-Token'] = csrfToken;
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post(this.SHOPWARE_DOMAIN + 'checkout/ajaxAddArticleCart', form, options).then((response)=>(0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Add To cart response', response)).then(()=>this.openBasketInventory());
    }
}


/* Helper class for PodolinoService) */ 
class $b422465f80e2074d$export$55fa1de7e0cc4099 {
    parseArticleNumber(data) {
        let artNumberPattern = /\d{12}$/;
        if (artNumberPattern.test(data.articleName)) {
            let nr = artNumberPattern.exec(data.articleName)[0];
            return nr.substring(0, 2) + ' ' + nr.substring(3, 8) + '/' + nr.substring(9, 12);
        }
        artNumberPattern = /\/(\d+)$/;
        const nodes = document.querySelectorAll('.entry--content');
        const articleNode = nodes[1];
        const hyperlinkNode = articleNode.querySelector('a');
        let articleNumber;
        const originalNumber = articleNode.innerHTML.trim();
        if (hyperlinkNode && artNumberPattern.test(originalNumber)) {
            const trailing = artNumberPattern.exec(originalNumber)[1];
            articleNumber = hyperlinkNode.innerHTML.trim() + '/' + trailing;
        } else if (hyperlinkNode) articleNumber = hyperlinkNode.innerHTML.trim();
        else articleNumber = articleNode.innerHTML.trim();
        return articleNumber;
    }
    getArticleSizesFromUI() {
        const result = [];
        const query = '.configurator--variant .variant--group .variant--option input';
        const items = document.querySelectorAll(query);
        items.forEach((item)=>result.push(item.getAttribute('title')));
        return result;
    }
    isV3Shoe(el, article) {
        if (!el) return false;
        const artNr = el.innerText.trim().split('.')[0];
        return artNr === 'V3AppShoe' || artNr === 'SW10027' || article.articleName.includes('V3');
    }
    isV2Shoe(el, article) {
        if (!el) return false;
        const artNr = el.innerText.trim().split('.')[0];
        return artNr === 'SW10016' || article.articleName.includes('V2');
    }
    hasCustomGV(el) {
        if (!el) return false;
        const artNr = el.innerText.trim().split('.')[0];
        return artNr === 'eltenTest' || artNr === 'SW10027';
    }
    getCustomGV(el, article) {
        let result = '2-step-child';
        const linkDetail = article.linkDetailsRewritten;
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('[helper] linkDetail', linkDetail);
        if (linkDetail.includes('clothing/men')) result = '3-step-blur-adult-v3.1';
        else if (this.hasCustomGV(el)) result = '3-step-blur-adult-v3.1';
        return result;
    }
}





class $db19e7f2591837a7$var$UserService {
    constructor(){
        this.client = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app"
        });
    }
    setSessionId(sessionId) {
        this.client.defaults.headers.common.Authorization = `Bearer ${sessionId}`;
    }
    searchUser(email) {
        return this.client.head(`/users/?email=${email}`).then((result)=>{
            return {
                email: email,
                status: {
                    code: result.status,
                    text: result.statusText
                }
            };
        });
    }
}
var $db19e7f2591837a7$export$2e2bcd8739ae039 = new $db19e7f2591837a7$var$UserService();





var $4d34497a6210a94d$exports = {};
'use strict';
var $4d34497a6210a94d$var$has = Object.prototype.hasOwnProperty, $4d34497a6210a94d$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $4d34497a6210a94d$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $4d34497a6210a94d$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $4d34497a6210a94d$var$Events().__proto__) $4d34497a6210a94d$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $4d34497a6210a94d$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $4d34497a6210a94d$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $4d34497a6210a94d$var$EE(fn, context || emitter, once), evt = $4d34497a6210a94d$var$prefix ? $4d34497a6210a94d$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $4d34497a6210a94d$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $4d34497a6210a94d$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $4d34497a6210a94d$var$EventEmitter() {
    this._events = new $4d34497a6210a94d$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $4d34497a6210a94d$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($4d34497a6210a94d$var$has.call(events, name)) names.push($4d34497a6210a94d$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $4d34497a6210a94d$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $4d34497a6210a94d$var$prefix ? $4d34497a6210a94d$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $4d34497a6210a94d$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $4d34497a6210a94d$var$prefix ? $4d34497a6210a94d$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $4d34497a6210a94d$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $4d34497a6210a94d$var$prefix ? $4d34497a6210a94d$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4d34497a6210a94d$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $4d34497a6210a94d$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4d34497a6210a94d$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $4d34497a6210a94d$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4d34497a6210a94d$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $4d34497a6210a94d$var$prefix ? $4d34497a6210a94d$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $4d34497a6210a94d$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $4d34497a6210a94d$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $4d34497a6210a94d$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4d34497a6210a94d$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $4d34497a6210a94d$var$prefix ? $4d34497a6210a94d$var$prefix + event : event;
        if (this._events[evt]) $4d34497a6210a94d$var$clearEvent(this, evt);
    } else {
        this._events = new $4d34497a6210a94d$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$4d34497a6210a94d$var$EventEmitter.prototype.off = $4d34497a6210a94d$var$EventEmitter.prototype.removeListener;
$4d34497a6210a94d$var$EventEmitter.prototype.addListener = $4d34497a6210a94d$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$4d34497a6210a94d$var$EventEmitter.prefixed = $4d34497a6210a94d$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$4d34497a6210a94d$var$EventEmitter.EventEmitter = $4d34497a6210a94d$var$EventEmitter;
$4d34497a6210a94d$exports = $4d34497a6210a94d$var$EventEmitter;



const $ff2dffc388a082ec$var$emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($4d34497a6210a94d$exports)))();
function $ff2dffc388a082ec$var$hasArticle(data) {
    return data && data.length > 0;
}
function $ff2dffc388a082ec$var$getSessionLastMeasurement() {
    return (0, $f188c4e754268d8b$export$2e2bcd8739ae039).getSessionMeasurements().then((result)=>{
        if (result && result.length > 0) return result[0];
        return null;
    });
}
// Deprecated, use App Controller and Shop Service instead
class $ff2dffc388a082ec$var$AbstractShop {
    constructor(){
        this.articleNumber = '';
        this.themeName = 'default';
        this.sizes = [];
        this.productSrc = '';
        this.customGv = '2-step-child';
        this.currency = 'EUR';
        this.hasPolling = false;
        this.steps = 'default';
        const fptEl = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getFPTTag();
        this.lang = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).getLang();
        if (!fptEl) return;
        if ('sessionId' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got client session id', fptEl.dataset.sessionId);
            this.clientSessionId = fptEl.dataset.sessionId;
        }
        if ('apiKey' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got API key', fptEl.dataset.apiKey);
            this.apiKey = fptEl.dataset.apiKey;
        }
        if ('articleNumber' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got article number', fptEl.dataset.articleNumber);
            this.articleNumber = fptEl.dataset.articleNumber;
        }
        if ('articleName' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got article name', fptEl.dataset.articleName);
            this.articleName = fptEl.dataset.articleName;
        }
        if ('articleImage' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got article image', fptEl.dataset.articleImage);
            this.productSrc = fptEl.dataset.articleImage;
        }
        if ('articlePrice' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got article price', fptEl.dataset.articlePrice);
            const str = fptEl.dataset.articlePrice;
            const price = Number(str);
            this.price = Number.isNaN(price) || str === '' ? null : price;
        }
        if ('currency' in fptEl.dataset) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got currency', fptEl.dataset.currency);
            this.currency = fptEl.dataset.currency;
        }
    }
    getApiKey() {
        return this.apiKey;
    }
    getTarget() {
        return "https://staging-app.myfootprint.app";
    }
    getArticleData() {
        return {
            id: this.articleId,
            number: this.articleNumber,
            name: this.articleName,
            image: this.productSrc,
            price: this.price,
            sizes: this.sizes
        };
    }
    handleMatching(m) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('Add to cart called but feature is not supported');
        return Promise.resolve();
    }
    addShopListeners() {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Abstract add shop listeners called');
    }
    removeShopListeners() {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Abstract remove shop listeners called');
    }
    createSession() {
        const anonymousId = (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).getAnonymousId();
        const sessionData = {
            screen_height: window.innerHeight,
            screen_width: window.innerWidth,
            analytics_accepted: true,
            client_session_id: this.clientSessionId,
            anonymous_id: anonymousId,
            referrer: window.location.href
        };
        return (0, $f188c4e754268d8b$export$2e2bcd8739ae039).createSession(sessionData);
    }
    updateSessionId(sessionId) {
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).update('sessionId', sessionId);
        (0, $1cb4b7f8102a5c96$export$2e2bcd8739ae039).setSessionId(sessionId);
        (0, $f188c4e754268d8b$export$2e2bcd8739ae039).setSessionId(sessionId);
        (0, $db19e7f2591837a7$export$2e2bcd8739ae039).setSessionId(sessionId);
        return sessionId;
    }
    async checkIfArticleExists() {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('checking if article exists');
        const articleData = {
            articleNumber: this.articleNumber,
            articleName: this.articleName
        };
        return (0, $1cb4b7f8102a5c96$export$2e2bcd8739ae039).lookupArticle(articleData).then((result)=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('lookup article response', result);
            (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).setCtaButtonState('DONE');
            return $ff2dffc388a082ec$var$hasArticle(result.data);
        }).catch((err)=>{
            if (err.response && err.response.status == '401') {
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`soemething went wrong with article lookup ${err.response.statusText}`);
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('creating new session');
                // Session has expired, create a new One
                return this.createSession().then((result)=>this.updateSessionId(result)).then(()=>(0, $1cb4b7f8102a5c96$export$2e2bcd8739ae039).lookupArticle(articleData)).then((result)=>{
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('lookup article response', result);
                    (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).setCtaButtonState('DONE');
                    return $ff2dffc388a082ec$var$hasArticle(result.data);
                }).catch(()=>{
                    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('create new session or article lookup failed');
                    (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).setCtaButtonState('DONE');
                });
            }
            const { message: message } = err;
            if (message) (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`soemething went wrong with article lookup ${message}`);
            return false;
        });
    }
    getArticleId() {
        return this.articleId;
    }
    getArticleNumber() {
        return this.articleNumber;
    }
    getClientSessionId() {
        return this.clientSessionId;
    }
    hasReload() {
        return true;
    }
    hasTooltip() {
        return false;
    }
    createConversion(matching, action) {
        if (matching.error_code !== 'MAST0-00') return;
        const data = {
            matching_id: matching.matching_id,
            price: this.price,
            quantity: 1,
            tax: 0,
            total: this.price,
            currency: this.currency,
            action: action
        };
        if (this.clientSessionId) data.client_session_id = this.clientSessionId;
        (0, $0b9a73fbfdf98b28$export$2e2bcd8739ae039).postConversion(data);
    }
    readClientCookie(key) {
        let cookie = document.cookie.split(';').find((item)=>item.includes(key));
        if (cookie?.indexOf('=') > -1) return cookie.split('=')[1];
        return null;
    }
    static isCheckout() {
        return false;
    }
    static handleCheckout() {
        return Promise.resolve();
    }
}
var $ff2dffc388a082ec$export$2e2bcd8739ae039 = $ff2dffc388a082ec$var$AbstractShop;




const $3d7f90dff891df39$var$stagingKey = '25f80fc9-8379-5090-b8c6-7de96d672316';
function $3d7f90dff891df39$var$isStaging() {
    const url = new URL(window.location.href);
    return url.hostname.includes('staging');
}
class $3d7f90dff891df39$export$1999f40f675e5871 extends (0, $ff2dffc388a082ec$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.apiKey = $3d7f90dff891df39$var$isStaging() ? $3d7f90dff891df39$var$stagingKey : undefined;
        this.themeName = undefined;
        const article = window.lastSeenProductsConfig.currentArticle;
        this.helper = new (0, $b422465f80e2074d$export$55fa1de7e0cc4099)();
        this.articleNumber = this.helper.parseArticleNumber(article);
        this.articleName = article.articleName;
        const artNr = document.querySelector('[itemprop=sku]');
        this.customGv = this.helper.getCustomGV(artNr, article);
        this.sizes = this.helper.getArticleSizesFromUI();
        this.articleId = article.articleId;
        this.clientSessionId = this.readClientCookie('session-1');
        const priceEl = document.querySelector('meta[itemprop=price]');
        if (priceEl) {
            const priceValue = priceEl.getAttribute('content');
            this.price = Number(priceValue);
        }
        this.productSrc = article.images[0].source;
        this.shopware = new (0, $9c25b55508618332$export$63d9b5d863e3bd7c)(undefined, undefined, undefined, undefined);
        const sessionCookie = document.cookie.split(';').find((item)=>item.includes('session-1'));
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('session cookie', sessionCookie);
    }
    /* Interface implentation */ getTarget() {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Podolino get target called');
        if (this.articleName.toLowerCase().includes('staging')) return 'https://staging-app.myfootprint.app';
        return "https://staging-app.myfootprint.app";
    }
    handleMatching(matching) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('handling matching');
        const url = new URL(window.location.href);
        const isPodolinoStaging = url.hostname === 'staging.podolino.de';
        if (isPodolinoStaging) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('skipping add to cart');
            return super.handleMatching(matching);
        }
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('adding to cart');
        return this.shopware.getArticleById(this.articleId).then((articleData)=>{
            this.shopware.addToCart(articleData, matching.size.value);
        }).catch((error)=>{
            console.error('Unable to get article data', error);
        });
    }
    static createClient() {
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app",
            headers: {
                'X-API-KEY': undefined,
                'X-SHOP-DOMAIN': window.location.origin
            }
        });
    }
    hasTooltip() {
        return true;
    }
}



class $ef1ad6286560c00d$export$1eb863931faa66a6 {
    constructor(){
        this.testSetting = $parcel$global.testSettings;
    }
    getTarget() {
        switch(this.testSetting.env){
            default:
            case 'dev':
                return 'https://dev-app.myfootprint.app';
            case 'test':
                return 'https://test-app.myfootprint.app';
            case 'staging':
                return 'https://staging-app.myfootprint.app';
            case 'prod':
                return 'https://app.myfootprint.app';
        }
    }
    getProductData() {
        return {
            articleName: this.testSetting.articleName,
            articleNumber: this.testSetting.articleId,
            apiKey: this.testSetting.apiKey,
            theme: this.testSetting.theme || 'default',
            sizes: this.testSetting.sizes,
            variant: Math.random() > 0.5 ? 1 : 0,
            mode: this.testSetting.testMode ? 'test' : null,
            'custom-gv': this.testSetting.adultMode ? '3-step-blur-adult-v3.1' : null
        };
    }
    handleMatching(matching) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`handling matching for ${matching.size}`);
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).error('handling matching not implemented in test mode');
        return null;
    }
}


/* eslint-disable @typescript-eslint/lines-between-class-members */ /* eslint-disable @typescript-eslint/lines-between-class-members */ const $1dabb4002436020a$var$KEYS = {
    'www.koyobear.com': '6f2ded1b-0724-5f60-8e62-70b43008105c',
    'koyo-bear-test-4-2.webflow.io': '75133322-a5ca-507a-b56c-ec94a730acd3',
    'jp.koyobear.com': '3006fdf3-dfd1-577c-8135-83946cffbb01'
};
class $1dabb4002436020a$export$598e297bfd10f844 {
    static getApiKey() {
        const domain = window.location.hostname;
        return $1dabb4002436020a$var$KEYS[domain];
    }
    selectSize(size) {
        const found = this.getArticleSizeOptions().find((item)=>{
            const sizeEl = item.querySelector('.size');
            const currentSize = sizeEl ? sizeEl.textContent.split('/')[0] : '';
            return currentSize == size;
        });
        return new Promise((fulfill, reject)=>{
            if (found) {
                found.click();
                setTimeout(()=>fulfill(found), 300);
            } else reject(new Error(`size ${size} option not found`));
        });
    }
    addToCart(button) {
        if (button && this.isSizeAvailable(button)) {
            const submit = document.querySelector('.add-to-cart-button');
            submit.click();
        } else {
            const size = this.getOptionSize(button);
            const message = `Size ${size} not available`;
            console.error(message);
            alert(message);
        }
    }
    isSizeAvailable(button) {
        return !button.classList.contains('w--ecommerce-pill-disabled');
    }
    getOptionSize(button) {
        const sizeEl = button.querySelector('.size');
        return sizeEl.textContent.split('/')[0];
    }
    getArticleSizeOptions() {
        return Array.from(document.querySelectorAll('.size-button'));
    }
    getArticleSizeList() {
        return this.getArticleSizeOptions().filter((item)=>this.isSizeAvailable(item)).map((item)=>this.getOptionSize(item));
    }
}





class $d17aa5492128ca42$export$9b506fea9eb94f11 extends (0, $ff2dffc388a082ec$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.helper = new (0, $1dabb4002436020a$export$598e297bfd10f844)();
        if (!this.apiKey) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('looking for API key');
            this.apiKey = (0, $1dabb4002436020a$export$598e297bfd10f844).getApiKey();
        }
        this.themeName = 'Koyobear';
        this.articleNumber = 'koyobear-article';
        this.articleName = 'Sharpman';
        if (!this.productSrc) this.productSrc = 'https://uploads-ssl.webflow.com/61fa3df7d4d22423aa145f14/61fa6ebd6b79d8bf6fe3532f_koyobear-sharpman-detail-1.jpg';
        this.sizes = this.helper.getArticleSizeList();
        this.customGv = '3-step-blur-adult-v3.1';
    }
    handleMatching(matching) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('handling matching Koyobear');
        return Promise.resolve().then(()=>{
            this.helper.selectSize(matching.size.value).then((result)=>{
                this.helper.addToCart(result);
            }).catch((err)=>{
                console.error(err.message);
            });
        });
    }
    hasReload() {
        return true;
    }
    static createClient() {
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app",
            headers: {
                'X-API-KEY': (0, $1dabb4002436020a$export$598e297bfd10f844).getApiKey()
            }
        });
    }
    static getApiKey() {
        return (0, $1dabb4002436020a$export$598e297bfd10f844).getApiKey();
    }
}







class $f87db475c01c276e$var$ShopifyShop extends (0, $ff2dffc388a082ec$export$2e2bcd8739ae039) {
    handleMatching(matching) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('handle matching Shopify');
        const variant = this.variants.find((item)=>item.size == matching.size.value && item.available);
        if (!variant) {
            alert('ERROR: Shoe Size not found');
            return Promise.reject();
        }
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).addMatching(matching, this.articleId);
        (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).update('measurementId', matching.measurement_id);
        const form = new FormData();
        form.append('Size', variant.size);
        form.append('form_type', 'product');
        form.append('utf8', "\u2713");
        // form.append('return_to', '/checkout');
        form.append('id', '' + variant.id);
        form.append('footprint_id', matching.matching_id);
        // const options = { headers: {} };
        // options.headers['X-CSRF-Token'] = csrfToken;
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post('/cart/add', form).then((response)=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Add To cart response', response);
            window.location.href = '/cart';
        });
    }
    getArticlePriceFromVariant(variant) {
        const { price: price } = variant;
        if (!price || Number.isNaN(price) || Number.isNaN(Number.parseInt(price))) return null;
        return price / 100;
    }
    static isCheckout() {
        return window.location.pathname.includes('checkouts');
    }
    static processPurchase(purchaseData) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('processing purchase', purchaseData);
        const { matching: matching, purchase: purchase, article: article, service: service } = purchaseData;
        const data = {
            matching_id: matching.matching_id,
            price: Number(article.price),
            quantity: Number(article.quantity),
            tax: Number(purchase.tax),
            total: Number(purchase.value),
            currency: purchase.currency,
            client_session_id: '' + purchase.transaction_id
        };
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('posting conversion', data);
        return service.postConversion(data);
    }
    static isPurchase() {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('Abstract isPurchase called');
        return false;
    }
    static getPurchase() {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('Abstract getPurchase called');
        return null;
    }
    static getApiKey() {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('Abstract getApiKey called');
        return '';
    }
    static findArticlePurchaseData(id, purchase) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Looking for purchase with id', id);
        return purchase.items.find((item)=>item.id == id);
    }
    static handleCheckout() {
        const isPurchase = this.isPurchase();
        if (!isPurchase) {
            const err = new Error('No data found for FPT purchase');
            return Promise.reject(err);
        }
        const fptSessionStr = sessionStorage.getItem('fpt-session');
        if (!fptSessionStr) {
            const err = new Error('No purchase data found');
            return Promise.reject(err);
        }
        const fptSession = JSON.parse(fptSessionStr);
        const articles = Object.getOwnPropertyNames(fptSession.matchings);
        if (articles.length == 0) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('No matchings found', fptSession.matchings);
            return Promise.resolve(null);
        }
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('searching for purchase');
        const purchase = this.getPurchase();
        if (!purchase) {
            const err = new Error('unable to identify purchase object');
            return Promise.reject(err);
        }
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('found purchase', purchase);
        const conversionsService = new (0, $0b9a73fbfdf98b28$export$1424597384d1ce2b)({
            apiKey: this.getApiKey(),
            baseUrl: "https://staging-backend.myfootprint.app"
        });
        const filteredArticles = articles.filter((articleId)=>this.findArticlePurchaseData(articleId, purchase));
        if (!filteredArticles.length) (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('no FPT matchings found');
        const promises = filteredArticles.map((articleId)=>this.findArticlePurchaseData(articleId, purchase)).map((item)=>this.processPurchase({
                purchase: purchase,
                article: item,
                matching: fptSession.matchings['' + item.id],
                service: conversionsService
            }));
        return Promise.all(promises);
    }
}
var $f87db475c01c276e$export$2e2bcd8739ae039 = $f87db475c01c276e$var$ShopifyShop;



class $fe2ea1cb0b206944$export$f22a6e613aee9310 extends (0, $f87db475c01c276e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        const productData = window.product;
        this.articleNumber = 'PFI_TEST'; // '' + productData.id;
        this.articleName = productData.title;
        this.articleId = '' + productData.id;
        const media = productData.media.filter((item)=>item.media_type === 'image').reduce((previous, current)=>{
            if (current.height < previous.height) return current;
            return previous;
        }, productData.media[0]);
        this.productSrc = media.src;
        this.apiKey = '43750087-71fa-52b4-9d73-4d509ef34982';
        this.themeName = 'default';
        this.variants = productData.variants.map((item)=>{
            return {
                id: item.id,
                size: item.options[0],
                available: item.available
            };
        });
        this.sizes = productData.variants.filter((item)=>item.available).map((item)=>item.options[0]);
        const btn = document.querySelector('#footprinttech-button');
        btn.style.marginBottom = '3rem';
        btn.style.maxWidth = '44rem';
    }
    static createClient() {
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app",
            headers: {
                'X-API-KEY': '43750087-71fa-52b4-9d73-4d509ef34982',
                'X-SHOP-DOMAIN': window.location.origin
            }
        });
    }
}




const $e1fa07d82dbc23d8$var$KEY_MAP = {
    'fashion-spa.cu2qdtboy0-public1-p13-public.model-t.cc.commerce.ondemand.com': '2589b2fb-2e67-5f73-8ed3-3e78d58d768f',
    'fashion-spa.sfashion-sapphire.usdemo.hybris.com': 'bfa0552b-86ad-5920-8377-ab4c6b7c7156'
};
const $e1fa07d82dbc23d8$var$SHOE_MAP = {
    '555': 'SAP_DIVERGE',
    '616': 'SAP_ADIDAS_M',
    // '': 'SAP_ADIDAS_W',
    '618': 'SAP_EVERLANE',
    '597': 'SAP_TANNERS',
    '843': 'SAP_DIVERGE',
    '636': 'SAP_BILLY_FOOTWEAR'
};
const $e1fa07d82dbc23d8$var$ARTICLE_NAME_MAP = {
    '555': 'Diverge Sneakers',
    '616': 'Adidas Sneakers',
    // '': 'SAP_ADIDAS_W',
    '618': 'Everlane Slip-on Sneaker',
    '597': "Tanner's Sneakers",
    '843': 'Allbirds Wool Runners',
    '636': 'Billy Footwear Casual Shoes'
};
function $e1fa07d82dbc23d8$var$getArticleNumberById(id) {
    return $e1fa07d82dbc23d8$var$SHOE_MAP[id.substr(0, 3)] ? $e1fa07d82dbc23d8$var$SHOE_MAP[id.substr(0, 3)] : 'SAP_DIVERGE';
}
function $e1fa07d82dbc23d8$var$getArticleNameById(id) {
    return $e1fa07d82dbc23d8$var$ARTICLE_NAME_MAP[id.substr(0, 3)] ? $e1fa07d82dbc23d8$var$ARTICLE_NAME_MAP[id.substr(0, 3)] : 'Diverge Sneakers';
}
const $e1fa07d82dbc23d8$var$productPattern = /product\/(\d+)/;
function $e1fa07d82dbc23d8$var$getSpartacusArticleId() {
    const pathname = window.location.pathname;
    const match = $e1fa07d82dbc23d8$var$productPattern.exec(pathname);
    return match ? match[1] : '555001';
}
function $e1fa07d82dbc23d8$var$getApiKey() {
    const domain = window.location.hostname;
    return $e1fa07d82dbc23d8$var$KEY_MAP[domain];
}
class $e1fa07d82dbc23d8$export$4238dfb2076179d6 extends (0, $ff2dffc388a082ec$export$2e2bcd8739ae039) {
    constructor(){
        super();
        const articleId = $e1fa07d82dbc23d8$var$getSpartacusArticleId();
        this.articleId = articleId;
        this.articleNumber = $e1fa07d82dbc23d8$var$getArticleNumberById(articleId);
        this.articleName = $e1fa07d82dbc23d8$var$getArticleNameById(articleId);
        this.productSrc = '';
        this.apiKey = $e1fa07d82dbc23d8$var$getApiKey();
        this.themeName = 'default';
        this.sizes = [];
        this.lang = 'en';
    }
    hasReload() {
        return true;
    }
    getArticleId() {
        const articleId = $e1fa07d82dbc23d8$var$getSpartacusArticleId();
        this.articleId = articleId;
        this.articleNumber = $e1fa07d82dbc23d8$var$getArticleNumberById(articleId);
        return this.articleId;
    }
    getArticleNumber() {
        const articleId = $e1fa07d82dbc23d8$var$getSpartacusArticleId();
        this.articleId = articleId;
        this.articleNumber = $e1fa07d82dbc23d8$var$getArticleNumberById(articleId);
        return this.articleNumber;
    }
    static createClient() {
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app",
            headers: {
                'X-API-KEY': $e1fa07d82dbc23d8$var$getApiKey(),
                'X-SHOP-DOMAIN': window.location.origin
            }
        });
    }
}





class $848372274f51d2f5$export$9e2d9c658eee7d21 extends (0, $ff2dffc388a082ec$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.themeName = 'default', this.sizes = [], this.productSrc = '', this.customGv = '2-step-child';
        this.articleName = 'Test Shoe';
        this.articleNumber = 'WMS_TABLE_FULL';
        this.apiKey = '1351eb90-6281-53d6-be26-25a843556a19';
        this.themeName = 'default';
        this.sizes = [];
    }
    getTarget() {
        return "https://staging-app.myfootprint.app";
    }
    getUmaTarget() {
        return undefined;
    }
    handleMatching() {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('handling matching');
        return Promise.resolve();
    }
    static createClient() {
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app",
            headers: {
                'X-API-KEY': '1351eb90-6281-53d6-be26-25a843556a19',
                'X-SHOP-DOMAIN': window.location.origin
            }
        });
    }
}


/* eslint-disable @typescript-eslint/lines-between-class-members */ 



const $a26a1b045e0c5397$var$KeyMap = {
    'live.footprinttech.de': 'e2b0dcca-0090-5ecc-a6b2-617e397ad8e4',
    'lidl.footprinttech.de': 'f37d2370-386d-11ef-b46a-e3124c8b1f40',
    'shopware6.podolino.de': '2aff6f7b-c730-572b-930b-9e8a20fe2382',
    'defense.footprinttech.de': 'f2380950-459f-11ef-b720-e9ae1b45235e',
    'aai.footprinttech.de': 'e7c3ef3b-d3bf-47ae-bd60-b8896e18530e'
};
const $a26a1b045e0c5397$var$getApiKey = ()=>{
    const { hostname: hostname } = window.location;
    return $a26a1b045e0c5397$var$KeyMap[hostname];
};
function $a26a1b045e0c5397$var$getArticleSizesFromUI() {
    const result = [];
    const query = 'select.product-detail-configurator-select-input > option';
    const items = document.querySelectorAll(query);
    items.forEach((item)=>result.push(item.innerText.trim()));
    return result;
}
function $a26a1b045e0c5397$var$getSizeIDMap() {
    const ID_MAP = {};
    // get the select element by its class name
    const selectElement = document.getElementsByClassName('custom-select product-detail-configurator-select-input')[0];
    // loop through the option elements in the select element
    for(let i = 0; i < selectElement.options.length; i++){
        // get the value of each option element
        const optionID = selectElement.options[i].innerHTML.trim();
        const optionValue = selectElement.options[i].value;
        ID_MAP[optionID] = optionValue;
    }
}
function $a26a1b045e0c5397$var$getArticleNumber() {
    return document.querySelector('[itemprop=sku]').innerHTML.split('.')[0].trim();
}
function $a26a1b045e0c5397$var$getArticleName() {
    return document.querySelector('[itemprop=name]').innerHTML.split('|')[0].trim();
}
function $a26a1b045e0c5397$var$openBasketInventory() {
    const basketButton = document.querySelector('a.header-cart-btn');
    if (!basketButton) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).error('button a[title="Warenkorb"] not found');
        return;
    }
    basketButton.click();
}
function $a26a1b045e0c5397$var$addToCart(articleId) {
    const csrfToken = document.querySelector("#productDetailPageBuyProductForm input[name='_csrf_token']").getAttribute('value');
    const form = new FormData();
    form.append('_csrf_token', csrfToken);
    form.append(`lineItems[${articleId}][quantity]`, '1');
    form.append('redirectTo', 'frontend.cart.offcanvas');
    form.append(`lineItems[${articleId}][id]`, articleId);
    form.append(`lineItems[${articleId}][type]`, 'product');
    form.append(`lineItems[${articleId}][referencedId]`, articleId);
    form.append(`lineItems[${articleId}][stackable]`, '1');
    form.append(`lineItems[${articleId}][removable]`, '1');
    form.append('product-name', 'Tanners Mid-Court Roscoe');
    form.append('brand-name', '');
    const options = {
        headers: {}
    };
    options.headers['X-Requested-With'] = 'XMLHttpRequest';
    const itemAddURL = window.location.origin.includes('elten.footprinttech.de') ? 'https://elten.footprinttech.de/checkout/line-item/add' // elten.footprinttech.de; this addToCart should never be called for Elten.
     : 'https://live.footprinttech.de/checkout/line-item/add'; // live.footprinttech.de
    return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post(itemAddURL, form, options).then((response)=>(0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Add To cart response', response));
}
function $a26a1b045e0c5397$var$addGlobalStyle() {
    const style = document.createElement('style');
    style.innerHTML = `
        :root .btn {
          border-radius: 1rem;
        }
        :root .cms-block {
          padding: 2px;
        }
      `;
    document.head.appendChild(style);
}
class $a26a1b045e0c5397$export$ba1599178c4ac37e extends (0, $ff2dffc388a082ec$export$2e2bcd8739ae039) {
    constructor(){
        super();
        const artnum = $a26a1b045e0c5397$var$getArticleNumber();
        this.apiKey = $a26a1b045e0c5397$var$getApiKey();
        this.themeName = undefined;
        this.helper = new (0, $b422465f80e2074d$export$55fa1de7e0cc4099)();
        this.articleNumber = artnum;
        this.articleId = artnum;
        this.articleName = $a26a1b045e0c5397$var$getArticleName();
        this.customGv = 'adult';
        this.sizes = $a26a1b045e0c5397$var$getArticleSizesFromUI();
        let meta = document.head.querySelector('meta[property="og:image"]');
        if (!meta) meta = document.querySelector('meta[property="og:image"]');
        this.productSrc = meta && meta.content ? meta.content : '';
        const footerForm = document.querySelector('.footer-contact-form');
        if (footerForm) footerForm.remove();
        $a26a1b045e0c5397$var$addGlobalStyle();
    }
    getArticleData() {
        if (document && !this.productSrc) {
            let meta = document.head.querySelector('meta[property="og:image"]');
            if (!meta) meta = document.querySelector('meta[property="og:image"]');
            this.productSrc = meta && meta.content ? meta.content : '';
            document.querySelector('.footer-contact-form').remove();
            $a26a1b045e0c5397$var$addGlobalStyle();
        }
        return {
            id: this.articleId,
            number: this.articleNumber,
            name: this.articleName,
            image: this.productSrc,
            price: this.price,
            sizes: this.sizes
        };
    }
    /* Interface implentation */ handleMatching(matching) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('handling matching');
        const SIZE_ID_MAP = $a26a1b045e0c5397$var$getSizeIDMap();
        const variantId = SIZE_ID_MAP[matching.size.value];
        if (window.location.origin.includes('elten.footprinttech.de')) return; // do nothing, just exit
        return $a26a1b045e0c5397$var$addToCart(variantId).then(()=>{
            $a26a1b045e0c5397$var$openBasketInventory();
        }).catch((error)=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).error(`something went wrong ${error.message}`);
        });
    }
    hasTooltip() {
        return true;
    }
    static createClient() {
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app",
            headers: {
                'X-API-KEY': $a26a1b045e0c5397$var$getApiKey(),
                'X-SHOP-DOMAIN': window.location.origin
            }
        });
    }
}




const $33dc66d0d8e7096b$var$apiKey = 'FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF';
class $33dc66d0d8e7096b$export$cba685534c6c61e6 extends (0, $ff2dffc388a082ec$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.articleNumber = 'WMS_TABLE_FULL';
        this.articleName = 'Test Shoe';
        this.productSrc = '';
        this.apiKey = $33dc66d0d8e7096b$var$apiKey;
        this.themeName = 'default';
        this.sizes = [];
    }
    static createClient() {
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app",
            headers: {
                'X-API-KEY': $33dc66d0d8e7096b$var$apiKey,
                'X-SHOP-DOMAIN': 'http:www.dummy..de'
            }
        });
    }
}


/* eslint-disable @typescript-eslint/lines-between-class-members */ 

const $7a9eba2d378eea06$var$apiKey = 'f6b2d290-8846-5550-ab92-e8daff98f001';
const $7a9eba2d378eea06$var$shopDomain = window.location.origin.includes('localhost') ? 'www.dummy.de' : window.location.origin;
function $7a9eba2d378eea06$var$getSizes() {
    const sizeNodes = document.querySelectorAll('.product_option_select option');
    let key;
    const result = [];
    sizeNodes.forEach((node)=>{
        key = node.innerText;
        result.push(key);
    });
    return result;
}
class $7a9eba2d378eea06$export$8605403858ef645b extends (0, $ff2dffc388a082ec$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.articleNumber = 'WMS_TABLE_FULL';
        this.articleName = document.querySelector('.product-title').innerHTML;
        this.productSrc = document.querySelector('.product-image').src.split('?')[0];
        this.apiKey = $7a9eba2d378eea06$var$apiKey;
        this.themeName = 'default';
        this.sizes = $7a9eba2d378eea06$var$getSizes();
    }
    static createClient() {
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app",
            headers: {
                'X-API-KEY': $7a9eba2d378eea06$var$apiKey,
                'X-SHOP-DOMAIN': $7a9eba2d378eea06$var$shopDomain
            }
        });
    }
}


/* eslint-disable @typescript-eslint/lines-between-class-members */ 


const $61a7b43ca7c7a27a$var$apiKey = 'f2bd2805-2c22-528a-9049-738c58b1536e'; // elten.footprinttech.de
function $61a7b43ca7c7a27a$var$getArticleSizesFromUI() {
    const result = [];
    const query = 'select.product-detail-configurator-select-input > option';
    const items = document.querySelectorAll(query);
    items.forEach((item)=>result.push(item.innerText.trim()));
    return result;
}
function $61a7b43ca7c7a27a$var$getArticleNumber() {
    /*return 'WMS_TABLE_FULL';
  const pat = /^(\d+)\.\d+/;
  const el = document.querySelector(
    '.product-detail-ordernumber-container .product-detail-ordernumber') as HTMLElement;
  return pat.exec(el.innerText)[1];
  */ return document.querySelector('[itemprop=sku]').innerHTML.split('.')[0].trim();
}
function $61a7b43ca7c7a27a$var$getArticleName() {
    //const el = document.querySelector('.product-detail-name') as HTMLElement;
    //return el.innerText;
    return document.querySelector('[itemprop=name]').innerHTML.split('|')[0].trim();
}
function $61a7b43ca7c7a27a$var$addGlobalStyle() {
    const style = document.createElement('style');
    style.innerHTML = `
        :root .btn {
          border-radius: 1rem;
        }
      `;
    document.head.appendChild(style);
}
class $61a7b43ca7c7a27a$export$ef6c62bb481a9e19 extends (0, $ff2dffc388a082ec$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.apiKey = $61a7b43ca7c7a27a$var$apiKey;
        this.themeName = undefined;
        this.helper = new (0, $b422465f80e2074d$export$55fa1de7e0cc4099)();
        this.articleNumber = $61a7b43ca7c7a27a$var$getArticleNumber();
        this.articleName = $61a7b43ca7c7a27a$var$getArticleName();
        this.customGv = '2-step-child';
        this.sizes = $61a7b43ca7c7a27a$var$getArticleSizesFromUI();
        this.skipSteps = 'elten';
        document.querySelector('.footer-contact-form').remove();
        $61a7b43ca7c7a27a$var$addGlobalStyle();
    }
    static createClient() {
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app",
            headers: {
                'X-API-KEY': $61a7b43ca7c7a27a$var$apiKey,
                'X-SHOP-DOMAIN': window.location.origin
            }
        });
    }
}


/* eslint-disable @typescript-eslint/lines-between-class-members */ 


const $593b79392074497b$var$apiKey = '093b13eb-6e4f-518e-b077-768d1bccc2e1'; // tryon.footprinttech.de
function $593b79392074497b$var$getArticleSizesFromUI() {
    const result = [];
    const query = 'select.product-detail-configurator-select-input > option';
    const items = document.querySelectorAll(query);
    items.forEach((item)=>result.push(item.innerText.trim()));
    return result;
}
function $593b79392074497b$var$getArticleNumber() {
    /*return 'WMS_TABLE_FULL';
  const pat = /^(\d+)\.\d+/;
  const el = document.querySelector(
    '.product-detail-ordernumber-container .product-detail-ordernumber') as HTMLElement;
  return pat.exec(el.innerText)[1];
  */ return document.querySelector('[itemprop=sku]').innerHTML.split('.')[0].trim();
}
function $593b79392074497b$var$getArticleName() {
    //const el = document.querySelector('.product-detail-name') as HTMLElement;
    //return el.innerText;
    return document.querySelector('[itemprop=name]').innerHTML.split('|')[0].trim();
}
function $593b79392074497b$var$addGlobalStyle() {
    const style = document.createElement('style');
    style.innerHTML = `
        :root .btn {
          border-radius: 1rem;
        }
      `;
    document.head.appendChild(style);
}
class $593b79392074497b$export$db2208024f60a47 extends (0, $ff2dffc388a082ec$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.apiKey = $593b79392074497b$var$apiKey;
        this.themeName = undefined;
        this.helper = new (0, $b422465f80e2074d$export$55fa1de7e0cc4099)();
        this.articleNumber = $593b79392074497b$var$getArticleNumber();
        this.articleName = $593b79392074497b$var$getArticleName();
        this.customGv = '2-step-child';
        this.sizes = $593b79392074497b$var$getArticleSizesFromUI();
        let meta = document.head.querySelector('meta[property="og:image"]');
        if (!meta) meta = document.querySelector('meta[property="og:image"]');
        this.productSrc = meta && meta.content ? meta.content : '';
        const footerForm = document.querySelector('.footer-contact-form');
        if (footerForm) footerForm.remove();
        $593b79392074497b$var$addGlobalStyle();
    }
    static createClient() {
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app",
            headers: {
                'X-API-KEY': $593b79392074497b$var$apiKey,
                'X-SHOP-DOMAIN': window.location.origin
            }
        });
    }
    // hasReload is overridden to disable dynamic CTA button, which displays measurement reusing.
    hasReload() {
        return false;
    }
}





function $0646d5923ae67fe8$var$getVariantSize(variant) {
    return variant.sku.split('-')[1];
}
class $0646d5923ae67fe8$export$fe9c4c2bef815006 extends (0, $f87db475c01c276e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        const productData = window.meta?.product;
        const variant = productData.variants[0];
        this.articleName = variant.name.split('-')[0].trim();
        this.articleNumber = variant.sku.split('-')[0].trim();
        this.articleId = productData.id;
        this.price = this.getArticlePriceFromVariant(variant);
        this.variants = productData.variants.map((item)=>{
            return {
                id: item.id,
                available: true,
                size: $0646d5923ae67fe8$var$getVariantSize(item)
            };
        });
        let meta = document.head.querySelector('meta[property="og:image"]');
        if (!meta) meta = document.querySelector('meta[property="og:image"]');
        this.productSrc = meta && meta.content ? meta.content : '';
        // API key provided as data attribute this.apiKey = apiKey;
        this.themeName = 'default';
        this.sizes = productData.variants.map((item)=>$0646d5923ae67fe8$var$getVariantSize(item));
    }
    async onCtaButtonClick() {
        const box = document.querySelector('.site-box.product-gallery');
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('looking for sticky box', box);
        if (box) (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('applying fix for sticky box');
        return super.onCtaButtonClick();
    }
    static createClient() {
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app",
            headers: {
                'X-API-KEY': $0646d5923ae67fe8$export$fe9c4c2bef815006.getApiKey()
            }
        });
    }
    static isPurchase() {
        const shopInterface = window.Shopify;
        return (window.location.pathname.includes('checkouts') || window.location.pathname.includes('orders')) && shopInterface && shopInterface.checkout && shopInterface.checkout.line_items && shopInterface.checkout.line_items.length > 0;
    }
    static getPurchase() {
        const { checkout: checkout } = window.Shopify;
        return {
            tax: checkout.total_tax,
            value: checkout.total_price,
            shipping: checkout.shipping_rate.price,
            currency: checkout.currency,
            transaction_id: checkout.order_id,
            items: checkout.line_items.map((item)=>{
                return {
                    id: item.product_id,
                    price: item.price,
                    quantity: item.quantity
                };
            })
        };
    }
    static getApiKey() {
        return '5808049e-70bc-584b-939e-746b731b5bed';
    }
}




const $01729dc0cdf86f37$var$API_KEY_MAP = {
    'billyfootwear.com': '97308209-0a99-569c-9c1c-3623028dd44c',
    'sandbox-billy-footwear.myshopify.com': '36b288a6-a9df-52cf-b5f9-587d2a0c2c49'
};
function $01729dc0cdf86f37$var$getVariantSize(variant) {
    return variant.public_title.split('/')[1].trim();
}
function $01729dc0cdf86f37$var$getApiKey() {
    const domain = window.location.hostname;
    return $01729dc0cdf86f37$var$API_KEY_MAP[domain];
}
function $01729dc0cdf86f37$var$getArticleNumberFromSKU(sku) {
    const parts = sku.split('-');
    const hasThreeParts = parts.length > 2 && /[a-z]|[A-Z]/.test(parts[2]);
    if (hasThreeParts) return `${parts[0]}-${parts[1]}-${parts[2]}`;
    return `${parts[0]}-${parts[1]}`;
}
class $01729dc0cdf86f37$export$ba6e77174f0e6e7 extends (0, $f87db475c01c276e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        const productData = window.meta?.product;
        const variant = productData.variants[0];
        this.articleName = variant.name.split('-')[0].trim();
        this.articleNumber = $01729dc0cdf86f37$var$getArticleNumberFromSKU(variant.sku);
        this.articleId = productData.id;
        this.variants = productData.variants.map((item)=>{
            return {
                id: item.id,
                available: true,
                size: $01729dc0cdf86f37$var$getVariantSize(item)
            };
        });
        const meta = document.head.querySelector('meta[property="og:image"]');
        this.productSrc = meta?.content;
        this.apiKey = $01729dc0cdf86f37$var$getApiKey();
        this.themeName = 'Billy';
        this.sizes = productData.variants.map((item)=>$01729dc0cdf86f37$var$getVariantSize(item));
    }
    static createClient() {
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app",
            headers: {
                'X-API-KEY': $01729dc0cdf86f37$var$getApiKey()
            }
        });
    }
    static isPurchase() {
        const shopInterface = window.Shopify;
        return (window.location.pathname.includes('checkouts') || window.location.pathname.includes('orders')) && shopInterface && shopInterface.checkout && shopInterface.checkout.line_items && shopInterface.checkout.line_items.length > 0;
    }
    static getPurchase() {
        const { checkout: checkout } = window.Shopify;
        return {
            tax: checkout.total_tax,
            value: checkout.total_price,
            shipping: checkout.shipping_rate.price,
            currency: checkout.currency,
            transaction_id: checkout.order_id,
            items: checkout.line_items.map((item)=>{
                return {
                    id: item.product_id,
                    price: item.price,
                    quantity: item.quantity
                };
            })
        };
    }
}




const $3fc4be138bffa584$var$apiKey = 'ed9701e9-6ab2-5cd1-b887-c3f853689a61';
const $3fc4be138bffa584$var$skuPattern = /^(\w+\s\d)/;
const $3fc4be138bffa584$var$sizePattern = /^EU (\d+[.]?\d+?) \/ US (\d+[.]?\d+?)$/;
function $3fc4be138bffa584$var$getVariantSize(variant) {
    const title = variant.public_title;
    if (!$3fc4be138bffa584$var$sizePattern.test(title)) return title;
    const match = $3fc4be138bffa584$var$sizePattern.exec(title);
    const euSize = match[1];
    // const usSize = match[2];
    return euSize;
}
class $3fc4be138bffa584$export$4fe1e085058033be extends (0, $f87db475c01c276e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        const productData = window.meta?.product;
        const variant = productData.variants[0];
        const { sku: sku } = variant;
        const meta = document.head.querySelector('meta[property="og:image"]');
        this.articleName = variant.name.split('-')[0].trim();
        this.articleNumber = sku;
        this.productSrc = meta?.content;
        this.apiKey = $3fc4be138bffa584$var$apiKey;
        this.price = this.getArticlePriceFromVariant(variant);
        this.articleId = productData.id;
        this.variants = productData.variants.map((item)=>{
            return {
                id: item.id,
                available: true,
                size: $3fc4be138bffa584$var$getVariantSize(item)
            };
        });
        this.sizes = this.variants.map((item)=>item.size);
        this.lang = 'en';
    }
    hasTooltip() {
        return true;
    }
    static createClient() {
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app",
            headers: {
                'X-API-KEY': $3fc4be138bffa584$var$apiKey
            }
        });
    }
    static isPurchase() {
        return false;
    }
    static getPurchase() {
        return null;
    }
}




const $b277a01922fb7efe$var$apiKey = 'FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF';
class $b277a01922fb7efe$export$8fa2263a349bda0c extends (0, $ff2dffc388a082ec$export$2e2bcd8739ae039) {
    static createClient() {
        return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).create({
            baseURL: "https://staging-backend.myfootprint.app",
            headers: {
                'X-API-KEY': $b277a01922fb7efe$var$apiKey
            }
        });
    }
}





const $86f21f6a5d070d64$export$3873337c113ee218 = {
    'www.koyobear.com': (0, $d17aa5492128ca42$export$9b506fea9eb94f11),
    'koyo-bear-test-4-2.webflow.io': (0, $d17aa5492128ca42$export$9b506fea9eb94f11),
    'koyo-bear-footprint-test.webflow.io': (0, $d17aa5492128ca42$export$9b506fea9eb94f11),
    'www.vicinityclo.de': (0, $3fc4be138bffa584$export$4fe1e085058033be),
    'billyfootwear.com': (0, $01729dc0cdf86f37$export$ba6e77174f0e6e7),
    'sandbox-billy-footwear.myshopify.com': (0, $01729dc0cdf86f37$export$ba6e77174f0e6e7),
    'www.miret.co': (0, $0646d5923ae67fe8$export$fe9c4c2bef815006),
    'www.earthbound-sneakers.com': (0, $0646d5923ae67fe8$export$fe9c4c2bef815006),
    'jp.koyobear.com': (0, $d17aa5492128ca42$export$9b506fea9eb94f11),
    'elten.footprinttech.de': (0, $61a7b43ca7c7a27a$export$ef6c62bb481a9e19),
    // The test shop for Elten's PCH Testing on 28.03.2023
    'fashion-spa.cu2qdtboy0-public1-p13-public.model-t.cc.commerce.ondemand.com': (0, $e1fa07d82dbc23d8$export$4238dfb2076179d6),
    'fashion-spa.sfashion-sapphire.usdemo.hybris.com': (0, $e1fa07d82dbc23d8$export$4238dfb2076179d6),
    'footprintapp-egsvi.sw-testenvironment.de': (0, $848372274f51d2f5$export$9e2d9c658eee7d21),
    'shopware.podolino.de': (0, $3d7f90dff891df39$export$1999f40f675e5871),
    'staging.podolino.de': (0, $3d7f90dff891df39$export$1999f40f675e5871),
    'orange-ocean-017423203.1.azurestaticapps.net': (0, $ef1ad6286560c00d$export$1eb863931faa66a6),
    'demo.myfootprint.app': (0, $ef1ad6286560c00d$export$1eb863931faa66a6),
    'localhost:4200': (0, $e1fa07d82dbc23d8$export$4238dfb2076179d6),
    'myfootprint.bigcartel.com': (0, $7a9eba2d378eea06$export$8605403858ef645b),
    'tryon.footprinttech.de': (0, $593b79392074497b$export$db2208024f60a47 // The test shop for tryon shop
    )
};
function $86f21f6a5d070d64$var$getService() {
    const domain = window.location.hostname;
    if (domain in $86f21f6a5d070d64$export$3873337c113ee218) return $86f21f6a5d070d64$export$3873337c113ee218[domain];
    return 0, $b277a01922fb7efe$export$8fa2263a349bda0c;
}
class $86f21f6a5d070d64$export$5d9b19d5ff0bdaa2 {
    static create() {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('instantiating shop Service . . .');
        const Service = $86f21f6a5d070d64$var$getService();
        return new Service();
    }
    static getShopService() {
        return $86f21f6a5d070d64$var$getService();
    }
}









const $d5f06759a5444af7$export$bad24218ebd77223 = new (0, (/*@__PURE__*/$parcel$interopDefault($4d34497a6210a94d$exports)))();
const $d5f06759a5444af7$var$onRootElChange = (mutationList, observer)=>{
    for (const mutation of mutationList){
        if (mutation.type === "childList") (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info("A child node has been added or removed.");
        else if (mutation.type === "attributes" && mutation.attributeName === "data-measurement-id") {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`The ${mutation.attributeName} attribute was modified.`);
            const measurementId = mutation.target.getAttribute(mutation.attributeName);
            const articleNumber = mutation.target.dataset.articleNumber;
            const processProfileMeasurement = ()=>$d5f06759a5444af7$export$bad24218ebd77223.emit((0, $553cb74d80b27513$export$2e2bcd8739ae039).onProfileMeasurementSet, {
                    articleNumber: articleNumber,
                    measurementId: measurementId
                });
            if ((0, $90d2b26344f90169$export$2e2bcd8739ae039).hasShopSetting()) {
                processProfileMeasurement();
                return;
            }
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('waiting for driver to be initialized to process profile measurement');
            window.addEventListener('fpt-initialized', processProfileMeasurement, {
                once: true
            });
        }
    }
};
const $d5f06759a5444af7$export$44c0e82c67f4b417 = {
    render: (config)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('rendering widgets . . .');
        const customShopService = (0, $86f21f6a5d070d64$export$5d9b19d5ff0bdaa2).create();
        if (customShopService instanceof (0, $b277a01922fb7efe$export$8fa2263a349bda0c)) (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('using Generic Service');
        else {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('using Custom Service');
            (0, $90d2b26344f90169$export$2e2bcd8739ae039).setCustomService(customShopService);
        }
        const articleList = [];
        let apiKey = (0, $90d2b26344f90169$export$2e2bcd8739ae039).getApiKey(config);
        // set API key from custom service (deprecated)
        // or script element
        if (apiKey) (0, $90d2b26344f90169$export$2e2bcd8739ae039).setApiKey(apiKey);
        const renderButtonFromHTMLElement = (el)=>{
            const article = (0, $90d2b26344f90169$export$2e2bcd8739ae039).getArticleData(el);
            articleList.push(article);
            const root = (0, $64d0b1ebdd6bcffe$exports.createRoot)(el);
            // set API key from widget. This is deprecated
            if (!apiKey) {
                apiKey = (0, $90d2b26344f90169$export$2e2bcd8739ae039).getApiKey(el.dataset);
                (0, $90d2b26344f90169$export$2e2bcd8739ae039).setApiKey(apiKey);
            }
            if ('measurementId' in el.dataset && el.dataset.measurementId) {
                const { measurementId: measurementId } = el.dataset;
                (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('got measurement', measurementId);
                (0, $e3aa4ff3201c0ceb$export$2e2bcd8739ae039).setMeasurementId(measurementId);
            }
            // Create an observer instance linked to the callback function
            const observer = new MutationObserver($d5f06759a5444af7$var$onRootElChange);
            // Start observing the target node for configured mutations
            observer.observe(el, {
                attributes: true,
                childList: false,
                subtree: false
            });
            root.render(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3f8185a6b87e2fb4$export$ca3218b7861b9cb0), {
                emitter: $d5f06759a5444af7$export$bad24218ebd77223,
                articleData: article
            }));
        };
        document.querySelectorAll('[data-widget=fpt-button]').forEach(renderButtonFromHTMLElement);
        // this is deprecated. Does not work with data-widget attribute
        const legacyWidget = document.querySelector('#footprinttech-button');
        if (legacyWidget) {
            const article = (0, $90d2b26344f90169$export$2e2bcd8739ae039).getArticleData(legacyWidget);
            articleList.push(article);
            renderButtonFromHTMLElement(legacyWidget);
        }
        if (!apiKey) throw new Error('No API key found');
        const modalEl = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).appendModalEl();
        const appRoot = (0, $64d0b1ebdd6bcffe$exports.createRoot)(modalEl);
        appRoot.render(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f686bfa33774dad2$export$bd63dc5a00fdc201), {
            emitter: $d5f06759a5444af7$export$bad24218ebd77223,
            articleList: articleList
        }));
    },
    renderModal: ()=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('Headless mode initilizing');
        const el = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).appendHeadlessModalEl();
        const root = (0, $64d0b1ebdd6bcffe$exports.createRoot)(el);
        const articleList = [];
        const widget = document.querySelector('[data-widget=fpt-modal]');
        const article = (0, $90d2b26344f90169$export$2e2bcd8739ae039).getArticleData(widget);
        articleList.push(article);
        root.render(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f686bfa33774dad2$export$bd63dc5a00fdc201), {
            emitter: $d5f06759a5444af7$export$bad24218ebd77223,
            headlessEnabled: "true",
            articleList: articleList
        }));
    },
    isCheckoutPage: ()=>{
        const Service = (0, $86f21f6a5d070d64$export$5d9b19d5ff0bdaa2).getShopService();
        return Service.isCheckout();
    },
    initBanner: (bannerId)=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('has banner');
        // const el = document.getElementById(bannerId);
        const el = (0, $2fd26587fc2957b4$export$2e2bcd8739ae039).appendModalEl();
        const root = (0, $64d0b1ebdd6bcffe$exports.createRoot)(el);
        root.render(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f686bfa33774dad2$export$bd63dc5a00fdc201), {
            emitter: $d5f06759a5444af7$export$bad24218ebd77223,
            bannerId: "footprinttech-banner"
        }));
    },
    handleCheckout: ()=>{
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('checkout called');
        const Service = (0, $86f21f6a5d070d64$export$5d9b19d5ff0bdaa2).getShopService();
        return Service.handleCheckout();
    }
};



(function(Driver) {
    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('initializing . . .');
    const scriptEl = document.currentScript;
    const config = {
        apiKey: scriptEl.dataset.apiKey
    };
    let isButtonRendered = false;
    window.FootprintTechDriver = Driver;
    document.addEventListener('readystatechange', (event)=>{
        const target = event.target;
        const isCheckout = Driver.isCheckoutPage();
        const hasButton = !!document.querySelector('[data-widget=fpt-button]') || !!document.querySelector('#footprinttech-button');
        const hasBanner = !!document.querySelector('[data-widget=fpt-banner]') || !!document.querySelector('#footprinttech-banner');
        const headlessEnabled = !!document.querySelector('[data-widget=fpt-modal]');
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`ready state changed ${target.readyState}`);
        if (target.readyState === 'interactive' && !isCheckout && hasButton && !isButtonRendered && !headlessEnabled) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('button rendered interactive');
            Driver.render(config);
            isButtonRendered = true;
        }
        if (target.readyState === 'interactive' && !isCheckout && hasBanner && !headlessEnabled) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('banner initialized interactive');
            Driver.initBanner('footprinttech-banner');
        }
        if (target.readyState === 'complete' && hasButton && !isCheckout && !isButtonRendered && !headlessEnabled) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('ready state complete, rendering the button');
            Driver.render(config);
            isButtonRendered = true;
        }
        if (target.readyState === 'complete' && headlessEnabled) {
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('ready state complete, rendering modal');
            Driver.renderModal();
        }
        if (target.readyState !== 'complete') return;
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('ready state complete');
        if (isCheckout) return window.addEventListener('load', ()=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('page is fully loaded, calling checkout');
            Driver.handleCheckout().catch((err)=>(0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn(`no conversion created ${err}`));
        });
    });
    (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info(`document ready state: ${document.readyState}`);
    if (document.readyState === 'complete' && document.querySelector('#footprinttech-button') && !isButtonRendered) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('page is fully loaded, but button not rendered');
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).info('renderedering button');
        Driver.render(config);
        isButtonRendered = true;
    } else if (document.readyState === 'complete' && !isButtonRendered) {
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('page is fully loaded, but button not rendered');
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('unable to find button div element');
        (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('waiting for button div element to render');
        setTimeout(()=>{
            (0, $c40fe7cebd3a81ae$export$2e2bcd8739ae039).warn('trying to render button');
            Driver.render(config);
            isButtonRendered = true;
        }, 1000);
    }
})((0, $d5f06759a5444af7$export$44c0e82c67f4b417));

})();
//# sourceMappingURL=index.js.map
